// THIS IS A GENERATED FILE, DO NOT EDIT IT! (see codegen.yml)
/* eslint-disable */
import { gql } from '@apollo/client';
import * as ApolloReactCommon from '../state/graphql/apolloWithAbort';
import * as ApolloReactHooks from '../state/graphql/apolloWithAbort';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  Duration: { input: number; output: number; }
  Int64: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONString: { input: any; output: any; }
};

export type AriaActionArgs = {
  __typename: 'ARIAActionArgs';
  prompt: Scalars['String']['output'];
};

export type AriaActionInput = {
  prompt: Scalars['String']['input'];
};

export type AriaTriggeredAction = {
  __typename: 'ARIATriggeredAction';
  prompt: Scalars['String']['output'];
  readOnly: Scalars['Boolean']['output'];
};

export type AccessToken = {
  __typename: 'AccessToken';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  emails: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastAccessedAt?: Maybe<Scalars['DateTime']['output']>;
  projects: Array<Project>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  token: Scalars['String']['output'];
  type: AccessTokenType;
  view: View;
};

export enum AccessTokenType {
  IndividualSharing = 'INDIVIDUAL_SHARING',
  Public = 'PUBLIC',
  Restricted = 'RESTRICTED'
}

export type AckJobSetItemInput = {
  agentId: Scalars['ID']['input'];
  jobSetId: Scalars['ID']['input'];
  jobSetItemId: Scalars['ID']['input'];
  runName: Scalars['String']['input'];
};

export type AckJobSetItemPayload = {
  __typename: 'AckJobSetItemPayload';
  success: Scalars['Boolean']['output'];
};

export type AckRunQueueItemInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
  runQueueItemId: Scalars['ID']['input'];
};

export type AckRunQueueItemPayload = {
  __typename: 'AckRunQueueItemPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AckSlurmCommandInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type AckSlurmCommandPayload = {
  __typename: 'AckSlurmCommandPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ActiveExperiment = Node & {
  __typename: 'ActiveExperiment';
  activeVariants: Array<ActiveVariant>;
  endAt?: Maybe<Scalars['DateTime']['output']>;
  experimentType: ExperimentType;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ActiveVariant = {
  __typename: 'ActiveVariant';
  allocation: Scalars['Int']['output'];
  bucket: Scalars['Int']['output'];
};

export type ActivityDuration = {
  endAt: Scalars['DateTime']['output'];
  startAt: Scalars['DateTime']['output'];
};

export type AddAliasesInput = {
  aliases: Array<ArtifactCollectionAliasInput>;
  artifactID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type AddAliasesPayload = {
  __typename: 'AddAliasesPayload';
  aliases: Array<ArtifactCollectionAlias>;
  artifact: Artifact;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Event details for adding an alias to an artifact. */
export type AddArtifactAliasEventInput = {
  /** The alias that was added */
  alias: Scalars['String']['input'];
  /** The ID of the artifact version */
  artifactId: Scalars['ID']['input'];
  /** The ID of the artifact collection */
  collectionId: Scalars['ID']['input'];
};

/** Event details for adding a tag to an artifact. */
export type AddArtifactTagEventInput = {
  /** The ID of the artifact version */
  artifactId: Scalars['ID']['input'];
  /** The tag that was added */
  tag: Scalars['String']['input'];
};

/** Event details for adding a tag to a collection. */
export type AddCollectionTagEventInput = {
  /** The ID of the collection */
  collectionId: Scalars['ID']['input'];
  /** The tag that was added */
  tag: Scalars['String']['input'];
};

export type AddFilesInput = {
  bucketName?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  modelName: Scalars['String']['input'];
  names: Array<InputMaybe<Scalars['String']['input']>>;
};

export type AddFilesPayload = {
  __typename: 'AddFilesPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  files?: Maybe<FileConnection>;
};


export type AddFilesPayloadFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AddProjectProtectedAliasesInput = {
  aliases: Array<Scalars['String']['input']>;
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};

export type AddProjectProtectedAliasesPayload = {
  __typename: 'AddProjectProtectedAliasesPayload';
  aliases: Array<Scalars['String']['output']>;
  clientMutationID?: Maybe<Scalars['String']['output']>;
};

export type AddProtectedAliasesInput = {
  adminType: WorkflowsAdminType;
  aliases: Array<Scalars['String']['input']>;
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
};

export type AddProtectedAliasesPayload = {
  __typename: 'AddProtectedAliasesPayload';
  aliases: Array<Scalars['String']['output']>;
  clientMutationID?: Maybe<Scalars['String']['output']>;
};

export type AddPublicQueueLaunchAgentTeamConfigInput = {
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type AddPublicQueueLaunchAgentTeamConfigPayload = {
  __typename: 'AddPublicQueueLaunchAgentTeamConfigPayload';
  clientMutationID?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddReferenceBucketToTeamInput = {
  bucket: StorageBucketInfoInput;
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityID: Scalars['ID']['input'];
  objectKey: Scalars['String']['input'];
};

export type AddReferenceBucketToTeamPayload = {
  __typename: 'AddReferenceBucketToTeamPayload';
  bucketStoreID: Scalars['ID']['output'];
  clientMutationID?: Maybe<Scalars['String']['output']>;
  entity: Entity;
  success: Scalars['Boolean']['output'];
};

export type AddRolePermissionsInput = {
  permissions: Array<Scalars['String']['input']>;
  roleID: Scalars['ID']['input'];
};

export type AddRolePermissionsPayload = {
  __typename: 'AddRolePermissionsPayload';
  success: Scalars['Boolean']['output'];
};

export type AddUserToOrganizationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modelsSeat?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  teams?: InputMaybe<Array<Scalars['String']['input']>>;
  userName: Scalars['String']['input'];
  userOrgRole: Scalars['String']['input'];
  weaveRole?: InputMaybe<Scalars['String']['input']>;
};

export type AddUserToOrganizationPayload = {
  __typename: 'AddUserToOrganizationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emailSent: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type AddWorkflowsAdminInput = {
  adminType: WorkflowsAdminType;
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type AddWorkflowsAdminPayload = {
  __typename: 'AddWorkflowsAdminPayload';
  clientMutationID?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AdvancedRegistryFeatures = {
  __typename: 'AdvancedRegistryFeatures';
  advancedSearch: Scalars['Boolean']['output'];
  advancedUI: Scalars['Boolean']['output'];
};

export type Agent = Node & {
  __typename: 'Agent';
  createdAt: Scalars['DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  heartbeatAt?: Maybe<Scalars['DateTime']['output']>;
  host: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metrics: Scalars['JSONString']['output'];
  name: Scalars['String']['output'];
  persistent?: Maybe<Scalars['Boolean']['output']>;
  runs: RunConnection;
  state?: Maybe<Scalars['String']['output']>;
  sweep: Sweep;
  totalRuns: Scalars['Int']['output'];
  user?: Maybe<User>;
};


export type AgentRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

export type AgentConnection = {
  __typename: 'AgentConnection';
  edges: Array<AgentEdge>;
  pageInfo: PageInfo;
};

export type AgentEdge = {
  __typename: 'AgentEdge';
  cursor: Scalars['String']['output'];
  node: Agent;
};

export type AgentHeartbeatInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  metrics?: InputMaybe<Scalars['JSONString']['input']>;
  runState?: InputMaybe<Scalars['JSONString']['input']>;
};

export type AgentHeartbeatPayload = {
  __typename: 'AgentHeartbeatPayload';
  agent?: Maybe<Agent>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  commands?: Maybe<Scalars['JSONString']['output']>;
};

export enum Aggregation {
  Average = 'AVERAGE',
  Count = 'COUNT',
  Max = 'MAX',
  Min = 'MIN',
  Sum = 'SUM'
}

export type AggregationKey = {
  aggregation: Aggregation;
  key: Scalars['String']['input'];
};

export type Alert = {
  __typename: 'Alert';
  condition: AlertCondition;
  events: AlertEventConnection;
  id: Scalars['ID']['output'];
  subscriptions: Array<AlertSubscription>;
};


export type AlertEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['DateTime']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AlertCondition = FinishedRunCondition | ScriptableRunCondition | StoppedRunCondition;

export type AlertEvent = {
  __typename: 'AlertEvent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
};

export type AlertEventConnection = {
  __typename: 'AlertEventConnection';
  edges: Array<AlertEventEdge>;
  pageInfo: PageInfo;
};

export type AlertEventEdge = {
  __typename: 'AlertEventEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AlertEvent>;
};

export enum AlertSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Warn = 'WARN'
}

export type AlertSubscription = {
  id: Scalars['ID']['output'];
};

export type AlertThreshold = {
  __typename: 'AlertThreshold';
  emailSent: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  product: AlertThresholdProduct;
  type: AlertThresholdType;
  value: Scalars['Int']['output'];
};

export type AlertThresholdFilter = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  product?: InputMaybe<AlertThresholdProduct>;
  type?: InputMaybe<AlertThresholdType>;
};

export enum AlertThresholdProduct {
  Inference = 'INFERENCE',
  Storage = 'STORAGE',
  TrackingHour = 'TRACKING_HOUR',
  Training = 'TRAINING',
  Weave = 'WEAVE'
}

export enum AlertThresholdType {
  Spend = 'SPEND',
  Usage = 'USAGE'
}

export type ApiKey = {
  __typename: 'ApiKey';
  apiKeyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  ips: Array<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  organizationID?: Maybe<Scalars['ID']['output']>;
  rateLimit?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type ApiKeyConnection = {
  __typename: 'ApiKeyConnection';
  edges: Array<ApiKeyEdge>;
  pageInfo: PageInfo;
};

export type ApiKeyEdge = {
  __typename: 'ApiKeyEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ApiKey>;
};

export type Artifact = {
  __typename: 'Artifact';
  aliases: Array<ArtifactAlias>;
  /** @deprecated Field no longer supported */
  artifactActions?: Maybe<ArtifactActionConnection>;
  artifactCollections: ArtifactCollectionConnection;
  artifactLineageDag?: Maybe<ArtifactLineageDag>;
  artifactMemberships: ArtifactCollectionMembershipConnection;
  artifactSequence: ArtifactSequence;
  artifactSequenceMembership: ArtifactCollectionMembership;
  artifactType: ArtifactType;
  commitHash?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Initiator>;
  currentManifest?: Maybe<ArtifactManifest>;
  dependencyOf: ArtifactConnection;
  dependsOn: ArtifactConnection;
  description?: Maybe<Scalars['String']['output']>;
  digest: Scalars['String']['output'];
  digestAlgorithm: ArtifactDigestAlgorithm;
  fileCount: Scalars['Int64']['output'];
  /** @deprecated Use artifactMembership.files instead. */
  files?: Maybe<FileConnection>;
  /** @deprecated Use artifactMembership.filesByManifestEntries instead. */
  filesByManifestEntries?: Maybe<FileConnection>;
  historyStep?: Maybe<Scalars['Int64']['output']>;
  id: Scalars['ID']['output'];
  isGenerated: Scalars['Boolean']['output'];
  isLinkedToGlobalRegistry: Scalars['Boolean']['output'];
  isProtected: Scalars['Boolean']['output'];
  /** @deprecated Field no longer supported */
  labels?: Maybe<Scalars['JSONString']['output']>;
  metadata?: Maybe<Scalars['JSONString']['output']>;
  runHistory: Scalars['String']['output'];
  size: Scalars['Int64']['output'];
  state: ArtifactState;
  storageBytes: Scalars['Int64']['output'];
  storageRegion?: Maybe<Scalars['String']['output']>;
  tags: Array<Tag>;
  ttlDurationSeconds: Scalars['Int64']['output'];
  ttlIsInherited: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usedBy: RunConnection;
  usedCount: Scalars['Int']['output'];
  versionIndex?: Maybe<Scalars['Int']['output']>;
  /** Source info for artifacts backed by Weave objects. Null for regular artifacts. */
  weaveSource?: Maybe<ArtifactWeaveSource>;
};


export type ArtifactAliasesArgs = {
  artifactCollectionName?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactArtifactActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactArtifactLineageDagArgs = {
  baseGraphNodeIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  clusterSize?: InputMaybe<Scalars['Int']['input']>;
  directLineage?: InputMaybe<Scalars['Boolean']['input']>;
  filterGeneratedArtifacts: Scalars['Boolean']['input'];
  limit: Scalars['Int']['input'];
  traversalDirection?: InputMaybe<TraversalDirection>;
};


export type ArtifactCommitHashArgs = {
  artifactCollectionName?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactDependencyOfArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactDependsOnArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ArtifactFilesByManifestEntriesArgs = {
  entries?: InputMaybe<Array<ArtifactManifestEntryInput>>;
  manifestVersion: Scalars['String']['input'];
  storageLayout: Scalars['String']['input'];
  storageRegion?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactRunHistoryArgs = {
  maxKeyLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactUsedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactVersionIndexArgs = {
  artifactCollectionName?: InputMaybe<Scalars['String']['input']>;
};

export type ArtifactAction = {
  artifact: Artifact;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  initiator: Initiator;
};

export type ArtifactActionConnection = {
  __typename: 'ArtifactActionConnection';
  edges: Array<ArtifactActionEdge>;
  pageInfo: PageInfo;
};

export type ArtifactActionEdge = {
  __typename: 'ArtifactActionEdge';
  cursor: Scalars['String']['output'];
  node: ArtifactAction;
};

export type ArtifactAlias = {
  __typename: 'ArtifactAlias';
  alias: Scalars['String']['output'];
  artifact?: Maybe<Artifact>;
  artifactCollection?: Maybe<ArtifactCollection>;
  artifactCollectionName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ArtifactAliasAction = {
  __typename: 'ArtifactAliasAction';
  actionType: Scalars['String']['output'];
  alias: Scalars['String']['output'];
  artifactCollection: ArtifactCollection;
  createdAt: Scalars['DateTime']['output'];
  sourceArtifact?: Maybe<Artifact>;
  targetArtifact?: Maybe<Artifact>;
  user?: Maybe<User>;
};

export type ArtifactAliasActionConnection = {
  __typename: 'ArtifactAliasActionConnection';
  edges: Array<ArtifactAliasActionEdge>;
  pageInfo: PageInfo;
};

export type ArtifactAliasActionEdge = {
  __typename: 'ArtifactAliasActionEdge';
  cursor: Scalars['String']['output'];
  node: ArtifactAliasAction;
};

export type ArtifactAliasConnection = {
  __typename: 'ArtifactAliasConnection';
  edges: Array<ArtifactAliasEdge>;
  pageInfo: PageInfo;
};

export type ArtifactAliasEdge = {
  __typename: 'ArtifactAliasEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ArtifactAlias>;
};

export type ArtifactAliasEventDetails = {
  __typename: 'ArtifactAliasEventDetails';
  alias?: Maybe<Scalars['String']['output']>;
  artifactCollectionName?: Maybe<Scalars['String']['output']>;
  artifactMetadata?: Maybe<Scalars['JSONString']['output']>;
  artifactVersionIndex?: Maybe<Scalars['Int']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
};

export type ArtifactAliasInput = {
  alias: Scalars['String']['input'];
  artifactCollectionName: Scalars['String']['input'];
};

export type ArtifactCollection = {
  aliasActionHistory: ArtifactAliasActionConnection;
  aliases: ArtifactAliasConnection;
  /** @deprecated Field no longer supported */
  artifactActions?: Maybe<ArtifactActionConnection>;
  artifactCollectionActions: ArtifactCollectionActionConnection;
  artifactMembership?: Maybe<ArtifactCollectionMembership>;
  artifactMemberships: ArtifactCollectionMembershipConnection;
  artifactMetricSearch: Array<ArtifactMetricSearchResult>;
  artifactMetricValues: Array<ArtifactMetricValue>;
  artifacts?: Maybe<VersionedArtifactConnection>;
  createdAt: Scalars['DateTime']['output'];
  defaultArtifactType: ArtifactType;
  description?: Maybe<Scalars['String']['output']>;
  hasArtifactVersionLinkedToGlobalRegistry: Scalars['Boolean']['output'];
  hasProtectedArtifact: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isModelRegistryMigratedArtifactCollection: Scalars['Boolean']['output'];
  modelRegistryMigratedArtifactCollection?: Maybe<ArtifactCollection>;
  name: Scalars['String']['output'];
  overview?: Maybe<ArtifactCollectionOverview>;
  project?: Maybe<Project>;
  registryModelDeployments: RegistryModelDeploymentConnection;
  state: ArtifactCollectionState;
  tags: TagConnection;
  triggerExecutions: TriggerExecutionConnection;
  triggers: TriggerConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionIndexes: Array<Scalars['Int']['output']>;
};


export type ArtifactCollectionAliasActionHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactCollectionAliasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactCollectionArtifactActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactCollectionArtifactCollectionActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactCollectionArtifactMembershipArgs = {
  aliasName: Scalars['String']['input'];
};


export type ArtifactCollectionArtifactMembershipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactCollectionArtifactMetricSearchArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  membershipIds: Array<Scalars['ID']['input']>;
  metricNamePattern?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactCollectionArtifactMetricValuesArgs = {
  membershipIds: Array<Scalars['ID']['input']>;
  metricName: Scalars['String']['input'];
};


export type ArtifactCollectionArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactCollectionRegistryModelDeploymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Array<RegistryModelDeploymentState>>;
};


export type ArtifactCollectionTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tagCategoryName?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactCollectionTriggerExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  triggerID?: InputMaybe<Scalars['ID']['input']>;
};


export type ArtifactCollectionTriggersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactCollectionVersionIndexesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ArtifactCollectionAction = {
  __typename: 'ArtifactCollectionAction';
  actionType: Scalars['String']['output'];
  artifact?: Maybe<Artifact>;
  artifactCollection?: Maybe<ArtifactCollection>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  user?: Maybe<User>;
};

export type ArtifactCollectionActionConnection = {
  __typename: 'ArtifactCollectionActionConnection';
  edges: Array<ArtifactCollectionActionEdge>;
  pageInfo: PageInfo;
};

export type ArtifactCollectionActionEdge = {
  __typename: 'ArtifactCollectionActionEdge';
  cursor: Scalars['String']['output'];
  node: ArtifactCollectionAction;
};

export type ArtifactCollectionAlias = {
  __typename: 'ArtifactCollectionAlias';
  alias: Scalars['String']['output'];
  artifactCollectionName: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
};

export type ArtifactCollectionAliasInput = {
  alias: Scalars['String']['input'];
  artifactCollectionName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};

export type ArtifactCollectionConnection = {
  __typename: 'ArtifactCollectionConnection';
  edges: Array<ArtifactCollectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ArtifactCollectionEdge = {
  __typename: 'ArtifactCollectionEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ArtifactCollection>;
};

export type ArtifactCollectionMembership = {
  __typename: 'ArtifactCollectionMembership';
  aliases: Array<ArtifactAlias>;
  artifact?: Maybe<Artifact>;
  artifactCollection?: Maybe<ArtifactCollection>;
  commitHash?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  files?: Maybe<FileConnection>;
  filesByManifestEntries?: Maybe<FileConnection>;
  id: Scalars['ID']['output'];
  registryModelDeployments: RegistryModelDeploymentConnection;
  versionIndex?: Maybe<Scalars['Int']['output']>;
};


export type ArtifactCollectionMembershipFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ArtifactCollectionMembershipFilesByManifestEntriesArgs = {
  entries?: InputMaybe<Array<ArtifactManifestEntryInput>>;
  manifestVersion: Scalars['String']['input'];
  storageLayout: Scalars['String']['input'];
  storageRegion?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactCollectionMembershipRegistryModelDeploymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Array<RegistryModelDeploymentState>>;
};

export type ArtifactCollectionMembershipConnection = {
  __typename: 'ArtifactCollectionMembershipConnection';
  edges: Array<ArtifactCollectionMembershipEdge>;
  pageInfo: PageInfo;
};

export type ArtifactCollectionMembershipEdge = {
  __typename: 'ArtifactCollectionMembershipEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ArtifactCollectionMembership>;
};

export type ArtifactCollectionOverview = {
  __typename: 'ArtifactCollectionOverview';
  artifactCollectionID: Scalars['ID']['output'];
  viewID: Scalars['ID']['output'];
};

export type ArtifactCollectionOverviewAiBlockInput = {
  items?: InputMaybe<Array<Scalars['String']['input']>>;
  kind: ArtifactCollectionOverviewAiBlockKind;
  membershipIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  panels?: InputMaybe<Array<ArtifactCollectionOverviewAiMetricPanelInput>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export enum ArtifactCollectionOverviewAiBlockKind {
  BulletList = 'BULLET_LIST',
  Heading = 'HEADING',
  MetricGrid = 'METRIC_GRID',
  Paragraph = 'PARAGRAPH'
}

export enum ArtifactCollectionOverviewAiMetricChartType {
  Bar = 'BAR',
  Line = 'LINE',
  Scatter = 'SCATTER'
}

export type ArtifactCollectionOverviewAiMetricPanelInput = {
  chartTitle?: InputMaybe<Scalars['String']['input']>;
  chartType?: InputMaybe<ArtifactCollectionOverviewAiMetricChartType>;
  metricName: Scalars['String']['input'];
  xAxisMax?: InputMaybe<Scalars['Float']['input']>;
  xAxisMin?: InputMaybe<Scalars['Float']['input']>;
  xLogScale?: InputMaybe<Scalars['Boolean']['input']>;
  xMetricName?: InputMaybe<Scalars['String']['input']>;
  yAxisMax?: InputMaybe<Scalars['Float']['input']>;
  yAxisMin?: InputMaybe<Scalars['Float']['input']>;
  yLogScale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArtifactCollectionOverviewAiPlanInput = {
  blocks: Array<ArtifactCollectionOverviewAiBlockInput>;
};

export type ArtifactCollectionOverviewMetricCandidate = {
  __typename: 'ArtifactCollectionOverviewMetricCandidate';
  name: Scalars['String']['output'];
};

export type ArtifactCollectionOverviewMetricCandidatePacket = {
  __typename: 'ArtifactCollectionOverviewMetricCandidatePacket';
  metrics: Array<ArtifactCollectionOverviewMetricCandidate>;
};

export type ArtifactCollectionOverviewMetricCandidatesInput = {
  artifactCollectionID: Scalars['ID']['input'];
  membershipIDs: Array<Scalars['ID']['input']>;
};

export type ArtifactCollectionOverviewVersionCandidate = {
  __typename: 'ArtifactCollectionOverviewVersionCandidate';
  aliases: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  membershipID: Scalars['ID']['output'];
  tags: Array<Scalars['String']['output']>;
  versionIndex?: Maybe<Scalars['Int']['output']>;
};

export type ArtifactCollectionOverviewVersionCandidatePacket = {
  __typename: 'ArtifactCollectionOverviewVersionCandidatePacket';
  versions: Array<ArtifactCollectionOverviewVersionCandidate>;
};

export type ArtifactCollectionOverviewVersionCandidatesInput = {
  artifactCollectionID: Scalars['ID']['input'];
};

export type ArtifactCollectionSearchConnection = {
  __typename: 'ArtifactCollectionSearchConnection';
  edges: Array<ArtifactCollectionSearchEdge>;
  pageInfo: PageInfo;
};

export type ArtifactCollectionSearchEdge = {
  __typename: 'ArtifactCollectionSearchEdge';
  artifactMatch: Scalars['Boolean']['output'];
  artifactMemberships: ArtifactCollectionMembershipConnection;
  cursor: Scalars['String']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  node: ArtifactCollection;
};

export enum ArtifactCollectionState {
  Deleted = 'DELETED',
  Ready = 'READY'
}

export enum ArtifactCollectionType {
  Portfolio = 'PORTFOLIO',
  Sequence = 'SEQUENCE'
}

export type ArtifactConnection = ArtifactConnectionType & {
  __typename: 'ArtifactConnection';
  edges: Array<ArtifactEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ArtifactConnectionType = {
  edges: Array<ArtifactEdgeType>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ArtifactDigestAlgorithm {
  ManifestMd5 = 'MANIFEST_MD5',
  ManifestXxh128 = 'MANIFEST_XXH128'
}

export type ArtifactEdge = ArtifactEdgeType & {
  __typename: 'ArtifactEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Artifact>;
};

export type ArtifactEdgeType = {
  cursor: Scalars['String']['output'];
  node?: Maybe<Artifact>;
};

export type ArtifactEventDetails = {
  __typename: 'ArtifactEventDetails';
  artifactCollectionName?: Maybe<Scalars['String']['output']>;
  artifactMetadata?: Maybe<Scalars['JSONString']['output']>;
  artifactVersionIndex?: Maybe<Scalars['Int']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
};

export type ArtifactLineageDag = {
  __typename: 'ArtifactLineageDag';
  artifacts: Array<Maybe<ArtifactLineageDagArtifact>>;
  clusters: Array<Maybe<ArtifactLineageDagCluster>>;
  edges: Array<Maybe<ArtifactLineageDagEdge>>;
  hitLimit: Scalars['Boolean']['output'];
  runs: Array<Maybe<ArtifactLineageDagRun>>;
};

export type ArtifactLineageDagArtifact = {
  __typename: 'ArtifactLineageDagArtifact';
  artifactCommitHash: Scalars['String']['output'];
  artifactNodeID: Scalars['String']['output'];
  artifactSequenceName: Scalars['String']['output'];
  artifactTypeName: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
  versionIndex: Scalars['Int']['output'];
};

export type ArtifactLineageDagCluster = {
  __typename: 'ArtifactLineageDagCluster';
  artifactNodes: Array<Maybe<ArtifactLineageDagArtifact>>;
  clusterEdges: Array<Maybe<ArtifactLineageDagEdge>>;
  id: Scalars['String']['output'];
  nodeType: DagNodeType;
  runNodes: Array<Maybe<ArtifactLineageDagRun>>;
};

export type ArtifactLineageDagEdge = {
  __typename: 'ArtifactLineageDagEdge';
  artifactNodeID: Scalars['String']['output'];
  clusterNodeID?: Maybe<Scalars['String']['output']>;
  direction: DagDirection;
  edgeID: Scalars['String']['output'];
  runNodeID: Scalars['String']['output'];
};

export type ArtifactLineageDagRun = {
  __typename: 'ArtifactLineageDagRun';
  displayName?: Maybe<Scalars['String']['output']>;
  entityName: Scalars['String']['output'];
  jobType?: Maybe<Scalars['String']['output']>;
  projectName: Scalars['String']['output'];
  runName: Scalars['String']['output'];
  runNodeID: Scalars['String']['output'];
};

export type ArtifactManifest = {
  __typename: 'ArtifactManifest';
  artifact: Artifact;
  createdAt: Scalars['DateTime']['output'];
  digest: Scalars['String']['output'];
  file: File;
  id: Scalars['ID']['output'];
  type: ArtifactManifestType;
};

export type ArtifactManifestConnection = {
  __typename: 'ArtifactManifestConnection';
  edges: Array<ArtifactManifestEdge>;
  pageInfo: PageInfo;
};

export type ArtifactManifestEdge = {
  __typename: 'ArtifactManifestEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ArtifactManifest>;
};

export type ArtifactManifestEntryInput = {
  birthArtifactID?: InputMaybe<Scalars['ID']['input']>;
  digest: Scalars['String']['input'];
  name: Scalars['String']['input'];
  ref?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int64']['input']>;
};

export enum ArtifactManifestType {
  Full = 'FULL',
  Incremental = 'INCREMENTAL',
  Patch = 'PATCH'
}

export type ArtifactMetricSearchResult = {
  __typename: 'ArtifactMetricSearchResult';
  name: Scalars['String']['output'];
};

export type ArtifactMetricValue = {
  __typename: 'ArtifactMetricValue';
  aliases: Array<Scalars['String']['output']>;
  historyStep?: Maybe<Scalars['Int64']['output']>;
  membershipId: Scalars['ID']['output'];
  sourceProjectName?: Maybe<Scalars['String']['output']>;
  sourceRunName?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  versionIndex?: Maybe<Scalars['Int']['output']>;
};

export type ArtifactPortfolio = ArtifactCollection & {
  __typename: 'ArtifactPortfolio';
  aliasActionHistory: ArtifactAliasActionConnection;
  aliases: ArtifactAliasConnection;
  /** @deprecated Field no longer supported */
  artifactActions: ArtifactActionConnection;
  artifactCollectionActions: ArtifactCollectionActionConnection;
  artifactMembership?: Maybe<ArtifactCollectionMembership>;
  artifactMemberships: ArtifactCollectionMembershipConnection;
  artifactMetricSearch: Array<ArtifactMetricSearchResult>;
  artifactMetricValues: Array<ArtifactMetricValue>;
  artifacts: VersionedArtifactConnection;
  createdAt: Scalars['DateTime']['output'];
  defaultArtifactType: ArtifactType;
  description?: Maybe<Scalars['String']['output']>;
  hasArtifactVersionLinkedToGlobalRegistry: Scalars['Boolean']['output'];
  hasProtectedArtifact: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isModelRegistryMigratedArtifactCollection: Scalars['Boolean']['output'];
  linkedArtifactVersionUsageLimit?: Maybe<ArtifactUsageLimitStatus>;
  modelRegistryMigratedArtifactCollection?: Maybe<ArtifactCollection>;
  name: Scalars['String']['output'];
  overview?: Maybe<ArtifactCollectionOverview>;
  project?: Maybe<Project>;
  registryModelDeployments: RegistryModelDeploymentConnection;
  state: ArtifactCollectionState;
  tags: TagConnection;
  triggerExecutions: TriggerExecutionConnection;
  triggers: TriggerConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionIndexes: Array<Scalars['Int']['output']>;
};


export type ArtifactPortfolioAliasActionHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactPortfolioAliasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactPortfolioArtifactActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactPortfolioArtifactCollectionActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactPortfolioArtifactMembershipArgs = {
  aliasName: Scalars['String']['input'];
};


export type ArtifactPortfolioArtifactMembershipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactPortfolioArtifactMetricSearchArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  membershipIds: Array<Scalars['ID']['input']>;
  metricNamePattern?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactPortfolioArtifactMetricValuesArgs = {
  membershipIds: Array<Scalars['ID']['input']>;
  metricName: Scalars['String']['input'];
};


export type ArtifactPortfolioArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactPortfolioLinkedArtifactVersionUsageLimitArgs = {
  requestedIncrease: Scalars['Int64']['input'];
};


export type ArtifactPortfolioRegistryModelDeploymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Array<RegistryModelDeploymentState>>;
};


export type ArtifactPortfolioTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tagCategoryName?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactPortfolioTriggerExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  triggerID?: InputMaybe<Scalars['ID']['input']>;
};


export type ArtifactPortfolioTriggersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactPortfolioVersionIndexesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ArtifactSequence = ArtifactCollection & {
  __typename: 'ArtifactSequence';
  aliasActionHistory: ArtifactAliasActionConnection;
  aliases: ArtifactAliasConnection;
  /** @deprecated Field no longer supported */
  artifactActions: ArtifactActionConnection;
  artifactCollectionActions: ArtifactCollectionActionConnection;
  artifactMembership?: Maybe<ArtifactCollectionMembership>;
  artifactMemberships: ArtifactCollectionMembershipConnection;
  artifactMetricSearch: Array<ArtifactMetricSearchResult>;
  artifactMetricValues: Array<ArtifactMetricValue>;
  artifactVersionUsageLimit?: Maybe<ArtifactUsageLimitStatus>;
  artifacts: VersionedArtifactConnection;
  createdAt: Scalars['DateTime']['output'];
  defaultArtifactType: ArtifactType;
  description?: Maybe<Scalars['String']['output']>;
  digestAlgorithm: ArtifactDigestAlgorithm;
  hasArtifactVersionLinkedToGlobalRegistry: Scalars['Boolean']['output'];
  hasProtectedArtifact: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isModelRegistryMigratedArtifactCollection: Scalars['Boolean']['output'];
  latestArtifact?: Maybe<Artifact>;
  modelRegistryMigratedArtifactCollection?: Maybe<ArtifactCollection>;
  name: Scalars['String']['output'];
  overview?: Maybe<ArtifactCollectionOverview>;
  project?: Maybe<Project>;
  registryModelDeployments: RegistryModelDeploymentConnection;
  state: ArtifactCollectionState;
  tags: TagConnection;
  triggerExecutions: TriggerExecutionConnection;
  triggers: TriggerConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionIndexes: Array<Scalars['Int']['output']>;
};


export type ArtifactSequenceAliasActionHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactSequenceAliasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactSequenceArtifactActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactSequenceArtifactCollectionActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactSequenceArtifactMembershipArgs = {
  aliasName: Scalars['String']['input'];
};


export type ArtifactSequenceArtifactMembershipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactSequenceArtifactMetricSearchArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  membershipIds: Array<Scalars['ID']['input']>;
  metricNamePattern?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactSequenceArtifactMetricValuesArgs = {
  membershipIds: Array<Scalars['ID']['input']>;
  metricName: Scalars['String']['input'];
};


export type ArtifactSequenceArtifactVersionUsageLimitArgs = {
  requestedIncrease: Scalars['Int64']['input'];
};


export type ArtifactSequenceArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactSequenceRegistryModelDeploymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Array<RegistryModelDeploymentState>>;
};


export type ArtifactSequenceTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  tagCategoryName?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactSequenceTriggerExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  triggerID?: InputMaybe<Scalars['ID']['input']>;
};


export type ArtifactSequenceTriggersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactSequenceVersionIndexesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ArtifactSequenceConnection = {
  __typename: 'ArtifactSequenceConnection';
  edges: Array<ArtifactSequenceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ArtifactSequenceEdge = {
  __typename: 'ArtifactSequenceEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ArtifactSequence>;
};

export type ArtifactSequenceStorageNode = StorageTreeNode & {
  __typename: 'ArtifactSequenceStorageNode';
  artifactSequence: ArtifactSequence;
  artifactSequenceID: Scalars['ID']['output'];
  artifactType: ArtifactType;
  artifacts: ArtifactStorageNodeConnection;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int64']['output'];
};


export type ArtifactSequenceStorageNodeArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ArtifactSequenceStorageNodeConnection = {
  __typename: 'ArtifactSequenceStorageNodeConnection';
  edges: Array<ArtifactSequenceStorageNodeEdge>;
  pageInfo: PageInfo;
  totalSize: Scalars['Int64']['output'];
};

export type ArtifactSequenceStorageNodeEdge = {
  __typename: 'ArtifactSequenceStorageNodeEdge';
  cursor: Scalars['String']['output'];
  node: ArtifactSequenceStorageNode;
};

export enum ArtifactState {
  Committed = 'COMMITTED',
  Deleted = 'DELETED',
  Pending = 'PENDING'
}

export enum ArtifactStorageLayout {
  V1 = 'V1',
  V2 = 'V2'
}

export type ArtifactStorageNode = StorageTreeNode & {
  __typename: 'ArtifactStorageNode';
  artifact: Artifact;
  artifactID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int64']['output'];
};

export type ArtifactStorageNodeConnection = {
  __typename: 'ArtifactStorageNodeConnection';
  edges: Array<ArtifactStorageNodeEdge>;
  pageInfo: PageInfo;
  totalSize: Scalars['Int64']['output'];
};

export type ArtifactStorageNodeEdge = {
  __typename: 'ArtifactStorageNodeEdge';
  cursor: Scalars['String']['output'];
  node: ArtifactStorageNode;
};

export type ArtifactTagEventDetails = {
  __typename: 'ArtifactTagEventDetails';
  artifactCollectionName?: Maybe<Scalars['String']['output']>;
  artifactMetadata?: Maybe<Scalars['JSONString']['output']>;
  artifactVersionIndex?: Maybe<Scalars['Int']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type ArtifactType = {
  __typename: 'ArtifactType';
  artifact?: Maybe<Artifact>;
  /** @deprecated Field no longer supported */
  artifactActions?: Maybe<ArtifactActionConnection>;
  artifactCollection?: Maybe<ArtifactCollection>;
  artifactCollections?: Maybe<ArtifactCollectionConnection>;
  artifactSequence?: Maybe<ArtifactSequence>;
  artifactSequences?: Maybe<ArtifactSequenceConnection>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  project: Project;
};


export type ArtifactTypeArtifactArgs = {
  name: Scalars['String']['input'];
};


export type ArtifactTypeArtifactActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ArtifactTypeArtifactCollectionArgs = {
  name: Scalars['String']['input'];
};


export type ArtifactTypeArtifactCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionTypes?: InputMaybe<Array<ArtifactCollectionType>>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ArtifactTypeArtifactSequenceArgs = {
  name: Scalars['String']['input'];
};


export type ArtifactTypeArtifactSequencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

export type ArtifactTypeConnection = {
  __typename: 'ArtifactTypeConnection';
  edges: Array<ArtifactTypeEdge>;
  pageInfo: PageInfo;
};

export type ArtifactTypeEdge = {
  __typename: 'ArtifactTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ArtifactType>;
};

export type ArtifactTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ArtifactTypeNameConnection = {
  __typename: 'ArtifactTypeNameConnection';
  edges: Array<ArtifactTypeNameEdge>;
  pageInfo: PageInfo;
};

export type ArtifactTypeNameEdge = {
  __typename: 'ArtifactTypeNameEdge';
  cursor: Scalars['String']['output'];
  node: Scalars['String']['output'];
};

export type ArtifactTypeStorageNode = StorageTreeNode & {
  __typename: 'ArtifactTypeStorageNode';
  artifactType: ArtifactType;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int64']['output'];
};

export enum ArtifactUsageLimitBand {
  Blocked = 'BLOCKED',
  Ok = 'OK',
  Warning = 'WARNING'
}

export type ArtifactUsageLimitStatus = {
  __typename: 'ArtifactUsageLimitStatus';
  band: ArtifactUsageLimitBand;
  current: Scalars['Int64']['output'];
  limit?: Maybe<Scalars['Int64']['output']>;
  projected: Scalars['Int64']['output'];
};

export type ArtifactWeaveSource = {
  __typename: 'ArtifactWeaveSource';
  sourceType: WeaveSourceType;
};

export type AttachCustomerPaymentMethodInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
};

export type AttachCustomerPaymentMethodPayload = {
  __typename: 'AttachCustomerPaymentMethodPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type BenchmarkRun = {
  __typename: 'BenchmarkRun';
  benchmark: Project;
  createdAt: Scalars['DateTime']['output'];
  details?: Maybe<Scalars['JSON']['output']>;
  gitHubSubmissionPR?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCodeHidden: Scalars['Boolean']['output'];
  originalProject?: Maybe<Project>;
  originalRun?: Maybe<Run>;
  results?: Maybe<Scalars['String']['output']>;
  run: Run;
  state: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
};

export type BenchmarkRunConnection = {
  __typename: 'BenchmarkRunConnection';
  edges: Array<BenchmarkRunEdge>;
  pageInfo: PageInfo;
};

export type BenchmarkRunEdge = {
  __typename: 'BenchmarkRunEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<BenchmarkRun>;
};

export type BucketDiff = {
  __typename: 'BucketDiff';
  op: DiffOperation;
  run?: Maybe<Run>;
};

export type BucketDiffs = {
  __typename: 'BucketDiffs';
  delta: Array<BucketDiff>;
  incomplete?: Maybe<Array<Scalars['ID']['output']>>;
  order: Array<Scalars['ID']['output']>;
};

export type BucketStoreConnectionError = Error & {
  __typename: 'BucketStoreConnectionError';
  message: Scalars['String']['output'];
  severity: ErrorSeverity;
};

export type BucketType = {
  commit?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['JSONString']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  exampleTable?: Maybe<Scalars['JSONString']['output']>;
  exampleTableColumns?: Maybe<Scalars['JSONString']['output']>;
  exampleTableTypes?: Maybe<Scalars['JSONString']['output']>;
  fileCount?: Maybe<Scalars['Int']['output']>;
  files?: Maybe<FileConnection>;
  framework?: Maybe<Scalars['String']['output']>;
  github?: Maybe<Scalars['String']['output']>;
  history: Array<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logLines?: Maybe<LogLineConnection>;
  name?: Maybe<Scalars['String']['output']>;
  shouldStop?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  summaryMetrics?: Maybe<Scalars['JSONString']['output']>;
  sweep?: Maybe<Sweep>;
};


export type BucketTypeConfigArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type BucketTypeFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pattern?: InputMaybe<Scalars['String']['input']>;
};


export type BucketTypeHistoryArgs = {
  maxStep?: InputMaybe<Scalars['Int64']['input']>;
  minStep?: InputMaybe<Scalars['Int64']['input']>;
  samples?: InputMaybe<Scalars['Int']['input']>;
};


export type BucketTypeLogLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  useImprovedPagination?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BucketTypeSummaryMetricsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  packVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type CancelCustomerSubscriptionInput = {
  cancellationComments?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type CancelCustomerSubscriptionPayload = {
  __typename: 'CancelCustomerSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CancelPaygoSubscriptionsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type CancelPaygoSubscriptionsPayload = {
  __typename: 'CancelPaygoSubscriptionsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum CardBrand {
  Amex = 'AMEX',
  Diners = 'DINERS',
  Discover = 'DISCOVER',
  Interac = 'INTERAC',
  Jcb = 'JCB',
  Mastercard = 'MASTERCARD',
  Unionpay = 'UNIONPAY',
  Unknown = 'UNKNOWN',
  Visa = 'VISA'
}

export enum ChartAggOption {
  Last = 'last',
  Max = 'max',
  Mean = 'mean',
  Median = 'median',
  Min = 'min',
  Samples = 'samples',
  Sum = 'sum'
}

export type CheckoutPreview = {
  __typename: 'CheckoutPreview';
  lineItems: Array<Maybe<CheckoutPreviewLineItemsMetadata>>;
  renewalDate?: Maybe<Scalars['DateTime']['output']>;
  total: Scalars['Int']['output'];
};

export type CheckoutPreviewLineItemsMetadata = {
  __typename: 'CheckoutPreviewLineItemsMetadata';
  amount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  discountAmount?: Maybe<Scalars['Int']['output']>;
  position: Scalars['Int']['output'];
  product: Scalars['String']['output'];
  subLineItems: Array<Maybe<CheckoutPreviewSubLineItemsMetadata>>;
};

export type CheckoutPreviewSubLineItemsMetadata = {
  __typename: 'CheckoutPreviewSubLineItemsMetadata';
  amount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  proration: Scalars['Boolean']['output'];
};

export type ClaimAnonymousEntityInput = {
  anonymousApiKey: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type ClaimAnonymousEntityPayload = {
  __typename: 'ClaimAnonymousEntityPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  task: Task;
};

export type ClaimSlurmCommandsInput = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clusterName: Scalars['String']['input'];
};

export type ClaimSlurmCommandsPayload = {
  __typename: 'ClaimSlurmCommandsPayload';
  claimedCommands: Array<ClaimedSlurmCommand>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type ClaimedSlurmCommand = {
  __typename: 'ClaimedSlurmCommand';
  command: SlurmCommandType;
  id: Scalars['ID']['output'];
  jobId: Scalars['String']['output'];
  retryCount: Scalars['Int']['output'];
};

export type ClientIdMapping = {
  __typename: 'ClientIDMapping';
  clientID: Scalars['ID']['output'];
  entry: ClientIdMappingEntry;
  serverID: Scalars['ID']['output'];
};

export type ClientIdMappingEntry = Artifact | ArtifactSequence;

export type CloneProjectsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationEntityName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerUsername: Scalars['String']['input'];
  projectNames?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceEntityName: Scalars['String']['input'];
};

export type CloneProjectsPayload = {
  __typename: 'CloneProjectsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  tasks: Array<Task>;
};

export enum CloudProvider {
  Aws = 'AWS',
  Azure = 'AZURE',
  Coreweave = 'COREWEAVE',
  Gcp = 'GCP',
  Minio = 'MINIO'
}

export type CloudRegion = {
  __typename: 'CloudRegion';
  id: Scalars['ID']['output'];
  provider: CloudProvider;
  region: Scalars['String']['output'];
};

export type Code = {
  __typename: 'Code';
  body?: Maybe<Scalars['String']['output']>;
  directUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CollectionTagEventDetails = {
  __typename: 'CollectionTagEventDetails';
  artifactCollectionName?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type CommitArtifactInput = {
  artifactID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CommitArtifactPayload = {
  __typename: 'CommitArtifactPayload';
  artifact: Artifact;
  artifactMembership?: Maybe<ArtifactCollectionMembership>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export enum CompleteMultipartAction {
  Complete = 'Complete'
}

export type CompleteMultipartUploadArtifactInput = {
  artifactID: Scalars['ID']['input'];
  completeMultipartAction: CompleteMultipartAction;
  completedParts: Array<UploadPartsInput>;
  storagePath: Scalars['String']['input'];
  uploadID: Scalars['String']['input'];
};

export type CompleteMultipartUploadArtifactPayload = {
  __typename: 'CompleteMultipartUploadArtifactPayload';
  digest?: Maybe<Scalars['String']['output']>;
};

export type ContactUsForComputeHoursInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type ContactUsForComputeHoursPayload = {
  __typename: 'ContactUsForComputeHoursPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type ContactUsForUserLedTrialInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type ContactUsForUserLedTrialPayload = {
  __typename: 'ContactUsForUserLedTrialPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CoreweaveInfo = {
  __typename: 'CoreweaveInfo';
  clusterName: Scalars['String']['output'];
  orgId: Scalars['String']['output'];
  region: Scalars['String']['output'];
};

export type Coupon = {
  __typename: 'Coupon';
  amountOff: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  duration: Scalars['String']['output'];
  durationInMonths: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  percentOff: Scalars['Float']['output'];
};

export type CreateAwsExternalIdInput = {
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAcademicOrReverseTrialInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isAcademic: Scalars['Boolean']['input'];
  newOrganizationName: Scalars['String']['input'];
  newTeamName: Scalars['String']['input'];
};

export type CreateAcademicOrReverseTrialPayload = {
  __typename: 'CreateAcademicOrReverseTrialPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  orgID: Scalars['ID']['output'];
  subscription?: Maybe<Scalars['JSON']['output']>;
};

export type CreateAccessTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  previewURL?: InputMaybe<Scalars['String']['input']>;
  projects: Array<ProjectSpecifier>;
  username?: InputMaybe<Scalars['String']['input']>;
  viewId: Scalars['ID']['input'];
};

export type CreateAccessTokenPayload = {
  __typename: 'CreateAccessTokenPayload';
  accessToken: AccessToken;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  recipientAlreadyOnTeam?: Maybe<Scalars['Boolean']['output']>;
  toNewUser?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateAgentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  host: Scalars['String']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
  sweep: Scalars['String']['input'];
};

export type CreateAgentPayload = {
  __typename: 'CreateAgentPayload';
  agent?: Maybe<Agent>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateAlertPayload = {
  __typename: 'CreateAlertPayload';
  alert: Alert;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateAlertThresholdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationID: Scalars['ID']['input'];
  product: AlertThresholdProduct;
  type: AlertThresholdType;
  value: Scalars['Int']['input'];
};

export type CreateAlertThresholdPayload = {
  __typename: 'CreateAlertThresholdPayload';
  alertThreshold?: Maybe<AlertThreshold>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateAndLinkWeaveAssetInput = {
  aliases?: InputMaybe<Array<ArtifactAliasInput>>;
  artifactPortfolioID?: InputMaybe<Scalars['ID']['input']>;
  artifactPortfolioName?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  /** The weave:// URI (e.g., weave:///entity/project/object/name:version) */
  ref: Scalars['String']['input'];
};

export type CreateAnonymousEntityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateArtifactCollectionPayload = {
  __typename: 'CreateArtifactCollectionPayload';
  artifactCollection: ArtifactCollection;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateArtifactCollectionTagAssignmentsInput = {
  artifactCollectionName: Scalars['String']['input'];
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  tags: Array<TagInput>;
};

/** Event details for artifact creation. */
export type CreateArtifactEventInput = {
  /** The ID of the artifact version that was created */
  artifactId: Scalars['ID']['input'];
};

export type CreateArtifactFileSpecInput = {
  artifactID: Scalars['ID']['input'];
  artifactManifestID?: InputMaybe<Scalars['ID']['input']>;
  digest?: InputMaybe<Scalars['String']['input']>;
  md5: Scalars['String']['input'];
  mimetype?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  uploadPartsInput?: InputMaybe<Array<UploadPartsInput>>;
};

export type CreateArtifactFilesInput = {
  artifactFiles: Array<CreateArtifactFileSpecInput>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use storageRegion in CreateArtifact instead */
  cloudRegionID?: InputMaybe<Scalars['ID']['input']>;
  digestAlgorithm?: InputMaybe<ArtifactDigestAlgorithm>;
  storageLayout: ArtifactStorageLayout;
};

export type CreateArtifactFilesPayload = {
  __typename: 'CreateArtifactFilesPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  files: FileConnection;
};


export type CreateArtifactFilesPayloadFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateArtifactInput = {
  aliases?: InputMaybe<Array<ArtifactAliasInput>>;
  artifactCollectionName?: InputMaybe<Scalars['String']['input']>;
  artifactCollectionNames?: InputMaybe<Array<Scalars['String']['input']>>;
  artifactTypeName: Scalars['String']['input'];
  clientID?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  digest: Scalars['String']['input'];
  digestAlgorithm: ArtifactDigestAlgorithm;
  distributedID?: InputMaybe<Scalars['String']['input']>;
  enableDigestDeduplication?: InputMaybe<Scalars['Boolean']['input']>;
  entityName: Scalars['String']['input'];
  historyStep?: InputMaybe<Scalars['Int64']['input']>;
  /** @deprecated Field no longer supported */
  labels?: InputMaybe<Scalars['JSONString']['input']>;
  metadata?: InputMaybe<Scalars['JSONString']['input']>;
  projectName: Scalars['String']['input'];
  runName?: InputMaybe<Scalars['String']['input']>;
  sequenceClientID?: InputMaybe<Scalars['ID']['input']>;
  storageRegion?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<TagInput>>;
  ttlDurationSeconds?: InputMaybe<Scalars['Int64']['input']>;
};

export type CreateArtifactManifestInput = {
  artifactID: Scalars['ID']['input'];
  baseArtifactID?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  digest: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  type: ArtifactManifestType;
};

export type CreateArtifactManifestPayload = {
  __typename: 'CreateArtifactManifestPayload';
  artifactManifest: ArtifactManifest;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateArtifactPayload = {
  __typename: 'CreateArtifactPayload';
  artifact: Artifact;
  /** @deprecated Field no longer supported */
  artifactActions: Array<ArtifactAction>;
  artifactMembership?: Maybe<ArtifactCollectionMembership>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateArtifactPortfolioInput = {
  artifactTypeID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};

export type CreateArtifactSequenceInput = {
  artifactTypeID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};

export type CreateArtifactTagAssignmentsInput = {
  artifactID: Scalars['ID']['input'];
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  tags: Array<TagInput>;
};

export type CreateArtifactTypeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};

export type CreateArtifactTypePayload = {
  __typename: 'CreateArtifactTypePayload';
  artifactType: ArtifactType;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateArtifactTypesInput = {
  artifactTypes: Array<ArtifactTypeInput>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};

export type CreateArtifactTypesPayload = {
  __typename: 'CreateArtifactTypesPayload';
  artifactTypes: Array<ArtifactType>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateBenchmarkDiscussionCommentInput = {
  body: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discussionThreadID: Scalars['ID']['input'];
  parentCommentID?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateBenchmarkDiscussionThreadInput = {
  benchmarkEntityName: Scalars['String']['input'];
  benchmarkProjectName: Scalars['String']['input'];
  body?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateClientIdMappingInput = {
  clientID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  serverID: Scalars['ID']['input'];
};

export type CreateClientIdMappingPayload = {
  __typename: 'CreateClientIDMappingPayload';
  clientIDMapping: ClientIdMapping;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateClientInput = {
  entityName: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
};

export type CreateClientPayload = {
  __typename: 'CreateClientPayload';
  clientId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateCustomChartInput = {
  access: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  entity: Scalars['String']['input'];
  name: Scalars['String']['input'];
  spec: Scalars['JSONString']['input'];
  type: Scalars['String']['input'];
};

export type CreateCustomChartPayload = {
  __typename: 'CreateCustomChartPayload';
  chart: CustomChart;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCustomerSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newOrganizationName: Scalars['String']['input'];
  paymentMethod: Scalars['String']['input'];
  planId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  trial: Scalars['Boolean']['input'];
};

export type CreateCustomerSubscriptionPayload = {
  __typename: 'CreateCustomerSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  subscription?: Maybe<Scalars['JSON']['output']>;
};

export type CreateCustomerTrialInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newOrganizationName: Scalars['String']['input'];
  planId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  trialDays: Scalars['Int']['input'];
  userName: Scalars['String']['input'];
};

export type CreateCustomerTrialPayload = {
  __typename: 'CreateCustomerTrialPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Scalars['JSON']['output']>;
};

export type CreateDefaultResourceConfigInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  config: Scalars['JSONString']['input'];
  entityName: Scalars['String']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
  templateVariables?: InputMaybe<Scalars['JSONString']['input']>;
};

export type CreateDefaultResourceConfigPayload = {
  __typename: 'CreateDefaultResourceConfigPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  defaultResourceConfigID: Scalars['ID']['output'];
  schemaValidationErrors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type CreateDiscussionCommentPayload = {
  __typename: 'CreateDiscussionCommentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discussionComment: DiscussionComment;
};

export type CreateDiscussionThreadPayload = {
  __typename: 'CreateDiscussionThreadPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discussionThread: DiscussionThread;
};

export type CreateEmailSubscriptionInput = {
  alertID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEmailSubscriptionPayload = {
  __typename: 'CreateEmailSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subscription: EmailSubscription;
};

export type CreateEntityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultAccess?: InputMaybe<Scalars['String']['input']>;
  defaultFramework?: InputMaybe<Scalars['String']['input']>;
  invited?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateEntityPayload = {
  __typename: 'CreateEntityPayload';
  apiKey?: Maybe<ApiKey>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Entity>;
};

export type CreateExperimentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enrollmentPeriod: Scalars['Int']['input'];
  experimentType: ExperimentType;
  metadata?: InputMaybe<Scalars['JSONString']['input']>;
  name: Scalars['String']['input'];
  observationalUnit: ObservationalUnit;
  sampleSize: Scalars['Int']['input'];
  variants: Array<VariantInput>;
};

export type CreateExperimentPayload = {
  __typename: 'CreateExperimentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateFilterTriggerInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  eventFilter: Scalars['JSONString']['input'];
  name: Scalars['String']['input'];
  scopeID: Scalars['ID']['input'];
  scopeType: TriggerScopeType;
  triggeredActionConfig: TriggeredActionConfig;
  triggeredActionType: TriggeredActionType;
  triggeringEventType: EventTriggeringConditionType;
};

export type CreateFilterTriggerPayload = {
  __typename: 'CreateFilterTriggerPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  trigger?: Maybe<Trigger>;
};

export type CreateFinishedRunAlertInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGenericWebhookIntegrationInput = {
  accessTokenRef?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  secretRef?: InputMaybe<Scalars['String']['input']>;
  urlEndpoint: Scalars['String']['input'];
};

export type CreateGitHubOAuthIntegrationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  redirectURI: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type CreateGlueTaskInput = {
  arguments: Scalars['JSONString']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  status: Scalars['String']['input'];
  strategyMetadata: Scalars['String']['input'];
  strategyType: Scalars['String']['input'];
  taskType: Scalars['String']['input'];
};

export type CreateGlueTaskPayload = {
  __typename: 'CreateGlueTaskPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateHourOverageSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type CreateHourOverageSubscriptionPayload = {
  __typename: 'CreateHourOverageSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Scalars['JSON']['output']>;
};

export type CreateInferenceSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInferenceSubscriptionPayload = {
  __typename: 'CreateInferenceSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Scalars['JSON']['output']>;
};

export type CreateIntegrationPayload = {
  __typename: 'CreateIntegrationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  integration: Integration;
};

export type CreateInviteInput = {
  accountType?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use `role` instead. */
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  modelSeat?: InputMaybe<Scalars['String']['input']>;
  modelsSeat?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  weaveRole?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInvitePayload = {
  __typename: 'CreateInvitePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emailSent: Scalars['Boolean']['output'];
  entity?: Maybe<Entity>;
  invite?: Maybe<Invite>;
  remainingSeats?: Maybe<Scalars['Int']['output']>;
  remainingViewOnlySeats?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateLaunchAgentInput = {
  agentConfig?: InputMaybe<Scalars['JSONString']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  hostname: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runQueues: Array<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLaunchAgentPayload = {
  __typename: 'CreateLaunchAgentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  launchAgentId: Scalars['ID']['output'];
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateLocalLicenseOrganizationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newOrganizationName: Scalars['String']['input'];
};

export type CreateLocalLicenseOrganizationPayload = {
  __typename: 'CreateLocalLicenseOrganizationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization: Organization;
};

export type CreateNewsletterSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNewsletterSubscriptionPayload = {
  __typename: 'CreateNewsletterSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  newsletterSubscription: NewsletterSubscription;
};

export type CreateNotebookInput = {
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  template: NotebookTemplate;
};

export type CreateNotebookPayload = {
  __typename: 'CreateNotebookPayload';
  notebook?: Maybe<Notebook>;
};

export type CreateOAuthProviderInput = {
  accessTokenLifespanSeconds?: InputMaybe<Scalars['Int']['input']>;
  allowJwtReplay?: InputMaybe<Scalars['Boolean']['input']>;
  issuerUrl: Scalars['String']['input'];
  jwk?: InputMaybe<Scalars['JSONString']['input']>;
  organizationId: Scalars['ID']['input'];
  refreshEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  refreshFamilyLifespanSeconds?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateOAuthProviderPayload = {
  __typename: 'CreateOAuthProviderPayload';
  success: Scalars['Boolean']['output'];
};

export type CreateOrgServiceAccountInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultEntityId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type CreateOrgServiceAccountPayload = {
  __typename: 'CreateOrgServiceAccountPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type CreatePreviewableLinkInput = {
  author: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  redirectURL: Scalars['String']['input'];
  resourceID: Scalars['ID']['input'];
  resourceType: PreviewableLinkResourceType;
  title: Scalars['String']['input'];
  useDefaultImage: Scalars['Boolean']['input'];
};

export type CreatePreviewableLinkPayload = {
  __typename: 'CreatePreviewableLinkPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  previewImageUploadURL?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreatePricingPlanUpdatePrInput = {
  changes: Array<PricingPlanChangeInput>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newPlans: Array<NewPricingPlanInput>;
  prBody?: InputMaybe<Scalars['String']['input']>;
  prTitle: Scalars['String']['input'];
};

export type CreatePricingPlanUpdatePrPayload = {
  __typename: 'CreatePricingPlanUpdatePRPayload';
  branchName: Scalars['String']['output'];
  clientMutationId?: Maybe<Scalars['String']['output']>;
  prUrl: Scalars['String']['output'];
};

export type CreateProjectInput = {
  access?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateProjectMembersInput = {
  projectId: Scalars['ID']['input'];
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateProjectMembersPayload = {
  __typename: 'CreateProjectMembersPayload';
  success: Scalars['Boolean']['output'];
};

export type CreateProjectPayload = {
  __typename: 'CreateProjectPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
};

export type CreateRegistryHuggingFaceImportInput = {
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  hfRepoId: Scalars['String']['input'];
  hfRepoType: RegistryHuggingFaceImportRepoType;
  hfRevision?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  registry: RegistryHuggingFaceImportRegistryInput;
};

export type CreateRegistryHuggingFaceImportPayload = {
  __typename: 'CreateRegistryHuggingFaceImportPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  registryHuggingFaceImport: RegistryHuggingFaceImport;
};

export type CreateRegistryModelDeploymentInput = {
  backendType?: InputMaybe<RegistryModelDeploymentBackendType>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engine: Scalars['String']['input'];
  engineConfig?: InputMaybe<Scalars['JSONString']['input']>;
  idempotencyKey: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  registry: RegistryModelDeploymentSourceInput;
  sandbox: RegistryModelDeploymentSandboxInput;
};

export type CreateRegistryModelDeploymentPayload = {
  __typename: 'CreateRegistryModelDeploymentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  registryModelDeployment: RegistryModelDeployment;
};

export type CreateRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  inheritedFrom: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationID: Scalars['ID']['input'];
  permissions: Array<Scalars['String']['input']>;
};

export type CreateRolePayload = {
  __typename: 'CreateRolePayload';
  success: Scalars['Boolean']['output'];
};

export type CreateRunFilesInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  files: Array<Scalars['String']['input']>;
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
};

export type CreateRunFilesPayload = {
  __typename: 'CreateRunFilesPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  files: Array<File>;
  runID: Scalars['ID']['output'];
  uploadHeaders: Array<Scalars['String']['output']>;
};

export type CreateRunQueueInput = {
  access: RunQueueAccessType;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultResourceConfigID?: InputMaybe<Scalars['ID']['input']>;
  entityName: Scalars['String']['input'];
  prioritizationMode?: InputMaybe<RunQueuePrioritizationMode>;
  projectName: Scalars['String']['input'];
  queueName: Scalars['String']['input'];
};

export type CreateRunQueuePayload = {
  __typename: 'CreateRunQueuePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  queueID?: Maybe<Scalars['ID']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateSandboxInput = {
  entityName: Scalars['String']['input'];
  mode: SandboxMode;
  notebookId: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runNames: Array<Scalars['String']['input']>;
};

export type CreateSandboxPayload = {
  __typename: 'CreateSandboxPayload';
  id: Scalars['ID']['output'];
  /**
   * Short-lived credential handed to the sandbox bootstrap over postMessage.
   * Clients must not persist this value or place it in a URL.
   */
  token: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CreateSandboxPermissionInput = {
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSandboxPermissionPayload = {
  __typename: 'CreateSandboxPermissionPayload';
  clientMutationID?: Maybe<Scalars['String']['output']>;
};

export type CreateSandboxesSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSandboxesSubscriptionPayload = {
  __typename: 'CreateSandboxesSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Scalars['JSON']['output']>;
};

export type CreateScriptableRunAlertInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSemanticLegendInput = {
  bucketUpperBounds: Array<InputMaybe<Scalars['Float']['input']>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customColors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedRunColor: Scalars['String']['input'];
  metricName: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
  viewID: Scalars['ID']['input'];
  yValue: Scalars['String']['input'];
};

export type CreateSemanticLegendPayload = {
  __typename: 'CreateSemanticLegendPayload';
  success: Scalars['Boolean']['output'];
};

export type CreateServiceAccountApiKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  serviceAccountId: Scalars['ID']['input'];
};

export type CreateServiceAccountApiKeyPayload = {
  __typename: 'CreateServiceAccountApiKeyPayload';
  apiKey?: Maybe<ApiKey>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  secretApiKey?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateServiceAccountInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateServiceAccountPayload = {
  __typename: 'CreateServiceAccountPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type CreateSlackChannelSubscriptionInput = {
  alertID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationID: Scalars['ID']['input'];
};

export type CreateSlackChannelSubscriptionPayload = {
  __typename: 'CreateSlackChannelSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subscription: SlackChannelSubscription;
};

export type CreateSlackIntegrationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  redirectURI: Scalars['String']['input'];
};

export type CreateStoppedRunAlertInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  minimumRunDuration: Scalars['Duration']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStorageSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated storagePlanID is fetched within backend.  */
  storagePlanId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated trackingPlanID is fetched within backend.  */
  trackingPlanId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated trial is not relevant to storage subscription anymore. */
  trial?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateStorageSubscriptionPayload = {
  __typename: 'CreateStorageSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Scalars['JSON']['output']>;
};

export type CreateTagsPayload = {
  __typename: 'CreateTagsPayload';
  clientMutationID?: Maybe<Scalars['String']['output']>;
  tags: Array<Tag>;
};

export type CreateTeamInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultAccess?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  storageBucketInfo?: InputMaybe<StorageBucketInfoInput>;
  teamAdminUserName?: InputMaybe<Scalars['String']['input']>;
  teamName: Scalars['String']['input'];
};

export type CreateTeamPayload = {
  __typename: 'CreateTeamPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Entity>;
};

export type CreateUserEmailInput = {
  email: Scalars['String']['input'];
  type: EmailType;
};

export type CreateUserEmailPayload = {
  __typename: 'CreateUserEmailPayload';
  email?: Maybe<Email>;
  success: Scalars['Boolean']['output'];
};

export type CreateUserInput = {
  accountType?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  modelsSeat?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  weaveRole?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserLevelSlackIntegrationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  redirectURI: Scalars['String']['input'];
};

export type CreateUserLevelSlackIntegrationPayload = {
  __typename: 'CreateUserLevelSlackIntegrationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type CreateUserPayload = {
  __typename: 'CreateUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type CreateViewCommentsAlertSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  viewID: Scalars['ID']['input'];
};

export type CreateViewDiscussionCommentInput = {
  body: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discussionThreadID?: InputMaybe<Scalars['ID']['input']>;
  inlineCommentDetails?: InputMaybe<Scalars['JSONString']['input']>;
  notifyAllSubscribers?: InputMaybe<Scalars['Boolean']['input']>;
  viewID: Scalars['ID']['input'];
};

export type CreateViewDiscussionCommentPayload = {
  __typename: 'CreateViewDiscussionCommentPayload';
  alertSubscription: AlertSubscription;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discussionComment: DiscussionComment;
  discussionThread: DiscussionThread;
};

export type CustomChart = {
  __typename: 'CustomChart';
  access: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  entity: Entity;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  spec: Scalars['JSONString']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
};

export type CustomChartConnection = {
  __typename: 'CustomChartConnection';
  edges: Array<CustomChartEdge>;
  pageInfo: PageInfo;
};

export type CustomChartEdge = {
  __typename: 'CustomChartEdge';
  cursor: Scalars['String']['output'];
  node: CustomChart;
};

export type CustomColor = {
  __typename: 'CustomColor';
  bucketNumber: Scalars['Int64']['output'];
  colorHex: Scalars['String']['output'];
};

export enum DagDirection {
  AwayFromArtifact = 'AwayFromArtifact',
  TowardArtifact = 'TowardArtifact'
}

export enum DagNodeType {
  Artifact = 'Artifact',
  Run = 'Run'
}

export type DefaultResourceConfig = {
  __typename: 'DefaultResourceConfig';
  config?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  resource: Scalars['String']['output'];
  scope: DefaultResourceConfigScope;
  templateVariables: Array<TemplateVariable>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DefaultResourceConfigConnection = {
  __typename: 'DefaultResourceConfigConnection';
  edges: Array<DefaultResourceConfigEdge>;
  pageInfo: PageInfo;
};

export type DefaultResourceConfigEdge = {
  __typename: 'DefaultResourceConfigEdge';
  cursor: Scalars['String']['output'];
  node: DefaultResourceConfig;
};

export type DefaultResourceConfigScope = {
  __typename: 'DefaultResourceConfigScope';
  ID: Scalars['Int']['output'];
  Type: DefaultResourceConfigScopeType;
};

export enum DefaultResourceConfigScopeType {
  Entity = 'ENTITY',
  Project = 'PROJECT'
}

/** The outcome of any action that does not have a specialized result type. */
export type DefaultTriggerResultDetails = {
  __typename: 'DefaultTriggerResultDetails';
  error?: Maybe<TriggerExecutionError>;
};

export type DeleteAlertInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteAlertPayload = {
  __typename: 'DeleteAlertPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteAlertSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteAlertSubscriptionPayload = {
  __typename: 'DeleteAlertSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteAlertThresholdInput = {
  alertThresholdID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationID: Scalars['ID']['input'];
};

export type DeleteAlertThresholdPayload = {
  __typename: 'DeleteAlertThresholdPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteAliasesInput = {
  aliases: Array<ArtifactCollectionAliasInput>;
  artifactID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAliasesPayload = {
  __typename: 'DeleteAliasesPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteApiKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteApiKeyPayload = {
  __typename: 'DeleteApiKeyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteApiKeyRefInput = {
  apiKeyId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  serviceAccountId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteApiKeysInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  keys: Array<DeleteApiKeyRefInput>;
};

export type DeleteApiKeysPayload = {
  __typename: 'DeleteApiKeysPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCount: Scalars['Int']['output'];
};

export type DeleteArtifactAction = ArtifactAction & {
  __typename: 'DeleteArtifactAction';
  artifact: Artifact;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  initiator: Initiator;
};

export type DeleteArtifactByWeaveRefInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  items: Array<DeleteArtifactByWeaveRefItemInput>;
  mode: DeleteArtifactByWeaveRefMode;
  projectName: Scalars['String']['input'];
};

export type DeleteArtifactByWeaveRefItemInput = {
  digests?: InputMaybe<Array<Scalars['String']['input']>>;
  objectId: Scalars['String']['input'];
};

export enum DeleteArtifactByWeaveRefMode {
  DeleteArtifacts = 'DELETE_ARTIFACTS',
  UnlinkArtifacts = 'UNLINK_ARTIFACTS'
}

export type DeleteArtifactByWeaveRefPayload = {
  __typename: 'DeleteArtifactByWeaveRefPayload';
  artifacts: Array<Artifact>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type DeleteArtifactCollectionPayload = {
  __typename: 'DeleteArtifactCollectionPayload';
  artifactCollection: ArtifactCollection;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type DeleteArtifactCollectionTagAssignmentsInput = {
  artifactCollectionName: Scalars['String']['input'];
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  tags: Array<TagInput>;
};

export type DeleteArtifactEntityTtlInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
};

export type DeleteArtifactEntityTtlPayload = {
  __typename: 'DeleteArtifactEntityTTLPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type DeleteArtifactInput = {
  artifactID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleteAliases?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteArtifactPayload = {
  __typename: 'DeleteArtifactPayload';
  artifact: Artifact;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type DeleteArtifactPortfolioInput = {
  artifactPortfolioID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteArtifactSequenceInput = {
  artifactSequenceID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteArtifactTagAssignmentsInput = {
  artifactID: Scalars['ID']['input'];
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  tags: Array<TagInput>;
};

export type DeleteCustomChartInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entity: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DeleteCustomChartPayload = {
  __typename: 'DeleteCustomChartPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteDefaultResourceConfigsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultResourceConfigIDs: Array<Scalars['ID']['input']>;
};

export type DeleteDefaultResourceConfigsPayload = {
  __typename: 'DeleteDefaultResourceConfigsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  numAffected: Scalars['Int64']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteDiscussionCommentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleteThread?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteDiscussionCommentPayload = {
  __typename: 'DeleteDiscussionCommentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteExperimentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteExperimentPayload = {
  __typename: 'DeleteExperimentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteFilesByRunAndFolderInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  folders: Array<Scalars['String']['input']>;
  projectId: Scalars['Int']['input'];
  runName: Scalars['String']['input'];
};

export type DeleteFilesInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  files: Array<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
};

export type DeleteFilesPayload = {
  __typename: 'DeleteFilesPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteFromRunQueueInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  queueID: Scalars['ID']['input'];
  runQueueItemId: Scalars['ID']['input'];
};

export type DeleteFromRunQueuePayload = {
  __typename: 'DeleteFromRunQueuePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteGlueTaskInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteGlueTaskPayload = {
  __typename: 'DeleteGlueTaskPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteIntegrationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteIntegrationPayload = {
  __typename: 'DeleteIntegrationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteInviteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteInvitePayload = {
  __typename: 'DeleteInvitePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteLaunchAgentsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  launchAgentIds: Array<Scalars['ID']['input']>;
};

export type DeleteLaunchAgentsPayload = {
  __typename: 'DeleteLaunchAgentsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteModelInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type DeleteModelPayload = {
  __typename: 'DeleteModelPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteNotebookInput = {
  id: Scalars['ID']['input'];
};

export type DeleteNotebookPayload = {
  __typename: 'DeleteNotebookPayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteOAuthProviderInput = {
  providerId: Scalars['ID']['input'];
};

export type DeleteOAuthProviderPayload = {
  __typename: 'DeleteOAuthProviderPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteOrganizationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type DeleteOrganizationPayload = {
  __typename: 'DeleteOrganizationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteOrganizationSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  subscriptionID: Scalars['ID']['input'];
};

export type DeleteOrganizationSubscriptionPayload = {
  __typename: 'DeleteOrganizationSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteProjectMembersInput = {
  projectId: Scalars['ID']['input'];
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DeleteProjectMembersPayload = {
  __typename: 'DeleteProjectMembersPayload';
  success: Scalars['Boolean']['output'];
};

export type DeletePublicQueueLaunchAgentTeamConfigInput = {
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type DeletePublicQueueLaunchAgentTeamConfigPayload = {
  __typename: 'DeletePublicQueueLaunchAgentTeamConfigPayload';
  clientMutationID?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteRoleInput = {
  roleID: Scalars['ID']['input'];
};

export type DeleteRolePayload = {
  __typename: 'DeleteRolePayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteRolePermissionsInput = {
  permissions: Array<Scalars['String']['input']>;
  roleID: Scalars['ID']['input'];
};

export type DeleteRolePermissionsPayload = {
  __typename: 'DeleteRolePermissionsPayload';
  success: Scalars['Boolean']['output'];
};

export type DeleteRunInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleteArtifacts?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteRunPayload = {
  __typename: 'DeleteRunPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  numDeleted?: Maybe<Scalars['Int64']['output']>;
};

export type DeleteRunQueuesInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  queueIDs: Array<Scalars['ID']['input']>;
};

export type DeleteRunQueuesPayload = {
  __typename: 'DeleteRunQueuesPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteRunsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleteArtifacts?: InputMaybe<Scalars['Boolean']['input']>;
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  projectName: Scalars['String']['input'];
};

export type DeleteRunsPayload = {
  __typename: 'DeleteRunsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
};

export type DeleteSecretInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  secretName: Scalars['String']['input'];
};

export type DeleteSecretPayload = {
  __typename: 'DeleteSecretPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteServiceAccountApiKeyInput = {
  apiKeyId: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  serviceAccountId: Scalars['ID']['input'];
};

export type DeleteServiceAccountApiKeyPayload = {
  __typename: 'DeleteServiceAccountApiKeyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteServiceAccountInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteServiceAccountPayload = {
  __typename: 'DeleteServiceAccountPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type DeleteSweepInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleteRuns: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type DeleteSweepsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleteRuns: Scalars['Boolean']['input'];
  ids: Array<Scalars['ID']['input']>;
};

export type DeleteSweepsPayload = {
  __typename: 'DeleteSweepsPayload';
  affectedAgents: Scalars['Int']['output'];
  affectedRuns: Scalars['Int']['output'];
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type DeleteTagAssignmentPayload = {
  __typename: 'DeleteTagAssignmentPayload';
  clientMutationID?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteTeamInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamName: Scalars['String']['input'];
};

export type DeleteTeamPayload = {
  __typename: 'DeleteTeamPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteTeamSecretInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  secretName: Scalars['String']['input'];
};

export type DeleteTeamSecretPayload = {
  __typename: 'DeleteTeamSecretPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteTriggerInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  triggerID: Scalars['ID']['input'];
};

export type DeleteTriggerPayload = {
  __typename: 'DeleteTriggerPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteUserEmailInput = {
  id: Scalars['ID']['input'];
};

export type DeleteUserEmailPayload = {
  __typename: 'DeleteUserEmailPayload';
  email?: Maybe<Email>;
  success: Scalars['Boolean']['output'];
};

export type DeleteUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteUserLevelSlackIntegrationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationID?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use integrationID. */
  webhookURL?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteUserLevelSlackIntegrationPayload = {
  __typename: 'DeleteUserLevelSlackIntegrationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type DeleteUserPayload = {
  __typename: 'DeleteUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type DeleteUserSecretInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  secretName: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteUserSecretPayload = {
  __typename: 'DeleteUserSecretPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteViewInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleteDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteViewPayload = {
  __typename: 'DeleteViewPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  pendingDrafts?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteViewsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleteDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

export type DeleteViewsPayload = {
  __typename: 'DeleteViewsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  pendingDrafts?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteWorkflowsAdminInput = {
  adminType: WorkflowsAdminType;
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteWorkflowsAdminPayload = {
  __typename: 'DeleteWorkflowsAdminPayload';
  clientMutationID?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DeleteWorkspaceTemplateInput = {
  /** @deprecated Use linePlotTemplateId or workspaceLayoutTemplateId */
  id?: InputMaybe<Scalars['ID']['input']>;
  linePlotTemplateId?: InputMaybe<Scalars['ID']['input']>;
  workspaceLayoutTemplateId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteWorkspaceTemplatePayload = {
  __typename: 'DeleteWorkspaceTemplatePayload';
  success: Scalars['Boolean']['output'];
};

export type DeletedProjectInfo = {
  __typename: 'DeletedProjectInfo';
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  entityName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  storageKey: Scalars['String']['output'];
};

export type DeletedRunConnection = {
  __typename: 'DeletedRunConnection';
  edges: Array<DeletedRunEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DeletedRunEdge = {
  __typename: 'DeletedRunEdge';
  cursor: Scalars['String']['output'];
  node: DeletedRunInfo;
};

export type DeletedRunInfo = {
  __typename: 'DeletedRunInfo';
  deletedAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type DetachCustomerPaymentMethodInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
};

export type DetachCustomerPaymentMethodPayload = {
  __typename: 'DetachCustomerPaymentMethodPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum DevicePlatform {
  Ios = 'IOS'
}

export enum DiffOperation {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Update = 'UPDATE'
}

export type DisableGlueTaskInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type DisableGlueTaskPayload = {
  __typename: 'DisableGlueTaskPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DisableOldTrackingSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type DisableOldTrackingSubscriptionPayload = {
  __typename: 'DisableOldTrackingSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  subscriptionID?: Maybe<Scalars['String']['output']>;
};

export type Discount = {
  __typename: 'Discount';
  coupon: Coupon;
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type DiscussionComment = {
  __typename: 'DiscussionComment';
  body: Scalars['String']['output'];
  childComments: DiscussionCommentConnection;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isParent: Scalars['Boolean']['output'];
  parentComment?: Maybe<DiscussionComment>;
  poster: User;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  upvotes: Scalars['Int']['output'];
};


export type DiscussionCommentChildCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DiscussionCommentConnection = {
  __typename: 'DiscussionCommentConnection';
  edges: Array<DiscussionCommentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DiscussionCommentEdge = {
  __typename: 'DiscussionCommentEdge';
  cursor: Scalars['String']['output'];
  node: DiscussionComment;
};

export type DiscussionThread = {
  __typename: 'DiscussionThread';
  body: Scalars['String']['output'];
  comments: DiscussionCommentConnection;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  poster: User;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  upvotes: Scalars['Int']['output'];
};


export type DiscussionThreadCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DiscussionThreadConnection = {
  __typename: 'DiscussionThreadConnection';
  edges: Array<DiscussionThreadEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DiscussionThreadEdge = {
  __typename: 'DiscussionThreadEdge';
  cursor: Scalars['String']['output'];
  node: DiscussionThread;
};

export type DismissedBanner = {
  __typename: 'DismissedBanner';
  dismissedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
};

export enum DotBehavior {
  KeepAllDotValues = 'KEEP_ALL_DOT_VALUES',
  SkipFirstDotValue = 'SKIP_FIRST_DOT_VALUE'
}

/**
 * Duplicates a notebook: copies its current version into a new notebook (the
 * version history does not come along). The optional destination selects the
 * project the duplicate is created in; both fields must be provided together,
 * and they default to the source notebook's project.
 */
export type DuplicateNotebookInput = {
  entityName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
};

export type DuplicateNotebookPayload = {
  __typename: 'DuplicateNotebookPayload';
  notebook?: Maybe<Notebook>;
};

export type DynamicConfig = {
  __typename: 'DynamicConfig';
  value: Scalars['JSON']['output'];
};

export type Email = {
  __typename: 'Email';
  createdAt: Scalars['DateTime']['output'];
  emailAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  identities: Array<Identity>;
  type: EmailType;
  verified: Scalars['Boolean']['output'];
};

export type EmailSubscription = AlertSubscription & {
  __typename: 'EmailSubscription';
  id: Scalars['ID']['output'];
};

export enum EmailType {
  Academic = 'ACADEMIC',
  Corporate = 'CORPORATE',
  Personal = 'PERSONAL'
}

export type EnableGlueTaskInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type EnableGlueTaskPayload = {
  __typename: 'EnableGlueTaskPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type EnqueueSweepRunInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  config: Scalars['JSONString']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type EnqueueSweepRunPayload = {
  __typename: 'EnqueueSweepRunPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  runQueueItemId?: Maybe<Scalars['String']['output']>;
};

export type EnsureSandboxesOverageSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type EnsureSandboxesOverageSubscriptionPayload = {
  __typename: 'EnsureSandboxesOverageSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  newSubscriptionID?: Maybe<Scalars['String']['output']>;
};

export type EnsureWbagentOverageSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type EnsureWbagentOverageSubscriptionPayload = {
  __typename: 'EnsureWbagentOverageSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  newSubscriptionID?: Maybe<Scalars['String']['output']>;
};

export type Entity = Node & {
  __typename: 'Entity';
  accessTokens: Array<AccessToken>;
  artifactCollectionStorageTree?: Maybe<ArtifactStorageNodeConnection>;
  artifactCollections?: Maybe<ArtifactCollectionConnection>;
  artifactCollectionsSearch?: Maybe<ArtifactCollectionSearchConnection>;
  artifactMemberships?: Maybe<ArtifactCollectionMembershipConnection>;
  artifactTTLDurationSeconds: Scalars['Int64']['output'];
  artifactTypeNames?: Maybe<ArtifactTypeNameConnection>;
  available?: Maybe<Scalars['Boolean']['output']>;
  claimedEntities?: Maybe<EntityConnection>;
  claimingEntity?: Maybe<Entity>;
  codeSavingEnabled: Scalars['Boolean']['output'];
  computeHours: Scalars['Duration']['output'];
  createdAt: Scalars['DateTime']['output'];
  dailyRunCount: Array<Scalars['Int']['output']>;
  defaultAccess: Scalars['String']['output'];
  defaultAlerts: Array<Alert>;
  defaultResourceConfig?: Maybe<DefaultResourceConfig>;
  defaultResourceConfigs?: Maybe<DefaultResourceConfigConnection>;
  dynamicConfig?: Maybe<DynamicConfig>;
  entityType?: Maybe<Scalars['String']['output']>;
  featureFlags: Array<Maybe<FeatureFlag>>;
  id: Scalars['ID']['output'];
  integrations?: Maybe<IntegrationConnection>;
  invitedTeam?: Maybe<Scalars['String']['output']>;
  invites?: Maybe<InviteConnection>;
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  isTeam: Scalars['Boolean']['output'];
  latestRuns?: Maybe<RunConnection>;
  launchProject?: Maybe<Project>;
  limits?: Maybe<Scalars['JSONString']['output']>;
  member?: Maybe<Member>;
  memberCount: Scalars['Int']['output'];
  members: Array<Member>;
  modelRegistryMigrationConfig?: Maybe<ModelRegistryMigrationConfig>;
  name: Scalars['String']['output'];
  /**
   * Notebooks in this team's projects, restricted to projects the current
   * viewer can read.
   *
   * Use `search` for a case-insensitive match on notebook name or author
   * name/username, `userID` to filter by author, and `viewerPermissions` to
   * return only notebooks the current viewer holds the given permissions on.
   * Use the cursor arguments
   * (`first`/`last` with `before`/`after`) to page through results.
   *
   * Project readability is applied after each page is read, so a page can
   * return fewer edges than `first`, or none at all, while `hasNextPage` is
   * true. Page until `hasNextPage` is false rather than stopping on the first
   * short or empty page.
   */
  notebooks: NotebookConnection;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  photoUploadUrl: Scalars['String']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
  privateOnly: Scalars['Boolean']['output'];
  profileView?: Maybe<View>;
  project?: Maybe<Project>;
  projectCount: Scalars['Int']['output'];
  projects?: Maybe<ProjectConnection>;
  protectedAliases: Array<Scalars['String']['output']>;
  publicQueueLaunchAgents: Array<User>;
  rateLimits?: Maybe<RateLimits>;
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  readOnlyAdmin: Scalars['Boolean']['output'];
  referenceBytes: Scalars['Int64']['output'];
  registryModelDeployments: RegistryModelDeploymentConnection;
  repos?: Maybe<RepoConnection>;
  sandbox?: Maybe<Sandbox>;
  sandboxesConnection: SandboxConnection;
  secrets: Array<Secret>;
  settings: EntitySettings;
  storageBytes: Scalars['Int64']['output'];
  storageTree?: Maybe<EntityStorageNode>;
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  tagCategories: Array<TagCategory>;
  /** Execution history for any automation under this entity. */
  triggerExecutions: TriggerExecutionConnection;
  /**
   * All automations under this entity, including project- and collection-scoped descendants.
   * Set entityOnly: true to narrow to triggers whose scope is this entity itself.
   */
  triggers: TriggerConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadHeaders: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
  userStats?: Maybe<EntityUserConnection>;
  views: ViewConnection;
  workflowsAdmins: Array<User>;
  xxhashDigestsEnabled: Scalars['Boolean']['output'];
};


export type EntityArtifactCollectionStorageTreeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  artifactCollectionID: Scalars['ID']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  cached?: InputMaybe<Scalars['Boolean']['input']>;
  enableReferenceTracking?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EntityArtifactCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionTypes?: InputMaybe<Array<ArtifactCollectionType>>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  projectFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type EntityArtifactCollectionsSearchArgs = {
  artifactsLimit?: InputMaybe<Scalars['Int']['input']>;
  collectionTypes?: InputMaybe<Array<ArtifactCollectionType>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type EntityArtifactMembershipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionFilters?: InputMaybe<Scalars['JSONString']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  projectFilters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type EntityArtifactTypeNamesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EntityClaimedEntitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EntityComputeHoursArgs = {
  minDaysOld?: InputMaybe<Scalars['Int']['input']>;
  timeWindow?: InputMaybe<TimeWindow>;
};


export type EntityDailyRunCountArgs = {
  limit: Scalars['Int']['input'];
};


export type EntityDefaultResourceConfigArgs = {
  id: Scalars['ID']['input'];
};


export type EntityDefaultResourceConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EntityDynamicConfigArgs = {
  configId: Scalars['String']['input'];
};


export type EntityFeatureFlagsArgs = {
  featureKey?: InputMaybe<Scalars['String']['input']>;
  rampIDType: RampIdType;
};


export type EntityIntegrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EntityInvitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keysOnly?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type EntityLatestRunsArgs = {
  excludeUserID?: InputMaybe<Scalars['ID']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type EntityMemberArgs = {
  id: Scalars['ID']['input'];
};


export type EntityNotebooksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  viewerPermissions?: InputMaybe<Array<NotebookPermission>>;
};


export type EntityProjectArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type EntityProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
};


export type EntityProtectedAliasesArgs = {
  adminType: WorkflowsAdminType;
};


export type EntityReferenceBytesArgs = {
  cached?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EntityRegistryModelDeploymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registryProjectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  states?: InputMaybe<Array<RegistryModelDeploymentState>>;
};


export type EntityReposArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EntitySandboxArgs = {
  id: Scalars['ID']['input'];
};


export type EntitySandboxesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  runnerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  showTerminated?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<SandboxState>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  volumeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type EntityStorageBytesArgs = {
  cached?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EntityStorageTreeArgs = {
  cached?: InputMaybe<Scalars['Boolean']['input']>;
  enableReferenceTracking?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EntityTriggerExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  triggerID?: InputMaybe<Scalars['ID']['input']>;
};


export type EntityTriggersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entityOnly?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type EntityUserStatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['DateTime']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type EntityViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  displayNameContains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type EntityWorkflowsAdminsArgs = {
  adminType: WorkflowsAdminType;
};

export type EntityConnection = {
  __typename: 'EntityConnection';
  edges: Array<EntityEdge>;
};

export type EntityEdge = {
  __typename: 'EntityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Entity>;
};

export type EntitySettings = {
  __typename: 'EntitySettings';
  defaultCloudRegion: CloudRegion;
  disableMagicLinkSharing?: Maybe<Scalars['Boolean']['output']>;
  disableMembersEditArtifactTTL: Scalars['Boolean']['output'];
  entityProfileEnabled: Scalars['Boolean']['output'];
  hidden: Scalars['Boolean']['output'];
  hideActivityCalendar: Scalars['Boolean']['output'];
  membersCanInvite?: Maybe<Scalars['Boolean']['output']>;
  openToMatchingOrgEmailDomainUsers?: Maybe<Scalars['Boolean']['output']>;
  referenceBucketInfos: Array<StorageBucketInfo>;
  storageBucketInfo?: Maybe<StorageBucketInfo>;
};

export type EntitySettingsInput = {
  defaultCloudRegionID?: InputMaybe<Scalars['String']['input']>;
  disableMagicLinkSharing?: InputMaybe<Scalars['Boolean']['input']>;
  disableMembersEditArtifactTTL?: InputMaybe<Scalars['Boolean']['input']>;
  entityProfileEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  hideActivityCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  membersCanInvite?: InputMaybe<Scalars['Boolean']['input']>;
  openToMatchingOrgEmailDomainUsers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EntityStorageNode = StorageTreeNode & {
  __typename: 'EntityStorageNode';
  entity: Entity;
  entityID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  projects: ProjectStorageNodeConnection;
  size: Scalars['Int64']['output'];
};


export type EntityStorageNodeProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type EntityUsage = {
  __typename: 'EntityUsage';
  entityName: Scalars['String']['output'];
  value: Scalars['Int64']['output'];
};

export type EntityUser = Node & {
  __typename: 'EntityUser';
  id: Scalars['ID']['output'];
  runCount: Scalars['Int']['output'];
  user: User;
};

export type EntityUserConnection = {
  __typename: 'EntityUserConnection';
  edges: Array<EntityUserEdge>;
};

export type EntityUserEdge = {
  __typename: 'EntityUserEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<EntityUser>;
};

export type Error = {
  message: Scalars['String']['output'];
};

export enum ErrorSeverity {
  Error = 'ERROR',
  Warn = 'WARN'
}

export type Event = {
  __typename: 'Event';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  extra?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type EventEdge = {
  __typename: 'EventEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Event>;
};

export enum EventTriggeringConditionType {
  AddArtifactAlias = 'ADD_ARTIFACT_ALIAS',
  AddArtifactTag = 'ADD_ARTIFACT_TAG',
  AddCollectionTag = 'ADD_COLLECTION_TAG',
  CreateArtifact = 'CREATE_ARTIFACT',
  LinkModel = 'LINK_MODEL',
  RemoveArtifactTag = 'REMOVE_ARTIFACT_TAG',
  RemoveCollectionTag = 'REMOVE_COLLECTION_TAG',
  RunMetric = 'RUN_METRIC',
  RunMetricChange = 'RUN_METRIC_CHANGE',
  RunMetricZscore = 'RUN_METRIC_ZSCORE',
  RunState = 'RUN_STATE',
  UnlinkArtifact = 'UNLINK_ARTIFACT',
  /** @deprecated Use ADD_ARTIFACT_ALIAS instead */
  UpdateArtifactAlias = 'UPDATE_ARTIFACT_ALIAS',
  WeaveMetricThreshold = 'WEAVE_METRIC_THRESHOLD'
}

export type ExecuteTriggerInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  event: TriggerEventInput;
  projectName: Scalars['String']['input'];
  triggerId: Scalars['ID']['input'];
};

export type ExecuteTriggerPayload = {
  __typename: 'ExecuteTriggerPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExpansionPack = Node & {
  __typename: 'ExpansionPack';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  secondsLimit: Scalars['Duration']['output'];
  secondsRemaining: Scalars['Duration']['output'];
};

export type ExpansionPackConnection = {
  __typename: 'ExpansionPackConnection';
  edges: Array<ExpansionPackEdge>;
};

export type ExpansionPackEdge = {
  __typename: 'ExpansionPackEdge';
  cursor: Scalars['String']['output'];
  node: ExpansionPack;
};

export type Experiment = Node & {
  __typename: 'Experiment';
  endAt?: Maybe<Scalars['DateTime']['output']>;
  enrollmentPeriod: Scalars['Int']['output'];
  experimentType: ExperimentType;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  observationalUnit: ObservationalUnit;
  sampleSize: Scalars['Int']['output'];
  startAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  variants: Array<Variant>;
};

export enum ExperimentExposureUnit {
  Entity = 'ENTITY',
  Organization = 'ORGANIZATION',
  User = 'USER'
}

export enum ExperimentType {
  AbTest = 'AB_TEST',
  FeatureFlag = 'FEATURE_FLAG'
}

export type FailRunQueueItemInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  filePaths?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated use message, stage and filePaths instead */
  info?: InputMaybe<Scalars['JSONString']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  runQueueItemId: Scalars['ID']['input'];
  stage?: InputMaybe<Scalars['String']['input']>;
};

export type FailRunQueueItemPayload = {
  __typename: 'FailRunQueueItemPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type FailSlurmCommandInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  errorMessage: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type FailSlurmCommandPayload = {
  __typename: 'FailSlurmCommandPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type FailedPaymentBanners = {
  __typename: 'FailedPaymentBanners';
  orgsWithFailedPayments: Array<Maybe<OrganizationDataForFailedPaymentBanner>>;
  userID: Scalars['Int']['output'];
};

export type FeatureFlag = {
  __typename: 'FeatureFlag';
  isEnabled: Scalars['Boolean']['output'];
  rampKey: Scalars['String']['output'];
};

export type File = Node & {
  __typename: 'File';
  archived?: Maybe<Scalars['Boolean']['output']>;
  artifact?: Maybe<Artifact>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dashSrc?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  digest?: Maybe<Scalars['String']['output']>;
  directUrl: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  exists: Scalars['Boolean']['output'];
  hlsSrc?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isReference: Scalars['Boolean']['output'];
  md5?: Maybe<Scalars['String']['output']>;
  mimetype?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated Use id instead */
  ndbId?: Maybe<Scalars['ID']['output']>;
  sizeBytes: Scalars['Int64']['output'];
  special?: Maybe<Scalars['Boolean']['output']>;
  storageBucket?: Maybe<Scalars['String']['output']>;
  storagePath?: Maybe<Scalars['String']['output']>;
  thumbnails: Array<Thumbnail>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadHeaders: Array<Scalars['String']['output']>;
  uploadMultipartUrls?: Maybe<UploadMultipartUrls>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


export type FileUrlArgs = {
  upload?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FileConnection = {
  __typename: 'FileConnection';
  edges: Array<FileEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  uploadHeaders: Array<Scalars['String']['output']>;
};

export type FileEdge = {
  __typename: 'FileEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<File>;
};

export type FileStorageNode = StorageTreeNode & {
  __typename: 'FileStorageNode';
  file: File;
  fileID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int64']['output'];
};

export type FileStorageNodeConnection = {
  __typename: 'FileStorageNodeConnection';
  edges: Array<FileStorageNodeEdge>;
  pageInfo: PageInfo;
  totalSize: Scalars['Int64']['output'];
};

export type FileStorageNodeEdge = {
  __typename: 'FileStorageNodeEdge';
  cursor: Scalars['String']['output'];
  node: FileStorageNode;
};

export type FileSystemSnapshot = {
  __typename: 'FileSystemSnapshot';
  completeTime?: Maybe<Scalars['DateTime']['output']>;
  createTime?: Maybe<Scalars['DateTime']['output']>;
  fileSystemSnapshotId: Scalars['ID']['output'];
  sizeBytes: Scalars['Int64']['output'];
  sourceSandboxId: Scalars['ID']['output'];
  sourceVolumeName: Scalars['String']['output'];
  state: FileSystemSnapshotState;
  stateReason: Scalars['String']['output'];
  trigger: FileSystemSnapshotTrigger;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FileSystemSnapshotConnection = {
  __typename: 'FileSystemSnapshotConnection';
  edges: Array<FileSystemSnapshotEdge>;
  pageInfo: PageInfo;
};

export type FileSystemSnapshotEdge = {
  __typename: 'FileSystemSnapshotEdge';
  cursor: Scalars['String']['output'];
  node: FileSystemSnapshot;
};

export enum FileSystemSnapshotState {
  SnapshotStateCreating = 'SNAPSHOT_STATE_CREATING',
  SnapshotStateDeleting = 'SNAPSHOT_STATE_DELETING',
  SnapshotStateFailed = 'SNAPSHOT_STATE_FAILED',
  SnapshotStateReady = 'SNAPSHOT_STATE_READY',
  SnapshotStateUnspecified = 'SNAPSHOT_STATE_UNSPECIFIED'
}

export enum FileSystemSnapshotTrigger {
  SnapshotTriggerManual = 'SNAPSHOT_TRIGGER_MANUAL',
  SnapshotTriggerOnDelete = 'SNAPSHOT_TRIGGER_ON_DELETE',
  SnapshotTriggerUnspecified = 'SNAPSHOT_TRIGGER_UNSPECIFIED'
}

export type FilterEventTriggeringCondition = {
  __typename: 'FilterEventTriggeringCondition';
  eventType: EventTriggeringConditionType;
  filter: Scalars['String']['output'];
};

export type FinishedRunCondition = {
  __typename: 'FinishedRunCondition';
  success: Scalars['Boolean']['output'];
};

export type FolderMetadata = {
  __typename: 'FolderMetadata';
  name: Scalars['String']['output'];
  numberOfFiles: Scalars['Int64']['output'];
  size: Scalars['Int64']['output'];
};

export type Folders = {
  __typename: 'Folders';
  folderList: Array<Maybe<FolderMetadata>>;
};

export type ForceCleanArtifactStorageStatsInput = {
  artifactCollectionIDs: Array<Scalars['ID']['input']>;
};

export type ForceCleanArtifactStorageStatsPayload = {
  __typename: 'ForceCleanArtifactStorageStatsPayload';
  cleanedArtifactCollectionIDs: Array<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ForceCleanRunStorageStatsInput = {
  projectIDs: Array<Scalars['Int']['input']>;
};

export type ForceCleanRunStorageStatsPayload = {
  __typename: 'ForceCleanRunStorageStatsPayload';
  cleanedProjectIDs: Array<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GenerateApiKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateApiKeyPayload = {
  __typename: 'GenerateApiKeyPayload';
  apiKey?: Maybe<ApiKey>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  secretApiKey?: Maybe<Scalars['String']['output']>;
};

export type GenerateArtifactCollectionOverviewAiInput = {
  artifactCollectionID: Scalars['ID']['input'];
  plan: ArtifactCollectionOverviewAiPlanInput;
};

export type GenerateArtifactCollectionOverviewDraftInput = {
  artifactCollectionID: Scalars['ID']['input'];
};

export type GenerateArtifactCollectionOverviewDraftPayload = {
  __typename: 'GenerateArtifactCollectionOverviewDraftPayload';
  draftViewID: Scalars['ID']['output'];
  publishedViewID: Scalars['ID']['output'];
};

export type GenerateLocalLicenseInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactEmail: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  expDuration: Scalars['Int']['input'];
  flags: Array<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  seats: Scalars['Int']['input'];
  storageGigs: Scalars['Int']['input'];
  teams: Scalars['Int']['input'];
};

export type GenerateLocalLicensePayload = {
  __typename: 'GenerateLocalLicensePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  localLicense: LocalLicense;
};

export type GenericWebhookActionArgs = {
  __typename: 'GenericWebhookActionArgs';
  integration?: Maybe<GenericWebhookIntegration>;
  requestPayload?: Maybe<Scalars['JSONString']['output']>;
};

export type GenericWebhookActionInput = {
  integrationID: Scalars['ID']['input'];
  requestPayload?: InputMaybe<Scalars['JSONString']['input']>;
};

export type GenericWebhookIntegration = Integration & {
  __typename: 'GenericWebhookIntegration';
  accessTokenRef?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  secretRef?: Maybe<Scalars['String']['output']>;
  urlEndpoint: Scalars['String']['output'];
};

export type GenericWebhookTriggeredAction = {
  __typename: 'GenericWebhookTriggeredAction';
  entityName: Scalars['String']['output'];
  integration: Integration;
  readOnly: Scalars['Boolean']['output'];
  requestPayload?: Maybe<Scalars['JSONString']['output']>;
};

export type GitHubOAuthIntegration = Integration & {
  __typename: 'GitHubOAuthIntegration';
  id: Scalars['ID']['output'];
};

export type GitInfo = {
  __typename: 'GitInfo';
  commit?: Maybe<Scalars['String']['output']>;
  remote?: Maybe<Scalars['String']['output']>;
};

export type GlueManager = {
  __typename: 'GlueManager';
  registeredTasks: GlueTaskConnection;
  taskConfig?: Maybe<GlueTaskConfig>;
  taskTypes: Array<Scalars['String']['output']>;
};


export type GlueManagerRegisteredTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
};


export type GlueManagerTaskConfigArgs = {
  taskType: Scalars['String']['input'];
};

export type GlueRun = {
  __typename: 'GlueRun';
  arguments?: Maybe<Scalars['JSONString']['output']>;
  checkpoint?: Maybe<Scalars['JSONString']['output']>;
  errors?: Maybe<Scalars['JSONString']['output']>;
  id: Scalars['ID']['output'];
  retries: Scalars['Int']['output'];
  runAt: Scalars['DateTime']['output'];
  runtimeMS: Scalars['Int64']['output'];
  succeeded: Scalars['Boolean']['output'];
  task: GlueTask;
};

export type GlueRunConnection = {
  __typename: 'GlueRunConnection';
  edges: Array<GlueRunEdge>;
  pageInfo: PageInfo;
};

export type GlueRunEdge = {
  __typename: 'GlueRunEdge';
  cursor: Scalars['String']['output'];
  node: GlueRun;
};

export type GlueTask = {
  __typename: 'GlueTask';
  arguments?: Maybe<Scalars['JSONString']['output']>;
  checkpoint?: Maybe<Scalars['JSONString']['output']>;
  glueRuns: GlueRunConnection;
  id: Scalars['ID']['output'];
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  strategyMetadata: Scalars['String']['output'];
  strategyType: Scalars['String']['output'];
  taskType: Scalars['String']['output'];
};


export type GlueTaskGlueRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
};

export type GlueTaskConfig = {
  __typename: 'GlueTaskConfig';
  defaultArguments: Scalars['JSONString']['output'];
};

export type GlueTaskConnection = {
  __typename: 'GlueTaskConnection';
  edges: Array<GlueTaskEdge>;
  pageInfo: PageInfo;
};

export type GlueTaskEdge = {
  __typename: 'GlueTaskEdge';
  cursor: Scalars['String']['output'];
  node: GlueTask;
};

export type GrantPersonalSecretToWbAgentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  secretUuid: Scalars['String']['input'];
};

export type GrantPersonalSecretToWbAgentPayload = {
  __typename: 'GrantPersonalSecretToWBAgentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  grant: WbAgentPersonalSecretGrant;
};

export type GroupAggregation = {
  custom: Array<AggregationKey>;
  default: Aggregation;
};

export type GroupBucketDiff = {
  __typename: 'GroupBucketDiff';
  groupedRun?: Maybe<GroupedRun>;
  op: DiffOperation;
};

export type GroupBucketDiffs = {
  __typename: 'GroupBucketDiffs';
  delta: Array<GroupBucketDiff>;
  incomplete?: Maybe<Array<Scalars['ID']['output']>>;
  order: Array<Scalars['ID']['output']>;
};

export type GroupedRun = Node & {
  __typename: 'GroupedRun';
  bucketedHistory: Array<Scalars['JSON']['output']>;
  config?: Maybe<Scalars['JSONString']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultColorIndex?: Maybe<Scalars['Int']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Number of runs whose history was actually fetched and aggregated into
   * this group's metrics. May be less than totalRuns due to maxTotalRuns
   * budget distribution across groups via CalculateGroupSizes.
   */
  includedRuns: Scalars['Int']['output'];
  jobType?: Maybe<Scalars['String']['output']>;
  lines: Array<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  state?: Maybe<Scalars['String']['output']>;
  summaryMetrics?: Maybe<Scalars['JSONString']['output']>;
  sweep?: Maybe<Sweep>;
  /**
   * Total number of runs in this group before any capping or truncation.
   * Bounded by the initial fetch limit in NewSummarizeRunGroups, so it
   * may undercount on very large run sets.
   */
  totalRuns: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};


export type GroupedRunBucketedHistoryArgs = {
  excludeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
  packVersion?: InputMaybe<Scalars['Int']['input']>;
  primaryLineType?: InputMaybe<Scalars['String']['input']>;
  specs: Array<Scalars['JSONString']['input']>;
};


export type GroupedRunConfigArgs = {
  dotBehavior?: InputMaybe<DotBehavior>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type GroupedRunLinesArgs = {
  excludeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
  packVersion?: InputMaybe<Scalars['Int']['input']>;
  primaryLineType?: InputMaybe<Scalars['String']['input']>;
  specs: Array<Scalars['JSONString']['input']>;
};


export type GroupedRunSummaryMetricsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  packVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupedRunConnection = {
  __typename: 'GroupedRunConnection';
  deltas?: Maybe<GroupBucketDiffs>;
  edges: Array<GroupedRunEdge>;
};


export type GroupedRunConnectionDeltasArgs = {
  currentRuns: Array<Scalars['String']['input']>;
  lastUpdated: Scalars['DateTime']['input'];
  timeout?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupedRunEdge = {
  __typename: 'GroupedRunEdge';
  cursor: Scalars['String']['output'];
  node: GroupedRun;
};

export type HeartbeatSandboxInput = {
  sandboxId: Scalars['ID']['input'];
};

export type HeartbeatSandboxPayload = {
  __typename: 'HeartbeatSandboxPayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum HistoryKeysFormat {
  Bitmap = 'BITMAP',
  Plaintext = 'PLAINTEXT'
}

/** The outcome of an HTTP request. */
export type HttpTriggerResultDetails = {
  __typename: 'HttpTriggerResultDetails';
  body?: Maybe<Scalars['String']['output']>;
  error?: Maybe<TriggerExecutionError>;
  status?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type HubSettingsInput = {
  disk?: InputMaybe<Scalars['String']['input']>;
  dockerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  redisEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  repo?: InputMaybe<Scalars['String']['input']>;
};

export type Identity = {
  __typename: 'Identity';
  emailIdentityVerified: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  provider?: Maybe<Scalars['String']['output']>;
};

export type ImageUrl = {
  __typename: 'ImageUrl';
  path?: Maybe<Scalars['String']['output']>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type InferenceCostUsageAggregation = UsageAggregationInterface & {
  __typename: 'InferenceCostUsageAggregation';
  cachedCost: Scalars['Int64']['output'];
  cachedCount: Scalars['Int64']['output'];
  end: Scalars['DateTime']['output'];
  endpointName: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  inputCost: Scalars['Int64']['output'];
  inputCount: Scalars['Int64']['output'];
  outputCost: Scalars['Int64']['output'];
  outputCount: Scalars['Int64']['output'];
  projectName: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
  uncachedCost: Scalars['Int64']['output'];
  uncachedCount: Scalars['Int64']['output'];
  value: Scalars['Int64']['output'];
};

export type InferenceEnterpriseSubscription = {
  __typename: 'InferenceEnterpriseSubscription';
  billingPeriodEnd: Scalars['DateTime']['output'];
  billingPeriodStart: Scalars['DateTime']['output'];
  inferenceLimit: Scalars['Int64']['output'];
};

/** A signal from one configured subscription, not the health of every ingestion path. */
export type IngestionHealth = {
  __typename: 'IngestionHealth';
  /** Source measurement time, not the time this response was fetched. */
  observedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Age of the oldest unacknowledged message at observedAt, not an expected customer wait. */
  oldestPendingAgeSeconds?: Maybe<Scalars['Float']['output']>;
  /** Whether the measured backlog age meets the configured delay threshold. */
  status: IngestionHealthStatus;
};

export enum IngestionHealthStatus {
  /** The configured backlog signal meets or exceeds its delay threshold. */
  Delayed = 'DELAYED',
  /** The configured backlog signal is below its delay threshold; other ingestion paths may be delayed. */
  Healthy = 'HEALTHY',
  /** The configured backlog signal is unavailable or invalid. */
  Unknown = 'UNKNOWN'
}

export type Initiator = Run | User;

export type InputArtifactConnection = ArtifactConnectionType & {
  __typename: 'InputArtifactConnection';
  edges: Array<InputArtifactEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InputArtifactEdge = ArtifactEdgeType & {
  __typename: 'InputArtifactEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Artifact>;
  usedAs: Array<Scalars['String']['output']>;
};

export type InsertGalleryDiscussionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reportID: Scalars['ID']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  spec: Scalars['String']['input'];
};

export type InsertGalleryDiscussionPayload = {
  __typename: 'InsertGalleryDiscussionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type InsertSecretInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  secretName: Scalars['String']['input'];
  secretValue: Scalars['String']['input'];
};

export type InsertSecretPayload = {
  __typename: 'InsertSecretPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Integration = {
  id: Scalars['ID']['output'];
};

export type IntegrationConnection = {
  __typename: 'IntegrationConnection';
  edges: Array<IntegrationEdge>;
  pageInfo: PageInfo;
};

export type IntegrationEdge = {
  __typename: 'IntegrationEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Integration>;
};

export type Invite = {
  __typename: 'Invite';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Entity>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  fromUser?: Maybe<User>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  role: Scalars['String']['output'];
  toUser?: Maybe<User>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InviteConnection = {
  __typename: 'InviteConnection';
  edges: Array<InviteEdge>;
  pageInfo: PageInfo;
};

export type InviteEdge = {
  __typename: 'InviteEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Invite>;
};

export type JobSetDiff = {
  __typename: 'JobSetDiff';
  complete: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  removeJobs: Array<Scalars['ID']['output']>;
  upsertJobs: Array<RunQueueItem>;
  version: Scalars['Int']['output'];
};

export type JobSetSelectorInput = {
  entityName: Scalars['String']['input'];
  jobSetName: Scalars['String']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
};

export type LaunchAgent = {
  __typename: 'LaunchAgent';
  agentConfig?: Maybe<Scalars['JSONString']['output']>;
  agentStatus: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  heartbeatAt?: Maybe<Scalars['DateTime']['output']>;
  hostname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  runQueues: Array<Scalars['ID']['output']>;
  stopPolling: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type LeaseJobSetItemInput = {
  agentId: Scalars['ID']['input'];
  jobSetId: Scalars['ID']['input'];
  jobSetItemId: Scalars['ID']['input'];
};

export type LeaseJobSetItemPayload = {
  __typename: 'LeaseJobSetItemPayload';
  success: Scalars['Boolean']['output'];
};

export type LicenseClaims = {
  __typename: 'LicenseClaims';
  expiresAt: Scalars['Int64']['output'];
  flags: Array<Scalars['String']['output']>;
  seats: Scalars['Int']['output'];
  storageGigs: Scalars['Int']['output'];
  teams: Scalars['Int']['output'];
};

export type LicenseExpirationUi = {
  __typename: 'LicenseExpirationUI';
  bannerDaysRemaining: Scalars['Int']['output'];
  bannerTotalDays: Scalars['Int']['output'];
  renewUrl?: Maybe<Scalars['String']['output']>;
};

/** Event details for linking an artifact. */
export type LinkArtifactEventInput = {
  /** The ID of the artifact version that was linked */
  artifactId: Scalars['ID']['input'];
  /** The ID of the (portfolio) collection it was linked to */
  collectionId: Scalars['ID']['input'];
};

export type LinkArtifactInput = {
  aliases?: InputMaybe<Array<ArtifactAliasInput>>;
  artifactID?: InputMaybe<Scalars['ID']['input']>;
  artifactPortfolioID?: InputMaybe<Scalars['ID']['input']>;
  artifactPortfolioName?: InputMaybe<Scalars['String']['input']>;
  clientID?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
};

export type LinkArtifactPayload = {
  __typename: 'LinkArtifactPayload';
  aliases: Array<ArtifactCollectionAlias>;
  artifactCollectionID: Scalars['ID']['output'];
  artifactID: Scalars['ID']['output'];
  artifactMembership: ArtifactCollectionMembership;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  versionIndex?: Maybe<Scalars['Int']['output']>;
};

export type LinkTeamToOrganizationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  organizationID: Scalars['ID']['input'];
};

export type LinkTeamToOrganizationPayload = {
  __typename: 'LinkTeamToOrganizationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LocalLicense = Node & {
  __typename: 'LocalLicense';
  claims: LicenseClaims;
  contactEmail: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customerName: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  generatedBy: User;
  id: Scalars['ID']['output'];
  license: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LocalVersionInfo = {
  __typename: 'LocalVersionInfo';
  latestVersionString: Scalars['String']['output'];
  outOfDate: Scalars['Boolean']['output'];
  versionOnThisInstanceString: Scalars['String']['output'];
};

export type LogExperimentExposureInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  experimentName: Scalars['String']['input'];
  unit: ExperimentExposureUnit;
  unitId?: InputMaybe<Scalars['ID']['input']>;
};

export type LogExperimentExposurePayload = {
  __typename: 'LogExperimentExposurePayload';
  bucket?: Maybe<Scalars['Int']['output']>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LogLine = {
  __typename: 'LogLine';
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  level?: Maybe<Scalars['String']['output']>;
  line?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type LogLineConnection = {
  __typename: 'LogLineConnection';
  edges: Array<LogLineEdge>;
  pageInfo: PageInfo;
};

export type LogLineEdge = {
  __typename: 'LogLineEdge';
  cursor: Scalars['String']['output'];
  node: LogLine;
};

export type MakeOrgMembersNoAccessModelsSeatInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type MakeOrgMembersNoAccessModelsSeatPayload = {
  __typename: 'MakeOrgMembersNoAccessModelsSeatPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MarkRunFilesUploadedInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  files: Array<Scalars['String']['input']>;
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
};

export type MarkRunFilesUploadedPayload = {
  __typename: 'MarkRunFilesUploadedPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MaybeGroupedRunConnection = GroupedRunConnection | RunConnection;

export type Member = {
  __typename: 'Member';
  OAuthClients: Array<OAuthClient>;
  accountType?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `role` instead. */
  admin?: Maybe<Scalars['Boolean']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  apiKeyCount?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  memberRole?: Maybe<Role>;
  name: Scalars['String']['output'];
  pending?: Maybe<Scalars['Boolean']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  serviceAccountAuthMethod?: Maybe<ServiceAccountAuthMethod>;
  username?: Maybe<Scalars['String']['output']>;
};

export enum MetricColumn {
  SummaryMetrics = 'SUMMARY_METRICS',
  SystemMetrics = 'SYSTEM_METRICS'
}

export type MetricInfo = {
  __typename: 'MetricInfo';
  column: MetricColumn;
  key: Scalars['String']['output'];
  keyHash?: Maybe<Scalars['String']['output']>;
  latestType?: Maybe<Scalars['String']['output']>;
  types: Array<Scalars['String']['output']>;
};

export type MetricSearchResults = {
  __typename: 'MetricSearchResults';
  cursor: Scalars['String']['output'];
  hasMore: Scalars['Boolean']['output'];
  results: Array<MetricInfo>;
};

export type MigrateOldHourOverageSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type MigrateOldHourOverageSubscriptionPayload = {
  __typename: 'MigrateOldHourOverageSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  newSubscriptionID?: Maybe<Scalars['String']['output']>;
  oldSubscriptionID?: Maybe<Scalars['String']['output']>;
};

export type MigrateOldStorageSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type MigrateOldStorageSubscriptionPayload = {
  __typename: 'MigrateOldStorageSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  newSubscriptionID?: Maybe<Scalars['String']['output']>;
  oldSubscriptionID?: Maybe<Scalars['String']['output']>;
};

export type MigrateOrPurgePersonalEntityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userID: Scalars['ID']['input'];
};

export type MigrateOrPurgePersonalEntityPayload = {
  __typename: 'MigrateOrPurgePersonalEntityPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organizationID?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ModelRegistryMigrationConfig = {
  __typename: 'ModelRegistryMigrationConfig';
  blockWritesLegacyModelRegistry: Scalars['Boolean']['output'];
  blockWritesMigratedModelRegistry: Scalars['Boolean']['output'];
  migrationCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  orgRegistryProject?: Maybe<Project>;
};

export type ModifyRunsInput = {
  addTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  removeTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ModifyRunsPayload = {
  __typename: 'ModifyRunsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  runs: Array<Maybe<Run>>;
  runsSQL: Array<Maybe<Run>>;
};

export type MoveArtifactAliasAction = ArtifactAction & {
  __typename: 'MoveArtifactAliasAction';
  artifact: Artifact;
  createdAt: Scalars['DateTime']['output'];
  destinationArtifact?: Maybe<Artifact>;
  id: Scalars['ID']['output'];
  initiator: Initiator;
};

export type MoveArtifactCollectionPayload = {
  __typename: 'MoveArtifactCollectionPayload';
  artifactCollection?: Maybe<ArtifactCollection>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type MoveArtifactSequenceInput = {
  artifactSequenceID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationArtifactTypeName: Scalars['String']['input'];
};

export type MoveHistoryForRunInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationEntityName: Scalars['String']['input'];
  destinationProjectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  sourceEntityName: Scalars['String']['input'];
  sourceProjectName: Scalars['String']['input'];
};

export type MoveHistoryForRunPayload = {
  __typename: 'MoveHistoryForRunPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  task?: Maybe<Task>;
};

export type MoveProjectsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationEntityName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  ownerUsername: Scalars['String']['input'];
  projectNames?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceEntityName: Scalars['String']['input'];
};

export type MoveProjectsPayload = {
  __typename: 'MoveProjectsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  tasks: Array<Task>;
};

export type MoveRunsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  destinationEntityName: Scalars['String']['input'];
  destinationProjectName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  sourceEntityName: Scalars['String']['input'];
  sourceProjectName: Scalars['String']['input'];
};

export type MoveRunsPayload = {
  __typename: 'MoveRunsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  task: Task;
};

export type MoveTagCategoryInput = {
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  newEntityName: Scalars['String']['input'];
  oldEntityName: Scalars['String']['input'];
  tagCategoryName: Scalars['String']['input'];
};

export type MoveTagInput = {
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  newTagCategoryName: Scalars['String']['input'];
  oldTagCategoryName: Scalars['String']['input'];
  tagName: Scalars['String']['input'];
};

export type MoveViewInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  projectName: Scalars['String']['input'];
};

export type MoveViewPayload = {
  __typename: 'MoveViewPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MultiValueMetadataColumn = {
  __typename: 'MultiValueMetadataColumn';
  key: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type Mutation = {
  __typename: 'Mutation';
  ackJobSetItem?: Maybe<AckJobSetItemPayload>;
  ackRunQueueItem?: Maybe<AckRunQueueItemPayload>;
  ackSlurmCommand?: Maybe<AckSlurmCommandPayload>;
  addAliases?: Maybe<AddAliasesPayload>;
  addFiles?: Maybe<AddFilesPayload>;
  addProjectProtectedAliases?: Maybe<AddProjectProtectedAliasesPayload>;
  addProtectedAliases?: Maybe<AddProtectedAliasesPayload>;
  addPublicQueueLaunchAgentTeamConfig?: Maybe<AddPublicQueueLaunchAgentTeamConfigPayload>;
  addReferenceBucketToTeam: AddReferenceBucketToTeamPayload;
  addRolePermissions?: Maybe<AddRolePermissionsPayload>;
  addUserToOrganization?: Maybe<AddUserToOrganizationPayload>;
  addWorkflowsAdmin?: Maybe<AddWorkflowsAdminPayload>;
  agentHeartbeat?: Maybe<AgentHeartbeatPayload>;
  attachCustomerPaymentMethod?: Maybe<AttachCustomerPaymentMethodPayload>;
  cancelCustomerSubscription?: Maybe<CancelCustomerSubscriptionPayload>;
  cancelPaygoSubscriptions?: Maybe<CancelPaygoSubscriptionsPayload>;
  /** @deprecated No longer supported. */
  claimAnonymousEntity?: Maybe<ClaimAnonymousEntityPayload>;
  claimSlurmCommands?: Maybe<ClaimSlurmCommandsPayload>;
  cloneProjects?: Maybe<CloneProjectsPayload>;
  commitArtifact?: Maybe<CommitArtifactPayload>;
  completeMultipartUploadArtifact?: Maybe<CompleteMultipartUploadArtifactPayload>;
  contactUsForComputeHours?: Maybe<ContactUsForComputeHoursPayload>;
  contactUsForUserLedTrial?: Maybe<ContactUsForUserLedTrialPayload>;
  createAWSExternalID: Scalars['String']['output'];
  createAcademicOrReverseTrial?: Maybe<CreateAcademicOrReverseTrialPayload>;
  createAccessToken?: Maybe<CreateAccessTokenPayload>;
  createAgent?: Maybe<CreateAgentPayload>;
  createAlertThreshold?: Maybe<CreateAlertThresholdPayload>;
  createAndLinkWeaveAsset?: Maybe<LinkArtifactPayload>;
  createAnonymousEntity?: Maybe<CreateEntityPayload>;
  createArtifact?: Maybe<CreateArtifactPayload>;
  createArtifactCollectionTagAssignments?: Maybe<CreateTagsPayload>;
  createArtifactFiles?: Maybe<CreateArtifactFilesPayload>;
  createArtifactManifest?: Maybe<CreateArtifactManifestPayload>;
  createArtifactPortfolio?: Maybe<CreateArtifactCollectionPayload>;
  createArtifactSequence?: Maybe<CreateArtifactCollectionPayload>;
  createArtifactTagAssignments?: Maybe<CreateTagsPayload>;
  /** @deprecated Use createArtifactTypes instead */
  createArtifactType?: Maybe<CreateArtifactTypePayload>;
  createArtifactTypes?: Maybe<CreateArtifactTypesPayload>;
  createBenchmarkDiscussionComment?: Maybe<CreateDiscussionCommentPayload>;
  createBenchmarkDiscussionThread?: Maybe<CreateDiscussionThreadPayload>;
  createClient?: Maybe<CreateClientPayload>;
  createClientIDMapping?: Maybe<CreateClientIdMappingPayload>;
  createCustomChart?: Maybe<CreateCustomChartPayload>;
  createCustomerSubscription?: Maybe<CreateCustomerSubscriptionPayload>;
  createCustomerTrial?: Maybe<CreateCustomerTrialPayload>;
  createDefaultResourceConfig?: Maybe<CreateDefaultResourceConfigPayload>;
  createEmailSubscription?: Maybe<CreateEmailSubscriptionPayload>;
  createEntity?: Maybe<CreateEntityPayload>;
  createExperiment?: Maybe<CreateExperimentPayload>;
  createFilterTrigger?: Maybe<CreateFilterTriggerPayload>;
  createFinishedRunAlert?: Maybe<CreateAlertPayload>;
  createGenericWebhookIntegration?: Maybe<CreateIntegrationPayload>;
  createGitHubOAuthIntegration?: Maybe<CreateIntegrationPayload>;
  createGlueTask?: Maybe<CreateGlueTaskPayload>;
  createHourOverageSubscription?: Maybe<CreateHourOverageSubscriptionPayload>;
  createInferenceSubscription?: Maybe<CreateInferenceSubscriptionPayload>;
  createInvite?: Maybe<CreateInvitePayload>;
  createLaunchAgent?: Maybe<CreateLaunchAgentPayload>;
  createLocalLicenseOrganization?: Maybe<CreateLocalLicenseOrganizationPayload>;
  createNewsletterSubscription?: Maybe<CreateNewsletterSubscriptionPayload>;
  createNotebook?: Maybe<CreateNotebookPayload>;
  createOAuthProvider?: Maybe<CreateOAuthProviderPayload>;
  createOrgServiceAccount?: Maybe<CreateOrgServiceAccountPayload>;
  createPreviewableLink?: Maybe<CreatePreviewableLinkPayload>;
  createPricingPlanUpdatePR?: Maybe<CreatePricingPlanUpdatePrPayload>;
  createProject?: Maybe<CreateProjectPayload>;
  createProjectMembers?: Maybe<CreateProjectMembersPayload>;
  createRegistryHuggingFaceImport?: Maybe<CreateRegistryHuggingFaceImportPayload>;
  createRegistryModelDeployment?: Maybe<CreateRegistryModelDeploymentPayload>;
  createRole?: Maybe<CreateRolePayload>;
  createRunFiles?: Maybe<CreateRunFilesPayload>;
  createRunQueue?: Maybe<CreateRunQueuePayload>;
  createSandbox?: Maybe<CreateSandboxPayload>;
  createSandboxPermission?: Maybe<CreateSandboxPermissionPayload>;
  createSandboxesSubscription?: Maybe<CreateSandboxesSubscriptionPayload>;
  createScriptableRunAlert?: Maybe<CreateAlertPayload>;
  createSemanticLegend?: Maybe<CreateSemanticLegendPayload>;
  createServiceAccount?: Maybe<CreateServiceAccountPayload>;
  createServiceAccountApiKey?: Maybe<CreateServiceAccountApiKeyPayload>;
  createSlackChannelSubscription?: Maybe<CreateSlackChannelSubscriptionPayload>;
  createSlackIntegration?: Maybe<CreateIntegrationPayload>;
  createStoppedRunAlert?: Maybe<CreateAlertPayload>;
  createStorageSubscription?: Maybe<CreateStorageSubscriptionPayload>;
  createTeam?: Maybe<CreateTeamPayload>;
  createUser?: Maybe<CreateUserPayload>;
  createUserLevelSlackIntegration?: Maybe<CreateUserLevelSlackIntegrationPayload>;
  createViewCommentsAlertSubscription?: Maybe<CreateEmailSubscriptionPayload>;
  createViewDiscussionComment?: Maybe<CreateViewDiscussionCommentPayload>;
  deleteAlert?: Maybe<DeleteAlertPayload>;
  deleteAlertSubscription?: Maybe<DeleteAlertSubscriptionPayload>;
  deleteAlertThreshold?: Maybe<DeleteAlertThresholdPayload>;
  deleteAliases?: Maybe<DeleteAliasesPayload>;
  deleteApiKey?: Maybe<DeleteApiKeyPayload>;
  deleteApiKeys?: Maybe<DeleteApiKeysPayload>;
  deleteArtifact?: Maybe<DeleteArtifactPayload>;
  deleteArtifactByWeaveRef?: Maybe<DeleteArtifactByWeaveRefPayload>;
  deleteArtifactCollectionTagAssignments?: Maybe<DeleteTagAssignmentPayload>;
  deleteArtifactEntityTTL?: Maybe<DeleteArtifactEntityTtlPayload>;
  deleteArtifactPortfolio?: Maybe<DeleteArtifactCollectionPayload>;
  deleteArtifactSequence?: Maybe<DeleteArtifactCollectionPayload>;
  deleteArtifactTagAssignments?: Maybe<DeleteTagAssignmentPayload>;
  deleteCustomChart?: Maybe<DeleteCustomChartPayload>;
  deleteDefaultResourceConfigs?: Maybe<DeleteDefaultResourceConfigsPayload>;
  deleteDiscussionComment?: Maybe<DeleteDiscussionCommentPayload>;
  deleteExperiment?: Maybe<DeleteExperimentPayload>;
  deleteFiles?: Maybe<DeleteFilesPayload>;
  deleteFilesByRunAndFolder?: Maybe<DeleteFilesPayload>;
  deleteFromRunQueue?: Maybe<DeleteFromRunQueuePayload>;
  deleteGlueTask?: Maybe<DeleteGlueTaskPayload>;
  deleteIntegration?: Maybe<DeleteIntegrationPayload>;
  deleteInvite?: Maybe<DeleteInvitePayload>;
  deleteLaunchAgents?: Maybe<DeleteLaunchAgentsPayload>;
  deleteModel?: Maybe<DeleteModelPayload>;
  deleteNotebook?: Maybe<DeleteNotebookPayload>;
  deleteOAuthProvider?: Maybe<DeleteOAuthProviderPayload>;
  deleteOrganization?: Maybe<DeleteOrganizationPayload>;
  deleteOrganizationSubscription?: Maybe<DeleteOrganizationSubscriptionPayload>;
  deleteProjectMembers?: Maybe<DeleteProjectMembersPayload>;
  deletePublicQueueLaunchAgentTeamConfig?: Maybe<DeletePublicQueueLaunchAgentTeamConfigPayload>;
  deleteRole?: Maybe<DeleteRolePayload>;
  deleteRolePermissions?: Maybe<DeleteRolePermissionsPayload>;
  deleteRun?: Maybe<DeleteRunPayload>;
  deleteRunQueues?: Maybe<DeleteRunQueuesPayload>;
  deleteRuns?: Maybe<DeleteRunsPayload>;
  deleteSecret?: Maybe<DeleteSecretPayload>;
  deleteServiceAccount?: Maybe<DeleteServiceAccountPayload>;
  deleteServiceAccountApiKey?: Maybe<DeleteServiceAccountApiKeyPayload>;
  deleteSweep?: Maybe<DeleteSweepsPayload>;
  deleteSweeps?: Maybe<DeleteSweepsPayload>;
  deleteTeam?: Maybe<DeleteTeamPayload>;
  deleteTeamSecret?: Maybe<DeleteTeamSecretPayload>;
  deleteTrigger: DeleteTriggerPayload;
  deleteUser?: Maybe<DeleteUserPayload>;
  deleteUserEmail?: Maybe<DeleteUserEmailPayload>;
  deleteUserLevelSlackIntegration?: Maybe<DeleteUserLevelSlackIntegrationPayload>;
  deleteUserSecret?: Maybe<DeleteUserSecretPayload>;
  deleteView?: Maybe<DeleteViewPayload>;
  deleteViews?: Maybe<DeleteViewsPayload>;
  deleteWorkflowsAdmin?: Maybe<DeleteWorkflowsAdminPayload>;
  deleteWorkspaceTemplate?: Maybe<DeleteWorkspaceTemplatePayload>;
  detachCustomerPaymentMethod?: Maybe<DetachCustomerPaymentMethodPayload>;
  disableGlueTask?: Maybe<DisableGlueTaskPayload>;
  disableOldTrackingSubscription?: Maybe<DisableOldTrackingSubscriptionPayload>;
  duplicateNotebook?: Maybe<DuplicateNotebookPayload>;
  enableGlueTask?: Maybe<EnableGlueTaskPayload>;
  enqueueSweepRun?: Maybe<EnqueueSweepRunPayload>;
  ensureSandboxesOverageSubscription?: Maybe<EnsureSandboxesOverageSubscriptionPayload>;
  ensureWbagentOverageSubscription?: Maybe<EnsureWbagentOverageSubscriptionPayload>;
  executeTrigger?: Maybe<ExecuteTriggerPayload>;
  failRunQueueItem?: Maybe<FailRunQueueItemPayload>;
  failSlurmCommand?: Maybe<FailSlurmCommandPayload>;
  forceCleanArtifactStorageStats?: Maybe<ForceCleanArtifactStorageStatsPayload>;
  forceCleanRunStorageStats?: Maybe<ForceCleanRunStorageStatsPayload>;
  generateApiKey?: Maybe<GenerateApiKeyPayload>;
  generateArtifactCollectionOverviewDraft: GenerateArtifactCollectionOverviewDraftPayload;
  generateArtifactCollectionOverviewDraftFromAIPlan: GenerateArtifactCollectionOverviewDraftPayload;
  generateLocalLicense?: Maybe<GenerateLocalLicensePayload>;
  grantPersonalSecretToWBAgent?: Maybe<GrantPersonalSecretToWbAgentPayload>;
  heartbeatSandbox?: Maybe<HeartbeatSandboxPayload>;
  insertGalleryDiscussion?: Maybe<InsertGalleryDiscussionPayload>;
  insertSecret?: Maybe<InsertSecretPayload>;
  leaseJobSetItem?: Maybe<LeaseJobSetItemPayload>;
  linkArtifact?: Maybe<LinkArtifactPayload>;
  linkTeamToOrganization?: Maybe<LinkTeamToOrganizationPayload>;
  logExperimentExposure?: Maybe<LogExperimentExposurePayload>;
  makeOrgMembersNoAccessModelsSeat?: Maybe<MakeOrgMembersNoAccessModelsSeatPayload>;
  markRunFilesUploaded?: Maybe<MarkRunFilesUploadedPayload>;
  migrateOldHourOverageSubscription?: Maybe<MigrateOldHourOverageSubscriptionPayload>;
  migrateOldStorageSubscription?: Maybe<MigrateOldStorageSubscriptionPayload>;
  migrateOrPurgePersonalEntity?: Maybe<MigrateOrPurgePersonalEntityPayload>;
  modifyRuns?: Maybe<ModifyRunsPayload>;
  moveArtifactSequence?: Maybe<MoveArtifactCollectionPayload>;
  moveHistoryForRun?: Maybe<MoveHistoryForRunPayload>;
  moveProjects?: Maybe<MoveProjectsPayload>;
  moveRuns?: Maybe<MoveRunsPayload>;
  moveTag?: Maybe<UpdateTagPayload>;
  moveTagCategory?: Maybe<UpdateTagCategoryPayload>;
  moveView?: Maybe<MoveViewPayload>;
  notifyScriptableRunAlert?: Maybe<NotifyScriptableRunAlertPayload>;
  popFromRunQueue?: Maybe<PopFromRunQueuePayload>;
  publishBenchmarkRun?: Maybe<PublishBenchmarkRunPayload>;
  purgeUser?: Maybe<PurgeUserPayload>;
  pushToRunQueue?: Maybe<PushToRunQueuePayload>;
  pushToRunQueueByName?: Maybe<PushToRunQueueByNamePayload>;
  reactivateCustomerSubscription?: Maybe<ReactivateCustomerSubscriptionPayload>;
  recordSlurmCommandError?: Maybe<RecordSlurmCommandErrorPayload>;
  registerUserDevice?: Maybe<RegisterUserDevicePayload>;
  removeProjectProtectedAliases?: Maybe<RemoveProjectProtectedAliasesPayload>;
  removeProtectedAliases?: Maybe<RemoveProtectedAliasesPayload>;
  removeUserFromOrganization?: Maybe<RemoveUserFromOrganizationPayload>;
  removeUserFromOrganizationById?: Maybe<RemoveUserFromOrganizationByIdPayload>;
  renameNotebook?: Maybe<RenameNotebookPayload>;
  renameProject?: Maybe<UpsertModelPayload>;
  resendEmailVerification?: Maybe<ResendEmailVerificationPayload>;
  resetPassword?: Maybe<ResetPasswordPayload>;
  resumePaygoSubscriptions?: Maybe<ResumePaygoSubscriptionsPayload>;
  retryStripeOpenInvoicesByOrganization?: Maybe<RetryStripeOpenInvoicesByOrganizationPayload>;
  revokeAccessToken?: Maybe<RevokeAccessTokenPayload>;
  revokeAccessTokenEmail?: Maybe<RevokeAccessTokenEmailPayload>;
  revokeClient?: Maybe<RevokeClientPayload>;
  revokePersonalSecretFromWBAgent?: Maybe<RevokePersonalSecretFromWbAgentPayload>;
  rewindRun?: Maybe<RewindRunPayload>;
  setDismissedBanner?: Maybe<SetDismissedBannerPayload>;
  /**
   * Currently a no-op: the sandbox environment is applied at creation
   * (CreateSandboxInput.runNames), and clients restart the sandbox runtime to
   * pick up new values.
   */
  setSandboxEnvVars?: Maybe<SetSandboxEnvVarsPayload>;
  setTagColor?: Maybe<SetTagColorPayload>;
  starProject?: Maybe<StarProjectPayload>;
  starRegistry?: Maybe<StarRegistryPayload>;
  starView?: Maybe<StarViewPayload>;
  startExperiment?: Maybe<UpdateExperimentPayload>;
  stopExperiment?: Maybe<UpdateExperimentPayload>;
  stopRegistryModelDeployment?: Maybe<StopRegistryModelDeploymentPayload>;
  stopRun?: Maybe<StopRunPayload>;
  /** @deprecated submitBenchmarkRun has been removed */
  submitBenchmarkRun?: Maybe<SubmitBenchmarkRunPayload>;
  submitFCNews?: Maybe<SubmitFcNewsPayload>;
  submitSlurmCommand?: Maybe<SubmitSlurmCommandPayload>;
  terminateSandbox?: Maybe<TerminateSandboxPayload>;
  testBucketStoreConnection: Array<BucketStoreConnectionError>;
  testGenericWebhookIntegration?: Maybe<TestGenericWebhookIntegrationPayload>;
  testReferenceBucketConnection: Array<BucketStoreConnectionError>;
  triggerEventsExport?: Maybe<TriggerEventsExportPayload>;
  triggerFlatRunsMigrator?: Maybe<TriggerFlatRunsMigratorPayload>;
  triggerParquetExport?: Maybe<TriggerParquetExportPayload>;
  triggerRecomputeKeysInfo?: Maybe<TriggerRecomputeKeysInfoPayload>;
  triggerRecomputeSystemMetrics?: Maybe<TriggerRecomputeSystemMetricsPayload>;
  undeleteProject?: Maybe<UndeleteProjectPayload>;
  undeleteProjectByID?: Maybe<UndeleteProjectPayload>;
  undeleteRuns?: Maybe<UndeleteRunsPayload>;
  undeleteUser?: Maybe<UndeleteUserPayload>;
  unlinkArtifact?: Maybe<UnlinkArtifactPayload>;
  unlinkNvidiaAccount?: Maybe<UnlinkNvidiaAccountPayload>;
  unregisterUserDevice?: Maybe<UnregisterUserDevicePayload>;
  unstarProject?: Maybe<UnstarProjectPayload>;
  unstarRegistry?: Maybe<UnstarRegistryPayload>;
  unstarView?: Maybe<UnstarViewPayload>;
  updateAccessToken?: Maybe<UpdateAccessTokenPayload>;
  updateAccessTokenProjects?: Maybe<UpdateAccessTokenProjectsPayload>;
  updateAlertThreshold?: Maybe<UpdateAlertThresholdPayload>;
  updateApiKey?: Maybe<UpdateApiKeyPayload>;
  updateArtifact?: Maybe<UpdateArtifactPayload>;
  updateArtifactEntityTTL?: Maybe<UpdateArtifactEntityTtlPayload>;
  updateArtifactManifest?: Maybe<UpdateArtifactManifestPayload>;
  updateArtifactPortfolio?: Maybe<UpdateArtifactCollectionPayload>;
  updateArtifactSequence?: Maybe<UpdateArtifactCollectionPayload>;
  updateArtifactType?: Maybe<UpdateArtifactTypePayload>;
  updateBenchmarkRun?: Maybe<UpdateBenchmarkRunPayload>;
  updateCustomChart?: Maybe<UpdateCustomChartPayload>;
  updateCustomerDefaultPaymentMethod?: Maybe<UpdateCustomerDefaultPaymentMethodPayload>;
  updateCustomerPaymentMethod?: Maybe<UpdateCustomerPaymentMethodPayload>;
  updateDefaultResourceConfig?: Maybe<UpdateDefaultResourceConfigPayload>;
  updateDiscussionComment?: Maybe<UpdateDiscussionCommentPayload>;
  updateDiscussionThread?: Maybe<UpdateDiscussionThreadPayload>;
  updateEntity?: Maybe<UpdateEntityPayload>;
  updateExperiment?: Maybe<UpdateExperimentPayload>;
  updateFilterTrigger?: Maybe<UpdateFilterTriggerPayload>;
  updateGenericWebhookIntegration?: Maybe<CreateIntegrationPayload>;
  updateGlueTask?: Maybe<UpdateGlueTaskPayload>;
  updateLaunchAgent?: Maybe<UpdateLaunchAgentPayload>;
  updateLocalLicense?: Maybe<UpdateLocalLicensePayload>;
  updateMember?: Maybe<UpdateMemberPayload>;
  updateModelsSeat?: Maybe<UpdateModelsSeatPayload>;
  updateOAuthProvider?: Maybe<UpdateOAuthProviderPayload>;
  updateOrganization?: Maybe<UpdateOrganizationPayload>;
  updateOrganizationBillingUser?: Maybe<UpdateOrganizationBillingUserPayload>;
  updateOrganizationPrivacySettings?: Maybe<UpdateOrganizationPrivacySettingsPayload>;
  updateOrganizationRemoteScoringSettings?: Maybe<UpdateOrganizationRemoteScoringSettingsPayload>;
  updateOrganizationSubscription?: Maybe<UpdateOrganizationSubscriptionPayload>;
  updateOrganizationSubscriptionSeats?: Maybe<UpdateOrganizationSubscriptionSeatsPayload>;
  updateOrganizationUser?: Maybe<UpdateOrganizationUserPayload>;
  updateOrganizationUserV2?: Maybe<UpdateOrganizationUserV2Payload>;
  updateProjectLastActive?: Maybe<UpdateProjectLastActivePayload>;
  updateProjectMember?: Maybe<UpdateProjectMemberPayload>;
  updateProjectTeamMember?: Maybe<UpdateProjectTeamMemberPayload>;
  updateRampThreshold?: Maybe<UpdateRampThresholdPayload>;
  updateRole?: Maybe<UpdateRolePayload>;
  updateRunQueue?: Maybe<UpdateRunQueuePayload>;
  updateRunQueueItemWarning?: Maybe<UpdateRunQueueItemWarningPayload>;
  updateRunState?: Maybe<UpdateRunStatePayload>;
  updateSemanticLegend?: Maybe<UpdateSemanticLegendPayload>;
  updateServiceAccountApiKey?: Maybe<UpdateServiceAccountApiKeyPayload>;
  updateSlurmDaemonHeartbeat?: Maybe<UpdateSlurmDaemonHeartbeatPayload>;
  updateStoppedRunAlert?: Maybe<UpdateAlertPayload>;
  updateSubscription?: Maybe<UpdateSubscriptionPayload>;
  updateTag?: Maybe<UpdateTagPayload>;
  updateTagCategory?: Maybe<UpdateTagCategoryPayload>;
  updateTeamStorageBucket: UpdateTeamStorageBucketPayload;
  updateUser?: Maybe<UpdateUserPayload>;
  updateUserEmail?: Maybe<UpdateUserEmailPayload>;
  updateUserLevelAlertPreferences?: Maybe<UpdateUserLevelAlertPreferencesPayload>;
  updateUserRole?: Maybe<UpdateUserRolePayload>;
  updateUserRoleV2?: Maybe<UpdateUserRoleV2Payload>;
  updateWeaveRole?: Maybe<UpdateWeaveRolePayload>;
  upgradeCustomerSubscription?: Maybe<UpgradeCustomerSubscriptionPayload>;
  upgradeCustomerToProPlan?: Maybe<UpgradeCustomerToProPlanPayload>;
  upgradeProCustomer?: Maybe<UpgradeProCustomerPayload>;
  upgradeTrialSubscription?: Maybe<UpgradeTrialSubscriptionPayload>;
  /** @deprecated Use createPreviewableLink instead */
  uploadPanel?: Maybe<UploadPanelPayload>;
  upsertBucket?: Maybe<UpsertBucketPayload>;
  upsertModel?: Maybe<UpsertModelPayload>;
  upsertRunGroup?: Maybe<UpsertRunGroupPayload>;
  upsertRunQueue?: Maybe<UpsertRunQueuePayload>;
  upsertSharedView?: Maybe<UpsertSharedViewPayload>;
  upsertSweep?: Maybe<UpsertSweepPayload>;
  upsertTeamSecret?: Maybe<UpsertTeamSecretPayload>;
  upsertUserProfileView?: Maybe<UpsertUserProfileViewPayload>;
  upsertUserSecret?: Maybe<UpsertUserSecretPayload>;
  upsertView?: Maybe<UpsertViewPayload>;
  upsertWorkspaceTemplate?: Maybe<UpsertWorkspaceTemplatePayload>;
  useArtifact?: Maybe<UseArtifactPayload>;
  viewView?: Maybe<ViewViewPayload>;
};


export type MutationAckJobSetItemArgs = {
  input: AckJobSetItemInput;
};


export type MutationAckRunQueueItemArgs = {
  input: AckRunQueueItemInput;
};


export type MutationAckSlurmCommandArgs = {
  input: AckSlurmCommandInput;
};


export type MutationAddAliasesArgs = {
  input: AddAliasesInput;
};


export type MutationAddFilesArgs = {
  input: AddFilesInput;
};


export type MutationAddProjectProtectedAliasesArgs = {
  input: AddProjectProtectedAliasesInput;
};


export type MutationAddProtectedAliasesArgs = {
  input: AddProtectedAliasesInput;
};


export type MutationAddPublicQueueLaunchAgentTeamConfigArgs = {
  input: AddPublicQueueLaunchAgentTeamConfigInput;
};


export type MutationAddReferenceBucketToTeamArgs = {
  input: AddReferenceBucketToTeamInput;
};


export type MutationAddRolePermissionsArgs = {
  input: AddRolePermissionsInput;
};


export type MutationAddUserToOrganizationArgs = {
  input: AddUserToOrganizationInput;
};


export type MutationAddWorkflowsAdminArgs = {
  input: AddWorkflowsAdminInput;
};


export type MutationAgentHeartbeatArgs = {
  input: AgentHeartbeatInput;
};


export type MutationAttachCustomerPaymentMethodArgs = {
  input: AttachCustomerPaymentMethodInput;
};


export type MutationCancelCustomerSubscriptionArgs = {
  input: CancelCustomerSubscriptionInput;
};


export type MutationCancelPaygoSubscriptionsArgs = {
  input: CancelPaygoSubscriptionsInput;
};


export type MutationClaimAnonymousEntityArgs = {
  input: ClaimAnonymousEntityInput;
};


export type MutationClaimSlurmCommandsArgs = {
  input: ClaimSlurmCommandsInput;
};


export type MutationCloneProjectsArgs = {
  input: CloneProjectsInput;
};


export type MutationCommitArtifactArgs = {
  input: CommitArtifactInput;
};


export type MutationCompleteMultipartUploadArtifactArgs = {
  input: CompleteMultipartUploadArtifactInput;
};


export type MutationContactUsForComputeHoursArgs = {
  input: ContactUsForComputeHoursInput;
};


export type MutationContactUsForUserLedTrialArgs = {
  input: ContactUsForUserLedTrialInput;
};


export type MutationCreateAwsExternalIdArgs = {
  input: CreateAwsExternalIdInput;
};


export type MutationCreateAcademicOrReverseTrialArgs = {
  input: CreateAcademicOrReverseTrialInput;
};


export type MutationCreateAccessTokenArgs = {
  input: CreateAccessTokenInput;
};


export type MutationCreateAgentArgs = {
  input: CreateAgentInput;
};


export type MutationCreateAlertThresholdArgs = {
  input: CreateAlertThresholdInput;
};


export type MutationCreateAndLinkWeaveAssetArgs = {
  input: CreateAndLinkWeaveAssetInput;
};


export type MutationCreateAnonymousEntityArgs = {
  input: CreateAnonymousEntityInput;
};


export type MutationCreateArtifactArgs = {
  input: CreateArtifactInput;
};


export type MutationCreateArtifactCollectionTagAssignmentsArgs = {
  input: CreateArtifactCollectionTagAssignmentsInput;
};


export type MutationCreateArtifactFilesArgs = {
  input: CreateArtifactFilesInput;
};


export type MutationCreateArtifactManifestArgs = {
  input: CreateArtifactManifestInput;
};


export type MutationCreateArtifactPortfolioArgs = {
  input: CreateArtifactPortfolioInput;
};


export type MutationCreateArtifactSequenceArgs = {
  input: CreateArtifactSequenceInput;
};


export type MutationCreateArtifactTagAssignmentsArgs = {
  input: CreateArtifactTagAssignmentsInput;
};


export type MutationCreateArtifactTypeArgs = {
  input: CreateArtifactTypeInput;
};


export type MutationCreateArtifactTypesArgs = {
  input: CreateArtifactTypesInput;
};


export type MutationCreateBenchmarkDiscussionCommentArgs = {
  input: CreateBenchmarkDiscussionCommentInput;
};


export type MutationCreateBenchmarkDiscussionThreadArgs = {
  input: CreateBenchmarkDiscussionThreadInput;
};


export type MutationCreateClientArgs = {
  input: CreateClientInput;
};


export type MutationCreateClientIdMappingArgs = {
  input: CreateClientIdMappingInput;
};


export type MutationCreateCustomChartArgs = {
  input: CreateCustomChartInput;
};


export type MutationCreateCustomerSubscriptionArgs = {
  input: CreateCustomerSubscriptionInput;
};


export type MutationCreateCustomerTrialArgs = {
  input: CreateCustomerTrialInput;
};


export type MutationCreateDefaultResourceConfigArgs = {
  input: CreateDefaultResourceConfigInput;
};


export type MutationCreateEmailSubscriptionArgs = {
  input: CreateEmailSubscriptionInput;
};


export type MutationCreateEntityArgs = {
  input: CreateEntityInput;
};


export type MutationCreateExperimentArgs = {
  input: CreateExperimentInput;
};


export type MutationCreateFilterTriggerArgs = {
  input: CreateFilterTriggerInput;
};


export type MutationCreateFinishedRunAlertArgs = {
  input: CreateFinishedRunAlertInput;
};


export type MutationCreateGenericWebhookIntegrationArgs = {
  input: CreateGenericWebhookIntegrationInput;
};


export type MutationCreateGitHubOAuthIntegrationArgs = {
  input: CreateGitHubOAuthIntegrationInput;
};


export type MutationCreateGlueTaskArgs = {
  input: CreateGlueTaskInput;
};


export type MutationCreateHourOverageSubscriptionArgs = {
  input: CreateHourOverageSubscriptionInput;
};


export type MutationCreateInferenceSubscriptionArgs = {
  input: CreateInferenceSubscriptionInput;
};


export type MutationCreateInviteArgs = {
  input: CreateInviteInput;
};


export type MutationCreateLaunchAgentArgs = {
  input: CreateLaunchAgentInput;
};


export type MutationCreateLocalLicenseOrganizationArgs = {
  input: CreateLocalLicenseOrganizationInput;
};


export type MutationCreateNewsletterSubscriptionArgs = {
  input: CreateNewsletterSubscriptionInput;
};


export type MutationCreateNotebookArgs = {
  input: CreateNotebookInput;
};


export type MutationCreateOAuthProviderArgs = {
  input: CreateOAuthProviderInput;
};


export type MutationCreateOrgServiceAccountArgs = {
  input: CreateOrgServiceAccountInput;
};


export type MutationCreatePreviewableLinkArgs = {
  input: CreatePreviewableLinkInput;
};


export type MutationCreatePricingPlanUpdatePrArgs = {
  input: CreatePricingPlanUpdatePrInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateProjectMembersArgs = {
  input: CreateProjectMembersInput;
};


export type MutationCreateRegistryHuggingFaceImportArgs = {
  input: CreateRegistryHuggingFaceImportInput;
};


export type MutationCreateRegistryModelDeploymentArgs = {
  input: CreateRegistryModelDeploymentInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateRunFilesArgs = {
  input: CreateRunFilesInput;
};


export type MutationCreateRunQueueArgs = {
  input: CreateRunQueueInput;
};


export type MutationCreateSandboxArgs = {
  input: CreateSandboxInput;
};


export type MutationCreateSandboxPermissionArgs = {
  input: CreateSandboxPermissionInput;
};


export type MutationCreateSandboxesSubscriptionArgs = {
  input: CreateSandboxesSubscriptionInput;
};


export type MutationCreateScriptableRunAlertArgs = {
  input: CreateScriptableRunAlertInput;
};


export type MutationCreateSemanticLegendArgs = {
  input: CreateSemanticLegendInput;
};


export type MutationCreateServiceAccountArgs = {
  input: CreateServiceAccountInput;
};


export type MutationCreateServiceAccountApiKeyArgs = {
  input: CreateServiceAccountApiKeyInput;
};


export type MutationCreateSlackChannelSubscriptionArgs = {
  input: CreateSlackChannelSubscriptionInput;
};


export type MutationCreateSlackIntegrationArgs = {
  input: CreateSlackIntegrationInput;
};


export type MutationCreateStoppedRunAlertArgs = {
  input: CreateStoppedRunAlertInput;
};


export type MutationCreateStorageSubscriptionArgs = {
  input: CreateStorageSubscriptionInput;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateUserLevelSlackIntegrationArgs = {
  input: CreateUserLevelSlackIntegrationInput;
};


export type MutationCreateViewCommentsAlertSubscriptionArgs = {
  input: CreateViewCommentsAlertSubscriptionInput;
};


export type MutationCreateViewDiscussionCommentArgs = {
  input: CreateViewDiscussionCommentInput;
};


export type MutationDeleteAlertArgs = {
  input: DeleteAlertInput;
};


export type MutationDeleteAlertSubscriptionArgs = {
  input: DeleteAlertSubscriptionInput;
};


export type MutationDeleteAlertThresholdArgs = {
  input: DeleteAlertThresholdInput;
};


export type MutationDeleteAliasesArgs = {
  input: DeleteAliasesInput;
};


export type MutationDeleteApiKeyArgs = {
  input: DeleteApiKeyInput;
};


export type MutationDeleteApiKeysArgs = {
  input: DeleteApiKeysInput;
};


export type MutationDeleteArtifactArgs = {
  input: DeleteArtifactInput;
};


export type MutationDeleteArtifactByWeaveRefArgs = {
  input: DeleteArtifactByWeaveRefInput;
};


export type MutationDeleteArtifactCollectionTagAssignmentsArgs = {
  input: DeleteArtifactCollectionTagAssignmentsInput;
};


export type MutationDeleteArtifactEntityTtlArgs = {
  input: DeleteArtifactEntityTtlInput;
};


export type MutationDeleteArtifactPortfolioArgs = {
  input: DeleteArtifactPortfolioInput;
};


export type MutationDeleteArtifactSequenceArgs = {
  input: DeleteArtifactSequenceInput;
};


export type MutationDeleteArtifactTagAssignmentsArgs = {
  input: DeleteArtifactTagAssignmentsInput;
};


export type MutationDeleteCustomChartArgs = {
  input: DeleteCustomChartInput;
};


export type MutationDeleteDefaultResourceConfigsArgs = {
  input: DeleteDefaultResourceConfigsInput;
};


export type MutationDeleteDiscussionCommentArgs = {
  input: DeleteDiscussionCommentInput;
};


export type MutationDeleteExperimentArgs = {
  input: DeleteExperimentInput;
};


export type MutationDeleteFilesArgs = {
  input: DeleteFilesInput;
};


export type MutationDeleteFilesByRunAndFolderArgs = {
  input: DeleteFilesByRunAndFolderInput;
};


export type MutationDeleteFromRunQueueArgs = {
  input: DeleteFromRunQueueInput;
};


export type MutationDeleteGlueTaskArgs = {
  input: DeleteGlueTaskInput;
};


export type MutationDeleteIntegrationArgs = {
  input: DeleteIntegrationInput;
};


export type MutationDeleteInviteArgs = {
  input: DeleteInviteInput;
};


export type MutationDeleteLaunchAgentsArgs = {
  input: DeleteLaunchAgentsInput;
};


export type MutationDeleteModelArgs = {
  input: DeleteModelInput;
};


export type MutationDeleteNotebookArgs = {
  input: DeleteNotebookInput;
};


export type MutationDeleteOAuthProviderArgs = {
  input: DeleteOAuthProviderInput;
};


export type MutationDeleteOrganizationArgs = {
  input: DeleteOrganizationInput;
};


export type MutationDeleteOrganizationSubscriptionArgs = {
  input: DeleteOrganizationSubscriptionInput;
};


export type MutationDeleteProjectMembersArgs = {
  input: DeleteProjectMembersInput;
};


export type MutationDeletePublicQueueLaunchAgentTeamConfigArgs = {
  input: DeletePublicQueueLaunchAgentTeamConfigInput;
};


export type MutationDeleteRoleArgs = {
  input: DeleteRoleInput;
};


export type MutationDeleteRolePermissionsArgs = {
  input: DeleteRolePermissionsInput;
};


export type MutationDeleteRunArgs = {
  input: DeleteRunInput;
};


export type MutationDeleteRunQueuesArgs = {
  input: DeleteRunQueuesInput;
};


export type MutationDeleteRunsArgs = {
  input: DeleteRunsInput;
};


export type MutationDeleteSecretArgs = {
  input: DeleteSecretInput;
};


export type MutationDeleteServiceAccountArgs = {
  input: DeleteServiceAccountInput;
};


export type MutationDeleteServiceAccountApiKeyArgs = {
  input: DeleteServiceAccountApiKeyInput;
};


export type MutationDeleteSweepArgs = {
  input: DeleteSweepInput;
};


export type MutationDeleteSweepsArgs = {
  input: DeleteSweepsInput;
};


export type MutationDeleteTeamArgs = {
  input: DeleteTeamInput;
};


export type MutationDeleteTeamSecretArgs = {
  input: DeleteTeamSecretInput;
};


export type MutationDeleteTriggerArgs = {
  input: DeleteTriggerInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationDeleteUserEmailArgs = {
  input: DeleteUserEmailInput;
};


export type MutationDeleteUserLevelSlackIntegrationArgs = {
  input: DeleteUserLevelSlackIntegrationInput;
};


export type MutationDeleteUserSecretArgs = {
  input: DeleteUserSecretInput;
};


export type MutationDeleteViewArgs = {
  input: DeleteViewInput;
};


export type MutationDeleteViewsArgs = {
  input: DeleteViewsInput;
};


export type MutationDeleteWorkflowsAdminArgs = {
  input: DeleteWorkflowsAdminInput;
};


export type MutationDeleteWorkspaceTemplateArgs = {
  input: DeleteWorkspaceTemplateInput;
};


export type MutationDetachCustomerPaymentMethodArgs = {
  input: DetachCustomerPaymentMethodInput;
};


export type MutationDisableGlueTaskArgs = {
  input: DisableGlueTaskInput;
};


export type MutationDisableOldTrackingSubscriptionArgs = {
  input: DisableOldTrackingSubscriptionInput;
};


export type MutationDuplicateNotebookArgs = {
  input: DuplicateNotebookInput;
};


export type MutationEnableGlueTaskArgs = {
  input: EnableGlueTaskInput;
};


export type MutationEnqueueSweepRunArgs = {
  input: EnqueueSweepRunInput;
};


export type MutationEnsureSandboxesOverageSubscriptionArgs = {
  input: EnsureSandboxesOverageSubscriptionInput;
};


export type MutationEnsureWbagentOverageSubscriptionArgs = {
  input: EnsureWbagentOverageSubscriptionInput;
};


export type MutationExecuteTriggerArgs = {
  input: ExecuteTriggerInput;
};


export type MutationFailRunQueueItemArgs = {
  input: FailRunQueueItemInput;
};


export type MutationFailSlurmCommandArgs = {
  input: FailSlurmCommandInput;
};


export type MutationForceCleanArtifactStorageStatsArgs = {
  input: ForceCleanArtifactStorageStatsInput;
};


export type MutationForceCleanRunStorageStatsArgs = {
  input: ForceCleanRunStorageStatsInput;
};


export type MutationGenerateApiKeyArgs = {
  input: GenerateApiKeyInput;
};


export type MutationGenerateArtifactCollectionOverviewDraftArgs = {
  input: GenerateArtifactCollectionOverviewDraftInput;
};


export type MutationGenerateArtifactCollectionOverviewDraftFromAiPlanArgs = {
  input: GenerateArtifactCollectionOverviewAiInput;
};


export type MutationGenerateLocalLicenseArgs = {
  input: GenerateLocalLicenseInput;
};


export type MutationGrantPersonalSecretToWbAgentArgs = {
  input: GrantPersonalSecretToWbAgentInput;
};


export type MutationHeartbeatSandboxArgs = {
  input: HeartbeatSandboxInput;
};


export type MutationInsertGalleryDiscussionArgs = {
  input: InsertGalleryDiscussionInput;
};


export type MutationInsertSecretArgs = {
  input: InsertSecretInput;
};


export type MutationLeaseJobSetItemArgs = {
  input: LeaseJobSetItemInput;
};


export type MutationLinkArtifactArgs = {
  input: LinkArtifactInput;
};


export type MutationLinkTeamToOrganizationArgs = {
  input: LinkTeamToOrganizationInput;
};


export type MutationLogExperimentExposureArgs = {
  input: LogExperimentExposureInput;
};


export type MutationMakeOrgMembersNoAccessModelsSeatArgs = {
  input: MakeOrgMembersNoAccessModelsSeatInput;
};


export type MutationMarkRunFilesUploadedArgs = {
  input: MarkRunFilesUploadedInput;
};


export type MutationMigrateOldHourOverageSubscriptionArgs = {
  input: MigrateOldHourOverageSubscriptionInput;
};


export type MutationMigrateOldStorageSubscriptionArgs = {
  input: MigrateOldStorageSubscriptionInput;
};


export type MutationMigrateOrPurgePersonalEntityArgs = {
  input: MigrateOrPurgePersonalEntityInput;
};


export type MutationModifyRunsArgs = {
  input: ModifyRunsInput;
};


export type MutationMoveArtifactSequenceArgs = {
  input: MoveArtifactSequenceInput;
};


export type MutationMoveHistoryForRunArgs = {
  input: MoveHistoryForRunInput;
};


export type MutationMoveProjectsArgs = {
  input: MoveProjectsInput;
};


export type MutationMoveRunsArgs = {
  input: MoveRunsInput;
};


export type MutationMoveTagArgs = {
  input: MoveTagInput;
};


export type MutationMoveTagCategoryArgs = {
  input: MoveTagCategoryInput;
};


export type MutationMoveViewArgs = {
  input: MoveViewInput;
};


export type MutationNotifyScriptableRunAlertArgs = {
  input: NotifyScriptableRunAlertInput;
};


export type MutationPopFromRunQueueArgs = {
  input: PopFromRunQueueInput;
};


export type MutationPublishBenchmarkRunArgs = {
  input: PublishBenchmarkRunInput;
};


export type MutationPurgeUserArgs = {
  input: PurgeUserInput;
};


export type MutationPushToRunQueueArgs = {
  input: PushToRunQueueInput;
};


export type MutationPushToRunQueueByNameArgs = {
  input: PushToRunQueueByNameInput;
};


export type MutationReactivateCustomerSubscriptionArgs = {
  input: ReactivateCustomerSubscriptionInput;
};


export type MutationRecordSlurmCommandErrorArgs = {
  input: RecordSlurmCommandErrorInput;
};


export type MutationRegisterUserDeviceArgs = {
  input: RegisterUserDeviceInput;
};


export type MutationRemoveProjectProtectedAliasesArgs = {
  input: RemoveProjectProtectedAliasesInput;
};


export type MutationRemoveProtectedAliasesArgs = {
  input: RemoveProtectedAliasesInput;
};


export type MutationRemoveUserFromOrganizationArgs = {
  input: RemoveUserFromOrganizationInput;
};


export type MutationRemoveUserFromOrganizationByIdArgs = {
  input: RemoveUserFromOrganizationByIdInput;
};


export type MutationRenameNotebookArgs = {
  input: RenameNotebookInput;
};


export type MutationRenameProjectArgs = {
  input: RenameProjectInput;
};


export type MutationResendEmailVerificationArgs = {
  input: ResendEmailVerificationInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResumePaygoSubscriptionsArgs = {
  input: ResumePaygoSubscriptionsInput;
};


export type MutationRetryStripeOpenInvoicesByOrganizationArgs = {
  input: RetryStripeOpenInvoicesByOrganizationInput;
};


export type MutationRevokeAccessTokenArgs = {
  input: RevokeAccessTokenInput;
};


export type MutationRevokeAccessTokenEmailArgs = {
  input: RevokeAccessTokenEmailInput;
};


export type MutationRevokeClientArgs = {
  input: RevokeClientInput;
};


export type MutationRevokePersonalSecretFromWbAgentArgs = {
  input: RevokePersonalSecretFromWbAgentInput;
};


export type MutationRewindRunArgs = {
  input: RewindRunInput;
};


export type MutationSetDismissedBannerArgs = {
  input: SetDismissedBannerInput;
};


export type MutationSetSandboxEnvVarsArgs = {
  input: SetSandboxEnvVarsInput;
};


export type MutationSetTagColorArgs = {
  input: SetTagColorInput;
};


export type MutationStarProjectArgs = {
  input: StarProjectInput;
};


export type MutationStarRegistryArgs = {
  input: StarRegistryInput;
};


export type MutationStarViewArgs = {
  input: StarViewInput;
};


export type MutationStartExperimentArgs = {
  input: StartExperimentInput;
};


export type MutationStopExperimentArgs = {
  input: StopExperimentInput;
};


export type MutationStopRegistryModelDeploymentArgs = {
  input: StopRegistryModelDeploymentInput;
};


export type MutationStopRunArgs = {
  input: StopRunInput;
};


export type MutationSubmitBenchmarkRunArgs = {
  input: SubmitBenchmarkRunInput;
};


export type MutationSubmitFcNewsArgs = {
  input: SubmitFcNewsInput;
};


export type MutationSubmitSlurmCommandArgs = {
  input: SubmitSlurmCommandInput;
};


export type MutationTerminateSandboxArgs = {
  input: TerminateSandboxInput;
};


export type MutationTestBucketStoreConnectionArgs = {
  input: StorageBucketInfoInput;
};


export type MutationTestGenericWebhookIntegrationArgs = {
  input: TestGenericWebhookIntegrationInput;
};


export type MutationTestReferenceBucketConnectionArgs = {
  input: TestReferenceBucketConnectionInput;
};


export type MutationTriggerEventsExportArgs = {
  input: TriggerEventsExportInput;
};


export type MutationTriggerFlatRunsMigratorArgs = {
  input: TriggerFlatRunsMigratorInput;
};


export type MutationTriggerParquetExportArgs = {
  input: TriggerParquetExportInput;
};


export type MutationTriggerRecomputeKeysInfoArgs = {
  input: TriggerRecomputeKeysInfoInput;
};


export type MutationTriggerRecomputeSystemMetricsArgs = {
  input: TriggerRecomputeSystemMetricsInput;
};


export type MutationUndeleteProjectArgs = {
  input: UndeleteProjectInput;
};


export type MutationUndeleteProjectByIdArgs = {
  input: UndeleteProjectByIdInput;
};


export type MutationUndeleteRunsArgs = {
  input: UndeleteRunsInput;
};


export type MutationUndeleteUserArgs = {
  input: UndeleteUserInput;
};


export type MutationUnlinkArtifactArgs = {
  input: UnlinkArtifactInput;
};


export type MutationUnlinkNvidiaAccountArgs = {
  input: UnlinkNvidiaAccountInput;
};


export type MutationUnregisterUserDeviceArgs = {
  input: UnregisterUserDeviceInput;
};


export type MutationUnstarProjectArgs = {
  input: UnstarProjectInput;
};


export type MutationUnstarRegistryArgs = {
  input: UnstarRegistryInput;
};


export type MutationUnstarViewArgs = {
  input: UnstarViewInput;
};


export type MutationUpdateAccessTokenArgs = {
  input: UpdateAccessTokenInput;
};


export type MutationUpdateAccessTokenProjectsArgs = {
  input: UpdateAccessTokenProjectsInput;
};


export type MutationUpdateAlertThresholdArgs = {
  input: UpdateAlertThresholdInput;
};


export type MutationUpdateApiKeyArgs = {
  input: UpdateApiKeyInput;
};


export type MutationUpdateArtifactArgs = {
  input: UpdateArtifactInput;
};


export type MutationUpdateArtifactEntityTtlArgs = {
  input: UpdateArtifactEntityTtlInput;
};


export type MutationUpdateArtifactManifestArgs = {
  input: UpdateArtifactManifestInput;
};


export type MutationUpdateArtifactPortfolioArgs = {
  input: UpdateArtifactPortfolioInput;
};


export type MutationUpdateArtifactSequenceArgs = {
  input: UpdateArtifactSequenceInput;
};


export type MutationUpdateArtifactTypeArgs = {
  input: UpdateArtifactTypeInput;
};


export type MutationUpdateBenchmarkRunArgs = {
  input: UpdateBenchmarkRunInput;
};


export type MutationUpdateCustomChartArgs = {
  input: UpdateCustomChartInput;
};


export type MutationUpdateCustomerDefaultPaymentMethodArgs = {
  input: UpdateCustomerDefaultPaymentMethodInput;
};


export type MutationUpdateCustomerPaymentMethodArgs = {
  input: UpdateCustomerPaymentMethodInput;
};


export type MutationUpdateDefaultResourceConfigArgs = {
  input: UpdateDefaultResourceConfigInput;
};


export type MutationUpdateDiscussionCommentArgs = {
  input: UpdateDiscussionCommentInput;
};


export type MutationUpdateDiscussionThreadArgs = {
  input: UpdateDiscussionThreadInput;
};


export type MutationUpdateEntityArgs = {
  input: UpdateEntityInput;
};


export type MutationUpdateExperimentArgs = {
  input: UpdateExperimentInput;
};


export type MutationUpdateFilterTriggerArgs = {
  input: UpdateFilterTriggerInput;
};


export type MutationUpdateGenericWebhookIntegrationArgs = {
  input: UpdateGenericWebhookIntegrationInput;
};


export type MutationUpdateGlueTaskArgs = {
  input: UpdateGlueTaskInput;
};


export type MutationUpdateLaunchAgentArgs = {
  input: UpdateLaunchAgentInput;
};


export type MutationUpdateLocalLicenseArgs = {
  input: UpdateLocalLicenseInput;
};


export type MutationUpdateMemberArgs = {
  input: UpdateMemberInput;
};


export type MutationUpdateModelsSeatArgs = {
  input: UpdateModelsSeatInput;
};


export type MutationUpdateOAuthProviderArgs = {
  input: UpdateOAuthProviderInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationBillingUserArgs = {
  input: UpdateOrganizationBillingUserInput;
};


export type MutationUpdateOrganizationPrivacySettingsArgs = {
  input: UpdateOrganizationPrivacySettingsInput;
};


export type MutationUpdateOrganizationRemoteScoringSettingsArgs = {
  input: UpdateOrganizationRemoteScoringSettingsInput;
};


export type MutationUpdateOrganizationSubscriptionArgs = {
  input: UpdateOrganizationSubscriptionInput;
};


export type MutationUpdateOrganizationSubscriptionSeatsArgs = {
  input: UpdateOrganizationSubscriptionSeatsInput;
};


export type MutationUpdateOrganizationUserArgs = {
  input: UpdateOrganizationUserInput;
};


export type MutationUpdateOrganizationUserV2Args = {
  input: UpdateOrganizationUserV2Input;
};


export type MutationUpdateProjectLastActiveArgs = {
  input: UpdateProjectLastActiveInput;
};


export type MutationUpdateProjectMemberArgs = {
  input: UpdateProjectMemberInput;
};


export type MutationUpdateProjectTeamMemberArgs = {
  input: UpdateProjectTeamMemberInput;
};


export type MutationUpdateRampThresholdArgs = {
  input: UpdateRampThresholdInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationUpdateRunQueueArgs = {
  input: UpdateRunQueueInput;
};


export type MutationUpdateRunQueueItemWarningArgs = {
  input: UpdateRunQueueItemWarningInput;
};


export type MutationUpdateRunStateArgs = {
  input: UpdateRunStateInput;
};


export type MutationUpdateSemanticLegendArgs = {
  input: UpdateSemanticLegendInput;
};


export type MutationUpdateServiceAccountApiKeyArgs = {
  input: UpdateServiceAccountApiKeyInput;
};


export type MutationUpdateSlurmDaemonHeartbeatArgs = {
  input: UpdateSlurmDaemonHeartbeatInput;
};


export type MutationUpdateStoppedRunAlertArgs = {
  input: UpdateStoppedRunAlertInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};


export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};


export type MutationUpdateTagCategoryArgs = {
  input: UpdateTagCategoryInput;
};


export type MutationUpdateTeamStorageBucketArgs = {
  input: UpdateTeamStorageBucketInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserEmailArgs = {
  input: UpdateUserEmailInput;
};


export type MutationUpdateUserLevelAlertPreferencesArgs = {
  input: UpdateUserLevelAlertPreferencesInput;
};


export type MutationUpdateUserRoleArgs = {
  input: UpdateUserRoleInput;
};


export type MutationUpdateUserRoleV2Args = {
  input: UpdateUserRoleV2Input;
};


export type MutationUpdateWeaveRoleArgs = {
  input: UpdateWeaveRoleInput;
};


export type MutationUpgradeCustomerSubscriptionArgs = {
  input: UpgradeCustomerSubscriptionInput;
};


export type MutationUpgradeCustomerToProPlanArgs = {
  input: UpgradeCustomerToProPlanInput;
};


export type MutationUpgradeProCustomerArgs = {
  input: UpgradeProCustomerInput;
};


export type MutationUpgradeTrialSubscriptionArgs = {
  input: UpgradeTrialSubscriptionInput;
};


export type MutationUploadPanelArgs = {
  input: UploadPanelInput;
};


export type MutationUpsertBucketArgs = {
  input: UpsertBucketInput;
};


export type MutationUpsertModelArgs = {
  input: UpsertModelInput;
};


export type MutationUpsertRunGroupArgs = {
  input: UpsertRunGroupInput;
};


export type MutationUpsertRunQueueArgs = {
  input: UpsertRunQueueInput;
};


export type MutationUpsertSharedViewArgs = {
  input: UpsertSharedViewInput;
};


export type MutationUpsertSweepArgs = {
  input: UpsertSweepInput;
};


export type MutationUpsertTeamSecretArgs = {
  input: UpsertTeamSecretInput;
};


export type MutationUpsertUserProfileViewArgs = {
  input: UpsertUserProfileViewInput;
};


export type MutationUpsertUserSecretArgs = {
  input: UpsertUserSecretInput;
};


export type MutationUpsertViewArgs = {
  input: UpsertViewInput;
};


export type MutationUpsertWorkspaceTemplateArgs = {
  input: UpsertWorkspaceTemplateInput;
};


export type MutationUseArtifactArgs = {
  input: UseArtifactInput;
};


export type MutationViewViewArgs = {
  input: ViewViewInput;
};

export type NewPricingPlanInput = {
  defaultPrivileges: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  maxSeats: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  planType: PlanType;
  planVisibility: PricingPlanFixtureVisibility;
  stripePlanIdProd?: InputMaybe<Scalars['String']['input']>;
  stripePlanIdQa?: InputMaybe<Scalars['String']['input']>;
};

export type NewsletterSubscription = {
  __typename: 'NewsletterSubscription';
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  user?: Maybe<User>;
};

export type NewsletterSubscriptionConnection = {
  __typename: 'NewsletterSubscriptionConnection';
  edges: Array<NewsletterSubscriptionEdge>;
};

export type NewsletterSubscriptionEdge = {
  __typename: 'NewsletterSubscriptionEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<NewsletterSubscription>;
};

export type NoOpActionArgs = {
  __typename: 'NoOpActionArgs';
  noOp?: Maybe<Scalars['Boolean']['output']>;
};

export type NoOpTriggeredAction = {
  __typename: 'NoOpTriggeredAction';
  noOp?: Maybe<Scalars['Boolean']['output']>;
  readOnly: Scalars['Boolean']['output'];
};

export type NoOpTriggeredActionInput = {
  noOp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type NodeAlert = {
  __typename: 'NodeAlert';
  alertName: Scalars['String']['output'];
  alertStatus: Scalars['String']['output'];
  cluster: Scalars['String']['output'];
  clusterOrg: Scalars['String']['output'];
  description: Scalars['String']['output'];
  grafanaDashboard: Scalars['String']['output'];
  labels: Scalars['JSON']['output'];
  node: Scalars['String']['output'];
  occurrences: Scalars['JSON']['output'];
  pod: Scalars['String']['output'];
};

export type Notebook = {
  __typename: 'Notebook';
  author?: Maybe<User>;
  /** The date the notebook was created in WandB. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Where the notebook's current version lives in the project's artifact
   * browser: the collection's newest committed version, the same one
   * `lastUpdated` reports, never the `latest` alias. Null until the first
   * version commits.
   */
  currentVersion?: Maybe<NotebookVersionRef>;
  id: Scalars['ID']['output'];
  /** When the notebook's source was last saved. */
  lastSourceEditedAt: Scalars['DateTime']['output'];
  /** When the notebook's static output was last rendered, if ever. */
  lastStaticOutputAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * When the notebook's content last changed: the created time of the newest
   * committed source version, falling back to row activity (create/rename)
   * before the first version commits. Listings sort by row activity.
   */
  lastUpdated: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  /** The project this notebook belongs to. */
  project: Project;
  staticOutputUrl?: Maybe<Scalars['String']['output']>;
  viewerPermissions: Array<NotebookPermission>;
};

export type NotebookConnection = {
  __typename: 'NotebookConnection';
  edges: Array<NotebookEdge>;
  pageInfo: PageInfo;
};

export type NotebookEdge = {
  __typename: 'NotebookEdge';
  cursor: Scalars['String']['output'];
  node: Notebook;
};

export enum NotebookPermission {
  Delete = 'DELETE',
  Duplicate = 'DUPLICATE',
  Edit = 'EDIT',
  Run = 'RUN',
  ViewStatic = 'VIEW_STATIC'
}

/**
 * An organization's notebook quota state. A check that fails or does not apply
 * to the organization's plan reports false, matching the mutations, which let
 * the request through in both cases.
 */
export type NotebookQuota = {
  __typename: 'NotebookQuota';
  /** The organization has used all of its sandbox credit. */
  sandboxCreditExhausted: Scalars['Boolean']['output'];
  /** The organization has reached its storage limit on a plan without overage. */
  storageQuotaExceeded: Scalars['Boolean']['output'];
};

export type NotebookSandbox = {
  __typename: 'NotebookSandbox';
  envVars?: Maybe<SandboxEnvVars>;
  id: Scalars['ID']['output'];
  mode: SandboxMode;
  notebookID: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

/**
 * Starter content a new notebook is seeded with. Each value maps to a source
 * file embedded in the gorilla binary and pre-cached in the runtime image.
 */
export enum NotebookTemplate {
  /** Trace a tool-calling agent with weave and read it in Agent Lens. */
  AgentLensMonitor = 'AGENT_LENS_MONITOR',
  /** Minimal wandb.Api starter. */
  Basic = 'BASIC',
  /** Plot a PCA embedding of handwritten digits and drill into a selection. */
  EmbeddingVisualizer = 'EMBEDDING_VISUALIZER',
  /** Fine-tune an email-search agent with CoreWeave Forge (OpenPipe ART). */
  ForgeFinetune = 'FORGE_FINETUNE',
  /** Train a 2048 agent with serverless reinforcement learning. */
  PostTrainingRl_2048 = 'POST_TRAINING_RL_2048',
  /** Fine-tune a model from a training file with serverless SFT. */
  PostTrainingSftTrainFromFile = 'POST_TRAINING_SFT_TRAIN_FROM_FILE',
  /** Behavior-clone a planar arm policy in numpy, logging the run to W&B. */
  RoboticsTraining = 'ROBOTICS_TRAINING'
}

/** Locates one notebook version in the project's artifact browser. */
export type NotebookVersionRef = {
  __typename: 'NotebookVersionRef';
  artifactCollectionName: Scalars['String']['output'];
  artifactTypeName: Scalars['String']['output'];
  /** Name of the notebook source file in the version's manifest. */
  sourceFileName: Scalars['String']['output'];
  /**
   * Zero-based position in the collection; the artifact browser addresses it as
   * `v<versionIndex>`.
   */
  versionIndex: Scalars['Int']['output'];
};

export type NotificationActionInput = {
  integrationID: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<AlertSeverity>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationTriggeredAction = {
  __typename: 'NotificationTriggeredAction';
  entityName: Scalars['String']['output'];
  integration: Integration;
  message?: Maybe<Scalars['String']['output']>;
  readOnly: Scalars['Boolean']['output'];
  severity?: Maybe<AlertSeverity>;
  title?: Maybe<Scalars['String']['output']>;
};

export type NotifyScriptableRunAlertInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  severity?: InputMaybe<AlertSeverity>;
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
  waitDuration?: InputMaybe<Scalars['Duration']['input']>;
};

export type NotifyScriptableRunAlertPayload = {
  __typename: 'NotifyScriptableRunAlertPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type OAuthClient = {
  __typename: 'OAuthClient';
  id: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type OAuthProvider = {
  __typename: 'OAuthProvider';
  accessTokenLifespanSeconds: Scalars['Int']['output'];
  allowJwtReplay: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  issuerUrl: Scalars['String']['output'];
  refreshEnabled: Scalars['Boolean']['output'];
  refreshFamilyLifespanSeconds?: Maybe<Scalars['Int']['output']>;
};

export enum ObservationalUnit {
  AnonymousUser = 'ANONYMOUS_USER',
  Organization = 'ORGANIZATION',
  Team = 'TEAM',
  User = 'USER'
}

export type OrgActivityTimeline = ActivityDuration & {
  __typename: 'OrgActivityTimeline';
  endAt: Scalars['DateTime']['output'];
  numActiveUsers: Scalars['Int']['output'];
  startAt: Scalars['DateTime']['output'];
};

export type OrgDashboardActiveUsersForRangeStats = {
  __typename: 'OrgDashboardActiveUsersForRangeStats';
  allTime: Scalars['Int64']['output'];
  last3Months: Scalars['Int64']['output'];
  last6Months: Scalars['Int64']['output'];
  last7Days: Scalars['Int64']['output'];
  last12Months: Scalars['Int64']['output'];
  last30Days: Scalars['Int64']['output'];
  last90Days: Scalars['Int64']['output'];
};

export enum OrgType {
  Organization = 'ORGANIZATION',
  Personal = 'PERSONAL'
}

export type Organization = Node & {
  __typename: 'Organization';
  OAuthProviders: Array<OAuthProvider>;
  activeUsersForRange?: Maybe<OrgDashboardActiveUsersForRangeStats>;
  activity: Array<OrgActivityTimeline>;
  advancedRegistryFeatures?: Maybe<AdvancedRegistryFeatures>;
  alertThresholds: Array<AlertThreshold>;
  apiKeysConnection: OrganizationApiKeyConnection;
  artifactCollections?: Maybe<ArtifactCollectionConnection>;
  artifactSequences?: Maybe<ArtifactSequenceConnection>;
  available: Scalars['Boolean']['output'];
  billingUser?: Maybe<User>;
  coreWeaveOrganizationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dynamicConfig?: Maybe<DynamicConfig>;
  featureFlags: Array<Maybe<FeatureFlag>>;
  fileSystemSnapshot?: Maybe<FileSystemSnapshot>;
  fileSystemSnapshotsConnection: FileSystemSnapshotConnection;
  firstActivity?: Maybe<Scalars['DateTime']['output']>;
  flags?: Maybe<Scalars['JSONString']['output']>;
  id: Scalars['ID']['output'];
  inferenceEnterpriseSubscription?: Maybe<InferenceEnterpriseSubscription>;
  isLaunchActive: Scalars['Boolean']['output'];
  latestRuns?: Maybe<RunConnection>;
  member?: Maybe<OrganizationMember>;
  memberCount: Scalars['Int']['output'];
  members: Array<OrganizationMember>;
  name: Scalars['String']['output'];
  /**
   * Notebooks in this organization's teams that the current viewer can read,
   * further restricted to projects the viewer can read. Public projects under
   * teams the viewer cannot read are not included.
   *
   * Use `search` for a case-insensitive match on notebook name or author
   * name/username, `userID` to return only notebooks authored by that user,
   * `viewerPermissions` to return only notebooks the current viewer holds the
   * given permissions on, and the cursor arguments (`first`/`last` with
   * `before`/`after`) to page through results.
   *
   * Team readability is applied before pagination. Project readability within
   * those teams is applied after each page is read, so a page can return fewer
   * edges than `first`, or none at all, while `hasNextPage` is true. Page until
   * `hasNextPage` is false rather than stopping on the first short or empty page.
   */
  notebooks: NotebookConnection;
  orgEntity?: Maybe<Entity>;
  orgType: OrgType;
  pendingInvites: Array<Invite>;
  projects?: Maybe<ProjectConnection>;
  registries?: Maybe<ProjectConnection>;
  registryHuggingFaceImports: RegistryHuggingFaceImportConnection;
  registryUsageLimit: ArtifactUsageLimitStatus;
  roles: Array<Role>;
  sandboxClusterOrgId?: Maybe<Scalars['String']['output']>;
  sandboxesEnterpriseSubscription?: Maybe<SandboxesEnterpriseSubscription>;
  seatAvailability: OrganizationSeatAvailability;
  serviceAccounts: Array<ServiceAccount>;
  stripeBillingInfo?: Maybe<StripeBillingInfo>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeInvoices: Array<StripeInvoice>;
  stripePaymentMethods: Array<StripePaymentMethod>;
  subscriptions: Array<OrganizationSubscription>;
  tagNames?: Maybe<TagNameConnection>;
  teams: Array<Entity>;
  triggerExecutions: TriggerExecutionConnection;
  triggers: TriggerConnection;
  usage: Array<UsageAggregationInterface>;
  usageByPeriod: UsageByPeriodResponse;
  usageTotal: Array<Scalars['Int64']['output']>;
  usedSeats: Scalars['Int']['output'];
  usedViewOnlySeats: Scalars['Int']['output'];
  views: ViewConnection;
  weaveEnterpriseSubscription?: Maybe<WeaveEnterpriseSubscription>;
};


export type OrganizationActivityArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type OrganizationAlertThresholdsArgs = {
  filters?: InputMaybe<AlertThresholdFilter>;
};


export type OrganizationApiKeysConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationArtifactCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionTypes?: InputMaybe<Array<ArtifactCollectionType>>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationArtifactSequencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationDynamicConfigArgs = {
  configId: Scalars['String']['input'];
};


export type OrganizationFeatureFlagsArgs = {
  featureKey?: InputMaybe<Scalars['String']['input']>;
  rampIDType: RampIdType;
};


export type OrganizationFileSystemSnapshotArgs = {
  id: Scalars['ID']['input'];
};


export type OrganizationFileSystemSnapshotsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sourceSandboxId?: InputMaybe<Scalars['ID']['input']>;
};


export type OrganizationLatestRunsArgs = {
  excludeUserID?: InputMaybe<Scalars['ID']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type OrganizationMemberArgs = {
  username?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationNotebooksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  viewerPermissions?: InputMaybe<Array<NotebookPermission>>;
};


export type OrganizationProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};


export type OrganizationRegistriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeStarred?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationRegistryHuggingFaceImportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  states?: InputMaybe<Array<RegistryHuggingFaceImportState>>;
};


export type OrganizationRegistryUsageLimitArgs = {
  requestedIncrease: Scalars['Int64']['input'];
};


export type OrganizationTagNamesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationTriggerExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  triggerID?: InputMaybe<Scalars['ID']['input']>;
};


export type OrganizationTriggersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationUsageArgs = {
  intervalMarkers: Array<Scalars['DateTime']['input']>;
  usageType: UsageType;
};


export type OrganizationUsageByPeriodArgs = {
  teamId?: InputMaybe<Scalars['ID']['input']>;
  usagePeriod: UsagePeriod;
  usageType: UsageType;
  viewType: ViewType;
};


export type OrganizationUsageTotalArgs = {
  intervalMarkers: Array<Scalars['DateTime']['input']>;
  usageType: UsageType;
};


export type OrganizationViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  displayNameContains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

export type OrganizationApiKeyConnection = {
  __typename: 'OrganizationApiKeyConnection';
  edges: Array<OrganizationApiKeyEdge>;
  pageInfo: PageInfo;
};

export type OrganizationApiKeyEdge = {
  __typename: 'OrganizationApiKeyEdge';
  cursor: Scalars['String']['output'];
  node: ApiKey;
};

export type OrganizationConnection = {
  __typename: 'OrganizationConnection';
  edges: Array<OrganizationEdge>;
  pageInfo: PageInfo;
};

export type OrganizationDataForFailedPaymentBanner = {
  __typename: 'OrganizationDataForFailedPaymentBanner';
  billingEmail: Scalars['String']['output'];
  daysUntilCancellation: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isBillingUser: Scalars['Boolean']['output'];
  isCollectionMethodACH: Scalars['Boolean']['output'];
  orgId: Scalars['Int']['output'];
  orgName: Scalars['String']['output'];
};

export type OrganizationEdge = {
  __typename: 'OrganizationEdge';
  cursor: Scalars['String']['output'];
  node: Organization;
};

export type OrganizationMember = {
  __typename: 'OrganizationMember';
  admin: Scalars['Boolean']['output'];
  daysActive?: Maybe<Scalars['Int']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isRegistryEntitled: Scalars['Boolean']['output'];
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  modelsSeat: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orgID: Scalars['ID']['output'];
  photoUrl: Scalars['String']['output'];
  role: Scalars['String']['output'];
  teams?: Maybe<EntityConnection>;
  user: User;
  username: Scalars['String']['output'];
  weaveRole: Scalars['String']['output'];
};


export type OrganizationMemberDaysActiveArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};


export type OrganizationMemberTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationSeatAvailability = {
  __typename: 'OrganizationSeatAvailability';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  seats: Scalars['Int']['output'];
  viewOnlySeats: Scalars['Int']['output'];
};

export type OrganizationSubscription = {
  __typename: 'OrganizationSubscription';
  availableSeatsToPurchase: Scalars['Int']['output'];
  billingPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  billingPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<Discount>;
  expansionPacks: ExpansionPackConnection;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isAutomaticUpgrade: Scalars['Boolean']['output'];
  nextPlans: Array<Plan>;
  plan: Plan;
  privileges: Scalars['JSON']['output'];
  seats: Scalars['Int']['output'];
  status: OrganizationSubscriptionStatus;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionType: OrganizationSubscriptionType;
  thresholdCrossedAt?: Maybe<Scalars['DateTime']['output']>;
  upgradedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type OrganizationSubscriptionExpansionPacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum OrganizationSubscriptionStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export enum OrganizationSubscriptionType {
  Academic = 'ACADEMIC',
  AcademicTrial = 'ACADEMIC_TRIAL',
  Enterprise = 'ENTERPRISE',
  FreePlan = 'FREE_PLAN',
  Local = 'LOCAL',
  ManualTrial = 'MANUAL_TRIAL',
  Stripe = 'STRIPE',
  UserLedTrial = 'USER_LED_TRIAL'
}

export type PageInfo = {
  __typename: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ParquetHistory = {
  __typename: 'ParquetHistory';
  liveData: Array<Scalars['JSON']['output']>;
  parquetUrls: Array<Scalars['String']['output']>;
};

export type PaymentMetadata = {
  __typename: 'PaymentMetadata';
  orgName?: Maybe<Scalars['String']['output']>;
  shouldUpgradeToTeams?: Maybe<Scalars['Boolean']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethod = {
  __typename: 'PaymentMethod';
  cardType?: Maybe<Scalars['String']['output']>;
  endingIn?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type Plan = {
  __typename: 'Plan';
  billingInterval?: Maybe<Scalars['String']['output']>;
  defaultPrivileges: Scalars['JSON']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  maxSeats: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  planType: PlanType;
  planVisibility: PlanVisibility;
  stripePlanId?: Maybe<Scalars['String']['output']>;
  stripePrice?: Maybe<StripePrice>;
  unitPrice?: Maybe<Scalars['Int']['output']>;
};

export enum PlanType {
  HourOverage = 'HOUR_OVERAGE',
  HourUsage = 'HOUR_USAGE',
  InferenceUsage = 'INFERENCE_USAGE',
  ModelsSeats = 'MODELS_SEATS',
  Primary = 'PRIMARY',
  Reference = 'REFERENCE',
  SandboxesUsage = 'SANDBOXES_USAGE',
  Storage = 'STORAGE',
  WbagentUsage = 'WBAGENT_USAGE',
  WeaveIngestionCommit = 'WEAVE_INGESTION_COMMIT',
  WeaveIngestionUsage = 'WEAVE_INGESTION_USAGE'
}

export enum PlanVisibility {
  Archived = 'ARCHIVED',
  Deprecated = 'DEPRECATED',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type PopFromRunQueueInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  launchAgentId?: InputMaybe<Scalars['ID']['input']>;
  projectName: Scalars['String']['input'];
  queueName: Scalars['String']['input'];
};

export type PopFromRunQueuePayload = {
  __typename: 'PopFromRunQueuePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  runQueueItemId?: Maybe<Scalars['ID']['output']>;
  runSpec?: Maybe<Scalars['JSON']['output']>;
};

export type PreviewFriendlyUrl = {
  __typename: 'PreviewFriendlyURL';
  URL: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  viewID: Scalars['ID']['output'];
};

export type PreviewableLink = {
  __typename: 'PreviewableLink';
  URL: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  resourceID: Scalars['ID']['output'];
  resourceType: PreviewableLinkResourceType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum PreviewableLinkResourceType {
  Entity = 'Entity',
  User = 'User',
  View = 'View'
}

export type PricingPlanChangeInput = {
  defaultPrivileges?: InputMaybe<Scalars['String']['input']>;
  maxSeats?: InputMaybe<Scalars['Int']['input']>;
  planName: Scalars['String']['input'];
  stripePlanIdProd?: InputMaybe<Scalars['String']['input']>;
  stripePlanIdQa?: InputMaybe<Scalars['String']['input']>;
};

export enum PricingPlanFixtureVisibility {
  Archived = 'ARCHIVED',
  Public = 'PUBLIC'
}

export type Project = Node & {
  __typename: 'Project';
  access?: Maybe<Scalars['String']['output']>;
  allViews?: Maybe<ViewConnection>;
  allowAllArtifactTypesInRegistry: Scalars['Boolean']['output'];
  artifact?: Maybe<Artifact>;
  artifactCollection?: Maybe<ArtifactCollection>;
  artifactCollectionMembership?: Maybe<ArtifactCollectionMembership>;
  artifactCollections?: Maybe<ArtifactCollectionConnection>;
  artifactCollectionsSearch?: Maybe<ArtifactCollectionSearchConnection>;
  artifactMembershipsWithAliasCount: Scalars['Int']['output'];
  artifactType?: Maybe<ArtifactType>;
  artifactTypes: ArtifactTypeConnection;
  artifacts: Array<Artifact>;
  benchmarkDiscussionThreads: DiscussionThreadConnection;
  benchmarkRuns?: Maybe<BenchmarkRunConnection>;
  benchmarkSubmissions?: Maybe<BenchmarkRunConnection>;
  bucket?: Maybe<Run>;
  bucketCount?: Maybe<Scalars['Int']['output']>;
  buckets?: Maybe<RunConnection>;
  computeHours: Scalars['Duration']['output'];
  createdAt: Scalars['DateTime']['output'];
  defaultResourceConfigs?: Maybe<DefaultResourceConfigConnection>;
  deletedRuns?: Maybe<DeletedRunConnection>;
  description?: Maybe<Scalars['String']['output']>;
  dockerImage?: Maybe<Scalars['String']['output']>;
  entity: Entity;
  entityId?: Maybe<Scalars['Int']['output']>;
  entityName: Scalars['String']['output'];
  featured?: Maybe<Scalars['Int']['output']>;
  fields: ProjectFieldConnection;
  fromV2?: Maybe<Scalars['Boolean']['output']>;
  gitHubSubmissionRepo?: Maybe<Scalars['String']['output']>;
  groupPath?: Maybe<Scalars['String']['output']>;
  groupedRuns?: Maybe<MaybeGroupedRunConnection>;
  hasProtectedArtifact: Scalars['Boolean']['output'];
  hasRun: Scalars['Boolean']['output'];
  icon?: Maybe<ProjectIcon>;
  id: Scalars['ID']['output'];
  internalId: Scalars['ID']['output'];
  /** @deprecated benchmarks have been deprecated */
  isBenchmark: Scalars['Boolean']['output'];
  isMigratedRegistryProject: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  isRegistryProject: Scalars['Boolean']['output'];
  lastActive?: Maybe<Scalars['DateTime']['output']>;
  launchAgents: Array<LaunchAgent>;
  legacyModelRegistryProject?: Maybe<Project>;
  media?: Maybe<Scalars['String']['output']>;
  member?: Maybe<ProjectMember>;
  members: Array<ProjectMember>;
  name: Scalars['String']['output'];
  ndbId?: Maybe<Scalars['ID']['output']>;
  /**
   * Whether this project's organization is out of the sandbox credit or storage
   * a new notebook needs. Runs the same checks that refuse createNotebook and
   * createSandbox, so clients can warn before the user tries.
   */
  notebookQuota: NotebookQuota;
  notebooks: NotebookConnection;
  parameterImportance: Scalars['JSON']['output'];
  pathCounts?: Maybe<Scalars['JSONString']['output']>;
  protectedArtifactAliases: Array<ProtectedArtifactAlias>;
  public?: Maybe<Scalars['Boolean']['output']>;
  rateLimits?: Maybe<RateLimits>;
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  registryAvailableTeams: Array<RegistryAvailableTeam>;
  registryCollectionUsageLimit?: Maybe<ArtifactUsageLimitStatus>;
  registryModelDeployments: RegistryModelDeploymentConnection;
  repo?: Maybe<Scalars['String']['output']>;
  reportAuthors: Array<Scalars['String']['output']>;
  requestSubscribe?: Maybe<Scalars['Boolean']['output']>;
  run?: Maybe<Run>;
  runActiveCount: Scalars['Int']['output'];
  runCount: Scalars['Int']['output'];
  runFieldValues?: Maybe<RunFieldValueConnection>;
  runGroup?: Maybe<RunGroup>;
  /** @deprecated Field no longer supported */
  runKeySuggestions: Array<RunKeySuggestion>;
  runOutputArtifactsCount: Scalars['Int']['output'];
  runQueue?: Maybe<RunQueue>;
  runQueues: Array<RunQueue>;
  runSelectorGroups?: Maybe<RunSelectorGroupConnection>;
  runStoreAcceleratorReadEnabled: Scalars['Boolean']['output'];
  runTags?: Maybe<RunTagConnection>;
  runs?: Maybe<RunConnection>;
  runsHaveProtectedOutputArtifacts: Scalars['Boolean']['output'];
  starred: Scalars['Boolean']['output'];
  storageBytes: Scalars['Int64']['output'];
  subGroupPath?: Maybe<Scalars['String']['output']>;
  summaryMetrics?: Maybe<Scalars['JSONString']['output']>;
  sweep?: Maybe<Sweep>;
  sweeps?: Maybe<SweepConnection>;
  tagCounts: Array<RunTagCount>;
  /** @deprecated Use runTags instead */
  tags: Array<RunTag>;
  teamMembers: Array<ProjectTeamMember>;
  totalArtifactCollections: Scalars['Int']['output'];
  /** @deprecated Use computeHours instead */
  totalRunTime?: Maybe<Scalars['Float']['output']>;
  totalRuns?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Field no longer supported */
  totalRunsWithGroup: Scalars['Int']['output'];
  /** @deprecated Field no longer supported */
  totalRunsWithJobType: Scalars['Int']['output'];
  totalSweeps: Scalars['Int']['output'];
  totalUsers?: Maybe<Scalars['Int']['output']>;
  triggerExecutions: TriggerExecutionConnection;
  triggers: Array<Trigger>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  views?: Maybe<Scalars['JSONString']['output']>;
  weavePermissions: ProjectPermissions;
};


export type ProjectAllViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  displayNameContains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  viewName?: InputMaybe<Scalars['String']['input']>;
  viewType?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectArtifactArgs = {
  enableTracking?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};


export type ProjectArtifactCollectionArgs = {
  name: Scalars['String']['input'];
};


export type ProjectArtifactCollectionMembershipArgs = {
  name: Scalars['String']['input'];
};


export type ProjectArtifactCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  collectionTypes?: InputMaybe<Array<ArtifactCollectionType>>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectArtifactCollectionsSearchArgs = {
  artifactsLimit?: InputMaybe<Scalars['Int']['input']>;
  collectionTypes?: InputMaybe<Array<ArtifactCollectionType>>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectArtifactMembershipsWithAliasCountArgs = {
  alias: Scalars['String']['input'];
};


export type ProjectArtifactTypeArgs = {
  name: Scalars['String']['input'];
};


export type ProjectArtifactTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectArtifactsArgs = {
  filters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type ProjectBenchmarkDiscussionThreadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectBenchmarkRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  state: Scalars['String']['input'];
};


export type ProjectBenchmarkSubmissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectBucketArgs = {
  desc?: InputMaybe<Scalars['String']['input']>;
  missingOk?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};


export type ProjectBucketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  jobKey?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectDefaultResourceConfigsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectDeletedRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ProjectGroupedRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<Scalars['JSONString']['input']>>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupAggregation?: InputMaybe<GroupAggregation>;
  groupKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupLevel?: InputMaybe<Scalars['Int']['input']>;
  groupingDepth?: InputMaybe<Scalars['Int']['input']>;
  historyFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobKey?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  order?: InputMaybe<Scalars['String']['input']>;
  selections?: InputMaybe<Scalars['JSONString']['input']>;
  stabilizeRunGroups?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProjectMemberArgs = {
  id: Scalars['ID']['input'];
};


export type ProjectNotebooksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  viewerPermissions?: InputMaybe<Array<NotebookPermission>>;
};


export type ProjectParameterImportanceArgs = {
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  parameters?: InputMaybe<Array<Scalars['String']['input']>>;
  runParameters?: InputMaybe<Array<Scalars['String']['input']>>;
  sweepName?: InputMaybe<Scalars['String']['input']>;
  target: Scalars['String']['input'];
};


export type ProjectPathCountsArgs = {
  filters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type ProjectRegistryCollectionUsageLimitArgs = {
  requestedIncrease: Scalars['Int64']['input'];
};


export type ProjectRegistryModelDeploymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Array<RegistryModelDeploymentState>>;
};


export type ProjectRunArgs = {
  desc?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type ProjectRunActiveCountArgs = {
  filters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type ProjectRunCountArgs = {
  filters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type ProjectRunFieldValuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keyPath: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  valuePattern?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectRunGroupArgs = {
  name: Scalars['String']['input'];
};


export type ProjectRunKeySuggestionsArgs = {
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  keyPath: Scalars['String']['input'];
};


export type ProjectRunOutputArtifactsCountArgs = {
  filters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type ProjectRunQueueArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectRunSelectorGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxRuns?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectRunTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupAggregation?: InputMaybe<GroupAggregation>;
  groupKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupLevel?: InputMaybe<Scalars['Int']['input']>;
  historyFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobKey?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  order?: InputMaybe<Scalars['String']['input']>;
  requiredRunKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ProjectRunsHaveProtectedOutputArtifactsArgs = {
  filters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type ProjectStarredArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type ProjectSweepArgs = {
  sweepName: Scalars['String']['input'];
};


export type ProjectSweepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type ProjectTagCountsArgs = {
  filters?: InputMaybe<Scalars['JSONString']['input']>;
};


export type ProjectTotalArtifactCollectionsArgs = {
  collectionTypes?: InputMaybe<Array<ArtifactCollectionType>>;
};


export type ProjectTriggerExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  projectOnly?: InputMaybe<Scalars['Boolean']['input']>;
  triggerID?: InputMaybe<Scalars['ID']['input']>;
};


export type ProjectTriggersArgs = {
  eventType?: InputMaybe<EventTriggeringConditionType>;
  projectOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectConnection = {
  __typename: 'ProjectConnection';
  edges: Array<ProjectEdge>;
  pageInfo: PageInfo;
};

export type ProjectEdge = {
  __typename: 'ProjectEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Project>;
};

export type ProjectField = {
  __typename: 'ProjectField';
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ProjectFieldConnection = {
  __typename: 'ProjectFieldConnection';
  edges: Array<ProjectFieldEdge>;
  pageInfo: PageInfo;
};

export type ProjectFieldEdge = {
  __typename: 'ProjectFieldEdge';
  cursor: Scalars['String']['output'];
  node: ProjectField;
};

export type ProjectIcon = {
  __typename: 'ProjectIcon';
  color: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ProjectIconInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type ProjectIdentifierInput = {
  EntityName?: InputMaybe<Scalars['String']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectMember = {
  __typename: 'ProjectMember';
  accountType: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  projectRoleIsInherited: Scalars['Boolean']['output'];
  role: Role;
  username?: Maybe<Scalars['String']['output']>;
};

export type ProjectPermissions = {
  __typename: 'ProjectPermissions';
  canRead: Scalars['Boolean']['output'];
  canWrite: Scalars['Boolean']['output'];
  effectiveSensitiveDataPolicy: WeaveSensitiveDataPolicy;
  hasProjectReadPermission: Scalars['Boolean']['output'];
};

export type ProjectSpecifier = {
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};

export type ProjectStorageNode = StorageTreeNode & {
  __typename: 'ProjectStorageNode';
  artifactSequences: ArtifactSequenceStorageNodeConnection;
  artifactTypes: Array<ArtifactTypeStorageNode>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  project: Project;
  projectID: Scalars['ID']['output'];
  runs: RunStorageNodeConnection;
  size: Scalars['Int64']['output'];
};


export type ProjectStorageNodeArtifactSequencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectStorageNodeArtifactTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectStorageNodeRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectStorageNodeConnection = {
  __typename: 'ProjectStorageNodeConnection';
  edges: Array<ProjectStorageNodeEdge>;
  pageInfo: PageInfo;
  totalSize: Scalars['Int64']['output'];
};

export type ProjectStorageNodeEdge = {
  __typename: 'ProjectStorageNodeEdge';
  cursor: Scalars['String']['output'];
  node: ProjectStorageNode;
};

export type ProjectTeamMember = {
  __typename: 'ProjectTeamMember';
  role: Role;
  team: Entity;
};

export type ProtectedArtifactAlias = {
  __typename: 'ProtectedArtifactAlias';
  alias: Scalars['String']['output'];
  projectID: Scalars['ID']['output'];
};

export type PublicImageUploadInfo = {
  __typename: 'PublicImageUploadInfo';
  imageUrl: Scalars['String']['output'];
  uploadHeaders: Array<Scalars['String']['output']>;
  uploadUrl: Scalars['String']['output'];
};

export type PublishBenchmarkRunInput = {
  benchmarkEntityName?: InputMaybe<Scalars['String']['input']>;
  benchmarkName?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isCodeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PublishBenchmarkRunPayload = {
  __typename: 'PublishBenchmarkRunPayload';
  benchmarkRun: BenchmarkRun;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type PurgeUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type PurgeUserPayload = {
  __typename: 'PurgeUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type PushNotificationActionArgs = {
  __typename: 'PushNotificationActionArgs';
  body?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type PushNotificationActionInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userID: Scalars['ID']['input'];
};

/** The outcome of a PUSH_NOTIFICATION action. */
export type PushNotificationTriggerResultDetails = {
  __typename: 'PushNotificationTriggerResultDetails';
  error?: Maybe<TriggerExecutionError>;
  failureCount: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
};

export type PushNotificationTriggeredAction = {
  __typename: 'PushNotificationTriggeredAction';
  body?: Maybe<Scalars['String']['output']>;
  readOnly: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type PushToRunQueueByNameInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  projectName: Scalars['String']['input'];
  queueName: Scalars['String']['input'];
  runSpec: Scalars['JSONString']['input'];
  templateVariableValues?: InputMaybe<Scalars['JSONString']['input']>;
};

export type PushToRunQueueByNamePayload = {
  __typename: 'PushToRunQueueByNamePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  runQueueItemId: Scalars['ID']['output'];
  runSpec: Scalars['JSONString']['output'];
};

export type PushToRunQueueInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  queueID: Scalars['ID']['input'];
  runSpec: Scalars['JSONString']['input'];
  templateVariableValues?: InputMaybe<Scalars['JSONString']['input']>;
};

export type PushToRunQueuePayload = {
  __typename: 'PushToRunQueuePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  runQueueItemId: Scalars['ID']['output'];
  runSpec: Scalars['JSONString']['output'];
};

export type Query = {
  __typename: 'Query';
  activeExperiments: Array<ActiveExperiment>;
  artifact?: Maybe<Artifact>;
  artifactByWeaveRef?: Maybe<Artifact>;
  artifactCollection?: Maybe<ArtifactCollection>;
  artifactCollectionOverviewMetricCandidates?: Maybe<ArtifactCollectionOverviewMetricCandidatePacket>;
  artifactCollectionOverviewVersionCandidates?: Maybe<ArtifactCollectionOverviewVersionCandidatePacket>;
  artifactSequence?: Maybe<ArtifactSequence>;
  benchmarks?: Maybe<ProjectConnection>;
  checkoutPreview?: Maybe<CheckoutPreview>;
  clientIDMapping?: Maybe<ClientIdMapping>;
  coupon?: Maybe<Coupon>;
  customChart?: Maybe<CustomChart>;
  customCharts?: Maybe<CustomChartConnection>;
  dataFrame?: Maybe<RowConnection>;
  dataFrameSchema: Array<Scalars['JSON']['output']>;
  discussionComment?: Maybe<DiscussionComment>;
  discussionThread?: Maybe<DiscussionThread>;
  dismissedBanner?: Maybe<DismissedBanner>;
  entities?: Maybe<EntityConnection>;
  entity?: Maybe<Entity>;
  entityDeletedProjects: Array<DeletedProjectInfo>;
  experiments: Array<Experiment>;
  failedPaymentBanners?: Maybe<FailedPaymentBanners>;
  featuredReports?: Maybe<View>;
  galleryTagSections: Scalars['JSONString']['output'];
  glueManager?: Maybe<GlueManager>;
  glueRuns?: Maybe<GlueRunConnection>;
  highQualityUserProfiles?: Maybe<View>;
  invite?: Maybe<Invite>;
  jobSetDiff?: Maybe<JobSetDiff>;
  launchAgent?: Maybe<LaunchAgent>;
  localLicenses: Array<Maybe<LocalLicense>>;
  /** @deprecated use project */
  model?: Maybe<Project>;
  models?: Maybe<ProjectConnection>;
  newsletterSubscriptions?: Maybe<NewsletterSubscriptionConnection>;
  notebook?: Maybe<Notebook>;
  numPendingInvites: Scalars['Int']['output'];
  organization?: Maybe<Organization>;
  organizationRemoteScoringPolicy?: Maybe<RemoteScoringPolicy>;
  organizations: OrganizationConnection;
  plans: Array<Maybe<Plan>>;
  /** @deprecated Use previewableLink instead */
  previewFriendlyURL?: Maybe<PreviewFriendlyUrl>;
  previewableLink?: Maybe<PreviewableLink>;
  project?: Maybe<Project>;
  projectRemoteScoringPolicy?: Maybe<RemoteScoringPolicy>;
  projects?: Maybe<ProjectConnection>;
  publicImageUploadUrl?: Maybe<PublicImageUploadInfo>;
  publicViews?: Maybe<ViewConnection>;
  publishedProjects?: Maybe<ProjectConnection>;
  rampManager?: Maybe<RampManager>;
  referenceBucketDownloadUrls: ReferenceBucketDownloadUrlsPayload;
  registryAsset?: Maybe<RegistryAsset>;
  registryHuggingFaceImport?: Maybe<RegistryHuggingFaceImport>;
  registryModelDeployment?: Maybe<RegistryModelDeployment>;
  repo?: Maybe<Repo>;
  repoInsightsPlotData?: Maybe<RepoInsightsRowConnection>;
  reportSearch?: Maybe<ViewConnection>;
  runs: RunsResult;
  sandboxReadPermission?: Maybe<SandboxReadPermissionPayload>;
  serverInfo?: Maybe<ServerInfo>;
  singletonView?: Maybe<View>;
  tag?: Maybe<Tag>;
  task?: Maybe<Task>;
  trigger: Trigger;
  triggerExecutions: TriggerExecutionConnection;
  /**
   * Returns available template variables for automations.
   *
   * Template variables are placeholders like "${artifact_version}" that are replaced
   * with actual values when the automation action is executed.
   *
   * If no event type is provided, all available template variables are returned.
   */
  triggerTemplateVariables: Array<TriggerTemplateVariable>;
  /** Automations that are readable by the viewer. */
  triggers: TriggerConnection;
  usage: Array<UsageAggregationInterface>;
  usageByPeriod: UsageByPeriodResponse;
  user?: Maybe<User>;
  users?: Maybe<UserConnection>;
  view?: Maybe<View>;
  viewParent?: Maybe<View>;
  viewer?: Maybe<User>;
  views?: Maybe<ViewConnection>;
  weaveSavingsCalculator?: Maybe<WeaveSavingsCalculator>;
  workspaceTemplates: Array<WorkspaceTemplate>;
};


export type QueryArtifactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryArtifactByWeaveRefArgs = {
  ref: Scalars['String']['input'];
};


export type QueryArtifactCollectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryArtifactCollectionOverviewMetricCandidatesArgs = {
  input: ArtifactCollectionOverviewMetricCandidatesInput;
};


export type QueryArtifactCollectionOverviewVersionCandidatesArgs = {
  input: ArtifactCollectionOverviewVersionCandidatesInput;
};


export type QueryArtifactSequenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBenchmarksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckoutPreviewArgs = {
  couponID?: InputMaybe<Scalars['String']['input']>;
  isMonthly?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfModelsSeat: Scalars['Int']['input'];
  organizationID: Scalars['ID']['input'];
  weaveIngestionTier: WeaveIngestionLimitInMb;
};


export type QueryClientIdMappingArgs = {
  clientID: Scalars['ID']['input'];
};


export type QueryCouponArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomChartArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomChartsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
  userName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDataFrameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  dataFrameKeys: Array<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  projectName: Scalars['String']['input'];
};


export type QueryDataFrameSchemaArgs = {
  dataFrameKeys: Array<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};


export type QueryDiscussionCommentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDiscussionThreadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDismissedBannerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEntitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEntityArgs = {
  login?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEntityDeletedProjectsArgs = {
  entityName: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFailedPaymentBannersArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGlueRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  taskID: Scalars['ID']['input'];
};


export type QueryInviteArgs = {
  key: Scalars['String']['input'];
};


export type QueryJobSetDiffArgs = {
  agentID: Scalars['ID']['input'];
  fromVersion?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  selector?: InputMaybe<JobSetSelectorInput>;
};


export type QueryLaunchAgentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocalLicensesArgs = {
  expired?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryModelArgs = {
  entityName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryModelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keysOnly?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNewsletterSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotebookArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationRemoteScoringPolicyArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  emailDomain?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  queryOrg?: InputMaybe<Scalars['String']['input']>;
  querySubId?: InputMaybe<Scalars['String']['input']>;
  queryTeam?: InputMaybe<Scalars['String']['input']>;
  queryUser?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPreviewFriendlyUrlArgs = {
  viewID: Scalars['ID']['input'];
};


export type QueryPreviewableLinkArgs = {
  resourceID: Scalars['ID']['input'];
  resourceType: PreviewableLinkResourceType;
};


export type QueryProjectArgs = {
  entityName?: InputMaybe<Scalars['String']['input']>;
  internalId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProjectRemoteScoringPolicyArgs = {
  internalId: Scalars['ID']['input'];
};


export type QueryProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  internalIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  projectIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPublicViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublishedProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReferenceBucketDownloadUrlsArgs = {
  entityID: Scalars['ID']['input'];
  objectUrls: Array<Scalars['String']['input']>;
};


export type QueryRegistryAssetArgs = {
  path: Scalars['String']['input'];
};


export type QueryRegistryHuggingFaceImportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRegistryModelDeploymentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRepoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRepoInsightsPlotDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  plotName: Scalars['String']['input'];
  repoName: Scalars['String']['input'];
};


export type QueryReportSearchArgs = {
  query: Scalars['String']['input'];
};


export type QueryRunsArgs = {
  ids: Array<Scalars['ID']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySingletonViewArgs = {
  type: Scalars['String']['input'];
};


export type QueryTagArgs = {
  entityName?: InputMaybe<Scalars['String']['input']>;
  tag: QueryTagInput;
};


export type QueryTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTriggerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTriggerExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  triggerID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTriggerTemplateVariablesArgs = {
  eventType?: InputMaybe<EventTriggeringConditionType>;
};


export type QueryTriggersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUsageArgs = {
  intervalMarkers: Array<Scalars['DateTime']['input']>;
  usageType: UsageType;
};


export type QueryUsageByPeriodArgs = {
  usagePeriod: UsagePeriod;
  usageType: UsageType;
  viewType: ViewType;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  queryEmail?: InputMaybe<Scalars['String']['input']>;
  usernames?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryViewArgs = {
  id: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryViewParentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryViewerArgs = {
  entityName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryViewsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryWeaveSavingsCalculatorArgs = {
  organizationID: Scalars['ID']['input'];
};


export type QueryWorkspaceTemplatesArgs = {
  entityId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryTagInput = {
  tagCategoryName?: InputMaybe<Scalars['String']['input']>;
  tagName: Scalars['String']['input'];
};

export type QueueJobActionArgs = {
  __typename: 'QueueJobActionArgs';
  priority?: Maybe<Scalars['Int']['output']>;
  runSpec?: Maybe<Scalars['JSON']['output']>;
};

export type QueueJobActionInput = {
  queueID: Scalars['ID']['input'];
  template: Scalars['JSONString']['input'];
};

export type QueueJobTriggeredAction = {
  __typename: 'QueueJobTriggeredAction';
  queue?: Maybe<RunQueue>;
  readOnly: Scalars['Boolean']['output'];
  template: Scalars['JSONString']['output'];
};

/** The outcome of a (legacy) Launch QUEUE_JOB action. */
export type QueuedJobTriggerResultDetails = {
  __typename: 'QueuedJobTriggerResultDetails';
  error?: Maybe<TriggerExecutionError>;
  runQueueItemID?: Maybe<Scalars['ID']['output']>;
};

export enum RampIdType {
  ApiKey = 'ApiKey',
  CustomId = 'CustomID',
  EntityId = 'EntityID',
  EntityName = 'EntityName',
  None = 'None',
  OrgId = 'OrgID',
  OrgName = 'OrgName',
  ProjectId = 'ProjectID',
  UserId = 'UserID',
  UserName = 'UserName'
}

export type RampManager = {
  __typename: 'RampManager';
  setting?: Maybe<RampSettingEdge>;
  settings: RampSettingConnection;
};


export type RampManagerSettingArgs = {
  name: Scalars['String']['input'];
};

export type RampSettingConnection = {
  __typename: 'RampSettingConnection';
  edges: Array<RampSettingEdge>;
};

export type RampSettingEdge = {
  __typename: 'RampSettingEdge';
  description: Scalars['String']['output'];
  group: Scalars['String']['output'];
  idIsRamped: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rampIDType: RampIdType;
  rampType: RampType;
  stores: Array<RampThresholdStore>;
};


export type RampSettingEdgeIdIsRampedArgs = {
  id: Scalars['String']['input'];
};

export type RampSettingThreshold = {
  __typename: 'RampSettingThreshold';
  checkId: Scalars['String']['output'];
  displayCheckID: Scalars['String']['output'];
  threshold: Scalars['Float']['output'];
};

export type RampThresholdStore = {
  __typename: 'RampThresholdStore';
  name: Scalars['String']['output'];
  thresholds: Array<RampSettingThreshold>;
};

export enum RampType {
  Backend = 'Backend',
  FrontendBetaFlag = 'FrontendBetaFlag',
  FrontendFeatureFlag = 'FrontendFeatureFlag',
  Statsig = 'Statsig'
}

export type RateLimits = {
  __typename: 'RateLimits';
  createArtifacts: Scalars['Int']['output'];
  createArtifactsCollectionRequestCount: Scalars['Int']['output'];
  createArtifactsRequestCount: Scalars['Int']['output'];
  createArtifactsTimeWindow: Scalars['Int']['output'];
  filestreamCount: Scalars['Float']['output'];
  filestreamPerRunCount: Scalars['Float']['output'];
  filestreamSize: Scalars['Int']['output'];
  graphql: Scalars['Int']['output'];
  runUpdateCount: Scalars['Float']['output'];
  sdkGraphql: Scalars['Int']['output'];
  sdkGraphqlQuerySeconds: Scalars['Float']['output'];
};

export type RateLimitsInput = {
  createArtifacts?: InputMaybe<Scalars['Int']['input']>;
  createArtifactsCollectionRequestCount?: InputMaybe<Scalars['Int']['input']>;
  createArtifactsRequestCount?: InputMaybe<Scalars['Int']['input']>;
  createArtifactsTimeWindow?: InputMaybe<Scalars['Int']['input']>;
  filestreamCount?: InputMaybe<Scalars['Float']['input']>;
  filestreamPerRunCount?: InputMaybe<Scalars['Float']['input']>;
  filestreamSize?: InputMaybe<Scalars['Int']['input']>;
  graphql?: InputMaybe<Scalars['Int']['input']>;
  runUpdateCount?: InputMaybe<Scalars['Float']['input']>;
  sdkGraphql?: InputMaybe<Scalars['Int']['input']>;
  sdkGraphqlQuerySeconds?: InputMaybe<Scalars['Float']['input']>;
};

export type ReactivateCustomerSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type ReactivateCustomerSubscriptionPayload = {
  __typename: 'ReactivateCustomerSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RecordSlurmCommandErrorInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  errorMessage: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type RecordSlurmCommandErrorPayload = {
  __typename: 'RecordSlurmCommandErrorPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ReferenceBucketDownloadUrlsPayload = {
  __typename: 'ReferenceBucketDownloadUrlsPayload';
  downloadUrls: Array<Scalars['String']['output']>;
  expiresAt: Scalars['DateTime']['output'];
};

/** Input payload for registering a device for push notifications. */
export type RegisterUserDeviceInput = {
  /** The device's human-readable name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The device platform. */
  platform: DevicePlatform;
  /** The device token to register. */
  token: Scalars['String']['input'];
};

/** Response payload from registering a device for push notifications. */
export type RegisterUserDevicePayload = {
  __typename: 'RegisterUserDevicePayload';
  /** The registered device. */
  device: UserDevice;
};

export type RegistryAsset = {
  __typename: 'RegistryAsset';
  canReadPromptContent: Scalars['Boolean']['output'];
  refType: WeaveSourceType;
  sourceProjectInternalID: Scalars['ID']['output'];
  weaveRef: Scalars['String']['output'];
};

export type RegistryAvailableTeam = {
  __typename: 'RegistryAvailableTeam';
  role?: Maybe<Role>;
  team: TeamSummary;
};

export type RegistryHuggingFaceImport = {
  __typename: 'RegistryHuggingFaceImport';
  artifact?: Maybe<Artifact>;
  artifactCollectionName: Scalars['String']['output'];
  artifactMembership?: Maybe<ArtifactCollectionMembership>;
  artifactRef?: Maybe<Scalars['String']['output']>;
  artifactSequence?: Maybe<ArtifactSequence>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  desiredState: RegistryHuggingFaceImportDesiredState;
  entity?: Maybe<Entity>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  events: RegistryHuggingFaceImportEventConnection;
  hfRepoId: Scalars['String']['output'];
  hfRepoType: RegistryHuggingFaceImportRepoType;
  hfRequestedRevision: Scalars['String']['output'];
  hfResolvedRevision?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  phase?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
  registryCollection?: Maybe<ArtifactPortfolio>;
  registryCollectionName?: Maybe<Scalars['String']['output']>;
  registryMembership?: Maybe<ArtifactCollectionMembership>;
  registryProject?: Maybe<Project>;
  registryRef?: Maybe<Scalars['String']['output']>;
  sandboxId?: Maybe<Scalars['String']['output']>;
  spec: Scalars['JSONString']['output'];
  state: RegistryHuggingFaceImportState;
  stats?: Maybe<Scalars['JSONString']['output']>;
  terminalAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RegistryHuggingFaceImportConnection = {
  __typename: 'RegistryHuggingFaceImportConnection';
  edges: Array<RegistryHuggingFaceImportEdge>;
  pageInfo: PageInfo;
};

export enum RegistryHuggingFaceImportDesiredState {
  Running = 'RUNNING',
  Stopped = 'STOPPED'
}

export type RegistryHuggingFaceImportEdge = {
  __typename: 'RegistryHuggingFaceImportEdge';
  cursor: Scalars['String']['output'];
  node: RegistryHuggingFaceImport;
};

export type RegistryHuggingFaceImportEvent = {
  __typename: 'RegistryHuggingFaceImportEvent';
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  time: Scalars['DateTime']['output'];
};

export type RegistryHuggingFaceImportEventConnection = {
  __typename: 'RegistryHuggingFaceImportEventConnection';
  edges: Array<RegistryHuggingFaceImportEventEdge>;
  pageInfo: PageInfo;
};

export type RegistryHuggingFaceImportEventEdge = {
  __typename: 'RegistryHuggingFaceImportEventEdge';
  cursor: Scalars['String']['output'];
  node: RegistryHuggingFaceImportEvent;
};

export type RegistryHuggingFaceImportRegistryInput = {
  collectionName: Scalars['String']['input'];
  registryName: Scalars['String']['input'];
};

export enum RegistryHuggingFaceImportRepoType {
  Model = 'MODEL'
}

export enum RegistryHuggingFaceImportState {
  Created = 'CREATED',
  Failed = 'FAILED',
  Running = 'RUNNING',
  Starting = 'STARTING',
  Stopped = 'STOPPED',
  Stopping = 'STOPPING',
  Succeeded = 'SUCCEEDED'
}

export type RegistryModelDeployment = {
  __typename: 'RegistryModelDeployment';
  artifactId: Scalars['ID']['output'];
  backendType: RegistryModelDeploymentBackendType;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  desiredState: RegistryModelDeploymentDesiredState;
  endpointUrl?: Maybe<Scalars['String']['output']>;
  engine: Scalars['String']['output'];
  events: RegistryModelDeploymentEventConnection;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phase?: Maybe<Scalars['String']['output']>;
  registryCollectionId: Scalars['ID']['output'];
  registryMembershipId: Scalars['ID']['output'];
  registryProjectId: Scalars['ID']['output'];
  registryRefCurrent?: Maybe<Scalars['String']['output']>;
  registryRefSnapshot: Scalars['String']['output'];
  registryVersionIndex: Scalars['Int']['output'];
  sandboxWorkloads: RegistryModelDeploymentSandboxWorkloadConnection;
  spec: Scalars['JSONString']['output'];
  state: RegistryModelDeploymentState;
  terminalAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum RegistryModelDeploymentBackendType {
  Sandbox = 'SANDBOX'
}

export type RegistryModelDeploymentConnection = {
  __typename: 'RegistryModelDeploymentConnection';
  edges: Array<RegistryModelDeploymentEdge>;
  pageInfo: PageInfo;
};

export enum RegistryModelDeploymentDesiredState {
  Running = 'RUNNING',
  Stopped = 'STOPPED'
}

export type RegistryModelDeploymentEdge = {
  __typename: 'RegistryModelDeploymentEdge';
  cursor: Scalars['String']['output'];
  node: RegistryModelDeployment;
};

export type RegistryModelDeploymentEvent = {
  __typename: 'RegistryModelDeploymentEvent';
  id: Scalars['ID']['output'];
  logTail?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  time: Scalars['DateTime']['output'];
};

export type RegistryModelDeploymentEventConnection = {
  __typename: 'RegistryModelDeploymentEventConnection';
  edges: Array<RegistryModelDeploymentEventEdge>;
  pageInfo: PageInfo;
};

export type RegistryModelDeploymentEventEdge = {
  __typename: 'RegistryModelDeploymentEventEdge';
  cursor: Scalars['String']['output'];
  node: RegistryModelDeploymentEvent;
};

export type RegistryModelDeploymentSandboxInput = {
  cpu?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  exposedRoutes?: InputMaybe<Array<Scalars['String']['input']>>;
  gpuCount?: InputMaybe<Scalars['Int']['input']>;
  maxLifetimeSeconds?: InputMaybe<Scalars['Int']['input']>;
  memory?: InputMaybe<Scalars['String']['input']>;
  modelFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  requestTimeoutSeconds?: InputMaybe<Scalars['Int']['input']>;
};

export type RegistryModelDeploymentSandboxWorkload = {
  __typename: 'RegistryModelDeploymentSandboxWorkload';
  createdAt: Scalars['DateTime']['output'];
  desiredState: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastErrorCode?: Maybe<Scalars['String']['output']>;
  lastErrorMessage?: Maybe<Scalars['String']['output']>;
  lastReconciledAt?: Maybe<Scalars['DateTime']['output']>;
  nextReconcileAt?: Maybe<Scalars['DateTime']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  terminalAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RegistryModelDeploymentSandboxWorkloadConnection = {
  __typename: 'RegistryModelDeploymentSandboxWorkloadConnection';
  edges: Array<RegistryModelDeploymentSandboxWorkloadEdge>;
  pageInfo: PageInfo;
};

export type RegistryModelDeploymentSandboxWorkloadEdge = {
  __typename: 'RegistryModelDeploymentSandboxWorkloadEdge';
  cursor: Scalars['String']['output'];
  node: RegistryModelDeploymentSandboxWorkload;
};

export type RegistryModelDeploymentSourceInput = {
  collectionName: Scalars['String']['input'];
  orgEntityName?: InputMaybe<Scalars['String']['input']>;
  projectName: Scalars['String']['input'];
  versionIndex: Scalars['Int']['input'];
};

export enum RegistryModelDeploymentState {
  Created = 'CREATED',
  Failed = 'FAILED',
  Running = 'RUNNING',
  Starting = 'STARTING',
  Stopped = 'STOPPED',
  Stopping = 'STOPPING'
}

export type RemoteScoringAllowedHost = {
  __typename: 'RemoteScoringAllowedHost';
  host: Scalars['String']['output'];
  port?: Maybe<Scalars['Int']['output']>;
};

export type RemoteScoringAllowedHostInput = {
  host: Scalars['String']['input'];
  port?: InputMaybe<Scalars['Int']['input']>;
};

export type RemoteScoringPolicy = {
  __typename: 'RemoteScoringPolicy';
  allowedHosts: Array<RemoteScoringAllowedHost>;
  configured: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
};

/** Event details for removing a tag from an artifact. */
export type RemoveArtifactTagEventInput = {
  /** The ID of the artifact version */
  artifactId: Scalars['ID']['input'];
  /** The tag that was removed */
  tag: Scalars['String']['input'];
};

/** Event details for removing a tag from a collection. */
export type RemoveCollectionTagEventInput = {
  /** The ID of the collection */
  collectionId: Scalars['ID']['input'];
  /** The tag that was removed */
  tag: Scalars['String']['input'];
};

export type RemoveProjectProtectedAliasesInput = {
  aliases: Array<Scalars['String']['input']>;
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};

export type RemoveProjectProtectedAliasesPayload = {
  __typename: 'RemoveProjectProtectedAliasesPayload';
  aliases: Array<Scalars['String']['output']>;
};

export type RemoveProtectedAliasesInput = {
  adminType: WorkflowsAdminType;
  aliases: Array<Scalars['String']['input']>;
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
};

export type RemoveProtectedAliasesPayload = {
  __typename: 'RemoveProtectedAliasesPayload';
  aliases: Array<Scalars['String']['output']>;
};

export type RemoveUserFromOrganizationByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type RemoveUserFromOrganizationByIdPayload = {
  __typename: 'RemoveUserFromOrganizationByIdPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RemoveUserFromOrganizationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  userName: Scalars['String']['input'];
};

export type RemoveUserFromOrganizationPayload = {
  __typename: 'RemoveUserFromOrganizationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RenameNotebookInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type RenameNotebookPayload = {
  __typename: 'RenameNotebookPayload';
  notebook?: Maybe<Notebook>;
};

export type RenameProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  newProjectName: Scalars['String']['input'];
  oldProjectName: Scalars['String']['input'];
};

export type Repo = Node & {
  __typename: 'Repo';
  displayName: Scalars['String']['output'];
  entity: Entity;
  id: Scalars['ID']['output'];
};

export type RepoConnection = {
  __typename: 'RepoConnection';
  edges: Array<RepoEdge>;
};

export type RepoEdge = {
  __typename: 'RepoEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Repo>;
};

export type RepoInsightsRowConnection = {
  __typename: 'RepoInsightsRowConnection';
  edges: Array<RowEdge>;
  isNormalizedUserCount: Scalars['Boolean']['output'];
  pageInfo: PageInfo;
  schema: Scalars['JSON']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ResendEmailVerificationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

export type ResendEmailVerificationPayload = {
  __typename: 'ResendEmailVerificationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ResetPasswordInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

export type ResetPasswordPayload = {
  __typename: 'ResetPasswordPayload';
  success: Scalars['Boolean']['output'];
};

export type ResumePaygoSubscriptionsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type ResumePaygoSubscriptionsPayload = {
  __typename: 'ResumePaygoSubscriptionsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RetryStripeOpenInvoicesByOrganizationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type RetryStripeOpenInvoicesByOrganizationPayload = {
  __typename: 'RetryStripeOpenInvoicesByOrganizationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RevokeAccessTokenEmailInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type RevokeAccessTokenEmailPayload = {
  __typename: 'RevokeAccessTokenEmailPayload';
  accessToken: AccessToken;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RevokeAccessTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type RevokeAccessTokenPayload = {
  __typename: 'RevokeAccessTokenPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RevokeClientInput = {
  clientId: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
};

export type RevokeClientPayload = {
  __typename: 'RevokeClientPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RevokePersonalSecretFromWbAgentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  secretUuid: Scalars['String']['input'];
};

export type RevokePersonalSecretFromWbAgentPayload = {
  __typename: 'RevokePersonalSecretFromWBAgentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RewindRunInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  metricName: Scalars['String']['input'];
  metricValue: Scalars['Float']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
};

export type RewindRunPayload = {
  __typename: 'RewindRunPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  rewoundRun?: Maybe<Run>;
};

export type Role = {
  __typename: 'Role';
  ID: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  inheritedFrom?: Maybe<Role>;
  name: Scalars['String']['output'];
  permissions: Array<RolePermission>;
};

export type RolePermission = {
  __typename: 'RolePermission';
  displayName: Scalars['String']['output'];
  groupName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RowConnection = {
  __typename: 'RowConnection';
  edges: Array<RowEdge>;
  pageInfo: PageInfo;
  schema: Scalars['JSON']['output'];
  totalCount: Scalars['Int']['output'];
};

export type RowEdge = {
  __typename: 'RowEdge';
  node?: Maybe<RowType>;
};

export type RowType = {
  __typename: 'RowType';
  row: Scalars['JSON']['output'];
};

export type Run = BucketType & Node & {
  __typename: 'Run';
  agent?: Maybe<Agent>;
  aggregations?: Maybe<Scalars['JSON']['output']>;
  artifactLineageDag?: Maybe<ArtifactLineageDag>;
  benchmarkRun?: Maybe<BenchmarkRun>;
  branchPoint?: Maybe<RunBranchPoint>;
  bucketedHistory: Array<Scalars['JSON']['output']>;
  codeArtifact?: Maybe<Artifact>;
  commit?: Maybe<Scalars['String']['output']>;
  computeSeconds: Scalars['Duration']['output'];
  config?: Maybe<Scalars['JSONString']['output']>;
  coreweaveGrafanaDashboard: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  debug?: Maybe<Scalars['Boolean']['output']>;
  defaultColorIndex?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  descendantRuns?: Maybe<RunDescendantRuns>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  events: Array<Scalars['String']['output']>;
  eventsLineCount?: Maybe<Scalars['Int']['output']>;
  eventsTail?: Maybe<Scalars['JSONString']['output']>;
  exampleTable?: Maybe<Scalars['JSONString']['output']>;
  exampleTableColumns?: Maybe<Scalars['JSONString']['output']>;
  exampleTableTypes?: Maybe<Scalars['JSONString']['output']>;
  exitcode?: Maybe<Scalars['Float']['output']>;
  failed?: Maybe<Scalars['Boolean']['output']>;
  fileCount?: Maybe<Scalars['Int']['output']>;
  files?: Maybe<FileConnection>;
  folders?: Maybe<Folders>;
  framework?: Maybe<Scalars['String']['output']>;
  github?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  groupCounts?: Maybe<Array<Scalars['Int']['output']>>;
  hasProtectedOutputArtifact: Scalars['Boolean']['output'];
  heartbeatAt?: Maybe<Scalars['DateTime']['output']>;
  history: Array<Scalars['String']['output']>;
  historyKeys?: Maybe<Scalars['JSON']['output']>;
  historyLineCount?: Maybe<Scalars['Int']['output']>;
  historyMaterializationTask?: Maybe<Task>;
  historyTail?: Maybe<Scalars['JSONString']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputArtifacts?: Maybe<InputArtifactConnection>;
  internalID?: Maybe<Scalars['ID']['output']>;
  job?: Maybe<Artifact>;
  jobId?: Maybe<Scalars['Int']['output']>;
  jobType?: Maybe<Scalars['String']['output']>;
  lines: Array<Scalars['JSON']['output']>;
  logLineCount?: Maybe<Scalars['Int']['output']>;
  logLines?: Maybe<LogLineConnection>;
  metricSearch?: Maybe<MetricSearchResults>;
  metricStatistics?: Maybe<Scalars['JSON']['output']>;
  model?: Maybe<Project>;
  multiValueMetadataColumns: Array<MultiValueMetadataColumn>;
  name: Scalars['String']['output'];
  ndbId?: Maybe<Scalars['ID']['output']>;
  nodeAlertsHistory: Array<NodeAlert>;
  notes?: Maybe<Scalars['String']['output']>;
  outputArtifacts?: Maybe<ArtifactConnection>;
  parquetHistory: ParquetHistory;
  patch?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
  projectId: Scalars['ID']['output'];
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  requestSubscribe?: Maybe<Scalars['Boolean']['output']>;
  runInfo?: Maybe<RunInfo>;
  running?: Maybe<Scalars['Boolean']['output']>;
  sampledHistory: Array<Scalars['JSON']['output']>;
  servicesAvailable?: Maybe<RunServicesAvailable>;
  shouldStop?: Maybe<Scalars['Boolean']['output']>;
  slurmControl?: Maybe<RunSlurmControl>;
  state?: Maybe<Scalars['String']['output']>;
  stepsForMetricValues: Array<Maybe<Scalars['Int']['output']>>;
  stopped?: Maybe<Scalars['Boolean']['output']>;
  storageBytes: Scalars['Int64']['output'];
  summaryMetrics?: Maybe<Scalars['JSONString']['output']>;
  sweep?: Maybe<Sweep>;
  sweepName?: Maybe<Scalars['String']['output']>;
  systemMetrics?: Maybe<Scalars['JSONString']['output']>;
  tagColors: Array<RunTag>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  wandbConfig?: Maybe<Scalars['JSONString']['output']>;
};


export type RunAggregationsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RunArtifactLineageDagArgs = {
  baseGraphNodeIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  clusterSize?: InputMaybe<Scalars['Int']['input']>;
  directLineage?: InputMaybe<Scalars['Boolean']['input']>;
  filterGeneratedArtifacts: Scalars['Boolean']['input'];
  limit: Scalars['Int']['input'];
  traversalDirection?: InputMaybe<TraversalDirection>;
};


export type RunBucketedHistoryArgs = {
  excludeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
  packVersion?: InputMaybe<Scalars['Int']['input']>;
  primaryLineType?: InputMaybe<Scalars['String']['input']>;
  specs: Array<Scalars['JSONString']['input']>;
};


export type RunConfigArgs = {
  dotBehavior?: InputMaybe<DotBehavior>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type RunEventsArgs = {
  samples?: InputMaybe<Scalars['Int']['input']>;
};


export type RunFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folderPath?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pattern?: InputMaybe<Scalars['String']['input']>;
};


export type RunFoldersArgs = {
  folderPath?: InputMaybe<Scalars['String']['input']>;
};


export type RunHistoryArgs = {
  maxKeyLimit?: InputMaybe<Scalars['Int']['input']>;
  maxStep?: InputMaybe<Scalars['Int64']['input']>;
  minStep?: InputMaybe<Scalars['Int64']['input']>;
  samples?: InputMaybe<Scalars['Int']['input']>;
};


export type RunHistoryKeysArgs = {
  format?: InputMaybe<HistoryKeysFormat>;
};


export type RunInputArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type RunLinesArgs = {
  excludeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
  packVersion?: InputMaybe<Scalars['Int']['input']>;
  primaryLineType?: InputMaybe<Scalars['String']['input']>;
  specs: Array<Scalars['JSONString']['input']>;
};


export type RunLogLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  useImprovedPagination?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RunMetricSearchArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  metricNamePattern?: InputMaybe<Scalars['String']['input']>;
  metricTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type RunMetricStatisticsArgs = {
  metricName?: InputMaybe<Scalars['String']['input']>;
};


export type RunMultiValueMetadataColumnsArgs = {
  keys: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type RunNodeAlertsHistoryArgs = {
  start: Scalars['DateTime']['input'];
};


export type RunOutputArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type RunParquetHistoryArgs = {
  liveKeys: Array<Scalars['String']['input']>;
};


export type RunSampledHistoryArgs = {
  packVersion?: InputMaybe<Scalars['Int']['input']>;
  specs: Array<Scalars['JSONString']['input']>;
};


export type RunStepsForMetricValuesArgs = {
  metric: Scalars['String']['input'];
  values: Array<Scalars['Float']['input']>;
};


export type RunSummaryMetricsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  packVersion?: InputMaybe<Scalars['Int']['input']>;
};


export type RunWandbConfigArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RunAlertChannelPrefs = {
  __typename: 'RunAlertChannelPrefs';
  email: Scalars['Boolean']['output'];
  slack: Scalars['Boolean']['output'];
};

export type RunAlertChannelPrefsInput = {
  email: Scalars['Boolean']['input'];
  slack: Scalars['Boolean']['input'];
};

export type RunBranchPoint = {
  __typename: 'RunBranchPoint';
  run: Run;
  step: Scalars['Int64']['output'];
};

export type RunConnection = {
  __typename: 'RunConnection';
  configValues?: Maybe<Scalars['JSON']['output']>;
  configValuesCategories?: Maybe<Scalars['JSON']['output']>;
  configValuesNumberAggregation?: Maybe<Scalars['JSON']['output']>;
  delta: Array<RunDiff>;
  deltaOrder: Array<Scalars['ID']['output']>;
  deltas?: Maybe<BucketDiffs>;
  edges: Array<RunEdge>;
  historyKeys?: Maybe<Scalars['JSON']['output']>;
  metricSearch?: Maybe<MetricSearchResults>;
  metricStatistics?: Maybe<Scalars['JSON']['output']>;
  metricStatisticsAggregation?: Maybe<Scalars['JSON']['output']>;
  pageInfo: PageInfo;
  paths?: Maybe<Scalars['JSONString']['output']>;
  sectionAwareHistoryKeys?: Maybe<SectionAwareHistoryKeysResults>;
  totalCount: Scalars['Int']['output'];
  uniqueKeyTypes?: Maybe<Array<Scalars['String']['output']>>;
};


export type RunConnectionConfigValuesArgs = {
  configKey?: InputMaybe<Scalars['String']['input']>;
  configType?: InputMaybe<Scalars['String']['input']>;
};


export type RunConnectionConfigValuesCategoriesArgs = {
  configKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type RunConnectionConfigValuesNumberAggregationArgs = {
  configKey?: InputMaybe<Scalars['String']['input']>;
};


export type RunConnectionDeltaArgs = {
  currentRuns: Array<Scalars['String']['input']>;
  lastUpdated: Scalars['DateTime']['input'];
};


export type RunConnectionDeltaOrderArgs = {
  currentRuns: Array<Scalars['String']['input']>;
  lastUpdated: Scalars['DateTime']['input'];
};


export type RunConnectionDeltasArgs = {
  currentRuns: Array<Scalars['String']['input']>;
  lastUpdated: Scalars['DateTime']['input'];
  timeout?: InputMaybe<Scalars['Int']['input']>;
};


export type RunConnectionHistoryKeysArgs = {
  cachedHash?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<HistoryKeysFormat>;
  includeHash?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
};


export type RunConnectionMetricSearchArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  metricNamePattern?: InputMaybe<Scalars['String']['input']>;
  metricTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type RunConnectionMetricStatisticsArgs = {
  metricName?: InputMaybe<Scalars['String']['input']>;
};


export type RunConnectionMetricStatisticsAggregationArgs = {
  metricName?: InputMaybe<Scalars['String']['input']>;
};


export type RunConnectionSectionAwareHistoryKeysArgs = {
  includeHash?: InputMaybe<Scalars['Boolean']['input']>;
  lastPrefix?: InputMaybe<Scalars['Boolean']['input']>;
  maxMetricsPerGroup?: InputMaybe<Scalars['Int']['input']>;
  maxPrefixGroups?: InputMaybe<Scalars['Int']['input']>;
  metricNamePattern?: InputMaybe<Scalars['String']['input']>;
  requiredMetrics?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredPrefixes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RunCrashedChannelPrefs = {
  __typename: 'RunCrashedChannelPrefs';
  email: Scalars['Boolean']['output'];
  minimumRunDurationMs?: Maybe<Scalars['Int']['output']>;
  slack: Scalars['Boolean']['output'];
};

export type RunCrashedChannelPrefsInput = {
  email: Scalars['Boolean']['input'];
  minimumRunDurationMs?: InputMaybe<Scalars['Int']['input']>;
  slack: Scalars['Boolean']['input'];
};

export type RunDescendantRuns = {
  __typename: 'RunDescendantRuns';
  runs: Array<RunIdentifier>;
};

export type RunDiff = {
  __typename: 'RunDiff';
  index: Scalars['Int']['output'];
  op: DiffOperation;
  run?: Maybe<Run>;
};

export type RunEdge = {
  __typename: 'RunEdge';
  cursor: Scalars['String']['output'];
  node: Run;
};

export type RunFieldValue = {
  __typename: 'RunFieldValue';
  value?: Maybe<Scalars['JSONString']['output']>;
};

export type RunFieldValueConnection = {
  __typename: 'RunFieldValueConnection';
  edges: Array<RunFieldValueEdge>;
  pageInfo: PageInfo;
};

export type RunFieldValueEdge = {
  __typename: 'RunFieldValueEdge';
  cursor: Scalars['String']['output'];
  node: RunFieldValue;
};

export type RunGroup = {
  __typename: 'RunGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  project: Project;
  tags: Array<RunTag>;
};

export type RunIdentifier = {
  __typename: 'RunIdentifier';
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RunInfo = {
  __typename: 'RunInfo';
  args: Array<Scalars['String']['output']>;
  codePath?: Maybe<Scalars['String']['output']>;
  codePathLocal?: Maybe<Scalars['String']['output']>;
  codeSaved?: Maybe<Scalars['Boolean']['output']>;
  colab?: Maybe<Scalars['String']['output']>;
  coreweave?: Maybe<CoreweaveInfo>;
  cpuCount?: Maybe<Scalars['Int']['output']>;
  cpuCountLogical?: Maybe<Scalars['Int']['output']>;
  executable?: Maybe<Scalars['String']['output']>;
  git?: Maybe<GitInfo>;
  gpu?: Maybe<Scalars['String']['output']>;
  gpuCount?: Maybe<Scalars['Int']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  program?: Maybe<Scalars['String']['output']>;
  python?: Maybe<Scalars['String']['output']>;
  slurm?: Maybe<SlurmInfo>;
};

export type RunKeySuggestion = {
  __typename: 'RunKeySuggestion';
  count: Scalars['Int']['output'];
  displayValue?: Maybe<Scalars['JSONString']['output']>;
  value?: Maybe<Scalars['JSONString']['output']>;
};

export type RunMetricEventDetails = {
  __typename: 'RunMetricEventDetails';
  entityName?: Maybe<Scalars['String']['output']>;
  metricName?: Maybe<Scalars['String']['output']>;
  metricValues?: Maybe<Array<Scalars['Float']['output']>>;
  projectName?: Maybe<Scalars['String']['output']>;
  runName?: Maybe<Scalars['String']['output']>;
};

export type RunQueue = {
  __typename: 'RunQueue';
  access: RunQueueAccessType;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  defaultResourceConfig?: Maybe<DefaultResourceConfig>;
  defaultResourceConfigID?: Maybe<Scalars['ID']['output']>;
  entityName: Scalars['String']['output'];
  /** @deprecated Executor state tracked in LaunchAgent.AgentStatus */
  executorInfo: Scalars['String']['output'];
  externalLinks?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  prioritizationMode: RunQueuePrioritizationMode;
  runQueueItem?: Maybe<RunQueueItem>;
  runQueueItems: RunQueueItemConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type RunQueueRunQueueItemArgs = {
  id: Scalars['ID']['input'];
};


export type RunQueueRunQueueItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum RunQueueAccessType {
  Project = 'PROJECT',
  User = 'USER'
}

export type RunQueueItem = {
  __typename: 'RunQueueItem';
  associatedRunId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<RunQueueItemInfoDetails>;
  id: Scalars['ID']['output'];
  launchAgentId?: Maybe<Scalars['ID']['output']>;
  priority: Scalars['Int']['output'];
  runSpec: Scalars['JSON']['output'];
  state: RunQueueItemState;
  templateVariableValues?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  warnings: Array<Maybe<RunQueueItemInfoDetails>>;
};

export type RunQueueItemConnection = {
  __typename: 'RunQueueItemConnection';
  edges: Array<RunQueueItemEdge>;
  pageInfo: PageInfo;
};

export type RunQueueItemEdge = {
  __typename: 'RunQueueItemEdge';
  cursor: Scalars['String']['output'];
  node: RunQueueItem;
};

export type RunQueueItemInfoDetails = Error & {
  __typename: 'RunQueueItemInfoDetails';
  filePaths: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  stage: Scalars['String']['output'];
};

export enum RunQueueItemState {
  Claimed = 'CLAIMED',
  Failed = 'FAILED',
  Leased = 'LEASED',
  Pending = 'PENDING'
}

export enum RunQueuePrioritizationMode {
  Disabled = 'DISABLED',
  V0 = 'V0'
}

export type RunSelectorGroup = {
  __typename: 'RunSelectorGroup';
  count: Scalars['Int']['output'];
  hasActiveRuns: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  subgroupCount?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type RunSelectorGroupConnection = {
  __typename: 'RunSelectorGroupConnection';
  edges: Array<RunSelectorGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RunSelectorGroupEdge = {
  __typename: 'RunSelectorGroupEdge';
  cursor: Scalars['String']['output'];
  node: RunSelectorGroup;
};

export type RunServicesAvailable = {
  __typename: 'RunServicesAvailable';
  tensorboard?: Maybe<Scalars['Boolean']['output']>;
};

export type RunSlurmControl = {
  __typename: 'RunSlurmControl';
  health?: Maybe<SlurmDaemonHealth>;
  latestCommand?: Maybe<SlurmCommandStatus>;
};

export type RunStateEventDetails = {
  __typename: 'RunStateEventDetails';
  entityName?: Maybe<Scalars['String']['output']>;
  newRunState?: Maybe<Scalars['String']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  runName?: Maybe<Scalars['String']['output']>;
};

export type RunStorageNode = StorageTreeNode & {
  __typename: 'RunStorageNode';
  files: FileStorageNodeConnection;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  run: Run;
  runID: Scalars['ID']['output'];
  size: Scalars['Int64']['output'];
};


export type RunStorageNodeFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type RunStorageNodeConnection = {
  __typename: 'RunStorageNodeConnection';
  edges: Array<RunStorageNodeEdge>;
  pageInfo: PageInfo;
  totalSize: Scalars['Int64']['output'];
};

export type RunStorageNodeEdge = {
  __typename: 'RunStorageNodeEdge';
  cursor: Scalars['String']['output'];
  node: RunStorageNode;
};

export type RunTag = {
  __typename: 'RunTag';
  colorIndex: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RunTagConnection = {
  __typename: 'RunTagConnection';
  edges: Array<RunTagEdge>;
  pageInfo: PageInfo;
};

export type RunTagCount = {
  __typename: 'RunTagCount';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type RunTagEdge = {
  __typename: 'RunTagEdge';
  cursor: Scalars['String']['output'];
  node: RunTag;
};

export type RunsResult = {
  __typename: 'RunsResult';
  deltas?: Maybe<BucketDiffs>;
  runs: Array<Run>;
};


export type RunsResultDeltasArgs = {
  currentRuns: Array<Scalars['String']['input']>;
  lastUpdated: Scalars['DateTime']['input'];
  timeout?: InputMaybe<Scalars['Int']['input']>;
};

export type Sandbox = {
  __typename: 'Sandbox';
  displayName?: Maybe<Scalars['String']['output']>;
  logs?: Maybe<SandboxLogConnection>;
  sandboxId: Scalars['ID']['output'];
  sourceTemplateId?: Maybe<Scalars['String']['output']>;
  sourceTemplateRevision?: Maybe<Scalars['Int64']['output']>;
  spec?: Maybe<SandboxSpec>;
  status?: Maybe<SandboxObservedStatus>;
};


export type SandboxLogsArgs = {
  sinceTime?: InputMaybe<Scalars['DateTime']['input']>;
  tailLines?: InputMaybe<Scalars['Int']['input']>;
};

export type SandboxCidrBlock = {
  __typename: 'SandboxCIDRBlock';
  cidr: Scalars['String']['output'];
  except: Array<Scalars['String']['output']>;
};

export type SandboxConnection = {
  __typename: 'SandboxConnection';
  edges: Array<SandboxEdge>;
  pageInfo: PageInfo;
};

export type SandboxContainerStatus = {
  __typename: 'SandboxContainerStatus';
  exitCode: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  restartCount: Scalars['Int']['output'];
  state: SandboxState;
};

export type SandboxEdge = {
  __typename: 'SandboxEdge';
  cursor: Scalars['String']['output'];
  node: Sandbox;
};

export type SandboxEgressRule = {
  __typename: 'SandboxEgressRule';
  any?: Maybe<Scalars['Boolean']['output']>;
  cidr?: Maybe<SandboxCidrBlock>;
  dnsName?: Maybe<Scalars['String']['output']>;
  ports: Array<SandboxPortRangeV1>;
  selector?: Maybe<SandboxSelectorBlock>;
  tenant?: Maybe<SandboxTenantScope>;
};

export enum SandboxEndpointAuth {
  EndpointAuthOpen = 'ENDPOINT_AUTH_OPEN',
  EndpointAuthToken = 'ENDPOINT_AUTH_TOKEN',
  EndpointAuthUnspecified = 'ENDPOINT_AUTH_UNSPECIFIED'
}

export enum SandboxEndpointKind {
  EndpointKindHttps = 'ENDPOINT_KIND_HTTPS',
  EndpointKindTlsPassthrough = 'ENDPOINT_KIND_TLS_PASSTHROUGH',
  EndpointKindUnspecified = 'ENDPOINT_KIND_UNSPECIFIED'
}

export type SandboxEndpointSpec = {
  __typename: 'SandboxEndpointSpec';
  auth: SandboxEndpointAuth;
  kind: SandboxEndpointKind;
};

export type SandboxEndpointStatus = {
  __typename: 'SandboxEndpointStatus';
  auth: SandboxEndpointAuth;
  kind: SandboxEndpointKind;
  url: Scalars['String']['output'];
};

export type SandboxEnvVars = {
  __typename: 'SandboxEnvVars';
  runNames: Array<Scalars['String']['output']>;
};

export type SandboxEnvVarsInput = {
  runNames: Array<Scalars['String']['input']>;
};

export type SandboxGpu = {
  __typename: 'SandboxGPU';
  count: Scalars['Int64']['output'];
  memoryGb?: Maybe<Scalars['Int64']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SandboxIngressRule = {
  __typename: 'SandboxIngressRule';
  any?: Maybe<Scalars['Boolean']['output']>;
  cidr?: Maybe<SandboxCidrBlock>;
  ports: Array<SandboxPortRangeV1>;
  tenant?: Maybe<SandboxTenantScope>;
};

export type SandboxLabel = {
  __typename: 'SandboxLabel';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SandboxLogConnection = {
  __typename: 'SandboxLogConnection';
  entries: Array<SandboxLogEntry>;
  truncated: Scalars['Boolean']['output'];
};

export type SandboxLogEntry = {
  __typename: 'SandboxLogEntry';
  text: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export enum SandboxMode {
  Edit = 'EDIT',
  Run = 'RUN'
}

export enum SandboxModeV1 {
  SandboxModeCks = 'SANDBOX_MODE_CKS',
  SandboxModeServerless = 'SANDBOX_MODE_SERVERLESS',
  SandboxModeUnspecified = 'SANDBOX_MODE_UNSPECIFIED'
}

export type SandboxNetworkOptions = {
  __typename: 'SandboxNetworkOptions';
  denyEgress?: Maybe<Scalars['Boolean']['output']>;
  denyIngress?: Maybe<Scalars['Boolean']['output']>;
  egress: Array<SandboxEgressRule>;
  ingress: Array<SandboxIngressRule>;
};

export type SandboxObservedStatus = {
  __typename: 'SandboxObservedStatus';
  attachedVolumeIds: Array<Scalars['String']['output']>;
  containerStatuses: Array<SandboxContainerStatus>;
  createTime?: Maybe<Scalars['DateTime']['output']>;
  effectiveEgress: Array<SandboxEgressRule>;
  effectiveIngress: Array<SandboxIngressRule>;
  effectiveMaxLifetimeSeconds: Scalars['Int']['output'];
  effectiveResourceRequirements?: Maybe<SandboxResourceRequirements>;
  effectiveResources?: Maybe<SandboxResources>;
  effectiveRuntimeClass: Scalars['String']['output'];
  endTime?: Maybe<Scalars['DateTime']['output']>;
  exitCode?: Maybe<Scalars['Int']['output']>;
  resourceUsage?: Maybe<SandboxV1ResourceUsage>;
  runnerGroupId: Scalars['String']['output'];
  runnerId: Scalars['String']['output'];
  services: Array<SandboxServiceStatus>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  state: SandboxState;
  stateReason: Scalars['String']['output'];
};

export type SandboxPortRangeV1 = {
  __typename: 'SandboxPortRangeV1';
  endPort: Scalars['Int']['output'];
  port: Scalars['Int']['output'];
  protocol: Scalars['String']['output'];
};

export type SandboxRbacResource = {
  __typename: 'SandboxRbacResource';
  id: Scalars['ID']['output'];
};

export type SandboxReadPermissionPayload = {
  __typename: 'SandboxReadPermissionPayload';
  id: Scalars['ID']['output'];
};

export type SandboxResourceRequirements = {
  __typename: 'SandboxResourceRequirements';
  limits?: Maybe<SandboxResources>;
  requests?: Maybe<SandboxResources>;
};

export type SandboxResources = {
  __typename: 'SandboxResources';
  cpu: Scalars['String']['output'];
  gpu?: Maybe<SandboxGpu>;
  memory: Scalars['String']['output'];
};

export type SandboxSelectorBlock = {
  __typename: 'SandboxSelectorBlock';
  namespaceLabels: Array<SandboxLabel>;
  podLabels: Array<SandboxLabel>;
};

export enum SandboxServiceProtocol {
  ServiceProtocolSctp = 'SERVICE_PROTOCOL_SCTP',
  ServiceProtocolTcp = 'SERVICE_PROTOCOL_TCP',
  ServiceProtocolUdp = 'SERVICE_PROTOCOL_UDP',
  ServiceProtocolUnspecified = 'SERVICE_PROTOCOL_UNSPECIFIED'
}

export type SandboxServiceSpec = {
  __typename: 'SandboxServiceSpec';
  endpoint?: Maybe<SandboxEndpointSpec>;
  name: Scalars['String']['output'];
  port: Scalars['Int']['output'];
  protocol: SandboxServiceProtocol;
  visibility: SandboxServiceVisibility;
};

export type SandboxServiceStatus = {
  __typename: 'SandboxServiceStatus';
  endpoint?: Maybe<SandboxEndpointStatus>;
  name: Scalars['String']['output'];
  port: Scalars['Int']['output'];
  protocol: SandboxServiceProtocol;
  url: Scalars['String']['output'];
  visibility: SandboxServiceVisibility;
};

export enum SandboxServiceVisibility {
  VisibilityCustom = 'VISIBILITY_CUSTOM',
  VisibilityPrivate = 'VISIBILITY_PRIVATE',
  VisibilityPublic = 'VISIBILITY_PUBLIC',
  VisibilityUnspecified = 'VISIBILITY_UNSPECIFIED'
}

export type SandboxSpec = {
  __typename: 'SandboxSpec';
  instanceType: Scalars['String']['output'];
  maxLifetimeSeconds: Scalars['Int']['output'];
  mode: SandboxModeV1;
  network?: Maybe<SandboxNetworkOptions>;
  networkIds: Array<Scalars['String']['output']>;
  primaryContainer: Scalars['String']['output'];
  runnerIds: Array<Scalars['String']['output']>;
  runtimeClass: Scalars['String']['output'];
  services: Array<SandboxServiceSpec>;
  tags: Array<Scalars['String']['output']>;
};

export enum SandboxState {
  StateCompleted = 'STATE_COMPLETED',
  StateCreating = 'STATE_CREATING',
  StateFailed = 'STATE_FAILED',
  StatePaused = 'STATE_PAUSED',
  StatePending = 'STATE_PENDING',
  StateRunning = 'STATE_RUNNING',
  StateTerminated = 'STATE_TERMINATED',
  StateTerminating = 'STATE_TERMINATING',
  StateUnspecified = 'STATE_UNSPECIFIED'
}

export enum SandboxTenantScope {
  TenantScopeSameOrg = 'TENANT_SCOPE_SAME_ORG',
  TenantScopeSameUser = 'TENANT_SCOPE_SAME_USER',
  TenantScopeSandboxNetwork = 'TENANT_SCOPE_SANDBOX_NETWORK',
  TenantScopeUnspecified = 'TENANT_SCOPE_UNSPECIFIED'
}

export enum SandboxTerminationReason {
  IdleTimeout = 'IDLE_TIMEOUT',
  UserRequest = 'USER_REQUEST'
}

export type SandboxV1ResourceUsage = {
  __typename: 'SandboxV1ResourceUsage';
  cpuMillicores: Scalars['Int64']['output'];
  gpuCount: Scalars['Int64']['output'];
  memoryMb: Scalars['Int64']['output'];
};

export type SandboxesEnterpriseSubscription = {
  __typename: 'SandboxesEnterpriseSubscription';
  billingPeriodEnd: Scalars['DateTime']['output'];
  billingPeriodStart: Scalars['DateTime']['output'];
  sandboxesLimit: Scalars['Int64']['output'];
};

export type ScriptableRunCondition = {
  __typename: 'ScriptableRunCondition';
  success: Scalars['Boolean']['output'];
};

export type Secret = {
  __typename: 'Secret';
  createdAt: Scalars['DateTime']['output'];
  entityId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type SectionAwareHistoryKeyPrefixGroup = {
  __typename: 'SectionAwareHistoryKeyPrefixGroup';
  matchedCount: Scalars['Int']['output'];
  metrics: Array<MetricInfo>;
  prefix: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export enum SectionAwareHistoryKeyTypeCategory {
  Charts = 'CHARTS',
  EvalTables = 'EVAL_TABLES',
  EvalTablesLegacy = 'EVAL_TABLES_LEGACY',
  Media = 'MEDIA',
  Tables = 'TABLES'
}

export type SectionAwareHistoryKeyTypeCategoryGroup = {
  __typename: 'SectionAwareHistoryKeyTypeCategoryGroup';
  category: SectionAwareHistoryKeyTypeCategory;
  hasMore: Scalars['Boolean']['output'];
  matchedCount: Scalars['Int']['output'];
  metrics: Array<MetricInfo>;
  totalCount: Scalars['Int']['output'];
};

export type SectionAwareHistoryKeysResults = {
  __typename: 'SectionAwareHistoryKeysResults';
  groups: Array<SectionAwareHistoryKeyPrefixGroup>;
  lastStep: Scalars['Int64']['output'];
  matchedPrefixCount: Scalars['Int']['output'];
  systemMetrics: Array<MetricInfo>;
  totalPrefixCount: Scalars['Int']['output'];
  typeCategorySections: Array<SectionAwareHistoryKeyTypeCategoryGroup>;
};

export type SemanticLegend = {
  __typename: 'SemanticLegend';
  currentMetric: Scalars['String']['output'];
  semanticLegendsByMetric: Array<Maybe<SemanticLegendByMetric>>;
  viewID: Scalars['ID']['output'];
};

export type SemanticLegendByMetric = {
  __typename: 'SemanticLegendByMetric';
  bucketUpperBounds?: Maybe<Array<Scalars['Float']['output']>>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  customColors: Array<CustomColor>;
  excludedRunColor?: Maybe<Scalars['String']['output']>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  metricName?: Maybe<Scalars['String']['output']>;
  yValue?: Maybe<Scalars['String']['output']>;
};

export type ServerFeature = {
  __typename: 'ServerFeature';
  description: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ServerInfo = {
  __typename: 'ServerInfo';
  actionHistoryLimit: Scalars['Int']['output'];
  availableBucketProviders: Array<CloudProvider>;
  availableCloudRegions: Array<CloudRegion>;
  cliVersionInfo: Scalars['JSON']['output'];
  contractStartDate?: Maybe<Scalars['DateTime']['output']>;
  dataRetentionDuration: Scalars['Duration']['output'];
  defaultCloudRegion: CloudRegion;
  deploymentId?: Maybe<Scalars['String']['output']>;
  exposesExplicitRunQueueAckPath: Scalars['Boolean']['output'];
  featureFlagValue?: Maybe<Scalars['Boolean']['output']>;
  features: Array<Maybe<ServerFeature>>;
  frontendHost: Scalars['String']['output'];
  hasLocalLicense: Scalars['Boolean']['output'];
  /** Backlog status for the subscription configured for this deployment. */
  ingestionHealth: IngestionHealth;
  isGoogleIap: Scalars['Boolean']['output'];
  latestLocalVersionInfo?: Maybe<LocalVersionInfo>;
  licenseExpirationUI?: Maybe<LicenseExpirationUi>;
  licenseFlags: Array<Scalars['String']['output']>;
  messageOfTheDay?: Maybe<Scalars['String']['output']>;
  pollingOK: Scalars['Boolean']['output'];
  registeredModelLimitReached: Scalars['Boolean']['output'];
  secureStorageConnectorEnabled: Scalars['Boolean']['output'];
  slackClientID: Scalars['String']['output'];
  streamTableEnabled: Scalars['Boolean']['output'];
  userLimitReached: Scalars['Boolean']['output'];
  viewOnlyUserLimitReached: Scalars['Boolean']['output'];
  weaveLimits?: Maybe<WeaveLimits>;
};


export type ServerInfoActionHistoryLimitArgs = {
  artifactCollectionID?: InputMaybe<Scalars['ID']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
};


export type ServerInfoFeatureFlagValueArgs = {
  key: Scalars['String']['input'];
};


export type ServerInfoRegisteredModelLimitReachedArgs = {
  entityName: Scalars['String']['input'];
};

export type ServiceAccount = {
  __typename: 'ServiceAccount';
  accountType: UserAccountType;
  apiKey?: Maybe<Scalars['String']['output']>;
  apiKeyCount: Scalars['Int']['output'];
  authMethod?: Maybe<ServiceAccountAuthMethod>;
  createdAt: Scalars['DateTime']['output'];
  defaultEntity?: Maybe<Entity>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  teams?: Maybe<EntityConnection>;
};


export type ServiceAccountTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum ServiceAccountAuthMethod {
  ApiKey = 'API_KEY',
  Federated = 'FEDERATED'
}

export type SetDismissedBannerInput = {
  bannerID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type SetDismissedBannerPayload = {
  __typename: 'SetDismissedBannerPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SetSandboxEnvVarsInput = {
  envVars?: InputMaybe<SandboxEnvVarsInput>;
  id: Scalars['ID']['input'];
};

export type SetSandboxEnvVarsPayload = {
  __typename: 'SetSandboxEnvVarsPayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SetTagColorInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  colorIndex?: InputMaybe<Scalars['Int']['input']>;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  tagName: Scalars['String']['input'];
};

export type SetTagColorPayload = {
  __typename: 'SetTagColorPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  tags: Array<RunTag>;
};

export type SlackChannelSubscription = AlertSubscription & {
  __typename: 'SlackChannelSubscription';
  id: Scalars['ID']['output'];
  slackIntegration: SlackIntegration;
};

export type SlackIntegration = Integration & {
  __typename: 'SlackIntegration';
  channelName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  teamName: Scalars['String']['output'];
};

export type SlackNotificationActionArgs = {
  __typename: 'SlackNotificationActionArgs';
  integration?: Maybe<SlackIntegration>;
  severity?: Maybe<AlertSeverity>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleURL?: Maybe<Scalars['String']['output']>;
};

export enum SlurmCommandState {
  Failed = 'FAILED',
  Leased = 'LEASED',
  Pending = 'PENDING',
  Submitted = 'SUBMITTED'
}

export type SlurmCommandStatus = {
  __typename: 'SlurmCommandStatus';
  command: SlurmCommandType;
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  state: SlurmCommandState;
  updatedAt: Scalars['DateTime']['output'];
};

export enum SlurmCommandType {
  Cancel = 'CANCEL',
  Requeue = 'REQUEUE'
}

export type SlurmDaemonHealth = {
  __typename: 'SlurmDaemonHealth';
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  ready: Scalars['Boolean']['output'];
};

export type SlurmInfo = {
  __typename: 'SlurmInfo';
  jobId: Scalars['String']['output'];
  /** Raw slurm metadata as captured from wandb-metadata.json — a JSON-encoded object of string to string (keys like job_name, job_num_nodes, job_partition, etc.). Clients parse and render what they need. */
  metadata?: Maybe<Scalars['JSONString']['output']>;
};

export enum SmoothingType {
  Average = 'average',
  Exponential = 'exponential',
  ExponentialTimeWeighted = 'exponentialTimeWeighted',
  Gaussian = 'gaussian',
  None = 'none'
}

export type StarProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  projectName: Scalars['String']['input'];
};

export type StarProjectPayload = {
  __typename: 'StarProjectPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
};

export type StarRegistryInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  registryName: Scalars['String']['input'];
};

export type StarRegistryPayload = {
  __typename: 'StarRegistryPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  registryProject?: Maybe<Project>;
};

export type StarViewInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type StarViewPayload = {
  __typename: 'StarViewPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  view?: Maybe<View>;
};

export type StargazerConnection = {
  __typename: 'StargazerConnection';
  edges: Array<StargazerEdge>;
  pageInfo: PageInfo;
};

export type StargazerEdge = {
  __typename: 'StargazerEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<User>;
};

export type StartExperimentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type StopExperimentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type StopRegistryModelDeploymentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type StopRegistryModelDeploymentPayload = {
  __typename: 'StopRegistryModelDeploymentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  registryModelDeployment?: Maybe<RegistryModelDeployment>;
};

export type StopRunInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type StopRunPayload = {
  __typename: 'StopRunPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type StoppedRunCondition = {
  __typename: 'StoppedRunCondition';
  minimumRunDuration: Scalars['Duration']['output'];
};

export type StorageBucketInfo = {
  __typename: 'StorageBucketInfo';
  ID: Scalars['ID']['output'];
  awsExternalID?: Maybe<Scalars['String']['output']>;
  azureClientID?: Maybe<Scalars['String']['output']>;
  azureTenantID?: Maybe<Scalars['String']['output']>;
  kmsKeyID?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  provider: CloudProvider;
};

export type StorageBucketInfoInput = {
  awsExternalID?: InputMaybe<Scalars['String']['input']>;
  azureClientID?: InputMaybe<Scalars['String']['input']>;
  azureTenantID?: InputMaybe<Scalars['String']['input']>;
  kmsKeyID?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  provider: CloudProvider;
};

export type StorageTreeNode = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int64']['output'];
};

export enum StorageUnit {
  B = 'B',
  Gb = 'GB',
  Kb = 'KB',
  Mb = 'MB',
  Pb = 'PB',
  Tb = 'TB'
}

export type StripeBillingInfo = {
  __typename: 'StripeBillingInfo';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentPeriodEnd: Scalars['DateTime']['output'];
  currentPeriodStart: Scalars['DateTime']['output'];
  invoiceLink?: Maybe<Scalars['String']['output']>;
  paymentMetadata?: Maybe<PaymentMetadata>;
  paymentMethod?: Maybe<PaymentMethod>;
  status: Scalars['String']['output'];
  stripeSubscriptionId: Scalars['String']['output'];
};

export type StripeInvoice = {
  __typename: 'StripeInvoice';
  created: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  hostedInvoiceURL: Scalars['String']['output'];
  invoicePDF: Scalars['String']['output'];
  number: Scalars['String']['output'];
  status: StripeInvoiceStatus;
  subscription?: Maybe<StripeSubscription>;
  total: Scalars['Int64']['output'];
};

export enum StripeInvoiceStatus {
  Draft = 'DRAFT',
  Open = 'OPEN',
  Paid = 'PAID',
  Uncollectible = 'UNCOLLECTIBLE',
  Void = 'VOID'
}

export type StripePaymentMethod = {
  __typename: 'StripePaymentMethod';
  card: StripePaymentMethodCard;
  isDefault: Scalars['Boolean']['output'];
  isFailed: Scalars['Boolean']['output'];
  stripePaymentMethodID: Scalars['String']['output'];
  type: StripePaymentMethodType;
};

export type StripePaymentMethodCard = {
  __typename: 'StripePaymentMethodCard';
  brand: CardBrand;
  last4: Scalars['String']['output'];
};

export enum StripePaymentMethodType {
  Card = 'CARD'
}

export type StripePrice = {
  __typename: 'StripePrice';
  amount: Scalars['Int64']['output'];
  currency: Scalars['String']['output'];
  interval?: Maybe<Scalars['String']['output']>;
};

export type StripeSubscription = {
  __typename: 'StripeSubscription';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentPeriodEnd: Scalars['DateTime']['output'];
  organizationSubscriptions: Array<OrganizationSubscription>;
  status: Scalars['String']['output'];
};

export type SubmitBenchmarkRunInput = {
  benchmarkEntityName?: InputMaybe<Scalars['String']['input']>;
  benchmarkName?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isCodeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubmitBenchmarkRunPayload = {
  __typename: 'SubmitBenchmarkRunPayload';
  benchmarkRun: BenchmarkRun;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type SubmitFcNewsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type SubmitFcNewsPayload = {
  __typename: 'SubmitFCNewsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SubmitSlurmCommandInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  command: SlurmCommandType;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
};

export type SubmitSlurmCommandPayload = {
  __typename: 'SubmitSlurmCommandPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Sweep = Node & {
  __typename: 'Sweep';
  agent?: Maybe<Agent>;
  agents: AgentConnection;
  bestLoss?: Maybe<Scalars['Float']['output']>;
  config: Scalars['String']['output'];
  controller?: Maybe<Scalars['JSONString']['output']>;
  controllerRunName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  earlyStopJobRunning: Scalars['Boolean']['output'];
  heartbeatAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  method: Scalars['String']['output'];
  name: Scalars['String']['output'];
  priorRuns: RunConnection;
  project?: Maybe<Project>;
  runCount: Scalars['Int']['output'];
  runCountExpected?: Maybe<Scalars['Int']['output']>;
  runTime: Scalars['Float']['output'];
  runs: RunConnection;
  scheduler?: Maybe<Scalars['JSONString']['output']>;
  state: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};


export type SweepAgentArgs = {
  agentName: Scalars['String']['input'];
};


export type SweepPriorRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type SweepRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

export type SweepConnection = {
  __typename: 'SweepConnection';
  edges: Array<SweepEdge>;
  pageInfo: PageInfo;
};

export type SweepEdge = {
  __typename: 'SweepEdge';
  cursor: Scalars['String']['output'];
  node: Sweep;
};

export type Tag = {
  __typename: 'Tag';
  attributes: Scalars['JSONString']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  objects?: Maybe<TaggedObjectConnection>;
  tagCategory?: Maybe<TagCategory>;
  tagCategoryName: Scalars['String']['output'];
};


export type TagObjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  objectType?: InputMaybe<TaggedObjectType>;
};

export type TagCategory = {
  __typename: 'TagCategory';
  group: TagGroup;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tags: TagConnection;
};


export type TagCategoryTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TagConnection = {
  __typename: 'TagConnection';
  edges: Array<TagEdge>;
  pageInfo: PageInfo;
};

export type TagEdge = {
  __typename: 'TagEdge';
  cursor: Scalars['String']['output'];
  node: Tag;
};

export type TagGroup = Entity;

export type TagInput = {
  attributes?: InputMaybe<Scalars['JSONString']['input']>;
  tagCategoryName?: InputMaybe<Scalars['String']['input']>;
  tagName: Scalars['String']['input'];
};

export type TagNameConnection = {
  __typename: 'TagNameConnection';
  edges: Array<TagNameEdge>;
  pageInfo: PageInfo;
};

export type TagNameEdge = {
  __typename: 'TagNameEdge';
  cursor: Scalars['String']['output'];
  node: Scalars['String']['output'];
};

export type TaggedObject = Artifact | ArtifactPortfolio | ArtifactSequence;

export type TaggedObjectConnection = {
  __typename: 'TaggedObjectConnection';
  edges: Array<TaggedObjectEdge>;
  pageInfo: PageInfo;
};

export type TaggedObjectEdge = {
  __typename: 'TaggedObjectEdge';
  cursor: Scalars['String']['output'];
  node: TaggedObject;
};

export enum TaggedObjectType {
  Artifact = 'ARTIFACT',
  ArtifactCollection = 'ARTIFACT_COLLECTION'
}

export type Task = {
  __typename: 'Task';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  progress: Scalars['Int']['output'];
  result?: Maybe<Scalars['String']['output']>;
  state: TaskState;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum TaskState {
  Failed = 'FAILED',
  Finished = 'FINISHED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export type TeamSummary = {
  __typename: 'TeamSummary';
  id: Scalars['ID']['output'];
  memberCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
};

export type TemplateVariable = {
  __typename: 'TemplateVariable';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  schema: Scalars['JSONString']['output'];
};

export type TerminateSandboxInput = {
  reason: SandboxTerminationReason;
  sandboxId: Scalars['ID']['input'];
};

export type TerminateSandboxPayload = {
  __typename: 'TerminateSandboxPayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TestGenericWebhookIntegrationInput = {
  accessTokenRef?: InputMaybe<Scalars['String']['input']>;
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  requestPayload?: InputMaybe<Scalars['JSONString']['input']>;
  secretRef?: InputMaybe<Scalars['String']['input']>;
  urlEndpoint: Scalars['String']['input'];
};

export type TestGenericWebhookIntegrationPayload = {
  __typename: 'TestGenericWebhookIntegrationPayload';
  clientMutationID?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  response: Scalars['JSONString']['output'];
};

export type TestReferenceBucketConnectionInput = {
  bucket: StorageBucketInfoInput;
  objectKey: Scalars['String']['input'];
};

export type Thumbnail = {
  __typename: 'Thumbnail';
  directUrl: Scalars['String']['output'];
  originalImageHeight: Scalars['Int']['output'];
  originalImageWidth: Scalars['Int']['output'];
  size: Scalars['Int64']['output'];
};

export type TimeWindow = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type TrainingCostUsageAggregation = UsageAggregationInterface & {
  __typename: 'TrainingCostUsageAggregation';
  end: Scalars['DateTime']['output'];
  entityName: Scalars['String']['output'];
  gpuDurationMs: Scalars['Int64']['output'];
  gpuModelID: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
  value: Scalars['Int64']['output'];
};

export enum TraversalDirection {
  Downstream = 'DOWNSTREAM',
  Upstream = 'UPSTREAM'
}

export type Trigger = {
  __typename: 'Trigger';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Timestamp of the most recent attempt, if any, to execute this automation. */
  lastExecutedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  /**
   * If true, the viewer cannot edit this automation. Note that even if false, the viewer
   * may not be able to edit the triggered action if its permissions are more restrictive.
   */
  readOnly: Scalars['Boolean']['output'];
  scope: TriggerScope;
  triggerExecutions: TriggerExecutionConnection;
  triggeredAction: TriggeredAction;
  triggeringCondition: TriggeringCondition;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type TriggerTriggerExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

export type TriggerActionDetails = AriaActionArgs | GenericWebhookActionArgs | NoOpActionArgs | PushNotificationActionArgs | QueueJobActionArgs | SlackNotificationActionArgs;

export type TriggerConnection = {
  __typename: 'TriggerConnection';
  edges: Array<TriggerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TriggerEdge = {
  __typename: 'TriggerEdge';
  cursor: Scalars['String']['output'];
  node: Trigger;
};

export type TriggerEventDetails = ArtifactAliasEventDetails | ArtifactEventDetails | ArtifactTagEventDetails | CollectionTagEventDetails | RunMetricEventDetails | RunStateEventDetails | WeaveMetricThresholdEventDetails;

/** Event data for external trigger execution. Exactly one field must be set. */
export type TriggerEventInput =
  { addArtifactAlias: AddArtifactAliasEventInput; addArtifactTag?: never; addCollectionTag?: never; createArtifact?: never; linkArtifact?: never; removeArtifactTag?: never; removeCollectionTag?: never; unlinkArtifact?: never; weaveMetricThreshold?: never; }
  |  { addArtifactAlias?: never; addArtifactTag: AddArtifactTagEventInput; addCollectionTag?: never; createArtifact?: never; linkArtifact?: never; removeArtifactTag?: never; removeCollectionTag?: never; unlinkArtifact?: never; weaveMetricThreshold?: never; }
  |  { addArtifactAlias?: never; addArtifactTag?: never; addCollectionTag: AddCollectionTagEventInput; createArtifact?: never; linkArtifact?: never; removeArtifactTag?: never; removeCollectionTag?: never; unlinkArtifact?: never; weaveMetricThreshold?: never; }
  |  { addArtifactAlias?: never; addArtifactTag?: never; addCollectionTag?: never; createArtifact: CreateArtifactEventInput; linkArtifact?: never; removeArtifactTag?: never; removeCollectionTag?: never; unlinkArtifact?: never; weaveMetricThreshold?: never; }
  |  { addArtifactAlias?: never; addArtifactTag?: never; addCollectionTag?: never; createArtifact?: never; linkArtifact: LinkArtifactEventInput; removeArtifactTag?: never; removeCollectionTag?: never; unlinkArtifact?: never; weaveMetricThreshold?: never; }
  |  { addArtifactAlias?: never; addArtifactTag?: never; addCollectionTag?: never; createArtifact?: never; linkArtifact?: never; removeArtifactTag: RemoveArtifactTagEventInput; removeCollectionTag?: never; unlinkArtifact?: never; weaveMetricThreshold?: never; }
  |  { addArtifactAlias?: never; addArtifactTag?: never; addCollectionTag?: never; createArtifact?: never; linkArtifact?: never; removeArtifactTag?: never; removeCollectionTag: RemoveCollectionTagEventInput; unlinkArtifact?: never; weaveMetricThreshold?: never; }
  |  { addArtifactAlias?: never; addArtifactTag?: never; addCollectionTag?: never; createArtifact?: never; linkArtifact?: never; removeArtifactTag?: never; removeCollectionTag?: never; unlinkArtifact: UnlinkArtifactEventInput; weaveMetricThreshold?: never; }
  |  { addArtifactAlias?: never; addArtifactTag?: never; addCollectionTag?: never; createArtifact?: never; linkArtifact?: never; removeArtifactTag?: never; removeCollectionTag?: never; unlinkArtifact?: never; weaveMetricThreshold: WeaveMetricThresholdEventInput; };

export type TriggerEventsExportInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  runId: Scalars['ID']['input'];
};

export type TriggerEventsExportPayload = {
  __typename: 'TriggerEventsExportPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  task: Task;
};

/** A single recorded execution of an automation. */
export type TriggerExecution = {
  __typename: 'TriggerExecution';
  action?: Maybe<TriggerExecutionAction>;
  actionDuration?: Maybe<Scalars['Duration']['output']>;
  actionStartedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  event?: Maybe<TriggerExecutionEvent>;
  id: Scalars['ID']['output'];
  result?: Maybe<TriggerExecutionResult>;
  scope?: Maybe<TriggerScope>;
  state: TriggerExecutionState;
  triggerID?: Maybe<Scalars['ID']['output']>;
  triggerName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TriggerExecutionAction = {
  __typename: 'TriggerExecutionAction';
  actionType: TriggeredActionType;
  data?: Maybe<TriggerActionDetails>;
};

export type TriggerExecutionConnection = {
  __typename: 'TriggerExecutionConnection';
  edges: Array<TriggerExecutionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int64']['output'];
};

export type TriggerExecutionEdge = {
  __typename: 'TriggerExecutionEdge';
  cursor: Scalars['String']['output'];
  node: TriggerExecution;
};

/** An error that occurred while executing an automation. */
export type TriggerExecutionError = Error & {
  __typename: 'TriggerExecutionError';
  message: Scalars['String']['output'];
};

export type TriggerExecutionEvent = {
  __typename: 'TriggerExecutionEvent';
  data?: Maybe<TriggerEventDetails>;
  eventType: EventTriggeringConditionType;
};

export type TriggerExecutionResult = {
  __typename: 'TriggerExecutionResult';
  data?: Maybe<TriggerResultDetails>;
  resultType: TriggerResultType;
};

export enum TriggerExecutionState {
  Failed = 'FAILED',
  Finished = 'FINISHED',
  Pending = 'PENDING',
  Skipped = 'SKIPPED'
}

export type TriggerFlatRunsMigratorInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
};

export type TriggerFlatRunsMigratorPayload = {
  __typename: 'TriggerFlatRunsMigratorPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  glueTaskName?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TriggerParquetExportInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  runId: Scalars['ID']['input'];
};

export type TriggerParquetExportPayload = {
  __typename: 'TriggerParquetExportPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  task: Task;
};

export type TriggerRecomputeKeysInfoInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  runId: Scalars['ID']['input'];
};

export type TriggerRecomputeKeysInfoPayload = {
  __typename: 'TriggerRecomputeKeysInfoPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  task: Task;
};

export type TriggerRecomputeSystemMetricsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  runId: Scalars['ID']['input'];
};

export type TriggerRecomputeSystemMetricsPayload = {
  __typename: 'TriggerRecomputeSystemMetricsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  task: Task;
};

export type TriggerResultDetails = DefaultTriggerResultDetails | HttpTriggerResultDetails | PushNotificationTriggerResultDetails | QueuedJobTriggerResultDetails;

export enum TriggerResultType {
  Default = 'DEFAULT',
  HttpResponse = 'HTTP_RESPONSE',
  PushNotification = 'PUSH_NOTIFICATION',
  QueueJob = 'QUEUE_JOB'
}

export type TriggerScope = ArtifactPortfolio | ArtifactSequence | Entity | Project;

export enum TriggerScopeType {
  ArtifactCollection = 'ARTIFACT_COLLECTION',
  Entity = 'ENTITY',
  Project = 'PROJECT'
}

/** A template variable that can be used in automation action payloads. */
export type TriggerTemplateVariable = {
  __typename: 'TriggerTemplateVariable';
  /** User-facing help text explaining what this variable resolves to. */
  description: Scalars['String']['output'];
  /** A user-facing representation of the variable syntax, e.g. `${artifact_version}` or `${artifact_metadata.KEY}` */
  name: Scalars['String']['output'];
};

export type TriggeredAction = AriaTriggeredAction | GenericWebhookTriggeredAction | NoOpTriggeredAction | NotificationTriggeredAction | PushNotificationTriggeredAction | QueueJobTriggeredAction;

export type TriggeredActionConfig =
  { ariaActionInput: AriaActionInput; genericWebhookActionInput?: never; noOpActionInput?: never; notificationActionInput?: never; pushNotificationActionInput?: never; queueJobActionInput?: never; }
  |  { ariaActionInput?: never; genericWebhookActionInput: GenericWebhookActionInput; noOpActionInput?: never; notificationActionInput?: never; pushNotificationActionInput?: never; queueJobActionInput?: never; }
  |  { ariaActionInput?: never; genericWebhookActionInput?: never; noOpActionInput: NoOpTriggeredActionInput; notificationActionInput?: never; pushNotificationActionInput?: never; queueJobActionInput?: never; }
  |  { ariaActionInput?: never; genericWebhookActionInput?: never; noOpActionInput?: never; notificationActionInput: NotificationActionInput; pushNotificationActionInput?: never; queueJobActionInput?: never; }
  |  { ariaActionInput?: never; genericWebhookActionInput?: never; noOpActionInput?: never; notificationActionInput?: never; pushNotificationActionInput: PushNotificationActionInput; queueJobActionInput?: never; }
  |  { ariaActionInput?: never; genericWebhookActionInput?: never; noOpActionInput?: never; notificationActionInput?: never; pushNotificationActionInput?: never; queueJobActionInput: QueueJobActionInput; };

export enum TriggeredActionType {
  Aria = 'ARIA',
  GenericWebhook = 'GENERIC_WEBHOOK',
  Notification = 'NOTIFICATION',
  NoOp = 'NO_OP',
  PushNotification = 'PUSH_NOTIFICATION',
  QueueJob = 'QUEUE_JOB'
}

export type TriggeringCondition = FilterEventTriggeringCondition;

export type UndeleteProjectByIdInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectID: Scalars['ID']['input'];
};

export type UndeleteProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};

export type UndeleteProjectPayload = {
  __typename: 'UndeleteProjectPayload';
  artifactCollectionsRestored: Scalars['Int']['output'];
  clientMutationId?: Maybe<Scalars['String']['output']>;
  nameRestored: Scalars['Boolean']['output'];
  project?: Maybe<Project>;
  runsRestored: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type UndeleteRunsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  projectName: Scalars['String']['input'];
};

export type UndeleteRunsPayload = {
  __typename: 'UndeleteRunsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UndeleteUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UndeleteUserPayload = {
  __typename: 'UndeleteUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Event details for unlinking an artifact. */
export type UnlinkArtifactEventInput = {
  /** The ID of the artifact version that was unlinked */
  artifactId: Scalars['ID']['input'];
  /** The ID of the (portfolio) collection it was unlinked from */
  collectionId: Scalars['ID']['input'];
};

export type UnlinkArtifactInput = {
  artifactID: Scalars['ID']['input'];
  artifactPortfolioID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type UnlinkArtifactPayload = {
  __typename: 'UnlinkArtifactPayload';
  artifactID: Scalars['ID']['output'];
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  /** Version index of the artifact within the portfolio at the time it was unlinked. */
  versionIndex?: Maybe<Scalars['Int']['output']>;
};

export type UnlinkNvidiaAccountInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type UnlinkNvidiaAccountPayload = {
  __typename: 'UnlinkNvidiaAccountPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Input payload for unregistering a device for push notifications. */
export type UnregisterUserDeviceInput = {
  /** The device platform. */
  platform: DevicePlatform;
  /** The device token to unregister. */
  token: Scalars['String']['input'];
};

/** Response payload from unregistering a device for push notifications. */
export type UnregisterUserDevicePayload = {
  __typename: 'UnregisterUserDevicePayload';
  /** Whether the device was successfully unregistered. */
  success: Scalars['Boolean']['output'];
};

export type UnstarProjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  projectName: Scalars['String']['input'];
};

export type UnstarProjectPayload = {
  __typename: 'UnstarProjectPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
};

export type UnstarRegistryInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  registryName: Scalars['String']['input'];
};

export type UnstarRegistryPayload = {
  __typename: 'UnstarRegistryPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  registryProject?: Maybe<Project>;
};

export type UnstarViewInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UnstarViewPayload = {
  __typename: 'UnstarViewPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  view?: Maybe<View>;
};

export type UpdateAccessTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  previewURL?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAccessTokenPayload = {
  __typename: 'UpdateAccessTokenPayload';
  accessToken: AccessToken;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  recipientAlreadyOnTeam?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
  toNewUser?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateAccessTokenProjectsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projects: Array<ProjectSpecifier>;
  token: Scalars['String']['input'];
};

export type UpdateAccessTokenProjectsPayload = {
  __typename: 'UpdateAccessTokenProjectsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateAlertPayload = {
  __typename: 'UpdateAlertPayload';
  alert: Alert;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateAlertThresholdInput = {
  alertThresholdID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  organizationID: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAlertThresholdPayload = {
  __typename: 'UpdateAlertThresholdPayload';
  alertThreshold?: Maybe<AlertThreshold>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateApiKeyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type UpdateApiKeyPayload = {
  __typename: 'UpdateApiKeyPayload';
  apiKey?: Maybe<ApiKey>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateArtifactAction = ArtifactAction & {
  __typename: 'UpdateArtifactAction';
  artifact: Artifact;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  initiator: Initiator;
  newAliases?: Maybe<Array<ArtifactAlias>>;
  newDescription?: Maybe<Scalars['String']['output']>;
  newMetadata?: Maybe<Scalars['JSONString']['output']>;
  /** @deprecated Field no longer supported */
  newTags?: Maybe<Scalars['JSONString']['output']>;
  oldAliases?: Maybe<Array<ArtifactAlias>>;
  oldDescription?: Maybe<Scalars['String']['output']>;
  oldMetadata?: Maybe<Scalars['JSONString']['output']>;
  /** @deprecated Field no longer supported */
  oldTags?: Maybe<Scalars['JSONString']['output']>;
};

export type UpdateArtifactCollectionPayload = {
  __typename: 'UpdateArtifactCollectionPayload';
  artifactCollection: ArtifactCollection;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateArtifactEntityTtlInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  ttlDurationSeconds: Scalars['Int64']['input'];
};

export type UpdateArtifactEntityTtlPayload = {
  __typename: 'UpdateArtifactEntityTTLPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateArtifactInput = {
  aliases?: InputMaybe<Array<ArtifactAliasInput>>;
  artifactID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Field no longer supported */
  labels?: InputMaybe<Scalars['JSONString']['input']>;
  metadata?: InputMaybe<Scalars['JSONString']['input']>;
  tagsToAdd?: InputMaybe<Array<TagInput>>;
  tagsToDelete?: InputMaybe<Array<TagInput>>;
  ttlDurationSeconds?: InputMaybe<Scalars['Int64']['input']>;
};

export type UpdateArtifactManifestInput = {
  artifactManifestID: Scalars['ID']['input'];
  baseArtifactID?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  digest?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateArtifactManifestPayload = {
  __typename: 'UpdateArtifactManifestPayload';
  artifactManifest: ArtifactManifest;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateArtifactPayload = {
  __typename: 'UpdateArtifactPayload';
  artifact: Artifact;
  /** @deprecated Field no longer supported */
  artifactActions: Array<ArtifactAction>;
  artifactMembership?: Maybe<ArtifactCollectionMembership>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateArtifactPortfolioInput = {
  artifactPortfolioID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateArtifactSequenceInput = {
  artifactSequenceID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateArtifactTypeInput = {
  artifactTypeID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateArtifactTypePayload = {
  __typename: 'UpdateArtifactTypePayload';
  artifactType: ArtifactType;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateBenchmarkRunInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['JSONString']['input']>;
  id: Scalars['ID']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBenchmarkRunPayload = {
  __typename: 'UpdateBenchmarkRunPayload';
  benchmarkRun: BenchmarkRun;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCustomChartInput = {
  access?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entity: Scalars['String']['input'];
  name: Scalars['String']['input'];
  spec?: InputMaybe<Scalars['JSONString']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomChartPayload = {
  __typename: 'UpdateCustomChartPayload';
  chart: CustomChart;
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateCustomerDefaultPaymentMethodInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
};

export type UpdateCustomerDefaultPaymentMethodPayload = {
  __typename: 'UpdateCustomerDefaultPaymentMethodPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateCustomerPaymentMethodInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
};

export type UpdateCustomerPaymentMethodPayload = {
  __typename: 'UpdateCustomerPaymentMethodPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateDefaultResourceConfigInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  config: Scalars['JSONString']['input'];
  defaultResourceConfigID: Scalars['ID']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  templateVariables?: InputMaybe<Scalars['JSONString']['input']>;
};

export type UpdateDefaultResourceConfigPayload = {
  __typename: 'UpdateDefaultResourceConfigPayload';
  defaultResourceConfigID: Scalars['ID']['output'];
  schemaValidationErrors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type UpdateDiscussionCommentInput = {
  body: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discussionCommentID: Scalars['ID']['input'];
  inlineCommentDetails?: InputMaybe<Scalars['JSONString']['input']>;
  viewID?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateDiscussionCommentPayload = {
  __typename: 'UpdateDiscussionCommentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discussionComment: DiscussionComment;
};

export type UpdateDiscussionThreadInput = {
  body: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discussionThreadID: Scalars['ID']['input'];
};

export type UpdateDiscussionThreadPayload = {
  __typename: 'UpdateDiscussionThreadPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discussionThread: DiscussionThread;
};

export type UpdateEntityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  codeSavingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  defaultAccess?: InputMaybe<Scalars['String']['input']>;
  entity: Scalars['String']['input'];
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  privateOnly?: InputMaybe<Scalars['Boolean']['input']>;
  rateLimits?: InputMaybe<RateLimitsInput>;
  settings?: InputMaybe<EntitySettingsInput>;
};

export type UpdateEntityPayload = {
  __typename: 'UpdateEntityPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Entity>;
};

export type UpdateExperimentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enrollmentPeriod: Scalars['Int']['input'];
  experimentType: ExperimentType;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['JSONString']['input']>;
  name: Scalars['String']['input'];
  observationalUnit: ObservationalUnit;
  sampleSize: Scalars['Int']['input'];
  variants: Array<VariantInput>;
};

export type UpdateExperimentPayload = {
  __typename: 'UpdateExperimentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateFilterTriggerInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventFilter?: InputMaybe<Scalars['JSONString']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  scopeID?: InputMaybe<Scalars['ID']['input']>;
  scopeType?: InputMaybe<TriggerScopeType>;
  triggeredActionConfig?: InputMaybe<TriggeredActionConfig>;
  triggeredActionType?: InputMaybe<TriggeredActionType>;
  triggeringEventType?: InputMaybe<EventTriggeringConditionType>;
};

export type UpdateFilterTriggerPayload = {
  __typename: 'UpdateFilterTriggerPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  trigger?: Maybe<Trigger>;
};

export type UpdateGenericWebhookIntegrationInput = {
  accessTokenRef?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  secretRef?: InputMaybe<Scalars['String']['input']>;
  urlEndpoint?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGlueTaskInput = {
  arguments?: InputMaybe<Scalars['JSONString']['input']>;
  checkpoint?: InputMaybe<Scalars['JSONString']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  strategyMetadata?: InputMaybe<Scalars['String']['input']>;
  strategyType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGlueTaskPayload = {
  __typename: 'UpdateGlueTaskPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateLaunchAgentInput = {
  agentStatus?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  heartbeatAt?: InputMaybe<Scalars['DateTime']['input']>;
  launchAgentId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  runQueues?: InputMaybe<Array<Scalars['ID']['input']>>;
  stopPolling?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateLaunchAgentPayload = {
  __typename: 'UpdateLaunchAgentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLocalLicenseInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLocalLicensePayload = {
  __typename: 'UpdateLocalLicensePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  localLicense: LocalLicense;
};

export type UpdateMemberInput = {
  /** @deprecated Use `role` instead */
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['ID']['input'];
};

export type UpdateMemberPayload = {
  __typename: 'UpdateMemberPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  member: Member;
};

export type UpdateModelsSeatInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modelsSeat: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type UpdateModelsSeatPayload = {
  __typename: 'UpdateModelsSeatPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateOAuthProviderInput = {
  accessTokenLifespanSeconds?: InputMaybe<Scalars['Int']['input']>;
  allowJwtReplay?: InputMaybe<Scalars['Boolean']['input']>;
  providerId: Scalars['ID']['input'];
  refreshEnabled: Scalars['Boolean']['input'];
  refreshFamilyLifespanSeconds?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateOAuthProviderPayload = {
  __typename: 'UpdateOAuthProviderPayload';
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationBillingUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newBillingUser: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type UpdateOrganizationBillingUserPayload = {
  __typename: 'UpdateOrganizationBillingUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['JSONString']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationID: Scalars['ID']['input'];
};

export type UpdateOrganizationPayload = {
  __typename: 'UpdateOrganizationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationPrivacySettingsInput = {
  allowModelTrainingOnSharedData?: InputMaybe<Scalars['Boolean']['input']>;
  ariaProjectMemoryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  cliSessionLifespanHours?: InputMaybe<Scalars['Int']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  codeSavingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  disableApiKeyCreation?: InputMaybe<Scalars['Boolean']['input']>;
  disableMagicLinkSharing?: InputMaybe<Scalars['Boolean']['input']>;
  enableLLMPoweredFeatures?: InputMaybe<Scalars['Boolean']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  onlyAdminsCanInvite?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  privateOnly?: InputMaybe<Scalars['Boolean']['input']>;
  requireOrgScopedAPIKeys?: InputMaybe<Scalars['Boolean']['input']>;
  restrictInvitesToClaimedDomain?: InputMaybe<Scalars['Boolean']['input']>;
  restrictMatchingOrgEmailDomainUsers?: InputMaybe<Scalars['Boolean']['input']>;
  shareAITracesWithWB?: InputMaybe<Scalars['Boolean']['input']>;
  weaveSensitiveDataPolicy?: InputMaybe<WeaveSensitiveDataPolicy>;
};

export type UpdateOrganizationPrivacySettingsPayload = {
  __typename: 'UpdateOrganizationPrivacySettingsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationRemoteScoringSettingsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  remoteScoringAllowedHosts: Array<RemoteScoringAllowedHostInput>;
  remoteScoringEnabled: Scalars['Boolean']['input'];
};

export type UpdateOrganizationRemoteScoringSettingsPayload = {
  __typename: 'UpdateOrganizationRemoteScoringSettingsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  couponID?: InputMaybe<Scalars['String']['input']>;
  createStripeSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  organizationSubscriptionID: Scalars['ID']['input'];
  planID?: InputMaybe<Scalars['ID']['input']>;
  privileges?: InputMaybe<Scalars['JSONString']['input']>;
  seats?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<OrganizationSubscriptionStatus>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OrganizationSubscriptionType>;
};

export type UpdateOrganizationSubscriptionPayload = {
  __typename: 'UpdateOrganizationSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationSubscriptionSeatsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationID: Scalars['ID']['input'];
  seats: Scalars['Int']['input'];
};

export type UpdateOrganizationSubscriptionSeatsPayload = {
  __typename: 'UpdateOrganizationSubscriptionSeatsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  userName: Scalars['String']['input'];
  userOrgRole: Scalars['String']['input'];
};

export type UpdateOrganizationUserPayload = {
  __typename: 'UpdateOrganizationUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateOrganizationUserV2Input = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  userName: Scalars['String']['input'];
  userOrgRole: Scalars['String']['input'];
};

export type UpdateOrganizationUserV2Payload = {
  __typename: 'UpdateOrganizationUserV2Payload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateProjectLastActiveInput = {
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
};

export type UpdateProjectLastActivePayload = {
  __typename: 'UpdateProjectLastActivePayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateProjectMemberInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  userProjectRole: Scalars['String']['input'];
};

export type UpdateProjectMemberPayload = {
  __typename: 'UpdateProjectMemberPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateProjectTeamMemberInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  teamProjectRole: Scalars['String']['input'];
};

export type UpdateProjectTeamMemberPayload = {
  __typename: 'UpdateProjectTeamMemberPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateRampThresholdInput = {
  checkId: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  setting: Scalars['String']['input'];
  store: Scalars['String']['input'];
  threshold: Scalars['Float']['input'];
};

export type UpdateRampThresholdPayload = {
  __typename: 'UpdateRampThresholdPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  inheritedFrom?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roleID: Scalars['ID']['input'];
};

export type UpdateRolePayload = {
  __typename: 'UpdateRolePayload';
  success: Scalars['Boolean']['output'];
};

export type UpdateRunQueueInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultResourceConfigID?: InputMaybe<Scalars['ID']['input']>;
  externalLinks?: InputMaybe<Scalars['JSONString']['input']>;
  prioritizationMode?: InputMaybe<RunQueuePrioritizationMode>;
  queueID: Scalars['ID']['input'];
};

export type UpdateRunQueueItemWarningInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  filePaths?: InputMaybe<Array<Scalars['String']['input']>>;
  message: Scalars['String']['input'];
  runQueueItemId: Scalars['ID']['input'];
  stage: Scalars['String']['input'];
};

export type UpdateRunQueueItemWarningPayload = {
  __typename: 'UpdateRunQueueItemWarningPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateRunQueuePayload = {
  __typename: 'UpdateRunQueuePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  queueID?: Maybe<Scalars['ID']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateRunStateInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  state: Scalars['String']['input'];
};

export type UpdateRunStatePayload = {
  __typename: 'UpdateRunStatePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  run?: Maybe<Run>;
  success: Scalars['Boolean']['output'];
};

export type UpdateSemanticLegendInput = {
  bucketUpperBounds?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currentMetric?: InputMaybe<Scalars['String']['input']>;
  customColors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludedRunColor?: InputMaybe<Scalars['String']['input']>;
  metricName?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  viewID?: InputMaybe<Scalars['ID']['input']>;
  yValue?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSemanticLegendPayload = {
  __typename: 'UpdateSemanticLegendPayload';
  success: Scalars['Boolean']['output'];
  view?: Maybe<View>;
};

export type UpdateServiceAccountApiKeyInput = {
  apiKeyId: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  serviceAccountId: Scalars['ID']['input'];
};

export type UpdateServiceAccountApiKeyPayload = {
  __typename: 'UpdateServiceAccountApiKeyPayload';
  apiKey?: Maybe<ApiKey>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateSlurmDaemonHeartbeatInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clusterName: Scalars['String']['input'];
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSONString']['input']>;
  ready: Scalars['Boolean']['input'];
};

export type UpdateSlurmDaemonHeartbeatPayload = {
  __typename: 'UpdateSlurmDaemonHeartbeatPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateStoppedRunAlertInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  minimumRunDuration?: InputMaybe<Scalars['Duration']['input']>;
};

export type UpdateSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  gpuEnabled?: InputMaybe<Scalars['DateTime']['input']>;
  hubPreset?: InputMaybe<Scalars['String']['input']>;
  hubSettings?: InputMaybe<HubSettingsInput>;
  privateProjects?: InputMaybe<Scalars['Boolean']['input']>;
  teamsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSubscriptionPayload = {
  __typename: 'UpdateSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Entity>;
};

export type UpdateTagCategoryInput = {
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  newTagCategoryName?: InputMaybe<Scalars['String']['input']>;
  oldTagCategoryName: Scalars['String']['input'];
};

export type UpdateTagCategoryPayload = {
  __typename: 'UpdateTagCategoryPayload';
  clientMutationID?: Maybe<Scalars['String']['output']>;
  tagCategory: TagCategory;
};

export type UpdateTagInput = {
  attributes?: InputMaybe<Scalars['JSONString']['input']>;
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  newTagName?: InputMaybe<Scalars['String']['input']>;
  oldTagName: Scalars['String']['input'];
  tagCategoryName: Scalars['String']['input'];
};

export type UpdateTagPayload = {
  __typename: 'UpdateTagPayload';
  clientMutationID?: Maybe<Scalars['String']['output']>;
  tag: Tag;
};

export type UpdateTeamStorageBucketInput = {
  bucket: StorageBucketInfoInput;
  clientMutationID?: InputMaybe<Scalars['String']['input']>;
  entityID: Scalars['ID']['input'];
};

export type UpdateTeamStorageBucketPayload = {
  __typename: 'UpdateTeamStorageBucketPayload';
  bucketStoreID: Scalars['ID']['output'];
  clientMutationID?: Maybe<Scalars['String']['output']>;
  entity: Entity;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserEmailInput = {
  id: Scalars['ID']['input'];
  type?: InputMaybe<EmailType>;
};

export type UpdateUserEmailPayload = {
  __typename: 'UpdateUserEmailPayload';
  email?: Maybe<Email>;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserInput = {
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  defaultEntity?: InputMaybe<Scalars['String']['input']>;
  defaultFramework?: InputMaybe<Scalars['String']['input']>;
  galleryVisited?: InputMaybe<Scalars['Boolean']['input']>;
  hideTeamsFromPublic?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardingHidden?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  settingsVisited?: InputMaybe<Scalars['Boolean']['input']>;
  userInfo?: InputMaybe<Scalars['JSONString']['input']>;
};

export type UpdateUserLevelAlertPreferencesInput = {
  alerts?: InputMaybe<UserLevelAlertsInput>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  slackIntegrations?: InputMaybe<Array<UserLevelSlackConfigInput>>;
};

export type UpdateUserLevelAlertPreferencesPayload = {
  __typename: 'UpdateUserLevelAlertPreferencesPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type UpdateUserPayload = {
  __typename: 'UpdateUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type UpdateUserRoleInput = {
  accountType: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateUserRolePayload = {
  __typename: 'UpdateUserRolePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type UpdateUserRoleV2Input = {
  accountType: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateUserRoleV2Payload = {
  __typename: 'UpdateUserRoleV2Payload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type UpdateWeaveRoleInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  weaveRole: Scalars['String']['input'];
};

export type UpdateWeaveRolePayload = {
  __typename: 'UpdateWeaveRolePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpgradeCustomerSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationID: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
  planID: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type UpgradeCustomerSubscriptionPayload = {
  __typename: 'UpgradeCustomerSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organizationID: Scalars['ID']['output'];
  subscription?: Maybe<Scalars['JSON']['output']>;
};

export type UpgradeTrialSubscriptionPayload = {
  __typename: 'UpgradeTrialSubscriptionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UploadMultipartUrls = {
  __typename: 'UploadMultipartUrls';
  uploadID: Scalars['String']['output'];
  uploadUrlParts: Array<UploadUrlPart>;
};

export type UploadPanelInput = {
  author: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  panelID: Scalars['String']['input'];
  redirectURL: Scalars['String']['input'];
  title: Scalars['String']['input'];
  viewID: Scalars['ID']['input'];
};

export type UploadPanelPayload = {
  __typename: 'UploadPanelPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  panelImageUploadUrl: Scalars['String']['output'];
  panelLink: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UploadPartsInput = {
  hexMD5: Scalars['String']['input'];
  partNumber: Scalars['Int64']['input'];
};

export type UploadUrlPart = {
  __typename: 'UploadUrlPart';
  partNumber: Scalars['Int64']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type UpsertBucketInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commit?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['JSONString']['input']>;
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  framework?: InputMaybe<Scalars['String']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  jobProgram?: InputMaybe<Scalars['String']['input']>;
  jobRepo?: InputMaybe<Scalars['String']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
  modelName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  runQueueItemId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  summaryMetrics?: InputMaybe<Scalars['JSONString']['input']>;
  sweep?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpsertBucketPayload = {
  __typename: 'UpsertBucketPayload';
  bucket?: Maybe<Run>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  inserted?: Maybe<Scalars['Boolean']['output']>;
  updateAvailable?: Maybe<Scalars['Boolean']['output']>;
};

export type UpsertModelInput = {
  access?: InputMaybe<Scalars['String']['input']>;
  allowAllArtifactTypesInRegistry?: InputMaybe<Scalars['Boolean']['input']>;
  artifactTypes?: InputMaybe<Array<ArtifactTypeInput>>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dockerImage?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  framework?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<ProjectIconInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  isBenchmark?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['ID']['input']>;
  rateLimits?: InputMaybe<RateLimitsInput>;
  repo?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Scalars['JSONString']['input']>;
};

export type UpsertModelPayload = {
  __typename: 'UpsertModelPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  inserted?: Maybe<Scalars['Boolean']['output']>;
  model?: Maybe<Project>;
  project?: Maybe<Project>;
};

export type UpsertRunGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  newName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectName: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpsertRunGroupPayload = {
  __typename: 'UpsertRunGroupPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<RunGroup>;
  inserted?: Maybe<Scalars['Boolean']['output']>;
};

export type UpsertRunQueueInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  externalLinks?: InputMaybe<Scalars['JSONString']['input']>;
  prioritizationMode?: InputMaybe<RunQueuePrioritizationMode>;
  projectName: Scalars['String']['input'];
  queueName: Scalars['String']['input'];
  resourceConfig: Scalars['JSONString']['input'];
  resourceType: Scalars['String']['input'];
  templateVariables?: InputMaybe<Scalars['JSONString']['input']>;
};

export type UpsertRunQueuePayload = {
  __typename: 'UpsertRunQueuePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  configSchemaValidationErrors?: Maybe<Array<Scalars['String']['output']>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpsertSharedViewInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  spec: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type UpsertSharedViewPayload = {
  __typename: 'UpsertSharedViewPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  view?: Maybe<View>;
};

export type UpsertSweepInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['String']['input']>;
  controller?: InputMaybe<Scalars['JSONString']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  launchScheduler?: InputMaybe<Scalars['JSONString']['input']>;
  priorRunsFilters?: InputMaybe<Scalars['JSONString']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  scheduler?: InputMaybe<Scalars['JSONString']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  templateVariableValues?: InputMaybe<Scalars['JSONString']['input']>;
};

export type UpsertSweepPayload = {
  __typename: 'UpsertSweepPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  configValidationWarnings: Array<Scalars['String']['output']>;
  inserted?: Maybe<Scalars['Boolean']['output']>;
  insertedPriorRuns?: Maybe<Scalars['Int']['output']>;
  sweep?: Maybe<Sweep>;
};

export type UpsertTeamSecretInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  secretName: Scalars['String']['input'];
  secretValue?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertTeamSecretPayload = {
  __typename: 'UpsertTeamSecretPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  secret?: Maybe<UpsertedSecret>;
};

export type UpsertUserProfileViewInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  spec?: InputMaybe<Scalars['String']['input']>;
  specIsGzipped?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpsertUserProfileViewPayload = {
  __typename: 'UpsertUserProfileViewPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  inserted?: Maybe<Scalars['Boolean']['output']>;
  view?: Maybe<View>;
};

export type UpsertUserSecretInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  secretName: Scalars['String']['input'];
  secretValue?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertUserSecretPayload = {
  __typename: 'UpsertUserSecretPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  secret?: Maybe<UpsertedSecret>;
};

export type UpsertViewInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverUrl?: InputMaybe<Scalars['String']['input']>;
  createdUsing?: InputMaybe<ViewSource>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overridePublished?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  showcasedAt?: InputMaybe<Scalars['DateTime']['input']>;
  spec?: InputMaybe<Scalars['String']['input']>;
  specIsGzipped?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertViewPayload = {
  __typename: 'UpsertViewPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  inserted?: Maybe<Scalars['Boolean']['output']>;
  view?: Maybe<View>;
};

export type UpsertWorkspaceTemplateInput = {
  entityId: Scalars['ID']['input'];
  /** @deprecated Use linePlotTemplateId or workspaceLayoutTemplateId */
  id?: InputMaybe<Scalars['ID']['input']>;
  linePlotSettings?: InputMaybe<Scalars['JSONString']['input']>;
  linePlotTemplateId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use linePlotSettings or workspaceLayoutSettings */
  settings?: InputMaybe<Scalars['JSONString']['input']>;
  /** @deprecated Use linePlotSettings or workspaceLayoutSettings */
  type?: InputMaybe<WorkspaceTemplateType>;
  workspaceLayoutSettings?: InputMaybe<Scalars['JSONString']['input']>;
  workspaceLayoutTemplateId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertWorkspaceTemplatePayload = {
  __typename: 'UpsertWorkspaceTemplatePayload';
  linePlotTemplateId?: Maybe<Scalars['ID']['output']>;
  workspaceLayoutTemplateId?: Maybe<Scalars['ID']['output']>;
};

export type UpsertedSecret = {
  __typename: 'UpsertedSecret';
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type UsageAggregation = UsageAggregationInterface & {
  __typename: 'UsageAggregation';
  end: Scalars['DateTime']['output'];
  entityName: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
  value: Scalars['Int64']['output'];
};

export type UsageAggregationInterface = {
  end: Scalars['DateTime']['output'];
  entityName: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
  value: Scalars['Int64']['output'];
};

export type UsageByPeriodResponse = {
  __typename: 'UsageByPeriodResponse';
  dailyAverageUsage?: Maybe<Scalars['Int64']['output']>;
  intervals: Array<UsageInterval>;
};

export type UsageInterval = {
  __typename: 'UsageInterval';
  endDate: Scalars['DateTime']['output'];
  entities: Array<EntityUsage>;
  stackTotal?: Maybe<Scalars['Int64']['output']>;
  startDate: Scalars['DateTime']['output'];
};

export enum UsagePeriod {
  CurrentCycle = 'CURRENT_CYCLE',
  Last_12Months = 'LAST_12_MONTHS',
  Last_24Months = 'LAST_24_MONTHS',
  Last_30Days = 'LAST_30_DAYS',
  Last_90Days = 'LAST_90_DAYS'
}

export type UsageStat = {
  __typename: 'UsageStat';
  date?: Maybe<Scalars['DateTime']['output']>;
  stat?: Maybe<Scalars['Float']['output']>;
};

export type UsageStatConnection = {
  __typename: 'UsageStatConnection';
  edges: Array<UsageStatEdge>;
  pageInfo: PageInfo;
};

export type UsageStatEdge = {
  __typename: 'UsageStatEdge';
  cursor: Scalars['String']['output'];
  node: UsageStat;
};

export enum UsageType {
  InferenceCost = 'INFERENCE_COST',
  SandboxesCost = 'SANDBOXES_COST',
  Storage = 'STORAGE',
  TrackedHours = 'TRACKED_HOURS',
  TrainingCost = 'TRAINING_COST',
  TrainingDuration = 'TRAINING_DURATION',
  UserSeats = 'USER_SEATS',
  WbAgentCost = 'WB_AGENT_COST',
  Weave = 'WEAVE'
}

export type UseArtifactAction = ArtifactAction & {
  __typename: 'UseArtifactAction';
  artifact: Artifact;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  initiator: Initiator;
};

export type UseArtifactInput = {
  artifactEntityName?: InputMaybe<Scalars['String']['input']>;
  artifactID: Scalars['ID']['input'];
  artifactProjectName?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  usedAs?: InputMaybe<Scalars['String']['input']>;
};

export type UseArtifactPayload = {
  __typename: 'UseArtifactPayload';
  artifact: Artifact;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  run: Run;
};

export type User = Node & {
  __typename: 'User';
  accountType?: Maybe<UserAccountType>;
  activity?: Maybe<UserActivityDetails>;
  admin?: Maybe<Scalars['Boolean']['output']>;
  analyticsId?: Maybe<Scalars['String']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  apiKeys?: Maybe<ApiKeyConnection>;
  /** @deprecated Field no longer supported */
  authId?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dailyRunCount: Array<Scalars['Int']['output']>;
  defaultEntity?: Maybe<Entity>;
  defaultEntityId?: Maybe<Scalars['Int']['output']>;
  defaultFramework?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  devices: Array<UserDevice>;
  domainClaimBlockingReason?: Maybe<Scalars['String']['output']>;
  dynamicConfig?: Maybe<DynamicConfig>;
  email?: Maybe<Scalars['String']['output']>;
  emails: Array<Email>;
  entity?: Maybe<Scalars['String']['output']>;
  featureFlags: Array<Maybe<FeatureFlag>>;
  flags?: Maybe<Scalars['JSONString']['output']>;
  hasRun: Scalars['Boolean']['output'];
  hideTeamsFromPublic: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  instanceAdminTeamAccessDisabled: Scalars['Boolean']['output'];
  isEmailDomainClaimedAndShouldRedirectToSSO: Scalars['Boolean']['output'];
  isNvidiaAccountLinked: Scalars['Boolean']['output'];
  limits?: Maybe<Scalars['JSON']['output']>;
  loggedInAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated Field no longer supported */
  ndbId?: Maybe<Scalars['ID']['output']>;
  newsletterSubscription?: Maybe<NewsletterSubscription>;
  /**
   * Notebooks authored by this user, restricted to projects the current viewer
   * can read — including when viewing your own notebooks, so authors who lose
   * access to a project no longer see its notebooks here. Supports
   * case-insensitive `search` on notebook name or author name/username and
   * cursor pagination (`first`/`last` with `before`/`after`).
   *
   * Not yet implemented; currently returns an empty connection.
   */
  notebooks: NotebookConnection;
  nvidiaAccountLinkedAt?: Maybe<Scalars['DateTime']['output']>;
  onboardingSteps?: Maybe<Scalars['JSON']['output']>;
  organizations: Array<Organization>;
  personalEntityDisabled: Scalars['Boolean']['output'];
  photoUploadUrl: Scalars['String']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
  private: Scalars['Boolean']['output'];
  profileView?: Maybe<View>;
  projects?: Maybe<ProjectConnection>;
  runs?: Maybe<RunConnection>;
  secrets: Array<UserSecret>;
  signupRequired: Scalars['Boolean']['output'];
  starredProjects?: Maybe<ProjectConnection>;
  starredRegistries?: Maybe<ProjectConnection>;
  starredViews?: Maybe<ViewConnection>;
  teams?: Maybe<EntityConnection>;
  totalRuns: Scalars['Int']['output'];
  /** Automations created by this user. */
  triggers: TriggerConnection;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadHeaders: Array<Scalars['String']['output']>;
  userEntity?: Maybe<Entity>;
  userInfo?: Maybe<Scalars['JSON']['output']>;
  userLevelAlertPreferences?: Maybe<UserLevelAlertPreferences>;
  username?: Maybe<Scalars['String']['output']>;
  views?: Maybe<ViewConnection>;
  wbAgentPersonalSecretGrants: Array<WbAgentPersonalSecretGrant>;
};


export type UserApiKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  keysOnly?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type UserDailyRunCountArgs = {
  limit: Scalars['Int']['input'];
};


export type UserDomainClaimBlockingReasonArgs = {
  orgId: Scalars['ID']['input'];
};


export type UserDynamicConfigArgs = {
  configId: Scalars['String']['input'];
};


export type UserFeatureFlagsArgs = {
  featureKey?: InputMaybe<Scalars['String']['input']>;
  rampIDType: RampIdType;
};


export type UserNotebooksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type UserOrganizationsArgs = {
  emailDomain?: InputMaybe<Scalars['String']['input']>;
};


export type UserProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  restrictTo?: InputMaybe<UserProjectRestriction>;
};


export type UserRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
};


export type UserSecretsArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type UserStarredProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
};


export type UserStarredRegistriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
};


export type UserStarredViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTriggersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type UserViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  displayNameContains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  viewType?: InputMaybe<Scalars['String']['input']>;
};


export type UserWbAgentPersonalSecretGrantsArgs = {
  organizationId: Scalars['ID']['input'];
};

export enum UserAccountType {
  Anonymous = 'ANONYMOUS',
  OrgService = 'ORG_SERVICE',
  Service = 'SERVICE',
  User = 'USER',
  Viewer = 'VIEWER'
}

export type UserActivityDetails = ActivityDuration & {
  __typename: 'UserActivityDetails';
  daysActive: Scalars['Int']['output'];
  endAt: Scalars['DateTime']['output'];
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  numReports: Scalars['Int']['output'];
  numRuns: Scalars['Int']['output'];
  startAt: Scalars['DateTime']['output'];
};

export type UserConnection = {
  __typename: 'UserConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
};

export type UserDevice = {
  __typename: 'UserDevice';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastSeenAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  platform: DevicePlatform;
};

export type UserEdge = {
  __typename: 'UserEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<User>;
};

export type UserLevelAlertPreferences = {
  __typename: 'UserLevelAlertPreferences';
  alerts?: Maybe<UserLevelAlerts>;
  slackIntegrations: Array<UserLevelSlackConfig>;
};

export type UserLevelAlerts = {
  __typename: 'UserLevelAlerts';
  runCrashed?: Maybe<RunCrashedChannelPrefs>;
  runFinished?: Maybe<RunAlertChannelPrefs>;
  scriptableAlert?: Maybe<RunAlertChannelPrefs>;
};

export type UserLevelAlertsInput = {
  runCrashed?: InputMaybe<RunCrashedChannelPrefsInput>;
  runFinished?: InputMaybe<RunAlertChannelPrefsInput>;
  scriptableAlert?: InputMaybe<RunAlertChannelPrefsInput>;
};

export type UserLevelSlackConfig = {
  __typename: 'UserLevelSlackConfig';
  channelName?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  teamName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use id for mutations and displayName for presentation. */
  webhookUrl: Scalars['String']['output'];
};

export type UserLevelSlackConfigInput = {
  channelName?: InputMaybe<Scalars['String']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  webhookUrl: Scalars['String']['input'];
};

export enum UserProjectRestriction {
  Contributed = 'CONTRIBUTED',
  Owned = 'OWNED'
}

export type UserSecret = {
  __typename: 'UserSecret';
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type Variant = {
  __typename: 'Variant';
  allocation: Scalars['Int']['output'];
  bucket: Scalars['Int']['output'];
  description: Scalars['String']['output'];
};

export type VariantInput = {
  allocation: Scalars['Int']['input'];
  bucket: Scalars['Int']['input'];
  description: Scalars['String']['input'];
};

export type VersionedArtifactConnection = ArtifactConnectionType & {
  __typename: 'VersionedArtifactConnection';
  edges: Array<VersionedArtifactEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VersionedArtifactEdge = ArtifactEdgeType & {
  __typename: 'VersionedArtifactEdge';
  cursor: Scalars['String']['output'];
  node: Artifact;
  version: Scalars['String']['output'];
};

export type View = Node & {
  __typename: 'View';
  accessTokens: Array<AccessToken>;
  alertSubscription?: Maybe<AlertSubscription>;
  children?: Maybe<ViewConnection>;
  coverUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdUsing: ViewSource;
  description?: Maybe<Scalars['String']['output']>;
  discussionThreads: DiscussionThreadConnection;
  displayName?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Entity>;
  entityName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUploadUrl: ImageUrl;
  locked: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['Int']['output']>;
  projectName: Scalars['String']['output'];
  semanticLegend: SemanticLegend;
  showcasedAt?: Maybe<Scalars['DateTime']['output']>;
  spec?: Maybe<Scalars['JSONString']['output']>;
  specObject?: Maybe<Scalars['JSON']['output']>;
  starCount: Scalars['Int']['output'];
  stargazers: StargazerConnection;
  starred?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  uploadHeaders: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  viewCount: Scalars['Int']['output'];
};


export type ViewDiscussionThreadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ViewImageUploadUrlArgs = {
  name: Scalars['String']['input'];
};


export type ViewStarCountArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type ViewStargazersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ViewConnection = {
  __typename: 'ViewConnection';
  edges: Array<ViewEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ViewEdge = {
  __typename: 'ViewEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<View>;
};

export enum ViewSource {
  WandbSdk = 'WANDB_SDK',
  WandbUi = 'WANDB_UI',
  WandbUiSharePanel = 'WANDB_UI_SHARE_PANEL',
  WeaveUi = 'WEAVE_UI'
}

export enum ViewType {
  Cumulative = 'CUMULATIVE',
  Historical = 'HISTORICAL'
}

export type ViewViewInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type ViewViewPayload = {
  __typename: 'ViewViewPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type WbAgentPersonalSecretGrant = {
  __typename: 'WBAgentPersonalSecretGrant';
  secret: UserSecret;
};

export type WeaveEnterpriseSubscription = {
  __typename: 'WeaveEnterpriseSubscription';
  billingPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  billingPeriodStart?: Maybe<Scalars['DateTime']['output']>;
  weaveLimit?: Maybe<WeaveLimits>;
};

export enum WeaveIngestionLimitInMb {
  Limit_1500 = 'LIMIT_1500',
  Limit_2000 = 'LIMIT_2000',
  Limit_3500 = 'LIMIT_3500',
  Limit_5000 = 'LIMIT_5000',
  Limit_6500 = 'LIMIT_6500',
  Limit_8000 = 'LIMIT_8000',
  Limit_10000 = 'LIMIT_10000',
  Limit_12500 = 'LIMIT_12500',
  Limit_15000 = 'LIMIT_15000',
  Limit_20000 = 'LIMIT_20000',
  Limit_25000 = 'LIMIT_25000',
  Limit_30000 = 'LIMIT_30000',
  Limit_35000 = 'LIMIT_35000'
}

export type WeaveLimits = {
  __typename: 'WeaveLimits';
  weaveLimitBytes?: Maybe<Scalars['Int64']['output']>;
  weaveOverageCostCents?: Maybe<Scalars['Int']['output']>;
  weaveOverageUnit?: Maybe<StorageUnit>;
};

export type WeaveMetricThresholdEventDetails = {
  __typename: 'WeaveMetricThresholdEventDetails';
  alertName?: Maybe<Scalars['String']['output']>;
  comparisonOp?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  metricName?: Maybe<Scalars['String']['output']>;
  metricValue?: Maybe<Scalars['Float']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
};

/** Event data for a Weave metric threshold trigger execution. */
export type WeaveMetricThresholdEventInput = {
  /** Name of the alert that was triggered */
  alertName: Scalars['String']['input'];
  /** Comparison operator (e.g., above, below, equals) */
  comparisonOp?: InputMaybe<Scalars['String']['input']>;
  /** Optional message describing the alert */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Name/path of the metric that triggered the alert */
  metricName: Scalars['String']['input'];
  /** Current value of the metric */
  metricValue?: InputMaybe<Scalars['Float']['input']>;
  /** Threshold value configured for the alert */
  threshold?: InputMaybe<Scalars['Float']['input']>;
};

export type WeaveSavingsCalculator = {
  __typename: 'WeaveSavingsCalculator';
  recommendationString: Scalars['String']['output'];
  recommendedWeaveTier: Scalars['String']['output'];
  totalPossibleSavings: Scalars['Int']['output'];
};

export enum WeaveSensitiveDataPolicy {
  Off = 'OFF',
  PiiV1 = 'PII_V1'
}

export enum WeaveSourceType {
  Prompt = 'PROMPT'
}

export enum WorkflowsAdminType {
  Model = 'MODEL'
}

export type WorkspaceTemplate = Node & {
  __typename: 'WorkspaceTemplate';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  settings?: Maybe<Scalars['JSON']['output']>;
  settingsVersion?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<WorkspaceTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum WorkspaceTemplateType {
  LinePlot = 'line_plot',
  WorkspaceLayout = 'workspace_layout'
}

export enum XAxisFormatValues {
  Datetime = 'datetime',
  Number = 'number'
}

export type UpgradeCustomerToProPlanInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modelsSeats: Scalars['Int']['input'];
  monthly?: InputMaybe<Scalars['Boolean']['input']>;
  organizationID: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
  planID: Scalars['ID']['input'];
  weaveIngestionTier: WeaveIngestionLimitInMb;
};

export type UpgradeCustomerToProPlanPayload = {
  __typename: 'upgradeCustomerToProPlanPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organizationID: Scalars['ID']['output'];
  subscriptionCommit?: Maybe<Scalars['JSON']['output']>;
  subscriptionUsage?: Maybe<Scalars['JSON']['output']>;
};

export type UpgradeProCustomerInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modelsSeats: Scalars['Int']['input'];
  monthly?: InputMaybe<Scalars['Boolean']['input']>;
  organizationID: Scalars['ID']['input'];
  weaveIngestionTier: WeaveIngestionLimitInMb;
};

export type UpgradeProCustomerPayload = {
  __typename: 'upgradeProCustomerPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organizationID: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpgradeTrialSubscriptionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationID: Scalars['ID']['input'];
  planID: Scalars['ID']['input'];
};

export type AgentChatRequestedProjectWriteAccessQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type AgentChatRequestedProjectWriteAccessQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, readOnly?: boolean | null } | null };

export type WbAgentPersonalSecretsWithGrantsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type WbAgentPersonalSecretsWithGrantsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, secrets: Array<{ __typename: 'UserSecret', uuid: string, name: string, createdAt: string, organizationId: number }>, wbAgentPersonalSecretGrants: Array<{ __typename: 'WBAgentPersonalSecretGrant', secret: { __typename: 'UserSecret', uuid: string } }> } | null };

export type GrantPersonalSecretToWbAgentMutationVariables = Exact<{
  secretUuid: Scalars['String']['input'];
}>;


export type GrantPersonalSecretToWbAgentMutation = { __typename: 'Mutation', grantPersonalSecretToWBAgent?: { __typename: 'GrantPersonalSecretToWBAgentPayload', grant: { __typename: 'WBAgentPersonalSecretGrant', secret: { __typename: 'UserSecret', uuid: string } } } | null };

export type RevokePersonalSecretFromWbAgentMutationVariables = Exact<{
  secretUuid: Scalars['String']['input'];
}>;


export type RevokePersonalSecretFromWbAgentMutation = { __typename: 'Mutation', revokePersonalSecretFromWBAgent?: { __typename: 'RevokePersonalSecretFromWBAgentPayload', success: boolean } | null };

export type GraphDataFragmentFragment = { __typename: 'ArtifactLineageDag', hitLimit: boolean, artifacts: Array<{ __typename: 'ArtifactLineageDagArtifact', id: string, artifactNodeID: string, entityName: string, projectName: string, artifactTypeName: string, artifactSequenceName: string, artifactCommitHash: string, versionIndex: number } | null>, runs: Array<{ __typename: 'ArtifactLineageDagRun', runNodeID: string, entityName: string, projectName: string, runName: string, displayName?: string | null, jobType?: string | null } | null>, clusters: Array<{ __typename: 'ArtifactLineageDagCluster', id: string, nodeType: DagNodeType, runNodes: Array<{ __typename: 'ArtifactLineageDagRun', runNodeID: string, entityName: string, projectName: string, runName: string, displayName?: string | null, jobType?: string | null } | null>, artifactNodes: Array<{ __typename: 'ArtifactLineageDagArtifact', id: string, artifactNodeID: string, entityName: string, projectName: string, artifactTypeName: string, artifactSequenceName: string, artifactCommitHash: string, versionIndex: number } | null>, clusterEdges: Array<{ __typename: 'ArtifactLineageDagEdge', edgeID: string, artifactNodeID: string, runNodeID: string, clusterNodeID?: string | null, direction: DagDirection } | null> } | null>, edges: Array<{ __typename: 'ArtifactLineageDagEdge', edgeID: string, artifactNodeID: string, runNodeID: string, clusterNodeID?: string | null, direction: DagDirection } | null> };

export type ArtifactDagQueryVariables = Exact<{
  artifactVersionID: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  filterGeneratedArtifacts: Scalars['Boolean']['input'];
  clusterSize?: InputMaybe<Scalars['Int']['input']>;
  directLineage?: InputMaybe<Scalars['Boolean']['input']>;
  traversalDirection?: InputMaybe<TraversalDirection>;
  baseGraphNodeIDs?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type ArtifactDagQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, artifactLineageDag?: { __typename: 'ArtifactLineageDag', hitLimit: boolean, artifacts: Array<{ __typename: 'ArtifactLineageDagArtifact', id: string, artifactNodeID: string, entityName: string, projectName: string, artifactTypeName: string, artifactSequenceName: string, artifactCommitHash: string, versionIndex: number } | null>, runs: Array<{ __typename: 'ArtifactLineageDagRun', runNodeID: string, entityName: string, projectName: string, runName: string, displayName?: string | null, jobType?: string | null } | null>, clusters: Array<{ __typename: 'ArtifactLineageDagCluster', id: string, nodeType: DagNodeType, runNodes: Array<{ __typename: 'ArtifactLineageDagRun', runNodeID: string, entityName: string, projectName: string, runName: string, displayName?: string | null, jobType?: string | null } | null>, artifactNodes: Array<{ __typename: 'ArtifactLineageDagArtifact', id: string, artifactNodeID: string, entityName: string, projectName: string, artifactTypeName: string, artifactSequenceName: string, artifactCommitHash: string, versionIndex: number } | null>, clusterEdges: Array<{ __typename: 'ArtifactLineageDagEdge', edgeID: string, artifactNodeID: string, runNodeID: string, clusterNodeID?: string | null, direction: DagDirection } | null> } | null>, edges: Array<{ __typename: 'ArtifactLineageDagEdge', edgeID: string, artifactNodeID: string, runNodeID: string, clusterNodeID?: string | null, direction: DagDirection } | null> } | null } | null };

export type ArtifactOverviewQueryVariables = Exact<{
  artifactID: Scalars['ID']['input'];
  artifactVersionIndex: Scalars['String']['input'];
}>;


export type ArtifactOverviewQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, digest: string, description?: string | null, size: any, fileCount: any, createdAt: string, usedCount: number, ttlDurationSeconds: any, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } | null }, createdBy?:
      | { __typename: 'Run', id: string, displayName?: string | null, runName: string, runProjectQuery?: { __typename: 'Project', id: string, runProject: string, runEntity: string } | null }
      | { __typename: 'User', id: string, username?: string | null }
     | null, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, artifactCollection?:
            | { __typename: 'ArtifactPortfolio', id: string, linkPortfolioName: string, linkProjectQuery?: { __typename: 'Project', id: string, linkProjectName: string, linkEntityName: string } | null }
            | { __typename: 'ArtifactSequence', id: string }
           | null } | null }> } } | null };

export type RunArtifactDagQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  filterGeneratedArtifacts: Scalars['Boolean']['input'];
  clusterSize?: InputMaybe<Scalars['Int']['input']>;
  directLineage?: InputMaybe<Scalars['Boolean']['input']>;
  traversalDirection?: InputMaybe<TraversalDirection>;
  baseGraphNodeIDs?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type RunArtifactDagQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, artifactLineageDag?: { __typename: 'ArtifactLineageDag', hitLimit: boolean, artifacts: Array<{ __typename: 'ArtifactLineageDagArtifact', id: string, artifactNodeID: string, entityName: string, projectName: string, artifactTypeName: string, artifactSequenceName: string, artifactCommitHash: string, versionIndex: number } | null>, runs: Array<{ __typename: 'ArtifactLineageDagRun', runNodeID: string, entityName: string, projectName: string, runName: string, displayName?: string | null, jobType?: string | null } | null>, clusters: Array<{ __typename: 'ArtifactLineageDagCluster', id: string, nodeType: DagNodeType, runNodes: Array<{ __typename: 'ArtifactLineageDagRun', runNodeID: string, entityName: string, projectName: string, runName: string, displayName?: string | null, jobType?: string | null } | null>, artifactNodes: Array<{ __typename: 'ArtifactLineageDagArtifact', id: string, artifactNodeID: string, entityName: string, projectName: string, artifactTypeName: string, artifactSequenceName: string, artifactCommitHash: string, versionIndex: number } | null>, clusterEdges: Array<{ __typename: 'ArtifactLineageDagEdge', edgeID: string, artifactNodeID: string, runNodeID: string, clusterNodeID?: string | null, direction: DagDirection } | null> } | null>, edges: Array<{ __typename: 'ArtifactLineageDagEdge', edgeID: string, artifactNodeID: string, runNodeID: string, clusterNodeID?: string | null, direction: DagDirection } | null> } | null } | null } | null };

export type RunOverviewLineageQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type RunOverviewLineageQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, createdAt: string, group?: string | null, state?: string | null, notes?: string | null, config?: any | null, tags?: Array<string> | null, host?: string | null, computeSeconds: number, project?: { __typename: 'Project', id: string, name: string } | null, user?: { __typename: 'User', id: string, username?: string | null } | null, runInfo?: { __typename: 'RunInfo', os?: string | null, python?: string | null } | null } | null } | null };

export type ArtifactVersionAliasesQueryVariables = Exact<{
  artifactCollectionID: Scalars['ID']['input'];
  versionAlias: Scalars['String']['input'];
  adminType: WorkflowsAdminType;
}>;


export type ArtifactVersionAliasesQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, name: string, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string } | null }> }, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, artifactType: { __typename: 'ArtifactType', id: string, name: string } } | null } | null, project?: { __typename: 'Project', id: string, name: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, entity: { __typename: 'Entity', id: string, name: string, protectedAliases: Array<string>, workflowsAdmins: Array<{ __typename: 'User', id: string, name: string, username?: string | null }> } } | null }
    | { __typename: 'ArtifactSequence', id: string, name: string, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string } | null }> }, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, artifactType: { __typename: 'ArtifactType', id: string, name: string } } | null } | null, project?: { __typename: 'Project', id: string, name: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, entity: { __typename: 'Entity', id: string, name: string, protectedAliases: Array<string>, workflowsAdmins: Array<{ __typename: 'User', id: string, name: string, username?: string | null }> } } | null }
   | null };

export type ArtifactVersionTagsQueryVariables = Exact<{
  artifactCollectionID: Scalars['ID']['input'];
  versionAlias: Scalars['String']['input'];
}>;


export type ArtifactVersionTagsQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, name: string, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, artifact?: { __typename: 'Artifact', id: string, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null } | null, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null }
    | { __typename: 'ArtifactSequence', id: string, name: string, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, artifact?: { __typename: 'Artifact', id: string, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null } | null, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null }
   | null };

export type ArtifactIsProtectedQueryVariables = Exact<{
  artifactID: Scalars['ID']['input'];
}>;


export type ArtifactIsProtectedQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, isProtected: boolean, artifactSequence: { __typename: 'ArtifactSequence', id: string, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null } } | null };

export type ArtifactTagsQueryVariables = Exact<{
  artifactCollectionID: Scalars['ID']['input'];
}>;


export type ArtifactTagsQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, name: string, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, attributes: any, tagCategoryName: string } }> }, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null }
    | { __typename: 'ArtifactSequence', id: string, name: string, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, attributes: any, tagCategoryName: string } }> }, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null }
   | null };

export type ArtifactVersionsTableDataQueryVariables = Exact<{
  artifactCollectionID: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type ArtifactVersionsTableDataQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, artifact?: { __typename: 'Artifact', id: string, metadata?: any | null, ttlDurationSeconds: any, usedCount: number, size: any, isGenerated: boolean, createdAt: string, runHistory: string, createdBy?:
                | { __typename: 'Run', id: string, name: string, displayName?: string | null, defaultColorIndex?: number | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
                | { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null }
               | null, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } | null }> } }
    | { __typename: 'ArtifactSequence', id: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, artifact?: { __typename: 'Artifact', id: string, metadata?: any | null, ttlDurationSeconds: any, usedCount: number, size: any, isGenerated: boolean, createdAt: string, runHistory: string, createdBy?:
                | { __typename: 'Run', id: string, name: string, displayName?: string | null, defaultColorIndex?: number | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
                | { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null }
               | null, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } | null }> } }
   | null };

export type ArtifactVersionsTableAliasesQueryVariables = Exact<{
  artifactCollectionID: Scalars['ID']['input'];
}>;


export type ArtifactVersionsTableAliasesQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string } | null }> }, project?: { __typename: 'Project', id: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }> } | null }
    | { __typename: 'ArtifactSequence', id: string, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string } | null }> }, project?: { __typename: 'Project', id: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }> } | null }
   | null };

export type ArtifactCollectionOverviewQueryVariables = Exact<{
  artifactCollectionID: Scalars['ID']['input'];
  includeOverview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ArtifactCollectionOverviewQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, createdAt: string, description?: string | null, name: string, overview?: { __typename: 'ArtifactCollectionOverview', artifactCollectionID: string, viewID: string } | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, artifactMemberships?: { __typename: 'ArtifactCollectionMembershipConnection', edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, artifact?: { __typename: 'Artifact', id: string, artifactSequence: { __typename: 'ArtifactSequence', id: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } } | null } | null }> }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
    | { __typename: 'ArtifactSequence', id: string, createdAt: string, description?: string | null, name: string, overview?: { __typename: 'ArtifactCollectionOverview', artifactCollectionID: string, viewID: string } | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, artifactMemberships?: { __typename: 'ArtifactCollectionMembershipConnection', edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, artifact?: { __typename: 'Artifact', id: string, artifactSequence: { __typename: 'ArtifactSequence', id: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } } | null } | null }> }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
   | null };

export type ArtifactCollectionDisplayVersionsQueryVariables = Exact<{
  artifactCollectionID: Scalars['ID']['input'];
}>;


export type ArtifactCollectionDisplayVersionsQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, versionIndexes: Array<number>, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string } | null }> } }
    | { __typename: 'ArtifactSequence', id: string, versionIndexes: Array<number>, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string } | null }> } }
   | null };

export type ArtifactCollectionWithRegistryVersionQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  artifactTypeName: Scalars['String']['input'];
  artifactCollectionName: Scalars['String']['input'];
}>;


export type ArtifactCollectionWithRegistryVersionQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactType?: { __typename: 'ArtifactType', id: string, artifactCollection?:
        | { __typename: 'ArtifactPortfolio', id: string, name: string, hasArtifactVersionLinkedToGlobalRegistry: boolean }
        | { __typename: 'ArtifactSequence', id: string, name: string, hasArtifactVersionLinkedToGlobalRegistry: boolean }
       | null } | null } | null };

export type ArtifactCollectionHasProtectedArtifactQueryVariables = Exact<{
  artifactCollectionID: Scalars['ID']['input'];
}>;


export type ArtifactCollectionHasProtectedArtifactQuery = { __typename: 'Query', artifactSequence?: { __typename: 'ArtifactSequence', id: string, hasProtectedArtifact: boolean } | null };

export type ArtifactSidebarCollectionsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first: Scalars['Int']['input'];
}>;


export type ArtifactSidebarCollectionsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
          | { __typename: 'ArtifactPortfolio', id: string, name: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string } }
          | { __typename: 'ArtifactSequence', id: string, name: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string } }
         | null }> } | null } | null };

export type ArtifactSidebarTypeCollectionsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  artifactTypeName: Scalars['String']['input'];
  portfolioFirst: Scalars['Int']['input'];
  portfolioAfter?: InputMaybe<Scalars['String']['input']>;
  sequenceFirst: Scalars['Int']['input'];
  sequenceAfter?: InputMaybe<Scalars['String']['input']>;
}>;


export type ArtifactSidebarTypeCollectionsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactType?: { __typename: 'ArtifactType', id: string, portfolios?: { __typename: 'ArtifactCollectionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, updatedAt?: string | null }
            | { __typename: 'ArtifactSequence', id: string, name: string, updatedAt?: string | null }
           | null }> } | null, sequences?: { __typename: 'ArtifactCollectionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, updatedAt?: string | null }
            | { __typename: 'ArtifactSequence', id: string, name: string, updatedAt?: string | null }
           | null }> } | null } | null } | null };

export type ArtifactSidebarTypesQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
}>;


export type ArtifactSidebarTypesQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string } | null }> } } | null };

export type ArtifactProjectMetadataSearchQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
}>;


export type ArtifactProjectMetadataSearchQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifacts: Array<{ __typename: 'Artifact', id: string, digest: string, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string }, artifactType: { __typename: 'ArtifactType', id: string, name: string } }> } | null };

export type FetchOrgAutomationHistoryQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  triggerID?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type FetchOrgAutomationHistoryQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, triggerExecutions: { __typename: 'TriggerExecutionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'TriggerExecutionEdge', node: { __typename: 'TriggerExecution', id: string, state: TriggerExecutionState, createdAt: string, updatedAt?: string | null, triggerID?: string | null, triggerName: string, actionStartedAt?: string | null, actionDuration?: number | null, scope?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
            | { __typename: 'ArtifactSequence', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
            | { __typename: 'Entity', id: string, name: string, isTeam: boolean }
            | { __typename: 'Project', id: string, name: string, entityName: string }
           | null, event?: { __typename: 'TriggerExecutionEvent', eventType: EventTriggeringConditionType, data?:
              | { __typename: 'ArtifactAliasEventDetails', artifactMetadata?: any | null, artifactVersionIndex?: number | null, artifactCollectionName?: string | null, projectName?: string | null, entityName?: string | null, alias?: string | null }
              | { __typename: 'ArtifactEventDetails', artifactMetadata?: any | null, artifactVersionIndex?: number | null, artifactCollectionName?: string | null, projectName?: string | null, entityName?: string | null }
              | { __typename: 'ArtifactTagEventDetails', artifactMetadata?: any | null, artifactVersionIndex?: number | null, artifactCollectionName?: string | null, projectName?: string | null, entityName?: string | null, tag?: string | null }
              | { __typename: 'CollectionTagEventDetails', artifactCollectionName?: string | null, projectName?: string | null, entityName?: string | null, tag?: string | null }
              | { __typename: 'RunMetricEventDetails', runName?: string | null, projectName?: string | null, entityName?: string | null, metricName?: string | null, metricValues?: Array<number> | null }
              | { __typename: 'RunStateEventDetails', runName?: string | null, projectName?: string | null, entityName?: string | null, newRunState?: string | null }
              | { __typename: 'WeaveMetricThresholdEventDetails' }
             | null } | null, action?: { __typename: 'TriggerExecutionAction', actionType: TriggeredActionType, data?:
              | { __typename: 'ARIAActionArgs', prompt: string }
              | { __typename: 'GenericWebhookActionArgs', requestPayload?: any | null, integration?: { __typename: 'GenericWebhookIntegration', id: string, name: string, urlEndpoint: string, accessTokenRef?: string | null, secretRef?: string | null, createdAt: string } | null }
              | { __typename: 'NoOpActionArgs' }
              | { __typename: 'PushNotificationActionArgs', title?: string | null, body?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null }
              | { __typename: 'QueueJobActionArgs', runSpec?: any | null, priority?: number | null }
              | { __typename: 'SlackNotificationActionArgs', title?: string | null, text?: string | null, titleURL?: string | null, severity?: AlertSeverity | null, integration?: { __typename: 'SlackIntegration', id: string, channelName: string } | null }
             | null } | null, result?: { __typename: 'TriggerExecutionResult', resultType: TriggerResultType, data?:
              | { __typename: 'DefaultTriggerResultDetails', error?: { __typename: 'TriggerExecutionError', message: string } | null }
              | { __typename: 'HttpTriggerResultDetails', status?: string | null, statusCode?: number | null, body?: string | null, error?: { __typename: 'TriggerExecutionError', message: string } | null }
              | { __typename: 'PushNotificationTriggerResultDetails', successCount: number, failureCount: number, error?: { __typename: 'TriggerExecutionError', message: string } | null }
              | { __typename: 'QueuedJobTriggerResultDetails', runQueueItemID?: string | null, error?: { __typename: 'TriggerExecutionError', message: string } | null }
             | null } | null } }> } } | null };

export type FetchOrgScopeTargetsQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  viewerUsername: Scalars['String']['input'];
  viewerId: Scalars['ID']['input'];
}>;


export type FetchOrgScopeTargetsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, member?: { __typename: 'OrganizationMember', id: string, role: string } | null, orgEntity?: { __typename: 'Entity', id: string, name: string } | null, teams: Array<{ __typename: 'Entity', id: string, name: string, member?: { __typename: 'Member', id?: string | null, role?: string | null, memberRole?: { __typename: 'Role', name: string } | null } | null }> } | null };

export type FetchOrgAutomationsQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type FetchOrgAutomationsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, triggers: { __typename: 'TriggerConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'TriggerEdge', node: { __typename: 'Trigger', id: string, name: string, createdAt: string, updatedAt?: string | null, enabled: boolean, description?: string | null, readOnly: boolean, lastExecutedAt?: string | null, createdBy: { __typename: 'User', id: string, name: string }, scope:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
            | { __typename: 'ArtifactSequence', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
            | { __typename: 'Entity', id: string, name: string, isTeam: boolean }
            | { __typename: 'Project', id: string, name: string, entityName: string }
          , triggeringCondition: { __typename: 'FilterEventTriggeringCondition', eventType: EventTriggeringConditionType, filter: string }, triggeredAction:
            | { __typename: 'ARIATriggeredAction', prompt: string, readOnly: boolean }
            | { __typename: 'GenericWebhookTriggeredAction', entityName: string, requestPayload?: any | null, readOnly: boolean, integration:
                | { __typename: 'GenericWebhookIntegration', id: string, name: string, urlEndpoint: string, accessTokenRef?: string | null, secretRef?: string | null, createdAt: string }
                | { __typename: 'GitHubOAuthIntegration' }
                | { __typename: 'SlackIntegration' }
               }
            | { __typename: 'NoOpTriggeredAction', readOnly: boolean }
            | { __typename: 'NotificationTriggeredAction', title?: string | null, message?: string | null, severity?: AlertSeverity | null, entityName: string, readOnly: boolean, integration:
                | { __typename: 'GenericWebhookIntegration', id: string }
                | { __typename: 'GitHubOAuthIntegration', id: string }
                | { __typename: 'SlackIntegration', channelName: string, id: string }
               }
            | { __typename: 'PushNotificationTriggeredAction', title?: string | null, body?: string | null, readOnly: boolean, user: { __typename: 'User', id: string, username?: string | null } }
            | { __typename: 'QueueJobTriggeredAction', template: any, readOnly: boolean, queue?: { __typename: 'RunQueue', id: string, name: string } | null }
           } }> } } | null };

export type TeamProjectsRunsV2StatusQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type TeamProjectsRunsV2StatusQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, fromV2?: boolean | null } | null }> } | null } | null };

export type DeleteRunChildrenQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type DeleteRunChildrenQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, descendantRuns?: { __typename: 'RunDescendantRuns', runs: Array<{ __typename: 'RunIdentifier', id: string, name: string, displayName?: string | null }> } | null } | null } | null };

export type EotfOrganizationSubscriptionsBasicInfoQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type EotfOrganizationSubscriptionsBasicInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, expiresAt?: string | null, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type GlobalBannerQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalBannerQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, organizations: Array<{ __typename: 'Organization', id: string, name: string, flags?: any | null, usedSeats: number, billingUser?: { __typename: 'User', id: string, username?: string | null, email?: string | null } | null, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, subscriptionType: OrganizationSubscriptionType, status: OrganizationSubscriptionStatus, expiresAt?: string | null, privileges: any, seats: number, isAutomaticUpgrade: boolean, billingPeriodStart?: string | null, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType }, expansionPacks: { __typename: 'ExpansionPackConnection', edges: Array<{ __typename: 'ExpansionPackEdge', node: { __typename: 'ExpansionPack', id: string, secondsLimit: number, expiresAt?: string | null } }> } }>, teams: Array<{ __typename: 'Entity', id: string, name: string, computeHours: number, oldComputeHours: number }>, members: Array<{ __typename: 'OrganizationMember', id: string, username: string, role: string }> }> } | null };

export type ProjectFromNameQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectFromNameQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, entityName: string } | null };

export type AutomationsProjectsQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
}>;


export type AutomationsProjectsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string } | null }> } | null } | null };

export type EntityArtifactTypeQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  artifactType: Scalars['String']['input'];
}>;


export type EntityArtifactTypeQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, artifactType?: { __typename: 'ArtifactType', id: string, name: string } | null } | null }> } | null } | null };

export type FetchProjectJobsForTriggersPartialQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchProjectJobsForTriggersPartialQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, artifactType?: { __typename: 'ArtifactType', id: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, createdAt: string, project?: { __typename: 'Project', id: string, name: string, access?: string | null, entity: { __typename: 'Entity', id: string, name: string } } | null, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, createdAt: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, createdBy?:
                      | { __typename: 'Run', id: string, name: string, config?: any | null }
                      | { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null }
                     | null, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string, config?: any | null, defaultColorIndex?: number | null, user?: { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null } | null } }> } } }> } }
            | { __typename: 'ArtifactSequence', id: string, name: string, createdAt: string, project?: { __typename: 'Project', id: string, name: string, access?: string | null, entity: { __typename: 'Entity', id: string, name: string } } | null, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, createdAt: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, createdBy?:
                      | { __typename: 'Run', id: string, name: string, config?: any | null }
                      | { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null }
                     | null, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string, config?: any | null, defaultColorIndex?: number | null, user?: { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null } | null } }> } } }> } }
           | null }> } | null } | null } | null };

type EventDetailsFragment_ArtifactAliasEventDetails_Fragment = { __typename: 'ArtifactAliasEventDetails', artifactMetadata?: any | null, artifactVersionIndex?: number | null, artifactCollectionName?: string | null, projectName?: string | null, entityName?: string | null, alias?: string | null };

type EventDetailsFragment_ArtifactEventDetails_Fragment = { __typename: 'ArtifactEventDetails', artifactMetadata?: any | null, artifactVersionIndex?: number | null, artifactCollectionName?: string | null, projectName?: string | null, entityName?: string | null };

type EventDetailsFragment_ArtifactTagEventDetails_Fragment = { __typename: 'ArtifactTagEventDetails', artifactMetadata?: any | null, artifactVersionIndex?: number | null, artifactCollectionName?: string | null, projectName?: string | null, entityName?: string | null, tag?: string | null };

type EventDetailsFragment_CollectionTagEventDetails_Fragment = { __typename: 'CollectionTagEventDetails', artifactCollectionName?: string | null, projectName?: string | null, entityName?: string | null, tag?: string | null };

type EventDetailsFragment_RunMetricEventDetails_Fragment = { __typename: 'RunMetricEventDetails', runName?: string | null, projectName?: string | null, entityName?: string | null, metricName?: string | null, metricValues?: Array<number> | null };

type EventDetailsFragment_RunStateEventDetails_Fragment = { __typename: 'RunStateEventDetails', runName?: string | null, projectName?: string | null, entityName?: string | null, newRunState?: string | null };

type EventDetailsFragment_WeaveMetricThresholdEventDetails_Fragment = { __typename: 'WeaveMetricThresholdEventDetails' };

export type EventDetailsFragmentFragment =
  | EventDetailsFragment_ArtifactAliasEventDetails_Fragment
  | EventDetailsFragment_ArtifactEventDetails_Fragment
  | EventDetailsFragment_ArtifactTagEventDetails_Fragment
  | EventDetailsFragment_CollectionTagEventDetails_Fragment
  | EventDetailsFragment_RunMetricEventDetails_Fragment
  | EventDetailsFragment_RunStateEventDetails_Fragment
  | EventDetailsFragment_WeaveMetricThresholdEventDetails_Fragment
;

type ActionDetailsFragment_AriaActionArgs_Fragment = { __typename: 'ARIAActionArgs', prompt: string };

type ActionDetailsFragment_GenericWebhookActionArgs_Fragment = { __typename: 'GenericWebhookActionArgs', requestPayload?: any | null, integration?: { __typename: 'GenericWebhookIntegration', id: string, name: string, urlEndpoint: string, accessTokenRef?: string | null, secretRef?: string | null, createdAt: string } | null };

type ActionDetailsFragment_NoOpActionArgs_Fragment = { __typename: 'NoOpActionArgs' };

type ActionDetailsFragment_PushNotificationActionArgs_Fragment = { __typename: 'PushNotificationActionArgs', title?: string | null, body?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null };

type ActionDetailsFragment_QueueJobActionArgs_Fragment = { __typename: 'QueueJobActionArgs', runSpec?: any | null, priority?: number | null };

type ActionDetailsFragment_SlackNotificationActionArgs_Fragment = { __typename: 'SlackNotificationActionArgs', title?: string | null, text?: string | null, titleURL?: string | null, severity?: AlertSeverity | null, integration?: { __typename: 'SlackIntegration', id: string, channelName: string } | null };

export type ActionDetailsFragmentFragment =
  | ActionDetailsFragment_AriaActionArgs_Fragment
  | ActionDetailsFragment_GenericWebhookActionArgs_Fragment
  | ActionDetailsFragment_NoOpActionArgs_Fragment
  | ActionDetailsFragment_PushNotificationActionArgs_Fragment
  | ActionDetailsFragment_QueueJobActionArgs_Fragment
  | ActionDetailsFragment_SlackNotificationActionArgs_Fragment
;

type ResultDetailsFragment_DefaultTriggerResultDetails_Fragment = { __typename: 'DefaultTriggerResultDetails', error?: { __typename: 'TriggerExecutionError', message: string } | null };

type ResultDetailsFragment_HttpTriggerResultDetails_Fragment = { __typename: 'HttpTriggerResultDetails', status?: string | null, statusCode?: number | null, body?: string | null, error?: { __typename: 'TriggerExecutionError', message: string } | null };

type ResultDetailsFragment_PushNotificationTriggerResultDetails_Fragment = { __typename: 'PushNotificationTriggerResultDetails', successCount: number, failureCount: number, error?: { __typename: 'TriggerExecutionError', message: string } | null };

type ResultDetailsFragment_QueuedJobTriggerResultDetails_Fragment = { __typename: 'QueuedJobTriggerResultDetails', runQueueItemID?: string | null, error?: { __typename: 'TriggerExecutionError', message: string } | null };

export type ResultDetailsFragmentFragment =
  | ResultDetailsFragment_DefaultTriggerResultDetails_Fragment
  | ResultDetailsFragment_HttpTriggerResultDetails_Fragment
  | ResultDetailsFragment_PushNotificationTriggerResultDetails_Fragment
  | ResultDetailsFragment_QueuedJobTriggerResultDetails_Fragment
;

export type TriggerExecutionFragmentFragment = { __typename: 'TriggerExecution', id: string, state: TriggerExecutionState, createdAt: string, updatedAt?: string | null, triggerID?: string | null, triggerName: string, actionStartedAt?: string | null, actionDuration?: number | null, scope?:
    | { __typename: 'ArtifactPortfolio', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
    | { __typename: 'ArtifactSequence', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
    | { __typename: 'Entity', id: string, name: string, isTeam: boolean }
    | { __typename: 'Project', id: string, name: string, entityName: string }
   | null, event?: { __typename: 'TriggerExecutionEvent', eventType: EventTriggeringConditionType, data?:
      | { __typename: 'ArtifactAliasEventDetails', artifactMetadata?: any | null, artifactVersionIndex?: number | null, artifactCollectionName?: string | null, projectName?: string | null, entityName?: string | null, alias?: string | null }
      | { __typename: 'ArtifactEventDetails', artifactMetadata?: any | null, artifactVersionIndex?: number | null, artifactCollectionName?: string | null, projectName?: string | null, entityName?: string | null }
      | { __typename: 'ArtifactTagEventDetails', artifactMetadata?: any | null, artifactVersionIndex?: number | null, artifactCollectionName?: string | null, projectName?: string | null, entityName?: string | null, tag?: string | null }
      | { __typename: 'CollectionTagEventDetails', artifactCollectionName?: string | null, projectName?: string | null, entityName?: string | null, tag?: string | null }
      | { __typename: 'RunMetricEventDetails', runName?: string | null, projectName?: string | null, entityName?: string | null, metricName?: string | null, metricValues?: Array<number> | null }
      | { __typename: 'RunStateEventDetails', runName?: string | null, projectName?: string | null, entityName?: string | null, newRunState?: string | null }
      | { __typename: 'WeaveMetricThresholdEventDetails' }
     | null } | null, action?: { __typename: 'TriggerExecutionAction', actionType: TriggeredActionType, data?:
      | { __typename: 'ARIAActionArgs', prompt: string }
      | { __typename: 'GenericWebhookActionArgs', requestPayload?: any | null, integration?: { __typename: 'GenericWebhookIntegration', id: string, name: string, urlEndpoint: string, accessTokenRef?: string | null, secretRef?: string | null, createdAt: string } | null }
      | { __typename: 'NoOpActionArgs' }
      | { __typename: 'PushNotificationActionArgs', title?: string | null, body?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null }
      | { __typename: 'QueueJobActionArgs', runSpec?: any | null, priority?: number | null }
      | { __typename: 'SlackNotificationActionArgs', title?: string | null, text?: string | null, titleURL?: string | null, severity?: AlertSeverity | null, integration?: { __typename: 'SlackIntegration', id: string, channelName: string } | null }
     | null } | null, result?: { __typename: 'TriggerExecutionResult', resultType: TriggerResultType, data?:
      | { __typename: 'DefaultTriggerResultDetails', error?: { __typename: 'TriggerExecutionError', message: string } | null }
      | { __typename: 'HttpTriggerResultDetails', status?: string | null, statusCode?: number | null, body?: string | null, error?: { __typename: 'TriggerExecutionError', message: string } | null }
      | { __typename: 'PushNotificationTriggerResultDetails', successCount: number, failureCount: number, error?: { __typename: 'TriggerExecutionError', message: string } | null }
      | { __typename: 'QueuedJobTriggerResultDetails', runQueueItemID?: string | null, error?: { __typename: 'TriggerExecutionError', message: string } | null }
     | null } | null };

export type FetchProjectTriggerExecutionsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  triggerID?: InputMaybe<Scalars['ID']['input']>;
  projectOnly?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type FetchProjectTriggerExecutionsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, triggerExecutions: { __typename: 'TriggerExecutionConnection', totalCount: any, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'TriggerExecutionEdge', node: { __typename: 'TriggerExecution', id: string, state: TriggerExecutionState, createdAt: string, updatedAt?: string | null, triggerID?: string | null, triggerName: string, actionStartedAt?: string | null, actionDuration?: number | null, scope?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
            | { __typename: 'ArtifactSequence', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
            | { __typename: 'Entity', id: string, name: string, isTeam: boolean }
            | { __typename: 'Project', id: string, name: string, entityName: string }
           | null, event?: { __typename: 'TriggerExecutionEvent', eventType: EventTriggeringConditionType, data?:
              | { __typename: 'ArtifactAliasEventDetails', artifactMetadata?: any | null, artifactVersionIndex?: number | null, artifactCollectionName?: string | null, projectName?: string | null, entityName?: string | null, alias?: string | null }
              | { __typename: 'ArtifactEventDetails', artifactMetadata?: any | null, artifactVersionIndex?: number | null, artifactCollectionName?: string | null, projectName?: string | null, entityName?: string | null }
              | { __typename: 'ArtifactTagEventDetails', artifactMetadata?: any | null, artifactVersionIndex?: number | null, artifactCollectionName?: string | null, projectName?: string | null, entityName?: string | null, tag?: string | null }
              | { __typename: 'CollectionTagEventDetails', artifactCollectionName?: string | null, projectName?: string | null, entityName?: string | null, tag?: string | null }
              | { __typename: 'RunMetricEventDetails', runName?: string | null, projectName?: string | null, entityName?: string | null, metricName?: string | null, metricValues?: Array<number> | null }
              | { __typename: 'RunStateEventDetails', runName?: string | null, projectName?: string | null, entityName?: string | null, newRunState?: string | null }
              | { __typename: 'WeaveMetricThresholdEventDetails' }
             | null } | null, action?: { __typename: 'TriggerExecutionAction', actionType: TriggeredActionType, data?:
              | { __typename: 'ARIAActionArgs', prompt: string }
              | { __typename: 'GenericWebhookActionArgs', requestPayload?: any | null, integration?: { __typename: 'GenericWebhookIntegration', id: string, name: string, urlEndpoint: string, accessTokenRef?: string | null, secretRef?: string | null, createdAt: string } | null }
              | { __typename: 'NoOpActionArgs' }
              | { __typename: 'PushNotificationActionArgs', title?: string | null, body?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null }
              | { __typename: 'QueueJobActionArgs', runSpec?: any | null, priority?: number | null }
              | { __typename: 'SlackNotificationActionArgs', title?: string | null, text?: string | null, titleURL?: string | null, severity?: AlertSeverity | null, integration?: { __typename: 'SlackIntegration', id: string, channelName: string } | null }
             | null } | null, result?: { __typename: 'TriggerExecutionResult', resultType: TriggerResultType, data?:
              | { __typename: 'DefaultTriggerResultDetails', error?: { __typename: 'TriggerExecutionError', message: string } | null }
              | { __typename: 'HttpTriggerResultDetails', status?: string | null, statusCode?: number | null, body?: string | null, error?: { __typename: 'TriggerExecutionError', message: string } | null }
              | { __typename: 'PushNotificationTriggerResultDetails', successCount: number, failureCount: number, error?: { __typename: 'TriggerExecutionError', message: string } | null }
              | { __typename: 'QueuedJobTriggerResultDetails', runQueueItemID?: string | null, error?: { __typename: 'TriggerExecutionError', message: string } | null }
             | null } | null } }> } } | null };

export type CreateFilterTriggerMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  triggeringEventType: EventTriggeringConditionType;
  scopeType: TriggerScopeType;
  scopeID: Scalars['ID']['input'];
  eventFilter: Scalars['JSONString']['input'];
  triggeredActionType: TriggeredActionType;
  triggeredActionConfig: TriggeredActionConfig;
  enabled: Scalars['Boolean']['input'];
}>;


export type CreateFilterTriggerMutation = { __typename: 'Mutation', createFilterTrigger?: { __typename: 'CreateFilterTriggerPayload', trigger?: { __typename: 'Trigger', id: string } | null } | null };

export type UpdateFilterTriggerMutationVariables = Exact<{
  triggerID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  triggeringEventType: EventTriggeringConditionType;
  scopeType: TriggerScopeType;
  scopeID: Scalars['ID']['input'];
  eventFilter: Scalars['JSONString']['input'];
  triggeredActionType: TriggeredActionType;
  triggeredActionConfig: TriggeredActionConfig;
  enabled: Scalars['Boolean']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateFilterTriggerMutation = { __typename: 'Mutation', updateFilterTrigger?: { __typename: 'UpdateFilterTriggerPayload', clientMutationId?: string | null, trigger?: { __typename: 'Trigger', id: string } | null } | null };

export type ProjectScopeFragmentFragment = { __typename: 'Project', id: string, name: string, entityName: string };

export type ArtifactSequenceScopeFragmentFragment = { __typename: 'ArtifactSequence', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null };

export type ArtifactPortfolioScopeFragmentFragment = { __typename: 'ArtifactPortfolio', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null };

export type EntityScopeFragmentFragment = { __typename: 'Entity', id: string, name: string, isTeam: boolean };

type TriggerScopeFragment_ArtifactPortfolio_Fragment = { __typename: 'ArtifactPortfolio', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null };

type TriggerScopeFragment_ArtifactSequence_Fragment = { __typename: 'ArtifactSequence', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null };

type TriggerScopeFragment_Entity_Fragment = { __typename: 'Entity', id: string, name: string, isTeam: boolean };

type TriggerScopeFragment_Project_Fragment = { __typename: 'Project', id: string, name: string, entityName: string };

export type TriggerScopeFragmentFragment =
  | TriggerScopeFragment_ArtifactPortfolio_Fragment
  | TriggerScopeFragment_ArtifactSequence_Fragment
  | TriggerScopeFragment_Entity_Fragment
  | TriggerScopeFragment_Project_Fragment
;

export type TriggeringConditionFragmentFragment = { __typename: 'FilterEventTriggeringCondition', eventType: EventTriggeringConditionType, filter: string };

type TriggeredActionFragment_AriaTriggeredAction_Fragment = { __typename: 'ARIATriggeredAction', prompt: string, readOnly: boolean };

type TriggeredActionFragment_GenericWebhookTriggeredAction_Fragment = { __typename: 'GenericWebhookTriggeredAction', entityName: string, requestPayload?: any | null, readOnly: boolean, integration:
    | { __typename: 'GenericWebhookIntegration', id: string, name: string, urlEndpoint: string, accessTokenRef?: string | null, secretRef?: string | null, createdAt: string }
    | { __typename: 'GitHubOAuthIntegration' }
    | { __typename: 'SlackIntegration' }
   };

type TriggeredActionFragment_NoOpTriggeredAction_Fragment = { __typename: 'NoOpTriggeredAction', readOnly: boolean };

type TriggeredActionFragment_NotificationTriggeredAction_Fragment = { __typename: 'NotificationTriggeredAction', title?: string | null, message?: string | null, severity?: AlertSeverity | null, entityName: string, readOnly: boolean, integration:
    | { __typename: 'GenericWebhookIntegration', id: string }
    | { __typename: 'GitHubOAuthIntegration', id: string }
    | { __typename: 'SlackIntegration', channelName: string, id: string }
   };

type TriggeredActionFragment_PushNotificationTriggeredAction_Fragment = { __typename: 'PushNotificationTriggeredAction', title?: string | null, body?: string | null, readOnly: boolean, user: { __typename: 'User', id: string, username?: string | null } };

type TriggeredActionFragment_QueueJobTriggeredAction_Fragment = { __typename: 'QueueJobTriggeredAction', template: any, readOnly: boolean, queue?: { __typename: 'RunQueue', id: string, name: string } | null };

export type TriggeredActionFragmentFragment =
  | TriggeredActionFragment_AriaTriggeredAction_Fragment
  | TriggeredActionFragment_GenericWebhookTriggeredAction_Fragment
  | TriggeredActionFragment_NoOpTriggeredAction_Fragment
  | TriggeredActionFragment_NotificationTriggeredAction_Fragment
  | TriggeredActionFragment_PushNotificationTriggeredAction_Fragment
  | TriggeredActionFragment_QueueJobTriggeredAction_Fragment
;

export type TriggerFragmentFragment = { __typename: 'Trigger', id: string, name: string, createdAt: string, updatedAt?: string | null, enabled: boolean, description?: string | null, readOnly: boolean, lastExecutedAt?: string | null, createdBy: { __typename: 'User', id: string, name: string }, scope:
    | { __typename: 'ArtifactPortfolio', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
    | { __typename: 'ArtifactSequence', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
    | { __typename: 'Entity', id: string, name: string, isTeam: boolean }
    | { __typename: 'Project', id: string, name: string, entityName: string }
  , triggeringCondition: { __typename: 'FilterEventTriggeringCondition', eventType: EventTriggeringConditionType, filter: string }, triggeredAction:
    | { __typename: 'ARIATriggeredAction', prompt: string, readOnly: boolean }
    | { __typename: 'GenericWebhookTriggeredAction', entityName: string, requestPayload?: any | null, readOnly: boolean, integration:
        | { __typename: 'GenericWebhookIntegration', id: string, name: string, urlEndpoint: string, accessTokenRef?: string | null, secretRef?: string | null, createdAt: string }
        | { __typename: 'GitHubOAuthIntegration' }
        | { __typename: 'SlackIntegration' }
       }
    | { __typename: 'NoOpTriggeredAction', readOnly: boolean }
    | { __typename: 'NotificationTriggeredAction', title?: string | null, message?: string | null, severity?: AlertSeverity | null, entityName: string, readOnly: boolean, integration:
        | { __typename: 'GenericWebhookIntegration', id: string }
        | { __typename: 'GitHubOAuthIntegration', id: string }
        | { __typename: 'SlackIntegration', channelName: string, id: string }
       }
    | { __typename: 'PushNotificationTriggeredAction', title?: string | null, body?: string | null, readOnly: boolean, user: { __typename: 'User', id: string, username?: string | null } }
    | { __typename: 'QueueJobTriggeredAction', template: any, readOnly: boolean, queue?: { __typename: 'RunQueue', id: string, name: string } | null }
   };

export type FetchProjectTriggersQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  projectOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FetchProjectTriggersQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, triggers: Array<{ __typename: 'Trigger', id: string, name: string, createdAt: string, updatedAt?: string | null, enabled: boolean, description?: string | null, readOnly: boolean, lastExecutedAt?: string | null, createdBy: { __typename: 'User', id: string, name: string }, scope:
        | { __typename: 'ArtifactPortfolio', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
        | { __typename: 'ArtifactSequence', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
        | { __typename: 'Entity', id: string, name: string, isTeam: boolean }
        | { __typename: 'Project', id: string, name: string, entityName: string }
      , triggeringCondition: { __typename: 'FilterEventTriggeringCondition', eventType: EventTriggeringConditionType, filter: string }, triggeredAction:
        | { __typename: 'ARIATriggeredAction', prompt: string, readOnly: boolean }
        | { __typename: 'GenericWebhookTriggeredAction', entityName: string, requestPayload?: any | null, readOnly: boolean, integration:
            | { __typename: 'GenericWebhookIntegration', id: string, name: string, urlEndpoint: string, accessTokenRef?: string | null, secretRef?: string | null, createdAt: string }
            | { __typename: 'GitHubOAuthIntegration' }
            | { __typename: 'SlackIntegration' }
           }
        | { __typename: 'NoOpTriggeredAction', readOnly: boolean }
        | { __typename: 'NotificationTriggeredAction', title?: string | null, message?: string | null, severity?: AlertSeverity | null, entityName: string, readOnly: boolean, integration:
            | { __typename: 'GenericWebhookIntegration', id: string }
            | { __typename: 'GitHubOAuthIntegration', id: string }
            | { __typename: 'SlackIntegration', channelName: string, id: string }
           }
        | { __typename: 'PushNotificationTriggeredAction', title?: string | null, body?: string | null, readOnly: boolean, user: { __typename: 'User', id: string, username?: string | null } }
        | { __typename: 'QueueJobTriggeredAction', template: any, readOnly: boolean, queue?: { __typename: 'RunQueue', id: string, name: string } | null }
       }> } | null };

export type FetchArtifactCollectionTriggersQueryVariables = Exact<{
  artifactCollectionID: Scalars['ID']['input'];
}>;


export type FetchArtifactCollectionTriggersQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, name: string, triggers: { __typename: 'TriggerConnection', edges: Array<{ __typename: 'TriggerEdge', node: { __typename: 'Trigger', id: string, name: string, createdAt: string, updatedAt?: string | null, enabled: boolean, description?: string | null, readOnly: boolean, lastExecutedAt?: string | null, createdBy: { __typename: 'User', id: string, name: string }, scope:
              | { __typename: 'ArtifactPortfolio', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
              | { __typename: 'ArtifactSequence', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
              | { __typename: 'Entity', id: string, name: string, isTeam: boolean }
              | { __typename: 'Project', id: string, name: string, entityName: string }
            , triggeringCondition: { __typename: 'FilterEventTriggeringCondition', eventType: EventTriggeringConditionType, filter: string }, triggeredAction:
              | { __typename: 'ARIATriggeredAction', prompt: string, readOnly: boolean }
              | { __typename: 'GenericWebhookTriggeredAction', entityName: string, requestPayload?: any | null, readOnly: boolean, integration:
                  | { __typename: 'GenericWebhookIntegration', id: string, name: string, urlEndpoint: string, accessTokenRef?: string | null, secretRef?: string | null, createdAt: string }
                  | { __typename: 'GitHubOAuthIntegration' }
                  | { __typename: 'SlackIntegration' }
                 }
              | { __typename: 'NoOpTriggeredAction', readOnly: boolean }
              | { __typename: 'NotificationTriggeredAction', title?: string | null, message?: string | null, severity?: AlertSeverity | null, entityName: string, readOnly: boolean, integration:
                  | { __typename: 'GenericWebhookIntegration', id: string }
                  | { __typename: 'GitHubOAuthIntegration', id: string }
                  | { __typename: 'SlackIntegration', channelName: string, id: string }
                 }
              | { __typename: 'PushNotificationTriggeredAction', title?: string | null, body?: string | null, readOnly: boolean, user: { __typename: 'User', id: string, username?: string | null } }
              | { __typename: 'QueueJobTriggeredAction', template: any, readOnly: boolean, queue?: { __typename: 'RunQueue', id: string, name: string } | null }
             } }> } }
    | { __typename: 'ArtifactSequence', id: string, name: string, triggers: { __typename: 'TriggerConnection', edges: Array<{ __typename: 'TriggerEdge', node: { __typename: 'Trigger', id: string, name: string, createdAt: string, updatedAt?: string | null, enabled: boolean, description?: string | null, readOnly: boolean, lastExecutedAt?: string | null, createdBy: { __typename: 'User', id: string, name: string }, scope:
              | { __typename: 'ArtifactPortfolio', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
              | { __typename: 'ArtifactSequence', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
              | { __typename: 'Entity', id: string, name: string, isTeam: boolean }
              | { __typename: 'Project', id: string, name: string, entityName: string }
            , triggeringCondition: { __typename: 'FilterEventTriggeringCondition', eventType: EventTriggeringConditionType, filter: string }, triggeredAction:
              | { __typename: 'ARIATriggeredAction', prompt: string, readOnly: boolean }
              | { __typename: 'GenericWebhookTriggeredAction', entityName: string, requestPayload?: any | null, readOnly: boolean, integration:
                  | { __typename: 'GenericWebhookIntegration', id: string, name: string, urlEndpoint: string, accessTokenRef?: string | null, secretRef?: string | null, createdAt: string }
                  | { __typename: 'GitHubOAuthIntegration' }
                  | { __typename: 'SlackIntegration' }
                 }
              | { __typename: 'NoOpTriggeredAction', readOnly: boolean }
              | { __typename: 'NotificationTriggeredAction', title?: string | null, message?: string | null, severity?: AlertSeverity | null, entityName: string, readOnly: boolean, integration:
                  | { __typename: 'GenericWebhookIntegration', id: string }
                  | { __typename: 'GitHubOAuthIntegration', id: string }
                  | { __typename: 'SlackIntegration', channelName: string, id: string }
                 }
              | { __typename: 'PushNotificationTriggeredAction', title?: string | null, body?: string | null, readOnly: boolean, user: { __typename: 'User', id: string, username?: string | null } }
              | { __typename: 'QueueJobTriggeredAction', template: any, readOnly: boolean, queue?: { __typename: 'RunQueue', id: string, name: string } | null }
             } }> } }
   | null };

export type DeleteTriggerMutationVariables = Exact<{
  triggerID: Scalars['ID']['input'];
}>;


export type DeleteTriggerMutation = { __typename: 'Mutation', deleteTrigger: { __typename: 'DeleteTriggerPayload', success: boolean } };

export type FetchTriggerTemplateVariablesQueryVariables = Exact<{
  eventType: EventTriggeringConditionType;
}>;


export type FetchTriggerTemplateVariablesQuery = { __typename: 'Query', triggerTemplateVariables: Array<{ __typename: 'TriggerTemplateVariable', value: string, help: string }> };

export type RunLogLinesQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  useImprovedPagination?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RunLogLinesQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, state?: string | null, logLines?: { __typename: 'LogLineConnection', edges: Array<{ __typename: 'LogLineEdge', node: { __typename: 'LogLine', id?: string | null, label?: string | null, level?: string | null, line?: string | null, number?: number | null, timestamp?: string | null } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null } | null } | null };

export type OrganizationMembersTableQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationMembersTableQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, billingUser?: { __typename: 'User', id: string, username?: string | null } | null, members: Array<{ __typename: 'OrganizationMember', id: string, name: string, username: string, email: string, photoUrl: string, lastActiveAt?: string | null, role: string, modelsSeat: string, weaveRole: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null }>, seatAvailability: { __typename: 'OrganizationSeatAvailability', viewOnlySeats: number, seats: number }, teams: Array<{ __typename: 'Entity', id: string, name: string, memberCount: number }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, availableSeatsToPurchase: number, privileges: any, plan: { __typename: 'Plan', id: string, planType: PlanType, unitPrice?: number | null } }>, pendingInvites: Array<{ __typename: 'Invite', id: string, email?: string | null, createdAt?: string | null, role: string, toUser?: { __typename: 'User', id: string, username?: string | null } | null, entity?: { __typename: 'Entity', id: string, name: string } | null }> } | null };

export type WorkspaceSingleRunQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
}>;


export type WorkspaceSingleRunQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, name: string, config?: any | null, createdAt: string, displayName?: string | null, defaultColorIndex?: number | null, state?: string | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }> } | null } | null };

export type NotebookQuotaQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type NotebookQuotaQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, notebookQuota: { __typename: 'NotebookQuota', sandboxCreditExhausted: boolean, storageQuotaExceeded: boolean } } | null };

export type NotebookTable_NotebookFragment = { __typename: 'Notebook', id: string, name: string, lastUpdated: string, viewerPermissions: Array<NotebookPermission>, author?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, project: { __typename: 'Project', id: string, entityName: string, name: string }, currentVersion?: { __typename: 'NotebookVersionRef', artifactTypeName: string, artifactCollectionName: string, versionIndex: number, sourceFileName: string } | null };

export type CopyNotebookMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  projectName: Scalars['String']['input'];
}>;


export type CopyNotebookMutation = { __typename: 'Mutation', copyNotebook?: { __typename: 'DuplicateNotebookPayload', notebook?: { __typename: 'Notebook', id: string, name: string, lastUpdated: string, viewerPermissions: Array<NotebookPermission>, author?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, project: { __typename: 'Project', id: string, entityName: string, name: string }, currentVersion?: { __typename: 'NotebookVersionRef', artifactTypeName: string, artifactCollectionName: string, versionIndex: number, sourceFileName: string } | null } | null } | null };

export type DeleteNotebookMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteNotebookMutation = { __typename: 'Mutation', deleteNotebook?: { __typename: 'DeleteNotebookPayload', success?: boolean | null } | null };

export type RenameNotebookMutationVariables = Exact<{
  name: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}>;


export type RenameNotebookMutation = { __typename: 'Mutation', renameNotebook?: { __typename: 'RenameNotebookPayload', notebook?: { __typename: 'Notebook', id: string, name: string, lastUpdated: string, viewerPermissions: Array<NotebookPermission>, author?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, project: { __typename: 'Project', id: string, entityName: string, name: string }, currentVersion?: { __typename: 'NotebookVersionRef', artifactTypeName: string, artifactCollectionName: string, versionIndex: number, sourceFileName: string } | null } | null } | null };

export type NotebookAuthorOptionsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  skipEntity: Scalars['Boolean']['input'];
  skipOrganization: Scalars['Boolean']['input'];
}>;


export type NotebookAuthorOptionsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, members: Array<{ __typename: 'Member', id?: string | null, role?: string | null, name: string, pending?: boolean | null, username?: string | null }> } | null, organization?: { __typename: 'Organization', id: string, members: Array<{ __typename: 'OrganizationMember', id: string, name: string, username: string }> } | null };

export type ProjectListFragment = { __typename: 'Project', name: string, access?: string | null, entityName: string, createdAt: string, lastActive?: string | null, totalRuns: number, entity: { __typename: 'Entity', id: string, entityType?: string | null } };

export type ProjectsByTeamQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectsByTeamQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, access?: string | null, entityName: string, createdAt: string, lastActive?: string | null, totalRuns: number, entity: { __typename: 'Entity', id: string, entityType?: string | null } } | null }>, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type ProjectsByAccountQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectsByAccountQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, access?: string | null, entityName: string, createdAt: string, lastActive?: string | null, totalRuns: number, entity: { __typename: 'Entity', id: string, entityType?: string | null } } | null }>, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } | null } | null };

export type ProjectsByUserQueryVariables = Exact<{
  userName: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectsByUserQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, username?: string | null, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, access?: string | null, entityName: string, createdAt: string, lastActive?: string | null, totalRuns: number, entity: { __typename: 'Entity', id: string, entityType?: string | null } } | null }>, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } | null } | null };

export type ArtifactMetricSearchQueryVariables = Exact<{
  artifactCollectionId: Scalars['ID']['input'];
  membershipIds: Array<Scalars['ID']['input']>;
  metricNamePattern?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ArtifactMetricSearchQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, artifactMetricSearch: Array<{ __typename: 'ArtifactMetricSearchResult', name: string }> }
    | { __typename: 'ArtifactSequence', id: string }
   | null };

export type ArtifactMetricValuesQueryVariables = Exact<{
  artifactCollectionId: Scalars['ID']['input'];
  membershipIds: Array<Scalars['ID']['input']>;
  metricName: Scalars['String']['input'];
}>;


export type ArtifactMetricValuesQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, artifactMetricValues: Array<{ __typename: 'ArtifactMetricValue', membershipId: string, versionIndex?: number | null, aliases: Array<string>, value?: number | null, historyStep?: any | null, sourceRunName?: string | null, sourceProjectName?: string | null }> }
    | { __typename: 'ArtifactSequence', id: string }
   | null };

export type ArtifactVersionSelectionDataQueryVariables = Exact<{
  artifactCollectionID: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type ArtifactVersionSelectionDataQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, artifact?: { __typename: 'Artifact', id: string, createdAt: string, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } | null }> } }
    | { __typename: 'ArtifactSequence', id: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, artifact?: { __typename: 'Artifact', id: string, createdAt: string, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } | null }> } }
   | null };

export type CreateReportButtonProjectQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateReportButtonProjectQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, totalRuns?: number | null } | null };

export type NotebookPermissionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NotebookPermissionsQuery = { __typename: 'Query', notebook?: { __typename: 'Notebook', id: string, viewerPermissions: Array<NotebookPermission> } | null };

export type PanelNotebookQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PanelNotebookQuery = { __typename: 'Query', notebook?: { __typename: 'Notebook', id: string, name: string, lastUpdated: string, staticOutputUrl?: string | null, viewerPermissions: Array<NotebookPermission> } | null };

export type SetSandboxEnvVarsMutationVariables = Exact<{
  input: SetSandboxEnvVarsInput;
}>;


export type SetSandboxEnvVarsMutation = { __typename: 'Mutation', setSandboxEnvVars?: { __typename: 'SetSandboxEnvVarsPayload', success?: boolean | null } | null };

export type RunComparerQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RunComparerQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, runInfo?: { __typename: 'RunInfo', program?: string | null, args: Array<string>, os?: string | null, python?: string | null, colab?: string | null, executable?: string | null, codeSaved?: boolean | null, cpuCount?: number | null, cpuCountLogical?: number | null, gpuCount?: number | null, gpu?: string | null, codePath?: string | null, git?: { __typename: 'GitInfo', remote?: string | null, commit?: string | null } | null, slurm?: { __typename: 'SlurmInfo', jobId: string } | null } | null } }> } | null } | null };

export type ProjectDetailsQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectDetailsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, fromV2?: boolean | null } | null };

export type BackendLinesDeltasFragmentFragment = { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> };

export type BackendLinesRunDeltasFragmentFragment = { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null };

export type BackendLinesDeltaQueryFragmentFragment = { __typename: 'Project', entityName: string, name: string, runs?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null };

export type BackendLinesDeltaQueryLegacyFragmentFragment = { __typename: 'Project', entityName: string, name: string, pinnedRuns?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null, runs?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null };

export type BackendLinesDeltaQuery_Dd_Dq_U_BldqQueryVariables = Exact<{
  bucketedHistorySpecs: Array<Scalars['JSONString']['input']>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  entityName: Scalars['String']['input'];
  excludeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  includePinnedRuns?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  pinnedRunIds: Array<Scalars['ID']['input']>;
  projectName: Scalars['String']['input'];
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  primaryLineType?: InputMaybe<Scalars['String']['input']>;
}>;


export type BackendLinesDeltaQuery_Dd_Dq_U_BldqQuery = { __typename: 'Query', pinnedRuns?: { __typename: 'RunsResult', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }, project?: { __typename: 'Project', id: string, entityName: string, name: string, runs?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null } | null };

export type BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQueryVariables = Exact<{
  bucketedHistorySpecs: Array<Scalars['JSONString']['input']>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  excludeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  includePinnedRuns?: InputMaybe<Scalars['Boolean']['input']>;
  internalId: Scalars['ID']['input'];
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  pinnedRunFilters?: InputMaybe<Scalars['JSONString']['input']>;
  pinnedRunsLimit: Scalars['Int']['input'];
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  primaryLineType?: InputMaybe<Scalars['String']['input']>;
}>;


export type BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, entityName: string, name: string, pinnedRuns?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null, runs?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null } | null };

export type RunsInfoQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
}>;


export type RunsInfoQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null, codePath?: string | null, codePathLocal?: string | null } | null } }> } | null } | null };

export type BucketedHistoryDeltasFragmentFragment = { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> };

export type RunDeltasFragmentFragment = { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null };

export type DeltaQueryFragmentWithoutRunInfoFragment = { __typename: 'Project', entityName: string, name: string, runs?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null };

export type DeltaQueryLegacyFragmentWithoutRunInfoFragment = { __typename: 'Project', entityName: string, name: string, pinnedRuns?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null, runs?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null };

export type BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQueryVariables = Exact<{
  bucketedHistorySpecs: Array<Scalars['JSONString']['input']>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  entityName: Scalars['String']['input'];
  excludeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  includePinnedRuns?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  pinnedRunIds: Array<Scalars['ID']['input']>;
  projectName: Scalars['String']['input'];
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  primaryLineType?: InputMaybe<Scalars['String']['input']>;
}>;


export type BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQuery = { __typename: 'Query', pinnedRuns?: { __typename: 'RunsResult', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }, project?: { __typename: 'Project', id: string, entityName: string, name: string, runs?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null } | null };

export type BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQueryVariables = Exact<{
  bucketedHistorySpecs: Array<Scalars['JSONString']['input']>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  excludeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  includePinnedRuns?: InputMaybe<Scalars['Boolean']['input']>;
  internalId: Scalars['ID']['input'];
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  pinnedRunFilters?: InputMaybe<Scalars['JSONString']['input']>;
  pinnedRunsLimit: Scalars['Int']['input'];
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  primaryLineType?: InputMaybe<Scalars['String']['input']>;
}>;


export type BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, entityName: string, name: string, pinnedRuns?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null, runs?: { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null } | null } | null };

export type GroupedBackendLinesDeltaQueryFragmentFragment = { __typename: 'Project', entityName: string, name: string, groupedRuns?:
    | { __typename: 'GroupedRunConnection', deltas?: { __typename: 'GroupBucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'GroupBucketDiff', op: DiffOperation, groupedRun?: { __typename: 'GroupedRun', lines: Array<any>, createdAt?: string | null, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, totalRuns: number, includedRuns: number, summaryMetrics?: any | null, updatedAt?: string | null, group?: string | null, jobType?: string | null, state?: string | null, host?: string | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
    | { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
   | null };

export type GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQueryVariables = Exact<{
  bucketedHistorySpecs: Array<Scalars['JSONString']['input']>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  entityName: Scalars['String']['input'];
  excludeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
  expressions?: InputMaybe<Array<Scalars['JSONString']['input']>>;
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  groupingDepth?: InputMaybe<Scalars['Int']['input']>;
  selections?: InputMaybe<Scalars['JSONString']['input']>;
  stabilizeRunGroups?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  order: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  primaryLineType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, entityName: string, name: string, groupedRuns?:
      | { __typename: 'GroupedRunConnection', deltas?: { __typename: 'GroupBucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'GroupBucketDiff', op: DiffOperation, groupedRun?: { __typename: 'GroupedRun', lines: Array<any>, createdAt?: string | null, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, totalRuns: number, includedRuns: number, summaryMetrics?: any | null, updatedAt?: string | null, group?: string | null, jobType?: string | null, state?: string | null, host?: string | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
      | { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
     | null } | null };

export type GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQueryVariables = Exact<{
  bucketedHistorySpecs: Array<Scalars['JSONString']['input']>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  excludeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
  expressions?: InputMaybe<Array<Scalars['JSONString']['input']>>;
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  groupingDepth?: InputMaybe<Scalars['Int']['input']>;
  selections?: InputMaybe<Scalars['JSONString']['input']>;
  stabilizeRunGroups?: InputMaybe<Scalars['Boolean']['input']>;
  internalId: Scalars['ID']['input'];
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  order: Scalars['String']['input'];
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  primaryLineType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, entityName: string, name: string, groupedRuns?:
      | { __typename: 'GroupedRunConnection', deltas?: { __typename: 'GroupBucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'GroupBucketDiff', op: DiffOperation, groupedRun?: { __typename: 'GroupedRun', lines: Array<any>, createdAt?: string | null, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, totalRuns: number, includedRuns: number, summaryMetrics?: any | null, updatedAt?: string | null, group?: string | null, jobType?: string | null, state?: string | null, host?: string | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
      | { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, lines: Array<any>, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
     | null } | null };

export type GroupedDeltaQueryFragmentWithoutRunInfoFragment = { __typename: 'Project', groupedRuns?:
    | { __typename: 'GroupedRunConnection', deltas?: { __typename: 'GroupBucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'GroupBucketDiff', op: DiffOperation, groupedRun?: { __typename: 'GroupedRun', bucketedHistory: Array<any>, createdAt?: string | null, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, totalRuns: number, includedRuns: number, summaryMetrics?: any | null, updatedAt?: string | null, group?: string | null, jobType?: string | null, state?: string | null, host?: string | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
    | { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
   | null };

export type GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQueryVariables = Exact<{
  bucketedHistorySpecs: Array<Scalars['JSONString']['input']>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  entityName: Scalars['String']['input'];
  excludeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
  expressions?: InputMaybe<Array<Scalars['JSONString']['input']>>;
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  groupingDepth?: InputMaybe<Scalars['Int']['input']>;
  selections?: InputMaybe<Scalars['JSONString']['input']>;
  stabilizeRunGroups?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  order: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  primaryLineType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, groupedRuns?:
      | { __typename: 'GroupedRunConnection', deltas?: { __typename: 'GroupBucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'GroupBucketDiff', op: DiffOperation, groupedRun?: { __typename: 'GroupedRun', bucketedHistory: Array<any>, createdAt?: string | null, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, totalRuns: number, includedRuns: number, summaryMetrics?: any | null, updatedAt?: string | null, group?: string | null, jobType?: string | null, state?: string | null, host?: string | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
      | { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
     | null } | null };

export type GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQueryVariables = Exact<{
  bucketedHistorySpecs: Array<Scalars['JSONString']['input']>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  excludeOutliers?: InputMaybe<Scalars['Boolean']['input']>;
  expressions?: InputMaybe<Array<Scalars['JSONString']['input']>>;
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  groupingDepth?: InputMaybe<Scalars['Int']['input']>;
  selections?: InputMaybe<Scalars['JSONString']['input']>;
  stabilizeRunGroups?: InputMaybe<Scalars['Boolean']['input']>;
  internalId: Scalars['ID']['input'];
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  maxGroups?: InputMaybe<Scalars['Int']['input']>;
  order: Scalars['String']['input'];
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  primaryLineType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, groupedRuns?:
      | { __typename: 'GroupedRunConnection', deltas?: { __typename: 'GroupBucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'GroupBucketDiff', op: DiffOperation, groupedRun?: { __typename: 'GroupedRun', bucketedHistory: Array<any>, createdAt?: string | null, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, totalRuns: number, includedRuns: number, summaryMetrics?: any | null, updatedAt?: string | null, group?: string | null, jobType?: string | null, state?: string | null, host?: string | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
      | { __typename: 'RunConnection', deltas?: { __typename: 'BucketDiffs', order: Array<string>, incomplete?: Array<string> | null, delta: Array<{ __typename: 'BucketDiff', op: DiffOperation, run?: { __typename: 'Run', bucketedHistory: Array<any>, config?: any | null, defaultColorIndex?: number | null, displayName?: string | null, id: string, name: string, projectId: string, summaryMetrics?: any | null, updatedAt?: string | null, commit?: string | null, createdAt: string, heartbeatAt?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } | null }> } | null }
     | null } | null };

export type LinePlotRunFragmentFragment = { __typename: 'Run', commit?: string | null, createdAt: string, heartbeatAt?: string | null, defaultColorIndex?: number | null, displayName?: string | null, group?: string | null, groupCounts?: Array<number> | null, host?: string | null, jobType?: string | null, projectId: string, state?: string | null, stopped?: boolean | null, project?: { __typename: 'Project', id: string, entityName: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null };

export type ProjectHasProtectedArtifactQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type ProjectHasProtectedArtifactQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, hasProtectedArtifact: boolean } | null };

export type StarProjectMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type StarProjectMutation = { __typename: 'Mutation', starProject?: { __typename: 'StarProjectPayload', clientMutationId?: string | null, project?: { __typename: 'Project', id: string, starred: boolean } | null } | null };

export type UnstarProjectMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnstarProjectMutation = { __typename: 'Mutation', unstarProject?: { __typename: 'UnstarProjectPayload', clientMutationId?: string | null, project?: { __typename: 'Project', id: string, starred: boolean } | null } | null };

export type TeamMemberRolesQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type TeamMemberRolesQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, members: Array<{ __typename: 'Member', id?: string | null, role?: string | null, username?: string | null, memberRole?: { __typename: 'Role', ID: string, name: string } | null }> } | null };

export type UpdateUserProjectRoleMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  userProjectRole: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserProjectRoleMutation = { __typename: 'Mutation', updateProjectMember?: { __typename: 'UpdateProjectMemberPayload', success: boolean, clientMutationId?: string | null } | null };

export type ProjectOverviewQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectOverviewQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, entityName: string, description?: string | null, lastActive?: string | null, access?: string | null, computeHours: number, totalUsers?: number | null, totalRuns: number, user?: { __typename: 'User', id: string } | null, entity: { __typename: 'Entity', id: string, name: string, isTeam: boolean } } | null };

export type ProjectPicker_ProjectFragment = { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, createdAt: string };

export type ProjectPickerQueryVariables = Exact<{
  count?: InputMaybe<Scalars['Int']['input']>;
  entityName: Scalars['String']['input'];
  order?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
  includeViewerAndTeamProjects: Scalars['Boolean']['input'];
  skipEntity: Scalars['Boolean']['input'];
  skipOrganization: Scalars['Boolean']['input'];
  userName: Scalars['String']['input'];
}>;


export type ProjectPickerQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, createdAt: string } | null }> } | null } | null, viewer?: { __typename: 'User', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, createdAt: string } | null }> } | null } | null, user?: { __typename: 'User', id: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, createdAt: string } | null }> } | null } | null }> } | null } | null, organization?: { __typename: 'Organization', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, createdAt: string } | null }> } | null } | null };

export type LegacyMrProjectQueryVariables = Exact<{
  orgEntityName: Scalars['String']['input'];
  registryProjectName: Scalars['String']['input'];
}>;


export type LegacyMrProjectQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, isMigratedRegistryProject: boolean, entity: { __typename: 'Entity', id: string, name: string, modelRegistryMigrationConfig?: { __typename: 'ModelRegistryMigrationConfig', blockWritesLegacyModelRegistry: boolean, blockWritesMigratedModelRegistry: boolean, migrationCompletedAt?: string | null, orgRegistryProject?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null }, legacyModelRegistryProject?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null };

export type MigratedArtifactCollectionQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  artifactCollectionName: Scalars['String']['input'];
}>;


export type MigratedArtifactCollectionQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, artifactCollection?:
      | { __typename: 'ArtifactPortfolio', id: string, name: string, modelRegistryMigratedArtifactCollection?:
          | { __typename: 'ArtifactPortfolio', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
          | { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
         | null }
      | { __typename: 'ArtifactSequence', id: string, name: string, modelRegistryMigratedArtifactCollection?:
          | { __typename: 'ArtifactPortfolio', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
          | { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
         | null }
     | null } | null };

export type ModelRegistryMigrationConfigFragmentFragment = { __typename: 'ModelRegistryMigrationConfig', blockWritesLegacyModelRegistry: boolean, blockWritesMigratedModelRegistry: boolean, migrationCompletedAt?: string | null, orgRegistryProject?: { __typename: 'Project', id: string, name: string, entityName: string } | null };

export type OrgMrConfigQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrgMrConfigQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, orgEntity?: { __typename: 'Entity', id: string, modelRegistryMigrationConfig?: { __typename: 'ModelRegistryMigrationConfig', blockWritesLegacyModelRegistry: boolean, blockWritesMigratedModelRegistry: boolean, migrationCompletedAt?: string | null, orgRegistryProject?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null } | null } | null };

export type EntityMrConfigQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type EntityMrConfigQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, modelRegistryMigrationConfig?: { __typename: 'ModelRegistryMigrationConfig', blockWritesLegacyModelRegistry: boolean, blockWritesMigratedModelRegistry: boolean, migrationCompletedAt?: string | null, orgRegistryProject?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null } | null };

export type OrgTeamsMrConfigQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrgTeamsMrConfigQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, teams: Array<{ __typename: 'Entity', id: string, name: string, modelRegistryMigrationConfig?: { __typename: 'ModelRegistryMigrationConfig', blockWritesLegacyModelRegistry: boolean, blockWritesMigratedModelRegistry: boolean, migrationCompletedAt?: string | null, orgRegistryProject?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null }> } | null };

export type FetchArtifactTypeNamesQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchArtifactTypeNamesQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, orgEntity?: { __typename: 'Entity', id: string, name: string, artifactTypeNames?: { __typename: 'ArtifactTypeNameConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactTypeNameEdge', node: string, cursor: string }> } | null } | null } | null };

export type OrganizationMemberFragmentFragment = { __typename: 'OrganizationMember', orgID: string, admin: boolean, username: string, name: string, id: string, email: string, photoUrl: string, role: string, modelsSeat: string, user: { __typename: 'User', id: string, accountType?: UserAccountType | null, admin?: boolean | null } };

export type RegistryMembersQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type RegistryMembersQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, members: Array<{ __typename: 'OrganizationMember', orgID: string, admin: boolean, username: string, name: string, id: string, email: string, photoUrl: string, role: string, modelsSeat: string, user: { __typename: 'User', id: string, accountType?: UserAccountType | null, admin?: boolean | null } }> } | null };

export type RegistryOrganizationQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type RegistryOrganizationQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, members: Array<{ __typename: 'OrganizationMember', orgID: string, admin: boolean, username: string, name: string, id: string, email: string, photoUrl: string, role: string, modelsSeat: string, user: { __typename: 'User', id: string, accountType?: UserAccountType | null, admin?: boolean | null } }>, teams: Array<{ __typename: 'Entity', id: string, name: string, photoUrl?: string | null, memberCount: number }>, serviceAccounts: Array<{ __typename: 'ServiceAccount', id: string, name: string, accountType: UserAccountType }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type OrganizationReadOnlyQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrganizationReadOnlyQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, orgEntity?: { __typename: 'Entity', id: string, name: string, readOnly?: boolean | null } | null, advancedRegistryFeatures?: { __typename: 'AdvancedRegistryFeatures', advancedUI: boolean, advancedSearch: boolean } | null } | null };

export type ProjectReadOnlyQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type ProjectReadOnlyQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, project?: { __typename: 'Project', id: string, readOnly?: boolean | null } | null } | null };

export type RegistryAvailableTeamsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type RegistryAvailableTeamsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, registryAvailableTeams: Array<{ __typename: 'RegistryAvailableTeam', team: { __typename: 'TeamSummary', id: string, name: string, photoUrl?: string | null, memberCount: number }, role?: { __typename: 'Role', ID: string, name: string } | null }> } | null };

export type RegistrySearchArtifactMembershipsFragmentFragment = { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, metadata?: any | null, size: any, usedCount: number, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null };

type RegistrySearchCollectionFragment_ArtifactPortfolio_Fragment = { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } };

type RegistrySearchCollectionFragment_ArtifactSequence_Fragment = { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } };

export type RegistrySearchCollectionFragmentFragment =
  | RegistrySearchCollectionFragment_ArtifactPortfolio_Fragment
  | RegistrySearchCollectionFragment_ArtifactSequence_Fragment
;

export type RegistrySearchResultFragmentFragment = { __typename: 'ArtifactCollectionSearchConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionSearchEdge', artifactMatch: boolean, lastUpdatedAt: string, cursor: string, node:
      | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
      | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
    , artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, metadata?: any | null, size: any, usedCount: number, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null } | null }> } }> };

export type FetchArtifactCollectionsPartialQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  artifactsLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FetchArtifactCollectionsPartialQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, orgEntity?: { __typename: 'Entity', id: string, name: string, artifactCollectionsSearch?: { __typename: 'ArtifactCollectionSearchConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionSearchEdge', artifactMatch: boolean, lastUpdatedAt: string, cursor: string, node:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
            | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
          , artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, metadata?: any | null, size: any, usedCount: number, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null } | null }> } }> } | null } | null } | null };

export type FetchArtifactMembershipsPartialQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchArtifactMembershipsPartialQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, metadata?: any | null, size: any, usedCount: number, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null } | null }> } }
    | { __typename: 'ArtifactSequence', id: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, metadata?: any | null, size: any, usedCount: number, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null } | null }> } }
   | null };

export type FetchArtifactCollectionSupplementalQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
}>;


export type FetchArtifactCollectionSupplementalQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, project?: { __typename: 'Project', id: string, name: string } | null, artifacts: { __typename: 'VersionedArtifactConnection', totalCount: number, edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, usedBy: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, user?: { __typename: 'User', id: string, name: string } | null } }> } } }> } }
    | { __typename: 'ArtifactSequence', id: string, project?: { __typename: 'Project', id: string, name: string } | null, artifacts: { __typename: 'VersionedArtifactConnection', totalCount: number, edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, usedBy: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, user?: { __typename: 'User', id: string, name: string } | null } }> } } }> } }
   | null };

type RegistryCollectionFragment_ArtifactPortfolio_Fragment = { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null, artifactType: { __typename: 'ArtifactType', id: string, name: string } };

type RegistryCollectionFragment_ArtifactSequence_Fragment = { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null, artifactType: { __typename: 'ArtifactType', id: string, name: string } };

export type RegistryCollectionFragmentFragment =
  | RegistryCollectionFragment_ArtifactPortfolio_Fragment
  | RegistryCollectionFragment_ArtifactSequence_Fragment
;

type RegistryCollectionWithDetailsFragment_ArtifactPortfolio_Fragment = { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string }, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, artifactType: { __typename: 'ArtifactType', id: string, name: string }, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } };

type RegistryCollectionWithDetailsFragment_ArtifactSequence_Fragment = { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string }, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, artifactType: { __typename: 'ArtifactType', id: string, name: string }, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } };

export type RegistryCollectionWithDetailsFragmentFragment =
  | RegistryCollectionWithDetailsFragment_ArtifactPortfolio_Fragment
  | RegistryCollectionWithDetailsFragment_ArtifactSequence_Fragment
;

export type PageInfoFragmentFragment = { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean };

export type ProjectInfoFragmentFragment = { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } };

export type RegistryCollectionsQueryVariables = Exact<{
  organization: Scalars['String']['input'];
  registryFilter?: InputMaybe<Scalars['JSONString']['input']>;
  collectionFilter?: InputMaybe<Scalars['JSONString']['input']>;
  collectionTypes?: InputMaybe<Array<ArtifactCollectionType>>;
  order?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RegistryCollectionsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, orgEntity?: { __typename: 'Entity', id: string, name: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null, artifactType: { __typename: 'ArtifactType', id: string, name: string } }
            | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null, artifactType: { __typename: 'ArtifactType', id: string, name: string } }
           | null }> } | null } | null } | null };

export type RegistryCollectionsWithDetailsQueryVariables = Exact<{
  organization: Scalars['String']['input'];
  registryFilter?: InputMaybe<Scalars['JSONString']['input']>;
  collectionFilter?: InputMaybe<Scalars['JSONString']['input']>;
  collectionTypes?: InputMaybe<Array<ArtifactCollectionType>>;
  order?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RegistryCollectionsWithDetailsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, orgEntity?: { __typename: 'Entity', id: string, name: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string }, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, artifactType: { __typename: 'ArtifactType', id: string, name: string }, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
            | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string }, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, artifactType: { __typename: 'ArtifactType', id: string, name: string }, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
           | null }> } | null } | null } | null };

export type RegistryCollectionsByProjectQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RegistryCollectionsByProjectQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
          | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, artifacts: { __typename: 'VersionedArtifactConnection', totalCount: number } }
          | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, artifacts: { __typename: 'VersionedArtifactConnection', totalCount: number } }
         | null }> } | null } | null };

export type RegistryHuggingFaceImportFieldsFragment = { __typename: 'RegistryHuggingFaceImport', id: string, state: RegistryHuggingFaceImportState, hfRepoId: string, hfRequestedRevision: string, artifactCollectionName: string, registryCollectionName?: string | null, errorMessage?: string | null, createdAt: string, terminalAt?: string | null, sandboxId?: string | null, entity?: { __typename: 'Entity', id: string, name: string } | null, project?: { __typename: 'Project', id: string, name: string } | null, registryProject?: { __typename: 'Project', id: string, name: string, entityName: string, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null };

export type CreateRegistryHuggingFaceImportMutationVariables = Exact<{
  input: CreateRegistryHuggingFaceImportInput;
}>;


export type CreateRegistryHuggingFaceImportMutation = { __typename: 'Mutation', createRegistryHuggingFaceImport?: { __typename: 'CreateRegistryHuggingFaceImportPayload', registryHuggingFaceImport: { __typename: 'RegistryHuggingFaceImport', id: string, state: RegistryHuggingFaceImportState, hfRepoId: string, hfRequestedRevision: string, artifactCollectionName: string, registryCollectionName?: string | null, errorMessage?: string | null, createdAt: string, terminalAt?: string | null, sandboxId?: string | null, entity?: { __typename: 'Entity', id: string, name: string } | null, project?: { __typename: 'Project', id: string, name: string } | null, registryProject?: { __typename: 'Project', id: string, name: string, entityName: string, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null } } | null };

export type RegistryHuggingFaceImportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RegistryHuggingFaceImportQuery = { __typename: 'Query', registryHuggingFaceImport?: { __typename: 'RegistryHuggingFaceImport', id: string, state: RegistryHuggingFaceImportState, hfRepoId: string, hfRequestedRevision: string, artifactCollectionName: string, registryCollectionName?: string | null, errorMessage?: string | null, createdAt: string, terminalAt?: string | null, sandboxId?: string | null, entity?: { __typename: 'Entity', id: string, name: string } | null, project?: { __typename: 'Project', id: string, name: string } | null, registryProject?: { __typename: 'Project', id: string, name: string, entityName: string, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null } | null };

export type RegistryHuggingFaceImportsQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegistryHuggingFaceImportsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, registryHuggingFaceImports: { __typename: 'RegistryHuggingFaceImportConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'RegistryHuggingFaceImportEdge', node: { __typename: 'RegistryHuggingFaceImport', id: string, state: RegistryHuggingFaceImportState, hfRepoId: string, hfRequestedRevision: string, artifactCollectionName: string, registryCollectionName?: string | null, errorMessage?: string | null, createdAt: string, terminalAt?: string | null, sandboxId?: string | null, entity?: { __typename: 'Entity', id: string, name: string } | null, project?: { __typename: 'Project', id: string, name: string } | null, registryProject?: { __typename: 'Project', id: string, name: string, entityName: string, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null } }> } } | null };

export type CreateRegistryMembersMutationVariables = Exact<{
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectId: Scalars['ID']['input'];
}>;


export type CreateRegistryMembersMutation = { __typename: 'Mutation', createProjectMembers?: { __typename: 'CreateProjectMembersPayload', success: boolean } | null };

export type DeleteRegistryMembersMutationVariables = Exact<{
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectId: Scalars['ID']['input'];
}>;


export type DeleteRegistryMembersMutation = { __typename: 'Mutation', deleteProjectMembers?: { __typename: 'DeleteProjectMembersPayload', success: boolean } | null };

export type UpdateUserRegistryRoleMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  userProjectRole: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserRegistryRoleMutation = { __typename: 'Mutation', updateProjectMember?: { __typename: 'UpdateProjectMemberPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateTeamRegistryRoleMutationVariables = Exact<{
  teamId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  teamProjectRole: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTeamRegistryRoleMutation = { __typename: 'Mutation', updateProjectTeamMember?: { __typename: 'UpdateProjectTeamMemberPayload', success: boolean, clientMutationId?: string | null } | null };

export type ArtifactMembershipFragmentFragment = { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, size: any, usedCount: number, artifactCreatedAt: string, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null, artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null }
    | { __typename: 'ArtifactSequence', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null }
   | null };

export type ArtifactMembershipsQueryVariables = Exact<{
  organization: Scalars['String']['input'];
  registryFilter?: InputMaybe<Scalars['JSONString']['input']>;
  collectionFilter?: InputMaybe<Scalars['JSONString']['input']>;
  artifactFilter?: InputMaybe<Scalars['JSONString']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type ArtifactMembershipsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, orgEntity?: { __typename: 'Entity', id: string, name: string, artifactMemberships?: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, size: any, usedCount: number, artifactCreatedAt: string, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null, artifactCollection?:
              | { __typename: 'ArtifactPortfolio', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null }
              | { __typename: 'ArtifactSequence', id: string, name: string, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null }
             | null } | null }> } | null } | null } | null };

export type RegistryModelDeploymentFieldsFragment = { __typename: 'RegistryModelDeployment', id: string, name: string, registryVersionIndex: number, registryCollectionId: string, registryMembershipId: string, engine: string, spec: any, endpointUrl?: string | null, desiredState: RegistryModelDeploymentDesiredState, state: RegistryModelDeploymentState, phase?: string | null, terminalAt?: string | null, createdAt: string, updatedAt: string, createdBy?: { __typename: 'User', id: string, name: string } | null, sandboxWorkloads: { __typename: 'RegistryModelDeploymentSandboxWorkloadConnection', edges: Array<{ __typename: 'RegistryModelDeploymentSandboxWorkloadEdge', node: { __typename: 'RegistryModelDeploymentSandboxWorkload', id: string, seq: number, state: string, providerId?: string | null, createdAt: string, terminalAt?: string | null, lastErrorCode?: string | null, lastErrorMessage?: string | null } }> } };

export type CreateRegistryModelDeploymentMutationVariables = Exact<{
  input: CreateRegistryModelDeploymentInput;
}>;


export type CreateRegistryModelDeploymentMutation = { __typename: 'Mutation', createRegistryModelDeployment?: { __typename: 'CreateRegistryModelDeploymentPayload', registryModelDeployment: { __typename: 'RegistryModelDeployment', id: string, name: string, registryVersionIndex: number, registryCollectionId: string, registryMembershipId: string, engine: string, spec: any, endpointUrl?: string | null, desiredState: RegistryModelDeploymentDesiredState, state: RegistryModelDeploymentState, phase?: string | null, terminalAt?: string | null, createdAt: string, updatedAt: string, createdBy?: { __typename: 'User', id: string, name: string } | null, sandboxWorkloads: { __typename: 'RegistryModelDeploymentSandboxWorkloadConnection', edges: Array<{ __typename: 'RegistryModelDeploymentSandboxWorkloadEdge', node: { __typename: 'RegistryModelDeploymentSandboxWorkload', id: string, seq: number, state: string, providerId?: string | null, createdAt: string, terminalAt?: string | null, lastErrorCode?: string | null, lastErrorMessage?: string | null } }> } } } | null };

export type StopRegistryModelDeploymentMutationVariables = Exact<{
  input: StopRegistryModelDeploymentInput;
}>;


export type StopRegistryModelDeploymentMutation = { __typename: 'Mutation', stopRegistryModelDeployment?: { __typename: 'StopRegistryModelDeploymentPayload', registryModelDeployment?: { __typename: 'RegistryModelDeployment', id: string, name: string, registryVersionIndex: number, registryCollectionId: string, registryMembershipId: string, engine: string, spec: any, endpointUrl?: string | null, desiredState: RegistryModelDeploymentDesiredState, state: RegistryModelDeploymentState, phase?: string | null, terminalAt?: string | null, createdAt: string, updatedAt: string, createdBy?: { __typename: 'User', id: string, name: string } | null, sandboxWorkloads: { __typename: 'RegistryModelDeploymentSandboxWorkloadConnection', edges: Array<{ __typename: 'RegistryModelDeploymentSandboxWorkloadEdge', node: { __typename: 'RegistryModelDeploymentSandboxWorkload', id: string, seq: number, state: string, providerId?: string | null, createdAt: string, terminalAt?: string | null, lastErrorCode?: string | null, lastErrorMessage?: string | null } }> } } | null } | null };

export type RegistryModelDeploymentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RegistryModelDeploymentQuery = { __typename: 'Query', registryModelDeployment?: { __typename: 'RegistryModelDeployment', id: string, name: string, registryVersionIndex: number, registryCollectionId: string, registryMembershipId: string, engine: string, spec: any, endpointUrl?: string | null, desiredState: RegistryModelDeploymentDesiredState, state: RegistryModelDeploymentState, phase?: string | null, terminalAt?: string | null, createdAt: string, updatedAt: string, createdBy?: { __typename: 'User', id: string, name: string } | null, sandboxWorkloads: { __typename: 'RegistryModelDeploymentSandboxWorkloadConnection', edges: Array<{ __typename: 'RegistryModelDeploymentSandboxWorkloadEdge', node: { __typename: 'RegistryModelDeploymentSandboxWorkload', id: string, seq: number, state: string, providerId?: string | null, createdAt: string, terminalAt?: string | null, lastErrorCode?: string | null, lastErrorMessage?: string | null } }> } } | null };

export type RegistryVersionDeploymentsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  collectionName: Scalars['String']['input'];
  aliasName: Scalars['String']['input'];
  first: Scalars['Int']['input'];
}>;


export type RegistryVersionDeploymentsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactCollection?:
      | { __typename: 'ArtifactPortfolio', id: string, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, registryModelDeployments: { __typename: 'RegistryModelDeploymentConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'RegistryModelDeploymentEdge', node: { __typename: 'RegistryModelDeployment', id: string, name: string, registryVersionIndex: number, registryCollectionId: string, registryMembershipId: string, engine: string, spec: any, endpointUrl?: string | null, desiredState: RegistryModelDeploymentDesiredState, state: RegistryModelDeploymentState, phase?: string | null, terminalAt?: string | null, createdAt: string, updatedAt: string, createdBy?: { __typename: 'User', id: string, name: string } | null, sandboxWorkloads: { __typename: 'RegistryModelDeploymentSandboxWorkloadConnection', edges: Array<{ __typename: 'RegistryModelDeploymentSandboxWorkloadEdge', node: { __typename: 'RegistryModelDeploymentSandboxWorkload', id: string, seq: number, state: string, providerId?: string | null, createdAt: string, terminalAt?: string | null, lastErrorCode?: string | null, lastErrorMessage?: string | null } }> } } }> } } | null }
      | { __typename: 'ArtifactSequence', id: string, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, registryModelDeployments: { __typename: 'RegistryModelDeploymentConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'RegistryModelDeploymentEdge', node: { __typename: 'RegistryModelDeployment', id: string, name: string, registryVersionIndex: number, registryCollectionId: string, registryMembershipId: string, engine: string, spec: any, endpointUrl?: string | null, desiredState: RegistryModelDeploymentDesiredState, state: RegistryModelDeploymentState, phase?: string | null, terminalAt?: string | null, createdAt: string, updatedAt: string, createdBy?: { __typename: 'User', id: string, name: string } | null, sandboxWorkloads: { __typename: 'RegistryModelDeploymentSandboxWorkloadConnection', edges: Array<{ __typename: 'RegistryModelDeploymentSandboxWorkloadEdge', node: { __typename: 'RegistryModelDeploymentSandboxWorkload', id: string, seq: number, state: string, providerId?: string | null, createdAt: string, terminalAt?: string | null, lastErrorCode?: string | null, lastErrorMessage?: string | null } }> } } }> } } | null }
     | null } | null };

export type RegistryCollectionDeploymentsQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
}>;


export type RegistryCollectionDeploymentsQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, registryModelDeployments: { __typename: 'RegistryModelDeploymentConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'RegistryModelDeploymentEdge', node: { __typename: 'RegistryModelDeployment', id: string, name: string, registryVersionIndex: number, registryCollectionId: string, registryMembershipId: string, engine: string, spec: any, endpointUrl?: string | null, desiredState: RegistryModelDeploymentDesiredState, state: RegistryModelDeploymentState, phase?: string | null, terminalAt?: string | null, createdAt: string, updatedAt: string, createdBy?: { __typename: 'User', id: string, name: string } | null, sandboxWorkloads: { __typename: 'RegistryModelDeploymentSandboxWorkloadConnection', edges: Array<{ __typename: 'RegistryModelDeploymentSandboxWorkloadEdge', node: { __typename: 'RegistryModelDeploymentSandboxWorkload', id: string, seq: number, state: string, providerId?: string | null, createdAt: string, terminalAt?: string | null, lastErrorCode?: string | null, lastErrorMessage?: string | null } }> } } }> } }
    | { __typename: 'ArtifactSequence', id: string, registryModelDeployments: { __typename: 'RegistryModelDeploymentConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'RegistryModelDeploymentEdge', node: { __typename: 'RegistryModelDeployment', id: string, name: string, registryVersionIndex: number, registryCollectionId: string, registryMembershipId: string, engine: string, spec: any, endpointUrl?: string | null, desiredState: RegistryModelDeploymentDesiredState, state: RegistryModelDeploymentState, phase?: string | null, terminalAt?: string | null, createdAt: string, updatedAt: string, createdBy?: { __typename: 'User', id: string, name: string } | null, sandboxWorkloads: { __typename: 'RegistryModelDeploymentSandboxWorkloadConnection', edges: Array<{ __typename: 'RegistryModelDeploymentSandboxWorkloadEdge', node: { __typename: 'RegistryModelDeploymentSandboxWorkload', id: string, seq: number, state: string, providerId?: string | null, createdAt: string, terminalAt?: string | null, lastErrorCode?: string | null, lastErrorMessage?: string | null } }> } } }> } }
   | null };

export type RegistryCollectionDeploymentCountsQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  states?: InputMaybe<Array<RegistryModelDeploymentState>>;
}>;


export type RegistryCollectionDeploymentCountsQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, registryModelDeployments: { __typename: 'RegistryModelDeploymentConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'RegistryModelDeploymentEdge', node: { __typename: 'RegistryModelDeployment', id: string, registryVersionIndex: number, state: RegistryModelDeploymentState } }> } }
    | { __typename: 'ArtifactSequence', id: string, registryModelDeployments: { __typename: 'RegistryModelDeploymentConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'RegistryModelDeploymentEdge', node: { __typename: 'RegistryModelDeployment', id: string, registryVersionIndex: number, state: RegistryModelDeploymentState } }> } }
   | null };

export type RegistryProjectArtifactTypesQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type RegistryProjectArtifactTypesQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string } | null }> } } | null };

export type RegistryProjectMembersQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type RegistryProjectMembersQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, user?: { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null, email?: string | null, accountType?: UserAccountType | null } | null, members: Array<{ __typename: 'ProjectMember', id: string, username?: string | null, name?: string | null, photoUrl?: string | null, email?: string | null, accountType: string, projectRoleIsInherited: boolean, role: { __typename: 'Role', ID: string, name: string } }>, teamMembers: Array<{ __typename: 'ProjectTeamMember', role: { __typename: 'Role', ID: string, name: string }, team: { __typename: 'Entity', id: string, name: string, photoUrl?: string | null, memberCount: number, members: Array<{ __typename: 'Member', id?: string | null, role?: string | null, name: string, photoUrl?: string | null, accountType?: string | null }> } }> } | null };

export type RegistryProjectMemberQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  memberID: Scalars['ID']['input'];
}>;


export type RegistryProjectMemberQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, member?: { __typename: 'ProjectMember', id: string, projectRoleIsInherited: boolean, role: { __typename: 'Role', ID: string, name: string } } | null, teamMembers: Array<{ __typename: 'ProjectTeamMember', role: { __typename: 'Role', ID: string, name: string }, team: { __typename: 'Entity', id: string, member?: { __typename: 'Member', id?: string | null, role?: string | null } | null } }> } | null };

export type BatchRegistryViewerMembershipQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  viewerID: Scalars['ID']['input'];
  projectIDs: Array<Scalars['ID']['input']>;
}>;


export type BatchRegistryViewerMembershipQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, member?: { __typename: 'ProjectMember', id: string, name?: string | null } | null, teamMembers: Array<{ __typename: 'ProjectTeamMember', team: { __typename: 'Entity', id: string, member?: { __typename: 'Member', id?: string | null, role?: string | null, name: string } | null } }> } | null }> } | null };

export type ProjectFragmentFragment = { __typename: 'Project', internalId: string, name: string, entityName: string, access?: string | null, createdAt: string, lastActive?: string | null, updatedAt?: string | null, description?: string | null, totalArtifactCollections: number, allowAllArtifactTypesInRegistry: boolean, user?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string } | null }> }, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null };

export type RegistryProjectsSearchFragmentFragment = { __typename: 'ProjectConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, access?: string | null, createdAt: string, lastActive?: string | null, updatedAt?: string | null, description?: string | null, totalArtifactCollections: number, allowAllArtifactTypesInRegistry: boolean, user?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string } | null }> }, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null }> };

export type FetchRegistryProjectsPartialQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FetchRegistryProjectsPartialQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, registries?: { __typename: 'ProjectConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, access?: string | null, createdAt: string, lastActive?: string | null, updatedAt?: string | null, description?: string | null, totalArtifactCollections: number, allowAllArtifactTypesInRegistry: boolean, user?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string } | null }> }, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null }> } | null } | null };

export type LegacyRegistryProjectsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  pattern: Scalars['String']['input'];
}>;


export type LegacyRegistryProjectsQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, access?: string | null, createdAt: string, lastActive?: string | null, updatedAt?: string | null, description?: string | null, totalArtifactCollections: number, allowAllArtifactTypesInRegistry: boolean, user?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string } | null }> }, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null }> } | null };

export type RegistryProjectsWithTypeQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  artifactTypeName: Scalars['String']['input'];
}>;


export type RegistryProjectsWithTypeQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, registries?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, allowAllArtifactTypesInRegistry: boolean, entityName: string, readOnly?: boolean | null, artifactType?: { __typename: 'ArtifactType', id: string, name: string } | null } | null }> } | null } | null };

export type UpsertRegistryProjectMutationVariables = Exact<{
  description?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  access?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['ID']['input']>;
  allowAllArtifactTypesInRegistry?: InputMaybe<Scalars['Boolean']['input']>;
  artifactTypes?: InputMaybe<Array<ArtifactTypeInput>>;
  icon?: InputMaybe<ProjectIconInput>;
}>;


export type UpsertRegistryProjectMutation = { __typename: 'Mutation', upsertModel?: { __typename: 'UpsertModelPayload', inserted?: boolean | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, description?: string | null, access?: string | null, allowAllArtifactTypesInRegistry: boolean, user?: { __typename: 'User', id: string } | null, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null } | null };

export type RegistryProjectQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type RegistryProjectQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, orgEntity?: { __typename: 'Entity', id: string, name: string, project?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, access?: string | null, createdAt: string, lastActive?: string | null, updatedAt?: string | null, description?: string | null, totalArtifactCollections: number, allowAllArtifactTypesInRegistry: boolean, user?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string } | null }> }, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null } | null } | null };

export type StarredRegistriesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type StarredRegistriesQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, starredRegistries?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, access?: string | null, createdAt: string, lastActive?: string | null, updatedAt?: string | null, description?: string | null, totalArtifactCollections: number, allowAllArtifactTypesInRegistry: boolean, user?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string } | null }> }, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null }> } | null } | null };

export type AddProjectProtectedAliasesMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  aliases: Array<Scalars['String']['input']>;
}>;


export type AddProjectProtectedAliasesMutation = { __typename: 'Mutation', addProjectProtectedAliases?: { __typename: 'AddProjectProtectedAliasesPayload', aliases: Array<string> } | null };

export type RemoveProjectProtectedAliasesMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  aliases: Array<Scalars['String']['input']>;
}>;


export type RemoveProjectProtectedAliasesMutation = { __typename: 'Mutation', removeProjectProtectedAliases?: { __typename: 'RemoveProjectProtectedAliasesPayload', aliases: Array<string> } | null };

export type ProjectProtectedAliasesQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type ProjectProtectedAliasesQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }> } | null };

export type ArtifactMembershipsWithAliasCountQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  alias: Scalars['String']['input'];
}>;


export type ArtifactMembershipsWithAliasCountQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, artifactMembershipsWithAliasCount: number } | null };

export type FetchRegistryArtifactCollectionsPartialQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  artifactsLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FetchRegistryArtifactCollectionsPartialQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactCollectionsSearch?: { __typename: 'ArtifactCollectionSearchConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionSearchEdge', artifactMatch: boolean, lastUpdatedAt: string, cursor: string, node:
          | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
          | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
        , artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, metadata?: any | null, size: any, usedCount: number, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null } | null }> } }> } | null } | null };

export type FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  artifactsLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FetchEntityModelRegistryArtifactCollectionsPartialQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, artifactCollectionsSearch?: { __typename: 'ArtifactCollectionSearchConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionSearchEdge', artifactMatch: boolean, lastUpdatedAt: string, cursor: string, node:
          | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
          | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, updatedAt?: string | null, defaultArtifactType: { __typename: 'ArtifactType', id: string, name: string }, project?: { __typename: 'Project', id: string, name: string, entityName: string, protectedArtifactAliases: Array<{ __typename: 'ProtectedArtifactAlias', alias: string }>, icon?: { __typename: 'ProjectIcon', name: string, color: string } | null } | null, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
        , artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifact?: { __typename: 'Artifact', id: string, metadata?: any | null, size: any, usedCount: number, tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any }> } | null } | null }> } }> } | null } | null };

export type StarRegistryMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  registryName: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type StarRegistryMutation = { __typename: 'Mutation', starRegistry?: { __typename: 'StarRegistryPayload', clientMutationId?: string | null } | null };

export type UnstarRegistryMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  registryName: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnstarRegistryMutation = { __typename: 'Mutation', unstarRegistry?: { __typename: 'UnstarRegistryPayload', clientMutationId?: string | null } | null };

export type ArtifactUsageLimitStatusFieldsFragment = { __typename: 'ArtifactUsageLimitStatus', current: any, projected: any, limit?: any | null, band: ArtifactUsageLimitBand };

export type OrganizationRegistryUsageLimitQueryVariables = Exact<{
  organizationName: Scalars['String']['input'];
  requestedIncrease: Scalars['Int64']['input'];
}>;


export type OrganizationRegistryUsageLimitQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, registryUsageLimit: { __typename: 'ArtifactUsageLimitStatus', current: any, projected: any, limit?: any | null, band: ArtifactUsageLimitBand } } | null };

export type RegistryCollectionUsageLimitQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  requestedIncrease: Scalars['Int64']['input'];
}>;


export type RegistryCollectionUsageLimitQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, registryCollectionUsageLimit?: { __typename: 'ArtifactUsageLimitStatus', current: any, projected: any, limit?: any | null, band: ArtifactUsageLimitBand } | null } | null };

export type LinkedArtifactVersionUsageLimitQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  requestedIncrease: Scalars['Int64']['input'];
}>;


export type LinkedArtifactVersionUsageLimitQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, linkedArtifactVersionUsageLimit?: { __typename: 'ArtifactUsageLimitStatus', current: any, projected: any, limit?: any | null, band: ArtifactUsageLimitBand } | null }
    | { __typename: 'ArtifactSequence', id: string }
   | null };

export type ArtifactVersionUsageLimitQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  requestedIncrease: Scalars['Int64']['input'];
}>;


export type ArtifactVersionUsageLimitQuery = { __typename: 'Query', artifactSequence?: { __typename: 'ArtifactSequence', id: string, artifactVersionUsageLimit?: { __typename: 'ArtifactUsageLimitStatus', current: any, projected: any, limit?: any | null, band: ArtifactUsageLimitBand } | null } | null };

export type LinkArtifactMutationVariables = Exact<{
  artifactID?: InputMaybe<Scalars['ID']['input']>;
  artifactPortfolioID?: InputMaybe<Scalars['ID']['input']>;
  aliases?: InputMaybe<Array<ArtifactAliasInput>>;
}>;


export type LinkArtifactMutation = { __typename: 'Mutation', linkArtifact?: { __typename: 'LinkArtifactPayload', artifactCollectionID: string, artifactID: string, createdAt: string, versionIndex?: number | null, clientMutationId?: string | null } | null };

export type CreateAndLinkWeaveAssetMutationVariables = Exact<{
  ref: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  artifactPortfolioID?: InputMaybe<Scalars['ID']['input']>;
  artifactPortfolioName?: InputMaybe<Scalars['String']['input']>;
  aliases?: InputMaybe<Array<ArtifactAliasInput>>;
}>;


export type CreateAndLinkWeaveAssetMutation = { __typename: 'Mutation', createAndLinkWeaveAsset?: { __typename: 'LinkArtifactPayload', artifactCollectionID: string, artifactID: string, createdAt: string, versionIndex?: number | null, clientMutationId?: string | null } | null };

export type DeployVersionFilesQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  aliasName: Scalars['String']['input'];
  first: Scalars['Int']['input'];
}>;


export type DeployVersionFilesQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, files?: { __typename: 'FileConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, sizeBytes: any } | null }> } | null } | null }
    | { __typename: 'ArtifactSequence', id: string, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, files?: { __typename: 'FileConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, sizeBytes: any } | null }> } | null } | null }
   | null };

export type ImportPanelMenuProjectsQueryVariables = Exact<{
  userName: Scalars['String']['input'];
  selectedEntityName?: InputMaybe<Scalars['String']['input']>;
  projectSearchQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type ImportPanelMenuProjectsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string } | null }> } | null } | null, user?: { __typename: 'User', id: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string } | null }> } | null } | null }> } | null } | null };

export type ImportPanelMenuEntityFragmentFragment = { __typename: 'Entity', id: string, name: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string } | null }> } | null };

export type ImportPanelMenuViewsQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ImportPanelMenuViewsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, allViews?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, name?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null } | null }> } | null } | null };

export type ImportPanelProjectViewsFragmentFragment = { __typename: 'View', id: string, name?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null };

export type ImportPanelMenuViewSpecQueryVariables = Exact<{
  viewId: Scalars['ID']['input'];
}>;


export type ImportPanelMenuViewSpecQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, spec?: any | null } | null };

export type ReportsTableFragmentFragment = { __typename: 'View', id: string, displayName?: string | null, description?: string | null, starCount: number, createdAt: string, updatedAt?: string | null, starred?: boolean | null, showcasedAt?: string | null, previewUrl?: string | null, viewCount: number, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null } | null };

export type ReproduceRun_FileFragment = { __typename: 'File', id: string, name: string, url?: string | null };

export type ReproduceRun_RunFragment = { __typename: 'Run', id: string, name: string, displayName?: string | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, runInfo?: { __typename: 'RunInfo', args: Array<string>, codePath?: string | null, codePathLocal?: string | null, executable?: string | null, os?: string | null, program?: string | null, python?: string | null, git?: { __typename: 'GitInfo', remote?: string | null, commit?: string | null } | null } | null, reproduceRunFiles?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, url?: string | null } | null }> } | null };

export type ReproduceRunDrawerQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type ReproduceRunDrawerQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, name: string, displayName?: string | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, runInfo?: { __typename: 'RunInfo', args: Array<string>, codePath?: string | null, codePathLocal?: string | null, executable?: string | null, os?: string | null, program?: string | null, python?: string | null, git?: { __typename: 'GitInfo', remote?: string | null, commit?: string | null } | null } | null, reproduceRunFiles?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, url?: string | null } | null }> } | null } | null } | null };

export type RunDetailsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
}>;


export type RunDetailsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, entityName: string, name: string, access?: string | null, readOnly?: boolean | null, entity: { __typename: 'Entity', id: string, claimingEntity?: { __typename: 'Entity', id: string, name: string } | null }, run?: { __typename: 'Run', id: string, group?: string | null, displayName?: string | null, name: string, summaryMetrics?: any | null, config?: any | null, createdAt: string, historyMaterializationTask?: { __typename: 'Task', id: string, type: string, state: TaskState, progress: number, updatedAt?: string | null } | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null, servicesAvailable?: { __typename: 'RunServicesAvailable', tensorboard?: boolean | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string } | null } | null } | null };

export type RunsDetailsUserQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type RunsDetailsUserQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, user?: { __typename: 'User', id: string, username?: string | null, apiKey?: string | null, accountType?: UserAccountType | null } | null } | null };

export type RunPageLogsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
}>;


export type RunPageLogsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, group?: string | null, state?: string | null, historyKeys?: any | null, createdAt: string, logLineCount?: number | null, sweep?: { __typename: 'Sweep', id: string } | null, outputLogFile?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, sizeBytes: any, url?: string | null } | null }> } | null } | null } | null };

export type RunFiles_FileFragment = { __typename: 'File', id: string, name: string, url?: string | null, sizeBytes: any, updatedAt?: string | null, artifact?: { __typename: 'Artifact', id: string, digest: string } | null };

export type RunFilesQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
  maxNumFiles: Scalars['Int']['input'];
}>;


export type RunFilesQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, run?: { __typename: 'Run', id: string, name: string, fileCount?: number | null, codeArtifact?: { __typename: 'Artifact', id: string, fileCount: any } | null, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, url?: string | null, sizeBytes: any, updatedAt?: string | null, artifact?: { __typename: 'Artifact', id: string, digest: string } | null } | null }> } | null } | null } | null };

export type RunFilesAndFoldersQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
  maxNumFiles: Scalars['Int']['input'];
  folderPath?: InputMaybe<Scalars['String']['input']>;
}>;


export type RunFilesAndFoldersQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, run?: { __typename: 'Run', id: string, name: string, projectId: string, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, url?: string | null, sizeBytes: any, updatedAt?: string | null, artifact?: { __typename: 'Artifact', id: string, digest: string } | null } | null }> } | null, folders?: { __typename: 'Folders', folderList: Array<{ __typename: 'FolderMetadata', name: string, size: any, numberOfFiles: any } | null> } | null } | null } | null };

export type RunFiles_DirectUrlFragment = { __typename: 'File', id: string, name: string, directUrl: string };

export type FileDownloadUrlQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
}>;


export type FileDownloadUrlQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, directUrl: string } | null }> } | null } | null } | null };

export type RunSelectorFieldAggregationsQueryVariables = Exact<{
  projectInternalId: Scalars['ID']['input'];
  fieldPattern: Scalars['String']['input'];
}>;


export type RunSelectorFieldAggregationsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, fields: { __typename: 'ProjectFieldConnection', edges: Array<{ __typename: 'ProjectFieldEdge', node: { __typename: 'ProjectField', path: string } }> } } | null };

export type CrossProjectRunsProjectsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  userName: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
}>;


export type CrossProjectRunsProjectsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, createdAt: string } | null }> } | null } | null, viewer?: { __typename: 'User', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, createdAt: string } | null }> } | null } | null, user?: { __typename: 'User', id: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, createdAt: string } | null }> } | null } | null }> } | null } | null };

export type CrossProjectRunsRunsQueryVariables = Exact<{
  internalId: Scalars['ID']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type CrossProjectRunsRunsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null } }> } | null } | null };

export type AllRunGroupsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
}>;


export type AllRunGroupsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, group?: string | null } }> } | null } | null };

export type GetRunsForMoveGroupsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
}>;


export type GetRunsForMoveGroupsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, group?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null } }> } | null } | null };

export type MoveRunToGroupMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  groupName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runId: Scalars['String']['input'];
}>;


export type MoveRunToGroupMutation = { __typename: 'Mutation', upsertBucket?: { __typename: 'UpsertBucketPayload', bucket?: { __typename: 'Run', id: string, group?: string | null } | null } | null };

export type MoveRunDrawerProjectQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type MoveRunDrawerProjectQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, totalUsers?: number | null } | null };

export type RunValueSuggestionsPaginatedQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  keyPath: Scalars['String']['input'];
  valuePattern?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RunValueSuggestionsPaginatedQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runFieldValues?: { __typename: 'RunFieldValueConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'RunFieldValueEdge', node: { __typename: 'RunFieldValue', value?: any | null } }> } | null } | null };

export type ProjectTotalRunsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectTotalRunsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, totalRuns?: number | null } | null };

export type ProjectRunsCountQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectRunsCountQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runCount: number } | null };

export type ProjectLastActiveQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectLastActiveQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, lastActive?: string | null } | null };

export type SweepRunsCountQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  sweepName: Scalars['String']['input'];
}>;


export type SweepRunsCountQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, sweep?: { __typename: 'Sweep', id: string, runCount: number } | null } | null };

export type RunsTableFragmentFragment = { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string, heartbeatAt?: string | null, updatedAt?: string | null, notes?: string | null, groupCounts?: Array<number> | null, user?: { __typename: 'User', id: string, username?: string | null, name: string, accountType?: UserAccountType | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }> };

export type SandboxFieldsFragment = { __typename: 'Sandbox', sandboxId: string, displayName?: string | null, sourceTemplateId?: string | null, sourceTemplateRevision?: any | null, spec?: { __typename: 'SandboxSpec', tags: Array<string>, mode: SandboxModeV1, runtimeClass: string } | null, status?: { __typename: 'SandboxObservedStatus', state: SandboxState, stateReason: string, createTime?: string | null, startTime?: string | null, endTime?: string | null, runnerId: string, runnerGroupId: string, effectiveRuntimeClass: string, resourceUsage?: { __typename: 'SandboxV1ResourceUsage', cpuMillicores: any, memoryMb: any, gpuCount: any } | null, services: Array<{ __typename: 'SandboxServiceStatus', name: string, port: number, url: string, protocol: SandboxServiceProtocol, visibility: SandboxServiceVisibility, endpoint?: { __typename: 'SandboxEndpointStatus', kind: SandboxEndpointKind, auth: SandboxEndpointAuth, url: string } | null }>, effectiveIngress: Array<{ __typename: 'SandboxIngressRule', tenant?: SandboxTenantScope | null, any?: boolean | null, cidr?: { __typename: 'SandboxCIDRBlock', cidr: string, except: Array<string> } | null, ports: Array<{ __typename: 'SandboxPortRangeV1', protocol: string, port: number, endPort: number }> }>, effectiveEgress: Array<{ __typename: 'SandboxEgressRule', dnsName?: string | null, tenant?: SandboxTenantScope | null, any?: boolean | null, cidr?: { __typename: 'SandboxCIDRBlock', cidr: string, except: Array<string> } | null, ports: Array<{ __typename: 'SandboxPortRangeV1', protocol: string, port: number, endPort: number }> }> } | null };

export type SandboxesConnectionQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<SandboxState>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  showTerminated?: InputMaybe<Scalars['Boolean']['input']>;
  runnerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  volumeIds?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type SandboxesConnectionQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, organizationId?: string | null, sandboxesConnection: { __typename: 'SandboxConnection', edges: Array<{ __typename: 'SandboxEdge', node: { __typename: 'Sandbox', sandboxId: string, displayName?: string | null, sourceTemplateId?: string | null, sourceTemplateRevision?: any | null, spec?: { __typename: 'SandboxSpec', tags: Array<string>, mode: SandboxModeV1, runtimeClass: string } | null, status?: { __typename: 'SandboxObservedStatus', state: SandboxState, stateReason: string, createTime?: string | null, startTime?: string | null, endTime?: string | null, runnerId: string, runnerGroupId: string, effectiveRuntimeClass: string, resourceUsage?: { __typename: 'SandboxV1ResourceUsage', cpuMillicores: any, memoryMb: any, gpuCount: any } | null, services: Array<{ __typename: 'SandboxServiceStatus', name: string, port: number, url: string, protocol: SandboxServiceProtocol, visibility: SandboxServiceVisibility, endpoint?: { __typename: 'SandboxEndpointStatus', kind: SandboxEndpointKind, auth: SandboxEndpointAuth, url: string } | null }>, effectiveIngress: Array<{ __typename: 'SandboxIngressRule', tenant?: SandboxTenantScope | null, any?: boolean | null, cidr?: { __typename: 'SandboxCIDRBlock', cidr: string, except: Array<string> } | null, ports: Array<{ __typename: 'SandboxPortRangeV1', protocol: string, port: number, endPort: number }> }>, effectiveEgress: Array<{ __typename: 'SandboxEgressRule', dnsName?: string | null, tenant?: SandboxTenantScope | null, any?: boolean | null, cidr?: { __typename: 'SandboxCIDRBlock', cidr: string, except: Array<string> } | null, ports: Array<{ __typename: 'SandboxPortRangeV1', protocol: string, port: number, endPort: number }> }> } | null } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } } | null };

export type SandboxQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  sandboxId: Scalars['ID']['input'];
}>;


export type SandboxQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, organizationId?: string | null, sandbox?: { __typename: 'Sandbox', sandboxId: string, displayName?: string | null, sourceTemplateId?: string | null, sourceTemplateRevision?: any | null, spec?: { __typename: 'SandboxSpec', tags: Array<string>, mode: SandboxModeV1, runtimeClass: string } | null, status?: { __typename: 'SandboxObservedStatus', state: SandboxState, stateReason: string, createTime?: string | null, startTime?: string | null, endTime?: string | null, runnerId: string, runnerGroupId: string, effectiveRuntimeClass: string, resourceUsage?: { __typename: 'SandboxV1ResourceUsage', cpuMillicores: any, memoryMb: any, gpuCount: any } | null, services: Array<{ __typename: 'SandboxServiceStatus', name: string, port: number, url: string, protocol: SandboxServiceProtocol, visibility: SandboxServiceVisibility, endpoint?: { __typename: 'SandboxEndpointStatus', kind: SandboxEndpointKind, auth: SandboxEndpointAuth, url: string } | null }>, effectiveIngress: Array<{ __typename: 'SandboxIngressRule', tenant?: SandboxTenantScope | null, any?: boolean | null, cidr?: { __typename: 'SandboxCIDRBlock', cidr: string, except: Array<string> } | null, ports: Array<{ __typename: 'SandboxPortRangeV1', protocol: string, port: number, endPort: number }> }>, effectiveEgress: Array<{ __typename: 'SandboxEgressRule', dnsName?: string | null, tenant?: SandboxTenantScope | null, any?: boolean | null, cidr?: { __typename: 'SandboxCIDRBlock', cidr: string, except: Array<string> } | null, ports: Array<{ __typename: 'SandboxPortRangeV1', protocol: string, port: number, endPort: number }> }> } | null } | null } | null };

export type SandboxLogsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  sandboxId: Scalars['ID']['input'];
  tailLines?: InputMaybe<Scalars['Int']['input']>;
  sinceTime?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type SandboxLogsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, sandbox?: { __typename: 'Sandbox', logs?: { __typename: 'SandboxLogConnection', entries: Array<{ __typename: 'SandboxLogEntry', text: string, timestamp?: string | null }> } | null } | null } | null };

export type FileSystemSnapshotFieldsFragment = { __typename: 'FileSystemSnapshot', fileSystemSnapshotId: string, state: FileSystemSnapshotState, stateReason: string, sizeBytes: any, sourceSandboxId: string, trigger: FileSystemSnapshotTrigger, createTime?: string | null, completeTime?: string | null, sourceVolumeName: string, updatedAt?: string | null };

export type FileSystemSnapshotsQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FileSystemSnapshotsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, fileSystemSnapshotsConnection: { __typename: 'FileSystemSnapshotConnection', edges: Array<{ __typename: 'FileSystemSnapshotEdge', node: { __typename: 'FileSystemSnapshot', fileSystemSnapshotId: string, state: FileSystemSnapshotState, stateReason: string, sizeBytes: any, sourceSandboxId: string, trigger: FileSystemSnapshotTrigger, createTime?: string | null, completeTime?: string | null, sourceVolumeName: string, updatedAt?: string | null } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } } | null };

export type FileSystemSnapshotQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  snapshotId: Scalars['ID']['input'];
}>;


export type FileSystemSnapshotQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, fileSystemSnapshot?: { __typename: 'FileSystemSnapshot', fileSystemSnapshotId: string, state: FileSystemSnapshotState, stateReason: string, sizeBytes: any, sourceSandboxId: string, trigger: FileSystemSnapshotTrigger, createTime?: string | null, completeTime?: string | null, sourceVolumeName: string, updatedAt?: string | null } | null } | null };

export type AccountSelectorContextProviderEntityQueryVariables = Exact<{
  teamName: Scalars['String']['input'];
}>;


export type AccountSelectorContextProviderEntityQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, isTeam: boolean, entityType?: string | null, organization?: { __typename: 'Organization', id: string, name: string } | null } | null };

export type AccountSelectorPersonalEntityUserQueryVariables = Exact<{
  teamName: Scalars['String']['input'];
}>;


export type AccountSelectorPersonalEntityUserQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, user?: { __typename: 'User', id: string } | null } | null };

export type ProfileMenuOrgRoleInfoQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  username: Scalars['String']['input'];
}>;


export type ProfileMenuOrgRoleInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, member?: { __typename: 'OrganizationMember', id: string, orgID: string, role: string, username: string } | null } | null };

export type OpenMatchingOrganizationsQueryVariables = Exact<{
  emailDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type OpenMatchingOrganizationsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, openMatchingOrganizations: Array<{ __typename: 'Organization', id: string, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, status: OrganizationSubscriptionStatus }>, teams: Array<{ __typename: 'Entity', id: string, settings: { __typename: 'EntitySettings', openToMatchingOrgEmailDomainUsers?: boolean | null } }> }> } | null };

export type SubmitSlurmCommandMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  command: SlurmCommandType;
}>;


export type SubmitSlurmCommandMutation = { __typename: 'Mutation', submitSlurmCommand?: { __typename: 'SubmitSlurmCommandPayload', success: boolean, clientMutationId?: string | null } | null };

export type SlurmLatestCommandQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type SlurmLatestCommandQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, slurmControl?: { __typename: 'RunSlurmControl', latestCommand?: { __typename: 'SlurmCommandStatus', id: string, command: SlurmCommandType, state: SlurmCommandState, errorMessage?: string | null, createdAt: string, updatedAt: string } | null } | null } | null } | null };

export type SlurmDaemonReadinessByRunNameQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type SlurmDaemonReadinessByRunNameQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, slurmControl?: { __typename: 'RunSlurmControl', health?: { __typename: 'SlurmDaemonHealth', ready: boolean, lastSeenAt?: string | null, message?: string | null } | null } | null } | null } | null };

export type UpdateTeamStorageBucketMutationVariables = Exact<{
  input: UpdateTeamStorageBucketInput;
}>;


export type UpdateTeamStorageBucketMutation = { __typename: 'Mutation', updateTeamStorageBucket: { __typename: 'UpdateTeamStorageBucketPayload', success: boolean, bucketStoreID: string, clientMutationID?: string | null, entity: { __typename: 'Entity', id: string, name: string } } };

export type WorkspaceIngestionHealthQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkspaceIngestionHealthQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', ingestionHealth: { __typename: 'IngestionHealth', status: IngestionHealthStatus } } | null };

export type UniqueKeyTypesQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  runLimit?: InputMaybe<Scalars['Int']['input']>;
  runOrder?: InputMaybe<Scalars['String']['input']>;
  requiredRunKeys?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type UniqueKeyTypesQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', uniqueKeyTypes?: Array<string> | null } | null } | null };

export type CreateNotebookMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  template: NotebookTemplate;
}>;


export type CreateNotebookMutation = { __typename: 'Mutation', createNotebook?: { __typename: 'CreateNotebookPayload', notebook?: { __typename: 'Notebook', id: string, name: string, lastUpdated: string, author?: { __typename: 'User', id: string, name: string } | null } | null } | null };

export type DuplicateNotebookMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DuplicateNotebookMutation = { __typename: 'Mutation', duplicateNotebook?: { __typename: 'DuplicateNotebookPayload', notebook?: { __typename: 'Notebook', id: string, name: string, lastUpdated: string, author?: { __typename: 'User', id: string, name: string } | null } | null } | null };

export type CreateSandboxMutationVariables = Exact<{
  notebookId: Scalars['String']['input'];
  mode: SandboxMode;
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runNames: Array<Scalars['String']['input']>;
}>;


export type CreateSandboxMutation = { __typename: 'Mutation', createSandbox?: { __typename: 'CreateSandboxPayload', id: string, url: string, token: string } | null };

export type HeartbeatSandboxMutationVariables = Exact<{
  sandboxId: Scalars['ID']['input'];
}>;


export type HeartbeatSandboxMutation = { __typename: 'Mutation', heartbeatSandbox?: { __typename: 'HeartbeatSandboxPayload', success?: boolean | null } | null };

export type NotebookFragmentFragment = { __typename: 'Notebook', id: string, name: string, lastUpdated: string, author?: { __typename: 'User', id: string, name: string } | null };

export type NotebookPermissionsFragmentFragment = { __typename: 'Notebook', id: string, viewerPermissions: Array<NotebookPermission> };

export type SourceNotebookQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SourceNotebookQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, notebooks: { __typename: 'NotebookConnection', edges: Array<{ __typename: 'NotebookEdge', cursor: string, node: { __typename: 'Notebook', id: string, name: string, lastUpdated: string, author?: { __typename: 'User', id: string, name: string } | null } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };

export type SelectedNotebookQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SelectedNotebookQuery = { __typename: 'Query', notebook?: { __typename: 'Notebook', id: string, name: string, lastUpdated: string, viewerPermissions: Array<NotebookPermission>, author?: { __typename: 'User', id: string, name: string } | null } | null };

export type ConfigValuesAggregationQueryQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  configKey: Scalars['String']['input'];
  configType: Scalars['String']['input'];
}>;


export type ConfigValuesAggregationQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', configValues?: any | null, configValuesNumberAggregation?: any | null } | null } | null };

export type ConfigValuesCategoriesQueryQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  configKey: Scalars['String']['input'];
  configType: Scalars['String']['input'];
}>;


export type ConfigValuesCategoriesQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', configValues?: any | null, configValuesCategories?: any | null } | null } | null };

export type MetricStatisticsAggregationQueryQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  metricName: Scalars['String']['input'];
}>;


export type MetricStatisticsAggregationQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', metricStatisticsAggregation?: any | null } | null } | null };

export type MetricStatisticsQueryQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  metricName: Scalars['String']['input'];
}>;


export type MetricStatisticsQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', metricStatistics?: any | null } | null } | null };

export type CreateSemanticLegendMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  metricName: Scalars['String']['input'];
  yValue: Scalars['String']['input'];
  customColors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bucketUpperBounds: Array<Scalars['Float']['input']>;
  excludedRunColor: Scalars['String']['input'];
}>;


export type CreateSemanticLegendMutation = { __typename: 'Mutation', createSemanticLegend?: { __typename: 'CreateSemanticLegendPayload', success: boolean } | null };

export type UpdateSemanticLegendMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  currentMetric: Scalars['String']['input'];
  metricName?: InputMaybe<Scalars['String']['input']>;
  yValue?: InputMaybe<Scalars['String']['input']>;
  customColors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bucketUpperBounds?: InputMaybe<Array<Scalars['Float']['input']>>;
  excludedRunColor?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSemanticLegendMutation = { __typename: 'Mutation', updateSemanticLegend?: { __typename: 'UpdateSemanticLegendPayload', success: boolean } | null };

export type SemanticLegendsQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SemanticLegendsQueryQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, semanticLegend: { __typename: 'SemanticLegend', currentMetric: string, semanticLegendsByMetric: Array<{ __typename: 'SemanticLegendByMetric', metricName?: string | null, yValue?: string | null, bucketUpperBounds?: Array<number> | null, excludedRunColor?: string | null, lastUpdatedAt?: string | null, customColors: Array<{ __typename: 'CustomColor', bucketNumber: any, colorHex: string }> } | null> } } | null };

export type CreateSemanticLegendWithCategoricalConfigMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  metricName: Scalars['String']['input'];
  yValue: Scalars['String']['input'];
  customColors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bucketUpperBounds: Array<Scalars['Float']['input']>;
  excludedRunColor: Scalars['String']['input'];
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}>;


export type CreateSemanticLegendWithCategoricalConfigMutation = { __typename: 'Mutation', createSemanticLegend?: { __typename: 'CreateSemanticLegendPayload', success: boolean } | null };

export type SemanticLegendWithCategoricalConfigFragmentFragment = { __typename: 'View', id: string, semanticLegend: { __typename: 'SemanticLegend', currentMetric: string, semanticLegendsByMetric: Array<{ __typename: 'SemanticLegendByMetric', metricName?: string | null, yValue?: string | null, bucketUpperBounds?: Array<number> | null, excludedRunColor?: string | null, lastUpdatedAt?: string | null, categories?: Array<string> | null, customColors: Array<{ __typename: 'CustomColor', bucketNumber: any, colorHex: string }> } | null> } };

export type UpdateSemanticLegendWithCategoricalConfigMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  currentMetric: Scalars['String']['input'];
  metricName?: InputMaybe<Scalars['String']['input']>;
  yValue?: InputMaybe<Scalars['String']['input']>;
  customColors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bucketUpperBounds?: InputMaybe<Array<Scalars['Float']['input']>>;
  excludedRunColor?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}>;


export type UpdateSemanticLegendWithCategoricalConfigMutation = { __typename: 'Mutation', updateSemanticLegend?: { __typename: 'UpdateSemanticLegendPayload', success: boolean, view?: { __typename: 'View', id: string, semanticLegend: { __typename: 'SemanticLegend', currentMetric: string, semanticLegendsByMetric: Array<{ __typename: 'SemanticLegendByMetric', metricName?: string | null, yValue?: string | null, bucketUpperBounds?: Array<number> | null, excludedRunColor?: string | null, lastUpdatedAt?: string | null, categories?: Array<string> | null, customColors: Array<{ __typename: 'CustomColor', bucketNumber: any, colorHex: string }> } | null> } } | null } | null };

export type SemanticLegendsQueryWithCategoricalConfigQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SemanticLegendsQueryWithCategoricalConfigQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, semanticLegend: { __typename: 'SemanticLegend', currentMetric: string, semanticLegendsByMetric: Array<{ __typename: 'SemanticLegendByMetric', metricName?: string | null, yValue?: string | null, bucketUpperBounds?: Array<number> | null, excludedRunColor?: string | null, lastUpdatedAt?: string | null, categories?: Array<string> | null, customColors: Array<{ __typename: 'CustomColor', bucketNumber: any, colorHex: string }> } | null> } } | null };

export type UpsertWorkspaceTemplateMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  linePlotTemplateId?: InputMaybe<Scalars['ID']['input']>;
  linePlotSettings?: InputMaybe<Scalars['JSONString']['input']>;
  workspaceLayoutTemplateId?: InputMaybe<Scalars['ID']['input']>;
  workspaceLayoutSettings?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type UpsertWorkspaceTemplateMutation = { __typename: 'Mutation', upsertWorkspaceTemplate?: { __typename: 'UpsertWorkspaceTemplatePayload', linePlotTemplateId?: string | null, workspaceLayoutTemplateId?: string | null } | null };

export type DeleteWorkspaceTemplateMutationVariables = Exact<{
  linePlotTemplateId?: InputMaybe<Scalars['ID']['input']>;
  workspaceLayoutTemplateId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteWorkspaceTemplateMutation = { __typename: 'Mutation', deleteWorkspaceTemplate?: { __typename: 'DeleteWorkspaceTemplatePayload', success: boolean } | null };

export type WorkspaceTemplatesQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type WorkspaceTemplatesQuery = { __typename: 'Query', workspaceTemplates: Array<{ __typename: 'WorkspaceTemplate', id: string, createdAt: string, updatedAt?: string | null, settings?: any | null, settingsVersion?: number | null, type?: WorkspaceTemplateType | null, createdBy: { __typename: 'User', id: string, name: string, email?: string | null, username?: string | null } }> };

export type CustomPanelEditorProjectQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type CustomPanelEditorProjectQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, readOnly?: boolean | null } | null };

export type ArtifactWeaveSourceQueryVariables = Exact<{
  artifactID: Scalars['ID']['input'];
}>;


export type ArtifactWeaveSourceQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, weaveSource?: { __typename: 'ArtifactWeaveSource', sourceType: WeaveSourceType } | null } | null };

export type WeaveRegistryAssetQueryVariables = Exact<{
  path: Scalars['String']['input'];
}>;


export type WeaveRegistryAssetQuery = { __typename: 'Query', registryAsset?: { __typename: 'RegistryAsset', weaveRef: string, refType: WeaveSourceType, canReadPromptContent: boolean } | null };

export type ArtifactMembershipOverviewQueryVariables = Exact<{
  artifactID: Scalars['ID']['input'];
}>;


export type ArtifactMembershipOverviewQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, digest: string, size: any, fileCount: any, usedCount: number, createdAt: string, description?: string | null, commitHash?: string | null, ttlDurationSeconds: any, ttlIsInherited: boolean, isGenerated: boolean, isLinkedToGlobalRegistry: boolean, storageRegion?: string | null, sourceVersionIndex?: number | null, artifactType: { __typename: 'ArtifactType', id: string, name: string }, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string, artifactTTLDurationSeconds: any } } | null }, createdBy?:
      | { __typename: 'Run', id: string, name: string, displayName?: string | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
      | { __typename: 'User', id: string, name: string, username?: string | null }
     | null } | null };

export type ArtifactVersionMembershipsQueryVariables = Exact<{
  artifactId: Scalars['ID']['input'];
}>;


export type ArtifactVersionMembershipsQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null, artifactCollection?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
            | { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }
           | null } | null }> } } | null };

export type ArtifactMembershipPeerArtifactsQueryVariables = Exact<{
  artifactID: Scalars['ID']['input'];
}>;


export type ArtifactMembershipPeerArtifactsQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, createdBy?:
      | { __typename: 'Run', id: string, inputArtifacts?: { __typename: 'InputArtifactConnection', edges: Array<{ __typename: 'InputArtifactEdge', node?: { __typename: 'Artifact', id: string, versionIndex?: number | null, artifactType: { __typename: 'ArtifactType', id: string, name: string }, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } } | null }> } | null }
      | { __typename: 'User' }
     | null } | null };

export type ArtifactVersionLineageInfoQueryVariables = Exact<{
  artifactID: Scalars['ID']['input'];
}>;


export type ArtifactVersionLineageInfoQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, commitHash?: string | null, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string } } | null };

export type ArtifactVersionMetadataQueryVariables = Exact<{
  artifactID: Scalars['ID']['input'];
}>;


export type ArtifactVersionMetadataQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, metadata?: any | null, artifactSequence: { __typename: 'ArtifactSequence', id: string, project?: { __typename: 'Project', id: string } | null } } | null };

export type ArtifactVersionRunConfigQueryVariables = Exact<{
  artifactID: Scalars['ID']['input'];
}>;


export type ArtifactVersionRunConfigQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, createdBy?:
      | { __typename: 'Run', id: string, config?: any | null }
      | { __typename: 'User' }
     | null } | null };

export type ArtifactVersionRunHistoryQueryVariables = Exact<{
  artifactID: Scalars['ID']['input'];
}>;


export type ArtifactVersionRunHistoryQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, runHistory: string } | null };

export type TeamsForInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamsForInvitesQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, teams: Array<{ __typename: 'Entity', id: string, name: string, memberCount: number }> } | null };

export type EntityRateLimitsFragment = { __typename: 'Entity', rateLimits?: { __typename: 'RateLimits', graphql: number, sdkGraphql: number, filestreamCount: number, filestreamPerRunCount: number, filestreamSize: number, runUpdateCount: number, sdkGraphqlQuerySeconds: number, createArtifacts: number, createArtifactsRequestCount: number, createArtifactsCollectionRequestCount: number, createArtifactsTimeWindow: number } | null };

export type ProjectRateLimitsFragment = { __typename: 'Project', rateLimits?: { __typename: 'RateLimits', filestreamCount: number, filestreamPerRunCount: number, filestreamSize: number, runUpdateCount: number, sdkGraphqlQuerySeconds: number, createArtifacts: number, createArtifactsRequestCount: number, createArtifactsCollectionRequestCount: number, createArtifactsTimeWindow: number } | null };

export type UpdateSubscriptionMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  teamsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  privateProjects?: InputMaybe<Scalars['Boolean']['input']>;
  gpuEnabled?: InputMaybe<Scalars['DateTime']['input']>;
  hubPreset?: InputMaybe<Scalars['String']['input']>;
  repo?: InputMaybe<Scalars['String']['input']>;
  disk?: InputMaybe<Scalars['String']['input']>;
  redisEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  dockerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSubscriptionMutation = { __typename: 'Mutation', updateSubscription?: { __typename: 'UpdateSubscriptionPayload', entity?: { __typename: 'Entity', id: string, name: string, available?: boolean | null, photoUrl?: string | null, limits?: any | null } | null } | null };

export type UpdateEntityPhotoMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  photoUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateEntityPhotoMutation = { __typename: 'Mutation', updateEntity?: { __typename: 'UpdateEntityPayload', entity?: { __typename: 'Entity', id: string, name: string, available?: boolean | null, photoUrl?: string | null, limits?: any | null } | null } | null };

export type TeamQueryQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type TeamQueryQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, available?: boolean | null, photoUrl?: string | null, limits?: any | null, settings: { __typename: 'EntitySettings', openToMatchingOrgEmailDomainUsers?: boolean | null } } | null };

export type UserQueryQueryVariables = Exact<{
  userName: Scalars['String']['input'];
}>;


export type UserQueryQuery = { __typename: 'Query', user?: { __typename: 'User', id: string } | null };

export type AllEntitiesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllEntitiesQuery = { __typename: 'Query', entities?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, createdAt: string, name: string, memberCount: number, isTeam: boolean, members: Array<{ __typename: 'Member', admin?: boolean | null, pending?: boolean | null, username?: string | null, email?: string | null, name: string, id?: string | null, role?: string | null }> } | null }> } | null };

export type UpdateEntityAdminMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  rateLimits?: InputMaybe<RateLimitsInput>;
}>;


export type UpdateEntityAdminMutation = { __typename: 'Mutation', updateEntity?: { __typename: 'UpdateEntityPayload', entity?: { __typename: 'Entity', id: string, isPaid?: boolean | null, rateLimits?: { __typename: 'RateLimits', graphql: number, sdkGraphql: number, filestreamCount: number, filestreamPerRunCount: number, filestreamSize: number, runUpdateCount: number, sdkGraphqlQuerySeconds: number, createArtifacts: number, createArtifactsRequestCount: number, createArtifactsCollectionRequestCount: number, createArtifactsTimeWindow: number } | null } | null } | null };

export type UpdateProjectAdminMutationVariables = Exact<{
  id: Scalars['String']['input'];
  rateLimits?: InputMaybe<RateLimitsInput>;
}>;


export type UpdateProjectAdminMutation = { __typename: 'Mutation', upsertModel?: { __typename: 'UpsertModelPayload', project?: { __typename: 'Project', id: string, rateLimits?: { __typename: 'RateLimits', filestreamCount: number, filestreamPerRunCount: number, filestreamSize: number, runUpdateCount: number, sdkGraphqlQuerySeconds: number, createArtifacts: number, createArtifactsRequestCount: number, createArtifactsCollectionRequestCount: number, createArtifactsTimeWindow: number } | null } | null } | null };

export type ProjectRateLimitsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectRateLimitsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, rateLimits?: { __typename: 'RateLimits', filestreamCount: number, filestreamPerRunCount: number, filestreamSize: number, runUpdateCount: number, sdkGraphqlQuerySeconds: number, createArtifacts: number, createArtifactsRequestCount: number, createArtifactsCollectionRequestCount: number, createArtifactsTimeWindow: number } | null } | null };

export type TriggerParquetExportMutationVariables = Exact<{
  runId: Scalars['ID']['input'];
}>;


export type TriggerParquetExportMutation = { __typename: 'Mutation', triggerParquetExport?: { __typename: 'TriggerParquetExportPayload', task: { __typename: 'Task', id: string } } | null };

export type TriggerRecomputeKeysInfoMutationVariables = Exact<{
  runId: Scalars['ID']['input'];
}>;


export type TriggerRecomputeKeysInfoMutation = { __typename: 'Mutation', triggerRecomputeKeysInfo?: { __typename: 'TriggerRecomputeKeysInfoPayload', task: { __typename: 'Task', id: string } } | null };

export type TriggerRecomputeSystemMetricsMutationVariables = Exact<{
  runId: Scalars['ID']['input'];
}>;


export type TriggerRecomputeSystemMetricsMutation = { __typename: 'Mutation', triggerRecomputeSystemMetrics?: { __typename: 'TriggerRecomputeSystemMetricsPayload', task: { __typename: 'Task', id: string } } | null };

export type TriggerEventsExportMutationVariables = Exact<{
  runId: Scalars['ID']['input'];
}>;


export type TriggerEventsExportMutation = { __typename: 'Mutation', triggerEventsExport?: { __typename: 'TriggerEventsExportPayload', task: { __typename: 'Task', id: string } } | null };

export type TriggerFlatRunsMigratorMutationVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
}>;


export type TriggerFlatRunsMigratorMutation = { __typename: 'Mutation', triggerFlatRunsMigrator?: { __typename: 'TriggerFlatRunsMigratorPayload', glueTaskName?: string | null } | null };

export type CreateFinishedRunAlertMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type CreateFinishedRunAlertMutation = { __typename: 'Mutation', createFinishedRunAlert?: { __typename: 'CreateAlertPayload', alert: { __typename: 'Alert', id: string, condition:
        | { __typename: 'FinishedRunCondition', success: boolean }
        | { __typename: 'ScriptableRunCondition' }
        | { __typename: 'StoppedRunCondition' }
      , subscriptions: Array<
        | { __typename: 'EmailSubscription', id: string }
        | { __typename: 'SlackChannelSubscription', id: string }
      > } } | null };

export type CreateStoppedRunAlertMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  minimumRunDuration: Scalars['Duration']['input'];
}>;


export type CreateStoppedRunAlertMutation = { __typename: 'Mutation', createStoppedRunAlert?: { __typename: 'CreateAlertPayload', alert: { __typename: 'Alert', id: string, condition:
        | { __typename: 'FinishedRunCondition' }
        | { __typename: 'ScriptableRunCondition' }
        | { __typename: 'StoppedRunCondition', minimumRunDuration: number }
      , subscriptions: Array<
        | { __typename: 'EmailSubscription', id: string }
        | { __typename: 'SlackChannelSubscription', id: string }
      > } } | null };

export type UpdateStoppedRunAlertMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  minimumRunDuration?: InputMaybe<Scalars['Duration']['input']>;
}>;


export type UpdateStoppedRunAlertMutation = { __typename: 'Mutation', updateStoppedRunAlert?: { __typename: 'UpdateAlertPayload', alert: { __typename: 'Alert', id: string, condition:
        | { __typename: 'FinishedRunCondition' }
        | { __typename: 'ScriptableRunCondition' }
        | { __typename: 'StoppedRunCondition', minimumRunDuration: number }
      , subscriptions: Array<
        | { __typename: 'EmailSubscription', id: string }
        | { __typename: 'SlackChannelSubscription', id: string }
      > } } | null };

export type CreateScriptableRunAlertMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type CreateScriptableRunAlertMutation = { __typename: 'Mutation', createScriptableRunAlert?: { __typename: 'CreateAlertPayload', alert: { __typename: 'Alert', id: string, condition:
        | { __typename: 'FinishedRunCondition' }
        | { __typename: 'ScriptableRunCondition', success: boolean }
        | { __typename: 'StoppedRunCondition' }
      , subscriptions: Array<
        | { __typename: 'EmailSubscription', id: string }
        | { __typename: 'SlackChannelSubscription', id: string }
      > } } | null };

export type DeleteAlertMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAlertMutation = { __typename: 'Mutation', deleteAlert?: { __typename: 'DeleteAlertPayload', success?: boolean | null } | null };

export type CreateSlackChannelSubscriptionMutationVariables = Exact<{
  alertID: Scalars['ID']['input'];
  integrationID: Scalars['ID']['input'];
}>;


export type CreateSlackChannelSubscriptionMutation = { __typename: 'Mutation', createSlackChannelSubscription?: { __typename: 'CreateSlackChannelSubscriptionPayload', subscription: { __typename: 'SlackChannelSubscription', id: string } } | null };

export type CreateEmailSubscriptionMutationVariables = Exact<{
  alertID: Scalars['ID']['input'];
}>;


export type CreateEmailSubscriptionMutation = { __typename: 'Mutation', createEmailSubscription?: { __typename: 'CreateEmailSubscriptionPayload', subscription: { __typename: 'EmailSubscription', id: string } } | null };

export type CreateViewCommentsAlertSubscriptionMutationVariables = Exact<{
  viewID: Scalars['ID']['input'];
}>;


export type CreateViewCommentsAlertSubscriptionMutation = { __typename: 'Mutation', createViewCommentsAlertSubscription?: { __typename: 'CreateEmailSubscriptionPayload', subscription: { __typename: 'EmailSubscription', id: string } } | null };

export type DeleteAlertSubscriptionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAlertSubscriptionMutation = { __typename: 'Mutation', deleteAlertSubscription?: { __typename: 'DeleteAlertSubscriptionPayload', success?: boolean | null } | null };

export type CreateReportsPromptQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateReportsPromptQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, createdAt: string, updatedAt?: string | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } }> } | null } | null };

export type CustomChartFragmentFragment = { __typename: 'CustomChart', id: string, name: string, displayName: string, spec: any, access: string, entity: { __typename: 'Entity', id: string, name: string, readOnly?: boolean | null }, user: { __typename: 'User', id: string, username?: string | null } };

export type CreateCustomChartMutationVariables = Exact<{
  entity: Scalars['String']['input'];
  name: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  type: Scalars['String']['input'];
  access: Scalars['String']['input'];
  spec: Scalars['JSONString']['input'];
}>;


export type CreateCustomChartMutation = { __typename: 'Mutation', createCustomChart?: { __typename: 'CreateCustomChartPayload', chart: { __typename: 'CustomChart', id: string, name: string, displayName: string, spec: any, access: string, entity: { __typename: 'Entity', id: string, name: string, readOnly?: boolean | null }, user: { __typename: 'User', id: string, username?: string | null } } } | null };

export type UpdateCustomChartMutationVariables = Exact<{
  entity: Scalars['String']['input'];
  name: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  access?: InputMaybe<Scalars['String']['input']>;
  spec?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type UpdateCustomChartMutation = { __typename: 'Mutation', updateCustomChart?: { __typename: 'UpdateCustomChartPayload', chart: { __typename: 'CustomChart', id: string, name: string, displayName: string, spec: any, access: string, entity: { __typename: 'Entity', id: string, name: string, readOnly?: boolean | null }, user: { __typename: 'User', id: string, username?: string | null } } } | null };

export type DeleteCustomChartMutationVariables = Exact<{
  entity: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type DeleteCustomChartMutation = { __typename: 'Mutation', deleteCustomChart?: { __typename: 'DeleteCustomChartPayload', success: boolean } | null };

export type CustomChartsQueryVariables = Exact<{
  entity: Scalars['String']['input'];
}>;


export type CustomChartsQuery = { __typename: 'Query', customCharts?: { __typename: 'CustomChartConnection', edges: Array<{ __typename: 'CustomChartEdge', node: { __typename: 'CustomChart', id: string, name: string, displayName: string, spec: any, access: string, entity: { __typename: 'Entity', id: string, name: string, readOnly?: boolean | null }, user: { __typename: 'User', id: string, username?: string | null } } }> } | null };

export type CustomChartQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CustomChartQuery = { __typename: 'Query', customChart?: { __typename: 'CustomChart', id: string, name: string, displayName: string, spec: any, access: string, entity: { __typename: 'Entity', id: string, name: string, readOnly?: boolean | null }, user: { __typename: 'User', id: string, username?: string | null } } | null };

export type CreateCustomerSubscriptionMutationVariables = Exact<{
  planId: Scalars['ID']['input'];
  newOrganizationName: Scalars['String']['input'];
  paymentMethod: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  trial: Scalars['Boolean']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCustomerSubscriptionMutation = { __typename: 'Mutation', createCustomerSubscription?: { __typename: 'CreateCustomerSubscriptionPayload', subscription?: any | null, organizationId: string, clientMutationId?: string | null } | null };

export type CreateAcademicOrReverseTrialMutationVariables = Exact<{
  newOrganizationName: Scalars['String']['input'];
  newTeamName: Scalars['String']['input'];
  isAcademic: Scalars['Boolean']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAcademicOrReverseTrialMutation = { __typename: 'Mutation', createAcademicOrReverseTrial?: { __typename: 'CreateAcademicOrReverseTrialPayload', clientMutationId?: string | null, orgID: string } | null };

export type CreateCustomerTrialMutationVariables = Exact<{
  planId: Scalars['ID']['input'];
  userName: Scalars['String']['input'];
  newOrganizationName: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  trialDays: Scalars['Int']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCustomerTrialMutation = { __typename: 'Mutation', createCustomerTrial?: { __typename: 'CreateCustomerTrialPayload', subscription?: any | null, clientMutationId?: string | null } | null };

export type CancelCustomerSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  cancellationComments?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CancelCustomerSubscriptionMutation = { __typename: 'Mutation', cancelCustomerSubscription?: { __typename: 'CancelCustomerSubscriptionPayload', success?: boolean | null, clientMutationId?: string | null } | null };

export type CancelPaygoSubscriptionsMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CancelPaygoSubscriptionsMutation = { __typename: 'Mutation', cancelPaygoSubscriptions?: { __typename: 'CancelPaygoSubscriptionsPayload', success?: boolean | null, clientMutationId?: string | null } | null };

export type ResumePaygoSubscriptionsMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResumePaygoSubscriptionsMutation = { __typename: 'Mutation', resumePaygoSubscriptions?: { __typename: 'ResumePaygoSubscriptionsPayload', success?: boolean | null, clientMutationId?: string | null } | null };

export type ReactivateCustomerSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReactivateCustomerSubscriptionMutation = { __typename: 'Mutation', reactivateCustomerSubscription?: { __typename: 'ReactivateCustomerSubscriptionPayload', success?: boolean | null, clientMutationId?: string | null } | null };

export type UpdateCustomerPaymentMethodMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCustomerPaymentMethodMutation = { __typename: 'Mutation', updateCustomerPaymentMethod?: { __typename: 'UpdateCustomerPaymentMethodPayload', success?: boolean | null, clientMutationId?: string | null } | null };

export type AttachCustomerPaymentMethodMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AttachCustomerPaymentMethodMutation = { __typename: 'Mutation', attachCustomerPaymentMethod?: { __typename: 'AttachCustomerPaymentMethodPayload', success?: boolean | null, clientMutationId?: string | null } | null };

export type UpdateCustomerDefaultPaymentMethodMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCustomerDefaultPaymentMethodMutation = { __typename: 'Mutation', updateCustomerDefaultPaymentMethod?: { __typename: 'UpdateCustomerDefaultPaymentMethodPayload', success?: boolean | null, clientMutationId?: string | null } | null };

export type DetachCustomerPaymentMethodMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DetachCustomerPaymentMethodMutation = { __typename: 'Mutation', detachCustomerPaymentMethod?: { __typename: 'DetachCustomerPaymentMethodPayload', success?: boolean | null, clientMutationId?: string | null } | null };

export type RetryStripeOpenInvoicesByOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type RetryStripeOpenInvoicesByOrganizationMutation = { __typename: 'Mutation', retryStripeOpenInvoicesByOrganization?: { __typename: 'RetryStripeOpenInvoicesByOrganizationPayload', success: boolean, clientMutationId?: string | null } | null };

export type CustomerSubscriptionInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerSubscriptionInfoQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, organizations: Array<{ __typename: 'Organization', id: string, name: string, orgType: OrgType, usedSeats: number, stripeBillingInfo?: { __typename: 'StripeBillingInfo', status: string, cancelAtPeriodEnd: boolean, currentPeriodEnd: string, invoiceLink?: string | null, paymentMethod?: { __typename: 'PaymentMethod', id: string, type: string, cardType?: string | null, endingIn?: string | null } | null } | null, billingUser?: { __typename: 'User', id: string, username?: string | null } | null, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, privileges: any, seats: number, expiresAt?: string | null, subscriptionType: OrganizationSubscriptionType, status: OrganizationSubscriptionStatus, billingPeriodStart?: string | null, billingPeriodEnd?: string | null, plan: { __typename: 'Plan', id: string, name: string, displayName: string, unitPrice?: number | null, billingInterval?: string | null, planType: PlanType } }>, teams: Array<{ __typename: 'Entity', id: string, name: string, storageBytes: any, referenceBytes: any, computeHours: number }>, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, username: string, name: string, photoUrl: string, admin: boolean, role: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null }>, pendingInvites: Array<{ __typename: 'Invite', id: string, email?: string | null }> }> } | null };

export type OrganizationSubscriptionInfoQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationSubscriptionInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, orgType: OrgType, flags?: any | null, usedSeats: number, usedViewOnlySeats: number, createdAt: string, stripeCustomerId?: string | null, seatAvailability: { __typename: 'OrganizationSeatAvailability', seats: number, viewOnlySeats: number }, stripeBillingInfo?: { __typename: 'StripeBillingInfo', status: string, cancelAtPeriodEnd: boolean, currentPeriodEnd: string, invoiceLink?: string | null, paymentMethod?: { __typename: 'PaymentMethod', id: string, type: string, cardType?: string | null, endingIn?: string | null } | null, paymentMetadata?: { __typename: 'PaymentMetadata', shouldUpgradeToTeams?: boolean | null } | null } | null, stripePaymentMethods: Array<{ __typename: 'StripePaymentMethod', stripePaymentMethodID: string, type: StripePaymentMethodType, isDefault: boolean, isFailed: boolean, card: { __typename: 'StripePaymentMethodCard', last4: string, brand: CardBrand } }>, stripeInvoices: Array<{ __typename: 'StripeInvoice', number: string, created: string, total: any, status: StripeInvoiceStatus, currency: string, hostedInvoiceURL: string, invoicePDF: string, subscription?: { __typename: 'StripeSubscription', status: string, organizationSubscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, plan: { __typename: 'Plan', id: string, displayName: string } }> } | null }>, billingUser?: { __typename: 'User', id: string, username?: string | null, name: string, email?: string | null, photoUrl?: string | null } | null, teams: Array<{ __typename: 'Entity', id: string, name: string, memberCount: number, photoUrl?: string | null }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, privileges: any, seats: number, expiresAt?: string | null, subscriptionType: OrganizationSubscriptionType, status: OrganizationSubscriptionStatus, availableSeatsToPurchase: number, isAutomaticUpgrade: boolean, thresholdCrossedAt?: string | null, upgradedAt?: string | null, billingPeriodStart?: string | null, billingPeriodEnd?: string | null, cancelAtPeriodEnd?: boolean | null, plan: { __typename: 'Plan', id: string, name: string, unitPrice?: number | null, billingInterval?: string | null, planType: PlanType, maxSeats: number, displayName: string, defaultPrivileges: any, stripePrice?: { __typename: 'StripePrice', amount: any } | null }, nextPlans: Array<{ __typename: 'Plan', id: string, name: string, displayName: string, billingInterval?: string | null, defaultPrivileges: any, stripePrice?: { __typename: 'StripePrice', amount: any } | null }> }>, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, username: string, name: string, photoUrl: string, admin: boolean, email: string, role: string, modelsSeat: string, weaveRole: string, user: { __typename: 'User', id: string, loggedInAt?: string | null }, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null }>, pendingInvites: Array<{ __typename: 'Invite', id: string, email?: string | null, role: string, createdAt?: string | null, entity?: { __typename: 'Entity', id: string, name: string } | null }> } | null };

export type UpgradeCustomerSubscriptionMutationVariables = Exact<{
  planID: Scalars['ID']['input'];
  organizationID: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpgradeCustomerSubscriptionMutation = { __typename: 'Mutation', upgradeCustomerSubscription?: { __typename: 'UpgradeCustomerSubscriptionPayload', subscription?: any | null, organizationID: string, clientMutationId?: string | null } | null };

export type UpgradeCustomerToProPlanMutationVariables = Exact<{
  planID: Scalars['ID']['input'];
  organizationID: Scalars['ID']['input'];
  paymentMethod: Scalars['String']['input'];
  modelsSeats: Scalars['Int']['input'];
  weaveIngestionTier: WeaveIngestionLimitInMb;
  monthly?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpgradeCustomerToProPlanMutation = { __typename: 'Mutation', upgradeCustomerToProPlan?: { __typename: 'upgradeCustomerToProPlanPayload', subscriptionUsage?: any | null, subscriptionCommit?: any | null, organizationID: string, clientMutationId?: string | null } | null };

export type CreateHourOverageSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateHourOverageSubscriptionMutation = { __typename: 'Mutation', createHourOverageSubscription?: { __typename: 'CreateHourOverageSubscriptionPayload', subscription?: any | null, clientMutationId?: string | null } | null };

export type UpgradeTrialSubscriptionMutationVariables = Exact<{
  organizationID: Scalars['ID']['input'];
  planID: Scalars['ID']['input'];
}>;


export type UpgradeTrialSubscriptionMutation = { __typename: 'Mutation', upgradeTrialSubscription?: { __typename: 'UpgradeTrialSubscriptionPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateDiscussionThreadMutationVariables = Exact<{
  discussionThreadID: Scalars['ID']['input'];
  body: Scalars['String']['input'];
}>;


export type UpdateDiscussionThreadMutation = { __typename: 'Mutation', updateDiscussionThread?: { __typename: 'UpdateDiscussionThreadPayload', discussionThread: { __typename: 'DiscussionThread', id: string, createdAt: string, updatedAt?: string | null, title: string, body: string, upvotes: number, poster: { __typename: 'User', id: string, photoUrl?: string | null, name: string } } } | null };

export type UpdateDiscussionCommentMutationVariables = Exact<{
  viewID?: InputMaybe<Scalars['ID']['input']>;
  discussionCommentID: Scalars['ID']['input'];
  body: Scalars['String']['input'];
  inlineCommentDetails?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type UpdateDiscussionCommentMutation = { __typename: 'Mutation', updateDiscussionComment?: { __typename: 'UpdateDiscussionCommentPayload', discussionComment: { __typename: 'DiscussionComment', id: string, createdAt: string, updatedAt?: string | null, deletedAt?: string | null, body: string, isParent: boolean, poster: { __typename: 'User', id: string, photoUrl?: string | null, name: string, username?: string | null } } } | null };

export type DeleteDiscussionCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  deleteThread?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDiscussionCommentMutation = { __typename: 'Mutation', deleteDiscussionComment?: { __typename: 'DeleteDiscussionCommentPayload', success?: boolean | null } | null };

export type ViewDiscussionThreadsQueryVariables = Exact<{
  viewID: Scalars['ID']['input'];
}>;


export type ViewDiscussionThreadsQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, discussionThreads: { __typename: 'DiscussionThreadConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'DiscussionThreadEdge', node: { __typename: 'DiscussionThread', id: string, createdAt: string, updatedAt?: string | null, title: string, body: string, upvotes: number, poster: { __typename: 'User', id: string, photoUrl?: string | null, name: string, username?: string | null }, comments: { __typename: 'DiscussionCommentConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'DiscussionCommentEdge', node: { __typename: 'DiscussionComment', id: string, createdAt: string, updatedAt?: string | null, body: string, poster: { __typename: 'User', id: string, photoUrl?: string | null, name: string, username?: string | null } } }> } } }> } } | null };

export type CreateViewDiscussionCommentMutationVariables = Exact<{
  viewID: Scalars['ID']['input'];
  discussionThreadID?: InputMaybe<Scalars['ID']['input']>;
  body: Scalars['String']['input'];
  notifyAllSubscribers?: InputMaybe<Scalars['Boolean']['input']>;
  inlineCommentDetails?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type CreateViewDiscussionCommentMutation = { __typename: 'Mutation', createViewDiscussionComment?: { __typename: 'CreateViewDiscussionCommentPayload', discussionThread: { __typename: 'DiscussionThread', id: string, createdAt: string, updatedAt?: string | null, title: string, body: string, upvotes: number, poster: { __typename: 'User', id: string, photoUrl?: string | null, name: string, username?: string | null } }, discussionComment: { __typename: 'DiscussionComment', id: string, createdAt: string, updatedAt?: string | null, body: string, poster: { __typename: 'User', id: string, photoUrl?: string | null, name: string, username?: string | null } }, alertSubscription:
      | { __typename: 'EmailSubscription', id: string }
      | { __typename: 'SlackChannelSubscription', id: string }
     } | null };

export type DismissedBannerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DismissedBannerQuery = { __typename: 'Query', dismissedBanner?: { __typename: 'DismissedBanner', id: string, dismissedAt: string } | null };

export type SetDismissedBannerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SetDismissedBannerMutation = { __typename: 'Mutation', setDismissedBanner?: { __typename: 'SetDismissedBannerPayload', success: boolean } | null };

export type ResendEmailVerificationMutationVariables = Exact<{
  email: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResendEmailVerificationMutation = { __typename: 'Mutation', resendEmailVerification?: { __typename: 'ResendEmailVerificationPayload', success: boolean, clientMutationId?: string | null } | null };

export type SelectedAccountEntityOrgQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SelectedAccountEntityOrgQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, orgEntity?: { __typename: 'Entity', id: string, name: string } | null } | null };

export type EntityPageQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type EntityPageQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, isTeam: boolean, entityType?: string | null, available?: boolean | null, name: string, claimingEntity?: { __typename: 'Entity', id: string, name: string } | null, members: Array<{ __typename: 'Member', id?: string | null, name: string, username?: string | null, email?: string | null, photoUrl?: string | null, pending?: boolean | null, accountType?: string | null, role?: string | null }> } | null };

export type EntityTypeQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type EntityTypeQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, entityType?: string | null } | null };

export type EntityPageUserStatsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  userStatsStartDate: Scalars['DateTime']['input'];
}>;


export type EntityPageUserStatsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, userStats?: { __typename: 'EntityUserConnection', edges: Array<{ __typename: 'EntityUserEdge', node?: { __typename: 'EntityUser', id: string, runCount: number, user: { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null, accountType?: UserAccountType | null } } | null }> } | null } | null };

export type EntityRunsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type EntityRunsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, latestRuns?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string, heartbeatAt?: string | null, updatedAt?: string | null, notes?: string | null, groupCounts?: Array<number> | null, user?: { __typename: 'User', id: string, username?: string | null, name: string, accountType?: UserAccountType | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }> } }> } | null } | null };

export type EntitySettingsQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type EntitySettingsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, entityType?: string | null, settings: { __typename: 'EntitySettings', openToMatchingOrgEmailDomainUsers?: boolean | null, entityProfileEnabled: boolean, hideActivityCalendar: boolean, membersCanInvite?: boolean | null, disableMagicLinkSharing?: boolean | null, disableMembersEditArtifactTTL: boolean, hidden: boolean, defaultCloudRegion: { __typename: 'CloudRegion', id: string, provider: CloudProvider, region: string } } } | null };

export type EntityStorageQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  enableReferenceTracking?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EntityStorageQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, storageBytes: any, referenceBytes: any, computeHours: number, storage?: { __typename: 'EntityStorageNode', id: string, size: any } | null } | null };

export type CachedEntityStorageInfoQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type CachedEntityStorageInfoQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, storageBytes: any } | null };

export type ArtifactNodeFragment = { __typename: 'ArtifactSequenceStorageNode', id: string, name: string, size: any, artifactSequenceID: string, artifactType: { __typename: 'ArtifactType', id: string, name: string } };

export type RunNodeFragment = { __typename: 'RunStorageNode', id: string, name: string, size: any, runID: string };

export type ArtifactCollectionStorageTreeQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  enableReferenceTracking: Scalars['Boolean']['input'];
  artifactCollectionID: Scalars['ID']['input'];
}>;


export type ArtifactCollectionStorageTreeQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, artifactCollectionStorageTree?: { __typename: 'ArtifactStorageNodeConnection', edges: Array<{ __typename: 'ArtifactStorageNodeEdge', node: { __typename: 'ArtifactStorageNode', id: string, name: string, size: any, artifactID: string } }> } | null } | null };

export type EntityStorageTreeQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  enableReferenceTracking: Scalars['Boolean']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  cached?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EntityStorageTreeQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, storageTree?: { __typename: 'EntityStorageNode', id: string, name: string, size: any, lastUpdatedAt?: string | null, projects: { __typename: 'ProjectStorageNodeConnection', totalSize: any, edges: Array<{ __typename: 'ProjectStorageNodeEdge', node: { __typename: 'ProjectStorageNode', id: string, name: string, size: any, projectID: string, runs?: { __typename: 'RunStorageNodeConnection', totalSize: any, edges: Array<{ __typename: 'RunStorageNodeEdge', node: { __typename: 'RunStorageNode', id: string, name: string, size: any, runID: string } }> }, artifactSequences: { __typename: 'ArtifactSequenceStorageNodeConnection', totalSize: any, edges: Array<{ __typename: 'ArtifactSequenceStorageNodeEdge', node: { __typename: 'ArtifactSequenceStorageNode', id: string, name: string, size: any, artifactSequenceID: string, artifactType: { __typename: 'ArtifactType', id: string, name: string } } }> }, artifactTypes: Array<{ __typename: 'ArtifactTypeStorageNode', id: string, name: string, size: any }> } }> } } | null } | null };

export type LogExperimentExposureMutationVariables = Exact<{
  experimentName: Scalars['String']['input'];
  unit: ExperimentExposureUnit;
}>;


export type LogExperimentExposureMutation = { __typename: 'Mutation', logExperimentExposure?: { __typename: 'LogExperimentExposurePayload', success: boolean, bucket?: number | null } | null };

export type GetEmails_UserFragment = { __typename: 'User', id: string, emails: Array<{ __typename: 'Email', id: string, emailAddress: string, type: EmailType, createdAt: string, verified: boolean, identities: Array<{ __typename: 'Identity', id: string, emailIdentityVerified: boolean, provider?: string | null }> }> };

export type UserEmailsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserEmailsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, emails: Array<{ __typename: 'Email', id: string, emailAddress: string, type: EmailType, createdAt: string, verified: boolean, identities: Array<{ __typename: 'Identity', id: string, emailIdentityVerified: boolean, provider?: string | null }> }> } | null };

export type GlueTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type GlueTasksQuery = { __typename: 'Query', glueManager?: { __typename: 'GlueManager', taskTypes: Array<string>, registeredTasks: { __typename: 'GlueTaskConnection', edges: Array<{ __typename: 'GlueTaskEdge', node: { __typename: 'GlueTask', id: string, name: string, taskType: string, arguments?: any | null, checkpoint?: any | null, lastRunAt?: string | null, status: string, strategyType: string, strategyMetadata: string } }> } } | null };

export type GlueTaskConfigQueryVariables = Exact<{
  taskType: Scalars['String']['input'];
}>;


export type GlueTaskConfigQuery = { __typename: 'Query', glueManager?: { __typename: 'GlueManager', taskConfig?: { __typename: 'GlueTaskConfig', defaultArguments: any } | null } | null };

export type GlueRunsQueryVariables = Exact<{
  taskID: Scalars['ID']['input'];
}>;


export type GlueRunsQuery = { __typename: 'Query', glueRuns?: { __typename: 'GlueRunConnection', edges: Array<{ __typename: 'GlueRunEdge', node: { __typename: 'GlueRun', id: string, runAt: string, runtimeMS: any, arguments?: any | null, errors?: any | null, retries: number, succeeded: boolean } }> } | null };

export type CreateGlueTaskMutationVariables = Exact<{
  name: Scalars['String']['input'];
  taskType: Scalars['String']['input'];
  arguments: Scalars['JSONString']['input'];
  status: Scalars['String']['input'];
  strategyType: Scalars['String']['input'];
  strategyMetadata: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateGlueTaskMutation = { __typename: 'Mutation', createGlueTask?: { __typename: 'CreateGlueTaskPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateGlueTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  arguments?: InputMaybe<Scalars['JSONString']['input']>;
  checkpoint?: InputMaybe<Scalars['JSONString']['input']>;
  strategyType?: InputMaybe<Scalars['String']['input']>;
  strategyMetadata?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateGlueTaskMutation = { __typename: 'Mutation', updateGlueTask?: { __typename: 'UpdateGlueTaskPayload', success: boolean, clientMutationId?: string | null } | null };

export type EnableGlueTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EnableGlueTaskMutation = { __typename: 'Mutation', enableGlueTask?: { __typename: 'EnableGlueTaskPayload', success: boolean, clientMutationId?: string | null } | null };

export type DisableGlueTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DisableGlueTaskMutation = { __typename: 'Mutation', disableGlueTask?: { __typename: 'DisableGlueTaskPayload', success: boolean, clientMutationId?: string | null } | null };

export type DeleteGlueTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteGlueTaskMutation = { __typename: 'Mutation', deleteGlueTask?: { __typename: 'DeleteGlueTaskPayload', success: boolean, clientMutationId?: string | null } | null };

export type HomePageViewerDetailsQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type HomePageViewerDetailsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, username?: string | null, name: string, photoUrl?: string | null, organizations: Array<{ __typename: 'Organization', id: string, name: string }>, defaultEntity?: { __typename: 'Entity', id: string, name: string } | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, photoUrl?: string | null } | null }> } | null } | null };

export type HomePageViewerProjectsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
}>;


export type HomePageViewerProjectsQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, createdAt: string } | null }> } | null };

export type EntityProjectsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EntityProjectsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, totalRuns?: number | null, createdAt: string, lastActive?: string | null, description?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null } | null }> } | null } | null };

export type EntityReportsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  displayNameContains?: InputMaybe<Scalars['String']['input']>;
}>;


export type EntityReportsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, views: { __typename: 'ViewConnection', totalCount: number, edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, description?: string | null, starCount: number, createdAt: string, updatedAt?: string | null, starred?: boolean | null, showcasedAt?: string | null, previewUrl?: string | null, viewCount: number, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null } | null } | null }> } } | null };

export type OrganizationReportsQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  displayNameContains?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationReportsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, views: { __typename: 'ViewConnection', totalCount: number, edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, description?: string | null, starCount: number, createdAt: string, updatedAt?: string | null, starred?: boolean | null, showcasedAt?: string | null, previewUrl?: string | null, viewCount: number, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null } | null } | null }> } } | null };

export type AccountTeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountTeamsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, name: string, username?: string | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, isTeam: boolean, entityType?: string | null, organizationId?: string | null, name: string, defaultAccess: string, privateOnly: boolean, settings: { __typename: 'EntitySettings', hidden: boolean }, members: Array<{ __typename: 'Member', id?: string | null, name: string, username?: string | null, email?: string | null, pending?: boolean | null, photoUrl?: string | null, accountType?: string | null, role?: string | null, memberRole?: { __typename: 'Role', name: string } | null }> } | null }> } | null } | null };

export type CreateSlackIntegrationMutationVariables = Exact<{
  code: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  redirectURI: Scalars['String']['input'];
}>;


export type CreateSlackIntegrationMutation = { __typename: 'Mutation', createSlackIntegration?: { __typename: 'CreateIntegrationPayload', integration:
      | { __typename: 'GenericWebhookIntegration', id: string }
      | { __typename: 'GitHubOAuthIntegration', id: string }
      | { __typename: 'SlackIntegration', id: string }
     } | null };

export type CreateGenericWebhookIntegrationMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  webhookName: Scalars['String']['input'];
  urlEndpoint: Scalars['String']['input'];
  accessTokenRef?: InputMaybe<Scalars['String']['input']>;
  secretRef?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateGenericWebhookIntegrationMutation = { __typename: 'Mutation', createGenericWebhookIntegration?: { __typename: 'CreateIntegrationPayload', integration:
      | { __typename: 'GenericWebhookIntegration', id: string, urlEndpoint: string, name: string }
      | { __typename: 'GitHubOAuthIntegration' }
      | { __typename: 'SlackIntegration' }
     } | null };

export type UpdateGenericWebhookIntegrationMutationVariables = Exact<{
  integrationID: Scalars['ID']['input'];
  webhookName?: InputMaybe<Scalars['String']['input']>;
  urlEndpoint?: InputMaybe<Scalars['String']['input']>;
  accessTokenRef?: InputMaybe<Scalars['String']['input']>;
  secretRef?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateGenericWebhookIntegrationMutation = { __typename: 'Mutation', updateGenericWebhookIntegration?: { __typename: 'CreateIntegrationPayload', integration:
      | { __typename: 'GenericWebhookIntegration', id: string, urlEndpoint: string, name: string }
      | { __typename: 'GitHubOAuthIntegration' }
      | { __typename: 'SlackIntegration' }
     } | null };

export type TestGenericWebhookIntegrationMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  urlEndpoint: Scalars['String']['input'];
  accessTokenRef?: InputMaybe<Scalars['String']['input']>;
  secretRef?: InputMaybe<Scalars['String']['input']>;
  requestPayload?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type TestGenericWebhookIntegrationMutation = { __typename: 'Mutation', testGenericWebhookIntegration?: { __typename: 'TestGenericWebhookIntegrationPayload', ok: boolean, response: any } | null };

export type DeleteIntegrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteIntegrationMutation = { __typename: 'Mutation', deleteIntegration?: { __typename: 'DeleteIntegrationPayload', success?: boolean | null } | null };

export type FetchLaunchAgentsFromProjectQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type FetchLaunchAgentsFromProjectQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, launchAgents: Array<{ __typename: 'LaunchAgent', id: string, name: string, createdAt: string, agentStatus: string, stopPolling: boolean, runQueues: Array<string>, hostname: string, agentConfig?: any | null, version?: string | null }> } | null };

export type StopLaunchAgentMutationVariables = Exact<{
  agentId: Scalars['ID']['input'];
  stopPolling?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type StopLaunchAgentMutation = { __typename: 'Mutation', updateLaunchAgent?: { __typename: 'UpdateLaunchAgentPayload', success?: boolean | null } | null };

export type DeleteLaunchAgentsMutationVariables = Exact<{
  agentIds: Array<Scalars['ID']['input']>;
}>;


export type DeleteLaunchAgentsMutation = { __typename: 'Mutation', deleteLaunchAgents?: { __typename: 'DeleteLaunchAgentsPayload', success?: boolean | null } | null };

export type HasLocalLicenseQueryVariables = Exact<{ [key: string]: never; }>;


export type HasLocalLicenseQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', hasLocalLicense: boolean } | null };

export type LatestLocalVersionInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestLocalVersionInfoQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', latestLocalVersionInfo?: { __typename: 'LocalVersionInfo', outOfDate: boolean, latestVersionString: string, versionOnThisInstanceString: string } | null } | null };

export type AvailableFilesQueryQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  filenames: Array<Scalars['String']['input']>;
  includeDirectUrl: Scalars['Boolean']['input'];
  includeThumbnails?: InputMaybe<Scalars['Boolean']['input']>;
  includeHlsSrc?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AvailableFilesQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, directUrl?: string, url?: string | null, md5?: string | null, sizeBytes: any, hlsSrc?: string | null, thumbnails?: Array<{ __typename: 'Thumbnail', size: any, directUrl: string, originalImageWidth: number, originalImageHeight: number }> } | null }> } | null } | null } | null };

export type DirectUrlQueryQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  filenames: Array<Scalars['String']['input']>;
}>;


export type DirectUrlQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, directUrl: string, url?: string | null, hlsSrc?: string | null, thumbnails: Array<{ __typename: 'Thumbnail', size: any, directUrl: string, originalImageWidth: number, originalImageHeight: number }> } | null }> } | null } | null } | null };

export type ArtifactCodeFileQueryQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  filenames: Array<Scalars['String']['input']>;
}>;


export type ArtifactCodeFileQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, outputArtifacts?: { __typename: 'ArtifactConnection', edges: Array<{ __typename: 'ArtifactEdge', node?: { __typename: 'Artifact', id: string, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, url?: string | null, directUrl: string, sizeBytes: any } | null }> } | null } | null }> } | null } | null } | null };

export type MetricSearchQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  metricNamePattern?: InputMaybe<Scalars['String']['input']>;
  runLimit?: InputMaybe<Scalars['Int']['input']>;
  runOrder?: InputMaybe<Scalars['String']['input']>;
  keysPageSize?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  requiredRunKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  metricTypes?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type MetricSearchQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', metricSearch?: { __typename: 'MetricSearchResults', cursor: string, hasMore: boolean, results: Array<{ __typename: 'MetricInfo', key: string, types: Array<string>, latestType?: string | null, column: MetricColumn }> } | null } | null } | null };

export type AddWorkflowsAdminMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  adminType: WorkflowsAdminType;
}>;


export type AddWorkflowsAdminMutation = { __typename: 'Mutation', addWorkflowsAdmin?: { __typename: 'AddWorkflowsAdminPayload', success: boolean } | null };

export type DeleteWorkflowsAdminMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  adminType: WorkflowsAdminType;
}>;


export type DeleteWorkflowsAdminMutation = { __typename: 'Mutation', deleteWorkflowsAdmin?: { __typename: 'DeleteWorkflowsAdminPayload', success: boolean } | null };

export type AddProtectedAliasesMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  aliases: Array<Scalars['String']['input']>;
  adminType: WorkflowsAdminType;
}>;


export type AddProtectedAliasesMutation = { __typename: 'Mutation', addProtectedAliases?: { __typename: 'AddProtectedAliasesPayload', aliases: Array<string> } | null };

export type RemoveProtectedAliasesMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  aliases: Array<Scalars['String']['input']>;
  adminType: WorkflowsAdminType;
}>;


export type RemoveProtectedAliasesMutation = { __typename: 'Mutation', removeProtectedAliases?: { __typename: 'RemoveProtectedAliasesPayload', aliases: Array<string> } | null };

export type EntityProtectedAliasesQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  workflowsAdminType: WorkflowsAdminType;
}>;


export type EntityProtectedAliasesQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, protectedAliases: Array<string>, workflowsAdmins: Array<{ __typename: 'User', id: string, username?: string | null, name: string, email?: string | null }> } | null };

export type ModelQueryVariables = Exact<{
  name: Scalars['String']['input'];
  logCursor?: InputMaybe<Scalars['String']['input']>;
  fileCursor?: InputMaybe<Scalars['String']['input']>;
  fileLimit?: InputMaybe<Scalars['Int']['input']>;
  fileNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  bucketName: Scalars['String']['input'];
  upload?: InputMaybe<Scalars['Boolean']['input']>;
  detailed: Scalars['Boolean']['input'];
  includeFiles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ModelQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, readOnly?: boolean | null, name: string, entityName: string, description?: string | null, createdAt: string, bucketCount?: number | null, access?: string | null, summaryMetrics?: any | null, views?: any | null, run?: { __typename: 'Run', id: string, name: string, config?: any | null, summaryMetrics?: any | null, systemMetrics?: any | null, readOnly?: boolean | null, framework?: string | null, displayName?: string | null, notes?: string | null, github?: string | null, group?: string | null, jobType?: string | null, createdAt: string, heartbeatAt?: string | null, commit?: string | null, host?: string | null, state?: string | null, shouldStop?: boolean | null, groupCounts?: Array<number> | null, stopped?: boolean | null, defaultColorIndex?: number | null, history: Array<string>, events: Array<string>, fileCount?: number | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null } | null, agent?: { __typename: 'Agent', id: string, name: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, runInfo?: { __typename: 'RunInfo', gpuCount?: number | null, gpu?: string | null } | null, logLines?: { __typename: 'LogLineConnection', edges: Array<{ __typename: 'LogLineEdge', node: { __typename: 'LogLine', id?: string | null, line?: string | null, level?: string | null } }> } | null, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, directUrl: string, url?: string | null, sizeBytes: any, updatedAt?: string | null } | null }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null } | null } | null, viewer?: { __typename: 'User', id: string, email?: string | null, photoUrl?: string | null, admin?: boolean | null, defaultFramework?: string | null } | null };

export type CreateProjectMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  access?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateProjectMutation = { __typename: 'Mutation', createProject?: { __typename: 'CreateProjectPayload', project?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, createdAt: string } | null } | null };

export type UpsertModelMutationVariables = Exact<{
  description?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  framework?: InputMaybe<Scalars['String']['input']>;
  access?: InputMaybe<Scalars['String']['input']>;
  views?: InputMaybe<Scalars['JSONString']['input']>;
  owner?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpsertModelMutation = { __typename: 'Mutation', upsertModel?: { __typename: 'UpsertModelPayload', inserted?: boolean | null, project?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string, createdAt: string, description?: string | null, access?: string | null, views?: any | null, user?: { __typename: 'User', id: string } | null } | null, model?: { __typename: 'Project', id: string, name: string, entityName: string, description?: string | null, access?: string | null, views?: any | null, user?: { __typename: 'User', id: string } | null } | null } | null };

export type RenameProjectMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  oldProjectName: Scalars['String']['input'];
  newProjectName: Scalars['String']['input'];
}>;


export type RenameProjectMutation = { __typename: 'Mutation', renameProject?: { __typename: 'UpsertModelPayload', inserted?: boolean | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, description?: string | null, access?: string | null, views?: any | null } | null, model?: { __typename: 'Project', id: string, name: string, entityName: string, description?: string | null, access?: string | null, views?: any | null } | null } | null };

export type DeleteModelMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteModelMutation = { __typename: 'Mutation', deleteModel?: { __typename: 'DeleteModelPayload', success?: boolean | null } | null };

export type ModelsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ModelsQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, description?: string | null, totalRuns?: number | null, totalUsers?: number | null, lastActive?: string | null } | null }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null, viewer?: { __typename: 'User', id: string, email?: string | null, photoUrl?: string | null } | null };

export type NumPendingInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type NumPendingInvitesQuery = { __typename: 'Query', numPendingInvites: number };

export type CreateOAuthProviderMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  issuerUrl: Scalars['String']['input'];
}>;


export type CreateOAuthProviderMutation = { __typename: 'Mutation', createOAuthProvider?: { __typename: 'CreateOAuthProviderPayload', success: boolean } | null };

export type OauthProvidersQueryVariables = Exact<{
  organizationName: Scalars['String']['input'];
}>;


export type OauthProvidersQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, OAuthProviders: Array<{ __typename: 'OAuthProvider', id: string, issuerUrl: string }> } | null };

export type DeleteOAuthProviderMutationVariables = Exact<{
  providerId: Scalars['ID']['input'];
}>;


export type DeleteOAuthProviderMutation = { __typename: 'Mutation', deleteOAuthProvider?: { __typename: 'DeleteOAuthProviderPayload', success: boolean } | null };

export type OauthClientsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type OauthClientsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, members: Array<{ __typename: 'Member', id?: string | null, role?: string | null, OAuthClients: Array<{ __typename: 'OAuthClient', id: string, subject: string }> }> } | null };

export type CreateOAuthClientMutationVariables = Exact<{
  providerId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
}>;


export type CreateOAuthClientMutation = { __typename: 'Mutation', createClient?: { __typename: 'CreateClientPayload', success: boolean } | null };

export type DeleteOAuthClientMutationVariables = Exact<{
  clientId: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
}>;


export type DeleteOAuthClientMutation = { __typename: 'Mutation', revokeClient?: { __typename: 'RevokeClientPayload', success: boolean } | null };

export type ActivityTimelineQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  orgName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ActivityTimelineQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, firstActivity?: string | null, activity: Array<{ __typename: 'OrgActivityTimeline', numActiveUsers: number, startAt: string, endAt: string }> } | null };

export type OrgFlagsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrgFlagsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, flags?: any | null } | null };

export type OrgDashboardEnablementQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgDashboardEnablementQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, activity: Array<{ __typename: 'OrgActivityTimeline', numActiveUsers: number }> } | null };

export type OrgDashboardContextQueryVariables = Exact<{
  orgName?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrgDashboardContextQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, role: string, username: string, modelsSeat: string, weaveRole: string, user: { __typename: 'User', id: string, accountType?: UserAccountType | null, admin?: boolean | null, deletedAt?: string | null, email?: string | null, username?: string | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null, activity?: { __typename: 'UserActivityDetails', lastActiveAt?: string | null, startAt: string, endAt: string, daysActive: number, numReports: number, numRuns: number } | null } }>, activeUsersForRange?: { __typename: 'OrgDashboardActiveUsersForRangeStats', last30Days: any, last3Months: any, last6Months: any, last12Months: any, allTime: any } | null } | null };

export type OrgActivityTimelineQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type OrgActivityTimelineQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, activity: Array<{ __typename: 'OrgActivityTimeline', numActiveUsers: number, startAt: string, endAt: string }> } | null };

export type OrgSeatsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgSeatsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, seatAvailability: { __typename: 'OrganizationSeatAvailability', seats: number, viewOnlySeats: number, expiresAt?: string | null } } | null };

export type UserActivityTableQueryVariables = Exact<{ [key: string]: never; }>;


export type UserActivityTableQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, usedSeats: number, usedViewOnlySeats: number, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, role: string, modelsSeat: string, weaveRole: string, user: { __typename: 'User', id: string, name: string, photoUrl?: string | null, createdAt: string, accountType?: UserAccountType | null, admin?: boolean | null, deletedAt?: string | null, email?: string | null, username?: string | null, activity?: { __typename: 'UserActivityDetails', lastActiveAt?: string | null, daysActive: number, numReports: number, numRuns: number } | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, entityType?: string | null } | null }> } | null } }> } | null };

export type AddUserToOrganizationMutationVariables = Exact<{
  userName: Scalars['String']['input'];
  teams?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userOrgRole: Scalars['String']['input'];
  modelsSeat?: InputMaybe<Scalars['String']['input']>;
  weaveRole?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddUserToOrganizationMutation = { __typename: 'Mutation', addUserToOrganization?: { __typename: 'AddUserToOrganizationPayload', success: boolean, clientMutationId?: string | null } | null };

export type RemoveUserFromOrganizationMutationVariables = Exact<{
  userName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveUserFromOrganizationMutation = { __typename: 'Mutation', removeUserFromOrganization?: { __typename: 'RemoveUserFromOrganizationPayload', success: boolean, clientMutationId?: string | null } | null };

export type RemoveUserFromOrganizationByIdMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveUserFromOrganizationByIdMutation = { __typename: 'Mutation', removeUserFromOrganizationById?: { __typename: 'RemoveUserFromOrganizationByIdPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateOrganizationMutationVariables = Exact<{
  organizationID: Scalars['ID']['input'];
  flags?: InputMaybe<Scalars['JSONString']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOrganizationMutation = { __typename: 'Mutation', updateOrganization?: { __typename: 'UpdateOrganizationPayload', success: boolean, clientMutationId?: string | null } | null };

export type DeleteOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteOrganizationMutation = { __typename: 'Mutation', deleteOrganization?: { __typename: 'DeleteOrganizationPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateOrganizationUserV2MutationVariables = Exact<{
  userName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  userOrgRole: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOrganizationUserV2Mutation = { __typename: 'Mutation', updateOrganizationUserV2?: { __typename: 'UpdateOrganizationUserV2Payload', success: boolean, clientMutationId?: string | null } | null };

export type MakeOrgMembersNoAccessModelsSeatMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MakeOrgMembersNoAccessModelsSeatMutation = { __typename: 'Mutation', makeOrgMembersNoAccessModelsSeat?: { __typename: 'MakeOrgMembersNoAccessModelsSeatPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateModelsSeatMutationVariables = Exact<{
  userID: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  modelsSeat: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateModelsSeatMutation = { __typename: 'Mutation', updateModelsSeat?: { __typename: 'UpdateModelsSeatPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateWeaveRoleMutationVariables = Exact<{
  userID: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  weaveRole: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateWeaveRoleMutation = { __typename: 'Mutation', updateWeaveRole?: { __typename: 'UpdateWeaveRolePayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateOrganizationBillingUserMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  newBillingUser: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOrganizationBillingUserMutation = { __typename: 'Mutation', updateOrganizationBillingUser?: { __typename: 'UpdateOrganizationBillingUserPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpgradeProCustomerMutationVariables = Exact<{
  organizationID: Scalars['ID']['input'];
  weaveIngestionTier: WeaveIngestionLimitInMb;
  modelsSeats: Scalars['Int']['input'];
  monthly?: InputMaybe<Scalars['Boolean']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpgradeProCustomerMutation = { __typename: 'Mutation', upgradeProCustomer?: { __typename: 'upgradeProCustomerPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateOrganizationSubscriptionMutationVariables = Exact<{
  organizationSubscriptionID: Scalars['ID']['input'];
  createStripeSubscription: Scalars['Boolean']['input'];
  planID?: InputMaybe<Scalars['ID']['input']>;
  seats?: InputMaybe<Scalars['Int']['input']>;
  privileges?: InputMaybe<Scalars['JSONString']['input']>;
  type?: InputMaybe<OrganizationSubscriptionType>;
  status?: InputMaybe<OrganizationSubscriptionStatus>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  couponID?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOrganizationSubscriptionMutation = { __typename: 'Mutation', updateOrganizationSubscription?: { __typename: 'UpdateOrganizationSubscriptionPayload', success: boolean, clientMutationId?: string | null } | null };

export type DeleteOrganizationSubscriptionMutationVariables = Exact<{
  subscriptionID: Scalars['ID']['input'];
}>;


export type DeleteOrganizationSubscriptionMutation = { __typename: 'Mutation', deleteOrganizationSubscription?: { __typename: 'DeleteOrganizationSubscriptionPayload', success: boolean, clientMutationId?: string | null } | null };

export type LinkTeamToOrganizationMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  organizationID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LinkTeamToOrganizationMutation = { __typename: 'Mutation', linkTeamToOrganization?: { __typename: 'LinkTeamToOrganizationPayload', success: boolean, clientMutationId?: string | null } | null };

export type WeaveSavingsCalculatorQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type WeaveSavingsCalculatorQuery = { __typename: 'Query', weaveSavingsCalculator?: { __typename: 'WeaveSavingsCalculator', recommendationString: string, totalPossibleSavings: number, recommendedWeaveTier: string } | null };

export type CheckoutPreviewQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
  weaveIngestionTier: WeaveIngestionLimitInMb;
  numberOfModelsSeat: Scalars['Int']['input'];
  couponID?: InputMaybe<Scalars['String']['input']>;
  isMonthly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CheckoutPreviewQuery = { __typename: 'Query', checkoutPreview?: { __typename: 'CheckoutPreview', total: number, renewalDate?: string | null, lineItems: Array<{ __typename: 'CheckoutPreviewLineItemsMetadata', description: string, amount: number, product: string, position: number, discountAmount?: number | null, subLineItems: Array<{ __typename: 'CheckoutPreviewSubLineItemsMetadata', description: string, amount: number, proration: boolean } | null> } | null> } | null };

export type AllOrganizationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  queryOrg?: InputMaybe<Scalars['String']['input']>;
  querySubId?: InputMaybe<Scalars['String']['input']>;
  queryUser?: InputMaybe<Scalars['String']['input']>;
  queryTeam?: InputMaybe<Scalars['String']['input']>;
  emailDomain?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllOrganizationsQuery = { __typename: 'Query', organizations: { __typename: 'OrganizationConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'OrganizationEdge', node: { __typename: 'Organization', id: string, name: string, orgType: OrgType, flags?: any | null, usedSeats: number, usedViewOnlySeats: number, billingUser?: { __typename: 'User', id: string, username?: string | null, email?: string | null } | null, teams: Array<{ __typename: 'Entity', id: string, name: string }>, stripeBillingInfo?: { __typename: 'StripeBillingInfo', stripeSubscriptionId: string, status: string, currentPeriodEnd: string, cancelAtPeriodEnd: boolean, paymentMethod?: { __typename: 'PaymentMethod', id: string, cardType?: string | null, endingIn?: string | null } | null } | null, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, admin: boolean, name: string, username: string, photoUrl: string, role: string, modelsSeat: string, weaveRole: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', seats: number, id: string, subscriptionType: OrganizationSubscriptionType, stripeSubscriptionId?: string | null, status: OrganizationSubscriptionStatus, expiresAt?: string | null, privileges: any, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType, displayName: string } }> } }> } };

export type OrganizationSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationSubscriptionsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, organizations: Array<{ __typename: 'Organization', id: string, createdAt: string, name: string, flags?: any | null, usedSeats: number, billingUser?: { __typename: 'User', id: string, username?: string | null, email?: string | null } | null, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, subscriptionType: OrganizationSubscriptionType, status: OrganizationSubscriptionStatus, expiresAt?: string | null, privileges: any, seats: number, isAutomaticUpgrade: boolean, createdAt: string, thresholdCrossedAt?: string | null, upgradedAt?: string | null, billingPeriodStart?: string | null, billingPeriodEnd?: string | null, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType, billingInterval?: string | null }, expansionPacks: { __typename: 'ExpansionPackConnection', edges: Array<{ __typename: 'ExpansionPackEdge', node: { __typename: 'ExpansionPack', id: string, secondsLimit: number, secondsRemaining: number, expiresAt?: string | null } }> } }>, teams: Array<{ __typename: 'Entity', id: string, name: string, computeHours: number, oldComputeHours: number }>, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, username: string, role: string }>, pendingInvites: Array<{ __typename: 'Invite', id: string }> }> } | null };

export type OrganizationStorageInfoQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type OrganizationStorageInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, teams: Array<{ __typename: 'Entity', id: string, storageBytes: any, referenceBytes: any }> } | null };

export type OrganizationSubscriptionBasicInfoFragment = { __typename: 'Organization', name: string, orgType: OrgType, memberCount: number, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, subscriptionType: OrganizationSubscriptionType, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> };

export type OrganizationSubscriptionsBasicInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationSubscriptionsBasicInfoQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, username?: string | null, organizations: Array<{ __typename: 'Organization', id: string, name: string, orgType: OrgType, memberCount: number, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, subscriptionType: OrganizationSubscriptionType, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> }> } | null };

export type OrganizationSubscriptionBasicInfoByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type OrganizationSubscriptionBasicInfoByNameQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, orgType: OrgType, memberCount: number, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, subscriptionType: OrganizationSubscriptionType, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type OrganizationSubscriptionsBasicDetailsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationSubscriptionsBasicDetailsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, subscriptionType: OrganizationSubscriptionType, billingPeriodStart?: string | null, billingPeriodEnd?: string | null, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type UpdateOrganizationSubscriptionSeatsMutationVariables = Exact<{
  organizationID: Scalars['ID']['input'];
  seats: Scalars['Int']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOrganizationSubscriptionSeatsMutation = { __typename: 'Mutation', updateOrganizationSubscriptionSeats?: { __typename: 'UpdateOrganizationSubscriptionSeatsPayload', success: boolean, clientMutationId?: string | null } | null };

export type OrganizationRunsQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
}>;


export type OrganizationRunsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, myRuns?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string, heartbeatAt?: string | null, updatedAt?: string | null, notes?: string | null, groupCounts?: Array<number> | null, user?: { __typename: 'User', id: string, username?: string | null, name: string, accountType?: UserAccountType | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }> } }> } | null, teamRuns?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string, heartbeatAt?: string | null, updatedAt?: string | null, notes?: string | null, groupCounts?: Array<number> | null, user?: { __typename: 'User', id: string, username?: string | null, name: string, accountType?: UserAccountType | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }> } }> } | null } | null };

export type OrganizationServiceAccountsQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrganizationServiceAccountsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, serviceAccounts: Array<{ __typename: 'ServiceAccount', id: string, name: string, createdAt: string, apiKeyCount: number, accountType: UserAccountType, defaultEntity?: { __typename: 'Entity', name: string, id: string } | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null }> } | null };

export type AccountProjectFragmentFragment = { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, totalRuns?: number | null, createdAt: string, lastActive?: string | null, description?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null };

export type OrganizationProjectsQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
  userID?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrganizationProjectsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, totalRuns?: number | null, createdAt: string, lastActive?: string | null, description?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null } | null }> } | null } | null };

export type ViewerOrganizationFeatureFlagsQueryVariables = Exact<{
  rampIDType: RampIdType;
}>;


export type ViewerOrganizationFeatureFlagsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, organizations: Array<{ __typename: 'Organization', id: string, name: string, featureFlags: Array<{ __typename: 'FeatureFlag', rampKey: string, isEnabled: boolean } | null> }> } | null };

export type OrganizationFeatureFlagsQueryVariables = Exact<{
  orgName?: InputMaybe<Scalars['String']['input']>;
  rampIDType: RampIdType;
}>;


export type OrganizationFeatureFlagsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, orgType: OrgType, featureFlags: Array<{ __typename: 'FeatureFlag', rampKey: string, isEnabled: boolean } | null> } | null };

export type UpdateOrganizationPrivacySettingsMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  privateOnly?: InputMaybe<Scalars['Boolean']['input']>;
  onlyAdminsCanInvite?: InputMaybe<Scalars['Boolean']['input']>;
  disableMagicLinkSharing?: InputMaybe<Scalars['Boolean']['input']>;
  restrictMatchingOrgEmailDomainUsers?: InputMaybe<Scalars['Boolean']['input']>;
  codeSavingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  enableLLMPoweredFeatures?: InputMaybe<Scalars['Boolean']['input']>;
  shareAITracesWithWB?: InputMaybe<Scalars['Boolean']['input']>;
  allowModelTrainingOnSharedData?: InputMaybe<Scalars['Boolean']['input']>;
  ariaProjectMemoryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  restrictInvitesToClaimedDomain?: InputMaybe<Scalars['Boolean']['input']>;
  disableApiKeyCreation?: InputMaybe<Scalars['Boolean']['input']>;
  requireOrgScopedAPIKeys?: InputMaybe<Scalars['Boolean']['input']>;
  weaveSensitiveDataPolicy?: InputMaybe<WeaveSensitiveDataPolicy>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOrganizationPrivacySettingsMutation = { __typename: 'Mutation', updateOrganizationPrivacySettings?: { __typename: 'UpdateOrganizationPrivacySettingsPayload', success: boolean, clientMutationId?: string | null } | null };

export type OrganizationMemberRoleQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationMemberRoleQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, member?: { __typename: 'OrganizationMember', id: string, orgID: string, role: string } | null } | null };

export type OrganizationMemberModelsSeatQueryVariables = Exact<{
  orgName?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationMemberModelsSeatQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, member?: { __typename: 'OrganizationMember', id: string, role: string, modelsSeat: string, isRegistryEntitled: boolean } | null } | null };

export type OrganizationMemberWeaveRoleQueryVariables = Exact<{
  orgName?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationMemberWeaveRoleQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, member?: { __typename: 'OrganizationMember', id: string, weaveRole: string } | null } | null };

export type OrganizationMembersQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrganizationMembersQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, members: Array<{ __typename: 'OrganizationMember', id: string, name: string, username: string, email: string, photoUrl: string, user: { __typename: 'User', id: string, accountType?: UserAccountType | null }, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null }> } | null };

export type OrganizationApiKeysQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationApiKeysQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, apiKeysConnection: { __typename: 'OrganizationApiKeyConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null }, edges: Array<{ __typename: 'OrganizationApiKeyEdge', node: { __typename: 'ApiKey', id: string, apiKeyId?: string | null, description?: string | null, createdAt?: string | null, expiresAt?: string | null, lastUsedAt?: string | null, user?: { __typename: 'User', id: string, name: string, accountType?: UserAccountType | null, username?: string | null } | null } }> } } | null };

export type FetchPreviewableLinkQueryVariables = Exact<{
  resourceID: Scalars['ID']['input'];
  resourceType: PreviewableLinkResourceType;
}>;


export type FetchPreviewableLinkQuery = { __typename: 'Query', previewableLink?: { __typename: 'PreviewableLink', id: string, URL: string, createdAt: string, updatedAt?: string | null, resourceID: string, resourceType: PreviewableLinkResourceType } | null };

export type CreateStorageSubscriptionMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateStorageSubscriptionMutation = { __typename: 'Mutation', createStorageSubscription?: { __typename: 'CreateStorageSubscriptionPayload', subscription?: any | null, clientMutationId?: string | null } | null };

export type CreateInferenceSubscriptionMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateInferenceSubscriptionMutation = { __typename: 'Mutation', createInferenceSubscription?: { __typename: 'CreateInferenceSubscriptionPayload', subscription?: any | null, clientMutationId?: string | null } | null };

export type CreatePricingPlanUpdatePrMutationVariables = Exact<{
  input: CreatePricingPlanUpdatePrInput;
}>;


export type CreatePricingPlanUpdatePrMutation = { __typename: 'Mutation', createPricingPlanUpdatePR?: { __typename: 'CreatePricingPlanUpdatePRPayload', prUrl: string, branchName: string } | null };

export type CreateSandboxesSubscriptionMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateSandboxesSubscriptionMutation = { __typename: 'Mutation', createSandboxesSubscription?: { __typename: 'CreateSandboxesSubscriptionPayload', subscription?: any | null, clientMutationId?: string | null } | null };

export type ProfilePageQueryVariables = Exact<{
  username: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  displayNameContains?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfilePageQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, name: string, username?: string | null, email?: string | null, photoUrl?: string | null, userInfo?: any | null, hideTeamsFromPublic: boolean, accountType?: UserAccountType | null, defaultEntity?: { __typename: 'Entity', id: string, name: string } | null, views?: { __typename: 'ViewConnection', totalCount: number, edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, description?: string | null, starCount: number, createdAt: string, updatedAt?: string | null, starred?: boolean | null, showcasedAt?: string | null, previewUrl?: string | null, viewCount: number, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null } | null } | null }> } | null, starredViews?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, description?: string | null, starCount: number, createdAt: string, updatedAt?: string | null, starred?: boolean | null, showcasedAt?: string | null, previewUrl?: string | null, viewCount: number, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null } | null } | null }> } | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, photoUrl?: string | null, isTeam: boolean } | null }> } | null } | null };

export type ProfilePageReportsQueryVariables = Exact<{
  username: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  displayNameContains?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfilePageReportsQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, views?: { __typename: 'ViewConnection', totalCount: number, edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, description?: string | null, starCount: number, createdAt: string, updatedAt?: string | null, starred?: boolean | null, showcasedAt?: string | null, previewUrl?: string | null, viewCount: number, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null } | null } | null }> } | null } | null };

export type ProfileUserCheckQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type ProfileUserCheckQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, name: string, username?: string | null } | null };

export type ProfilePageProjectsQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type ProfilePageProjectsQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, description?: string | null, totalRuns?: number | null, lastActive?: string | null, runCount: number, user?: { __typename: 'User', id: string, username?: string | null } | null } | null }> } | null } | null };

export type UserRunsActivityQueryVariables = Exact<{
  username: Scalars['String']['input'];
  dailyRunCountLimit: Scalars['Int']['input'];
}>;


export type UserRunsActivityQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, dailyRunCount: Array<number> } | null };

export type UserRunsQueryVariables = Exact<{
  username: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserRunsQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string, heartbeatAt?: string | null, updatedAt?: string | null, notes?: string | null, groupCounts?: Array<number> | null, user?: { __typename: 'User', id: string, username?: string | null, name: string, accountType?: UserAccountType | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }> } }> } | null } | null };

export type ProjectNameFromInternalIdQueryVariables = Exact<{
  internalId: Scalars['ID']['input'];
}>;


export type ProjectNameFromInternalIdQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, entityName: string, name: string } | null };

export type ProjectInternalIdFromNameQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type ProjectInternalIdFromNameQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, internalId: string } | null };

export type ProjectInfosFromInternalIdsQueryVariables = Exact<{
  internalIds: Array<Scalars['ID']['input']>;
}>;


export type ProjectInfosFromInternalIdsQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string } | null }> } | null };

export type AllProjectNamesQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllProjectNamesQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string } | null }> } | null };

export type AllProjectNamesWithPatternQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllProjectNamesWithPatternQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string } | null }> } | null };

export type MoveProjectsMutationVariables = Exact<{
  projectNames?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceEntityName: Scalars['String']['input'];
  destinationEntityName: Scalars['String']['input'];
  ownerUsername: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MoveProjectsMutation = { __typename: 'Mutation', moveProjects?: { __typename: 'MoveProjectsPayload', tasks: Array<{ __typename: 'Task', id: string, type: string, state: TaskState, progress: number, name: string }> } | null };

export type CloneProjectsMutationVariables = Exact<{
  projectNames?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceEntityName: Scalars['String']['input'];
  destinationEntityName: Scalars['String']['input'];
  ownerUsername: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CloneProjectsMutation = { __typename: 'Mutation', cloneProjects?: { __typename: 'CloneProjectsPayload', tasks: Array<{ __typename: 'Task', id: string, type: string, state: TaskState, progress: number, name: string }> } | null };

export type MoveHistoryForRunMutationVariables = Exact<{
  sourceEntityName: Scalars['String']['input'];
  sourceProjectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  destinationEntityName: Scalars['String']['input'];
  destinationProjectName: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MoveHistoryForRunMutation = { __typename: 'Mutation', moveHistoryForRun?: { __typename: 'MoveHistoryForRunPayload', task?: { __typename: 'Task', id: string, type: string, state: TaskState, progress: number, name: string } | null } | null };

export type ProjectMemberFieldsFragment = { __typename: 'ProjectMember', id: string, name?: string | null, username?: string | null, email?: string | null, photoUrl?: string | null, accountType: string, projectRoleIsInherited: boolean, role: { __typename: 'Role', ID: string, name: string, inheritedFrom?: { __typename: 'Role', permissions: Array<{ __typename: 'RolePermission', name: string }> } | null, permissions: Array<{ __typename: 'RolePermission', name: string }> } };

export type ProjectMembersQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
}>;


export type ProjectMembersQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, members: Array<{ __typename: 'ProjectMember', id: string, name?: string | null, username?: string | null, email?: string | null, photoUrl?: string | null, accountType: string, projectRoleIsInherited: boolean, role: { __typename: 'Role', ID: string, name: string, inheritedFrom?: { __typename: 'Role', permissions: Array<{ __typename: 'RolePermission', name: string }> } | null, permissions: Array<{ __typename: 'RolePermission', name: string }> } }> } | null };

export type ProjectMemberQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  memberId: Scalars['ID']['input'];
}>;


export type ProjectMemberQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, member?: { __typename: 'ProjectMember', id: string, name?: string | null, username?: string | null, email?: string | null, photoUrl?: string | null, accountType: string, projectRoleIsInherited: boolean, role: { __typename: 'Role', ID: string, name: string, inheritedFrom?: { __typename: 'Role', permissions: Array<{ __typename: 'RolePermission', name: string }> } | null, permissions: Array<{ __typename: 'RolePermission', name: string }> } } | null } | null };

export type CreateProjectMembersMutationVariables = Exact<{
  userIds: Array<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
}>;


export type CreateProjectMembersMutation = { __typename: 'Mutation', createProjectMembers?: { __typename: 'CreateProjectMembersPayload', success: boolean } | null };

export type DeleteProjectMembersMutationVariables = Exact<{
  userIds: Array<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
}>;


export type DeleteProjectMembersMutation = { __typename: 'Mutation', deleteProjectMembers?: { __typename: 'DeleteProjectMembersPayload', success: boolean } | null };

export type ProjectMembersEntityMembersQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectMembersEntityMembersQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, members: Array<{ __typename: 'ProjectMember', id: string, role: { __typename: 'Role', ID: string, name: string } }>, entity: { __typename: 'Entity', id: string, members: Array<{ __typename: 'Member', id?: string | null, role?: string | null, admin?: boolean | null, pending?: boolean | null, email?: string | null, username?: string | null, name: string, photoUrl?: string | null, accountType?: string | null, memberRole?: { __typename: 'Role', ID: string, name: string, permissions: Array<{ __typename: 'RolePermission', name: string, groupName: string, displayName: string }> } | null }> } } | null };

export type RampSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type RampSettingsQuery = { __typename: 'Query', rampManager?: { __typename: 'RampManager', settings: { __typename: 'RampSettingConnection', edges: Array<{ __typename: 'RampSettingEdge', name: string, group: string, description: string, rampType: RampType, rampIDType: RampIdType, stores: Array<{ __typename: 'RampThresholdStore', name: string, thresholds: Array<{ __typename: 'RampSettingThreshold', checkId: string, displayCheckID: string, threshold: number }> }> }> } } | null };

export type IdIsRampedForSettingQueryVariables = Exact<{
  setting: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type IdIsRampedForSettingQuery = { __typename: 'Query', rampManager?: { __typename: 'RampManager', setting?: { __typename: 'RampSettingEdge', idIsRamped: boolean } | null } | null };

export type UpdateRampThresholdMutationVariables = Exact<{
  store: Scalars['String']['input'];
  setting: Scalars['String']['input'];
  checkId: Scalars['String']['input'];
  threshold: Scalars['Float']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateRampThresholdMutation = { __typename: 'Mutation', updateRampThreshold?: { __typename: 'UpdateRampThresholdPayload', success: boolean, clientMutationId?: string | null } | null };

export type FetchRepoDisplayNameByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FetchRepoDisplayNameByIdQuery = { __typename: 'Query', repo?: { __typename: 'Repo', id: string, displayName: string } | null };

export type ReportSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type ReportSearchQuery = { __typename: 'Query', reportSearch?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', entityName: string, displayName?: string | null, id: string, projectName: string } | null }> } | null };

export type OrganizationRolesQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrganizationRolesQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, roles: Array<{ __typename: 'Role', ID: string, name: string, description?: string | null, inheritedFrom?: { __typename: 'Role', name: string } | null }> } | null };

export type OrganizationRolePermissionsQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrganizationRolePermissionsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, roles: Array<{ __typename: 'Role', ID: string, name: string, description?: string | null, inheritedFrom?: { __typename: 'Role', ID: string, name: string } | null, permissions: Array<{ __typename: 'RolePermission', name: string, displayName: string, groupName: string }> }> } | null };

export type CreateRoleMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  inheritedFrom: Scalars['String']['input'];
  permissions: Array<Scalars['String']['input']>;
  organizationID: Scalars['ID']['input'];
}>;


export type CreateRoleMutation = { __typename: 'Mutation', createRole?: { __typename: 'CreateRolePayload', success: boolean } | null };

export type UpdateRoleMutationVariables = Exact<{
  roleID: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inheritedFrom?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateRoleMutation = { __typename: 'Mutation', updateRole?: { __typename: 'UpdateRolePayload', success: boolean } | null };

export type DeleteRoleMutationVariables = Exact<{
  roleID: Scalars['ID']['input'];
}>;


export type DeleteRoleMutation = { __typename: 'Mutation', deleteRole?: { __typename: 'DeleteRolePayload', success: boolean } | null };

export type AddRolePermissionsMutationVariables = Exact<{
  roleID: Scalars['ID']['input'];
  permissions: Array<Scalars['String']['input']>;
}>;


export type AddRolePermissionsMutation = { __typename: 'Mutation', addRolePermissions?: { __typename: 'AddRolePermissionsPayload', success: boolean } | null };

export type DeleteRolePermissionsMutationVariables = Exact<{
  roleID: Scalars['ID']['input'];
  permissions: Array<Scalars['String']['input']>;
}>;


export type DeleteRolePermissionsMutation = { __typename: 'Mutation', deleteRolePermissions?: { __typename: 'DeleteRolePermissionsPayload', success: boolean } | null };

export type EntityMemberRoleQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  memberId: Scalars['ID']['input'];
}>;


export type EntityMemberRoleQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, member?: { __typename: 'Member', id?: string | null, role?: string | null, memberRole?: { __typename: 'Role', ID: string, name: string, inheritedFrom?: { __typename: 'Role', permissions: Array<{ __typename: 'RolePermission', name: string, groupName: string, displayName: string }> } | null, permissions: Array<{ __typename: 'RolePermission', name: string, groupName: string, displayName: string }> } | null } | null } | null };

export type GroupPageRunQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
}>;


export type GroupPageRunQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, access?: string | null, views?: any | null, entityName: string, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, run?: { __typename: 'Run', id: string, name: string, config?: any | null, summaryMetrics?: any | null, historyKeys?: any | null, state?: string | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null } | null, outputLogFile?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, md5?: string | null, sizeBytes: any, directUrl: string, url?: string | null } | null }> } | null } | null } | null };

export type RunQueueItemFragmentFragment = { __typename: 'RunQueueItem', id: string, createdAt: string, updatedAt?: string | null, runSpec: any, state: RunQueueItemState, associatedRunId?: string | null, launchAgentId?: string | null, priority: number, templateVariableValues?: any | null };

export type CreateRunQueueMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  queueName: Scalars['String']['input'];
  access: RunQueueAccessType;
  defaultResourceConfigID?: InputMaybe<Scalars['ID']['input']>;
  prioritizationMode: RunQueuePrioritizationMode;
}>;


export type CreateRunQueueMutation = { __typename: 'Mutation', createRunQueue?: { __typename: 'CreateRunQueuePayload', success?: boolean | null, queueID?: string | null } | null };

export type UpdateRunQueueMutationVariables = Exact<{
  queueID: Scalars['ID']['input'];
  defaultResourceConfigID?: InputMaybe<Scalars['ID']['input']>;
  externalLinks?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type UpdateRunQueueMutation = { __typename: 'Mutation', updateRunQueue?: { __typename: 'UpdateRunQueuePayload', success?: boolean | null } | null };

export type EnableRunQueuePrioritizationMutationVariables = Exact<{
  queueID: Scalars['ID']['input'];
}>;


export type EnableRunQueuePrioritizationMutation = { __typename: 'Mutation', updateRunQueue?: { __typename: 'UpdateRunQueuePayload', success?: boolean | null } | null };

export type DeleteRunQueuesMutationVariables = Exact<{
  queueIDs: Array<Scalars['ID']['input']>;
}>;


export type DeleteRunQueuesMutation = { __typename: 'Mutation', deleteRunQueues?: { __typename: 'DeleteRunQueuesPayload', success?: boolean | null } | null };

export type PushToRunQueueMutationVariables = Exact<{
  queueID: Scalars['ID']['input'];
  runSpec: Scalars['JSONString']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  templateVariableValues?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type PushToRunQueueMutation = { __typename: 'Mutation', pushToRunQueue?: { __typename: 'PushToRunQueuePayload', runQueueItemId: string } | null };

export type DeleteFromRunQueueMutationVariables = Exact<{
  queueID: Scalars['ID']['input'];
  runQueueItemId: Scalars['ID']['input'];
}>;


export type DeleteFromRunQueueMutation = { __typename: 'Mutation', deleteFromRunQueue?: { __typename: 'DeleteFromRunQueuePayload', success?: boolean | null } | null };

export type FetchRunQueuesFromProjectQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type FetchRunQueuesFromProjectQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runQueues: Array<{ __typename: 'RunQueue', id: string, createdAt: string, createdBy?: number | null, access: RunQueueAccessType, updatedAt?: string | null, name: string, defaultResourceConfigID?: string | null, executorInfo: string, runQueueItems: { __typename: 'RunQueueItemConnection', edges: Array<{ __typename: 'RunQueueItemEdge', node: { __typename: 'RunQueueItem', id: string, createdAt: string, updatedAt?: string | null, runSpec: any, state: RunQueueItemState, associatedRunId?: string | null, launchAgentId?: string | null, priority: number, templateVariableValues?: any | null } }> } }> } | null };

export type FetchRunQueueByNameQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runQueueName: Scalars['String']['input'];
}>;


export type FetchRunQueueByNameQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runQueue?: { __typename: 'RunQueue', id: string, createdAt: string, createdBy?: number | null, access: RunQueueAccessType, updatedAt?: string | null, name: string, defaultResourceConfigID?: string | null, executorInfo: string, runQueueItems: { __typename: 'RunQueueItemConnection', edges: Array<{ __typename: 'RunQueueItemEdge', node: { __typename: 'RunQueueItem', id: string, createdAt: string, updatedAt?: string | null, runSpec: any, state: RunQueueItemState, associatedRunId?: string | null, launchAgentId?: string | null, priority: number, templateVariableValues?: any | null } }> } } | null } | null };

export type FetchRunQueueItemFromProjectQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runQueueName: Scalars['String']['input'];
  runQueueItemID: Scalars['ID']['input'];
}>;


export type FetchRunQueueItemFromProjectQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runQueue?: { __typename: 'RunQueue', id: string, runQueueItem?: { __typename: 'RunQueueItem', id: string, createdAt: string, updatedAt?: string | null, runSpec: any, state: RunQueueItemState, associatedRunId?: string | null, launchAgentId?: string | null, priority: number, templateVariableValues?: any | null } | null } | null } | null };

export type TeamInfoQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type TeamInfoQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, members: Array<{ __typename: 'Member', id?: string | null, role?: string | null, username?: string | null, name: string, admin?: boolean | null }> } | null };

export type RunDisplayNameQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type RunDisplayNameQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, displayName?: string | null } | null } | null };

export type RunsStateQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type RunsStateQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null } }> } | null } | null };

export type RunTensorboardQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type RunTensorboardQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, servicesAvailable?: { __typename: 'RunServicesAvailable', tensorboard?: boolean | null } | null } | null } | null };

export type BasicRunFragmentFragment = { __typename: 'Run', id: string, readOnly?: boolean | null, framework?: string | null, displayName?: string | null, notes?: string | null, github?: string | null, group?: string | null, jobType?: string | null, createdAt: string, heartbeatAt?: string | null, commit?: string | null, host?: string | null, state?: string | null, shouldStop?: boolean | null, groupCounts?: Array<number> | null, stopped?: boolean | null, defaultColorIndex?: number | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null } | null, agent?: { __typename: 'Agent', id: string, name: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, runInfo?: { __typename: 'RunInfo', gpuCount?: number | null, gpu?: string | null } | null };

export type DetailedRunFragmentFragment = { __typename: 'Run', history: Array<string>, events: Array<string>, fileCount?: number | null, logLines?: { __typename: 'LogLineConnection', edges: Array<{ __typename: 'LogLineEdge', node: { __typename: 'LogLine', id?: string | null, line?: string | null, level?: string | null } }> } | null };

export type RunFilesFragmentFragment = { __typename: 'Run', files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, directUrl: string, url?: string | null, sizeBytes: any, updatedAt?: string | null } | null }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };

export type SelectRunFragmentFragment = { __typename: 'Run', config?: any | null, summaryMetrics?: any | null, systemMetrics?: any | null };

export type HistoryRunFragmentFragment = { __typename: 'Run', history: Array<string> };

export type SampledHistoryRunFragmentFragment = { __typename: 'Run', sampledHistory: Array<any> };

export type RunsModelQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  jobKey?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  bucketIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestSubscribe: Scalars['Boolean']['input'];
  selectEnable?: InputMaybe<Scalars['Boolean']['input']>;
  basicEnable?: InputMaybe<Scalars['Boolean']['input']>;
  history?: InputMaybe<Scalars['Boolean']['input']>;
  historyKeyInfo?: InputMaybe<Scalars['Boolean']['input']>;
  historySamples?: InputMaybe<Scalars['Int']['input']>;
  sampledHistory?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  historyFields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sampledHistorySpecs: Array<Scalars['JSONString']['input']>;
  groupKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupLevel?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RunsModelQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, createdAt: string, entityName: string, description?: string | null, summaryMetrics?: any | null, views?: any | null, requestSubscribe?: boolean | null, runCount: number, runs?: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, historyKeys?: any | null, config?: any | null, summaryMetrics?: any | null, systemMetrics?: any | null, readOnly?: boolean | null, framework?: string | null, notes?: string | null, github?: string | null, group?: string | null, jobType?: string | null, createdAt: string, heartbeatAt?: string | null, commit?: string | null, host?: string | null, state?: string | null, shouldStop?: boolean | null, groupCounts?: Array<number> | null, stopped?: boolean | null, defaultColorIndex?: number | null, history: Array<string>, sampledHistory: Array<any>, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null } | null, agent?: { __typename: 'Agent', id: string, name: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, runInfo?: { __typename: 'RunInfo', gpuCount?: number | null, gpu?: string | null } | null } }>, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, hasPreviousPage: boolean, endCursor?: string | null, hasNextPage: boolean } } | null } | null, viewer?: { __typename: 'User', id: string, email?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, serverInfo?: { __typename: 'ServerInfo', pollingOK: boolean } | null };

export type UpsertRunMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type UpsertRunMutation = { __typename: 'Mutation', upsertBucket?: { __typename: 'UpsertBucketPayload', inserted?: boolean | null, bucket?: { __typename: 'Run', id: string, name: string, displayName?: string | null, notes?: string | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, project?: { __typename: 'Project', id: string, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }> } | null } | null } | null };

export type RunGroupRenameQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  newName: Scalars['String']['input'];
}>;


export type RunGroupRenameQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, source?: { __typename: 'RunGroup', id: string, notes?: string | null, tags: Array<{ __typename: 'RunTag', id: string, name: string }> } | null, target?: { __typename: 'RunGroup', id: string, notes?: string | null, tags: Array<{ __typename: 'RunTag', id: string, name: string }> } | null } | null };

export type UpsertRunGroupMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  newName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type UpsertRunGroupMutation = { __typename: 'Mutation', upsertRunGroup?: { __typename: 'UpsertRunGroupPayload', group?: { __typename: 'RunGroup', id: string, name: string, notes?: string | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, project: { __typename: 'Project', id: string, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }> } } | null } | null };

export type ModifyRunsMutationVariables = Exact<{
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  addTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  removeTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}>;


export type ModifyRunsMutation = { __typename: 'Mutation', modifyRuns?: { __typename: 'ModifyRunsPayload', runsSQL: Array<{ __typename: 'Run', id: string, name: string, config?: any | null, summaryMetrics?: any | null, systemMetrics?: any | null, readOnly?: boolean | null, framework?: string | null, displayName?: string | null, notes?: string | null, github?: string | null, group?: string | null, jobType?: string | null, createdAt: string, heartbeatAt?: string | null, commit?: string | null, host?: string | null, state?: string | null, shouldStop?: boolean | null, groupCounts?: Array<number> | null, stopped?: boolean | null, defaultColorIndex?: number | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null } | null, agent?: { __typename: 'Agent', id: string, name: string } | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, runInfo?: { __typename: 'RunInfo', gpuCount?: number | null, gpu?: string | null } | null } | null> } | null };

export type MoveRunsMutationVariables = Exact<{
  filters: Scalars['JSONString']['input'];
  sourceEntityName: Scalars['String']['input'];
  sourceProjectName: Scalars['String']['input'];
  destinationEntityName: Scalars['String']['input'];
  destinationProjectName: Scalars['String']['input'];
}>;


export type MoveRunsMutation = { __typename: 'Mutation', moveRuns?: { __typename: 'MoveRunsPayload', task: { __typename: 'Task', id: string } } | null };

export type DeleteRunsMutationVariables = Exact<{
  filters: Scalars['JSONString']['input'];
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  deleteArtifacts: Scalars['Boolean']['input'];
}>;


export type DeleteRunsMutation = { __typename: 'Mutation', deleteRuns?: { __typename: 'DeleteRunsPayload', clientMutationId?: string | null, errors?: string | null } | null };

export type UndeleteRunsMutationVariables = Exact<{
  filters: Scalars['JSONString']['input'];
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type UndeleteRunsMutation = { __typename: 'Mutation', undeleteRuns?: { __typename: 'UndeleteRunsPayload', clientMutationId?: string | null } | null };

export type DeleteRunMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  deleteArtifacts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteRunMutation = { __typename: 'Mutation', deleteRun?: { __typename: 'DeleteRunPayload', clientMutationId?: string | null, numDeleted?: any | null } | null };

export type StopRunMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StopRunMutation = { __typename: 'Mutation', stopRun?: { __typename: 'StopRunPayload', clientMutationId?: string | null } | null };

export type RunStopMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RunStopMutation = { __typename: 'Mutation', stopRun?: { __typename: 'StopRunPayload', success: boolean } | null };

export type DeleteFilesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']>;
  projectId: Scalars['Int']['input'];
}>;


export type DeleteFilesMutation = { __typename: 'Mutation', deleteFiles?: { __typename: 'DeleteFilesPayload', clientMutationId?: string | null, success: boolean } | null };

export type DeleteFilesByRunAndFolderMutationVariables = Exact<{
  runName: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
  folders: Array<Scalars['String']['input']>;
}>;


export type DeleteFilesByRunAndFolderMutation = { __typename: 'Mutation', deleteFilesByRunAndFolder?: { __typename: 'DeleteFilesPayload', clientMutationId?: string | null, success: boolean } | null };

export type RunHasProtectedOutputArtifactQueryVariables = Exact<{
  runName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
}>;


export type RunHasProtectedOutputArtifactQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, hasProtectedOutputArtifact: boolean } | null } | null };

export type RunsHaveProtectedOutputArtifactsQueryVariables = Exact<{
  filters: Scalars['JSONString']['input'];
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
}>;


export type RunsHaveProtectedOutputArtifactsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runsHaveProtectedOutputArtifacts: boolean } | null };

export type UpsertTeamSecretMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  secretName: Scalars['String']['input'];
  secretValue: Scalars['String']['input'];
}>;


export type UpsertTeamSecretMutation = { __typename: 'Mutation', upsertTeamSecret?: { __typename: 'UpsertTeamSecretPayload', secret?: { __typename: 'UpsertedSecret', name: string } | null } | null };

export type DeleteSecretMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  secretName: Scalars['String']['input'];
}>;


export type DeleteSecretMutation = { __typename: 'Mutation', deleteSecret?: { __typename: 'DeleteSecretPayload', success: boolean } | null };

export type SecretsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type SecretsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, secrets: Array<{ __typename: 'Secret', entityId: number, name: string, uuid: string, createdAt: string }> } | null };

export type UserSecretFieldsFragment = { __typename: 'UserSecret', uuid: string, name: string, createdAt: string, organizationId: number };

export type UserSecretsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UserSecretsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, username?: string | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, organizationId?: string | null, secrets: Array<{ __typename: 'Secret', name: string }> } | null }> } | null, secrets: Array<{ __typename: 'UserSecret', uuid: string, name: string, createdAt: string, organizationId: number }> } | null };

export type UpsertUserSecretMutationVariables = Exact<{
  secretName: Scalars['String']['input'];
  secretValue: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpsertUserSecretMutation = { __typename: 'Mutation', upsertUserSecret?: { __typename: 'UpsertUserSecretPayload', secret?: { __typename: 'UpsertedSecret', uuid: string, name: string, createdAt: string } | null } | null };

export type DeleteUserSecretMutationVariables = Exact<{
  secretName: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteUserSecretMutation = { __typename: 'Mutation', deleteUserSecret?: { __typename: 'DeleteUserSecretPayload', success: boolean } | null };

export type ServerInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ServerInfoQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', isGoogleIap: boolean, slackClientID: string, availableCloudRegions: Array<{ __typename: 'CloudRegion', id: string, provider: CloudProvider, region: string }> } | null };

export type LicenseExpirationUiQueryVariables = Exact<{ [key: string]: never; }>;


export type LicenseExpirationUiQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', licenseExpirationUI?: { __typename: 'LicenseExpirationUI', bannerTotalDays: number, bannerDaysRemaining: number, renewUrl?: string | null } | null } | null };

export type UserLimitReachedQueryVariables = Exact<{ [key: string]: never; }>;


export type UserLimitReachedQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', userLimitReached: boolean, viewOnlyUserLimitReached: boolean, licenseFlags: Array<string> } | null };

export type ViewOnlyUserLimitReachedQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewOnlyUserLimitReachedQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', viewOnlyUserLimitReached: boolean } | null };

export type RegisteredModelLimitReachedQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type RegisteredModelLimitReachedQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', registeredModelLimitReached: boolean } | null };

export type ActionHistoryLimitQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  artifactCollectionID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ActionHistoryLimitQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', actionHistoryLimit: number } | null };

export type FrontendHostQueryVariables = Exact<{ [key: string]: never; }>;


export type FrontendHostQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', frontendHost: string } | null };

export type DeploymentIdQueryVariables = Exact<{ [key: string]: never; }>;


export type DeploymentIdQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', deploymentId?: string | null } | null };

export type SecureStorageConnectorEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type SecureStorageConnectorEnabledQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', secureStorageConnectorEnabled: boolean } | null };

export type AvailableBucketProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableBucketProvidersQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', availableBucketProviders: Array<CloudProvider> } | null };

export type DataRetentionDurationQueryVariables = Exact<{ [key: string]: never; }>;


export type DataRetentionDurationQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', dataRetentionDuration: number } | null };

export type FailedPaymentBannersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FailedPaymentBannersQuery = { __typename: 'Query', failedPaymentBanners?: { __typename: 'FailedPaymentBanners', userID: number, orgsWithFailedPayments: Array<{ __typename: 'OrganizationDataForFailedPaymentBanner', id: string, orgId: number, orgName: string, isBillingUser: boolean, billingEmail: string, daysUntilCancellation: number, isCollectionMethodACH: boolean } | null> } | null };

export type SingleFileQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
}>;


export type SingleFileQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, directUrl: string, sizeBytes: any, updatedAt?: string | null } | null }> } | null } | null } | null };

export type StarredProjectsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type StarredProjectsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, starredProjects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, totalRuns?: number | null, createdAt: string, lastActive?: string | null, description?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null } | null }> } | null } | null };

export type SubscriptionPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionPlansQuery = { __typename: 'Query', plans: Array<{ __typename: 'Plan', id: string, name: string, displayName: string, stripePlanId?: string | null, maxSeats: number, defaultPrivileges: any, planType: PlanType, planVisibility: PlanVisibility, unitPrice?: number | null, billingInterval?: string | null } | null> };

export type UpsertSweepMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  priorRunsFilters?: InputMaybe<Scalars['JSONString']['input']>;
  launchScheduler?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type UpsertSweepMutation = { __typename: 'Mutation', upsertSweep?: { __typename: 'UpsertSweepPayload', inserted?: boolean | null, insertedPriorRuns?: number | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, description?: string | null, state: string } | null } | null };

export type DeleteSweepsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']>;
  deleteRuns: Scalars['Boolean']['input'];
}>;


export type DeleteSweepsMutation = { __typename: 'Mutation', deleteSweeps?: { __typename: 'DeleteSweepsPayload', affectedAgents: number, affectedRuns: number } | null };

export type GetTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTaskQuery = { __typename: 'Query', task?: { __typename: 'Task', id: string, name: string, state: TaskState, progress: number, createdAt: string, updatedAt?: string | null, type: string, result?: string | null } | null };

export type OrgMemberFieldsFragment = { __typename: 'OrganizationMember', orgID: string, id: string, email: string, username: string, role: string, modelsSeat: string, weaveRole: string };

export type TeamMembersOrgMemberFieldsFragment = { __typename: 'OrganizationMember', orgID: string, id: string, email: string, username: string, role: string, modelsSeat: string, weaveRole: string, user: { __typename: 'User', id: string, deletedAt?: string | null, email?: string | null, username?: string | null } };

export type EntityIsTeamQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type EntityIsTeamQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, isTeam: boolean } | null };

export type BasicTeamOrganizationQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type BasicTeamOrganizationQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, isTeam: boolean, available?: boolean | null, organization?: { __typename: 'Organization', id: string, name: string } | null } | null };

export type TeamOrganizationQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type TeamOrganizationQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, isTeam: boolean, computeHours: number, settings: { __typename: 'EntitySettings', openToMatchingOrgEmailDomainUsers?: boolean | null, membersCanInvite?: boolean | null, disableMagicLinkSharing?: boolean | null }, organization?: { __typename: 'Organization', id: string, name: string, flags?: any | null, usedSeats: number, memberCount: number, orgType: OrgType, roles: Array<{ __typename: 'Role', ID: string, name: string, description?: string | null, inheritedFrom?: { __typename: 'Role', name: string } | null }>, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, email: string, username: string, role: string, modelsSeat: string, weaveRole: string }>, seatAvailability: { __typename: 'OrganizationSeatAvailability', seats: number, viewOnlySeats: number }, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, privileges: any, subscriptionType: OrganizationSubscriptionType, billingPeriodStart?: string | null, billingPeriodEnd?: string | null, availableSeatsToPurchase: number, seats: number, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType, unitPrice?: number | null, billingInterval?: string | null, defaultPrivileges: any, maxSeats: number } }> } | null } | null };

export type TeamMembersOrganizationQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type TeamMembersOrganizationQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, organization?: { __typename: 'Organization', id: string, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, email: string, username: string, role: string, modelsSeat: string, weaveRole: string, user: { __typename: 'User', id: string, deletedAt?: string | null, email?: string | null, username?: string | null } }> } | null } | null };

export type TeamOrganizationRolesQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type TeamOrganizationRolesQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, settings: { __typename: 'EntitySettings', membersCanInvite?: boolean | null }, members: Array<{ __typename: 'Member', id?: string | null, username?: string | null, role?: string | null }>, organization?: { __typename: 'Organization', id: string, seatAvailability: { __typename: 'OrganizationSeatAvailability', viewOnlySeats: number }, roles: Array<{ __typename: 'Role', ID: string, name: string, description?: string | null, inheritedFrom?: { __typename: 'Role', name: string } | null }>, members: Array<{ __typename: 'OrganizationMember', id: string, username: string, role: string }> } | null } | null };

export type TeamOrganizationMembersQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type TeamOrganizationMembersQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, isTeam: boolean, organizationId?: string | null } | null };

export type TeamPageProjectsTwoQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TeamPageProjectsTwoQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, organizationId?: string | null, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, description?: string | null, totalRuns?: number | null, lastActive?: string | null } | null }> } | null } | null };

export type TeamPageProjectsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type TeamPageProjectsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, organizationId?: string | null, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null } | null }> } | null } | null };

export type TeamPageReportsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  displayNameContains?: InputMaybe<Scalars['String']['input']>;
}>;


export type TeamPageReportsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, views: { __typename: 'ViewConnection', totalCount: number, edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, description?: string | null, starCount: number, createdAt: string, updatedAt?: string | null, starred?: boolean | null, showcasedAt?: string | null, previewUrl?: string | null, viewCount: number, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null } | null } | null }> } } | null };

export type FetchTeamProfilePageProjectsByIDsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectIDs: Array<Scalars['ID']['input']>;
}>;


export type FetchTeamProfilePageProjectsByIDsQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, lastActive?: string | null, runCount: number, user?: { __typename: 'User', id: string, username?: string | null } | null } | null }> } | null };

export type TeamPageQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  workflowsAdminType: WorkflowsAdminType;
}>;


export type TeamPageQuery = { __typename: 'Query', entity?: { __typename: 'Entity', available?: boolean | null, id: string, isTeam: boolean, memberCount: number, name: string, organizationId?: string | null, photoUrl?: string | null, projectCount: number, readOnly?: boolean | null, protectedAliases: Array<string>, claimingEntity?: { __typename: 'Entity', id: string, name: string } | null, members: Array<{ __typename: 'Member', id?: string | null, admin?: boolean | null, pending?: boolean | null, email?: string | null, username?: string | null, name: string, photoUrl?: string | null, accountType?: string | null, apiKeyCount?: number | null, role?: string | null, serviceAccountAuthMethod?: ServiceAccountAuthMethod | null, memberRole?: { __typename: 'Role', ID: string, name: string } | null }>, invites?: { __typename: 'InviteConnection', edges: Array<{ __typename: 'InviteEdge', node?: { __typename: 'Invite', id: string, email?: string | null, fromUser?: { __typename: 'User', id: string, username?: string | null } | null } | null }> } | null, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string } | null }> } | null, workflowsAdmins: Array<{ __typename: 'User', id: string, username?: string | null, name: string, email?: string | null }>, publicQueueLaunchAgents: Array<{ __typename: 'User', id: string, username?: string | null, name: string, email?: string | null }> } | null };

export type AvailableTeamQueryVariables = Exact<{
  teamName: Scalars['String']['input'];
}>;


export type AvailableTeamQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, available?: boolean | null } | null };

export type AvailableOrgQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type AvailableOrgQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, available: boolean } | null };

export type OrganizationStorageBucketInfosQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationStorageBucketInfosQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, teams: Array<{ __typename: 'Entity', id: string, settings: { __typename: 'EntitySettings', storageBucketInfo?: { __typename: 'StorageBucketInfo', ID: string, provider: CloudProvider, name: string, kmsKeyID?: string | null, awsExternalID?: string | null, path?: string | null } | null } }> } | null };

export type StorageBucketInfosQueryVariables = Exact<{ [key: string]: never; }>;


export type StorageBucketInfosQuery = { __typename: 'Query', entities?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, settings: { __typename: 'EntitySettings', storageBucketInfo?: { __typename: 'StorageBucketInfo', ID: string, provider: CloudProvider, name: string, kmsKeyID?: string | null, awsExternalID?: string | null, path?: string | null } | null } } | null }> } | null };

export type CreateTeamMutationVariables = Exact<{
  teamName: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  teamAdminUserName?: InputMaybe<Scalars['String']['input']>;
  storageBucketInfo?: InputMaybe<StorageBucketInfoInput>;
}>;


export type CreateTeamMutation = { __typename: 'Mutation', createTeam?: { __typename: 'CreateTeamPayload', entity?: { __typename: 'Entity', id: string, name: string, available?: boolean | null, photoUrl?: string | null, limits?: any | null } | null } | null };

export type TestBucketStoreConnectionMutationVariables = Exact<{
  input: StorageBucketInfoInput;
}>;


export type TestBucketStoreConnectionMutation = { __typename: 'Mutation', testBucketStoreConnection: Array<{ __typename: 'BucketStoreConnectionError', message: string, severity: ErrorSeverity }> };

export type TestReferenceBucketConnectionMutationVariables = Exact<{
  input: TestReferenceBucketConnectionInput;
}>;


export type TestReferenceBucketConnectionMutation = { __typename: 'Mutation', testReferenceBucketConnection: Array<{ __typename: 'BucketStoreConnectionError', message: string, severity: ErrorSeverity }> };

export type AddReferenceBucketToTeamMutationVariables = Exact<{
  input: AddReferenceBucketToTeamInput;
}>;


export type AddReferenceBucketToTeamMutation = { __typename: 'Mutation', addReferenceBucketToTeam: { __typename: 'AddReferenceBucketToTeamPayload', success: boolean, bucketStoreID: string, clientMutationID?: string | null, entity: { __typename: 'Entity', id: string, name: string } } };

export type DeleteTeamMutationVariables = Exact<{
  teamName: Scalars['String']['input'];
}>;


export type DeleteTeamMutation = { __typename: 'Mutation', deleteTeam?: { __typename: 'DeleteTeamPayload', success: boolean } | null };

export type EntityFeatureFlagsQueryVariables = Exact<{
  teamName?: InputMaybe<Scalars['String']['input']>;
  rampIDType: RampIdType;
}>;


export type EntityFeatureFlagsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, featureFlags: Array<{ __typename: 'FeatureFlag', rampKey: string, isEnabled: boolean } | null> } | null };

export type OrganizationTeamsQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrganizationTeamsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, teams: Array<{ __typename: 'Entity', id: string, name: string, memberCount: number, computeHours: number }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, privileges: any }>, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, username: string, role: string, user: { __typename: 'User', id: string, name: string, accountType?: UserAccountType | null, admin?: boolean | null, deletedAt?: string | null, email?: string | null, username?: string | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null } }> } | null };

export type EntityOrganizationQueryVariables = Exact<{
  teamName: Scalars['String']['input'];
}>;


export type EntityOrganizationQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, organization?: { __typename: 'Organization', id: string, name: string } | null } | null };

export type UserLevelAlertPreferencesFieldsFragment = { __typename: 'UserLevelAlertPreferences', alerts?: { __typename: 'UserLevelAlerts', runFinished?: { __typename: 'RunAlertChannelPrefs', email: boolean, slack: boolean } | null, runCrashed?: { __typename: 'RunCrashedChannelPrefs', email: boolean, slack: boolean, minimumRunDurationMs?: number | null } | null, scriptableAlert?: { __typename: 'RunAlertChannelPrefs', email: boolean, slack: boolean } | null } | null, slackIntegrations: Array<{ __typename: 'UserLevelSlackConfig', id: string, displayName: string, teamName?: string | null, channelName?: string | null }> };

export type CreateUserLevelSlackIntegrationMutationVariables = Exact<{
  code: Scalars['String']['input'];
  redirectURI: Scalars['String']['input'];
}>;


export type CreateUserLevelSlackIntegrationMutation = { __typename: 'Mutation', createUserLevelSlackIntegration?: { __typename: 'CreateUserLevelSlackIntegrationPayload', user?: { __typename: 'User', id: string, userLevelAlertPreferences?: { __typename: 'UserLevelAlertPreferences', alerts?: { __typename: 'UserLevelAlerts', runFinished?: { __typename: 'RunAlertChannelPrefs', email: boolean, slack: boolean } | null, runCrashed?: { __typename: 'RunCrashedChannelPrefs', email: boolean, slack: boolean, minimumRunDurationMs?: number | null } | null, scriptableAlert?: { __typename: 'RunAlertChannelPrefs', email: boolean, slack: boolean } | null } | null, slackIntegrations: Array<{ __typename: 'UserLevelSlackConfig', id: string, displayName: string, teamName?: string | null, channelName?: string | null }> } | null } | null } | null };

export type DeleteUserLevelSlackIntegrationMutationVariables = Exact<{
  integrationID: Scalars['ID']['input'];
}>;


export type DeleteUserLevelSlackIntegrationMutation = { __typename: 'Mutation', deleteUserLevelSlackIntegration?: { __typename: 'DeleteUserLevelSlackIntegrationPayload', user?: { __typename: 'User', id: string, userLevelAlertPreferences?: { __typename: 'UserLevelAlertPreferences', alerts?: { __typename: 'UserLevelAlerts', runFinished?: { __typename: 'RunAlertChannelPrefs', email: boolean, slack: boolean } | null, runCrashed?: { __typename: 'RunCrashedChannelPrefs', email: boolean, slack: boolean, minimumRunDurationMs?: number | null } | null, scriptableAlert?: { __typename: 'RunAlertChannelPrefs', email: boolean, slack: boolean } | null } | null, slackIntegrations: Array<{ __typename: 'UserLevelSlackConfig', id: string, displayName: string, teamName?: string | null, channelName?: string | null }> } | null } | null } | null };

export type UpdateUserLevelAlertPreferencesMutationVariables = Exact<{
  input: UpdateUserLevelAlertPreferencesInput;
}>;


export type UpdateUserLevelAlertPreferencesMutation = { __typename: 'Mutation', updateUserLevelAlertPreferences?: { __typename: 'UpdateUserLevelAlertPreferencesPayload', user?: { __typename: 'User', id: string, userLevelAlertPreferences?: { __typename: 'UserLevelAlertPreferences', alerts?: { __typename: 'UserLevelAlerts', runFinished?: { __typename: 'RunAlertChannelPrefs', email: boolean, slack: boolean } | null, runCrashed?: { __typename: 'RunCrashedChannelPrefs', email: boolean, slack: boolean, minimumRunDurationMs?: number | null } | null, scriptableAlert?: { __typename: 'RunAlertChannelPrefs', email: boolean, slack: boolean } | null } | null, slackIntegrations: Array<{ __typename: 'UserLevelSlackConfig', id: string, displayName: string, teamName?: string | null, channelName?: string | null }> } | null } | null } | null };

export type ViewerUserLevelAlertPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerUserLevelAlertPreferencesQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, userLevelAlertPreferences?: { __typename: 'UserLevelAlertPreferences', alerts?: { __typename: 'UserLevelAlerts', runFinished?: { __typename: 'RunAlertChannelPrefs', email: boolean, slack: boolean } | null, runCrashed?: { __typename: 'RunCrashedChannelPrefs', email: boolean, slack: boolean, minimumRunDurationMs?: number | null } | null, scriptableAlert?: { __typename: 'RunAlertChannelPrefs', email: boolean, slack: boolean } | null } | null, slackIntegrations: Array<{ __typename: 'UserLevelSlackConfig', id: string, displayName: string, teamName?: string | null, channelName?: string | null }> } | null } | null };

export type UserContextQueryVariables = Exact<{ [key: string]: never; }>;


export type UserContextQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, views?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, spec?: any | null } | null }> } | null } | null };

export type ViewerUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerUserInfoQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, userInfo?: any | null } | null };

export type UserOrganizationsQueryVariables = Exact<{
  emailDomain?: InputMaybe<Scalars['String']['input']>;
  includeOpenMatchingOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UserOrganizationsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, organizations: Array<{ __typename: 'Organization', id: string, name: string, orgType: OrgType, members: Array<{ __typename: 'OrganizationMember', id: string, admin: boolean }>, teams: Array<{ __typename: 'Entity', id: string, name: string }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, subscriptionType: OrganizationSubscriptionType, privileges: any, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType, displayName: string } }> }>, openMatchingOrganizations?: Array<{ __typename: 'Organization', id: string, name: string, orgType: OrgType, flags?: any | null, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, admin: boolean }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, status: OrganizationSubscriptionStatus }>, teams: Array<{ __typename: 'Entity', id: string, name: string, memberCount: number, settings: { __typename: 'EntitySettings', openToMatchingOrgEmailDomainUsers?: boolean | null } }> }> } | null };

export type EntityStorageBytesQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type EntityStorageBytesQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, storageBytes: any } | null };

export type EntityQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type EntityQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, available?: boolean | null, photoUrl?: string | null, readOnly?: boolean | null, readOnlyAdmin: boolean, isTeam: boolean, privateOnly: boolean, codeSavingEnabled: boolean, artifactTTLDurationSeconds: any, defaultAccess: string, isPaid?: boolean | null, computeHours: number, settings: { __typename: 'EntitySettings', hidden: boolean, openToMatchingOrgEmailDomainUsers?: boolean | null, membersCanInvite?: boolean | null, disableMagicLinkSharing?: boolean | null, disableMembersEditArtifactTTL: boolean, defaultCloudRegion: { __typename: 'CloudRegion', id: string, provider: CloudProvider, region: string }, storageBucketInfo?: { __typename: 'StorageBucketInfo', ID: string, provider: CloudProvider, name: string, kmsKeyID?: string | null, awsExternalID?: string | null, path?: string | null } | null, referenceBucketInfos: Array<{ __typename: 'StorageBucketInfo', ID: string, provider: CloudProvider, name: string, path?: string | null }> }, members: Array<{ __typename: 'Member', id?: string | null, admin?: boolean | null, role?: string | null, pending?: boolean | null, email?: string | null, username?: string | null, name: string, photoUrl?: string | null, accountType?: string | null, apiKey?: string | null }>, defaultAlerts: Array<{ __typename: 'Alert', id: string, condition:
        | { __typename: 'FinishedRunCondition', success: boolean }
        | { __typename: 'ScriptableRunCondition' }
        | { __typename: 'StoppedRunCondition', minimumRunDuration: number }
      , subscriptions: Array<
        | { __typename: 'EmailSubscription', id: string }
        | { __typename: 'SlackChannelSubscription', id: string }
      > }>, integrations?: { __typename: 'IntegrationConnection', edges: Array<{ __typename: 'IntegrationEdge', node?:
          | { __typename: 'GenericWebhookIntegration', id: string, urlEndpoint: string, name: string, accessTokenRef?: string | null, secretRef?: string | null, createdAt: string }
          | { __typename: 'GitHubOAuthIntegration', id: string }
          | { __typename: 'SlackIntegration', teamName: string, channelName: string, id: string }
         | null }> } | null, organization?: { __typename: 'Organization', id: string, name: string, orgType: OrgType, billingUser?: { __typename: 'User', id: string, username?: string | null } | null, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, privileges: any, seats: number, expiresAt?: string | null, subscriptionType: OrganizationSubscriptionType, status: OrganizationSubscriptionStatus, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }>, members: Array<{ __typename: 'OrganizationMember', orgID: string, id: string, username: string, name: string, photoUrl: string, admin: boolean, role: string }>, pendingInvites: Array<{ __typename: 'Invite', id: string, email?: string | null }> } | null, invites?: { __typename: 'InviteConnection', edges: Array<{ __typename: 'InviteEdge', node?: { __typename: 'Invite', id: string, createdAt?: string | null, name: string, toUser?: { __typename: 'User', id: string, email?: string | null, username?: string | null } | null } | null }> } | null, rateLimits?: { __typename: 'RateLimits', graphql: number, sdkGraphql: number, filestreamCount: number, filestreamPerRunCount: number, filestreamSize: number, runUpdateCount: number, sdkGraphqlQuerySeconds: number, createArtifacts: number, createArtifactsRequestCount: number, createArtifactsCollectionRequestCount: number, createArtifactsTimeWindow: number } | null } | null, user?: { __typename: 'User', id: string, username?: string | null, accountType?: UserAccountType | null } | null };

export type EntityIntegrationsQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type EntityIntegrationsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, integrations?: { __typename: 'IntegrationConnection', edges: Array<{ __typename: 'IntegrationEdge', node?:
          | { __typename: 'GenericWebhookIntegration', id: string, urlEndpoint: string, name: string, accessTokenRef?: string | null, secretRef?: string | null, createdAt: string }
          | { __typename: 'GitHubOAuthIntegration', id: string }
          | { __typename: 'SlackIntegration', teamName: string, channelName: string, id: string }
         | null }> } | null } | null };

export type UserRoleFragmentFragment = { __typename: 'User', accountType?: UserAccountType | null, admin?: boolean | null, deletedAt?: string | null, email?: string | null, username?: string | null };

export type EmailBasicFragment = { __typename: 'Email', id: string, emailAddress: string, createdAt: string, type: EmailType };

export type SearchUsersQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  queryEmail?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  usernames?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type SearchUsersQuery = { __typename: 'Query', users?: { __typename: 'UserConnection', edges: Array<{ __typename: 'UserEdge', node?: { __typename: 'User', id: string, name: string, loggedInAt?: string | null, userInfo?: any | null, accountType?: UserAccountType | null, admin?: boolean | null, deletedAt?: string | null, email?: string | null, username?: string | null, emails: Array<{ __typename: 'Email', id: string, emailAddress: string, createdAt: string, type: EmailType }> } | null }> } | null };

export type UserFragmentFragment = { __typename: 'User', name: string, email?: string | null, username?: string | null, deletedAt?: string | null, photoUrl?: string | null };

export type FindUsersQueryVariables = Exact<{
  query: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
}>;


export type FindUsersQuery = { __typename: 'Query', users?: { __typename: 'UserConnection', edges: Array<{ __typename: 'UserEdge', node?: { __typename: 'User', id: string, name: string, email?: string | null, username?: string | null, deletedAt?: string | null, photoUrl?: string | null } | null }> } | null };

export type FindUsersByUsernameQueryVariables = Exact<{
  usernames: Array<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
}>;


export type FindUsersByUsernameQuery = { __typename: 'Query', users?: { __typename: 'UserConnection', edges: Array<{ __typename: 'UserEdge', node?: { __typename: 'User', id: string, name: string, email?: string | null, username?: string | null, deletedAt?: string | null, photoUrl?: string | null } | null }> } | null };

export type UpdateUserRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  role: Scalars['String']['input'];
}>;


export type UpdateUserRoleMutation = { __typename: 'Mutation', updateUserRole?: { __typename: 'UpdateUserRolePayload', user?: { __typename: 'User', id: string, name: string, username?: string | null, email?: string | null, admin?: boolean | null, deletedAt?: string | null, accountType?: UserAccountType | null } | null } | null };

export type UpdateUserRoleV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  role: Scalars['String']['input'];
}>;


export type UpdateUserRoleV2Mutation = { __typename: 'Mutation', updateUserRoleV2?: { __typename: 'UpdateUserRoleV2Payload', user?: { __typename: 'User', id: string, name: string, username?: string | null, email?: string | null, admin?: boolean | null, deletedAt?: string | null, accountType?: UserAccountType | null } | null } | null };

export type SetUserAdminMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  admin: Scalars['Boolean']['input'];
}>;


export type SetUserAdminMutation = { __typename: 'Mutation', updateUser?: { __typename: 'UpdateUserPayload', user?: { __typename: 'User', id: string, name: string, username?: string | null, email?: string | null, admin?: boolean | null, deletedAt?: string | null } | null } | null };

export type PurgeUserMutationVariables = Exact<{
  username: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type PurgeUserMutation = { __typename: 'Mutation', purgeUser?: { __typename: 'PurgeUserPayload', user?: { __typename: 'User', id: string, deletedAt?: string | null } | null } | null };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserMutation = { __typename: 'Mutation', deleteUser?: { __typename: 'DeleteUserPayload', user?: { __typename: 'User', id: string, name: string, username?: string | null, email?: string | null, admin?: boolean | null, deletedAt?: string | null } | null } | null };

export type UndeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UndeleteUserMutation = { __typename: 'Mutation', undeleteUser?: { __typename: 'UndeleteUserPayload', user?: { __typename: 'User', id: string, name: string, username?: string | null, email?: string | null, admin?: boolean | null, deletedAt?: string | null } | null } | null };

export type CreateInviteMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  modelsSeat?: InputMaybe<Scalars['String']['input']>;
  weaveRole?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateInviteMutation = { __typename: 'Mutation', createInvite?: { __typename: 'CreateInvitePayload', success: boolean, remainingSeats?: number | null, remainingViewOnlySeats?: number | null, invite?: { __typename: 'Invite', id: string, name: string, email?: string | null, createdAt?: string | null, toUser?: { __typename: 'User', id: string, name: string } | null } | null } | null };

export type DeleteInviteMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteInviteMutation = { __typename: 'Mutation', deleteInvite?: { __typename: 'DeleteInvitePayload', success?: boolean | null } | null };

export type UpdateMemberMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  user: Scalars['ID']['input'];
  role: Scalars['String']['input'];
}>;


export type UpdateMemberMutation = { __typename: 'Mutation', updateMember?: { __typename: 'UpdateMemberPayload', member: { __typename: 'Member', id?: string | null, role?: string | null } } | null };

export type CreateServiceAccountMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  description: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateServiceAccountMutation = { __typename: 'Mutation', createServiceAccount?: { __typename: 'CreateServiceAccountPayload', user?: { __typename: 'User', id: string, name: string, apiKeys?: { __typename: 'ApiKeyConnection', edges: Array<{ __typename: 'ApiKeyEdge', node?: { __typename: 'ApiKey', id: string, name: string } | null }> } | null } | null } | null };

export type CreateOrgServiceAccountMutationVariables = Exact<{
  description: Scalars['String']['input'];
  defaultEntityId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type CreateOrgServiceAccountMutation = { __typename: 'Mutation', createOrgServiceAccount?: { __typename: 'CreateOrgServiceAccountPayload', user?: { __typename: 'User', id: string, name: string, apiKeys?: { __typename: 'ApiKeyConnection', edges: Array<{ __typename: 'ApiKeyEdge', node?: { __typename: 'ApiKey', id: string, name: string } | null }> } | null } | null } | null };

export type DeleteServiceAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteServiceAccountMutation = { __typename: 'Mutation', deleteServiceAccount?: { __typename: 'DeleteServiceAccountPayload', user?: { __typename: 'User', id: string } | null } | null };

export type CreateEntityMutationVariables = Exact<{
  name: Scalars['String']['input'];
  invited?: InputMaybe<Scalars['String']['input']>;
  framework?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateEntityMutation = { __typename: 'Mutation', createEntity?: { __typename: 'CreateEntityPayload', entity?: { __typename: 'Entity', id: string, name: string, photoUrl?: string | null, invitedTeam?: string | null, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string } | null }> } | null } | null, apiKey?: { __typename: 'ApiKey', id: string, name: string } | null } | null };

export type CreateUserFromAdminMutationVariables = Exact<{
  email: Scalars['String']['input'];
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  accountType?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  modelsSeat?: InputMaybe<Scalars['String']['input']>;
  weaveRole?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateUserFromAdminMutation = { __typename: 'Mutation', createUser?: { __typename: 'CreateUserPayload', user?: { __typename: 'User', id: string, name: string, username?: string | null, email?: string | null, admin?: boolean | null } | null } | null };

export type CreateEntityOnboardingFlowMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateEntityOnboardingFlowMutation = { __typename: 'Mutation', createEntity?: { __typename: 'CreateEntityPayload', entity?: { __typename: 'Entity', id: string } | null } | null };

export type CheckAvailabilityQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckAvailabilityQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, available?: boolean | null } | null };

export type UpdateUserMutationVariables = Exact<{
  defaultEntity?: InputMaybe<Scalars['String']['input']>;
  defaultFramework?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  settingsVisited?: InputMaybe<Scalars['Boolean']['input']>;
  galleryVisited?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingHidden?: InputMaybe<Scalars['Boolean']['input']>;
  hideTeamsFromPublic?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateUserMutation = { __typename: 'Mutation', updateUser?: { __typename: 'UpdateUserPayload', user?: { __typename: 'User', id: string, flags?: any | null, entity?: string | null, hideTeamsFromPublic: boolean, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, isTeam: boolean } | null }> } | null } | null } | null };

export type UpdateUserInfoMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  userInfo?: InputMaybe<Scalars['JSONString']['input']>;
  defaultEntity?: InputMaybe<Scalars['String']['input']>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserInfoMutation = { __typename: 'Mutation', updateUser?: { __typename: 'UpdateUserPayload', user?: { __typename: 'User', id: string, name: string, userInfo?: any | null, photoUrl?: string | null, entity?: string | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, isTeam: boolean } | null }> } | null } | null } | null };

export type UpdateUserEmailMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  type?: InputMaybe<EmailType>;
}>;


export type UpdateUserEmailMutation = { __typename: 'Mutation', updateUserEmail?: { __typename: 'UpdateUserEmailPayload', success: boolean, email?: { __typename: 'Email', id: string, emailAddress: string } | null } | null };

export type DeleteUserEmailMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserEmailMutation = { __typename: 'Mutation', deleteUserEmail?: { __typename: 'DeleteUserEmailPayload', success: boolean } | null };

export type GenerateApiKeyMutationVariables = Exact<{
  description?: InputMaybe<Scalars['String']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GenerateApiKeyMutation = { __typename: 'Mutation', generateApiKey?: { __typename: 'GenerateApiKeyPayload', secretApiKey?: string | null, apiKey?: { __typename: 'ApiKey', id: string, name: string, description?: string | null, apiKeyId?: string | null, createdAt?: string | null, expiresAt?: string | null, user?: { __typename: 'User', id: string, name: string } | null } | null } | null };

export type DeleteApiKeyMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteApiKeyMutation = { __typename: 'Mutation', deleteApiKey?: { __typename: 'DeleteApiKeyPayload', success?: boolean | null } | null };

export type CreateServiceAccountApiKeyMutationVariables = Exact<{
  serviceAccountId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateServiceAccountApiKeyMutation = { __typename: 'Mutation', createServiceAccountApiKey?: { __typename: 'CreateServiceAccountApiKeyPayload', secretApiKey?: string | null, success?: boolean | null, apiKey?: { __typename: 'ApiKey', id: string, name: string, description?: string | null, apiKeyId?: string | null, createdAt?: string | null, expiresAt?: string | null, user?: { __typename: 'User', id: string, name: string } | null } | null } | null };

export type DeleteServiceAccountApiKeyMutationVariables = Exact<{
  apiKeyId: Scalars['String']['input'];
  serviceAccountId: Scalars['ID']['input'];
}>;


export type DeleteServiceAccountApiKeyMutation = { __typename: 'Mutation', deleteServiceAccountApiKey?: { __typename: 'DeleteServiceAccountApiKeyPayload', success?: boolean | null } | null };

export type DeleteApiKeysMutationVariables = Exact<{
  keys: Array<DeleteApiKeyRefInput>;
}>;


export type DeleteApiKeysMutation = { __typename: 'Mutation', deleteApiKeys?: { __typename: 'DeleteApiKeysPayload', deletedCount: number } | null };

export type UpdateServiceAccountApiKeyMutationVariables = Exact<{
  apiKeyId: Scalars['String']['input'];
  serviceAccountId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
}>;


export type UpdateServiceAccountApiKeyMutation = { __typename: 'Mutation', updateServiceAccountApiKey?: { __typename: 'UpdateServiceAccountApiKeyPayload', success?: boolean | null, apiKey?: { __typename: 'ApiKey', id: string, description?: string | null } | null } | null };

export type UpdateApiKeyMutationVariables = Exact<{
  apiKeyId: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type UpdateApiKeyMutation = { __typename: 'Mutation', updateApiKey?: { __typename: 'UpdateApiKeyPayload', success?: boolean | null, apiKey?: { __typename: 'ApiKey', id: string, description?: string | null } | null } | null };

export type OrganizationTeamsWithViewerRoleQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrganizationTeamsWithViewerRoleQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, teams: Array<{ __typename: 'Entity', id: string, name: string, members: Array<{ __typename: 'Member', id?: string | null, username?: string | null, role?: string | null, memberRole?: { __typename: 'Role', ID: string, name: string, permissions: Array<{ __typename: 'RolePermission', name: string, groupName: string, displayName: string }> } | null }> }> } | null, viewer?: { __typename: 'User', id: string, username?: string | null } | null };

export type UpdateEntityMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  defaultAccess?: InputMaybe<Scalars['String']['input']>;
  privateOnly?: InputMaybe<Scalars['Boolean']['input']>;
  codeSavingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<EntitySettingsInput>;
}>;


export type UpdateEntityMutation = { __typename: 'Mutation', updateEntity?: { __typename: 'UpdateEntityPayload', entity?: { __typename: 'Entity', id: string, defaultAccess: string, privateOnly: boolean, limits?: any | null, settings: { __typename: 'EntitySettings', hidden: boolean, defaultCloudRegion: { __typename: 'CloudRegion', id: string, provider: CloudProvider, region: string } } } | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename: 'Mutation', resetPassword?: { __typename: 'ResetPasswordPayload', success: boolean } | null };

export type ViewerAllProjectsWithPatternQueryVariables = Exact<{
  pattern?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ViewerAllProjectsWithPatternQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, entity?: string | null, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string } | null }> } | null } | null };

export type ViewerQueryVariables = Exact<{
  includeStorage?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ViewerQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, analyticsId?: string | null, admin?: boolean | null, email?: string | null, entity?: string | null, defaultFramework?: string | null, photoUrl?: string | null, flags?: any | null, code?: string | null, username?: string | null, createdAt: string, name: string, accountType?: UserAccountType | null, userInfo?: any | null, hideTeamsFromPublic: boolean, limits?: any | null, nvidiaAccountLinkedAt?: string | null, signupRequired: boolean, personalEntityDisabled: boolean, isNvidiaAccountLinked: boolean, instanceAdminTeamAccessDisabled: boolean, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, photoUrl?: string | null, defaultAccess: string, readOnlyAdmin: boolean, privateOnly: boolean, isTeam: boolean, entityType?: string | null, organizationId?: string | null } | null }> } | null, organizations: Array<{ __typename: 'Organization', id: string, name: string, orgType: OrgType, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, subscriptionType: OrganizationSubscriptionType }> }>, defaultEntity?: { __typename: 'Entity', id: string, name: string } | null, userEntity?: { __typename: 'Entity', id: string, name: string, defaultAccess: string, codeSavingEnabled: boolean, storageBytes?: any, isTeam: boolean, settings: { __typename: 'EntitySettings', defaultCloudRegion: { __typename: 'CloudRegion', id: string, provider: CloudProvider, region: string } }, defaultAlerts: Array<{ __typename: 'Alert', id: string, condition:
          | { __typename: 'FinishedRunCondition', success: boolean }
          | { __typename: 'ScriptableRunCondition' }
          | { __typename: 'StoppedRunCondition', minimumRunDuration: number }
        , subscriptions: Array<
          | { __typename: 'EmailSubscription', id: string }
          | { __typename: 'SlackChannelSubscription', id: string }
        > }>, integrations?: { __typename: 'IntegrationConnection', edges: Array<{ __typename: 'IntegrationEdge', node?:
            | { __typename: 'GenericWebhookIntegration', id: string }
            | { __typename: 'GitHubOAuthIntegration', id: string }
            | { __typename: 'SlackIntegration', teamName: string, channelName: string, id: string }
           | null }> } | null, claimedEntities?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null } | null } | null };

export type ViewerPhotoUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerPhotoUrlQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, photoUrl?: string | null } | null };

export type ViewerFeatureFlagsQueryVariables = Exact<{
  rampIDType: RampIdType;
}>;


export type ViewerFeatureFlagsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, featureFlags: Array<{ __typename: 'FeatureFlag', rampKey: string, isEnabled: boolean } | null> } | null };

export type ViewFragmentFragment = { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, spec?: any | null, updatedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null };

export type ViewFragmentMetadataFragment = { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, updatedAt?: string | null, createdAt: string, starred?: boolean | null, starCount: number, parentId?: string | null, locked: boolean, viewCount: number, updatedBy?: { __typename: 'User', id: string, username?: string | null, name: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, alertSubscription?:
    | { __typename: 'EmailSubscription', id: string }
    | { __typename: 'SlackChannelSubscription', id: string }
   | null };

export type UpsertViewMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  spec: Scalars['String']['input'];
  specIsGzipped?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpsertViewMutation = { __typename: 'Mutation', upsertView?: { __typename: 'UpsertViewPayload', inserted?: boolean | null, view?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, spec?: any | null, updatedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null } | null };

export type DeleteViewMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteViewMutation = { __typename: 'Mutation', deleteView?: { __typename: 'DeleteViewPayload', success?: boolean | null } | null };

export type CreateSharedViewMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  spec: Scalars['String']['input'];
}>;


export type CreateSharedViewMutation = { __typename: 'Mutation', upsertSharedView?: { __typename: 'UpsertSharedViewPayload', view?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, spec?: any | null, updatedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null } | null };

export type ViewParentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ViewParentQuery = { __typename: 'Query', viewParent?: { __typename: 'View', id: string, displayName?: string | null } | null };

export type ViewChildrenQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ViewChildrenQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, children?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, user?: { __typename: 'User', id: string } | null } | null }> } | null } | null };

export type AcademicApplicationOrgInfoQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type AcademicApplicationOrgInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type MostActiveMembersQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type MostActiveMembersQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, members: Array<{ __typename: 'OrganizationMember', id: string, name: string, username: string, photoUrl: string, daysActive?: number | null, lastActiveAt?: string | null }> } | null };

export type OrganizationMemberActivityQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationMemberActivityQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, members: Array<{ __typename: 'OrganizationMember', id: string, lastActiveAt?: string | null }>, activeUsersForRange?: { __typename: 'OrgDashboardActiveUsersForRangeStats', last7Days: any, last30Days: any, last90Days: any, last6Months: any, last12Months: any } | null } | null };

export type TeamUsageChartDataQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  usageType: UsageType;
  usagePeriod: UsagePeriod;
  viewType: ViewType;
}>;


export type TeamUsageChartDataQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, usageByPeriod: { __typename: 'UsageByPeriodResponse', dailyAverageUsage?: any | null, intervals: Array<{ __typename: 'UsageInterval', startDate: string, endDate: string, stackTotal?: any | null, entities: Array<{ __typename: 'EntityUsage', entityName: string, value: any }> }> } } | null };

export type CreateAlertThresholdMutationVariables = Exact<{
  input: CreateAlertThresholdInput;
}>;


export type CreateAlertThresholdMutation = { __typename: 'Mutation', createAlertThreshold?: { __typename: 'CreateAlertThresholdPayload', success: boolean, alertThreshold?: { __typename: 'AlertThreshold', id: string, type: AlertThresholdType, value: number, emailSent: boolean, isEnabled: boolean, product: AlertThresholdProduct } | null } | null };

export type DeleteAlertThresholdMutationVariables = Exact<{
  input: DeleteAlertThresholdInput;
}>;


export type DeleteAlertThresholdMutation = { __typename: 'Mutation', deleteAlertThreshold?: { __typename: 'DeleteAlertThresholdPayload', success: boolean } | null };

export type UpdateAlertThresholdMutationVariables = Exact<{
  input: UpdateAlertThresholdInput;
}>;


export type UpdateAlertThresholdMutation = { __typename: 'Mutation', updateAlertThreshold?: { __typename: 'UpdateAlertThresholdPayload', success: boolean, alertThreshold?: { __typename: 'AlertThreshold', id: string, isEnabled: boolean } | null } | null };

export type AlertsTabOrgInfoQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type AlertsTabOrgInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, alertThresholds: Array<{ __typename: 'AlertThreshold', id: string, type: AlertThresholdType, value: number, emailSent: boolean, isEnabled: boolean, product: AlertThresholdProduct }> } | null };

export type CurrentBillingPeriodUsageSectionOrgInfoQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type CurrentBillingPeriodUsageSectionOrgInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, createdAt: string, usedSeats: number, stripeBillingInfo?: { __typename: 'StripeBillingInfo', cancelAtPeriodEnd: boolean, currentPeriodEnd: string } | null, teams: Array<{ __typename: 'Entity', id: string, name: string }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, billingPeriodStart?: string | null, billingPeriodEnd?: string | null, subscriptionType: OrganizationSubscriptionType, seats: number, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type EnterpriseBillingPeriodOrgInfoQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type EnterpriseBillingPeriodOrgInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, weaveEnterpriseSubscription?: { __typename: 'WeaveEnterpriseSubscription', billingPeriodStart?: string | null, billingPeriodEnd?: string | null } | null } | null };

export type UsageTotalInfoQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  usageType: UsageType;
  intervalMarkers: Array<Scalars['DateTime']['input']>;
}>;


export type UsageTotalInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, createdAt: string, usageTotal: Array<any> } | null };

export type CurrentPlanPageOrgInfoQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type CurrentPlanPageOrgInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, usedSeats: number, createdAt: string, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, status: OrganizationSubscriptionStatus, seats: number, plan: { __typename: 'Plan', id: string, planType: PlanType, name: string } }>, teams: Array<{ __typename: 'Entity', id: string, name: string }>, stripeBillingInfo?: { __typename: 'StripeBillingInfo', currentPeriodEnd: string } | null } | null };

export type PrimaryPlanCardV3OrgInfoQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type PrimaryPlanCardV3OrgInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, usedSeats: number, createdAt: string, teams: Array<{ __typename: 'Entity', id: string, name: string, computeHours: number }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, expiresAt?: string | null, seats: number, billingPeriodStart?: string | null, billingPeriodEnd?: string | null, subscriptionType: OrganizationSubscriptionType, status: OrganizationSubscriptionStatus, discount?: { __typename: 'Discount', start: string, end: string, coupon: { __typename: 'Coupon', id: string, amountOff: number, percentOff: number, duration: string, currency: string, name: string } } | null, plan: { __typename: 'Plan', id: string, displayName: string, planType: PlanType, name: string, billingInterval?: string | null, unitPrice?: number | null, stripePrice?: { __typename: 'StripePrice', amount: any } | null } }> } | null };

export type StoragePlanCardV2OrgInfoQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type StoragePlanCardV2OrgInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, createdAt: string, teams: Array<{ __typename: 'Entity', id: string, storageBytes: any, referenceBytes: any }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, billingPeriodStart?: string | null, billingPeriodEnd?: string | null, subscriptionType: OrganizationSubscriptionType, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type ServerCurrentBillingPeriodUsageSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type ServerCurrentBillingPeriodUsageSectionQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', contractStartDate?: string | null, weaveLimits?: { __typename: 'WeaveLimits', weaveLimitBytes?: any | null, weaveOverageCostCents?: number | null, weaveOverageUnit?: StorageUnit | null } | null } | null };

export type TotalUsageSectionOrgInfoQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type TotalUsageSectionOrgInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, usedSeats: number, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, privileges: any, seats: number, subscriptionType: OrganizationSubscriptionType, billingPeriodEnd?: string | null, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }>, teams: Array<{ __typename: 'Entity', id: string, computeHours: number, storageBytes: any, referenceBytes: any }> } | null };

export type StorageTableQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type StorageTableQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, teams: Array<{ __typename: 'Entity', id: string, name: string, storageBytes: any, storageTree?: { __typename: 'EntityStorageNode', id: string } | null, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, storageBytes: any } | null }> } | null }> } | null };

export type ServiceAccountDrawerOrgTeamsQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type ServiceAccountDrawerOrgTeamsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, teams: Array<{ __typename: 'Entity', id: string, name: string }> } | null };

export type DefaultEntityForDomainCaptureDropdownQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type DefaultEntityForDomainCaptureDropdownQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, flags?: any | null, teams: Array<{ __typename: 'Entity', id: string, name: string, settings: { __typename: 'EntitySettings', openToMatchingOrgEmailDomainUsers?: boolean | null } }> } | null };

export type OrganizationDefaultModelsSeatQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrganizationDefaultModelsSeatQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, flags?: any | null, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, privileges: any, plan: { __typename: 'Plan', id: string, planType: PlanType } }> } | null };

export type OrganizationDomainCaptureSettingQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationDomainCaptureSettingQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, flags?: any | null, teams: Array<{ __typename: 'Entity', id: string, settings: { __typename: 'EntitySettings', openToMatchingOrgEmailDomainUsers?: boolean | null } }> } | null };

export type ViewerDomainClaimBlockingReasonQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type ViewerDomainClaimBlockingReasonQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, domainClaimBlockingReason?: string | null } | null };

export type OrganizationTeamsWithDomainCaptureEnabledQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationTeamsWithDomainCaptureEnabledQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, flags?: any | null, teams: Array<{ __typename: 'Entity', id: string, name: string, memberCount: number, settings: { __typename: 'EntitySettings', openToMatchingOrgEmailDomainUsers?: boolean | null } }> } | null };

export type ViewerOrgTeamAccessQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  viewerId: Scalars['ID']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
}>;


export type ViewerOrgTeamAccessQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, member?: { __typename: 'OrganizationMember', id: string, role: string } | null, teams: Array<{ __typename: 'Entity', id: string, name: string, member?: { __typename: 'Member', id?: string | null, role?: string | null } | null }> } | null };

export type EditOrgMembersModalQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type EditOrgMembersModalQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, flags?: any | null, teams: Array<{ __typename: 'Entity', id: string, name: string, settings: { __typename: 'EntitySettings', openToMatchingOrgEmailDomainUsers?: boolean | null } }>, seatAvailability: { __typename: 'OrganizationSeatAvailability', seats: number }, pendingInvites: Array<{ __typename: 'Invite', id: string, email?: string | null }>, billingUser?: { __typename: 'User', id: string, username?: string | null } | null, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, seats: number, plan: { __typename: 'Plan', id: string, unitPrice?: number | null, planType: PlanType, billingInterval?: string | null } }>, members: Array<{ __typename: 'OrganizationMember', id: string, username: string, role: string, modelsSeat: string, name: string, user: { __typename: 'User', id: string, loggedInAt?: string | null }, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string } | null }> } | null }> } | null };

export type IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables = Exact<{ [key: string]: never; }>;


export type IsEmailDomainClaimedAndShouldRedirectToSsoQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, isEmailDomainClaimedAndShouldRedirectToSSO: boolean } | null };

export type TeamPageShowcasedProjectsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type TeamPageShowcasedProjectsQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, description?: string | null, lastActive?: string | null, runCount: number, access?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null } | null }>, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type ProfilePageShowcasedProjectsQueryVariables = Exact<{
  username: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfilePageShowcasedProjectsQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, description?: string | null, totalRuns?: number | null, lastActive?: string | null, runCount: number, user?: { __typename: 'User', id: string, username?: string | null } | null } | null }> } | null } | null };

export type SimpleTestQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SimpleTestQueryQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', pollingOK: boolean } | null };

export type HistoricUsageOrganizationInfoQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type HistoricUsageOrganizationInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, members: Array<{ __typename: 'OrganizationMember', id: string, username: string, role: string }> } | null };

export type UsageTabInfoQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  usageType: UsageType;
  intervalMarkers: Array<Scalars['DateTime']['input']>;
}>;


export type UsageTabInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, createdAt: string, usage: Array<
      | { __typename: 'InferenceCostUsageAggregation', endpointName: string, inputCount: any, outputCount: any, inputCost: any, outputCost: any, cachedCost: any, uncachedCost: any, cachedCount: any, uncachedCount: any, start: string, end: string, value: any, projectName: string, entityName: string }
      | { __typename: 'TrainingCostUsageAggregation', gpuModelID: string, gpuDurationMs: any, start: string, end: string, value: any, projectName: string, entityName: string }
      | { __typename: 'UsageAggregation', start: string, end: string, value: any, projectName: string, entityName: string }
    > } | null };

export type GlobalUsageTabInfoQueryVariables = Exact<{
  usageType: UsageType;
  intervalMarkers: Array<Scalars['DateTime']['input']>;
}>;


export type GlobalUsageTabInfoQuery = { __typename: 'Query', usage: Array<
    | { __typename: 'InferenceCostUsageAggregation', endpointName: string, inputCount: any, outputCount: any, inputCost: any, outputCost: any, cachedCost: any, uncachedCost: any, cachedCount: any, uncachedCount: any, start: string, end: string, value: any, projectName: string, entityName: string }
    | { __typename: 'TrainingCostUsageAggregation', gpuModelID: string, gpuDurationMs: any, start: string, end: string, value: any, projectName: string, entityName: string }
    | { __typename: 'UsageAggregation', start: string, end: string, value: any, projectName: string, entityName: string }
  > };

export type WeaveUsageInfoQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  usageType: UsageType;
  intervalMarkers: Array<Scalars['DateTime']['input']>;
}>;


export type WeaveUsageInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, createdAt: string, usageTotal: Array<any> } | null };

export type HomepageProjectsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type HomepageProjectsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, totalRuns?: number | null, createdAt: string, lastActive?: string | null, description?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null } | null }> } | null } | null };

export type ServerHomepageContentQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  orgName: Scalars['String']['input'];
  userID: Scalars['ID']['input'];
}>;


export type ServerHomepageContentQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, teamRuns?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string, heartbeatAt?: string | null, updatedAt?: string | null, notes?: string | null, groupCounts?: Array<number> | null, user?: { __typename: 'User', id: string, username?: string | null, name: string, accountType?: UserAccountType | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }> } }> } | null } | null, viewer?: { __typename: 'User', id: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, myRuns?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string, heartbeatAt?: string | null, updatedAt?: string | null, notes?: string | null, groupCounts?: Array<number> | null, user?: { __typename: 'User', id: string, username?: string | null, name: string, accountType?: UserAccountType | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }> } }> } | null } | null }> } | null, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, totalRuns?: number | null, createdAt: string, lastActive?: string | null, description?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null } | null }> } | null, views?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, description?: string | null, starCount: number, createdAt: string, updatedAt?: string | null, starred?: boolean | null, showcasedAt?: string | null, previewUrl?: string | null, viewCount: number, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null } | null } | null }> } | null } | null };

export type DeletedRunsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type DeletedRunsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, deletedRuns?: { __typename: 'DeletedRunConnection', totalCount: number, edges: Array<{ __typename: 'DeletedRunEdge', node: { __typename: 'DeletedRunInfo', displayName: string, name: string, state?: string | null, deletedAt: string } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } } | null } | null };

export type TrialCardAccountExpirationQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type TrialCardAccountExpirationQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, expiresAt?: string | null, status: OrganizationSubscriptionStatus, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type CreateProjectDrawerProjectQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateProjectDrawerProjectQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, description?: string | null, user?: { __typename: 'User', id: string } | null, entity: { __typename: 'Entity', id: string, isTeam: boolean, entityType?: string | null } } | null };

export type MarimoNotebookRuntimePageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarimoNotebookRuntimePageQuery = { __typename: 'Query', notebook?: { __typename: 'Notebook', id: string, name: string, lastUpdated: string, viewerPermissions: Array<NotebookPermission>, author?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, project: { __typename: 'Project', id: string, entityName: string, name: string }, currentVersion?: { __typename: 'NotebookVersionRef', artifactTypeName: string, artifactCollectionName: string, versionIndex: number, sourceFileName: string } | null } | null };

export type MarimoNotebookViewPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarimoNotebookViewPageQuery = { __typename: 'Query', notebook?: { __typename: 'Notebook', id: string, staticOutputUrl?: string | null, name: string, lastUpdated: string, viewerPermissions: Array<NotebookPermission>, author?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, project: { __typename: 'Project', id: string, entityName: string, name: string }, currentVersion?: { __typename: 'NotebookVersionRef', artifactTypeName: string, artifactCollectionName: string, versionIndex: number, sourceFileName: string } | null } | null };

export type AccountNotebooksQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  skipEntity: Scalars['Boolean']['input'];
  skipOrganization: Scalars['Boolean']['input'];
}>;


export type AccountNotebooksQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, notebooks: { __typename: 'NotebookConnection', edges: Array<{ __typename: 'NotebookEdge', node: { __typename: 'Notebook', id: string, name: string, lastUpdated: string, viewerPermissions: Array<NotebookPermission>, author?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, project: { __typename: 'Project', id: string, entityName: string, name: string }, currentVersion?: { __typename: 'NotebookVersionRef', artifactTypeName: string, artifactCollectionName: string, versionIndex: number, sourceFileName: string } | null } }>, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } | null, organization?: { __typename: 'Organization', id: string, notebooks: { __typename: 'NotebookConnection', edges: Array<{ __typename: 'NotebookEdge', node: { __typename: 'Notebook', id: string, name: string, lastUpdated: string, viewerPermissions: Array<NotebookPermission>, author?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, project: { __typename: 'Project', id: string, entityName: string, name: string }, currentVersion?: { __typename: 'NotebookVersionRef', artifactTypeName: string, artifactCollectionName: string, versionIndex: number, sourceFileName: string } | null } }>, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } | null };

export type PredefinedRoleOrgInfoQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type PredefinedRoleOrgInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, subscriptionType: OrganizationSubscriptionType, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type OrganizationFlagsQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrganizationFlagsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, flags?: any | null } | null };

export type RemoteScoringOrganizationQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type RemoteScoringOrganizationQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string } | null };

export type OrganizationRemoteScoringPolicyQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationRemoteScoringPolicyQuery = { __typename: 'Query', organizationRemoteScoringPolicy?: { __typename: 'RemoteScoringPolicy', enabled: boolean, allowedHosts: Array<{ __typename: 'RemoteScoringAllowedHost', host: string, port?: number | null }> } | null };

export type OrganizationRemoteScoringGateQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationRemoteScoringGateQuery = { __typename: 'Query', organizationRemoteScoringPolicy?: { __typename: 'RemoteScoringPolicy', configured: boolean, enabled: boolean } | null };

export type UpdateOrganizationRemoteScoringSettingsMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  remoteScoringEnabled: Scalars['Boolean']['input'];
  remoteScoringAllowedHosts: Array<RemoteScoringAllowedHostInput>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOrganizationRemoteScoringSettingsMutation = { __typename: 'Mutation', updateOrganizationRemoteScoringSettings?: { __typename: 'UpdateOrganizationRemoteScoringSettingsPayload', success: boolean, clientMutationId?: string | null } | null };

export type FetchProfilePageProjectsByIDsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectIDs: Array<Scalars['ID']['input']>;
}>;


export type FetchProfilePageProjectsByIDsQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, lastActive?: string | null, runCount: number, user?: { __typename: 'User', id: string, username?: string | null } | null } | null }> } | null };

export type ProjectNotebooksQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProjectNotebooksQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, notebooks: { __typename: 'NotebookConnection', edges: Array<{ __typename: 'NotebookEdge', node: { __typename: 'Notebook', id: string, name: string, lastUpdated: string, viewerPermissions: Array<NotebookPermission>, author?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, project: { __typename: 'Project', id: string, entityName: string, name: string }, currentVersion?: { __typename: 'NotebookVersionRef', artifactTypeName: string, artifactCollectionName: string, versionIndex: number, sourceFileName: string } | null } }>, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } | null };

export type ProjectPageQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectPageQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null, hasRun: boolean, fromV2?: boolean | null, entity: { __typename: 'Entity', id: string, claimingEntity?: { __typename: 'Entity', id: string, name: string } | null } } | null };

export type RunOverflowMenuQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
}>;


export type RunOverflowMenuQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, entityName: string, readOnly?: boolean | null, run?: { __typename: 'Run', id: string, state?: string | null, displayName?: string | null, commit?: string | null, github?: string | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, runInfo?: { __typename: 'RunInfo', git?: { __typename: 'GitInfo', remote?: string | null, commit?: string | null } | null } | null } | null } | null };

export type RunOverviewCommandItems_RunFragment = { __typename: 'Run', id: string, displayName?: string | null, runInfo?: { __typename: 'RunInfo', args: Array<string>, executable?: string | null, program?: string | null, git?: { __typename: 'GitInfo', commit?: string | null, remote?: string | null } | null } | null };

export type RunOverviewPatchItem_RunFragment = { __typename: 'Run', id: string, patchFiles?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, url?: string | null } | null }> } | null };

export type RunOverviewPatchItemQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
}>;


export type RunOverviewPatchItemQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, patchFiles?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, url?: string | null } | null }> } | null } | null } | null };

export type RunOverviewQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
}>;


export type RunOverviewQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, internalId: string, name: string, readOnly?: boolean | null, entityName: string, entity: { __typename: 'Entity', id: string, isTeam: boolean }, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, run?: { __typename: 'Run', id: string, state?: string | null, stopped?: boolean | null, heartbeatAt?: string | null, name: string, displayName?: string | null, notes?: string | null, config?: any | null, createdAt: string, jobType?: string | null, group?: string | null, host?: string | null, internalID?: string | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null } | null, runInfo?: { __typename: 'RunInfo', program?: string | null, args: Array<string>, os?: string | null, python?: string | null, colab?: string | null, executable?: string | null, cpuCount?: number | null, cpuCountLogical?: number | null, gpuCount?: number | null, gpu?: string | null, git?: { __typename: 'GitInfo', remote?: string | null, commit?: string | null } | null } | null, user?: { __typename: 'User', id: string, username?: string | null, name: string, photoUrl?: string | null, accountType?: UserAccountType | null } | null, branchPoint?: { __typename: 'RunBranchPoint', step: any, run: { __typename: 'Run', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null } } | null } | null } | null };

export type RunPageHeaderQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
}>;


export type RunPageHeaderQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, readOnly?: boolean | null, run?: { __typename: 'Run', id: string, name: string, state?: string | null, stopped?: boolean | null, config?: any | null, notes?: string | null, displayName?: string | null, tags: Array<{ __typename: 'RunTag', id: string, name: string }> } | null } | null };

export type ViewCodeModal_RunFragment = { __typename: 'Run', commit?: string | null, github?: string | null, runInfo?: { __typename: 'RunInfo', git?: { __typename: 'GitInfo', remote?: string | null, commit?: string | null } | null } | null, viewCodeModalPatchFile?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, sizeBytes: any } | null }> } | null };

export type RunOverviewViewCodeModalQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
}>;


export type RunOverviewViewCodeModalQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, commit?: string | null, github?: string | null, runInfo?: { __typename: 'RunInfo', git?: { __typename: 'GitInfo', remote?: string | null, commit?: string | null } | null } | null, viewCodeModalPatchFile?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, sizeBytes: any } | null }> } | null } | null } | null };

export type StartupProgramQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type StartupProgramQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, flags?: any | null, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, subscriptionType: OrganizationSubscriptionType, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type StartupProgramCouponInfoQueryVariables = Exact<{
  couponID: Scalars['String']['input'];
}>;


export type StartupProgramCouponInfoQuery = { __typename: 'Query', coupon?: { __typename: 'Coupon', id: string } | null };

export type TeamPageNotebooksQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TeamPageNotebooksQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, notebooks: { __typename: 'NotebookConnection', edges: Array<{ __typename: 'NotebookEdge', node: { __typename: 'Notebook', id: string, name: string, lastUpdated: string, viewerPermissions: Array<NotebookPermission>, author?: { __typename: 'User', id: string, name: string, photoUrl?: string | null } | null, project: { __typename: 'Project', id: string, entityName: string, name: string }, currentVersion?: { __typename: 'NotebookVersionRef', artifactTypeName: string, artifactCollectionName: string, versionIndex: number, sourceFileName: string } | null } }>, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } } | null };

export type TrialEndOrgInfoQueryVariables = Exact<{
  organizationID: Scalars['ID']['input'];
}>;


export type TrialEndOrgInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, name: string, usedSeats: number, flags?: any | null, teams: Array<{ __typename: 'Entity', id: string, name: string }>, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, expiresAt?: string | null, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null };

export type TrialEndCouponInfoQueryVariables = Exact<{
  couponID: Scalars['String']['input'];
}>;


export type TrialEndCouponInfoQuery = { __typename: 'Query', coupon?: { __typename: 'Coupon', id: string, amountOff: number, percentOff: number, duration: string, currency: string, name: string, durationInMonths: number } | null };

export type TrackRouteOrgAccountTypeQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type TrackRouteOrgAccountTypeQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, organization?: { __typename: 'Organization', id: string, name: string, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, subscriptionType: OrganizationSubscriptionType, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }> } | null } | null };

export type CreateAccessTokenMutationVariables = Exact<{
  projects: Array<ProjectSpecifier>;
  viewId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  previewURL?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAccessTokenMutation = { __typename: 'Mutation', createAccessToken?: { __typename: 'CreateAccessTokenPayload', toNewUser?: boolean | null, recipientAlreadyOnTeam?: boolean | null, clientMutationId?: string | null, accessToken: { __typename: 'AccessToken', id: string, token: string, type: AccessTokenType, emails: Array<string>, createdAt: string, lastAccessedAt?: string | null, revokedAt?: string | null, view: { __typename: 'View', id: string }, createdBy: { __typename: 'User', id: string, username?: string | null, email?: string | null, name: string }, projects: Array<{ __typename: 'Project', id: string, name: string, entityName: string }> } } | null };

export type RevokeAccessTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RevokeAccessTokenMutation = { __typename: 'Mutation', revokeAccessToken?: { __typename: 'RevokeAccessTokenPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateAccessTokenProjectsMutationVariables = Exact<{
  token: Scalars['String']['input'];
  projects: Array<ProjectSpecifier>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateAccessTokenProjectsMutation = { __typename: 'Mutation', updateAccessTokenProjects?: { __typename: 'UpdateAccessTokenProjectsPayload', success: boolean, clientMutationId?: string | null } | null };

export type UpdateAccessTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  previewURL?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateAccessTokenMutation = { __typename: 'Mutation', updateAccessToken?: { __typename: 'UpdateAccessTokenPayload', toNewUser?: boolean | null, recipientAlreadyOnTeam?: boolean | null, clientMutationId?: string | null, accessToken: { __typename: 'AccessToken', id: string, token: string, type: AccessTokenType, emails: Array<string>, createdAt: string, lastAccessedAt?: string | null, revokedAt?: string | null, view: { __typename: 'View', id: string }, createdBy: { __typename: 'User', id: string, username?: string | null, email?: string | null, name: string }, projects: Array<{ __typename: 'Project', id: string, name: string, entityName: string }> } } | null };

export type RevokeAccessTokenEmailMutationVariables = Exact<{
  token: Scalars['String']['input'];
  email: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RevokeAccessTokenEmailMutation = { __typename: 'Mutation', revokeAccessTokenEmail?: { __typename: 'RevokeAccessTokenEmailPayload', clientMutationId?: string | null, accessToken: { __typename: 'AccessToken', id: string, token: string, type: AccessTokenType, emails: Array<string>, view: { __typename: 'View', id: string } } } | null };

export type ArtifactCollectionAliasActionHistoryQueryVariables = Exact<{
  projectName?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  artifactTypeName: Scalars['String']['input'];
  artifactCollectionName: Scalars['String']['input'];
  actionCursor?: InputMaybe<Scalars['String']['input']>;
  actionFirst?: InputMaybe<Scalars['Int']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
}>;


export type ArtifactCollectionAliasActionHistoryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactType?: { __typename: 'ArtifactType', id: string, artifactCollection?:
        | { __typename: 'ArtifactPortfolio', id: string, isModelRegistryMigratedArtifactCollection: boolean, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string } | null }> }, aliasActionHistory: { __typename: 'ArtifactAliasActionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactAliasActionEdge', node: { __typename: 'ArtifactAliasAction', createdAt: string, alias: string, actionType: string, targetArtifact?: { __typename: 'Artifact', id: string, versionIndex?: number | null, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null } } | null, sourceArtifact?: { __typename: 'Artifact', id: string, versionIndex?: number | null, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null } } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, name: string, accountType?: UserAccountType | null } | null } }> } }
        | { __typename: 'ArtifactSequence', id: string, isModelRegistryMigratedArtifactCollection: boolean, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string } | null }> }, aliasActionHistory: { __typename: 'ArtifactAliasActionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactAliasActionEdge', node: { __typename: 'ArtifactAliasAction', createdAt: string, alias: string, actionType: string, targetArtifact?: { __typename: 'Artifact', id: string, versionIndex?: number | null, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null } } | null, sourceArtifact?: { __typename: 'Artifact', id: string, versionIndex?: number | null, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null } } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, name: string, accountType?: UserAccountType | null } | null } }> } }
       | null } | null } | null };

export type ArtifactCollectionActionHistoryQueryVariables = Exact<{
  projectName?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  artifactTypeName: Scalars['String']['input'];
  artifactCollectionName: Scalars['String']['input'];
  actionCursor?: InputMaybe<Scalars['String']['input']>;
  actionFirst?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ArtifactCollectionActionHistoryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactType?: { __typename: 'ArtifactType', id: string, artifactCollection?:
        | { __typename: 'ArtifactPortfolio', id: string, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string } | null }> }, artifactCollectionActions: { __typename: 'ArtifactCollectionActionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionActionEdge', node: { __typename: 'ArtifactCollectionAction', id: string, createdAt: string, actionType: string, user?: { __typename: 'User', id: string, username?: string | null, name: string, accountType?: UserAccountType | null } | null, artifact?: { __typename: 'Artifact', id: string, versionIndex?: number | null, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null } } | null } }> } }
        | { __typename: 'ArtifactSequence', id: string, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string } | null }> }, artifactCollectionActions: { __typename: 'ArtifactCollectionActionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionActionEdge', node: { __typename: 'ArtifactCollectionAction', id: string, createdAt: string, actionType: string, user?: { __typename: 'User', id: string, username?: string | null, name: string, accountType?: UserAccountType | null } | null, artifact?: { __typename: 'Artifact', id: string, versionIndex?: number | null, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null } } | null } }> } }
       | null } | null } | null };

export type ArtifactCollectionQueryVariables = Exact<{
  projectName?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  artifactTypeName: Scalars['String']['input'];
  artifactCollectionName: Scalars['String']['input'];
  artifactCursor?: InputMaybe<Scalars['String']['input']>;
  artifactFirst?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ArtifactCollectionQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactType?: { __typename: 'ArtifactType', id: string, name: string, description?: string | null, artifactCollection?:
        | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, createdAt: string, commitHash?: string | null, versionIndex?: number | null, artifact?: { __typename: 'Artifact', id: string, digest: string, state: ArtifactState, createdAt: string } | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string, artifactCollection?:
                    | { __typename: 'ArtifactPortfolio', id: string, name: string }
                    | { __typename: 'ArtifactSequence', id: string, name: string }
                   | null }> } | null }> }, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string, artifact?: { __typename: 'Artifact', id: string, versionIndex?: number | null } | null } | null }> }, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
        | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, createdAt: string, commitHash?: string | null, versionIndex?: number | null, artifact?: { __typename: 'Artifact', id: string, digest: string, state: ArtifactState, createdAt: string } | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string, artifactCollection?:
                    | { __typename: 'ArtifactPortfolio', id: string, name: string }
                    | { __typename: 'ArtifactSequence', id: string, name: string }
                   | null }> } | null }> }, aliases: { __typename: 'ArtifactAliasConnection', edges: Array<{ __typename: 'ArtifactAliasEdge', node?: { __typename: 'ArtifactAlias', id: string, alias: string, artifact?: { __typename: 'Artifact', id: string, versionIndex?: number | null } | null } | null }> }, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }
       | null } | null } | null };

export type EntityPortfoliosQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  artifactTypeName: Scalars['String']['input'];
}>;


export type EntityPortfoliosQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, artifactType?: { __typename: 'ArtifactType', id: string, name: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
                  | { __typename: 'ArtifactPortfolio', id: string, name: string }
                  | { __typename: 'ArtifactSequence', id: string, name: string }
                 | null }> } | null } | null } | null }> } | null } | null };

export type ArtifactCollectionNameFromIdQueryVariables = Exact<{
  artifactCollectionID: Scalars['ID']['input'];
}>;


export type ArtifactCollectionNameFromIdQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null }
    | { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string } | null }
   | null };

export type ArtifactFilesQueryVariables = Exact<{
  artifactID: Scalars['ID']['input'];
  artifactFileNames: Array<Scalars['String']['input']>;
}>;


export type ArtifactFilesQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, createdAt: string, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, displayName: string, digest?: string | null, url?: string | null, directUrl: string, isReference: boolean, sizeBytes: any, updatedAt?: string | null } | null }> } | null } | null };

export type ArtifactIdQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  artifactTypeName: Scalars['String']['input'];
  artifactID: Scalars['String']['input'];
}>;


export type ArtifactIdQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactType?: { __typename: 'ArtifactType', id: string, artifact?: { __typename: 'Artifact', id: string } | null } | null } | null };

export type ArtifactPathInfoQueryVariables = Exact<{
  artifactId: Scalars['ID']['input'];
}>;


export type ArtifactPathInfoQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, createdAt: string, commitHash?: string | null, versionIndex?: number | null, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string }, artifactType: { __typename: 'ArtifactType', id: string, name: string, project: { __typename: 'Project', id: string, name: string, entityName: string } } } | null };

export type ArtifactManifestQueryVariables = Exact<{
  projectName?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  artifactTypeName: Scalars['String']['input'];
  artifactID: Scalars['String']['input'];
}>;


export type ArtifactManifestQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactType?: { __typename: 'ArtifactType', id: string, artifact?: { __typename: 'Artifact', id: string, createdAt: string, currentManifest?: { __typename: 'ArtifactManifest', id: string, file: { __typename: 'File', id: string, directUrl: string } } | null } | null } | null } | null, serverInfo?: { __typename: 'ServerInfo', defaultCloudRegion: { __typename: 'CloudRegion', id: string } } | null };

export type ArtifactManifestFromIdQueryVariables = Exact<{
  artifactId: Scalars['ID']['input'];
}>;


export type ArtifactManifestFromIdQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, createdAt: string, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null }, artifactType: { __typename: 'ArtifactType', id: string, name: string }, currentManifest?: { __typename: 'ArtifactManifest', id: string, file: { __typename: 'File', id: string, directUrl: string } } | null } | null, serverInfo?: { __typename: 'ServerInfo', defaultCloudRegion: { __typename: 'CloudRegion', id: string } } | null };

export type ResolveLatestSequenceAliasToArtifactIdQueryVariables = Exact<{
  sequenceId: Scalars['ID']['input'];
}>;


export type ResolveLatestSequenceAliasToArtifactIdQuery = { __typename: 'Query', artifactSequence?: { __typename: 'ArtifactSequence', id: string, latestArtifact?: { __typename: 'Artifact', id: string } | null } | null };

export type ArtifactCommitHashQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  artifactCollectionName: Scalars['String']['input'];
}>;


export type ArtifactCommitHashQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, commitHash?: string | null } | null };

export type ArtifactManifestFromMembershipQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  artifactName: Scalars['String']['input'];
  versionIndex: Scalars['String']['input'];
}>;


export type ArtifactManifestFromMembershipQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactCollection?:
      | { __typename: 'ArtifactPortfolio', id: string, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, artifact?: { __typename: 'Artifact', id: string, createdAt: string, currentManifest?: { __typename: 'ArtifactManifest', id: string, file: { __typename: 'File', id: string, directUrl: string } } | null } | null } | null }
      | { __typename: 'ArtifactSequence', id: string, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, artifact?: { __typename: 'Artifact', id: string, createdAt: string, currentManifest?: { __typename: 'ArtifactManifest', id: string, file: { __typename: 'File', id: string, directUrl: string } } | null } | null } | null }
     | null } | null, serverInfo?: { __typename: 'ServerInfo', defaultCloudRegion: { __typename: 'CloudRegion', id: string } } | null };

export type CreateArtifactTypesMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  artifactTypes: Array<ArtifactTypeInput>;
}>;


export type CreateArtifactTypesMutation = { __typename: 'Mutation', createArtifactTypes?: { __typename: 'CreateArtifactTypesPayload', artifactTypes: Array<{ __typename: 'ArtifactType', id: string, name: string }> } | null };

export type UpdateArtifactMutationVariables = Exact<{
  artifactID: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  aliases?: InputMaybe<Array<ArtifactAliasInput>>;
  labels?: InputMaybe<Scalars['JSONString']['input']>;
  metadata?: InputMaybe<Scalars['JSONString']['input']>;
  ttlDurationSeconds?: InputMaybe<Scalars['Int64']['input']>;
}>;


export type UpdateArtifactMutation = { __typename: 'Mutation', updateArtifact?: { __typename: 'UpdateArtifactPayload', artifact: { __typename: 'Artifact', id: string, digest: string, description?: string | null, labels?: any | null, ttlDurationSeconds: any, aliases: Array<{ __typename: 'ArtifactAlias', id: string, artifactCollectionName: string, alias: string }> } } | null };

export type DeleteArtifactMutationVariables = Exact<{
  artifactID: Scalars['ID']['input'];
  deleteAliases?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteArtifactMutation = { __typename: 'Mutation', deleteArtifact?: { __typename: 'DeleteArtifactPayload', artifact: { __typename: 'Artifact', id: string, state: ArtifactState } } | null };

export type DeleteArtifactSequenceMutationVariables = Exact<{
  artifactSequenceID: Scalars['ID']['input'];
}>;


export type DeleteArtifactSequenceMutation = { __typename: 'Mutation', deleteArtifactSequence?: { __typename: 'DeleteArtifactCollectionPayload', artifactCollection:
      | { __typename: 'ArtifactPortfolio', id: string, state: ArtifactCollectionState }
      | { __typename: 'ArtifactSequence', id: string, state: ArtifactCollectionState }
     } | null };

export type UpdateArtifactTypeMutationVariables = Exact<{
  artifactTypeID: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateArtifactTypeMutation = { __typename: 'Mutation', updateArtifactType?: { __typename: 'UpdateArtifactTypePayload', artifactType: { __typename: 'ArtifactType', id: string, description?: string | null } } | null };

export type UpdateArtifactPortfolioMutationVariables = Exact<{
  artifactPortfolioID: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateArtifactPortfolioMutation = { __typename: 'Mutation', updateArtifactPortfolio?: { __typename: 'UpdateArtifactCollectionPayload', artifactCollection:
      | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null }
      | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null }
     } | null };

export type UpdateArtifactCollectionMutationVariables = Exact<{
  artifactSequenceID: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateArtifactCollectionMutation = { __typename: 'Mutation', updateArtifactSequence?: { __typename: 'UpdateArtifactCollectionPayload', artifactCollection:
      | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null }
      | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null }
     } | null };

export type MoveArtifactCollectionMutationVariables = Exact<{
  artifactSequenceID: Scalars['ID']['input'];
  destinationArtifactTypeName: Scalars['String']['input'];
}>;


export type MoveArtifactCollectionMutation = { __typename: 'Mutation', moveArtifactSequence?: { __typename: 'MoveArtifactCollectionPayload', artifactCollection?:
      | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null }
      | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null }
     | null } | null };

export type DeleteArtifactCollectionMutationVariables = Exact<{
  artifactSequenceID: Scalars['ID']['input'];
}>;


export type DeleteArtifactCollectionMutation = { __typename: 'Mutation', deleteArtifactSequence?: { __typename: 'DeleteArtifactCollectionPayload', artifactCollection:
      | { __typename: 'ArtifactPortfolio', id: string }
      | { __typename: 'ArtifactSequence', id: string }
     } | null };

export type DeleteArtifactPortfolioMutationVariables = Exact<{
  artifactPortfolioID: Scalars['ID']['input'];
}>;


export type DeleteArtifactPortfolioMutation = { __typename: 'Mutation', deleteArtifactPortfolio?: { __typename: 'DeleteArtifactCollectionPayload', artifactCollection:
      | { __typename: 'ArtifactPortfolio', id: string }
      | { __typename: 'ArtifactSequence', id: string }
     } | null };

export type CreateArtifactFilesMutationVariables = Exact<{
  artifactFiles: Array<CreateArtifactFileSpecInput>;
  layout?: InputMaybe<ArtifactStorageLayout>;
}>;


export type CreateArtifactFilesMutation = { __typename: 'Mutation', createArtifactFiles?: { __typename: 'CreateArtifactFilesPayload', files: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, displayName: string, directUrl: string, isReference: boolean, sizeBytes: any, updatedAt?: string | null, uploadUrl?: string | null } | null }> } } | null };

export type CreateArtifactPortfolioMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  artifactTypeID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateArtifactPortfolioMutation = { __typename: 'Mutation', createArtifactPortfolio?: { __typename: 'CreateArtifactCollectionPayload', artifactCollection:
      | { __typename: 'ArtifactPortfolio', id: string, name: string }
      | { __typename: 'ArtifactSequence', id: string, name: string }
     } | null };

export type CreateArtifactSequenceMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  artifactTypeID: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateArtifactSequenceMutation = { __typename: 'Mutation', createArtifactSequence?: { __typename: 'CreateArtifactCollectionPayload', artifactCollection:
      | { __typename: 'ArtifactPortfolio', id: string, name: string }
      | { __typename: 'ArtifactSequence', id: string, name: string }
     } | null };

export type UnlinkArtifactMutationVariables = Exact<{
  artifactID: Scalars['ID']['input'];
  artifactPortfolioID: Scalars['ID']['input'];
}>;


export type UnlinkArtifactMutation = { __typename: 'Mutation', unlinkArtifact?: { __typename: 'UnlinkArtifactPayload', artifactID: string, success: boolean, clientMutationId?: string | null } | null };

export type AddAliasesMutationVariables = Exact<{
  artifactID: Scalars['ID']['input'];
  aliases: Array<ArtifactCollectionAliasInput>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddAliasesMutation = { __typename: 'Mutation', addAliases?: { __typename: 'AddAliasesPayload', success: boolean } | null };

export type DeleteAliasesMutationVariables = Exact<{
  artifactID: Scalars['ID']['input'];
  aliases: Array<ArtifactCollectionAliasInput>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteAliasesMutation = { __typename: 'Mutation', deleteAliases?: { __typename: 'DeleteAliasesPayload', success: boolean } | null };

export type UpdateArtifactEntityTtlMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  ttlDurationSeconds: Scalars['Int64']['input'];
}>;


export type UpdateArtifactEntityTtlMutation = { __typename: 'Mutation', updateArtifactEntityTTL?: { __typename: 'UpdateArtifactEntityTTLPayload', clientMutationId?: string | null } | null };

export type DeleteArtifactEntityTtlMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type DeleteArtifactEntityTtlMutation = { __typename: 'Mutation', deleteArtifactEntityTTL?: { __typename: 'DeleteArtifactEntityTTLPayload', clientMutationId?: string | null } | null };

export type ArtifactRedirectQueryVariables = Exact<{
  projectName?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  artifactTypeName: Scalars['String']['input'];
  artifactCollectionName: Scalars['String']['input'];
  membershipIdentifier: Scalars['String']['input'];
  includeMembership: Scalars['Boolean']['input'];
}>;


export type ArtifactRedirectQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
                | { __typename: 'ArtifactPortfolio', id: string, name: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null } | null }> } }
                | { __typename: 'ArtifactSequence', id: string, name: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null } | null }> } }
               | null }> } | null } | null }> }, artifactType?: { __typename: 'ArtifactType', id: string, name: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null } | null }> } }
            | { __typename: 'ArtifactSequence', id: string, name: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null } | null }> } }
           | null }> } | null, artifactCollection?:
        | { __typename: 'ArtifactPortfolio', id: string, name: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null } | null }> }, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null } | null }
        | { __typename: 'ArtifactSequence', id: string, name: string, artifactMemberships: { __typename: 'ArtifactCollectionMembershipConnection', edges: Array<{ __typename: 'ArtifactCollectionMembershipEdge', node?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null } | null }> }, artifactMembership?: { __typename: 'ArtifactCollectionMembership', id: string, versionIndex?: number | null } | null }
       | null } | null } | null };

export type ArtifactTypeQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  artifactTypeName: Scalars['String']['input'];
}>;


export type ArtifactTypeQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactType?: { __typename: 'ArtifactType', id: string, name: string, description?: string | null, artifactSequences?: { __typename: 'ArtifactSequenceConnection', edges: Array<{ __typename: 'ArtifactSequenceEdge', node?: { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, artifacts: { __typename: 'VersionedArtifactConnection', totalCount: number } } | null }> } | null } | null } | null };

export type ArtifactTypesQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ArtifactTypesQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string } | null }> } } | null };

export type ViewerDefaultResourceConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerDefaultResourceConfigsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, defaultResourceConfigs?: { __typename: 'DefaultResourceConfigConnection', edges: Array<{ __typename: 'DefaultResourceConfigEdge', node: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, updatedAt?: string | null, resource: string, config?: any | null, scope: { __typename: 'DefaultResourceConfigScope', Type: DefaultResourceConfigScopeType, ID: number }, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } }> } | null } | null }> } | null } | null };

export type EntityDefaultResourceConfigsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type EntityDefaultResourceConfigsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, defaultResourceConfigs?: { __typename: 'DefaultResourceConfigConnection', edges: Array<{ __typename: 'DefaultResourceConfigEdge', node: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, updatedAt?: string | null, resource: string, config?: any | null, scope: { __typename: 'DefaultResourceConfigScope', Type: DefaultResourceConfigScopeType, ID: number }, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } }> } | null } | null };

export type ProjectDefaultResourceConfigsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
}>;


export type ProjectDefaultResourceConfigsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, defaultResourceConfigs?: { __typename: 'DefaultResourceConfigConnection', edges: Array<{ __typename: 'DefaultResourceConfigEdge', node: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, updatedAt?: string | null, resource: string, config?: any | null, scope: { __typename: 'DefaultResourceConfigScope', Type: DefaultResourceConfigScopeType, ID: number }, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } }> } | null } | null };

export type CreateDefaultResourceConfigMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName?: InputMaybe<Scalars['String']['input']>;
  resource: Scalars['String']['input'];
  config: Scalars['JSONString']['input'];
  templateVariables: Scalars['JSONString']['input'];
}>;


export type CreateDefaultResourceConfigMutation = { __typename: 'Mutation', createDefaultResourceConfig?: { __typename: 'CreateDefaultResourceConfigPayload', defaultResourceConfigID: string, schemaValidationErrors?: Array<string> | null, success: boolean } | null };

export type DeleteDefaultResourceConfigMutationVariables = Exact<{
  defaultResourceConfigIDs: Array<Scalars['ID']['input']>;
}>;


export type DeleteDefaultResourceConfigMutation = { __typename: 'Mutation', deleteDefaultResourceConfigs?: { __typename: 'DeleteDefaultResourceConfigsPayload', numAffected: any, success: boolean } | null };

export type UpdateDefaultResourceConfigMutationVariables = Exact<{
  defaultResourceConfigID: Scalars['ID']['input'];
  resource?: InputMaybe<Scalars['String']['input']>;
  config: Scalars['JSONString']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  templateVariables: Scalars['JSONString']['input'];
}>;


export type UpdateDefaultResourceConfigMutation = { __typename: 'Mutation', updateDefaultResourceConfig?: { __typename: 'UpdateDefaultResourceConfigPayload', schemaValidationErrors?: Array<string> | null, success: boolean } | null };

export type DefaultResourceConfigQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  defaultResourceConfigID: Scalars['ID']['input'];
}>;


export type DefaultResourceConfigQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, defaultResourceConfig?: { __typename: 'DefaultResourceConfig', id: string, config?: any | null, resource: string, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } | null } | null };

export type EntityArtifactsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type EntityArtifactsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string, artifactSequences?: { __typename: 'ArtifactSequenceConnection', edges: Array<{ __typename: 'ArtifactSequenceEdge', node?: { __typename: 'ArtifactSequence', id: string, name: string, createdAt: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } }> } } | null }> } | null } | null }> } } | null }> } | null } | null };

export type PaidEntityQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type PaidEntityQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, isPaid?: boolean | null } | null };

export type EntityProfileQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type EntityProfileQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, profileView?: { __typename: 'View', id: string, spec?: any | null, updatedAt?: string | null, updatedBy?: { __typename: 'User', id: string, username?: string | null } | null } | null } | null };

export type EntityProjectsReportsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EntityProjectsReportsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, reports?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, updatedAt?: string | null, createdAt: string, starred?: boolean | null, starCount: number, parentId?: string | null, locked: boolean, viewCount: number, updatedBy?: { __typename: 'User', id: string, username?: string | null, name: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, alertSubscription?:
                  | { __typename: 'EmailSubscription', id: string }
                  | { __typename: 'SlackChannelSubscription', id: string }
                 | null } | null }> } | null } | null }> } | null } | null };

export type ProjectReportsQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectReportsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, entityName: string, reports?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, updatedAt?: string | null, createdAt: string, starred?: boolean | null, starCount: number, parentId?: string | null, locked: boolean, viewCount: number, updatedBy?: { __typename: 'User', id: string, username?: string | null, name: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, alertSubscription?:
            | { __typename: 'EmailSubscription', id: string }
            | { __typename: 'SlackChannelSubscription', id: string }
           | null } | null }> } | null } | null };

export type EntityTagsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type EntityTagsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, tagCategories: Array<{ __typename: 'TagCategory', id: string, name: string, tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, tagCategoryName: string, attributes: any } }> } }> } | null };

export type GalleryQueryVariables = Exact<{ [key: string]: never; }>;


export type GalleryQuery = { __typename: 'Query', singletonView?: { __typename: 'View', id: string, spec?: any | null } | null };

export type UpdateGalleryMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  spec: Scalars['String']['input'];
}>;


export type UpdateGalleryMutation = { __typename: 'Mutation', upsertView?: { __typename: 'UpsertViewPayload', inserted?: boolean | null, view?: { __typename: 'View', id: string, updatedAt?: string | null, createdAt: string, spec?: any | null } | null } | null };

export type FeaturedReportsMetadataQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']>;
  recentStarCountFrom?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type FeaturedReportsMetadataQuery = { __typename: 'Query', views?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, createdAt: string, updatedAt?: string | null, entityName: string, displayName?: string | null, description?: string | null, previewUrl?: string | null, viewCount: number, starCount: number, starred?: boolean | null, recentStarCount: number, project?: { __typename: 'Project', id: string, entityName: string, name: string, access?: string | null } | null } | null }> } | null };

export type FeaturedReportsAuthorsQueryVariables = Exact<{
  usernames: Array<Scalars['String']['input']>;
}>;


export type FeaturedReportsAuthorsQuery = { __typename: 'Query', users?: { __typename: 'UserConnection', edges: Array<{ __typename: 'UserEdge', node?: { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null, userInfo?: any | null } | null }> } | null };

export type InsertGalleryDiscussionMutationVariables = Exact<{
  spec: Scalars['String']['input'];
  reportID: Scalars['ID']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InsertGalleryDiscussionMutation = { __typename: 'Mutation', insertGalleryDiscussion?: { __typename: 'InsertGalleryDiscussionPayload', success: boolean } | null };

export type SubmitFcNewsMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  url: Scalars['String']['input'];
  details?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubmitFcNewsMutation = { __typename: 'Mutation', submitFCNews?: { __typename: 'SubmitFCNewsPayload', success: boolean } | null };

export type GalleryTagSectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GalleryTagSectionsQuery = { __typename: 'Query', galleryTagSections: any };

export type ProjectAccessQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectAccessQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, access?: string | null } | null };

export type NewsletterSubscriptionQueryVariables = Exact<{
  userName: Scalars['String']['input'];
}>;


export type NewsletterSubscriptionQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, newsletterSubscription?: { __typename: 'NewsletterSubscription', id: string } | null } | null };

export type CreateNewsletterSubscriptionMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateNewsletterSubscriptionMutation = { __typename: 'Mutation', createNewsletterSubscription?: { __typename: 'CreateNewsletterSubscriptionPayload', newsletterSubscription: { __typename: 'NewsletterSubscription', id: string } } | null };

export type AllNewsletterSubscriptionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllNewsletterSubscriptionsQuery = { __typename: 'Query', newsletterSubscriptions?: { __typename: 'NewsletterSubscriptionConnection', edges: Array<{ __typename: 'NewsletterSubscriptionEdge', node?: { __typename: 'NewsletterSubscription', id: string, email?: string | null, createdAt: string, user?: { __typename: 'User', id: string, username?: string | null, email?: string | null } | null } | null }> } | null };

export type ViewPreviewUrlQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ViewPreviewUrlQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, previewUrl?: string | null } | null };

export type GroupPageQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  groupName: Scalars['String']['input'];
}>;


export type GroupPageQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runGroup?: { __typename: 'RunGroup', id: string, name: string, notes?: string | null, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }> } | null } | null };

export type HistoryKeysRunsFieldsFragment = { __typename: 'RunConnection', historyKeys?: any | null };

export type HistoryKeysQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type HistoryKeysQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', historyKeys?: any | null } | null } | null };

export type HistoryKeysWithHashQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  pinnedFilters?: InputMaybe<Scalars['JSONString']['input']>;
  includePinnedRuns?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type HistoryKeysWithHashQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', historyKeys?: any | null } | null, pinnedRuns?: { __typename: 'RunConnection', historyKeys?: any | null } | null } | null };

export type HistoryKeysByProjectIdQueryVariables = Exact<{
  internalId: Scalars['ID']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type HistoryKeysByProjectIdQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', historyKeys?: any | null } | null } | null };

export type InviteQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type InviteQuery = { __typename: 'Query', invite?: { __typename: 'Invite', id: string, toUser?: { __typename: 'User', id: string, username?: string | null } | null } | null };

type JobInfo_ArtifactPortfolio_Fragment = { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string } }> } } }> } };

type JobInfo_ArtifactSequence_Fragment = { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string } }> } } }> } };

export type JobInfoFragment =
  | JobInfo_ArtifactPortfolio_Fragment
  | JobInfo_ArtifactSequence_Fragment
;

export type DefaultResourceConfigFragmentFragment = { __typename: 'DefaultResourceConfig', id: string, createdAt: string, updatedAt?: string | null, resource: string, config?: any | null, scope: { __typename: 'DefaultResourceConfigScope', Type: DefaultResourceConfigScopeType, ID: number }, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> };

export type FetchEntityJobsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchEntityJobsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, artifactType?: { __typename: 'ArtifactType', id: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
                  | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } }> } }
                  | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } }> } }
                 | null }> } | null } | null } | null }> } | null } | null };

export type FetchProjectJobsPartialQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type FetchProjectJobsPartialQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, internalId: string, artifactType?: { __typename: 'ArtifactType', id: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string } }> } } }> } }
            | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string } }> } } }> } }
           | null }> } | null } | null } | null };

export type FetchProjectInternalIdQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type FetchProjectInternalIdQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, internalId: string } | null };

export type FetchProjectJobsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type FetchProjectJobsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, artifactType?: { __typename: 'ArtifactType', id: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string } }> } } }> } }
            | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string } }> } } }> } }
           | null }> } | null } | null } | null };

export type FetchRecentlyUsedJobsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type FetchRecentlyUsedJobsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, createdAt: string, job?: { __typename: 'Artifact', id: string, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, state: ArtifactCollectionState, description?: string | null, createdAt: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } } | null } }> } | null } | null };

export type FetchJobVersionsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  jobName: Scalars['String']['input'];
}>;


export type FetchJobVersionsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactCollection?:
      | { __typename: 'ArtifactPortfolio', id: string, description?: string | null, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, createdAt: string, createdBy?:
                | { __typename: 'Run', id: string, name: string, displayName?: string | null, defaultColorIndex?: number | null }
                | { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null }
               | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } }> } }
      | { __typename: 'ArtifactSequence', id: string, description?: string | null, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, createdAt: string, createdBy?:
                | { __typename: 'Run', id: string, name: string, displayName?: string | null, defaultColorIndex?: number | null }
                | { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null }
               | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } }> } }
     | null } | null };

export type FetchRecentlyUsedJobDetailQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  artifactCollectionFilters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type FetchRecentlyUsedJobDetailQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, internalId: string, entityName: string, artifactType?: { __typename: 'ArtifactType', id: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string } }> } } }> } }
            | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string } }> } } }> } }
           | null }> } | null } | null } | null };

export type FetchJobQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type FetchJobQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, name: string }
    | { __typename: 'ArtifactSequence', id: string, name: string }
   | null };

type JobCollectionFields_ArtifactPortfolio_Fragment = { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, project?: { __typename: 'Project', id: string, access?: string | null, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null };

type JobCollectionFields_ArtifactSequence_Fragment = { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, project?: { __typename: 'Project', id: string, access?: string | null, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null };

export type JobCollectionFieldsFragment =
  | JobCollectionFields_ArtifactPortfolio_Fragment
  | JobCollectionFields_ArtifactSequence_Fragment
;

export type JobVersionFieldsFragment = { __typename: 'Artifact', id: string, description?: string | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, createdBy?:
    | { __typename: 'Run', id: string, name: string, displayName?: string | null, defaultColorIndex?: number | null }
    | { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null }
   | null };

export type JobRunFieldsFragment = { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, stopped?: boolean | null, createdAt: string, config?: any | null, defaultColorIndex?: number | null, user?: { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null };

export type FetchJobDetailsQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type FetchJobDetailsQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', labels?: any | null, versionIndex?: number | null, id: string, description?: string | null, createdAt: string, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, stopped?: boolean | null, createdAt: string, config?: any | null, defaultColorIndex?: number | null, user?: { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null } }> }, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, createdBy?:
              | { __typename: 'Run', id: string, name: string, displayName?: string | null, defaultColorIndex?: number | null }
              | { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null }
             | null } }> }, project?: { __typename: 'Project', id: string, access?: string | null, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null }
    | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', labels?: any | null, versionIndex?: number | null, id: string, description?: string | null, createdAt: string, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, stopped?: boolean | null, createdAt: string, config?: any | null, defaultColorIndex?: number | null, user?: { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null } }> }, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, createdBy?:
              | { __typename: 'Run', id: string, name: string, displayName?: string | null, defaultColorIndex?: number | null }
              | { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null }
             | null } }> }, project?: { __typename: 'Project', id: string, access?: string | null, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null }
   | null };

export type FetchJobVersionsByIdQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type FetchJobVersionsByIdQuery = { __typename: 'Query', artifactCollection?:
    | { __typename: 'ArtifactPortfolio', id: string, name: string, description?: string | null, createdAt: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, createdBy?:
              | { __typename: 'Run', id: string, name: string, displayName?: string | null, defaultColorIndex?: number | null }
              | { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null }
             | null } }> }, project?: { __typename: 'Project', id: string, access?: string | null, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null }
    | { __typename: 'ArtifactSequence', id: string, name: string, description?: string | null, createdAt: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, description?: string | null, createdAt: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, createdBy?:
              | { __typename: 'Run', id: string, name: string, displayName?: string | null, defaultColorIndex?: number | null }
              | { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null }
             | null } }> }, project?: { __typename: 'Project', id: string, access?: string | null, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null }
   | null };

export type FetchJobVersionRunsQueryVariables = Exact<{
  artifactId: Scalars['ID']['input'];
  usedByFilters?: InputMaybe<Scalars['JSONString']['input']>;
  usedByFirst?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FetchJobVersionRunsQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, usedBy: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, stopped?: boolean | null, createdAt: string, config?: any | null, defaultColorIndex?: number | null, runInfo?: { __typename: 'RunInfo', args: Array<string> } | null, user?: { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null } }> } } | null };

export type FetchProjectRunsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type FetchProjectRunsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, runInfo?: { __typename: 'RunInfo', git?: { __typename: 'GitInfo', remote?: string | null, commit?: string | null } | null } | null } }> } | null } | null };

export type FetchProjectLaunchQueuesQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type FetchProjectLaunchQueuesQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, isTeam: boolean, name: string }, runQueues: Array<{ __typename: 'RunQueue', id: string, name: string, access: RunQueueAccessType, defaultResourceConfigID?: string | null, prioritizationMode: RunQueuePrioritizationMode }> } | null };

export type FetchEntityProjectsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type FetchEntityProjectsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string } | null }> } | null } | null };

export type EntityPhotoQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type EntityPhotoQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, photoUrl?: string | null } | null };

export type UserEntitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserEntitiesQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, photoUrl?: string | null, entityType?: string | null, members: Array<{ __typename: 'Member', id?: string | null, username?: string | null, role?: string | null }> } | null }> } | null } | null };

export type ViewerDestinationProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerDestinationProjectsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string } | null }> } | null } | null }> } | null } | null };

export type QueueNamesQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type QueueNamesQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runQueues: Array<{ __typename: 'RunQueue', id: string, name: string }> } | null };

export type AllQueuesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllQueuesQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, entity?: string | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, organizationId?: string | null, launchProject?: { __typename: 'Project', id: string, name: string, launchAgents: Array<{ __typename: 'LaunchAgent', id: string, name: string, createdAt: string, heartbeatAt?: string | null, agentStatus: string, stopPolling: boolean, runQueues: Array<string>, hostname: string }>, runQueues: Array<{ __typename: 'RunQueue', id: string, createdAt: string, createdBy?: number | null, updatedAt?: string | null, name: string, access: RunQueueAccessType, prioritizationMode: RunQueuePrioritizationMode, executorInfo: string, externalLinks?: any | null, defaultResourceConfig?: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, updatedAt?: string | null, resource: string, config?: any | null, scope: { __typename: 'DefaultResourceConfigScope', Type: DefaultResourceConfigScopeType, ID: number }, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } | null, runQueueItems: { __typename: 'RunQueueItemConnection', edges: Array<{ __typename: 'RunQueueItemEdge', node: { __typename: 'RunQueueItem', id: string, createdAt: string, updatedAt?: string | null, runSpec: any, state: RunQueueItemState, associatedRunId?: string | null, launchAgentId?: string | null, priority: number, templateVariableValues?: any | null } }> } }> } | null } | null }> } | null } | null };

export type PublicQueueQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  publicQueueName?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublicQueueQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, launchProject?: { __typename: 'Project', id: string, name: string, launchAgents: Array<{ __typename: 'LaunchAgent', id: string, name: string, createdAt: string, heartbeatAt?: string | null, agentStatus: string, stopPolling: boolean, runQueues: Array<string>, hostname: string }>, runQueue?: { __typename: 'RunQueue', id: string, createdAt: string, createdBy?: number | null, updatedAt?: string | null, name: string, access: RunQueueAccessType, prioritizationMode: RunQueuePrioritizationMode, executorInfo: string, externalLinks?: any | null, defaultResourceConfig?: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, updatedAt?: string | null, resource: string, config?: any | null, scope: { __typename: 'DefaultResourceConfigScope', Type: DefaultResourceConfigScopeType, ID: number }, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } | null, runQueueItems: { __typename: 'RunQueueItemConnection', edges: Array<{ __typename: 'RunQueueItemEdge', node: { __typename: 'RunQueueItem', id: string, createdAt: string, updatedAt?: string | null, runSpec: any, state: RunQueueItemState, associatedRunId?: string | null, launchAgentId?: string | null, priority: number, templateVariableValues?: any | null, error?: { __typename: 'RunQueueItemInfoDetails', message: string, stage: string, filePaths: Array<string> } | null, warnings: Array<{ __typename: 'RunQueueItemInfoDetails', message: string, stage: string, filePaths: Array<string> } | null> } }> } } | null } | null } | null };

export type QueueByIdLiteQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  queueId: Scalars['ID']['input'];
}>;


export type QueueByIdLiteQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, launchAgents: Array<{ __typename: 'LaunchAgent', id: string, name: string, createdAt: string, heartbeatAt?: string | null, agentStatus: string, stopPolling: boolean, runQueues: Array<string>, hostname: string }>, runQueue?: { __typename: 'RunQueue', id: string, createdAt: string, name: string, prioritizationMode: RunQueuePrioritizationMode, executorInfo: string, externalLinks?: any | null, defaultResourceConfig?: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, resource: string, config?: any | null, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } | null, runQueueItems: { __typename: 'RunQueueItemConnection', edges: Array<{ __typename: 'RunQueueItemEdge', node: { __typename: 'RunQueueItem', id: string, createdAt: string, updatedAt?: string | null, runSpec: any, state: RunQueueItemState, associatedRunId?: string | null, launchAgentId?: string | null, priority: number, templateVariableValues?: any | null } }> } } | null } | null };

export type PublicQueueLiteQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  publicQueueName?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublicQueueLiteQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, launchProject?: { __typename: 'Project', id: string, name: string, launchAgents: Array<{ __typename: 'LaunchAgent', id: string, name: string, createdAt: string, heartbeatAt?: string | null, agentStatus: string, stopPolling: boolean, runQueues: Array<string>, hostname: string }>, runQueue?: { __typename: 'RunQueue', id: string, createdAt: string, createdBy?: number | null, updatedAt?: string | null, name: string, access: RunQueueAccessType, prioritizationMode: RunQueuePrioritizationMode, executorInfo: string, externalLinks?: any | null, defaultResourceConfig?: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, updatedAt?: string | null, resource: string, config?: any | null, scope: { __typename: 'DefaultResourceConfigScope', Type: DefaultResourceConfigScopeType, ID: number }, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } | null, runQueueItems: { __typename: 'RunQueueItemConnection', edges: Array<{ __typename: 'RunQueueItemEdge', node: { __typename: 'RunQueueItem', id: string, createdAt: string, updatedAt?: string | null, runSpec: any, state: RunQueueItemState, associatedRunId?: string | null, launchAgentId?: string | null, priority: number, templateVariableValues?: any | null } }> } } | null } | null } | null };

export type EntityQueuesLiteQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type EntityQueuesLiteQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, launchProject?: { __typename: 'Project', id: string, name: string, launchAgents: Array<{ __typename: 'LaunchAgent', id: string, name: string, createdAt: string, heartbeatAt?: string | null, agentStatus: string, stopPolling: boolean, runQueues: Array<string>, hostname: string }>, runQueues: Array<{ __typename: 'RunQueue', id: string, createdAt: string, createdBy?: number | null, updatedAt?: string | null, name: string, access: RunQueueAccessType, prioritizationMode: RunQueuePrioritizationMode, executorInfo: string, externalLinks?: any | null, defaultResourceConfig?: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, updatedAt?: string | null, resource: string, config?: any | null, scope: { __typename: 'DefaultResourceConfigScope', Type: DefaultResourceConfigScopeType, ID: number }, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } | null }> } | null } | null };

export type EntityQueueByQueueNameLiteQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  queueName?: InputMaybe<Scalars['String']['input']>;
}>;


export type EntityQueueByQueueNameLiteQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, launchProject?: { __typename: 'Project', id: string, name: string, launchAgents: Array<{ __typename: 'LaunchAgent', id: string, name: string, createdAt: string, heartbeatAt?: string | null, agentStatus: string, stopPolling: boolean, runQueues: Array<string>, hostname: string }>, runQueue?: { __typename: 'RunQueue', id: string, createdAt: string, createdBy?: number | null, updatedAt?: string | null, name: string, access: RunQueueAccessType, prioritizationMode: RunQueuePrioritizationMode, executorInfo: string, externalLinks?: any | null, defaultResourceConfig?: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, updatedAt?: string | null, resource: string, config?: any | null, scope: { __typename: 'DefaultResourceConfigScope', Type: DefaultResourceConfigScopeType, ID: number }, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } | null } | null } | null } | null };

export type AllQueuesLiteQueryVariables = Exact<{ [key: string]: never; }>;


export type AllQueuesLiteQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, entity?: string | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, organizationId?: string | null, launchProject?: { __typename: 'Project', id: string, name: string, launchAgents: Array<{ __typename: 'LaunchAgent', id: string, name: string, createdAt: string, heartbeatAt?: string | null, agentStatus: string, stopPolling: boolean, runQueues: Array<string>, hostname: string }>, runQueues: Array<{ __typename: 'RunQueue', id: string, createdAt: string, createdBy?: number | null, updatedAt?: string | null, name: string, access: RunQueueAccessType, prioritizationMode: RunQueuePrioritizationMode, executorInfo: string, externalLinks?: any | null, defaultResourceConfig?: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, updatedAt?: string | null, resource: string, config?: any | null, scope: { __typename: 'DefaultResourceConfigScope', Type: DefaultResourceConfigScopeType, ID: number }, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } | null }> } | null } | null }> } | null } | null };

export type RunsInformationQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type RunsInformationQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, state?: string | null, createdAt: string, heartbeatAt?: string | null } }> } | null } | null };

export type FetchCodeArtifactFilesQueryVariables = Exact<{
  artifactID: Scalars['ID']['input'];
}>;


export type FetchCodeArtifactFilesQuery = { __typename: 'Query', artifact?: { __typename: 'Artifact', id: string, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, displayName: string, mimetype?: string | null, sizeBytes: any, url?: string | null } | null }> } | null } | null };

export type FetchAgentDetailsQueryVariables = Exact<{
  agentId: Scalars['ID']['input'];
}>;


export type FetchAgentDetailsQuery = { __typename: 'Query', launchAgent?: { __typename: 'LaunchAgent', id: string, name: string, createdAt: string, updatedAt?: string | null, heartbeatAt?: string | null, runQueues: Array<string>, hostname: string, agentStatus: string, stopPolling: boolean, agentConfig?: any | null, version?: string | null } | null };

export type EntityAgentsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type EntityAgentsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, launchProject?: { __typename: 'Project', id: string, name: string, launchAgents: Array<{ __typename: 'LaunchAgent', id: string, name: string, createdAt: string, heartbeatAt?: string | null, agentStatus: string, stopPolling: boolean, runQueues: Array<string>, hostname: string }> } | null } | null };

export type FetchRunOutputLogQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type FetchRunOutputLogQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, logLineCount?: number | null, outputLogFile?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, md5?: string | null, sizeBytes: any, directUrl: string, url?: string | null } | null }> } | null } | null } | null };

export type QueueByIdQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  queueId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type QueueByIdQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, launchAgents: Array<{ __typename: 'LaunchAgent', id: string, name: string, createdAt: string, heartbeatAt?: string | null, agentStatus: string, stopPolling: boolean, runQueues: Array<string>, hostname: string }>, runQueue?: { __typename: 'RunQueue', id: string, createdAt: string, name: string, prioritizationMode: RunQueuePrioritizationMode, executorInfo: string, externalLinks?: any | null, defaultResourceConfig?: { __typename: 'DefaultResourceConfig', id: string, createdAt: string, resource: string, config?: any | null, templateVariables: Array<{ __typename: 'TemplateVariable', name: string, description?: string | null, schema: any }> } | null, runQueueItems: { __typename: 'RunQueueItemConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'RunQueueItemEdge', node: { __typename: 'RunQueueItem', id: string, createdAt: string, updatedAt?: string | null, runSpec: any, state: RunQueueItemState, associatedRunId?: string | null, launchAgentId?: string | null, priority: number, templateVariableValues?: any | null, error?: { __typename: 'RunQueueItemInfoDetails', message: string, stage: string, filePaths: Array<string> } | null, warnings: Array<{ __typename: 'RunQueueItemInfoDetails', message: string, stage: string, filePaths: Array<string> } | null> } }> } } | null } | null };

export type RunJobQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type RunJobQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, job?: { __typename: 'Artifact', id: string, versionIndex?: number | null, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string } } | null } | null } | null };

export type RunFilesAndFolderWithDirectUrLsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
  maxNumFiles: Scalars['Int']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
}>;


export type RunFilesAndFolderWithDirectUrLsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, run?: { __typename: 'Run', id: string, name: string, projectId: string, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string, directUrl: string, sizeBytes: any, updatedAt?: string | null, artifact?: { __typename: 'Artifact', id: string, digest: string } | null } | null }> } | null } | null } | null };

export type AccountUsingLaunchQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type AccountUsingLaunchQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, isLaunchActive: boolean } | null };

export type ArtifactPathEntityProjectsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
}>;


export type ArtifactPathEntityProjectsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string } | null }> } | null } | null };

export type ArtifactPathSearchArtifactsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  artifactsLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ArtifactPathSearchArtifactsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, project?: { __typename: 'Project', id: string, artifactCollectionsSearch?: { __typename: 'ArtifactCollectionSearchConnection', edges: Array<{ __typename: 'ArtifactCollectionSearchEdge', node:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } }> } }
            | { __typename: 'ArtifactSequence', id: string, name: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }> } }> } }
           }> } | null } | null } | null };

export type AddPublicQueueLaunchAgentTeamConfigMutationVariables = Exact<{
  input: AddPublicQueueLaunchAgentTeamConfigInput;
}>;


export type AddPublicQueueLaunchAgentTeamConfigMutation = { __typename: 'Mutation', addPublicQueueLaunchAgentTeamConfig?: { __typename: 'AddPublicQueueLaunchAgentTeamConfigPayload', success: boolean, clientMutationID?: string | null } | null };

export type DeletePublicQueueLaunchAgentTeamConfigMutationVariables = Exact<{
  input: DeletePublicQueueLaunchAgentTeamConfigInput;
}>;


export type DeletePublicQueueLaunchAgentTeamConfigMutation = { __typename: 'Mutation', deletePublicQueueLaunchAgentTeamConfig?: { __typename: 'DeletePublicQueueLaunchAgentTeamConfigPayload', success: boolean, clientMutationID?: string | null } | null };

export type ViewerTeamsProjectsQueryVariables = Exact<{
  pattern?: InputMaybe<Scalars['String']['input']>;
}>;


export type ViewerTeamsProjectsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string } | null }> } | null } | null }> } | null } | null };

export type FetchProjectRunsForConfigQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FetchProjectRunsForConfigQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, createdAt: string, state?: string | null, defaultColorIndex?: number | null, config?: any | null, runInfo?: { __typename: 'RunInfo', args: Array<string> } | null, user?: { __typename: 'User', id: string, name: string, username?: string | null, photoUrl?: string | null } | null, job?: { __typename: 'Artifact', id: string, description?: string | null, labels?: any | null, versionIndex?: number | null, aliases: Array<{ __typename: 'ArtifactAlias', id: string, alias: string }>, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string } } | null } }> } | null } | null };

export type MessageOfTheDayQueryVariables = Exact<{ [key: string]: never; }>;


export type MessageOfTheDayQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', messageOfTheDay?: string | null } | null };

export type MoveViewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MoveViewMutation = { __typename: 'Mutation', moveView?: { __typename: 'MoveViewPayload', success?: boolean | null, clientMutationId?: string | null } | null };

export type MultiRunWorkspaceQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type MultiRunWorkspaceQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, readOnly?: boolean | null } | null };

export type NwEntityPermissionQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type NwEntityPermissionQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, isTeam: boolean, settings: { __typename: 'EntitySettings', hidden: boolean } } | null };

export type NwProjectPermissionQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
}>;


export type NwProjectPermissionQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, access?: string | null, user?: { __typename: 'User', id: string, username?: string | null } | null, members: Array<{ __typename: 'ProjectMember', id: string, username?: string | null }> } | null };

export type OrgAdminsQueryVariables = Exact<{
  orgName?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrgAdminsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, billingUser?: { __typename: 'User', id: string, username?: string | null } | null, members: Array<{ __typename: 'OrganizationMember', id: string, admin: boolean, user: { __typename: 'User', id: string, username?: string | null } }> } | null };

export type OrganizationTagNamesQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type OrganizationTagNamesQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, tagNames?: { __typename: 'TagNameConnection', edges: Array<{ __typename: 'TagNameEdge', node: string }> } | null } | null };

export type ParameterImportanceQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  targetName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  parameters?: InputMaybe<Array<Scalars['String']['input']>>;
  runParameters?: InputMaybe<Array<Scalars['String']['input']>>;
  sweepName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ParameterImportanceQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, parameterImportance: any } | null };

export type ProjectArtifactCollectionsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  collectionTypes?: InputMaybe<Array<ArtifactCollectionType>>;
}>;


export type ProjectArtifactCollectionsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactTypes: { __typename: 'ArtifactTypeConnection', edges: Array<{ __typename: 'ArtifactTypeEdge', node?: { __typename: 'ArtifactType', id: string, name: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
                | { __typename: 'ArtifactPortfolio', id: string, name: string }
                | { __typename: 'ArtifactSequence', id: string, name: string }
               | null }> } | null } | null }> } } | null };

export type ProjectFieldsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  types: Array<Scalars['String']['input']>;
  columns: Array<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  count: Scalars['Int']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectFieldsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, fields: { __typename: 'ProjectFieldConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ProjectFieldEdge', node: { __typename: 'ProjectField', path: string, type: string } }> } } | null };

export type ProjectTags2QueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  pattern?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProjectTags2Query = { __typename: 'Query', project?: { __typename: 'Project', id: string, runTags?: { __typename: 'RunTagConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'RunTagEdge', node: { __typename: 'RunTag', name: string, id: string } }> } | null } | null };

export type ProjectTagsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type ProjectTagsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, tagCounts: Array<{ __typename: 'RunTagCount', name: string, count: number }> } | null };

export type ReportPageQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
}>;


export type ReportPageQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, access?: string | null, readOnly?: boolean | null, entity: { __typename: 'Entity', id: string, name: string, defaultAccess: string, readOnlyAdmin: boolean, privateOnly: boolean, isTeam: boolean } } | null };

export type ReportTableQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  draftsOffset?: InputMaybe<Scalars['Int']['input']>;
  draftsPageSize?: InputMaybe<Scalars['Int']['input']>;
  publishedOffset?: InputMaybe<Scalars['Int']['input']>;
  publishedPageSize?: InputMaybe<Scalars['Int']['input']>;
  displayNameContains?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportTableQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, access?: string | null, readOnly?: boolean | null, reportAuthors: Array<string>, reportDrafts?: { __typename: 'ViewConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, updatedAt?: string | null, createdAt: string, starred?: boolean | null, starCount: number, parentId?: string | null, locked: boolean, viewCount: number, updatedBy?: { __typename: 'User', id: string, username?: string | null, name: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, alertSubscription?:
            | { __typename: 'EmailSubscription', id: string }
            | { __typename: 'SlackChannelSubscription', id: string }
           | null } | null }> } | null, reports?: { __typename: 'ViewConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, updatedAt?: string | null, createdAt: string, starred?: boolean | null, starCount: number, parentId?: string | null, locked: boolean, viewCount: number, children?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, type?: string | null, user?: { __typename: 'User', id: string } | null } | null }> } | null, updatedBy?: { __typename: 'User', id: string, username?: string | null, name: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, alertSubscription?:
            | { __typename: 'EmailSubscription', id: string }
            | { __typename: 'SlackChannelSubscription', id: string }
           | null } | null }> } | null } | null };

export type RunArtifactVersionsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  includeOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeInput?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type RunArtifactVersionsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, state?: string | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'ArtifactEdge', node?: { __typename: 'Artifact', id: string, versionIndex?: number | null, isLinkedToGlobalRegistry: boolean, artifactType: { __typename: 'ArtifactType', id: string, name: string, project: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } }, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string }, usedBy: { __typename: 'RunConnection', totalCount: number } } | null }> } | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'InputArtifactEdge', node?: { __typename: 'Artifact', id: string, versionIndex?: number | null, artifactType: { __typename: 'ArtifactType', id: string, name: string, project: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } }, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string, project?: { __typename: 'Project', id: string, name: string, entity: { __typename: 'Entity', id: string, name: string } } | null }, usedBy: { __typename: 'RunConnection', totalCount: number } } | null }> } | null } | null } | null };

export type CodeFilesQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type CodeFilesQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, config?: any | null, group?: string | null, codeArtifact?: { __typename: 'Artifact', id: string, commitHash?: string | null, artifactSequence: { __typename: 'ArtifactSequence', id: string, name: string } } | null, sweep?: { __typename: 'Sweep', id: string, name: string } | null } | null } | null };

export type RunCodePollingQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type RunCodePollingQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, state?: string | null, historyKeys?: any | null } | null } | null };

export type RunsOutputArtifactsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runNames: Array<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  filenames: Array<Scalars['String']['input']>;
}>;


export type RunsOutputArtifactsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, outputArtifacts?: { __typename: 'ArtifactConnection', edges: Array<{ __typename: 'ArtifactEdge', node?: { __typename: 'Artifact', id: string, artifactType: { __typename: 'ArtifactType', id: string, name: string }, artifactSequenceMembership: { __typename: 'ArtifactCollectionMembership', id: string, files?: { __typename: 'FileConnection', edges: Array<{ __typename: 'FileEdge', node?: { __typename: 'File', id: string, name: string } | null }> } | null } } | null }> } | null } }> } | null } | null };

export type RunByDisplayNameQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
}>;


export type RunByDisplayNameQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null, createdAt: string } }> } | null } | null };

export type RunHistoryQueryQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  sampledHistorySpecs: Array<Scalars['JSONString']['input']>;
}>;


export type RunHistoryQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, sampledHistory: Array<any> } | null } | null };

export type RunInfoAndConfigQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
}>;


export type RunInfoAndConfigQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, config?: any | null, runInfo?: { __typename: 'RunInfo', program?: string | null, args: Array<string>, os?: string | null, python?: string | null, colab?: string | null, executable?: string | null, codeSaved?: boolean | null, cpuCount?: number | null, cpuCountLogical?: number | null, gpuCount?: number | null, gpu?: string | null, git?: { __typename: 'GitInfo', remote?: string | null, commit?: string | null } | null } | null } | null } | null };

export type RunInfoQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
}>;


export type RunInfoQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, runInfo?: { __typename: 'RunInfo', program?: string | null, args: Array<string>, os?: string | null, python?: string | null, colab?: string | null, executable?: string | null, codeSaved?: boolean | null, cpuCount?: number | null, cpuCountLogical?: number | null, gpuCount?: number | null, gpu?: string | null, git?: { __typename: 'GitInfo', remote?: string | null, commit?: string | null } | null } | null } | null } | null };

export type RunKeysQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RunKeysQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, fields: { __typename: 'ProjectFieldConnection', edges: Array<{ __typename: 'ProjectFieldEdge', node: { __typename: 'ProjectField', path: string } }> } } | null };

export type RunSearchQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RunSearchQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, displayName?: string | null } }> } | null } | null };

export type RunSelectorQueryVariables = Exact<{
  projectInternalId: Scalars['ID']['input'];
}>;


export type RunSelectorQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, fields: { __typename: 'ProjectFieldConnection', edges: Array<{ __typename: 'ProjectFieldEdge', node: { __typename: 'ProjectField', path: string } }> }, entity: { __typename: 'Entity', id: string, settings: { __typename: 'EntitySettings', storageBucketInfo?: { __typename: 'StorageBucketInfo', ID: string } | null } } } | null };

export type RunFieldsFragment = { __typename: 'Run', id: string, aggregations?: any | null, commit?: string | null, computeSeconds: number, config?: any | null, createdAt: string, defaultColorIndex?: number | null, displayName?: string | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, name: string, notes?: string | null, projectId: string, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, summaryMetrics?: any | null, updatedAt?: string | null, wandbConfig?: any | null, agent?: { __typename: 'Agent', id: string, name: string } | null, multiValueMetadataColumns?: Array<{ __typename: 'MultiValueMetadataColumn', key: string, values: Array<string> }>, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, tags?: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null };

export type RunsSelectorRunsProjectFragmentFragment = { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', totalCount: number, deltaOrder: Array<string>, delta: Array<{ __typename: 'RunDiff', index: number, op: DiffOperation, run?: { __typename: 'Run', id: string, aggregations?: any | null, commit?: string | null, computeSeconds: number, config?: any | null, createdAt: string, defaultColorIndex?: number | null, displayName?: string | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, name: string, notes?: string | null, projectId: string, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, summaryMetrics?: any | null, updatedAt?: string | null, wandbConfig?: any | null, agent?: { __typename: 'Agent', id: string, name: string } | null, multiValueMetadataColumns?: Array<{ __typename: 'MultiValueMetadataColumn', key: string, values: Array<string> }>, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, tags?: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null } | null }> } | null };

export type RunSelectorGroupsLeanQueryVariables = Exact<{
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  projectInternalId: Scalars['ID']['input'];
}>;


export type RunSelectorGroupsLeanQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runSelectorGroups?: { __typename: 'RunSelectorGroupConnection', totalCount: number, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'RunSelectorGroupEdge', node: { __typename: 'RunSelectorGroup', id: string, value?: any | null, label: string, count: number, subgroupCount?: number | null, hasActiveRuns: boolean } }> } | null } | null };

export type RunSelectorRunsQueryVariables = Exact<{
  aggregationKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableAggregations?: InputMaybe<Scalars['Boolean']['input']>;
  enableArtifactCounts?: InputMaybe<Scalars['Boolean']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableGroupedMetadataColumns?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableTags?: InputMaybe<Scalars['Boolean']['input']>;
  filters: Scalars['JSONString']['input'];
  groupAggregation?: InputMaybe<GroupAggregation>;
  groupedMetadataColumnKeys: Array<Scalars['String']['input']>;
  groupedMetadataColumnLimit?: InputMaybe<Scalars['Int']['input']>;
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  pinnedRunIds: Array<Scalars['ID']['input']>;
  projectInternalId: Scalars['ID']['input'];
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  wandbKeys?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type RunSelectorRunsQuery = { __typename: 'Query', pinnedRuns: { __typename: 'RunsResult', runs: Array<{ __typename: 'Run', id: string, aggregations?: any | null, commit?: string | null, computeSeconds: number, config?: any | null, createdAt: string, defaultColorIndex?: number | null, displayName?: string | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, name: string, notes?: string | null, projectId: string, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, summaryMetrics?: any | null, updatedAt?: string | null, wandbConfig?: any | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, agent?: { __typename: 'Agent', id: string, name: string } | null, multiValueMetadataColumns?: Array<{ __typename: 'MultiValueMetadataColumn', key: string, values: Array<string> }>, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, tags?: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null }> }, project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', totalCount: number, deltaOrder: Array<string>, delta: Array<{ __typename: 'RunDiff', index: number, op: DiffOperation, run?: { __typename: 'Run', id: string, aggregations?: any | null, commit?: string | null, computeSeconds: number, config?: any | null, createdAt: string, defaultColorIndex?: number | null, displayName?: string | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, name: string, notes?: string | null, projectId: string, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, summaryMetrics?: any | null, updatedAt?: string | null, wandbConfig?: any | null, agent?: { __typename: 'Agent', id: string, name: string } | null, multiValueMetadataColumns?: Array<{ __typename: 'MultiValueMetadataColumn', key: string, values: Array<string> }>, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, tags?: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null } | null }> } | null } | null };

export type RunSelectorFilteredRunExistsQueryVariables = Exact<{
  projectInternalId: Scalars['ID']['input'];
  filters: Scalars['JSONString']['input'];
}>;


export type RunSelectorFilteredRunExistsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string } }> } | null } | null };

export type RunSelectorCsvExportRunFieldsFragment = { __typename: 'Run', id: string, aggregations?: any | null, commit?: string | null, config?: any | null, createdAt: string, displayName?: string | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, name: string, notes?: string | null, projectId: string, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, summaryMetrics?: any | null, tags?: Array<string> | null, updatedAt?: string | null, wandbConfig?: any | null, multiValueMetadataColumns?: Array<{ __typename: 'MultiValueMetadataColumn', key: string, values: Array<string> }>, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null } | null, user?: { __typename: 'User', id: string, username?: string | null } | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null };

export type RunSelectorCsvExportRunsQueryVariables = Exact<{
  aggregationKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  enableAggregations?: InputMaybe<Scalars['Boolean']['input']>;
  enableArtifactCounts?: InputMaybe<Scalars['Boolean']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableGroupedMetadataColumns?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableTags?: InputMaybe<Scalars['Boolean']['input']>;
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  groupAggregation?: InputMaybe<GroupAggregation>;
  groupedMetadataColumnKeys: Array<Scalars['String']['input']>;
  groupedMetadataColumnLimit?: InputMaybe<Scalars['Int']['input']>;
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  pinnedRunIds: Array<Scalars['ID']['input']>;
  projectName: Scalars['String']['input'];
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  wandbKeys?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type RunSelectorCsvExportRunsQuery = { __typename: 'Query', pinnedRuns: { __typename: 'RunsResult', runs: Array<{ __typename: 'Run', id: string, aggregations?: any | null, commit?: string | null, config?: any | null, createdAt: string, displayName?: string | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, name: string, notes?: string | null, projectId: string, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, summaryMetrics?: any | null, tags?: Array<string> | null, updatedAt?: string | null, wandbConfig?: any | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null, multiValueMetadataColumns?: Array<{ __typename: 'MultiValueMetadataColumn', key: string, values: Array<string> }>, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null } | null, user?: { __typename: 'User', id: string, username?: string | null } | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null }> }, project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, aggregations?: any | null, commit?: string | null, config?: any | null, createdAt: string, displayName?: string | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, name: string, notes?: string | null, projectId: string, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, summaryMetrics?: any | null, tags?: Array<string> | null, updatedAt?: string | null, wandbConfig?: any | null, multiValueMetadataColumns?: Array<{ __typename: 'MultiValueMetadataColumn', key: string, values: Array<string> }>, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null } | null, user?: { __typename: 'User', id: string, username?: string | null } | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null } }> } | null } | null };

export type RunSelectorAutoColsRunsQueryVariables = Exact<{
  enableArtifactCounts?: InputMaybe<Scalars['Boolean']['input']>;
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type RunSelectorAutoColsRunsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, aggregations?: any | null, commit?: string | null, config?: any | null, createdAt: string, displayName?: string | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, name: string, notes?: string | null, projectId: string, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, summaryMetrics?: any | null, updatedAt?: string | null, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null } | null, user?: { __typename: 'User', id: string, username?: string | null } | null, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null } }> } | null } | null };

export type BulkEditorProjectTagsQueryVariables = Exact<{
  name: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  tempFilters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type BulkEditorProjectTagsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, tags: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, tagCounts: Array<{ __typename: 'RunTagCount', name: string, count: number }> } | null };

export type RunSetSummaryQueryVariables = Exact<{
  projectInternalId: Scalars['ID']['input'];
  selections: Scalars['JSONString']['input'];
}>;


export type RunSetSummaryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, selectedCount: number } | null };

export type ViewSpecQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ViewSpecQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, type?: string | null, spec?: any | null } | null };

export type SearchEntityProjectsQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  entityProjectsLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchEntityProjectsQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, allViews?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null }> } | null } | null }> } | null };

export type SearchViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchViewerQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, admin?: boolean | null, photoUrl?: string | null, username?: string | null, organizations: Array<{ __typename: 'Organization', id: string, name: string, orgType: OrgType }>, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string } | null }> } | null, views?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null }> } | null, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, photoUrl?: string | null, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string } | null }> } | null } | null }> } | null } | null };

export type SearchNavQueryQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  runName: Scalars['String']['input'];
  sweepName: Scalars['String']['input'];
}>;


export type SearchNavQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, name: string, access?: string | null, readOnly?: boolean | null, entity: { __typename: 'Entity', id: string, name: string, readOnlyAdmin: boolean, defaultAccess: string, privateOnly: boolean, isTeam: boolean }, user?: { __typename: 'User', id: string } | null, run?: { __typename: 'Run', id: string, displayName?: string | null, state?: string | null } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null } | null };

export type SelectedCountQueryVariables = Exact<{
  projectInternalId: Scalars['ID']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  tempFilters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type SelectedCountQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, selectedCount: number, tempSelectedCount: number, tempSelectedActiveCount: number, tempOutputArtifactsCount: number } | null };

export type SweepPageQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  sweepName: Scalars['String']['input'];
}>;


export type SweepPageQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, access?: string | null, readOnly?: boolean | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, runCount: number, runCountExpected?: number | null, runTime: number, method: string, state: string, description?: string | null, config: string, createdAt: string, heartbeatAt: string, updatedAt?: string | null, controllerRunName: string, scheduler?: any | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, priorRuns: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string } }> } } | null, entity: { __typename: 'Entity', id: string, name: string, defaultAccess: string, readOnlyAdmin: boolean, privateOnly: boolean, isTeam: boolean } } | null };

export type SweepPageAgentsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  sweepName: Scalars['String']['input'];
}>;


export type SweepPageAgentsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, sweep?: { __typename: 'Sweep', id: string, agents: { __typename: 'AgentConnection', edges: Array<{ __typename: 'AgentEdge', node: { __typename: 'Agent', id: string, name: string, state?: string | null, host: string, persistent?: boolean | null, metrics: any, createdAt: string, heartbeatAt?: string | null, totalRuns: number, user?: { __typename: 'User', id: string } | null } }> } } | null } | null };

export type SweepValueDropdownQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type SweepValueDropdownQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, sweeps?: { __typename: 'SweepConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'SweepEdge', node: { __typename: 'Sweep', id: string, name: string } }> } | null } | null };

export type SweepsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONString']['input']>;
}>;


export type SweepsQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, readOnly?: boolean | null, sweeps?: { __typename: 'SweepConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename: 'SweepEdge', node: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, state: string, runCount: number, runCountExpected?: number | null, runTime: number, createdAt: string, config: string, scheduler?: any | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null } }> } | null } | null };

export type CreateArtifactCollectionTagAssignmentsMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  artifactCollectionName: Scalars['String']['input'];
  tags: Array<TagInput>;
}>;


export type CreateArtifactCollectionTagAssignmentsMutation = { __typename: 'Mutation', createArtifactCollectionTagAssignments?: { __typename: 'CreateTagsPayload', tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string }> } | null };

export type DeleteArtifactCollectionTagAssignmentsMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  artifactCollectionName: Scalars['String']['input'];
  tags: Array<TagInput>;
}>;


export type DeleteArtifactCollectionTagAssignmentsMutation = { __typename: 'Mutation', deleteArtifactCollectionTagAssignments?: { __typename: 'DeleteTagAssignmentPayload', success: boolean } | null };

export type CreateArtifactTagAssignmentsMutationVariables = Exact<{
  artifactID: Scalars['ID']['input'];
  tags: Array<TagInput>;
}>;


export type CreateArtifactTagAssignmentsMutation = { __typename: 'Mutation', createArtifactTagAssignments?: { __typename: 'CreateTagsPayload', tags: Array<{ __typename: 'Tag', id: string, name: string, tagCategoryName: string }> } | null };

export type DeleteArtifactTagAssignmentsMutationVariables = Exact<{
  artifactID: Scalars['ID']['input'];
  tags: Array<TagInput>;
}>;


export type DeleteArtifactTagAssignmentsMutation = { __typename: 'Mutation', deleteArtifactTagAssignments?: { __typename: 'DeleteTagAssignmentPayload', success: boolean } | null };

export type TeamMemberFieldsFragment = { __typename: 'Member', id?: string | null, username?: string | null, name: string, photoUrl?: string | null, role?: string | null };

export type TeamMemberDetailedRoleFragment = { __typename: 'Member', memberRole?: { __typename: 'Role', ID: string, name: string, permissions: Array<{ __typename: 'RolePermission', name: string }>, inheritedFrom?: { __typename: 'Role', ID: string, name: string, permissions: Array<{ __typename: 'RolePermission', name: string }> } | null } | null };

export type TeamMembersQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type TeamMembersQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, members: Array<{ __typename: 'Member', id?: string | null, username?: string | null, name: string, photoUrl?: string | null, role?: string | null }> } | null };

export type TeamMemberQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  memberId: Scalars['ID']['input'];
}>;


export type TeamMemberQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, member?: { __typename: 'Member', id?: string | null, username?: string | null, name: string, photoUrl?: string | null, role?: string | null, memberRole?: { __typename: 'Role', ID: string, name: string, permissions: Array<{ __typename: 'RolePermission', name: string }>, inheritedFrom?: { __typename: 'Role', ID: string, name: string, permissions: Array<{ __typename: 'RolePermission', name: string }> } | null } | null } | null } | null };

export type ContactUsForUserLedTrialMutationVariables = Exact<{
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContactUsForUserLedTrialMutation = { __typename: 'Mutation', contactUsForUserLedTrial?: { __typename: 'ContactUsForUserLedTrialPayload', clientMutationId?: string | null } | null };

export type ContactUsForComputeHoursMutationVariables = Exact<{
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContactUsForComputeHoursMutation = { __typename: 'Mutation', contactUsForComputeHours?: { __typename: 'ContactUsForComputeHoursPayload', clientMutationId?: string | null } | null };

export type UserProfileQueryVariables = Exact<{
  userName: Scalars['String']['input'];
}>;


export type UserProfileQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, profileView?: { __typename: 'View', id: string, spec?: any | null, updatedAt?: string | null, updatedBy?: { __typename: 'User', id: string, username?: string | null } | null } | null } | null };

export type UserProjectsQueryVariables = Exact<{
  userName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserProjectsQuery = { __typename: 'Query', user?: { __typename: 'User', id: string, teams?: { __typename: 'EntityConnection', edges: Array<{ __typename: 'EntityEdge', node?: { __typename: 'Entity', id: string, name: string, projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string } | null }> } | null } | null }> } | null } | null };

export type AllTeamProjectsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllTeamProjectsQuery = { __typename: 'Query', projects?: { __typename: 'ProjectConnection', edges: Array<{ __typename: 'ProjectEdge', node?: { __typename: 'Project', id: string, name: string, entityName: string, totalRuns?: number | null, lastActive?: string | null, computeHours: number } | null }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type UserReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserReportsQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, username?: string | null, views?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, createdAt: string, updatedAt?: string | null, name?: string | null, displayName?: string | null, description?: string | null, previewUrl?: string | null, spec?: any | null, viewCount: number, project?: { __typename: 'Project', id: string, name: string, entityName: string, access?: string | null } | null } | null }> } | null } | null };

export type Vega2PanelQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  fetchSingle: Scalars['Boolean']['input'];
}>;


export type Vega2PanelQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, allViews?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, spec?: any | null, updatedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null }> } | null } | null, view?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, spec?: any | null, updatedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null };

export type VegaPanelQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  fetchSingle: Scalars['Boolean']['input'];
}>;


export type VegaPanelQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, allViews?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, spec?: any | null, updatedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null }> } | null } | null, view?: { __typename: 'View', id: string, type?: string | null, name?: string | null, displayName?: string | null, description?: string | null, spec?: any | null, updatedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null };

export type ViewerApiKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerApiKeyQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, apiKey?: string | null } | null };

export type ViewerApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerApiKeysQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, apiKeys?: { __typename: 'ApiKeyConnection', edges: Array<{ __typename: 'ApiKeyEdge', node?: { __typename: 'ApiKey', id: string, name: string, createdAt?: string | null, expiresAt?: string | null, description?: string | null, apiKeyId?: string | null, organizationID?: string | null, lastUsedAt?: string | null } | null }> } | null } | null };

export type WandbConfigQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type WandbConfigQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, wandbConfig?: any | null } }> } | null } | null };

export type CoreweaveIdQueryVariables = Exact<{
  entity?: InputMaybe<Scalars['String']['input']>;
}>;


export type CoreweaveIdQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, organization?: { __typename: 'Organization', id: string, coreWeaveOrganizationId?: string | null } | null } | null };

export type CoreweaveIdByRunNameQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type CoreweaveIdByRunNameQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, organizationId?: string | null } | null, project?: { __typename: 'Project', id: string, readOnly?: boolean | null, run?: { __typename: 'Run', id: string, runInfo?: { __typename: 'RunInfo', slurm?: { __typename: 'SlurmInfo', jobId: string, metadata?: any | null } | null, coreweave?: { __typename: 'CoreweaveInfo', orgId: string, clusterName: string, region: string } | null } | null } | null } | null };

export type NodeAlertFragmentFragment = { __typename: 'NodeAlert', alertName: string, alertStatus: string, cluster: string, clusterOrg: string, description: string, grafanaDashboard: string, labels: any, node: string, pod: string, occurrences: any };

export type RunIssueQueryQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
}>;


export type RunIssueQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, nodeAlertsHistory: Array<{ __typename: 'NodeAlert', alertName: string, alertStatus: string, cluster: string, clusterOrg: string, description: string, grafanaDashboard: string, labels: any, node: string, pod: string, occurrences: any }> } | null } | null };

export type IssuesTimestampsByMetricQueryQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
  bucketedHistorySpecs: Array<Scalars['JSONString']['input']>;
}>;


export type IssuesTimestampsByMetricQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, bucketedHistory: Array<any> } | null } | null };

export type RunGrafanaDashboardQueryQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  runName: Scalars['String']['input'];
}>;


export type RunGrafanaDashboardQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, run?: { __typename: 'Run', id: string, coreweaveGrafanaDashboard: string } | null } | null };

export type PanelGenHistoryKeysQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONString']['input']>;
  runLimit?: InputMaybe<Scalars['Int']['input']>;
  runOrder?: InputMaybe<Scalars['String']['input']>;
  maxPrefixGroups?: InputMaybe<Scalars['Int']['input']>;
  maxMetricsPerGroup?: InputMaybe<Scalars['Int']['input']>;
  metricNamePattern?: InputMaybe<Scalars['String']['input']>;
  requiredPrefixes?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredRunKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredMetrics?: InputMaybe<Array<Scalars['String']['input']>>;
  lastPrefix?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PanelGenHistoryKeysQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', sectionAwareHistoryKeys?: { __typename: 'SectionAwareHistoryKeysResults', lastStep: any, matchedPrefixCount: number, groups: Array<{ __typename: 'SectionAwareHistoryKeyPrefixGroup', prefix: string, matchedCount: number, totalCount: number, metrics: Array<{ __typename: 'MetricInfo', key: string, types: Array<string>, latestType?: string | null, column: MetricColumn }> }>, typeCategorySections: Array<{ __typename: 'SectionAwareHistoryKeyTypeCategoryGroup', category: SectionAwareHistoryKeyTypeCategory, matchedCount: number, totalCount: number, hasMore: boolean, metrics: Array<{ __typename: 'MetricInfo', key: string, types: Array<string>, latestType?: string | null, column: MetricColumn }> }>, systemMetrics: Array<{ __typename: 'MetricInfo', key: string, types: Array<string>, latestType?: string | null, column: MetricColumn }> } | null } | null } | null };

export type ServerPollingOkQueryVariables = Exact<{ [key: string]: never; }>;


export type ServerPollingOkQuery = { __typename: 'Query', serverInfo?: { __typename: 'ServerInfo', pollingOK: boolean } | null };

export type RunWithoutRunInfoStateBasicFragmentFragment = { __typename: 'Run', commit?: string | null, computeSeconds: number, createdAt: string, defaultColorIndex?: number | null, displayName?: string | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, projectId: string, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null };

export type RunInfoFragmentFragment = { __typename: 'Run', runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null, codePath?: string | null, codePathLocal?: string | null } | null };

export type RunStateBasicFragmentFragment = { __typename: 'Run', commit?: string | null, computeSeconds: number, createdAt: string, defaultColorIndex?: number | null, displayName?: string | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, projectId: string, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, agent?: { __typename: 'Agent', id: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null, codePath?: string | null, codePathLocal?: string | null } | null };

export type ArtifactCountsFragmentFragment = { __typename: 'Run', inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null };

export type RunsStateQueryQueryVariables = Exact<{
  aggregationKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  enableAggregations?: InputMaybe<Scalars['Boolean']['input']>;
  enableArtifactCounts?: InputMaybe<Scalars['Boolean']['input']>;
  enableBasic?: InputMaybe<Scalars['Boolean']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableHistoryKeyInfo?: InputMaybe<Scalars['Boolean']['input']>;
  enableSampledHistory?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableSystemMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  enableTags?: InputMaybe<Scalars['Boolean']['input']>;
  enableWandb?: InputMaybe<Scalars['Boolean']['input']>;
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  sampledHistorySpecs: Array<Scalars['JSONString']['input']>;
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  wandbKeys?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type RunsStateQueryQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, projectId: string, displayName?: string | null, updatedAt?: string | null, aggregations?: any | null, config?: any | null, historyKeys?: any | null, sampledHistory?: Array<any>, summaryMetrics?: any | null, systemMetrics?: any | null, wandbConfig?: any | null, commit?: string | null, computeSeconds: number, createdAt: string, defaultColorIndex?: number | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, tags?: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null, agent?: { __typename: 'Agent', id: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null, codePath?: string | null, codePathLocal?: string | null } | null } }> } | null } | null };

export type RunsStateQueryWithProjectIdQueryVariables = Exact<{
  aggregationKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  enableAggregations?: InputMaybe<Scalars['Boolean']['input']>;
  enableArtifactCounts?: InputMaybe<Scalars['Boolean']['input']>;
  enableBasic?: InputMaybe<Scalars['Boolean']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableHistoryKeyInfo?: InputMaybe<Scalars['Boolean']['input']>;
  enableSampledHistory?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableSystemMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  enableTags?: InputMaybe<Scalars['Boolean']['input']>;
  enableWandb?: InputMaybe<Scalars['Boolean']['input']>;
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  sampledHistorySpecs: Array<Scalars['JSONString']['input']>;
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  wandbKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  internalId: Scalars['ID']['input'];
}>;


export type RunsStateQueryWithProjectIdQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', totalCount: number, edges: Array<{ __typename: 'RunEdge', node: { __typename: 'Run', id: string, name: string, projectId: string, displayName?: string | null, updatedAt?: string | null, aggregations?: any | null, config?: any | null, historyKeys?: any | null, sampledHistory?: Array<any>, summaryMetrics?: any | null, systemMetrics?: any | null, wandbConfig?: any | null, commit?: string | null, computeSeconds: number, createdAt: string, defaultColorIndex?: number | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, tags?: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null, agent?: { __typename: 'Agent', id: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null, codePath?: string | null, codePathLocal?: string | null } | null } }> } | null } | null };

export type RunsStateDeltaQuery_Dd_Dq_U_RsdqQueryVariables = Exact<{
  aggregationKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableAggregations?: InputMaybe<Scalars['Boolean']['input']>;
  enableArtifactCounts?: InputMaybe<Scalars['Boolean']['input']>;
  enableBasic?: InputMaybe<Scalars['Boolean']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableHistoryKeyInfo?: InputMaybe<Scalars['Boolean']['input']>;
  enableSampledHistory?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableSystemMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  enableTags?: InputMaybe<Scalars['Boolean']['input']>;
  enableWandb?: InputMaybe<Scalars['Boolean']['input']>;
  entityName: Scalars['String']['input'];
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  sampledHistorySpecs: Array<Scalars['JSONString']['input']>;
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  wandbKeys?: InputMaybe<Array<Scalars['String']['input']>>;
}>;


export type RunsStateDeltaQuery_Dd_Dq_U_RsdqQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', totalCount: number, delta: Array<{ __typename: 'RunDiff', index: number, op: DiffOperation, run?: { __typename: 'Run', id: string, name: string, projectId: string, displayName?: string | null, updatedAt?: string | null, aggregations?: any | null, config?: any | null, historyKeys?: any | null, sampledHistory?: Array<any>, summaryMetrics?: any | null, systemMetrics?: any | null, wandbConfig?: any | null, commit?: string | null, computeSeconds: number, createdAt: string, defaultColorIndex?: number | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, tags?: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null, agent?: { __typename: 'Agent', id: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null, codePath?: string | null, codePathLocal?: string | null } | null } | null }> } | null } | null };

export type RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQueryVariables = Exact<{
  aggregationKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  configKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  currentRuns: Array<Scalars['String']['input']>;
  enableAggregations?: InputMaybe<Scalars['Boolean']['input']>;
  enableArtifactCounts?: InputMaybe<Scalars['Boolean']['input']>;
  enableBasic?: InputMaybe<Scalars['Boolean']['input']>;
  enableConfig?: InputMaybe<Scalars['Boolean']['input']>;
  enableHistoryKeyInfo?: InputMaybe<Scalars['Boolean']['input']>;
  enableSampledHistory?: InputMaybe<Scalars['Boolean']['input']>;
  enableSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableSystemMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  enableTags?: InputMaybe<Scalars['Boolean']['input']>;
  enableWandb?: InputMaybe<Scalars['Boolean']['input']>;
  filters: Scalars['JSONString']['input'];
  groupKeys: Array<Scalars['String']['input']>;
  groupLevel: Scalars['Int']['input'];
  lastUpdated: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
  order: Scalars['String']['input'];
  sampledHistorySpecs: Array<Scalars['JSONString']['input']>;
  summaryKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  wandbKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  internalId: Scalars['ID']['input'];
}>;


export type RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runs?: { __typename: 'RunConnection', totalCount: number, delta: Array<{ __typename: 'RunDiff', index: number, op: DiffOperation, run?: { __typename: 'Run', id: string, name: string, projectId: string, displayName?: string | null, updatedAt?: string | null, aggregations?: any | null, config?: any | null, historyKeys?: any | null, sampledHistory?: Array<any>, summaryMetrics?: any | null, systemMetrics?: any | null, wandbConfig?: any | null, commit?: string | null, computeSeconds: number, createdAt: string, defaultColorIndex?: number | null, framework?: string | null, github?: string | null, group?: string | null, groupCounts?: Array<number> | null, heartbeatAt?: string | null, host?: string | null, jobType?: string | null, logLineCount?: number | null, notes?: string | null, readOnly?: boolean | null, shouldStop?: boolean | null, state?: string | null, stopped?: boolean | null, tags?: Array<{ __typename: 'RunTag', id: string, name: string, colorIndex: number }>, inputArtifacts?: { __typename: 'InputArtifactConnection', totalCount: number } | null, outputArtifacts?: { __typename: 'ArtifactConnection', totalCount: number } | null, agent?: { __typename: 'Agent', id: string, name: string } | null, sweep?: { __typename: 'Sweep', id: string, name: string, displayName?: string | null, config: string } | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null } | null, runInfo?: { __typename: 'RunInfo', gpu?: string | null, gpuCount?: number | null, codePath?: string | null, codePathLocal?: string | null } | null } | null }> } | null } | null };

export type ViewFragmentMetadata2Fragment = { __typename: 'View', id: string, name?: string | null, displayName?: string | null, type?: string | null, description?: string | null, entityName: string, previewUrl?: string | null, coverUrl?: string | null, updatedAt?: string | null, createdAt: string, starCount: number, starred?: boolean | null, parentId?: string | null, locked: boolean, viewCount: number, showcasedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null, name: string } | null, updatedBy?: { __typename: 'User', id: string, name: string, username?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, readOnly?: boolean | null } | null, alertSubscription?:
    | { __typename: 'EmailSubscription', id: string }
    | { __typename: 'SlackChannelSubscription', id: string }
   | null, accessTokens: Array<{ __typename: 'AccessToken', id: string, token: string, type: AccessTokenType, emails: Array<string>, createdAt: string, lastAccessedAt?: string | null, revokedAt?: string | null, view: { __typename: 'View', id: string }, createdBy: { __typename: 'User', id: string, username?: string | null, email?: string | null, name: string }, projects: Array<{ __typename: 'Project', id: string, name: string, entityName: string }> }> };

export type Views2MetadataQueryVariables = Exact<{
  entityName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  viewType?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
  viewName?: InputMaybe<Scalars['String']['input']>;
}>;


export type Views2MetadataQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, allViews?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, name?: string | null, displayName?: string | null, type?: string | null, description?: string | null, entityName: string, previewUrl?: string | null, coverUrl?: string | null, updatedAt?: string | null, createdAt: string, starCount: number, starred?: boolean | null, parentId?: string | null, locked: boolean, viewCount: number, showcasedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null, name: string } | null, updatedBy?: { __typename: 'User', id: string, name: string, username?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, readOnly?: boolean | null } | null, alertSubscription?:
            | { __typename: 'EmailSubscription', id: string }
            | { __typename: 'SlackChannelSubscription', id: string }
           | null, accessTokens: Array<{ __typename: 'AccessToken', id: string, token: string, type: AccessTokenType, emails: Array<string>, createdAt: string, lastAccessedAt?: string | null, revokedAt?: string | null, view: { __typename: 'View', id: string }, createdBy: { __typename: 'User', id: string, username?: string | null, email?: string | null, name: string }, projects: Array<{ __typename: 'Project', id: string, name: string, entityName: string }> }> } | null }> } | null } | null };

export type Views2ViewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type Views2ViewQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, spec?: any | null, name?: string | null, displayName?: string | null, type?: string | null, description?: string | null, entityName: string, previewUrl?: string | null, coverUrl?: string | null, updatedAt?: string | null, createdAt: string, starCount: number, starred?: boolean | null, parentId?: string | null, locked: boolean, viewCount: number, showcasedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null, name: string } | null, updatedBy?: { __typename: 'User', id: string, name: string, username?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, readOnly?: boolean | null } | null, alertSubscription?:
      | { __typename: 'EmailSubscription', id: string }
      | { __typename: 'SlackChannelSubscription', id: string }
     | null, accessTokens: Array<{ __typename: 'AccessToken', id: string, token: string, type: AccessTokenType, emails: Array<string>, createdAt: string, lastAccessedAt?: string | null, revokedAt?: string | null, view: { __typename: 'View', id: string }, createdBy: { __typename: 'User', id: string, username?: string | null, email?: string | null, name: string }, projects: Array<{ __typename: 'Project', id: string, name: string, entityName: string }> }> } | null };

export type Views2RawViewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type Views2RawViewQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, specObject?: any | null, name?: string | null, displayName?: string | null, type?: string | null, description?: string | null, entityName: string, previewUrl?: string | null, coverUrl?: string | null, updatedAt?: string | null, createdAt: string, starCount: number, starred?: boolean | null, parentId?: string | null, locked: boolean, viewCount: number, showcasedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null, name: string } | null, updatedBy?: { __typename: 'User', id: string, name: string, username?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, readOnly?: boolean | null } | null, alertSubscription?:
      | { __typename: 'EmailSubscription', id: string }
      | { __typename: 'SlackChannelSubscription', id: string }
     | null, accessTokens: Array<{ __typename: 'AccessToken', id: string, token: string, type: AccessTokenType, emails: Array<string>, createdAt: string, lastAccessedAt?: string | null, revokedAt?: string | null, view: { __typename: 'View', id: string }, createdBy: { __typename: 'User', id: string, username?: string | null, email?: string | null, name: string }, projects: Array<{ __typename: 'Project', id: string, name: string, entityName: string }> }> } | null };

export type ViewUpdatedAtQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ViewUpdatedAtQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, updatedAt?: string | null } | null };

export type NamedWorkspaceUpdateViewFieldsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NamedWorkspaceUpdateViewFieldsQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, createdAt: string, updatedAt?: string | null, user?: { __typename: 'User', id: string, name: string, username?: string | null } | null, updatedBy?: { __typename: 'User', id: string, name: string, username?: string | null } | null } | null };

export type UpsertView2MutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  spec?: InputMaybe<Scalars['String']['input']>;
  specIsGzipped?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  overridePublished?: InputMaybe<Scalars['Boolean']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  coverUrl?: InputMaybe<Scalars['String']['input']>;
  showcasedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdUsing?: InputMaybe<ViewSource>;
}>;


export type UpsertView2Mutation = { __typename: 'Mutation', upsertView?: { __typename: 'UpsertViewPayload', inserted?: boolean | null, view?: { __typename: 'View', id: string, name?: string | null, displayName?: string | null, type?: string | null, description?: string | null, entityName: string, previewUrl?: string | null, coverUrl?: string | null, updatedAt?: string | null, createdAt: string, starCount: number, starred?: boolean | null, parentId?: string | null, locked: boolean, viewCount: number, showcasedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null, name: string } | null, updatedBy?: { __typename: 'User', id: string, name: string, username?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, readOnly?: boolean | null } | null, alertSubscription?:
        | { __typename: 'EmailSubscription', id: string }
        | { __typename: 'SlackChannelSubscription', id: string }
       | null, accessTokens: Array<{ __typename: 'AccessToken', id: string, token: string, type: AccessTokenType, emails: Array<string>, createdAt: string, lastAccessedAt?: string | null, revokedAt?: string | null, view: { __typename: 'View', id: string }, createdBy: { __typename: 'User', id: string, username?: string | null, email?: string | null, name: string }, projects: Array<{ __typename: 'Project', id: string, name: string, entityName: string }> }> } | null } | null };

export type UpsertUserProfileViewMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  spec?: InputMaybe<Scalars['String']['input']>;
  specIsGzipped?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpsertUserProfileViewMutation = { __typename: 'Mutation', upsertUserProfileView?: { __typename: 'UpsertUserProfileViewPayload', inserted?: boolean | null, view?: { __typename: 'View', id: string, spec?: any | null, name?: string | null, displayName?: string | null, type?: string | null, description?: string | null, entityName: string, previewUrl?: string | null, coverUrl?: string | null, updatedAt?: string | null, createdAt: string, starCount: number, starred?: boolean | null, parentId?: string | null, locked: boolean, viewCount: number, showcasedAt?: string | null, user?: { __typename: 'User', id: string, username?: string | null, photoUrl?: string | null, admin?: boolean | null, name: string } | null, updatedBy?: { __typename: 'User', id: string, name: string, username?: string | null } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string, readOnly?: boolean | null } | null, alertSubscription?:
        | { __typename: 'EmailSubscription', id: string }
        | { __typename: 'SlackChannelSubscription', id: string }
       | null, accessTokens: Array<{ __typename: 'AccessToken', id: string, token: string, type: AccessTokenType, emails: Array<string>, createdAt: string, lastAccessedAt?: string | null, revokedAt?: string | null, view: { __typename: 'View', id: string }, createdBy: { __typename: 'User', id: string, username?: string | null, email?: string | null, name: string }, projects: Array<{ __typename: 'Project', id: string, name: string, entityName: string }> }> } | null } | null };

export type DeleteView2MutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  deleteDrafts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteView2Mutation = { __typename: 'Mutation', deleteView?: { __typename: 'DeleteViewPayload', success?: boolean | null, pendingDrafts?: boolean | null } | null };

export type DeleteViewsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']>;
  deleteDrafts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteViewsMutation = { __typename: 'Mutation', deleteViews?: { __typename: 'DeleteViewsPayload', success?: boolean | null, pendingDrafts?: boolean | null } | null };

export type StarViewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StarViewMutation = { __typename: 'Mutation', starView?: { __typename: 'StarViewPayload', view?: { __typename: 'View', id: string, starCount: number, starred?: boolean | null } | null } | null };

export type UnstarViewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnstarViewMutation = { __typename: 'Mutation', unstarView?: { __typename: 'UnstarViewPayload', view?: { __typename: 'View', id: string, starCount: number, starred?: boolean | null } | null } | null };

export type StargazersQueryQueryVariables = Exact<{
  viewID: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type StargazersQueryQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, stargazers: { __typename: 'StargazerConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'StargazerEdge', node?: { __typename: 'User', id: string, name: string, username?: string | null, userInfo?: any | null, photoUrl?: string | null } | null }> } } | null };

export type PublicViewsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublicViewsQuery = { __typename: 'Query', publicViews?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, name?: string | null, description?: string | null, user?: { __typename: 'User', id: string, username?: string | null, name: string } | null } | null }> } | null };

export type ViewDraftsQueryVariables = Exact<{
  viewID: Scalars['ID']['input'];
}>;


export type ViewDraftsQuery = { __typename: 'Query', view?: { __typename: 'View', id: string, children?: { __typename: 'ViewConnection', edges: Array<{ __typename: 'ViewEdge', node?: { __typename: 'View', id: string, displayName?: string | null, updatedAt?: string | null, entityName: string, user?: { __typename: 'User', id: string } | null, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null }> } | null } | null };

export type ViewPermissionsQueryVariables = Exact<{
  projectName: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
}>;


export type ViewPermissionsQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, isTeam: boolean, settings: { __typename: 'EntitySettings', disableMagicLinkSharing?: boolean | null, hidden: boolean } } | null, project?: { __typename: 'Project', id: string, access?: string | null } | null };

export type ViewViewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ViewViewMutation = { __typename: 'Mutation', viewView?: { __typename: 'ViewViewPayload', success?: boolean | null } | null };

export type AccountPrivilegesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type AccountPrivilegesQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, privileges: any, plan: { __typename: 'Plan', id: string, planType: PlanType } }> } | null };

export type AccountEnterpriseWeaveLimitsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type AccountEnterpriseWeaveLimitsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, weaveEnterpriseSubscription?: { __typename: 'WeaveEnterpriseSubscription', billingPeriodStart?: string | null, billingPeriodEnd?: string | null, weaveLimit?: { __typename: 'WeaveLimits', weaveLimitBytes?: any | null, weaveOverageCostCents?: number | null, weaveOverageUnit?: StorageUnit | null } | null } | null } | null };

export type AccountSubscriptionPlansQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type AccountSubscriptionPlansQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, plan: { __typename: 'Plan', id: string, planType: PlanType, name: string } }> } | null };

export type UserDynamicConfigQueryVariables = Exact<{
  configId: Scalars['String']['input'];
}>;


export type UserDynamicConfigQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, dynamicConfig?: { __typename: 'DynamicConfig', value: any } | null } | null };

export type EntityDynamicConfigQueryVariables = Exact<{
  configId: Scalars['String']['input'];
  entityName: Scalars['String']['input'];
}>;


export type EntityDynamicConfigQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, dynamicConfig?: { __typename: 'DynamicConfig', value: any } | null } | null };

export type OrganizationDyamicConfigQueryVariables = Exact<{
  configId: Scalars['String']['input'];
  orgName: Scalars['String']['input'];
}>;


export type OrganizationDyamicConfigQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, orgType: OrgType, dynamicConfig?: { __typename: 'DynamicConfig', value: any } | null } | null };

export type ViewerOrganizationsDynamicConfigQueryVariables = Exact<{
  configId: Scalars['String']['input'];
}>;


export type ViewerOrganizationsDynamicConfigQuery = { __typename: 'Query', viewer?: { __typename: 'User', id: string, organizations: Array<{ __typename: 'Organization', id: string, name: string, dynamicConfig?: { __typename: 'DynamicConfig', value: any } | null }> } | null };

export type TeamOrgQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
}>;


export type TeamOrgQuery = { __typename: 'Query', entity?: { __typename: 'Entity', id: string, name: string, organization?: { __typename: 'Organization', id: string, name: string } | null } | null };

export type ProjectRsaReadGateFragment = { __typename: 'Project', id: string, runStoreAcceleratorReadEnabled: boolean };

export type ProjectRunStoreAcceleratorReadEnabledQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type ProjectRunStoreAcceleratorReadEnabledQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, runStoreAcceleratorReadEnabled: boolean } | null };

export type PinnedRunsProjectLookupQueryVariables = Exact<{
  pinnedRunIds: Array<Scalars['ID']['input']>;
  order: Scalars['String']['input'];
}>;


export type PinnedRunsProjectLookupQuery = { __typename: 'Query', pinnedRuns: { __typename: 'RunsResult', runs: Array<{ __typename: 'Run', id: string, name: string, project?: { __typename: 'Project', id: string, internalId: string, name: string, entityName: string } | null }> } };

export type BillingPeriodSubscriptionsQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type BillingPeriodSubscriptionsQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, createdAt: string, subscriptions: Array<{ __typename: 'OrganizationSubscription', id: string, billingPeriodStart?: string | null, billingPeriodEnd?: string | null, subscriptionType: OrganizationSubscriptionType, plan: { __typename: 'Plan', id: string, name: string, planType: PlanType } }>, inferenceEnterpriseSubscription?: { __typename: 'InferenceEnterpriseSubscription', billingPeriodStart: string, billingPeriodEnd: string, inferenceLimit: any } | null, sandboxesEnterpriseSubscription?: { __typename: 'SandboxesEnterpriseSubscription', billingPeriodStart: string, billingPeriodEnd: string, sandboxesLimit: any } | null } | null };

export type EntityDeletedProjectsQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EntityDeletedProjectsQuery = { __typename: 'Query', entityDeletedProjects: Array<{ __typename: 'DeletedProjectInfo', id: string, name: string, storageKey: string, entityName: string, createdAt: string, deletedAt: string }> };

export type UndeleteProjectMutationVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UndeleteProjectMutation = { __typename: 'Mutation', undeleteProject?: { __typename: 'UndeleteProjectPayload', success: boolean, nameRestored: boolean, runsRestored: number, artifactCollectionsRestored: number, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null };

export type UndeleteProjectByIdMutationVariables = Exact<{
  projectID: Scalars['ID']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UndeleteProjectByIdMutation = { __typename: 'Mutation', undeleteProjectByID?: { __typename: 'UndeleteProjectPayload', success: boolean, nameRestored: boolean, runsRestored: number, artifactCollectionsRestored: number, project?: { __typename: 'Project', id: string, name: string, entityName: string } | null } | null };

export type OrganizationSubscriptionUpdateAdditionalInfoQueryVariables = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type OrganizationSubscriptionUpdateAdditionalInfoQuery = { __typename: 'Query', organization?: { __typename: 'Organization', id: string, weaveEnterpriseSubscription?: { __typename: 'WeaveEnterpriseSubscription', billingPeriodStart?: string | null, billingPeriodEnd?: string | null } | null, inferenceEnterpriseSubscription?: { __typename: 'InferenceEnterpriseSubscription', billingPeriodStart: string, billingPeriodEnd: string, inferenceLimit: any } | null, sandboxesEnterpriseSubscription?: { __typename: 'SandboxesEnterpriseSubscription', billingPeriodStart: string, billingPeriodEnd: string, sandboxesLimit: any } | null } | null };

export type FetchLorasQueryVariables = Exact<{
  entityName: Scalars['String']['input'];
  projectName: Scalars['String']['input'];
}>;


export type FetchLorasQuery = { __typename: 'Query', project?: { __typename: 'Project', id: string, artifactType?: { __typename: 'ArtifactType', id: string, artifactCollections?: { __typename: 'ArtifactCollectionConnection', edges: Array<{ __typename: 'ArtifactCollectionEdge', node?:
            | { __typename: 'ArtifactPortfolio', id: string, name: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, versionIndex?: number | null, metadata?: any | null } }> } }
            | { __typename: 'ArtifactSequence', id: string, name: string, artifacts: { __typename: 'VersionedArtifactConnection', edges: Array<{ __typename: 'VersionedArtifactEdge', node: { __typename: 'Artifact', id: string, versionIndex?: number | null, metadata?: any | null } }> } }
           | null }> } | null } | null } | null };

export const GraphDataFragmentFragmentDoc = gql`
    fragment GraphDataFragment on ArtifactLineageDag {
  artifacts {
    id
    artifactNodeID
    entityName
    projectName
    artifactTypeName
    artifactSequenceName
    artifactCommitHash
    versionIndex
  }
  runs {
    runNodeID
    entityName
    projectName
    runName
    displayName
    jobType
  }
  clusters {
    id
    nodeType
    runNodes {
      runNodeID
      entityName
      projectName
      runName
      displayName
      jobType
    }
    artifactNodes {
      id
      artifactNodeID
      entityName
      projectName
      artifactTypeName
      artifactSequenceName
      artifactCommitHash
      versionIndex
    }
    clusterEdges {
      edgeID
      artifactNodeID
      runNodeID
      clusterNodeID
      direction
    }
  }
  edges {
    edgeID
    artifactNodeID
    runNodeID
    clusterNodeID
    direction
  }
  hitLimit
}
    `;
export const ProjectScopeFragmentFragmentDoc = gql`
    fragment ProjectScopeFragment on Project {
  id
  name
  entityName
}
    `;
export const ArtifactSequenceScopeFragmentFragmentDoc = gql`
    fragment ArtifactSequenceScopeFragment on ArtifactSequence {
  id
  name
  defaultArtifactType {
    id
    name
  }
  project {
    ...ProjectScopeFragment
  }
}
    ${ProjectScopeFragmentFragmentDoc}`;
export const ArtifactPortfolioScopeFragmentFragmentDoc = gql`
    fragment ArtifactPortfolioScopeFragment on ArtifactPortfolio {
  id
  name
  defaultArtifactType {
    id
    name
  }
  project {
    ...ProjectScopeFragment
  }
}
    ${ProjectScopeFragmentFragmentDoc}`;
export const EntityScopeFragmentFragmentDoc = gql`
    fragment EntityScopeFragment on Entity {
  id
  name
  isTeam
}
    `;
export const TriggerScopeFragmentFragmentDoc = gql`
    fragment TriggerScopeFragment on TriggerScope {
  __typename
  ... on Project {
    ...ProjectScopeFragment
  }
  ... on ArtifactSequence {
    ...ArtifactSequenceScopeFragment
  }
  ... on ArtifactPortfolio {
    ...ArtifactPortfolioScopeFragment
  }
  ... on Entity {
    ...EntityScopeFragment
  }
}
    ${ProjectScopeFragmentFragmentDoc}
${ArtifactSequenceScopeFragmentFragmentDoc}
${ArtifactPortfolioScopeFragmentFragmentDoc}
${EntityScopeFragmentFragmentDoc}`;
export const EventDetailsFragmentFragmentDoc = gql`
    fragment EventDetailsFragment on TriggerEventDetails {
  ... on ArtifactEventDetails {
    artifactMetadata
    artifactVersionIndex
    artifactCollectionName
    projectName
    entityName
  }
  ... on ArtifactAliasEventDetails {
    artifactMetadata
    artifactVersionIndex
    artifactCollectionName
    projectName
    entityName
    alias
  }
  ... on ArtifactTagEventDetails {
    artifactMetadata
    artifactVersionIndex
    artifactCollectionName
    projectName
    entityName
    tag
  }
  ... on CollectionTagEventDetails {
    artifactCollectionName
    projectName
    entityName
    tag
  }
  ... on RunMetricEventDetails {
    runName
    projectName
    entityName
    metricName
    metricValues
  }
  ... on RunStateEventDetails {
    runName
    projectName
    entityName
    newRunState
  }
}
    `;
export const ActionDetailsFragmentFragmentDoc = gql`
    fragment ActionDetailsFragment on TriggerActionDetails {
  ... on QueueJobActionArgs {
    runSpec
    priority
  }
  ... on SlackNotificationActionArgs {
    integration {
      id
      channelName
    }
    title
    text
    titleURL
    severity
  }
  ... on GenericWebhookActionArgs {
    integration {
      id
      name
      urlEndpoint
      accessTokenRef
      secretRef
      createdAt
    }
    requestPayload
  }
  ... on PushNotificationActionArgs {
    user {
      id
      username
    }
    title
    body
  }
  ... on ARIAActionArgs {
    prompt
  }
}
    `;
export const ResultDetailsFragmentFragmentDoc = gql`
    fragment ResultDetailsFragment on TriggerResultDetails {
  ... on DefaultTriggerResultDetails {
    error {
      message
    }
  }
  ... on QueuedJobTriggerResultDetails {
    error {
      message
    }
    runQueueItemID
  }
  ... on HttpTriggerResultDetails {
    error {
      message
    }
    status
    statusCode
    body
  }
  ... on PushNotificationTriggerResultDetails {
    error {
      message
    }
    successCount
    failureCount
  }
}
    `;
export const TriggerExecutionFragmentFragmentDoc = gql`
    fragment TriggerExecutionFragment on TriggerExecution {
  id
  state
  createdAt
  updatedAt
  triggerID
  triggerName
  scope {
    ...TriggerScopeFragment
  }
  event {
    eventType
    data {
      ...EventDetailsFragment
    }
  }
  action {
    actionType
    data {
      ...ActionDetailsFragment
    }
  }
  result {
    resultType
    data {
      ...ResultDetailsFragment
    }
  }
  actionStartedAt
  actionDuration
}
    ${TriggerScopeFragmentFragmentDoc}
${EventDetailsFragmentFragmentDoc}
${ActionDetailsFragmentFragmentDoc}
${ResultDetailsFragmentFragmentDoc}`;
export const TriggeringConditionFragmentFragmentDoc = gql`
    fragment TriggeringConditionFragment on TriggeringCondition {
  __typename
  ... on FilterEventTriggeringCondition {
    eventType
    filter
  }
}
    `;
export const TriggeredActionFragmentFragmentDoc = gql`
    fragment TriggeredActionFragment on TriggeredAction {
  __typename
  ... on QueueJobTriggeredAction {
    queue {
      id
      name
    }
    template
    readOnly
  }
  ... on NotificationTriggeredAction {
    integration {
      id
      ... on SlackIntegration {
        channelName
      }
    }
    title
    message
    severity
    entityName
    readOnly
  }
  ... on GenericWebhookTriggeredAction {
    integration {
      __typename
      ... on GenericWebhookIntegration {
        id
        name
        urlEndpoint
        accessTokenRef
        secretRef
        createdAt
      }
    }
    entityName
    requestPayload
    readOnly
  }
  ... on PushNotificationTriggeredAction {
    user {
      id
      username
    }
    title
    body
    readOnly
  }
  ... on ARIATriggeredAction {
    prompt
    readOnly
  }
  ... on NoOpTriggeredAction {
    readOnly
  }
}
    `;
export const TriggerFragmentFragmentDoc = gql`
    fragment TriggerFragment on Trigger {
  id
  name
  createdAt
  updatedAt
  enabled
  createdBy {
    id
    name
  }
  description
  readOnly
  lastExecutedAt
  scope {
    ...TriggerScopeFragment
  }
  triggeringCondition {
    ...TriggeringConditionFragment
  }
  triggeredAction {
    ...TriggeredActionFragment
  }
}
    ${TriggerScopeFragmentFragmentDoc}
${TriggeringConditionFragmentFragmentDoc}
${TriggeredActionFragmentFragmentDoc}`;
export const NotebookTable_NotebookFragmentDoc = gql`
    fragment NotebookTable_Notebook on Notebook {
  id
  name
  author {
    id
    name
    photoUrl
  }
  lastUpdated
  project {
    id
    entityName
    name
  }
  viewerPermissions
  currentVersion {
    artifactTypeName
    artifactCollectionName
    versionIndex
    sourceFileName
  }
}
    `;
export const ProjectListFragmentDoc = gql`
    fragment ProjectList on Project {
  name
  access
  entityName
  totalRuns: runCount
  createdAt
  lastActive
  entity {
    id
    entityType
  }
}
    `;
export const LinePlotRunFragmentFragmentDoc = gql`
    fragment LinePlotRunFragment on Run {
  commit
  createdAt
  heartbeatAt
  defaultColorIndex
  displayName
  group
  groupCounts
  host
  jobType
  project {
    id
    entityName
    name
  }
  projectId
  state
  stopped
  sweep {
    id
    name
    displayName
    config
  }
  user {
    id
    username
    photoUrl
  }
}
    `;
export const BackendLinesDeltasFragmentFragmentDoc = gql`
    fragment BackendLinesDeltasFragment on BucketDiffs {
  order
  incomplete
  delta {
    op
    run {
      ...LinePlotRunFragment
      config(keys: $configKeys) @include(if: $enableConfig)
      defaultColorIndex
      displayName
      id
      lines(
        specs: $bucketedHistorySpecs
        excludeOutliers: $excludeOutliers
        primaryLineType: $primaryLineType
      )
      name
      projectId
      summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
      updatedAt
    }
  }
}
    ${LinePlotRunFragmentFragmentDoc}`;
export const BackendLinesRunDeltasFragmentFragmentDoc = gql`
    fragment BackendLinesRunDeltasFragment on RunConnection {
  deltas(currentRuns: $currentRuns, lastUpdated: $lastUpdated, timeout: $timeout) {
    ...BackendLinesDeltasFragment
  }
}
    ${BackendLinesDeltasFragmentFragmentDoc}`;
export const BackendLinesDeltaQueryFragmentFragmentDoc = gql`
    fragment BackendLinesDeltaQueryFragment on Project {
  entityName
  name
  runs(
    first: $limit
    order: $order
    filters: $filters
    groupKeys: $groupKeys
    groupLevel: $groupLevel
  ) {
    ...BackendLinesRunDeltasFragment
  }
}
    ${BackendLinesRunDeltasFragmentFragmentDoc}`;
export const BackendLinesDeltaQueryLegacyFragmentFragmentDoc = gql`
    fragment BackendLinesDeltaQueryLegacyFragment on Project {
  entityName
  name
  pinnedRuns: runs(filters: $pinnedRunFilters, first: $pinnedRunsLimit) @include(if: $includePinnedRuns) {
    ...BackendLinesRunDeltasFragment
  }
  runs(
    first: $limit
    order: $order
    filters: $filters
    groupKeys: $groupKeys
    groupLevel: $groupLevel
  ) {
    ...BackendLinesRunDeltasFragment
  }
}
    ${BackendLinesRunDeltasFragmentFragmentDoc}`;
export const BucketedHistoryDeltasFragmentFragmentDoc = gql`
    fragment BucketedHistoryDeltasFragment on BucketDiffs {
  order
  incomplete
  delta {
    op
    run {
      ...LinePlotRunFragment
      bucketedHistory(
        specs: $bucketedHistorySpecs
        packVersion: 1
        excludeOutliers: $excludeOutliers
        primaryLineType: $primaryLineType
      )
      config(keys: $configKeys) @include(if: $enableConfig)
      defaultColorIndex
      displayName
      id
      name
      projectId
      summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
      updatedAt
    }
  }
}
    ${LinePlotRunFragmentFragmentDoc}`;
export const RunDeltasFragmentFragmentDoc = gql`
    fragment RunDeltasFragment on RunConnection {
  deltas(currentRuns: $currentRuns, lastUpdated: $lastUpdated, timeout: $timeout) {
    ...BucketedHistoryDeltasFragment
  }
}
    ${BucketedHistoryDeltasFragmentFragmentDoc}`;
export const DeltaQueryFragmentWithoutRunInfoFragmentDoc = gql`
    fragment DeltaQueryFragmentWithoutRunInfo on Project {
  entityName
  name
  runs(
    first: $limit
    order: $order
    filters: $filters
    groupKeys: $groupKeys
    groupLevel: $groupLevel
  ) {
    ...RunDeltasFragment
  }
}
    ${RunDeltasFragmentFragmentDoc}`;
export const DeltaQueryLegacyFragmentWithoutRunInfoFragmentDoc = gql`
    fragment DeltaQueryLegacyFragmentWithoutRunInfo on Project {
  entityName
  name
  pinnedRuns: runs(filters: $pinnedRunFilters, first: $pinnedRunsLimit) @include(if: $includePinnedRuns) {
    ...RunDeltasFragment
  }
  runs(
    first: $limit
    order: $order
    filters: $filters
    groupKeys: $groupKeys
    groupLevel: $groupLevel
  ) {
    ...RunDeltasFragment
  }
}
    ${RunDeltasFragmentFragmentDoc}`;
export const GroupedBackendLinesDeltaQueryFragmentFragmentDoc = gql`
    fragment GroupedBackendLinesDeltaQueryFragment on Project {
  entityName
  name
  groupedRuns(
    first: $limit
    order: $order
    filters: $filters
    groupKeys: $groupKeys
    groupLevel: $groupLevel
    groupingDepth: $groupingDepth
    selections: $selections
    stabilizeRunGroups: $stabilizeRunGroups
    expressions: $expressions
    maxGroups: $maxGroups
  ) {
    ... on GroupedRunConnection {
      deltas(currentRuns: $currentRuns, lastUpdated: $lastUpdated, timeout: $timeout) {
        order
        incomplete
        delta {
          op
          groupedRun {
            lines(
              specs: $bucketedHistorySpecs
              excludeOutliers: $excludeOutliers
              primaryLineType: $primaryLineType
            )
            createdAt
            config(keys: $configKeys) @include(if: $enableConfig)
            defaultColorIndex
            displayName
            id
            name
            projectId
            totalRuns
            includedRuns
            summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
            updatedAt
            group
            jobType
            state
            host
            sweep {
              id
              name
              displayName
              config
            }
            user {
              id
              username
              photoUrl
            }
          }
        }
      }
    }
    ... on RunConnection {
      deltas(currentRuns: $currentRuns, lastUpdated: $lastUpdated, timeout: $timeout) {
        order
        incomplete
        delta {
          op
          run {
            ...LinePlotRunFragment
            config(keys: $configKeys) @include(if: $enableConfig)
            defaultColorIndex
            displayName
            id
            lines(
              specs: $bucketedHistorySpecs
              excludeOutliers: $excludeOutliers
              primaryLineType: $primaryLineType
            )
            name
            projectId
            summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
            updatedAt
          }
        }
      }
    }
  }
}
    ${LinePlotRunFragmentFragmentDoc}`;
export const GroupedDeltaQueryFragmentWithoutRunInfoFragmentDoc = gql`
    fragment GroupedDeltaQueryFragmentWithoutRunInfo on Project {
  groupedRuns(
    first: $limit
    order: $order
    filters: $filters
    groupKeys: $groupKeys
    groupLevel: $groupLevel
    groupingDepth: $groupingDepth
    selections: $selections
    stabilizeRunGroups: $stabilizeRunGroups
    expressions: $expressions
    maxGroups: $maxGroups
  ) {
    __typename
    ... on GroupedRunConnection {
      deltas(currentRuns: $currentRuns, lastUpdated: $lastUpdated, timeout: $timeout) {
        order
        incomplete
        delta {
          op
          groupedRun {
            bucketedHistory(
              specs: $bucketedHistorySpecs
              packVersion: 1
              excludeOutliers: $excludeOutliers
              primaryLineType: $primaryLineType
            )
            createdAt
            config(keys: $configKeys) @include(if: $enableConfig)
            defaultColorIndex
            displayName
            id
            name
            projectId
            totalRuns
            includedRuns
            summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
            updatedAt
            group
            jobType
            state
            host
            sweep {
              id
              name
              displayName
              config
            }
            user {
              id
              username
              photoUrl
            }
          }
        }
      }
    }
    ... on RunConnection {
      deltas(currentRuns: $currentRuns, lastUpdated: $lastUpdated, timeout: $timeout) {
        order
        incomplete
        delta {
          op
          run {
            ...LinePlotRunFragment
            bucketedHistory(
              specs: $bucketedHistorySpecs
              packVersion: 1
              excludeOutliers: $excludeOutliers
              primaryLineType: $primaryLineType
            )
            config(keys: $configKeys) @include(if: $enableConfig)
            defaultColorIndex
            displayName
            id
            name
            projectId
            summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
            updatedAt
          }
        }
      }
    }
  }
}
    ${LinePlotRunFragmentFragmentDoc}`;
export const ProjectPicker_ProjectFragmentDoc = gql`
    fragment ProjectPicker_Project on Project {
  id
  internalId
  name
  entityName
  createdAt
}
    `;
export const ModelRegistryMigrationConfigFragmentFragmentDoc = gql`
    fragment ModelRegistryMigrationConfigFragment on ModelRegistryMigrationConfig {
  blockWritesLegacyModelRegistry
  blockWritesMigratedModelRegistry
  migrationCompletedAt
  orgRegistryProject {
    id
    name
    entityName
  }
}
    `;
export const OrganizationMemberFragmentFragmentDoc = gql`
    fragment OrganizationMemberFragment on OrganizationMember {
  orgID
  user {
    id
    accountType
    admin
  }
  admin
  username
  name
  id
  email
  photoUrl
  role
  modelsSeat
}
    `;
export const RegistrySearchCollectionFragmentFragmentDoc = gql`
    fragment registrySearchCollectionFragment on ArtifactCollection {
  __typename
  ... on ArtifactPortfolio {
    id
    name
    description
    createdAt
    updatedAt
    defaultArtifactType {
      id
      name
    }
    project {
      id
      name
      entityName
      protectedArtifactAliases {
        alias
      }
      icon {
        name
        color
      }
    }
    tags {
      edges {
        node {
          id
          name
          tagCategoryName
          attributes
        }
      }
    }
  }
  __typename
  ... on ArtifactSequence {
    id
    name
    description
    createdAt
    updatedAt
    defaultArtifactType {
      id
      name
    }
    project {
      id
      name
      entityName
      protectedArtifactAliases {
        alias
      }
      icon {
        name
        color
      }
    }
    tags {
      edges {
        node {
          id
          name
          tagCategoryName
          attributes
        }
      }
    }
  }
}
    `;
export const RegistrySearchArtifactMembershipsFragmentFragmentDoc = gql`
    fragment registrySearchArtifactMembershipsFragment on ArtifactCollectionMembership {
  ... on ArtifactCollectionMembership {
    id
    versionIndex
    createdAt
    aliases {
      id
      alias
    }
    artifact {
      id
      tags {
        id
        name
        tagCategoryName
        attributes
      }
      metadata
      size
      usedCount
    }
  }
}
    `;
export const RegistrySearchResultFragmentFragmentDoc = gql`
    fragment registrySearchResultFragment on ArtifactCollectionSearchConnection {
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
  edges {
    artifactMatch
    lastUpdatedAt
    cursor
    node {
      ...registrySearchCollectionFragment
    }
    artifactMemberships {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...registrySearchArtifactMembershipsFragment
        }
      }
    }
  }
}
    ${RegistrySearchCollectionFragmentFragmentDoc}
${RegistrySearchArtifactMembershipsFragmentFragmentDoc}`;
export const ProjectInfoFragmentFragmentDoc = gql`
    fragment ProjectInfoFragment on Project {
  id
  name
  entity {
    id
    name
  }
}
    `;
export const RegistryCollectionFragmentFragmentDoc = gql`
    fragment RegistryCollectionFragment on ArtifactCollection {
  __typename
  id
  name
  description
  createdAt
  project {
    ...ProjectInfoFragment
  }
  artifactType: defaultArtifactType {
    id
    name
  }
}
    ${ProjectInfoFragmentFragmentDoc}`;
export const RegistryCollectionWithDetailsFragmentFragmentDoc = gql`
    fragment RegistryCollectionWithDetailsFragment on ArtifactCollection {
  __typename
  id
  name
  description
  createdAt
  updatedAt
  project {
    id
    name
    entity {
      id
      name
    }
    protectedArtifactAliases {
      alias
    }
    icon {
      name
      color
    }
  }
  artifactType: defaultArtifactType {
    id
    name
  }
  tags {
    edges {
      node {
        id
        name
        tagCategoryName
        attributes
      }
    }
  }
}
    `;
export const PageInfoFragmentFragmentDoc = gql`
    fragment PageInfoFragment on PageInfo {
  __typename
  endCursor
  hasNextPage
}
    `;
export const RegistryHuggingFaceImportFieldsFragmentDoc = gql`
    fragment RegistryHuggingFaceImportFields on RegistryHuggingFaceImport {
  id
  state
  hfRepoId
  hfRequestedRevision
  artifactCollectionName
  registryCollectionName
  errorMessage
  createdAt
  terminalAt
  entity {
    id
    name
  }
  project {
    id
    name
  }
  registryProject {
    id
    name
    entityName
    icon {
      name
      color
    }
  }
  sandboxId
}
    `;
export const ArtifactMembershipFragmentFragmentDoc = gql`
    fragment ArtifactMembershipFragment on ArtifactCollectionMembership {
  id
  versionIndex
  createdAt
  aliases {
    id
    alias
  }
  artifact {
    id
    size
    artifactCreatedAt: createdAt
    tags {
      id
      name
      tagCategoryName
      attributes
    }
    usedCount
  }
  artifactCollection {
    id
    name
    defaultArtifactType {
      id
      name
    }
    project {
      id
      name
      entityName
      icon {
        name
        color
      }
    }
  }
}
    `;
export const RegistryModelDeploymentFieldsFragmentDoc = gql`
    fragment RegistryModelDeploymentFields on RegistryModelDeployment {
  id
  name
  registryVersionIndex
  registryCollectionId
  registryMembershipId
  engine
  spec
  endpointUrl
  desiredState
  state
  phase
  terminalAt
  createdAt
  updatedAt
  createdBy {
    id
    name
  }
  sandboxWorkloads {
    edges {
      node {
        id
        seq
        state
        providerId
        createdAt
        terminalAt
        lastErrorCode
        lastErrorMessage
      }
    }
  }
}
    `;
export const ProjectFragmentFragmentDoc = gql`
    fragment ProjectFragment on Project {
  internalId
  name
  user {
    id
    name
    photoUrl
  }
  entityName
  access
  createdAt
  lastActive
  updatedAt
  description
  totalArtifactCollections(collectionTypes: [PORTFOLIO])
  artifactTypes(includeAll: true) {
    edges {
      node {
        id
        name
      }
    }
  }
  allowAllArtifactTypesInRegistry
  protectedArtifactAliases {
    alias
  }
  icon {
    name
    color
  }
}
    `;
export const RegistryProjectsSearchFragmentFragmentDoc = gql`
    fragment RegistryProjectsSearchFragment on ProjectConnection {
  pageInfo {
    hasNextPage
    startCursor
    endCursor
  }
  edges {
    node {
      id
      ...ProjectFragment
    }
  }
}
    ${ProjectFragmentFragmentDoc}`;
export const ArtifactUsageLimitStatusFieldsFragmentDoc = gql`
    fragment ArtifactUsageLimitStatusFields on ArtifactUsageLimitStatus {
  current
  projected
  limit
  band
}
    `;
export const ImportPanelMenuEntityFragmentFragmentDoc = gql`
    fragment ImportPanelMenuEntityFragment on Entity {
  id
  name
  projects(order: "-created_at", first: 10000, pattern: $projectSearchQuery) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;
export const ImportPanelProjectViewsFragmentFragmentDoc = gql`
    fragment ImportPanelProjectViewsFragment on View {
  id
  name
  user {
    id
    username
  }
}
    `;
export const ReportsTableFragmentFragmentDoc = gql`
    fragment ReportsTableFragment on View {
  id
  displayName
  description
  user {
    id
    username
    photoUrl
    admin
  }
  project {
    id
    name
    entityName
    access
  }
  starCount
  createdAt
  updatedAt
  starred
  showcasedAt
  previewUrl
  viewCount
}
    `;
export const ReproduceRun_FileFragmentDoc = gql`
    fragment ReproduceRun_File on File {
  id
  name
  url(upload: false)
}
    `;
export const ReproduceRun_RunFragmentDoc = gql`
    fragment ReproduceRun_Run on Run {
  id
  name
  displayName
  project {
    id
    name
    entityName
  }
  runInfo {
    args
    codePath
    codePathLocal
    executable
    git {
      remote
      commit
    }
    os
    program
    python
  }
  reproduceRunFiles: files(pattern: "diff%.patch") {
    edges {
      node {
        ...ReproduceRun_File
      }
    }
  }
}
    ${ReproduceRun_FileFragmentDoc}`;
export const RunFiles_FileFragmentDoc = gql`
    fragment RunFiles_File on File {
  id
  name
  url(upload: false)
  sizeBytes
  updatedAt
  artifact {
    id
    digest
  }
}
    `;
export const RunFiles_DirectUrlFragmentDoc = gql`
    fragment RunFiles_DirectUrl on File {
  id
  name
  directUrl
}
    `;
export const RunsTableFragmentFragmentDoc = gql`
    fragment RunsTableFragment on Run {
  id
  name
  displayName
  state
  createdAt
  heartbeatAt
  updatedAt
  notes
  user {
    id
    username
    name
    accountType
  }
  project {
    id
    name
    entityName
  }
  groupCounts
  tags: tagColors {
    id
    name
    colorIndex
  }
}
    `;
export const SandboxFieldsFragmentDoc = gql`
    fragment SandboxFields on Sandbox {
  sandboxId
  displayName
  sourceTemplateId
  sourceTemplateRevision
  spec {
    tags
    mode
    runtimeClass
  }
  status {
    state
    stateReason
    createTime
    startTime
    endTime
    runnerId
    runnerGroupId
    effectiveRuntimeClass
    resourceUsage {
      cpuMillicores
      memoryMb
      gpuCount
    }
    services {
      name
      port
      url
      protocol
      visibility
      endpoint {
        kind
        auth
        url
      }
    }
    effectiveIngress {
      cidr {
        cidr
        except
      }
      tenant
      any
      ports {
        protocol
        port
        endPort
      }
    }
    effectiveEgress {
      cidr {
        cidr
        except
      }
      dnsName
      tenant
      any
      ports {
        protocol
        port
        endPort
      }
    }
  }
}
    `;
export const FileSystemSnapshotFieldsFragmentDoc = gql`
    fragment FileSystemSnapshotFields on FileSystemSnapshot {
  fileSystemSnapshotId
  state
  stateReason
  sizeBytes
  sourceSandboxId
  trigger
  createTime
  completeTime
  sourceVolumeName
  updatedAt
}
    `;
export const NotebookFragmentFragmentDoc = gql`
    fragment NotebookFragment on Notebook {
  id
  name
  author {
    id
    name
  }
  lastUpdated
}
    `;
export const NotebookPermissionsFragmentFragmentDoc = gql`
    fragment NotebookPermissionsFragment on Notebook {
  id
  viewerPermissions
}
    `;
export const SemanticLegendWithCategoricalConfigFragmentFragmentDoc = gql`
    fragment SemanticLegendWithCategoricalConfigFragment on View {
  id
  semanticLegend {
    currentMetric
    semanticLegendsByMetric {
      metricName
      yValue
      customColors {
        bucketNumber
        colorHex
      }
      bucketUpperBounds
      excludedRunColor
      lastUpdatedAt
      categories
    }
  }
}
    `;
export const EntityRateLimitsFragmentDoc = gql`
    fragment EntityRateLimits on Entity {
  rateLimits {
    graphql
    sdkGraphql
    filestreamCount
    filestreamPerRunCount
    filestreamSize
    runUpdateCount
    sdkGraphqlQuerySeconds
    createArtifacts
    createArtifactsRequestCount
    createArtifactsCollectionRequestCount
    createArtifactsTimeWindow
  }
}
    `;
export const ProjectRateLimitsFragmentDoc = gql`
    fragment ProjectRateLimits on Project {
  rateLimits {
    filestreamCount
    filestreamPerRunCount
    filestreamSize
    runUpdateCount
    sdkGraphqlQuerySeconds
    createArtifacts
    createArtifactsRequestCount
    createArtifactsCollectionRequestCount
    createArtifactsTimeWindow
  }
}
    `;
export const CustomChartFragmentFragmentDoc = gql`
    fragment CustomChartFragment on CustomChart {
  id
  name
  displayName
  entity {
    id
    name
    readOnly
  }
  user {
    id
    username
  }
  spec
  access
}
    `;
export const ArtifactNodeFragmentDoc = gql`
    fragment ArtifactNode on ArtifactSequenceStorageNode {
  id
  name
  size
  artifactType {
    id
    name
  }
  artifactSequenceID
}
    `;
export const RunNodeFragmentDoc = gql`
    fragment RunNode on RunStorageNode {
  id
  name
  size
  runID
}
    `;
export const GetEmails_UserFragmentDoc = gql`
    fragment GetEmails_User on User {
  id
  emails {
    id
    emailAddress
    type
    createdAt
    verified
    identities {
      id
      emailIdentityVerified
      provider
    }
  }
}
    `;
export const OrganizationSubscriptionBasicInfoFragmentDoc = gql`
    fragment OrganizationSubscriptionBasicInfo on Organization {
  name
  orgType
  memberCount
  subscriptions {
    id
    subscriptionType
    plan {
      id
      name
      planType
    }
  }
}
    `;
export const AccountProjectFragmentFragmentDoc = gql`
    fragment AccountProjectFragment on Project {
  id
  name
  entityName
  access
  totalRuns
  createdAt
  lastActive
  description
  user {
    id
    username
  }
}
    `;
export const ProjectMemberFieldsFragmentDoc = gql`
    fragment ProjectMemberFields on ProjectMember {
  id
  name
  username
  email
  photoUrl
  accountType
  projectRoleIsInherited
  role {
    ID
    name
    inheritedFrom {
      permissions {
        name
      }
    }
    permissions {
      name
    }
  }
}
    `;
export const RunQueueItemFragmentFragmentDoc = gql`
    fragment RunQueueItemFragment on RunQueueItem {
  id
  createdAt
  updatedAt
  runSpec
  state
  associatedRunId
  launchAgentId
  priority
  templateVariableValues
}
    `;
export const BasicRunFragmentFragmentDoc = gql`
    fragment BasicRunFragment on Run {
  id
  readOnly
  framework
  displayName
  notes
  github
  group
  jobType
  createdAt
  heartbeatAt
  commit
  host
  state
  shouldStop
  groupCounts
  stopped
  defaultColorIndex
  sweep {
    id
    name
    displayName
  }
  agent {
    id
    name
  }
  user {
    id
    username
    photoUrl
  }
  tags: tagColors {
    id
    name
    colorIndex
  }
  runInfo {
    gpuCount
    gpu
  }
}
    `;
export const DetailedRunFragmentFragmentDoc = gql`
    fragment DetailedRunFragment on Run {
  history
  events
  fileCount
  logLines(after: $logCursor, last: 1000) {
    edges {
      node {
        id
        line
        level
      }
    }
  }
}
    `;
export const RunFilesFragmentFragmentDoc = gql`
    fragment RunFilesFragment on Run {
  files(after: $fileCursor, first: $fileLimit, names: $fileNames) {
    edges {
      node {
        id
        name
        directUrl
        url(upload: $upload)
        sizeBytes
        updatedAt
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;
export const SelectRunFragmentFragmentDoc = gql`
    fragment SelectRunFragment on Run {
  config
  summaryMetrics(packVersion: 1)
  systemMetrics
}
    `;
export const HistoryRunFragmentFragmentDoc = gql`
    fragment HistoryRunFragment on Run {
  history(samples: $historySamples)
}
    `;
export const SampledHistoryRunFragmentFragmentDoc = gql`
    fragment SampledHistoryRunFragment on Run {
  sampledHistory(specs: $sampledHistorySpecs, packVersion: 1)
}
    `;
export const UserSecretFieldsFragmentDoc = gql`
    fragment UserSecretFields on UserSecret {
  uuid
  name
  createdAt
  organizationId
}
    `;
export const OrgMemberFieldsFragmentDoc = gql`
    fragment OrgMemberFields on OrganizationMember {
  orgID
  id
  email
  username
  role
  modelsSeat
  weaveRole
}
    `;
export const TeamMembersOrgMemberFieldsFragmentDoc = gql`
    fragment TeamMembersOrgMemberFields on OrganizationMember {
  ...OrgMemberFields
  user {
    id
    deletedAt
    email
    username
  }
}
    ${OrgMemberFieldsFragmentDoc}`;
export const UserLevelAlertPreferencesFieldsFragmentDoc = gql`
    fragment UserLevelAlertPreferencesFields on UserLevelAlertPreferences {
  alerts {
    runFinished {
      email
      slack
    }
    runCrashed {
      email
      slack
      minimumRunDurationMs
    }
    scriptableAlert {
      email
      slack
    }
  }
  slackIntegrations {
    id
    displayName
    teamName
    channelName
  }
}
    `;
export const UserRoleFragmentFragmentDoc = gql`
    fragment UserRoleFragment on User {
  accountType
  admin
  deletedAt
  email
  username
}
    `;
export const EmailBasicFragmentDoc = gql`
    fragment EmailBasic on Email {
  id
  emailAddress
  createdAt
  type
}
    `;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  name
  email
  username
  deletedAt
  photoUrl
}
    `;
export const ViewFragmentFragmentDoc = gql`
    fragment ViewFragment on View {
  id
  type
  name
  displayName
  description
  user {
    id
    username
    photoUrl
    admin
  }
  project {
    id
    name
    entityName
  }
  spec
  updatedAt
}
    `;
export const ViewFragmentMetadataFragmentDoc = gql`
    fragment ViewFragmentMetadata on View {
  id
  type
  name
  displayName
  description
  updatedBy {
    id
    username
    name
  }
  user {
    id
    username
    photoUrl
    admin
  }
  project {
    id
    name
    entityName
  }
  updatedAt
  createdAt
  starred
  starCount
  parentId
  locked
  viewCount
  alertSubscription {
    id
  }
}
    `;
export const RunOverviewCommandItems_RunFragmentDoc = gql`
    fragment RunOverviewCommandItems_Run on Run {
  id
  displayName
  runInfo {
    args
    executable
    git {
      commit
      remote
    }
    program
  }
}
    `;
export const RunOverviewPatchItem_RunFragmentDoc = gql`
    fragment RunOverviewPatchItem_Run on Run {
  id
  patchFiles: files(pattern: "diff%.patch") {
    edges {
      node {
        id
        name
        url
      }
    }
  }
}
    `;
export const ViewCodeModal_RunFragmentDoc = gql`
    fragment ViewCodeModal_Run on Run {
  runInfo {
    git {
      remote
      commit
    }
  }
  commit
  github
  viewCodeModalPatchFile: files(first: 1, names: ["diff.patch"]) {
    edges {
      node {
        id
        sizeBytes
      }
    }
  }
}
    `;
export const HistoryKeysRunsFieldsFragmentDoc = gql`
    fragment HistoryKeysRunsFields on RunConnection {
  historyKeys(format: PLAINTEXT, includeHash: true)
}
    `;
export const JobInfoFragmentDoc = gql`
    fragment JobInfo on ArtifactCollection {
  id
  name
  description
  createdAt
  artifacts {
    edges {
      node {
        id
        description
        labels
        versionIndex
        aliases {
          id
          alias
        }
        usedBy(first: 1, order: "-createdAt", filters: $filters) {
          totalCount
          edges {
            node {
              id
              name
              displayName
              state
              createdAt
            }
          }
        }
      }
    }
  }
}
    `;
export const DefaultResourceConfigFragmentFragmentDoc = gql`
    fragment DefaultResourceConfigFragment on DefaultResourceConfig {
  id
  createdAt
  updatedAt
  scope {
    __typename
    Type
    ID
  }
  resource
  config
  templateVariables {
    name
    description
    schema
  }
}
    `;
export const JobCollectionFieldsFragmentDoc = gql`
    fragment JobCollectionFields on ArtifactCollection {
  id
  name
  description
  createdAt
  project {
    id
    access
    name
    entity {
      id
      name
    }
  }
}
    `;
export const JobVersionFieldsFragmentDoc = gql`
    fragment JobVersionFields on Artifact {
  id
  description
  aliases {
    id
    alias
  }
  createdAt
  createdBy {
    __typename
    ... on User {
      id
      name
      username
      photoUrl
    }
    ... on Run {
      id
      name
      displayName
      defaultColorIndex
    }
  }
}
    `;
export const JobRunFieldsFragmentDoc = gql`
    fragment JobRunFields on Run {
  id
  name
  displayName
  state
  stopped
  createdAt
  user {
    id
    name
    username
    photoUrl
  }
  config
  project {
    id
    name
    entity {
      id
      name
    }
  }
  defaultColorIndex
}
    `;
export const ArtifactCountsFragmentFragmentDoc = gql`
    fragment ArtifactCountsFragment on Run {
  inputArtifacts {
    totalCount
  }
  outputArtifacts {
    totalCount
  }
}
    `;
export const RunFieldsFragmentDoc = gql`
    fragment RunFields on Run {
  id
  agent {
    id
    name
  }
  aggregations(keys: $aggregationKeys) @include(if: $enableAggregations)
  commit
  computeSeconds
  config(keys: $configKeys) @include(if: $enableConfig)
  createdAt
  defaultColorIndex
  displayName
  framework
  github
  group
  groupCounts
  heartbeatAt
  host
  jobType
  logLineCount
  multiValueMetadataColumns(
    keys: $groupedMetadataColumnKeys
    limit: $groupedMetadataColumnLimit
  ) @include(if: $enableGroupedMetadataColumns) {
    key
    values
  }
  name
  notes
  projectId
  readOnly
  runInfo {
    gpu
    gpuCount
  }
  shouldStop
  state
  stopped
  summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
  sweep {
    id
    name
    displayName
    config
  }
  tags: tagColors @include(if: $enableTags) {
    id
    name
    colorIndex
  }
  updatedAt
  user {
    id
    username
    photoUrl
  }
  wandbConfig(keys: $wandbKeys)
  ...ArtifactCountsFragment @include(if: $enableArtifactCounts)
}
    ${ArtifactCountsFragmentFragmentDoc}`;
export const RunsSelectorRunsProjectFragmentFragmentDoc = gql`
    fragment RunsSelectorRunsProjectFragment on Project {
  id
  runs(
    first: $limit
    order: $order
    filters: $filters
    groupKeys: $groupKeys
    groupAggregation: $groupAggregation
    groupLevel: $groupLevel
  ) {
    totalCount
    deltaOrder(currentRuns: $currentRuns, lastUpdated: $lastUpdated)
    delta(currentRuns: $currentRuns, lastUpdated: $lastUpdated) {
      index
      op
      run {
        ...RunFields
      }
    }
  }
}
    ${RunFieldsFragmentDoc}`;
export const RunSelectorCsvExportRunFieldsFragmentDoc = gql`
    fragment RunSelectorCsvExportRunFields on Run {
  id
  aggregations(keys: $aggregationKeys) @include(if: $enableAggregations)
  commit
  config(keys: $configKeys) @include(if: $enableConfig)
  createdAt
  displayName
  framework
  github
  group
  groupCounts
  heartbeatAt
  host
  jobType
  logLineCount
  multiValueMetadataColumns(
    keys: $groupedMetadataColumnKeys
    limit: $groupedMetadataColumnLimit
  ) @include(if: $enableGroupedMetadataColumns) {
    key
    values
  }
  name
  notes
  projectId
  readOnly
  runInfo {
    gpu
    gpuCount
  }
  shouldStop
  state
  stopped
  summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
  sweep {
    id
    name
    displayName
  }
  tags @include(if: $enableTags)
  updatedAt
  user {
    id
    username
  }
  wandbConfig(keys: $wandbKeys)
  ...ArtifactCountsFragment @include(if: $enableArtifactCounts)
}
    ${ArtifactCountsFragmentFragmentDoc}`;
export const TeamMemberFieldsFragmentDoc = gql`
    fragment TeamMemberFields on Member {
  id
  username
  name
  photoUrl
  role
}
    `;
export const TeamMemberDetailedRoleFragmentDoc = gql`
    fragment TeamMemberDetailedRole on Member {
  memberRole {
    ID
    name
    permissions {
      name
    }
    inheritedFrom {
      ID
      name
      permissions {
        name
      }
    }
  }
}
    `;
export const NodeAlertFragmentFragmentDoc = gql`
    fragment NodeAlertFragment on NodeAlert {
  alertName
  alertStatus
  cluster
  clusterOrg
  description
  grafanaDashboard
  labels
  node
  pod
  occurrences
}
    `;
export const RunWithoutRunInfoStateBasicFragmentFragmentDoc = gql`
    fragment RunWithoutRunInfoStateBasicFragment on Run {
  agent {
    id
    name
  }
  commit
  computeSeconds
  createdAt
  defaultColorIndex
  displayName
  framework
  github
  group
  groupCounts
  heartbeatAt
  host
  jobType
  logLineCount
  notes
  projectId
  readOnly
  shouldStop
  state
  stopped
  sweep {
    id
    name
    displayName
    config
  }
  user {
    id
    username
    photoUrl
  }
}
    `;
export const RunInfoFragmentFragmentDoc = gql`
    fragment RunInfoFragment on Run {
  runInfo {
    gpu
    gpuCount
    codePath
    codePathLocal
  }
}
    `;
export const RunStateBasicFragmentFragmentDoc = gql`
    fragment RunStateBasicFragment on Run {
  ...RunWithoutRunInfoStateBasicFragment
  ...RunInfoFragment
}
    ${RunWithoutRunInfoStateBasicFragmentFragmentDoc}
${RunInfoFragmentFragmentDoc}`;
export const ViewFragmentMetadata2FragmentDoc = gql`
    fragment ViewFragmentMetadata2 on View {
  id
  name
  displayName
  type
  description
  user {
    id
    username
    photoUrl
    admin
    name
  }
  updatedBy {
    id
    name
    username
  }
  entityName
  project {
    id
    name
    entityName
    readOnly
  }
  previewUrl
  coverUrl
  updatedAt
  createdAt
  starCount
  starred
  parentId
  locked
  viewCount
  showcasedAt
  alertSubscription {
    id
  }
  accessTokens {
    id
    token
    view {
      id
    }
    type
    emails
    createdBy {
      id
      username
      email
      name
    }
    createdAt
    lastAccessedAt
    revokedAt
    projects {
      id
      name
      entityName
    }
  }
}
    `;
export const ProjectRsaReadGateFragmentDoc = gql`
    fragment ProjectRsaReadGate on Project {
  id
  runStoreAcceleratorReadEnabled
}
    `;
export const AgentChatRequestedProjectWriteAccessDocument = gql`
    query AgentChatRequestedProjectWriteAccess($entityName: String!, $projectName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    readOnly
  }
}
    `;

/**
 * __useAgentChatRequestedProjectWriteAccessQuery__
 *
 * To run a query within a React component, call `useAgentChatRequestedProjectWriteAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentChatRequestedProjectWriteAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentChatRequestedProjectWriteAccessQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useAgentChatRequestedProjectWriteAccessQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AgentChatRequestedProjectWriteAccessQuery, AgentChatRequestedProjectWriteAccessQueryVariables> & ({ variables: AgentChatRequestedProjectWriteAccessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AgentChatRequestedProjectWriteAccessQuery, AgentChatRequestedProjectWriteAccessQueryVariables>(AgentChatRequestedProjectWriteAccessDocument, options);
      }
export function useAgentChatRequestedProjectWriteAccessLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AgentChatRequestedProjectWriteAccessQuery, AgentChatRequestedProjectWriteAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AgentChatRequestedProjectWriteAccessQuery, AgentChatRequestedProjectWriteAccessQueryVariables>(AgentChatRequestedProjectWriteAccessDocument, options);
        }
// @ts-ignore
export function useAgentChatRequestedProjectWriteAccessSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AgentChatRequestedProjectWriteAccessQuery, AgentChatRequestedProjectWriteAccessQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AgentChatRequestedProjectWriteAccessQuery, AgentChatRequestedProjectWriteAccessQueryVariables>;
export function useAgentChatRequestedProjectWriteAccessSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AgentChatRequestedProjectWriteAccessQuery, AgentChatRequestedProjectWriteAccessQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AgentChatRequestedProjectWriteAccessQuery | undefined, AgentChatRequestedProjectWriteAccessQueryVariables>;
export function useAgentChatRequestedProjectWriteAccessSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AgentChatRequestedProjectWriteAccessQuery, AgentChatRequestedProjectWriteAccessQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AgentChatRequestedProjectWriteAccessQuery, AgentChatRequestedProjectWriteAccessQueryVariables>(AgentChatRequestedProjectWriteAccessDocument, options);
        }
export type AgentChatRequestedProjectWriteAccessQueryHookResult = ReturnType<typeof useAgentChatRequestedProjectWriteAccessQuery>;
export type AgentChatRequestedProjectWriteAccessLazyQueryHookResult = ReturnType<typeof useAgentChatRequestedProjectWriteAccessLazyQuery>;
export type AgentChatRequestedProjectWriteAccessSuspenseQueryHookResult = ReturnType<typeof useAgentChatRequestedProjectWriteAccessSuspenseQuery>;
export type AgentChatRequestedProjectWriteAccessQueryResult = ApolloReactCommon.QueryResult<AgentChatRequestedProjectWriteAccessQuery, AgentChatRequestedProjectWriteAccessQueryVariables>;
export const WbAgentPersonalSecretsWithGrantsDocument = gql`
    query WBAgentPersonalSecretsWithGrants($organizationId: ID!) {
  viewer {
    id
    secrets(organizationId: $organizationId) {
      ...UserSecretFields
    }
    wbAgentPersonalSecretGrants(organizationId: $organizationId) {
      secret {
        uuid
      }
    }
  }
}
    ${UserSecretFieldsFragmentDoc}`;

/**
 * __useWbAgentPersonalSecretsWithGrantsQuery__
 *
 * To run a query within a React component, call `useWbAgentPersonalSecretsWithGrantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWbAgentPersonalSecretsWithGrantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWbAgentPersonalSecretsWithGrantsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useWbAgentPersonalSecretsWithGrantsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WbAgentPersonalSecretsWithGrantsQuery, WbAgentPersonalSecretsWithGrantsQueryVariables> & ({ variables: WbAgentPersonalSecretsWithGrantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WbAgentPersonalSecretsWithGrantsQuery, WbAgentPersonalSecretsWithGrantsQueryVariables>(WbAgentPersonalSecretsWithGrantsDocument, options);
      }
export function useWbAgentPersonalSecretsWithGrantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WbAgentPersonalSecretsWithGrantsQuery, WbAgentPersonalSecretsWithGrantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WbAgentPersonalSecretsWithGrantsQuery, WbAgentPersonalSecretsWithGrantsQueryVariables>(WbAgentPersonalSecretsWithGrantsDocument, options);
        }
// @ts-ignore
export function useWbAgentPersonalSecretsWithGrantsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WbAgentPersonalSecretsWithGrantsQuery, WbAgentPersonalSecretsWithGrantsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WbAgentPersonalSecretsWithGrantsQuery, WbAgentPersonalSecretsWithGrantsQueryVariables>;
export function useWbAgentPersonalSecretsWithGrantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WbAgentPersonalSecretsWithGrantsQuery, WbAgentPersonalSecretsWithGrantsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WbAgentPersonalSecretsWithGrantsQuery | undefined, WbAgentPersonalSecretsWithGrantsQueryVariables>;
export function useWbAgentPersonalSecretsWithGrantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WbAgentPersonalSecretsWithGrantsQuery, WbAgentPersonalSecretsWithGrantsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WbAgentPersonalSecretsWithGrantsQuery, WbAgentPersonalSecretsWithGrantsQueryVariables>(WbAgentPersonalSecretsWithGrantsDocument, options);
        }
export type WbAgentPersonalSecretsWithGrantsQueryHookResult = ReturnType<typeof useWbAgentPersonalSecretsWithGrantsQuery>;
export type WbAgentPersonalSecretsWithGrantsLazyQueryHookResult = ReturnType<typeof useWbAgentPersonalSecretsWithGrantsLazyQuery>;
export type WbAgentPersonalSecretsWithGrantsSuspenseQueryHookResult = ReturnType<typeof useWbAgentPersonalSecretsWithGrantsSuspenseQuery>;
export type WbAgentPersonalSecretsWithGrantsQueryResult = ApolloReactCommon.QueryResult<WbAgentPersonalSecretsWithGrantsQuery, WbAgentPersonalSecretsWithGrantsQueryVariables>;
export const GrantPersonalSecretToWbAgentDocument = gql`
    mutation GrantPersonalSecretToWBAgent($secretUuid: String!) {
  grantPersonalSecretToWBAgent(input: {secretUuid: $secretUuid}) {
    grant {
      secret {
        uuid
      }
    }
  }
}
    `;
export type GrantPersonalSecretToWbAgentMutationFn = ApolloReactCommon.MutationFunction<GrantPersonalSecretToWbAgentMutation, GrantPersonalSecretToWbAgentMutationVariables>;

/**
 * __useGrantPersonalSecretToWbAgentMutation__
 *
 * To run a mutation, you first call `useGrantPersonalSecretToWbAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantPersonalSecretToWbAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantPersonalSecretToWbAgentMutation, { data, loading, error }] = useGrantPersonalSecretToWbAgentMutation({
 *   variables: {
 *      secretUuid: // value for 'secretUuid'
 *   },
 * });
 */
export function useGrantPersonalSecretToWbAgentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GrantPersonalSecretToWbAgentMutation, GrantPersonalSecretToWbAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GrantPersonalSecretToWbAgentMutation, GrantPersonalSecretToWbAgentMutationVariables>(GrantPersonalSecretToWbAgentDocument, options);
      }
export type GrantPersonalSecretToWbAgentMutationHookResult = ReturnType<typeof useGrantPersonalSecretToWbAgentMutation>;
export type GrantPersonalSecretToWbAgentMutationResult = ApolloReactCommon.MutationResult<GrantPersonalSecretToWbAgentMutation>;
export type GrantPersonalSecretToWbAgentMutationOptions = ApolloReactCommon.BaseMutationOptions<GrantPersonalSecretToWbAgentMutation, GrantPersonalSecretToWbAgentMutationVariables>;
export const RevokePersonalSecretFromWbAgentDocument = gql`
    mutation RevokePersonalSecretFromWBAgent($secretUuid: String!) {
  revokePersonalSecretFromWBAgent(input: {secretUuid: $secretUuid}) {
    success
  }
}
    `;
export type RevokePersonalSecretFromWbAgentMutationFn = ApolloReactCommon.MutationFunction<RevokePersonalSecretFromWbAgentMutation, RevokePersonalSecretFromWbAgentMutationVariables>;

/**
 * __useRevokePersonalSecretFromWbAgentMutation__
 *
 * To run a mutation, you first call `useRevokePersonalSecretFromWbAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokePersonalSecretFromWbAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokePersonalSecretFromWbAgentMutation, { data, loading, error }] = useRevokePersonalSecretFromWbAgentMutation({
 *   variables: {
 *      secretUuid: // value for 'secretUuid'
 *   },
 * });
 */
export function useRevokePersonalSecretFromWbAgentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RevokePersonalSecretFromWbAgentMutation, RevokePersonalSecretFromWbAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RevokePersonalSecretFromWbAgentMutation, RevokePersonalSecretFromWbAgentMutationVariables>(RevokePersonalSecretFromWbAgentDocument, options);
      }
export type RevokePersonalSecretFromWbAgentMutationHookResult = ReturnType<typeof useRevokePersonalSecretFromWbAgentMutation>;
export type RevokePersonalSecretFromWbAgentMutationResult = ApolloReactCommon.MutationResult<RevokePersonalSecretFromWbAgentMutation>;
export type RevokePersonalSecretFromWbAgentMutationOptions = ApolloReactCommon.BaseMutationOptions<RevokePersonalSecretFromWbAgentMutation, RevokePersonalSecretFromWbAgentMutationVariables>;
export const ArtifactDagDocument = gql`
    query ArtifactDAG($artifactVersionID: ID!, $limit: Int!, $filterGeneratedArtifacts: Boolean!, $clusterSize: Int, $directLineage: Boolean, $traversalDirection: TraversalDirection, $baseGraphNodeIDs: [String!]) {
  artifact(id: $artifactVersionID) {
    id
    artifactLineageDag(
      limit: $limit
      filterGeneratedArtifacts: $filterGeneratedArtifacts
      clusterSize: $clusterSize
      directLineage: $directLineage
      traversalDirection: $traversalDirection
      baseGraphNodeIDs: $baseGraphNodeIDs
    ) {
      ...GraphDataFragment
    }
  }
}
    ${GraphDataFragmentFragmentDoc}`;

/**
 * __useArtifactDagQuery__
 *
 * To run a query within a React component, call `useArtifactDagQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactDagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactDagQuery({
 *   variables: {
 *      artifactVersionID: // value for 'artifactVersionID'
 *      limit: // value for 'limit'
 *      filterGeneratedArtifacts: // value for 'filterGeneratedArtifacts'
 *      clusterSize: // value for 'clusterSize'
 *      directLineage: // value for 'directLineage'
 *      traversalDirection: // value for 'traversalDirection'
 *      baseGraphNodeIDs: // value for 'baseGraphNodeIDs'
 *   },
 * });
 */
export function useArtifactDagQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactDagQuery, ArtifactDagQueryVariables> & ({ variables: ArtifactDagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactDagQuery, ArtifactDagQueryVariables>(ArtifactDagDocument, options);
      }
export function useArtifactDagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactDagQuery, ArtifactDagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactDagQuery, ArtifactDagQueryVariables>(ArtifactDagDocument, options);
        }
// @ts-ignore
export function useArtifactDagSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactDagQuery, ArtifactDagQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactDagQuery, ArtifactDagQueryVariables>;
export function useArtifactDagSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactDagQuery, ArtifactDagQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactDagQuery | undefined, ArtifactDagQueryVariables>;
export function useArtifactDagSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactDagQuery, ArtifactDagQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactDagQuery, ArtifactDagQueryVariables>(ArtifactDagDocument, options);
        }
export type ArtifactDagQueryHookResult = ReturnType<typeof useArtifactDagQuery>;
export type ArtifactDagLazyQueryHookResult = ReturnType<typeof useArtifactDagLazyQuery>;
export type ArtifactDagSuspenseQueryHookResult = ReturnType<typeof useArtifactDagSuspenseQuery>;
export type ArtifactDagQueryResult = ApolloReactCommon.QueryResult<ArtifactDagQuery, ArtifactDagQueryVariables>;
export const ArtifactOverviewDocument = gql`
    query ArtifactOverview($artifactID: ID!, $artifactVersionIndex: String!) {
  artifact(id: $artifactID) {
    id
    artifactSequence {
      id
      name
      project {
        id
        name
        entityName
      }
      artifactMembership(aliasName: $artifactVersionIndex) {
        id
        aliases {
          id
          alias
        }
      }
    }
    digest
    description
    size
    fileCount
    createdAt
    createdBy {
      __typename
      ... on Run {
        id
        runName: name
        displayName
        runProjectQuery: project {
          id
          runProject: name
          runEntity: entityName
        }
      }
      ... on User {
        id
        username
      }
    }
    artifactMemberships {
      edges {
        node {
          id
          versionIndex
          artifactCollection {
            __typename
            id
            ... on ArtifactPortfolio {
              linkPortfolioName: name
              linkProjectQuery: project {
                id
                linkProjectName: name
                linkEntityName: entityName
              }
            }
          }
        }
      }
    }
    usedCount
    ttlDurationSeconds
  }
}
    `;

/**
 * __useArtifactOverviewQuery__
 *
 * To run a query within a React component, call `useArtifactOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactOverviewQuery({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *      artifactVersionIndex: // value for 'artifactVersionIndex'
 *   },
 * });
 */
export function useArtifactOverviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactOverviewQuery, ArtifactOverviewQueryVariables> & ({ variables: ArtifactOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactOverviewQuery, ArtifactOverviewQueryVariables>(ArtifactOverviewDocument, options);
      }
export function useArtifactOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactOverviewQuery, ArtifactOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactOverviewQuery, ArtifactOverviewQueryVariables>(ArtifactOverviewDocument, options);
        }
// @ts-ignore
export function useArtifactOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactOverviewQuery, ArtifactOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactOverviewQuery, ArtifactOverviewQueryVariables>;
export function useArtifactOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactOverviewQuery, ArtifactOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactOverviewQuery | undefined, ArtifactOverviewQueryVariables>;
export function useArtifactOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactOverviewQuery, ArtifactOverviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactOverviewQuery, ArtifactOverviewQueryVariables>(ArtifactOverviewDocument, options);
        }
export type ArtifactOverviewQueryHookResult = ReturnType<typeof useArtifactOverviewQuery>;
export type ArtifactOverviewLazyQueryHookResult = ReturnType<typeof useArtifactOverviewLazyQuery>;
export type ArtifactOverviewSuspenseQueryHookResult = ReturnType<typeof useArtifactOverviewSuspenseQuery>;
export type ArtifactOverviewQueryResult = ApolloReactCommon.QueryResult<ArtifactOverviewQuery, ArtifactOverviewQueryVariables>;
export const RunArtifactDagDocument = gql`
    query RunArtifactDAG($projectName: String!, $entityName: String!, $runName: String!, $limit: Int!, $filterGeneratedArtifacts: Boolean!, $clusterSize: Int, $directLineage: Boolean, $traversalDirection: TraversalDirection, $baseGraphNodeIDs: [String!]) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      artifactLineageDag(
        limit: $limit
        filterGeneratedArtifacts: $filterGeneratedArtifacts
        clusterSize: $clusterSize
        directLineage: $directLineage
        traversalDirection: $traversalDirection
        baseGraphNodeIDs: $baseGraphNodeIDs
      ) {
        ...GraphDataFragment
      }
    }
  }
}
    ${GraphDataFragmentFragmentDoc}`;

/**
 * __useRunArtifactDagQuery__
 *
 * To run a query within a React component, call `useRunArtifactDagQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunArtifactDagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunArtifactDagQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      limit: // value for 'limit'
 *      filterGeneratedArtifacts: // value for 'filterGeneratedArtifacts'
 *      clusterSize: // value for 'clusterSize'
 *      directLineage: // value for 'directLineage'
 *      traversalDirection: // value for 'traversalDirection'
 *      baseGraphNodeIDs: // value for 'baseGraphNodeIDs'
 *   },
 * });
 */
export function useRunArtifactDagQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunArtifactDagQuery, RunArtifactDagQueryVariables> & ({ variables: RunArtifactDagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunArtifactDagQuery, RunArtifactDagQueryVariables>(RunArtifactDagDocument, options);
      }
export function useRunArtifactDagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunArtifactDagQuery, RunArtifactDagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunArtifactDagQuery, RunArtifactDagQueryVariables>(RunArtifactDagDocument, options);
        }
// @ts-ignore
export function useRunArtifactDagSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunArtifactDagQuery, RunArtifactDagQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunArtifactDagQuery, RunArtifactDagQueryVariables>;
export function useRunArtifactDagSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunArtifactDagQuery, RunArtifactDagQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunArtifactDagQuery | undefined, RunArtifactDagQueryVariables>;
export function useRunArtifactDagSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunArtifactDagQuery, RunArtifactDagQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunArtifactDagQuery, RunArtifactDagQueryVariables>(RunArtifactDagDocument, options);
        }
export type RunArtifactDagQueryHookResult = ReturnType<typeof useRunArtifactDagQuery>;
export type RunArtifactDagLazyQueryHookResult = ReturnType<typeof useRunArtifactDagLazyQuery>;
export type RunArtifactDagSuspenseQueryHookResult = ReturnType<typeof useRunArtifactDagSuspenseQuery>;
export type RunArtifactDagQueryResult = ApolloReactCommon.QueryResult<RunArtifactDagQuery, RunArtifactDagQueryVariables>;
export const RunOverviewLineageDocument = gql`
    query RunOverviewLineage($projectName: String!, $entityName: String!, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      project {
        id
        name
      }
      createdAt
      group
      state
      notes
      config
      tags
      host
      computeSeconds
      user {
        id
        username
      }
      runInfo {
        os
        python
      }
    }
  }
}
    `;

/**
 * __useRunOverviewLineageQuery__
 *
 * To run a query within a React component, call `useRunOverviewLineageQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunOverviewLineageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunOverviewLineageQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunOverviewLineageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunOverviewLineageQuery, RunOverviewLineageQueryVariables> & ({ variables: RunOverviewLineageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunOverviewLineageQuery, RunOverviewLineageQueryVariables>(RunOverviewLineageDocument, options);
      }
export function useRunOverviewLineageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunOverviewLineageQuery, RunOverviewLineageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunOverviewLineageQuery, RunOverviewLineageQueryVariables>(RunOverviewLineageDocument, options);
        }
// @ts-ignore
export function useRunOverviewLineageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunOverviewLineageQuery, RunOverviewLineageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunOverviewLineageQuery, RunOverviewLineageQueryVariables>;
export function useRunOverviewLineageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunOverviewLineageQuery, RunOverviewLineageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunOverviewLineageQuery | undefined, RunOverviewLineageQueryVariables>;
export function useRunOverviewLineageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunOverviewLineageQuery, RunOverviewLineageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunOverviewLineageQuery, RunOverviewLineageQueryVariables>(RunOverviewLineageDocument, options);
        }
export type RunOverviewLineageQueryHookResult = ReturnType<typeof useRunOverviewLineageQuery>;
export type RunOverviewLineageLazyQueryHookResult = ReturnType<typeof useRunOverviewLineageLazyQuery>;
export type RunOverviewLineageSuspenseQueryHookResult = ReturnType<typeof useRunOverviewLineageSuspenseQuery>;
export type RunOverviewLineageQueryResult = ApolloReactCommon.QueryResult<RunOverviewLineageQuery, RunOverviewLineageQueryVariables>;
export const ArtifactVersionAliasesDocument = gql`
    query ArtifactVersionAliases($artifactCollectionID: ID!, $versionAlias: String!, $adminType: WorkflowsAdminType!) {
  artifactCollection(id: $artifactCollectionID) {
    id
    name
    __typename
    aliases {
      edges {
        node {
          id
          alias
        }
      }
    }
    artifactMembership(aliasName: $versionAlias) {
      id
      aliases {
        id
        alias
      }
      artifact {
        id
        artifactType {
          id
          name
        }
      }
    }
    project {
      id
      name
      protectedArtifactAliases {
        alias
      }
      entity {
        id
        name
        protectedAliases(adminType: $adminType)
        workflowsAdmins(adminType: $adminType) {
          id
          name
          username
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactVersionAliasesQuery__
 *
 * To run a query within a React component, call `useArtifactVersionAliasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactVersionAliasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactVersionAliasesQuery({
 *   variables: {
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *      versionAlias: // value for 'versionAlias'
 *      adminType: // value for 'adminType'
 *   },
 * });
 */
export function useArtifactVersionAliasesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables> & ({ variables: ArtifactVersionAliasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables>(ArtifactVersionAliasesDocument, options);
      }
export function useArtifactVersionAliasesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables>(ArtifactVersionAliasesDocument, options);
        }
// @ts-ignore
export function useArtifactVersionAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables>;
export function useArtifactVersionAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionAliasesQuery | undefined, ArtifactVersionAliasesQueryVariables>;
export function useArtifactVersionAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables>(ArtifactVersionAliasesDocument, options);
        }
export type ArtifactVersionAliasesQueryHookResult = ReturnType<typeof useArtifactVersionAliasesQuery>;
export type ArtifactVersionAliasesLazyQueryHookResult = ReturnType<typeof useArtifactVersionAliasesLazyQuery>;
export type ArtifactVersionAliasesSuspenseQueryHookResult = ReturnType<typeof useArtifactVersionAliasesSuspenseQuery>;
export type ArtifactVersionAliasesQueryResult = ApolloReactCommon.QueryResult<ArtifactVersionAliasesQuery, ArtifactVersionAliasesQueryVariables>;
export const ArtifactVersionTagsDocument = gql`
    query ArtifactVersionTags($artifactCollectionID: ID!, $versionAlias: String!) {
  artifactCollection(id: $artifactCollectionID) {
    id
    name
    artifactMembership(aliasName: $versionAlias) {
      id
      artifact {
        id
        tags {
          id
          name
          tagCategoryName
          attributes
        }
      }
    }
    project {
      id
      name
      entity {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useArtifactVersionTagsQuery__
 *
 * To run a query within a React component, call `useArtifactVersionTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactVersionTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactVersionTagsQuery({
 *   variables: {
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *      versionAlias: // value for 'versionAlias'
 *   },
 * });
 */
export function useArtifactVersionTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables> & ({ variables: ArtifactVersionTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables>(ArtifactVersionTagsDocument, options);
      }
export function useArtifactVersionTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables>(ArtifactVersionTagsDocument, options);
        }
// @ts-ignore
export function useArtifactVersionTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables>;
export function useArtifactVersionTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionTagsQuery | undefined, ArtifactVersionTagsQueryVariables>;
export function useArtifactVersionTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables>(ArtifactVersionTagsDocument, options);
        }
export type ArtifactVersionTagsQueryHookResult = ReturnType<typeof useArtifactVersionTagsQuery>;
export type ArtifactVersionTagsLazyQueryHookResult = ReturnType<typeof useArtifactVersionTagsLazyQuery>;
export type ArtifactVersionTagsSuspenseQueryHookResult = ReturnType<typeof useArtifactVersionTagsSuspenseQuery>;
export type ArtifactVersionTagsQueryResult = ApolloReactCommon.QueryResult<ArtifactVersionTagsQuery, ArtifactVersionTagsQueryVariables>;
export const ArtifactIsProtectedDocument = gql`
    query ArtifactIsProtected($artifactID: ID!) {
  artifact(id: $artifactID) {
    id
    isProtected
    artifactSequence {
      id
      project {
        id
        name
        entity {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactIsProtectedQuery__
 *
 * To run a query within a React component, call `useArtifactIsProtectedQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactIsProtectedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactIsProtectedQuery({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *   },
 * });
 */
export function useArtifactIsProtectedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables> & ({ variables: ArtifactIsProtectedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables>(ArtifactIsProtectedDocument, options);
      }
export function useArtifactIsProtectedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables>(ArtifactIsProtectedDocument, options);
        }
// @ts-ignore
export function useArtifactIsProtectedSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables>;
export function useArtifactIsProtectedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactIsProtectedQuery | undefined, ArtifactIsProtectedQueryVariables>;
export function useArtifactIsProtectedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables>(ArtifactIsProtectedDocument, options);
        }
export type ArtifactIsProtectedQueryHookResult = ReturnType<typeof useArtifactIsProtectedQuery>;
export type ArtifactIsProtectedLazyQueryHookResult = ReturnType<typeof useArtifactIsProtectedLazyQuery>;
export type ArtifactIsProtectedSuspenseQueryHookResult = ReturnType<typeof useArtifactIsProtectedSuspenseQuery>;
export type ArtifactIsProtectedQueryResult = ApolloReactCommon.QueryResult<ArtifactIsProtectedQuery, ArtifactIsProtectedQueryVariables>;
export const ArtifactTagsDocument = gql`
    query ArtifactTags($artifactCollectionID: ID!) {
  artifactCollection(id: $artifactCollectionID) {
    id
    name
    tags {
      edges {
        node {
          id
          name
          attributes
          tagCategoryName
        }
      }
    }
    project {
      id
      name
      entity {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useArtifactTagsQuery__
 *
 * To run a query within a React component, call `useArtifactTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactTagsQuery({
 *   variables: {
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *   },
 * });
 */
export function useArtifactTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactTagsQuery, ArtifactTagsQueryVariables> & ({ variables: ArtifactTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactTagsQuery, ArtifactTagsQueryVariables>(ArtifactTagsDocument, options);
      }
export function useArtifactTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactTagsQuery, ArtifactTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactTagsQuery, ArtifactTagsQueryVariables>(ArtifactTagsDocument, options);
        }
// @ts-ignore
export function useArtifactTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactTagsQuery, ArtifactTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactTagsQuery, ArtifactTagsQueryVariables>;
export function useArtifactTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactTagsQuery, ArtifactTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactTagsQuery | undefined, ArtifactTagsQueryVariables>;
export function useArtifactTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactTagsQuery, ArtifactTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactTagsQuery, ArtifactTagsQueryVariables>(ArtifactTagsDocument, options);
        }
export type ArtifactTagsQueryHookResult = ReturnType<typeof useArtifactTagsQuery>;
export type ArtifactTagsLazyQueryHookResult = ReturnType<typeof useArtifactTagsLazyQuery>;
export type ArtifactTagsSuspenseQueryHookResult = ReturnType<typeof useArtifactTagsSuspenseQuery>;
export type ArtifactTagsQueryResult = ApolloReactCommon.QueryResult<ArtifactTagsQuery, ArtifactTagsQueryVariables>;
export const ArtifactVersionsTableDataDocument = gql`
    query ArtifactVersionsTableData($artifactCollectionID: ID!, $limit: Int!, $after: String, $searchTerm: String) {
  artifactCollection(id: $artifactCollectionID) {
    id
    artifactMemberships(first: $limit, after: $after, searchTerm: $searchTerm) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          versionIndex
          createdAt
          artifact {
            id
            createdBy {
              __typename
              ... on User {
                id
                name
                username
                photoUrl
              }
              ... on Run {
                id
                name
                displayName
                defaultColorIndex
                project {
                  id
                  name
                  entityName
                }
              }
            }
            tags {
              id
              name
              tagCategoryName
              attributes
            }
            metadata
            ttlDurationSeconds
            usedCount
            size
            isGenerated
            createdAt
            runHistory
          }
          aliases {
            id
            alias
          }
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactVersionsTableDataQuery__
 *
 * To run a query within a React component, call `useArtifactVersionsTableDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactVersionsTableDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactVersionsTableDataQuery({
 *   variables: {
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useArtifactVersionsTableDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables> & ({ variables: ArtifactVersionsTableDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables>(ArtifactVersionsTableDataDocument, options);
      }
export function useArtifactVersionsTableDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables>(ArtifactVersionsTableDataDocument, options);
        }
// @ts-ignore
export function useArtifactVersionsTableDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables>;
export function useArtifactVersionsTableDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionsTableDataQuery | undefined, ArtifactVersionsTableDataQueryVariables>;
export function useArtifactVersionsTableDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables>(ArtifactVersionsTableDataDocument, options);
        }
export type ArtifactVersionsTableDataQueryHookResult = ReturnType<typeof useArtifactVersionsTableDataQuery>;
export type ArtifactVersionsTableDataLazyQueryHookResult = ReturnType<typeof useArtifactVersionsTableDataLazyQuery>;
export type ArtifactVersionsTableDataSuspenseQueryHookResult = ReturnType<typeof useArtifactVersionsTableDataSuspenseQuery>;
export type ArtifactVersionsTableDataQueryResult = ApolloReactCommon.QueryResult<ArtifactVersionsTableDataQuery, ArtifactVersionsTableDataQueryVariables>;
export const ArtifactVersionsTableAliasesDocument = gql`
    query ArtifactVersionsTableAliases($artifactCollectionID: ID!) {
  artifactCollection(id: $artifactCollectionID) {
    id
    aliases {
      edges {
        node {
          id
          alias
        }
      }
    }
    project {
      id
      protectedArtifactAliases {
        alias
      }
    }
  }
}
    `;

/**
 * __useArtifactVersionsTableAliasesQuery__
 *
 * To run a query within a React component, call `useArtifactVersionsTableAliasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactVersionsTableAliasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactVersionsTableAliasesQuery({
 *   variables: {
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *   },
 * });
 */
export function useArtifactVersionsTableAliasesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables> & ({ variables: ArtifactVersionsTableAliasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables>(ArtifactVersionsTableAliasesDocument, options);
      }
export function useArtifactVersionsTableAliasesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables>(ArtifactVersionsTableAliasesDocument, options);
        }
// @ts-ignore
export function useArtifactVersionsTableAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables>;
export function useArtifactVersionsTableAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionsTableAliasesQuery | undefined, ArtifactVersionsTableAliasesQueryVariables>;
export function useArtifactVersionsTableAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables>(ArtifactVersionsTableAliasesDocument, options);
        }
export type ArtifactVersionsTableAliasesQueryHookResult = ReturnType<typeof useArtifactVersionsTableAliasesQuery>;
export type ArtifactVersionsTableAliasesLazyQueryHookResult = ReturnType<typeof useArtifactVersionsTableAliasesLazyQuery>;
export type ArtifactVersionsTableAliasesSuspenseQueryHookResult = ReturnType<typeof useArtifactVersionsTableAliasesSuspenseQuery>;
export type ArtifactVersionsTableAliasesQueryResult = ApolloReactCommon.QueryResult<ArtifactVersionsTableAliasesQuery, ArtifactVersionsTableAliasesQueryVariables>;
export const ArtifactCollectionOverviewDocument = gql`
    query ArtifactCollectionOverview($artifactCollectionID: ID!, $includeOverview: Boolean = false) {
  artifactCollection(id: $artifactCollectionID) {
    id
    createdAt
    description
    __typename
    name
    overview @include(if: $includeOverview) {
      artifactCollectionID
      viewID
    }
    defaultArtifactType {
      id
      name
    }
    artifactMemberships(first: 1) @include(if: $includeOverview) {
      edges {
        node {
          id
          artifact {
            id
            artifactSequence {
              id
              project {
                id
                name
                entityName
              }
            }
          }
        }
      }
    }
    project {
      id
      name
      entityName
    }
  }
}
    `;

/**
 * __useArtifactCollectionOverviewQuery__
 *
 * To run a query within a React component, call `useArtifactCollectionOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCollectionOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCollectionOverviewQuery({
 *   variables: {
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *      includeOverview: // value for 'includeOverview'
 *   },
 * });
 */
export function useArtifactCollectionOverviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables> & ({ variables: ArtifactCollectionOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables>(ArtifactCollectionOverviewDocument, options);
      }
export function useArtifactCollectionOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables>(ArtifactCollectionOverviewDocument, options);
        }
// @ts-ignore
export function useArtifactCollectionOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables>;
export function useArtifactCollectionOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionOverviewQuery | undefined, ArtifactCollectionOverviewQueryVariables>;
export function useArtifactCollectionOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables>(ArtifactCollectionOverviewDocument, options);
        }
export type ArtifactCollectionOverviewQueryHookResult = ReturnType<typeof useArtifactCollectionOverviewQuery>;
export type ArtifactCollectionOverviewLazyQueryHookResult = ReturnType<typeof useArtifactCollectionOverviewLazyQuery>;
export type ArtifactCollectionOverviewSuspenseQueryHookResult = ReturnType<typeof useArtifactCollectionOverviewSuspenseQuery>;
export type ArtifactCollectionOverviewQueryResult = ApolloReactCommon.QueryResult<ArtifactCollectionOverviewQuery, ArtifactCollectionOverviewQueryVariables>;
export const ArtifactCollectionDisplayVersionsDocument = gql`
    query ArtifactCollectionDisplayVersions($artifactCollectionID: ID!) {
  artifactCollection(id: $artifactCollectionID) {
    id
    versionIndexes
    aliases {
      edges {
        node {
          id
          alias
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactCollectionDisplayVersionsQuery__
 *
 * To run a query within a React component, call `useArtifactCollectionDisplayVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCollectionDisplayVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCollectionDisplayVersionsQuery({
 *   variables: {
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *   },
 * });
 */
export function useArtifactCollectionDisplayVersionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCollectionDisplayVersionsQuery, ArtifactCollectionDisplayVersionsQueryVariables> & ({ variables: ArtifactCollectionDisplayVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCollectionDisplayVersionsQuery, ArtifactCollectionDisplayVersionsQueryVariables>(ArtifactCollectionDisplayVersionsDocument, options);
      }
export function useArtifactCollectionDisplayVersionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCollectionDisplayVersionsQuery, ArtifactCollectionDisplayVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCollectionDisplayVersionsQuery, ArtifactCollectionDisplayVersionsQueryVariables>(ArtifactCollectionDisplayVersionsDocument, options);
        }
// @ts-ignore
export function useArtifactCollectionDisplayVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionDisplayVersionsQuery, ArtifactCollectionDisplayVersionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionDisplayVersionsQuery, ArtifactCollectionDisplayVersionsQueryVariables>;
export function useArtifactCollectionDisplayVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionDisplayVersionsQuery, ArtifactCollectionDisplayVersionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionDisplayVersionsQuery | undefined, ArtifactCollectionDisplayVersionsQueryVariables>;
export function useArtifactCollectionDisplayVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionDisplayVersionsQuery, ArtifactCollectionDisplayVersionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCollectionDisplayVersionsQuery, ArtifactCollectionDisplayVersionsQueryVariables>(ArtifactCollectionDisplayVersionsDocument, options);
        }
export type ArtifactCollectionDisplayVersionsQueryHookResult = ReturnType<typeof useArtifactCollectionDisplayVersionsQuery>;
export type ArtifactCollectionDisplayVersionsLazyQueryHookResult = ReturnType<typeof useArtifactCollectionDisplayVersionsLazyQuery>;
export type ArtifactCollectionDisplayVersionsSuspenseQueryHookResult = ReturnType<typeof useArtifactCollectionDisplayVersionsSuspenseQuery>;
export type ArtifactCollectionDisplayVersionsQueryResult = ApolloReactCommon.QueryResult<ArtifactCollectionDisplayVersionsQuery, ArtifactCollectionDisplayVersionsQueryVariables>;
export const ArtifactCollectionWithRegistryVersionDocument = gql`
    query ArtifactCollectionWithRegistryVersion($projectName: String!, $entityName: String!, $artifactTypeName: String!, $artifactCollectionName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactType(name: $artifactTypeName) {
      id
      artifactCollection(name: $artifactCollectionName) {
        id
        name
        hasArtifactVersionLinkedToGlobalRegistry
      }
    }
  }
}
    `;

/**
 * __useArtifactCollectionWithRegistryVersionQuery__
 *
 * To run a query within a React component, call `useArtifactCollectionWithRegistryVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCollectionWithRegistryVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCollectionWithRegistryVersionQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *      artifactCollectionName: // value for 'artifactCollectionName'
 *   },
 * });
 */
export function useArtifactCollectionWithRegistryVersionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables> & ({ variables: ArtifactCollectionWithRegistryVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables>(ArtifactCollectionWithRegistryVersionDocument, options);
      }
export function useArtifactCollectionWithRegistryVersionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables>(ArtifactCollectionWithRegistryVersionDocument, options);
        }
// @ts-ignore
export function useArtifactCollectionWithRegistryVersionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables>;
export function useArtifactCollectionWithRegistryVersionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionWithRegistryVersionQuery | undefined, ArtifactCollectionWithRegistryVersionQueryVariables>;
export function useArtifactCollectionWithRegistryVersionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables>(ArtifactCollectionWithRegistryVersionDocument, options);
        }
export type ArtifactCollectionWithRegistryVersionQueryHookResult = ReturnType<typeof useArtifactCollectionWithRegistryVersionQuery>;
export type ArtifactCollectionWithRegistryVersionLazyQueryHookResult = ReturnType<typeof useArtifactCollectionWithRegistryVersionLazyQuery>;
export type ArtifactCollectionWithRegistryVersionSuspenseQueryHookResult = ReturnType<typeof useArtifactCollectionWithRegistryVersionSuspenseQuery>;
export type ArtifactCollectionWithRegistryVersionQueryResult = ApolloReactCommon.QueryResult<ArtifactCollectionWithRegistryVersionQuery, ArtifactCollectionWithRegistryVersionQueryVariables>;
export const ArtifactCollectionHasProtectedArtifactDocument = gql`
    query ArtifactCollectionHasProtectedArtifact($artifactCollectionID: ID!) {
  artifactSequence(id: $artifactCollectionID) {
    id
    hasProtectedArtifact
  }
}
    `;

/**
 * __useArtifactCollectionHasProtectedArtifactQuery__
 *
 * To run a query within a React component, call `useArtifactCollectionHasProtectedArtifactQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCollectionHasProtectedArtifactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCollectionHasProtectedArtifactQuery({
 *   variables: {
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *   },
 * });
 */
export function useArtifactCollectionHasProtectedArtifactQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables> & ({ variables: ArtifactCollectionHasProtectedArtifactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables>(ArtifactCollectionHasProtectedArtifactDocument, options);
      }
export function useArtifactCollectionHasProtectedArtifactLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables>(ArtifactCollectionHasProtectedArtifactDocument, options);
        }
// @ts-ignore
export function useArtifactCollectionHasProtectedArtifactSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables>;
export function useArtifactCollectionHasProtectedArtifactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionHasProtectedArtifactQuery | undefined, ArtifactCollectionHasProtectedArtifactQueryVariables>;
export function useArtifactCollectionHasProtectedArtifactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables>(ArtifactCollectionHasProtectedArtifactDocument, options);
        }
export type ArtifactCollectionHasProtectedArtifactQueryHookResult = ReturnType<typeof useArtifactCollectionHasProtectedArtifactQuery>;
export type ArtifactCollectionHasProtectedArtifactLazyQueryHookResult = ReturnType<typeof useArtifactCollectionHasProtectedArtifactLazyQuery>;
export type ArtifactCollectionHasProtectedArtifactSuspenseQueryHookResult = ReturnType<typeof useArtifactCollectionHasProtectedArtifactSuspenseQuery>;
export type ArtifactCollectionHasProtectedArtifactQueryResult = ApolloReactCommon.QueryResult<ArtifactCollectionHasProtectedArtifactQuery, ArtifactCollectionHasProtectedArtifactQueryVariables>;
export const ArtifactSidebarCollectionsDocument = gql`
    query ArtifactSidebarCollections($projectName: String!, $entityName: String!, $filters: JSONString, $first: Int!) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactCollections(first: $first, order: "-createdAt", filters: $filters) {
      edges {
        node {
          id
          name
          updatedAt
          defaultArtifactType {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactSidebarCollectionsQuery__
 *
 * To run a query within a React component, call `useArtifactSidebarCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactSidebarCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactSidebarCollectionsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useArtifactSidebarCollectionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactSidebarCollectionsQuery, ArtifactSidebarCollectionsQueryVariables> & ({ variables: ArtifactSidebarCollectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactSidebarCollectionsQuery, ArtifactSidebarCollectionsQueryVariables>(ArtifactSidebarCollectionsDocument, options);
      }
export function useArtifactSidebarCollectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactSidebarCollectionsQuery, ArtifactSidebarCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactSidebarCollectionsQuery, ArtifactSidebarCollectionsQueryVariables>(ArtifactSidebarCollectionsDocument, options);
        }
// @ts-ignore
export function useArtifactSidebarCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactSidebarCollectionsQuery, ArtifactSidebarCollectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactSidebarCollectionsQuery, ArtifactSidebarCollectionsQueryVariables>;
export function useArtifactSidebarCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactSidebarCollectionsQuery, ArtifactSidebarCollectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactSidebarCollectionsQuery | undefined, ArtifactSidebarCollectionsQueryVariables>;
export function useArtifactSidebarCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactSidebarCollectionsQuery, ArtifactSidebarCollectionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactSidebarCollectionsQuery, ArtifactSidebarCollectionsQueryVariables>(ArtifactSidebarCollectionsDocument, options);
        }
export type ArtifactSidebarCollectionsQueryHookResult = ReturnType<typeof useArtifactSidebarCollectionsQuery>;
export type ArtifactSidebarCollectionsLazyQueryHookResult = ReturnType<typeof useArtifactSidebarCollectionsLazyQuery>;
export type ArtifactSidebarCollectionsSuspenseQueryHookResult = ReturnType<typeof useArtifactSidebarCollectionsSuspenseQuery>;
export type ArtifactSidebarCollectionsQueryResult = ApolloReactCommon.QueryResult<ArtifactSidebarCollectionsQuery, ArtifactSidebarCollectionsQueryVariables>;
export const ArtifactSidebarTypeCollectionsDocument = gql`
    query ArtifactSidebarTypeCollections($projectName: String!, $entityName: String!, $artifactTypeName: String!, $portfolioFirst: Int!, $portfolioAfter: String, $sequenceFirst: Int!, $sequenceAfter: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactType(name: $artifactTypeName) {
      id
      portfolios: artifactCollections(
        collectionTypes: [PORTFOLIO]
        first: $portfolioFirst
        after: $portfolioAfter
      ) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            name
            updatedAt
          }
        }
      }
      sequences: artifactCollections(
        collectionTypes: [SEQUENCE]
        first: $sequenceFirst
        after: $sequenceAfter
      ) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            name
            updatedAt
          }
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactSidebarTypeCollectionsQuery__
 *
 * To run a query within a React component, call `useArtifactSidebarTypeCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactSidebarTypeCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactSidebarTypeCollectionsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *      portfolioFirst: // value for 'portfolioFirst'
 *      portfolioAfter: // value for 'portfolioAfter'
 *      sequenceFirst: // value for 'sequenceFirst'
 *      sequenceAfter: // value for 'sequenceAfter'
 *   },
 * });
 */
export function useArtifactSidebarTypeCollectionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactSidebarTypeCollectionsQuery, ArtifactSidebarTypeCollectionsQueryVariables> & ({ variables: ArtifactSidebarTypeCollectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactSidebarTypeCollectionsQuery, ArtifactSidebarTypeCollectionsQueryVariables>(ArtifactSidebarTypeCollectionsDocument, options);
      }
export function useArtifactSidebarTypeCollectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactSidebarTypeCollectionsQuery, ArtifactSidebarTypeCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactSidebarTypeCollectionsQuery, ArtifactSidebarTypeCollectionsQueryVariables>(ArtifactSidebarTypeCollectionsDocument, options);
        }
// @ts-ignore
export function useArtifactSidebarTypeCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactSidebarTypeCollectionsQuery, ArtifactSidebarTypeCollectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactSidebarTypeCollectionsQuery, ArtifactSidebarTypeCollectionsQueryVariables>;
export function useArtifactSidebarTypeCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactSidebarTypeCollectionsQuery, ArtifactSidebarTypeCollectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactSidebarTypeCollectionsQuery | undefined, ArtifactSidebarTypeCollectionsQueryVariables>;
export function useArtifactSidebarTypeCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactSidebarTypeCollectionsQuery, ArtifactSidebarTypeCollectionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactSidebarTypeCollectionsQuery, ArtifactSidebarTypeCollectionsQueryVariables>(ArtifactSidebarTypeCollectionsDocument, options);
        }
export type ArtifactSidebarTypeCollectionsQueryHookResult = ReturnType<typeof useArtifactSidebarTypeCollectionsQuery>;
export type ArtifactSidebarTypeCollectionsLazyQueryHookResult = ReturnType<typeof useArtifactSidebarTypeCollectionsLazyQuery>;
export type ArtifactSidebarTypeCollectionsSuspenseQueryHookResult = ReturnType<typeof useArtifactSidebarTypeCollectionsSuspenseQuery>;
export type ArtifactSidebarTypeCollectionsQueryResult = ApolloReactCommon.QueryResult<ArtifactSidebarTypeCollectionsQuery, ArtifactSidebarTypeCollectionsQueryVariables>;
export const ArtifactSidebarTypesDocument = gql`
    query ArtifactSidebarTypes($projectName: String!, $entityName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactTypes {
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactSidebarTypesQuery__
 *
 * To run a query within a React component, call `useArtifactSidebarTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactSidebarTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactSidebarTypesQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useArtifactSidebarTypesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactSidebarTypesQuery, ArtifactSidebarTypesQueryVariables> & ({ variables: ArtifactSidebarTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactSidebarTypesQuery, ArtifactSidebarTypesQueryVariables>(ArtifactSidebarTypesDocument, options);
      }
export function useArtifactSidebarTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactSidebarTypesQuery, ArtifactSidebarTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactSidebarTypesQuery, ArtifactSidebarTypesQueryVariables>(ArtifactSidebarTypesDocument, options);
        }
// @ts-ignore
export function useArtifactSidebarTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactSidebarTypesQuery, ArtifactSidebarTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactSidebarTypesQuery, ArtifactSidebarTypesQueryVariables>;
export function useArtifactSidebarTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactSidebarTypesQuery, ArtifactSidebarTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactSidebarTypesQuery | undefined, ArtifactSidebarTypesQueryVariables>;
export function useArtifactSidebarTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactSidebarTypesQuery, ArtifactSidebarTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactSidebarTypesQuery, ArtifactSidebarTypesQueryVariables>(ArtifactSidebarTypesDocument, options);
        }
export type ArtifactSidebarTypesQueryHookResult = ReturnType<typeof useArtifactSidebarTypesQuery>;
export type ArtifactSidebarTypesLazyQueryHookResult = ReturnType<typeof useArtifactSidebarTypesLazyQuery>;
export type ArtifactSidebarTypesSuspenseQueryHookResult = ReturnType<typeof useArtifactSidebarTypesSuspenseQuery>;
export type ArtifactSidebarTypesQueryResult = ApolloReactCommon.QueryResult<ArtifactSidebarTypesQuery, ArtifactSidebarTypesQueryVariables>;
export const ArtifactProjectMetadataSearchDocument = gql`
    query ArtifactProjectMetadataSearch($projectName: String!, $entityName: String!, $filters: JSONString!) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifacts(filters: $filters) {
      id
      digest
      aliases {
        id
        alias
      }
      versionIndex
      artifactSequence {
        id
        name
      }
      artifactType {
        id
        name
      }
      createdAt
    }
  }
}
    `;

/**
 * __useArtifactProjectMetadataSearchQuery__
 *
 * To run a query within a React component, call `useArtifactProjectMetadataSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactProjectMetadataSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactProjectMetadataSearchQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useArtifactProjectMetadataSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables> & ({ variables: ArtifactProjectMetadataSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables>(ArtifactProjectMetadataSearchDocument, options);
      }
export function useArtifactProjectMetadataSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables>(ArtifactProjectMetadataSearchDocument, options);
        }
// @ts-ignore
export function useArtifactProjectMetadataSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables>;
export function useArtifactProjectMetadataSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactProjectMetadataSearchQuery | undefined, ArtifactProjectMetadataSearchQueryVariables>;
export function useArtifactProjectMetadataSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables>(ArtifactProjectMetadataSearchDocument, options);
        }
export type ArtifactProjectMetadataSearchQueryHookResult = ReturnType<typeof useArtifactProjectMetadataSearchQuery>;
export type ArtifactProjectMetadataSearchLazyQueryHookResult = ReturnType<typeof useArtifactProjectMetadataSearchLazyQuery>;
export type ArtifactProjectMetadataSearchSuspenseQueryHookResult = ReturnType<typeof useArtifactProjectMetadataSearchSuspenseQuery>;
export type ArtifactProjectMetadataSearchQueryResult = ApolloReactCommon.QueryResult<ArtifactProjectMetadataSearchQuery, ArtifactProjectMetadataSearchQueryVariables>;
export const FetchOrgAutomationHistoryDocument = gql`
    query FetchOrgAutomationHistory($orgName: String!, $triggerID: ID, $first: Int, $after: String, $order: String = "-created_at", $filters: JSONString) {
  organization(name: $orgName) {
    id
    triggerExecutions(
      triggerID: $triggerID
      first: $first
      after: $after
      order: $order
      filters: $filters
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          ...TriggerExecutionFragment
        }
      }
    }
  }
}
    ${TriggerExecutionFragmentFragmentDoc}`;

/**
 * __useFetchOrgAutomationHistoryQuery__
 *
 * To run a query within a React component, call `useFetchOrgAutomationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOrgAutomationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOrgAutomationHistoryQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      triggerID: // value for 'triggerID'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchOrgAutomationHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchOrgAutomationHistoryQuery, FetchOrgAutomationHistoryQueryVariables> & ({ variables: FetchOrgAutomationHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchOrgAutomationHistoryQuery, FetchOrgAutomationHistoryQueryVariables>(FetchOrgAutomationHistoryDocument, options);
      }
export function useFetchOrgAutomationHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchOrgAutomationHistoryQuery, FetchOrgAutomationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchOrgAutomationHistoryQuery, FetchOrgAutomationHistoryQueryVariables>(FetchOrgAutomationHistoryDocument, options);
        }
// @ts-ignore
export function useFetchOrgAutomationHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchOrgAutomationHistoryQuery, FetchOrgAutomationHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchOrgAutomationHistoryQuery, FetchOrgAutomationHistoryQueryVariables>;
export function useFetchOrgAutomationHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchOrgAutomationHistoryQuery, FetchOrgAutomationHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchOrgAutomationHistoryQuery | undefined, FetchOrgAutomationHistoryQueryVariables>;
export function useFetchOrgAutomationHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchOrgAutomationHistoryQuery, FetchOrgAutomationHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchOrgAutomationHistoryQuery, FetchOrgAutomationHistoryQueryVariables>(FetchOrgAutomationHistoryDocument, options);
        }
export type FetchOrgAutomationHistoryQueryHookResult = ReturnType<typeof useFetchOrgAutomationHistoryQuery>;
export type FetchOrgAutomationHistoryLazyQueryHookResult = ReturnType<typeof useFetchOrgAutomationHistoryLazyQuery>;
export type FetchOrgAutomationHistorySuspenseQueryHookResult = ReturnType<typeof useFetchOrgAutomationHistorySuspenseQuery>;
export type FetchOrgAutomationHistoryQueryResult = ApolloReactCommon.QueryResult<FetchOrgAutomationHistoryQuery, FetchOrgAutomationHistoryQueryVariables>;
export const FetchOrgScopeTargetsDocument = gql`
    query FetchOrgScopeTargets($orgName: String!, $viewerUsername: String!, $viewerId: ID!) {
  organization(name: $orgName) {
    id
    name
    member(username: $viewerUsername) {
      id
      role
    }
    orgEntity {
      id
      name
    }
    teams {
      id
      name
      member(id: $viewerId) {
        id
        role
        memberRole {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFetchOrgScopeTargetsQuery__
 *
 * To run a query within a React component, call `useFetchOrgScopeTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOrgScopeTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOrgScopeTargetsQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      viewerUsername: // value for 'viewerUsername'
 *      viewerId: // value for 'viewerId'
 *   },
 * });
 */
export function useFetchOrgScopeTargetsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchOrgScopeTargetsQuery, FetchOrgScopeTargetsQueryVariables> & ({ variables: FetchOrgScopeTargetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchOrgScopeTargetsQuery, FetchOrgScopeTargetsQueryVariables>(FetchOrgScopeTargetsDocument, options);
      }
export function useFetchOrgScopeTargetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchOrgScopeTargetsQuery, FetchOrgScopeTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchOrgScopeTargetsQuery, FetchOrgScopeTargetsQueryVariables>(FetchOrgScopeTargetsDocument, options);
        }
// @ts-ignore
export function useFetchOrgScopeTargetsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchOrgScopeTargetsQuery, FetchOrgScopeTargetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchOrgScopeTargetsQuery, FetchOrgScopeTargetsQueryVariables>;
export function useFetchOrgScopeTargetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchOrgScopeTargetsQuery, FetchOrgScopeTargetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchOrgScopeTargetsQuery | undefined, FetchOrgScopeTargetsQueryVariables>;
export function useFetchOrgScopeTargetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchOrgScopeTargetsQuery, FetchOrgScopeTargetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchOrgScopeTargetsQuery, FetchOrgScopeTargetsQueryVariables>(FetchOrgScopeTargetsDocument, options);
        }
export type FetchOrgScopeTargetsQueryHookResult = ReturnType<typeof useFetchOrgScopeTargetsQuery>;
export type FetchOrgScopeTargetsLazyQueryHookResult = ReturnType<typeof useFetchOrgScopeTargetsLazyQuery>;
export type FetchOrgScopeTargetsSuspenseQueryHookResult = ReturnType<typeof useFetchOrgScopeTargetsSuspenseQuery>;
export type FetchOrgScopeTargetsQueryResult = ApolloReactCommon.QueryResult<FetchOrgScopeTargetsQuery, FetchOrgScopeTargetsQueryVariables>;
export const FetchOrgAutomationsDocument = gql`
    query FetchOrgAutomations($orgName: String!, $first: Int = 20, $after: String, $order: String = "-created_at", $filters: JSONString) {
  organization(name: $orgName) {
    id
    triggers(first: $first, after: $after, order: $order, filters: $filters) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          ...TriggerFragment
        }
      }
    }
  }
}
    ${TriggerFragmentFragmentDoc}`;

/**
 * __useFetchOrgAutomationsQuery__
 *
 * To run a query within a React component, call `useFetchOrgAutomationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOrgAutomationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOrgAutomationsQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchOrgAutomationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchOrgAutomationsQuery, FetchOrgAutomationsQueryVariables> & ({ variables: FetchOrgAutomationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchOrgAutomationsQuery, FetchOrgAutomationsQueryVariables>(FetchOrgAutomationsDocument, options);
      }
export function useFetchOrgAutomationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchOrgAutomationsQuery, FetchOrgAutomationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchOrgAutomationsQuery, FetchOrgAutomationsQueryVariables>(FetchOrgAutomationsDocument, options);
        }
// @ts-ignore
export function useFetchOrgAutomationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchOrgAutomationsQuery, FetchOrgAutomationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchOrgAutomationsQuery, FetchOrgAutomationsQueryVariables>;
export function useFetchOrgAutomationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchOrgAutomationsQuery, FetchOrgAutomationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchOrgAutomationsQuery | undefined, FetchOrgAutomationsQueryVariables>;
export function useFetchOrgAutomationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchOrgAutomationsQuery, FetchOrgAutomationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchOrgAutomationsQuery, FetchOrgAutomationsQueryVariables>(FetchOrgAutomationsDocument, options);
        }
export type FetchOrgAutomationsQueryHookResult = ReturnType<typeof useFetchOrgAutomationsQuery>;
export type FetchOrgAutomationsLazyQueryHookResult = ReturnType<typeof useFetchOrgAutomationsLazyQuery>;
export type FetchOrgAutomationsSuspenseQueryHookResult = ReturnType<typeof useFetchOrgAutomationsSuspenseQuery>;
export type FetchOrgAutomationsQueryResult = ApolloReactCommon.QueryResult<FetchOrgAutomationsQuery, FetchOrgAutomationsQueryVariables>;
export const TeamProjectsRunsV2StatusDocument = gql`
    query TeamProjectsRunsV2Status($entityName: String) {
  entity(name: $entityName) {
    id
    projects(first: 50, order: "-last_active") {
      edges {
        node {
          id
          fromV2
        }
      }
    }
  }
}
    `;

/**
 * __useTeamProjectsRunsV2StatusQuery__
 *
 * To run a query within a React component, call `useTeamProjectsRunsV2StatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamProjectsRunsV2StatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamProjectsRunsV2StatusQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useTeamProjectsRunsV2StatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamProjectsRunsV2StatusQuery, TeamProjectsRunsV2StatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamProjectsRunsV2StatusQuery, TeamProjectsRunsV2StatusQueryVariables>(TeamProjectsRunsV2StatusDocument, options);
      }
export function useTeamProjectsRunsV2StatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamProjectsRunsV2StatusQuery, TeamProjectsRunsV2StatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamProjectsRunsV2StatusQuery, TeamProjectsRunsV2StatusQueryVariables>(TeamProjectsRunsV2StatusDocument, options);
        }
// @ts-ignore
export function useTeamProjectsRunsV2StatusSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamProjectsRunsV2StatusQuery, TeamProjectsRunsV2StatusQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamProjectsRunsV2StatusQuery, TeamProjectsRunsV2StatusQueryVariables>;
export function useTeamProjectsRunsV2StatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamProjectsRunsV2StatusQuery, TeamProjectsRunsV2StatusQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamProjectsRunsV2StatusQuery | undefined, TeamProjectsRunsV2StatusQueryVariables>;
export function useTeamProjectsRunsV2StatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamProjectsRunsV2StatusQuery, TeamProjectsRunsV2StatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamProjectsRunsV2StatusQuery, TeamProjectsRunsV2StatusQueryVariables>(TeamProjectsRunsV2StatusDocument, options);
        }
export type TeamProjectsRunsV2StatusQueryHookResult = ReturnType<typeof useTeamProjectsRunsV2StatusQuery>;
export type TeamProjectsRunsV2StatusLazyQueryHookResult = ReturnType<typeof useTeamProjectsRunsV2StatusLazyQuery>;
export type TeamProjectsRunsV2StatusSuspenseQueryHookResult = ReturnType<typeof useTeamProjectsRunsV2StatusSuspenseQuery>;
export type TeamProjectsRunsV2StatusQueryResult = ApolloReactCommon.QueryResult<TeamProjectsRunsV2StatusQuery, TeamProjectsRunsV2StatusQueryVariables>;
export const DeleteRunChildrenDocument = gql`
    query DeleteRunChildren($entityName: String!, $projectName: String!, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      descendantRuns {
        runs {
          id
          name
          displayName
        }
      }
    }
  }
}
    `;

/**
 * __useDeleteRunChildrenQuery__
 *
 * To run a query within a React component, call `useDeleteRunChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeleteRunChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeleteRunChildrenQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useDeleteRunChildrenQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DeleteRunChildrenQuery, DeleteRunChildrenQueryVariables> & ({ variables: DeleteRunChildrenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DeleteRunChildrenQuery, DeleteRunChildrenQueryVariables>(DeleteRunChildrenDocument, options);
      }
export function useDeleteRunChildrenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DeleteRunChildrenQuery, DeleteRunChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DeleteRunChildrenQuery, DeleteRunChildrenQueryVariables>(DeleteRunChildrenDocument, options);
        }
// @ts-ignore
export function useDeleteRunChildrenSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DeleteRunChildrenQuery, DeleteRunChildrenQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DeleteRunChildrenQuery, DeleteRunChildrenQueryVariables>;
export function useDeleteRunChildrenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DeleteRunChildrenQuery, DeleteRunChildrenQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DeleteRunChildrenQuery | undefined, DeleteRunChildrenQueryVariables>;
export function useDeleteRunChildrenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DeleteRunChildrenQuery, DeleteRunChildrenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DeleteRunChildrenQuery, DeleteRunChildrenQueryVariables>(DeleteRunChildrenDocument, options);
        }
export type DeleteRunChildrenQueryHookResult = ReturnType<typeof useDeleteRunChildrenQuery>;
export type DeleteRunChildrenLazyQueryHookResult = ReturnType<typeof useDeleteRunChildrenLazyQuery>;
export type DeleteRunChildrenSuspenseQueryHookResult = ReturnType<typeof useDeleteRunChildrenSuspenseQuery>;
export type DeleteRunChildrenQueryResult = ApolloReactCommon.QueryResult<DeleteRunChildrenQuery, DeleteRunChildrenQueryVariables>;
export const EotfOrganizationSubscriptionsBasicInfoDocument = gql`
    query EOTFOrganizationSubscriptionsBasicInfo($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    name
    subscriptions {
      id
      expiresAt
      plan {
        id
        name
        planType
      }
    }
  }
}
    `;

/**
 * __useEotfOrganizationSubscriptionsBasicInfoQuery__
 *
 * To run a query within a React component, call `useEotfOrganizationSubscriptionsBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEotfOrganizationSubscriptionsBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEotfOrganizationSubscriptionsBasicInfoQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useEotfOrganizationSubscriptionsBasicInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables> & ({ variables: EotfOrganizationSubscriptionsBasicInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables>(EotfOrganizationSubscriptionsBasicInfoDocument, options);
      }
export function useEotfOrganizationSubscriptionsBasicInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables>(EotfOrganizationSubscriptionsBasicInfoDocument, options);
        }
// @ts-ignore
export function useEotfOrganizationSubscriptionsBasicInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables>;
export function useEotfOrganizationSubscriptionsBasicInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EotfOrganizationSubscriptionsBasicInfoQuery | undefined, EotfOrganizationSubscriptionsBasicInfoQueryVariables>;
export function useEotfOrganizationSubscriptionsBasicInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables>(EotfOrganizationSubscriptionsBasicInfoDocument, options);
        }
export type EotfOrganizationSubscriptionsBasicInfoQueryHookResult = ReturnType<typeof useEotfOrganizationSubscriptionsBasicInfoQuery>;
export type EotfOrganizationSubscriptionsBasicInfoLazyQueryHookResult = ReturnType<typeof useEotfOrganizationSubscriptionsBasicInfoLazyQuery>;
export type EotfOrganizationSubscriptionsBasicInfoSuspenseQueryHookResult = ReturnType<typeof useEotfOrganizationSubscriptionsBasicInfoSuspenseQuery>;
export type EotfOrganizationSubscriptionsBasicInfoQueryResult = ApolloReactCommon.QueryResult<EotfOrganizationSubscriptionsBasicInfoQuery, EotfOrganizationSubscriptionsBasicInfoQueryVariables>;
export const GlobalBannerDocument = gql`
    query GlobalBanner {
  viewer {
    id
    organizations {
      id
      name
      billingUser {
        id
        username
        email
      }
      flags
      usedSeats
      subscriptions {
        id
        subscriptionType
        status
        expiresAt
        privileges
        plan {
          id
          name
          planType
        }
        seats
        isAutomaticUpgrade
        billingPeriodStart
        expansionPacks {
          edges {
            node {
              id
              secondsLimit
              expiresAt
            }
          }
        }
      }
      teams {
        id
        name
        computeHours
        oldComputeHours: computeHours(minDaysOld: 14)
      }
      members {
        id
        username
        role
      }
    }
  }
}
    `;

/**
 * __useGlobalBannerQuery__
 *
 * To run a query within a React component, call `useGlobalBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalBannerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlobalBannerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GlobalBannerQuery, GlobalBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlobalBannerQuery, GlobalBannerQueryVariables>(GlobalBannerDocument, options);
      }
export function useGlobalBannerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalBannerQuery, GlobalBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlobalBannerQuery, GlobalBannerQueryVariables>(GlobalBannerDocument, options);
        }
// @ts-ignore
export function useGlobalBannerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GlobalBannerQuery, GlobalBannerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalBannerQuery, GlobalBannerQueryVariables>;
export function useGlobalBannerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalBannerQuery, GlobalBannerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalBannerQuery | undefined, GlobalBannerQueryVariables>;
export function useGlobalBannerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalBannerQuery, GlobalBannerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlobalBannerQuery, GlobalBannerQueryVariables>(GlobalBannerDocument, options);
        }
export type GlobalBannerQueryHookResult = ReturnType<typeof useGlobalBannerQuery>;
export type GlobalBannerLazyQueryHookResult = ReturnType<typeof useGlobalBannerLazyQuery>;
export type GlobalBannerSuspenseQueryHookResult = ReturnType<typeof useGlobalBannerSuspenseQuery>;
export type GlobalBannerQueryResult = ApolloReactCommon.QueryResult<GlobalBannerQuery, GlobalBannerQueryVariables>;
export const ProjectFromNameDocument = gql`
    query ProjectFromName($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    name
    entityName
  }
}
    `;

/**
 * __useProjectFromNameQuery__
 *
 * To run a query within a React component, call `useProjectFromNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFromNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFromNameQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useProjectFromNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectFromNameQuery, ProjectFromNameQueryVariables> & ({ variables: ProjectFromNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectFromNameQuery, ProjectFromNameQueryVariables>(ProjectFromNameDocument, options);
      }
export function useProjectFromNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectFromNameQuery, ProjectFromNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectFromNameQuery, ProjectFromNameQueryVariables>(ProjectFromNameDocument, options);
        }
// @ts-ignore
export function useProjectFromNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectFromNameQuery, ProjectFromNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectFromNameQuery, ProjectFromNameQueryVariables>;
export function useProjectFromNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectFromNameQuery, ProjectFromNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectFromNameQuery | undefined, ProjectFromNameQueryVariables>;
export function useProjectFromNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectFromNameQuery, ProjectFromNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectFromNameQuery, ProjectFromNameQueryVariables>(ProjectFromNameDocument, options);
        }
export type ProjectFromNameQueryHookResult = ReturnType<typeof useProjectFromNameQuery>;
export type ProjectFromNameLazyQueryHookResult = ReturnType<typeof useProjectFromNameLazyQuery>;
export type ProjectFromNameSuspenseQueryHookResult = ReturnType<typeof useProjectFromNameSuspenseQuery>;
export type ProjectFromNameQueryResult = ApolloReactCommon.QueryResult<ProjectFromNameQuery, ProjectFromNameQueryVariables>;
export const AutomationsProjectsDocument = gql`
    query AutomationsProjects($orgID: ID!, $first: Int = 100, $pattern: String) {
  organization(id: $orgID) {
    id
    projects(first: $first, order: "-created_at", pattern: $pattern) {
      edges {
        node {
          id
          name
          entityName
        }
      }
    }
  }
}
    `;

/**
 * __useAutomationsProjectsQuery__
 *
 * To run a query within a React component, call `useAutomationsProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationsProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutomationsProjectsQuery({
 *   variables: {
 *      orgID: // value for 'orgID'
 *      first: // value for 'first'
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useAutomationsProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AutomationsProjectsQuery, AutomationsProjectsQueryVariables> & ({ variables: AutomationsProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AutomationsProjectsQuery, AutomationsProjectsQueryVariables>(AutomationsProjectsDocument, options);
      }
export function useAutomationsProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AutomationsProjectsQuery, AutomationsProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AutomationsProjectsQuery, AutomationsProjectsQueryVariables>(AutomationsProjectsDocument, options);
        }
// @ts-ignore
export function useAutomationsProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AutomationsProjectsQuery, AutomationsProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AutomationsProjectsQuery, AutomationsProjectsQueryVariables>;
export function useAutomationsProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AutomationsProjectsQuery, AutomationsProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AutomationsProjectsQuery | undefined, AutomationsProjectsQueryVariables>;
export function useAutomationsProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AutomationsProjectsQuery, AutomationsProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AutomationsProjectsQuery, AutomationsProjectsQueryVariables>(AutomationsProjectsDocument, options);
        }
export type AutomationsProjectsQueryHookResult = ReturnType<typeof useAutomationsProjectsQuery>;
export type AutomationsProjectsLazyQueryHookResult = ReturnType<typeof useAutomationsProjectsLazyQuery>;
export type AutomationsProjectsSuspenseQueryHookResult = ReturnType<typeof useAutomationsProjectsSuspenseQuery>;
export type AutomationsProjectsQueryResult = ApolloReactCommon.QueryResult<AutomationsProjectsQuery, AutomationsProjectsQueryVariables>;
export const EntityArtifactTypeDocument = gql`
    query EntityArtifactType($entityName: String!, $artifactType: String!) {
  entity(name: $entityName) {
    id
    projects {
      edges {
        node {
          id
          name
          artifactType(name: $artifactType) {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useEntityArtifactTypeQuery__
 *
 * To run a query within a React component, call `useEntityArtifactTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityArtifactTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityArtifactTypeQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      artifactType: // value for 'artifactType'
 *   },
 * });
 */
export function useEntityArtifactTypeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables> & ({ variables: EntityArtifactTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables>(EntityArtifactTypeDocument, options);
      }
export function useEntityArtifactTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables>(EntityArtifactTypeDocument, options);
        }
// @ts-ignore
export function useEntityArtifactTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables>;
export function useEntityArtifactTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityArtifactTypeQuery | undefined, EntityArtifactTypeQueryVariables>;
export function useEntityArtifactTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables>(EntityArtifactTypeDocument, options);
        }
export type EntityArtifactTypeQueryHookResult = ReturnType<typeof useEntityArtifactTypeQuery>;
export type EntityArtifactTypeLazyQueryHookResult = ReturnType<typeof useEntityArtifactTypeLazyQuery>;
export type EntityArtifactTypeSuspenseQueryHookResult = ReturnType<typeof useEntityArtifactTypeSuspenseQuery>;
export type EntityArtifactTypeQueryResult = ApolloReactCommon.QueryResult<EntityArtifactTypeQuery, EntityArtifactTypeQueryVariables>;
export const FetchProjectJobsForTriggersPartialDocument = gql`
    query FetchProjectJobsForTriggersPartial($entityName: String!, $projectName: String!, $limit: Int!, $after: String) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    artifactType(name: "job") {
      id
      artifactCollections(first: $limit, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            name
            createdAt
            project {
              id
              name
              access
              entity {
                id
                name
              }
            }
            artifacts {
              edges {
                node {
                  id
                  createdAt
                  description
                  labels
                  versionIndex
                  aliases {
                    id
                    alias
                  }
                  createdBy {
                    __typename
                    ... on User {
                      id
                      name
                      username
                      photoUrl
                    }
                    ... on Run {
                      id
                      name
                      config
                    }
                  }
                  usedBy(order: "-createdAt") {
                    totalCount
                    edges {
                      node {
                        id
                        name
                        displayName
                        state
                        createdAt
                        user {
                          id
                          name
                          username
                          photoUrl
                        }
                        config
                        defaultColorIndex
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchProjectJobsForTriggersPartialQuery__
 *
 * To run a query within a React component, call `useFetchProjectJobsForTriggersPartialQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectJobsForTriggersPartialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectJobsForTriggersPartialQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFetchProjectJobsForTriggersPartialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables> & ({ variables: FetchProjectJobsForTriggersPartialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables>(FetchProjectJobsForTriggersPartialDocument, options);
      }
export function useFetchProjectJobsForTriggersPartialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables>(FetchProjectJobsForTriggersPartialDocument, options);
        }
// @ts-ignore
export function useFetchProjectJobsForTriggersPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables>;
export function useFetchProjectJobsForTriggersPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectJobsForTriggersPartialQuery | undefined, FetchProjectJobsForTriggersPartialQueryVariables>;
export function useFetchProjectJobsForTriggersPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables>(FetchProjectJobsForTriggersPartialDocument, options);
        }
export type FetchProjectJobsForTriggersPartialQueryHookResult = ReturnType<typeof useFetchProjectJobsForTriggersPartialQuery>;
export type FetchProjectJobsForTriggersPartialLazyQueryHookResult = ReturnType<typeof useFetchProjectJobsForTriggersPartialLazyQuery>;
export type FetchProjectJobsForTriggersPartialSuspenseQueryHookResult = ReturnType<typeof useFetchProjectJobsForTriggersPartialSuspenseQuery>;
export type FetchProjectJobsForTriggersPartialQueryResult = ApolloReactCommon.QueryResult<FetchProjectJobsForTriggersPartialQuery, FetchProjectJobsForTriggersPartialQueryVariables>;
export const FetchProjectTriggerExecutionsDocument = gql`
    query FetchProjectTriggerExecutions($entityName: String!, $projectName: String!, $triggerID: ID, $projectOnly: Boolean = false, $first: Int, $after: String, $order: String = "-created_at", $filters: JSONString) {
  project(entityName: $entityName, name: $projectName) {
    id
    triggerExecutions(
      triggerID: $triggerID
      projectOnly: $projectOnly
      first: $first
      after: $after
      order: $order
      filters: $filters
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...TriggerExecutionFragment
        }
      }
    }
  }
}
    ${TriggerExecutionFragmentFragmentDoc}`;

/**
 * __useFetchProjectTriggerExecutionsQuery__
 *
 * To run a query within a React component, call `useFetchProjectTriggerExecutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectTriggerExecutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectTriggerExecutionsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      triggerID: // value for 'triggerID'
 *      projectOnly: // value for 'projectOnly'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchProjectTriggerExecutionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables> & ({ variables: FetchProjectTriggerExecutionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables>(FetchProjectTriggerExecutionsDocument, options);
      }
export function useFetchProjectTriggerExecutionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables>(FetchProjectTriggerExecutionsDocument, options);
        }
// @ts-ignore
export function useFetchProjectTriggerExecutionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables>;
export function useFetchProjectTriggerExecutionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectTriggerExecutionsQuery | undefined, FetchProjectTriggerExecutionsQueryVariables>;
export function useFetchProjectTriggerExecutionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables>(FetchProjectTriggerExecutionsDocument, options);
        }
export type FetchProjectTriggerExecutionsQueryHookResult = ReturnType<typeof useFetchProjectTriggerExecutionsQuery>;
export type FetchProjectTriggerExecutionsLazyQueryHookResult = ReturnType<typeof useFetchProjectTriggerExecutionsLazyQuery>;
export type FetchProjectTriggerExecutionsSuspenseQueryHookResult = ReturnType<typeof useFetchProjectTriggerExecutionsSuspenseQuery>;
export type FetchProjectTriggerExecutionsQueryResult = ApolloReactCommon.QueryResult<FetchProjectTriggerExecutionsQuery, FetchProjectTriggerExecutionsQueryVariables>;
export const CreateFilterTriggerDocument = gql`
    mutation createFilterTrigger($name: String!, $description: String, $triggeringEventType: EventTriggeringConditionType!, $scopeType: TriggerScopeType!, $scopeID: ID!, $eventFilter: JSONString!, $triggeredActionType: TriggeredActionType!, $triggeredActionConfig: TriggeredActionConfig!, $enabled: Boolean!) {
  createFilterTrigger(
    input: {name: $name, description: $description, triggeringEventType: $triggeringEventType, scopeType: $scopeType, scopeID: $scopeID, eventFilter: $eventFilter, triggeredActionType: $triggeredActionType, triggeredActionConfig: $triggeredActionConfig, enabled: $enabled}
  ) {
    trigger {
      id
    }
  }
}
    `;
export type CreateFilterTriggerMutationFn = ApolloReactCommon.MutationFunction<CreateFilterTriggerMutation, CreateFilterTriggerMutationVariables>;

/**
 * __useCreateFilterTriggerMutation__
 *
 * To run a mutation, you first call `useCreateFilterTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFilterTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFilterTriggerMutation, { data, loading, error }] = useCreateFilterTriggerMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      triggeringEventType: // value for 'triggeringEventType'
 *      scopeType: // value for 'scopeType'
 *      scopeID: // value for 'scopeID'
 *      eventFilter: // value for 'eventFilter'
 *      triggeredActionType: // value for 'triggeredActionType'
 *      triggeredActionConfig: // value for 'triggeredActionConfig'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useCreateFilterTriggerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFilterTriggerMutation, CreateFilterTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateFilterTriggerMutation, CreateFilterTriggerMutationVariables>(CreateFilterTriggerDocument, options);
      }
export type CreateFilterTriggerMutationHookResult = ReturnType<typeof useCreateFilterTriggerMutation>;
export type CreateFilterTriggerMutationResult = ApolloReactCommon.MutationResult<CreateFilterTriggerMutation>;
export type CreateFilterTriggerMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateFilterTriggerMutation, CreateFilterTriggerMutationVariables>;
export const UpdateFilterTriggerDocument = gql`
    mutation updateFilterTrigger($triggerID: ID!, $name: String!, $description: String, $triggeringEventType: EventTriggeringConditionType!, $scopeType: TriggerScopeType!, $scopeID: ID!, $eventFilter: JSONString!, $triggeredActionType: TriggeredActionType!, $triggeredActionConfig: TriggeredActionConfig!, $enabled: Boolean!, $clientMutationId: String) {
  updateFilterTrigger(
    input: {id: $triggerID, name: $name, description: $description, triggeringEventType: $triggeringEventType, scopeType: $scopeType, scopeID: $scopeID, eventFilter: $eventFilter, triggeredActionType: $triggeredActionType, triggeredActionConfig: $triggeredActionConfig, enabled: $enabled, clientMutationId: $clientMutationId}
  ) {
    trigger {
      id
    }
    clientMutationId
  }
}
    `;
export type UpdateFilterTriggerMutationFn = ApolloReactCommon.MutationFunction<UpdateFilterTriggerMutation, UpdateFilterTriggerMutationVariables>;

/**
 * __useUpdateFilterTriggerMutation__
 *
 * To run a mutation, you first call `useUpdateFilterTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFilterTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFilterTriggerMutation, { data, loading, error }] = useUpdateFilterTriggerMutation({
 *   variables: {
 *      triggerID: // value for 'triggerID'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      triggeringEventType: // value for 'triggeringEventType'
 *      scopeType: // value for 'scopeType'
 *      scopeID: // value for 'scopeID'
 *      eventFilter: // value for 'eventFilter'
 *      triggeredActionType: // value for 'triggeredActionType'
 *      triggeredActionConfig: // value for 'triggeredActionConfig'
 *      enabled: // value for 'enabled'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateFilterTriggerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFilterTriggerMutation, UpdateFilterTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateFilterTriggerMutation, UpdateFilterTriggerMutationVariables>(UpdateFilterTriggerDocument, options);
      }
export type UpdateFilterTriggerMutationHookResult = ReturnType<typeof useUpdateFilterTriggerMutation>;
export type UpdateFilterTriggerMutationResult = ApolloReactCommon.MutationResult<UpdateFilterTriggerMutation>;
export type UpdateFilterTriggerMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateFilterTriggerMutation, UpdateFilterTriggerMutationVariables>;
export const FetchProjectTriggersDocument = gql`
    query FetchProjectTriggers($entityName: String!, $projectName: String!, $projectOnly: Boolean) {
  project(name: $projectName, entityName: $entityName) {
    id
    triggers(projectOnly: $projectOnly) {
      ...TriggerFragment
    }
  }
}
    ${TriggerFragmentFragmentDoc}`;

/**
 * __useFetchProjectTriggersQuery__
 *
 * To run a query within a React component, call `useFetchProjectTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectTriggersQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      projectOnly: // value for 'projectOnly'
 *   },
 * });
 */
export function useFetchProjectTriggersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables> & ({ variables: FetchProjectTriggersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables>(FetchProjectTriggersDocument, options);
      }
export function useFetchProjectTriggersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables>(FetchProjectTriggersDocument, options);
        }
// @ts-ignore
export function useFetchProjectTriggersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables>;
export function useFetchProjectTriggersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectTriggersQuery | undefined, FetchProjectTriggersQueryVariables>;
export function useFetchProjectTriggersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables>(FetchProjectTriggersDocument, options);
        }
export type FetchProjectTriggersQueryHookResult = ReturnType<typeof useFetchProjectTriggersQuery>;
export type FetchProjectTriggersLazyQueryHookResult = ReturnType<typeof useFetchProjectTriggersLazyQuery>;
export type FetchProjectTriggersSuspenseQueryHookResult = ReturnType<typeof useFetchProjectTriggersSuspenseQuery>;
export type FetchProjectTriggersQueryResult = ApolloReactCommon.QueryResult<FetchProjectTriggersQuery, FetchProjectTriggersQueryVariables>;
export const FetchArtifactCollectionTriggersDocument = gql`
    query FetchArtifactCollectionTriggers($artifactCollectionID: ID!) {
  artifactCollection(id: $artifactCollectionID) {
    id
    name
    triggers {
      edges {
        node {
          ...TriggerFragment
        }
      }
    }
  }
}
    ${TriggerFragmentFragmentDoc}`;

/**
 * __useFetchArtifactCollectionTriggersQuery__
 *
 * To run a query within a React component, call `useFetchArtifactCollectionTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchArtifactCollectionTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchArtifactCollectionTriggersQuery({
 *   variables: {
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *   },
 * });
 */
export function useFetchArtifactCollectionTriggersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables> & ({ variables: FetchArtifactCollectionTriggersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables>(FetchArtifactCollectionTriggersDocument, options);
      }
export function useFetchArtifactCollectionTriggersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables>(FetchArtifactCollectionTriggersDocument, options);
        }
// @ts-ignore
export function useFetchArtifactCollectionTriggersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables>;
export function useFetchArtifactCollectionTriggersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchArtifactCollectionTriggersQuery | undefined, FetchArtifactCollectionTriggersQueryVariables>;
export function useFetchArtifactCollectionTriggersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables>(FetchArtifactCollectionTriggersDocument, options);
        }
export type FetchArtifactCollectionTriggersQueryHookResult = ReturnType<typeof useFetchArtifactCollectionTriggersQuery>;
export type FetchArtifactCollectionTriggersLazyQueryHookResult = ReturnType<typeof useFetchArtifactCollectionTriggersLazyQuery>;
export type FetchArtifactCollectionTriggersSuspenseQueryHookResult = ReturnType<typeof useFetchArtifactCollectionTriggersSuspenseQuery>;
export type FetchArtifactCollectionTriggersQueryResult = ApolloReactCommon.QueryResult<FetchArtifactCollectionTriggersQuery, FetchArtifactCollectionTriggersQueryVariables>;
export const DeleteTriggerDocument = gql`
    mutation DeleteTrigger($triggerID: ID!) {
  deleteTrigger(input: {triggerID: $triggerID}) {
    success
  }
}
    `;
export type DeleteTriggerMutationFn = ApolloReactCommon.MutationFunction<DeleteTriggerMutation, DeleteTriggerMutationVariables>;

/**
 * __useDeleteTriggerMutation__
 *
 * To run a mutation, you first call `useDeleteTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTriggerMutation, { data, loading, error }] = useDeleteTriggerMutation({
 *   variables: {
 *      triggerID: // value for 'triggerID'
 *   },
 * });
 */
export function useDeleteTriggerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTriggerMutation, DeleteTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTriggerMutation, DeleteTriggerMutationVariables>(DeleteTriggerDocument, options);
      }
export type DeleteTriggerMutationHookResult = ReturnType<typeof useDeleteTriggerMutation>;
export type DeleteTriggerMutationResult = ApolloReactCommon.MutationResult<DeleteTriggerMutation>;
export type DeleteTriggerMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteTriggerMutation, DeleteTriggerMutationVariables>;
export const FetchTriggerTemplateVariablesDocument = gql`
    query FetchTriggerTemplateVariables($eventType: EventTriggeringConditionType!) {
  triggerTemplateVariables(eventType: $eventType) {
    value: name
    help: description
  }
}
    `;

/**
 * __useFetchTriggerTemplateVariablesQuery__
 *
 * To run a query within a React component, call `useFetchTriggerTemplateVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTriggerTemplateVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTriggerTemplateVariablesQuery({
 *   variables: {
 *      eventType: // value for 'eventType'
 *   },
 * });
 */
export function useFetchTriggerTemplateVariablesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables> & ({ variables: FetchTriggerTemplateVariablesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables>(FetchTriggerTemplateVariablesDocument, options);
      }
export function useFetchTriggerTemplateVariablesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables>(FetchTriggerTemplateVariablesDocument, options);
        }
// @ts-ignore
export function useFetchTriggerTemplateVariablesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables>;
export function useFetchTriggerTemplateVariablesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchTriggerTemplateVariablesQuery | undefined, FetchTriggerTemplateVariablesQueryVariables>;
export function useFetchTriggerTemplateVariablesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables>(FetchTriggerTemplateVariablesDocument, options);
        }
export type FetchTriggerTemplateVariablesQueryHookResult = ReturnType<typeof useFetchTriggerTemplateVariablesQuery>;
export type FetchTriggerTemplateVariablesLazyQueryHookResult = ReturnType<typeof useFetchTriggerTemplateVariablesLazyQuery>;
export type FetchTriggerTemplateVariablesSuspenseQueryHookResult = ReturnType<typeof useFetchTriggerTemplateVariablesSuspenseQuery>;
export type FetchTriggerTemplateVariablesQueryResult = ApolloReactCommon.QueryResult<FetchTriggerTemplateVariablesQuery, FetchTriggerTemplateVariablesQueryVariables>;
export const RunLogLinesDocument = gql`
    query RunLogLines($projectName: String!, $entityName: String, $runName: String!, $last: Int, $before: String, $first: Int, $after: String, $useImprovedPagination: Boolean = false) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      state @include(if: $useImprovedPagination)
      logLines(
        after: $after
        before: $before
        first: $first
        last: $last
        useImprovedPagination: $useImprovedPagination
      ) {
        edges {
          node {
            id
            label
            level
            line
            number
            timestamp
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
          startCursor
        }
      }
    }
  }
}
    `;

/**
 * __useRunLogLinesQuery__
 *
 * To run a query within a React component, call `useRunLogLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunLogLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunLogLinesQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      useImprovedPagination: // value for 'useImprovedPagination'
 *   },
 * });
 */
export function useRunLogLinesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunLogLinesQuery, RunLogLinesQueryVariables> & ({ variables: RunLogLinesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunLogLinesQuery, RunLogLinesQueryVariables>(RunLogLinesDocument, options);
      }
export function useRunLogLinesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunLogLinesQuery, RunLogLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunLogLinesQuery, RunLogLinesQueryVariables>(RunLogLinesDocument, options);
        }
// @ts-ignore
export function useRunLogLinesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunLogLinesQuery, RunLogLinesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunLogLinesQuery, RunLogLinesQueryVariables>;
export function useRunLogLinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunLogLinesQuery, RunLogLinesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunLogLinesQuery | undefined, RunLogLinesQueryVariables>;
export function useRunLogLinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunLogLinesQuery, RunLogLinesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunLogLinesQuery, RunLogLinesQueryVariables>(RunLogLinesDocument, options);
        }
export type RunLogLinesQueryHookResult = ReturnType<typeof useRunLogLinesQuery>;
export type RunLogLinesLazyQueryHookResult = ReturnType<typeof useRunLogLinesLazyQuery>;
export type RunLogLinesSuspenseQueryHookResult = ReturnType<typeof useRunLogLinesSuspenseQuery>;
export type RunLogLinesQueryResult = ApolloReactCommon.QueryResult<RunLogLinesQuery, RunLogLinesQueryVariables>;
export const OrganizationMembersTableDocument = gql`
    query OrganizationMembersTable($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    name
    billingUser {
      id
      username
    }
    members {
      id
      name
      username
      email
      photoUrl
      teams {
        edges {
          node {
            id
            name
          }
        }
      }
      lastActiveAt
      role
      modelsSeat
      weaveRole
    }
    seatAvailability {
      viewOnlySeats
      seats
    }
    teams {
      id
      name
      memberCount
    }
    subscriptions {
      id
      availableSeatsToPurchase
      plan {
        id
        planType
        unitPrice
      }
      privileges
    }
    pendingInvites {
      id
      email
      createdAt
      toUser {
        id
        username
      }
      entity {
        id
        name
      }
      role
    }
  }
}
    `;

/**
 * __useOrganizationMembersTableQuery__
 *
 * To run a query within a React component, call `useOrganizationMembersTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMembersTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMembersTableQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationMembersTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables> & ({ variables: OrganizationMembersTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables>(OrganizationMembersTableDocument, options);
      }
export function useOrganizationMembersTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables>(OrganizationMembersTableDocument, options);
        }
// @ts-ignore
export function useOrganizationMembersTableSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables>;
export function useOrganizationMembersTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMembersTableQuery | undefined, OrganizationMembersTableQueryVariables>;
export function useOrganizationMembersTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables>(OrganizationMembersTableDocument, options);
        }
export type OrganizationMembersTableQueryHookResult = ReturnType<typeof useOrganizationMembersTableQuery>;
export type OrganizationMembersTableLazyQueryHookResult = ReturnType<typeof useOrganizationMembersTableLazyQuery>;
export type OrganizationMembersTableSuspenseQueryHookResult = ReturnType<typeof useOrganizationMembersTableSuspenseQuery>;
export type OrganizationMembersTableQueryResult = ApolloReactCommon.QueryResult<OrganizationMembersTableQuery, OrganizationMembersTableQueryVariables>;
export const WorkspaceSingleRunDocument = gql`
    query WorkspaceSingleRun($projectName: String!, $entityName: String, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      name
      config
      createdAt
      displayName
      defaultColorIndex
      state
      tags: tagColors {
        id
        name
        colorIndex
      }
    }
  }
}
    `;

/**
 * __useWorkspaceSingleRunQuery__
 *
 * To run a query within a React component, call `useWorkspaceSingleRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceSingleRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceSingleRunQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useWorkspaceSingleRunQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables> & ({ variables: WorkspaceSingleRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables>(WorkspaceSingleRunDocument, options);
      }
export function useWorkspaceSingleRunLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables>(WorkspaceSingleRunDocument, options);
        }
// @ts-ignore
export function useWorkspaceSingleRunSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables>;
export function useWorkspaceSingleRunSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspaceSingleRunQuery | undefined, WorkspaceSingleRunQueryVariables>;
export function useWorkspaceSingleRunSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables>(WorkspaceSingleRunDocument, options);
        }
export type WorkspaceSingleRunQueryHookResult = ReturnType<typeof useWorkspaceSingleRunQuery>;
export type WorkspaceSingleRunLazyQueryHookResult = ReturnType<typeof useWorkspaceSingleRunLazyQuery>;
export type WorkspaceSingleRunSuspenseQueryHookResult = ReturnType<typeof useWorkspaceSingleRunSuspenseQuery>;
export type WorkspaceSingleRunQueryResult = ApolloReactCommon.QueryResult<WorkspaceSingleRunQuery, WorkspaceSingleRunQueryVariables>;
export const NotebookQuotaDocument = gql`
    query NotebookQuota($entityName: String!, $projectName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    notebookQuota {
      sandboxCreditExhausted
      storageQuotaExceeded
    }
  }
}
    `;

/**
 * __useNotebookQuotaQuery__
 *
 * To run a query within a React component, call `useNotebookQuotaQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotebookQuotaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotebookQuotaQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useNotebookQuotaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NotebookQuotaQuery, NotebookQuotaQueryVariables> & ({ variables: NotebookQuotaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NotebookQuotaQuery, NotebookQuotaQueryVariables>(NotebookQuotaDocument, options);
      }
export function useNotebookQuotaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NotebookQuotaQuery, NotebookQuotaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NotebookQuotaQuery, NotebookQuotaQueryVariables>(NotebookQuotaDocument, options);
        }
// @ts-ignore
export function useNotebookQuotaSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NotebookQuotaQuery, NotebookQuotaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NotebookQuotaQuery, NotebookQuotaQueryVariables>;
export function useNotebookQuotaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NotebookQuotaQuery, NotebookQuotaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NotebookQuotaQuery | undefined, NotebookQuotaQueryVariables>;
export function useNotebookQuotaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NotebookQuotaQuery, NotebookQuotaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NotebookQuotaQuery, NotebookQuotaQueryVariables>(NotebookQuotaDocument, options);
        }
export type NotebookQuotaQueryHookResult = ReturnType<typeof useNotebookQuotaQuery>;
export type NotebookQuotaLazyQueryHookResult = ReturnType<typeof useNotebookQuotaLazyQuery>;
export type NotebookQuotaSuspenseQueryHookResult = ReturnType<typeof useNotebookQuotaSuspenseQuery>;
export type NotebookQuotaQueryResult = ApolloReactCommon.QueryResult<NotebookQuotaQuery, NotebookQuotaQueryVariables>;
export const CopyNotebookDocument = gql`
    mutation CopyNotebook($entityName: String!, $id: ID!, $projectName: String!) {
  copyNotebook: duplicateNotebook(
    input: {entityName: $entityName, id: $id, projectName: $projectName}
  ) {
    notebook {
      id
      ...NotebookTable_Notebook
    }
  }
}
    ${NotebookTable_NotebookFragmentDoc}`;
export type CopyNotebookMutationFn = ApolloReactCommon.MutationFunction<CopyNotebookMutation, CopyNotebookMutationVariables>;

/**
 * __useCopyNotebookMutation__
 *
 * To run a mutation, you first call `useCopyNotebookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyNotebookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyNotebookMutation, { data, loading, error }] = useCopyNotebookMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      id: // value for 'id'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useCopyNotebookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CopyNotebookMutation, CopyNotebookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CopyNotebookMutation, CopyNotebookMutationVariables>(CopyNotebookDocument, options);
      }
export type CopyNotebookMutationHookResult = ReturnType<typeof useCopyNotebookMutation>;
export type CopyNotebookMutationResult = ApolloReactCommon.MutationResult<CopyNotebookMutation>;
export type CopyNotebookMutationOptions = ApolloReactCommon.BaseMutationOptions<CopyNotebookMutation, CopyNotebookMutationVariables>;
export const DeleteNotebookDocument = gql`
    mutation DeleteNotebook($id: ID!) {
  deleteNotebook(input: {id: $id}) {
    success
  }
}
    `;
export type DeleteNotebookMutationFn = ApolloReactCommon.MutationFunction<DeleteNotebookMutation, DeleteNotebookMutationVariables>;

/**
 * __useDeleteNotebookMutation__
 *
 * To run a mutation, you first call `useDeleteNotebookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotebookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotebookMutation, { data, loading, error }] = useDeleteNotebookMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNotebookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteNotebookMutation, DeleteNotebookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteNotebookMutation, DeleteNotebookMutationVariables>(DeleteNotebookDocument, options);
      }
export type DeleteNotebookMutationHookResult = ReturnType<typeof useDeleteNotebookMutation>;
export type DeleteNotebookMutationResult = ApolloReactCommon.MutationResult<DeleteNotebookMutation>;
export type DeleteNotebookMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteNotebookMutation, DeleteNotebookMutationVariables>;
export const RenameNotebookDocument = gql`
    mutation RenameNotebook($name: String!, $id: ID!) {
  renameNotebook(input: {name: $name, id: $id}) {
    notebook {
      id
      ...NotebookTable_Notebook
    }
  }
}
    ${NotebookTable_NotebookFragmentDoc}`;
export type RenameNotebookMutationFn = ApolloReactCommon.MutationFunction<RenameNotebookMutation, RenameNotebookMutationVariables>;

/**
 * __useRenameNotebookMutation__
 *
 * To run a mutation, you first call `useRenameNotebookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameNotebookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameNotebookMutation, { data, loading, error }] = useRenameNotebookMutation({
 *   variables: {
 *      name: // value for 'name'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRenameNotebookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RenameNotebookMutation, RenameNotebookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RenameNotebookMutation, RenameNotebookMutationVariables>(RenameNotebookDocument, options);
      }
export type RenameNotebookMutationHookResult = ReturnType<typeof useRenameNotebookMutation>;
export type RenameNotebookMutationResult = ApolloReactCommon.MutationResult<RenameNotebookMutation>;
export type RenameNotebookMutationOptions = ApolloReactCommon.BaseMutationOptions<RenameNotebookMutation, RenameNotebookMutationVariables>;
export const NotebookAuthorOptionsDocument = gql`
    query NotebookAuthorOptions($entityName: String!, $organizationId: ID!, $skipEntity: Boolean!, $skipOrganization: Boolean!) {
  entity(name: $entityName) @skip(if: $skipEntity) {
    id
    name
    members {
      id
      role
      name
      pending
      username
    }
  }
  organization(id: $organizationId) @skip(if: $skipOrganization) {
    id
    members {
      id
      name
      username
    }
  }
}
    `;

/**
 * __useNotebookAuthorOptionsQuery__
 *
 * To run a query within a React component, call `useNotebookAuthorOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotebookAuthorOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotebookAuthorOptionsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      organizationId: // value for 'organizationId'
 *      skipEntity: // value for 'skipEntity'
 *      skipOrganization: // value for 'skipOrganization'
 *   },
 * });
 */
export function useNotebookAuthorOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NotebookAuthorOptionsQuery, NotebookAuthorOptionsQueryVariables> & ({ variables: NotebookAuthorOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NotebookAuthorOptionsQuery, NotebookAuthorOptionsQueryVariables>(NotebookAuthorOptionsDocument, options);
      }
export function useNotebookAuthorOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NotebookAuthorOptionsQuery, NotebookAuthorOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NotebookAuthorOptionsQuery, NotebookAuthorOptionsQueryVariables>(NotebookAuthorOptionsDocument, options);
        }
// @ts-ignore
export function useNotebookAuthorOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NotebookAuthorOptionsQuery, NotebookAuthorOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NotebookAuthorOptionsQuery, NotebookAuthorOptionsQueryVariables>;
export function useNotebookAuthorOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NotebookAuthorOptionsQuery, NotebookAuthorOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NotebookAuthorOptionsQuery | undefined, NotebookAuthorOptionsQueryVariables>;
export function useNotebookAuthorOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NotebookAuthorOptionsQuery, NotebookAuthorOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NotebookAuthorOptionsQuery, NotebookAuthorOptionsQueryVariables>(NotebookAuthorOptionsDocument, options);
        }
export type NotebookAuthorOptionsQueryHookResult = ReturnType<typeof useNotebookAuthorOptionsQuery>;
export type NotebookAuthorOptionsLazyQueryHookResult = ReturnType<typeof useNotebookAuthorOptionsLazyQuery>;
export type NotebookAuthorOptionsSuspenseQueryHookResult = ReturnType<typeof useNotebookAuthorOptionsSuspenseQuery>;
export type NotebookAuthorOptionsQueryResult = ApolloReactCommon.QueryResult<NotebookAuthorOptionsQuery, NotebookAuthorOptionsQueryVariables>;
export const ProjectsByTeamDocument = gql`
    query ProjectsByTeam($entityName: String!, $pattern: String, $order: String, $first: Int = 500, $before: String, $after: String) {
  projects(
    first: $first
    entityName: $entityName
    order: $order
    before: $before
    after: $after
    pattern: $pattern
  ) {
    edges {
      node {
        id
        ...ProjectList
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ProjectListFragmentDoc}`;

/**
 * __useProjectsByTeamQuery__
 *
 * To run a query within a React component, call `useProjectsByTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsByTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsByTeamQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      pattern: // value for 'pattern'
 *      order: // value for 'order'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useProjectsByTeamQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectsByTeamQuery, ProjectsByTeamQueryVariables> & ({ variables: ProjectsByTeamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectsByTeamQuery, ProjectsByTeamQueryVariables>(ProjectsByTeamDocument, options);
      }
export function useProjectsByTeamLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectsByTeamQuery, ProjectsByTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectsByTeamQuery, ProjectsByTeamQueryVariables>(ProjectsByTeamDocument, options);
        }
// @ts-ignore
export function useProjectsByTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectsByTeamQuery, ProjectsByTeamQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectsByTeamQuery, ProjectsByTeamQueryVariables>;
export function useProjectsByTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsByTeamQuery, ProjectsByTeamQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectsByTeamQuery | undefined, ProjectsByTeamQueryVariables>;
export function useProjectsByTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsByTeamQuery, ProjectsByTeamQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectsByTeamQuery, ProjectsByTeamQueryVariables>(ProjectsByTeamDocument, options);
        }
export type ProjectsByTeamQueryHookResult = ReturnType<typeof useProjectsByTeamQuery>;
export type ProjectsByTeamLazyQueryHookResult = ReturnType<typeof useProjectsByTeamLazyQuery>;
export type ProjectsByTeamSuspenseQueryHookResult = ReturnType<typeof useProjectsByTeamSuspenseQuery>;
export type ProjectsByTeamQueryResult = ApolloReactCommon.QueryResult<ProjectsByTeamQuery, ProjectsByTeamQueryVariables>;
export const ProjectsByAccountDocument = gql`
    query ProjectsByAccount($orgID: ID!, $userID: ID!, $order: String, $first: Int = 500, $before: String, $after: String, $pattern: String) {
  organization(id: $orgID) {
    id
    projects(
      first: $first
      userID: $userID
      order: $order
      before: $before
      after: $after
      pattern: $pattern
    ) {
      edges {
        node {
          id
          ...ProjectList
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${ProjectListFragmentDoc}`;

/**
 * __useProjectsByAccountQuery__
 *
 * To run a query within a React component, call `useProjectsByAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsByAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsByAccountQuery({
 *   variables: {
 *      orgID: // value for 'orgID'
 *      userID: // value for 'userID'
 *      order: // value for 'order'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useProjectsByAccountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectsByAccountQuery, ProjectsByAccountQueryVariables> & ({ variables: ProjectsByAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectsByAccountQuery, ProjectsByAccountQueryVariables>(ProjectsByAccountDocument, options);
      }
export function useProjectsByAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectsByAccountQuery, ProjectsByAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectsByAccountQuery, ProjectsByAccountQueryVariables>(ProjectsByAccountDocument, options);
        }
// @ts-ignore
export function useProjectsByAccountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectsByAccountQuery, ProjectsByAccountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectsByAccountQuery, ProjectsByAccountQueryVariables>;
export function useProjectsByAccountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsByAccountQuery, ProjectsByAccountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectsByAccountQuery | undefined, ProjectsByAccountQueryVariables>;
export function useProjectsByAccountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsByAccountQuery, ProjectsByAccountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectsByAccountQuery, ProjectsByAccountQueryVariables>(ProjectsByAccountDocument, options);
        }
export type ProjectsByAccountQueryHookResult = ReturnType<typeof useProjectsByAccountQuery>;
export type ProjectsByAccountLazyQueryHookResult = ReturnType<typeof useProjectsByAccountLazyQuery>;
export type ProjectsByAccountSuspenseQueryHookResult = ReturnType<typeof useProjectsByAccountSuspenseQuery>;
export type ProjectsByAccountQueryResult = ApolloReactCommon.QueryResult<ProjectsByAccountQuery, ProjectsByAccountQueryVariables>;
export const ProjectsByUserDocument = gql`
    query ProjectsByUser($userName: String!, $pattern: String, $order: String, $first: Int = 500, $before: String, $after: String) {
  user(userName: $userName) {
    id
    username
    projects(
      first: $first
      order: $order
      before: $before
      after: $after
      pattern: $pattern
    ) {
      edges {
        node {
          id
          ...ProjectList
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${ProjectListFragmentDoc}`;

/**
 * __useProjectsByUserQuery__
 *
 * To run a query within a React component, call `useProjectsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsByUserQuery({
 *   variables: {
 *      userName: // value for 'userName'
 *      pattern: // value for 'pattern'
 *      order: // value for 'order'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useProjectsByUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectsByUserQuery, ProjectsByUserQueryVariables> & ({ variables: ProjectsByUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectsByUserQuery, ProjectsByUserQueryVariables>(ProjectsByUserDocument, options);
      }
export function useProjectsByUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectsByUserQuery, ProjectsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectsByUserQuery, ProjectsByUserQueryVariables>(ProjectsByUserDocument, options);
        }
// @ts-ignore
export function useProjectsByUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectsByUserQuery, ProjectsByUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectsByUserQuery, ProjectsByUserQueryVariables>;
export function useProjectsByUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsByUserQuery, ProjectsByUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectsByUserQuery | undefined, ProjectsByUserQueryVariables>;
export function useProjectsByUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsByUserQuery, ProjectsByUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectsByUserQuery, ProjectsByUserQueryVariables>(ProjectsByUserDocument, options);
        }
export type ProjectsByUserQueryHookResult = ReturnType<typeof useProjectsByUserQuery>;
export type ProjectsByUserLazyQueryHookResult = ReturnType<typeof useProjectsByUserLazyQuery>;
export type ProjectsByUserSuspenseQueryHookResult = ReturnType<typeof useProjectsByUserSuspenseQuery>;
export type ProjectsByUserQueryResult = ApolloReactCommon.QueryResult<ProjectsByUserQuery, ProjectsByUserQueryVariables>;
export const ArtifactMetricSearchDocument = gql`
    query ArtifactMetricSearch($artifactCollectionId: ID!, $membershipIds: [ID!]!, $metricNamePattern: String, $first: Int = 50) {
  artifactCollection(id: $artifactCollectionId) {
    id
    ... on ArtifactPortfolio {
      artifactMetricSearch(
        membershipIds: $membershipIds
        metricNamePattern: $metricNamePattern
        first: $first
      ) {
        name
      }
    }
  }
}
    `;

/**
 * __useArtifactMetricSearchQuery__
 *
 * To run a query within a React component, call `useArtifactMetricSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactMetricSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactMetricSearchQuery({
 *   variables: {
 *      artifactCollectionId: // value for 'artifactCollectionId'
 *      membershipIds: // value for 'membershipIds'
 *      metricNamePattern: // value for 'metricNamePattern'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useArtifactMetricSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactMetricSearchQuery, ArtifactMetricSearchQueryVariables> & ({ variables: ArtifactMetricSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactMetricSearchQuery, ArtifactMetricSearchQueryVariables>(ArtifactMetricSearchDocument, options);
      }
export function useArtifactMetricSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactMetricSearchQuery, ArtifactMetricSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactMetricSearchQuery, ArtifactMetricSearchQueryVariables>(ArtifactMetricSearchDocument, options);
        }
// @ts-ignore
export function useArtifactMetricSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMetricSearchQuery, ArtifactMetricSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactMetricSearchQuery, ArtifactMetricSearchQueryVariables>;
export function useArtifactMetricSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMetricSearchQuery, ArtifactMetricSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactMetricSearchQuery | undefined, ArtifactMetricSearchQueryVariables>;
export function useArtifactMetricSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMetricSearchQuery, ArtifactMetricSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactMetricSearchQuery, ArtifactMetricSearchQueryVariables>(ArtifactMetricSearchDocument, options);
        }
export type ArtifactMetricSearchQueryHookResult = ReturnType<typeof useArtifactMetricSearchQuery>;
export type ArtifactMetricSearchLazyQueryHookResult = ReturnType<typeof useArtifactMetricSearchLazyQuery>;
export type ArtifactMetricSearchSuspenseQueryHookResult = ReturnType<typeof useArtifactMetricSearchSuspenseQuery>;
export type ArtifactMetricSearchQueryResult = ApolloReactCommon.QueryResult<ArtifactMetricSearchQuery, ArtifactMetricSearchQueryVariables>;
export const ArtifactMetricValuesDocument = gql`
    query ArtifactMetricValues($artifactCollectionId: ID!, $membershipIds: [ID!]!, $metricName: String!) {
  artifactCollection(id: $artifactCollectionId) {
    id
    ... on ArtifactPortfolio {
      artifactMetricValues(membershipIds: $membershipIds, metricName: $metricName) {
        membershipId
        versionIndex
        aliases
        value
        historyStep
        sourceRunName
        sourceProjectName
      }
    }
  }
}
    `;

/**
 * __useArtifactMetricValuesQuery__
 *
 * To run a query within a React component, call `useArtifactMetricValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactMetricValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactMetricValuesQuery({
 *   variables: {
 *      artifactCollectionId: // value for 'artifactCollectionId'
 *      membershipIds: // value for 'membershipIds'
 *      metricName: // value for 'metricName'
 *   },
 * });
 */
export function useArtifactMetricValuesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactMetricValuesQuery, ArtifactMetricValuesQueryVariables> & ({ variables: ArtifactMetricValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactMetricValuesQuery, ArtifactMetricValuesQueryVariables>(ArtifactMetricValuesDocument, options);
      }
export function useArtifactMetricValuesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactMetricValuesQuery, ArtifactMetricValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactMetricValuesQuery, ArtifactMetricValuesQueryVariables>(ArtifactMetricValuesDocument, options);
        }
// @ts-ignore
export function useArtifactMetricValuesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMetricValuesQuery, ArtifactMetricValuesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactMetricValuesQuery, ArtifactMetricValuesQueryVariables>;
export function useArtifactMetricValuesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMetricValuesQuery, ArtifactMetricValuesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactMetricValuesQuery | undefined, ArtifactMetricValuesQueryVariables>;
export function useArtifactMetricValuesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMetricValuesQuery, ArtifactMetricValuesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactMetricValuesQuery, ArtifactMetricValuesQueryVariables>(ArtifactMetricValuesDocument, options);
        }
export type ArtifactMetricValuesQueryHookResult = ReturnType<typeof useArtifactMetricValuesQuery>;
export type ArtifactMetricValuesLazyQueryHookResult = ReturnType<typeof useArtifactMetricValuesLazyQuery>;
export type ArtifactMetricValuesSuspenseQueryHookResult = ReturnType<typeof useArtifactMetricValuesSuspenseQuery>;
export type ArtifactMetricValuesQueryResult = ApolloReactCommon.QueryResult<ArtifactMetricValuesQuery, ArtifactMetricValuesQueryVariables>;
export const ArtifactVersionSelectionDataDocument = gql`
    query ArtifactVersionSelectionData($artifactCollectionID: ID!, $limit: Int!, $after: String, $searchTerm: String) {
  artifactCollection(id: $artifactCollectionID) {
    id
    artifactMemberships(first: $limit, after: $after, searchTerm: $searchTerm) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          versionIndex
          createdAt
          artifact {
            id
            tags {
              id
              name
              tagCategoryName
              attributes
            }
            createdAt
          }
          aliases {
            id
            alias
          }
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactVersionSelectionDataQuery__
 *
 * To run a query within a React component, call `useArtifactVersionSelectionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactVersionSelectionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactVersionSelectionDataQuery({
 *   variables: {
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useArtifactVersionSelectionDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactVersionSelectionDataQuery, ArtifactVersionSelectionDataQueryVariables> & ({ variables: ArtifactVersionSelectionDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactVersionSelectionDataQuery, ArtifactVersionSelectionDataQueryVariables>(ArtifactVersionSelectionDataDocument, options);
      }
export function useArtifactVersionSelectionDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactVersionSelectionDataQuery, ArtifactVersionSelectionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactVersionSelectionDataQuery, ArtifactVersionSelectionDataQueryVariables>(ArtifactVersionSelectionDataDocument, options);
        }
// @ts-ignore
export function useArtifactVersionSelectionDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionSelectionDataQuery, ArtifactVersionSelectionDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionSelectionDataQuery, ArtifactVersionSelectionDataQueryVariables>;
export function useArtifactVersionSelectionDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionSelectionDataQuery, ArtifactVersionSelectionDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionSelectionDataQuery | undefined, ArtifactVersionSelectionDataQueryVariables>;
export function useArtifactVersionSelectionDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionSelectionDataQuery, ArtifactVersionSelectionDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactVersionSelectionDataQuery, ArtifactVersionSelectionDataQueryVariables>(ArtifactVersionSelectionDataDocument, options);
        }
export type ArtifactVersionSelectionDataQueryHookResult = ReturnType<typeof useArtifactVersionSelectionDataQuery>;
export type ArtifactVersionSelectionDataLazyQueryHookResult = ReturnType<typeof useArtifactVersionSelectionDataLazyQuery>;
export type ArtifactVersionSelectionDataSuspenseQueryHookResult = ReturnType<typeof useArtifactVersionSelectionDataSuspenseQuery>;
export type ArtifactVersionSelectionDataQueryResult = ApolloReactCommon.QueryResult<ArtifactVersionSelectionDataQuery, ArtifactVersionSelectionDataQueryVariables>;
export const CreateReportButtonProjectDocument = gql`
    query CreateReportButtonProject($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    totalRuns
  }
}
    `;

/**
 * __useCreateReportButtonProjectQuery__
 *
 * To run a query within a React component, call `useCreateReportButtonProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateReportButtonProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateReportButtonProjectQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useCreateReportButtonProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CreateReportButtonProjectQuery, CreateReportButtonProjectQueryVariables> & ({ variables: CreateReportButtonProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreateReportButtonProjectQuery, CreateReportButtonProjectQueryVariables>(CreateReportButtonProjectDocument, options);
      }
export function useCreateReportButtonProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateReportButtonProjectQuery, CreateReportButtonProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreateReportButtonProjectQuery, CreateReportButtonProjectQueryVariables>(CreateReportButtonProjectDocument, options);
        }
// @ts-ignore
export function useCreateReportButtonProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CreateReportButtonProjectQuery, CreateReportButtonProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateReportButtonProjectQuery, CreateReportButtonProjectQueryVariables>;
export function useCreateReportButtonProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateReportButtonProjectQuery, CreateReportButtonProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateReportButtonProjectQuery | undefined, CreateReportButtonProjectQueryVariables>;
export function useCreateReportButtonProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateReportButtonProjectQuery, CreateReportButtonProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreateReportButtonProjectQuery, CreateReportButtonProjectQueryVariables>(CreateReportButtonProjectDocument, options);
        }
export type CreateReportButtonProjectQueryHookResult = ReturnType<typeof useCreateReportButtonProjectQuery>;
export type CreateReportButtonProjectLazyQueryHookResult = ReturnType<typeof useCreateReportButtonProjectLazyQuery>;
export type CreateReportButtonProjectSuspenseQueryHookResult = ReturnType<typeof useCreateReportButtonProjectSuspenseQuery>;
export type CreateReportButtonProjectQueryResult = ApolloReactCommon.QueryResult<CreateReportButtonProjectQuery, CreateReportButtonProjectQueryVariables>;
export const NotebookPermissionsDocument = gql`
    query NotebookPermissions($id: ID!) {
  notebook(id: $id) {
    id
    viewerPermissions
  }
}
    `;

/**
 * __useNotebookPermissionsQuery__
 *
 * To run a query within a React component, call `useNotebookPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotebookPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotebookPermissionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNotebookPermissionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NotebookPermissionsQuery, NotebookPermissionsQueryVariables> & ({ variables: NotebookPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NotebookPermissionsQuery, NotebookPermissionsQueryVariables>(NotebookPermissionsDocument, options);
      }
export function useNotebookPermissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NotebookPermissionsQuery, NotebookPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NotebookPermissionsQuery, NotebookPermissionsQueryVariables>(NotebookPermissionsDocument, options);
        }
// @ts-ignore
export function useNotebookPermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NotebookPermissionsQuery, NotebookPermissionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NotebookPermissionsQuery, NotebookPermissionsQueryVariables>;
export function useNotebookPermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NotebookPermissionsQuery, NotebookPermissionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NotebookPermissionsQuery | undefined, NotebookPermissionsQueryVariables>;
export function useNotebookPermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NotebookPermissionsQuery, NotebookPermissionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NotebookPermissionsQuery, NotebookPermissionsQueryVariables>(NotebookPermissionsDocument, options);
        }
export type NotebookPermissionsQueryHookResult = ReturnType<typeof useNotebookPermissionsQuery>;
export type NotebookPermissionsLazyQueryHookResult = ReturnType<typeof useNotebookPermissionsLazyQuery>;
export type NotebookPermissionsSuspenseQueryHookResult = ReturnType<typeof useNotebookPermissionsSuspenseQuery>;
export type NotebookPermissionsQueryResult = ApolloReactCommon.QueryResult<NotebookPermissionsQuery, NotebookPermissionsQueryVariables>;
export const PanelNotebookDocument = gql`
    query PanelNotebook($id: ID!) {
  notebook(id: $id) {
    id
    name
    lastUpdated
    staticOutputUrl
    viewerPermissions
  }
}
    `;

/**
 * __usePanelNotebookQuery__
 *
 * To run a query within a React component, call `usePanelNotebookQuery` and pass it any options that fit your needs.
 * When your component renders, `usePanelNotebookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePanelNotebookQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePanelNotebookQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PanelNotebookQuery, PanelNotebookQueryVariables> & ({ variables: PanelNotebookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PanelNotebookQuery, PanelNotebookQueryVariables>(PanelNotebookDocument, options);
      }
export function usePanelNotebookLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PanelNotebookQuery, PanelNotebookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PanelNotebookQuery, PanelNotebookQueryVariables>(PanelNotebookDocument, options);
        }
// @ts-ignore
export function usePanelNotebookSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PanelNotebookQuery, PanelNotebookQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PanelNotebookQuery, PanelNotebookQueryVariables>;
export function usePanelNotebookSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PanelNotebookQuery, PanelNotebookQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PanelNotebookQuery | undefined, PanelNotebookQueryVariables>;
export function usePanelNotebookSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PanelNotebookQuery, PanelNotebookQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PanelNotebookQuery, PanelNotebookQueryVariables>(PanelNotebookDocument, options);
        }
export type PanelNotebookQueryHookResult = ReturnType<typeof usePanelNotebookQuery>;
export type PanelNotebookLazyQueryHookResult = ReturnType<typeof usePanelNotebookLazyQuery>;
export type PanelNotebookSuspenseQueryHookResult = ReturnType<typeof usePanelNotebookSuspenseQuery>;
export type PanelNotebookQueryResult = ApolloReactCommon.QueryResult<PanelNotebookQuery, PanelNotebookQueryVariables>;
export const SetSandboxEnvVarsDocument = gql`
    mutation SetSandboxEnvVars($input: SetSandboxEnvVarsInput!) {
  setSandboxEnvVars(input: $input) {
    success
  }
}
    `;
export type SetSandboxEnvVarsMutationFn = ApolloReactCommon.MutationFunction<SetSandboxEnvVarsMutation, SetSandboxEnvVarsMutationVariables>;

/**
 * __useSetSandboxEnvVarsMutation__
 *
 * To run a mutation, you first call `useSetSandboxEnvVarsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSandboxEnvVarsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSandboxEnvVarsMutation, { data, loading, error }] = useSetSandboxEnvVarsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetSandboxEnvVarsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetSandboxEnvVarsMutation, SetSandboxEnvVarsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetSandboxEnvVarsMutation, SetSandboxEnvVarsMutationVariables>(SetSandboxEnvVarsDocument, options);
      }
export type SetSandboxEnvVarsMutationHookResult = ReturnType<typeof useSetSandboxEnvVarsMutation>;
export type SetSandboxEnvVarsMutationResult = ApolloReactCommon.MutationResult<SetSandboxEnvVarsMutation>;
export type SetSandboxEnvVarsMutationOptions = ApolloReactCommon.BaseMutationOptions<SetSandboxEnvVarsMutation, SetSandboxEnvVarsMutationVariables>;
export const RunComparerDocument = gql`
    query RunComparer($projectName: String!, $entityName: String!, $filters: JSONString, $first: Int) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(filters: $filters, first: $first) {
      edges {
        node {
          id
          name
          runInfo {
            program
            args
            os
            python
            colab
            executable
            codeSaved
            cpuCount
            cpuCountLogical
            gpuCount
            gpu
            git {
              remote
              commit
            }
            codePath
            slurm {
              jobId
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRunComparerQuery__
 *
 * To run a query within a React component, call `useRunComparerQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunComparerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunComparerQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useRunComparerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunComparerQuery, RunComparerQueryVariables> & ({ variables: RunComparerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunComparerQuery, RunComparerQueryVariables>(RunComparerDocument, options);
      }
export function useRunComparerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunComparerQuery, RunComparerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunComparerQuery, RunComparerQueryVariables>(RunComparerDocument, options);
        }
// @ts-ignore
export function useRunComparerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunComparerQuery, RunComparerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunComparerQuery, RunComparerQueryVariables>;
export function useRunComparerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunComparerQuery, RunComparerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunComparerQuery | undefined, RunComparerQueryVariables>;
export function useRunComparerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunComparerQuery, RunComparerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunComparerQuery, RunComparerQueryVariables>(RunComparerDocument, options);
        }
export type RunComparerQueryHookResult = ReturnType<typeof useRunComparerQuery>;
export type RunComparerLazyQueryHookResult = ReturnType<typeof useRunComparerLazyQuery>;
export type RunComparerSuspenseQueryHookResult = ReturnType<typeof useRunComparerSuspenseQuery>;
export type RunComparerQueryResult = ApolloReactCommon.QueryResult<RunComparerQuery, RunComparerQueryVariables>;
export const ProjectDetailsDocument = gql`
    query ProjectDetails($entityName: String, $projectName: String) {
  project(entityName: $entityName, name: $projectName) {
    id
    fromV2
  }
}
    `;

/**
 * __useProjectDetailsQuery__
 *
 * To run a query within a React component, call `useProjectDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectDetailsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useProjectDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectDetailsQuery, ProjectDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectDetailsQuery, ProjectDetailsQueryVariables>(ProjectDetailsDocument, options);
      }
export function useProjectDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectDetailsQuery, ProjectDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectDetailsQuery, ProjectDetailsQueryVariables>(ProjectDetailsDocument, options);
        }
// @ts-ignore
export function useProjectDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectDetailsQuery, ProjectDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectDetailsQuery, ProjectDetailsQueryVariables>;
export function useProjectDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectDetailsQuery, ProjectDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectDetailsQuery | undefined, ProjectDetailsQueryVariables>;
export function useProjectDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectDetailsQuery, ProjectDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectDetailsQuery, ProjectDetailsQueryVariables>(ProjectDetailsDocument, options);
        }
export type ProjectDetailsQueryHookResult = ReturnType<typeof useProjectDetailsQuery>;
export type ProjectDetailsLazyQueryHookResult = ReturnType<typeof useProjectDetailsLazyQuery>;
export type ProjectDetailsSuspenseQueryHookResult = ReturnType<typeof useProjectDetailsSuspenseQuery>;
export type ProjectDetailsQueryResult = ApolloReactCommon.QueryResult<ProjectDetailsQuery, ProjectDetailsQueryVariables>;
export const BackendLinesDeltaQuery_Dd_Dq_U_BldqDocument = gql`
    query BackendLinesDeltaQuery_DD_DQ_U_BLDQ($bucketedHistorySpecs: [JSONString!]!, $configKeys: [String!], $currentRuns: [String!]!, $enableConfig: Boolean = false, $enableSummary: Boolean = false, $entityName: String!, $excludeOutliers: Boolean, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $includePinnedRuns: Boolean = false, $lastUpdated: DateTime!, $limit: Int!, $order: String!, $pinnedRunIds: [ID!]!, $projectName: String!, $summaryKeys: [String!], $timeout: Int, $primaryLineType: String) {
  pinnedRuns: runs(ids: $pinnedRunIds) @include(if: $includePinnedRuns) {
    deltas(currentRuns: $currentRuns, lastUpdated: $lastUpdated, timeout: $timeout) {
      ...BackendLinesDeltasFragment
    }
  }
  project(name: $projectName, entityName: $entityName) {
    id
    ...BackendLinesDeltaQueryFragment
  }
}
    ${BackendLinesDeltasFragmentFragmentDoc}
${BackendLinesDeltaQueryFragmentFragmentDoc}`;

/**
 * __useBackendLinesDeltaQuery_Dd_Dq_U_BldqQuery__
 *
 * To run a query within a React component, call `useBackendLinesDeltaQuery_Dd_Dq_U_BldqQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackendLinesDeltaQuery_Dd_Dq_U_BldqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackendLinesDeltaQuery_Dd_Dq_U_BldqQuery({
 *   variables: {
 *      bucketedHistorySpecs: // value for 'bucketedHistorySpecs'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableConfig: // value for 'enableConfig'
 *      enableSummary: // value for 'enableSummary'
 *      entityName: // value for 'entityName'
 *      excludeOutliers: // value for 'excludeOutliers'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      includePinnedRuns: // value for 'includePinnedRuns'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      pinnedRunIds: // value for 'pinnedRunIds'
 *      projectName: // value for 'projectName'
 *      summaryKeys: // value for 'summaryKeys'
 *      timeout: // value for 'timeout'
 *      primaryLineType: // value for 'primaryLineType'
 *   },
 * });
 */
export function useBackendLinesDeltaQuery_Dd_Dq_U_BldqQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BackendLinesDeltaQuery_Dd_Dq_U_BldqQuery, BackendLinesDeltaQuery_Dd_Dq_U_BldqQueryVariables> & ({ variables: BackendLinesDeltaQuery_Dd_Dq_U_BldqQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BackendLinesDeltaQuery_Dd_Dq_U_BldqQuery, BackendLinesDeltaQuery_Dd_Dq_U_BldqQueryVariables>(BackendLinesDeltaQuery_Dd_Dq_U_BldqDocument, options);
      }
export function useBackendLinesDeltaQuery_Dd_Dq_U_BldqLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BackendLinesDeltaQuery_Dd_Dq_U_BldqQuery, BackendLinesDeltaQuery_Dd_Dq_U_BldqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BackendLinesDeltaQuery_Dd_Dq_U_BldqQuery, BackendLinesDeltaQuery_Dd_Dq_U_BldqQueryVariables>(BackendLinesDeltaQuery_Dd_Dq_U_BldqDocument, options);
        }
// @ts-ignore
export function useBackendLinesDeltaQuery_Dd_Dq_U_BldqSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BackendLinesDeltaQuery_Dd_Dq_U_BldqQuery, BackendLinesDeltaQuery_Dd_Dq_U_BldqQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BackendLinesDeltaQuery_Dd_Dq_U_BldqQuery, BackendLinesDeltaQuery_Dd_Dq_U_BldqQueryVariables>;
export function useBackendLinesDeltaQuery_Dd_Dq_U_BldqSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BackendLinesDeltaQuery_Dd_Dq_U_BldqQuery, BackendLinesDeltaQuery_Dd_Dq_U_BldqQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BackendLinesDeltaQuery_Dd_Dq_U_BldqQuery | undefined, BackendLinesDeltaQuery_Dd_Dq_U_BldqQueryVariables>;
export function useBackendLinesDeltaQuery_Dd_Dq_U_BldqSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BackendLinesDeltaQuery_Dd_Dq_U_BldqQuery, BackendLinesDeltaQuery_Dd_Dq_U_BldqQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BackendLinesDeltaQuery_Dd_Dq_U_BldqQuery, BackendLinesDeltaQuery_Dd_Dq_U_BldqQueryVariables>(BackendLinesDeltaQuery_Dd_Dq_U_BldqDocument, options);
        }
export type BackendLinesDeltaQuery_Dd_Dq_U_BldqQueryHookResult = ReturnType<typeof useBackendLinesDeltaQuery_Dd_Dq_U_BldqQuery>;
export type BackendLinesDeltaQuery_Dd_Dq_U_BldqLazyQueryHookResult = ReturnType<typeof useBackendLinesDeltaQuery_Dd_Dq_U_BldqLazyQuery>;
export type BackendLinesDeltaQuery_Dd_Dq_U_BldqSuspenseQueryHookResult = ReturnType<typeof useBackendLinesDeltaQuery_Dd_Dq_U_BldqSuspenseQuery>;
export type BackendLinesDeltaQuery_Dd_Dq_U_BldqQueryResult = ApolloReactCommon.QueryResult<BackendLinesDeltaQuery_Dd_Dq_U_BldqQuery, BackendLinesDeltaQuery_Dd_Dq_U_BldqQueryVariables>;
export const BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqDocument = gql`
    query BackendLinesInternalIdDeltaQuery_DD_DQ_U_BLDQ($bucketedHistorySpecs: [JSONString!]!, $configKeys: [String!], $currentRuns: [String!]!, $enableConfig: Boolean = false, $enableSummary: Boolean = false, $excludeOutliers: Boolean, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $includePinnedRuns: Boolean = false, $internalId: ID!, $lastUpdated: DateTime!, $limit: Int!, $order: String!, $pinnedRunFilters: JSONString, $pinnedRunsLimit: Int!, $summaryKeys: [String!], $timeout: Int, $primaryLineType: String) {
  project(internalId: $internalId) {
    id
    ...BackendLinesDeltaQueryLegacyFragment
  }
}
    ${BackendLinesDeltaQueryLegacyFragmentFragmentDoc}`;

/**
 * __useBackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQuery__
 *
 * To run a query within a React component, call `useBackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQuery({
 *   variables: {
 *      bucketedHistorySpecs: // value for 'bucketedHistorySpecs'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableConfig: // value for 'enableConfig'
 *      enableSummary: // value for 'enableSummary'
 *      excludeOutliers: // value for 'excludeOutliers'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      includePinnedRuns: // value for 'includePinnedRuns'
 *      internalId: // value for 'internalId'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      pinnedRunFilters: // value for 'pinnedRunFilters'
 *      pinnedRunsLimit: // value for 'pinnedRunsLimit'
 *      summaryKeys: // value for 'summaryKeys'
 *      timeout: // value for 'timeout'
 *      primaryLineType: // value for 'primaryLineType'
 *   },
 * });
 */
export function useBackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQuery, BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQueryVariables> & ({ variables: BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQuery, BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQueryVariables>(BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqDocument, options);
      }
export function useBackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQuery, BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQuery, BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQueryVariables>(BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqDocument, options);
        }
// @ts-ignore
export function useBackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQuery, BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQuery, BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQueryVariables>;
export function useBackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQuery, BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQuery | undefined, BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQueryVariables>;
export function useBackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQuery, BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQuery, BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQueryVariables>(BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqDocument, options);
        }
export type BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQueryHookResult = ReturnType<typeof useBackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQuery>;
export type BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqLazyQueryHookResult = ReturnType<typeof useBackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqLazyQuery>;
export type BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqSuspenseQueryHookResult = ReturnType<typeof useBackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqSuspenseQuery>;
export type BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQueryResult = ApolloReactCommon.QueryResult<BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQuery, BackendLinesInternalIdDeltaQuery_Dd_Dq_U_BldqQueryVariables>;
export const RunsInfoDocument = gql`
    query RunsInfo($projectName: String!, $entityName: String!, $filters: JSONString!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(filters: $filters) {
      edges {
        node {
          id
          ...RunInfoFragment
        }
      }
    }
  }
}
    ${RunInfoFragmentFragmentDoc}`;

/**
 * __useRunsInfoQuery__
 *
 * To run a query within a React component, call `useRunsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsInfoQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRunsInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsInfoQuery, RunsInfoQueryVariables> & ({ variables: RunsInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsInfoQuery, RunsInfoQueryVariables>(RunsInfoDocument, options);
      }
export function useRunsInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsInfoQuery, RunsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsInfoQuery, RunsInfoQueryVariables>(RunsInfoDocument, options);
        }
// @ts-ignore
export function useRunsInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsInfoQuery, RunsInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsInfoQuery, RunsInfoQueryVariables>;
export function useRunsInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsInfoQuery, RunsInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsInfoQuery | undefined, RunsInfoQueryVariables>;
export function useRunsInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsInfoQuery, RunsInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsInfoQuery, RunsInfoQueryVariables>(RunsInfoDocument, options);
        }
export type RunsInfoQueryHookResult = ReturnType<typeof useRunsInfoQuery>;
export type RunsInfoLazyQueryHookResult = ReturnType<typeof useRunsInfoLazyQuery>;
export type RunsInfoSuspenseQueryHookResult = ReturnType<typeof useRunsInfoSuspenseQuery>;
export type RunsInfoQueryResult = ApolloReactCommon.QueryResult<RunsInfoQuery, RunsInfoQueryVariables>;
export const BucketedRunsDeltaQuery_Dd_Dq_U_BrdqDocument = gql`
    query BucketedRunsDeltaQuery_DD_DQ_U_BRDQ($bucketedHistorySpecs: [JSONString!]!, $configKeys: [String!], $currentRuns: [String!]!, $enableConfig: Boolean = false, $enableSummary: Boolean = false, $entityName: String!, $excludeOutliers: Boolean, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $includePinnedRuns: Boolean = false, $lastUpdated: DateTime!, $limit: Int!, $order: String!, $pinnedRunIds: [ID!]!, $projectName: String!, $summaryKeys: [String!], $timeout: Int, $primaryLineType: String) {
  pinnedRuns: runs(ids: $pinnedRunIds) @include(if: $includePinnedRuns) {
    deltas(currentRuns: $currentRuns, lastUpdated: $lastUpdated, timeout: $timeout) {
      ...BucketedHistoryDeltasFragment
    }
  }
  project(name: $projectName, entityName: $entityName) {
    id
    ...DeltaQueryFragmentWithoutRunInfo
  }
}
    ${BucketedHistoryDeltasFragmentFragmentDoc}
${DeltaQueryFragmentWithoutRunInfoFragmentDoc}`;

/**
 * __useBucketedRunsDeltaQuery_Dd_Dq_U_BrdqQuery__
 *
 * To run a query within a React component, call `useBucketedRunsDeltaQuery_Dd_Dq_U_BrdqQuery` and pass it any options that fit your needs.
 * When your component renders, `useBucketedRunsDeltaQuery_Dd_Dq_U_BrdqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBucketedRunsDeltaQuery_Dd_Dq_U_BrdqQuery({
 *   variables: {
 *      bucketedHistorySpecs: // value for 'bucketedHistorySpecs'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableConfig: // value for 'enableConfig'
 *      enableSummary: // value for 'enableSummary'
 *      entityName: // value for 'entityName'
 *      excludeOutliers: // value for 'excludeOutliers'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      includePinnedRuns: // value for 'includePinnedRuns'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      pinnedRunIds: // value for 'pinnedRunIds'
 *      projectName: // value for 'projectName'
 *      summaryKeys: // value for 'summaryKeys'
 *      timeout: // value for 'timeout'
 *      primaryLineType: // value for 'primaryLineType'
 *   },
 * });
 */
export function useBucketedRunsDeltaQuery_Dd_Dq_U_BrdqQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQuery, BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQueryVariables> & ({ variables: BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQuery, BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQueryVariables>(BucketedRunsDeltaQuery_Dd_Dq_U_BrdqDocument, options);
      }
export function useBucketedRunsDeltaQuery_Dd_Dq_U_BrdqLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQuery, BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQuery, BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQueryVariables>(BucketedRunsDeltaQuery_Dd_Dq_U_BrdqDocument, options);
        }
// @ts-ignore
export function useBucketedRunsDeltaQuery_Dd_Dq_U_BrdqSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQuery, BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQuery, BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQueryVariables>;
export function useBucketedRunsDeltaQuery_Dd_Dq_U_BrdqSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQuery, BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQuery | undefined, BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQueryVariables>;
export function useBucketedRunsDeltaQuery_Dd_Dq_U_BrdqSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQuery, BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQuery, BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQueryVariables>(BucketedRunsDeltaQuery_Dd_Dq_U_BrdqDocument, options);
        }
export type BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQueryHookResult = ReturnType<typeof useBucketedRunsDeltaQuery_Dd_Dq_U_BrdqQuery>;
export type BucketedRunsDeltaQuery_Dd_Dq_U_BrdqLazyQueryHookResult = ReturnType<typeof useBucketedRunsDeltaQuery_Dd_Dq_U_BrdqLazyQuery>;
export type BucketedRunsDeltaQuery_Dd_Dq_U_BrdqSuspenseQueryHookResult = ReturnType<typeof useBucketedRunsDeltaQuery_Dd_Dq_U_BrdqSuspenseQuery>;
export type BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQueryResult = ApolloReactCommon.QueryResult<BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQuery, BucketedRunsDeltaQuery_Dd_Dq_U_BrdqQueryVariables>;
export const BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqDocument = gql`
    query BucketedRunsInternalIdDeltaQuery_DD_DQ_U_BRDQ($bucketedHistorySpecs: [JSONString!]!, $configKeys: [String!], $currentRuns: [String!]!, $enableConfig: Boolean = false, $enableSummary: Boolean = false, $excludeOutliers: Boolean, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $includePinnedRuns: Boolean = false, $internalId: ID!, $lastUpdated: DateTime!, $limit: Int!, $order: String!, $pinnedRunFilters: JSONString, $pinnedRunsLimit: Int!, $summaryKeys: [String!], $timeout: Int, $primaryLineType: String) {
  project(internalId: $internalId) {
    id
    ...DeltaQueryLegacyFragmentWithoutRunInfo
  }
}
    ${DeltaQueryLegacyFragmentWithoutRunInfoFragmentDoc}`;

/**
 * __useBucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQuery__
 *
 * To run a query within a React component, call `useBucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQuery` and pass it any options that fit your needs.
 * When your component renders, `useBucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQuery({
 *   variables: {
 *      bucketedHistorySpecs: // value for 'bucketedHistorySpecs'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableConfig: // value for 'enableConfig'
 *      enableSummary: // value for 'enableSummary'
 *      excludeOutliers: // value for 'excludeOutliers'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      includePinnedRuns: // value for 'includePinnedRuns'
 *      internalId: // value for 'internalId'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      pinnedRunFilters: // value for 'pinnedRunFilters'
 *      pinnedRunsLimit: // value for 'pinnedRunsLimit'
 *      summaryKeys: // value for 'summaryKeys'
 *      timeout: // value for 'timeout'
 *      primaryLineType: // value for 'primaryLineType'
 *   },
 * });
 */
export function useBucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQuery, BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQueryVariables> & ({ variables: BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQuery, BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQueryVariables>(BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqDocument, options);
      }
export function useBucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQuery, BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQuery, BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQueryVariables>(BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqDocument, options);
        }
// @ts-ignore
export function useBucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQuery, BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQuery, BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQueryVariables>;
export function useBucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQuery, BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQuery | undefined, BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQueryVariables>;
export function useBucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQuery, BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQuery, BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQueryVariables>(BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqDocument, options);
        }
export type BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQueryHookResult = ReturnType<typeof useBucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQuery>;
export type BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqLazyQueryHookResult = ReturnType<typeof useBucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqLazyQuery>;
export type BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqSuspenseQueryHookResult = ReturnType<typeof useBucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqSuspenseQuery>;
export type BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQueryResult = ApolloReactCommon.QueryResult<BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQuery, BucketedRunsInternalIdDeltaQuery_Dd_Dq_U_BrdqQueryVariables>;
export const GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqDocument = gql`
    query GroupedBackendLinesDeltaQuery_DD_DQ_G_BLDQ($bucketedHistorySpecs: [JSONString!]!, $configKeys: [String!], $currentRuns: [String!]!, $enableConfig: Boolean = false, $enableSummary: Boolean = false, $entityName: String!, $excludeOutliers: Boolean, $expressions: [JSONString!], $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $groupingDepth: Int, $selections: JSONString, $stabilizeRunGroups: Boolean, $lastUpdated: DateTime!, $limit: Int!, $maxGroups: Int, $order: String!, $projectName: String!, $summaryKeys: [String!], $timeout: Int, $primaryLineType: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    ...GroupedBackendLinesDeltaQueryFragment
  }
}
    ${GroupedBackendLinesDeltaQueryFragmentFragmentDoc}`;

/**
 * __useGroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQuery__
 *
 * To run a query within a React component, call `useGroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQuery({
 *   variables: {
 *      bucketedHistorySpecs: // value for 'bucketedHistorySpecs'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableConfig: // value for 'enableConfig'
 *      enableSummary: // value for 'enableSummary'
 *      entityName: // value for 'entityName'
 *      excludeOutliers: // value for 'excludeOutliers'
 *      expressions: // value for 'expressions'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      groupingDepth: // value for 'groupingDepth'
 *      selections: // value for 'selections'
 *      stabilizeRunGroups: // value for 'stabilizeRunGroups'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      maxGroups: // value for 'maxGroups'
 *      order: // value for 'order'
 *      projectName: // value for 'projectName'
 *      summaryKeys: // value for 'summaryKeys'
 *      timeout: // value for 'timeout'
 *      primaryLineType: // value for 'primaryLineType'
 *   },
 * });
 */
export function useGroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQuery, GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQueryVariables> & ({ variables: GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQuery, GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQueryVariables>(GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqDocument, options);
      }
export function useGroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQuery, GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQuery, GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQueryVariables>(GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqDocument, options);
        }
// @ts-ignore
export function useGroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQuery, GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQuery, GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQueryVariables>;
export function useGroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQuery, GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQuery | undefined, GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQueryVariables>;
export function useGroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQuery, GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQuery, GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQueryVariables>(GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqDocument, options);
        }
export type GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQueryHookResult = ReturnType<typeof useGroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQuery>;
export type GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqLazyQueryHookResult = ReturnType<typeof useGroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqLazyQuery>;
export type GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqSuspenseQueryHookResult = ReturnType<typeof useGroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqSuspenseQuery>;
export type GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQueryResult = ApolloReactCommon.QueryResult<GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQuery, GroupedBackendLinesDeltaQuery_Dd_Dq_G_BldqQueryVariables>;
export const GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqDocument = gql`
    query GroupedBackendLinesInternalIdDeltaQuery_DD_DQ_G_BLDQ($bucketedHistorySpecs: [JSONString!]!, $configKeys: [String!], $currentRuns: [String!]!, $enableConfig: Boolean = false, $enableSummary: Boolean = false, $excludeOutliers: Boolean, $expressions: [JSONString!], $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $groupingDepth: Int, $selections: JSONString, $stabilizeRunGroups: Boolean, $internalId: ID!, $lastUpdated: DateTime!, $limit: Int!, $maxGroups: Int, $order: String!, $summaryKeys: [String!], $timeout: Int, $primaryLineType: String) {
  project(internalId: $internalId) {
    id
    ...GroupedBackendLinesDeltaQueryFragment
  }
}
    ${GroupedBackendLinesDeltaQueryFragmentFragmentDoc}`;

/**
 * __useGroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQuery__
 *
 * To run a query within a React component, call `useGroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQuery({
 *   variables: {
 *      bucketedHistorySpecs: // value for 'bucketedHistorySpecs'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableConfig: // value for 'enableConfig'
 *      enableSummary: // value for 'enableSummary'
 *      excludeOutliers: // value for 'excludeOutliers'
 *      expressions: // value for 'expressions'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      groupingDepth: // value for 'groupingDepth'
 *      selections: // value for 'selections'
 *      stabilizeRunGroups: // value for 'stabilizeRunGroups'
 *      internalId: // value for 'internalId'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      maxGroups: // value for 'maxGroups'
 *      order: // value for 'order'
 *      summaryKeys: // value for 'summaryKeys'
 *      timeout: // value for 'timeout'
 *      primaryLineType: // value for 'primaryLineType'
 *   },
 * });
 */
export function useGroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQuery, GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQueryVariables> & ({ variables: GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQuery, GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQueryVariables>(GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqDocument, options);
      }
export function useGroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQuery, GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQuery, GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQueryVariables>(GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqDocument, options);
        }
// @ts-ignore
export function useGroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQuery, GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQuery, GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQueryVariables>;
export function useGroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQuery, GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQuery | undefined, GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQueryVariables>;
export function useGroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQuery, GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQuery, GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQueryVariables>(GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqDocument, options);
        }
export type GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQueryHookResult = ReturnType<typeof useGroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQuery>;
export type GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqLazyQueryHookResult = ReturnType<typeof useGroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqLazyQuery>;
export type GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqSuspenseQueryHookResult = ReturnType<typeof useGroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqSuspenseQuery>;
export type GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQueryResult = ApolloReactCommon.QueryResult<GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQuery, GroupedBackendLinesInternalIdDeltaQuery_Dd_Dq_G_BldqQueryVariables>;
export const GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqDocument = gql`
    query GroupedBucketedRunsDeltaQuery_DD_DQ_G_BRDQ($bucketedHistorySpecs: [JSONString!]!, $configKeys: [String!], $currentRuns: [String!]!, $enableConfig: Boolean = true, $enableSummary: Boolean = true, $entityName: String!, $excludeOutliers: Boolean, $expressions: [JSONString!], $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $groupingDepth: Int, $selections: JSONString, $stabilizeRunGroups: Boolean, $lastUpdated: DateTime!, $limit: Int!, $maxGroups: Int, $order: String!, $projectName: String!, $summaryKeys: [String!], $timeout: Int, $primaryLineType: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    ...GroupedDeltaQueryFragmentWithoutRunInfo
  }
}
    ${GroupedDeltaQueryFragmentWithoutRunInfoFragmentDoc}`;

/**
 * __useGroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQuery__
 *
 * To run a query within a React component, call `useGroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQuery({
 *   variables: {
 *      bucketedHistorySpecs: // value for 'bucketedHistorySpecs'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableConfig: // value for 'enableConfig'
 *      enableSummary: // value for 'enableSummary'
 *      entityName: // value for 'entityName'
 *      excludeOutliers: // value for 'excludeOutliers'
 *      expressions: // value for 'expressions'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      groupingDepth: // value for 'groupingDepth'
 *      selections: // value for 'selections'
 *      stabilizeRunGroups: // value for 'stabilizeRunGroups'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      maxGroups: // value for 'maxGroups'
 *      order: // value for 'order'
 *      projectName: // value for 'projectName'
 *      summaryKeys: // value for 'summaryKeys'
 *      timeout: // value for 'timeout'
 *      primaryLineType: // value for 'primaryLineType'
 *   },
 * });
 */
export function useGroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQuery, GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQueryVariables> & ({ variables: GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQuery, GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQueryVariables>(GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqDocument, options);
      }
export function useGroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQuery, GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQuery, GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQueryVariables>(GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqDocument, options);
        }
// @ts-ignore
export function useGroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQuery, GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQuery, GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQueryVariables>;
export function useGroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQuery, GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQuery | undefined, GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQueryVariables>;
export function useGroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQuery, GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQuery, GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQueryVariables>(GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqDocument, options);
        }
export type GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQueryHookResult = ReturnType<typeof useGroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQuery>;
export type GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqLazyQueryHookResult = ReturnType<typeof useGroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqLazyQuery>;
export type GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqSuspenseQueryHookResult = ReturnType<typeof useGroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqSuspenseQuery>;
export type GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQueryResult = ApolloReactCommon.QueryResult<GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQuery, GroupedBucketedRunsDeltaQuery_Dd_Dq_G_BrdqQueryVariables>;
export const GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqDocument = gql`
    query GroupedBucketedRunsInternalIdDeltaQuery_DD_DQ_G_BRDQ($bucketedHistorySpecs: [JSONString!]!, $configKeys: [String!], $currentRuns: [String!]!, $enableConfig: Boolean = true, $enableSummary: Boolean = true, $excludeOutliers: Boolean, $expressions: [JSONString!], $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $groupingDepth: Int, $selections: JSONString, $stabilizeRunGroups: Boolean, $internalId: ID!, $lastUpdated: DateTime!, $limit: Int!, $maxGroups: Int, $order: String!, $summaryKeys: [String!], $timeout: Int, $primaryLineType: String) {
  project(internalId: $internalId) {
    id
    ...GroupedDeltaQueryFragmentWithoutRunInfo
  }
}
    ${GroupedDeltaQueryFragmentWithoutRunInfoFragmentDoc}`;

/**
 * __useGroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQuery__
 *
 * To run a query within a React component, call `useGroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQuery({
 *   variables: {
 *      bucketedHistorySpecs: // value for 'bucketedHistorySpecs'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableConfig: // value for 'enableConfig'
 *      enableSummary: // value for 'enableSummary'
 *      excludeOutliers: // value for 'excludeOutliers'
 *      expressions: // value for 'expressions'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      groupingDepth: // value for 'groupingDepth'
 *      selections: // value for 'selections'
 *      stabilizeRunGroups: // value for 'stabilizeRunGroups'
 *      internalId: // value for 'internalId'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      maxGroups: // value for 'maxGroups'
 *      order: // value for 'order'
 *      summaryKeys: // value for 'summaryKeys'
 *      timeout: // value for 'timeout'
 *      primaryLineType: // value for 'primaryLineType'
 *   },
 * });
 */
export function useGroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQuery, GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQueryVariables> & ({ variables: GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQuery, GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQueryVariables>(GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqDocument, options);
      }
export function useGroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQuery, GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQuery, GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQueryVariables>(GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqDocument, options);
        }
// @ts-ignore
export function useGroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQuery, GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQuery, GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQueryVariables>;
export function useGroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQuery, GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQuery | undefined, GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQueryVariables>;
export function useGroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQuery, GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQuery, GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQueryVariables>(GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqDocument, options);
        }
export type GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQueryHookResult = ReturnType<typeof useGroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQuery>;
export type GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqLazyQueryHookResult = ReturnType<typeof useGroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqLazyQuery>;
export type GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqSuspenseQueryHookResult = ReturnType<typeof useGroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqSuspenseQuery>;
export type GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQueryResult = ApolloReactCommon.QueryResult<GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQuery, GroupedBucketedRunsInternalIdDeltaQuery_Dd_Dq_G_BrdqQueryVariables>;
export const ProjectHasProtectedArtifactDocument = gql`
    query ProjectHasProtectedArtifact($entityName: String!, $name: String!) {
  project(entityName: $entityName, name: $name) {
    id
    hasProtectedArtifact
  }
}
    `;

/**
 * __useProjectHasProtectedArtifactQuery__
 *
 * To run a query within a React component, call `useProjectHasProtectedArtifactQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectHasProtectedArtifactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectHasProtectedArtifactQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useProjectHasProtectedArtifactQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables> & ({ variables: ProjectHasProtectedArtifactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables>(ProjectHasProtectedArtifactDocument, options);
      }
export function useProjectHasProtectedArtifactLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables>(ProjectHasProtectedArtifactDocument, options);
        }
// @ts-ignore
export function useProjectHasProtectedArtifactSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables>;
export function useProjectHasProtectedArtifactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectHasProtectedArtifactQuery | undefined, ProjectHasProtectedArtifactQueryVariables>;
export function useProjectHasProtectedArtifactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables>(ProjectHasProtectedArtifactDocument, options);
        }
export type ProjectHasProtectedArtifactQueryHookResult = ReturnType<typeof useProjectHasProtectedArtifactQuery>;
export type ProjectHasProtectedArtifactLazyQueryHookResult = ReturnType<typeof useProjectHasProtectedArtifactLazyQuery>;
export type ProjectHasProtectedArtifactSuspenseQueryHookResult = ReturnType<typeof useProjectHasProtectedArtifactSuspenseQuery>;
export type ProjectHasProtectedArtifactQueryResult = ApolloReactCommon.QueryResult<ProjectHasProtectedArtifactQuery, ProjectHasProtectedArtifactQueryVariables>;
export const StarProjectDocument = gql`
    mutation starProject($entityName: String!, $projectName: String!, $organizationId: ID, $clientMutationId: String) {
  starProject(
    input: {entityName: $entityName, projectName: $projectName, organizationId: $organizationId, clientMutationId: $clientMutationId}
  ) {
    project {
      id
      starred(organizationId: $organizationId)
    }
    clientMutationId
  }
}
    `;
export type StarProjectMutationFn = ApolloReactCommon.MutationFunction<StarProjectMutation, StarProjectMutationVariables>;

/**
 * __useStarProjectMutation__
 *
 * To run a mutation, you first call `useStarProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStarProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [starProjectMutation, { data, loading, error }] = useStarProjectMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      organizationId: // value for 'organizationId'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useStarProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StarProjectMutation, StarProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StarProjectMutation, StarProjectMutationVariables>(StarProjectDocument, options);
      }
export type StarProjectMutationHookResult = ReturnType<typeof useStarProjectMutation>;
export type StarProjectMutationResult = ApolloReactCommon.MutationResult<StarProjectMutation>;
export type StarProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<StarProjectMutation, StarProjectMutationVariables>;
export const UnstarProjectDocument = gql`
    mutation unstarProject($entityName: String!, $projectName: String!, $organizationId: ID, $clientMutationId: String) {
  unstarProject(
    input: {entityName: $entityName, projectName: $projectName, organizationId: $organizationId, clientMutationId: $clientMutationId}
  ) {
    project {
      id
      starred(organizationId: $organizationId)
    }
    clientMutationId
  }
}
    `;
export type UnstarProjectMutationFn = ApolloReactCommon.MutationFunction<UnstarProjectMutation, UnstarProjectMutationVariables>;

/**
 * __useUnstarProjectMutation__
 *
 * To run a mutation, you first call `useUnstarProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnstarProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unstarProjectMutation, { data, loading, error }] = useUnstarProjectMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      organizationId: // value for 'organizationId'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUnstarProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnstarProjectMutation, UnstarProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnstarProjectMutation, UnstarProjectMutationVariables>(UnstarProjectDocument, options);
      }
export type UnstarProjectMutationHookResult = ReturnType<typeof useUnstarProjectMutation>;
export type UnstarProjectMutationResult = ApolloReactCommon.MutationResult<UnstarProjectMutation>;
export type UnstarProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<UnstarProjectMutation, UnstarProjectMutationVariables>;
export const TeamMemberRolesDocument = gql`
    query TeamMemberRoles($entityName: String!) {
  entity(name: $entityName) {
    id
    members {
      id
      role
      username
      memberRole {
        ID
        name
      }
    }
  }
}
    `;

/**
 * __useTeamMemberRolesQuery__
 *
 * To run a query within a React component, call `useTeamMemberRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMemberRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMemberRolesQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useTeamMemberRolesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamMemberRolesQuery, TeamMemberRolesQueryVariables> & ({ variables: TeamMemberRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamMemberRolesQuery, TeamMemberRolesQueryVariables>(TeamMemberRolesDocument, options);
      }
export function useTeamMemberRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamMemberRolesQuery, TeamMemberRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamMemberRolesQuery, TeamMemberRolesQueryVariables>(TeamMemberRolesDocument, options);
        }
// @ts-ignore
export function useTeamMemberRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamMemberRolesQuery, TeamMemberRolesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamMemberRolesQuery, TeamMemberRolesQueryVariables>;
export function useTeamMemberRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamMemberRolesQuery, TeamMemberRolesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamMemberRolesQuery | undefined, TeamMemberRolesQueryVariables>;
export function useTeamMemberRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamMemberRolesQuery, TeamMemberRolesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamMemberRolesQuery, TeamMemberRolesQueryVariables>(TeamMemberRolesDocument, options);
        }
export type TeamMemberRolesQueryHookResult = ReturnType<typeof useTeamMemberRolesQuery>;
export type TeamMemberRolesLazyQueryHookResult = ReturnType<typeof useTeamMemberRolesLazyQuery>;
export type TeamMemberRolesSuspenseQueryHookResult = ReturnType<typeof useTeamMemberRolesSuspenseQuery>;
export type TeamMemberRolesQueryResult = ApolloReactCommon.QueryResult<TeamMemberRolesQuery, TeamMemberRolesQueryVariables>;
export const UpdateUserProjectRoleDocument = gql`
    mutation updateUserProjectRole($userId: ID!, $projectId: ID!, $userProjectRole: String!, $clientMutationId: String) {
  updateProjectMember(
    input: {userId: $userId, projectId: $projectId, userProjectRole: $userProjectRole, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateUserProjectRoleMutationFn = ApolloReactCommon.MutationFunction<UpdateUserProjectRoleMutation, UpdateUserProjectRoleMutationVariables>;

/**
 * __useUpdateUserProjectRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserProjectRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProjectRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProjectRoleMutation, { data, loading, error }] = useUpdateUserProjectRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      projectId: // value for 'projectId'
 *      userProjectRole: // value for 'userProjectRole'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateUserProjectRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserProjectRoleMutation, UpdateUserProjectRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserProjectRoleMutation, UpdateUserProjectRoleMutationVariables>(UpdateUserProjectRoleDocument, options);
      }
export type UpdateUserProjectRoleMutationHookResult = ReturnType<typeof useUpdateUserProjectRoleMutation>;
export type UpdateUserProjectRoleMutationResult = ApolloReactCommon.MutationResult<UpdateUserProjectRoleMutation>;
export type UpdateUserProjectRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserProjectRoleMutation, UpdateUserProjectRoleMutationVariables>;
export const ProjectOverviewDocument = gql`
    query ProjectOverview($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    name
    entityName
    description
    lastActive
    access
    totalRuns: runCount
    computeHours
    totalUsers
    user {
      id
    }
    entity {
      id
      name
      isTeam
    }
  }
}
    `;

/**
 * __useProjectOverviewQuery__
 *
 * To run a query within a React component, call `useProjectOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectOverviewQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useProjectOverviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectOverviewQuery, ProjectOverviewQueryVariables> & ({ variables: ProjectOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectOverviewQuery, ProjectOverviewQueryVariables>(ProjectOverviewDocument, options);
      }
export function useProjectOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectOverviewQuery, ProjectOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectOverviewQuery, ProjectOverviewQueryVariables>(ProjectOverviewDocument, options);
        }
// @ts-ignore
export function useProjectOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectOverviewQuery, ProjectOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectOverviewQuery, ProjectOverviewQueryVariables>;
export function useProjectOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectOverviewQuery, ProjectOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectOverviewQuery | undefined, ProjectOverviewQueryVariables>;
export function useProjectOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectOverviewQuery, ProjectOverviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectOverviewQuery, ProjectOverviewQueryVariables>(ProjectOverviewDocument, options);
        }
export type ProjectOverviewQueryHookResult = ReturnType<typeof useProjectOverviewQuery>;
export type ProjectOverviewLazyQueryHookResult = ReturnType<typeof useProjectOverviewLazyQuery>;
export type ProjectOverviewSuspenseQueryHookResult = ReturnType<typeof useProjectOverviewSuspenseQuery>;
export type ProjectOverviewQueryResult = ApolloReactCommon.QueryResult<ProjectOverviewQuery, ProjectOverviewQueryVariables>;
export const ProjectPickerDocument = gql`
    query ProjectPicker($count: Int = 50, $entityName: String!, $order: String = "-created_at", $organizationId: ID!, $pattern: String, $includeViewerAndTeamProjects: Boolean!, $skipEntity: Boolean!, $skipOrganization: Boolean!, $userName: String!) {
  entity(name: $entityName) @skip(if: $skipEntity) {
    id
    projects(first: $count, pattern: $pattern, order: $order) {
      edges {
        node {
          ...ProjectPicker_Project
        }
      }
    }
  }
  viewer @include(if: $includeViewerAndTeamProjects) {
    id
    projects(first: $count, pattern: $pattern, order: $order) {
      edges {
        node {
          ...ProjectPicker_Project
        }
      }
    }
  }
  user(userName: $userName) @include(if: $includeViewerAndTeamProjects) {
    id
    teams {
      edges {
        node {
          id
          projects(first: $count, pattern: $pattern, order: $order) {
            edges {
              node {
                ...ProjectPicker_Project
              }
            }
          }
        }
      }
    }
  }
  organization(id: $organizationId) @skip(if: $skipOrganization) {
    id
    projects(first: $count, pattern: $pattern, order: $order) {
      edges {
        node {
          ...ProjectPicker_Project
        }
      }
    }
  }
}
    ${ProjectPicker_ProjectFragmentDoc}`;

/**
 * __useProjectPickerQuery__
 *
 * To run a query within a React component, call `useProjectPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPickerQuery({
 *   variables: {
 *      count: // value for 'count'
 *      entityName: // value for 'entityName'
 *      order: // value for 'order'
 *      organizationId: // value for 'organizationId'
 *      pattern: // value for 'pattern'
 *      includeViewerAndTeamProjects: // value for 'includeViewerAndTeamProjects'
 *      skipEntity: // value for 'skipEntity'
 *      skipOrganization: // value for 'skipOrganization'
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useProjectPickerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectPickerQuery, ProjectPickerQueryVariables> & ({ variables: ProjectPickerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectPickerQuery, ProjectPickerQueryVariables>(ProjectPickerDocument, options);
      }
export function useProjectPickerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectPickerQuery, ProjectPickerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectPickerQuery, ProjectPickerQueryVariables>(ProjectPickerDocument, options);
        }
// @ts-ignore
export function useProjectPickerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectPickerQuery, ProjectPickerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectPickerQuery, ProjectPickerQueryVariables>;
export function useProjectPickerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectPickerQuery, ProjectPickerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectPickerQuery | undefined, ProjectPickerQueryVariables>;
export function useProjectPickerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectPickerQuery, ProjectPickerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectPickerQuery, ProjectPickerQueryVariables>(ProjectPickerDocument, options);
        }
export type ProjectPickerQueryHookResult = ReturnType<typeof useProjectPickerQuery>;
export type ProjectPickerLazyQueryHookResult = ReturnType<typeof useProjectPickerLazyQuery>;
export type ProjectPickerSuspenseQueryHookResult = ReturnType<typeof useProjectPickerSuspenseQuery>;
export type ProjectPickerQueryResult = ApolloReactCommon.QueryResult<ProjectPickerQuery, ProjectPickerQueryVariables>;
export const LegacyMrProjectDocument = gql`
    query LegacyMRProject($orgEntityName: String!, $registryProjectName: String!) {
  project(entityName: $orgEntityName, name: $registryProjectName) {
    id
    name
    entity {
      id
      name
      modelRegistryMigrationConfig {
        ...ModelRegistryMigrationConfigFragment
      }
    }
    isMigratedRegistryProject
    legacyModelRegistryProject {
      id
      name
      entityName
    }
  }
}
    ${ModelRegistryMigrationConfigFragmentFragmentDoc}`;

/**
 * __useLegacyMrProjectQuery__
 *
 * To run a query within a React component, call `useLegacyMrProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegacyMrProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegacyMrProjectQuery({
 *   variables: {
 *      orgEntityName: // value for 'orgEntityName'
 *      registryProjectName: // value for 'registryProjectName'
 *   },
 * });
 */
export function useLegacyMrProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LegacyMrProjectQuery, LegacyMrProjectQueryVariables> & ({ variables: LegacyMrProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LegacyMrProjectQuery, LegacyMrProjectQueryVariables>(LegacyMrProjectDocument, options);
      }
export function useLegacyMrProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LegacyMrProjectQuery, LegacyMrProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LegacyMrProjectQuery, LegacyMrProjectQueryVariables>(LegacyMrProjectDocument, options);
        }
// @ts-ignore
export function useLegacyMrProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LegacyMrProjectQuery, LegacyMrProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LegacyMrProjectQuery, LegacyMrProjectQueryVariables>;
export function useLegacyMrProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LegacyMrProjectQuery, LegacyMrProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LegacyMrProjectQuery | undefined, LegacyMrProjectQueryVariables>;
export function useLegacyMrProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LegacyMrProjectQuery, LegacyMrProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LegacyMrProjectQuery, LegacyMrProjectQueryVariables>(LegacyMrProjectDocument, options);
        }
export type LegacyMrProjectQueryHookResult = ReturnType<typeof useLegacyMrProjectQuery>;
export type LegacyMrProjectLazyQueryHookResult = ReturnType<typeof useLegacyMrProjectLazyQuery>;
export type LegacyMrProjectSuspenseQueryHookResult = ReturnType<typeof useLegacyMrProjectSuspenseQuery>;
export type LegacyMrProjectQueryResult = ApolloReactCommon.QueryResult<LegacyMrProjectQuery, LegacyMrProjectQueryVariables>;
export const MigratedArtifactCollectionDocument = gql`
    query MigratedArtifactCollection($entityName: String!, $projectName: String!, $artifactCollectionName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    artifactCollection(name: $artifactCollectionName) {
      id
      name
      modelRegistryMigratedArtifactCollection {
        id
        name
        project {
          id
          name
          entityName
        }
      }
    }
  }
}
    `;

/**
 * __useMigratedArtifactCollectionQuery__
 *
 * To run a query within a React component, call `useMigratedArtifactCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMigratedArtifactCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMigratedArtifactCollectionQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      artifactCollectionName: // value for 'artifactCollectionName'
 *   },
 * });
 */
export function useMigratedArtifactCollectionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables> & ({ variables: MigratedArtifactCollectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables>(MigratedArtifactCollectionDocument, options);
      }
export function useMigratedArtifactCollectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables>(MigratedArtifactCollectionDocument, options);
        }
// @ts-ignore
export function useMigratedArtifactCollectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables>;
export function useMigratedArtifactCollectionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MigratedArtifactCollectionQuery | undefined, MigratedArtifactCollectionQueryVariables>;
export function useMigratedArtifactCollectionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables>(MigratedArtifactCollectionDocument, options);
        }
export type MigratedArtifactCollectionQueryHookResult = ReturnType<typeof useMigratedArtifactCollectionQuery>;
export type MigratedArtifactCollectionLazyQueryHookResult = ReturnType<typeof useMigratedArtifactCollectionLazyQuery>;
export type MigratedArtifactCollectionSuspenseQueryHookResult = ReturnType<typeof useMigratedArtifactCollectionSuspenseQuery>;
export type MigratedArtifactCollectionQueryResult = ApolloReactCommon.QueryResult<MigratedArtifactCollectionQuery, MigratedArtifactCollectionQueryVariables>;
export const OrgMrConfigDocument = gql`
    query OrgMRConfig($orgName: String!) {
  organization(name: $orgName) {
    id
    name
    orgEntity {
      id
      modelRegistryMigrationConfig {
        ...ModelRegistryMigrationConfigFragment
      }
    }
  }
}
    ${ModelRegistryMigrationConfigFragmentFragmentDoc}`;

/**
 * __useOrgMrConfigQuery__
 *
 * To run a query within a React component, call `useOrgMrConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgMrConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgMrConfigQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrgMrConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrgMrConfigQuery, OrgMrConfigQueryVariables> & ({ variables: OrgMrConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrgMrConfigQuery, OrgMrConfigQueryVariables>(OrgMrConfigDocument, options);
      }
export function useOrgMrConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrgMrConfigQuery, OrgMrConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrgMrConfigQuery, OrgMrConfigQueryVariables>(OrgMrConfigDocument, options);
        }
// @ts-ignore
export function useOrgMrConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrgMrConfigQuery, OrgMrConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgMrConfigQuery, OrgMrConfigQueryVariables>;
export function useOrgMrConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgMrConfigQuery, OrgMrConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgMrConfigQuery | undefined, OrgMrConfigQueryVariables>;
export function useOrgMrConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgMrConfigQuery, OrgMrConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrgMrConfigQuery, OrgMrConfigQueryVariables>(OrgMrConfigDocument, options);
        }
export type OrgMrConfigQueryHookResult = ReturnType<typeof useOrgMrConfigQuery>;
export type OrgMrConfigLazyQueryHookResult = ReturnType<typeof useOrgMrConfigLazyQuery>;
export type OrgMrConfigSuspenseQueryHookResult = ReturnType<typeof useOrgMrConfigSuspenseQuery>;
export type OrgMrConfigQueryResult = ApolloReactCommon.QueryResult<OrgMrConfigQuery, OrgMrConfigQueryVariables>;
export const EntityMrConfigDocument = gql`
    query EntityMRConfig($entityName: String!) {
  entity(name: $entityName) {
    id
    name
    modelRegistryMigrationConfig {
      ...ModelRegistryMigrationConfigFragment
    }
  }
}
    ${ModelRegistryMigrationConfigFragmentFragmentDoc}`;

/**
 * __useEntityMrConfigQuery__
 *
 * To run a query within a React component, call `useEntityMrConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityMrConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityMrConfigQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityMrConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityMrConfigQuery, EntityMrConfigQueryVariables> & ({ variables: EntityMrConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityMrConfigQuery, EntityMrConfigQueryVariables>(EntityMrConfigDocument, options);
      }
export function useEntityMrConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityMrConfigQuery, EntityMrConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityMrConfigQuery, EntityMrConfigQueryVariables>(EntityMrConfigDocument, options);
        }
// @ts-ignore
export function useEntityMrConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityMrConfigQuery, EntityMrConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityMrConfigQuery, EntityMrConfigQueryVariables>;
export function useEntityMrConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityMrConfigQuery, EntityMrConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityMrConfigQuery | undefined, EntityMrConfigQueryVariables>;
export function useEntityMrConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityMrConfigQuery, EntityMrConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityMrConfigQuery, EntityMrConfigQueryVariables>(EntityMrConfigDocument, options);
        }
export type EntityMrConfigQueryHookResult = ReturnType<typeof useEntityMrConfigQuery>;
export type EntityMrConfigLazyQueryHookResult = ReturnType<typeof useEntityMrConfigLazyQuery>;
export type EntityMrConfigSuspenseQueryHookResult = ReturnType<typeof useEntityMrConfigSuspenseQuery>;
export type EntityMrConfigQueryResult = ApolloReactCommon.QueryResult<EntityMrConfigQuery, EntityMrConfigQueryVariables>;
export const OrgTeamsMrConfigDocument = gql`
    query OrgTeamsMRConfig($orgName: String!) {
  organization(name: $orgName) {
    id
    name
    teams {
      id
      name
      modelRegistryMigrationConfig {
        ...ModelRegistryMigrationConfigFragment
      }
    }
  }
}
    ${ModelRegistryMigrationConfigFragmentFragmentDoc}`;

/**
 * __useOrgTeamsMrConfigQuery__
 *
 * To run a query within a React component, call `useOrgTeamsMrConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgTeamsMrConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgTeamsMrConfigQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrgTeamsMrConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables> & ({ variables: OrgTeamsMrConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables>(OrgTeamsMrConfigDocument, options);
      }
export function useOrgTeamsMrConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables>(OrgTeamsMrConfigDocument, options);
        }
// @ts-ignore
export function useOrgTeamsMrConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables>;
export function useOrgTeamsMrConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgTeamsMrConfigQuery | undefined, OrgTeamsMrConfigQueryVariables>;
export function useOrgTeamsMrConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables>(OrgTeamsMrConfigDocument, options);
        }
export type OrgTeamsMrConfigQueryHookResult = ReturnType<typeof useOrgTeamsMrConfigQuery>;
export type OrgTeamsMrConfigLazyQueryHookResult = ReturnType<typeof useOrgTeamsMrConfigLazyQuery>;
export type OrgTeamsMrConfigSuspenseQueryHookResult = ReturnType<typeof useOrgTeamsMrConfigSuspenseQuery>;
export type OrgTeamsMrConfigQueryResult = ApolloReactCommon.QueryResult<OrgTeamsMrConfigQuery, OrgTeamsMrConfigQueryVariables>;
export const FetchArtifactTypeNamesDocument = gql`
    query FetchArtifactTypeNames($orgName: String!, $first: Int, $after: String) {
  organization(name: $orgName) {
    id
    name
    orgEntity {
      id
      name
      artifactTypeNames(first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node
          cursor
        }
      }
    }
  }
}
    `;

/**
 * __useFetchArtifactTypeNamesQuery__
 *
 * To run a query within a React component, call `useFetchArtifactTypeNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchArtifactTypeNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchArtifactTypeNamesQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFetchArtifactTypeNamesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables> & ({ variables: FetchArtifactTypeNamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables>(FetchArtifactTypeNamesDocument, options);
      }
export function useFetchArtifactTypeNamesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables>(FetchArtifactTypeNamesDocument, options);
        }
// @ts-ignore
export function useFetchArtifactTypeNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables>;
export function useFetchArtifactTypeNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchArtifactTypeNamesQuery | undefined, FetchArtifactTypeNamesQueryVariables>;
export function useFetchArtifactTypeNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables>(FetchArtifactTypeNamesDocument, options);
        }
export type FetchArtifactTypeNamesQueryHookResult = ReturnType<typeof useFetchArtifactTypeNamesQuery>;
export type FetchArtifactTypeNamesLazyQueryHookResult = ReturnType<typeof useFetchArtifactTypeNamesLazyQuery>;
export type FetchArtifactTypeNamesSuspenseQueryHookResult = ReturnType<typeof useFetchArtifactTypeNamesSuspenseQuery>;
export type FetchArtifactTypeNamesQueryResult = ApolloReactCommon.QueryResult<FetchArtifactTypeNamesQuery, FetchArtifactTypeNamesQueryVariables>;
export const RegistryMembersDocument = gql`
    query RegistryMembers($orgName: String!) {
  organization(name: $orgName) {
    id
    members {
      ...OrganizationMemberFragment
    }
  }
}
    ${OrganizationMemberFragmentFragmentDoc}`;

/**
 * __useRegistryMembersQuery__
 *
 * To run a query within a React component, call `useRegistryMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryMembersQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useRegistryMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryMembersQuery, RegistryMembersQueryVariables> & ({ variables: RegistryMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryMembersQuery, RegistryMembersQueryVariables>(RegistryMembersDocument, options);
      }
export function useRegistryMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryMembersQuery, RegistryMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryMembersQuery, RegistryMembersQueryVariables>(RegistryMembersDocument, options);
        }
// @ts-ignore
export function useRegistryMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryMembersQuery, RegistryMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryMembersQuery, RegistryMembersQueryVariables>;
export function useRegistryMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryMembersQuery, RegistryMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryMembersQuery | undefined, RegistryMembersQueryVariables>;
export function useRegistryMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryMembersQuery, RegistryMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryMembersQuery, RegistryMembersQueryVariables>(RegistryMembersDocument, options);
        }
export type RegistryMembersQueryHookResult = ReturnType<typeof useRegistryMembersQuery>;
export type RegistryMembersLazyQueryHookResult = ReturnType<typeof useRegistryMembersLazyQuery>;
export type RegistryMembersSuspenseQueryHookResult = ReturnType<typeof useRegistryMembersSuspenseQuery>;
export type RegistryMembersQueryResult = ApolloReactCommon.QueryResult<RegistryMembersQuery, RegistryMembersQueryVariables>;
export const RegistryOrganizationDocument = gql`
    query RegistryOrganization($orgName: String!) {
  organization(name: $orgName) {
    id
    members {
      ...OrganizationMemberFragment
    }
    teams {
      id
      name
      photoUrl
      memberCount
    }
    serviceAccounts {
      id
      name
      accountType
    }
    subscriptions {
      id
      plan {
        id
        name
        planType
      }
    }
  }
}
    ${OrganizationMemberFragmentFragmentDoc}`;

/**
 * __useRegistryOrganizationQuery__
 *
 * To run a query within a React component, call `useRegistryOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryOrganizationQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useRegistryOrganizationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryOrganizationQuery, RegistryOrganizationQueryVariables> & ({ variables: RegistryOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryOrganizationQuery, RegistryOrganizationQueryVariables>(RegistryOrganizationDocument, options);
      }
export function useRegistryOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryOrganizationQuery, RegistryOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryOrganizationQuery, RegistryOrganizationQueryVariables>(RegistryOrganizationDocument, options);
        }
// @ts-ignore
export function useRegistryOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryOrganizationQuery, RegistryOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryOrganizationQuery, RegistryOrganizationQueryVariables>;
export function useRegistryOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryOrganizationQuery, RegistryOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryOrganizationQuery | undefined, RegistryOrganizationQueryVariables>;
export function useRegistryOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryOrganizationQuery, RegistryOrganizationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryOrganizationQuery, RegistryOrganizationQueryVariables>(RegistryOrganizationDocument, options);
        }
export type RegistryOrganizationQueryHookResult = ReturnType<typeof useRegistryOrganizationQuery>;
export type RegistryOrganizationLazyQueryHookResult = ReturnType<typeof useRegistryOrganizationLazyQuery>;
export type RegistryOrganizationSuspenseQueryHookResult = ReturnType<typeof useRegistryOrganizationSuspenseQuery>;
export type RegistryOrganizationQueryResult = ApolloReactCommon.QueryResult<RegistryOrganizationQuery, RegistryOrganizationQueryVariables>;
export const OrganizationReadOnlyDocument = gql`
    query OrganizationReadOnly($orgName: String!) {
  organization(name: $orgName) {
    id
    orgEntity {
      id
      name
      readOnly
    }
    advancedRegistryFeatures {
      advancedUI
      advancedSearch
    }
  }
}
    `;

/**
 * __useOrganizationReadOnlyQuery__
 *
 * To run a query within a React component, call `useOrganizationReadOnlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationReadOnlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationReadOnlyQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationReadOnlyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables> & ({ variables: OrganizationReadOnlyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables>(OrganizationReadOnlyDocument, options);
      }
export function useOrganizationReadOnlyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables>(OrganizationReadOnlyDocument, options);
        }
// @ts-ignore
export function useOrganizationReadOnlySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables>;
export function useOrganizationReadOnlySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationReadOnlyQuery | undefined, OrganizationReadOnlyQueryVariables>;
export function useOrganizationReadOnlySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables>(OrganizationReadOnlyDocument, options);
        }
export type OrganizationReadOnlyQueryHookResult = ReturnType<typeof useOrganizationReadOnlyQuery>;
export type OrganizationReadOnlyLazyQueryHookResult = ReturnType<typeof useOrganizationReadOnlyLazyQuery>;
export type OrganizationReadOnlySuspenseQueryHookResult = ReturnType<typeof useOrganizationReadOnlySuspenseQuery>;
export type OrganizationReadOnlyQueryResult = ApolloReactCommon.QueryResult<OrganizationReadOnlyQuery, OrganizationReadOnlyQueryVariables>;
export const ProjectReadOnlyDocument = gql`
    query ProjectReadOnly($entityName: String!, $projectName: String!) {
  entity(name: $entityName) {
    id
    project(name: $projectName) {
      id
      readOnly
    }
  }
}
    `;

/**
 * __useProjectReadOnlyQuery__
 *
 * To run a query within a React component, call `useProjectReadOnlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectReadOnlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectReadOnlyQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useProjectReadOnlyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables> & ({ variables: ProjectReadOnlyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables>(ProjectReadOnlyDocument, options);
      }
export function useProjectReadOnlyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables>(ProjectReadOnlyDocument, options);
        }
// @ts-ignore
export function useProjectReadOnlySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables>;
export function useProjectReadOnlySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectReadOnlyQuery | undefined, ProjectReadOnlyQueryVariables>;
export function useProjectReadOnlySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables>(ProjectReadOnlyDocument, options);
        }
export type ProjectReadOnlyQueryHookResult = ReturnType<typeof useProjectReadOnlyQuery>;
export type ProjectReadOnlyLazyQueryHookResult = ReturnType<typeof useProjectReadOnlyLazyQuery>;
export type ProjectReadOnlySuspenseQueryHookResult = ReturnType<typeof useProjectReadOnlySuspenseQuery>;
export type ProjectReadOnlyQueryResult = ApolloReactCommon.QueryResult<ProjectReadOnlyQuery, ProjectReadOnlyQueryVariables>;
export const RegistryAvailableTeamsDocument = gql`
    query RegistryAvailableTeams($entityName: String!, $projectName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    registryAvailableTeams {
      team {
        id
        name
        photoUrl
        memberCount
      }
      role {
        ID
        name
      }
    }
  }
}
    `;

/**
 * __useRegistryAvailableTeamsQuery__
 *
 * To run a query within a React component, call `useRegistryAvailableTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryAvailableTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryAvailableTeamsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useRegistryAvailableTeamsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryAvailableTeamsQuery, RegistryAvailableTeamsQueryVariables> & ({ variables: RegistryAvailableTeamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryAvailableTeamsQuery, RegistryAvailableTeamsQueryVariables>(RegistryAvailableTeamsDocument, options);
      }
export function useRegistryAvailableTeamsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryAvailableTeamsQuery, RegistryAvailableTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryAvailableTeamsQuery, RegistryAvailableTeamsQueryVariables>(RegistryAvailableTeamsDocument, options);
        }
// @ts-ignore
export function useRegistryAvailableTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryAvailableTeamsQuery, RegistryAvailableTeamsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryAvailableTeamsQuery, RegistryAvailableTeamsQueryVariables>;
export function useRegistryAvailableTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryAvailableTeamsQuery, RegistryAvailableTeamsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryAvailableTeamsQuery | undefined, RegistryAvailableTeamsQueryVariables>;
export function useRegistryAvailableTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryAvailableTeamsQuery, RegistryAvailableTeamsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryAvailableTeamsQuery, RegistryAvailableTeamsQueryVariables>(RegistryAvailableTeamsDocument, options);
        }
export type RegistryAvailableTeamsQueryHookResult = ReturnType<typeof useRegistryAvailableTeamsQuery>;
export type RegistryAvailableTeamsLazyQueryHookResult = ReturnType<typeof useRegistryAvailableTeamsLazyQuery>;
export type RegistryAvailableTeamsSuspenseQueryHookResult = ReturnType<typeof useRegistryAvailableTeamsSuspenseQuery>;
export type RegistryAvailableTeamsQueryResult = ApolloReactCommon.QueryResult<RegistryAvailableTeamsQuery, RegistryAvailableTeamsQueryVariables>;
export const FetchArtifactCollectionsPartialDocument = gql`
    query FetchArtifactCollectionsPartial($orgName: String!, $searchTerm: String, $cursor: String, $limit: Int!, $artifactsLimit: Int) {
  organization(name: $orgName) {
    id
    orgEntity {
      id
      name
      artifactCollectionsSearch(
        searchTerm: $searchTerm
        cursor: $cursor
        limit: $limit
        artifactsLimit: $artifactsLimit
      ) {
        ...registrySearchResultFragment
      }
    }
  }
}
    ${RegistrySearchResultFragmentFragmentDoc}`;

/**
 * __useFetchArtifactCollectionsPartialQuery__
 *
 * To run a query within a React component, call `useFetchArtifactCollectionsPartialQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchArtifactCollectionsPartialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchArtifactCollectionsPartialQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      searchTerm: // value for 'searchTerm'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      artifactsLimit: // value for 'artifactsLimit'
 *   },
 * });
 */
export function useFetchArtifactCollectionsPartialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables> & ({ variables: FetchArtifactCollectionsPartialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables>(FetchArtifactCollectionsPartialDocument, options);
      }
export function useFetchArtifactCollectionsPartialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables>(FetchArtifactCollectionsPartialDocument, options);
        }
// @ts-ignore
export function useFetchArtifactCollectionsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables>;
export function useFetchArtifactCollectionsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchArtifactCollectionsPartialQuery | undefined, FetchArtifactCollectionsPartialQueryVariables>;
export function useFetchArtifactCollectionsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables>(FetchArtifactCollectionsPartialDocument, options);
        }
export type FetchArtifactCollectionsPartialQueryHookResult = ReturnType<typeof useFetchArtifactCollectionsPartialQuery>;
export type FetchArtifactCollectionsPartialLazyQueryHookResult = ReturnType<typeof useFetchArtifactCollectionsPartialLazyQuery>;
export type FetchArtifactCollectionsPartialSuspenseQueryHookResult = ReturnType<typeof useFetchArtifactCollectionsPartialSuspenseQuery>;
export type FetchArtifactCollectionsPartialQueryResult = ApolloReactCommon.QueryResult<FetchArtifactCollectionsPartialQuery, FetchArtifactCollectionsPartialQueryVariables>;
export const FetchArtifactMembershipsPartialDocument = gql`
    query FetchArtifactMembershipsPartial($collectionId: ID!, $limit: Int!, $after: String, $searchTerm: String) {
  artifactCollection(id: $collectionId) {
    id
    artifactMemberships(first: $limit, after: $after, searchTerm: $searchTerm) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...registrySearchArtifactMembershipsFragment
        }
      }
    }
  }
}
    ${RegistrySearchArtifactMembershipsFragmentFragmentDoc}`;

/**
 * __useFetchArtifactMembershipsPartialQuery__
 *
 * To run a query within a React component, call `useFetchArtifactMembershipsPartialQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchArtifactMembershipsPartialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchArtifactMembershipsPartialQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useFetchArtifactMembershipsPartialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables> & ({ variables: FetchArtifactMembershipsPartialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables>(FetchArtifactMembershipsPartialDocument, options);
      }
export function useFetchArtifactMembershipsPartialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables>(FetchArtifactMembershipsPartialDocument, options);
        }
// @ts-ignore
export function useFetchArtifactMembershipsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables>;
export function useFetchArtifactMembershipsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchArtifactMembershipsPartialQuery | undefined, FetchArtifactMembershipsPartialQueryVariables>;
export function useFetchArtifactMembershipsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables>(FetchArtifactMembershipsPartialDocument, options);
        }
export type FetchArtifactMembershipsPartialQueryHookResult = ReturnType<typeof useFetchArtifactMembershipsPartialQuery>;
export type FetchArtifactMembershipsPartialLazyQueryHookResult = ReturnType<typeof useFetchArtifactMembershipsPartialLazyQuery>;
export type FetchArtifactMembershipsPartialSuspenseQueryHookResult = ReturnType<typeof useFetchArtifactMembershipsPartialSuspenseQuery>;
export type FetchArtifactMembershipsPartialQueryResult = ApolloReactCommon.QueryResult<FetchArtifactMembershipsPartialQuery, FetchArtifactMembershipsPartialQueryVariables>;
export const FetchArtifactCollectionSupplementalDocument = gql`
    query FetchArtifactCollectionSupplemental($collectionId: ID!) {
  artifactCollection(id: $collectionId) {
    id
    project {
      id
      name
    }
    artifacts {
      edges {
        node {
          id
          usedBy {
            edges {
              node {
                id
                user {
                  id
                  name
                }
              }
            }
          }
        }
      }
      totalCount
    }
  }
}
    `;

/**
 * __useFetchArtifactCollectionSupplementalQuery__
 *
 * To run a query within a React component, call `useFetchArtifactCollectionSupplementalQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchArtifactCollectionSupplementalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchArtifactCollectionSupplementalQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useFetchArtifactCollectionSupplementalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables> & ({ variables: FetchArtifactCollectionSupplementalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables>(FetchArtifactCollectionSupplementalDocument, options);
      }
export function useFetchArtifactCollectionSupplementalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables>(FetchArtifactCollectionSupplementalDocument, options);
        }
// @ts-ignore
export function useFetchArtifactCollectionSupplementalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables>;
export function useFetchArtifactCollectionSupplementalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchArtifactCollectionSupplementalQuery | undefined, FetchArtifactCollectionSupplementalQueryVariables>;
export function useFetchArtifactCollectionSupplementalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables>(FetchArtifactCollectionSupplementalDocument, options);
        }
export type FetchArtifactCollectionSupplementalQueryHookResult = ReturnType<typeof useFetchArtifactCollectionSupplementalQuery>;
export type FetchArtifactCollectionSupplementalLazyQueryHookResult = ReturnType<typeof useFetchArtifactCollectionSupplementalLazyQuery>;
export type FetchArtifactCollectionSupplementalSuspenseQueryHookResult = ReturnType<typeof useFetchArtifactCollectionSupplementalSuspenseQuery>;
export type FetchArtifactCollectionSupplementalQueryResult = ApolloReactCommon.QueryResult<FetchArtifactCollectionSupplementalQuery, FetchArtifactCollectionSupplementalQueryVariables>;
export const RegistryCollectionsDocument = gql`
    query RegistryCollections($organization: String!, $registryFilter: JSONString, $collectionFilter: JSONString, $collectionTypes: [ArtifactCollectionType!] = [PORTFOLIO], $order: String, $cursor: String, $perPage: Int) {
  organization(name: $organization) {
    id
    orgEntity {
      id
      name
      artifactCollections(
        projectFilters: $registryFilter
        filters: $collectionFilter
        collectionTypes: $collectionTypes
        order: $order
        after: $cursor
        first: $perPage
      ) {
        totalCount
        pageInfo {
          ...PageInfoFragment
        }
        edges {
          node {
            ...RegistryCollectionFragment
          }
        }
      }
    }
  }
}
    ${PageInfoFragmentFragmentDoc}
${RegistryCollectionFragmentFragmentDoc}`;

/**
 * __useRegistryCollectionsQuery__
 *
 * To run a query within a React component, call `useRegistryCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryCollectionsQuery({
 *   variables: {
 *      organization: // value for 'organization'
 *      registryFilter: // value for 'registryFilter'
 *      collectionFilter: // value for 'collectionFilter'
 *      collectionTypes: // value for 'collectionTypes'
 *      order: // value for 'order'
 *      cursor: // value for 'cursor'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useRegistryCollectionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryCollectionsQuery, RegistryCollectionsQueryVariables> & ({ variables: RegistryCollectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryCollectionsQuery, RegistryCollectionsQueryVariables>(RegistryCollectionsDocument, options);
      }
export function useRegistryCollectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryCollectionsQuery, RegistryCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryCollectionsQuery, RegistryCollectionsQueryVariables>(RegistryCollectionsDocument, options);
        }
// @ts-ignore
export function useRegistryCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionsQuery, RegistryCollectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryCollectionsQuery, RegistryCollectionsQueryVariables>;
export function useRegistryCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionsQuery, RegistryCollectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryCollectionsQuery | undefined, RegistryCollectionsQueryVariables>;
export function useRegistryCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionsQuery, RegistryCollectionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryCollectionsQuery, RegistryCollectionsQueryVariables>(RegistryCollectionsDocument, options);
        }
export type RegistryCollectionsQueryHookResult = ReturnType<typeof useRegistryCollectionsQuery>;
export type RegistryCollectionsLazyQueryHookResult = ReturnType<typeof useRegistryCollectionsLazyQuery>;
export type RegistryCollectionsSuspenseQueryHookResult = ReturnType<typeof useRegistryCollectionsSuspenseQuery>;
export type RegistryCollectionsQueryResult = ApolloReactCommon.QueryResult<RegistryCollectionsQuery, RegistryCollectionsQueryVariables>;
export const RegistryCollectionsWithDetailsDocument = gql`
    query RegistryCollectionsWithDetails($organization: String!, $registryFilter: JSONString, $collectionFilter: JSONString, $collectionTypes: [ArtifactCollectionType!] = [PORTFOLIO], $order: String, $cursor: String, $perPage: Int) {
  organization(name: $organization) {
    id
    orgEntity {
      id
      name
      artifactCollections(
        projectFilters: $registryFilter
        filters: $collectionFilter
        collectionTypes: $collectionTypes
        order: $order
        after: $cursor
        first: $perPage
      ) {
        pageInfo {
          ...PageInfoFragment
        }
        edges {
          node {
            ...RegistryCollectionWithDetailsFragment
          }
        }
      }
    }
  }
}
    ${PageInfoFragmentFragmentDoc}
${RegistryCollectionWithDetailsFragmentFragmentDoc}`;

/**
 * __useRegistryCollectionsWithDetailsQuery__
 *
 * To run a query within a React component, call `useRegistryCollectionsWithDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryCollectionsWithDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryCollectionsWithDetailsQuery({
 *   variables: {
 *      organization: // value for 'organization'
 *      registryFilter: // value for 'registryFilter'
 *      collectionFilter: // value for 'collectionFilter'
 *      collectionTypes: // value for 'collectionTypes'
 *      order: // value for 'order'
 *      cursor: // value for 'cursor'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useRegistryCollectionsWithDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables> & ({ variables: RegistryCollectionsWithDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables>(RegistryCollectionsWithDetailsDocument, options);
      }
export function useRegistryCollectionsWithDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables>(RegistryCollectionsWithDetailsDocument, options);
        }
// @ts-ignore
export function useRegistryCollectionsWithDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables>;
export function useRegistryCollectionsWithDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryCollectionsWithDetailsQuery | undefined, RegistryCollectionsWithDetailsQueryVariables>;
export function useRegistryCollectionsWithDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables>(RegistryCollectionsWithDetailsDocument, options);
        }
export type RegistryCollectionsWithDetailsQueryHookResult = ReturnType<typeof useRegistryCollectionsWithDetailsQuery>;
export type RegistryCollectionsWithDetailsLazyQueryHookResult = ReturnType<typeof useRegistryCollectionsWithDetailsLazyQuery>;
export type RegistryCollectionsWithDetailsSuspenseQueryHookResult = ReturnType<typeof useRegistryCollectionsWithDetailsSuspenseQuery>;
export type RegistryCollectionsWithDetailsQueryResult = ApolloReactCommon.QueryResult<RegistryCollectionsWithDetailsQuery, RegistryCollectionsWithDetailsQueryVariables>;
export const RegistryCollectionsByProjectDocument = gql`
    query RegistryCollectionsByProject($projectName: String!, $entityName: String!, $limit: Int = 100) {
  project(name: $projectName, entityName: $entityName) {
    id
    name
    artifactCollections(first: $limit) {
      edges {
        node {
          id
          name
          description
          defaultArtifactType {
            id
            name
          }
          artifacts(first: 0) {
            totalCount
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRegistryCollectionsByProjectQuery__
 *
 * To run a query within a React component, call `useRegistryCollectionsByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryCollectionsByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryCollectionsByProjectQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRegistryCollectionsByProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryCollectionsByProjectQuery, RegistryCollectionsByProjectQueryVariables> & ({ variables: RegistryCollectionsByProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryCollectionsByProjectQuery, RegistryCollectionsByProjectQueryVariables>(RegistryCollectionsByProjectDocument, options);
      }
export function useRegistryCollectionsByProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryCollectionsByProjectQuery, RegistryCollectionsByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryCollectionsByProjectQuery, RegistryCollectionsByProjectQueryVariables>(RegistryCollectionsByProjectDocument, options);
        }
// @ts-ignore
export function useRegistryCollectionsByProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionsByProjectQuery, RegistryCollectionsByProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryCollectionsByProjectQuery, RegistryCollectionsByProjectQueryVariables>;
export function useRegistryCollectionsByProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionsByProjectQuery, RegistryCollectionsByProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryCollectionsByProjectQuery | undefined, RegistryCollectionsByProjectQueryVariables>;
export function useRegistryCollectionsByProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionsByProjectQuery, RegistryCollectionsByProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryCollectionsByProjectQuery, RegistryCollectionsByProjectQueryVariables>(RegistryCollectionsByProjectDocument, options);
        }
export type RegistryCollectionsByProjectQueryHookResult = ReturnType<typeof useRegistryCollectionsByProjectQuery>;
export type RegistryCollectionsByProjectLazyQueryHookResult = ReturnType<typeof useRegistryCollectionsByProjectLazyQuery>;
export type RegistryCollectionsByProjectSuspenseQueryHookResult = ReturnType<typeof useRegistryCollectionsByProjectSuspenseQuery>;
export type RegistryCollectionsByProjectQueryResult = ApolloReactCommon.QueryResult<RegistryCollectionsByProjectQuery, RegistryCollectionsByProjectQueryVariables>;
export const CreateRegistryHuggingFaceImportDocument = gql`
    mutation CreateRegistryHuggingFaceImport($input: CreateRegistryHuggingFaceImportInput!) {
  createRegistryHuggingFaceImport(input: $input) {
    registryHuggingFaceImport {
      ...RegistryHuggingFaceImportFields
    }
  }
}
    ${RegistryHuggingFaceImportFieldsFragmentDoc}`;
export type CreateRegistryHuggingFaceImportMutationFn = ApolloReactCommon.MutationFunction<CreateRegistryHuggingFaceImportMutation, CreateRegistryHuggingFaceImportMutationVariables>;

/**
 * __useCreateRegistryHuggingFaceImportMutation__
 *
 * To run a mutation, you first call `useCreateRegistryHuggingFaceImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistryHuggingFaceImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegistryHuggingFaceImportMutation, { data, loading, error }] = useCreateRegistryHuggingFaceImportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRegistryHuggingFaceImportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRegistryHuggingFaceImportMutation, CreateRegistryHuggingFaceImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateRegistryHuggingFaceImportMutation, CreateRegistryHuggingFaceImportMutationVariables>(CreateRegistryHuggingFaceImportDocument, options);
      }
export type CreateRegistryHuggingFaceImportMutationHookResult = ReturnType<typeof useCreateRegistryHuggingFaceImportMutation>;
export type CreateRegistryHuggingFaceImportMutationResult = ApolloReactCommon.MutationResult<CreateRegistryHuggingFaceImportMutation>;
export type CreateRegistryHuggingFaceImportMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateRegistryHuggingFaceImportMutation, CreateRegistryHuggingFaceImportMutationVariables>;
export const RegistryHuggingFaceImportDocument = gql`
    query RegistryHuggingFaceImport($id: ID!) {
  registryHuggingFaceImport(id: $id) {
    ...RegistryHuggingFaceImportFields
  }
}
    ${RegistryHuggingFaceImportFieldsFragmentDoc}`;

/**
 * __useRegistryHuggingFaceImportQuery__
 *
 * To run a query within a React component, call `useRegistryHuggingFaceImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryHuggingFaceImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryHuggingFaceImportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegistryHuggingFaceImportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryHuggingFaceImportQuery, RegistryHuggingFaceImportQueryVariables> & ({ variables: RegistryHuggingFaceImportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryHuggingFaceImportQuery, RegistryHuggingFaceImportQueryVariables>(RegistryHuggingFaceImportDocument, options);
      }
export function useRegistryHuggingFaceImportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryHuggingFaceImportQuery, RegistryHuggingFaceImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryHuggingFaceImportQuery, RegistryHuggingFaceImportQueryVariables>(RegistryHuggingFaceImportDocument, options);
        }
// @ts-ignore
export function useRegistryHuggingFaceImportSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryHuggingFaceImportQuery, RegistryHuggingFaceImportQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryHuggingFaceImportQuery, RegistryHuggingFaceImportQueryVariables>;
export function useRegistryHuggingFaceImportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryHuggingFaceImportQuery, RegistryHuggingFaceImportQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryHuggingFaceImportQuery | undefined, RegistryHuggingFaceImportQueryVariables>;
export function useRegistryHuggingFaceImportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryHuggingFaceImportQuery, RegistryHuggingFaceImportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryHuggingFaceImportQuery, RegistryHuggingFaceImportQueryVariables>(RegistryHuggingFaceImportDocument, options);
        }
export type RegistryHuggingFaceImportQueryHookResult = ReturnType<typeof useRegistryHuggingFaceImportQuery>;
export type RegistryHuggingFaceImportLazyQueryHookResult = ReturnType<typeof useRegistryHuggingFaceImportLazyQuery>;
export type RegistryHuggingFaceImportSuspenseQueryHookResult = ReturnType<typeof useRegistryHuggingFaceImportSuspenseQuery>;
export type RegistryHuggingFaceImportQueryResult = ApolloReactCommon.QueryResult<RegistryHuggingFaceImportQuery, RegistryHuggingFaceImportQueryVariables>;
export const RegistryHuggingFaceImportsDocument = gql`
    query RegistryHuggingFaceImports($orgName: String!, $first: Int, $after: String) {
  organization(name: $orgName) {
    id
    registryHuggingFaceImports(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...RegistryHuggingFaceImportFields
        }
      }
    }
  }
}
    ${RegistryHuggingFaceImportFieldsFragmentDoc}`;

/**
 * __useRegistryHuggingFaceImportsQuery__
 *
 * To run a query within a React component, call `useRegistryHuggingFaceImportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryHuggingFaceImportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryHuggingFaceImportsQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRegistryHuggingFaceImportsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryHuggingFaceImportsQuery, RegistryHuggingFaceImportsQueryVariables> & ({ variables: RegistryHuggingFaceImportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryHuggingFaceImportsQuery, RegistryHuggingFaceImportsQueryVariables>(RegistryHuggingFaceImportsDocument, options);
      }
export function useRegistryHuggingFaceImportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryHuggingFaceImportsQuery, RegistryHuggingFaceImportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryHuggingFaceImportsQuery, RegistryHuggingFaceImportsQueryVariables>(RegistryHuggingFaceImportsDocument, options);
        }
// @ts-ignore
export function useRegistryHuggingFaceImportsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryHuggingFaceImportsQuery, RegistryHuggingFaceImportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryHuggingFaceImportsQuery, RegistryHuggingFaceImportsQueryVariables>;
export function useRegistryHuggingFaceImportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryHuggingFaceImportsQuery, RegistryHuggingFaceImportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryHuggingFaceImportsQuery | undefined, RegistryHuggingFaceImportsQueryVariables>;
export function useRegistryHuggingFaceImportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryHuggingFaceImportsQuery, RegistryHuggingFaceImportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryHuggingFaceImportsQuery, RegistryHuggingFaceImportsQueryVariables>(RegistryHuggingFaceImportsDocument, options);
        }
export type RegistryHuggingFaceImportsQueryHookResult = ReturnType<typeof useRegistryHuggingFaceImportsQuery>;
export type RegistryHuggingFaceImportsLazyQueryHookResult = ReturnType<typeof useRegistryHuggingFaceImportsLazyQuery>;
export type RegistryHuggingFaceImportsSuspenseQueryHookResult = ReturnType<typeof useRegistryHuggingFaceImportsSuspenseQuery>;
export type RegistryHuggingFaceImportsQueryResult = ApolloReactCommon.QueryResult<RegistryHuggingFaceImportsQuery, RegistryHuggingFaceImportsQueryVariables>;
export const CreateRegistryMembersDocument = gql`
    mutation createRegistryMembers($userIds: [ID!], $teamIds: [ID!], $projectId: ID!) {
  createProjectMembers(
    input: {userIds: $userIds, teamIds: $teamIds, projectId: $projectId}
  ) {
    success
  }
}
    `;
export type CreateRegistryMembersMutationFn = ApolloReactCommon.MutationFunction<CreateRegistryMembersMutation, CreateRegistryMembersMutationVariables>;

/**
 * __useCreateRegistryMembersMutation__
 *
 * To run a mutation, you first call `useCreateRegistryMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistryMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegistryMembersMutation, { data, loading, error }] = useCreateRegistryMembersMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      teamIds: // value for 'teamIds'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateRegistryMembersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRegistryMembersMutation, CreateRegistryMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateRegistryMembersMutation, CreateRegistryMembersMutationVariables>(CreateRegistryMembersDocument, options);
      }
export type CreateRegistryMembersMutationHookResult = ReturnType<typeof useCreateRegistryMembersMutation>;
export type CreateRegistryMembersMutationResult = ApolloReactCommon.MutationResult<CreateRegistryMembersMutation>;
export type CreateRegistryMembersMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateRegistryMembersMutation, CreateRegistryMembersMutationVariables>;
export const DeleteRegistryMembersDocument = gql`
    mutation deleteRegistryMembers($userIds: [ID!], $teamIds: [ID!], $projectId: ID!) {
  deleteProjectMembers(
    input: {userIds: $userIds, teamIds: $teamIds, projectId: $projectId}
  ) {
    success
  }
}
    `;
export type DeleteRegistryMembersMutationFn = ApolloReactCommon.MutationFunction<DeleteRegistryMembersMutation, DeleteRegistryMembersMutationVariables>;

/**
 * __useDeleteRegistryMembersMutation__
 *
 * To run a mutation, you first call `useDeleteRegistryMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegistryMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegistryMembersMutation, { data, loading, error }] = useDeleteRegistryMembersMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      teamIds: // value for 'teamIds'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteRegistryMembersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRegistryMembersMutation, DeleteRegistryMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteRegistryMembersMutation, DeleteRegistryMembersMutationVariables>(DeleteRegistryMembersDocument, options);
      }
export type DeleteRegistryMembersMutationHookResult = ReturnType<typeof useDeleteRegistryMembersMutation>;
export type DeleteRegistryMembersMutationResult = ApolloReactCommon.MutationResult<DeleteRegistryMembersMutation>;
export type DeleteRegistryMembersMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteRegistryMembersMutation, DeleteRegistryMembersMutationVariables>;
export const UpdateUserRegistryRoleDocument = gql`
    mutation updateUserRegistryRole($userId: ID!, $projectId: ID!, $userProjectRole: String!, $clientMutationId: String) {
  updateProjectMember(
    input: {userId: $userId, projectId: $projectId, userProjectRole: $userProjectRole, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateUserRegistryRoleMutationFn = ApolloReactCommon.MutationFunction<UpdateUserRegistryRoleMutation, UpdateUserRegistryRoleMutationVariables>;

/**
 * __useUpdateUserRegistryRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRegistryRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRegistryRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRegistryRoleMutation, { data, loading, error }] = useUpdateUserRegistryRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      projectId: // value for 'projectId'
 *      userProjectRole: // value for 'userProjectRole'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateUserRegistryRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserRegistryRoleMutation, UpdateUserRegistryRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserRegistryRoleMutation, UpdateUserRegistryRoleMutationVariables>(UpdateUserRegistryRoleDocument, options);
      }
export type UpdateUserRegistryRoleMutationHookResult = ReturnType<typeof useUpdateUserRegistryRoleMutation>;
export type UpdateUserRegistryRoleMutationResult = ApolloReactCommon.MutationResult<UpdateUserRegistryRoleMutation>;
export type UpdateUserRegistryRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserRegistryRoleMutation, UpdateUserRegistryRoleMutationVariables>;
export const UpdateTeamRegistryRoleDocument = gql`
    mutation updateTeamRegistryRole($teamId: ID!, $projectId: ID!, $teamProjectRole: String!, $clientMutationId: String) {
  updateProjectTeamMember(
    input: {teamId: $teamId, projectId: $projectId, teamProjectRole: $teamProjectRole, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateTeamRegistryRoleMutationFn = ApolloReactCommon.MutationFunction<UpdateTeamRegistryRoleMutation, UpdateTeamRegistryRoleMutationVariables>;

/**
 * __useUpdateTeamRegistryRoleMutation__
 *
 * To run a mutation, you first call `useUpdateTeamRegistryRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamRegistryRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamRegistryRoleMutation, { data, loading, error }] = useUpdateTeamRegistryRoleMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      projectId: // value for 'projectId'
 *      teamProjectRole: // value for 'teamProjectRole'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateTeamRegistryRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTeamRegistryRoleMutation, UpdateTeamRegistryRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTeamRegistryRoleMutation, UpdateTeamRegistryRoleMutationVariables>(UpdateTeamRegistryRoleDocument, options);
      }
export type UpdateTeamRegistryRoleMutationHookResult = ReturnType<typeof useUpdateTeamRegistryRoleMutation>;
export type UpdateTeamRegistryRoleMutationResult = ApolloReactCommon.MutationResult<UpdateTeamRegistryRoleMutation>;
export type UpdateTeamRegistryRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTeamRegistryRoleMutation, UpdateTeamRegistryRoleMutationVariables>;
export const ArtifactMembershipsDocument = gql`
    query ArtifactMemberships($organization: String!, $registryFilter: JSONString, $collectionFilter: JSONString, $artifactFilter: JSONString, $cursor: String, $perPage: Int, $order: String) {
  organization(name: $organization) {
    id
    orgEntity {
      id
      name
      artifactMemberships(
        projectFilters: $registryFilter
        collectionFilters: $collectionFilter
        filters: $artifactFilter
        after: $cursor
        first: $perPage
        order: $order
      ) {
        pageInfo {
          ...PageInfoFragment
        }
        edges {
          node {
            ...ArtifactMembershipFragment
          }
        }
      }
    }
  }
}
    ${PageInfoFragmentFragmentDoc}
${ArtifactMembershipFragmentFragmentDoc}`;

/**
 * __useArtifactMembershipsQuery__
 *
 * To run a query within a React component, call `useArtifactMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactMembershipsQuery({
 *   variables: {
 *      organization: // value for 'organization'
 *      registryFilter: // value for 'registryFilter'
 *      collectionFilter: // value for 'collectionFilter'
 *      artifactFilter: // value for 'artifactFilter'
 *      cursor: // value for 'cursor'
 *      perPage: // value for 'perPage'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useArtifactMembershipsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables> & ({ variables: ArtifactMembershipsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables>(ArtifactMembershipsDocument, options);
      }
export function useArtifactMembershipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables>(ArtifactMembershipsDocument, options);
        }
// @ts-ignore
export function useArtifactMembershipsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables>;
export function useArtifactMembershipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactMembershipsQuery | undefined, ArtifactMembershipsQueryVariables>;
export function useArtifactMembershipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables>(ArtifactMembershipsDocument, options);
        }
export type ArtifactMembershipsQueryHookResult = ReturnType<typeof useArtifactMembershipsQuery>;
export type ArtifactMembershipsLazyQueryHookResult = ReturnType<typeof useArtifactMembershipsLazyQuery>;
export type ArtifactMembershipsSuspenseQueryHookResult = ReturnType<typeof useArtifactMembershipsSuspenseQuery>;
export type ArtifactMembershipsQueryResult = ApolloReactCommon.QueryResult<ArtifactMembershipsQuery, ArtifactMembershipsQueryVariables>;
export const CreateRegistryModelDeploymentDocument = gql`
    mutation CreateRegistryModelDeployment($input: CreateRegistryModelDeploymentInput!) {
  createRegistryModelDeployment(input: $input) {
    registryModelDeployment {
      ...RegistryModelDeploymentFields
    }
  }
}
    ${RegistryModelDeploymentFieldsFragmentDoc}`;
export type CreateRegistryModelDeploymentMutationFn = ApolloReactCommon.MutationFunction<CreateRegistryModelDeploymentMutation, CreateRegistryModelDeploymentMutationVariables>;

/**
 * __useCreateRegistryModelDeploymentMutation__
 *
 * To run a mutation, you first call `useCreateRegistryModelDeploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistryModelDeploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegistryModelDeploymentMutation, { data, loading, error }] = useCreateRegistryModelDeploymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRegistryModelDeploymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRegistryModelDeploymentMutation, CreateRegistryModelDeploymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateRegistryModelDeploymentMutation, CreateRegistryModelDeploymentMutationVariables>(CreateRegistryModelDeploymentDocument, options);
      }
export type CreateRegistryModelDeploymentMutationHookResult = ReturnType<typeof useCreateRegistryModelDeploymentMutation>;
export type CreateRegistryModelDeploymentMutationResult = ApolloReactCommon.MutationResult<CreateRegistryModelDeploymentMutation>;
export type CreateRegistryModelDeploymentMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateRegistryModelDeploymentMutation, CreateRegistryModelDeploymentMutationVariables>;
export const StopRegistryModelDeploymentDocument = gql`
    mutation StopRegistryModelDeployment($input: StopRegistryModelDeploymentInput!) {
  stopRegistryModelDeployment(input: $input) {
    registryModelDeployment {
      ...RegistryModelDeploymentFields
    }
  }
}
    ${RegistryModelDeploymentFieldsFragmentDoc}`;
export type StopRegistryModelDeploymentMutationFn = ApolloReactCommon.MutationFunction<StopRegistryModelDeploymentMutation, StopRegistryModelDeploymentMutationVariables>;

/**
 * __useStopRegistryModelDeploymentMutation__
 *
 * To run a mutation, you first call `useStopRegistryModelDeploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopRegistryModelDeploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopRegistryModelDeploymentMutation, { data, loading, error }] = useStopRegistryModelDeploymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStopRegistryModelDeploymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StopRegistryModelDeploymentMutation, StopRegistryModelDeploymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StopRegistryModelDeploymentMutation, StopRegistryModelDeploymentMutationVariables>(StopRegistryModelDeploymentDocument, options);
      }
export type StopRegistryModelDeploymentMutationHookResult = ReturnType<typeof useStopRegistryModelDeploymentMutation>;
export type StopRegistryModelDeploymentMutationResult = ApolloReactCommon.MutationResult<StopRegistryModelDeploymentMutation>;
export type StopRegistryModelDeploymentMutationOptions = ApolloReactCommon.BaseMutationOptions<StopRegistryModelDeploymentMutation, StopRegistryModelDeploymentMutationVariables>;
export const RegistryModelDeploymentDocument = gql`
    query RegistryModelDeployment($id: ID!) {
  registryModelDeployment(id: $id) {
    ...RegistryModelDeploymentFields
  }
}
    ${RegistryModelDeploymentFieldsFragmentDoc}`;

/**
 * __useRegistryModelDeploymentQuery__
 *
 * To run a query within a React component, call `useRegistryModelDeploymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryModelDeploymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryModelDeploymentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegistryModelDeploymentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryModelDeploymentQuery, RegistryModelDeploymentQueryVariables> & ({ variables: RegistryModelDeploymentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryModelDeploymentQuery, RegistryModelDeploymentQueryVariables>(RegistryModelDeploymentDocument, options);
      }
export function useRegistryModelDeploymentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryModelDeploymentQuery, RegistryModelDeploymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryModelDeploymentQuery, RegistryModelDeploymentQueryVariables>(RegistryModelDeploymentDocument, options);
        }
// @ts-ignore
export function useRegistryModelDeploymentSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryModelDeploymentQuery, RegistryModelDeploymentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryModelDeploymentQuery, RegistryModelDeploymentQueryVariables>;
export function useRegistryModelDeploymentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryModelDeploymentQuery, RegistryModelDeploymentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryModelDeploymentQuery | undefined, RegistryModelDeploymentQueryVariables>;
export function useRegistryModelDeploymentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryModelDeploymentQuery, RegistryModelDeploymentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryModelDeploymentQuery, RegistryModelDeploymentQueryVariables>(RegistryModelDeploymentDocument, options);
        }
export type RegistryModelDeploymentQueryHookResult = ReturnType<typeof useRegistryModelDeploymentQuery>;
export type RegistryModelDeploymentLazyQueryHookResult = ReturnType<typeof useRegistryModelDeploymentLazyQuery>;
export type RegistryModelDeploymentSuspenseQueryHookResult = ReturnType<typeof useRegistryModelDeploymentSuspenseQuery>;
export type RegistryModelDeploymentQueryResult = ApolloReactCommon.QueryResult<RegistryModelDeploymentQuery, RegistryModelDeploymentQueryVariables>;
export const RegistryVersionDeploymentsDocument = gql`
    query RegistryVersionDeployments($entityName: String!, $projectName: String!, $collectionName: String!, $aliasName: String!, $first: Int!) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactCollection(name: $collectionName) {
      id
      artifactMembership(aliasName: $aliasName) {
        id
        registryModelDeployments(first: $first) {
          pageInfo {
            hasNextPage
          }
          edges {
            node {
              ...RegistryModelDeploymentFields
            }
          }
        }
      }
    }
  }
}
    ${RegistryModelDeploymentFieldsFragmentDoc}`;

/**
 * __useRegistryVersionDeploymentsQuery__
 *
 * To run a query within a React component, call `useRegistryVersionDeploymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryVersionDeploymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryVersionDeploymentsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      collectionName: // value for 'collectionName'
 *      aliasName: // value for 'aliasName'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useRegistryVersionDeploymentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryVersionDeploymentsQuery, RegistryVersionDeploymentsQueryVariables> & ({ variables: RegistryVersionDeploymentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryVersionDeploymentsQuery, RegistryVersionDeploymentsQueryVariables>(RegistryVersionDeploymentsDocument, options);
      }
export function useRegistryVersionDeploymentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryVersionDeploymentsQuery, RegistryVersionDeploymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryVersionDeploymentsQuery, RegistryVersionDeploymentsQueryVariables>(RegistryVersionDeploymentsDocument, options);
        }
// @ts-ignore
export function useRegistryVersionDeploymentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryVersionDeploymentsQuery, RegistryVersionDeploymentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryVersionDeploymentsQuery, RegistryVersionDeploymentsQueryVariables>;
export function useRegistryVersionDeploymentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryVersionDeploymentsQuery, RegistryVersionDeploymentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryVersionDeploymentsQuery | undefined, RegistryVersionDeploymentsQueryVariables>;
export function useRegistryVersionDeploymentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryVersionDeploymentsQuery, RegistryVersionDeploymentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryVersionDeploymentsQuery, RegistryVersionDeploymentsQueryVariables>(RegistryVersionDeploymentsDocument, options);
        }
export type RegistryVersionDeploymentsQueryHookResult = ReturnType<typeof useRegistryVersionDeploymentsQuery>;
export type RegistryVersionDeploymentsLazyQueryHookResult = ReturnType<typeof useRegistryVersionDeploymentsLazyQuery>;
export type RegistryVersionDeploymentsSuspenseQueryHookResult = ReturnType<typeof useRegistryVersionDeploymentsSuspenseQuery>;
export type RegistryVersionDeploymentsQueryResult = ApolloReactCommon.QueryResult<RegistryVersionDeploymentsQuery, RegistryVersionDeploymentsQueryVariables>;
export const RegistryCollectionDeploymentsDocument = gql`
    query RegistryCollectionDeployments($collectionId: ID!, $first: Int!) {
  artifactCollection(id: $collectionId) {
    id
    registryModelDeployments(first: $first) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          ...RegistryModelDeploymentFields
        }
      }
    }
  }
}
    ${RegistryModelDeploymentFieldsFragmentDoc}`;

/**
 * __useRegistryCollectionDeploymentsQuery__
 *
 * To run a query within a React component, call `useRegistryCollectionDeploymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryCollectionDeploymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryCollectionDeploymentsQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useRegistryCollectionDeploymentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryCollectionDeploymentsQuery, RegistryCollectionDeploymentsQueryVariables> & ({ variables: RegistryCollectionDeploymentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryCollectionDeploymentsQuery, RegistryCollectionDeploymentsQueryVariables>(RegistryCollectionDeploymentsDocument, options);
      }
export function useRegistryCollectionDeploymentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryCollectionDeploymentsQuery, RegistryCollectionDeploymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryCollectionDeploymentsQuery, RegistryCollectionDeploymentsQueryVariables>(RegistryCollectionDeploymentsDocument, options);
        }
// @ts-ignore
export function useRegistryCollectionDeploymentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionDeploymentsQuery, RegistryCollectionDeploymentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryCollectionDeploymentsQuery, RegistryCollectionDeploymentsQueryVariables>;
export function useRegistryCollectionDeploymentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionDeploymentsQuery, RegistryCollectionDeploymentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryCollectionDeploymentsQuery | undefined, RegistryCollectionDeploymentsQueryVariables>;
export function useRegistryCollectionDeploymentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionDeploymentsQuery, RegistryCollectionDeploymentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryCollectionDeploymentsQuery, RegistryCollectionDeploymentsQueryVariables>(RegistryCollectionDeploymentsDocument, options);
        }
export type RegistryCollectionDeploymentsQueryHookResult = ReturnType<typeof useRegistryCollectionDeploymentsQuery>;
export type RegistryCollectionDeploymentsLazyQueryHookResult = ReturnType<typeof useRegistryCollectionDeploymentsLazyQuery>;
export type RegistryCollectionDeploymentsSuspenseQueryHookResult = ReturnType<typeof useRegistryCollectionDeploymentsSuspenseQuery>;
export type RegistryCollectionDeploymentsQueryResult = ApolloReactCommon.QueryResult<RegistryCollectionDeploymentsQuery, RegistryCollectionDeploymentsQueryVariables>;
export const RegistryCollectionDeploymentCountsDocument = gql`
    query RegistryCollectionDeploymentCounts($collectionId: ID!, $states: [RegistryModelDeploymentState!]) {
  artifactCollection(id: $collectionId) {
    id
    registryModelDeployments(first: 100, states: $states) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          registryVersionIndex
          state
        }
      }
    }
  }
}
    `;

/**
 * __useRegistryCollectionDeploymentCountsQuery__
 *
 * To run a query within a React component, call `useRegistryCollectionDeploymentCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryCollectionDeploymentCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryCollectionDeploymentCountsQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      states: // value for 'states'
 *   },
 * });
 */
export function useRegistryCollectionDeploymentCountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryCollectionDeploymentCountsQuery, RegistryCollectionDeploymentCountsQueryVariables> & ({ variables: RegistryCollectionDeploymentCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryCollectionDeploymentCountsQuery, RegistryCollectionDeploymentCountsQueryVariables>(RegistryCollectionDeploymentCountsDocument, options);
      }
export function useRegistryCollectionDeploymentCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryCollectionDeploymentCountsQuery, RegistryCollectionDeploymentCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryCollectionDeploymentCountsQuery, RegistryCollectionDeploymentCountsQueryVariables>(RegistryCollectionDeploymentCountsDocument, options);
        }
// @ts-ignore
export function useRegistryCollectionDeploymentCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionDeploymentCountsQuery, RegistryCollectionDeploymentCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryCollectionDeploymentCountsQuery, RegistryCollectionDeploymentCountsQueryVariables>;
export function useRegistryCollectionDeploymentCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionDeploymentCountsQuery, RegistryCollectionDeploymentCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryCollectionDeploymentCountsQuery | undefined, RegistryCollectionDeploymentCountsQueryVariables>;
export function useRegistryCollectionDeploymentCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionDeploymentCountsQuery, RegistryCollectionDeploymentCountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryCollectionDeploymentCountsQuery, RegistryCollectionDeploymentCountsQueryVariables>(RegistryCollectionDeploymentCountsDocument, options);
        }
export type RegistryCollectionDeploymentCountsQueryHookResult = ReturnType<typeof useRegistryCollectionDeploymentCountsQuery>;
export type RegistryCollectionDeploymentCountsLazyQueryHookResult = ReturnType<typeof useRegistryCollectionDeploymentCountsLazyQuery>;
export type RegistryCollectionDeploymentCountsSuspenseQueryHookResult = ReturnType<typeof useRegistryCollectionDeploymentCountsSuspenseQuery>;
export type RegistryCollectionDeploymentCountsQueryResult = ApolloReactCommon.QueryResult<RegistryCollectionDeploymentCountsQuery, RegistryCollectionDeploymentCountsQueryVariables>;
export const RegistryProjectArtifactTypesDocument = gql`
    query RegistryProjectArtifactTypes($entityName: String!, $projectName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    artifactTypes(includeAll: true) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useRegistryProjectArtifactTypesQuery__
 *
 * To run a query within a React component, call `useRegistryProjectArtifactTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryProjectArtifactTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryProjectArtifactTypesQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useRegistryProjectArtifactTypesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables> & ({ variables: RegistryProjectArtifactTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables>(RegistryProjectArtifactTypesDocument, options);
      }
export function useRegistryProjectArtifactTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables>(RegistryProjectArtifactTypesDocument, options);
        }
// @ts-ignore
export function useRegistryProjectArtifactTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables>;
export function useRegistryProjectArtifactTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryProjectArtifactTypesQuery | undefined, RegistryProjectArtifactTypesQueryVariables>;
export function useRegistryProjectArtifactTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables>(RegistryProjectArtifactTypesDocument, options);
        }
export type RegistryProjectArtifactTypesQueryHookResult = ReturnType<typeof useRegistryProjectArtifactTypesQuery>;
export type RegistryProjectArtifactTypesLazyQueryHookResult = ReturnType<typeof useRegistryProjectArtifactTypesLazyQuery>;
export type RegistryProjectArtifactTypesSuspenseQueryHookResult = ReturnType<typeof useRegistryProjectArtifactTypesSuspenseQuery>;
export type RegistryProjectArtifactTypesQueryResult = ApolloReactCommon.QueryResult<RegistryProjectArtifactTypesQuery, RegistryProjectArtifactTypesQueryVariables>;
export const RegistryProjectMembersDocument = gql`
    query RegistryProjectMembers($entityName: String!, $projectName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    user {
      id
      name
      username
      photoUrl
      email
      accountType
    }
    members {
      id
      username
      name
      photoUrl
      email
      accountType
      role {
        ID
        name
      }
      projectRoleIsInherited
    }
    teamMembers {
      role {
        ID
        name
      }
      team {
        id
        name
        photoUrl
        memberCount
        members {
          id
          role
          name
          photoUrl
          accountType
        }
      }
    }
  }
}
    `;

/**
 * __useRegistryProjectMembersQuery__
 *
 * To run a query within a React component, call `useRegistryProjectMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryProjectMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryProjectMembersQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useRegistryProjectMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables> & ({ variables: RegistryProjectMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables>(RegistryProjectMembersDocument, options);
      }
export function useRegistryProjectMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables>(RegistryProjectMembersDocument, options);
        }
// @ts-ignore
export function useRegistryProjectMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables>;
export function useRegistryProjectMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryProjectMembersQuery | undefined, RegistryProjectMembersQueryVariables>;
export function useRegistryProjectMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables>(RegistryProjectMembersDocument, options);
        }
export type RegistryProjectMembersQueryHookResult = ReturnType<typeof useRegistryProjectMembersQuery>;
export type RegistryProjectMembersLazyQueryHookResult = ReturnType<typeof useRegistryProjectMembersLazyQuery>;
export type RegistryProjectMembersSuspenseQueryHookResult = ReturnType<typeof useRegistryProjectMembersSuspenseQuery>;
export type RegistryProjectMembersQueryResult = ApolloReactCommon.QueryResult<RegistryProjectMembersQuery, RegistryProjectMembersQueryVariables>;
export const RegistryProjectMemberDocument = gql`
    query RegistryProjectMember($entityName: String!, $projectName: String!, $memberID: ID!) {
  project(entityName: $entityName, name: $projectName) {
    id
    member(id: $memberID) {
      id
      role {
        ID
        name
      }
      projectRoleIsInherited
    }
    teamMembers {
      role {
        ID
        name
      }
      team {
        id
        member(id: $memberID) {
          id
          role
        }
      }
    }
  }
}
    `;

/**
 * __useRegistryProjectMemberQuery__
 *
 * To run a query within a React component, call `useRegistryProjectMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryProjectMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryProjectMemberQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      memberID: // value for 'memberID'
 *   },
 * });
 */
export function useRegistryProjectMemberQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables> & ({ variables: RegistryProjectMemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables>(RegistryProjectMemberDocument, options);
      }
export function useRegistryProjectMemberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables>(RegistryProjectMemberDocument, options);
        }
// @ts-ignore
export function useRegistryProjectMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables>;
export function useRegistryProjectMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryProjectMemberQuery | undefined, RegistryProjectMemberQueryVariables>;
export function useRegistryProjectMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables>(RegistryProjectMemberDocument, options);
        }
export type RegistryProjectMemberQueryHookResult = ReturnType<typeof useRegistryProjectMemberQuery>;
export type RegistryProjectMemberLazyQueryHookResult = ReturnType<typeof useRegistryProjectMemberLazyQuery>;
export type RegistryProjectMemberSuspenseQueryHookResult = ReturnType<typeof useRegistryProjectMemberSuspenseQuery>;
export type RegistryProjectMemberQueryResult = ApolloReactCommon.QueryResult<RegistryProjectMemberQuery, RegistryProjectMemberQueryVariables>;
export const BatchRegistryViewerMembershipDocument = gql`
    query BatchRegistryViewerMembership($entityName: String!, $viewerID: ID!, $projectIDs: [ID!]!) {
  projects(entityName: $entityName, projectIDs: $projectIDs) {
    edges {
      node {
        id
        member(id: $viewerID) {
          id
          name
        }
        teamMembers {
          team {
            id
            member(id: $viewerID) {
              id
              role
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useBatchRegistryViewerMembershipQuery__
 *
 * To run a query within a React component, call `useBatchRegistryViewerMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useBatchRegistryViewerMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBatchRegistryViewerMembershipQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      viewerID: // value for 'viewerID'
 *      projectIDs: // value for 'projectIDs'
 *   },
 * });
 */
export function useBatchRegistryViewerMembershipQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables> & ({ variables: BatchRegistryViewerMembershipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables>(BatchRegistryViewerMembershipDocument, options);
      }
export function useBatchRegistryViewerMembershipLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables>(BatchRegistryViewerMembershipDocument, options);
        }
// @ts-ignore
export function useBatchRegistryViewerMembershipSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables>;
export function useBatchRegistryViewerMembershipSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BatchRegistryViewerMembershipQuery | undefined, BatchRegistryViewerMembershipQueryVariables>;
export function useBatchRegistryViewerMembershipSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables>(BatchRegistryViewerMembershipDocument, options);
        }
export type BatchRegistryViewerMembershipQueryHookResult = ReturnType<typeof useBatchRegistryViewerMembershipQuery>;
export type BatchRegistryViewerMembershipLazyQueryHookResult = ReturnType<typeof useBatchRegistryViewerMembershipLazyQuery>;
export type BatchRegistryViewerMembershipSuspenseQueryHookResult = ReturnType<typeof useBatchRegistryViewerMembershipSuspenseQuery>;
export type BatchRegistryViewerMembershipQueryResult = ApolloReactCommon.QueryResult<BatchRegistryViewerMembershipQuery, BatchRegistryViewerMembershipQueryVariables>;
export const FetchRegistryProjectsPartialDocument = gql`
    query FetchRegistryProjectsPartial($orgName: String!, $pattern: String, $after: String, $filters: JSONString, $order: String, $limit: Int) {
  organization(name: $orgName) {
    id
    registries(
      pattern: $pattern
      filters: $filters
      order: $order
      after: $after
      first: $limit
    ) {
      ...RegistryProjectsSearchFragment
    }
  }
}
    ${RegistryProjectsSearchFragmentFragmentDoc}`;

/**
 * __useFetchRegistryProjectsPartialQuery__
 *
 * To run a query within a React component, call `useFetchRegistryProjectsPartialQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRegistryProjectsPartialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRegistryProjectsPartialQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      pattern: // value for 'pattern'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFetchRegistryProjectsPartialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables> & ({ variables: FetchRegistryProjectsPartialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables>(FetchRegistryProjectsPartialDocument, options);
      }
export function useFetchRegistryProjectsPartialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables>(FetchRegistryProjectsPartialDocument, options);
        }
// @ts-ignore
export function useFetchRegistryProjectsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables>;
export function useFetchRegistryProjectsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRegistryProjectsPartialQuery | undefined, FetchRegistryProjectsPartialQueryVariables>;
export function useFetchRegistryProjectsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables>(FetchRegistryProjectsPartialDocument, options);
        }
export type FetchRegistryProjectsPartialQueryHookResult = ReturnType<typeof useFetchRegistryProjectsPartialQuery>;
export type FetchRegistryProjectsPartialLazyQueryHookResult = ReturnType<typeof useFetchRegistryProjectsPartialLazyQuery>;
export type FetchRegistryProjectsPartialSuspenseQueryHookResult = ReturnType<typeof useFetchRegistryProjectsPartialSuspenseQuery>;
export type FetchRegistryProjectsPartialQueryResult = ApolloReactCommon.QueryResult<FetchRegistryProjectsPartialQuery, FetchRegistryProjectsPartialQueryVariables>;
export const LegacyRegistryProjectsDocument = gql`
    query LegacyRegistryProjects($entityName: String!, $pattern: String!) {
  projects(pattern: $pattern, entityName: $entityName) {
    edges {
      node {
        id
        ...ProjectFragment
      }
    }
  }
}
    ${ProjectFragmentFragmentDoc}`;

/**
 * __useLegacyRegistryProjectsQuery__
 *
 * To run a query within a React component, call `useLegacyRegistryProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegacyRegistryProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegacyRegistryProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useLegacyRegistryProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables> & ({ variables: LegacyRegistryProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables>(LegacyRegistryProjectsDocument, options);
      }
export function useLegacyRegistryProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables>(LegacyRegistryProjectsDocument, options);
        }
// @ts-ignore
export function useLegacyRegistryProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables>;
export function useLegacyRegistryProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LegacyRegistryProjectsQuery | undefined, LegacyRegistryProjectsQueryVariables>;
export function useLegacyRegistryProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables>(LegacyRegistryProjectsDocument, options);
        }
export type LegacyRegistryProjectsQueryHookResult = ReturnType<typeof useLegacyRegistryProjectsQuery>;
export type LegacyRegistryProjectsLazyQueryHookResult = ReturnType<typeof useLegacyRegistryProjectsLazyQuery>;
export type LegacyRegistryProjectsSuspenseQueryHookResult = ReturnType<typeof useLegacyRegistryProjectsSuspenseQuery>;
export type LegacyRegistryProjectsQueryResult = ApolloReactCommon.QueryResult<LegacyRegistryProjectsQuery, LegacyRegistryProjectsQueryVariables>;
export const RegistryProjectsWithTypeDocument = gql`
    query RegistryProjectsWithType($orgName: String!, $artifactTypeName: String!) {
  organization(name: $orgName) {
    id
    registries(pattern: "wandb-registry-") {
      edges {
        node {
          id
          name
          artifactType(name: $artifactTypeName) {
            id
            name
          }
          allowAllArtifactTypesInRegistry
          entityName
          readOnly
        }
      }
    }
  }
}
    `;

/**
 * __useRegistryProjectsWithTypeQuery__
 *
 * To run a query within a React component, call `useRegistryProjectsWithTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryProjectsWithTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryProjectsWithTypeQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *   },
 * });
 */
export function useRegistryProjectsWithTypeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables> & ({ variables: RegistryProjectsWithTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables>(RegistryProjectsWithTypeDocument, options);
      }
export function useRegistryProjectsWithTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables>(RegistryProjectsWithTypeDocument, options);
        }
// @ts-ignore
export function useRegistryProjectsWithTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables>;
export function useRegistryProjectsWithTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryProjectsWithTypeQuery | undefined, RegistryProjectsWithTypeQueryVariables>;
export function useRegistryProjectsWithTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables>(RegistryProjectsWithTypeDocument, options);
        }
export type RegistryProjectsWithTypeQueryHookResult = ReturnType<typeof useRegistryProjectsWithTypeQuery>;
export type RegistryProjectsWithTypeLazyQueryHookResult = ReturnType<typeof useRegistryProjectsWithTypeLazyQuery>;
export type RegistryProjectsWithTypeSuspenseQueryHookResult = ReturnType<typeof useRegistryProjectsWithTypeSuspenseQuery>;
export type RegistryProjectsWithTypeQueryResult = ApolloReactCommon.QueryResult<RegistryProjectsWithTypeQuery, RegistryProjectsWithTypeQueryVariables>;
export const UpsertRegistryProjectDocument = gql`
    mutation upsertRegistryProject($description: String, $entityName: String, $id: String, $name: String, $access: String, $owner: ID, $allowAllArtifactTypesInRegistry: Boolean, $artifactTypes: [ArtifactTypeInput!], $icon: ProjectIconInput) {
  upsertModel(
    input: {description: $description, entityName: $entityName, id: $id, name: $name, access: $access, owner: $owner, allowAllArtifactTypesInRegistry: $allowAllArtifactTypesInRegistry, artifactTypes: $artifactTypes, icon: $icon}
  ) {
    project {
      id
      name
      entityName
      description
      access
      user {
        id
      }
      allowAllArtifactTypesInRegistry
      icon {
        name
        color
      }
    }
    inserted
  }
}
    `;
export type UpsertRegistryProjectMutationFn = ApolloReactCommon.MutationFunction<UpsertRegistryProjectMutation, UpsertRegistryProjectMutationVariables>;

/**
 * __useUpsertRegistryProjectMutation__
 *
 * To run a mutation, you first call `useUpsertRegistryProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRegistryProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRegistryProjectMutation, { data, loading, error }] = useUpsertRegistryProjectMutation({
 *   variables: {
 *      description: // value for 'description'
 *      entityName: // value for 'entityName'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      access: // value for 'access'
 *      owner: // value for 'owner'
 *      allowAllArtifactTypesInRegistry: // value for 'allowAllArtifactTypesInRegistry'
 *      artifactTypes: // value for 'artifactTypes'
 *      icon: // value for 'icon'
 *   },
 * });
 */
export function useUpsertRegistryProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertRegistryProjectMutation, UpsertRegistryProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertRegistryProjectMutation, UpsertRegistryProjectMutationVariables>(UpsertRegistryProjectDocument, options);
      }
export type UpsertRegistryProjectMutationHookResult = ReturnType<typeof useUpsertRegistryProjectMutation>;
export type UpsertRegistryProjectMutationResult = ApolloReactCommon.MutationResult<UpsertRegistryProjectMutation>;
export type UpsertRegistryProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertRegistryProjectMutation, UpsertRegistryProjectMutationVariables>;
export const RegistryProjectDocument = gql`
    query RegistryProject($orgName: String!, $projectName: String!) {
  organization(name: $orgName) {
    id
    orgEntity {
      id
      name
      project(name: $projectName) {
        id
        ...ProjectFragment
      }
    }
  }
}
    ${ProjectFragmentFragmentDoc}`;

/**
 * __useRegistryProjectQuery__
 *
 * To run a query within a React component, call `useRegistryProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryProjectQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useRegistryProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryProjectQuery, RegistryProjectQueryVariables> & ({ variables: RegistryProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryProjectQuery, RegistryProjectQueryVariables>(RegistryProjectDocument, options);
      }
export function useRegistryProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryProjectQuery, RegistryProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryProjectQuery, RegistryProjectQueryVariables>(RegistryProjectDocument, options);
        }
// @ts-ignore
export function useRegistryProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectQuery, RegistryProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryProjectQuery, RegistryProjectQueryVariables>;
export function useRegistryProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectQuery, RegistryProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryProjectQuery | undefined, RegistryProjectQueryVariables>;
export function useRegistryProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryProjectQuery, RegistryProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryProjectQuery, RegistryProjectQueryVariables>(RegistryProjectDocument, options);
        }
export type RegistryProjectQueryHookResult = ReturnType<typeof useRegistryProjectQuery>;
export type RegistryProjectLazyQueryHookResult = ReturnType<typeof useRegistryProjectLazyQuery>;
export type RegistryProjectSuspenseQueryHookResult = ReturnType<typeof useRegistryProjectSuspenseQuery>;
export type RegistryProjectQueryResult = ApolloReactCommon.QueryResult<RegistryProjectQuery, RegistryProjectQueryVariables>;
export const StarredRegistriesDocument = gql`
    query StarredRegistries($organizationId: ID) {
  viewer {
    id
    starredRegistries(first: 30, organizationID: $organizationId) {
      edges {
        node {
          id
          ...ProjectFragment
        }
      }
    }
  }
}
    ${ProjectFragmentFragmentDoc}`;

/**
 * __useStarredRegistriesQuery__
 *
 * To run a query within a React component, call `useStarredRegistriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStarredRegistriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStarredRegistriesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useStarredRegistriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StarredRegistriesQuery, StarredRegistriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StarredRegistriesQuery, StarredRegistriesQueryVariables>(StarredRegistriesDocument, options);
      }
export function useStarredRegistriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StarredRegistriesQuery, StarredRegistriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StarredRegistriesQuery, StarredRegistriesQueryVariables>(StarredRegistriesDocument, options);
        }
// @ts-ignore
export function useStarredRegistriesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<StarredRegistriesQuery, StarredRegistriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StarredRegistriesQuery, StarredRegistriesQueryVariables>;
export function useStarredRegistriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StarredRegistriesQuery, StarredRegistriesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StarredRegistriesQuery | undefined, StarredRegistriesQueryVariables>;
export function useStarredRegistriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StarredRegistriesQuery, StarredRegistriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<StarredRegistriesQuery, StarredRegistriesQueryVariables>(StarredRegistriesDocument, options);
        }
export type StarredRegistriesQueryHookResult = ReturnType<typeof useStarredRegistriesQuery>;
export type StarredRegistriesLazyQueryHookResult = ReturnType<typeof useStarredRegistriesLazyQuery>;
export type StarredRegistriesSuspenseQueryHookResult = ReturnType<typeof useStarredRegistriesSuspenseQuery>;
export type StarredRegistriesQueryResult = ApolloReactCommon.QueryResult<StarredRegistriesQuery, StarredRegistriesQueryVariables>;
export const AddProjectProtectedAliasesDocument = gql`
    mutation AddProjectProtectedAliases($entityName: String!, $projectName: String!, $aliases: [String!]!) {
  addProjectProtectedAliases(
    input: {entityName: $entityName, projectName: $projectName, aliases: $aliases}
  ) {
    aliases
  }
}
    `;
export type AddProjectProtectedAliasesMutationFn = ApolloReactCommon.MutationFunction<AddProjectProtectedAliasesMutation, AddProjectProtectedAliasesMutationVariables>;

/**
 * __useAddProjectProtectedAliasesMutation__
 *
 * To run a mutation, you first call `useAddProjectProtectedAliasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectProtectedAliasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectProtectedAliasesMutation, { data, loading, error }] = useAddProjectProtectedAliasesMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      aliases: // value for 'aliases'
 *   },
 * });
 */
export function useAddProjectProtectedAliasesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddProjectProtectedAliasesMutation, AddProjectProtectedAliasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddProjectProtectedAliasesMutation, AddProjectProtectedAliasesMutationVariables>(AddProjectProtectedAliasesDocument, options);
      }
export type AddProjectProtectedAliasesMutationHookResult = ReturnType<typeof useAddProjectProtectedAliasesMutation>;
export type AddProjectProtectedAliasesMutationResult = ApolloReactCommon.MutationResult<AddProjectProtectedAliasesMutation>;
export type AddProjectProtectedAliasesMutationOptions = ApolloReactCommon.BaseMutationOptions<AddProjectProtectedAliasesMutation, AddProjectProtectedAliasesMutationVariables>;
export const RemoveProjectProtectedAliasesDocument = gql`
    mutation RemoveProjectProtectedAliases($entityName: String!, $projectName: String!, $aliases: [String!]!) {
  removeProjectProtectedAliases(
    input: {entityName: $entityName, projectName: $projectName, aliases: $aliases}
  ) {
    aliases
  }
}
    `;
export type RemoveProjectProtectedAliasesMutationFn = ApolloReactCommon.MutationFunction<RemoveProjectProtectedAliasesMutation, RemoveProjectProtectedAliasesMutationVariables>;

/**
 * __useRemoveProjectProtectedAliasesMutation__
 *
 * To run a mutation, you first call `useRemoveProjectProtectedAliasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectProtectedAliasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectProtectedAliasesMutation, { data, loading, error }] = useRemoveProjectProtectedAliasesMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      aliases: // value for 'aliases'
 *   },
 * });
 */
export function useRemoveProjectProtectedAliasesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveProjectProtectedAliasesMutation, RemoveProjectProtectedAliasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveProjectProtectedAliasesMutation, RemoveProjectProtectedAliasesMutationVariables>(RemoveProjectProtectedAliasesDocument, options);
      }
export type RemoveProjectProtectedAliasesMutationHookResult = ReturnType<typeof useRemoveProjectProtectedAliasesMutation>;
export type RemoveProjectProtectedAliasesMutationResult = ApolloReactCommon.MutationResult<RemoveProjectProtectedAliasesMutation>;
export type RemoveProjectProtectedAliasesMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveProjectProtectedAliasesMutation, RemoveProjectProtectedAliasesMutationVariables>;
export const ProjectProtectedAliasesDocument = gql`
    query ProjectProtectedAliases($entityName: String!, $projectName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    protectedArtifactAliases {
      alias
    }
  }
}
    `;

/**
 * __useProjectProtectedAliasesQuery__
 *
 * To run a query within a React component, call `useProjectProtectedAliasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectProtectedAliasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectProtectedAliasesQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useProjectProtectedAliasesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables> & ({ variables: ProjectProtectedAliasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables>(ProjectProtectedAliasesDocument, options);
      }
export function useProjectProtectedAliasesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables>(ProjectProtectedAliasesDocument, options);
        }
// @ts-ignore
export function useProjectProtectedAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables>;
export function useProjectProtectedAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectProtectedAliasesQuery | undefined, ProjectProtectedAliasesQueryVariables>;
export function useProjectProtectedAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables>(ProjectProtectedAliasesDocument, options);
        }
export type ProjectProtectedAliasesQueryHookResult = ReturnType<typeof useProjectProtectedAliasesQuery>;
export type ProjectProtectedAliasesLazyQueryHookResult = ReturnType<typeof useProjectProtectedAliasesLazyQuery>;
export type ProjectProtectedAliasesSuspenseQueryHookResult = ReturnType<typeof useProjectProtectedAliasesSuspenseQuery>;
export type ProjectProtectedAliasesQueryResult = ApolloReactCommon.QueryResult<ProjectProtectedAliasesQuery, ProjectProtectedAliasesQueryVariables>;
export const ArtifactMembershipsWithAliasCountDocument = gql`
    query ArtifactMembershipsWithAliasCount($entityName: String!, $projectName: String!, $alias: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    artifactMembershipsWithAliasCount(alias: $alias)
  }
}
    `;

/**
 * __useArtifactMembershipsWithAliasCountQuery__
 *
 * To run a query within a React component, call `useArtifactMembershipsWithAliasCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactMembershipsWithAliasCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactMembershipsWithAliasCountQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      alias: // value for 'alias'
 *   },
 * });
 */
export function useArtifactMembershipsWithAliasCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables> & ({ variables: ArtifactMembershipsWithAliasCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables>(ArtifactMembershipsWithAliasCountDocument, options);
      }
export function useArtifactMembershipsWithAliasCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables>(ArtifactMembershipsWithAliasCountDocument, options);
        }
// @ts-ignore
export function useArtifactMembershipsWithAliasCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables>;
export function useArtifactMembershipsWithAliasCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactMembershipsWithAliasCountQuery | undefined, ArtifactMembershipsWithAliasCountQueryVariables>;
export function useArtifactMembershipsWithAliasCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables>(ArtifactMembershipsWithAliasCountDocument, options);
        }
export type ArtifactMembershipsWithAliasCountQueryHookResult = ReturnType<typeof useArtifactMembershipsWithAliasCountQuery>;
export type ArtifactMembershipsWithAliasCountLazyQueryHookResult = ReturnType<typeof useArtifactMembershipsWithAliasCountLazyQuery>;
export type ArtifactMembershipsWithAliasCountSuspenseQueryHookResult = ReturnType<typeof useArtifactMembershipsWithAliasCountSuspenseQuery>;
export type ArtifactMembershipsWithAliasCountQueryResult = ApolloReactCommon.QueryResult<ArtifactMembershipsWithAliasCountQuery, ArtifactMembershipsWithAliasCountQueryVariables>;
export const FetchRegistryArtifactCollectionsPartialDocument = gql`
    query FetchRegistryArtifactCollectionsPartial($entityName: String!, $projectName: String!, $searchTerm: String, $cursor: String, $limit: Int!, $artifactsLimit: Int) {
  project(entityName: $entityName, name: $projectName) {
    id
    artifactCollectionsSearch(
      searchTerm: $searchTerm
      cursor: $cursor
      limit: $limit
      artifactsLimit: $artifactsLimit
      collectionTypes: PORTFOLIO
    ) {
      ...registrySearchResultFragment
    }
  }
}
    ${RegistrySearchResultFragmentFragmentDoc}`;

/**
 * __useFetchRegistryArtifactCollectionsPartialQuery__
 *
 * To run a query within a React component, call `useFetchRegistryArtifactCollectionsPartialQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRegistryArtifactCollectionsPartialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRegistryArtifactCollectionsPartialQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      searchTerm: // value for 'searchTerm'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      artifactsLimit: // value for 'artifactsLimit'
 *   },
 * });
 */
export function useFetchRegistryArtifactCollectionsPartialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables> & ({ variables: FetchRegistryArtifactCollectionsPartialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables>(FetchRegistryArtifactCollectionsPartialDocument, options);
      }
export function useFetchRegistryArtifactCollectionsPartialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables>(FetchRegistryArtifactCollectionsPartialDocument, options);
        }
// @ts-ignore
export function useFetchRegistryArtifactCollectionsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables>;
export function useFetchRegistryArtifactCollectionsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRegistryArtifactCollectionsPartialQuery | undefined, FetchRegistryArtifactCollectionsPartialQueryVariables>;
export function useFetchRegistryArtifactCollectionsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables>(FetchRegistryArtifactCollectionsPartialDocument, options);
        }
export type FetchRegistryArtifactCollectionsPartialQueryHookResult = ReturnType<typeof useFetchRegistryArtifactCollectionsPartialQuery>;
export type FetchRegistryArtifactCollectionsPartialLazyQueryHookResult = ReturnType<typeof useFetchRegistryArtifactCollectionsPartialLazyQuery>;
export type FetchRegistryArtifactCollectionsPartialSuspenseQueryHookResult = ReturnType<typeof useFetchRegistryArtifactCollectionsPartialSuspenseQuery>;
export type FetchRegistryArtifactCollectionsPartialQueryResult = ApolloReactCommon.QueryResult<FetchRegistryArtifactCollectionsPartialQuery, FetchRegistryArtifactCollectionsPartialQueryVariables>;
export const FetchEntityModelRegistryArtifactCollectionsPartialDocument = gql`
    query FetchEntityModelRegistryArtifactCollectionsPartial($entityName: String!, $searchTerm: String, $cursor: String, $limit: Int!, $artifactsLimit: Int) {
  entity(name: $entityName) {
    id
    name
    artifactCollectionsSearch(
      searchTerm: $searchTerm
      cursor: $cursor
      limit: $limit
      artifactsLimit: $artifactsLimit
      collectionTypes: PORTFOLIO
    ) {
      ...registrySearchResultFragment
    }
  }
}
    ${RegistrySearchResultFragmentFragmentDoc}`;

/**
 * __useFetchEntityModelRegistryArtifactCollectionsPartialQuery__
 *
 * To run a query within a React component, call `useFetchEntityModelRegistryArtifactCollectionsPartialQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEntityModelRegistryArtifactCollectionsPartialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEntityModelRegistryArtifactCollectionsPartialQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      searchTerm: // value for 'searchTerm'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      artifactsLimit: // value for 'artifactsLimit'
 *   },
 * });
 */
export function useFetchEntityModelRegistryArtifactCollectionsPartialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables> & ({ variables: FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>(FetchEntityModelRegistryArtifactCollectionsPartialDocument, options);
      }
export function useFetchEntityModelRegistryArtifactCollectionsPartialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>(FetchEntityModelRegistryArtifactCollectionsPartialDocument, options);
        }
// @ts-ignore
export function useFetchEntityModelRegistryArtifactCollectionsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>;
export function useFetchEntityModelRegistryArtifactCollectionsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchEntityModelRegistryArtifactCollectionsPartialQuery | undefined, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>;
export function useFetchEntityModelRegistryArtifactCollectionsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>(FetchEntityModelRegistryArtifactCollectionsPartialDocument, options);
        }
export type FetchEntityModelRegistryArtifactCollectionsPartialQueryHookResult = ReturnType<typeof useFetchEntityModelRegistryArtifactCollectionsPartialQuery>;
export type FetchEntityModelRegistryArtifactCollectionsPartialLazyQueryHookResult = ReturnType<typeof useFetchEntityModelRegistryArtifactCollectionsPartialLazyQuery>;
export type FetchEntityModelRegistryArtifactCollectionsPartialSuspenseQueryHookResult = ReturnType<typeof useFetchEntityModelRegistryArtifactCollectionsPartialSuspenseQuery>;
export type FetchEntityModelRegistryArtifactCollectionsPartialQueryResult = ApolloReactCommon.QueryResult<FetchEntityModelRegistryArtifactCollectionsPartialQuery, FetchEntityModelRegistryArtifactCollectionsPartialQueryVariables>;
export const StarRegistryDocument = gql`
    mutation starRegistry($entityName: String!, $registryName: String!, $clientMutationId: String) {
  starRegistry(
    input: {entityName: $entityName, registryName: $registryName, clientMutationId: $clientMutationId}
  ) {
    clientMutationId
  }
}
    `;
export type StarRegistryMutationFn = ApolloReactCommon.MutationFunction<StarRegistryMutation, StarRegistryMutationVariables>;

/**
 * __useStarRegistryMutation__
 *
 * To run a mutation, you first call `useStarRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStarRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [starRegistryMutation, { data, loading, error }] = useStarRegistryMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      registryName: // value for 'registryName'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useStarRegistryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StarRegistryMutation, StarRegistryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StarRegistryMutation, StarRegistryMutationVariables>(StarRegistryDocument, options);
      }
export type StarRegistryMutationHookResult = ReturnType<typeof useStarRegistryMutation>;
export type StarRegistryMutationResult = ApolloReactCommon.MutationResult<StarRegistryMutation>;
export type StarRegistryMutationOptions = ApolloReactCommon.BaseMutationOptions<StarRegistryMutation, StarRegistryMutationVariables>;
export const UnstarRegistryDocument = gql`
    mutation unstarRegistry($entityName: String!, $registryName: String!, $clientMutationId: String) {
  unstarRegistry(
    input: {entityName: $entityName, registryName: $registryName, clientMutationId: $clientMutationId}
  ) {
    clientMutationId
  }
}
    `;
export type UnstarRegistryMutationFn = ApolloReactCommon.MutationFunction<UnstarRegistryMutation, UnstarRegistryMutationVariables>;

/**
 * __useUnstarRegistryMutation__
 *
 * To run a mutation, you first call `useUnstarRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnstarRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unstarRegistryMutation, { data, loading, error }] = useUnstarRegistryMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      registryName: // value for 'registryName'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUnstarRegistryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnstarRegistryMutation, UnstarRegistryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnstarRegistryMutation, UnstarRegistryMutationVariables>(UnstarRegistryDocument, options);
      }
export type UnstarRegistryMutationHookResult = ReturnType<typeof useUnstarRegistryMutation>;
export type UnstarRegistryMutationResult = ApolloReactCommon.MutationResult<UnstarRegistryMutation>;
export type UnstarRegistryMutationOptions = ApolloReactCommon.BaseMutationOptions<UnstarRegistryMutation, UnstarRegistryMutationVariables>;
export const OrganizationRegistryUsageLimitDocument = gql`
    query OrganizationRegistryUsageLimit($organizationName: String!, $requestedIncrease: Int64!) {
  organization(name: $organizationName) {
    id
    registryUsageLimit(requestedIncrease: $requestedIncrease) {
      ...ArtifactUsageLimitStatusFields
    }
  }
}
    ${ArtifactUsageLimitStatusFieldsFragmentDoc}`;

/**
 * __useOrganizationRegistryUsageLimitQuery__
 *
 * To run a query within a React component, call `useOrganizationRegistryUsageLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationRegistryUsageLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationRegistryUsageLimitQuery({
 *   variables: {
 *      organizationName: // value for 'organizationName'
 *      requestedIncrease: // value for 'requestedIncrease'
 *   },
 * });
 */
export function useOrganizationRegistryUsageLimitQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationRegistryUsageLimitQuery, OrganizationRegistryUsageLimitQueryVariables> & ({ variables: OrganizationRegistryUsageLimitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationRegistryUsageLimitQuery, OrganizationRegistryUsageLimitQueryVariables>(OrganizationRegistryUsageLimitDocument, options);
      }
export function useOrganizationRegistryUsageLimitLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationRegistryUsageLimitQuery, OrganizationRegistryUsageLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationRegistryUsageLimitQuery, OrganizationRegistryUsageLimitQueryVariables>(OrganizationRegistryUsageLimitDocument, options);
        }
// @ts-ignore
export function useOrganizationRegistryUsageLimitSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRegistryUsageLimitQuery, OrganizationRegistryUsageLimitQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationRegistryUsageLimitQuery, OrganizationRegistryUsageLimitQueryVariables>;
export function useOrganizationRegistryUsageLimitSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRegistryUsageLimitQuery, OrganizationRegistryUsageLimitQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationRegistryUsageLimitQuery | undefined, OrganizationRegistryUsageLimitQueryVariables>;
export function useOrganizationRegistryUsageLimitSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRegistryUsageLimitQuery, OrganizationRegistryUsageLimitQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationRegistryUsageLimitQuery, OrganizationRegistryUsageLimitQueryVariables>(OrganizationRegistryUsageLimitDocument, options);
        }
export type OrganizationRegistryUsageLimitQueryHookResult = ReturnType<typeof useOrganizationRegistryUsageLimitQuery>;
export type OrganizationRegistryUsageLimitLazyQueryHookResult = ReturnType<typeof useOrganizationRegistryUsageLimitLazyQuery>;
export type OrganizationRegistryUsageLimitSuspenseQueryHookResult = ReturnType<typeof useOrganizationRegistryUsageLimitSuspenseQuery>;
export type OrganizationRegistryUsageLimitQueryResult = ApolloReactCommon.QueryResult<OrganizationRegistryUsageLimitQuery, OrganizationRegistryUsageLimitQueryVariables>;
export const RegistryCollectionUsageLimitDocument = gql`
    query RegistryCollectionUsageLimit($entityName: String!, $projectName: String!, $requestedIncrease: Int64!) {
  project(entityName: $entityName, name: $projectName) {
    id
    registryCollectionUsageLimit(requestedIncrease: $requestedIncrease) {
      ...ArtifactUsageLimitStatusFields
    }
  }
}
    ${ArtifactUsageLimitStatusFieldsFragmentDoc}`;

/**
 * __useRegistryCollectionUsageLimitQuery__
 *
 * To run a query within a React component, call `useRegistryCollectionUsageLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistryCollectionUsageLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistryCollectionUsageLimitQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      requestedIncrease: // value for 'requestedIncrease'
 *   },
 * });
 */
export function useRegistryCollectionUsageLimitQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegistryCollectionUsageLimitQuery, RegistryCollectionUsageLimitQueryVariables> & ({ variables: RegistryCollectionUsageLimitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegistryCollectionUsageLimitQuery, RegistryCollectionUsageLimitQueryVariables>(RegistryCollectionUsageLimitDocument, options);
      }
export function useRegistryCollectionUsageLimitLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegistryCollectionUsageLimitQuery, RegistryCollectionUsageLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegistryCollectionUsageLimitQuery, RegistryCollectionUsageLimitQueryVariables>(RegistryCollectionUsageLimitDocument, options);
        }
// @ts-ignore
export function useRegistryCollectionUsageLimitSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionUsageLimitQuery, RegistryCollectionUsageLimitQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryCollectionUsageLimitQuery, RegistryCollectionUsageLimitQueryVariables>;
export function useRegistryCollectionUsageLimitSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionUsageLimitQuery, RegistryCollectionUsageLimitQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegistryCollectionUsageLimitQuery | undefined, RegistryCollectionUsageLimitQueryVariables>;
export function useRegistryCollectionUsageLimitSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegistryCollectionUsageLimitQuery, RegistryCollectionUsageLimitQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegistryCollectionUsageLimitQuery, RegistryCollectionUsageLimitQueryVariables>(RegistryCollectionUsageLimitDocument, options);
        }
export type RegistryCollectionUsageLimitQueryHookResult = ReturnType<typeof useRegistryCollectionUsageLimitQuery>;
export type RegistryCollectionUsageLimitLazyQueryHookResult = ReturnType<typeof useRegistryCollectionUsageLimitLazyQuery>;
export type RegistryCollectionUsageLimitSuspenseQueryHookResult = ReturnType<typeof useRegistryCollectionUsageLimitSuspenseQuery>;
export type RegistryCollectionUsageLimitQueryResult = ApolloReactCommon.QueryResult<RegistryCollectionUsageLimitQuery, RegistryCollectionUsageLimitQueryVariables>;
export const LinkedArtifactVersionUsageLimitDocument = gql`
    query LinkedArtifactVersionUsageLimit($collectionId: ID!, $requestedIncrease: Int64!) {
  artifactCollection(id: $collectionId) {
    id
    ... on ArtifactPortfolio {
      linkedArtifactVersionUsageLimit(requestedIncrease: $requestedIncrease) {
        ...ArtifactUsageLimitStatusFields
      }
    }
  }
}
    ${ArtifactUsageLimitStatusFieldsFragmentDoc}`;

/**
 * __useLinkedArtifactVersionUsageLimitQuery__
 *
 * To run a query within a React component, call `useLinkedArtifactVersionUsageLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkedArtifactVersionUsageLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkedArtifactVersionUsageLimitQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      requestedIncrease: // value for 'requestedIncrease'
 *   },
 * });
 */
export function useLinkedArtifactVersionUsageLimitQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LinkedArtifactVersionUsageLimitQuery, LinkedArtifactVersionUsageLimitQueryVariables> & ({ variables: LinkedArtifactVersionUsageLimitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LinkedArtifactVersionUsageLimitQuery, LinkedArtifactVersionUsageLimitQueryVariables>(LinkedArtifactVersionUsageLimitDocument, options);
      }
export function useLinkedArtifactVersionUsageLimitLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LinkedArtifactVersionUsageLimitQuery, LinkedArtifactVersionUsageLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LinkedArtifactVersionUsageLimitQuery, LinkedArtifactVersionUsageLimitQueryVariables>(LinkedArtifactVersionUsageLimitDocument, options);
        }
// @ts-ignore
export function useLinkedArtifactVersionUsageLimitSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LinkedArtifactVersionUsageLimitQuery, LinkedArtifactVersionUsageLimitQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LinkedArtifactVersionUsageLimitQuery, LinkedArtifactVersionUsageLimitQueryVariables>;
export function useLinkedArtifactVersionUsageLimitSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LinkedArtifactVersionUsageLimitQuery, LinkedArtifactVersionUsageLimitQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LinkedArtifactVersionUsageLimitQuery | undefined, LinkedArtifactVersionUsageLimitQueryVariables>;
export function useLinkedArtifactVersionUsageLimitSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LinkedArtifactVersionUsageLimitQuery, LinkedArtifactVersionUsageLimitQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LinkedArtifactVersionUsageLimitQuery, LinkedArtifactVersionUsageLimitQueryVariables>(LinkedArtifactVersionUsageLimitDocument, options);
        }
export type LinkedArtifactVersionUsageLimitQueryHookResult = ReturnType<typeof useLinkedArtifactVersionUsageLimitQuery>;
export type LinkedArtifactVersionUsageLimitLazyQueryHookResult = ReturnType<typeof useLinkedArtifactVersionUsageLimitLazyQuery>;
export type LinkedArtifactVersionUsageLimitSuspenseQueryHookResult = ReturnType<typeof useLinkedArtifactVersionUsageLimitSuspenseQuery>;
export type LinkedArtifactVersionUsageLimitQueryResult = ApolloReactCommon.QueryResult<LinkedArtifactVersionUsageLimitQuery, LinkedArtifactVersionUsageLimitQueryVariables>;
export const ArtifactVersionUsageLimitDocument = gql`
    query ArtifactVersionUsageLimit($collectionId: ID!, $requestedIncrease: Int64!) {
  artifactSequence(id: $collectionId) {
    id
    artifactVersionUsageLimit(requestedIncrease: $requestedIncrease) {
      ...ArtifactUsageLimitStatusFields
    }
  }
}
    ${ArtifactUsageLimitStatusFieldsFragmentDoc}`;

/**
 * __useArtifactVersionUsageLimitQuery__
 *
 * To run a query within a React component, call `useArtifactVersionUsageLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactVersionUsageLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactVersionUsageLimitQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      requestedIncrease: // value for 'requestedIncrease'
 *   },
 * });
 */
export function useArtifactVersionUsageLimitQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactVersionUsageLimitQuery, ArtifactVersionUsageLimitQueryVariables> & ({ variables: ArtifactVersionUsageLimitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactVersionUsageLimitQuery, ArtifactVersionUsageLimitQueryVariables>(ArtifactVersionUsageLimitDocument, options);
      }
export function useArtifactVersionUsageLimitLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactVersionUsageLimitQuery, ArtifactVersionUsageLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactVersionUsageLimitQuery, ArtifactVersionUsageLimitQueryVariables>(ArtifactVersionUsageLimitDocument, options);
        }
// @ts-ignore
export function useArtifactVersionUsageLimitSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionUsageLimitQuery, ArtifactVersionUsageLimitQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionUsageLimitQuery, ArtifactVersionUsageLimitQueryVariables>;
export function useArtifactVersionUsageLimitSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionUsageLimitQuery, ArtifactVersionUsageLimitQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionUsageLimitQuery | undefined, ArtifactVersionUsageLimitQueryVariables>;
export function useArtifactVersionUsageLimitSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionUsageLimitQuery, ArtifactVersionUsageLimitQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactVersionUsageLimitQuery, ArtifactVersionUsageLimitQueryVariables>(ArtifactVersionUsageLimitDocument, options);
        }
export type ArtifactVersionUsageLimitQueryHookResult = ReturnType<typeof useArtifactVersionUsageLimitQuery>;
export type ArtifactVersionUsageLimitLazyQueryHookResult = ReturnType<typeof useArtifactVersionUsageLimitLazyQuery>;
export type ArtifactVersionUsageLimitSuspenseQueryHookResult = ReturnType<typeof useArtifactVersionUsageLimitSuspenseQuery>;
export type ArtifactVersionUsageLimitQueryResult = ApolloReactCommon.QueryResult<ArtifactVersionUsageLimitQuery, ArtifactVersionUsageLimitQueryVariables>;
export const LinkArtifactDocument = gql`
    mutation LinkArtifact($artifactID: ID, $artifactPortfolioID: ID, $aliases: [ArtifactAliasInput!]) {
  linkArtifact(
    input: {artifactID: $artifactID, artifactPortfolioID: $artifactPortfolioID, aliases: $aliases}
  ) {
    artifactCollectionID
    artifactID
    createdAt
    versionIndex
    clientMutationId
  }
}
    `;
export type LinkArtifactMutationFn = ApolloReactCommon.MutationFunction<LinkArtifactMutation, LinkArtifactMutationVariables>;

/**
 * __useLinkArtifactMutation__
 *
 * To run a mutation, you first call `useLinkArtifactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkArtifactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkArtifactMutation, { data, loading, error }] = useLinkArtifactMutation({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *      artifactPortfolioID: // value for 'artifactPortfolioID'
 *      aliases: // value for 'aliases'
 *   },
 * });
 */
export function useLinkArtifactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LinkArtifactMutation, LinkArtifactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LinkArtifactMutation, LinkArtifactMutationVariables>(LinkArtifactDocument, options);
      }
export type LinkArtifactMutationHookResult = ReturnType<typeof useLinkArtifactMutation>;
export type LinkArtifactMutationResult = ApolloReactCommon.MutationResult<LinkArtifactMutation>;
export type LinkArtifactMutationOptions = ApolloReactCommon.BaseMutationOptions<LinkArtifactMutation, LinkArtifactMutationVariables>;
export const CreateAndLinkWeaveAssetDocument = gql`
    mutation CreateAndLinkWeaveAsset($ref: String!, $entityName: String, $projectName: String, $artifactPortfolioID: ID, $artifactPortfolioName: String, $aliases: [ArtifactAliasInput!]) {
  createAndLinkWeaveAsset(
    input: {ref: $ref, entityName: $entityName, projectName: $projectName, artifactPortfolioID: $artifactPortfolioID, artifactPortfolioName: $artifactPortfolioName, aliases: $aliases}
  ) {
    artifactCollectionID
    artifactID
    createdAt
    versionIndex
    clientMutationId
  }
}
    `;
export type CreateAndLinkWeaveAssetMutationFn = ApolloReactCommon.MutationFunction<CreateAndLinkWeaveAssetMutation, CreateAndLinkWeaveAssetMutationVariables>;

/**
 * __useCreateAndLinkWeaveAssetMutation__
 *
 * To run a mutation, you first call `useCreateAndLinkWeaveAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndLinkWeaveAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndLinkWeaveAssetMutation, { data, loading, error }] = useCreateAndLinkWeaveAssetMutation({
 *   variables: {
 *      ref: // value for 'ref'
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      artifactPortfolioID: // value for 'artifactPortfolioID'
 *      artifactPortfolioName: // value for 'artifactPortfolioName'
 *      aliases: // value for 'aliases'
 *   },
 * });
 */
export function useCreateAndLinkWeaveAssetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAndLinkWeaveAssetMutation, CreateAndLinkWeaveAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAndLinkWeaveAssetMutation, CreateAndLinkWeaveAssetMutationVariables>(CreateAndLinkWeaveAssetDocument, options);
      }
export type CreateAndLinkWeaveAssetMutationHookResult = ReturnType<typeof useCreateAndLinkWeaveAssetMutation>;
export type CreateAndLinkWeaveAssetMutationResult = ApolloReactCommon.MutationResult<CreateAndLinkWeaveAssetMutation>;
export type CreateAndLinkWeaveAssetMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAndLinkWeaveAssetMutation, CreateAndLinkWeaveAssetMutationVariables>;
export const DeployVersionFilesDocument = gql`
    query DeployVersionFiles($collectionId: ID!, $aliasName: String!, $first: Int!) {
  artifactCollection(id: $collectionId) {
    id
    artifactMembership(aliasName: $aliasName) {
      id
      files(first: $first) {
        pageInfo {
          hasNextPage
        }
        edges {
          node {
            id
            name
            sizeBytes
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDeployVersionFilesQuery__
 *
 * To run a query within a React component, call `useDeployVersionFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeployVersionFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeployVersionFilesQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      aliasName: // value for 'aliasName'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useDeployVersionFilesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DeployVersionFilesQuery, DeployVersionFilesQueryVariables> & ({ variables: DeployVersionFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DeployVersionFilesQuery, DeployVersionFilesQueryVariables>(DeployVersionFilesDocument, options);
      }
export function useDeployVersionFilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DeployVersionFilesQuery, DeployVersionFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DeployVersionFilesQuery, DeployVersionFilesQueryVariables>(DeployVersionFilesDocument, options);
        }
// @ts-ignore
export function useDeployVersionFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DeployVersionFilesQuery, DeployVersionFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DeployVersionFilesQuery, DeployVersionFilesQueryVariables>;
export function useDeployVersionFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DeployVersionFilesQuery, DeployVersionFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DeployVersionFilesQuery | undefined, DeployVersionFilesQueryVariables>;
export function useDeployVersionFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DeployVersionFilesQuery, DeployVersionFilesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DeployVersionFilesQuery, DeployVersionFilesQueryVariables>(DeployVersionFilesDocument, options);
        }
export type DeployVersionFilesQueryHookResult = ReturnType<typeof useDeployVersionFilesQuery>;
export type DeployVersionFilesLazyQueryHookResult = ReturnType<typeof useDeployVersionFilesLazyQuery>;
export type DeployVersionFilesSuspenseQueryHookResult = ReturnType<typeof useDeployVersionFilesSuspenseQuery>;
export type DeployVersionFilesQueryResult = ApolloReactCommon.QueryResult<DeployVersionFilesQuery, DeployVersionFilesQueryVariables>;
export const ImportPanelMenuProjectsDocument = gql`
    query ImportPanelMenuProjects($userName: String!, $selectedEntityName: String, $projectSearchQuery: String) {
  entity(name: $selectedEntityName) {
    id
    ...ImportPanelMenuEntityFragment
  }
  user(userName: $userName) {
    id
    teams {
      edges {
        node {
          id
          ...ImportPanelMenuEntityFragment
        }
      }
    }
  }
}
    ${ImportPanelMenuEntityFragmentFragmentDoc}`;

/**
 * __useImportPanelMenuProjectsQuery__
 *
 * To run a query within a React component, call `useImportPanelMenuProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportPanelMenuProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportPanelMenuProjectsQuery({
 *   variables: {
 *      userName: // value for 'userName'
 *      selectedEntityName: // value for 'selectedEntityName'
 *      projectSearchQuery: // value for 'projectSearchQuery'
 *   },
 * });
 */
export function useImportPanelMenuProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables> & ({ variables: ImportPanelMenuProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables>(ImportPanelMenuProjectsDocument, options);
      }
export function useImportPanelMenuProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables>(ImportPanelMenuProjectsDocument, options);
        }
// @ts-ignore
export function useImportPanelMenuProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables>;
export function useImportPanelMenuProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ImportPanelMenuProjectsQuery | undefined, ImportPanelMenuProjectsQueryVariables>;
export function useImportPanelMenuProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables>(ImportPanelMenuProjectsDocument, options);
        }
export type ImportPanelMenuProjectsQueryHookResult = ReturnType<typeof useImportPanelMenuProjectsQuery>;
export type ImportPanelMenuProjectsLazyQueryHookResult = ReturnType<typeof useImportPanelMenuProjectsLazyQuery>;
export type ImportPanelMenuProjectsSuspenseQueryHookResult = ReturnType<typeof useImportPanelMenuProjectsSuspenseQuery>;
export type ImportPanelMenuProjectsQueryResult = ApolloReactCommon.QueryResult<ImportPanelMenuProjectsQuery, ImportPanelMenuProjectsQueryVariables>;
export const ImportPanelMenuViewsDocument = gql`
    query ImportPanelMenuViews($entityName: String, $projectName: String, $userName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    allViews(viewType: "project-view", userName: $userName) {
      edges {
        node {
          id
          ...ImportPanelProjectViewsFragment
        }
      }
    }
  }
}
    ${ImportPanelProjectViewsFragmentFragmentDoc}`;

/**
 * __useImportPanelMenuViewsQuery__
 *
 * To run a query within a React component, call `useImportPanelMenuViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportPanelMenuViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportPanelMenuViewsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useImportPanelMenuViewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>(ImportPanelMenuViewsDocument, options);
      }
export function useImportPanelMenuViewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>(ImportPanelMenuViewsDocument, options);
        }
// @ts-ignore
export function useImportPanelMenuViewsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>;
export function useImportPanelMenuViewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ImportPanelMenuViewsQuery | undefined, ImportPanelMenuViewsQueryVariables>;
export function useImportPanelMenuViewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>(ImportPanelMenuViewsDocument, options);
        }
export type ImportPanelMenuViewsQueryHookResult = ReturnType<typeof useImportPanelMenuViewsQuery>;
export type ImportPanelMenuViewsLazyQueryHookResult = ReturnType<typeof useImportPanelMenuViewsLazyQuery>;
export type ImportPanelMenuViewsSuspenseQueryHookResult = ReturnType<typeof useImportPanelMenuViewsSuspenseQuery>;
export type ImportPanelMenuViewsQueryResult = ApolloReactCommon.QueryResult<ImportPanelMenuViewsQuery, ImportPanelMenuViewsQueryVariables>;
export const ImportPanelMenuViewSpecDocument = gql`
    query ImportPanelMenuViewSpec($viewId: ID!) {
  view(id: $viewId) {
    id
    spec
  }
}
    `;

/**
 * __useImportPanelMenuViewSpecQuery__
 *
 * To run a query within a React component, call `useImportPanelMenuViewSpecQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportPanelMenuViewSpecQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportPanelMenuViewSpecQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useImportPanelMenuViewSpecQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables> & ({ variables: ImportPanelMenuViewSpecQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables>(ImportPanelMenuViewSpecDocument, options);
      }
export function useImportPanelMenuViewSpecLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables>(ImportPanelMenuViewSpecDocument, options);
        }
// @ts-ignore
export function useImportPanelMenuViewSpecSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables>;
export function useImportPanelMenuViewSpecSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ImportPanelMenuViewSpecQuery | undefined, ImportPanelMenuViewSpecQueryVariables>;
export function useImportPanelMenuViewSpecSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables>(ImportPanelMenuViewSpecDocument, options);
        }
export type ImportPanelMenuViewSpecQueryHookResult = ReturnType<typeof useImportPanelMenuViewSpecQuery>;
export type ImportPanelMenuViewSpecLazyQueryHookResult = ReturnType<typeof useImportPanelMenuViewSpecLazyQuery>;
export type ImportPanelMenuViewSpecSuspenseQueryHookResult = ReturnType<typeof useImportPanelMenuViewSpecSuspenseQuery>;
export type ImportPanelMenuViewSpecQueryResult = ApolloReactCommon.QueryResult<ImportPanelMenuViewSpecQuery, ImportPanelMenuViewSpecQueryVariables>;
export const ReproduceRunDrawerDocument = gql`
    query ReproduceRunDrawer($projectName: String!, $entityName: String!, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      ...ReproduceRun_Run
    }
  }
}
    ${ReproduceRun_RunFragmentDoc}`;

/**
 * __useReproduceRunDrawerQuery__
 *
 * To run a query within a React component, call `useReproduceRunDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useReproduceRunDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReproduceRunDrawerQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useReproduceRunDrawerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReproduceRunDrawerQuery, ReproduceRunDrawerQueryVariables> & ({ variables: ReproduceRunDrawerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReproduceRunDrawerQuery, ReproduceRunDrawerQueryVariables>(ReproduceRunDrawerDocument, options);
      }
export function useReproduceRunDrawerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReproduceRunDrawerQuery, ReproduceRunDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReproduceRunDrawerQuery, ReproduceRunDrawerQueryVariables>(ReproduceRunDrawerDocument, options);
        }
// @ts-ignore
export function useReproduceRunDrawerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReproduceRunDrawerQuery, ReproduceRunDrawerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReproduceRunDrawerQuery, ReproduceRunDrawerQueryVariables>;
export function useReproduceRunDrawerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReproduceRunDrawerQuery, ReproduceRunDrawerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReproduceRunDrawerQuery | undefined, ReproduceRunDrawerQueryVariables>;
export function useReproduceRunDrawerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReproduceRunDrawerQuery, ReproduceRunDrawerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReproduceRunDrawerQuery, ReproduceRunDrawerQueryVariables>(ReproduceRunDrawerDocument, options);
        }
export type ReproduceRunDrawerQueryHookResult = ReturnType<typeof useReproduceRunDrawerQuery>;
export type ReproduceRunDrawerLazyQueryHookResult = ReturnType<typeof useReproduceRunDrawerLazyQuery>;
export type ReproduceRunDrawerSuspenseQueryHookResult = ReturnType<typeof useReproduceRunDrawerSuspenseQuery>;
export type ReproduceRunDrawerQueryResult = ApolloReactCommon.QueryResult<ReproduceRunDrawerQuery, ReproduceRunDrawerQueryVariables>;
export const RunDetailsDocument = gql`
    query RunDetails($projectName: String!, $entityName: String, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    entityName
    name
    entity {
      id
      claimingEntity {
        id
        name
      }
    }
    access
    readOnly
    run(name: $runName) {
      id
      historyMaterializationTask {
        id
        type
        state
        progress
        updatedAt
      }
      inputArtifacts {
        totalCount
      }
      outputArtifacts {
        totalCount
      }
      servicesAvailable {
        tensorboard
      }
      sweep {
        id
        name
      }
      group
      displayName
      name
      summaryMetrics
      config
      createdAt
    }
  }
}
    `;

/**
 * __useRunDetailsQuery__
 *
 * To run a query within a React component, call `useRunDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunDetailsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunDetailsQuery, RunDetailsQueryVariables> & ({ variables: RunDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunDetailsQuery, RunDetailsQueryVariables>(RunDetailsDocument, options);
      }
export function useRunDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunDetailsQuery, RunDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunDetailsQuery, RunDetailsQueryVariables>(RunDetailsDocument, options);
        }
// @ts-ignore
export function useRunDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunDetailsQuery, RunDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunDetailsQuery, RunDetailsQueryVariables>;
export function useRunDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunDetailsQuery, RunDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunDetailsQuery | undefined, RunDetailsQueryVariables>;
export function useRunDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunDetailsQuery, RunDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunDetailsQuery, RunDetailsQueryVariables>(RunDetailsDocument, options);
        }
export type RunDetailsQueryHookResult = ReturnType<typeof useRunDetailsQuery>;
export type RunDetailsLazyQueryHookResult = ReturnType<typeof useRunDetailsLazyQuery>;
export type RunDetailsSuspenseQueryHookResult = ReturnType<typeof useRunDetailsSuspenseQuery>;
export type RunDetailsQueryResult = ApolloReactCommon.QueryResult<RunDetailsQuery, RunDetailsQueryVariables>;
export const RunsDetailsUserDocument = gql`
    query RunsDetailsUser($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    user {
      id
      username
      apiKey
      accountType
    }
  }
}
    `;

/**
 * __useRunsDetailsUserQuery__
 *
 * To run a query within a React component, call `useRunsDetailsUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsDetailsUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsDetailsUserQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useRunsDetailsUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsDetailsUserQuery, RunsDetailsUserQueryVariables> & ({ variables: RunsDetailsUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsDetailsUserQuery, RunsDetailsUserQueryVariables>(RunsDetailsUserDocument, options);
      }
export function useRunsDetailsUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsDetailsUserQuery, RunsDetailsUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsDetailsUserQuery, RunsDetailsUserQueryVariables>(RunsDetailsUserDocument, options);
        }
// @ts-ignore
export function useRunsDetailsUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsDetailsUserQuery, RunsDetailsUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsDetailsUserQuery, RunsDetailsUserQueryVariables>;
export function useRunsDetailsUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsDetailsUserQuery, RunsDetailsUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsDetailsUserQuery | undefined, RunsDetailsUserQueryVariables>;
export function useRunsDetailsUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsDetailsUserQuery, RunsDetailsUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsDetailsUserQuery, RunsDetailsUserQueryVariables>(RunsDetailsUserDocument, options);
        }
export type RunsDetailsUserQueryHookResult = ReturnType<typeof useRunsDetailsUserQuery>;
export type RunsDetailsUserLazyQueryHookResult = ReturnType<typeof useRunsDetailsUserLazyQuery>;
export type RunsDetailsUserSuspenseQueryHookResult = ReturnType<typeof useRunsDetailsUserSuspenseQuery>;
export type RunsDetailsUserQueryResult = ApolloReactCommon.QueryResult<RunsDetailsUserQuery, RunsDetailsUserQueryVariables>;
export const RunPageLogsDocument = gql`
    query RunPageLogs($projectName: String!, $entityName: String, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      group
      sweep {
        id
      }
      state
      historyKeys(format: PLAINTEXT)
      createdAt
      logLineCount
      outputLogFile: files(first: 1, names: ["output.log"]) {
        edges {
          node {
            id
            sizeBytes
            url
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRunPageLogsQuery__
 *
 * To run a query within a React component, call `useRunPageLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunPageLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunPageLogsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunPageLogsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunPageLogsQuery, RunPageLogsQueryVariables> & ({ variables: RunPageLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunPageLogsQuery, RunPageLogsQueryVariables>(RunPageLogsDocument, options);
      }
export function useRunPageLogsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunPageLogsQuery, RunPageLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunPageLogsQuery, RunPageLogsQueryVariables>(RunPageLogsDocument, options);
        }
// @ts-ignore
export function useRunPageLogsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunPageLogsQuery, RunPageLogsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunPageLogsQuery, RunPageLogsQueryVariables>;
export function useRunPageLogsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunPageLogsQuery, RunPageLogsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunPageLogsQuery | undefined, RunPageLogsQueryVariables>;
export function useRunPageLogsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunPageLogsQuery, RunPageLogsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunPageLogsQuery, RunPageLogsQueryVariables>(RunPageLogsDocument, options);
        }
export type RunPageLogsQueryHookResult = ReturnType<typeof useRunPageLogsQuery>;
export type RunPageLogsLazyQueryHookResult = ReturnType<typeof useRunPageLogsLazyQuery>;
export type RunPageLogsSuspenseQueryHookResult = ReturnType<typeof useRunPageLogsSuspenseQuery>;
export type RunPageLogsQueryResult = ApolloReactCommon.QueryResult<RunPageLogsQuery, RunPageLogsQueryVariables>;
export const RunFilesDocument = gql`
    query RunFiles($projectName: String!, $entityName: String, $runName: String!, $maxNumFiles: Int!) {
  project(name: $projectName, entityName: $entityName) {
    id
    name
    run(name: $runName) {
      id
      name
      fileCount
      codeArtifact {
        id
        fileCount
      }
      files(first: $maxNumFiles) {
        edges {
          node {
            ...RunFiles_File
          }
        }
      }
    }
  }
}
    ${RunFiles_FileFragmentDoc}`;

/**
 * __useRunFilesQuery__
 *
 * To run a query within a React component, call `useRunFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunFilesQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      maxNumFiles: // value for 'maxNumFiles'
 *   },
 * });
 */
export function useRunFilesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunFilesQuery, RunFilesQueryVariables> & ({ variables: RunFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunFilesQuery, RunFilesQueryVariables>(RunFilesDocument, options);
      }
export function useRunFilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunFilesQuery, RunFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunFilesQuery, RunFilesQueryVariables>(RunFilesDocument, options);
        }
// @ts-ignore
export function useRunFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunFilesQuery, RunFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunFilesQuery, RunFilesQueryVariables>;
export function useRunFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunFilesQuery, RunFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunFilesQuery | undefined, RunFilesQueryVariables>;
export function useRunFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunFilesQuery, RunFilesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunFilesQuery, RunFilesQueryVariables>(RunFilesDocument, options);
        }
export type RunFilesQueryHookResult = ReturnType<typeof useRunFilesQuery>;
export type RunFilesLazyQueryHookResult = ReturnType<typeof useRunFilesLazyQuery>;
export type RunFilesSuspenseQueryHookResult = ReturnType<typeof useRunFilesSuspenseQuery>;
export type RunFilesQueryResult = ApolloReactCommon.QueryResult<RunFilesQuery, RunFilesQueryVariables>;
export const RunFilesAndFoldersDocument = gql`
    query RunFilesAndFolders($projectName: String!, $entityName: String, $runName: String!, $maxNumFiles: Int!, $folderPath: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    name
    run(name: $runName) {
      id
      name
      projectId
      files(first: $maxNumFiles, folderPath: $folderPath) {
        edges {
          node {
            ...RunFiles_File
          }
        }
      }
      folders(folderPath: $folderPath) {
        folderList {
          name
          size
          numberOfFiles
        }
      }
    }
  }
}
    ${RunFiles_FileFragmentDoc}`;

/**
 * __useRunFilesAndFoldersQuery__
 *
 * To run a query within a React component, call `useRunFilesAndFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunFilesAndFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunFilesAndFoldersQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      maxNumFiles: // value for 'maxNumFiles'
 *      folderPath: // value for 'folderPath'
 *   },
 * });
 */
export function useRunFilesAndFoldersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables> & ({ variables: RunFilesAndFoldersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables>(RunFilesAndFoldersDocument, options);
      }
export function useRunFilesAndFoldersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables>(RunFilesAndFoldersDocument, options);
        }
// @ts-ignore
export function useRunFilesAndFoldersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables>;
export function useRunFilesAndFoldersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunFilesAndFoldersQuery | undefined, RunFilesAndFoldersQueryVariables>;
export function useRunFilesAndFoldersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables>(RunFilesAndFoldersDocument, options);
        }
export type RunFilesAndFoldersQueryHookResult = ReturnType<typeof useRunFilesAndFoldersQuery>;
export type RunFilesAndFoldersLazyQueryHookResult = ReturnType<typeof useRunFilesAndFoldersLazyQuery>;
export type RunFilesAndFoldersSuspenseQueryHookResult = ReturnType<typeof useRunFilesAndFoldersSuspenseQuery>;
export type RunFilesAndFoldersQueryResult = ApolloReactCommon.QueryResult<RunFilesAndFoldersQuery, RunFilesAndFoldersQueryVariables>;
export const FileDownloadUrlDocument = gql`
    query FileDownloadUrl($projectName: String!, $entityName: String, $runName: String!, $fileName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      files(first: 1, names: [$fileName]) {
        edges {
          node {
            ...RunFiles_DirectUrl
          }
        }
      }
    }
  }
}
    ${RunFiles_DirectUrlFragmentDoc}`;

/**
 * __useFileDownloadUrlQuery__
 *
 * To run a query within a React component, call `useFileDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileDownloadUrlQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useFileDownloadUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FileDownloadUrlQuery, FileDownloadUrlQueryVariables> & ({ variables: FileDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FileDownloadUrlQuery, FileDownloadUrlQueryVariables>(FileDownloadUrlDocument, options);
      }
export function useFileDownloadUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FileDownloadUrlQuery, FileDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FileDownloadUrlQuery, FileDownloadUrlQueryVariables>(FileDownloadUrlDocument, options);
        }
// @ts-ignore
export function useFileDownloadUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FileDownloadUrlQuery, FileDownloadUrlQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FileDownloadUrlQuery, FileDownloadUrlQueryVariables>;
export function useFileDownloadUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FileDownloadUrlQuery, FileDownloadUrlQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FileDownloadUrlQuery | undefined, FileDownloadUrlQueryVariables>;
export function useFileDownloadUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FileDownloadUrlQuery, FileDownloadUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FileDownloadUrlQuery, FileDownloadUrlQueryVariables>(FileDownloadUrlDocument, options);
        }
export type FileDownloadUrlQueryHookResult = ReturnType<typeof useFileDownloadUrlQuery>;
export type FileDownloadUrlLazyQueryHookResult = ReturnType<typeof useFileDownloadUrlLazyQuery>;
export type FileDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useFileDownloadUrlSuspenseQuery>;
export type FileDownloadUrlQueryResult = ApolloReactCommon.QueryResult<FileDownloadUrlQuery, FileDownloadUrlQueryVariables>;
export const RunSelectorFieldAggregationsDocument = gql`
    query RunSelectorFieldAggregations($projectInternalId: ID!, $fieldPattern: String!) {
  project(internalId: $projectInternalId) {
    id
    fields(
      pattern: $fieldPattern
      types: ["number"]
      columns: ["summary_metrics", "aggregations_min", "aggregations_max"]
    ) {
      edges {
        node {
          path
        }
      }
    }
  }
}
    `;

/**
 * __useRunSelectorFieldAggregationsQuery__
 *
 * To run a query within a React component, call `useRunSelectorFieldAggregationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunSelectorFieldAggregationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunSelectorFieldAggregationsQuery({
 *   variables: {
 *      projectInternalId: // value for 'projectInternalId'
 *      fieldPattern: // value for 'fieldPattern'
 *   },
 * });
 */
export function useRunSelectorFieldAggregationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunSelectorFieldAggregationsQuery, RunSelectorFieldAggregationsQueryVariables> & ({ variables: RunSelectorFieldAggregationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunSelectorFieldAggregationsQuery, RunSelectorFieldAggregationsQueryVariables>(RunSelectorFieldAggregationsDocument, options);
      }
export function useRunSelectorFieldAggregationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunSelectorFieldAggregationsQuery, RunSelectorFieldAggregationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunSelectorFieldAggregationsQuery, RunSelectorFieldAggregationsQueryVariables>(RunSelectorFieldAggregationsDocument, options);
        }
// @ts-ignore
export function useRunSelectorFieldAggregationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorFieldAggregationsQuery, RunSelectorFieldAggregationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorFieldAggregationsQuery, RunSelectorFieldAggregationsQueryVariables>;
export function useRunSelectorFieldAggregationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorFieldAggregationsQuery, RunSelectorFieldAggregationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorFieldAggregationsQuery | undefined, RunSelectorFieldAggregationsQueryVariables>;
export function useRunSelectorFieldAggregationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorFieldAggregationsQuery, RunSelectorFieldAggregationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunSelectorFieldAggregationsQuery, RunSelectorFieldAggregationsQueryVariables>(RunSelectorFieldAggregationsDocument, options);
        }
export type RunSelectorFieldAggregationsQueryHookResult = ReturnType<typeof useRunSelectorFieldAggregationsQuery>;
export type RunSelectorFieldAggregationsLazyQueryHookResult = ReturnType<typeof useRunSelectorFieldAggregationsLazyQuery>;
export type RunSelectorFieldAggregationsSuspenseQueryHookResult = ReturnType<typeof useRunSelectorFieldAggregationsSuspenseQuery>;
export type RunSelectorFieldAggregationsQueryResult = ApolloReactCommon.QueryResult<RunSelectorFieldAggregationsQuery, RunSelectorFieldAggregationsQueryVariables>;
export const CrossProjectRunsProjectsDocument = gql`
    query CrossProjectRunsProjects($entityName: String!, $userName: String!, $pattern: String) {
  entity(name: $entityName) {
    id
    projects(first: 50, pattern: $pattern) {
      edges {
        node {
          id
          internalId
          name
          entityName
          createdAt
        }
      }
    }
  }
  viewer {
    id
    projects(first: 500) {
      edges {
        node {
          id
          internalId
          name
          entityName
          createdAt
        }
      }
    }
  }
  user(userName: $userName) {
    id
    teams {
      edges {
        node {
          id
          projects(first: 50, pattern: $pattern) {
            edges {
              node {
                id
                internalId
                name
                entityName
                createdAt
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCrossProjectRunsProjectsQuery__
 *
 * To run a query within a React component, call `useCrossProjectRunsProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrossProjectRunsProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrossProjectRunsProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      userName: // value for 'userName'
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useCrossProjectRunsProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CrossProjectRunsProjectsQuery, CrossProjectRunsProjectsQueryVariables> & ({ variables: CrossProjectRunsProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CrossProjectRunsProjectsQuery, CrossProjectRunsProjectsQueryVariables>(CrossProjectRunsProjectsDocument, options);
      }
export function useCrossProjectRunsProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CrossProjectRunsProjectsQuery, CrossProjectRunsProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CrossProjectRunsProjectsQuery, CrossProjectRunsProjectsQueryVariables>(CrossProjectRunsProjectsDocument, options);
        }
// @ts-ignore
export function useCrossProjectRunsProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CrossProjectRunsProjectsQuery, CrossProjectRunsProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CrossProjectRunsProjectsQuery, CrossProjectRunsProjectsQueryVariables>;
export function useCrossProjectRunsProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CrossProjectRunsProjectsQuery, CrossProjectRunsProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CrossProjectRunsProjectsQuery | undefined, CrossProjectRunsProjectsQueryVariables>;
export function useCrossProjectRunsProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CrossProjectRunsProjectsQuery, CrossProjectRunsProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CrossProjectRunsProjectsQuery, CrossProjectRunsProjectsQueryVariables>(CrossProjectRunsProjectsDocument, options);
        }
export type CrossProjectRunsProjectsQueryHookResult = ReturnType<typeof useCrossProjectRunsProjectsQuery>;
export type CrossProjectRunsProjectsLazyQueryHookResult = ReturnType<typeof useCrossProjectRunsProjectsLazyQuery>;
export type CrossProjectRunsProjectsSuspenseQueryHookResult = ReturnType<typeof useCrossProjectRunsProjectsSuspenseQuery>;
export type CrossProjectRunsProjectsQueryResult = ApolloReactCommon.QueryResult<CrossProjectRunsProjectsQuery, CrossProjectRunsProjectsQueryVariables>;
export const CrossProjectRunsRunsDocument = gql`
    query CrossProjectRunsRuns($internalId: ID!, $filters: JSONString) {
  project(internalId: $internalId) {
    id
    runs(first: 100, filters: $filters, order: "-createdAt") {
      totalCount
      edges {
        node {
          id
          name
          displayName
        }
      }
    }
  }
}
    `;

/**
 * __useCrossProjectRunsRunsQuery__
 *
 * To run a query within a React component, call `useCrossProjectRunsRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrossProjectRunsRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrossProjectRunsRunsQuery({
 *   variables: {
 *      internalId: // value for 'internalId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCrossProjectRunsRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CrossProjectRunsRunsQuery, CrossProjectRunsRunsQueryVariables> & ({ variables: CrossProjectRunsRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CrossProjectRunsRunsQuery, CrossProjectRunsRunsQueryVariables>(CrossProjectRunsRunsDocument, options);
      }
export function useCrossProjectRunsRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CrossProjectRunsRunsQuery, CrossProjectRunsRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CrossProjectRunsRunsQuery, CrossProjectRunsRunsQueryVariables>(CrossProjectRunsRunsDocument, options);
        }
// @ts-ignore
export function useCrossProjectRunsRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CrossProjectRunsRunsQuery, CrossProjectRunsRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CrossProjectRunsRunsQuery, CrossProjectRunsRunsQueryVariables>;
export function useCrossProjectRunsRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CrossProjectRunsRunsQuery, CrossProjectRunsRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CrossProjectRunsRunsQuery | undefined, CrossProjectRunsRunsQueryVariables>;
export function useCrossProjectRunsRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CrossProjectRunsRunsQuery, CrossProjectRunsRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CrossProjectRunsRunsQuery, CrossProjectRunsRunsQueryVariables>(CrossProjectRunsRunsDocument, options);
        }
export type CrossProjectRunsRunsQueryHookResult = ReturnType<typeof useCrossProjectRunsRunsQuery>;
export type CrossProjectRunsRunsLazyQueryHookResult = ReturnType<typeof useCrossProjectRunsRunsLazyQuery>;
export type CrossProjectRunsRunsSuspenseQueryHookResult = ReturnType<typeof useCrossProjectRunsRunsSuspenseQuery>;
export type CrossProjectRunsRunsQueryResult = ApolloReactCommon.QueryResult<CrossProjectRunsRunsQuery, CrossProjectRunsRunsQueryVariables>;
export const AllRunGroupsDocument = gql`
    query AllRunGroups($projectName: String!, $entityName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(groupKeys: ["group"]) {
      edges {
        node {
          id
          name
          group
        }
      }
    }
  }
}
    `;

/**
 * __useAllRunGroupsQuery__
 *
 * To run a query within a React component, call `useAllRunGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRunGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRunGroupsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useAllRunGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllRunGroupsQuery, AllRunGroupsQueryVariables> & ({ variables: AllRunGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllRunGroupsQuery, AllRunGroupsQueryVariables>(AllRunGroupsDocument, options);
      }
export function useAllRunGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllRunGroupsQuery, AllRunGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllRunGroupsQuery, AllRunGroupsQueryVariables>(AllRunGroupsDocument, options);
        }
// @ts-ignore
export function useAllRunGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllRunGroupsQuery, AllRunGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllRunGroupsQuery, AllRunGroupsQueryVariables>;
export function useAllRunGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllRunGroupsQuery, AllRunGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllRunGroupsQuery | undefined, AllRunGroupsQueryVariables>;
export function useAllRunGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllRunGroupsQuery, AllRunGroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllRunGroupsQuery, AllRunGroupsQueryVariables>(AllRunGroupsDocument, options);
        }
export type AllRunGroupsQueryHookResult = ReturnType<typeof useAllRunGroupsQuery>;
export type AllRunGroupsLazyQueryHookResult = ReturnType<typeof useAllRunGroupsLazyQuery>;
export type AllRunGroupsSuspenseQueryHookResult = ReturnType<typeof useAllRunGroupsSuspenseQuery>;
export type AllRunGroupsQueryResult = ApolloReactCommon.QueryResult<AllRunGroupsQuery, AllRunGroupsQueryVariables>;
export const GetRunsForMoveGroupsDocument = gql`
    query GetRunsForMoveGroups($projectName: String!, $entityName: String!, $filters: JSONString!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(filters: $filters) {
      edges {
        node {
          id
          user {
            id
            username
          }
          name
          displayName
          group
        }
      }
    }
  }
}
    `;

/**
 * __useGetRunsForMoveGroupsQuery__
 *
 * To run a query within a React component, call `useGetRunsForMoveGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRunsForMoveGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRunsForMoveGroupsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetRunsForMoveGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables> & ({ variables: GetRunsForMoveGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables>(GetRunsForMoveGroupsDocument, options);
      }
export function useGetRunsForMoveGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables>(GetRunsForMoveGroupsDocument, options);
        }
// @ts-ignore
export function useGetRunsForMoveGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables>;
export function useGetRunsForMoveGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetRunsForMoveGroupsQuery | undefined, GetRunsForMoveGroupsQueryVariables>;
export function useGetRunsForMoveGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables>(GetRunsForMoveGroupsDocument, options);
        }
export type GetRunsForMoveGroupsQueryHookResult = ReturnType<typeof useGetRunsForMoveGroupsQuery>;
export type GetRunsForMoveGroupsLazyQueryHookResult = ReturnType<typeof useGetRunsForMoveGroupsLazyQuery>;
export type GetRunsForMoveGroupsSuspenseQueryHookResult = ReturnType<typeof useGetRunsForMoveGroupsSuspenseQuery>;
export type GetRunsForMoveGroupsQueryResult = ApolloReactCommon.QueryResult<GetRunsForMoveGroupsQuery, GetRunsForMoveGroupsQueryVariables>;
export const MoveRunToGroupDocument = gql`
    mutation MoveRunToGroup($entityName: String!, $groupName: String!, $projectName: String!, $runId: String!) {
  upsertBucket(
    input: {entityName: $entityName, groupName: $groupName, id: $runId, modelName: $projectName}
  ) {
    bucket {
      id
      group
    }
  }
}
    `;
export type MoveRunToGroupMutationFn = ApolloReactCommon.MutationFunction<MoveRunToGroupMutation, MoveRunToGroupMutationVariables>;

/**
 * __useMoveRunToGroupMutation__
 *
 * To run a mutation, you first call `useMoveRunToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveRunToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveRunToGroupMutation, { data, loading, error }] = useMoveRunToGroupMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      groupName: // value for 'groupName'
 *      projectName: // value for 'projectName'
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useMoveRunToGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveRunToGroupMutation, MoveRunToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveRunToGroupMutation, MoveRunToGroupMutationVariables>(MoveRunToGroupDocument, options);
      }
export type MoveRunToGroupMutationHookResult = ReturnType<typeof useMoveRunToGroupMutation>;
export type MoveRunToGroupMutationResult = ApolloReactCommon.MutationResult<MoveRunToGroupMutation>;
export type MoveRunToGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveRunToGroupMutation, MoveRunToGroupMutationVariables>;
export const MoveRunDrawerProjectDocument = gql`
    query MoveRunDrawerProject($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    totalUsers
  }
}
    `;

/**
 * __useMoveRunDrawerProjectQuery__
 *
 * To run a query within a React component, call `useMoveRunDrawerProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMoveRunDrawerProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMoveRunDrawerProjectQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useMoveRunDrawerProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MoveRunDrawerProjectQuery, MoveRunDrawerProjectQueryVariables> & ({ variables: MoveRunDrawerProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MoveRunDrawerProjectQuery, MoveRunDrawerProjectQueryVariables>(MoveRunDrawerProjectDocument, options);
      }
export function useMoveRunDrawerProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MoveRunDrawerProjectQuery, MoveRunDrawerProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MoveRunDrawerProjectQuery, MoveRunDrawerProjectQueryVariables>(MoveRunDrawerProjectDocument, options);
        }
// @ts-ignore
export function useMoveRunDrawerProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MoveRunDrawerProjectQuery, MoveRunDrawerProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MoveRunDrawerProjectQuery, MoveRunDrawerProjectQueryVariables>;
export function useMoveRunDrawerProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MoveRunDrawerProjectQuery, MoveRunDrawerProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MoveRunDrawerProjectQuery | undefined, MoveRunDrawerProjectQueryVariables>;
export function useMoveRunDrawerProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MoveRunDrawerProjectQuery, MoveRunDrawerProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MoveRunDrawerProjectQuery, MoveRunDrawerProjectQueryVariables>(MoveRunDrawerProjectDocument, options);
        }
export type MoveRunDrawerProjectQueryHookResult = ReturnType<typeof useMoveRunDrawerProjectQuery>;
export type MoveRunDrawerProjectLazyQueryHookResult = ReturnType<typeof useMoveRunDrawerProjectLazyQuery>;
export type MoveRunDrawerProjectSuspenseQueryHookResult = ReturnType<typeof useMoveRunDrawerProjectSuspenseQuery>;
export type MoveRunDrawerProjectQueryResult = ApolloReactCommon.QueryResult<MoveRunDrawerProjectQuery, MoveRunDrawerProjectQueryVariables>;
export const RunValueSuggestionsPaginatedDocument = gql`
    query RunValueSuggestionsPaginated($projectName: String!, $entityName: String, $keyPath: String!, $valuePattern: String, $before: String, $after: String, $first: Int, $last: Int) {
  project(name: $projectName, entityName: $entityName) {
    id
    runFieldValues(
      keyPath: $keyPath
      valuePattern: $valuePattern
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          value
        }
      }
    }
  }
}
    `;

/**
 * __useRunValueSuggestionsPaginatedQuery__
 *
 * To run a query within a React component, call `useRunValueSuggestionsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunValueSuggestionsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunValueSuggestionsPaginatedQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      keyPath: // value for 'keyPath'
 *      valuePattern: // value for 'valuePattern'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useRunValueSuggestionsPaginatedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables> & ({ variables: RunValueSuggestionsPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables>(RunValueSuggestionsPaginatedDocument, options);
      }
export function useRunValueSuggestionsPaginatedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables>(RunValueSuggestionsPaginatedDocument, options);
        }
// @ts-ignore
export function useRunValueSuggestionsPaginatedSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables>;
export function useRunValueSuggestionsPaginatedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunValueSuggestionsPaginatedQuery | undefined, RunValueSuggestionsPaginatedQueryVariables>;
export function useRunValueSuggestionsPaginatedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables>(RunValueSuggestionsPaginatedDocument, options);
        }
export type RunValueSuggestionsPaginatedQueryHookResult = ReturnType<typeof useRunValueSuggestionsPaginatedQuery>;
export type RunValueSuggestionsPaginatedLazyQueryHookResult = ReturnType<typeof useRunValueSuggestionsPaginatedLazyQuery>;
export type RunValueSuggestionsPaginatedSuspenseQueryHookResult = ReturnType<typeof useRunValueSuggestionsPaginatedSuspenseQuery>;
export type RunValueSuggestionsPaginatedQueryResult = ApolloReactCommon.QueryResult<RunValueSuggestionsPaginatedQuery, RunValueSuggestionsPaginatedQueryVariables>;
export const ProjectTotalRunsDocument = gql`
    query ProjectTotalRuns($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    totalRuns
  }
}
    `;

/**
 * __useProjectTotalRunsQuery__
 *
 * To run a query within a React component, call `useProjectTotalRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTotalRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTotalRunsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useProjectTotalRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectTotalRunsQuery, ProjectTotalRunsQueryVariables> & ({ variables: ProjectTotalRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectTotalRunsQuery, ProjectTotalRunsQueryVariables>(ProjectTotalRunsDocument, options);
      }
export function useProjectTotalRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectTotalRunsQuery, ProjectTotalRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectTotalRunsQuery, ProjectTotalRunsQueryVariables>(ProjectTotalRunsDocument, options);
        }
// @ts-ignore
export function useProjectTotalRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectTotalRunsQuery, ProjectTotalRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectTotalRunsQuery, ProjectTotalRunsQueryVariables>;
export function useProjectTotalRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectTotalRunsQuery, ProjectTotalRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectTotalRunsQuery | undefined, ProjectTotalRunsQueryVariables>;
export function useProjectTotalRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectTotalRunsQuery, ProjectTotalRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectTotalRunsQuery, ProjectTotalRunsQueryVariables>(ProjectTotalRunsDocument, options);
        }
export type ProjectTotalRunsQueryHookResult = ReturnType<typeof useProjectTotalRunsQuery>;
export type ProjectTotalRunsLazyQueryHookResult = ReturnType<typeof useProjectTotalRunsLazyQuery>;
export type ProjectTotalRunsSuspenseQueryHookResult = ReturnType<typeof useProjectTotalRunsSuspenseQuery>;
export type ProjectTotalRunsQueryResult = ApolloReactCommon.QueryResult<ProjectTotalRunsQuery, ProjectTotalRunsQueryVariables>;
export const ProjectRunsCountDocument = gql`
    query ProjectRunsCount($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    runCount
  }
}
    `;

/**
 * __useProjectRunsCountQuery__
 *
 * To run a query within a React component, call `useProjectRunsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRunsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectRunsCountQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useProjectRunsCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectRunsCountQuery, ProjectRunsCountQueryVariables> & ({ variables: ProjectRunsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectRunsCountQuery, ProjectRunsCountQueryVariables>(ProjectRunsCountDocument, options);
      }
export function useProjectRunsCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectRunsCountQuery, ProjectRunsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectRunsCountQuery, ProjectRunsCountQueryVariables>(ProjectRunsCountDocument, options);
        }
// @ts-ignore
export function useProjectRunsCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectRunsCountQuery, ProjectRunsCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectRunsCountQuery, ProjectRunsCountQueryVariables>;
export function useProjectRunsCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectRunsCountQuery, ProjectRunsCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectRunsCountQuery | undefined, ProjectRunsCountQueryVariables>;
export function useProjectRunsCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectRunsCountQuery, ProjectRunsCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectRunsCountQuery, ProjectRunsCountQueryVariables>(ProjectRunsCountDocument, options);
        }
export type ProjectRunsCountQueryHookResult = ReturnType<typeof useProjectRunsCountQuery>;
export type ProjectRunsCountLazyQueryHookResult = ReturnType<typeof useProjectRunsCountLazyQuery>;
export type ProjectRunsCountSuspenseQueryHookResult = ReturnType<typeof useProjectRunsCountSuspenseQuery>;
export type ProjectRunsCountQueryResult = ApolloReactCommon.QueryResult<ProjectRunsCountQuery, ProjectRunsCountQueryVariables>;
export const ProjectLastActiveDocument = gql`
    query ProjectLastActive($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    lastActive
  }
}
    `;

/**
 * __useProjectLastActiveQuery__
 *
 * To run a query within a React component, call `useProjectLastActiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectLastActiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectLastActiveQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useProjectLastActiveQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectLastActiveQuery, ProjectLastActiveQueryVariables> & ({ variables: ProjectLastActiveQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectLastActiveQuery, ProjectLastActiveQueryVariables>(ProjectLastActiveDocument, options);
      }
export function useProjectLastActiveLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectLastActiveQuery, ProjectLastActiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectLastActiveQuery, ProjectLastActiveQueryVariables>(ProjectLastActiveDocument, options);
        }
// @ts-ignore
export function useProjectLastActiveSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectLastActiveQuery, ProjectLastActiveQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectLastActiveQuery, ProjectLastActiveQueryVariables>;
export function useProjectLastActiveSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectLastActiveQuery, ProjectLastActiveQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectLastActiveQuery | undefined, ProjectLastActiveQueryVariables>;
export function useProjectLastActiveSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectLastActiveQuery, ProjectLastActiveQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectLastActiveQuery, ProjectLastActiveQueryVariables>(ProjectLastActiveDocument, options);
        }
export type ProjectLastActiveQueryHookResult = ReturnType<typeof useProjectLastActiveQuery>;
export type ProjectLastActiveLazyQueryHookResult = ReturnType<typeof useProjectLastActiveLazyQuery>;
export type ProjectLastActiveSuspenseQueryHookResult = ReturnType<typeof useProjectLastActiveSuspenseQuery>;
export type ProjectLastActiveQueryResult = ApolloReactCommon.QueryResult<ProjectLastActiveQuery, ProjectLastActiveQueryVariables>;
export const SweepRunsCountDocument = gql`
    query SweepRunsCount($projectName: String!, $entityName: String!, $sweepName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    sweep(sweepName: $sweepName) {
      id
      runCount
    }
  }
}
    `;

/**
 * __useSweepRunsCountQuery__
 *
 * To run a query within a React component, call `useSweepRunsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSweepRunsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSweepRunsCountQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      sweepName: // value for 'sweepName'
 *   },
 * });
 */
export function useSweepRunsCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SweepRunsCountQuery, SweepRunsCountQueryVariables> & ({ variables: SweepRunsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SweepRunsCountQuery, SweepRunsCountQueryVariables>(SweepRunsCountDocument, options);
      }
export function useSweepRunsCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SweepRunsCountQuery, SweepRunsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SweepRunsCountQuery, SweepRunsCountQueryVariables>(SweepRunsCountDocument, options);
        }
// @ts-ignore
export function useSweepRunsCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SweepRunsCountQuery, SweepRunsCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SweepRunsCountQuery, SweepRunsCountQueryVariables>;
export function useSweepRunsCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SweepRunsCountQuery, SweepRunsCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SweepRunsCountQuery | undefined, SweepRunsCountQueryVariables>;
export function useSweepRunsCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SweepRunsCountQuery, SweepRunsCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SweepRunsCountQuery, SweepRunsCountQueryVariables>(SweepRunsCountDocument, options);
        }
export type SweepRunsCountQueryHookResult = ReturnType<typeof useSweepRunsCountQuery>;
export type SweepRunsCountLazyQueryHookResult = ReturnType<typeof useSweepRunsCountLazyQuery>;
export type SweepRunsCountSuspenseQueryHookResult = ReturnType<typeof useSweepRunsCountSuspenseQuery>;
export type SweepRunsCountQueryResult = ApolloReactCommon.QueryResult<SweepRunsCountQuery, SweepRunsCountQueryVariables>;
export const SandboxesConnectionDocument = gql`
    query SandboxesConnection($entityName: String!, $first: Int, $after: String, $state: SandboxState, $tags: [String!], $showTerminated: Boolean, $runnerIds: [String!], $volumeIds: [String!]) {
  entity(name: $entityName) {
    id
    organizationId
    sandboxesConnection(
      first: $first
      after: $after
      state: $state
      tags: $tags
      showTerminated: $showTerminated
      runnerIds: $runnerIds
      volumeIds: $volumeIds
    ) {
      edges {
        node {
          ...SandboxFields
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}
    ${SandboxFieldsFragmentDoc}`;

/**
 * __useSandboxesConnectionQuery__
 *
 * To run a query within a React component, call `useSandboxesConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSandboxesConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSandboxesConnectionQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      state: // value for 'state'
 *      tags: // value for 'tags'
 *      showTerminated: // value for 'showTerminated'
 *      runnerIds: // value for 'runnerIds'
 *      volumeIds: // value for 'volumeIds'
 *   },
 * });
 */
export function useSandboxesConnectionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SandboxesConnectionQuery, SandboxesConnectionQueryVariables> & ({ variables: SandboxesConnectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SandboxesConnectionQuery, SandboxesConnectionQueryVariables>(SandboxesConnectionDocument, options);
      }
export function useSandboxesConnectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SandboxesConnectionQuery, SandboxesConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SandboxesConnectionQuery, SandboxesConnectionQueryVariables>(SandboxesConnectionDocument, options);
        }
// @ts-ignore
export function useSandboxesConnectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SandboxesConnectionQuery, SandboxesConnectionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SandboxesConnectionQuery, SandboxesConnectionQueryVariables>;
export function useSandboxesConnectionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SandboxesConnectionQuery, SandboxesConnectionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SandboxesConnectionQuery | undefined, SandboxesConnectionQueryVariables>;
export function useSandboxesConnectionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SandboxesConnectionQuery, SandboxesConnectionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SandboxesConnectionQuery, SandboxesConnectionQueryVariables>(SandboxesConnectionDocument, options);
        }
export type SandboxesConnectionQueryHookResult = ReturnType<typeof useSandboxesConnectionQuery>;
export type SandboxesConnectionLazyQueryHookResult = ReturnType<typeof useSandboxesConnectionLazyQuery>;
export type SandboxesConnectionSuspenseQueryHookResult = ReturnType<typeof useSandboxesConnectionSuspenseQuery>;
export type SandboxesConnectionQueryResult = ApolloReactCommon.QueryResult<SandboxesConnectionQuery, SandboxesConnectionQueryVariables>;
export const SandboxDocument = gql`
    query Sandbox($entityName: String!, $sandboxId: ID!) {
  entity(name: $entityName) {
    id
    organizationId
    sandbox(id: $sandboxId) {
      ...SandboxFields
    }
  }
}
    ${SandboxFieldsFragmentDoc}`;

/**
 * __useSandboxQuery__
 *
 * To run a query within a React component, call `useSandboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useSandboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSandboxQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      sandboxId: // value for 'sandboxId'
 *   },
 * });
 */
export function useSandboxQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SandboxQuery, SandboxQueryVariables> & ({ variables: SandboxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SandboxQuery, SandboxQueryVariables>(SandboxDocument, options);
      }
export function useSandboxLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SandboxQuery, SandboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SandboxQuery, SandboxQueryVariables>(SandboxDocument, options);
        }
// @ts-ignore
export function useSandboxSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SandboxQuery, SandboxQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SandboxQuery, SandboxQueryVariables>;
export function useSandboxSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SandboxQuery, SandboxQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SandboxQuery | undefined, SandboxQueryVariables>;
export function useSandboxSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SandboxQuery, SandboxQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SandboxQuery, SandboxQueryVariables>(SandboxDocument, options);
        }
export type SandboxQueryHookResult = ReturnType<typeof useSandboxQuery>;
export type SandboxLazyQueryHookResult = ReturnType<typeof useSandboxLazyQuery>;
export type SandboxSuspenseQueryHookResult = ReturnType<typeof useSandboxSuspenseQuery>;
export type SandboxQueryResult = ApolloReactCommon.QueryResult<SandboxQuery, SandboxQueryVariables>;
export const SandboxLogsDocument = gql`
    query SandboxLogs($entityName: String!, $sandboxId: ID!, $tailLines: Int, $sinceTime: DateTime) {
  entity(name: $entityName) {
    id
    sandbox(id: $sandboxId) {
      logs(sinceTime: $sinceTime, tailLines: $tailLines) {
        entries {
          text
          timestamp
        }
      }
    }
  }
}
    `;

/**
 * __useSandboxLogsQuery__
 *
 * To run a query within a React component, call `useSandboxLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSandboxLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSandboxLogsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      sandboxId: // value for 'sandboxId'
 *      tailLines: // value for 'tailLines'
 *      sinceTime: // value for 'sinceTime'
 *   },
 * });
 */
export function useSandboxLogsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SandboxLogsQuery, SandboxLogsQueryVariables> & ({ variables: SandboxLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SandboxLogsQuery, SandboxLogsQueryVariables>(SandboxLogsDocument, options);
      }
export function useSandboxLogsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SandboxLogsQuery, SandboxLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SandboxLogsQuery, SandboxLogsQueryVariables>(SandboxLogsDocument, options);
        }
// @ts-ignore
export function useSandboxLogsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SandboxLogsQuery, SandboxLogsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SandboxLogsQuery, SandboxLogsQueryVariables>;
export function useSandboxLogsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SandboxLogsQuery, SandboxLogsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SandboxLogsQuery | undefined, SandboxLogsQueryVariables>;
export function useSandboxLogsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SandboxLogsQuery, SandboxLogsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SandboxLogsQuery, SandboxLogsQueryVariables>(SandboxLogsDocument, options);
        }
export type SandboxLogsQueryHookResult = ReturnType<typeof useSandboxLogsQuery>;
export type SandboxLogsLazyQueryHookResult = ReturnType<typeof useSandboxLogsLazyQuery>;
export type SandboxLogsSuspenseQueryHookResult = ReturnType<typeof useSandboxLogsSuspenseQuery>;
export type SandboxLogsQueryResult = ApolloReactCommon.QueryResult<SandboxLogsQuery, SandboxLogsQueryVariables>;
export const FileSystemSnapshotsDocument = gql`
    query FileSystemSnapshots($orgName: String!, $first: Int, $after: String) {
  organization(name: $orgName) {
    id
    fileSystemSnapshotsConnection(first: $first, after: $after) {
      edges {
        node {
          ...FileSystemSnapshotFields
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
    }
  }
}
    ${FileSystemSnapshotFieldsFragmentDoc}`;

/**
 * __useFileSystemSnapshotsQuery__
 *
 * To run a query within a React component, call `useFileSystemSnapshotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileSystemSnapshotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileSystemSnapshotsQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFileSystemSnapshotsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FileSystemSnapshotsQuery, FileSystemSnapshotsQueryVariables> & ({ variables: FileSystemSnapshotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FileSystemSnapshotsQuery, FileSystemSnapshotsQueryVariables>(FileSystemSnapshotsDocument, options);
      }
export function useFileSystemSnapshotsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FileSystemSnapshotsQuery, FileSystemSnapshotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FileSystemSnapshotsQuery, FileSystemSnapshotsQueryVariables>(FileSystemSnapshotsDocument, options);
        }
// @ts-ignore
export function useFileSystemSnapshotsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FileSystemSnapshotsQuery, FileSystemSnapshotsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FileSystemSnapshotsQuery, FileSystemSnapshotsQueryVariables>;
export function useFileSystemSnapshotsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FileSystemSnapshotsQuery, FileSystemSnapshotsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FileSystemSnapshotsQuery | undefined, FileSystemSnapshotsQueryVariables>;
export function useFileSystemSnapshotsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FileSystemSnapshotsQuery, FileSystemSnapshotsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FileSystemSnapshotsQuery, FileSystemSnapshotsQueryVariables>(FileSystemSnapshotsDocument, options);
        }
export type FileSystemSnapshotsQueryHookResult = ReturnType<typeof useFileSystemSnapshotsQuery>;
export type FileSystemSnapshotsLazyQueryHookResult = ReturnType<typeof useFileSystemSnapshotsLazyQuery>;
export type FileSystemSnapshotsSuspenseQueryHookResult = ReturnType<typeof useFileSystemSnapshotsSuspenseQuery>;
export type FileSystemSnapshotsQueryResult = ApolloReactCommon.QueryResult<FileSystemSnapshotsQuery, FileSystemSnapshotsQueryVariables>;
export const FileSystemSnapshotDocument = gql`
    query FileSystemSnapshot($orgName: String!, $snapshotId: ID!) {
  organization(name: $orgName) {
    id
    fileSystemSnapshot(id: $snapshotId) {
      ...FileSystemSnapshotFields
    }
  }
}
    ${FileSystemSnapshotFieldsFragmentDoc}`;

/**
 * __useFileSystemSnapshotQuery__
 *
 * To run a query within a React component, call `useFileSystemSnapshotQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileSystemSnapshotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileSystemSnapshotQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      snapshotId: // value for 'snapshotId'
 *   },
 * });
 */
export function useFileSystemSnapshotQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FileSystemSnapshotQuery, FileSystemSnapshotQueryVariables> & ({ variables: FileSystemSnapshotQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FileSystemSnapshotQuery, FileSystemSnapshotQueryVariables>(FileSystemSnapshotDocument, options);
      }
export function useFileSystemSnapshotLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FileSystemSnapshotQuery, FileSystemSnapshotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FileSystemSnapshotQuery, FileSystemSnapshotQueryVariables>(FileSystemSnapshotDocument, options);
        }
// @ts-ignore
export function useFileSystemSnapshotSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FileSystemSnapshotQuery, FileSystemSnapshotQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FileSystemSnapshotQuery, FileSystemSnapshotQueryVariables>;
export function useFileSystemSnapshotSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FileSystemSnapshotQuery, FileSystemSnapshotQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FileSystemSnapshotQuery | undefined, FileSystemSnapshotQueryVariables>;
export function useFileSystemSnapshotSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FileSystemSnapshotQuery, FileSystemSnapshotQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FileSystemSnapshotQuery, FileSystemSnapshotQueryVariables>(FileSystemSnapshotDocument, options);
        }
export type FileSystemSnapshotQueryHookResult = ReturnType<typeof useFileSystemSnapshotQuery>;
export type FileSystemSnapshotLazyQueryHookResult = ReturnType<typeof useFileSystemSnapshotLazyQuery>;
export type FileSystemSnapshotSuspenseQueryHookResult = ReturnType<typeof useFileSystemSnapshotSuspenseQuery>;
export type FileSystemSnapshotQueryResult = ApolloReactCommon.QueryResult<FileSystemSnapshotQuery, FileSystemSnapshotQueryVariables>;
export const AccountSelectorContextProviderEntityDocument = gql`
    query AccountSelectorContextProviderEntity($teamName: String!) {
  entity(name: $teamName) {
    id
    isTeam
    entityType
    organization {
      id
      name
    }
  }
}
    `;

/**
 * __useAccountSelectorContextProviderEntityQuery__
 *
 * To run a query within a React component, call `useAccountSelectorContextProviderEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSelectorContextProviderEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSelectorContextProviderEntityQuery({
 *   variables: {
 *      teamName: // value for 'teamName'
 *   },
 * });
 */
export function useAccountSelectorContextProviderEntityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables> & ({ variables: AccountSelectorContextProviderEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables>(AccountSelectorContextProviderEntityDocument, options);
      }
export function useAccountSelectorContextProviderEntityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables>(AccountSelectorContextProviderEntityDocument, options);
        }
// @ts-ignore
export function useAccountSelectorContextProviderEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables>;
export function useAccountSelectorContextProviderEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountSelectorContextProviderEntityQuery | undefined, AccountSelectorContextProviderEntityQueryVariables>;
export function useAccountSelectorContextProviderEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables>(AccountSelectorContextProviderEntityDocument, options);
        }
export type AccountSelectorContextProviderEntityQueryHookResult = ReturnType<typeof useAccountSelectorContextProviderEntityQuery>;
export type AccountSelectorContextProviderEntityLazyQueryHookResult = ReturnType<typeof useAccountSelectorContextProviderEntityLazyQuery>;
export type AccountSelectorContextProviderEntitySuspenseQueryHookResult = ReturnType<typeof useAccountSelectorContextProviderEntitySuspenseQuery>;
export type AccountSelectorContextProviderEntityQueryResult = ApolloReactCommon.QueryResult<AccountSelectorContextProviderEntityQuery, AccountSelectorContextProviderEntityQueryVariables>;
export const AccountSelectorPersonalEntityUserDocument = gql`
    query AccountSelectorPersonalEntityUser($teamName: String!) {
  entity(name: $teamName) {
    id
    user {
      id
    }
  }
}
    `;

/**
 * __useAccountSelectorPersonalEntityUserQuery__
 *
 * To run a query within a React component, call `useAccountSelectorPersonalEntityUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSelectorPersonalEntityUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSelectorPersonalEntityUserQuery({
 *   variables: {
 *      teamName: // value for 'teamName'
 *   },
 * });
 */
export function useAccountSelectorPersonalEntityUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountSelectorPersonalEntityUserQuery, AccountSelectorPersonalEntityUserQueryVariables> & ({ variables: AccountSelectorPersonalEntityUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountSelectorPersonalEntityUserQuery, AccountSelectorPersonalEntityUserQueryVariables>(AccountSelectorPersonalEntityUserDocument, options);
      }
export function useAccountSelectorPersonalEntityUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountSelectorPersonalEntityUserQuery, AccountSelectorPersonalEntityUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountSelectorPersonalEntityUserQuery, AccountSelectorPersonalEntityUserQueryVariables>(AccountSelectorPersonalEntityUserDocument, options);
        }
// @ts-ignore
export function useAccountSelectorPersonalEntityUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AccountSelectorPersonalEntityUserQuery, AccountSelectorPersonalEntityUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountSelectorPersonalEntityUserQuery, AccountSelectorPersonalEntityUserQueryVariables>;
export function useAccountSelectorPersonalEntityUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountSelectorPersonalEntityUserQuery, AccountSelectorPersonalEntityUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountSelectorPersonalEntityUserQuery | undefined, AccountSelectorPersonalEntityUserQueryVariables>;
export function useAccountSelectorPersonalEntityUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountSelectorPersonalEntityUserQuery, AccountSelectorPersonalEntityUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccountSelectorPersonalEntityUserQuery, AccountSelectorPersonalEntityUserQueryVariables>(AccountSelectorPersonalEntityUserDocument, options);
        }
export type AccountSelectorPersonalEntityUserQueryHookResult = ReturnType<typeof useAccountSelectorPersonalEntityUserQuery>;
export type AccountSelectorPersonalEntityUserLazyQueryHookResult = ReturnType<typeof useAccountSelectorPersonalEntityUserLazyQuery>;
export type AccountSelectorPersonalEntityUserSuspenseQueryHookResult = ReturnType<typeof useAccountSelectorPersonalEntityUserSuspenseQuery>;
export type AccountSelectorPersonalEntityUserQueryResult = ApolloReactCommon.QueryResult<AccountSelectorPersonalEntityUserQuery, AccountSelectorPersonalEntityUserQueryVariables>;
export const ProfileMenuOrgRoleInfoDocument = gql`
    query ProfileMenuOrgRoleInfo($orgName: String!, $username: String!) {
  organization(name: $orgName) {
    id
    member(username: $username) {
      id
      orgID
      role
      username
    }
  }
}
    `;

/**
 * __useProfileMenuOrgRoleInfoQuery__
 *
 * To run a query within a React component, call `useProfileMenuOrgRoleInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileMenuOrgRoleInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileMenuOrgRoleInfoQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useProfileMenuOrgRoleInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables> & ({ variables: ProfileMenuOrgRoleInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables>(ProfileMenuOrgRoleInfoDocument, options);
      }
export function useProfileMenuOrgRoleInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables>(ProfileMenuOrgRoleInfoDocument, options);
        }
// @ts-ignore
export function useProfileMenuOrgRoleInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables>;
export function useProfileMenuOrgRoleInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfileMenuOrgRoleInfoQuery | undefined, ProfileMenuOrgRoleInfoQueryVariables>;
export function useProfileMenuOrgRoleInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables>(ProfileMenuOrgRoleInfoDocument, options);
        }
export type ProfileMenuOrgRoleInfoQueryHookResult = ReturnType<typeof useProfileMenuOrgRoleInfoQuery>;
export type ProfileMenuOrgRoleInfoLazyQueryHookResult = ReturnType<typeof useProfileMenuOrgRoleInfoLazyQuery>;
export type ProfileMenuOrgRoleInfoSuspenseQueryHookResult = ReturnType<typeof useProfileMenuOrgRoleInfoSuspenseQuery>;
export type ProfileMenuOrgRoleInfoQueryResult = ApolloReactCommon.QueryResult<ProfileMenuOrgRoleInfoQuery, ProfileMenuOrgRoleInfoQueryVariables>;
export const OpenMatchingOrganizationsDocument = gql`
    query OpenMatchingOrganizations($emailDomain: String) {
  viewer {
    id
    openMatchingOrganizations: organizations(emailDomain: $emailDomain) {
      id
      subscriptions {
        id
        status
      }
      teams {
        id
        settings {
          openToMatchingOrgEmailDomainUsers
        }
      }
    }
  }
}
    `;

/**
 * __useOpenMatchingOrganizationsQuery__
 *
 * To run a query within a React component, call `useOpenMatchingOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenMatchingOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenMatchingOrganizationsQuery({
 *   variables: {
 *      emailDomain: // value for 'emailDomain'
 *   },
 * });
 */
export function useOpenMatchingOrganizationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OpenMatchingOrganizationsQuery, OpenMatchingOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OpenMatchingOrganizationsQuery, OpenMatchingOrganizationsQueryVariables>(OpenMatchingOrganizationsDocument, options);
      }
export function useOpenMatchingOrganizationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OpenMatchingOrganizationsQuery, OpenMatchingOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OpenMatchingOrganizationsQuery, OpenMatchingOrganizationsQueryVariables>(OpenMatchingOrganizationsDocument, options);
        }
// @ts-ignore
export function useOpenMatchingOrganizationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OpenMatchingOrganizationsQuery, OpenMatchingOrganizationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OpenMatchingOrganizationsQuery, OpenMatchingOrganizationsQueryVariables>;
export function useOpenMatchingOrganizationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OpenMatchingOrganizationsQuery, OpenMatchingOrganizationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OpenMatchingOrganizationsQuery | undefined, OpenMatchingOrganizationsQueryVariables>;
export function useOpenMatchingOrganizationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OpenMatchingOrganizationsQuery, OpenMatchingOrganizationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OpenMatchingOrganizationsQuery, OpenMatchingOrganizationsQueryVariables>(OpenMatchingOrganizationsDocument, options);
        }
export type OpenMatchingOrganizationsQueryHookResult = ReturnType<typeof useOpenMatchingOrganizationsQuery>;
export type OpenMatchingOrganizationsLazyQueryHookResult = ReturnType<typeof useOpenMatchingOrganizationsLazyQuery>;
export type OpenMatchingOrganizationsSuspenseQueryHookResult = ReturnType<typeof useOpenMatchingOrganizationsSuspenseQuery>;
export type OpenMatchingOrganizationsQueryResult = ApolloReactCommon.QueryResult<OpenMatchingOrganizationsQuery, OpenMatchingOrganizationsQueryVariables>;
export const SubmitSlurmCommandDocument = gql`
    mutation submitSlurmCommand($entityName: String!, $projectName: String!, $runName: String!, $command: SlurmCommandType!) {
  submitSlurmCommand(
    input: {entityName: $entityName, projectName: $projectName, runName: $runName, command: $command}
  ) {
    success
    clientMutationId
  }
}
    `;
export type SubmitSlurmCommandMutationFn = ApolloReactCommon.MutationFunction<SubmitSlurmCommandMutation, SubmitSlurmCommandMutationVariables>;

/**
 * __useSubmitSlurmCommandMutation__
 *
 * To run a mutation, you first call `useSubmitSlurmCommandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitSlurmCommandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitSlurmCommandMutation, { data, loading, error }] = useSubmitSlurmCommandMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runName: // value for 'runName'
 *      command: // value for 'command'
 *   },
 * });
 */
export function useSubmitSlurmCommandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitSlurmCommandMutation, SubmitSlurmCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitSlurmCommandMutation, SubmitSlurmCommandMutationVariables>(SubmitSlurmCommandDocument, options);
      }
export type SubmitSlurmCommandMutationHookResult = ReturnType<typeof useSubmitSlurmCommandMutation>;
export type SubmitSlurmCommandMutationResult = ApolloReactCommon.MutationResult<SubmitSlurmCommandMutation>;
export type SubmitSlurmCommandMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitSlurmCommandMutation, SubmitSlurmCommandMutationVariables>;
export const SlurmLatestCommandDocument = gql`
    query SlurmLatestCommand($projectName: String!, $entityName: String!, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      slurmControl {
        latestCommand {
          __typename
          id
          command
          state
          errorMessage
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `;

/**
 * __useSlurmLatestCommandQuery__
 *
 * To run a query within a React component, call `useSlurmLatestCommandQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlurmLatestCommandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlurmLatestCommandQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useSlurmLatestCommandQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SlurmLatestCommandQuery, SlurmLatestCommandQueryVariables> & ({ variables: SlurmLatestCommandQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SlurmLatestCommandQuery, SlurmLatestCommandQueryVariables>(SlurmLatestCommandDocument, options);
      }
export function useSlurmLatestCommandLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SlurmLatestCommandQuery, SlurmLatestCommandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SlurmLatestCommandQuery, SlurmLatestCommandQueryVariables>(SlurmLatestCommandDocument, options);
        }
// @ts-ignore
export function useSlurmLatestCommandSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SlurmLatestCommandQuery, SlurmLatestCommandQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SlurmLatestCommandQuery, SlurmLatestCommandQueryVariables>;
export function useSlurmLatestCommandSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SlurmLatestCommandQuery, SlurmLatestCommandQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SlurmLatestCommandQuery | undefined, SlurmLatestCommandQueryVariables>;
export function useSlurmLatestCommandSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SlurmLatestCommandQuery, SlurmLatestCommandQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SlurmLatestCommandQuery, SlurmLatestCommandQueryVariables>(SlurmLatestCommandDocument, options);
        }
export type SlurmLatestCommandQueryHookResult = ReturnType<typeof useSlurmLatestCommandQuery>;
export type SlurmLatestCommandLazyQueryHookResult = ReturnType<typeof useSlurmLatestCommandLazyQuery>;
export type SlurmLatestCommandSuspenseQueryHookResult = ReturnType<typeof useSlurmLatestCommandSuspenseQuery>;
export type SlurmLatestCommandQueryResult = ApolloReactCommon.QueryResult<SlurmLatestCommandQuery, SlurmLatestCommandQueryVariables>;
export const SlurmDaemonReadinessByRunNameDocument = gql`
    query SlurmDaemonReadinessByRunName($projectName: String!, $entityName: String!, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      slurmControl {
        health {
          ready
          lastSeenAt
          message
        }
      }
    }
  }
}
    `;

/**
 * __useSlurmDaemonReadinessByRunNameQuery__
 *
 * To run a query within a React component, call `useSlurmDaemonReadinessByRunNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlurmDaemonReadinessByRunNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlurmDaemonReadinessByRunNameQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useSlurmDaemonReadinessByRunNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SlurmDaemonReadinessByRunNameQuery, SlurmDaemonReadinessByRunNameQueryVariables> & ({ variables: SlurmDaemonReadinessByRunNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SlurmDaemonReadinessByRunNameQuery, SlurmDaemonReadinessByRunNameQueryVariables>(SlurmDaemonReadinessByRunNameDocument, options);
      }
export function useSlurmDaemonReadinessByRunNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SlurmDaemonReadinessByRunNameQuery, SlurmDaemonReadinessByRunNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SlurmDaemonReadinessByRunNameQuery, SlurmDaemonReadinessByRunNameQueryVariables>(SlurmDaemonReadinessByRunNameDocument, options);
        }
// @ts-ignore
export function useSlurmDaemonReadinessByRunNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SlurmDaemonReadinessByRunNameQuery, SlurmDaemonReadinessByRunNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SlurmDaemonReadinessByRunNameQuery, SlurmDaemonReadinessByRunNameQueryVariables>;
export function useSlurmDaemonReadinessByRunNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SlurmDaemonReadinessByRunNameQuery, SlurmDaemonReadinessByRunNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SlurmDaemonReadinessByRunNameQuery | undefined, SlurmDaemonReadinessByRunNameQueryVariables>;
export function useSlurmDaemonReadinessByRunNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SlurmDaemonReadinessByRunNameQuery, SlurmDaemonReadinessByRunNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SlurmDaemonReadinessByRunNameQuery, SlurmDaemonReadinessByRunNameQueryVariables>(SlurmDaemonReadinessByRunNameDocument, options);
        }
export type SlurmDaemonReadinessByRunNameQueryHookResult = ReturnType<typeof useSlurmDaemonReadinessByRunNameQuery>;
export type SlurmDaemonReadinessByRunNameLazyQueryHookResult = ReturnType<typeof useSlurmDaemonReadinessByRunNameLazyQuery>;
export type SlurmDaemonReadinessByRunNameSuspenseQueryHookResult = ReturnType<typeof useSlurmDaemonReadinessByRunNameSuspenseQuery>;
export type SlurmDaemonReadinessByRunNameQueryResult = ApolloReactCommon.QueryResult<SlurmDaemonReadinessByRunNameQuery, SlurmDaemonReadinessByRunNameQueryVariables>;
export const UpdateTeamStorageBucketDocument = gql`
    mutation updateTeamStorageBucket($input: UpdateTeamStorageBucketInput!) {
  updateTeamStorageBucket(input: $input) {
    success
    bucketStoreID
    entity {
      id
      name
    }
    clientMutationID
  }
}
    `;
export type UpdateTeamStorageBucketMutationFn = ApolloReactCommon.MutationFunction<UpdateTeamStorageBucketMutation, UpdateTeamStorageBucketMutationVariables>;

/**
 * __useUpdateTeamStorageBucketMutation__
 *
 * To run a mutation, you first call `useUpdateTeamStorageBucketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamStorageBucketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamStorageBucketMutation, { data, loading, error }] = useUpdateTeamStorageBucketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamStorageBucketMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTeamStorageBucketMutation, UpdateTeamStorageBucketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTeamStorageBucketMutation, UpdateTeamStorageBucketMutationVariables>(UpdateTeamStorageBucketDocument, options);
      }
export type UpdateTeamStorageBucketMutationHookResult = ReturnType<typeof useUpdateTeamStorageBucketMutation>;
export type UpdateTeamStorageBucketMutationResult = ApolloReactCommon.MutationResult<UpdateTeamStorageBucketMutation>;
export type UpdateTeamStorageBucketMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateTeamStorageBucketMutation, UpdateTeamStorageBucketMutationVariables>;
export const WorkspaceIngestionHealthDocument = gql`
    query WorkspaceIngestionHealth {
  serverInfo {
    ingestionHealth {
      status
    }
  }
}
    `;

/**
 * __useWorkspaceIngestionHealthQuery__
 *
 * To run a query within a React component, call `useWorkspaceIngestionHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceIngestionHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceIngestionHealthQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceIngestionHealthQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WorkspaceIngestionHealthQuery, WorkspaceIngestionHealthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkspaceIngestionHealthQuery, WorkspaceIngestionHealthQueryVariables>(WorkspaceIngestionHealthDocument, options);
      }
export function useWorkspaceIngestionHealthLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspaceIngestionHealthQuery, WorkspaceIngestionHealthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkspaceIngestionHealthQuery, WorkspaceIngestionHealthQueryVariables>(WorkspaceIngestionHealthDocument, options);
        }
// @ts-ignore
export function useWorkspaceIngestionHealthSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceIngestionHealthQuery, WorkspaceIngestionHealthQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspaceIngestionHealthQuery, WorkspaceIngestionHealthQueryVariables>;
export function useWorkspaceIngestionHealthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceIngestionHealthQuery, WorkspaceIngestionHealthQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspaceIngestionHealthQuery | undefined, WorkspaceIngestionHealthQueryVariables>;
export function useWorkspaceIngestionHealthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceIngestionHealthQuery, WorkspaceIngestionHealthQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WorkspaceIngestionHealthQuery, WorkspaceIngestionHealthQueryVariables>(WorkspaceIngestionHealthDocument, options);
        }
export type WorkspaceIngestionHealthQueryHookResult = ReturnType<typeof useWorkspaceIngestionHealthQuery>;
export type WorkspaceIngestionHealthLazyQueryHookResult = ReturnType<typeof useWorkspaceIngestionHealthLazyQuery>;
export type WorkspaceIngestionHealthSuspenseQueryHookResult = ReturnType<typeof useWorkspaceIngestionHealthSuspenseQuery>;
export type WorkspaceIngestionHealthQueryResult = ApolloReactCommon.QueryResult<WorkspaceIngestionHealthQuery, WorkspaceIngestionHealthQueryVariables>;
export const UniqueKeyTypesDocument = gql`
    query UniqueKeyTypes($projectName: String!, $entityName: String!, $filters: JSONString, $runLimit: Int, $runOrder: String, $requiredRunKeys: [String!]) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(
      filters: $filters
      first: $runLimit
      order: $runOrder
      requiredRunKeys: $requiredRunKeys
    ) {
      uniqueKeyTypes
    }
  }
}
    `;

/**
 * __useUniqueKeyTypesQuery__
 *
 * To run a query within a React component, call `useUniqueKeyTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniqueKeyTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniqueKeyTypesQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      runLimit: // value for 'runLimit'
 *      runOrder: // value for 'runOrder'
 *      requiredRunKeys: // value for 'requiredRunKeys'
 *   },
 * });
 */
export function useUniqueKeyTypesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UniqueKeyTypesQuery, UniqueKeyTypesQueryVariables> & ({ variables: UniqueKeyTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UniqueKeyTypesQuery, UniqueKeyTypesQueryVariables>(UniqueKeyTypesDocument, options);
      }
export function useUniqueKeyTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UniqueKeyTypesQuery, UniqueKeyTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UniqueKeyTypesQuery, UniqueKeyTypesQueryVariables>(UniqueKeyTypesDocument, options);
        }
// @ts-ignore
export function useUniqueKeyTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UniqueKeyTypesQuery, UniqueKeyTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UniqueKeyTypesQuery, UniqueKeyTypesQueryVariables>;
export function useUniqueKeyTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UniqueKeyTypesQuery, UniqueKeyTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UniqueKeyTypesQuery | undefined, UniqueKeyTypesQueryVariables>;
export function useUniqueKeyTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UniqueKeyTypesQuery, UniqueKeyTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UniqueKeyTypesQuery, UniqueKeyTypesQueryVariables>(UniqueKeyTypesDocument, options);
        }
export type UniqueKeyTypesQueryHookResult = ReturnType<typeof useUniqueKeyTypesQuery>;
export type UniqueKeyTypesLazyQueryHookResult = ReturnType<typeof useUniqueKeyTypesLazyQuery>;
export type UniqueKeyTypesSuspenseQueryHookResult = ReturnType<typeof useUniqueKeyTypesSuspenseQuery>;
export type UniqueKeyTypesQueryResult = ApolloReactCommon.QueryResult<UniqueKeyTypesQuery, UniqueKeyTypesQueryVariables>;
export const CreateNotebookDocument = gql`
    mutation CreateNotebook($entityName: String!, $projectName: String!, $template: NotebookTemplate!) {
  createNotebook(
    input: {template: $template, entityName: $entityName, projectName: $projectName}
  ) {
    notebook {
      id
      ...NotebookFragment
    }
  }
}
    ${NotebookFragmentFragmentDoc}`;
export type CreateNotebookMutationFn = ApolloReactCommon.MutationFunction<CreateNotebookMutation, CreateNotebookMutationVariables>;

/**
 * __useCreateNotebookMutation__
 *
 * To run a mutation, you first call `useCreateNotebookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotebookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotebookMutation, { data, loading, error }] = useCreateNotebookMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      template: // value for 'template'
 *   },
 * });
 */
export function useCreateNotebookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateNotebookMutation, CreateNotebookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateNotebookMutation, CreateNotebookMutationVariables>(CreateNotebookDocument, options);
      }
export type CreateNotebookMutationHookResult = ReturnType<typeof useCreateNotebookMutation>;
export type CreateNotebookMutationResult = ApolloReactCommon.MutationResult<CreateNotebookMutation>;
export type CreateNotebookMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateNotebookMutation, CreateNotebookMutationVariables>;
export const DuplicateNotebookDocument = gql`
    mutation DuplicateNotebook($id: ID!) {
  duplicateNotebook(input: {id: $id}) {
    notebook {
      id
      ...NotebookFragment
    }
  }
}
    ${NotebookFragmentFragmentDoc}`;
export type DuplicateNotebookMutationFn = ApolloReactCommon.MutationFunction<DuplicateNotebookMutation, DuplicateNotebookMutationVariables>;

/**
 * __useDuplicateNotebookMutation__
 *
 * To run a mutation, you first call `useDuplicateNotebookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateNotebookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateNotebookMutation, { data, loading, error }] = useDuplicateNotebookMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateNotebookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DuplicateNotebookMutation, DuplicateNotebookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DuplicateNotebookMutation, DuplicateNotebookMutationVariables>(DuplicateNotebookDocument, options);
      }
export type DuplicateNotebookMutationHookResult = ReturnType<typeof useDuplicateNotebookMutation>;
export type DuplicateNotebookMutationResult = ApolloReactCommon.MutationResult<DuplicateNotebookMutation>;
export type DuplicateNotebookMutationOptions = ApolloReactCommon.BaseMutationOptions<DuplicateNotebookMutation, DuplicateNotebookMutationVariables>;
export const CreateSandboxDocument = gql`
    mutation CreateSandbox($notebookId: String!, $mode: SandboxMode!, $entityName: String!, $projectName: String!, $runNames: [String!]!) {
  createSandbox(
    input: {notebookId: $notebookId, mode: $mode, entityName: $entityName, projectName: $projectName, runNames: $runNames}
  ) {
    id
    url
    token
  }
}
    `;
export type CreateSandboxMutationFn = ApolloReactCommon.MutationFunction<CreateSandboxMutation, CreateSandboxMutationVariables>;

/**
 * __useCreateSandboxMutation__
 *
 * To run a mutation, you first call `useCreateSandboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSandboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSandboxMutation, { data, loading, error }] = useCreateSandboxMutation({
 *   variables: {
 *      notebookId: // value for 'notebookId'
 *      mode: // value for 'mode'
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runNames: // value for 'runNames'
 *   },
 * });
 */
export function useCreateSandboxMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSandboxMutation, CreateSandboxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSandboxMutation, CreateSandboxMutationVariables>(CreateSandboxDocument, options);
      }
export type CreateSandboxMutationHookResult = ReturnType<typeof useCreateSandboxMutation>;
export type CreateSandboxMutationResult = ApolloReactCommon.MutationResult<CreateSandboxMutation>;
export type CreateSandboxMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSandboxMutation, CreateSandboxMutationVariables>;
export const HeartbeatSandboxDocument = gql`
    mutation HeartbeatSandbox($sandboxId: ID!) {
  heartbeatSandbox(input: {sandboxId: $sandboxId}) {
    success
  }
}
    `;
export type HeartbeatSandboxMutationFn = ApolloReactCommon.MutationFunction<HeartbeatSandboxMutation, HeartbeatSandboxMutationVariables>;

/**
 * __useHeartbeatSandboxMutation__
 *
 * To run a mutation, you first call `useHeartbeatSandboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHeartbeatSandboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [heartbeatSandboxMutation, { data, loading, error }] = useHeartbeatSandboxMutation({
 *   variables: {
 *      sandboxId: // value for 'sandboxId'
 *   },
 * });
 */
export function useHeartbeatSandboxMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<HeartbeatSandboxMutation, HeartbeatSandboxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<HeartbeatSandboxMutation, HeartbeatSandboxMutationVariables>(HeartbeatSandboxDocument, options);
      }
export type HeartbeatSandboxMutationHookResult = ReturnType<typeof useHeartbeatSandboxMutation>;
export type HeartbeatSandboxMutationResult = ApolloReactCommon.MutationResult<HeartbeatSandboxMutation>;
export type HeartbeatSandboxMutationOptions = ApolloReactCommon.BaseMutationOptions<HeartbeatSandboxMutation, HeartbeatSandboxMutationVariables>;
export const SourceNotebookDocument = gql`
    query SourceNotebook($projectName: String!, $entityName: String!, $search: String, $after: String, $first: Int) {
  project(name: $projectName, entityName: $entityName) {
    id
    notebooks(
      viewerPermissions: [DUPLICATE]
      search: $search
      after: $after
      first: $first
    ) {
      edges {
        cursor
        node {
          id
          ...NotebookFragment
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${NotebookFragmentFragmentDoc}`;

/**
 * __useSourceNotebookQuery__
 *
 * To run a query within a React component, call `useSourceNotebookQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceNotebookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceNotebookQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      search: // value for 'search'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSourceNotebookQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SourceNotebookQuery, SourceNotebookQueryVariables> & ({ variables: SourceNotebookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SourceNotebookQuery, SourceNotebookQueryVariables>(SourceNotebookDocument, options);
      }
export function useSourceNotebookLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SourceNotebookQuery, SourceNotebookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SourceNotebookQuery, SourceNotebookQueryVariables>(SourceNotebookDocument, options);
        }
// @ts-ignore
export function useSourceNotebookSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SourceNotebookQuery, SourceNotebookQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SourceNotebookQuery, SourceNotebookQueryVariables>;
export function useSourceNotebookSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SourceNotebookQuery, SourceNotebookQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SourceNotebookQuery | undefined, SourceNotebookQueryVariables>;
export function useSourceNotebookSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SourceNotebookQuery, SourceNotebookQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SourceNotebookQuery, SourceNotebookQueryVariables>(SourceNotebookDocument, options);
        }
export type SourceNotebookQueryHookResult = ReturnType<typeof useSourceNotebookQuery>;
export type SourceNotebookLazyQueryHookResult = ReturnType<typeof useSourceNotebookLazyQuery>;
export type SourceNotebookSuspenseQueryHookResult = ReturnType<typeof useSourceNotebookSuspenseQuery>;
export type SourceNotebookQueryResult = ApolloReactCommon.QueryResult<SourceNotebookQuery, SourceNotebookQueryVariables>;
export const SelectedNotebookDocument = gql`
    query SelectedNotebook($id: ID!) {
  notebook(id: $id) {
    id
    ...NotebookFragment
    ...NotebookPermissionsFragment
  }
}
    ${NotebookFragmentFragmentDoc}
${NotebookPermissionsFragmentFragmentDoc}`;

/**
 * __useSelectedNotebookQuery__
 *
 * To run a query within a React component, call `useSelectedNotebookQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedNotebookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedNotebookQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSelectedNotebookQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SelectedNotebookQuery, SelectedNotebookQueryVariables> & ({ variables: SelectedNotebookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectedNotebookQuery, SelectedNotebookQueryVariables>(SelectedNotebookDocument, options);
      }
export function useSelectedNotebookLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectedNotebookQuery, SelectedNotebookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectedNotebookQuery, SelectedNotebookQueryVariables>(SelectedNotebookDocument, options);
        }
// @ts-ignore
export function useSelectedNotebookSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SelectedNotebookQuery, SelectedNotebookQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectedNotebookQuery, SelectedNotebookQueryVariables>;
export function useSelectedNotebookSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectedNotebookQuery, SelectedNotebookQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectedNotebookQuery | undefined, SelectedNotebookQueryVariables>;
export function useSelectedNotebookSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectedNotebookQuery, SelectedNotebookQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SelectedNotebookQuery, SelectedNotebookQueryVariables>(SelectedNotebookDocument, options);
        }
export type SelectedNotebookQueryHookResult = ReturnType<typeof useSelectedNotebookQuery>;
export type SelectedNotebookLazyQueryHookResult = ReturnType<typeof useSelectedNotebookLazyQuery>;
export type SelectedNotebookSuspenseQueryHookResult = ReturnType<typeof useSelectedNotebookSuspenseQuery>;
export type SelectedNotebookQueryResult = ApolloReactCommon.QueryResult<SelectedNotebookQuery, SelectedNotebookQueryVariables>;
export const ConfigValuesAggregationQueryDocument = gql`
    query ConfigValuesAggregationQuery($entityName: String!, $filters: JSONString!, $limit: Int!, $order: String!, $projectName: String!, $configKey: String!, $configType: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(first: $limit, order: $order, filters: $filters) {
      configValues(configKey: $configKey, configType: $configType)
      configValuesNumberAggregation(configKey: $configKey)
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useConfigValuesAggregationQueryQuery__
 *
 * To run a query within a React component, call `useConfigValuesAggregationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigValuesAggregationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigValuesAggregationQueryQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      projectName: // value for 'projectName'
 *      configKey: // value for 'configKey'
 *      configType: // value for 'configType'
 *   },
 * });
 */
export function useConfigValuesAggregationQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables> & ({ variables: ConfigValuesAggregationQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables>(ConfigValuesAggregationQueryDocument, options);
      }
export function useConfigValuesAggregationQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables>(ConfigValuesAggregationQueryDocument, options);
        }
// @ts-ignore
export function useConfigValuesAggregationQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables>;
export function useConfigValuesAggregationQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfigValuesAggregationQueryQuery | undefined, ConfigValuesAggregationQueryQueryVariables>;
export function useConfigValuesAggregationQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables>(ConfigValuesAggregationQueryDocument, options);
        }
export type ConfigValuesAggregationQueryQueryHookResult = ReturnType<typeof useConfigValuesAggregationQueryQuery>;
export type ConfigValuesAggregationQueryLazyQueryHookResult = ReturnType<typeof useConfigValuesAggregationQueryLazyQuery>;
export type ConfigValuesAggregationQuerySuspenseQueryHookResult = ReturnType<typeof useConfigValuesAggregationQuerySuspenseQuery>;
export type ConfigValuesAggregationQueryQueryResult = ApolloReactCommon.QueryResult<ConfigValuesAggregationQueryQuery, ConfigValuesAggregationQueryQueryVariables>;
export const ConfigValuesCategoriesQueryDocument = gql`
    query ConfigValuesCategoriesQuery($entityName: String!, $filters: JSONString!, $limit: Int!, $order: String!, $projectName: String!, $configKey: String!, $configType: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(first: $limit, order: $order, filters: $filters) {
      configValues(configKey: $configKey, configType: $configType)
      configValuesCategories(configKey: $configKey, limit: $limit)
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useConfigValuesCategoriesQueryQuery__
 *
 * To run a query within a React component, call `useConfigValuesCategoriesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigValuesCategoriesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigValuesCategoriesQueryQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      projectName: // value for 'projectName'
 *      configKey: // value for 'configKey'
 *      configType: // value for 'configType'
 *   },
 * });
 */
export function useConfigValuesCategoriesQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables> & ({ variables: ConfigValuesCategoriesQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables>(ConfigValuesCategoriesQueryDocument, options);
      }
export function useConfigValuesCategoriesQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables>(ConfigValuesCategoriesQueryDocument, options);
        }
// @ts-ignore
export function useConfigValuesCategoriesQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables>;
export function useConfigValuesCategoriesQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ConfigValuesCategoriesQueryQuery | undefined, ConfigValuesCategoriesQueryQueryVariables>;
export function useConfigValuesCategoriesQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables>(ConfigValuesCategoriesQueryDocument, options);
        }
export type ConfigValuesCategoriesQueryQueryHookResult = ReturnType<typeof useConfigValuesCategoriesQueryQuery>;
export type ConfigValuesCategoriesQueryLazyQueryHookResult = ReturnType<typeof useConfigValuesCategoriesQueryLazyQuery>;
export type ConfigValuesCategoriesQuerySuspenseQueryHookResult = ReturnType<typeof useConfigValuesCategoriesQuerySuspenseQuery>;
export type ConfigValuesCategoriesQueryQueryResult = ApolloReactCommon.QueryResult<ConfigValuesCategoriesQueryQuery, ConfigValuesCategoriesQueryQueryVariables>;
export const MetricStatisticsAggregationQueryDocument = gql`
    query MetricStatisticsAggregationQuery($entityName: String!, $filters: JSONString!, $limit: Int!, $order: String!, $projectName: String!, $metricName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(first: $limit, order: $order, filters: $filters) {
      metricStatisticsAggregation(metricName: $metricName)
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useMetricStatisticsAggregationQueryQuery__
 *
 * To run a query within a React component, call `useMetricStatisticsAggregationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricStatisticsAggregationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricStatisticsAggregationQueryQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      projectName: // value for 'projectName'
 *      metricName: // value for 'metricName'
 *   },
 * });
 */
export function useMetricStatisticsAggregationQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables> & ({ variables: MetricStatisticsAggregationQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables>(MetricStatisticsAggregationQueryDocument, options);
      }
export function useMetricStatisticsAggregationQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables>(MetricStatisticsAggregationQueryDocument, options);
        }
// @ts-ignore
export function useMetricStatisticsAggregationQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables>;
export function useMetricStatisticsAggregationQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MetricStatisticsAggregationQueryQuery | undefined, MetricStatisticsAggregationQueryQueryVariables>;
export function useMetricStatisticsAggregationQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables>(MetricStatisticsAggregationQueryDocument, options);
        }
export type MetricStatisticsAggregationQueryQueryHookResult = ReturnType<typeof useMetricStatisticsAggregationQueryQuery>;
export type MetricStatisticsAggregationQueryLazyQueryHookResult = ReturnType<typeof useMetricStatisticsAggregationQueryLazyQuery>;
export type MetricStatisticsAggregationQuerySuspenseQueryHookResult = ReturnType<typeof useMetricStatisticsAggregationQuerySuspenseQuery>;
export type MetricStatisticsAggregationQueryQueryResult = ApolloReactCommon.QueryResult<MetricStatisticsAggregationQueryQuery, MetricStatisticsAggregationQueryQueryVariables>;
export const MetricStatisticsQueryDocument = gql`
    query MetricStatisticsQuery($entityName: String!, $filters: JSONString!, $limit: Int!, $order: String!, $projectName: String!, $metricName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(first: $limit, order: $order, filters: $filters) {
      metricStatistics(metricName: $metricName)
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useMetricStatisticsQueryQuery__
 *
 * To run a query within a React component, call `useMetricStatisticsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricStatisticsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricStatisticsQueryQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      projectName: // value for 'projectName'
 *      metricName: // value for 'metricName'
 *   },
 * });
 */
export function useMetricStatisticsQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables> & ({ variables: MetricStatisticsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables>(MetricStatisticsQueryDocument, options);
      }
export function useMetricStatisticsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables>(MetricStatisticsQueryDocument, options);
        }
// @ts-ignore
export function useMetricStatisticsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables>;
export function useMetricStatisticsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MetricStatisticsQueryQuery | undefined, MetricStatisticsQueryQueryVariables>;
export function useMetricStatisticsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables>(MetricStatisticsQueryDocument, options);
        }
export type MetricStatisticsQueryQueryHookResult = ReturnType<typeof useMetricStatisticsQueryQuery>;
export type MetricStatisticsQueryLazyQueryHookResult = ReturnType<typeof useMetricStatisticsQueryLazyQuery>;
export type MetricStatisticsQuerySuspenseQueryHookResult = ReturnType<typeof useMetricStatisticsQuerySuspenseQuery>;
export type MetricStatisticsQueryQueryResult = ApolloReactCommon.QueryResult<MetricStatisticsQueryQuery, MetricStatisticsQueryQueryVariables>;
export const CreateSemanticLegendDocument = gql`
    mutation CreateSemanticLegend($id: ID!, $metricName: String!, $yValue: String!, $customColors: [String], $bucketUpperBounds: [Float!]!, $excludedRunColor: String!) {
  createSemanticLegend(
    input: {viewID: $id, metricName: $metricName, yValue: $yValue, customColors: $customColors, bucketUpperBounds: $bucketUpperBounds, excludedRunColor: $excludedRunColor}
  ) {
    success
  }
}
    `;
export type CreateSemanticLegendMutationFn = ApolloReactCommon.MutationFunction<CreateSemanticLegendMutation, CreateSemanticLegendMutationVariables>;

/**
 * __useCreateSemanticLegendMutation__
 *
 * To run a mutation, you first call `useCreateSemanticLegendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSemanticLegendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSemanticLegendMutation, { data, loading, error }] = useCreateSemanticLegendMutation({
 *   variables: {
 *      id: // value for 'id'
 *      metricName: // value for 'metricName'
 *      yValue: // value for 'yValue'
 *      customColors: // value for 'customColors'
 *      bucketUpperBounds: // value for 'bucketUpperBounds'
 *      excludedRunColor: // value for 'excludedRunColor'
 *   },
 * });
 */
export function useCreateSemanticLegendMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSemanticLegendMutation, CreateSemanticLegendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSemanticLegendMutation, CreateSemanticLegendMutationVariables>(CreateSemanticLegendDocument, options);
      }
export type CreateSemanticLegendMutationHookResult = ReturnType<typeof useCreateSemanticLegendMutation>;
export type CreateSemanticLegendMutationResult = ApolloReactCommon.MutationResult<CreateSemanticLegendMutation>;
export type CreateSemanticLegendMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSemanticLegendMutation, CreateSemanticLegendMutationVariables>;
export const UpdateSemanticLegendDocument = gql`
    mutation UpdateSemanticLegend($id: ID!, $currentMetric: String!, $metricName: String, $yValue: String, $customColors: [String], $bucketUpperBounds: [Float!], $excludedRunColor: String) {
  updateSemanticLegend(
    input: {viewID: $id, currentMetric: $currentMetric, metricName: $metricName, yValue: $yValue, customColors: $customColors, bucketUpperBounds: $bucketUpperBounds, excludedRunColor: $excludedRunColor}
  ) {
    success
  }
}
    `;
export type UpdateSemanticLegendMutationFn = ApolloReactCommon.MutationFunction<UpdateSemanticLegendMutation, UpdateSemanticLegendMutationVariables>;

/**
 * __useUpdateSemanticLegendMutation__
 *
 * To run a mutation, you first call `useUpdateSemanticLegendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSemanticLegendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSemanticLegendMutation, { data, loading, error }] = useUpdateSemanticLegendMutation({
 *   variables: {
 *      id: // value for 'id'
 *      currentMetric: // value for 'currentMetric'
 *      metricName: // value for 'metricName'
 *      yValue: // value for 'yValue'
 *      customColors: // value for 'customColors'
 *      bucketUpperBounds: // value for 'bucketUpperBounds'
 *      excludedRunColor: // value for 'excludedRunColor'
 *   },
 * });
 */
export function useUpdateSemanticLegendMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSemanticLegendMutation, UpdateSemanticLegendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSemanticLegendMutation, UpdateSemanticLegendMutationVariables>(UpdateSemanticLegendDocument, options);
      }
export type UpdateSemanticLegendMutationHookResult = ReturnType<typeof useUpdateSemanticLegendMutation>;
export type UpdateSemanticLegendMutationResult = ApolloReactCommon.MutationResult<UpdateSemanticLegendMutation>;
export type UpdateSemanticLegendMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSemanticLegendMutation, UpdateSemanticLegendMutationVariables>;
export const SemanticLegendsQueryDocument = gql`
    query SemanticLegendsQuery($id: ID!) {
  view(id: $id) {
    id
    semanticLegend {
      currentMetric
      semanticLegendsByMetric {
        metricName
        yValue
        customColors {
          bucketNumber
          colorHex
        }
        bucketUpperBounds
        excludedRunColor
        lastUpdatedAt
      }
    }
  }
}
    `;

/**
 * __useSemanticLegendsQueryQuery__
 *
 * To run a query within a React component, call `useSemanticLegendsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSemanticLegendsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSemanticLegendsQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSemanticLegendsQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables> & ({ variables: SemanticLegendsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables>(SemanticLegendsQueryDocument, options);
      }
export function useSemanticLegendsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables>(SemanticLegendsQueryDocument, options);
        }
// @ts-ignore
export function useSemanticLegendsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables>;
export function useSemanticLegendsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SemanticLegendsQueryQuery | undefined, SemanticLegendsQueryQueryVariables>;
export function useSemanticLegendsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables>(SemanticLegendsQueryDocument, options);
        }
export type SemanticLegendsQueryQueryHookResult = ReturnType<typeof useSemanticLegendsQueryQuery>;
export type SemanticLegendsQueryLazyQueryHookResult = ReturnType<typeof useSemanticLegendsQueryLazyQuery>;
export type SemanticLegendsQuerySuspenseQueryHookResult = ReturnType<typeof useSemanticLegendsQuerySuspenseQuery>;
export type SemanticLegendsQueryQueryResult = ApolloReactCommon.QueryResult<SemanticLegendsQueryQuery, SemanticLegendsQueryQueryVariables>;
export const CreateSemanticLegendWithCategoricalConfigDocument = gql`
    mutation CreateSemanticLegendWithCategoricalConfig($id: ID!, $metricName: String!, $yValue: String!, $customColors: [String], $bucketUpperBounds: [Float!]!, $excludedRunColor: String!, $categories: [String]) {
  createSemanticLegend(
    input: {viewID: $id, metricName: $metricName, yValue: $yValue, customColors: $customColors, bucketUpperBounds: $bucketUpperBounds, excludedRunColor: $excludedRunColor, categories: $categories}
  ) {
    success
  }
}
    `;
export type CreateSemanticLegendWithCategoricalConfigMutationFn = ApolloReactCommon.MutationFunction<CreateSemanticLegendWithCategoricalConfigMutation, CreateSemanticLegendWithCategoricalConfigMutationVariables>;

/**
 * __useCreateSemanticLegendWithCategoricalConfigMutation__
 *
 * To run a mutation, you first call `useCreateSemanticLegendWithCategoricalConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSemanticLegendWithCategoricalConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSemanticLegendWithCategoricalConfigMutation, { data, loading, error }] = useCreateSemanticLegendWithCategoricalConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *      metricName: // value for 'metricName'
 *      yValue: // value for 'yValue'
 *      customColors: // value for 'customColors'
 *      bucketUpperBounds: // value for 'bucketUpperBounds'
 *      excludedRunColor: // value for 'excludedRunColor'
 *      categories: // value for 'categories'
 *   },
 * });
 */
export function useCreateSemanticLegendWithCategoricalConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSemanticLegendWithCategoricalConfigMutation, CreateSemanticLegendWithCategoricalConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSemanticLegendWithCategoricalConfigMutation, CreateSemanticLegendWithCategoricalConfigMutationVariables>(CreateSemanticLegendWithCategoricalConfigDocument, options);
      }
export type CreateSemanticLegendWithCategoricalConfigMutationHookResult = ReturnType<typeof useCreateSemanticLegendWithCategoricalConfigMutation>;
export type CreateSemanticLegendWithCategoricalConfigMutationResult = ApolloReactCommon.MutationResult<CreateSemanticLegendWithCategoricalConfigMutation>;
export type CreateSemanticLegendWithCategoricalConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSemanticLegendWithCategoricalConfigMutation, CreateSemanticLegendWithCategoricalConfigMutationVariables>;
export const UpdateSemanticLegendWithCategoricalConfigDocument = gql`
    mutation UpdateSemanticLegendWithCategoricalConfig($id: ID!, $currentMetric: String!, $metricName: String, $yValue: String, $customColors: [String], $bucketUpperBounds: [Float!], $excludedRunColor: String, $categories: [String]) {
  updateSemanticLegend(
    input: {viewID: $id, currentMetric: $currentMetric, metricName: $metricName, yValue: $yValue, customColors: $customColors, bucketUpperBounds: $bucketUpperBounds, excludedRunColor: $excludedRunColor, categories: $categories}
  ) {
    success
    view {
      ...SemanticLegendWithCategoricalConfigFragment
    }
  }
}
    ${SemanticLegendWithCategoricalConfigFragmentFragmentDoc}`;
export type UpdateSemanticLegendWithCategoricalConfigMutationFn = ApolloReactCommon.MutationFunction<UpdateSemanticLegendWithCategoricalConfigMutation, UpdateSemanticLegendWithCategoricalConfigMutationVariables>;

/**
 * __useUpdateSemanticLegendWithCategoricalConfigMutation__
 *
 * To run a mutation, you first call `useUpdateSemanticLegendWithCategoricalConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSemanticLegendWithCategoricalConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSemanticLegendWithCategoricalConfigMutation, { data, loading, error }] = useUpdateSemanticLegendWithCategoricalConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *      currentMetric: // value for 'currentMetric'
 *      metricName: // value for 'metricName'
 *      yValue: // value for 'yValue'
 *      customColors: // value for 'customColors'
 *      bucketUpperBounds: // value for 'bucketUpperBounds'
 *      excludedRunColor: // value for 'excludedRunColor'
 *      categories: // value for 'categories'
 *   },
 * });
 */
export function useUpdateSemanticLegendWithCategoricalConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSemanticLegendWithCategoricalConfigMutation, UpdateSemanticLegendWithCategoricalConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSemanticLegendWithCategoricalConfigMutation, UpdateSemanticLegendWithCategoricalConfigMutationVariables>(UpdateSemanticLegendWithCategoricalConfigDocument, options);
      }
export type UpdateSemanticLegendWithCategoricalConfigMutationHookResult = ReturnType<typeof useUpdateSemanticLegendWithCategoricalConfigMutation>;
export type UpdateSemanticLegendWithCategoricalConfigMutationResult = ApolloReactCommon.MutationResult<UpdateSemanticLegendWithCategoricalConfigMutation>;
export type UpdateSemanticLegendWithCategoricalConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSemanticLegendWithCategoricalConfigMutation, UpdateSemanticLegendWithCategoricalConfigMutationVariables>;
export const SemanticLegendsQueryWithCategoricalConfigDocument = gql`
    query SemanticLegendsQueryWithCategoricalConfig($id: ID!) {
  view(id: $id) {
    ...SemanticLegendWithCategoricalConfigFragment
  }
}
    ${SemanticLegendWithCategoricalConfigFragmentFragmentDoc}`;

/**
 * __useSemanticLegendsQueryWithCategoricalConfigQuery__
 *
 * To run a query within a React component, call `useSemanticLegendsQueryWithCategoricalConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSemanticLegendsQueryWithCategoricalConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSemanticLegendsQueryWithCategoricalConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSemanticLegendsQueryWithCategoricalConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables> & ({ variables: SemanticLegendsQueryWithCategoricalConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables>(SemanticLegendsQueryWithCategoricalConfigDocument, options);
      }
export function useSemanticLegendsQueryWithCategoricalConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables>(SemanticLegendsQueryWithCategoricalConfigDocument, options);
        }
// @ts-ignore
export function useSemanticLegendsQueryWithCategoricalConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables>;
export function useSemanticLegendsQueryWithCategoricalConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SemanticLegendsQueryWithCategoricalConfigQuery | undefined, SemanticLegendsQueryWithCategoricalConfigQueryVariables>;
export function useSemanticLegendsQueryWithCategoricalConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables>(SemanticLegendsQueryWithCategoricalConfigDocument, options);
        }
export type SemanticLegendsQueryWithCategoricalConfigQueryHookResult = ReturnType<typeof useSemanticLegendsQueryWithCategoricalConfigQuery>;
export type SemanticLegendsQueryWithCategoricalConfigLazyQueryHookResult = ReturnType<typeof useSemanticLegendsQueryWithCategoricalConfigLazyQuery>;
export type SemanticLegendsQueryWithCategoricalConfigSuspenseQueryHookResult = ReturnType<typeof useSemanticLegendsQueryWithCategoricalConfigSuspenseQuery>;
export type SemanticLegendsQueryWithCategoricalConfigQueryResult = ApolloReactCommon.QueryResult<SemanticLegendsQueryWithCategoricalConfigQuery, SemanticLegendsQueryWithCategoricalConfigQueryVariables>;
export const UpsertWorkspaceTemplateDocument = gql`
    mutation UpsertWorkspaceTemplate($entityId: ID!, $linePlotTemplateId: ID, $linePlotSettings: JSONString, $workspaceLayoutTemplateId: ID, $workspaceLayoutSettings: JSONString) {
  upsertWorkspaceTemplate(
    input: {entityId: $entityId, linePlotTemplateId: $linePlotTemplateId, linePlotSettings: $linePlotSettings, workspaceLayoutTemplateId: $workspaceLayoutTemplateId, workspaceLayoutSettings: $workspaceLayoutSettings}
  ) {
    linePlotTemplateId
    workspaceLayoutTemplateId
  }
}
    `;
export type UpsertWorkspaceTemplateMutationFn = ApolloReactCommon.MutationFunction<UpsertWorkspaceTemplateMutation, UpsertWorkspaceTemplateMutationVariables>;

/**
 * __useUpsertWorkspaceTemplateMutation__
 *
 * To run a mutation, you first call `useUpsertWorkspaceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertWorkspaceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertWorkspaceTemplateMutation, { data, loading, error }] = useUpsertWorkspaceTemplateMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      linePlotTemplateId: // value for 'linePlotTemplateId'
 *      linePlotSettings: // value for 'linePlotSettings'
 *      workspaceLayoutTemplateId: // value for 'workspaceLayoutTemplateId'
 *      workspaceLayoutSettings: // value for 'workspaceLayoutSettings'
 *   },
 * });
 */
export function useUpsertWorkspaceTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertWorkspaceTemplateMutation, UpsertWorkspaceTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertWorkspaceTemplateMutation, UpsertWorkspaceTemplateMutationVariables>(UpsertWorkspaceTemplateDocument, options);
      }
export type UpsertWorkspaceTemplateMutationHookResult = ReturnType<typeof useUpsertWorkspaceTemplateMutation>;
export type UpsertWorkspaceTemplateMutationResult = ApolloReactCommon.MutationResult<UpsertWorkspaceTemplateMutation>;
export type UpsertWorkspaceTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertWorkspaceTemplateMutation, UpsertWorkspaceTemplateMutationVariables>;
export const DeleteWorkspaceTemplateDocument = gql`
    mutation DeleteWorkspaceTemplate($linePlotTemplateId: ID, $workspaceLayoutTemplateId: ID) {
  deleteWorkspaceTemplate(
    input: {linePlotTemplateId: $linePlotTemplateId, workspaceLayoutTemplateId: $workspaceLayoutTemplateId}
  ) {
    success
  }
}
    `;
export type DeleteWorkspaceTemplateMutationFn = ApolloReactCommon.MutationFunction<DeleteWorkspaceTemplateMutation, DeleteWorkspaceTemplateMutationVariables>;

/**
 * __useDeleteWorkspaceTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceTemplateMutation, { data, loading, error }] = useDeleteWorkspaceTemplateMutation({
 *   variables: {
 *      linePlotTemplateId: // value for 'linePlotTemplateId'
 *      workspaceLayoutTemplateId: // value for 'workspaceLayoutTemplateId'
 *   },
 * });
 */
export function useDeleteWorkspaceTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteWorkspaceTemplateMutation, DeleteWorkspaceTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteWorkspaceTemplateMutation, DeleteWorkspaceTemplateMutationVariables>(DeleteWorkspaceTemplateDocument, options);
      }
export type DeleteWorkspaceTemplateMutationHookResult = ReturnType<typeof useDeleteWorkspaceTemplateMutation>;
export type DeleteWorkspaceTemplateMutationResult = ApolloReactCommon.MutationResult<DeleteWorkspaceTemplateMutation>;
export type DeleteWorkspaceTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteWorkspaceTemplateMutation, DeleteWorkspaceTemplateMutationVariables>;
export const WorkspaceTemplatesDocument = gql`
    query WorkspaceTemplates($entityId: ID!, $userId: ID) {
  workspaceTemplates(entityId: $entityId, userId: $userId) {
    id
    createdAt
    createdBy {
      id
      name
      email
      username
    }
    updatedAt
    settings
    settingsVersion
    type
  }
}
    `;

/**
 * __useWorkspaceTemplatesQuery__
 *
 * To run a query within a React component, call `useWorkspaceTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceTemplatesQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useWorkspaceTemplatesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables> & ({ variables: WorkspaceTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables>(WorkspaceTemplatesDocument, options);
      }
export function useWorkspaceTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables>(WorkspaceTemplatesDocument, options);
        }
// @ts-ignore
export function useWorkspaceTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables>;
export function useWorkspaceTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspaceTemplatesQuery | undefined, WorkspaceTemplatesQueryVariables>;
export function useWorkspaceTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables>(WorkspaceTemplatesDocument, options);
        }
export type WorkspaceTemplatesQueryHookResult = ReturnType<typeof useWorkspaceTemplatesQuery>;
export type WorkspaceTemplatesLazyQueryHookResult = ReturnType<typeof useWorkspaceTemplatesLazyQuery>;
export type WorkspaceTemplatesSuspenseQueryHookResult = ReturnType<typeof useWorkspaceTemplatesSuspenseQuery>;
export type WorkspaceTemplatesQueryResult = ApolloReactCommon.QueryResult<WorkspaceTemplatesQuery, WorkspaceTemplatesQueryVariables>;
export const CustomPanelEditorProjectDocument = gql`
    query CustomPanelEditorProject($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    readOnly
  }
}
    `;

/**
 * __useCustomPanelEditorProjectQuery__
 *
 * To run a query within a React component, call `useCustomPanelEditorProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomPanelEditorProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomPanelEditorProjectQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useCustomPanelEditorProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CustomPanelEditorProjectQuery, CustomPanelEditorProjectQueryVariables> & ({ variables: CustomPanelEditorProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CustomPanelEditorProjectQuery, CustomPanelEditorProjectQueryVariables>(CustomPanelEditorProjectDocument, options);
      }
export function useCustomPanelEditorProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CustomPanelEditorProjectQuery, CustomPanelEditorProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CustomPanelEditorProjectQuery, CustomPanelEditorProjectQueryVariables>(CustomPanelEditorProjectDocument, options);
        }
// @ts-ignore
export function useCustomPanelEditorProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CustomPanelEditorProjectQuery, CustomPanelEditorProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CustomPanelEditorProjectQuery, CustomPanelEditorProjectQueryVariables>;
export function useCustomPanelEditorProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CustomPanelEditorProjectQuery, CustomPanelEditorProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CustomPanelEditorProjectQuery | undefined, CustomPanelEditorProjectQueryVariables>;
export function useCustomPanelEditorProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CustomPanelEditorProjectQuery, CustomPanelEditorProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CustomPanelEditorProjectQuery, CustomPanelEditorProjectQueryVariables>(CustomPanelEditorProjectDocument, options);
        }
export type CustomPanelEditorProjectQueryHookResult = ReturnType<typeof useCustomPanelEditorProjectQuery>;
export type CustomPanelEditorProjectLazyQueryHookResult = ReturnType<typeof useCustomPanelEditorProjectLazyQuery>;
export type CustomPanelEditorProjectSuspenseQueryHookResult = ReturnType<typeof useCustomPanelEditorProjectSuspenseQuery>;
export type CustomPanelEditorProjectQueryResult = ApolloReactCommon.QueryResult<CustomPanelEditorProjectQuery, CustomPanelEditorProjectQueryVariables>;
export const ArtifactWeaveSourceDocument = gql`
    query ArtifactWeaveSource($artifactID: ID!) {
  artifact(id: $artifactID) {
    id
    weaveSource {
      sourceType
    }
  }
}
    `;

/**
 * __useArtifactWeaveSourceQuery__
 *
 * To run a query within a React component, call `useArtifactWeaveSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactWeaveSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactWeaveSourceQuery({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *   },
 * });
 */
export function useArtifactWeaveSourceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactWeaveSourceQuery, ArtifactWeaveSourceQueryVariables> & ({ variables: ArtifactWeaveSourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactWeaveSourceQuery, ArtifactWeaveSourceQueryVariables>(ArtifactWeaveSourceDocument, options);
      }
export function useArtifactWeaveSourceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactWeaveSourceQuery, ArtifactWeaveSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactWeaveSourceQuery, ArtifactWeaveSourceQueryVariables>(ArtifactWeaveSourceDocument, options);
        }
// @ts-ignore
export function useArtifactWeaveSourceSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactWeaveSourceQuery, ArtifactWeaveSourceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactWeaveSourceQuery, ArtifactWeaveSourceQueryVariables>;
export function useArtifactWeaveSourceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactWeaveSourceQuery, ArtifactWeaveSourceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactWeaveSourceQuery | undefined, ArtifactWeaveSourceQueryVariables>;
export function useArtifactWeaveSourceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactWeaveSourceQuery, ArtifactWeaveSourceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactWeaveSourceQuery, ArtifactWeaveSourceQueryVariables>(ArtifactWeaveSourceDocument, options);
        }
export type ArtifactWeaveSourceQueryHookResult = ReturnType<typeof useArtifactWeaveSourceQuery>;
export type ArtifactWeaveSourceLazyQueryHookResult = ReturnType<typeof useArtifactWeaveSourceLazyQuery>;
export type ArtifactWeaveSourceSuspenseQueryHookResult = ReturnType<typeof useArtifactWeaveSourceSuspenseQuery>;
export type ArtifactWeaveSourceQueryResult = ApolloReactCommon.QueryResult<ArtifactWeaveSourceQuery, ArtifactWeaveSourceQueryVariables>;
export const WeaveRegistryAssetDocument = gql`
    query WeaveRegistryAsset($path: String!) {
  registryAsset(path: $path) {
    weaveRef
    refType
    canReadPromptContent
  }
}
    `;

/**
 * __useWeaveRegistryAssetQuery__
 *
 * To run a query within a React component, call `useWeaveRegistryAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeaveRegistryAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeaveRegistryAssetQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useWeaveRegistryAssetQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WeaveRegistryAssetQuery, WeaveRegistryAssetQueryVariables> & ({ variables: WeaveRegistryAssetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WeaveRegistryAssetQuery, WeaveRegistryAssetQueryVariables>(WeaveRegistryAssetDocument, options);
      }
export function useWeaveRegistryAssetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WeaveRegistryAssetQuery, WeaveRegistryAssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WeaveRegistryAssetQuery, WeaveRegistryAssetQueryVariables>(WeaveRegistryAssetDocument, options);
        }
// @ts-ignore
export function useWeaveRegistryAssetSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WeaveRegistryAssetQuery, WeaveRegistryAssetQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WeaveRegistryAssetQuery, WeaveRegistryAssetQueryVariables>;
export function useWeaveRegistryAssetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WeaveRegistryAssetQuery, WeaveRegistryAssetQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WeaveRegistryAssetQuery | undefined, WeaveRegistryAssetQueryVariables>;
export function useWeaveRegistryAssetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WeaveRegistryAssetQuery, WeaveRegistryAssetQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WeaveRegistryAssetQuery, WeaveRegistryAssetQueryVariables>(WeaveRegistryAssetDocument, options);
        }
export type WeaveRegistryAssetQueryHookResult = ReturnType<typeof useWeaveRegistryAssetQuery>;
export type WeaveRegistryAssetLazyQueryHookResult = ReturnType<typeof useWeaveRegistryAssetLazyQuery>;
export type WeaveRegistryAssetSuspenseQueryHookResult = ReturnType<typeof useWeaveRegistryAssetSuspenseQuery>;
export type WeaveRegistryAssetQueryResult = ApolloReactCommon.QueryResult<WeaveRegistryAssetQuery, WeaveRegistryAssetQueryVariables>;
export const ArtifactMembershipOverviewDocument = gql`
    query ArtifactMembershipOverview($artifactID: ID!) {
  artifact(id: $artifactID) {
    id
    digest
    size
    fileCount
    usedCount
    createdAt
    description
    commitHash
    sourceVersionIndex: versionIndex
    ttlDurationSeconds
    ttlIsInherited
    isGenerated
    isLinkedToGlobalRegistry
    storageRegion
    artifactType {
      id
      name
    }
    artifactSequence {
      id
      name
      project {
        id
        name
        entity {
          id
          name
          artifactTTLDurationSeconds
        }
      }
    }
    createdBy {
      __typename
      ... on Run {
        id
        name
        displayName
        project {
          id
          name
          entityName
        }
      }
      ... on User {
        id
        name
        username
      }
    }
  }
}
    `;

/**
 * __useArtifactMembershipOverviewQuery__
 *
 * To run a query within a React component, call `useArtifactMembershipOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactMembershipOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactMembershipOverviewQuery({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *   },
 * });
 */
export function useArtifactMembershipOverviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactMembershipOverviewQuery, ArtifactMembershipOverviewQueryVariables> & ({ variables: ArtifactMembershipOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactMembershipOverviewQuery, ArtifactMembershipOverviewQueryVariables>(ArtifactMembershipOverviewDocument, options);
      }
export function useArtifactMembershipOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactMembershipOverviewQuery, ArtifactMembershipOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactMembershipOverviewQuery, ArtifactMembershipOverviewQueryVariables>(ArtifactMembershipOverviewDocument, options);
        }
// @ts-ignore
export function useArtifactMembershipOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMembershipOverviewQuery, ArtifactMembershipOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactMembershipOverviewQuery, ArtifactMembershipOverviewQueryVariables>;
export function useArtifactMembershipOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMembershipOverviewQuery, ArtifactMembershipOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactMembershipOverviewQuery | undefined, ArtifactMembershipOverviewQueryVariables>;
export function useArtifactMembershipOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMembershipOverviewQuery, ArtifactMembershipOverviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactMembershipOverviewQuery, ArtifactMembershipOverviewQueryVariables>(ArtifactMembershipOverviewDocument, options);
        }
export type ArtifactMembershipOverviewQueryHookResult = ReturnType<typeof useArtifactMembershipOverviewQuery>;
export type ArtifactMembershipOverviewLazyQueryHookResult = ReturnType<typeof useArtifactMembershipOverviewLazyQuery>;
export type ArtifactMembershipOverviewSuspenseQueryHookResult = ReturnType<typeof useArtifactMembershipOverviewSuspenseQuery>;
export type ArtifactMembershipOverviewQueryResult = ApolloReactCommon.QueryResult<ArtifactMembershipOverviewQuery, ArtifactMembershipOverviewQueryVariables>;
export const ArtifactVersionMembershipsDocument = gql`
    query ArtifactVersionMemberships($artifactId: ID!) {
  artifact(id: $artifactId) {
    id
    artifactMemberships {
      edges {
        node {
          id
          versionIndex
          artifactCollection {
            __typename
            id
            name
            project {
              id
              name
              entityName
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactVersionMembershipsQuery__
 *
 * To run a query within a React component, call `useArtifactVersionMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactVersionMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactVersionMembershipsQuery({
 *   variables: {
 *      artifactId: // value for 'artifactId'
 *   },
 * });
 */
export function useArtifactVersionMembershipsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactVersionMembershipsQuery, ArtifactVersionMembershipsQueryVariables> & ({ variables: ArtifactVersionMembershipsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactVersionMembershipsQuery, ArtifactVersionMembershipsQueryVariables>(ArtifactVersionMembershipsDocument, options);
      }
export function useArtifactVersionMembershipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactVersionMembershipsQuery, ArtifactVersionMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactVersionMembershipsQuery, ArtifactVersionMembershipsQueryVariables>(ArtifactVersionMembershipsDocument, options);
        }
// @ts-ignore
export function useArtifactVersionMembershipsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionMembershipsQuery, ArtifactVersionMembershipsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionMembershipsQuery, ArtifactVersionMembershipsQueryVariables>;
export function useArtifactVersionMembershipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionMembershipsQuery, ArtifactVersionMembershipsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionMembershipsQuery | undefined, ArtifactVersionMembershipsQueryVariables>;
export function useArtifactVersionMembershipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionMembershipsQuery, ArtifactVersionMembershipsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactVersionMembershipsQuery, ArtifactVersionMembershipsQueryVariables>(ArtifactVersionMembershipsDocument, options);
        }
export type ArtifactVersionMembershipsQueryHookResult = ReturnType<typeof useArtifactVersionMembershipsQuery>;
export type ArtifactVersionMembershipsLazyQueryHookResult = ReturnType<typeof useArtifactVersionMembershipsLazyQuery>;
export type ArtifactVersionMembershipsSuspenseQueryHookResult = ReturnType<typeof useArtifactVersionMembershipsSuspenseQuery>;
export type ArtifactVersionMembershipsQueryResult = ApolloReactCommon.QueryResult<ArtifactVersionMembershipsQuery, ArtifactVersionMembershipsQueryVariables>;
export const ArtifactMembershipPeerArtifactsDocument = gql`
    query ArtifactMembershipPeerArtifacts($artifactID: ID!) {
  artifact(id: $artifactID) {
    id
    createdBy {
      __typename
      ... on Run {
        id
        inputArtifacts {
          edges {
            node {
              id
              versionIndex
              artifactType {
                id
                name
              }
              artifactSequence {
                id
                name
                project {
                  id
                  name
                  entityName
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactMembershipPeerArtifactsQuery__
 *
 * To run a query within a React component, call `useArtifactMembershipPeerArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactMembershipPeerArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactMembershipPeerArtifactsQuery({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *   },
 * });
 */
export function useArtifactMembershipPeerArtifactsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactMembershipPeerArtifactsQuery, ArtifactMembershipPeerArtifactsQueryVariables> & ({ variables: ArtifactMembershipPeerArtifactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactMembershipPeerArtifactsQuery, ArtifactMembershipPeerArtifactsQueryVariables>(ArtifactMembershipPeerArtifactsDocument, options);
      }
export function useArtifactMembershipPeerArtifactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactMembershipPeerArtifactsQuery, ArtifactMembershipPeerArtifactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactMembershipPeerArtifactsQuery, ArtifactMembershipPeerArtifactsQueryVariables>(ArtifactMembershipPeerArtifactsDocument, options);
        }
// @ts-ignore
export function useArtifactMembershipPeerArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMembershipPeerArtifactsQuery, ArtifactMembershipPeerArtifactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactMembershipPeerArtifactsQuery, ArtifactMembershipPeerArtifactsQueryVariables>;
export function useArtifactMembershipPeerArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMembershipPeerArtifactsQuery, ArtifactMembershipPeerArtifactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactMembershipPeerArtifactsQuery | undefined, ArtifactMembershipPeerArtifactsQueryVariables>;
export function useArtifactMembershipPeerArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactMembershipPeerArtifactsQuery, ArtifactMembershipPeerArtifactsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactMembershipPeerArtifactsQuery, ArtifactMembershipPeerArtifactsQueryVariables>(ArtifactMembershipPeerArtifactsDocument, options);
        }
export type ArtifactMembershipPeerArtifactsQueryHookResult = ReturnType<typeof useArtifactMembershipPeerArtifactsQuery>;
export type ArtifactMembershipPeerArtifactsLazyQueryHookResult = ReturnType<typeof useArtifactMembershipPeerArtifactsLazyQuery>;
export type ArtifactMembershipPeerArtifactsSuspenseQueryHookResult = ReturnType<typeof useArtifactMembershipPeerArtifactsSuspenseQuery>;
export type ArtifactMembershipPeerArtifactsQueryResult = ApolloReactCommon.QueryResult<ArtifactMembershipPeerArtifactsQuery, ArtifactMembershipPeerArtifactsQueryVariables>;
export const ArtifactVersionLineageInfoDocument = gql`
    query ArtifactVersionLineageInfo($artifactID: ID!) {
  artifact(id: $artifactID) {
    id
    commitHash
    artifactSequence {
      id
      name
    }
  }
}
    `;

/**
 * __useArtifactVersionLineageInfoQuery__
 *
 * To run a query within a React component, call `useArtifactVersionLineageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactVersionLineageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactVersionLineageInfoQuery({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *   },
 * });
 */
export function useArtifactVersionLineageInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactVersionLineageInfoQuery, ArtifactVersionLineageInfoQueryVariables> & ({ variables: ArtifactVersionLineageInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactVersionLineageInfoQuery, ArtifactVersionLineageInfoQueryVariables>(ArtifactVersionLineageInfoDocument, options);
      }
export function useArtifactVersionLineageInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactVersionLineageInfoQuery, ArtifactVersionLineageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactVersionLineageInfoQuery, ArtifactVersionLineageInfoQueryVariables>(ArtifactVersionLineageInfoDocument, options);
        }
// @ts-ignore
export function useArtifactVersionLineageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionLineageInfoQuery, ArtifactVersionLineageInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionLineageInfoQuery, ArtifactVersionLineageInfoQueryVariables>;
export function useArtifactVersionLineageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionLineageInfoQuery, ArtifactVersionLineageInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionLineageInfoQuery | undefined, ArtifactVersionLineageInfoQueryVariables>;
export function useArtifactVersionLineageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionLineageInfoQuery, ArtifactVersionLineageInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactVersionLineageInfoQuery, ArtifactVersionLineageInfoQueryVariables>(ArtifactVersionLineageInfoDocument, options);
        }
export type ArtifactVersionLineageInfoQueryHookResult = ReturnType<typeof useArtifactVersionLineageInfoQuery>;
export type ArtifactVersionLineageInfoLazyQueryHookResult = ReturnType<typeof useArtifactVersionLineageInfoLazyQuery>;
export type ArtifactVersionLineageInfoSuspenseQueryHookResult = ReturnType<typeof useArtifactVersionLineageInfoSuspenseQuery>;
export type ArtifactVersionLineageInfoQueryResult = ApolloReactCommon.QueryResult<ArtifactVersionLineageInfoQuery, ArtifactVersionLineageInfoQueryVariables>;
export const ArtifactVersionMetadataDocument = gql`
    query ArtifactVersionMetadata($artifactID: ID!) {
  artifact(id: $artifactID) {
    id
    metadata
    artifactSequence {
      id
      project {
        id
      }
    }
  }
}
    `;

/**
 * __useArtifactVersionMetadataQuery__
 *
 * To run a query within a React component, call `useArtifactVersionMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactVersionMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactVersionMetadataQuery({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *   },
 * });
 */
export function useArtifactVersionMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactVersionMetadataQuery, ArtifactVersionMetadataQueryVariables> & ({ variables: ArtifactVersionMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactVersionMetadataQuery, ArtifactVersionMetadataQueryVariables>(ArtifactVersionMetadataDocument, options);
      }
export function useArtifactVersionMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactVersionMetadataQuery, ArtifactVersionMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactVersionMetadataQuery, ArtifactVersionMetadataQueryVariables>(ArtifactVersionMetadataDocument, options);
        }
// @ts-ignore
export function useArtifactVersionMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionMetadataQuery, ArtifactVersionMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionMetadataQuery, ArtifactVersionMetadataQueryVariables>;
export function useArtifactVersionMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionMetadataQuery, ArtifactVersionMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionMetadataQuery | undefined, ArtifactVersionMetadataQueryVariables>;
export function useArtifactVersionMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionMetadataQuery, ArtifactVersionMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactVersionMetadataQuery, ArtifactVersionMetadataQueryVariables>(ArtifactVersionMetadataDocument, options);
        }
export type ArtifactVersionMetadataQueryHookResult = ReturnType<typeof useArtifactVersionMetadataQuery>;
export type ArtifactVersionMetadataLazyQueryHookResult = ReturnType<typeof useArtifactVersionMetadataLazyQuery>;
export type ArtifactVersionMetadataSuspenseQueryHookResult = ReturnType<typeof useArtifactVersionMetadataSuspenseQuery>;
export type ArtifactVersionMetadataQueryResult = ApolloReactCommon.QueryResult<ArtifactVersionMetadataQuery, ArtifactVersionMetadataQueryVariables>;
export const ArtifactVersionRunConfigDocument = gql`
    query ArtifactVersionRunConfig($artifactID: ID!) {
  artifact(id: $artifactID) {
    id
    createdBy {
      __typename
      ... on Run {
        id
        config
      }
    }
  }
}
    `;

/**
 * __useArtifactVersionRunConfigQuery__
 *
 * To run a query within a React component, call `useArtifactVersionRunConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactVersionRunConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactVersionRunConfigQuery({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *   },
 * });
 */
export function useArtifactVersionRunConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactVersionRunConfigQuery, ArtifactVersionRunConfigQueryVariables> & ({ variables: ArtifactVersionRunConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactVersionRunConfigQuery, ArtifactVersionRunConfigQueryVariables>(ArtifactVersionRunConfigDocument, options);
      }
export function useArtifactVersionRunConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactVersionRunConfigQuery, ArtifactVersionRunConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactVersionRunConfigQuery, ArtifactVersionRunConfigQueryVariables>(ArtifactVersionRunConfigDocument, options);
        }
// @ts-ignore
export function useArtifactVersionRunConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionRunConfigQuery, ArtifactVersionRunConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionRunConfigQuery, ArtifactVersionRunConfigQueryVariables>;
export function useArtifactVersionRunConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionRunConfigQuery, ArtifactVersionRunConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionRunConfigQuery | undefined, ArtifactVersionRunConfigQueryVariables>;
export function useArtifactVersionRunConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionRunConfigQuery, ArtifactVersionRunConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactVersionRunConfigQuery, ArtifactVersionRunConfigQueryVariables>(ArtifactVersionRunConfigDocument, options);
        }
export type ArtifactVersionRunConfigQueryHookResult = ReturnType<typeof useArtifactVersionRunConfigQuery>;
export type ArtifactVersionRunConfigLazyQueryHookResult = ReturnType<typeof useArtifactVersionRunConfigLazyQuery>;
export type ArtifactVersionRunConfigSuspenseQueryHookResult = ReturnType<typeof useArtifactVersionRunConfigSuspenseQuery>;
export type ArtifactVersionRunConfigQueryResult = ApolloReactCommon.QueryResult<ArtifactVersionRunConfigQuery, ArtifactVersionRunConfigQueryVariables>;
export const ArtifactVersionRunHistoryDocument = gql`
    query ArtifactVersionRunHistory($artifactID: ID!) {
  artifact(id: $artifactID) {
    id
    runHistory
  }
}
    `;

/**
 * __useArtifactVersionRunHistoryQuery__
 *
 * To run a query within a React component, call `useArtifactVersionRunHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactVersionRunHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactVersionRunHistoryQuery({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *   },
 * });
 */
export function useArtifactVersionRunHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactVersionRunHistoryQuery, ArtifactVersionRunHistoryQueryVariables> & ({ variables: ArtifactVersionRunHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactVersionRunHistoryQuery, ArtifactVersionRunHistoryQueryVariables>(ArtifactVersionRunHistoryDocument, options);
      }
export function useArtifactVersionRunHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactVersionRunHistoryQuery, ArtifactVersionRunHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactVersionRunHistoryQuery, ArtifactVersionRunHistoryQueryVariables>(ArtifactVersionRunHistoryDocument, options);
        }
// @ts-ignore
export function useArtifactVersionRunHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionRunHistoryQuery, ArtifactVersionRunHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionRunHistoryQuery, ArtifactVersionRunHistoryQueryVariables>;
export function useArtifactVersionRunHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionRunHistoryQuery, ArtifactVersionRunHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactVersionRunHistoryQuery | undefined, ArtifactVersionRunHistoryQueryVariables>;
export function useArtifactVersionRunHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactVersionRunHistoryQuery, ArtifactVersionRunHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactVersionRunHistoryQuery, ArtifactVersionRunHistoryQueryVariables>(ArtifactVersionRunHistoryDocument, options);
        }
export type ArtifactVersionRunHistoryQueryHookResult = ReturnType<typeof useArtifactVersionRunHistoryQuery>;
export type ArtifactVersionRunHistoryLazyQueryHookResult = ReturnType<typeof useArtifactVersionRunHistoryLazyQuery>;
export type ArtifactVersionRunHistorySuspenseQueryHookResult = ReturnType<typeof useArtifactVersionRunHistorySuspenseQuery>;
export type ArtifactVersionRunHistoryQueryResult = ApolloReactCommon.QueryResult<ArtifactVersionRunHistoryQuery, ArtifactVersionRunHistoryQueryVariables>;
export const TeamsForInvitesDocument = gql`
    query teamsForInvites {
  organization {
    id
    teams {
      id
      name
      memberCount
    }
  }
}
    `;

/**
 * __useTeamsForInvitesQuery__
 *
 * To run a query within a React component, call `useTeamsForInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsForInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsForInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamsForInvitesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>(TeamsForInvitesDocument, options);
      }
export function useTeamsForInvitesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>(TeamsForInvitesDocument, options);
        }
// @ts-ignore
export function useTeamsForInvitesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>;
export function useTeamsForInvitesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamsForInvitesQuery | undefined, TeamsForInvitesQueryVariables>;
export function useTeamsForInvitesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>(TeamsForInvitesDocument, options);
        }
export type TeamsForInvitesQueryHookResult = ReturnType<typeof useTeamsForInvitesQuery>;
export type TeamsForInvitesLazyQueryHookResult = ReturnType<typeof useTeamsForInvitesLazyQuery>;
export type TeamsForInvitesSuspenseQueryHookResult = ReturnType<typeof useTeamsForInvitesSuspenseQuery>;
export type TeamsForInvitesQueryResult = ApolloReactCommon.QueryResult<TeamsForInvitesQuery, TeamsForInvitesQueryVariables>;
export const UpdateSubscriptionDocument = gql`
    mutation updateSubscription($entityName: String!, $teamsEnabled: Boolean, $privateProjects: Boolean, $gpuEnabled: DateTime, $hubPreset: String, $repo: String, $disk: String, $redisEnabled: Boolean, $dockerEnabled: Boolean, $image: String) {
  updateSubscription(
    input: {entityName: $entityName, teamsEnabled: $teamsEnabled, privateProjects: $privateProjects, gpuEnabled: $gpuEnabled, hubPreset: $hubPreset, hubSettings: {repo: $repo, disk: $disk, redisEnabled: $redisEnabled, dockerEnabled: $dockerEnabled, image: $image}}
  ) {
    entity {
      id
      name
      available
      photoUrl
      limits
    }
  }
}
    `;
export type UpdateSubscriptionMutationFn = ApolloReactCommon.MutationFunction<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      teamsEnabled: // value for 'teamsEnabled'
 *      privateProjects: // value for 'privateProjects'
 *      gpuEnabled: // value for 'gpuEnabled'
 *      hubPreset: // value for 'hubPreset'
 *      repo: // value for 'repo'
 *      disk: // value for 'disk'
 *      redisEnabled: // value for 'redisEnabled'
 *      dockerEnabled: // value for 'dockerEnabled'
 *      image: // value for 'image'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(UpdateSubscriptionDocument, options);
      }
export type UpdateSubscriptionMutationHookResult = ReturnType<typeof useUpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationResult = ApolloReactCommon.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const UpdateEntityPhotoDocument = gql`
    mutation updateEntityPhoto($entityName: String!, $photoUrl: String) {
  updateEntity(input: {entity: $entityName, photoUrl: $photoUrl}) {
    entity {
      id
      name
      available
      photoUrl
      limits
    }
  }
}
    `;
export type UpdateEntityPhotoMutationFn = ApolloReactCommon.MutationFunction<UpdateEntityPhotoMutation, UpdateEntityPhotoMutationVariables>;

/**
 * __useUpdateEntityPhotoMutation__
 *
 * To run a mutation, you first call `useUpdateEntityPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityPhotoMutation, { data, loading, error }] = useUpdateEntityPhotoMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      photoUrl: // value for 'photoUrl'
 *   },
 * });
 */
export function useUpdateEntityPhotoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEntityPhotoMutation, UpdateEntityPhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateEntityPhotoMutation, UpdateEntityPhotoMutationVariables>(UpdateEntityPhotoDocument, options);
      }
export type UpdateEntityPhotoMutationHookResult = ReturnType<typeof useUpdateEntityPhotoMutation>;
export type UpdateEntityPhotoMutationResult = ApolloReactCommon.MutationResult<UpdateEntityPhotoMutation>;
export type UpdateEntityPhotoMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEntityPhotoMutation, UpdateEntityPhotoMutationVariables>;
export const TeamQueryDocument = gql`
    query TeamQuery($name: String) {
  entity(name: $name) {
    id
    name
    available
    photoUrl
    limits
    settings {
      openToMatchingOrgEmailDomainUsers
    }
  }
}
    `;

/**
 * __useTeamQueryQuery__
 *
 * To run a query within a React component, call `useTeamQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamQueryQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useTeamQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamQueryQuery, TeamQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamQueryQuery, TeamQueryQueryVariables>(TeamQueryDocument, options);
      }
export function useTeamQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamQueryQuery, TeamQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamQueryQuery, TeamQueryQueryVariables>(TeamQueryDocument, options);
        }
// @ts-ignore
export function useTeamQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamQueryQuery, TeamQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamQueryQuery, TeamQueryQueryVariables>;
export function useTeamQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamQueryQuery, TeamQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamQueryQuery | undefined, TeamQueryQueryVariables>;
export function useTeamQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamQueryQuery, TeamQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamQueryQuery, TeamQueryQueryVariables>(TeamQueryDocument, options);
        }
export type TeamQueryQueryHookResult = ReturnType<typeof useTeamQueryQuery>;
export type TeamQueryLazyQueryHookResult = ReturnType<typeof useTeamQueryLazyQuery>;
export type TeamQuerySuspenseQueryHookResult = ReturnType<typeof useTeamQuerySuspenseQuery>;
export type TeamQueryQueryResult = ApolloReactCommon.QueryResult<TeamQueryQuery, TeamQueryQueryVariables>;
export const UserQueryDocument = gql`
    query UserQuery($userName: String!) {
  user(userName: $userName) {
    id
  }
}
    `;

/**
 * __useUserQueryQuery__
 *
 * To run a query within a React component, call `useUserQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQueryQuery({
 *   variables: {
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useUserQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserQueryQuery, UserQueryQueryVariables> & ({ variables: UserQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserQueryQuery, UserQueryQueryVariables>(UserQueryDocument, options);
      }
export function useUserQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserQueryQuery, UserQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserQueryQuery, UserQueryQueryVariables>(UserQueryDocument, options);
        }
// @ts-ignore
export function useUserQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserQueryQuery, UserQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserQueryQuery, UserQueryQueryVariables>;
export function useUserQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserQueryQuery, UserQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserQueryQuery | undefined, UserQueryQueryVariables>;
export function useUserQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserQueryQuery, UserQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserQueryQuery, UserQueryQueryVariables>(UserQueryDocument, options);
        }
export type UserQueryQueryHookResult = ReturnType<typeof useUserQueryQuery>;
export type UserQueryLazyQueryHookResult = ReturnType<typeof useUserQueryLazyQuery>;
export type UserQuerySuspenseQueryHookResult = ReturnType<typeof useUserQuerySuspenseQuery>;
export type UserQueryQueryResult = ApolloReactCommon.QueryResult<UserQueryQuery, UserQueryQueryVariables>;
export const AllEntitiesDocument = gql`
    query allEntities($first: Int = 2000) {
  entities(first: $first) {
    edges {
      node {
        id
        createdAt
        name
        memberCount
        isTeam
        members {
          admin
          pending
          username
          email
          name
          id
          role
        }
      }
    }
  }
}
    `;

/**
 * __useAllEntitiesQuery__
 *
 * To run a query within a React component, call `useAllEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllEntitiesQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAllEntitiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllEntitiesQuery, AllEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllEntitiesQuery, AllEntitiesQueryVariables>(AllEntitiesDocument, options);
      }
export function useAllEntitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllEntitiesQuery, AllEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllEntitiesQuery, AllEntitiesQueryVariables>(AllEntitiesDocument, options);
        }
// @ts-ignore
export function useAllEntitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllEntitiesQuery, AllEntitiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllEntitiesQuery, AllEntitiesQueryVariables>;
export function useAllEntitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllEntitiesQuery, AllEntitiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllEntitiesQuery | undefined, AllEntitiesQueryVariables>;
export function useAllEntitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllEntitiesQuery, AllEntitiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllEntitiesQuery, AllEntitiesQueryVariables>(AllEntitiesDocument, options);
        }
export type AllEntitiesQueryHookResult = ReturnType<typeof useAllEntitiesQuery>;
export type AllEntitiesLazyQueryHookResult = ReturnType<typeof useAllEntitiesLazyQuery>;
export type AllEntitiesSuspenseQueryHookResult = ReturnType<typeof useAllEntitiesSuspenseQuery>;
export type AllEntitiesQueryResult = ApolloReactCommon.QueryResult<AllEntitiesQuery, AllEntitiesQueryVariables>;
export const UpdateEntityAdminDocument = gql`
    mutation UpdateEntityAdmin($entityName: String!, $isPaid: Boolean, $rateLimits: RateLimitsInput) {
  updateEntity(
    input: {entity: $entityName, isPaid: $isPaid, rateLimits: $rateLimits}
  ) {
    entity {
      id
      isPaid
      ...EntityRateLimits
    }
  }
}
    ${EntityRateLimitsFragmentDoc}`;
export type UpdateEntityAdminMutationFn = ApolloReactCommon.MutationFunction<UpdateEntityAdminMutation, UpdateEntityAdminMutationVariables>;

/**
 * __useUpdateEntityAdminMutation__
 *
 * To run a mutation, you first call `useUpdateEntityAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityAdminMutation, { data, loading, error }] = useUpdateEntityAdminMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      isPaid: // value for 'isPaid'
 *      rateLimits: // value for 'rateLimits'
 *   },
 * });
 */
export function useUpdateEntityAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEntityAdminMutation, UpdateEntityAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateEntityAdminMutation, UpdateEntityAdminMutationVariables>(UpdateEntityAdminDocument, options);
      }
export type UpdateEntityAdminMutationHookResult = ReturnType<typeof useUpdateEntityAdminMutation>;
export type UpdateEntityAdminMutationResult = ApolloReactCommon.MutationResult<UpdateEntityAdminMutation>;
export type UpdateEntityAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEntityAdminMutation, UpdateEntityAdminMutationVariables>;
export const UpdateProjectAdminDocument = gql`
    mutation UpdateProjectAdmin($id: String!, $rateLimits: RateLimitsInput) {
  upsertModel(input: {id: $id, rateLimits: $rateLimits}) {
    project {
      id
      ...ProjectRateLimits
    }
  }
}
    ${ProjectRateLimitsFragmentDoc}`;
export type UpdateProjectAdminMutationFn = ApolloReactCommon.MutationFunction<UpdateProjectAdminMutation, UpdateProjectAdminMutationVariables>;

/**
 * __useUpdateProjectAdminMutation__
 *
 * To run a mutation, you first call `useUpdateProjectAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectAdminMutation, { data, loading, error }] = useUpdateProjectAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      rateLimits: // value for 'rateLimits'
 *   },
 * });
 */
export function useUpdateProjectAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectAdminMutation, UpdateProjectAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectAdminMutation, UpdateProjectAdminMutationVariables>(UpdateProjectAdminDocument, options);
      }
export type UpdateProjectAdminMutationHookResult = ReturnType<typeof useUpdateProjectAdminMutation>;
export type UpdateProjectAdminMutationResult = ApolloReactCommon.MutationResult<UpdateProjectAdminMutation>;
export type UpdateProjectAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProjectAdminMutation, UpdateProjectAdminMutationVariables>;
export const ProjectRateLimitsDocument = gql`
    query ProjectRateLimits($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    ...ProjectRateLimits
  }
}
    ${ProjectRateLimitsFragmentDoc}`;

/**
 * __useProjectRateLimitsQuery__
 *
 * To run a query within a React component, call `useProjectRateLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRateLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectRateLimitsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useProjectRateLimitsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables> & ({ variables: ProjectRateLimitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables>(ProjectRateLimitsDocument, options);
      }
export function useProjectRateLimitsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables>(ProjectRateLimitsDocument, options);
        }
// @ts-ignore
export function useProjectRateLimitsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables>;
export function useProjectRateLimitsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectRateLimitsQuery | undefined, ProjectRateLimitsQueryVariables>;
export function useProjectRateLimitsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables>(ProjectRateLimitsDocument, options);
        }
export type ProjectRateLimitsQueryHookResult = ReturnType<typeof useProjectRateLimitsQuery>;
export type ProjectRateLimitsLazyQueryHookResult = ReturnType<typeof useProjectRateLimitsLazyQuery>;
export type ProjectRateLimitsSuspenseQueryHookResult = ReturnType<typeof useProjectRateLimitsSuspenseQuery>;
export type ProjectRateLimitsQueryResult = ApolloReactCommon.QueryResult<ProjectRateLimitsQuery, ProjectRateLimitsQueryVariables>;
export const TriggerParquetExportDocument = gql`
    mutation triggerParquetExport($runId: ID!) {
  triggerParquetExport(input: {runId: $runId}) {
    task {
      id
    }
  }
}
    `;
export type TriggerParquetExportMutationFn = ApolloReactCommon.MutationFunction<TriggerParquetExportMutation, TriggerParquetExportMutationVariables>;

/**
 * __useTriggerParquetExportMutation__
 *
 * To run a mutation, you first call `useTriggerParquetExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerParquetExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerParquetExportMutation, { data, loading, error }] = useTriggerParquetExportMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useTriggerParquetExportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TriggerParquetExportMutation, TriggerParquetExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TriggerParquetExportMutation, TriggerParquetExportMutationVariables>(TriggerParquetExportDocument, options);
      }
export type TriggerParquetExportMutationHookResult = ReturnType<typeof useTriggerParquetExportMutation>;
export type TriggerParquetExportMutationResult = ApolloReactCommon.MutationResult<TriggerParquetExportMutation>;
export type TriggerParquetExportMutationOptions = ApolloReactCommon.BaseMutationOptions<TriggerParquetExportMutation, TriggerParquetExportMutationVariables>;
export const TriggerRecomputeKeysInfoDocument = gql`
    mutation triggerRecomputeKeysInfo($runId: ID!) {
  triggerRecomputeKeysInfo(input: {runId: $runId}) {
    task {
      id
    }
  }
}
    `;
export type TriggerRecomputeKeysInfoMutationFn = ApolloReactCommon.MutationFunction<TriggerRecomputeKeysInfoMutation, TriggerRecomputeKeysInfoMutationVariables>;

/**
 * __useTriggerRecomputeKeysInfoMutation__
 *
 * To run a mutation, you first call `useTriggerRecomputeKeysInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerRecomputeKeysInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerRecomputeKeysInfoMutation, { data, loading, error }] = useTriggerRecomputeKeysInfoMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useTriggerRecomputeKeysInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TriggerRecomputeKeysInfoMutation, TriggerRecomputeKeysInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TriggerRecomputeKeysInfoMutation, TriggerRecomputeKeysInfoMutationVariables>(TriggerRecomputeKeysInfoDocument, options);
      }
export type TriggerRecomputeKeysInfoMutationHookResult = ReturnType<typeof useTriggerRecomputeKeysInfoMutation>;
export type TriggerRecomputeKeysInfoMutationResult = ApolloReactCommon.MutationResult<TriggerRecomputeKeysInfoMutation>;
export type TriggerRecomputeKeysInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<TriggerRecomputeKeysInfoMutation, TriggerRecomputeKeysInfoMutationVariables>;
export const TriggerRecomputeSystemMetricsDocument = gql`
    mutation triggerRecomputeSystemMetrics($runId: ID!) {
  triggerRecomputeSystemMetrics(input: {runId: $runId}) {
    task {
      id
    }
  }
}
    `;
export type TriggerRecomputeSystemMetricsMutationFn = ApolloReactCommon.MutationFunction<TriggerRecomputeSystemMetricsMutation, TriggerRecomputeSystemMetricsMutationVariables>;

/**
 * __useTriggerRecomputeSystemMetricsMutation__
 *
 * To run a mutation, you first call `useTriggerRecomputeSystemMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerRecomputeSystemMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerRecomputeSystemMetricsMutation, { data, loading, error }] = useTriggerRecomputeSystemMetricsMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useTriggerRecomputeSystemMetricsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TriggerRecomputeSystemMetricsMutation, TriggerRecomputeSystemMetricsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TriggerRecomputeSystemMetricsMutation, TriggerRecomputeSystemMetricsMutationVariables>(TriggerRecomputeSystemMetricsDocument, options);
      }
export type TriggerRecomputeSystemMetricsMutationHookResult = ReturnType<typeof useTriggerRecomputeSystemMetricsMutation>;
export type TriggerRecomputeSystemMetricsMutationResult = ApolloReactCommon.MutationResult<TriggerRecomputeSystemMetricsMutation>;
export type TriggerRecomputeSystemMetricsMutationOptions = ApolloReactCommon.BaseMutationOptions<TriggerRecomputeSystemMetricsMutation, TriggerRecomputeSystemMetricsMutationVariables>;
export const TriggerEventsExportDocument = gql`
    mutation triggerEventsExport($runId: ID!) {
  triggerEventsExport(input: {runId: $runId}) {
    task {
      id
    }
  }
}
    `;
export type TriggerEventsExportMutationFn = ApolloReactCommon.MutationFunction<TriggerEventsExportMutation, TriggerEventsExportMutationVariables>;

/**
 * __useTriggerEventsExportMutation__
 *
 * To run a mutation, you first call `useTriggerEventsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerEventsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerEventsExportMutation, { data, loading, error }] = useTriggerEventsExportMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useTriggerEventsExportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TriggerEventsExportMutation, TriggerEventsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TriggerEventsExportMutation, TriggerEventsExportMutationVariables>(TriggerEventsExportDocument, options);
      }
export type TriggerEventsExportMutationHookResult = ReturnType<typeof useTriggerEventsExportMutation>;
export type TriggerEventsExportMutationResult = ApolloReactCommon.MutationResult<TriggerEventsExportMutation>;
export type TriggerEventsExportMutationOptions = ApolloReactCommon.BaseMutationOptions<TriggerEventsExportMutation, TriggerEventsExportMutationVariables>;
export const TriggerFlatRunsMigratorDocument = gql`
    mutation triggerFlatRunsMigrator($entityName: String, $organizationName: String) {
  triggerFlatRunsMigrator(
    input: {entityName: $entityName, organizationName: $organizationName}
  ) {
    glueTaskName
  }
}
    `;
export type TriggerFlatRunsMigratorMutationFn = ApolloReactCommon.MutationFunction<TriggerFlatRunsMigratorMutation, TriggerFlatRunsMigratorMutationVariables>;

/**
 * __useTriggerFlatRunsMigratorMutation__
 *
 * To run a mutation, you first call `useTriggerFlatRunsMigratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerFlatRunsMigratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerFlatRunsMigratorMutation, { data, loading, error }] = useTriggerFlatRunsMigratorMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      organizationName: // value for 'organizationName'
 *   },
 * });
 */
export function useTriggerFlatRunsMigratorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TriggerFlatRunsMigratorMutation, TriggerFlatRunsMigratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TriggerFlatRunsMigratorMutation, TriggerFlatRunsMigratorMutationVariables>(TriggerFlatRunsMigratorDocument, options);
      }
export type TriggerFlatRunsMigratorMutationHookResult = ReturnType<typeof useTriggerFlatRunsMigratorMutation>;
export type TriggerFlatRunsMigratorMutationResult = ApolloReactCommon.MutationResult<TriggerFlatRunsMigratorMutation>;
export type TriggerFlatRunsMigratorMutationOptions = ApolloReactCommon.BaseMutationOptions<TriggerFlatRunsMigratorMutation, TriggerFlatRunsMigratorMutationVariables>;
export const CreateFinishedRunAlertDocument = gql`
    mutation CreateFinishedRunAlert($entityName: String!) {
  createFinishedRunAlert(input: {entityName: $entityName}) {
    alert {
      id
      condition {
        __typename
        ... on FinishedRunCondition {
          success
        }
      }
      subscriptions {
        id
      }
    }
  }
}
    `;
export type CreateFinishedRunAlertMutationFn = ApolloReactCommon.MutationFunction<CreateFinishedRunAlertMutation, CreateFinishedRunAlertMutationVariables>;

/**
 * __useCreateFinishedRunAlertMutation__
 *
 * To run a mutation, you first call `useCreateFinishedRunAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFinishedRunAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFinishedRunAlertMutation, { data, loading, error }] = useCreateFinishedRunAlertMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useCreateFinishedRunAlertMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFinishedRunAlertMutation, CreateFinishedRunAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateFinishedRunAlertMutation, CreateFinishedRunAlertMutationVariables>(CreateFinishedRunAlertDocument, options);
      }
export type CreateFinishedRunAlertMutationHookResult = ReturnType<typeof useCreateFinishedRunAlertMutation>;
export type CreateFinishedRunAlertMutationResult = ApolloReactCommon.MutationResult<CreateFinishedRunAlertMutation>;
export type CreateFinishedRunAlertMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateFinishedRunAlertMutation, CreateFinishedRunAlertMutationVariables>;
export const CreateStoppedRunAlertDocument = gql`
    mutation CreateStoppedRunAlert($entityName: String!, $minimumRunDuration: Duration!) {
  createStoppedRunAlert(
    input: {entityName: $entityName, minimumRunDuration: $minimumRunDuration}
  ) {
    alert {
      id
      condition {
        __typename
        ... on StoppedRunCondition {
          minimumRunDuration
        }
      }
      subscriptions {
        id
      }
    }
  }
}
    `;
export type CreateStoppedRunAlertMutationFn = ApolloReactCommon.MutationFunction<CreateStoppedRunAlertMutation, CreateStoppedRunAlertMutationVariables>;

/**
 * __useCreateStoppedRunAlertMutation__
 *
 * To run a mutation, you first call `useCreateStoppedRunAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStoppedRunAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStoppedRunAlertMutation, { data, loading, error }] = useCreateStoppedRunAlertMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      minimumRunDuration: // value for 'minimumRunDuration'
 *   },
 * });
 */
export function useCreateStoppedRunAlertMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateStoppedRunAlertMutation, CreateStoppedRunAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateStoppedRunAlertMutation, CreateStoppedRunAlertMutationVariables>(CreateStoppedRunAlertDocument, options);
      }
export type CreateStoppedRunAlertMutationHookResult = ReturnType<typeof useCreateStoppedRunAlertMutation>;
export type CreateStoppedRunAlertMutationResult = ApolloReactCommon.MutationResult<CreateStoppedRunAlertMutation>;
export type CreateStoppedRunAlertMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateStoppedRunAlertMutation, CreateStoppedRunAlertMutationVariables>;
export const UpdateStoppedRunAlertDocument = gql`
    mutation UpdateStoppedRunAlert($id: ID!, $minimumRunDuration: Duration) {
  updateStoppedRunAlert(input: {id: $id, minimumRunDuration: $minimumRunDuration}) {
    alert {
      id
      condition {
        __typename
        ... on StoppedRunCondition {
          minimumRunDuration
        }
      }
      subscriptions {
        id
      }
    }
  }
}
    `;
export type UpdateStoppedRunAlertMutationFn = ApolloReactCommon.MutationFunction<UpdateStoppedRunAlertMutation, UpdateStoppedRunAlertMutationVariables>;

/**
 * __useUpdateStoppedRunAlertMutation__
 *
 * To run a mutation, you first call `useUpdateStoppedRunAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStoppedRunAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStoppedRunAlertMutation, { data, loading, error }] = useUpdateStoppedRunAlertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      minimumRunDuration: // value for 'minimumRunDuration'
 *   },
 * });
 */
export function useUpdateStoppedRunAlertMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStoppedRunAlertMutation, UpdateStoppedRunAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateStoppedRunAlertMutation, UpdateStoppedRunAlertMutationVariables>(UpdateStoppedRunAlertDocument, options);
      }
export type UpdateStoppedRunAlertMutationHookResult = ReturnType<typeof useUpdateStoppedRunAlertMutation>;
export type UpdateStoppedRunAlertMutationResult = ApolloReactCommon.MutationResult<UpdateStoppedRunAlertMutation>;
export type UpdateStoppedRunAlertMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateStoppedRunAlertMutation, UpdateStoppedRunAlertMutationVariables>;
export const CreateScriptableRunAlertDocument = gql`
    mutation CreateScriptableRunAlert($entityName: String!) {
  createScriptableRunAlert(input: {entityName: $entityName}) {
    alert {
      id
      condition {
        __typename
        ... on ScriptableRunCondition {
          success
        }
      }
      subscriptions {
        id
      }
    }
  }
}
    `;
export type CreateScriptableRunAlertMutationFn = ApolloReactCommon.MutationFunction<CreateScriptableRunAlertMutation, CreateScriptableRunAlertMutationVariables>;

/**
 * __useCreateScriptableRunAlertMutation__
 *
 * To run a mutation, you first call `useCreateScriptableRunAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScriptableRunAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScriptableRunAlertMutation, { data, loading, error }] = useCreateScriptableRunAlertMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useCreateScriptableRunAlertMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateScriptableRunAlertMutation, CreateScriptableRunAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateScriptableRunAlertMutation, CreateScriptableRunAlertMutationVariables>(CreateScriptableRunAlertDocument, options);
      }
export type CreateScriptableRunAlertMutationHookResult = ReturnType<typeof useCreateScriptableRunAlertMutation>;
export type CreateScriptableRunAlertMutationResult = ApolloReactCommon.MutationResult<CreateScriptableRunAlertMutation>;
export type CreateScriptableRunAlertMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateScriptableRunAlertMutation, CreateScriptableRunAlertMutationVariables>;
export const DeleteAlertDocument = gql`
    mutation DeleteAlert($id: ID!) {
  deleteAlert(input: {id: $id}) {
    success
  }
}
    `;
export type DeleteAlertMutationFn = ApolloReactCommon.MutationFunction<DeleteAlertMutation, DeleteAlertMutationVariables>;

/**
 * __useDeleteAlertMutation__
 *
 * To run a mutation, you first call `useDeleteAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlertMutation, { data, loading, error }] = useDeleteAlertMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAlertMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAlertMutation, DeleteAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAlertMutation, DeleteAlertMutationVariables>(DeleteAlertDocument, options);
      }
export type DeleteAlertMutationHookResult = ReturnType<typeof useDeleteAlertMutation>;
export type DeleteAlertMutationResult = ApolloReactCommon.MutationResult<DeleteAlertMutation>;
export type DeleteAlertMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAlertMutation, DeleteAlertMutationVariables>;
export const CreateSlackChannelSubscriptionDocument = gql`
    mutation CreateSlackChannelSubscription($alertID: ID!, $integrationID: ID!) {
  createSlackChannelSubscription(
    input: {alertID: $alertID, integrationID: $integrationID}
  ) {
    subscription {
      id
    }
  }
}
    `;
export type CreateSlackChannelSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CreateSlackChannelSubscriptionMutation, CreateSlackChannelSubscriptionMutationVariables>;

/**
 * __useCreateSlackChannelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSlackChannelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSlackChannelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSlackChannelSubscriptionMutation, { data, loading, error }] = useCreateSlackChannelSubscriptionMutation({
 *   variables: {
 *      alertID: // value for 'alertID'
 *      integrationID: // value for 'integrationID'
 *   },
 * });
 */
export function useCreateSlackChannelSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSlackChannelSubscriptionMutation, CreateSlackChannelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSlackChannelSubscriptionMutation, CreateSlackChannelSubscriptionMutationVariables>(CreateSlackChannelSubscriptionDocument, options);
      }
export type CreateSlackChannelSubscriptionMutationHookResult = ReturnType<typeof useCreateSlackChannelSubscriptionMutation>;
export type CreateSlackChannelSubscriptionMutationResult = ApolloReactCommon.MutationResult<CreateSlackChannelSubscriptionMutation>;
export type CreateSlackChannelSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSlackChannelSubscriptionMutation, CreateSlackChannelSubscriptionMutationVariables>;
export const CreateEmailSubscriptionDocument = gql`
    mutation CreateEmailSubscription($alertID: ID!) {
  createEmailSubscription(input: {alertID: $alertID}) {
    subscription {
      id
    }
  }
}
    `;
export type CreateEmailSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CreateEmailSubscriptionMutation, CreateEmailSubscriptionMutationVariables>;

/**
 * __useCreateEmailSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateEmailSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailSubscriptionMutation, { data, loading, error }] = useCreateEmailSubscriptionMutation({
 *   variables: {
 *      alertID: // value for 'alertID'
 *   },
 * });
 */
export function useCreateEmailSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEmailSubscriptionMutation, CreateEmailSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateEmailSubscriptionMutation, CreateEmailSubscriptionMutationVariables>(CreateEmailSubscriptionDocument, options);
      }
export type CreateEmailSubscriptionMutationHookResult = ReturnType<typeof useCreateEmailSubscriptionMutation>;
export type CreateEmailSubscriptionMutationResult = ApolloReactCommon.MutationResult<CreateEmailSubscriptionMutation>;
export type CreateEmailSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateEmailSubscriptionMutation, CreateEmailSubscriptionMutationVariables>;
export const CreateViewCommentsAlertSubscriptionDocument = gql`
    mutation CreateViewCommentsAlertSubscription($viewID: ID!) {
  createViewCommentsAlertSubscription(input: {viewID: $viewID}) {
    subscription {
      id
    }
  }
}
    `;
export type CreateViewCommentsAlertSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CreateViewCommentsAlertSubscriptionMutation, CreateViewCommentsAlertSubscriptionMutationVariables>;

/**
 * __useCreateViewCommentsAlertSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateViewCommentsAlertSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateViewCommentsAlertSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createViewCommentsAlertSubscriptionMutation, { data, loading, error }] = useCreateViewCommentsAlertSubscriptionMutation({
 *   variables: {
 *      viewID: // value for 'viewID'
 *   },
 * });
 */
export function useCreateViewCommentsAlertSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateViewCommentsAlertSubscriptionMutation, CreateViewCommentsAlertSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateViewCommentsAlertSubscriptionMutation, CreateViewCommentsAlertSubscriptionMutationVariables>(CreateViewCommentsAlertSubscriptionDocument, options);
      }
export type CreateViewCommentsAlertSubscriptionMutationHookResult = ReturnType<typeof useCreateViewCommentsAlertSubscriptionMutation>;
export type CreateViewCommentsAlertSubscriptionMutationResult = ApolloReactCommon.MutationResult<CreateViewCommentsAlertSubscriptionMutation>;
export type CreateViewCommentsAlertSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateViewCommentsAlertSubscriptionMutation, CreateViewCommentsAlertSubscriptionMutationVariables>;
export const DeleteAlertSubscriptionDocument = gql`
    mutation DeleteAlertSubscription($id: ID!) {
  deleteAlertSubscription(input: {id: $id}) {
    success
  }
}
    `;
export type DeleteAlertSubscriptionMutationFn = ApolloReactCommon.MutationFunction<DeleteAlertSubscriptionMutation, DeleteAlertSubscriptionMutationVariables>;

/**
 * __useDeleteAlertSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteAlertSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlertSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlertSubscriptionMutation, { data, loading, error }] = useDeleteAlertSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAlertSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAlertSubscriptionMutation, DeleteAlertSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAlertSubscriptionMutation, DeleteAlertSubscriptionMutationVariables>(DeleteAlertSubscriptionDocument, options);
      }
export type DeleteAlertSubscriptionMutationHookResult = ReturnType<typeof useDeleteAlertSubscriptionMutation>;
export type DeleteAlertSubscriptionMutationResult = ApolloReactCommon.MutationResult<DeleteAlertSubscriptionMutation>;
export type DeleteAlertSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAlertSubscriptionMutation, DeleteAlertSubscriptionMutationVariables>;
export const CreateReportsPromptDocument = gql`
    query CreateReportsPrompt($entityName: String, $last: Int) {
  viewer(entityName: $entityName) {
    id
    runs(last: $last, order: "-updated_at") {
      edges {
        node {
          id
          createdAt
          project {
            id
            name
            entityName
          }
          updatedAt
        }
      }
    }
  }
}
    `;

/**
 * __useCreateReportsPromptQuery__
 *
 * To run a query within a React component, call `useCreateReportsPromptQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateReportsPromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateReportsPromptQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useCreateReportsPromptQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>(CreateReportsPromptDocument, options);
      }
export function useCreateReportsPromptLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>(CreateReportsPromptDocument, options);
        }
// @ts-ignore
export function useCreateReportsPromptSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>;
export function useCreateReportsPromptSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateReportsPromptQuery | undefined, CreateReportsPromptQueryVariables>;
export function useCreateReportsPromptSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>(CreateReportsPromptDocument, options);
        }
export type CreateReportsPromptQueryHookResult = ReturnType<typeof useCreateReportsPromptQuery>;
export type CreateReportsPromptLazyQueryHookResult = ReturnType<typeof useCreateReportsPromptLazyQuery>;
export type CreateReportsPromptSuspenseQueryHookResult = ReturnType<typeof useCreateReportsPromptSuspenseQuery>;
export type CreateReportsPromptQueryResult = ApolloReactCommon.QueryResult<CreateReportsPromptQuery, CreateReportsPromptQueryVariables>;
export const CreateCustomChartDocument = gql`
    mutation CreateCustomChart($entity: String!, $name: String!, $displayName: String!, $type: String!, $access: String!, $spec: JSONString!) {
  createCustomChart(
    input: {entity: $entity, name: $name, displayName: $displayName, type: $type, access: $access, spec: $spec}
  ) {
    chart {
      id
      ...CustomChartFragment
    }
  }
}
    ${CustomChartFragmentFragmentDoc}`;
export type CreateCustomChartMutationFn = ApolloReactCommon.MutationFunction<CreateCustomChartMutation, CreateCustomChartMutationVariables>;

/**
 * __useCreateCustomChartMutation__
 *
 * To run a mutation, you first call `useCreateCustomChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomChartMutation, { data, loading, error }] = useCreateCustomChartMutation({
 *   variables: {
 *      entity: // value for 'entity'
 *      name: // value for 'name'
 *      displayName: // value for 'displayName'
 *      type: // value for 'type'
 *      access: // value for 'access'
 *      spec: // value for 'spec'
 *   },
 * });
 */
export function useCreateCustomChartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCustomChartMutation, CreateCustomChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCustomChartMutation, CreateCustomChartMutationVariables>(CreateCustomChartDocument, options);
      }
export type CreateCustomChartMutationHookResult = ReturnType<typeof useCreateCustomChartMutation>;
export type CreateCustomChartMutationResult = ApolloReactCommon.MutationResult<CreateCustomChartMutation>;
export type CreateCustomChartMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCustomChartMutation, CreateCustomChartMutationVariables>;
export const UpdateCustomChartDocument = gql`
    mutation UpdateCustomChart($entity: String!, $name: String!, $displayName: String, $type: String, $access: String, $spec: JSONString) {
  updateCustomChart(
    input: {entity: $entity, name: $name, displayName: $displayName, type: $type, access: $access, spec: $spec}
  ) {
    chart {
      id
      ...CustomChartFragment
    }
  }
}
    ${CustomChartFragmentFragmentDoc}`;
export type UpdateCustomChartMutationFn = ApolloReactCommon.MutationFunction<UpdateCustomChartMutation, UpdateCustomChartMutationVariables>;

/**
 * __useUpdateCustomChartMutation__
 *
 * To run a mutation, you first call `useUpdateCustomChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomChartMutation, { data, loading, error }] = useUpdateCustomChartMutation({
 *   variables: {
 *      entity: // value for 'entity'
 *      name: // value for 'name'
 *      displayName: // value for 'displayName'
 *      type: // value for 'type'
 *      access: // value for 'access'
 *      spec: // value for 'spec'
 *   },
 * });
 */
export function useUpdateCustomChartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCustomChartMutation, UpdateCustomChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCustomChartMutation, UpdateCustomChartMutationVariables>(UpdateCustomChartDocument, options);
      }
export type UpdateCustomChartMutationHookResult = ReturnType<typeof useUpdateCustomChartMutation>;
export type UpdateCustomChartMutationResult = ApolloReactCommon.MutationResult<UpdateCustomChartMutation>;
export type UpdateCustomChartMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCustomChartMutation, UpdateCustomChartMutationVariables>;
export const DeleteCustomChartDocument = gql`
    mutation DeleteCustomChart($entity: String!, $name: String!) {
  deleteCustomChart(input: {entity: $entity, name: $name}) {
    success
  }
}
    `;
export type DeleteCustomChartMutationFn = ApolloReactCommon.MutationFunction<DeleteCustomChartMutation, DeleteCustomChartMutationVariables>;

/**
 * __useDeleteCustomChartMutation__
 *
 * To run a mutation, you first call `useDeleteCustomChartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomChartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomChartMutation, { data, loading, error }] = useDeleteCustomChartMutation({
 *   variables: {
 *      entity: // value for 'entity'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteCustomChartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCustomChartMutation, DeleteCustomChartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCustomChartMutation, DeleteCustomChartMutationVariables>(DeleteCustomChartDocument, options);
      }
export type DeleteCustomChartMutationHookResult = ReturnType<typeof useDeleteCustomChartMutation>;
export type DeleteCustomChartMutationResult = ApolloReactCommon.MutationResult<DeleteCustomChartMutation>;
export type DeleteCustomChartMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteCustomChartMutation, DeleteCustomChartMutationVariables>;
export const CustomChartsDocument = gql`
    query CustomCharts($entity: String!) {
  customCharts(type: "vega2", entity: $entity) {
    edges {
      node {
        id
        ...CustomChartFragment
      }
    }
  }
}
    ${CustomChartFragmentFragmentDoc}`;

/**
 * __useCustomChartsQuery__
 *
 * To run a query within a React component, call `useCustomChartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomChartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomChartsQuery({
 *   variables: {
 *      entity: // value for 'entity'
 *   },
 * });
 */
export function useCustomChartsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CustomChartsQuery, CustomChartsQueryVariables> & ({ variables: CustomChartsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CustomChartsQuery, CustomChartsQueryVariables>(CustomChartsDocument, options);
      }
export function useCustomChartsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CustomChartsQuery, CustomChartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CustomChartsQuery, CustomChartsQueryVariables>(CustomChartsDocument, options);
        }
// @ts-ignore
export function useCustomChartsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CustomChartsQuery, CustomChartsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CustomChartsQuery, CustomChartsQueryVariables>;
export function useCustomChartsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CustomChartsQuery, CustomChartsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CustomChartsQuery | undefined, CustomChartsQueryVariables>;
export function useCustomChartsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CustomChartsQuery, CustomChartsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CustomChartsQuery, CustomChartsQueryVariables>(CustomChartsDocument, options);
        }
export type CustomChartsQueryHookResult = ReturnType<typeof useCustomChartsQuery>;
export type CustomChartsLazyQueryHookResult = ReturnType<typeof useCustomChartsLazyQuery>;
export type CustomChartsSuspenseQueryHookResult = ReturnType<typeof useCustomChartsSuspenseQuery>;
export type CustomChartsQueryResult = ApolloReactCommon.QueryResult<CustomChartsQuery, CustomChartsQueryVariables>;
export const CustomChartDocument = gql`
    query CustomChart($id: ID!) {
  customChart(id: $id) {
    id
    ...CustomChartFragment
  }
}
    ${CustomChartFragmentFragmentDoc}`;

/**
 * __useCustomChartQuery__
 *
 * To run a query within a React component, call `useCustomChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomChartQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomChartQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CustomChartQuery, CustomChartQueryVariables> & ({ variables: CustomChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CustomChartQuery, CustomChartQueryVariables>(CustomChartDocument, options);
      }
export function useCustomChartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CustomChartQuery, CustomChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CustomChartQuery, CustomChartQueryVariables>(CustomChartDocument, options);
        }
// @ts-ignore
export function useCustomChartSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CustomChartQuery, CustomChartQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CustomChartQuery, CustomChartQueryVariables>;
export function useCustomChartSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CustomChartQuery, CustomChartQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CustomChartQuery | undefined, CustomChartQueryVariables>;
export function useCustomChartSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CustomChartQuery, CustomChartQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CustomChartQuery, CustomChartQueryVariables>(CustomChartDocument, options);
        }
export type CustomChartQueryHookResult = ReturnType<typeof useCustomChartQuery>;
export type CustomChartLazyQueryHookResult = ReturnType<typeof useCustomChartLazyQuery>;
export type CustomChartSuspenseQueryHookResult = ReturnType<typeof useCustomChartSuspenseQuery>;
export type CustomChartQueryResult = ApolloReactCommon.QueryResult<CustomChartQuery, CustomChartQueryVariables>;
export const CreateCustomerSubscriptionDocument = gql`
    mutation createCustomerSubscription($planId: ID!, $newOrganizationName: String!, $paymentMethod: String!, $quantity: Int!, $trial: Boolean!, $clientMutationId: String) {
  createCustomerSubscription(
    input: {planId: $planId, newOrganizationName: $newOrganizationName, paymentMethod: $paymentMethod, quantity: $quantity, trial: $trial, clientMutationId: $clientMutationId}
  ) {
    subscription
    organizationId
    clientMutationId
  }
}
    `;
export type CreateCustomerSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CreateCustomerSubscriptionMutation, CreateCustomerSubscriptionMutationVariables>;

/**
 * __useCreateCustomerSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateCustomerSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerSubscriptionMutation, { data, loading, error }] = useCreateCustomerSubscriptionMutation({
 *   variables: {
 *      planId: // value for 'planId'
 *      newOrganizationName: // value for 'newOrganizationName'
 *      paymentMethod: // value for 'paymentMethod'
 *      quantity: // value for 'quantity'
 *      trial: // value for 'trial'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCreateCustomerSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCustomerSubscriptionMutation, CreateCustomerSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCustomerSubscriptionMutation, CreateCustomerSubscriptionMutationVariables>(CreateCustomerSubscriptionDocument, options);
      }
export type CreateCustomerSubscriptionMutationHookResult = ReturnType<typeof useCreateCustomerSubscriptionMutation>;
export type CreateCustomerSubscriptionMutationResult = ApolloReactCommon.MutationResult<CreateCustomerSubscriptionMutation>;
export type CreateCustomerSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCustomerSubscriptionMutation, CreateCustomerSubscriptionMutationVariables>;
export const CreateAcademicOrReverseTrialDocument = gql`
    mutation createAcademicOrReverseTrial($newOrganizationName: String!, $newTeamName: String!, $isAcademic: Boolean!, $clientMutationId: String) {
  createAcademicOrReverseTrial(
    input: {newOrganizationName: $newOrganizationName, newTeamName: $newTeamName, isAcademic: $isAcademic, clientMutationId: $clientMutationId}
  ) {
    clientMutationId
    orgID
  }
}
    `;
export type CreateAcademicOrReverseTrialMutationFn = ApolloReactCommon.MutationFunction<CreateAcademicOrReverseTrialMutation, CreateAcademicOrReverseTrialMutationVariables>;

/**
 * __useCreateAcademicOrReverseTrialMutation__
 *
 * To run a mutation, you first call `useCreateAcademicOrReverseTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAcademicOrReverseTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAcademicOrReverseTrialMutation, { data, loading, error }] = useCreateAcademicOrReverseTrialMutation({
 *   variables: {
 *      newOrganizationName: // value for 'newOrganizationName'
 *      newTeamName: // value for 'newTeamName'
 *      isAcademic: // value for 'isAcademic'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCreateAcademicOrReverseTrialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAcademicOrReverseTrialMutation, CreateAcademicOrReverseTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAcademicOrReverseTrialMutation, CreateAcademicOrReverseTrialMutationVariables>(CreateAcademicOrReverseTrialDocument, options);
      }
export type CreateAcademicOrReverseTrialMutationHookResult = ReturnType<typeof useCreateAcademicOrReverseTrialMutation>;
export type CreateAcademicOrReverseTrialMutationResult = ApolloReactCommon.MutationResult<CreateAcademicOrReverseTrialMutation>;
export type CreateAcademicOrReverseTrialMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAcademicOrReverseTrialMutation, CreateAcademicOrReverseTrialMutationVariables>;
export const CreateCustomerTrialDocument = gql`
    mutation createCustomerTrial($planId: ID!, $userName: String!, $newOrganizationName: String!, $quantity: Int!, $trialDays: Int!, $clientMutationId: String) {
  createCustomerTrial(
    input: {planId: $planId, userName: $userName, newOrganizationName: $newOrganizationName, quantity: $quantity, trialDays: $trialDays, clientMutationId: $clientMutationId}
  ) {
    subscription
    clientMutationId
  }
}
    `;
export type CreateCustomerTrialMutationFn = ApolloReactCommon.MutationFunction<CreateCustomerTrialMutation, CreateCustomerTrialMutationVariables>;

/**
 * __useCreateCustomerTrialMutation__
 *
 * To run a mutation, you first call `useCreateCustomerTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerTrialMutation, { data, loading, error }] = useCreateCustomerTrialMutation({
 *   variables: {
 *      planId: // value for 'planId'
 *      userName: // value for 'userName'
 *      newOrganizationName: // value for 'newOrganizationName'
 *      quantity: // value for 'quantity'
 *      trialDays: // value for 'trialDays'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCreateCustomerTrialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCustomerTrialMutation, CreateCustomerTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCustomerTrialMutation, CreateCustomerTrialMutationVariables>(CreateCustomerTrialDocument, options);
      }
export type CreateCustomerTrialMutationHookResult = ReturnType<typeof useCreateCustomerTrialMutation>;
export type CreateCustomerTrialMutationResult = ApolloReactCommon.MutationResult<CreateCustomerTrialMutation>;
export type CreateCustomerTrialMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCustomerTrialMutation, CreateCustomerTrialMutationVariables>;
export const CancelCustomerSubscriptionDocument = gql`
    mutation cancelCustomerSubscription($organizationId: ID!, $cancellationReason: String, $cancellationComments: String, $clientMutationId: String) {
  cancelCustomerSubscription(
    input: {organizationId: $organizationId, cancellationReason: $cancellationReason, cancellationComments: $cancellationComments, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type CancelCustomerSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CancelCustomerSubscriptionMutation, CancelCustomerSubscriptionMutationVariables>;

/**
 * __useCancelCustomerSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelCustomerSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCustomerSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCustomerSubscriptionMutation, { data, loading, error }] = useCancelCustomerSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      cancellationReason: // value for 'cancellationReason'
 *      cancellationComments: // value for 'cancellationComments'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCancelCustomerSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelCustomerSubscriptionMutation, CancelCustomerSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelCustomerSubscriptionMutation, CancelCustomerSubscriptionMutationVariables>(CancelCustomerSubscriptionDocument, options);
      }
export type CancelCustomerSubscriptionMutationHookResult = ReturnType<typeof useCancelCustomerSubscriptionMutation>;
export type CancelCustomerSubscriptionMutationResult = ApolloReactCommon.MutationResult<CancelCustomerSubscriptionMutation>;
export type CancelCustomerSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CancelCustomerSubscriptionMutation, CancelCustomerSubscriptionMutationVariables>;
export const CancelPaygoSubscriptionsDocument = gql`
    mutation cancelPaygoSubscriptions($organizationId: ID!, $clientMutationId: String) {
  cancelPaygoSubscriptions(
    input: {organizationId: $organizationId, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type CancelPaygoSubscriptionsMutationFn = ApolloReactCommon.MutationFunction<CancelPaygoSubscriptionsMutation, CancelPaygoSubscriptionsMutationVariables>;

/**
 * __useCancelPaygoSubscriptionsMutation__
 *
 * To run a mutation, you first call `useCancelPaygoSubscriptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPaygoSubscriptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPaygoSubscriptionsMutation, { data, loading, error }] = useCancelPaygoSubscriptionsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCancelPaygoSubscriptionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelPaygoSubscriptionsMutation, CancelPaygoSubscriptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelPaygoSubscriptionsMutation, CancelPaygoSubscriptionsMutationVariables>(CancelPaygoSubscriptionsDocument, options);
      }
export type CancelPaygoSubscriptionsMutationHookResult = ReturnType<typeof useCancelPaygoSubscriptionsMutation>;
export type CancelPaygoSubscriptionsMutationResult = ApolloReactCommon.MutationResult<CancelPaygoSubscriptionsMutation>;
export type CancelPaygoSubscriptionsMutationOptions = ApolloReactCommon.BaseMutationOptions<CancelPaygoSubscriptionsMutation, CancelPaygoSubscriptionsMutationVariables>;
export const ResumePaygoSubscriptionsDocument = gql`
    mutation resumePaygoSubscriptions($organizationId: ID!, $clientMutationId: String) {
  resumePaygoSubscriptions(
    input: {organizationId: $organizationId, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type ResumePaygoSubscriptionsMutationFn = ApolloReactCommon.MutationFunction<ResumePaygoSubscriptionsMutation, ResumePaygoSubscriptionsMutationVariables>;

/**
 * __useResumePaygoSubscriptionsMutation__
 *
 * To run a mutation, you first call `useResumePaygoSubscriptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumePaygoSubscriptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumePaygoSubscriptionsMutation, { data, loading, error }] = useResumePaygoSubscriptionsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useResumePaygoSubscriptionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResumePaygoSubscriptionsMutation, ResumePaygoSubscriptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResumePaygoSubscriptionsMutation, ResumePaygoSubscriptionsMutationVariables>(ResumePaygoSubscriptionsDocument, options);
      }
export type ResumePaygoSubscriptionsMutationHookResult = ReturnType<typeof useResumePaygoSubscriptionsMutation>;
export type ResumePaygoSubscriptionsMutationResult = ApolloReactCommon.MutationResult<ResumePaygoSubscriptionsMutation>;
export type ResumePaygoSubscriptionsMutationOptions = ApolloReactCommon.BaseMutationOptions<ResumePaygoSubscriptionsMutation, ResumePaygoSubscriptionsMutationVariables>;
export const ReactivateCustomerSubscriptionDocument = gql`
    mutation reactivateCustomerSubscription($organizationId: ID!, $clientMutationId: String) {
  reactivateCustomerSubscription(
    input: {organizationId: $organizationId, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type ReactivateCustomerSubscriptionMutationFn = ApolloReactCommon.MutationFunction<ReactivateCustomerSubscriptionMutation, ReactivateCustomerSubscriptionMutationVariables>;

/**
 * __useReactivateCustomerSubscriptionMutation__
 *
 * To run a mutation, you first call `useReactivateCustomerSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateCustomerSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateCustomerSubscriptionMutation, { data, loading, error }] = useReactivateCustomerSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useReactivateCustomerSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReactivateCustomerSubscriptionMutation, ReactivateCustomerSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReactivateCustomerSubscriptionMutation, ReactivateCustomerSubscriptionMutationVariables>(ReactivateCustomerSubscriptionDocument, options);
      }
export type ReactivateCustomerSubscriptionMutationHookResult = ReturnType<typeof useReactivateCustomerSubscriptionMutation>;
export type ReactivateCustomerSubscriptionMutationResult = ApolloReactCommon.MutationResult<ReactivateCustomerSubscriptionMutation>;
export type ReactivateCustomerSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<ReactivateCustomerSubscriptionMutation, ReactivateCustomerSubscriptionMutationVariables>;
export const UpdateCustomerPaymentMethodDocument = gql`
    mutation updateCustomerPaymentMethod($organizationId: ID!, $paymentMethod: String!, $clientMutationId: String) {
  updateCustomerPaymentMethod(
    input: {organizationId: $organizationId, paymentMethod: $paymentMethod, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateCustomerPaymentMethodMutationFn = ApolloReactCommon.MutationFunction<UpdateCustomerPaymentMethodMutation, UpdateCustomerPaymentMethodMutationVariables>;

/**
 * __useUpdateCustomerPaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerPaymentMethodMutation, { data, loading, error }] = useUpdateCustomerPaymentMethodMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      paymentMethod: // value for 'paymentMethod'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateCustomerPaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCustomerPaymentMethodMutation, UpdateCustomerPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCustomerPaymentMethodMutation, UpdateCustomerPaymentMethodMutationVariables>(UpdateCustomerPaymentMethodDocument, options);
      }
export type UpdateCustomerPaymentMethodMutationHookResult = ReturnType<typeof useUpdateCustomerPaymentMethodMutation>;
export type UpdateCustomerPaymentMethodMutationResult = ApolloReactCommon.MutationResult<UpdateCustomerPaymentMethodMutation>;
export type UpdateCustomerPaymentMethodMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCustomerPaymentMethodMutation, UpdateCustomerPaymentMethodMutationVariables>;
export const AttachCustomerPaymentMethodDocument = gql`
    mutation attachCustomerPaymentMethod($organizationId: ID!, $paymentMethod: String!, $clientMutationId: String) {
  attachCustomerPaymentMethod(
    input: {organizationId: $organizationId, paymentMethod: $paymentMethod, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type AttachCustomerPaymentMethodMutationFn = ApolloReactCommon.MutationFunction<AttachCustomerPaymentMethodMutation, AttachCustomerPaymentMethodMutationVariables>;

/**
 * __useAttachCustomerPaymentMethodMutation__
 *
 * To run a mutation, you first call `useAttachCustomerPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachCustomerPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachCustomerPaymentMethodMutation, { data, loading, error }] = useAttachCustomerPaymentMethodMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      paymentMethod: // value for 'paymentMethod'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useAttachCustomerPaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AttachCustomerPaymentMethodMutation, AttachCustomerPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AttachCustomerPaymentMethodMutation, AttachCustomerPaymentMethodMutationVariables>(AttachCustomerPaymentMethodDocument, options);
      }
export type AttachCustomerPaymentMethodMutationHookResult = ReturnType<typeof useAttachCustomerPaymentMethodMutation>;
export type AttachCustomerPaymentMethodMutationResult = ApolloReactCommon.MutationResult<AttachCustomerPaymentMethodMutation>;
export type AttachCustomerPaymentMethodMutationOptions = ApolloReactCommon.BaseMutationOptions<AttachCustomerPaymentMethodMutation, AttachCustomerPaymentMethodMutationVariables>;
export const UpdateCustomerDefaultPaymentMethodDocument = gql`
    mutation updateCustomerDefaultPaymentMethod($organizationId: ID!, $paymentMethod: String!, $clientMutationId: String) {
  updateCustomerDefaultPaymentMethod(
    input: {organizationId: $organizationId, paymentMethod: $paymentMethod, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateCustomerDefaultPaymentMethodMutationFn = ApolloReactCommon.MutationFunction<UpdateCustomerDefaultPaymentMethodMutation, UpdateCustomerDefaultPaymentMethodMutationVariables>;

/**
 * __useUpdateCustomerDefaultPaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerDefaultPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerDefaultPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerDefaultPaymentMethodMutation, { data, loading, error }] = useUpdateCustomerDefaultPaymentMethodMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      paymentMethod: // value for 'paymentMethod'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateCustomerDefaultPaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCustomerDefaultPaymentMethodMutation, UpdateCustomerDefaultPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCustomerDefaultPaymentMethodMutation, UpdateCustomerDefaultPaymentMethodMutationVariables>(UpdateCustomerDefaultPaymentMethodDocument, options);
      }
export type UpdateCustomerDefaultPaymentMethodMutationHookResult = ReturnType<typeof useUpdateCustomerDefaultPaymentMethodMutation>;
export type UpdateCustomerDefaultPaymentMethodMutationResult = ApolloReactCommon.MutationResult<UpdateCustomerDefaultPaymentMethodMutation>;
export type UpdateCustomerDefaultPaymentMethodMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCustomerDefaultPaymentMethodMutation, UpdateCustomerDefaultPaymentMethodMutationVariables>;
export const DetachCustomerPaymentMethodDocument = gql`
    mutation detachCustomerPaymentMethod($organizationId: ID!, $paymentMethod: String!, $clientMutationId: String) {
  detachCustomerPaymentMethod(
    input: {organizationId: $organizationId, paymentMethod: $paymentMethod, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type DetachCustomerPaymentMethodMutationFn = ApolloReactCommon.MutationFunction<DetachCustomerPaymentMethodMutation, DetachCustomerPaymentMethodMutationVariables>;

/**
 * __useDetachCustomerPaymentMethodMutation__
 *
 * To run a mutation, you first call `useDetachCustomerPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachCustomerPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachCustomerPaymentMethodMutation, { data, loading, error }] = useDetachCustomerPaymentMethodMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      paymentMethod: // value for 'paymentMethod'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useDetachCustomerPaymentMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DetachCustomerPaymentMethodMutation, DetachCustomerPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DetachCustomerPaymentMethodMutation, DetachCustomerPaymentMethodMutationVariables>(DetachCustomerPaymentMethodDocument, options);
      }
export type DetachCustomerPaymentMethodMutationHookResult = ReturnType<typeof useDetachCustomerPaymentMethodMutation>;
export type DetachCustomerPaymentMethodMutationResult = ApolloReactCommon.MutationResult<DetachCustomerPaymentMethodMutation>;
export type DetachCustomerPaymentMethodMutationOptions = ApolloReactCommon.BaseMutationOptions<DetachCustomerPaymentMethodMutation, DetachCustomerPaymentMethodMutationVariables>;
export const RetryStripeOpenInvoicesByOrganizationDocument = gql`
    mutation retryStripeOpenInvoicesByOrganization($organizationId: ID!) {
  retryStripeOpenInvoicesByOrganization(input: {organizationId: $organizationId}) {
    success
    clientMutationId
  }
}
    `;
export type RetryStripeOpenInvoicesByOrganizationMutationFn = ApolloReactCommon.MutationFunction<RetryStripeOpenInvoicesByOrganizationMutation, RetryStripeOpenInvoicesByOrganizationMutationVariables>;

/**
 * __useRetryStripeOpenInvoicesByOrganizationMutation__
 *
 * To run a mutation, you first call `useRetryStripeOpenInvoicesByOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryStripeOpenInvoicesByOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryStripeOpenInvoicesByOrganizationMutation, { data, loading, error }] = useRetryStripeOpenInvoicesByOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useRetryStripeOpenInvoicesByOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RetryStripeOpenInvoicesByOrganizationMutation, RetryStripeOpenInvoicesByOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RetryStripeOpenInvoicesByOrganizationMutation, RetryStripeOpenInvoicesByOrganizationMutationVariables>(RetryStripeOpenInvoicesByOrganizationDocument, options);
      }
export type RetryStripeOpenInvoicesByOrganizationMutationHookResult = ReturnType<typeof useRetryStripeOpenInvoicesByOrganizationMutation>;
export type RetryStripeOpenInvoicesByOrganizationMutationResult = ApolloReactCommon.MutationResult<RetryStripeOpenInvoicesByOrganizationMutation>;
export type RetryStripeOpenInvoicesByOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<RetryStripeOpenInvoicesByOrganizationMutation, RetryStripeOpenInvoicesByOrganizationMutationVariables>;
export const CustomerSubscriptionInfoDocument = gql`
    query CustomerSubscriptionInfo {
  viewer {
    id
    organizations {
      id
      name
      orgType
      usedSeats
      stripeBillingInfo {
        status
        cancelAtPeriodEnd
        currentPeriodEnd
        invoiceLink
        paymentMethod {
          id
          type
          cardType
          endingIn
        }
      }
      billingUser {
        id
        username
      }
      subscriptions {
        id
        plan {
          id
          name
          displayName
          unitPrice
          billingInterval
          planType
        }
        privileges
        seats
        expiresAt
        subscriptionType
        status
        billingPeriodStart
        billingPeriodEnd
      }
      teams {
        id
        name
        storageBytes
        referenceBytes
        computeHours
      }
      members {
        orgID
        id
        username
        name
        photoUrl
        admin
        teams {
          edges {
            node {
              id
              name
            }
          }
        }
        role
      }
      pendingInvites {
        id
        email
      }
    }
  }
}
    `;

/**
 * __useCustomerSubscriptionInfoQuery__
 *
 * To run a query within a React component, call `useCustomerSubscriptionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSubscriptionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSubscriptionInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerSubscriptionInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>(CustomerSubscriptionInfoDocument, options);
      }
export function useCustomerSubscriptionInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>(CustomerSubscriptionInfoDocument, options);
        }
// @ts-ignore
export function useCustomerSubscriptionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>;
export function useCustomerSubscriptionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CustomerSubscriptionInfoQuery | undefined, CustomerSubscriptionInfoQueryVariables>;
export function useCustomerSubscriptionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>(CustomerSubscriptionInfoDocument, options);
        }
export type CustomerSubscriptionInfoQueryHookResult = ReturnType<typeof useCustomerSubscriptionInfoQuery>;
export type CustomerSubscriptionInfoLazyQueryHookResult = ReturnType<typeof useCustomerSubscriptionInfoLazyQuery>;
export type CustomerSubscriptionInfoSuspenseQueryHookResult = ReturnType<typeof useCustomerSubscriptionInfoSuspenseQuery>;
export type CustomerSubscriptionInfoQueryResult = ApolloReactCommon.QueryResult<CustomerSubscriptionInfoQuery, CustomerSubscriptionInfoQueryVariables>;
export const OrganizationSubscriptionInfoDocument = gql`
    query OrganizationSubscriptionInfo($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    name
    orgType
    flags
    usedSeats
    usedViewOnlySeats
    createdAt
    seatAvailability {
      seats
      viewOnlySeats
    }
    stripeBillingInfo {
      status
      cancelAtPeriodEnd
      currentPeriodEnd
      invoiceLink
      paymentMethod {
        id
        type
        cardType
        endingIn
      }
      paymentMetadata {
        shouldUpgradeToTeams
      }
    }
    stripePaymentMethods {
      stripePaymentMethodID
      type
      isDefault
      isFailed
      card {
        last4
        brand
      }
    }
    stripeInvoices {
      number
      created
      total
      status
      currency
      hostedInvoiceURL
      invoicePDF
      subscription {
        status
        organizationSubscriptions {
          id
          plan {
            id
            displayName
          }
        }
      }
    }
    billingUser {
      id
      username
      name
      email
      photoUrl
    }
    stripeCustomerId
    teams {
      id
      name
      memberCount
      photoUrl
    }
    subscriptions {
      id
      plan {
        id
        name
        unitPrice
        billingInterval
        planType
        maxSeats
        displayName
        defaultPrivileges
        stripePrice {
          amount
        }
      }
      privileges
      seats
      expiresAt
      subscriptionType
      status
      nextPlans {
        id
        name
        displayName
        billingInterval
        defaultPrivileges
        stripePrice {
          amount
        }
      }
      availableSeatsToPurchase
      isAutomaticUpgrade
      thresholdCrossedAt
      upgradedAt
      billingPeriodStart
      billingPeriodEnd
      cancelAtPeriodEnd
    }
    members {
      orgID
      id
      username
      name
      photoUrl
      admin
      email
      user {
        id
        loggedInAt
      }
      teams {
        edges {
          node {
            id
            name
          }
        }
      }
      role
      modelsSeat
      weaveRole
    }
    pendingInvites {
      id
      email
      entity {
        id
        name
      }
      role
      createdAt
    }
  }
}
    `;

/**
 * __useOrganizationSubscriptionInfoQuery__
 *
 * To run a query within a React component, call `useOrganizationSubscriptionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSubscriptionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSubscriptionInfoQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationSubscriptionInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables> & ({ variables: OrganizationSubscriptionInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables>(OrganizationSubscriptionInfoDocument, options);
      }
export function useOrganizationSubscriptionInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables>(OrganizationSubscriptionInfoDocument, options);
        }
// @ts-ignore
export function useOrganizationSubscriptionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables>;
export function useOrganizationSubscriptionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionInfoQuery | undefined, OrganizationSubscriptionInfoQueryVariables>;
export function useOrganizationSubscriptionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables>(OrganizationSubscriptionInfoDocument, options);
        }
export type OrganizationSubscriptionInfoQueryHookResult = ReturnType<typeof useOrganizationSubscriptionInfoQuery>;
export type OrganizationSubscriptionInfoLazyQueryHookResult = ReturnType<typeof useOrganizationSubscriptionInfoLazyQuery>;
export type OrganizationSubscriptionInfoSuspenseQueryHookResult = ReturnType<typeof useOrganizationSubscriptionInfoSuspenseQuery>;
export type OrganizationSubscriptionInfoQueryResult = ApolloReactCommon.QueryResult<OrganizationSubscriptionInfoQuery, OrganizationSubscriptionInfoQueryVariables>;
export const UpgradeCustomerSubscriptionDocument = gql`
    mutation upgradeCustomerSubscription($planID: ID!, $organizationID: ID!, $paymentMethod: String!, $quantity: Int!, $clientMutationId: String) {
  upgradeCustomerSubscription(
    input: {planID: $planID, organizationID: $organizationID, paymentMethod: $paymentMethod, quantity: $quantity, clientMutationId: $clientMutationId}
  ) {
    subscription
    organizationID
    clientMutationId
  }
}
    `;
export type UpgradeCustomerSubscriptionMutationFn = ApolloReactCommon.MutationFunction<UpgradeCustomerSubscriptionMutation, UpgradeCustomerSubscriptionMutationVariables>;

/**
 * __useUpgradeCustomerSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpgradeCustomerSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeCustomerSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeCustomerSubscriptionMutation, { data, loading, error }] = useUpgradeCustomerSubscriptionMutation({
 *   variables: {
 *      planID: // value for 'planID'
 *      organizationID: // value for 'organizationID'
 *      paymentMethod: // value for 'paymentMethod'
 *      quantity: // value for 'quantity'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpgradeCustomerSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpgradeCustomerSubscriptionMutation, UpgradeCustomerSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpgradeCustomerSubscriptionMutation, UpgradeCustomerSubscriptionMutationVariables>(UpgradeCustomerSubscriptionDocument, options);
      }
export type UpgradeCustomerSubscriptionMutationHookResult = ReturnType<typeof useUpgradeCustomerSubscriptionMutation>;
export type UpgradeCustomerSubscriptionMutationResult = ApolloReactCommon.MutationResult<UpgradeCustomerSubscriptionMutation>;
export type UpgradeCustomerSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpgradeCustomerSubscriptionMutation, UpgradeCustomerSubscriptionMutationVariables>;
export const UpgradeCustomerToProPlanDocument = gql`
    mutation upgradeCustomerToProPlan($planID: ID!, $organizationID: ID!, $paymentMethod: String!, $modelsSeats: Int!, $weaveIngestionTier: WeaveIngestionLimitInMb!, $monthly: Boolean, $clientMutationId: String) {
  upgradeCustomerToProPlan(
    input: {planID: $planID, organizationID: $organizationID, paymentMethod: $paymentMethod, modelsSeats: $modelsSeats, weaveIngestionTier: $weaveIngestionTier, monthly: $monthly, clientMutationId: $clientMutationId}
  ) {
    subscriptionUsage
    subscriptionCommit
    organizationID
    clientMutationId
  }
}
    `;
export type UpgradeCustomerToProPlanMutationFn = ApolloReactCommon.MutationFunction<UpgradeCustomerToProPlanMutation, UpgradeCustomerToProPlanMutationVariables>;

/**
 * __useUpgradeCustomerToProPlanMutation__
 *
 * To run a mutation, you first call `useUpgradeCustomerToProPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeCustomerToProPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeCustomerToProPlanMutation, { data, loading, error }] = useUpgradeCustomerToProPlanMutation({
 *   variables: {
 *      planID: // value for 'planID'
 *      organizationID: // value for 'organizationID'
 *      paymentMethod: // value for 'paymentMethod'
 *      modelsSeats: // value for 'modelsSeats'
 *      weaveIngestionTier: // value for 'weaveIngestionTier'
 *      monthly: // value for 'monthly'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpgradeCustomerToProPlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpgradeCustomerToProPlanMutation, UpgradeCustomerToProPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpgradeCustomerToProPlanMutation, UpgradeCustomerToProPlanMutationVariables>(UpgradeCustomerToProPlanDocument, options);
      }
export type UpgradeCustomerToProPlanMutationHookResult = ReturnType<typeof useUpgradeCustomerToProPlanMutation>;
export type UpgradeCustomerToProPlanMutationResult = ApolloReactCommon.MutationResult<UpgradeCustomerToProPlanMutation>;
export type UpgradeCustomerToProPlanMutationOptions = ApolloReactCommon.BaseMutationOptions<UpgradeCustomerToProPlanMutation, UpgradeCustomerToProPlanMutationVariables>;
export const CreateHourOverageSubscriptionDocument = gql`
    mutation createHourOverageSubscription($organizationId: ID!, $clientMutationId: String) {
  createHourOverageSubscription(
    input: {organizationId: $organizationId, clientMutationId: $clientMutationId}
  ) {
    subscription
    clientMutationId
  }
}
    `;
export type CreateHourOverageSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CreateHourOverageSubscriptionMutation, CreateHourOverageSubscriptionMutationVariables>;

/**
 * __useCreateHourOverageSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateHourOverageSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHourOverageSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHourOverageSubscriptionMutation, { data, loading, error }] = useCreateHourOverageSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCreateHourOverageSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateHourOverageSubscriptionMutation, CreateHourOverageSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateHourOverageSubscriptionMutation, CreateHourOverageSubscriptionMutationVariables>(CreateHourOverageSubscriptionDocument, options);
      }
export type CreateHourOverageSubscriptionMutationHookResult = ReturnType<typeof useCreateHourOverageSubscriptionMutation>;
export type CreateHourOverageSubscriptionMutationResult = ApolloReactCommon.MutationResult<CreateHourOverageSubscriptionMutation>;
export type CreateHourOverageSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateHourOverageSubscriptionMutation, CreateHourOverageSubscriptionMutationVariables>;
export const UpgradeTrialSubscriptionDocument = gql`
    mutation upgradeTrialSubscription($organizationID: ID!, $planID: ID!) {
  upgradeTrialSubscription(
    input: {organizationID: $organizationID, planID: $planID}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpgradeTrialSubscriptionMutationFn = ApolloReactCommon.MutationFunction<UpgradeTrialSubscriptionMutation, UpgradeTrialSubscriptionMutationVariables>;

/**
 * __useUpgradeTrialSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpgradeTrialSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeTrialSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeTrialSubscriptionMutation, { data, loading, error }] = useUpgradeTrialSubscriptionMutation({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *      planID: // value for 'planID'
 *   },
 * });
 */
export function useUpgradeTrialSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpgradeTrialSubscriptionMutation, UpgradeTrialSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpgradeTrialSubscriptionMutation, UpgradeTrialSubscriptionMutationVariables>(UpgradeTrialSubscriptionDocument, options);
      }
export type UpgradeTrialSubscriptionMutationHookResult = ReturnType<typeof useUpgradeTrialSubscriptionMutation>;
export type UpgradeTrialSubscriptionMutationResult = ApolloReactCommon.MutationResult<UpgradeTrialSubscriptionMutation>;
export type UpgradeTrialSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpgradeTrialSubscriptionMutation, UpgradeTrialSubscriptionMutationVariables>;
export const UpdateDiscussionThreadDocument = gql`
    mutation UpdateDiscussionThread($discussionThreadID: ID!, $body: String!) {
  updateDiscussionThread(
    input: {discussionThreadID: $discussionThreadID, body: $body}
  ) {
    discussionThread {
      id
      createdAt
      updatedAt
      title
      body
      upvotes
      poster {
        id
        photoUrl
        name
      }
    }
  }
}
    `;
export type UpdateDiscussionThreadMutationFn = ApolloReactCommon.MutationFunction<UpdateDiscussionThreadMutation, UpdateDiscussionThreadMutationVariables>;

/**
 * __useUpdateDiscussionThreadMutation__
 *
 * To run a mutation, you first call `useUpdateDiscussionThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscussionThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscussionThreadMutation, { data, loading, error }] = useUpdateDiscussionThreadMutation({
 *   variables: {
 *      discussionThreadID: // value for 'discussionThreadID'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateDiscussionThreadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDiscussionThreadMutation, UpdateDiscussionThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDiscussionThreadMutation, UpdateDiscussionThreadMutationVariables>(UpdateDiscussionThreadDocument, options);
      }
export type UpdateDiscussionThreadMutationHookResult = ReturnType<typeof useUpdateDiscussionThreadMutation>;
export type UpdateDiscussionThreadMutationResult = ApolloReactCommon.MutationResult<UpdateDiscussionThreadMutation>;
export type UpdateDiscussionThreadMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDiscussionThreadMutation, UpdateDiscussionThreadMutationVariables>;
export const UpdateDiscussionCommentDocument = gql`
    mutation UpdateDiscussionComment($viewID: ID, $discussionCommentID: ID!, $body: String!, $inlineCommentDetails: JSONString) {
  updateDiscussionComment(
    input: {viewID: $viewID, discussionCommentID: $discussionCommentID, body: $body, inlineCommentDetails: $inlineCommentDetails}
  ) {
    discussionComment {
      id
      createdAt
      updatedAt
      deletedAt
      body
      isParent
      poster {
        id
        photoUrl
        name
        username
      }
    }
  }
}
    `;
export type UpdateDiscussionCommentMutationFn = ApolloReactCommon.MutationFunction<UpdateDiscussionCommentMutation, UpdateDiscussionCommentMutationVariables>;

/**
 * __useUpdateDiscussionCommentMutation__
 *
 * To run a mutation, you first call `useUpdateDiscussionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscussionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscussionCommentMutation, { data, loading, error }] = useUpdateDiscussionCommentMutation({
 *   variables: {
 *      viewID: // value for 'viewID'
 *      discussionCommentID: // value for 'discussionCommentID'
 *      body: // value for 'body'
 *      inlineCommentDetails: // value for 'inlineCommentDetails'
 *   },
 * });
 */
export function useUpdateDiscussionCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDiscussionCommentMutation, UpdateDiscussionCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDiscussionCommentMutation, UpdateDiscussionCommentMutationVariables>(UpdateDiscussionCommentDocument, options);
      }
export type UpdateDiscussionCommentMutationHookResult = ReturnType<typeof useUpdateDiscussionCommentMutation>;
export type UpdateDiscussionCommentMutationResult = ApolloReactCommon.MutationResult<UpdateDiscussionCommentMutation>;
export type UpdateDiscussionCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDiscussionCommentMutation, UpdateDiscussionCommentMutationVariables>;
export const DeleteDiscussionCommentDocument = gql`
    mutation DeleteDiscussionComment($id: ID!, $deleteThread: Boolean) {
  deleteDiscussionComment(input: {id: $id, deleteThread: $deleteThread}) {
    success
  }
}
    `;
export type DeleteDiscussionCommentMutationFn = ApolloReactCommon.MutationFunction<DeleteDiscussionCommentMutation, DeleteDiscussionCommentMutationVariables>;

/**
 * __useDeleteDiscussionCommentMutation__
 *
 * To run a mutation, you first call `useDeleteDiscussionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscussionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscussionCommentMutation, { data, loading, error }] = useDeleteDiscussionCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deleteThread: // value for 'deleteThread'
 *   },
 * });
 */
export function useDeleteDiscussionCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDiscussionCommentMutation, DeleteDiscussionCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDiscussionCommentMutation, DeleteDiscussionCommentMutationVariables>(DeleteDiscussionCommentDocument, options);
      }
export type DeleteDiscussionCommentMutationHookResult = ReturnType<typeof useDeleteDiscussionCommentMutation>;
export type DeleteDiscussionCommentMutationResult = ApolloReactCommon.MutationResult<DeleteDiscussionCommentMutation>;
export type DeleteDiscussionCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteDiscussionCommentMutation, DeleteDiscussionCommentMutationVariables>;
export const ViewDiscussionThreadsDocument = gql`
    query ViewDiscussionThreads($viewID: ID!) {
  view(id: $viewID) {
    id
    discussionThreads {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          createdAt
          updatedAt
          title
          body
          upvotes
          poster {
            id
            photoUrl
            name
            username
          }
          comments {
            totalCount
            pageInfo {
              hasNextPage
              hasPreviousPage
            }
            edges {
              node {
                id
                createdAt
                updatedAt
                body
                poster {
                  id
                  photoUrl
                  name
                  username
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useViewDiscussionThreadsQuery__
 *
 * To run a query within a React component, call `useViewDiscussionThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewDiscussionThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewDiscussionThreadsQuery({
 *   variables: {
 *      viewID: // value for 'viewID'
 *   },
 * });
 */
export function useViewDiscussionThreadsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables> & ({ variables: ViewDiscussionThreadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables>(ViewDiscussionThreadsDocument, options);
      }
export function useViewDiscussionThreadsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables>(ViewDiscussionThreadsDocument, options);
        }
// @ts-ignore
export function useViewDiscussionThreadsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables>;
export function useViewDiscussionThreadsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewDiscussionThreadsQuery | undefined, ViewDiscussionThreadsQueryVariables>;
export function useViewDiscussionThreadsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables>(ViewDiscussionThreadsDocument, options);
        }
export type ViewDiscussionThreadsQueryHookResult = ReturnType<typeof useViewDiscussionThreadsQuery>;
export type ViewDiscussionThreadsLazyQueryHookResult = ReturnType<typeof useViewDiscussionThreadsLazyQuery>;
export type ViewDiscussionThreadsSuspenseQueryHookResult = ReturnType<typeof useViewDiscussionThreadsSuspenseQuery>;
export type ViewDiscussionThreadsQueryResult = ApolloReactCommon.QueryResult<ViewDiscussionThreadsQuery, ViewDiscussionThreadsQueryVariables>;
export const CreateViewDiscussionCommentDocument = gql`
    mutation CreateViewDiscussionComment($viewID: ID!, $discussionThreadID: ID, $body: String!, $notifyAllSubscribers: Boolean, $inlineCommentDetails: JSONString) {
  createViewDiscussionComment(
    input: {viewID: $viewID, discussionThreadID: $discussionThreadID, body: $body, notifyAllSubscribers: $notifyAllSubscribers, inlineCommentDetails: $inlineCommentDetails}
  ) {
    discussionThread {
      id
      createdAt
      updatedAt
      title
      body
      upvotes
      poster {
        id
        photoUrl
        name
        username
      }
    }
    discussionComment {
      id
      createdAt
      updatedAt
      body
      poster {
        id
        photoUrl
        name
        username
      }
    }
    alertSubscription {
      id
    }
  }
}
    `;
export type CreateViewDiscussionCommentMutationFn = ApolloReactCommon.MutationFunction<CreateViewDiscussionCommentMutation, CreateViewDiscussionCommentMutationVariables>;

/**
 * __useCreateViewDiscussionCommentMutation__
 *
 * To run a mutation, you first call `useCreateViewDiscussionCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateViewDiscussionCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createViewDiscussionCommentMutation, { data, loading, error }] = useCreateViewDiscussionCommentMutation({
 *   variables: {
 *      viewID: // value for 'viewID'
 *      discussionThreadID: // value for 'discussionThreadID'
 *      body: // value for 'body'
 *      notifyAllSubscribers: // value for 'notifyAllSubscribers'
 *      inlineCommentDetails: // value for 'inlineCommentDetails'
 *   },
 * });
 */
export function useCreateViewDiscussionCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateViewDiscussionCommentMutation, CreateViewDiscussionCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateViewDiscussionCommentMutation, CreateViewDiscussionCommentMutationVariables>(CreateViewDiscussionCommentDocument, options);
      }
export type CreateViewDiscussionCommentMutationHookResult = ReturnType<typeof useCreateViewDiscussionCommentMutation>;
export type CreateViewDiscussionCommentMutationResult = ApolloReactCommon.MutationResult<CreateViewDiscussionCommentMutation>;
export type CreateViewDiscussionCommentMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateViewDiscussionCommentMutation, CreateViewDiscussionCommentMutationVariables>;
export const DismissedBannerDocument = gql`
    query DismissedBanner($id: ID!) {
  dismissedBanner(id: $id) {
    id
    dismissedAt
  }
}
    `;

/**
 * __useDismissedBannerQuery__
 *
 * To run a query within a React component, call `useDismissedBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useDismissedBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDismissedBannerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDismissedBannerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DismissedBannerQuery, DismissedBannerQueryVariables> & ({ variables: DismissedBannerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DismissedBannerQuery, DismissedBannerQueryVariables>(DismissedBannerDocument, options);
      }
export function useDismissedBannerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DismissedBannerQuery, DismissedBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DismissedBannerQuery, DismissedBannerQueryVariables>(DismissedBannerDocument, options);
        }
// @ts-ignore
export function useDismissedBannerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DismissedBannerQuery, DismissedBannerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DismissedBannerQuery, DismissedBannerQueryVariables>;
export function useDismissedBannerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DismissedBannerQuery, DismissedBannerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DismissedBannerQuery | undefined, DismissedBannerQueryVariables>;
export function useDismissedBannerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DismissedBannerQuery, DismissedBannerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DismissedBannerQuery, DismissedBannerQueryVariables>(DismissedBannerDocument, options);
        }
export type DismissedBannerQueryHookResult = ReturnType<typeof useDismissedBannerQuery>;
export type DismissedBannerLazyQueryHookResult = ReturnType<typeof useDismissedBannerLazyQuery>;
export type DismissedBannerSuspenseQueryHookResult = ReturnType<typeof useDismissedBannerSuspenseQuery>;
export type DismissedBannerQueryResult = ApolloReactCommon.QueryResult<DismissedBannerQuery, DismissedBannerQueryVariables>;
export const SetDismissedBannerDocument = gql`
    mutation SetDismissedBanner($id: ID!) {
  setDismissedBanner(input: {bannerID: $id}) {
    success
  }
}
    `;
export type SetDismissedBannerMutationFn = ApolloReactCommon.MutationFunction<SetDismissedBannerMutation, SetDismissedBannerMutationVariables>;

/**
 * __useSetDismissedBannerMutation__
 *
 * To run a mutation, you first call `useSetDismissedBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDismissedBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDismissedBannerMutation, { data, loading, error }] = useSetDismissedBannerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDismissedBannerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetDismissedBannerMutation, SetDismissedBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetDismissedBannerMutation, SetDismissedBannerMutationVariables>(SetDismissedBannerDocument, options);
      }
export type SetDismissedBannerMutationHookResult = ReturnType<typeof useSetDismissedBannerMutation>;
export type SetDismissedBannerMutationResult = ApolloReactCommon.MutationResult<SetDismissedBannerMutation>;
export type SetDismissedBannerMutationOptions = ApolloReactCommon.BaseMutationOptions<SetDismissedBannerMutation, SetDismissedBannerMutationVariables>;
export const ResendEmailVerificationDocument = gql`
    mutation resendEmailVerification($email: String!, $clientMutationId: String) {
  resendEmailVerification(
    input: {email: $email, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type ResendEmailVerificationMutationFn = ApolloReactCommon.MutationFunction<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>;

/**
 * __useResendEmailVerificationMutation__
 *
 * To run a mutation, you first call `useResendEmailVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailVerificationMutation, { data, loading, error }] = useResendEmailVerificationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useResendEmailVerificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>(ResendEmailVerificationDocument, options);
      }
export type ResendEmailVerificationMutationHookResult = ReturnType<typeof useResendEmailVerificationMutation>;
export type ResendEmailVerificationMutationResult = ApolloReactCommon.MutationResult<ResendEmailVerificationMutation>;
export type ResendEmailVerificationMutationOptions = ApolloReactCommon.BaseMutationOptions<ResendEmailVerificationMutation, ResendEmailVerificationMutationVariables>;
export const SelectedAccountEntityOrgDocument = gql`
    query SelectedAccountEntityOrg($id: ID!) {
  organization(id: $id) {
    id
    orgEntity {
      id
      name
    }
  }
}
    `;

/**
 * __useSelectedAccountEntityOrgQuery__
 *
 * To run a query within a React component, call `useSelectedAccountEntityOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedAccountEntityOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedAccountEntityOrgQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSelectedAccountEntityOrgQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables> & ({ variables: SelectedAccountEntityOrgQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables>(SelectedAccountEntityOrgDocument, options);
      }
export function useSelectedAccountEntityOrgLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables>(SelectedAccountEntityOrgDocument, options);
        }
// @ts-ignore
export function useSelectedAccountEntityOrgSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables>;
export function useSelectedAccountEntityOrgSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectedAccountEntityOrgQuery | undefined, SelectedAccountEntityOrgQueryVariables>;
export function useSelectedAccountEntityOrgSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables>(SelectedAccountEntityOrgDocument, options);
        }
export type SelectedAccountEntityOrgQueryHookResult = ReturnType<typeof useSelectedAccountEntityOrgQuery>;
export type SelectedAccountEntityOrgLazyQueryHookResult = ReturnType<typeof useSelectedAccountEntityOrgLazyQuery>;
export type SelectedAccountEntityOrgSuspenseQueryHookResult = ReturnType<typeof useSelectedAccountEntityOrgSuspenseQuery>;
export type SelectedAccountEntityOrgQueryResult = ApolloReactCommon.QueryResult<SelectedAccountEntityOrgQuery, SelectedAccountEntityOrgQueryVariables>;
export const EntityPageDocument = gql`
    query EntityPage($entityName: String!) {
  entity(name: $entityName) {
    id
    isTeam
    entityType
    available
    claimingEntity {
      id
      name
    }
    members {
      id
      name
      username
      email
      photoUrl
      pending
      accountType
      role
    }
    name
  }
}
    `;

/**
 * __useEntityPageQuery__
 *
 * To run a query within a React component, call `useEntityPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityPageQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityPageQuery, EntityPageQueryVariables> & ({ variables: EntityPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityPageQuery, EntityPageQueryVariables>(EntityPageDocument, options);
      }
export function useEntityPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityPageQuery, EntityPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityPageQuery, EntityPageQueryVariables>(EntityPageDocument, options);
        }
// @ts-ignore
export function useEntityPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityPageQuery, EntityPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityPageQuery, EntityPageQueryVariables>;
export function useEntityPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityPageQuery, EntityPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityPageQuery | undefined, EntityPageQueryVariables>;
export function useEntityPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityPageQuery, EntityPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityPageQuery, EntityPageQueryVariables>(EntityPageDocument, options);
        }
export type EntityPageQueryHookResult = ReturnType<typeof useEntityPageQuery>;
export type EntityPageLazyQueryHookResult = ReturnType<typeof useEntityPageLazyQuery>;
export type EntityPageSuspenseQueryHookResult = ReturnType<typeof useEntityPageSuspenseQuery>;
export type EntityPageQueryResult = ApolloReactCommon.QueryResult<EntityPageQuery, EntityPageQueryVariables>;
export const EntityTypeDocument = gql`
    query EntityType($entityName: String!) {
  entity(name: $entityName) {
    id
    entityType
  }
}
    `;

/**
 * __useEntityTypeQuery__
 *
 * To run a query within a React component, call `useEntityTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityTypeQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityTypeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityTypeQuery, EntityTypeQueryVariables> & ({ variables: EntityTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityTypeQuery, EntityTypeQueryVariables>(EntityTypeDocument, options);
      }
export function useEntityTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityTypeQuery, EntityTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityTypeQuery, EntityTypeQueryVariables>(EntityTypeDocument, options);
        }
// @ts-ignore
export function useEntityTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityTypeQuery, EntityTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityTypeQuery, EntityTypeQueryVariables>;
export function useEntityTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityTypeQuery, EntityTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityTypeQuery | undefined, EntityTypeQueryVariables>;
export function useEntityTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityTypeQuery, EntityTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityTypeQuery, EntityTypeQueryVariables>(EntityTypeDocument, options);
        }
export type EntityTypeQueryHookResult = ReturnType<typeof useEntityTypeQuery>;
export type EntityTypeLazyQueryHookResult = ReturnType<typeof useEntityTypeLazyQuery>;
export type EntityTypeSuspenseQueryHookResult = ReturnType<typeof useEntityTypeSuspenseQuery>;
export type EntityTypeQueryResult = ApolloReactCommon.QueryResult<EntityTypeQuery, EntityTypeQueryVariables>;
export const EntityPageUserStatsDocument = gql`
    query EntityPageUserStats($entityName: String!, $userStatsStartDate: DateTime!) {
  entity(name: $entityName) {
    id
    userStats(from: $userStatsStartDate, first: 10) {
      edges {
        node {
          id
          user {
            id
            name
            username
            photoUrl
            accountType
          }
          runCount
        }
      }
    }
  }
}
    `;

/**
 * __useEntityPageUserStatsQuery__
 *
 * To run a query within a React component, call `useEntityPageUserStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityPageUserStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityPageUserStatsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      userStatsStartDate: // value for 'userStatsStartDate'
 *   },
 * });
 */
export function useEntityPageUserStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables> & ({ variables: EntityPageUserStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables>(EntityPageUserStatsDocument, options);
      }
export function useEntityPageUserStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables>(EntityPageUserStatsDocument, options);
        }
// @ts-ignore
export function useEntityPageUserStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables>;
export function useEntityPageUserStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityPageUserStatsQuery | undefined, EntityPageUserStatsQueryVariables>;
export function useEntityPageUserStatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables>(EntityPageUserStatsDocument, options);
        }
export type EntityPageUserStatsQueryHookResult = ReturnType<typeof useEntityPageUserStatsQuery>;
export type EntityPageUserStatsLazyQueryHookResult = ReturnType<typeof useEntityPageUserStatsLazyQuery>;
export type EntityPageUserStatsSuspenseQueryHookResult = ReturnType<typeof useEntityPageUserStatsSuspenseQuery>;
export type EntityPageUserStatsQueryResult = ApolloReactCommon.QueryResult<EntityPageUserStatsQuery, EntityPageUserStatsQueryVariables>;
export const EntityRunsDocument = gql`
    query EntityRuns($entityName: String!) {
  entity(name: $entityName) {
    id
    latestRuns {
      edges {
        node {
          id
          ...RunsTableFragment
        }
      }
    }
  }
}
    ${RunsTableFragmentFragmentDoc}`;

/**
 * __useEntityRunsQuery__
 *
 * To run a query within a React component, call `useEntityRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityRunsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityRunsQuery, EntityRunsQueryVariables> & ({ variables: EntityRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityRunsQuery, EntityRunsQueryVariables>(EntityRunsDocument, options);
      }
export function useEntityRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityRunsQuery, EntityRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityRunsQuery, EntityRunsQueryVariables>(EntityRunsDocument, options);
        }
// @ts-ignore
export function useEntityRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityRunsQuery, EntityRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityRunsQuery, EntityRunsQueryVariables>;
export function useEntityRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityRunsQuery, EntityRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityRunsQuery | undefined, EntityRunsQueryVariables>;
export function useEntityRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityRunsQuery, EntityRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityRunsQuery, EntityRunsQueryVariables>(EntityRunsDocument, options);
        }
export type EntityRunsQueryHookResult = ReturnType<typeof useEntityRunsQuery>;
export type EntityRunsLazyQueryHookResult = ReturnType<typeof useEntityRunsLazyQuery>;
export type EntityRunsSuspenseQueryHookResult = ReturnType<typeof useEntityRunsSuspenseQuery>;
export type EntityRunsQueryResult = ApolloReactCommon.QueryResult<EntityRunsQuery, EntityRunsQueryVariables>;
export const EntitySettingsDocument = gql`
    query EntitySettings($name: String!) {
  entity(name: $name) {
    id
    entityType
    settings {
      defaultCloudRegion {
        id
        provider
        region
      }
      openToMatchingOrgEmailDomainUsers
      entityProfileEnabled
      hideActivityCalendar
      membersCanInvite
      disableMagicLinkSharing
      disableMembersEditArtifactTTL
      hidden
    }
  }
}
    `;

/**
 * __useEntitySettingsQuery__
 *
 * To run a query within a React component, call `useEntitySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitySettingsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEntitySettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntitySettingsQuery, EntitySettingsQueryVariables> & ({ variables: EntitySettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntitySettingsQuery, EntitySettingsQueryVariables>(EntitySettingsDocument, options);
      }
export function useEntitySettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntitySettingsQuery, EntitySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntitySettingsQuery, EntitySettingsQueryVariables>(EntitySettingsDocument, options);
        }
// @ts-ignore
export function useEntitySettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntitySettingsQuery, EntitySettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntitySettingsQuery, EntitySettingsQueryVariables>;
export function useEntitySettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntitySettingsQuery, EntitySettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntitySettingsQuery | undefined, EntitySettingsQueryVariables>;
export function useEntitySettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntitySettingsQuery, EntitySettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntitySettingsQuery, EntitySettingsQueryVariables>(EntitySettingsDocument, options);
        }
export type EntitySettingsQueryHookResult = ReturnType<typeof useEntitySettingsQuery>;
export type EntitySettingsLazyQueryHookResult = ReturnType<typeof useEntitySettingsLazyQuery>;
export type EntitySettingsSuspenseQueryHookResult = ReturnType<typeof useEntitySettingsSuspenseQuery>;
export type EntitySettingsQueryResult = ApolloReactCommon.QueryResult<EntitySettingsQuery, EntitySettingsQueryVariables>;
export const EntityStorageDocument = gql`
    query EntityStorage($entityName: String, $enableReferenceTracking: Boolean) {
  entity(name: $entityName) {
    id
    storageBytes
    referenceBytes
    computeHours
    storage: storageTree(enableReferenceTracking: $enableReferenceTracking) {
      id
      size
    }
  }
}
    `;

/**
 * __useEntityStorageQuery__
 *
 * To run a query within a React component, call `useEntityStorageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityStorageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityStorageQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      enableReferenceTracking: // value for 'enableReferenceTracking'
 *   },
 * });
 */
export function useEntityStorageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EntityStorageQuery, EntityStorageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityStorageQuery, EntityStorageQueryVariables>(EntityStorageDocument, options);
      }
export function useEntityStorageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityStorageQuery, EntityStorageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityStorageQuery, EntityStorageQueryVariables>(EntityStorageDocument, options);
        }
// @ts-ignore
export function useEntityStorageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityStorageQuery, EntityStorageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityStorageQuery, EntityStorageQueryVariables>;
export function useEntityStorageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityStorageQuery, EntityStorageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityStorageQuery | undefined, EntityStorageQueryVariables>;
export function useEntityStorageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityStorageQuery, EntityStorageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityStorageQuery, EntityStorageQueryVariables>(EntityStorageDocument, options);
        }
export type EntityStorageQueryHookResult = ReturnType<typeof useEntityStorageQuery>;
export type EntityStorageLazyQueryHookResult = ReturnType<typeof useEntityStorageLazyQuery>;
export type EntityStorageSuspenseQueryHookResult = ReturnType<typeof useEntityStorageSuspenseQuery>;
export type EntityStorageQueryResult = ApolloReactCommon.QueryResult<EntityStorageQuery, EntityStorageQueryVariables>;
export const CachedEntityStorageInfoDocument = gql`
    query CachedEntityStorageInfo($entityName: String) {
  entity(name: $entityName) {
    id
    storageBytes(cached: true)
  }
}
    `;

/**
 * __useCachedEntityStorageInfoQuery__
 *
 * To run a query within a React component, call `useCachedEntityStorageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCachedEntityStorageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCachedEntityStorageInfoQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useCachedEntityStorageInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>(CachedEntityStorageInfoDocument, options);
      }
export function useCachedEntityStorageInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>(CachedEntityStorageInfoDocument, options);
        }
// @ts-ignore
export function useCachedEntityStorageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>;
export function useCachedEntityStorageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CachedEntityStorageInfoQuery | undefined, CachedEntityStorageInfoQueryVariables>;
export function useCachedEntityStorageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>(CachedEntityStorageInfoDocument, options);
        }
export type CachedEntityStorageInfoQueryHookResult = ReturnType<typeof useCachedEntityStorageInfoQuery>;
export type CachedEntityStorageInfoLazyQueryHookResult = ReturnType<typeof useCachedEntityStorageInfoLazyQuery>;
export type CachedEntityStorageInfoSuspenseQueryHookResult = ReturnType<typeof useCachedEntityStorageInfoSuspenseQuery>;
export type CachedEntityStorageInfoQueryResult = ApolloReactCommon.QueryResult<CachedEntityStorageInfoQuery, CachedEntityStorageInfoQueryVariables>;
export const ArtifactCollectionStorageTreeDocument = gql`
    query ArtifactCollectionStorageTree($entityName: String!, $enableReferenceTracking: Boolean!, $artifactCollectionID: ID!) {
  entity(name: $entityName) {
    id
    artifactCollectionStorageTree(
      artifactCollectionID: $artifactCollectionID
      enableReferenceTracking: $enableReferenceTracking
    ) {
      edges {
        node {
          id
          name
          size
          artifactID
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactCollectionStorageTreeQuery__
 *
 * To run a query within a React component, call `useArtifactCollectionStorageTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCollectionStorageTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCollectionStorageTreeQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      enableReferenceTracking: // value for 'enableReferenceTracking'
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *   },
 * });
 */
export function useArtifactCollectionStorageTreeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables> & ({ variables: ArtifactCollectionStorageTreeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables>(ArtifactCollectionStorageTreeDocument, options);
      }
export function useArtifactCollectionStorageTreeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables>(ArtifactCollectionStorageTreeDocument, options);
        }
// @ts-ignore
export function useArtifactCollectionStorageTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables>;
export function useArtifactCollectionStorageTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionStorageTreeQuery | undefined, ArtifactCollectionStorageTreeQueryVariables>;
export function useArtifactCollectionStorageTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables>(ArtifactCollectionStorageTreeDocument, options);
        }
export type ArtifactCollectionStorageTreeQueryHookResult = ReturnType<typeof useArtifactCollectionStorageTreeQuery>;
export type ArtifactCollectionStorageTreeLazyQueryHookResult = ReturnType<typeof useArtifactCollectionStorageTreeLazyQuery>;
export type ArtifactCollectionStorageTreeSuspenseQueryHookResult = ReturnType<typeof useArtifactCollectionStorageTreeSuspenseQuery>;
export type ArtifactCollectionStorageTreeQueryResult = ApolloReactCommon.QueryResult<ArtifactCollectionStorageTreeQuery, ArtifactCollectionStorageTreeQueryVariables>;
export const EntityStorageTreeDocument = gql`
    query EntityStorageTree($entityName: String!, $enableReferenceTracking: Boolean!, $query: String, $cached: Boolean) {
  entity(name: $entityName) {
    id
    storageTree(enableReferenceTracking: $enableReferenceTracking, cached: $cached) {
      id
      name
      size
      lastUpdatedAt
      projects(query: $query) {
        totalSize
        edges {
          node {
            id
            name
            size
            projectID
            runs @skip(if: $enableReferenceTracking) {
              totalSize
              edges {
                node {
                  id
                  ...RunNode
                }
              }
            }
            artifactSequences {
              totalSize
              edges {
                node {
                  id
                  ...ArtifactNode
                }
              }
            }
            artifactTypes {
              id
              name
              size
            }
          }
        }
      }
    }
  }
}
    ${RunNodeFragmentDoc}
${ArtifactNodeFragmentDoc}`;

/**
 * __useEntityStorageTreeQuery__
 *
 * To run a query within a React component, call `useEntityStorageTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityStorageTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityStorageTreeQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      enableReferenceTracking: // value for 'enableReferenceTracking'
 *      query: // value for 'query'
 *      cached: // value for 'cached'
 *   },
 * });
 */
export function useEntityStorageTreeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityStorageTreeQuery, EntityStorageTreeQueryVariables> & ({ variables: EntityStorageTreeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityStorageTreeQuery, EntityStorageTreeQueryVariables>(EntityStorageTreeDocument, options);
      }
export function useEntityStorageTreeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityStorageTreeQuery, EntityStorageTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityStorageTreeQuery, EntityStorageTreeQueryVariables>(EntityStorageTreeDocument, options);
        }
// @ts-ignore
export function useEntityStorageTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityStorageTreeQuery, EntityStorageTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityStorageTreeQuery, EntityStorageTreeQueryVariables>;
export function useEntityStorageTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityStorageTreeQuery, EntityStorageTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityStorageTreeQuery | undefined, EntityStorageTreeQueryVariables>;
export function useEntityStorageTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityStorageTreeQuery, EntityStorageTreeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityStorageTreeQuery, EntityStorageTreeQueryVariables>(EntityStorageTreeDocument, options);
        }
export type EntityStorageTreeQueryHookResult = ReturnType<typeof useEntityStorageTreeQuery>;
export type EntityStorageTreeLazyQueryHookResult = ReturnType<typeof useEntityStorageTreeLazyQuery>;
export type EntityStorageTreeSuspenseQueryHookResult = ReturnType<typeof useEntityStorageTreeSuspenseQuery>;
export type EntityStorageTreeQueryResult = ApolloReactCommon.QueryResult<EntityStorageTreeQuery, EntityStorageTreeQueryVariables>;
export const LogExperimentExposureDocument = gql`
    mutation LogExperimentExposure($experimentName: String!, $unit: ExperimentExposureUnit!) {
  logExperimentExposure(input: {experimentName: $experimentName, unit: $unit}) {
    success
    bucket
  }
}
    `;
export type LogExperimentExposureMutationFn = ApolloReactCommon.MutationFunction<LogExperimentExposureMutation, LogExperimentExposureMutationVariables>;

/**
 * __useLogExperimentExposureMutation__
 *
 * To run a mutation, you first call `useLogExperimentExposureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogExperimentExposureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logExperimentExposureMutation, { data, loading, error }] = useLogExperimentExposureMutation({
 *   variables: {
 *      experimentName: // value for 'experimentName'
 *      unit: // value for 'unit'
 *   },
 * });
 */
export function useLogExperimentExposureMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogExperimentExposureMutation, LogExperimentExposureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LogExperimentExposureMutation, LogExperimentExposureMutationVariables>(LogExperimentExposureDocument, options);
      }
export type LogExperimentExposureMutationHookResult = ReturnType<typeof useLogExperimentExposureMutation>;
export type LogExperimentExposureMutationResult = ApolloReactCommon.MutationResult<LogExperimentExposureMutation>;
export type LogExperimentExposureMutationOptions = ApolloReactCommon.BaseMutationOptions<LogExperimentExposureMutation, LogExperimentExposureMutationVariables>;
export const UserEmailsDocument = gql`
    query UserEmails {
  viewer {
    id
    ...GetEmails_User
  }
}
    ${GetEmails_UserFragmentDoc}`;

/**
 * __useUserEmailsQuery__
 *
 * To run a query within a React component, call `useUserEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEmailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserEmailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserEmailsQuery, UserEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserEmailsQuery, UserEmailsQueryVariables>(UserEmailsDocument, options);
      }
export function useUserEmailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserEmailsQuery, UserEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserEmailsQuery, UserEmailsQueryVariables>(UserEmailsDocument, options);
        }
// @ts-ignore
export function useUserEmailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserEmailsQuery, UserEmailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserEmailsQuery, UserEmailsQueryVariables>;
export function useUserEmailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserEmailsQuery, UserEmailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserEmailsQuery | undefined, UserEmailsQueryVariables>;
export function useUserEmailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserEmailsQuery, UserEmailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserEmailsQuery, UserEmailsQueryVariables>(UserEmailsDocument, options);
        }
export type UserEmailsQueryHookResult = ReturnType<typeof useUserEmailsQuery>;
export type UserEmailsLazyQueryHookResult = ReturnType<typeof useUserEmailsLazyQuery>;
export type UserEmailsSuspenseQueryHookResult = ReturnType<typeof useUserEmailsSuspenseQuery>;
export type UserEmailsQueryResult = ApolloReactCommon.QueryResult<UserEmailsQuery, UserEmailsQueryVariables>;
export const GlueTasksDocument = gql`
    query GlueTasks {
  glueManager {
    taskTypes
    registeredTasks {
      edges {
        node {
          id
          name
          taskType
          arguments
          checkpoint
          lastRunAt
          status
          strategyType
          strategyMetadata
        }
      }
    }
  }
}
    `;

/**
 * __useGlueTasksQuery__
 *
 * To run a query within a React component, call `useGlueTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlueTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlueTasksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGlueTasksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GlueTasksQuery, GlueTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlueTasksQuery, GlueTasksQueryVariables>(GlueTasksDocument, options);
      }
export function useGlueTasksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlueTasksQuery, GlueTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlueTasksQuery, GlueTasksQueryVariables>(GlueTasksDocument, options);
        }
// @ts-ignore
export function useGlueTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GlueTasksQuery, GlueTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlueTasksQuery, GlueTasksQueryVariables>;
export function useGlueTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlueTasksQuery, GlueTasksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlueTasksQuery | undefined, GlueTasksQueryVariables>;
export function useGlueTasksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlueTasksQuery, GlueTasksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlueTasksQuery, GlueTasksQueryVariables>(GlueTasksDocument, options);
        }
export type GlueTasksQueryHookResult = ReturnType<typeof useGlueTasksQuery>;
export type GlueTasksLazyQueryHookResult = ReturnType<typeof useGlueTasksLazyQuery>;
export type GlueTasksSuspenseQueryHookResult = ReturnType<typeof useGlueTasksSuspenseQuery>;
export type GlueTasksQueryResult = ApolloReactCommon.QueryResult<GlueTasksQuery, GlueTasksQueryVariables>;
export const GlueTaskConfigDocument = gql`
    query GlueTaskConfig($taskType: String!) {
  glueManager {
    taskConfig(taskType: $taskType) {
      defaultArguments
    }
  }
}
    `;

/**
 * __useGlueTaskConfigQuery__
 *
 * To run a query within a React component, call `useGlueTaskConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlueTaskConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlueTaskConfigQuery({
 *   variables: {
 *      taskType: // value for 'taskType'
 *   },
 * });
 */
export function useGlueTaskConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GlueTaskConfigQuery, GlueTaskConfigQueryVariables> & ({ variables: GlueTaskConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlueTaskConfigQuery, GlueTaskConfigQueryVariables>(GlueTaskConfigDocument, options);
      }
export function useGlueTaskConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlueTaskConfigQuery, GlueTaskConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlueTaskConfigQuery, GlueTaskConfigQueryVariables>(GlueTaskConfigDocument, options);
        }
// @ts-ignore
export function useGlueTaskConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GlueTaskConfigQuery, GlueTaskConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlueTaskConfigQuery, GlueTaskConfigQueryVariables>;
export function useGlueTaskConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlueTaskConfigQuery, GlueTaskConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlueTaskConfigQuery | undefined, GlueTaskConfigQueryVariables>;
export function useGlueTaskConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlueTaskConfigQuery, GlueTaskConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlueTaskConfigQuery, GlueTaskConfigQueryVariables>(GlueTaskConfigDocument, options);
        }
export type GlueTaskConfigQueryHookResult = ReturnType<typeof useGlueTaskConfigQuery>;
export type GlueTaskConfigLazyQueryHookResult = ReturnType<typeof useGlueTaskConfigLazyQuery>;
export type GlueTaskConfigSuspenseQueryHookResult = ReturnType<typeof useGlueTaskConfigSuspenseQuery>;
export type GlueTaskConfigQueryResult = ApolloReactCommon.QueryResult<GlueTaskConfigQuery, GlueTaskConfigQueryVariables>;
export const GlueRunsDocument = gql`
    query GlueRuns($taskID: ID!) {
  glueRuns(taskID: $taskID) {
    edges {
      node {
        id
        runAt
        runtimeMS
        arguments
        errors
        retries
        succeeded
      }
    }
  }
}
    `;

/**
 * __useGlueRunsQuery__
 *
 * To run a query within a React component, call `useGlueRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlueRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlueRunsQuery({
 *   variables: {
 *      taskID: // value for 'taskID'
 *   },
 * });
 */
export function useGlueRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GlueRunsQuery, GlueRunsQueryVariables> & ({ variables: GlueRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlueRunsQuery, GlueRunsQueryVariables>(GlueRunsDocument, options);
      }
export function useGlueRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlueRunsQuery, GlueRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlueRunsQuery, GlueRunsQueryVariables>(GlueRunsDocument, options);
        }
// @ts-ignore
export function useGlueRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GlueRunsQuery, GlueRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlueRunsQuery, GlueRunsQueryVariables>;
export function useGlueRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlueRunsQuery, GlueRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlueRunsQuery | undefined, GlueRunsQueryVariables>;
export function useGlueRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlueRunsQuery, GlueRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlueRunsQuery, GlueRunsQueryVariables>(GlueRunsDocument, options);
        }
export type GlueRunsQueryHookResult = ReturnType<typeof useGlueRunsQuery>;
export type GlueRunsLazyQueryHookResult = ReturnType<typeof useGlueRunsLazyQuery>;
export type GlueRunsSuspenseQueryHookResult = ReturnType<typeof useGlueRunsSuspenseQuery>;
export type GlueRunsQueryResult = ApolloReactCommon.QueryResult<GlueRunsQuery, GlueRunsQueryVariables>;
export const CreateGlueTaskDocument = gql`
    mutation CreateGlueTask($name: String!, $taskType: String!, $arguments: JSONString!, $status: String!, $strategyType: String!, $strategyMetadata: String!, $clientMutationId: String) {
  createGlueTask(
    input: {name: $name, taskType: $taskType, arguments: $arguments, status: $status, strategyType: $strategyType, strategyMetadata: $strategyMetadata, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type CreateGlueTaskMutationFn = ApolloReactCommon.MutationFunction<CreateGlueTaskMutation, CreateGlueTaskMutationVariables>;

/**
 * __useCreateGlueTaskMutation__
 *
 * To run a mutation, you first call `useCreateGlueTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGlueTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGlueTaskMutation, { data, loading, error }] = useCreateGlueTaskMutation({
 *   variables: {
 *      name: // value for 'name'
 *      taskType: // value for 'taskType'
 *      arguments: // value for 'arguments'
 *      status: // value for 'status'
 *      strategyType: // value for 'strategyType'
 *      strategyMetadata: // value for 'strategyMetadata'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCreateGlueTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateGlueTaskMutation, CreateGlueTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateGlueTaskMutation, CreateGlueTaskMutationVariables>(CreateGlueTaskDocument, options);
      }
export type CreateGlueTaskMutationHookResult = ReturnType<typeof useCreateGlueTaskMutation>;
export type CreateGlueTaskMutationResult = ApolloReactCommon.MutationResult<CreateGlueTaskMutation>;
export type CreateGlueTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateGlueTaskMutation, CreateGlueTaskMutationVariables>;
export const UpdateGlueTaskDocument = gql`
    mutation UpdateGlueTask($id: ID!, $name: String, $arguments: JSONString, $checkpoint: JSONString, $strategyType: String, $strategyMetadata: String, $status: String) {
  updateGlueTask(
    input: {id: $id, name: $name, arguments: $arguments, checkpoint: $checkpoint, strategyType: $strategyType, strategyMetadata: $strategyMetadata, status: $status}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateGlueTaskMutationFn = ApolloReactCommon.MutationFunction<UpdateGlueTaskMutation, UpdateGlueTaskMutationVariables>;

/**
 * __useUpdateGlueTaskMutation__
 *
 * To run a mutation, you first call `useUpdateGlueTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGlueTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGlueTaskMutation, { data, loading, error }] = useUpdateGlueTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      arguments: // value for 'arguments'
 *      checkpoint: // value for 'checkpoint'
 *      strategyType: // value for 'strategyType'
 *      strategyMetadata: // value for 'strategyMetadata'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateGlueTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateGlueTaskMutation, UpdateGlueTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateGlueTaskMutation, UpdateGlueTaskMutationVariables>(UpdateGlueTaskDocument, options);
      }
export type UpdateGlueTaskMutationHookResult = ReturnType<typeof useUpdateGlueTaskMutation>;
export type UpdateGlueTaskMutationResult = ApolloReactCommon.MutationResult<UpdateGlueTaskMutation>;
export type UpdateGlueTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateGlueTaskMutation, UpdateGlueTaskMutationVariables>;
export const EnableGlueTaskDocument = gql`
    mutation EnableGlueTask($id: ID!) {
  enableGlueTask(input: {id: $id}) {
    success
    clientMutationId
  }
}
    `;
export type EnableGlueTaskMutationFn = ApolloReactCommon.MutationFunction<EnableGlueTaskMutation, EnableGlueTaskMutationVariables>;

/**
 * __useEnableGlueTaskMutation__
 *
 * To run a mutation, you first call `useEnableGlueTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableGlueTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableGlueTaskMutation, { data, loading, error }] = useEnableGlueTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnableGlueTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnableGlueTaskMutation, EnableGlueTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EnableGlueTaskMutation, EnableGlueTaskMutationVariables>(EnableGlueTaskDocument, options);
      }
export type EnableGlueTaskMutationHookResult = ReturnType<typeof useEnableGlueTaskMutation>;
export type EnableGlueTaskMutationResult = ApolloReactCommon.MutationResult<EnableGlueTaskMutation>;
export type EnableGlueTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<EnableGlueTaskMutation, EnableGlueTaskMutationVariables>;
export const DisableGlueTaskDocument = gql`
    mutation DisableGlueTask($id: ID!) {
  disableGlueTask(input: {id: $id}) {
    success
    clientMutationId
  }
}
    `;
export type DisableGlueTaskMutationFn = ApolloReactCommon.MutationFunction<DisableGlueTaskMutation, DisableGlueTaskMutationVariables>;

/**
 * __useDisableGlueTaskMutation__
 *
 * To run a mutation, you first call `useDisableGlueTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableGlueTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableGlueTaskMutation, { data, loading, error }] = useDisableGlueTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableGlueTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisableGlueTaskMutation, DisableGlueTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisableGlueTaskMutation, DisableGlueTaskMutationVariables>(DisableGlueTaskDocument, options);
      }
export type DisableGlueTaskMutationHookResult = ReturnType<typeof useDisableGlueTaskMutation>;
export type DisableGlueTaskMutationResult = ApolloReactCommon.MutationResult<DisableGlueTaskMutation>;
export type DisableGlueTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<DisableGlueTaskMutation, DisableGlueTaskMutationVariables>;
export const DeleteGlueTaskDocument = gql`
    mutation DeleteGlueTask($id: ID!) {
  deleteGlueTask(input: {id: $id}) {
    success
    clientMutationId
  }
}
    `;
export type DeleteGlueTaskMutationFn = ApolloReactCommon.MutationFunction<DeleteGlueTaskMutation, DeleteGlueTaskMutationVariables>;

/**
 * __useDeleteGlueTaskMutation__
 *
 * To run a mutation, you first call `useDeleteGlueTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGlueTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGlueTaskMutation, { data, loading, error }] = useDeleteGlueTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGlueTaskMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteGlueTaskMutation, DeleteGlueTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteGlueTaskMutation, DeleteGlueTaskMutationVariables>(DeleteGlueTaskDocument, options);
      }
export type DeleteGlueTaskMutationHookResult = ReturnType<typeof useDeleteGlueTaskMutation>;
export type DeleteGlueTaskMutationResult = ApolloReactCommon.MutationResult<DeleteGlueTaskMutation>;
export type DeleteGlueTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteGlueTaskMutation, DeleteGlueTaskMutationVariables>;
export const HomePageViewerDetailsDocument = gql`
    query HomePageViewerDetails($entityName: String) {
  viewer(entityName: $entityName) {
    id
    username
    name
    photoUrl
    organizations {
      id
      name
    }
    defaultEntity {
      id
      name
    }
    teams(first: 100) {
      edges {
        node {
          id
          name
          photoUrl
        }
      }
    }
  }
}
    `;

/**
 * __useHomePageViewerDetailsQuery__
 *
 * To run a query within a React component, call `useHomePageViewerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageViewerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageViewerDetailsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useHomePageViewerDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>(HomePageViewerDetailsDocument, options);
      }
export function useHomePageViewerDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>(HomePageViewerDetailsDocument, options);
        }
// @ts-ignore
export function useHomePageViewerDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>;
export function useHomePageViewerDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HomePageViewerDetailsQuery | undefined, HomePageViewerDetailsQueryVariables>;
export function useHomePageViewerDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>(HomePageViewerDetailsDocument, options);
        }
export type HomePageViewerDetailsQueryHookResult = ReturnType<typeof useHomePageViewerDetailsQuery>;
export type HomePageViewerDetailsLazyQueryHookResult = ReturnType<typeof useHomePageViewerDetailsLazyQuery>;
export type HomePageViewerDetailsSuspenseQueryHookResult = ReturnType<typeof useHomePageViewerDetailsSuspenseQuery>;
export type HomePageViewerDetailsQueryResult = ApolloReactCommon.QueryResult<HomePageViewerDetailsQuery, HomePageViewerDetailsQueryVariables>;
export const HomePageViewerProjectsDocument = gql`
    query HomePageViewerProjects($entityName: String!, $first: Int = 20, $pattern: String) {
  projects(
    entityName: $entityName
    first: $first
    pattern: $pattern
    order: "-created_at"
  ) {
    edges {
      node {
        id
        name
        entityName
        access
        createdAt
      }
    }
  }
}
    `;

/**
 * __useHomePageViewerProjectsQuery__
 *
 * To run a query within a React component, call `useHomePageViewerProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageViewerProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageViewerProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      first: // value for 'first'
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useHomePageViewerProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables> & ({ variables: HomePageViewerProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables>(HomePageViewerProjectsDocument, options);
      }
export function useHomePageViewerProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables>(HomePageViewerProjectsDocument, options);
        }
// @ts-ignore
export function useHomePageViewerProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables>;
export function useHomePageViewerProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HomePageViewerProjectsQuery | undefined, HomePageViewerProjectsQueryVariables>;
export function useHomePageViewerProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables>(HomePageViewerProjectsDocument, options);
        }
export type HomePageViewerProjectsQueryHookResult = ReturnType<typeof useHomePageViewerProjectsQuery>;
export type HomePageViewerProjectsLazyQueryHookResult = ReturnType<typeof useHomePageViewerProjectsLazyQuery>;
export type HomePageViewerProjectsSuspenseQueryHookResult = ReturnType<typeof useHomePageViewerProjectsSuspenseQuery>;
export type HomePageViewerProjectsQueryResult = ApolloReactCommon.QueryResult<HomePageViewerProjectsQuery, HomePageViewerProjectsQueryVariables>;
export const EntityProjectsDocument = gql`
    query EntityProjects($entityName: String!, $first: Int = 20) {
  entity(name: $entityName) {
    id
    projects(first: $first) {
      edges {
        node {
          id
          ...AccountProjectFragment
        }
      }
    }
  }
}
    ${AccountProjectFragmentFragmentDoc}`;

/**
 * __useEntityProjectsQuery__
 *
 * To run a query within a React component, call `useEntityProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useEntityProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityProjectsQuery, EntityProjectsQueryVariables> & ({ variables: EntityProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityProjectsQuery, EntityProjectsQueryVariables>(EntityProjectsDocument, options);
      }
export function useEntityProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityProjectsQuery, EntityProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityProjectsQuery, EntityProjectsQueryVariables>(EntityProjectsDocument, options);
        }
// @ts-ignore
export function useEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityProjectsQuery, EntityProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityProjectsQuery, EntityProjectsQueryVariables>;
export function useEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityProjectsQuery, EntityProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityProjectsQuery | undefined, EntityProjectsQueryVariables>;
export function useEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityProjectsQuery, EntityProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityProjectsQuery, EntityProjectsQueryVariables>(EntityProjectsDocument, options);
        }
export type EntityProjectsQueryHookResult = ReturnType<typeof useEntityProjectsQuery>;
export type EntityProjectsLazyQueryHookResult = ReturnType<typeof useEntityProjectsLazyQuery>;
export type EntityProjectsSuspenseQueryHookResult = ReturnType<typeof useEntityProjectsSuspenseQuery>;
export type EntityProjectsQueryResult = ApolloReactCommon.QueryResult<EntityProjectsQuery, EntityProjectsQueryVariables>;
export const EntityReportsDocument = gql`
    query EntityReports($entityName: String!, $first: Int = 100, $offset: Int = 0, $displayNameContains: String) {
  entity(name: $entityName) {
    id
    views(first: $first, offset: $offset, displayNameContains: $displayNameContains) {
      totalCount
      edges {
        node {
          id
          ...ReportsTableFragment
        }
      }
    }
  }
}
    ${ReportsTableFragmentFragmentDoc}`;

/**
 * __useEntityReportsQuery__
 *
 * To run a query within a React component, call `useEntityReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityReportsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *      displayNameContains: // value for 'displayNameContains'
 *   },
 * });
 */
export function useEntityReportsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityReportsQuery, EntityReportsQueryVariables> & ({ variables: EntityReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityReportsQuery, EntityReportsQueryVariables>(EntityReportsDocument, options);
      }
export function useEntityReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityReportsQuery, EntityReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityReportsQuery, EntityReportsQueryVariables>(EntityReportsDocument, options);
        }
// @ts-ignore
export function useEntityReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityReportsQuery, EntityReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityReportsQuery, EntityReportsQueryVariables>;
export function useEntityReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityReportsQuery, EntityReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityReportsQuery | undefined, EntityReportsQueryVariables>;
export function useEntityReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityReportsQuery, EntityReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityReportsQuery, EntityReportsQueryVariables>(EntityReportsDocument, options);
        }
export type EntityReportsQueryHookResult = ReturnType<typeof useEntityReportsQuery>;
export type EntityReportsLazyQueryHookResult = ReturnType<typeof useEntityReportsLazyQuery>;
export type EntityReportsSuspenseQueryHookResult = ReturnType<typeof useEntityReportsSuspenseQuery>;
export type EntityReportsQueryResult = ApolloReactCommon.QueryResult<EntityReportsQuery, EntityReportsQueryVariables>;
export const OrganizationReportsDocument = gql`
    query OrganizationReports($orgID: ID!, $userID: ID, $first: Int = 100, $offset: Int = 0, $displayNameContains: String) {
  organization(id: $orgID) {
    id
    views(
      first: $first
      offset: $offset
      userID: $userID
      displayNameContains: $displayNameContains
    ) {
      totalCount
      edges {
        node {
          id
          ...ReportsTableFragment
        }
      }
    }
  }
}
    ${ReportsTableFragmentFragmentDoc}`;

/**
 * __useOrganizationReportsQuery__
 *
 * To run a query within a React component, call `useOrganizationReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationReportsQuery({
 *   variables: {
 *      orgID: // value for 'orgID'
 *      userID: // value for 'userID'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *      displayNameContains: // value for 'displayNameContains'
 *   },
 * });
 */
export function useOrganizationReportsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationReportsQuery, OrganizationReportsQueryVariables> & ({ variables: OrganizationReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationReportsQuery, OrganizationReportsQueryVariables>(OrganizationReportsDocument, options);
      }
export function useOrganizationReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationReportsQuery, OrganizationReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationReportsQuery, OrganizationReportsQueryVariables>(OrganizationReportsDocument, options);
        }
// @ts-ignore
export function useOrganizationReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationReportsQuery, OrganizationReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationReportsQuery, OrganizationReportsQueryVariables>;
export function useOrganizationReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationReportsQuery, OrganizationReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationReportsQuery | undefined, OrganizationReportsQueryVariables>;
export function useOrganizationReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationReportsQuery, OrganizationReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationReportsQuery, OrganizationReportsQueryVariables>(OrganizationReportsDocument, options);
        }
export type OrganizationReportsQueryHookResult = ReturnType<typeof useOrganizationReportsQuery>;
export type OrganizationReportsLazyQueryHookResult = ReturnType<typeof useOrganizationReportsLazyQuery>;
export type OrganizationReportsSuspenseQueryHookResult = ReturnType<typeof useOrganizationReportsSuspenseQuery>;
export type OrganizationReportsQueryResult = ApolloReactCommon.QueryResult<OrganizationReportsQuery, OrganizationReportsQueryVariables>;
export const AccountTeamsDocument = gql`
    query AccountTeams {
  viewer {
    id
    name
    username
    teams {
      edges {
        node {
          id
          isTeam
          entityType
          organizationId
          name
          defaultAccess
          privateOnly
          settings {
            hidden
          }
          members {
            id
            name
            username
            memberRole {
              name
            }
            email
            pending
            photoUrl
            accountType
            role
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAccountTeamsQuery__
 *
 * To run a query within a React component, call `useAccountTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountTeamsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountTeamsQuery, AccountTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountTeamsQuery, AccountTeamsQueryVariables>(AccountTeamsDocument, options);
      }
export function useAccountTeamsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountTeamsQuery, AccountTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountTeamsQuery, AccountTeamsQueryVariables>(AccountTeamsDocument, options);
        }
// @ts-ignore
export function useAccountTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AccountTeamsQuery, AccountTeamsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountTeamsQuery, AccountTeamsQueryVariables>;
export function useAccountTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountTeamsQuery, AccountTeamsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountTeamsQuery | undefined, AccountTeamsQueryVariables>;
export function useAccountTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountTeamsQuery, AccountTeamsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccountTeamsQuery, AccountTeamsQueryVariables>(AccountTeamsDocument, options);
        }
export type AccountTeamsQueryHookResult = ReturnType<typeof useAccountTeamsQuery>;
export type AccountTeamsLazyQueryHookResult = ReturnType<typeof useAccountTeamsLazyQuery>;
export type AccountTeamsSuspenseQueryHookResult = ReturnType<typeof useAccountTeamsSuspenseQuery>;
export type AccountTeamsQueryResult = ApolloReactCommon.QueryResult<AccountTeamsQuery, AccountTeamsQueryVariables>;
export const CreateSlackIntegrationDocument = gql`
    mutation CreateSlackIntegration($code: String!, $entityName: String!, $redirectURI: String!) {
  createSlackIntegration(
    input: {code: $code, entityName: $entityName, redirectURI: $redirectURI}
  ) {
    integration {
      id
    }
  }
}
    `;
export type CreateSlackIntegrationMutationFn = ApolloReactCommon.MutationFunction<CreateSlackIntegrationMutation, CreateSlackIntegrationMutationVariables>;

/**
 * __useCreateSlackIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateSlackIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSlackIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSlackIntegrationMutation, { data, loading, error }] = useCreateSlackIntegrationMutation({
 *   variables: {
 *      code: // value for 'code'
 *      entityName: // value for 'entityName'
 *      redirectURI: // value for 'redirectURI'
 *   },
 * });
 */
export function useCreateSlackIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSlackIntegrationMutation, CreateSlackIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSlackIntegrationMutation, CreateSlackIntegrationMutationVariables>(CreateSlackIntegrationDocument, options);
      }
export type CreateSlackIntegrationMutationHookResult = ReturnType<typeof useCreateSlackIntegrationMutation>;
export type CreateSlackIntegrationMutationResult = ApolloReactCommon.MutationResult<CreateSlackIntegrationMutation>;
export type CreateSlackIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSlackIntegrationMutation, CreateSlackIntegrationMutationVariables>;
export const CreateGenericWebhookIntegrationDocument = gql`
    mutation CreateGenericWebhookIntegration($entityName: String!, $webhookName: String!, $urlEndpoint: String!, $accessTokenRef: String, $secretRef: String) {
  createGenericWebhookIntegration(
    input: {entityName: $entityName, name: $webhookName, urlEndpoint: $urlEndpoint, accessTokenRef: $accessTokenRef, secretRef: $secretRef}
  ) {
    integration {
      __typename
      ... on GenericWebhookIntegration {
        id
        urlEndpoint
        name
      }
    }
  }
}
    `;
export type CreateGenericWebhookIntegrationMutationFn = ApolloReactCommon.MutationFunction<CreateGenericWebhookIntegrationMutation, CreateGenericWebhookIntegrationMutationVariables>;

/**
 * __useCreateGenericWebhookIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateGenericWebhookIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenericWebhookIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGenericWebhookIntegrationMutation, { data, loading, error }] = useCreateGenericWebhookIntegrationMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      webhookName: // value for 'webhookName'
 *      urlEndpoint: // value for 'urlEndpoint'
 *      accessTokenRef: // value for 'accessTokenRef'
 *      secretRef: // value for 'secretRef'
 *   },
 * });
 */
export function useCreateGenericWebhookIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateGenericWebhookIntegrationMutation, CreateGenericWebhookIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateGenericWebhookIntegrationMutation, CreateGenericWebhookIntegrationMutationVariables>(CreateGenericWebhookIntegrationDocument, options);
      }
export type CreateGenericWebhookIntegrationMutationHookResult = ReturnType<typeof useCreateGenericWebhookIntegrationMutation>;
export type CreateGenericWebhookIntegrationMutationResult = ApolloReactCommon.MutationResult<CreateGenericWebhookIntegrationMutation>;
export type CreateGenericWebhookIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateGenericWebhookIntegrationMutation, CreateGenericWebhookIntegrationMutationVariables>;
export const UpdateGenericWebhookIntegrationDocument = gql`
    mutation UpdateGenericWebhookIntegration($integrationID: ID!, $webhookName: String, $urlEndpoint: String, $accessTokenRef: String, $secretRef: String) {
  updateGenericWebhookIntegration(
    input: {id: $integrationID, name: $webhookName, urlEndpoint: $urlEndpoint, accessTokenRef: $accessTokenRef, secretRef: $secretRef}
  ) {
    integration {
      __typename
      ... on GenericWebhookIntegration {
        id
        urlEndpoint
        name
      }
    }
  }
}
    `;
export type UpdateGenericWebhookIntegrationMutationFn = ApolloReactCommon.MutationFunction<UpdateGenericWebhookIntegrationMutation, UpdateGenericWebhookIntegrationMutationVariables>;

/**
 * __useUpdateGenericWebhookIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateGenericWebhookIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGenericWebhookIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGenericWebhookIntegrationMutation, { data, loading, error }] = useUpdateGenericWebhookIntegrationMutation({
 *   variables: {
 *      integrationID: // value for 'integrationID'
 *      webhookName: // value for 'webhookName'
 *      urlEndpoint: // value for 'urlEndpoint'
 *      accessTokenRef: // value for 'accessTokenRef'
 *      secretRef: // value for 'secretRef'
 *   },
 * });
 */
export function useUpdateGenericWebhookIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateGenericWebhookIntegrationMutation, UpdateGenericWebhookIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateGenericWebhookIntegrationMutation, UpdateGenericWebhookIntegrationMutationVariables>(UpdateGenericWebhookIntegrationDocument, options);
      }
export type UpdateGenericWebhookIntegrationMutationHookResult = ReturnType<typeof useUpdateGenericWebhookIntegrationMutation>;
export type UpdateGenericWebhookIntegrationMutationResult = ApolloReactCommon.MutationResult<UpdateGenericWebhookIntegrationMutation>;
export type UpdateGenericWebhookIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateGenericWebhookIntegrationMutation, UpdateGenericWebhookIntegrationMutationVariables>;
export const TestGenericWebhookIntegrationDocument = gql`
    mutation TestGenericWebhookIntegration($entityName: String!, $urlEndpoint: String!, $accessTokenRef: String, $secretRef: String, $requestPayload: JSONString) {
  testGenericWebhookIntegration(
    input: {entityName: $entityName, urlEndpoint: $urlEndpoint, accessTokenRef: $accessTokenRef, secretRef: $secretRef, requestPayload: $requestPayload}
  ) {
    ok
    response
  }
}
    `;
export type TestGenericWebhookIntegrationMutationFn = ApolloReactCommon.MutationFunction<TestGenericWebhookIntegrationMutation, TestGenericWebhookIntegrationMutationVariables>;

/**
 * __useTestGenericWebhookIntegrationMutation__
 *
 * To run a mutation, you first call `useTestGenericWebhookIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestGenericWebhookIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testGenericWebhookIntegrationMutation, { data, loading, error }] = useTestGenericWebhookIntegrationMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      urlEndpoint: // value for 'urlEndpoint'
 *      accessTokenRef: // value for 'accessTokenRef'
 *      secretRef: // value for 'secretRef'
 *      requestPayload: // value for 'requestPayload'
 *   },
 * });
 */
export function useTestGenericWebhookIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TestGenericWebhookIntegrationMutation, TestGenericWebhookIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TestGenericWebhookIntegrationMutation, TestGenericWebhookIntegrationMutationVariables>(TestGenericWebhookIntegrationDocument, options);
      }
export type TestGenericWebhookIntegrationMutationHookResult = ReturnType<typeof useTestGenericWebhookIntegrationMutation>;
export type TestGenericWebhookIntegrationMutationResult = ApolloReactCommon.MutationResult<TestGenericWebhookIntegrationMutation>;
export type TestGenericWebhookIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<TestGenericWebhookIntegrationMutation, TestGenericWebhookIntegrationMutationVariables>;
export const DeleteIntegrationDocument = gql`
    mutation DeleteIntegration($id: ID!) {
  deleteIntegration(input: {id: $id}) {
    success
  }
}
    `;
export type DeleteIntegrationMutationFn = ApolloReactCommon.MutationFunction<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>;

/**
 * __useDeleteIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIntegrationMutation, { data, loading, error }] = useDeleteIntegrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>(DeleteIntegrationDocument, options);
      }
export type DeleteIntegrationMutationHookResult = ReturnType<typeof useDeleteIntegrationMutation>;
export type DeleteIntegrationMutationResult = ApolloReactCommon.MutationResult<DeleteIntegrationMutation>;
export type DeleteIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteIntegrationMutation, DeleteIntegrationMutationVariables>;
export const FetchLaunchAgentsFromProjectDocument = gql`
    query fetchLaunchAgentsFromProject($entityName: String!, $projectName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    launchAgents {
      id
      name
      createdAt
      agentStatus
      stopPolling
      runQueues
      hostname
      agentConfig
      version
    }
  }
}
    `;

/**
 * __useFetchLaunchAgentsFromProjectQuery__
 *
 * To run a query within a React component, call `useFetchLaunchAgentsFromProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLaunchAgentsFromProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLaunchAgentsFromProjectQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useFetchLaunchAgentsFromProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables> & ({ variables: FetchLaunchAgentsFromProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables>(FetchLaunchAgentsFromProjectDocument, options);
      }
export function useFetchLaunchAgentsFromProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables>(FetchLaunchAgentsFromProjectDocument, options);
        }
// @ts-ignore
export function useFetchLaunchAgentsFromProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables>;
export function useFetchLaunchAgentsFromProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchLaunchAgentsFromProjectQuery | undefined, FetchLaunchAgentsFromProjectQueryVariables>;
export function useFetchLaunchAgentsFromProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables>(FetchLaunchAgentsFromProjectDocument, options);
        }
export type FetchLaunchAgentsFromProjectQueryHookResult = ReturnType<typeof useFetchLaunchAgentsFromProjectQuery>;
export type FetchLaunchAgentsFromProjectLazyQueryHookResult = ReturnType<typeof useFetchLaunchAgentsFromProjectLazyQuery>;
export type FetchLaunchAgentsFromProjectSuspenseQueryHookResult = ReturnType<typeof useFetchLaunchAgentsFromProjectSuspenseQuery>;
export type FetchLaunchAgentsFromProjectQueryResult = ApolloReactCommon.QueryResult<FetchLaunchAgentsFromProjectQuery, FetchLaunchAgentsFromProjectQueryVariables>;
export const StopLaunchAgentDocument = gql`
    mutation stopLaunchAgent($agentId: ID!, $stopPolling: Boolean) {
  updateLaunchAgent(input: {launchAgentId: $agentId, stopPolling: $stopPolling}) {
    success
  }
}
    `;
export type StopLaunchAgentMutationFn = ApolloReactCommon.MutationFunction<StopLaunchAgentMutation, StopLaunchAgentMutationVariables>;

/**
 * __useStopLaunchAgentMutation__
 *
 * To run a mutation, you first call `useStopLaunchAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopLaunchAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopLaunchAgentMutation, { data, loading, error }] = useStopLaunchAgentMutation({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      stopPolling: // value for 'stopPolling'
 *   },
 * });
 */
export function useStopLaunchAgentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StopLaunchAgentMutation, StopLaunchAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StopLaunchAgentMutation, StopLaunchAgentMutationVariables>(StopLaunchAgentDocument, options);
      }
export type StopLaunchAgentMutationHookResult = ReturnType<typeof useStopLaunchAgentMutation>;
export type StopLaunchAgentMutationResult = ApolloReactCommon.MutationResult<StopLaunchAgentMutation>;
export type StopLaunchAgentMutationOptions = ApolloReactCommon.BaseMutationOptions<StopLaunchAgentMutation, StopLaunchAgentMutationVariables>;
export const DeleteLaunchAgentsDocument = gql`
    mutation deleteLaunchAgents($agentIds: [ID!]!) {
  deleteLaunchAgents(input: {launchAgentIds: $agentIds}) {
    success
  }
}
    `;
export type DeleteLaunchAgentsMutationFn = ApolloReactCommon.MutationFunction<DeleteLaunchAgentsMutation, DeleteLaunchAgentsMutationVariables>;

/**
 * __useDeleteLaunchAgentsMutation__
 *
 * To run a mutation, you first call `useDeleteLaunchAgentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLaunchAgentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLaunchAgentsMutation, { data, loading, error }] = useDeleteLaunchAgentsMutation({
 *   variables: {
 *      agentIds: // value for 'agentIds'
 *   },
 * });
 */
export function useDeleteLaunchAgentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteLaunchAgentsMutation, DeleteLaunchAgentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteLaunchAgentsMutation, DeleteLaunchAgentsMutationVariables>(DeleteLaunchAgentsDocument, options);
      }
export type DeleteLaunchAgentsMutationHookResult = ReturnType<typeof useDeleteLaunchAgentsMutation>;
export type DeleteLaunchAgentsMutationResult = ApolloReactCommon.MutationResult<DeleteLaunchAgentsMutation>;
export type DeleteLaunchAgentsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteLaunchAgentsMutation, DeleteLaunchAgentsMutationVariables>;
export const HasLocalLicenseDocument = gql`
    query HasLocalLicense {
  serverInfo {
    hasLocalLicense
  }
}
    `;

/**
 * __useHasLocalLicenseQuery__
 *
 * To run a query within a React component, call `useHasLocalLicenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasLocalLicenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasLocalLicenseQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasLocalLicenseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>(HasLocalLicenseDocument, options);
      }
export function useHasLocalLicenseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>(HasLocalLicenseDocument, options);
        }
// @ts-ignore
export function useHasLocalLicenseSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>;
export function useHasLocalLicenseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HasLocalLicenseQuery | undefined, HasLocalLicenseQueryVariables>;
export function useHasLocalLicenseSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>(HasLocalLicenseDocument, options);
        }
export type HasLocalLicenseQueryHookResult = ReturnType<typeof useHasLocalLicenseQuery>;
export type HasLocalLicenseLazyQueryHookResult = ReturnType<typeof useHasLocalLicenseLazyQuery>;
export type HasLocalLicenseSuspenseQueryHookResult = ReturnType<typeof useHasLocalLicenseSuspenseQuery>;
export type HasLocalLicenseQueryResult = ApolloReactCommon.QueryResult<HasLocalLicenseQuery, HasLocalLicenseQueryVariables>;
export const LatestLocalVersionInfoDocument = gql`
    query latestLocalVersionInfo {
  serverInfo {
    latestLocalVersionInfo {
      outOfDate
      latestVersionString
      versionOnThisInstanceString
    }
  }
}
    `;

/**
 * __useLatestLocalVersionInfoQuery__
 *
 * To run a query within a React component, call `useLatestLocalVersionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestLocalVersionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestLocalVersionInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useLatestLocalVersionInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>(LatestLocalVersionInfoDocument, options);
      }
export function useLatestLocalVersionInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>(LatestLocalVersionInfoDocument, options);
        }
// @ts-ignore
export function useLatestLocalVersionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>;
export function useLatestLocalVersionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LatestLocalVersionInfoQuery | undefined, LatestLocalVersionInfoQueryVariables>;
export function useLatestLocalVersionInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>(LatestLocalVersionInfoDocument, options);
        }
export type LatestLocalVersionInfoQueryHookResult = ReturnType<typeof useLatestLocalVersionInfoQuery>;
export type LatestLocalVersionInfoLazyQueryHookResult = ReturnType<typeof useLatestLocalVersionInfoLazyQuery>;
export type LatestLocalVersionInfoSuspenseQueryHookResult = ReturnType<typeof useLatestLocalVersionInfoSuspenseQuery>;
export type LatestLocalVersionInfoQueryResult = ApolloReactCommon.QueryResult<LatestLocalVersionInfoQuery, LatestLocalVersionInfoQueryVariables>;
export const AvailableFilesQueryDocument = gql`
    query AvailableFilesQuery($projectName: String!, $entityName: String!, $runName: String!, $filenames: [String!]!, $includeDirectUrl: Boolean!, $includeThumbnails: Boolean = false, $includeHlsSrc: Boolean = false) {
  project(entityName: $entityName, name: $projectName) {
    id
    run(name: $runName) {
      id
      files(names: $filenames) {
        edges {
          node {
            id
            name
            directUrl @include(if: $includeDirectUrl)
            url(upload: false)
            md5
            sizeBytes
            thumbnails @include(if: $includeThumbnails) {
              size
              directUrl
              originalImageWidth
              originalImageHeight
            }
            hlsSrc @include(if: $includeHlsSrc)
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAvailableFilesQueryQuery__
 *
 * To run a query within a React component, call `useAvailableFilesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableFilesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableFilesQueryQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      filenames: // value for 'filenames'
 *      includeDirectUrl: // value for 'includeDirectUrl'
 *      includeThumbnails: // value for 'includeThumbnails'
 *      includeHlsSrc: // value for 'includeHlsSrc'
 *   },
 * });
 */
export function useAvailableFilesQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables> & ({ variables: AvailableFilesQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables>(AvailableFilesQueryDocument, options);
      }
export function useAvailableFilesQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables>(AvailableFilesQueryDocument, options);
        }
// @ts-ignore
export function useAvailableFilesQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables>;
export function useAvailableFilesQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AvailableFilesQueryQuery | undefined, AvailableFilesQueryQueryVariables>;
export function useAvailableFilesQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables>(AvailableFilesQueryDocument, options);
        }
export type AvailableFilesQueryQueryHookResult = ReturnType<typeof useAvailableFilesQueryQuery>;
export type AvailableFilesQueryLazyQueryHookResult = ReturnType<typeof useAvailableFilesQueryLazyQuery>;
export type AvailableFilesQuerySuspenseQueryHookResult = ReturnType<typeof useAvailableFilesQuerySuspenseQuery>;
export type AvailableFilesQueryQueryResult = ApolloReactCommon.QueryResult<AvailableFilesQueryQuery, AvailableFilesQueryQueryVariables>;
export const DirectUrlQueryDocument = gql`
    query DirectUrlQuery($projectName: String!, $entityName: String!, $runName: String!, $filenames: [String!]!) {
  project(entityName: $entityName, name: $projectName) {
    id
    run(name: $runName) {
      id
      files(names: $filenames) {
        edges {
          node {
            id
            name
            directUrl
            url(upload: false)
            thumbnails {
              size
              directUrl
              originalImageWidth
              originalImageHeight
            }
            hlsSrc
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDirectUrlQueryQuery__
 *
 * To run a query within a React component, call `useDirectUrlQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDirectUrlQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectUrlQueryQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      filenames: // value for 'filenames'
 *   },
 * });
 */
export function useDirectUrlQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DirectUrlQueryQuery, DirectUrlQueryQueryVariables> & ({ variables: DirectUrlQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DirectUrlQueryQuery, DirectUrlQueryQueryVariables>(DirectUrlQueryDocument, options);
      }
export function useDirectUrlQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DirectUrlQueryQuery, DirectUrlQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DirectUrlQueryQuery, DirectUrlQueryQueryVariables>(DirectUrlQueryDocument, options);
        }
// @ts-ignore
export function useDirectUrlQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DirectUrlQueryQuery, DirectUrlQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DirectUrlQueryQuery, DirectUrlQueryQueryVariables>;
export function useDirectUrlQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DirectUrlQueryQuery, DirectUrlQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DirectUrlQueryQuery | undefined, DirectUrlQueryQueryVariables>;
export function useDirectUrlQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DirectUrlQueryQuery, DirectUrlQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DirectUrlQueryQuery, DirectUrlQueryQueryVariables>(DirectUrlQueryDocument, options);
        }
export type DirectUrlQueryQueryHookResult = ReturnType<typeof useDirectUrlQueryQuery>;
export type DirectUrlQueryLazyQueryHookResult = ReturnType<typeof useDirectUrlQueryLazyQuery>;
export type DirectUrlQuerySuspenseQueryHookResult = ReturnType<typeof useDirectUrlQuerySuspenseQuery>;
export type DirectUrlQueryQueryResult = ApolloReactCommon.QueryResult<DirectUrlQueryQuery, DirectUrlQueryQueryVariables>;
export const ArtifactCodeFileQueryDocument = gql`
    query ArtifactCodeFileQuery($projectName: String!, $entityName: String!, $runName: String!, $filenames: [String!]!) {
  project(entityName: $entityName, name: $projectName) {
    id
    run(name: $runName) {
      id
      outputArtifacts {
        edges {
          node {
            id
            files(names: $filenames) {
              edges {
                node {
                  id
                  name
                  url(upload: false)
                  directUrl
                  sizeBytes
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactCodeFileQueryQuery__
 *
 * To run a query within a React component, call `useArtifactCodeFileQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCodeFileQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCodeFileQueryQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      filenames: // value for 'filenames'
 *   },
 * });
 */
export function useArtifactCodeFileQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables> & ({ variables: ArtifactCodeFileQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables>(ArtifactCodeFileQueryDocument, options);
      }
export function useArtifactCodeFileQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables>(ArtifactCodeFileQueryDocument, options);
        }
// @ts-ignore
export function useArtifactCodeFileQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables>;
export function useArtifactCodeFileQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCodeFileQueryQuery | undefined, ArtifactCodeFileQueryQueryVariables>;
export function useArtifactCodeFileQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables>(ArtifactCodeFileQueryDocument, options);
        }
export type ArtifactCodeFileQueryQueryHookResult = ReturnType<typeof useArtifactCodeFileQueryQuery>;
export type ArtifactCodeFileQueryLazyQueryHookResult = ReturnType<typeof useArtifactCodeFileQueryLazyQuery>;
export type ArtifactCodeFileQuerySuspenseQueryHookResult = ReturnType<typeof useArtifactCodeFileQuerySuspenseQuery>;
export type ArtifactCodeFileQueryQueryResult = ApolloReactCommon.QueryResult<ArtifactCodeFileQueryQuery, ArtifactCodeFileQueryQueryVariables>;
export const MetricSearchDocument = gql`
    query MetricSearch($projectName: String!, $entityName: String!, $filters: JSONString, $metricNamePattern: String, $runLimit: Int = 100, $runOrder: String, $keysPageSize: Int = 100, $cursor: String, $requiredRunKeys: [String!], $metricTypes: [String!]) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(
      filters: $filters
      first: $runLimit
      order: $runOrder
      requiredRunKeys: $requiredRunKeys
    ) {
      metricSearch(
        pageSize: $keysPageSize
        cursor: $cursor
        metricNamePattern: $metricNamePattern
        metricTypes: $metricTypes
      ) {
        results {
          key
          types
          latestType
          column
        }
        cursor
        hasMore
      }
    }
  }
}
    `;

/**
 * __useMetricSearchQuery__
 *
 * To run a query within a React component, call `useMetricSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricSearchQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      metricNamePattern: // value for 'metricNamePattern'
 *      runLimit: // value for 'runLimit'
 *      runOrder: // value for 'runOrder'
 *      keysPageSize: // value for 'keysPageSize'
 *      cursor: // value for 'cursor'
 *      requiredRunKeys: // value for 'requiredRunKeys'
 *      metricTypes: // value for 'metricTypes'
 *   },
 * });
 */
export function useMetricSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MetricSearchQuery, MetricSearchQueryVariables> & ({ variables: MetricSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetricSearchQuery, MetricSearchQueryVariables>(MetricSearchDocument, options);
      }
export function useMetricSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetricSearchQuery, MetricSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetricSearchQuery, MetricSearchQueryVariables>(MetricSearchDocument, options);
        }
// @ts-ignore
export function useMetricSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MetricSearchQuery, MetricSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MetricSearchQuery, MetricSearchQueryVariables>;
export function useMetricSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MetricSearchQuery, MetricSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MetricSearchQuery | undefined, MetricSearchQueryVariables>;
export function useMetricSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MetricSearchQuery, MetricSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MetricSearchQuery, MetricSearchQueryVariables>(MetricSearchDocument, options);
        }
export type MetricSearchQueryHookResult = ReturnType<typeof useMetricSearchQuery>;
export type MetricSearchLazyQueryHookResult = ReturnType<typeof useMetricSearchLazyQuery>;
export type MetricSearchSuspenseQueryHookResult = ReturnType<typeof useMetricSearchSuspenseQuery>;
export type MetricSearchQueryResult = ApolloReactCommon.QueryResult<MetricSearchQuery, MetricSearchQueryVariables>;
export const AddWorkflowsAdminDocument = gql`
    mutation AddWorkflowsAdmin($entityName: String!, $username: String, $userID: ID, $adminType: WorkflowsAdminType!) {
  addWorkflowsAdmin(
    input: {entityName: $entityName, username: $username, userID: $userID, adminType: $adminType}
  ) {
    success
  }
}
    `;
export type AddWorkflowsAdminMutationFn = ApolloReactCommon.MutationFunction<AddWorkflowsAdminMutation, AddWorkflowsAdminMutationVariables>;

/**
 * __useAddWorkflowsAdminMutation__
 *
 * To run a mutation, you first call `useAddWorkflowsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWorkflowsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWorkflowsAdminMutation, { data, loading, error }] = useAddWorkflowsAdminMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      username: // value for 'username'
 *      userID: // value for 'userID'
 *      adminType: // value for 'adminType'
 *   },
 * });
 */
export function useAddWorkflowsAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddWorkflowsAdminMutation, AddWorkflowsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddWorkflowsAdminMutation, AddWorkflowsAdminMutationVariables>(AddWorkflowsAdminDocument, options);
      }
export type AddWorkflowsAdminMutationHookResult = ReturnType<typeof useAddWorkflowsAdminMutation>;
export type AddWorkflowsAdminMutationResult = ApolloReactCommon.MutationResult<AddWorkflowsAdminMutation>;
export type AddWorkflowsAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<AddWorkflowsAdminMutation, AddWorkflowsAdminMutationVariables>;
export const DeleteWorkflowsAdminDocument = gql`
    mutation DeleteWorkflowsAdmin($entityName: String!, $username: String, $userID: ID, $adminType: WorkflowsAdminType!) {
  deleteWorkflowsAdmin(
    input: {entityName: $entityName, username: $username, userID: $userID, adminType: $adminType}
  ) {
    success
  }
}
    `;
export type DeleteWorkflowsAdminMutationFn = ApolloReactCommon.MutationFunction<DeleteWorkflowsAdminMutation, DeleteWorkflowsAdminMutationVariables>;

/**
 * __useDeleteWorkflowsAdminMutation__
 *
 * To run a mutation, you first call `useDeleteWorkflowsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkflowsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkflowsAdminMutation, { data, loading, error }] = useDeleteWorkflowsAdminMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      username: // value for 'username'
 *      userID: // value for 'userID'
 *      adminType: // value for 'adminType'
 *   },
 * });
 */
export function useDeleteWorkflowsAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteWorkflowsAdminMutation, DeleteWorkflowsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteWorkflowsAdminMutation, DeleteWorkflowsAdminMutationVariables>(DeleteWorkflowsAdminDocument, options);
      }
export type DeleteWorkflowsAdminMutationHookResult = ReturnType<typeof useDeleteWorkflowsAdminMutation>;
export type DeleteWorkflowsAdminMutationResult = ApolloReactCommon.MutationResult<DeleteWorkflowsAdminMutation>;
export type DeleteWorkflowsAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteWorkflowsAdminMutation, DeleteWorkflowsAdminMutationVariables>;
export const AddProtectedAliasesDocument = gql`
    mutation AddProtectedAliases($entityName: String!, $aliases: [String!]!, $adminType: WorkflowsAdminType!) {
  addProtectedAliases(
    input: {entityName: $entityName, aliases: $aliases, adminType: $adminType}
  ) {
    aliases
  }
}
    `;
export type AddProtectedAliasesMutationFn = ApolloReactCommon.MutationFunction<AddProtectedAliasesMutation, AddProtectedAliasesMutationVariables>;

/**
 * __useAddProtectedAliasesMutation__
 *
 * To run a mutation, you first call `useAddProtectedAliasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProtectedAliasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProtectedAliasesMutation, { data, loading, error }] = useAddProtectedAliasesMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      aliases: // value for 'aliases'
 *      adminType: // value for 'adminType'
 *   },
 * });
 */
export function useAddProtectedAliasesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddProtectedAliasesMutation, AddProtectedAliasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddProtectedAliasesMutation, AddProtectedAliasesMutationVariables>(AddProtectedAliasesDocument, options);
      }
export type AddProtectedAliasesMutationHookResult = ReturnType<typeof useAddProtectedAliasesMutation>;
export type AddProtectedAliasesMutationResult = ApolloReactCommon.MutationResult<AddProtectedAliasesMutation>;
export type AddProtectedAliasesMutationOptions = ApolloReactCommon.BaseMutationOptions<AddProtectedAliasesMutation, AddProtectedAliasesMutationVariables>;
export const RemoveProtectedAliasesDocument = gql`
    mutation RemoveProtectedAliases($entityName: String!, $aliases: [String!]!, $adminType: WorkflowsAdminType!) {
  removeProtectedAliases(
    input: {entityName: $entityName, aliases: $aliases, adminType: $adminType}
  ) {
    aliases
  }
}
    `;
export type RemoveProtectedAliasesMutationFn = ApolloReactCommon.MutationFunction<RemoveProtectedAliasesMutation, RemoveProtectedAliasesMutationVariables>;

/**
 * __useRemoveProtectedAliasesMutation__
 *
 * To run a mutation, you first call `useRemoveProtectedAliasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProtectedAliasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProtectedAliasesMutation, { data, loading, error }] = useRemoveProtectedAliasesMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      aliases: // value for 'aliases'
 *      adminType: // value for 'adminType'
 *   },
 * });
 */
export function useRemoveProtectedAliasesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveProtectedAliasesMutation, RemoveProtectedAliasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveProtectedAliasesMutation, RemoveProtectedAliasesMutationVariables>(RemoveProtectedAliasesDocument, options);
      }
export type RemoveProtectedAliasesMutationHookResult = ReturnType<typeof useRemoveProtectedAliasesMutation>;
export type RemoveProtectedAliasesMutationResult = ApolloReactCommon.MutationResult<RemoveProtectedAliasesMutation>;
export type RemoveProtectedAliasesMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveProtectedAliasesMutation, RemoveProtectedAliasesMutationVariables>;
export const EntityProtectedAliasesDocument = gql`
    query EntityProtectedAliases($entityName: String!, $workflowsAdminType: WorkflowsAdminType!) {
  entity(name: $entityName) {
    id
    workflowsAdmins(adminType: $workflowsAdminType) {
      id
      username
      name
      email
    }
    protectedAliases(adminType: $workflowsAdminType)
  }
}
    `;

/**
 * __useEntityProtectedAliasesQuery__
 *
 * To run a query within a React component, call `useEntityProtectedAliasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityProtectedAliasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityProtectedAliasesQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      workflowsAdminType: // value for 'workflowsAdminType'
 *   },
 * });
 */
export function useEntityProtectedAliasesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables> & ({ variables: EntityProtectedAliasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables>(EntityProtectedAliasesDocument, options);
      }
export function useEntityProtectedAliasesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables>(EntityProtectedAliasesDocument, options);
        }
// @ts-ignore
export function useEntityProtectedAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables>;
export function useEntityProtectedAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityProtectedAliasesQuery | undefined, EntityProtectedAliasesQueryVariables>;
export function useEntityProtectedAliasesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables>(EntityProtectedAliasesDocument, options);
        }
export type EntityProtectedAliasesQueryHookResult = ReturnType<typeof useEntityProtectedAliasesQuery>;
export type EntityProtectedAliasesLazyQueryHookResult = ReturnType<typeof useEntityProtectedAliasesLazyQuery>;
export type EntityProtectedAliasesSuspenseQueryHookResult = ReturnType<typeof useEntityProtectedAliasesSuspenseQuery>;
export type EntityProtectedAliasesQueryResult = ApolloReactCommon.QueryResult<EntityProtectedAliasesQuery, EntityProtectedAliasesQueryVariables>;
export const ModelDocument = gql`
    query Model($name: String!, $logCursor: String, $fileCursor: String, $fileLimit: Int = 10, $fileNames: [String] = [], $entityName: String, $bucketName: String!, $upload: Boolean, $detailed: Boolean!, $includeFiles: Boolean = false) {
  project(name: $name, entityName: $entityName) {
    id
    readOnly
    name
    entityName
    description
    createdAt
    bucketCount
    access
    summaryMetrics
    run(name: $bucketName) {
      id
      name
      __typename
      ...SelectRunFragment
      ...BasicRunFragment
      ...DetailedRunFragment @include(if: $detailed)
      ...RunFilesFragment @include(if: $includeFiles)
    }
    views
  }
  viewer {
    id
    email
    photoUrl
    admin
    defaultFramework
  }
}
    ${SelectRunFragmentFragmentDoc}
${BasicRunFragmentFragmentDoc}
${DetailedRunFragmentFragmentDoc}
${RunFilesFragmentFragmentDoc}`;

/**
 * __useModelQuery__
 *
 * To run a query within a React component, call `useModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelQuery({
 *   variables: {
 *      name: // value for 'name'
 *      logCursor: // value for 'logCursor'
 *      fileCursor: // value for 'fileCursor'
 *      fileLimit: // value for 'fileLimit'
 *      fileNames: // value for 'fileNames'
 *      entityName: // value for 'entityName'
 *      bucketName: // value for 'bucketName'
 *      upload: // value for 'upload'
 *      detailed: // value for 'detailed'
 *      includeFiles: // value for 'includeFiles'
 *   },
 * });
 */
export function useModelQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ModelQuery, ModelQueryVariables> & ({ variables: ModelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModelQuery, ModelQueryVariables>(ModelDocument, options);
      }
export function useModelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModelQuery, ModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModelQuery, ModelQueryVariables>(ModelDocument, options);
        }
// @ts-ignore
export function useModelSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ModelQuery, ModelQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ModelQuery, ModelQueryVariables>;
export function useModelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModelQuery, ModelQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ModelQuery | undefined, ModelQueryVariables>;
export function useModelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModelQuery, ModelQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ModelQuery, ModelQueryVariables>(ModelDocument, options);
        }
export type ModelQueryHookResult = ReturnType<typeof useModelQuery>;
export type ModelLazyQueryHookResult = ReturnType<typeof useModelLazyQuery>;
export type ModelSuspenseQueryHookResult = ReturnType<typeof useModelSuspenseQuery>;
export type ModelQueryResult = ApolloReactCommon.QueryResult<ModelQuery, ModelQueryVariables>;
export const CreateProjectDocument = gql`
    mutation createProject($entityName: String!, $name: String!, $description: String, $access: String) {
  createProject(
    input: {entityName: $entityName, name: $name, description: $description, access: $access}
  ) {
    project {
      id
      internalId
      name
      entityName
      createdAt
    }
  }
}
    `;
export type CreateProjectMutationFn = ApolloReactCommon.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      access: // value for 'access'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = ApolloReactCommon.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const UpsertModelDocument = gql`
    mutation upsertModel($description: String, $entityName: String, $id: String, $name: String, $framework: String, $access: String, $views: JSONString, $owner: ID) {
  upsertModel(
    input: {description: $description, entityName: $entityName, id: $id, name: $name, framework: $framework, access: $access, views: $views, owner: $owner}
  ) {
    project {
      id
      internalId
      name
      entityName
      createdAt
      description
      access
      views
      user {
        id
      }
    }
    model {
      id
      name
      entityName
      description
      access
      views
      user {
        id
      }
    }
    inserted
  }
}
    `;
export type UpsertModelMutationFn = ApolloReactCommon.MutationFunction<UpsertModelMutation, UpsertModelMutationVariables>;

/**
 * __useUpsertModelMutation__
 *
 * To run a mutation, you first call `useUpsertModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertModelMutation, { data, loading, error }] = useUpsertModelMutation({
 *   variables: {
 *      description: // value for 'description'
 *      entityName: // value for 'entityName'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      framework: // value for 'framework'
 *      access: // value for 'access'
 *      views: // value for 'views'
 *      owner: // value for 'owner'
 *   },
 * });
 */
export function useUpsertModelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertModelMutation, UpsertModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertModelMutation, UpsertModelMutationVariables>(UpsertModelDocument, options);
      }
export type UpsertModelMutationHookResult = ReturnType<typeof useUpsertModelMutation>;
export type UpsertModelMutationResult = ApolloReactCommon.MutationResult<UpsertModelMutation>;
export type UpsertModelMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertModelMutation, UpsertModelMutationVariables>;
export const RenameProjectDocument = gql`
    mutation renameProject($entityName: String!, $oldProjectName: String!, $newProjectName: String!) {
  renameProject(
    input: {entityName: $entityName, oldProjectName: $oldProjectName, newProjectName: $newProjectName}
  ) {
    project {
      id
      name
      entityName
      description
      access
      views
    }
    model {
      id
      name
      entityName
      description
      access
      views
    }
    inserted
  }
}
    `;
export type RenameProjectMutationFn = ApolloReactCommon.MutationFunction<RenameProjectMutation, RenameProjectMutationVariables>;

/**
 * __useRenameProjectMutation__
 *
 * To run a mutation, you first call `useRenameProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameProjectMutation, { data, loading, error }] = useRenameProjectMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      oldProjectName: // value for 'oldProjectName'
 *      newProjectName: // value for 'newProjectName'
 *   },
 * });
 */
export function useRenameProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RenameProjectMutation, RenameProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RenameProjectMutation, RenameProjectMutationVariables>(RenameProjectDocument, options);
      }
export type RenameProjectMutationHookResult = ReturnType<typeof useRenameProjectMutation>;
export type RenameProjectMutationResult = ApolloReactCommon.MutationResult<RenameProjectMutation>;
export type RenameProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<RenameProjectMutation, RenameProjectMutationVariables>;
export const DeleteModelDocument = gql`
    mutation deleteModel($id: String!) {
  deleteModel(input: {id: $id}) {
    success
  }
}
    `;
export type DeleteModelMutationFn = ApolloReactCommon.MutationFunction<DeleteModelMutation, DeleteModelMutationVariables>;

/**
 * __useDeleteModelMutation__
 *
 * To run a mutation, you first call `useDeleteModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModelMutation, { data, loading, error }] = useDeleteModelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteModelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteModelMutation, DeleteModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteModelMutation, DeleteModelMutationVariables>(DeleteModelDocument, options);
      }
export type DeleteModelMutationHookResult = ReturnType<typeof useDeleteModelMutation>;
export type DeleteModelMutationResult = ApolloReactCommon.MutationResult<DeleteModelMutation>;
export type DeleteModelMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteModelMutation, DeleteModelMutationVariables>;
export const ModelsDocument = gql`
    query Models($cursor: String, $entityName: String, $order: String, $first: Int = 500, $anonymous: Boolean = false) {
  projects(
    first: $first
    after: $cursor
    entityName: $entityName
    order: $order
    anonymous: $anonymous
  ) {
    edges {
      node {
        id
        name
        entityName
        description
        totalRuns
        totalUsers
        lastActive
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  viewer {
    id
    email
    photoUrl
  }
}
    `;

/**
 * __useModelsQuery__
 *
 * To run a query within a React component, call `useModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      entityName: // value for 'entityName'
 *      order: // value for 'order'
 *      first: // value for 'first'
 *      anonymous: // value for 'anonymous'
 *   },
 * });
 */
export function useModelsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ModelsQuery, ModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ModelsQuery, ModelsQueryVariables>(ModelsDocument, options);
      }
export function useModelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ModelsQuery, ModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ModelsQuery, ModelsQueryVariables>(ModelsDocument, options);
        }
// @ts-ignore
export function useModelsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ModelsQuery, ModelsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ModelsQuery, ModelsQueryVariables>;
export function useModelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModelsQuery, ModelsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ModelsQuery | undefined, ModelsQueryVariables>;
export function useModelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ModelsQuery, ModelsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ModelsQuery, ModelsQueryVariables>(ModelsDocument, options);
        }
export type ModelsQueryHookResult = ReturnType<typeof useModelsQuery>;
export type ModelsLazyQueryHookResult = ReturnType<typeof useModelsLazyQuery>;
export type ModelsSuspenseQueryHookResult = ReturnType<typeof useModelsSuspenseQuery>;
export type ModelsQueryResult = ApolloReactCommon.QueryResult<ModelsQuery, ModelsQueryVariables>;
export const NumPendingInvitesDocument = gql`
    query NumPendingInvites {
  numPendingInvites
}
    `;

/**
 * __useNumPendingInvitesQuery__
 *
 * To run a query within a React component, call `useNumPendingInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNumPendingInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNumPendingInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useNumPendingInvitesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>(NumPendingInvitesDocument, options);
      }
export function useNumPendingInvitesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>(NumPendingInvitesDocument, options);
        }
// @ts-ignore
export function useNumPendingInvitesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>;
export function useNumPendingInvitesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NumPendingInvitesQuery | undefined, NumPendingInvitesQueryVariables>;
export function useNumPendingInvitesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>(NumPendingInvitesDocument, options);
        }
export type NumPendingInvitesQueryHookResult = ReturnType<typeof useNumPendingInvitesQuery>;
export type NumPendingInvitesLazyQueryHookResult = ReturnType<typeof useNumPendingInvitesLazyQuery>;
export type NumPendingInvitesSuspenseQueryHookResult = ReturnType<typeof useNumPendingInvitesSuspenseQuery>;
export type NumPendingInvitesQueryResult = ApolloReactCommon.QueryResult<NumPendingInvitesQuery, NumPendingInvitesQueryVariables>;
export const CreateOAuthProviderDocument = gql`
    mutation createOAuthProvider($organizationId: ID!, $issuerUrl: String!) {
  createOAuthProvider(
    input: {issuerUrl: $issuerUrl, organizationId: $organizationId}
  ) {
    success
  }
}
    `;
export type CreateOAuthProviderMutationFn = ApolloReactCommon.MutationFunction<CreateOAuthProviderMutation, CreateOAuthProviderMutationVariables>;

/**
 * __useCreateOAuthProviderMutation__
 *
 * To run a mutation, you first call `useCreateOAuthProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOAuthProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOAuthProviderMutation, { data, loading, error }] = useCreateOAuthProviderMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      issuerUrl: // value for 'issuerUrl'
 *   },
 * });
 */
export function useCreateOAuthProviderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOAuthProviderMutation, CreateOAuthProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOAuthProviderMutation, CreateOAuthProviderMutationVariables>(CreateOAuthProviderDocument, options);
      }
export type CreateOAuthProviderMutationHookResult = ReturnType<typeof useCreateOAuthProviderMutation>;
export type CreateOAuthProviderMutationResult = ApolloReactCommon.MutationResult<CreateOAuthProviderMutation>;
export type CreateOAuthProviderMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOAuthProviderMutation, CreateOAuthProviderMutationVariables>;
export const OauthProvidersDocument = gql`
    query oauthProviders($organizationName: String!) {
  organization(name: $organizationName) {
    id
    OAuthProviders {
      id
      issuerUrl
    }
  }
}
    `;

/**
 * __useOauthProvidersQuery__
 *
 * To run a query within a React component, call `useOauthProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOauthProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOauthProvidersQuery({
 *   variables: {
 *      organizationName: // value for 'organizationName'
 *   },
 * });
 */
export function useOauthProvidersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OauthProvidersQuery, OauthProvidersQueryVariables> & ({ variables: OauthProvidersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OauthProvidersQuery, OauthProvidersQueryVariables>(OauthProvidersDocument, options);
      }
export function useOauthProvidersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OauthProvidersQuery, OauthProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OauthProvidersQuery, OauthProvidersQueryVariables>(OauthProvidersDocument, options);
        }
// @ts-ignore
export function useOauthProvidersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OauthProvidersQuery, OauthProvidersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OauthProvidersQuery, OauthProvidersQueryVariables>;
export function useOauthProvidersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OauthProvidersQuery, OauthProvidersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OauthProvidersQuery | undefined, OauthProvidersQueryVariables>;
export function useOauthProvidersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OauthProvidersQuery, OauthProvidersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OauthProvidersQuery, OauthProvidersQueryVariables>(OauthProvidersDocument, options);
        }
export type OauthProvidersQueryHookResult = ReturnType<typeof useOauthProvidersQuery>;
export type OauthProvidersLazyQueryHookResult = ReturnType<typeof useOauthProvidersLazyQuery>;
export type OauthProvidersSuspenseQueryHookResult = ReturnType<typeof useOauthProvidersSuspenseQuery>;
export type OauthProvidersQueryResult = ApolloReactCommon.QueryResult<OauthProvidersQuery, OauthProvidersQueryVariables>;
export const DeleteOAuthProviderDocument = gql`
    mutation deleteOAuthProvider($providerId: ID!) {
  deleteOAuthProvider(input: {providerId: $providerId}) {
    success
  }
}
    `;
export type DeleteOAuthProviderMutationFn = ApolloReactCommon.MutationFunction<DeleteOAuthProviderMutation, DeleteOAuthProviderMutationVariables>;

/**
 * __useDeleteOAuthProviderMutation__
 *
 * To run a mutation, you first call `useDeleteOAuthProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOAuthProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOAuthProviderMutation, { data, loading, error }] = useDeleteOAuthProviderMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useDeleteOAuthProviderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOAuthProviderMutation, DeleteOAuthProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteOAuthProviderMutation, DeleteOAuthProviderMutationVariables>(DeleteOAuthProviderDocument, options);
      }
export type DeleteOAuthProviderMutationHookResult = ReturnType<typeof useDeleteOAuthProviderMutation>;
export type DeleteOAuthProviderMutationResult = ApolloReactCommon.MutationResult<DeleteOAuthProviderMutation>;
export type DeleteOAuthProviderMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteOAuthProviderMutation, DeleteOAuthProviderMutationVariables>;
export const OauthClientsDocument = gql`
    query oauthClients($entityName: String!) {
  entity(name: $entityName) {
    id
    members {
      id
      role
      OAuthClients {
        id
        subject
      }
    }
  }
}
    `;

/**
 * __useOauthClientsQuery__
 *
 * To run a query within a React component, call `useOauthClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOauthClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOauthClientsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useOauthClientsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OauthClientsQuery, OauthClientsQueryVariables> & ({ variables: OauthClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OauthClientsQuery, OauthClientsQueryVariables>(OauthClientsDocument, options);
      }
export function useOauthClientsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OauthClientsQuery, OauthClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OauthClientsQuery, OauthClientsQueryVariables>(OauthClientsDocument, options);
        }
// @ts-ignore
export function useOauthClientsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OauthClientsQuery, OauthClientsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OauthClientsQuery, OauthClientsQueryVariables>;
export function useOauthClientsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OauthClientsQuery, OauthClientsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OauthClientsQuery | undefined, OauthClientsQueryVariables>;
export function useOauthClientsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OauthClientsQuery, OauthClientsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OauthClientsQuery, OauthClientsQueryVariables>(OauthClientsDocument, options);
        }
export type OauthClientsQueryHookResult = ReturnType<typeof useOauthClientsQuery>;
export type OauthClientsLazyQueryHookResult = ReturnType<typeof useOauthClientsLazyQuery>;
export type OauthClientsSuspenseQueryHookResult = ReturnType<typeof useOauthClientsSuspenseQuery>;
export type OauthClientsQueryResult = ApolloReactCommon.QueryResult<OauthClientsQuery, OauthClientsQueryVariables>;
export const CreateOAuthClientDocument = gql`
    mutation createOAuthClient($providerId: ID!, $name: String!, $subject: String!, $entityName: String!) {
  createClient(
    input: {providerId: $providerId, entityName: $entityName, name: $name, subject: $subject}
  ) {
    success
  }
}
    `;
export type CreateOAuthClientMutationFn = ApolloReactCommon.MutationFunction<CreateOAuthClientMutation, CreateOAuthClientMutationVariables>;

/**
 * __useCreateOAuthClientMutation__
 *
 * To run a mutation, you first call `useCreateOAuthClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOAuthClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOAuthClientMutation, { data, loading, error }] = useCreateOAuthClientMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      name: // value for 'name'
 *      subject: // value for 'subject'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useCreateOAuthClientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOAuthClientMutation, CreateOAuthClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOAuthClientMutation, CreateOAuthClientMutationVariables>(CreateOAuthClientDocument, options);
      }
export type CreateOAuthClientMutationHookResult = ReturnType<typeof useCreateOAuthClientMutation>;
export type CreateOAuthClientMutationResult = ApolloReactCommon.MutationResult<CreateOAuthClientMutation>;
export type CreateOAuthClientMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOAuthClientMutation, CreateOAuthClientMutationVariables>;
export const DeleteOAuthClientDocument = gql`
    mutation deleteOAuthClient($clientId: String!, $entityName: String!) {
  revokeClient(input: {clientId: $clientId, entityName: $entityName}) {
    success
  }
}
    `;
export type DeleteOAuthClientMutationFn = ApolloReactCommon.MutationFunction<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>;

/**
 * __useDeleteOAuthClientMutation__
 *
 * To run a mutation, you first call `useDeleteOAuthClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOAuthClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOAuthClientMutation, { data, loading, error }] = useDeleteOAuthClientMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useDeleteOAuthClientMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>(DeleteOAuthClientDocument, options);
      }
export type DeleteOAuthClientMutationHookResult = ReturnType<typeof useDeleteOAuthClientMutation>;
export type DeleteOAuthClientMutationResult = ApolloReactCommon.MutationResult<DeleteOAuthClientMutation>;
export type DeleteOAuthClientMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteOAuthClientMutation, DeleteOAuthClientMutationVariables>;
export const ActivityTimelineDocument = gql`
    query ActivityTimeline($startDate: DateTime, $endDate: DateTime, $orgName: String) {
  organization(name: $orgName) {
    id
    firstActivity
    activity: activity(start: $startDate, end: $endDate) {
      numActiveUsers
      startAt
      endAt
    }
  }
}
    `;

/**
 * __useActivityTimelineQuery__
 *
 * To run a query within a React component, call `useActivityTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityTimelineQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useActivityTimelineQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActivityTimelineQuery, ActivityTimelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActivityTimelineQuery, ActivityTimelineQueryVariables>(ActivityTimelineDocument, options);
      }
export function useActivityTimelineLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActivityTimelineQuery, ActivityTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActivityTimelineQuery, ActivityTimelineQueryVariables>(ActivityTimelineDocument, options);
        }
// @ts-ignore
export function useActivityTimelineSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ActivityTimelineQuery, ActivityTimelineQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActivityTimelineQuery, ActivityTimelineQueryVariables>;
export function useActivityTimelineSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActivityTimelineQuery, ActivityTimelineQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActivityTimelineQuery | undefined, ActivityTimelineQueryVariables>;
export function useActivityTimelineSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActivityTimelineQuery, ActivityTimelineQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ActivityTimelineQuery, ActivityTimelineQueryVariables>(ActivityTimelineDocument, options);
        }
export type ActivityTimelineQueryHookResult = ReturnType<typeof useActivityTimelineQuery>;
export type ActivityTimelineLazyQueryHookResult = ReturnType<typeof useActivityTimelineLazyQuery>;
export type ActivityTimelineSuspenseQueryHookResult = ReturnType<typeof useActivityTimelineSuspenseQuery>;
export type ActivityTimelineQueryResult = ApolloReactCommon.QueryResult<ActivityTimelineQuery, ActivityTimelineQueryVariables>;
export const OrgFlagsDocument = gql`
    query OrgFlags($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    flags
  }
}
    `;

/**
 * __useOrgFlagsQuery__
 *
 * To run a query within a React component, call `useOrgFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgFlagsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrgFlagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrgFlagsQuery, OrgFlagsQueryVariables> & ({ variables: OrgFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrgFlagsQuery, OrgFlagsQueryVariables>(OrgFlagsDocument, options);
      }
export function useOrgFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrgFlagsQuery, OrgFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrgFlagsQuery, OrgFlagsQueryVariables>(OrgFlagsDocument, options);
        }
// @ts-ignore
export function useOrgFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrgFlagsQuery, OrgFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgFlagsQuery, OrgFlagsQueryVariables>;
export function useOrgFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgFlagsQuery, OrgFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgFlagsQuery | undefined, OrgFlagsQueryVariables>;
export function useOrgFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgFlagsQuery, OrgFlagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrgFlagsQuery, OrgFlagsQueryVariables>(OrgFlagsDocument, options);
        }
export type OrgFlagsQueryHookResult = ReturnType<typeof useOrgFlagsQuery>;
export type OrgFlagsLazyQueryHookResult = ReturnType<typeof useOrgFlagsLazyQuery>;
export type OrgFlagsSuspenseQueryHookResult = ReturnType<typeof useOrgFlagsSuspenseQuery>;
export type OrgFlagsQueryResult = ApolloReactCommon.QueryResult<OrgFlagsQuery, OrgFlagsQueryVariables>;
export const OrgDashboardEnablementDocument = gql`
    query OrgDashboardEnablement {
  organization {
    id
    name
    activity {
      numActiveUsers
    }
  }
}
    `;

/**
 * __useOrgDashboardEnablementQuery__
 *
 * To run a query within a React component, call `useOrgDashboardEnablementQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgDashboardEnablementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgDashboardEnablementQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgDashboardEnablementQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>(OrgDashboardEnablementDocument, options);
      }
export function useOrgDashboardEnablementLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>(OrgDashboardEnablementDocument, options);
        }
// @ts-ignore
export function useOrgDashboardEnablementSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>;
export function useOrgDashboardEnablementSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgDashboardEnablementQuery | undefined, OrgDashboardEnablementQueryVariables>;
export function useOrgDashboardEnablementSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>(OrgDashboardEnablementDocument, options);
        }
export type OrgDashboardEnablementQueryHookResult = ReturnType<typeof useOrgDashboardEnablementQuery>;
export type OrgDashboardEnablementLazyQueryHookResult = ReturnType<typeof useOrgDashboardEnablementLazyQuery>;
export type OrgDashboardEnablementSuspenseQueryHookResult = ReturnType<typeof useOrgDashboardEnablementSuspenseQuery>;
export type OrgDashboardEnablementQueryResult = ApolloReactCommon.QueryResult<OrgDashboardEnablementQuery, OrgDashboardEnablementQueryVariables>;
export const OrgDashboardContextDocument = gql`
    query OrgDashboardContext($orgName: String) {
  organization(name: $orgName) {
    id
    name
    members {
      orgID
      id
      role
      username
      modelsSeat
      weaveRole
      user {
        id
        ...UserRoleFragment
        teams {
          edges {
            node {
              id
              name
            }
          }
        }
        activity {
          lastActiveAt
          startAt
          endAt
          daysActive
          numReports
          numRuns
        }
      }
    }
    activeUsersForRange {
      last30Days
      last3Months
      last6Months
      last12Months
      allTime
    }
  }
}
    ${UserRoleFragmentFragmentDoc}`;

/**
 * __useOrgDashboardContextQuery__
 *
 * To run a query within a React component, call `useOrgDashboardContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgDashboardContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgDashboardContextQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrgDashboardContextQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>(OrgDashboardContextDocument, options);
      }
export function useOrgDashboardContextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>(OrgDashboardContextDocument, options);
        }
// @ts-ignore
export function useOrgDashboardContextSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>;
export function useOrgDashboardContextSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgDashboardContextQuery | undefined, OrgDashboardContextQueryVariables>;
export function useOrgDashboardContextSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>(OrgDashboardContextDocument, options);
        }
export type OrgDashboardContextQueryHookResult = ReturnType<typeof useOrgDashboardContextQuery>;
export type OrgDashboardContextLazyQueryHookResult = ReturnType<typeof useOrgDashboardContextLazyQuery>;
export type OrgDashboardContextSuspenseQueryHookResult = ReturnType<typeof useOrgDashboardContextSuspenseQuery>;
export type OrgDashboardContextQueryResult = ApolloReactCommon.QueryResult<OrgDashboardContextQuery, OrgDashboardContextQueryVariables>;
export const OrgActivityTimelineDocument = gql`
    query OrgActivityTimeline($startDate: DateTime, $endDate: DateTime) {
  organization {
    id
    activity: activity(start: $startDate, end: $endDate) {
      numActiveUsers
      startAt
      endAt
    }
  }
}
    `;

/**
 * __useOrgActivityTimelineQuery__
 *
 * To run a query within a React component, call `useOrgActivityTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgActivityTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgActivityTimelineQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useOrgActivityTimelineQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>(OrgActivityTimelineDocument, options);
      }
export function useOrgActivityTimelineLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>(OrgActivityTimelineDocument, options);
        }
// @ts-ignore
export function useOrgActivityTimelineSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>;
export function useOrgActivityTimelineSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgActivityTimelineQuery | undefined, OrgActivityTimelineQueryVariables>;
export function useOrgActivityTimelineSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>(OrgActivityTimelineDocument, options);
        }
export type OrgActivityTimelineQueryHookResult = ReturnType<typeof useOrgActivityTimelineQuery>;
export type OrgActivityTimelineLazyQueryHookResult = ReturnType<typeof useOrgActivityTimelineLazyQuery>;
export type OrgActivityTimelineSuspenseQueryHookResult = ReturnType<typeof useOrgActivityTimelineSuspenseQuery>;
export type OrgActivityTimelineQueryResult = ApolloReactCommon.QueryResult<OrgActivityTimelineQuery, OrgActivityTimelineQueryVariables>;
export const OrgSeatsDocument = gql`
    query OrgSeats {
  organization {
    id
    seatAvailability {
      seats
      viewOnlySeats
      expiresAt
    }
  }
}
    `;

/**
 * __useOrgSeatsQuery__
 *
 * To run a query within a React component, call `useOrgSeatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgSeatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgSeatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgSeatsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrgSeatsQuery, OrgSeatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrgSeatsQuery, OrgSeatsQueryVariables>(OrgSeatsDocument, options);
      }
export function useOrgSeatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrgSeatsQuery, OrgSeatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrgSeatsQuery, OrgSeatsQueryVariables>(OrgSeatsDocument, options);
        }
// @ts-ignore
export function useOrgSeatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrgSeatsQuery, OrgSeatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgSeatsQuery, OrgSeatsQueryVariables>;
export function useOrgSeatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgSeatsQuery, OrgSeatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgSeatsQuery | undefined, OrgSeatsQueryVariables>;
export function useOrgSeatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgSeatsQuery, OrgSeatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrgSeatsQuery, OrgSeatsQueryVariables>(OrgSeatsDocument, options);
        }
export type OrgSeatsQueryHookResult = ReturnType<typeof useOrgSeatsQuery>;
export type OrgSeatsLazyQueryHookResult = ReturnType<typeof useOrgSeatsLazyQuery>;
export type OrgSeatsSuspenseQueryHookResult = ReturnType<typeof useOrgSeatsSuspenseQuery>;
export type OrgSeatsQueryResult = ApolloReactCommon.QueryResult<OrgSeatsQuery, OrgSeatsQueryVariables>;
export const UserActivityTableDocument = gql`
    query UserActivityTable {
  organization {
    id
    name
    usedSeats
    usedViewOnlySeats
    members {
      orgID
      id
      role
      modelsSeat
      weaveRole
      user {
        id
        name
        photoUrl
        createdAt
        accountType
        ...UserRoleFragment
        activity {
          lastActiveAt
          daysActive
          numReports
          numRuns
        }
        teams {
          edges {
            node {
              id
              name
              entityType
            }
          }
        }
      }
    }
  }
}
    ${UserRoleFragmentFragmentDoc}`;

/**
 * __useUserActivityTableQuery__
 *
 * To run a query within a React component, call `useUserActivityTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserActivityTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserActivityTableQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserActivityTableQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserActivityTableQuery, UserActivityTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserActivityTableQuery, UserActivityTableQueryVariables>(UserActivityTableDocument, options);
      }
export function useUserActivityTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserActivityTableQuery, UserActivityTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserActivityTableQuery, UserActivityTableQueryVariables>(UserActivityTableDocument, options);
        }
// @ts-ignore
export function useUserActivityTableSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserActivityTableQuery, UserActivityTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserActivityTableQuery, UserActivityTableQueryVariables>;
export function useUserActivityTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserActivityTableQuery, UserActivityTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserActivityTableQuery | undefined, UserActivityTableQueryVariables>;
export function useUserActivityTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserActivityTableQuery, UserActivityTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserActivityTableQuery, UserActivityTableQueryVariables>(UserActivityTableDocument, options);
        }
export type UserActivityTableQueryHookResult = ReturnType<typeof useUserActivityTableQuery>;
export type UserActivityTableLazyQueryHookResult = ReturnType<typeof useUserActivityTableLazyQuery>;
export type UserActivityTableSuspenseQueryHookResult = ReturnType<typeof useUserActivityTableSuspenseQuery>;
export type UserActivityTableQueryResult = ApolloReactCommon.QueryResult<UserActivityTableQuery, UserActivityTableQueryVariables>;
export const AddUserToOrganizationDocument = gql`
    mutation addUserToOrganization($userName: String!, $teams: [String!], $organizationId: ID!, $clientMutationId: String, $userOrgRole: String!, $modelsSeat: String, $weaveRole: String) {
  addUserToOrganization(
    input: {userName: $userName, teams: $teams, organizationId: $organizationId, clientMutationId: $clientMutationId, userOrgRole: $userOrgRole, modelsSeat: $modelsSeat, weaveRole: $weaveRole}
  ) {
    success
    clientMutationId
  }
}
    `;
export type AddUserToOrganizationMutationFn = ApolloReactCommon.MutationFunction<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>;

/**
 * __useAddUserToOrganizationMutation__
 *
 * To run a mutation, you first call `useAddUserToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToOrganizationMutation, { data, loading, error }] = useAddUserToOrganizationMutation({
 *   variables: {
 *      userName: // value for 'userName'
 *      teams: // value for 'teams'
 *      organizationId: // value for 'organizationId'
 *      clientMutationId: // value for 'clientMutationId'
 *      userOrgRole: // value for 'userOrgRole'
 *      modelsSeat: // value for 'modelsSeat'
 *      weaveRole: // value for 'weaveRole'
 *   },
 * });
 */
export function useAddUserToOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>(AddUserToOrganizationDocument, options);
      }
export type AddUserToOrganizationMutationHookResult = ReturnType<typeof useAddUserToOrganizationMutation>;
export type AddUserToOrganizationMutationResult = ApolloReactCommon.MutationResult<AddUserToOrganizationMutation>;
export type AddUserToOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<AddUserToOrganizationMutation, AddUserToOrganizationMutationVariables>;
export const RemoveUserFromOrganizationDocument = gql`
    mutation removeUserFromOrganization($userName: String!, $organizationId: ID!, $clientMutationId: String) {
  removeUserFromOrganization(
    input: {userName: $userName, organizationId: $organizationId, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type RemoveUserFromOrganizationMutationFn = ApolloReactCommon.MutationFunction<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>;

/**
 * __useRemoveUserFromOrganizationMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromOrganizationMutation, { data, loading, error }] = useRemoveUserFromOrganizationMutation({
 *   variables: {
 *      userName: // value for 'userName'
 *      organizationId: // value for 'organizationId'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useRemoveUserFromOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>(RemoveUserFromOrganizationDocument, options);
      }
export type RemoveUserFromOrganizationMutationHookResult = ReturnType<typeof useRemoveUserFromOrganizationMutation>;
export type RemoveUserFromOrganizationMutationResult = ApolloReactCommon.MutationResult<RemoveUserFromOrganizationMutation>;
export type RemoveUserFromOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>;
export const RemoveUserFromOrganizationByIdDocument = gql`
    mutation removeUserFromOrganizationById($userId: ID!, $organizationId: ID!, $clientMutationId: String) {
  removeUserFromOrganizationById(
    input: {userId: $userId, organizationId: $organizationId, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type RemoveUserFromOrganizationByIdMutationFn = ApolloReactCommon.MutationFunction<RemoveUserFromOrganizationByIdMutation, RemoveUserFromOrganizationByIdMutationVariables>;

/**
 * __useRemoveUserFromOrganizationByIdMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromOrganizationByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromOrganizationByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromOrganizationByIdMutation, { data, loading, error }] = useRemoveUserFromOrganizationByIdMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      organizationId: // value for 'organizationId'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useRemoveUserFromOrganizationByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveUserFromOrganizationByIdMutation, RemoveUserFromOrganizationByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveUserFromOrganizationByIdMutation, RemoveUserFromOrganizationByIdMutationVariables>(RemoveUserFromOrganizationByIdDocument, options);
      }
export type RemoveUserFromOrganizationByIdMutationHookResult = ReturnType<typeof useRemoveUserFromOrganizationByIdMutation>;
export type RemoveUserFromOrganizationByIdMutationResult = ApolloReactCommon.MutationResult<RemoveUserFromOrganizationByIdMutation>;
export type RemoveUserFromOrganizationByIdMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveUserFromOrganizationByIdMutation, RemoveUserFromOrganizationByIdMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($organizationID: ID!, $flags: JSONString, $name: String) {
  updateOrganization(
    input: {organizationID: $organizationID, flags: $flags, name: $name}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateOrganizationMutationFn = ApolloReactCommon.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *      flags: // value for 'flags'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const DeleteOrganizationDocument = gql`
    mutation deleteOrganization($organizationId: ID!, $clientMutationId: String) {
  deleteOrganization(
    input: {organizationId: $organizationId, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type DeleteOrganizationMutationFn = ApolloReactCommon.MutationFunction<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, options);
      }
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = ApolloReactCommon.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const UpdateOrganizationUserV2Document = gql`
    mutation UpdateOrganizationUserV2($userName: String!, $organizationId: ID!, $userOrgRole: String!, $clientMutationId: String) {
  updateOrganizationUserV2(
    input: {userName: $userName, organizationId: $organizationId, userOrgRole: $userOrgRole, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateOrganizationUserV2MutationFn = ApolloReactCommon.MutationFunction<UpdateOrganizationUserV2Mutation, UpdateOrganizationUserV2MutationVariables>;

/**
 * __useUpdateOrganizationUserV2Mutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationUserV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationUserV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationUserV2Mutation, { data, loading, error }] = useUpdateOrganizationUserV2Mutation({
 *   variables: {
 *      userName: // value for 'userName'
 *      organizationId: // value for 'organizationId'
 *      userOrgRole: // value for 'userOrgRole'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateOrganizationUserV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationUserV2Mutation, UpdateOrganizationUserV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationUserV2Mutation, UpdateOrganizationUserV2MutationVariables>(UpdateOrganizationUserV2Document, options);
      }
export type UpdateOrganizationUserV2MutationHookResult = ReturnType<typeof useUpdateOrganizationUserV2Mutation>;
export type UpdateOrganizationUserV2MutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationUserV2Mutation>;
export type UpdateOrganizationUserV2MutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationUserV2Mutation, UpdateOrganizationUserV2MutationVariables>;
export const MakeOrgMembersNoAccessModelsSeatDocument = gql`
    mutation makeOrgMembersNoAccessModelsSeat($organizationId: ID!, $clientMutationId: String) {
  makeOrgMembersNoAccessModelsSeat(
    input: {organizationId: $organizationId, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type MakeOrgMembersNoAccessModelsSeatMutationFn = ApolloReactCommon.MutationFunction<MakeOrgMembersNoAccessModelsSeatMutation, MakeOrgMembersNoAccessModelsSeatMutationVariables>;

/**
 * __useMakeOrgMembersNoAccessModelsSeatMutation__
 *
 * To run a mutation, you first call `useMakeOrgMembersNoAccessModelsSeatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeOrgMembersNoAccessModelsSeatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeOrgMembersNoAccessModelsSeatMutation, { data, loading, error }] = useMakeOrgMembersNoAccessModelsSeatMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useMakeOrgMembersNoAccessModelsSeatMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MakeOrgMembersNoAccessModelsSeatMutation, MakeOrgMembersNoAccessModelsSeatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MakeOrgMembersNoAccessModelsSeatMutation, MakeOrgMembersNoAccessModelsSeatMutationVariables>(MakeOrgMembersNoAccessModelsSeatDocument, options);
      }
export type MakeOrgMembersNoAccessModelsSeatMutationHookResult = ReturnType<typeof useMakeOrgMembersNoAccessModelsSeatMutation>;
export type MakeOrgMembersNoAccessModelsSeatMutationResult = ApolloReactCommon.MutationResult<MakeOrgMembersNoAccessModelsSeatMutation>;
export type MakeOrgMembersNoAccessModelsSeatMutationOptions = ApolloReactCommon.BaseMutationOptions<MakeOrgMembersNoAccessModelsSeatMutation, MakeOrgMembersNoAccessModelsSeatMutationVariables>;
export const UpdateModelsSeatDocument = gql`
    mutation updateModelsSeat($userID: ID!, $organizationId: ID!, $modelsSeat: String!, $clientMutationId: String) {
  updateModelsSeat(
    input: {organizationId: $organizationId, userId: $userID, modelsSeat: $modelsSeat, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateModelsSeatMutationFn = ApolloReactCommon.MutationFunction<UpdateModelsSeatMutation, UpdateModelsSeatMutationVariables>;

/**
 * __useUpdateModelsSeatMutation__
 *
 * To run a mutation, you first call `useUpdateModelsSeatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModelsSeatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModelsSeatMutation, { data, loading, error }] = useUpdateModelsSeatMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *      organizationId: // value for 'organizationId'
 *      modelsSeat: // value for 'modelsSeat'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateModelsSeatMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateModelsSeatMutation, UpdateModelsSeatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateModelsSeatMutation, UpdateModelsSeatMutationVariables>(UpdateModelsSeatDocument, options);
      }
export type UpdateModelsSeatMutationHookResult = ReturnType<typeof useUpdateModelsSeatMutation>;
export type UpdateModelsSeatMutationResult = ApolloReactCommon.MutationResult<UpdateModelsSeatMutation>;
export type UpdateModelsSeatMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateModelsSeatMutation, UpdateModelsSeatMutationVariables>;
export const UpdateWeaveRoleDocument = gql`
    mutation updateWeaveRole($userID: ID!, $organizationId: ID!, $weaveRole: String!, $clientMutationId: String) {
  updateWeaveRole(
    input: {organizationId: $organizationId, userId: $userID, weaveRole: $weaveRole, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateWeaveRoleMutationFn = ApolloReactCommon.MutationFunction<UpdateWeaveRoleMutation, UpdateWeaveRoleMutationVariables>;

/**
 * __useUpdateWeaveRoleMutation__
 *
 * To run a mutation, you first call `useUpdateWeaveRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWeaveRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWeaveRoleMutation, { data, loading, error }] = useUpdateWeaveRoleMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *      organizationId: // value for 'organizationId'
 *      weaveRole: // value for 'weaveRole'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateWeaveRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWeaveRoleMutation, UpdateWeaveRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWeaveRoleMutation, UpdateWeaveRoleMutationVariables>(UpdateWeaveRoleDocument, options);
      }
export type UpdateWeaveRoleMutationHookResult = ReturnType<typeof useUpdateWeaveRoleMutation>;
export type UpdateWeaveRoleMutationResult = ApolloReactCommon.MutationResult<UpdateWeaveRoleMutation>;
export type UpdateWeaveRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateWeaveRoleMutation, UpdateWeaveRoleMutationVariables>;
export const UpdateOrganizationBillingUserDocument = gql`
    mutation updateOrganizationBillingUser($organizationId: ID!, $newBillingUser: ID!, $clientMutationId: String) {
  updateOrganizationBillingUser(
    input: {organizationId: $organizationId, newBillingUser: $newBillingUser, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateOrganizationBillingUserMutationFn = ApolloReactCommon.MutationFunction<UpdateOrganizationBillingUserMutation, UpdateOrganizationBillingUserMutationVariables>;

/**
 * __useUpdateOrganizationBillingUserMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationBillingUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationBillingUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationBillingUserMutation, { data, loading, error }] = useUpdateOrganizationBillingUserMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      newBillingUser: // value for 'newBillingUser'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateOrganizationBillingUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationBillingUserMutation, UpdateOrganizationBillingUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationBillingUserMutation, UpdateOrganizationBillingUserMutationVariables>(UpdateOrganizationBillingUserDocument, options);
      }
export type UpdateOrganizationBillingUserMutationHookResult = ReturnType<typeof useUpdateOrganizationBillingUserMutation>;
export type UpdateOrganizationBillingUserMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationBillingUserMutation>;
export type UpdateOrganizationBillingUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationBillingUserMutation, UpdateOrganizationBillingUserMutationVariables>;
export const UpgradeProCustomerDocument = gql`
    mutation upgradeProCustomer($organizationID: ID!, $weaveIngestionTier: WeaveIngestionLimitInMb!, $modelsSeats: Int!, $monthly: Boolean, $clientMutationId: String) {
  upgradeProCustomer(
    input: {organizationID: $organizationID, weaveIngestionTier: $weaveIngestionTier, modelsSeats: $modelsSeats, monthly: $monthly, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpgradeProCustomerMutationFn = ApolloReactCommon.MutationFunction<UpgradeProCustomerMutation, UpgradeProCustomerMutationVariables>;

/**
 * __useUpgradeProCustomerMutation__
 *
 * To run a mutation, you first call `useUpgradeProCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeProCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeProCustomerMutation, { data, loading, error }] = useUpgradeProCustomerMutation({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *      weaveIngestionTier: // value for 'weaveIngestionTier'
 *      modelsSeats: // value for 'modelsSeats'
 *      monthly: // value for 'monthly'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpgradeProCustomerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpgradeProCustomerMutation, UpgradeProCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpgradeProCustomerMutation, UpgradeProCustomerMutationVariables>(UpgradeProCustomerDocument, options);
      }
export type UpgradeProCustomerMutationHookResult = ReturnType<typeof useUpgradeProCustomerMutation>;
export type UpgradeProCustomerMutationResult = ApolloReactCommon.MutationResult<UpgradeProCustomerMutation>;
export type UpgradeProCustomerMutationOptions = ApolloReactCommon.BaseMutationOptions<UpgradeProCustomerMutation, UpgradeProCustomerMutationVariables>;
export const UpdateOrganizationSubscriptionDocument = gql`
    mutation updateOrganizationSubscription($organizationSubscriptionID: ID!, $createStripeSubscription: Boolean!, $planID: ID, $seats: Int, $privileges: JSONString, $type: OrganizationSubscriptionType, $status: OrganizationSubscriptionStatus, $stripeSubscriptionId: String, $expiresAt: DateTime, $couponID: String) {
  updateOrganizationSubscription(
    input: {organizationSubscriptionID: $organizationSubscriptionID, planID: $planID, seats: $seats, privileges: $privileges, type: $type, status: $status, stripeSubscriptionId: $stripeSubscriptionId, expiresAt: $expiresAt, createStripeSubscription: $createStripeSubscription, couponID: $couponID}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateOrganizationSubscriptionMutationFn = ApolloReactCommon.MutationFunction<UpdateOrganizationSubscriptionMutation, UpdateOrganizationSubscriptionMutationVariables>;

/**
 * __useUpdateOrganizationSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSubscriptionMutation, { data, loading, error }] = useUpdateOrganizationSubscriptionMutation({
 *   variables: {
 *      organizationSubscriptionID: // value for 'organizationSubscriptionID'
 *      createStripeSubscription: // value for 'createStripeSubscription'
 *      planID: // value for 'planID'
 *      seats: // value for 'seats'
 *      privileges: // value for 'privileges'
 *      type: // value for 'type'
 *      status: // value for 'status'
 *      stripeSubscriptionId: // value for 'stripeSubscriptionId'
 *      expiresAt: // value for 'expiresAt'
 *      couponID: // value for 'couponID'
 *   },
 * });
 */
export function useUpdateOrganizationSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationSubscriptionMutation, UpdateOrganizationSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationSubscriptionMutation, UpdateOrganizationSubscriptionMutationVariables>(UpdateOrganizationSubscriptionDocument, options);
      }
export type UpdateOrganizationSubscriptionMutationHookResult = ReturnType<typeof useUpdateOrganizationSubscriptionMutation>;
export type UpdateOrganizationSubscriptionMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationSubscriptionMutation>;
export type UpdateOrganizationSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationSubscriptionMutation, UpdateOrganizationSubscriptionMutationVariables>;
export const DeleteOrganizationSubscriptionDocument = gql`
    mutation deleteOrganizationSubscription($subscriptionID: ID!) {
  deleteOrganizationSubscription(input: {subscriptionID: $subscriptionID}) {
    success
    clientMutationId
  }
}
    `;
export type DeleteOrganizationSubscriptionMutationFn = ApolloReactCommon.MutationFunction<DeleteOrganizationSubscriptionMutation, DeleteOrganizationSubscriptionMutationVariables>;

/**
 * __useDeleteOrganizationSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationSubscriptionMutation, { data, loading, error }] = useDeleteOrganizationSubscriptionMutation({
 *   variables: {
 *      subscriptionID: // value for 'subscriptionID'
 *   },
 * });
 */
export function useDeleteOrganizationSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteOrganizationSubscriptionMutation, DeleteOrganizationSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteOrganizationSubscriptionMutation, DeleteOrganizationSubscriptionMutationVariables>(DeleteOrganizationSubscriptionDocument, options);
      }
export type DeleteOrganizationSubscriptionMutationHookResult = ReturnType<typeof useDeleteOrganizationSubscriptionMutation>;
export type DeleteOrganizationSubscriptionMutationResult = ApolloReactCommon.MutationResult<DeleteOrganizationSubscriptionMutation>;
export type DeleteOrganizationSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteOrganizationSubscriptionMutation, DeleteOrganizationSubscriptionMutationVariables>;
export const LinkTeamToOrganizationDocument = gql`
    mutation linkTeamToOrganization($entityName: String!, $organizationID: ID!, $clientMutationId: String) {
  linkTeamToOrganization(
    input: {entityName: $entityName, organizationID: $organizationID, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type LinkTeamToOrganizationMutationFn = ApolloReactCommon.MutationFunction<LinkTeamToOrganizationMutation, LinkTeamToOrganizationMutationVariables>;

/**
 * __useLinkTeamToOrganizationMutation__
 *
 * To run a mutation, you first call `useLinkTeamToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkTeamToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkTeamToOrganizationMutation, { data, loading, error }] = useLinkTeamToOrganizationMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      organizationID: // value for 'organizationID'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useLinkTeamToOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LinkTeamToOrganizationMutation, LinkTeamToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LinkTeamToOrganizationMutation, LinkTeamToOrganizationMutationVariables>(LinkTeamToOrganizationDocument, options);
      }
export type LinkTeamToOrganizationMutationHookResult = ReturnType<typeof useLinkTeamToOrganizationMutation>;
export type LinkTeamToOrganizationMutationResult = ApolloReactCommon.MutationResult<LinkTeamToOrganizationMutation>;
export type LinkTeamToOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<LinkTeamToOrganizationMutation, LinkTeamToOrganizationMutationVariables>;
export const WeaveSavingsCalculatorDocument = gql`
    query weaveSavingsCalculator($organizationID: ID!) {
  weaveSavingsCalculator(organizationID: $organizationID) {
    recommendationString
    totalPossibleSavings
    recommendedWeaveTier
  }
}
    `;

/**
 * __useWeaveSavingsCalculatorQuery__
 *
 * To run a query within a React component, call `useWeaveSavingsCalculatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeaveSavingsCalculatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeaveSavingsCalculatorQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useWeaveSavingsCalculatorQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables> & ({ variables: WeaveSavingsCalculatorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables>(WeaveSavingsCalculatorDocument, options);
      }
export function useWeaveSavingsCalculatorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables>(WeaveSavingsCalculatorDocument, options);
        }
// @ts-ignore
export function useWeaveSavingsCalculatorSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables>;
export function useWeaveSavingsCalculatorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WeaveSavingsCalculatorQuery | undefined, WeaveSavingsCalculatorQueryVariables>;
export function useWeaveSavingsCalculatorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables>(WeaveSavingsCalculatorDocument, options);
        }
export type WeaveSavingsCalculatorQueryHookResult = ReturnType<typeof useWeaveSavingsCalculatorQuery>;
export type WeaveSavingsCalculatorLazyQueryHookResult = ReturnType<typeof useWeaveSavingsCalculatorLazyQuery>;
export type WeaveSavingsCalculatorSuspenseQueryHookResult = ReturnType<typeof useWeaveSavingsCalculatorSuspenseQuery>;
export type WeaveSavingsCalculatorQueryResult = ApolloReactCommon.QueryResult<WeaveSavingsCalculatorQuery, WeaveSavingsCalculatorQueryVariables>;
export const CheckoutPreviewDocument = gql`
    query checkoutPreview($organizationID: ID!, $weaveIngestionTier: WeaveIngestionLimitInMb!, $numberOfModelsSeat: Int!, $couponID: String, $isMonthly: Boolean) {
  checkoutPreview(
    organizationID: $organizationID
    weaveIngestionTier: $weaveIngestionTier
    numberOfModelsSeat: $numberOfModelsSeat
    couponID: $couponID
    isMonthly: $isMonthly
  ) {
    total
    renewalDate
    lineItems {
      description
      amount
      product
      position
      discountAmount
      subLineItems {
        description
        amount
        proration
      }
    }
  }
}
    `;

/**
 * __useCheckoutPreviewQuery__
 *
 * To run a query within a React component, call `useCheckoutPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutPreviewQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *      weaveIngestionTier: // value for 'weaveIngestionTier'
 *      numberOfModelsSeat: // value for 'numberOfModelsSeat'
 *      couponID: // value for 'couponID'
 *      isMonthly: // value for 'isMonthly'
 *   },
 * });
 */
export function useCheckoutPreviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckoutPreviewQuery, CheckoutPreviewQueryVariables> & ({ variables: CheckoutPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>(CheckoutPreviewDocument, options);
      }
export function useCheckoutPreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>(CheckoutPreviewDocument, options);
        }
// @ts-ignore
export function useCheckoutPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>;
export function useCheckoutPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CheckoutPreviewQuery | undefined, CheckoutPreviewQueryVariables>;
export function useCheckoutPreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>(CheckoutPreviewDocument, options);
        }
export type CheckoutPreviewQueryHookResult = ReturnType<typeof useCheckoutPreviewQuery>;
export type CheckoutPreviewLazyQueryHookResult = ReturnType<typeof useCheckoutPreviewLazyQuery>;
export type CheckoutPreviewSuspenseQueryHookResult = ReturnType<typeof useCheckoutPreviewSuspenseQuery>;
export type CheckoutPreviewQueryResult = ApolloReactCommon.QueryResult<CheckoutPreviewQuery, CheckoutPreviewQueryVariables>;
export const AllOrganizationsDocument = gql`
    query allOrganizations($first: Int, $cursor: String, $queryOrg: String, $querySubId: String, $queryUser: String, $queryTeam: String, $emailDomain: String) {
  organizations(
    first: $first
    after: $cursor
    queryOrg: $queryOrg
    querySubId: $querySubId
    queryUser: $queryUser
    queryTeam: $queryTeam
    emailDomain: $emailDomain
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
        orgType
        flags
        billingUser {
          id
          username
          email
        }
        teams {
          id
          name
        }
        usedSeats
        usedViewOnlySeats
        stripeBillingInfo {
          stripeSubscriptionId
          status
          currentPeriodEnd
          cancelAtPeriodEnd
          paymentMethod {
            id
            cardType
            endingIn
          }
        }
        members {
          orgID
          id
          admin
          name
          username
          photoUrl
          teams {
            edges {
              node {
                id
                name
              }
            }
          }
          role
          modelsSeat
          weaveRole
        }
        subscriptions {
          plan {
            id
            name
            planType
            displayName
          }
          seats
          id
          subscriptionType
          stripeSubscriptionId
          status
          expiresAt
          privileges
        }
      }
    }
  }
}
    `;

/**
 * __useAllOrganizationsQuery__
 *
 * To run a query within a React component, call `useAllOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllOrganizationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      queryOrg: // value for 'queryOrg'
 *      querySubId: // value for 'querySubId'
 *      queryUser: // value for 'queryUser'
 *      queryTeam: // value for 'queryTeam'
 *      emailDomain: // value for 'emailDomain'
 *   },
 * });
 */
export function useAllOrganizationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllOrganizationsQuery, AllOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllOrganizationsQuery, AllOrganizationsQueryVariables>(AllOrganizationsDocument, options);
      }
export function useAllOrganizationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllOrganizationsQuery, AllOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllOrganizationsQuery, AllOrganizationsQueryVariables>(AllOrganizationsDocument, options);
        }
// @ts-ignore
export function useAllOrganizationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllOrganizationsQuery, AllOrganizationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllOrganizationsQuery, AllOrganizationsQueryVariables>;
export function useAllOrganizationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllOrganizationsQuery, AllOrganizationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllOrganizationsQuery | undefined, AllOrganizationsQueryVariables>;
export function useAllOrganizationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllOrganizationsQuery, AllOrganizationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllOrganizationsQuery, AllOrganizationsQueryVariables>(AllOrganizationsDocument, options);
        }
export type AllOrganizationsQueryHookResult = ReturnType<typeof useAllOrganizationsQuery>;
export type AllOrganizationsLazyQueryHookResult = ReturnType<typeof useAllOrganizationsLazyQuery>;
export type AllOrganizationsSuspenseQueryHookResult = ReturnType<typeof useAllOrganizationsSuspenseQuery>;
export type AllOrganizationsQueryResult = ApolloReactCommon.QueryResult<AllOrganizationsQuery, AllOrganizationsQueryVariables>;
export const OrganizationSubscriptionsDocument = gql`
    query OrganizationSubscriptions {
  viewer {
    id
    organizations {
      id
      createdAt
      name
      billingUser {
        id
        username
        email
      }
      flags
      usedSeats
      subscriptions {
        id
        subscriptionType
        status
        expiresAt
        privileges
        plan {
          id
          name
          planType
          billingInterval
        }
        seats
        isAutomaticUpgrade
        createdAt
        thresholdCrossedAt
        upgradedAt
        billingPeriodStart
        billingPeriodEnd
        expansionPacks {
          edges {
            node {
              id
              secondsLimit
              secondsRemaining
              expiresAt
            }
          }
        }
      }
      teams {
        id
        name
        computeHours
        oldComputeHours: computeHours(minDaysOld: 14)
      }
      members {
        orgID
        id
        username
        role
      }
      pendingInvites {
        id
      }
    }
  }
}
    `;

/**
 * __useOrganizationSubscriptionsQuery__
 *
 * To run a query within a React component, call `useOrganizationSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationSubscriptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>(OrganizationSubscriptionsDocument, options);
      }
export function useOrganizationSubscriptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>(OrganizationSubscriptionsDocument, options);
        }
// @ts-ignore
export function useOrganizationSubscriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>;
export function useOrganizationSubscriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionsQuery | undefined, OrganizationSubscriptionsQueryVariables>;
export function useOrganizationSubscriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>(OrganizationSubscriptionsDocument, options);
        }
export type OrganizationSubscriptionsQueryHookResult = ReturnType<typeof useOrganizationSubscriptionsQuery>;
export type OrganizationSubscriptionsLazyQueryHookResult = ReturnType<typeof useOrganizationSubscriptionsLazyQuery>;
export type OrganizationSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useOrganizationSubscriptionsSuspenseQuery>;
export type OrganizationSubscriptionsQueryResult = ApolloReactCommon.QueryResult<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>;
export const OrganizationStorageInfoDocument = gql`
    query OrganizationStorageInfo($organizationID: ID!) {
  organization(id: $organizationID) {
    id
    teams {
      id
      storageBytes(cached: true)
      referenceBytes(cached: true)
    }
  }
}
    `;

/**
 * __useOrganizationStorageInfoQuery__
 *
 * To run a query within a React component, call `useOrganizationStorageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationStorageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationStorageInfoQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useOrganizationStorageInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables> & ({ variables: OrganizationStorageInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables>(OrganizationStorageInfoDocument, options);
      }
export function useOrganizationStorageInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables>(OrganizationStorageInfoDocument, options);
        }
// @ts-ignore
export function useOrganizationStorageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables>;
export function useOrganizationStorageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationStorageInfoQuery | undefined, OrganizationStorageInfoQueryVariables>;
export function useOrganizationStorageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables>(OrganizationStorageInfoDocument, options);
        }
export type OrganizationStorageInfoQueryHookResult = ReturnType<typeof useOrganizationStorageInfoQuery>;
export type OrganizationStorageInfoLazyQueryHookResult = ReturnType<typeof useOrganizationStorageInfoLazyQuery>;
export type OrganizationStorageInfoSuspenseQueryHookResult = ReturnType<typeof useOrganizationStorageInfoSuspenseQuery>;
export type OrganizationStorageInfoQueryResult = ApolloReactCommon.QueryResult<OrganizationStorageInfoQuery, OrganizationStorageInfoQueryVariables>;
export const OrganizationSubscriptionsBasicInfoDocument = gql`
    query OrganizationSubscriptionsBasicInfo {
  viewer {
    id
    username
    organizations {
      id
      ...OrganizationSubscriptionBasicInfo
    }
  }
}
    ${OrganizationSubscriptionBasicInfoFragmentDoc}`;

/**
 * __useOrganizationSubscriptionsBasicInfoQuery__
 *
 * To run a query within a React component, call `useOrganizationSubscriptionsBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSubscriptionsBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSubscriptionsBasicInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationSubscriptionsBasicInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>(OrganizationSubscriptionsBasicInfoDocument, options);
      }
export function useOrganizationSubscriptionsBasicInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>(OrganizationSubscriptionsBasicInfoDocument, options);
        }
// @ts-ignore
export function useOrganizationSubscriptionsBasicInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>;
export function useOrganizationSubscriptionsBasicInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionsBasicInfoQuery | undefined, OrganizationSubscriptionsBasicInfoQueryVariables>;
export function useOrganizationSubscriptionsBasicInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>(OrganizationSubscriptionsBasicInfoDocument, options);
        }
export type OrganizationSubscriptionsBasicInfoQueryHookResult = ReturnType<typeof useOrganizationSubscriptionsBasicInfoQuery>;
export type OrganizationSubscriptionsBasicInfoLazyQueryHookResult = ReturnType<typeof useOrganizationSubscriptionsBasicInfoLazyQuery>;
export type OrganizationSubscriptionsBasicInfoSuspenseQueryHookResult = ReturnType<typeof useOrganizationSubscriptionsBasicInfoSuspenseQuery>;
export type OrganizationSubscriptionsBasicInfoQueryResult = ApolloReactCommon.QueryResult<OrganizationSubscriptionsBasicInfoQuery, OrganizationSubscriptionsBasicInfoQueryVariables>;
export const OrganizationSubscriptionBasicInfoByNameDocument = gql`
    query OrganizationSubscriptionBasicInfoByName($name: String!) {
  organization(name: $name) {
    id
    ...OrganizationSubscriptionBasicInfo
  }
}
    ${OrganizationSubscriptionBasicInfoFragmentDoc}`;

/**
 * __useOrganizationSubscriptionBasicInfoByNameQuery__
 *
 * To run a query within a React component, call `useOrganizationSubscriptionBasicInfoByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSubscriptionBasicInfoByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSubscriptionBasicInfoByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useOrganizationSubscriptionBasicInfoByNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables> & ({ variables: OrganizationSubscriptionBasicInfoByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables>(OrganizationSubscriptionBasicInfoByNameDocument, options);
      }
export function useOrganizationSubscriptionBasicInfoByNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables>(OrganizationSubscriptionBasicInfoByNameDocument, options);
        }
// @ts-ignore
export function useOrganizationSubscriptionBasicInfoByNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables>;
export function useOrganizationSubscriptionBasicInfoByNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionBasicInfoByNameQuery | undefined, OrganizationSubscriptionBasicInfoByNameQueryVariables>;
export function useOrganizationSubscriptionBasicInfoByNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables>(OrganizationSubscriptionBasicInfoByNameDocument, options);
        }
export type OrganizationSubscriptionBasicInfoByNameQueryHookResult = ReturnType<typeof useOrganizationSubscriptionBasicInfoByNameQuery>;
export type OrganizationSubscriptionBasicInfoByNameLazyQueryHookResult = ReturnType<typeof useOrganizationSubscriptionBasicInfoByNameLazyQuery>;
export type OrganizationSubscriptionBasicInfoByNameSuspenseQueryHookResult = ReturnType<typeof useOrganizationSubscriptionBasicInfoByNameSuspenseQuery>;
export type OrganizationSubscriptionBasicInfoByNameQueryResult = ApolloReactCommon.QueryResult<OrganizationSubscriptionBasicInfoByNameQuery, OrganizationSubscriptionBasicInfoByNameQueryVariables>;
export const OrganizationSubscriptionsBasicDetailsDocument = gql`
    query OrganizationSubscriptionsBasicDetails($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    subscriptions {
      id
      subscriptionType
      billingPeriodStart
      billingPeriodEnd
      plan {
        id
        name
        planType
      }
    }
  }
}
    `;

/**
 * __useOrganizationSubscriptionsBasicDetailsQuery__
 *
 * To run a query within a React component, call `useOrganizationSubscriptionsBasicDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSubscriptionsBasicDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSubscriptionsBasicDetailsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationSubscriptionsBasicDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables> & ({ variables: OrganizationSubscriptionsBasicDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables>(OrganizationSubscriptionsBasicDetailsDocument, options);
      }
export function useOrganizationSubscriptionsBasicDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables>(OrganizationSubscriptionsBasicDetailsDocument, options);
        }
// @ts-ignore
export function useOrganizationSubscriptionsBasicDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables>;
export function useOrganizationSubscriptionsBasicDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionsBasicDetailsQuery | undefined, OrganizationSubscriptionsBasicDetailsQueryVariables>;
export function useOrganizationSubscriptionsBasicDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables>(OrganizationSubscriptionsBasicDetailsDocument, options);
        }
export type OrganizationSubscriptionsBasicDetailsQueryHookResult = ReturnType<typeof useOrganizationSubscriptionsBasicDetailsQuery>;
export type OrganizationSubscriptionsBasicDetailsLazyQueryHookResult = ReturnType<typeof useOrganizationSubscriptionsBasicDetailsLazyQuery>;
export type OrganizationSubscriptionsBasicDetailsSuspenseQueryHookResult = ReturnType<typeof useOrganizationSubscriptionsBasicDetailsSuspenseQuery>;
export type OrganizationSubscriptionsBasicDetailsQueryResult = ApolloReactCommon.QueryResult<OrganizationSubscriptionsBasicDetailsQuery, OrganizationSubscriptionsBasicDetailsQueryVariables>;
export const UpdateOrganizationSubscriptionSeatsDocument = gql`
    mutation updateOrganizationSubscriptionSeats($organizationID: ID!, $seats: Int!, $clientMutationId: String) {
  updateOrganizationSubscriptionSeats(
    input: {organizationID: $organizationID, seats: $seats, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateOrganizationSubscriptionSeatsMutationFn = ApolloReactCommon.MutationFunction<UpdateOrganizationSubscriptionSeatsMutation, UpdateOrganizationSubscriptionSeatsMutationVariables>;

/**
 * __useUpdateOrganizationSubscriptionSeatsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSubscriptionSeatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSubscriptionSeatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSubscriptionSeatsMutation, { data, loading, error }] = useUpdateOrganizationSubscriptionSeatsMutation({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *      seats: // value for 'seats'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateOrganizationSubscriptionSeatsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationSubscriptionSeatsMutation, UpdateOrganizationSubscriptionSeatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationSubscriptionSeatsMutation, UpdateOrganizationSubscriptionSeatsMutationVariables>(UpdateOrganizationSubscriptionSeatsDocument, options);
      }
export type UpdateOrganizationSubscriptionSeatsMutationHookResult = ReturnType<typeof useUpdateOrganizationSubscriptionSeatsMutation>;
export type UpdateOrganizationSubscriptionSeatsMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationSubscriptionSeatsMutation>;
export type UpdateOrganizationSubscriptionSeatsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationSubscriptionSeatsMutation, UpdateOrganizationSubscriptionSeatsMutationVariables>;
export const OrganizationRunsDocument = gql`
    query OrganizationRuns($orgID: ID!, $userID: ID!) {
  organization(id: $orgID) {
    id
    myRuns: latestRuns(userID: $userID) {
      edges {
        node {
          id
          ...RunsTableFragment
        }
      }
    }
    teamRuns: latestRuns(excludeUserID: $userID) {
      edges {
        node {
          id
          ...RunsTableFragment
        }
      }
    }
  }
}
    ${RunsTableFragmentFragmentDoc}`;

/**
 * __useOrganizationRunsQuery__
 *
 * To run a query within a React component, call `useOrganizationRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationRunsQuery({
 *   variables: {
 *      orgID: // value for 'orgID'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useOrganizationRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationRunsQuery, OrganizationRunsQueryVariables> & ({ variables: OrganizationRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationRunsQuery, OrganizationRunsQueryVariables>(OrganizationRunsDocument, options);
      }
export function useOrganizationRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationRunsQuery, OrganizationRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationRunsQuery, OrganizationRunsQueryVariables>(OrganizationRunsDocument, options);
        }
// @ts-ignore
export function useOrganizationRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRunsQuery, OrganizationRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationRunsQuery, OrganizationRunsQueryVariables>;
export function useOrganizationRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRunsQuery, OrganizationRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationRunsQuery | undefined, OrganizationRunsQueryVariables>;
export function useOrganizationRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRunsQuery, OrganizationRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationRunsQuery, OrganizationRunsQueryVariables>(OrganizationRunsDocument, options);
        }
export type OrganizationRunsQueryHookResult = ReturnType<typeof useOrganizationRunsQuery>;
export type OrganizationRunsLazyQueryHookResult = ReturnType<typeof useOrganizationRunsLazyQuery>;
export type OrganizationRunsSuspenseQueryHookResult = ReturnType<typeof useOrganizationRunsSuspenseQuery>;
export type OrganizationRunsQueryResult = ApolloReactCommon.QueryResult<OrganizationRunsQuery, OrganizationRunsQueryVariables>;
export const OrganizationServiceAccountsDocument = gql`
    query OrganizationServiceAccounts($orgName: String!) {
  organization(name: $orgName) {
    id
    serviceAccounts {
      id
      name
      createdAt
      apiKeyCount
      accountType
      defaultEntity {
        name
        id
      }
      teams {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useOrganizationServiceAccountsQuery__
 *
 * To run a query within a React component, call `useOrganizationServiceAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationServiceAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationServiceAccountsQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationServiceAccountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables> & ({ variables: OrganizationServiceAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables>(OrganizationServiceAccountsDocument, options);
      }
export function useOrganizationServiceAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables>(OrganizationServiceAccountsDocument, options);
        }
// @ts-ignore
export function useOrganizationServiceAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables>;
export function useOrganizationServiceAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationServiceAccountsQuery | undefined, OrganizationServiceAccountsQueryVariables>;
export function useOrganizationServiceAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables>(OrganizationServiceAccountsDocument, options);
        }
export type OrganizationServiceAccountsQueryHookResult = ReturnType<typeof useOrganizationServiceAccountsQuery>;
export type OrganizationServiceAccountsLazyQueryHookResult = ReturnType<typeof useOrganizationServiceAccountsLazyQuery>;
export type OrganizationServiceAccountsSuspenseQueryHookResult = ReturnType<typeof useOrganizationServiceAccountsSuspenseQuery>;
export type OrganizationServiceAccountsQueryResult = ApolloReactCommon.QueryResult<OrganizationServiceAccountsQuery, OrganizationServiceAccountsQueryVariables>;
export const OrganizationProjectsDocument = gql`
    query OrganizationProjects($orgID: ID!, $userID: ID, $first: Int = 20) {
  organization(id: $orgID) {
    id
    projects(userID: $userID, first: $first, order: "-created_at") {
      edges {
        node {
          id
          ...AccountProjectFragment
        }
      }
    }
  }
}
    ${AccountProjectFragmentFragmentDoc}`;

/**
 * __useOrganizationProjectsQuery__
 *
 * To run a query within a React component, call `useOrganizationProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationProjectsQuery({
 *   variables: {
 *      orgID: // value for 'orgID'
 *      userID: // value for 'userID'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useOrganizationProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationProjectsQuery, OrganizationProjectsQueryVariables> & ({ variables: OrganizationProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>(OrganizationProjectsDocument, options);
      }
export function useOrganizationProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>(OrganizationProjectsDocument, options);
        }
// @ts-ignore
export function useOrganizationProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>;
export function useOrganizationProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationProjectsQuery | undefined, OrganizationProjectsQueryVariables>;
export function useOrganizationProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>(OrganizationProjectsDocument, options);
        }
export type OrganizationProjectsQueryHookResult = ReturnType<typeof useOrganizationProjectsQuery>;
export type OrganizationProjectsLazyQueryHookResult = ReturnType<typeof useOrganizationProjectsLazyQuery>;
export type OrganizationProjectsSuspenseQueryHookResult = ReturnType<typeof useOrganizationProjectsSuspenseQuery>;
export type OrganizationProjectsQueryResult = ApolloReactCommon.QueryResult<OrganizationProjectsQuery, OrganizationProjectsQueryVariables>;
export const ViewerOrganizationFeatureFlagsDocument = gql`
    query viewerOrganizationFeatureFlags($rampIDType: RampIDType!) {
  viewer {
    id
    organizations {
      id
      name
      featureFlags(rampIDType: $rampIDType) {
        rampKey
        isEnabled
      }
    }
  }
}
    `;

/**
 * __useViewerOrganizationFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useViewerOrganizationFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerOrganizationFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerOrganizationFeatureFlagsQuery({
 *   variables: {
 *      rampIDType: // value for 'rampIDType'
 *   },
 * });
 */
export function useViewerOrganizationFeatureFlagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables> & ({ variables: ViewerOrganizationFeatureFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables>(ViewerOrganizationFeatureFlagsDocument, options);
      }
export function useViewerOrganizationFeatureFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables>(ViewerOrganizationFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useViewerOrganizationFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables>;
export function useViewerOrganizationFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerOrganizationFeatureFlagsQuery | undefined, ViewerOrganizationFeatureFlagsQueryVariables>;
export function useViewerOrganizationFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables>(ViewerOrganizationFeatureFlagsDocument, options);
        }
export type ViewerOrganizationFeatureFlagsQueryHookResult = ReturnType<typeof useViewerOrganizationFeatureFlagsQuery>;
export type ViewerOrganizationFeatureFlagsLazyQueryHookResult = ReturnType<typeof useViewerOrganizationFeatureFlagsLazyQuery>;
export type ViewerOrganizationFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useViewerOrganizationFeatureFlagsSuspenseQuery>;
export type ViewerOrganizationFeatureFlagsQueryResult = ApolloReactCommon.QueryResult<ViewerOrganizationFeatureFlagsQuery, ViewerOrganizationFeatureFlagsQueryVariables>;
export const OrganizationFeatureFlagsDocument = gql`
    query organizationFeatureFlags($orgName: String, $rampIDType: RampIDType!) {
  organization(name: $orgName) {
    id
    orgType
    featureFlags(rampIDType: $rampIDType) {
      rampKey
      isEnabled
    }
  }
}
    `;

/**
 * __useOrganizationFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useOrganizationFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationFeatureFlagsQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      rampIDType: // value for 'rampIDType'
 *   },
 * });
 */
export function useOrganizationFeatureFlagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables> & ({ variables: OrganizationFeatureFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables>(OrganizationFeatureFlagsDocument, options);
      }
export function useOrganizationFeatureFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables>(OrganizationFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useOrganizationFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables>;
export function useOrganizationFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationFeatureFlagsQuery | undefined, OrganizationFeatureFlagsQueryVariables>;
export function useOrganizationFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables>(OrganizationFeatureFlagsDocument, options);
        }
export type OrganizationFeatureFlagsQueryHookResult = ReturnType<typeof useOrganizationFeatureFlagsQuery>;
export type OrganizationFeatureFlagsLazyQueryHookResult = ReturnType<typeof useOrganizationFeatureFlagsLazyQuery>;
export type OrganizationFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useOrganizationFeatureFlagsSuspenseQuery>;
export type OrganizationFeatureFlagsQueryResult = ApolloReactCommon.QueryResult<OrganizationFeatureFlagsQuery, OrganizationFeatureFlagsQueryVariables>;
export const UpdateOrganizationPrivacySettingsDocument = gql`
    mutation updateOrganizationPrivacySettings($organizationId: ID!, $hidden: Boolean, $privateOnly: Boolean, $onlyAdminsCanInvite: Boolean, $disableMagicLinkSharing: Boolean, $restrictMatchingOrgEmailDomainUsers: Boolean, $codeSavingDisabled: Boolean, $enableLLMPoweredFeatures: Boolean, $shareAITracesWithWB: Boolean, $allowModelTrainingOnSharedData: Boolean, $ariaProjectMemoryEnabled: Boolean, $restrictInvitesToClaimedDomain: Boolean, $disableApiKeyCreation: Boolean, $requireOrgScopedAPIKeys: Boolean, $weaveSensitiveDataPolicy: WeaveSensitiveDataPolicy, $clientMutationId: String) {
  updateOrganizationPrivacySettings(
    input: {organizationId: $organizationId, hidden: $hidden, privateOnly: $privateOnly, onlyAdminsCanInvite: $onlyAdminsCanInvite, disableMagicLinkSharing: $disableMagicLinkSharing, restrictMatchingOrgEmailDomainUsers: $restrictMatchingOrgEmailDomainUsers, codeSavingDisabled: $codeSavingDisabled, enableLLMPoweredFeatures: $enableLLMPoweredFeatures, shareAITracesWithWB: $shareAITracesWithWB, allowModelTrainingOnSharedData: $allowModelTrainingOnSharedData, ariaProjectMemoryEnabled: $ariaProjectMemoryEnabled, restrictInvitesToClaimedDomain: $restrictInvitesToClaimedDomain, disableApiKeyCreation: $disableApiKeyCreation, requireOrgScopedAPIKeys: $requireOrgScopedAPIKeys, weaveSensitiveDataPolicy: $weaveSensitiveDataPolicy, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateOrganizationPrivacySettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateOrganizationPrivacySettingsMutation, UpdateOrganizationPrivacySettingsMutationVariables>;

/**
 * __useUpdateOrganizationPrivacySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationPrivacySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationPrivacySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationPrivacySettingsMutation, { data, loading, error }] = useUpdateOrganizationPrivacySettingsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      hidden: // value for 'hidden'
 *      privateOnly: // value for 'privateOnly'
 *      onlyAdminsCanInvite: // value for 'onlyAdminsCanInvite'
 *      disableMagicLinkSharing: // value for 'disableMagicLinkSharing'
 *      restrictMatchingOrgEmailDomainUsers: // value for 'restrictMatchingOrgEmailDomainUsers'
 *      codeSavingDisabled: // value for 'codeSavingDisabled'
 *      enableLLMPoweredFeatures: // value for 'enableLLMPoweredFeatures'
 *      shareAITracesWithWB: // value for 'shareAITracesWithWB'
 *      allowModelTrainingOnSharedData: // value for 'allowModelTrainingOnSharedData'
 *      ariaProjectMemoryEnabled: // value for 'ariaProjectMemoryEnabled'
 *      restrictInvitesToClaimedDomain: // value for 'restrictInvitesToClaimedDomain'
 *      disableApiKeyCreation: // value for 'disableApiKeyCreation'
 *      requireOrgScopedAPIKeys: // value for 'requireOrgScopedAPIKeys'
 *      weaveSensitiveDataPolicy: // value for 'weaveSensitiveDataPolicy'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateOrganizationPrivacySettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationPrivacySettingsMutation, UpdateOrganizationPrivacySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationPrivacySettingsMutation, UpdateOrganizationPrivacySettingsMutationVariables>(UpdateOrganizationPrivacySettingsDocument, options);
      }
export type UpdateOrganizationPrivacySettingsMutationHookResult = ReturnType<typeof useUpdateOrganizationPrivacySettingsMutation>;
export type UpdateOrganizationPrivacySettingsMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationPrivacySettingsMutation>;
export type UpdateOrganizationPrivacySettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationPrivacySettingsMutation, UpdateOrganizationPrivacySettingsMutationVariables>;
export const OrganizationMemberRoleDocument = gql`
    query OrganizationMemberRole($orgID: ID!, $username: String) {
  organization(id: $orgID) {
    id
    member(username: $username) {
      id
      orgID
      role
    }
  }
}
    `;

/**
 * __useOrganizationMemberRoleQuery__
 *
 * To run a query within a React component, call `useOrganizationMemberRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMemberRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMemberRoleQuery({
 *   variables: {
 *      orgID: // value for 'orgID'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useOrganizationMemberRoleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables> & ({ variables: OrganizationMemberRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables>(OrganizationMemberRoleDocument, options);
      }
export function useOrganizationMemberRoleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables>(OrganizationMemberRoleDocument, options);
        }
// @ts-ignore
export function useOrganizationMemberRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables>;
export function useOrganizationMemberRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMemberRoleQuery | undefined, OrganizationMemberRoleQueryVariables>;
export function useOrganizationMemberRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables>(OrganizationMemberRoleDocument, options);
        }
export type OrganizationMemberRoleQueryHookResult = ReturnType<typeof useOrganizationMemberRoleQuery>;
export type OrganizationMemberRoleLazyQueryHookResult = ReturnType<typeof useOrganizationMemberRoleLazyQuery>;
export type OrganizationMemberRoleSuspenseQueryHookResult = ReturnType<typeof useOrganizationMemberRoleSuspenseQuery>;
export type OrganizationMemberRoleQueryResult = ApolloReactCommon.QueryResult<OrganizationMemberRoleQuery, OrganizationMemberRoleQueryVariables>;
export const OrganizationMemberModelsSeatDocument = gql`
    query OrganizationMemberModelsSeat($orgName: String, $username: String) {
  organization(name: $orgName) {
    id
    member(username: $username) {
      id
      role
      modelsSeat
      isRegistryEntitled
    }
  }
}
    `;

/**
 * __useOrganizationMemberModelsSeatQuery__
 *
 * To run a query within a React component, call `useOrganizationMemberModelsSeatQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMemberModelsSeatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMemberModelsSeatQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useOrganizationMemberModelsSeatQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>(OrganizationMemberModelsSeatDocument, options);
      }
export function useOrganizationMemberModelsSeatLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>(OrganizationMemberModelsSeatDocument, options);
        }
// @ts-ignore
export function useOrganizationMemberModelsSeatSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>;
export function useOrganizationMemberModelsSeatSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMemberModelsSeatQuery | undefined, OrganizationMemberModelsSeatQueryVariables>;
export function useOrganizationMemberModelsSeatSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>(OrganizationMemberModelsSeatDocument, options);
        }
export type OrganizationMemberModelsSeatQueryHookResult = ReturnType<typeof useOrganizationMemberModelsSeatQuery>;
export type OrganizationMemberModelsSeatLazyQueryHookResult = ReturnType<typeof useOrganizationMemberModelsSeatLazyQuery>;
export type OrganizationMemberModelsSeatSuspenseQueryHookResult = ReturnType<typeof useOrganizationMemberModelsSeatSuspenseQuery>;
export type OrganizationMemberModelsSeatQueryResult = ApolloReactCommon.QueryResult<OrganizationMemberModelsSeatQuery, OrganizationMemberModelsSeatQueryVariables>;
export const OrganizationMemberWeaveRoleDocument = gql`
    query OrganizationMemberWeaveRole($orgName: String, $username: String) {
  organization(name: $orgName) {
    id
    member(username: $username) {
      id
      weaveRole
    }
  }
}
    `;

/**
 * __useOrganizationMemberWeaveRoleQuery__
 *
 * To run a query within a React component, call `useOrganizationMemberWeaveRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMemberWeaveRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMemberWeaveRoleQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useOrganizationMemberWeaveRoleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>(OrganizationMemberWeaveRoleDocument, options);
      }
export function useOrganizationMemberWeaveRoleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>(OrganizationMemberWeaveRoleDocument, options);
        }
// @ts-ignore
export function useOrganizationMemberWeaveRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>;
export function useOrganizationMemberWeaveRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMemberWeaveRoleQuery | undefined, OrganizationMemberWeaveRoleQueryVariables>;
export function useOrganizationMemberWeaveRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>(OrganizationMemberWeaveRoleDocument, options);
        }
export type OrganizationMemberWeaveRoleQueryHookResult = ReturnType<typeof useOrganizationMemberWeaveRoleQuery>;
export type OrganizationMemberWeaveRoleLazyQueryHookResult = ReturnType<typeof useOrganizationMemberWeaveRoleLazyQuery>;
export type OrganizationMemberWeaveRoleSuspenseQueryHookResult = ReturnType<typeof useOrganizationMemberWeaveRoleSuspenseQuery>;
export type OrganizationMemberWeaveRoleQueryResult = ApolloReactCommon.QueryResult<OrganizationMemberWeaveRoleQuery, OrganizationMemberWeaveRoleQueryVariables>;
export const OrganizationMembersDocument = gql`
    query OrganizationMembers($orgName: String!) {
  organization(name: $orgName) {
    id
    members {
      id
      name
      username
      email
      photoUrl
      user {
        id
        accountType
      }
      teams {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useOrganizationMembersQuery__
 *
 * To run a query within a React component, call `useOrganizationMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMembersQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationMembersQuery, OrganizationMembersQueryVariables> & ({ variables: OrganizationMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationMembersQuery, OrganizationMembersQueryVariables>(OrganizationMembersDocument, options);
      }
export function useOrganizationMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationMembersQuery, OrganizationMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationMembersQuery, OrganizationMembersQueryVariables>(OrganizationMembersDocument, options);
        }
// @ts-ignore
export function useOrganizationMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMembersQuery, OrganizationMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMembersQuery, OrganizationMembersQueryVariables>;
export function useOrganizationMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMembersQuery, OrganizationMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMembersQuery | undefined, OrganizationMembersQueryVariables>;
export function useOrganizationMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMembersQuery, OrganizationMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationMembersQuery, OrganizationMembersQueryVariables>(OrganizationMembersDocument, options);
        }
export type OrganizationMembersQueryHookResult = ReturnType<typeof useOrganizationMembersQuery>;
export type OrganizationMembersLazyQueryHookResult = ReturnType<typeof useOrganizationMembersLazyQuery>;
export type OrganizationMembersSuspenseQueryHookResult = ReturnType<typeof useOrganizationMembersSuspenseQuery>;
export type OrganizationMembersQueryResult = ApolloReactCommon.QueryResult<OrganizationMembersQuery, OrganizationMembersQueryVariables>;
export const OrganizationApiKeysDocument = gql`
    query OrganizationApiKeys($orgName: String!, $first: Int, $after: String) {
  organization(name: $orgName) {
    id
    apiKeysConnection(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
      edges {
        node {
          id
          apiKeyId
          description
          createdAt
          expiresAt
          lastUsedAt
          user {
            id
            name
            accountType
            username
          }
        }
      }
    }
  }
}
    `;

/**
 * __useOrganizationApiKeysQuery__
 *
 * To run a query within a React component, call `useOrganizationApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationApiKeysQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useOrganizationApiKeysQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables> & ({ variables: OrganizationApiKeysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables>(OrganizationApiKeysDocument, options);
      }
export function useOrganizationApiKeysLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables>(OrganizationApiKeysDocument, options);
        }
// @ts-ignore
export function useOrganizationApiKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables>;
export function useOrganizationApiKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationApiKeysQuery | undefined, OrganizationApiKeysQueryVariables>;
export function useOrganizationApiKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables>(OrganizationApiKeysDocument, options);
        }
export type OrganizationApiKeysQueryHookResult = ReturnType<typeof useOrganizationApiKeysQuery>;
export type OrganizationApiKeysLazyQueryHookResult = ReturnType<typeof useOrganizationApiKeysLazyQuery>;
export type OrganizationApiKeysSuspenseQueryHookResult = ReturnType<typeof useOrganizationApiKeysSuspenseQuery>;
export type OrganizationApiKeysQueryResult = ApolloReactCommon.QueryResult<OrganizationApiKeysQuery, OrganizationApiKeysQueryVariables>;
export const FetchPreviewableLinkDocument = gql`
    query FetchPreviewableLink($resourceID: ID!, $resourceType: PreviewableLinkResourceType!) {
  previewableLink(resourceID: $resourceID, resourceType: $resourceType) {
    id
    URL
    createdAt
    updatedAt
    resourceID
    resourceType
    __typename
  }
}
    `;

/**
 * __useFetchPreviewableLinkQuery__
 *
 * To run a query within a React component, call `useFetchPreviewableLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPreviewableLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchPreviewableLinkQuery({
 *   variables: {
 *      resourceID: // value for 'resourceID'
 *      resourceType: // value for 'resourceType'
 *   },
 * });
 */
export function useFetchPreviewableLinkQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables> & ({ variables: FetchPreviewableLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables>(FetchPreviewableLinkDocument, options);
      }
export function useFetchPreviewableLinkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables>(FetchPreviewableLinkDocument, options);
        }
// @ts-ignore
export function useFetchPreviewableLinkSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables>;
export function useFetchPreviewableLinkSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchPreviewableLinkQuery | undefined, FetchPreviewableLinkQueryVariables>;
export function useFetchPreviewableLinkSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables>(FetchPreviewableLinkDocument, options);
        }
export type FetchPreviewableLinkQueryHookResult = ReturnType<typeof useFetchPreviewableLinkQuery>;
export type FetchPreviewableLinkLazyQueryHookResult = ReturnType<typeof useFetchPreviewableLinkLazyQuery>;
export type FetchPreviewableLinkSuspenseQueryHookResult = ReturnType<typeof useFetchPreviewableLinkSuspenseQuery>;
export type FetchPreviewableLinkQueryResult = ApolloReactCommon.QueryResult<FetchPreviewableLinkQuery, FetchPreviewableLinkQueryVariables>;
export const CreateStorageSubscriptionDocument = gql`
    mutation createStorageSubscription($organizationId: ID, $paymentMethod: String, $clientMutationId: String) {
  createStorageSubscription(
    input: {organizationId: $organizationId, paymentMethod: $paymentMethod, clientMutationId: $clientMutationId}
  ) {
    subscription
    clientMutationId
  }
}
    `;
export type CreateStorageSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CreateStorageSubscriptionMutation, CreateStorageSubscriptionMutationVariables>;

/**
 * __useCreateStorageSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateStorageSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStorageSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStorageSubscriptionMutation, { data, loading, error }] = useCreateStorageSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      paymentMethod: // value for 'paymentMethod'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCreateStorageSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateStorageSubscriptionMutation, CreateStorageSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateStorageSubscriptionMutation, CreateStorageSubscriptionMutationVariables>(CreateStorageSubscriptionDocument, options);
      }
export type CreateStorageSubscriptionMutationHookResult = ReturnType<typeof useCreateStorageSubscriptionMutation>;
export type CreateStorageSubscriptionMutationResult = ApolloReactCommon.MutationResult<CreateStorageSubscriptionMutation>;
export type CreateStorageSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateStorageSubscriptionMutation, CreateStorageSubscriptionMutationVariables>;
export const CreateInferenceSubscriptionDocument = gql`
    mutation createInferenceSubscription($organizationId: ID, $paymentMethod: String, $clientMutationId: String) {
  createInferenceSubscription(
    input: {organizationId: $organizationId, paymentMethod: $paymentMethod, clientMutationId: $clientMutationId}
  ) {
    subscription
    clientMutationId
  }
}
    `;
export type CreateInferenceSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CreateInferenceSubscriptionMutation, CreateInferenceSubscriptionMutationVariables>;

/**
 * __useCreateInferenceSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateInferenceSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInferenceSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInferenceSubscriptionMutation, { data, loading, error }] = useCreateInferenceSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      paymentMethod: // value for 'paymentMethod'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCreateInferenceSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInferenceSubscriptionMutation, CreateInferenceSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateInferenceSubscriptionMutation, CreateInferenceSubscriptionMutationVariables>(CreateInferenceSubscriptionDocument, options);
      }
export type CreateInferenceSubscriptionMutationHookResult = ReturnType<typeof useCreateInferenceSubscriptionMutation>;
export type CreateInferenceSubscriptionMutationResult = ApolloReactCommon.MutationResult<CreateInferenceSubscriptionMutation>;
export type CreateInferenceSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateInferenceSubscriptionMutation, CreateInferenceSubscriptionMutationVariables>;
export const CreatePricingPlanUpdatePrDocument = gql`
    mutation CreatePricingPlanUpdatePR($input: CreatePricingPlanUpdatePRInput!) {
  createPricingPlanUpdatePR(input: $input) {
    prUrl
    branchName
  }
}
    `;
export type CreatePricingPlanUpdatePrMutationFn = ApolloReactCommon.MutationFunction<CreatePricingPlanUpdatePrMutation, CreatePricingPlanUpdatePrMutationVariables>;

/**
 * __useCreatePricingPlanUpdatePrMutation__
 *
 * To run a mutation, you first call `useCreatePricingPlanUpdatePrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePricingPlanUpdatePrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPricingPlanUpdatePrMutation, { data, loading, error }] = useCreatePricingPlanUpdatePrMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePricingPlanUpdatePrMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePricingPlanUpdatePrMutation, CreatePricingPlanUpdatePrMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePricingPlanUpdatePrMutation, CreatePricingPlanUpdatePrMutationVariables>(CreatePricingPlanUpdatePrDocument, options);
      }
export type CreatePricingPlanUpdatePrMutationHookResult = ReturnType<typeof useCreatePricingPlanUpdatePrMutation>;
export type CreatePricingPlanUpdatePrMutationResult = ApolloReactCommon.MutationResult<CreatePricingPlanUpdatePrMutation>;
export type CreatePricingPlanUpdatePrMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePricingPlanUpdatePrMutation, CreatePricingPlanUpdatePrMutationVariables>;
export const CreateSandboxesSubscriptionDocument = gql`
    mutation createSandboxesSubscription($organizationId: ID, $paymentMethod: String, $clientMutationId: String) {
  createSandboxesSubscription(
    input: {organizationId: $organizationId, paymentMethod: $paymentMethod, clientMutationId: $clientMutationId}
  ) {
    subscription
    clientMutationId
  }
}
    `;
export type CreateSandboxesSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CreateSandboxesSubscriptionMutation, CreateSandboxesSubscriptionMutationVariables>;

/**
 * __useCreateSandboxesSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSandboxesSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSandboxesSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSandboxesSubscriptionMutation, { data, loading, error }] = useCreateSandboxesSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      paymentMethod: // value for 'paymentMethod'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCreateSandboxesSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSandboxesSubscriptionMutation, CreateSandboxesSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSandboxesSubscriptionMutation, CreateSandboxesSubscriptionMutationVariables>(CreateSandboxesSubscriptionDocument, options);
      }
export type CreateSandboxesSubscriptionMutationHookResult = ReturnType<typeof useCreateSandboxesSubscriptionMutation>;
export type CreateSandboxesSubscriptionMutationResult = ApolloReactCommon.MutationResult<CreateSandboxesSubscriptionMutation>;
export type CreateSandboxesSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSandboxesSubscriptionMutation, CreateSandboxesSubscriptionMutationVariables>;
export const ProfilePageDocument = gql`
    query ProfilePage($username: String!, $first: Int = 100, $offset: Int = 0, $displayNameContains: String) {
  user(userName: $username) {
    id
    name
    username
    email
    photoUrl
    userInfo
    hideTeamsFromPublic
    accountType
    defaultEntity {
      id
      name
    }
    views(
      viewType: "runs"
      first: $first
      offset: $offset
      displayNameContains: $displayNameContains
    ) {
      totalCount
      edges {
        node {
          id
          ...ReportsTableFragment
        }
      }
    }
    starredViews(first: 500) {
      edges {
        node {
          id
          ...ReportsTableFragment
        }
      }
    }
    teams(first: 100) {
      edges {
        node {
          id
          name
          photoUrl
          isTeam
        }
      }
    }
  }
}
    ${ReportsTableFragmentFragmentDoc}`;

/**
 * __useProfilePageQuery__
 *
 * To run a query within a React component, call `useProfilePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilePageQuery({
 *   variables: {
 *      username: // value for 'username'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *      displayNameContains: // value for 'displayNameContains'
 *   },
 * });
 */
export function useProfilePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProfilePageQuery, ProfilePageQueryVariables> & ({ variables: ProfilePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfilePageQuery, ProfilePageQueryVariables>(ProfilePageDocument, options);
      }
export function useProfilePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfilePageQuery, ProfilePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfilePageQuery, ProfilePageQueryVariables>(ProfilePageDocument, options);
        }
// @ts-ignore
export function useProfilePageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageQuery, ProfilePageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfilePageQuery, ProfilePageQueryVariables>;
export function useProfilePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageQuery, ProfilePageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfilePageQuery | undefined, ProfilePageQueryVariables>;
export function useProfilePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageQuery, ProfilePageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfilePageQuery, ProfilePageQueryVariables>(ProfilePageDocument, options);
        }
export type ProfilePageQueryHookResult = ReturnType<typeof useProfilePageQuery>;
export type ProfilePageLazyQueryHookResult = ReturnType<typeof useProfilePageLazyQuery>;
export type ProfilePageSuspenseQueryHookResult = ReturnType<typeof useProfilePageSuspenseQuery>;
export type ProfilePageQueryResult = ApolloReactCommon.QueryResult<ProfilePageQuery, ProfilePageQueryVariables>;
export const ProfilePageReportsDocument = gql`
    query ProfilePageReports($username: String!, $first: Int = 10, $offset: Int = 0, $displayNameContains: String) {
  user(userName: $username) {
    id
    views(
      viewType: "runs"
      first: $first
      offset: $offset
      displayNameContains: $displayNameContains
    ) {
      totalCount
      edges {
        node {
          id
          ...ReportsTableFragment
        }
      }
    }
  }
}
    ${ReportsTableFragmentFragmentDoc}`;

/**
 * __useProfilePageReportsQuery__
 *
 * To run a query within a React component, call `useProfilePageReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilePageReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilePageReportsQuery({
 *   variables: {
 *      username: // value for 'username'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *      displayNameContains: // value for 'displayNameContains'
 *   },
 * });
 */
export function useProfilePageReportsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProfilePageReportsQuery, ProfilePageReportsQueryVariables> & ({ variables: ProfilePageReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfilePageReportsQuery, ProfilePageReportsQueryVariables>(ProfilePageReportsDocument, options);
      }
export function useProfilePageReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfilePageReportsQuery, ProfilePageReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfilePageReportsQuery, ProfilePageReportsQueryVariables>(ProfilePageReportsDocument, options);
        }
// @ts-ignore
export function useProfilePageReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageReportsQuery, ProfilePageReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfilePageReportsQuery, ProfilePageReportsQueryVariables>;
export function useProfilePageReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageReportsQuery, ProfilePageReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfilePageReportsQuery | undefined, ProfilePageReportsQueryVariables>;
export function useProfilePageReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageReportsQuery, ProfilePageReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfilePageReportsQuery, ProfilePageReportsQueryVariables>(ProfilePageReportsDocument, options);
        }
export type ProfilePageReportsQueryHookResult = ReturnType<typeof useProfilePageReportsQuery>;
export type ProfilePageReportsLazyQueryHookResult = ReturnType<typeof useProfilePageReportsLazyQuery>;
export type ProfilePageReportsSuspenseQueryHookResult = ReturnType<typeof useProfilePageReportsSuspenseQuery>;
export type ProfilePageReportsQueryResult = ApolloReactCommon.QueryResult<ProfilePageReportsQuery, ProfilePageReportsQueryVariables>;
export const ProfileUserCheckDocument = gql`
    query ProfileUserCheck($username: String!) {
  user(userName: $username) {
    id
    name
    username
  }
}
    `;

/**
 * __useProfileUserCheckQuery__
 *
 * To run a query within a React component, call `useProfileUserCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileUserCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileUserCheckQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useProfileUserCheckQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProfileUserCheckQuery, ProfileUserCheckQueryVariables> & ({ variables: ProfileUserCheckQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfileUserCheckQuery, ProfileUserCheckQueryVariables>(ProfileUserCheckDocument, options);
      }
export function useProfileUserCheckLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfileUserCheckQuery, ProfileUserCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfileUserCheckQuery, ProfileUserCheckQueryVariables>(ProfileUserCheckDocument, options);
        }
// @ts-ignore
export function useProfileUserCheckSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProfileUserCheckQuery, ProfileUserCheckQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfileUserCheckQuery, ProfileUserCheckQueryVariables>;
export function useProfileUserCheckSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfileUserCheckQuery, ProfileUserCheckQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfileUserCheckQuery | undefined, ProfileUserCheckQueryVariables>;
export function useProfileUserCheckSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfileUserCheckQuery, ProfileUserCheckQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfileUserCheckQuery, ProfileUserCheckQueryVariables>(ProfileUserCheckDocument, options);
        }
export type ProfileUserCheckQueryHookResult = ReturnType<typeof useProfileUserCheckQuery>;
export type ProfileUserCheckLazyQueryHookResult = ReturnType<typeof useProfileUserCheckLazyQuery>;
export type ProfileUserCheckSuspenseQueryHookResult = ReturnType<typeof useProfileUserCheckSuspenseQuery>;
export type ProfileUserCheckQueryResult = ApolloReactCommon.QueryResult<ProfileUserCheckQuery, ProfileUserCheckQueryVariables>;
export const ProfilePageProjectsDocument = gql`
    query ProfilePageProjects($username: String!) {
  user(userName: $username) {
    id
    projects(first: 100) {
      edges {
        node {
          id
          name
          entityName
          access
          description
          totalRuns
          lastActive
          runCount
          user {
            id
            username
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProfilePageProjectsQuery__
 *
 * To run a query within a React component, call `useProfilePageProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilePageProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilePageProjectsQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useProfilePageProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables> & ({ variables: ProfilePageProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables>(ProfilePageProjectsDocument, options);
      }
export function useProfilePageProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables>(ProfilePageProjectsDocument, options);
        }
// @ts-ignore
export function useProfilePageProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables>;
export function useProfilePageProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfilePageProjectsQuery | undefined, ProfilePageProjectsQueryVariables>;
export function useProfilePageProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables>(ProfilePageProjectsDocument, options);
        }
export type ProfilePageProjectsQueryHookResult = ReturnType<typeof useProfilePageProjectsQuery>;
export type ProfilePageProjectsLazyQueryHookResult = ReturnType<typeof useProfilePageProjectsLazyQuery>;
export type ProfilePageProjectsSuspenseQueryHookResult = ReturnType<typeof useProfilePageProjectsSuspenseQuery>;
export type ProfilePageProjectsQueryResult = ApolloReactCommon.QueryResult<ProfilePageProjectsQuery, ProfilePageProjectsQueryVariables>;
export const UserRunsActivityDocument = gql`
    query UserRunsActivity($username: String!, $dailyRunCountLimit: Int!) {
  user(userName: $username) {
    id
    dailyRunCount(limit: $dailyRunCountLimit)
  }
}
    `;

/**
 * __useUserRunsActivityQuery__
 *
 * To run a query within a React component, call `useUserRunsActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRunsActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRunsActivityQuery({
 *   variables: {
 *      username: // value for 'username'
 *      dailyRunCountLimit: // value for 'dailyRunCountLimit'
 *   },
 * });
 */
export function useUserRunsActivityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserRunsActivityQuery, UserRunsActivityQueryVariables> & ({ variables: UserRunsActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserRunsActivityQuery, UserRunsActivityQueryVariables>(UserRunsActivityDocument, options);
      }
export function useUserRunsActivityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserRunsActivityQuery, UserRunsActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserRunsActivityQuery, UserRunsActivityQueryVariables>(UserRunsActivityDocument, options);
        }
// @ts-ignore
export function useUserRunsActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserRunsActivityQuery, UserRunsActivityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserRunsActivityQuery, UserRunsActivityQueryVariables>;
export function useUserRunsActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserRunsActivityQuery, UserRunsActivityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserRunsActivityQuery | undefined, UserRunsActivityQueryVariables>;
export function useUserRunsActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserRunsActivityQuery, UserRunsActivityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserRunsActivityQuery, UserRunsActivityQueryVariables>(UserRunsActivityDocument, options);
        }
export type UserRunsActivityQueryHookResult = ReturnType<typeof useUserRunsActivityQuery>;
export type UserRunsActivityLazyQueryHookResult = ReturnType<typeof useUserRunsActivityLazyQuery>;
export type UserRunsActivitySuspenseQueryHookResult = ReturnType<typeof useUserRunsActivitySuspenseQuery>;
export type UserRunsActivityQueryResult = ApolloReactCommon.QueryResult<UserRunsActivityQuery, UserRunsActivityQueryVariables>;
export const UserRunsDocument = gql`
    query UserRuns($username: String!, $pattern: String, $first: Int = 100) {
  user(userName: $username) {
    id
    runs(first: $first, pattern: $pattern) {
      edges {
        node {
          id
          ...RunsTableFragment
        }
      }
    }
  }
}
    ${RunsTableFragmentFragmentDoc}`;

/**
 * __useUserRunsQuery__
 *
 * To run a query within a React component, call `useUserRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRunsQuery({
 *   variables: {
 *      username: // value for 'username'
 *      pattern: // value for 'pattern'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useUserRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserRunsQuery, UserRunsQueryVariables> & ({ variables: UserRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserRunsQuery, UserRunsQueryVariables>(UserRunsDocument, options);
      }
export function useUserRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserRunsQuery, UserRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserRunsQuery, UserRunsQueryVariables>(UserRunsDocument, options);
        }
// @ts-ignore
export function useUserRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserRunsQuery, UserRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserRunsQuery, UserRunsQueryVariables>;
export function useUserRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserRunsQuery, UserRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserRunsQuery | undefined, UserRunsQueryVariables>;
export function useUserRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserRunsQuery, UserRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserRunsQuery, UserRunsQueryVariables>(UserRunsDocument, options);
        }
export type UserRunsQueryHookResult = ReturnType<typeof useUserRunsQuery>;
export type UserRunsLazyQueryHookResult = ReturnType<typeof useUserRunsLazyQuery>;
export type UserRunsSuspenseQueryHookResult = ReturnType<typeof useUserRunsSuspenseQuery>;
export type UserRunsQueryResult = ApolloReactCommon.QueryResult<UserRunsQuery, UserRunsQueryVariables>;
export const ProjectNameFromInternalIdDocument = gql`
    query ProjectNameFromInternalId($internalId: ID!) {
  project(internalId: $internalId) {
    id
    entityName
    name
  }
}
    `;

/**
 * __useProjectNameFromInternalIdQuery__
 *
 * To run a query within a React component, call `useProjectNameFromInternalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectNameFromInternalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectNameFromInternalIdQuery({
 *   variables: {
 *      internalId: // value for 'internalId'
 *   },
 * });
 */
export function useProjectNameFromInternalIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables> & ({ variables: ProjectNameFromInternalIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables>(ProjectNameFromInternalIdDocument, options);
      }
export function useProjectNameFromInternalIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables>(ProjectNameFromInternalIdDocument, options);
        }
// @ts-ignore
export function useProjectNameFromInternalIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables>;
export function useProjectNameFromInternalIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectNameFromInternalIdQuery | undefined, ProjectNameFromInternalIdQueryVariables>;
export function useProjectNameFromInternalIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables>(ProjectNameFromInternalIdDocument, options);
        }
export type ProjectNameFromInternalIdQueryHookResult = ReturnType<typeof useProjectNameFromInternalIdQuery>;
export type ProjectNameFromInternalIdLazyQueryHookResult = ReturnType<typeof useProjectNameFromInternalIdLazyQuery>;
export type ProjectNameFromInternalIdSuspenseQueryHookResult = ReturnType<typeof useProjectNameFromInternalIdSuspenseQuery>;
export type ProjectNameFromInternalIdQueryResult = ApolloReactCommon.QueryResult<ProjectNameFromInternalIdQuery, ProjectNameFromInternalIdQueryVariables>;
export const ProjectInternalIdFromNameDocument = gql`
    query ProjectInternalIdFromName($entityName: String!, $projectName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    internalId
  }
}
    `;

/**
 * __useProjectInternalIdFromNameQuery__
 *
 * To run a query within a React component, call `useProjectInternalIdFromNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectInternalIdFromNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectInternalIdFromNameQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useProjectInternalIdFromNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables> & ({ variables: ProjectInternalIdFromNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables>(ProjectInternalIdFromNameDocument, options);
      }
export function useProjectInternalIdFromNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables>(ProjectInternalIdFromNameDocument, options);
        }
// @ts-ignore
export function useProjectInternalIdFromNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables>;
export function useProjectInternalIdFromNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectInternalIdFromNameQuery | undefined, ProjectInternalIdFromNameQueryVariables>;
export function useProjectInternalIdFromNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables>(ProjectInternalIdFromNameDocument, options);
        }
export type ProjectInternalIdFromNameQueryHookResult = ReturnType<typeof useProjectInternalIdFromNameQuery>;
export type ProjectInternalIdFromNameLazyQueryHookResult = ReturnType<typeof useProjectInternalIdFromNameLazyQuery>;
export type ProjectInternalIdFromNameSuspenseQueryHookResult = ReturnType<typeof useProjectInternalIdFromNameSuspenseQuery>;
export type ProjectInternalIdFromNameQueryResult = ApolloReactCommon.QueryResult<ProjectInternalIdFromNameQuery, ProjectInternalIdFromNameQueryVariables>;
export const ProjectInfosFromInternalIdsDocument = gql`
    query ProjectInfosFromInternalIds($internalIds: [ID!]!) {
  projects(internalIDs: $internalIds) {
    edges {
      node {
        id
        internalId
        name
        entityName
      }
    }
  }
}
    `;

/**
 * __useProjectInfosFromInternalIdsQuery__
 *
 * To run a query within a React component, call `useProjectInfosFromInternalIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectInfosFromInternalIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectInfosFromInternalIdsQuery({
 *   variables: {
 *      internalIds: // value for 'internalIds'
 *   },
 * });
 */
export function useProjectInfosFromInternalIdsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables> & ({ variables: ProjectInfosFromInternalIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables>(ProjectInfosFromInternalIdsDocument, options);
      }
export function useProjectInfosFromInternalIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables>(ProjectInfosFromInternalIdsDocument, options);
        }
// @ts-ignore
export function useProjectInfosFromInternalIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables>;
export function useProjectInfosFromInternalIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectInfosFromInternalIdsQuery | undefined, ProjectInfosFromInternalIdsQueryVariables>;
export function useProjectInfosFromInternalIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables>(ProjectInfosFromInternalIdsDocument, options);
        }
export type ProjectInfosFromInternalIdsQueryHookResult = ReturnType<typeof useProjectInfosFromInternalIdsQuery>;
export type ProjectInfosFromInternalIdsLazyQueryHookResult = ReturnType<typeof useProjectInfosFromInternalIdsLazyQuery>;
export type ProjectInfosFromInternalIdsSuspenseQueryHookResult = ReturnType<typeof useProjectInfosFromInternalIdsSuspenseQuery>;
export type ProjectInfosFromInternalIdsQueryResult = ApolloReactCommon.QueryResult<ProjectInfosFromInternalIdsQuery, ProjectInfosFromInternalIdsQueryVariables>;
export const AllProjectNamesDocument = gql`
    query AllProjectNames($entityName: String!, $first: Int = 500, $order: String = "name") {
  projects(first: $first, entityName: $entityName, order: $order) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAllProjectNamesQuery__
 *
 * To run a query within a React component, call `useAllProjectNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProjectNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProjectNamesQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      first: // value for 'first'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAllProjectNamesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllProjectNamesQuery, AllProjectNamesQueryVariables> & ({ variables: AllProjectNamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllProjectNamesQuery, AllProjectNamesQueryVariables>(AllProjectNamesDocument, options);
      }
export function useAllProjectNamesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllProjectNamesQuery, AllProjectNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllProjectNamesQuery, AllProjectNamesQueryVariables>(AllProjectNamesDocument, options);
        }
// @ts-ignore
export function useAllProjectNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllProjectNamesQuery, AllProjectNamesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllProjectNamesQuery, AllProjectNamesQueryVariables>;
export function useAllProjectNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllProjectNamesQuery, AllProjectNamesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllProjectNamesQuery | undefined, AllProjectNamesQueryVariables>;
export function useAllProjectNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllProjectNamesQuery, AllProjectNamesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllProjectNamesQuery, AllProjectNamesQueryVariables>(AllProjectNamesDocument, options);
        }
export type AllProjectNamesQueryHookResult = ReturnType<typeof useAllProjectNamesQuery>;
export type AllProjectNamesLazyQueryHookResult = ReturnType<typeof useAllProjectNamesLazyQuery>;
export type AllProjectNamesSuspenseQueryHookResult = ReturnType<typeof useAllProjectNamesSuspenseQuery>;
export type AllProjectNamesQueryResult = ApolloReactCommon.QueryResult<AllProjectNamesQuery, AllProjectNamesQueryVariables>;
export const AllProjectNamesWithPatternDocument = gql`
    query AllProjectNamesWithPattern($entityName: String!, $first: Int = 500, $order: String = "name", $pattern: String) {
  projects(
    first: $first
    entityName: $entityName
    order: $order
    pattern: $pattern
  ) {
    edges {
      node {
        id
        name
        entityName
      }
    }
  }
}
    `;

/**
 * __useAllProjectNamesWithPatternQuery__
 *
 * To run a query within a React component, call `useAllProjectNamesWithPatternQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProjectNamesWithPatternQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProjectNamesWithPatternQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      first: // value for 'first'
 *      order: // value for 'order'
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useAllProjectNamesWithPatternQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables> & ({ variables: AllProjectNamesWithPatternQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables>(AllProjectNamesWithPatternDocument, options);
      }
export function useAllProjectNamesWithPatternLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables>(AllProjectNamesWithPatternDocument, options);
        }
// @ts-ignore
export function useAllProjectNamesWithPatternSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables>;
export function useAllProjectNamesWithPatternSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllProjectNamesWithPatternQuery | undefined, AllProjectNamesWithPatternQueryVariables>;
export function useAllProjectNamesWithPatternSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables>(AllProjectNamesWithPatternDocument, options);
        }
export type AllProjectNamesWithPatternQueryHookResult = ReturnType<typeof useAllProjectNamesWithPatternQuery>;
export type AllProjectNamesWithPatternLazyQueryHookResult = ReturnType<typeof useAllProjectNamesWithPatternLazyQuery>;
export type AllProjectNamesWithPatternSuspenseQueryHookResult = ReturnType<typeof useAllProjectNamesWithPatternSuspenseQuery>;
export type AllProjectNamesWithPatternQueryResult = ApolloReactCommon.QueryResult<AllProjectNamesWithPatternQuery, AllProjectNamesWithPatternQueryVariables>;
export const MoveProjectsDocument = gql`
    mutation moveProjects($projectNames: [String!], $sourceEntityName: String!, $destinationEntityName: String!, $ownerUsername: String!, $notes: String, $clientMutationId: String) {
  moveProjects(
    input: {projectNames: $projectNames, sourceEntityName: $sourceEntityName, destinationEntityName: $destinationEntityName, ownerUsername: $ownerUsername, notes: $notes, clientMutationId: $clientMutationId}
  ) {
    tasks {
      id
      type
      state
      progress
      name
    }
  }
}
    `;
export type MoveProjectsMutationFn = ApolloReactCommon.MutationFunction<MoveProjectsMutation, MoveProjectsMutationVariables>;

/**
 * __useMoveProjectsMutation__
 *
 * To run a mutation, you first call `useMoveProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveProjectsMutation, { data, loading, error }] = useMoveProjectsMutation({
 *   variables: {
 *      projectNames: // value for 'projectNames'
 *      sourceEntityName: // value for 'sourceEntityName'
 *      destinationEntityName: // value for 'destinationEntityName'
 *      ownerUsername: // value for 'ownerUsername'
 *      notes: // value for 'notes'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useMoveProjectsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveProjectsMutation, MoveProjectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveProjectsMutation, MoveProjectsMutationVariables>(MoveProjectsDocument, options);
      }
export type MoveProjectsMutationHookResult = ReturnType<typeof useMoveProjectsMutation>;
export type MoveProjectsMutationResult = ApolloReactCommon.MutationResult<MoveProjectsMutation>;
export type MoveProjectsMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveProjectsMutation, MoveProjectsMutationVariables>;
export const CloneProjectsDocument = gql`
    mutation cloneProjects($projectNames: [String!], $sourceEntityName: String!, $destinationEntityName: String!, $ownerUsername: String!, $notes: String, $clientMutationId: String) {
  cloneProjects(
    input: {projectNames: $projectNames, sourceEntityName: $sourceEntityName, destinationEntityName: $destinationEntityName, ownerUsername: $ownerUsername, notes: $notes, clientMutationId: $clientMutationId}
  ) {
    tasks {
      id
      type
      state
      progress
      name
    }
  }
}
    `;
export type CloneProjectsMutationFn = ApolloReactCommon.MutationFunction<CloneProjectsMutation, CloneProjectsMutationVariables>;

/**
 * __useCloneProjectsMutation__
 *
 * To run a mutation, you first call `useCloneProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneProjectsMutation, { data, loading, error }] = useCloneProjectsMutation({
 *   variables: {
 *      projectNames: // value for 'projectNames'
 *      sourceEntityName: // value for 'sourceEntityName'
 *      destinationEntityName: // value for 'destinationEntityName'
 *      ownerUsername: // value for 'ownerUsername'
 *      notes: // value for 'notes'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCloneProjectsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CloneProjectsMutation, CloneProjectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CloneProjectsMutation, CloneProjectsMutationVariables>(CloneProjectsDocument, options);
      }
export type CloneProjectsMutationHookResult = ReturnType<typeof useCloneProjectsMutation>;
export type CloneProjectsMutationResult = ApolloReactCommon.MutationResult<CloneProjectsMutation>;
export type CloneProjectsMutationOptions = ApolloReactCommon.BaseMutationOptions<CloneProjectsMutation, CloneProjectsMutationVariables>;
export const MoveHistoryForRunDocument = gql`
    mutation moveHistoryForRun($sourceEntityName: String!, $sourceProjectName: String!, $runName: String!, $destinationEntityName: String!, $destinationProjectName: String!, $clientMutationId: String) {
  moveHistoryForRun(
    input: {sourceEntityName: $sourceEntityName, sourceProjectName: $sourceProjectName, runName: $runName, destinationEntityName: $destinationEntityName, destinationProjectName: $destinationProjectName, clientMutationId: $clientMutationId}
  ) {
    task {
      id
      type
      state
      progress
      name
    }
  }
}
    `;
export type MoveHistoryForRunMutationFn = ApolloReactCommon.MutationFunction<MoveHistoryForRunMutation, MoveHistoryForRunMutationVariables>;

/**
 * __useMoveHistoryForRunMutation__
 *
 * To run a mutation, you first call `useMoveHistoryForRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveHistoryForRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveHistoryForRunMutation, { data, loading, error }] = useMoveHistoryForRunMutation({
 *   variables: {
 *      sourceEntityName: // value for 'sourceEntityName'
 *      sourceProjectName: // value for 'sourceProjectName'
 *      runName: // value for 'runName'
 *      destinationEntityName: // value for 'destinationEntityName'
 *      destinationProjectName: // value for 'destinationProjectName'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useMoveHistoryForRunMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveHistoryForRunMutation, MoveHistoryForRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveHistoryForRunMutation, MoveHistoryForRunMutationVariables>(MoveHistoryForRunDocument, options);
      }
export type MoveHistoryForRunMutationHookResult = ReturnType<typeof useMoveHistoryForRunMutation>;
export type MoveHistoryForRunMutationResult = ApolloReactCommon.MutationResult<MoveHistoryForRunMutation>;
export type MoveHistoryForRunMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveHistoryForRunMutation, MoveHistoryForRunMutationVariables>;
export const ProjectMembersDocument = gql`
    query ProjectMembers($projectName: String!, $entityName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    members {
      ...ProjectMemberFields
    }
  }
}
    ${ProjectMemberFieldsFragmentDoc}`;

/**
 * __useProjectMembersQuery__
 *
 * To run a query within a React component, call `useProjectMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectMembersQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useProjectMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectMembersQuery, ProjectMembersQueryVariables> & ({ variables: ProjectMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectMembersQuery, ProjectMembersQueryVariables>(ProjectMembersDocument, options);
      }
export function useProjectMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectMembersQuery, ProjectMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectMembersQuery, ProjectMembersQueryVariables>(ProjectMembersDocument, options);
        }
// @ts-ignore
export function useProjectMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectMembersQuery, ProjectMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectMembersQuery, ProjectMembersQueryVariables>;
export function useProjectMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectMembersQuery, ProjectMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectMembersQuery | undefined, ProjectMembersQueryVariables>;
export function useProjectMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectMembersQuery, ProjectMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectMembersQuery, ProjectMembersQueryVariables>(ProjectMembersDocument, options);
        }
export type ProjectMembersQueryHookResult = ReturnType<typeof useProjectMembersQuery>;
export type ProjectMembersLazyQueryHookResult = ReturnType<typeof useProjectMembersLazyQuery>;
export type ProjectMembersSuspenseQueryHookResult = ReturnType<typeof useProjectMembersSuspenseQuery>;
export type ProjectMembersQueryResult = ApolloReactCommon.QueryResult<ProjectMembersQuery, ProjectMembersQueryVariables>;
export const ProjectMemberDocument = gql`
    query ProjectMember($projectName: String!, $entityName: String!, $memberId: ID!) {
  project(name: $projectName, entityName: $entityName) {
    id
    member(id: $memberId) {
      ...ProjectMemberFields
    }
  }
}
    ${ProjectMemberFieldsFragmentDoc}`;

/**
 * __useProjectMemberQuery__
 *
 * To run a query within a React component, call `useProjectMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectMemberQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useProjectMemberQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectMemberQuery, ProjectMemberQueryVariables> & ({ variables: ProjectMemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectMemberQuery, ProjectMemberQueryVariables>(ProjectMemberDocument, options);
      }
export function useProjectMemberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectMemberQuery, ProjectMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectMemberQuery, ProjectMemberQueryVariables>(ProjectMemberDocument, options);
        }
// @ts-ignore
export function useProjectMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectMemberQuery, ProjectMemberQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectMemberQuery, ProjectMemberQueryVariables>;
export function useProjectMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectMemberQuery, ProjectMemberQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectMemberQuery | undefined, ProjectMemberQueryVariables>;
export function useProjectMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectMemberQuery, ProjectMemberQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectMemberQuery, ProjectMemberQueryVariables>(ProjectMemberDocument, options);
        }
export type ProjectMemberQueryHookResult = ReturnType<typeof useProjectMemberQuery>;
export type ProjectMemberLazyQueryHookResult = ReturnType<typeof useProjectMemberLazyQuery>;
export type ProjectMemberSuspenseQueryHookResult = ReturnType<typeof useProjectMemberSuspenseQuery>;
export type ProjectMemberQueryResult = ApolloReactCommon.QueryResult<ProjectMemberQuery, ProjectMemberQueryVariables>;
export const CreateProjectMembersDocument = gql`
    mutation createProjectMembers($userIds: [ID!]!, $projectId: ID!) {
  createProjectMembers(input: {userIds: $userIds, projectId: $projectId}) {
    success
  }
}
    `;
export type CreateProjectMembersMutationFn = ApolloReactCommon.MutationFunction<CreateProjectMembersMutation, CreateProjectMembersMutationVariables>;

/**
 * __useCreateProjectMembersMutation__
 *
 * To run a mutation, you first call `useCreateProjectMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMembersMutation, { data, loading, error }] = useCreateProjectMembersMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateProjectMembersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProjectMembersMutation, CreateProjectMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProjectMembersMutation, CreateProjectMembersMutationVariables>(CreateProjectMembersDocument, options);
      }
export type CreateProjectMembersMutationHookResult = ReturnType<typeof useCreateProjectMembersMutation>;
export type CreateProjectMembersMutationResult = ApolloReactCommon.MutationResult<CreateProjectMembersMutation>;
export type CreateProjectMembersMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProjectMembersMutation, CreateProjectMembersMutationVariables>;
export const DeleteProjectMembersDocument = gql`
    mutation deleteProjectMembers($userIds: [ID!]!, $projectId: ID!) {
  deleteProjectMembers(input: {userIds: $userIds, projectId: $projectId}) {
    success
  }
}
    `;
export type DeleteProjectMembersMutationFn = ApolloReactCommon.MutationFunction<DeleteProjectMembersMutation, DeleteProjectMembersMutationVariables>;

/**
 * __useDeleteProjectMembersMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMembersMutation, { data, loading, error }] = useDeleteProjectMembersMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteProjectMembersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProjectMembersMutation, DeleteProjectMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteProjectMembersMutation, DeleteProjectMembersMutationVariables>(DeleteProjectMembersDocument, options);
      }
export type DeleteProjectMembersMutationHookResult = ReturnType<typeof useDeleteProjectMembersMutation>;
export type DeleteProjectMembersMutationResult = ApolloReactCommon.MutationResult<DeleteProjectMembersMutation>;
export type DeleteProjectMembersMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteProjectMembersMutation, DeleteProjectMembersMutationVariables>;
export const ProjectMembersEntityMembersDocument = gql`
    query ProjectMembersEntityMembers($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    members {
      id
      role {
        ID
        name
      }
    }
    entity {
      id
      members {
        id
        role
        admin
        pending
        email
        username
        name
        photoUrl
        accountType
        memberRole {
          ID
          name
          permissions {
            name
            groupName
            displayName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProjectMembersEntityMembersQuery__
 *
 * To run a query within a React component, call `useProjectMembersEntityMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectMembersEntityMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectMembersEntityMembersQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useProjectMembersEntityMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables> & ({ variables: ProjectMembersEntityMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables>(ProjectMembersEntityMembersDocument, options);
      }
export function useProjectMembersEntityMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables>(ProjectMembersEntityMembersDocument, options);
        }
// @ts-ignore
export function useProjectMembersEntityMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables>;
export function useProjectMembersEntityMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectMembersEntityMembersQuery | undefined, ProjectMembersEntityMembersQueryVariables>;
export function useProjectMembersEntityMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables>(ProjectMembersEntityMembersDocument, options);
        }
export type ProjectMembersEntityMembersQueryHookResult = ReturnType<typeof useProjectMembersEntityMembersQuery>;
export type ProjectMembersEntityMembersLazyQueryHookResult = ReturnType<typeof useProjectMembersEntityMembersLazyQuery>;
export type ProjectMembersEntityMembersSuspenseQueryHookResult = ReturnType<typeof useProjectMembersEntityMembersSuspenseQuery>;
export type ProjectMembersEntityMembersQueryResult = ApolloReactCommon.QueryResult<ProjectMembersEntityMembersQuery, ProjectMembersEntityMembersQueryVariables>;
export const RampSettingsDocument = gql`
    query RampSettings {
  rampManager {
    settings {
      edges {
        name
        group
        description
        rampType
        rampIDType
        stores {
          name
          thresholds {
            checkId
            displayCheckID
            threshold
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRampSettingsQuery__
 *
 * To run a query within a React component, call `useRampSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRampSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRampSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRampSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RampSettingsQuery, RampSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RampSettingsQuery, RampSettingsQueryVariables>(RampSettingsDocument, options);
      }
export function useRampSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RampSettingsQuery, RampSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RampSettingsQuery, RampSettingsQueryVariables>(RampSettingsDocument, options);
        }
// @ts-ignore
export function useRampSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RampSettingsQuery, RampSettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RampSettingsQuery, RampSettingsQueryVariables>;
export function useRampSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RampSettingsQuery, RampSettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RampSettingsQuery | undefined, RampSettingsQueryVariables>;
export function useRampSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RampSettingsQuery, RampSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RampSettingsQuery, RampSettingsQueryVariables>(RampSettingsDocument, options);
        }
export type RampSettingsQueryHookResult = ReturnType<typeof useRampSettingsQuery>;
export type RampSettingsLazyQueryHookResult = ReturnType<typeof useRampSettingsLazyQuery>;
export type RampSettingsSuspenseQueryHookResult = ReturnType<typeof useRampSettingsSuspenseQuery>;
export type RampSettingsQueryResult = ApolloReactCommon.QueryResult<RampSettingsQuery, RampSettingsQueryVariables>;
export const IdIsRampedForSettingDocument = gql`
    query IDIsRampedForSetting($setting: String!, $id: String!) {
  rampManager {
    setting(name: $setting) {
      idIsRamped(id: $id)
    }
  }
}
    `;

/**
 * __useIdIsRampedForSettingQuery__
 *
 * To run a query within a React component, call `useIdIsRampedForSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdIsRampedForSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdIsRampedForSettingQuery({
 *   variables: {
 *      setting: // value for 'setting'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIdIsRampedForSettingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables> & ({ variables: IdIsRampedForSettingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables>(IdIsRampedForSettingDocument, options);
      }
export function useIdIsRampedForSettingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables>(IdIsRampedForSettingDocument, options);
        }
// @ts-ignore
export function useIdIsRampedForSettingSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables>;
export function useIdIsRampedForSettingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IdIsRampedForSettingQuery | undefined, IdIsRampedForSettingQueryVariables>;
export function useIdIsRampedForSettingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables>(IdIsRampedForSettingDocument, options);
        }
export type IdIsRampedForSettingQueryHookResult = ReturnType<typeof useIdIsRampedForSettingQuery>;
export type IdIsRampedForSettingLazyQueryHookResult = ReturnType<typeof useIdIsRampedForSettingLazyQuery>;
export type IdIsRampedForSettingSuspenseQueryHookResult = ReturnType<typeof useIdIsRampedForSettingSuspenseQuery>;
export type IdIsRampedForSettingQueryResult = ApolloReactCommon.QueryResult<IdIsRampedForSettingQuery, IdIsRampedForSettingQueryVariables>;
export const UpdateRampThresholdDocument = gql`
    mutation updateRampThreshold($store: String!, $setting: String!, $checkId: String!, $threshold: Float!, $clientMutationId: String) {
  updateRampThreshold(
    input: {store: $store, setting: $setting, checkId: $checkId, threshold: $threshold, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateRampThresholdMutationFn = ApolloReactCommon.MutationFunction<UpdateRampThresholdMutation, UpdateRampThresholdMutationVariables>;

/**
 * __useUpdateRampThresholdMutation__
 *
 * To run a mutation, you first call `useUpdateRampThresholdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRampThresholdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRampThresholdMutation, { data, loading, error }] = useUpdateRampThresholdMutation({
 *   variables: {
 *      store: // value for 'store'
 *      setting: // value for 'setting'
 *      checkId: // value for 'checkId'
 *      threshold: // value for 'threshold'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateRampThresholdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRampThresholdMutation, UpdateRampThresholdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRampThresholdMutation, UpdateRampThresholdMutationVariables>(UpdateRampThresholdDocument, options);
      }
export type UpdateRampThresholdMutationHookResult = ReturnType<typeof useUpdateRampThresholdMutation>;
export type UpdateRampThresholdMutationResult = ApolloReactCommon.MutationResult<UpdateRampThresholdMutation>;
export type UpdateRampThresholdMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRampThresholdMutation, UpdateRampThresholdMutationVariables>;
export const FetchRepoDisplayNameByIdDocument = gql`
    query FetchRepoDisplayNameByID($id: ID!) {
  repo(id: $id) {
    id
    displayName
  }
}
    `;

/**
 * __useFetchRepoDisplayNameByIdQuery__
 *
 * To run a query within a React component, call `useFetchRepoDisplayNameByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRepoDisplayNameByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRepoDisplayNameByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchRepoDisplayNameByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables> & ({ variables: FetchRepoDisplayNameByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables>(FetchRepoDisplayNameByIdDocument, options);
      }
export function useFetchRepoDisplayNameByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables>(FetchRepoDisplayNameByIdDocument, options);
        }
// @ts-ignore
export function useFetchRepoDisplayNameByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables>;
export function useFetchRepoDisplayNameByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRepoDisplayNameByIdQuery | undefined, FetchRepoDisplayNameByIdQueryVariables>;
export function useFetchRepoDisplayNameByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables>(FetchRepoDisplayNameByIdDocument, options);
        }
export type FetchRepoDisplayNameByIdQueryHookResult = ReturnType<typeof useFetchRepoDisplayNameByIdQuery>;
export type FetchRepoDisplayNameByIdLazyQueryHookResult = ReturnType<typeof useFetchRepoDisplayNameByIdLazyQuery>;
export type FetchRepoDisplayNameByIdSuspenseQueryHookResult = ReturnType<typeof useFetchRepoDisplayNameByIdSuspenseQuery>;
export type FetchRepoDisplayNameByIdQueryResult = ApolloReactCommon.QueryResult<FetchRepoDisplayNameByIdQuery, FetchRepoDisplayNameByIdQueryVariables>;
export const ReportSearchDocument = gql`
    query ReportSearch($query: String!) {
  reportSearch(query: $query) {
    edges {
      node {
        entityName
        displayName
        id
        projectName
      }
    }
  }
}
    `;

/**
 * __useReportSearchQuery__
 *
 * To run a query within a React component, call `useReportSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useReportSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReportSearchQuery, ReportSearchQueryVariables> & ({ variables: ReportSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReportSearchQuery, ReportSearchQueryVariables>(ReportSearchDocument, options);
      }
export function useReportSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReportSearchQuery, ReportSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReportSearchQuery, ReportSearchQueryVariables>(ReportSearchDocument, options);
        }
// @ts-ignore
export function useReportSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReportSearchQuery, ReportSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReportSearchQuery, ReportSearchQueryVariables>;
export function useReportSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReportSearchQuery, ReportSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReportSearchQuery | undefined, ReportSearchQueryVariables>;
export function useReportSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReportSearchQuery, ReportSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReportSearchQuery, ReportSearchQueryVariables>(ReportSearchDocument, options);
        }
export type ReportSearchQueryHookResult = ReturnType<typeof useReportSearchQuery>;
export type ReportSearchLazyQueryHookResult = ReturnType<typeof useReportSearchLazyQuery>;
export type ReportSearchSuspenseQueryHookResult = ReturnType<typeof useReportSearchSuspenseQuery>;
export type ReportSearchQueryResult = ApolloReactCommon.QueryResult<ReportSearchQuery, ReportSearchQueryVariables>;
export const OrganizationRolesDocument = gql`
    query OrganizationRoles($orgName: String!) {
  organization(name: $orgName) {
    id
    roles {
      ID
      name
      description
      inheritedFrom {
        name
      }
    }
  }
}
    `;

/**
 * __useOrganizationRolesQuery__
 *
 * To run a query within a React component, call `useOrganizationRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationRolesQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationRolesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationRolesQuery, OrganizationRolesQueryVariables> & ({ variables: OrganizationRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationRolesQuery, OrganizationRolesQueryVariables>(OrganizationRolesDocument, options);
      }
export function useOrganizationRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationRolesQuery, OrganizationRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationRolesQuery, OrganizationRolesQueryVariables>(OrganizationRolesDocument, options);
        }
// @ts-ignore
export function useOrganizationRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRolesQuery, OrganizationRolesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationRolesQuery, OrganizationRolesQueryVariables>;
export function useOrganizationRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRolesQuery, OrganizationRolesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationRolesQuery | undefined, OrganizationRolesQueryVariables>;
export function useOrganizationRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRolesQuery, OrganizationRolesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationRolesQuery, OrganizationRolesQueryVariables>(OrganizationRolesDocument, options);
        }
export type OrganizationRolesQueryHookResult = ReturnType<typeof useOrganizationRolesQuery>;
export type OrganizationRolesLazyQueryHookResult = ReturnType<typeof useOrganizationRolesLazyQuery>;
export type OrganizationRolesSuspenseQueryHookResult = ReturnType<typeof useOrganizationRolesSuspenseQuery>;
export type OrganizationRolesQueryResult = ApolloReactCommon.QueryResult<OrganizationRolesQuery, OrganizationRolesQueryVariables>;
export const OrganizationRolePermissionsDocument = gql`
    query OrganizationRolePermissions($orgName: String!) {
  organization(name: $orgName) {
    id
    roles {
      ID
      name
      description
      inheritedFrom {
        ID
        name
      }
      permissions {
        name
        displayName
        groupName
      }
    }
  }
}
    `;

/**
 * __useOrganizationRolePermissionsQuery__
 *
 * To run a query within a React component, call `useOrganizationRolePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationRolePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationRolePermissionsQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationRolePermissionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables> & ({ variables: OrganizationRolePermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables>(OrganizationRolePermissionsDocument, options);
      }
export function useOrganizationRolePermissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables>(OrganizationRolePermissionsDocument, options);
        }
// @ts-ignore
export function useOrganizationRolePermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables>;
export function useOrganizationRolePermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationRolePermissionsQuery | undefined, OrganizationRolePermissionsQueryVariables>;
export function useOrganizationRolePermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables>(OrganizationRolePermissionsDocument, options);
        }
export type OrganizationRolePermissionsQueryHookResult = ReturnType<typeof useOrganizationRolePermissionsQuery>;
export type OrganizationRolePermissionsLazyQueryHookResult = ReturnType<typeof useOrganizationRolePermissionsLazyQuery>;
export type OrganizationRolePermissionsSuspenseQueryHookResult = ReturnType<typeof useOrganizationRolePermissionsSuspenseQuery>;
export type OrganizationRolePermissionsQueryResult = ApolloReactCommon.QueryResult<OrganizationRolePermissionsQuery, OrganizationRolePermissionsQueryVariables>;
export const CreateRoleDocument = gql`
    mutation createRole($name: String!, $description: String, $inheritedFrom: String!, $permissions: [String!]!, $organizationID: ID!) {
  createRole(
    input: {name: $name, description: $description, inheritedFrom: $inheritedFrom, permissions: $permissions, organizationID: $organizationID}
  ) {
    success
  }
}
    `;
export type CreateRoleMutationFn = ApolloReactCommon.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      inheritedFrom: // value for 'inheritedFrom'
 *      permissions: // value for 'permissions'
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = ApolloReactCommon.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation updateRole($roleID: ID!, $name: String, $description: String, $inheritedFrom: String) {
  updateRole(
    input: {roleID: $roleID, name: $name, description: $description, inheritedFrom: $inheritedFrom}
  ) {
    success
  }
}
    `;
export type UpdateRoleMutationFn = ApolloReactCommon.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      roleID: // value for 'roleID'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      inheritedFrom: // value for 'inheritedFrom'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = ApolloReactCommon.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation deleteRole($roleID: ID!) {
  deleteRole(input: {roleID: $roleID}) {
    success
  }
}
    `;
export type DeleteRoleMutationFn = ApolloReactCommon.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      roleID: // value for 'roleID'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = ApolloReactCommon.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const AddRolePermissionsDocument = gql`
    mutation addRolePermissions($roleID: ID!, $permissions: [String!]!) {
  addRolePermissions(input: {roleID: $roleID, permissions: $permissions}) {
    success
  }
}
    `;
export type AddRolePermissionsMutationFn = ApolloReactCommon.MutationFunction<AddRolePermissionsMutation, AddRolePermissionsMutationVariables>;

/**
 * __useAddRolePermissionsMutation__
 *
 * To run a mutation, you first call `useAddRolePermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRolePermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRolePermissionsMutation, { data, loading, error }] = useAddRolePermissionsMutation({
 *   variables: {
 *      roleID: // value for 'roleID'
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useAddRolePermissionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddRolePermissionsMutation, AddRolePermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddRolePermissionsMutation, AddRolePermissionsMutationVariables>(AddRolePermissionsDocument, options);
      }
export type AddRolePermissionsMutationHookResult = ReturnType<typeof useAddRolePermissionsMutation>;
export type AddRolePermissionsMutationResult = ApolloReactCommon.MutationResult<AddRolePermissionsMutation>;
export type AddRolePermissionsMutationOptions = ApolloReactCommon.BaseMutationOptions<AddRolePermissionsMutation, AddRolePermissionsMutationVariables>;
export const DeleteRolePermissionsDocument = gql`
    mutation deleteRolePermissions($roleID: ID!, $permissions: [String!]!) {
  deleteRolePermissions(input: {roleID: $roleID, permissions: $permissions}) {
    success
  }
}
    `;
export type DeleteRolePermissionsMutationFn = ApolloReactCommon.MutationFunction<DeleteRolePermissionsMutation, DeleteRolePermissionsMutationVariables>;

/**
 * __useDeleteRolePermissionsMutation__
 *
 * To run a mutation, you first call `useDeleteRolePermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRolePermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRolePermissionsMutation, { data, loading, error }] = useDeleteRolePermissionsMutation({
 *   variables: {
 *      roleID: // value for 'roleID'
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useDeleteRolePermissionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRolePermissionsMutation, DeleteRolePermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteRolePermissionsMutation, DeleteRolePermissionsMutationVariables>(DeleteRolePermissionsDocument, options);
      }
export type DeleteRolePermissionsMutationHookResult = ReturnType<typeof useDeleteRolePermissionsMutation>;
export type DeleteRolePermissionsMutationResult = ApolloReactCommon.MutationResult<DeleteRolePermissionsMutation>;
export type DeleteRolePermissionsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteRolePermissionsMutation, DeleteRolePermissionsMutationVariables>;
export const EntityMemberRoleDocument = gql`
    query EntityMemberRole($entityName: String!, $memberId: ID!) {
  entity(name: $entityName) {
    id
    member(id: $memberId) {
      id
      role
      memberRole {
        ID
        name
        inheritedFrom {
          permissions {
            name
            groupName
            displayName
          }
        }
        permissions {
          name
          groupName
          displayName
        }
      }
    }
  }
}
    `;

/**
 * __useEntityMemberRoleQuery__
 *
 * To run a query within a React component, call `useEntityMemberRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityMemberRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityMemberRoleQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useEntityMemberRoleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityMemberRoleQuery, EntityMemberRoleQueryVariables> & ({ variables: EntityMemberRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityMemberRoleQuery, EntityMemberRoleQueryVariables>(EntityMemberRoleDocument, options);
      }
export function useEntityMemberRoleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityMemberRoleQuery, EntityMemberRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityMemberRoleQuery, EntityMemberRoleQueryVariables>(EntityMemberRoleDocument, options);
        }
// @ts-ignore
export function useEntityMemberRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityMemberRoleQuery, EntityMemberRoleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityMemberRoleQuery, EntityMemberRoleQueryVariables>;
export function useEntityMemberRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityMemberRoleQuery, EntityMemberRoleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityMemberRoleQuery | undefined, EntityMemberRoleQueryVariables>;
export function useEntityMemberRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityMemberRoleQuery, EntityMemberRoleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityMemberRoleQuery, EntityMemberRoleQueryVariables>(EntityMemberRoleDocument, options);
        }
export type EntityMemberRoleQueryHookResult = ReturnType<typeof useEntityMemberRoleQuery>;
export type EntityMemberRoleLazyQueryHookResult = ReturnType<typeof useEntityMemberRoleLazyQuery>;
export type EntityMemberRoleSuspenseQueryHookResult = ReturnType<typeof useEntityMemberRoleSuspenseQuery>;
export type EntityMemberRoleQueryResult = ApolloReactCommon.QueryResult<EntityMemberRoleQuery, EntityMemberRoleQueryVariables>;
export const GroupPageRunDocument = gql`
    query GroupPageRun($projectName: String!, $entityName: String, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    access
    views
    entityName
    tags {
      id
      name
      colorIndex
    }
    run(name: $runName) {
      id
      name
      config
      summaryMetrics
      historyKeys(format: PLAINTEXT)
      state
      sweep {
        id
        name
        displayName
      }
      outputLogFile: files(first: 1, names: ["output.log"]) {
        edges {
          node {
            id
            name
            md5
            sizeBytes
            directUrl
            url(upload: false)
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGroupPageRunQuery__
 *
 * To run a query within a React component, call `useGroupPageRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupPageRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupPageRunQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useGroupPageRunQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GroupPageRunQuery, GroupPageRunQueryVariables> & ({ variables: GroupPageRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GroupPageRunQuery, GroupPageRunQueryVariables>(GroupPageRunDocument, options);
      }
export function useGroupPageRunLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GroupPageRunQuery, GroupPageRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GroupPageRunQuery, GroupPageRunQueryVariables>(GroupPageRunDocument, options);
        }
// @ts-ignore
export function useGroupPageRunSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GroupPageRunQuery, GroupPageRunQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupPageRunQuery, GroupPageRunQueryVariables>;
export function useGroupPageRunSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupPageRunQuery, GroupPageRunQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupPageRunQuery | undefined, GroupPageRunQueryVariables>;
export function useGroupPageRunSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupPageRunQuery, GroupPageRunQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GroupPageRunQuery, GroupPageRunQueryVariables>(GroupPageRunDocument, options);
        }
export type GroupPageRunQueryHookResult = ReturnType<typeof useGroupPageRunQuery>;
export type GroupPageRunLazyQueryHookResult = ReturnType<typeof useGroupPageRunLazyQuery>;
export type GroupPageRunSuspenseQueryHookResult = ReturnType<typeof useGroupPageRunSuspenseQuery>;
export type GroupPageRunQueryResult = ApolloReactCommon.QueryResult<GroupPageRunQuery, GroupPageRunQueryVariables>;
export const CreateRunQueueDocument = gql`
    mutation createRunQueue($entityName: String!, $projectName: String!, $queueName: String!, $access: RunQueueAccessType!, $defaultResourceConfigID: ID, $prioritizationMode: RunQueuePrioritizationMode!) {
  createRunQueue(
    input: {entityName: $entityName, projectName: $projectName, queueName: $queueName, access: $access, defaultResourceConfigID: $defaultResourceConfigID, prioritizationMode: $prioritizationMode}
  ) {
    success
    queueID
  }
}
    `;
export type CreateRunQueueMutationFn = ApolloReactCommon.MutationFunction<CreateRunQueueMutation, CreateRunQueueMutationVariables>;

/**
 * __useCreateRunQueueMutation__
 *
 * To run a mutation, you first call `useCreateRunQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRunQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRunQueueMutation, { data, loading, error }] = useCreateRunQueueMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      queueName: // value for 'queueName'
 *      access: // value for 'access'
 *      defaultResourceConfigID: // value for 'defaultResourceConfigID'
 *      prioritizationMode: // value for 'prioritizationMode'
 *   },
 * });
 */
export function useCreateRunQueueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRunQueueMutation, CreateRunQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateRunQueueMutation, CreateRunQueueMutationVariables>(CreateRunQueueDocument, options);
      }
export type CreateRunQueueMutationHookResult = ReturnType<typeof useCreateRunQueueMutation>;
export type CreateRunQueueMutationResult = ApolloReactCommon.MutationResult<CreateRunQueueMutation>;
export type CreateRunQueueMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateRunQueueMutation, CreateRunQueueMutationVariables>;
export const UpdateRunQueueDocument = gql`
    mutation updateRunQueue($queueID: ID!, $defaultResourceConfigID: ID, $externalLinks: JSONString) {
  updateRunQueue(
    input: {queueID: $queueID, defaultResourceConfigID: $defaultResourceConfigID, externalLinks: $externalLinks}
  ) {
    success
  }
}
    `;
export type UpdateRunQueueMutationFn = ApolloReactCommon.MutationFunction<UpdateRunQueueMutation, UpdateRunQueueMutationVariables>;

/**
 * __useUpdateRunQueueMutation__
 *
 * To run a mutation, you first call `useUpdateRunQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRunQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRunQueueMutation, { data, loading, error }] = useUpdateRunQueueMutation({
 *   variables: {
 *      queueID: // value for 'queueID'
 *      defaultResourceConfigID: // value for 'defaultResourceConfigID'
 *      externalLinks: // value for 'externalLinks'
 *   },
 * });
 */
export function useUpdateRunQueueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRunQueueMutation, UpdateRunQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRunQueueMutation, UpdateRunQueueMutationVariables>(UpdateRunQueueDocument, options);
      }
export type UpdateRunQueueMutationHookResult = ReturnType<typeof useUpdateRunQueueMutation>;
export type UpdateRunQueueMutationResult = ApolloReactCommon.MutationResult<UpdateRunQueueMutation>;
export type UpdateRunQueueMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRunQueueMutation, UpdateRunQueueMutationVariables>;
export const EnableRunQueuePrioritizationDocument = gql`
    mutation enableRunQueuePrioritization($queueID: ID!) {
  updateRunQueue(input: {queueID: $queueID, prioritizationMode: V0}) {
    success
  }
}
    `;
export type EnableRunQueuePrioritizationMutationFn = ApolloReactCommon.MutationFunction<EnableRunQueuePrioritizationMutation, EnableRunQueuePrioritizationMutationVariables>;

/**
 * __useEnableRunQueuePrioritizationMutation__
 *
 * To run a mutation, you first call `useEnableRunQueuePrioritizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableRunQueuePrioritizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableRunQueuePrioritizationMutation, { data, loading, error }] = useEnableRunQueuePrioritizationMutation({
 *   variables: {
 *      queueID: // value for 'queueID'
 *   },
 * });
 */
export function useEnableRunQueuePrioritizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnableRunQueuePrioritizationMutation, EnableRunQueuePrioritizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EnableRunQueuePrioritizationMutation, EnableRunQueuePrioritizationMutationVariables>(EnableRunQueuePrioritizationDocument, options);
      }
export type EnableRunQueuePrioritizationMutationHookResult = ReturnType<typeof useEnableRunQueuePrioritizationMutation>;
export type EnableRunQueuePrioritizationMutationResult = ApolloReactCommon.MutationResult<EnableRunQueuePrioritizationMutation>;
export type EnableRunQueuePrioritizationMutationOptions = ApolloReactCommon.BaseMutationOptions<EnableRunQueuePrioritizationMutation, EnableRunQueuePrioritizationMutationVariables>;
export const DeleteRunQueuesDocument = gql`
    mutation deleteRunQueues($queueIDs: [ID!]!) {
  deleteRunQueues(input: {queueIDs: $queueIDs}) {
    success
  }
}
    `;
export type DeleteRunQueuesMutationFn = ApolloReactCommon.MutationFunction<DeleteRunQueuesMutation, DeleteRunQueuesMutationVariables>;

/**
 * __useDeleteRunQueuesMutation__
 *
 * To run a mutation, you first call `useDeleteRunQueuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRunQueuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRunQueuesMutation, { data, loading, error }] = useDeleteRunQueuesMutation({
 *   variables: {
 *      queueIDs: // value for 'queueIDs'
 *   },
 * });
 */
export function useDeleteRunQueuesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRunQueuesMutation, DeleteRunQueuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteRunQueuesMutation, DeleteRunQueuesMutationVariables>(DeleteRunQueuesDocument, options);
      }
export type DeleteRunQueuesMutationHookResult = ReturnType<typeof useDeleteRunQueuesMutation>;
export type DeleteRunQueuesMutationResult = ApolloReactCommon.MutationResult<DeleteRunQueuesMutation>;
export type DeleteRunQueuesMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteRunQueuesMutation, DeleteRunQueuesMutationVariables>;
export const PushToRunQueueDocument = gql`
    mutation pushToRunQueue($queueID: ID!, $runSpec: JSONString!, $priority: Int, $templateVariableValues: JSONString) {
  pushToRunQueue(
    input: {queueID: $queueID, runSpec: $runSpec, priority: $priority, templateVariableValues: $templateVariableValues}
  ) {
    runQueueItemId
  }
}
    `;
export type PushToRunQueueMutationFn = ApolloReactCommon.MutationFunction<PushToRunQueueMutation, PushToRunQueueMutationVariables>;

/**
 * __usePushToRunQueueMutation__
 *
 * To run a mutation, you first call `usePushToRunQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushToRunQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushToRunQueueMutation, { data, loading, error }] = usePushToRunQueueMutation({
 *   variables: {
 *      queueID: // value for 'queueID'
 *      runSpec: // value for 'runSpec'
 *      priority: // value for 'priority'
 *      templateVariableValues: // value for 'templateVariableValues'
 *   },
 * });
 */
export function usePushToRunQueueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PushToRunQueueMutation, PushToRunQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PushToRunQueueMutation, PushToRunQueueMutationVariables>(PushToRunQueueDocument, options);
      }
export type PushToRunQueueMutationHookResult = ReturnType<typeof usePushToRunQueueMutation>;
export type PushToRunQueueMutationResult = ApolloReactCommon.MutationResult<PushToRunQueueMutation>;
export type PushToRunQueueMutationOptions = ApolloReactCommon.BaseMutationOptions<PushToRunQueueMutation, PushToRunQueueMutationVariables>;
export const DeleteFromRunQueueDocument = gql`
    mutation deleteFromRunQueue($queueID: ID!, $runQueueItemId: ID!) {
  deleteFromRunQueue(input: {queueID: $queueID, runQueueItemId: $runQueueItemId}) {
    success
  }
}
    `;
export type DeleteFromRunQueueMutationFn = ApolloReactCommon.MutationFunction<DeleteFromRunQueueMutation, DeleteFromRunQueueMutationVariables>;

/**
 * __useDeleteFromRunQueueMutation__
 *
 * To run a mutation, you first call `useDeleteFromRunQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFromRunQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFromRunQueueMutation, { data, loading, error }] = useDeleteFromRunQueueMutation({
 *   variables: {
 *      queueID: // value for 'queueID'
 *      runQueueItemId: // value for 'runQueueItemId'
 *   },
 * });
 */
export function useDeleteFromRunQueueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFromRunQueueMutation, DeleteFromRunQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFromRunQueueMutation, DeleteFromRunQueueMutationVariables>(DeleteFromRunQueueDocument, options);
      }
export type DeleteFromRunQueueMutationHookResult = ReturnType<typeof useDeleteFromRunQueueMutation>;
export type DeleteFromRunQueueMutationResult = ApolloReactCommon.MutationResult<DeleteFromRunQueueMutation>;
export type DeleteFromRunQueueMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteFromRunQueueMutation, DeleteFromRunQueueMutationVariables>;
export const FetchRunQueuesFromProjectDocument = gql`
    query fetchRunQueuesFromProject($entityName: String!, $projectName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runQueues {
      id
      createdAt
      createdBy
      access
      updatedAt
      name
      defaultResourceConfigID
      executorInfo
      runQueueItems {
        edges {
          node {
            id
            ...RunQueueItemFragment
          }
        }
      }
    }
  }
}
    ${RunQueueItemFragmentFragmentDoc}`;

/**
 * __useFetchRunQueuesFromProjectQuery__
 *
 * To run a query within a React component, call `useFetchRunQueuesFromProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRunQueuesFromProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRunQueuesFromProjectQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useFetchRunQueuesFromProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables> & ({ variables: FetchRunQueuesFromProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables>(FetchRunQueuesFromProjectDocument, options);
      }
export function useFetchRunQueuesFromProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables>(FetchRunQueuesFromProjectDocument, options);
        }
// @ts-ignore
export function useFetchRunQueuesFromProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables>;
export function useFetchRunQueuesFromProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRunQueuesFromProjectQuery | undefined, FetchRunQueuesFromProjectQueryVariables>;
export function useFetchRunQueuesFromProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables>(FetchRunQueuesFromProjectDocument, options);
        }
export type FetchRunQueuesFromProjectQueryHookResult = ReturnType<typeof useFetchRunQueuesFromProjectQuery>;
export type FetchRunQueuesFromProjectLazyQueryHookResult = ReturnType<typeof useFetchRunQueuesFromProjectLazyQuery>;
export type FetchRunQueuesFromProjectSuspenseQueryHookResult = ReturnType<typeof useFetchRunQueuesFromProjectSuspenseQuery>;
export type FetchRunQueuesFromProjectQueryResult = ApolloReactCommon.QueryResult<FetchRunQueuesFromProjectQuery, FetchRunQueuesFromProjectQueryVariables>;
export const FetchRunQueueByNameDocument = gql`
    query FetchRunQueueByName($entityName: String!, $projectName: String!, $runQueueName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runQueue(name: $runQueueName) {
      id
      createdAt
      createdBy
      access
      updatedAt
      name
      defaultResourceConfigID
      executorInfo
      runQueueItems {
        edges {
          node {
            id
            ...RunQueueItemFragment
          }
        }
      }
    }
  }
}
    ${RunQueueItemFragmentFragmentDoc}`;

/**
 * __useFetchRunQueueByNameQuery__
 *
 * To run a query within a React component, call `useFetchRunQueueByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRunQueueByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRunQueueByNameQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runQueueName: // value for 'runQueueName'
 *   },
 * });
 */
export function useFetchRunQueueByNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables> & ({ variables: FetchRunQueueByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables>(FetchRunQueueByNameDocument, options);
      }
export function useFetchRunQueueByNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables>(FetchRunQueueByNameDocument, options);
        }
// @ts-ignore
export function useFetchRunQueueByNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables>;
export function useFetchRunQueueByNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRunQueueByNameQuery | undefined, FetchRunQueueByNameQueryVariables>;
export function useFetchRunQueueByNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables>(FetchRunQueueByNameDocument, options);
        }
export type FetchRunQueueByNameQueryHookResult = ReturnType<typeof useFetchRunQueueByNameQuery>;
export type FetchRunQueueByNameLazyQueryHookResult = ReturnType<typeof useFetchRunQueueByNameLazyQuery>;
export type FetchRunQueueByNameSuspenseQueryHookResult = ReturnType<typeof useFetchRunQueueByNameSuspenseQuery>;
export type FetchRunQueueByNameQueryResult = ApolloReactCommon.QueryResult<FetchRunQueueByNameQuery, FetchRunQueueByNameQueryVariables>;
export const FetchRunQueueItemFromProjectDocument = gql`
    query FetchRunQueueItemFromProject($entityName: String!, $projectName: String!, $runQueueName: String!, $runQueueItemID: ID!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runQueue(name: $runQueueName) {
      id
      runQueueItem(id: $runQueueItemID) {
        id
        ...RunQueueItemFragment
      }
    }
  }
}
    ${RunQueueItemFragmentFragmentDoc}`;

/**
 * __useFetchRunQueueItemFromProjectQuery__
 *
 * To run a query within a React component, call `useFetchRunQueueItemFromProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRunQueueItemFromProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRunQueueItemFromProjectQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runQueueName: // value for 'runQueueName'
 *      runQueueItemID: // value for 'runQueueItemID'
 *   },
 * });
 */
export function useFetchRunQueueItemFromProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables> & ({ variables: FetchRunQueueItemFromProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables>(FetchRunQueueItemFromProjectDocument, options);
      }
export function useFetchRunQueueItemFromProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables>(FetchRunQueueItemFromProjectDocument, options);
        }
// @ts-ignore
export function useFetchRunQueueItemFromProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables>;
export function useFetchRunQueueItemFromProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRunQueueItemFromProjectQuery | undefined, FetchRunQueueItemFromProjectQueryVariables>;
export function useFetchRunQueueItemFromProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables>(FetchRunQueueItemFromProjectDocument, options);
        }
export type FetchRunQueueItemFromProjectQueryHookResult = ReturnType<typeof useFetchRunQueueItemFromProjectQuery>;
export type FetchRunQueueItemFromProjectLazyQueryHookResult = ReturnType<typeof useFetchRunQueueItemFromProjectLazyQuery>;
export type FetchRunQueueItemFromProjectSuspenseQueryHookResult = ReturnType<typeof useFetchRunQueueItemFromProjectSuspenseQuery>;
export type FetchRunQueueItemFromProjectQueryResult = ApolloReactCommon.QueryResult<FetchRunQueueItemFromProjectQuery, FetchRunQueueItemFromProjectQueryVariables>;
export const TeamInfoDocument = gql`
    query TeamInfo($entityName: String!) {
  entity(name: $entityName) {
    id
    members {
      id
      role
      username
      name
      admin
    }
  }
}
    `;

/**
 * __useTeamInfoQuery__
 *
 * To run a query within a React component, call `useTeamInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamInfoQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useTeamInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamInfoQuery, TeamInfoQueryVariables> & ({ variables: TeamInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamInfoQuery, TeamInfoQueryVariables>(TeamInfoDocument, options);
      }
export function useTeamInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamInfoQuery, TeamInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamInfoQuery, TeamInfoQueryVariables>(TeamInfoDocument, options);
        }
// @ts-ignore
export function useTeamInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamInfoQuery, TeamInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamInfoQuery, TeamInfoQueryVariables>;
export function useTeamInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamInfoQuery, TeamInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamInfoQuery | undefined, TeamInfoQueryVariables>;
export function useTeamInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamInfoQuery, TeamInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamInfoQuery, TeamInfoQueryVariables>(TeamInfoDocument, options);
        }
export type TeamInfoQueryHookResult = ReturnType<typeof useTeamInfoQuery>;
export type TeamInfoLazyQueryHookResult = ReturnType<typeof useTeamInfoLazyQuery>;
export type TeamInfoSuspenseQueryHookResult = ReturnType<typeof useTeamInfoSuspenseQuery>;
export type TeamInfoQueryResult = ApolloReactCommon.QueryResult<TeamInfoQuery, TeamInfoQueryVariables>;
export const RunDisplayNameDocument = gql`
    query RunDisplayName($entityName: String!, $projectName: String!, $runName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    run(name: $runName) {
      id
      displayName
    }
  }
}
    `;

/**
 * __useRunDisplayNameQuery__
 *
 * To run a query within a React component, call `useRunDisplayNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunDisplayNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunDisplayNameQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunDisplayNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunDisplayNameQuery, RunDisplayNameQueryVariables> & ({ variables: RunDisplayNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunDisplayNameQuery, RunDisplayNameQueryVariables>(RunDisplayNameDocument, options);
      }
export function useRunDisplayNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunDisplayNameQuery, RunDisplayNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunDisplayNameQuery, RunDisplayNameQueryVariables>(RunDisplayNameDocument, options);
        }
// @ts-ignore
export function useRunDisplayNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunDisplayNameQuery, RunDisplayNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunDisplayNameQuery, RunDisplayNameQueryVariables>;
export function useRunDisplayNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunDisplayNameQuery, RunDisplayNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunDisplayNameQuery | undefined, RunDisplayNameQueryVariables>;
export function useRunDisplayNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunDisplayNameQuery, RunDisplayNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunDisplayNameQuery, RunDisplayNameQueryVariables>(RunDisplayNameDocument, options);
        }
export type RunDisplayNameQueryHookResult = ReturnType<typeof useRunDisplayNameQuery>;
export type RunDisplayNameLazyQueryHookResult = ReturnType<typeof useRunDisplayNameLazyQuery>;
export type RunDisplayNameSuspenseQueryHookResult = ReturnType<typeof useRunDisplayNameSuspenseQuery>;
export type RunDisplayNameQueryResult = ApolloReactCommon.QueryResult<RunDisplayNameQuery, RunDisplayNameQueryVariables>;
export const RunsStateDocument = gql`
    query RunsState($projectName: String!, $entityName: String, $filters: JSONString) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(filters: $filters) {
      edges {
        node {
          id
          name
          displayName
          state
        }
      }
    }
  }
}
    `;

/**
 * __useRunsStateQuery__
 *
 * To run a query within a React component, call `useRunsStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsStateQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRunsStateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsStateQuery, RunsStateQueryVariables> & ({ variables: RunsStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsStateQuery, RunsStateQueryVariables>(RunsStateDocument, options);
      }
export function useRunsStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsStateQuery, RunsStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsStateQuery, RunsStateQueryVariables>(RunsStateDocument, options);
        }
// @ts-ignore
export function useRunsStateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsStateQuery, RunsStateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsStateQuery, RunsStateQueryVariables>;
export function useRunsStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsStateQuery, RunsStateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsStateQuery | undefined, RunsStateQueryVariables>;
export function useRunsStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsStateQuery, RunsStateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsStateQuery, RunsStateQueryVariables>(RunsStateDocument, options);
        }
export type RunsStateQueryHookResult = ReturnType<typeof useRunsStateQuery>;
export type RunsStateLazyQueryHookResult = ReturnType<typeof useRunsStateLazyQuery>;
export type RunsStateSuspenseQueryHookResult = ReturnType<typeof useRunsStateSuspenseQuery>;
export type RunsStateQueryResult = ApolloReactCommon.QueryResult<RunsStateQuery, RunsStateQueryVariables>;
export const RunTensorboardDocument = gql`
    query RunTensorboard($projectName: String!, $entityName: String!, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      servicesAvailable {
        tensorboard
      }
    }
  }
}
    `;

/**
 * __useRunTensorboardQuery__
 *
 * To run a query within a React component, call `useRunTensorboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunTensorboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunTensorboardQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunTensorboardQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunTensorboardQuery, RunTensorboardQueryVariables> & ({ variables: RunTensorboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunTensorboardQuery, RunTensorboardQueryVariables>(RunTensorboardDocument, options);
      }
export function useRunTensorboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunTensorboardQuery, RunTensorboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunTensorboardQuery, RunTensorboardQueryVariables>(RunTensorboardDocument, options);
        }
// @ts-ignore
export function useRunTensorboardSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunTensorboardQuery, RunTensorboardQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunTensorboardQuery, RunTensorboardQueryVariables>;
export function useRunTensorboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunTensorboardQuery, RunTensorboardQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunTensorboardQuery | undefined, RunTensorboardQueryVariables>;
export function useRunTensorboardSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunTensorboardQuery, RunTensorboardQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunTensorboardQuery, RunTensorboardQueryVariables>(RunTensorboardDocument, options);
        }
export type RunTensorboardQueryHookResult = ReturnType<typeof useRunTensorboardQuery>;
export type RunTensorboardLazyQueryHookResult = ReturnType<typeof useRunTensorboardLazyQuery>;
export type RunTensorboardSuspenseQueryHookResult = ReturnType<typeof useRunTensorboardSuspenseQuery>;
export type RunTensorboardQueryResult = ApolloReactCommon.QueryResult<RunTensorboardQuery, RunTensorboardQueryVariables>;
export const RunsModelDocument = gql`
    query RunsModel($cursor: String, $name: String!, $entityName: String, $jobKey: String, $order: String, $filters: JSONString, $limit: Int = 1000, $bucketIds: [String], $requestSubscribe: Boolean!, $selectEnable: Boolean = true, $basicEnable: Boolean = true, $history: Boolean = false, $historyKeyInfo: Boolean = false, $historySamples: Int = 750, $sampledHistory: Boolean = false, $fields: [String], $historyFields: [String], $sampledHistorySpecs: [JSONString!]!, $groupKeys: [String], $groupLevel: Int) {
  project(name: $name, entityName: $entityName) {
    id
    name
    createdAt
    entityName
    description
    summaryMetrics
    views
    requestSubscribe @include(if: $requestSubscribe)
    runCount(filters: $filters)
    runs(
      first: $limit
      after: $cursor
      jobKey: $jobKey
      order: $order
      names: $bucketIds
      filters: $filters
      fields: $fields
      historyFields: $historyFields
      groupKeys: $groupKeys
      groupLevel: $groupLevel
    ) {
      totalCount
      edges {
        node {
          id
          name
          displayName
          __typename
          ...SelectRunFragment @include(if: $selectEnable)
          ...BasicRunFragment @include(if: $basicEnable)
          ...HistoryRunFragment @include(if: $history)
          ...SampledHistoryRunFragment @include(if: $sampledHistory)
          historyKeys(format: PLAINTEXT) @include(if: $historyKeyInfo)
        }
      }
      pageInfo {
        startCursor
        hasPreviousPage
        endCursor
        hasNextPage
      }
    }
  }
  viewer {
    id
    email
    photoUrl
    admin
  }
  serverInfo {
    pollingOK
  }
}
    ${SelectRunFragmentFragmentDoc}
${BasicRunFragmentFragmentDoc}
${HistoryRunFragmentFragmentDoc}
${SampledHistoryRunFragmentFragmentDoc}`;

/**
 * __useRunsModelQuery__
 *
 * To run a query within a React component, call `useRunsModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsModelQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      name: // value for 'name'
 *      entityName: // value for 'entityName'
 *      jobKey: // value for 'jobKey'
 *      order: // value for 'order'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      bucketIds: // value for 'bucketIds'
 *      requestSubscribe: // value for 'requestSubscribe'
 *      selectEnable: // value for 'selectEnable'
 *      basicEnable: // value for 'basicEnable'
 *      history: // value for 'history'
 *      historyKeyInfo: // value for 'historyKeyInfo'
 *      historySamples: // value for 'historySamples'
 *      sampledHistory: // value for 'sampledHistory'
 *      fields: // value for 'fields'
 *      historyFields: // value for 'historyFields'
 *      sampledHistorySpecs: // value for 'sampledHistorySpecs'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *   },
 * });
 */
export function useRunsModelQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsModelQuery, RunsModelQueryVariables> & ({ variables: RunsModelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsModelQuery, RunsModelQueryVariables>(RunsModelDocument, options);
      }
export function useRunsModelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsModelQuery, RunsModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsModelQuery, RunsModelQueryVariables>(RunsModelDocument, options);
        }
// @ts-ignore
export function useRunsModelSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsModelQuery, RunsModelQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsModelQuery, RunsModelQueryVariables>;
export function useRunsModelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsModelQuery, RunsModelQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsModelQuery | undefined, RunsModelQueryVariables>;
export function useRunsModelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsModelQuery, RunsModelQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsModelQuery, RunsModelQueryVariables>(RunsModelDocument, options);
        }
export type RunsModelQueryHookResult = ReturnType<typeof useRunsModelQuery>;
export type RunsModelLazyQueryHookResult = ReturnType<typeof useRunsModelLazyQuery>;
export type RunsModelSuspenseQueryHookResult = ReturnType<typeof useRunsModelSuspenseQuery>;
export type RunsModelQueryResult = ApolloReactCommon.QueryResult<RunsModelQuery, RunsModelQueryVariables>;
export const UpsertRunDocument = gql`
    mutation upsertRun($id: String, $displayName: String, $notes: String, $tags: [String!]) {
  upsertBucket(
    input: {id: $id, displayName: $displayName, notes: $notes, tags: $tags}
  ) {
    bucket {
      id
      name
      displayName
      notes
      tags: tagColors {
        id
        name
        colorIndex
      }
      project {
        id
        tags {
          id
          name
          colorIndex
        }
      }
    }
    inserted
  }
}
    `;
export type UpsertRunMutationFn = ApolloReactCommon.MutationFunction<UpsertRunMutation, UpsertRunMutationVariables>;

/**
 * __useUpsertRunMutation__
 *
 * To run a mutation, you first call `useUpsertRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRunMutation, { data, loading, error }] = useUpsertRunMutation({
 *   variables: {
 *      id: // value for 'id'
 *      displayName: // value for 'displayName'
 *      notes: // value for 'notes'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUpsertRunMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertRunMutation, UpsertRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertRunMutation, UpsertRunMutationVariables>(UpsertRunDocument, options);
      }
export type UpsertRunMutationHookResult = ReturnType<typeof useUpsertRunMutation>;
export type UpsertRunMutationResult = ApolloReactCommon.MutationResult<UpsertRunMutation>;
export type UpsertRunMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertRunMutation, UpsertRunMutationVariables>;
export const RunGroupRenameDocument = gql`
    query runGroupRename($projectName: String!, $entityName: String!, $name: String!, $newName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    source: runGroup(name: $name) {
      id
      notes
      tags {
        id
        name
      }
    }
    target: runGroup(name: $newName) {
      id
      notes
      tags {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useRunGroupRenameQuery__
 *
 * To run a query within a React component, call `useRunGroupRenameQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunGroupRenameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunGroupRenameQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      name: // value for 'name'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useRunGroupRenameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunGroupRenameQuery, RunGroupRenameQueryVariables> & ({ variables: RunGroupRenameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunGroupRenameQuery, RunGroupRenameQueryVariables>(RunGroupRenameDocument, options);
      }
export function useRunGroupRenameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunGroupRenameQuery, RunGroupRenameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunGroupRenameQuery, RunGroupRenameQueryVariables>(RunGroupRenameDocument, options);
        }
// @ts-ignore
export function useRunGroupRenameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunGroupRenameQuery, RunGroupRenameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunGroupRenameQuery, RunGroupRenameQueryVariables>;
export function useRunGroupRenameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunGroupRenameQuery, RunGroupRenameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunGroupRenameQuery | undefined, RunGroupRenameQueryVariables>;
export function useRunGroupRenameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunGroupRenameQuery, RunGroupRenameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunGroupRenameQuery, RunGroupRenameQueryVariables>(RunGroupRenameDocument, options);
        }
export type RunGroupRenameQueryHookResult = ReturnType<typeof useRunGroupRenameQuery>;
export type RunGroupRenameLazyQueryHookResult = ReturnType<typeof useRunGroupRenameLazyQuery>;
export type RunGroupRenameSuspenseQueryHookResult = ReturnType<typeof useRunGroupRenameSuspenseQuery>;
export type RunGroupRenameQueryResult = ApolloReactCommon.QueryResult<RunGroupRenameQuery, RunGroupRenameQueryVariables>;
export const UpsertRunGroupDocument = gql`
    mutation upsertRunGroup($entityName: String!, $projectName: String!, $name: String!, $newName: String, $notes: String, $tags: [String!]) {
  upsertRunGroup(
    input: {projectName: $projectName, entityName: $entityName, name: $name, notes: $notes, newName: $newName, tags: $tags}
  ) {
    group {
      id
      name
      notes
      tags {
        id
        name
        colorIndex
      }
      project {
        id
        tags {
          id
          name
          colorIndex
        }
      }
    }
  }
}
    `;
export type UpsertRunGroupMutationFn = ApolloReactCommon.MutationFunction<UpsertRunGroupMutation, UpsertRunGroupMutationVariables>;

/**
 * __useUpsertRunGroupMutation__
 *
 * To run a mutation, you first call `useUpsertRunGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRunGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRunGroupMutation, { data, loading, error }] = useUpsertRunGroupMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      name: // value for 'name'
 *      newName: // value for 'newName'
 *      notes: // value for 'notes'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUpsertRunGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertRunGroupMutation, UpsertRunGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertRunGroupMutation, UpsertRunGroupMutationVariables>(UpsertRunGroupDocument, options);
      }
export type UpsertRunGroupMutationHookResult = ReturnType<typeof useUpsertRunGroupMutation>;
export type UpsertRunGroupMutationResult = ApolloReactCommon.MutationResult<UpsertRunGroupMutation>;
export type UpsertRunGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertRunGroupMutation, UpsertRunGroupMutationVariables>;
export const ModifyRunsDocument = gql`
    mutation modifyRuns($filters: JSONString, $entityName: String, $projectName: String, $addTags: [String], $removeTags: [String]) {
  modifyRuns(
    input: {filters: $filters, entityName: $entityName, projectName: $projectName, addTags: $addTags, removeTags: $removeTags}
  ) {
    runsSQL {
      id
      name
      __typename
      ...SelectRunFragment
      ...BasicRunFragment
      user {
        id
        username
        photoUrl
      }
    }
  }
}
    ${SelectRunFragmentFragmentDoc}
${BasicRunFragmentFragmentDoc}`;
export type ModifyRunsMutationFn = ApolloReactCommon.MutationFunction<ModifyRunsMutation, ModifyRunsMutationVariables>;

/**
 * __useModifyRunsMutation__
 *
 * To run a mutation, you first call `useModifyRunsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyRunsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyRunsMutation, { data, loading, error }] = useModifyRunsMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      addTags: // value for 'addTags'
 *      removeTags: // value for 'removeTags'
 *   },
 * });
 */
export function useModifyRunsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ModifyRunsMutation, ModifyRunsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ModifyRunsMutation, ModifyRunsMutationVariables>(ModifyRunsDocument, options);
      }
export type ModifyRunsMutationHookResult = ReturnType<typeof useModifyRunsMutation>;
export type ModifyRunsMutationResult = ApolloReactCommon.MutationResult<ModifyRunsMutation>;
export type ModifyRunsMutationOptions = ApolloReactCommon.BaseMutationOptions<ModifyRunsMutation, ModifyRunsMutationVariables>;
export const MoveRunsDocument = gql`
    mutation moveRuns($filters: JSONString!, $sourceEntityName: String!, $sourceProjectName: String!, $destinationEntityName: String!, $destinationProjectName: String!) {
  moveRuns(
    input: {filters: $filters, sourceEntityName: $sourceEntityName, sourceProjectName: $sourceProjectName, destinationEntityName: $destinationEntityName, destinationProjectName: $destinationProjectName}
  ) {
    task {
      id
    }
  }
}
    `;
export type MoveRunsMutationFn = ApolloReactCommon.MutationFunction<MoveRunsMutation, MoveRunsMutationVariables>;

/**
 * __useMoveRunsMutation__
 *
 * To run a mutation, you first call `useMoveRunsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveRunsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveRunsMutation, { data, loading, error }] = useMoveRunsMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *      sourceEntityName: // value for 'sourceEntityName'
 *      sourceProjectName: // value for 'sourceProjectName'
 *      destinationEntityName: // value for 'destinationEntityName'
 *      destinationProjectName: // value for 'destinationProjectName'
 *   },
 * });
 */
export function useMoveRunsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveRunsMutation, MoveRunsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveRunsMutation, MoveRunsMutationVariables>(MoveRunsDocument, options);
      }
export type MoveRunsMutationHookResult = ReturnType<typeof useMoveRunsMutation>;
export type MoveRunsMutationResult = ApolloReactCommon.MutationResult<MoveRunsMutation>;
export type MoveRunsMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveRunsMutation, MoveRunsMutationVariables>;
export const DeleteRunsDocument = gql`
    mutation deleteRuns($filters: JSONString!, $entityName: String!, $projectName: String!, $deleteArtifacts: Boolean!) {
  deleteRuns(
    input: {filters: $filters, entityName: $entityName, projectName: $projectName, deleteArtifacts: $deleteArtifacts}
  ) {
    clientMutationId
    errors
  }
}
    `;
export type DeleteRunsMutationFn = ApolloReactCommon.MutationFunction<DeleteRunsMutation, DeleteRunsMutationVariables>;

/**
 * __useDeleteRunsMutation__
 *
 * To run a mutation, you first call `useDeleteRunsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRunsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRunsMutation, { data, loading, error }] = useDeleteRunsMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      deleteArtifacts: // value for 'deleteArtifacts'
 *   },
 * });
 */
export function useDeleteRunsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRunsMutation, DeleteRunsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteRunsMutation, DeleteRunsMutationVariables>(DeleteRunsDocument, options);
      }
export type DeleteRunsMutationHookResult = ReturnType<typeof useDeleteRunsMutation>;
export type DeleteRunsMutationResult = ApolloReactCommon.MutationResult<DeleteRunsMutation>;
export type DeleteRunsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteRunsMutation, DeleteRunsMutationVariables>;
export const UndeleteRunsDocument = gql`
    mutation undeleteRuns($filters: JSONString!, $entityName: String!, $projectName: String!) {
  undeleteRuns(
    input: {filters: $filters, entityName: $entityName, projectName: $projectName}
  ) {
    clientMutationId
  }
}
    `;
export type UndeleteRunsMutationFn = ApolloReactCommon.MutationFunction<UndeleteRunsMutation, UndeleteRunsMutationVariables>;

/**
 * __useUndeleteRunsMutation__
 *
 * To run a mutation, you first call `useUndeleteRunsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndeleteRunsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undeleteRunsMutation, { data, loading, error }] = useUndeleteRunsMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useUndeleteRunsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UndeleteRunsMutation, UndeleteRunsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UndeleteRunsMutation, UndeleteRunsMutationVariables>(UndeleteRunsDocument, options);
      }
export type UndeleteRunsMutationHookResult = ReturnType<typeof useUndeleteRunsMutation>;
export type UndeleteRunsMutationResult = ApolloReactCommon.MutationResult<UndeleteRunsMutation>;
export type UndeleteRunsMutationOptions = ApolloReactCommon.BaseMutationOptions<UndeleteRunsMutation, UndeleteRunsMutationVariables>;
export const DeleteRunDocument = gql`
    mutation deleteRun($id: ID!, $deleteArtifacts: Boolean = false) {
  deleteRun(input: {id: $id, deleteArtifacts: $deleteArtifacts}) {
    clientMutationId
    numDeleted
  }
}
    `;
export type DeleteRunMutationFn = ApolloReactCommon.MutationFunction<DeleteRunMutation, DeleteRunMutationVariables>;

/**
 * __useDeleteRunMutation__
 *
 * To run a mutation, you first call `useDeleteRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRunMutation, { data, loading, error }] = useDeleteRunMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deleteArtifacts: // value for 'deleteArtifacts'
 *   },
 * });
 */
export function useDeleteRunMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRunMutation, DeleteRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteRunMutation, DeleteRunMutationVariables>(DeleteRunDocument, options);
      }
export type DeleteRunMutationHookResult = ReturnType<typeof useDeleteRunMutation>;
export type DeleteRunMutationResult = ApolloReactCommon.MutationResult<DeleteRunMutation>;
export type DeleteRunMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteRunMutation, DeleteRunMutationVariables>;
export const StopRunDocument = gql`
    mutation stopRun($id: ID!) {
  stopRun(input: {id: $id}) {
    clientMutationId
  }
}
    `;
export type StopRunMutationFn = ApolloReactCommon.MutationFunction<StopRunMutation, StopRunMutationVariables>;

/**
 * __useStopRunMutation__
 *
 * To run a mutation, you first call `useStopRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopRunMutation, { data, loading, error }] = useStopRunMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStopRunMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StopRunMutation, StopRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StopRunMutation, StopRunMutationVariables>(StopRunDocument, options);
      }
export type StopRunMutationHookResult = ReturnType<typeof useStopRunMutation>;
export type StopRunMutationResult = ApolloReactCommon.MutationResult<StopRunMutation>;
export type StopRunMutationOptions = ApolloReactCommon.BaseMutationOptions<StopRunMutation, StopRunMutationVariables>;
export const RunStopDocument = gql`
    mutation runStop($id: ID!) {
  stopRun(input: {id: $id}) {
    success
  }
}
    `;
export type RunStopMutationFn = ApolloReactCommon.MutationFunction<RunStopMutation, RunStopMutationVariables>;

/**
 * __useRunStopMutation__
 *
 * To run a mutation, you first call `useRunStopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunStopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runStopMutation, { data, loading, error }] = useRunStopMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRunStopMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RunStopMutation, RunStopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RunStopMutation, RunStopMutationVariables>(RunStopDocument, options);
      }
export type RunStopMutationHookResult = ReturnType<typeof useRunStopMutation>;
export type RunStopMutationResult = ApolloReactCommon.MutationResult<RunStopMutation>;
export type RunStopMutationOptions = ApolloReactCommon.BaseMutationOptions<RunStopMutation, RunStopMutationVariables>;
export const DeleteFilesDocument = gql`
    mutation deleteFiles($ids: [ID!]!, $projectId: Int!) {
  deleteFiles(input: {files: $ids, projectId: $projectId}) {
    clientMutationId
    success
  }
}
    `;
export type DeleteFilesMutationFn = ApolloReactCommon.MutationFunction<DeleteFilesMutation, DeleteFilesMutationVariables>;

/**
 * __useDeleteFilesMutation__
 *
 * To run a mutation, you first call `useDeleteFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFilesMutation, { data, loading, error }] = useDeleteFilesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteFilesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFilesMutation, DeleteFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFilesMutation, DeleteFilesMutationVariables>(DeleteFilesDocument, options);
      }
export type DeleteFilesMutationHookResult = ReturnType<typeof useDeleteFilesMutation>;
export type DeleteFilesMutationResult = ApolloReactCommon.MutationResult<DeleteFilesMutation>;
export type DeleteFilesMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteFilesMutation, DeleteFilesMutationVariables>;
export const DeleteFilesByRunAndFolderDocument = gql`
    mutation deleteFilesByRunAndFolder($runName: String!, $projectId: Int!, $folders: [String!]!) {
  deleteFilesByRunAndFolder(
    input: {runName: $runName, projectId: $projectId, folders: $folders}
  ) {
    clientMutationId
    success
  }
}
    `;
export type DeleteFilesByRunAndFolderMutationFn = ApolloReactCommon.MutationFunction<DeleteFilesByRunAndFolderMutation, DeleteFilesByRunAndFolderMutationVariables>;

/**
 * __useDeleteFilesByRunAndFolderMutation__
 *
 * To run a mutation, you first call `useDeleteFilesByRunAndFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFilesByRunAndFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFilesByRunAndFolderMutation, { data, loading, error }] = useDeleteFilesByRunAndFolderMutation({
 *   variables: {
 *      runName: // value for 'runName'
 *      projectId: // value for 'projectId'
 *      folders: // value for 'folders'
 *   },
 * });
 */
export function useDeleteFilesByRunAndFolderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFilesByRunAndFolderMutation, DeleteFilesByRunAndFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFilesByRunAndFolderMutation, DeleteFilesByRunAndFolderMutationVariables>(DeleteFilesByRunAndFolderDocument, options);
      }
export type DeleteFilesByRunAndFolderMutationHookResult = ReturnType<typeof useDeleteFilesByRunAndFolderMutation>;
export type DeleteFilesByRunAndFolderMutationResult = ApolloReactCommon.MutationResult<DeleteFilesByRunAndFolderMutation>;
export type DeleteFilesByRunAndFolderMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteFilesByRunAndFolderMutation, DeleteFilesByRunAndFolderMutationVariables>;
export const RunHasProtectedOutputArtifactDocument = gql`
    query runHasProtectedOutputArtifact($runName: String!, $projectName: String!, $entityName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      hasProtectedOutputArtifact
    }
  }
}
    `;

/**
 * __useRunHasProtectedOutputArtifactQuery__
 *
 * To run a query within a React component, call `useRunHasProtectedOutputArtifactQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunHasProtectedOutputArtifactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunHasProtectedOutputArtifactQuery({
 *   variables: {
 *      runName: // value for 'runName'
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useRunHasProtectedOutputArtifactQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables> & ({ variables: RunHasProtectedOutputArtifactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables>(RunHasProtectedOutputArtifactDocument, options);
      }
export function useRunHasProtectedOutputArtifactLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables>(RunHasProtectedOutputArtifactDocument, options);
        }
// @ts-ignore
export function useRunHasProtectedOutputArtifactSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables>;
export function useRunHasProtectedOutputArtifactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunHasProtectedOutputArtifactQuery | undefined, RunHasProtectedOutputArtifactQueryVariables>;
export function useRunHasProtectedOutputArtifactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables>(RunHasProtectedOutputArtifactDocument, options);
        }
export type RunHasProtectedOutputArtifactQueryHookResult = ReturnType<typeof useRunHasProtectedOutputArtifactQuery>;
export type RunHasProtectedOutputArtifactLazyQueryHookResult = ReturnType<typeof useRunHasProtectedOutputArtifactLazyQuery>;
export type RunHasProtectedOutputArtifactSuspenseQueryHookResult = ReturnType<typeof useRunHasProtectedOutputArtifactSuspenseQuery>;
export type RunHasProtectedOutputArtifactQueryResult = ApolloReactCommon.QueryResult<RunHasProtectedOutputArtifactQuery, RunHasProtectedOutputArtifactQueryVariables>;
export const RunsHaveProtectedOutputArtifactsDocument = gql`
    query runsHaveProtectedOutputArtifacts($filters: JSONString!, $projectName: String!, $entityName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runsHaveProtectedOutputArtifacts(filters: $filters)
  }
}
    `;

/**
 * __useRunsHaveProtectedOutputArtifactsQuery__
 *
 * To run a query within a React component, call `useRunsHaveProtectedOutputArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsHaveProtectedOutputArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsHaveProtectedOutputArtifactsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useRunsHaveProtectedOutputArtifactsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables> & ({ variables: RunsHaveProtectedOutputArtifactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables>(RunsHaveProtectedOutputArtifactsDocument, options);
      }
export function useRunsHaveProtectedOutputArtifactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables>(RunsHaveProtectedOutputArtifactsDocument, options);
        }
// @ts-ignore
export function useRunsHaveProtectedOutputArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables>;
export function useRunsHaveProtectedOutputArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsHaveProtectedOutputArtifactsQuery | undefined, RunsHaveProtectedOutputArtifactsQueryVariables>;
export function useRunsHaveProtectedOutputArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables>(RunsHaveProtectedOutputArtifactsDocument, options);
        }
export type RunsHaveProtectedOutputArtifactsQueryHookResult = ReturnType<typeof useRunsHaveProtectedOutputArtifactsQuery>;
export type RunsHaveProtectedOutputArtifactsLazyQueryHookResult = ReturnType<typeof useRunsHaveProtectedOutputArtifactsLazyQuery>;
export type RunsHaveProtectedOutputArtifactsSuspenseQueryHookResult = ReturnType<typeof useRunsHaveProtectedOutputArtifactsSuspenseQuery>;
export type RunsHaveProtectedOutputArtifactsQueryResult = ApolloReactCommon.QueryResult<RunsHaveProtectedOutputArtifactsQuery, RunsHaveProtectedOutputArtifactsQueryVariables>;
export const UpsertTeamSecretDocument = gql`
    mutation upsertTeamSecret($entityName: String!, $secretName: String!, $secretValue: String!) {
  upsertTeamSecret(
    input: {entityName: $entityName, secretName: $secretName, secretValue: $secretValue}
  ) {
    secret {
      name
    }
  }
}
    `;
export type UpsertTeamSecretMutationFn = ApolloReactCommon.MutationFunction<UpsertTeamSecretMutation, UpsertTeamSecretMutationVariables>;

/**
 * __useUpsertTeamSecretMutation__
 *
 * To run a mutation, you first call `useUpsertTeamSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTeamSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTeamSecretMutation, { data, loading, error }] = useUpsertTeamSecretMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      secretName: // value for 'secretName'
 *      secretValue: // value for 'secretValue'
 *   },
 * });
 */
export function useUpsertTeamSecretMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertTeamSecretMutation, UpsertTeamSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertTeamSecretMutation, UpsertTeamSecretMutationVariables>(UpsertTeamSecretDocument, options);
      }
export type UpsertTeamSecretMutationHookResult = ReturnType<typeof useUpsertTeamSecretMutation>;
export type UpsertTeamSecretMutationResult = ApolloReactCommon.MutationResult<UpsertTeamSecretMutation>;
export type UpsertTeamSecretMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertTeamSecretMutation, UpsertTeamSecretMutationVariables>;
export const DeleteSecretDocument = gql`
    mutation deleteSecret($entityName: String!, $secretName: String!) {
  deleteSecret(input: {entityName: $entityName, secretName: $secretName}) {
    success
  }
}
    `;
export type DeleteSecretMutationFn = ApolloReactCommon.MutationFunction<DeleteSecretMutation, DeleteSecretMutationVariables>;

/**
 * __useDeleteSecretMutation__
 *
 * To run a mutation, you first call `useDeleteSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSecretMutation, { data, loading, error }] = useDeleteSecretMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      secretName: // value for 'secretName'
 *   },
 * });
 */
export function useDeleteSecretMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteSecretMutation, DeleteSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteSecretMutation, DeleteSecretMutationVariables>(DeleteSecretDocument, options);
      }
export type DeleteSecretMutationHookResult = ReturnType<typeof useDeleteSecretMutation>;
export type DeleteSecretMutationResult = ApolloReactCommon.MutationResult<DeleteSecretMutation>;
export type DeleteSecretMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteSecretMutation, DeleteSecretMutationVariables>;
export const SecretsDocument = gql`
    query secrets($entityName: String!) {
  entity(name: $entityName) {
    id
    secrets {
      entityId
      name
      uuid
      createdAt
    }
  }
}
    `;

/**
 * __useSecretsQuery__
 *
 * To run a query within a React component, call `useSecretsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecretsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSecretsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useSecretsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SecretsQuery, SecretsQueryVariables> & ({ variables: SecretsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SecretsQuery, SecretsQueryVariables>(SecretsDocument, options);
      }
export function useSecretsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SecretsQuery, SecretsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SecretsQuery, SecretsQueryVariables>(SecretsDocument, options);
        }
// @ts-ignore
export function useSecretsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SecretsQuery, SecretsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SecretsQuery, SecretsQueryVariables>;
export function useSecretsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SecretsQuery, SecretsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SecretsQuery | undefined, SecretsQueryVariables>;
export function useSecretsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SecretsQuery, SecretsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SecretsQuery, SecretsQueryVariables>(SecretsDocument, options);
        }
export type SecretsQueryHookResult = ReturnType<typeof useSecretsQuery>;
export type SecretsLazyQueryHookResult = ReturnType<typeof useSecretsLazyQuery>;
export type SecretsSuspenseQueryHookResult = ReturnType<typeof useSecretsSuspenseQuery>;
export type SecretsQueryResult = ApolloReactCommon.QueryResult<SecretsQuery, SecretsQueryVariables>;
export const UserSecretsDocument = gql`
    query UserSecrets($organizationId: ID) {
  viewer {
    id
    username
    teams(first: 100) {
      edges {
        node {
          id
          name
          organizationId
          secrets {
            name
          }
        }
      }
    }
    secrets(organizationId: $organizationId) {
      ...UserSecretFields
    }
  }
}
    ${UserSecretFieldsFragmentDoc}`;

/**
 * __useUserSecretsQuery__
 *
 * To run a query within a React component, call `useUserSecretsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSecretsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSecretsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useUserSecretsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserSecretsQuery, UserSecretsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserSecretsQuery, UserSecretsQueryVariables>(UserSecretsDocument, options);
      }
export function useUserSecretsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserSecretsQuery, UserSecretsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserSecretsQuery, UserSecretsQueryVariables>(UserSecretsDocument, options);
        }
// @ts-ignore
export function useUserSecretsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserSecretsQuery, UserSecretsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserSecretsQuery, UserSecretsQueryVariables>;
export function useUserSecretsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserSecretsQuery, UserSecretsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserSecretsQuery | undefined, UserSecretsQueryVariables>;
export function useUserSecretsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserSecretsQuery, UserSecretsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserSecretsQuery, UserSecretsQueryVariables>(UserSecretsDocument, options);
        }
export type UserSecretsQueryHookResult = ReturnType<typeof useUserSecretsQuery>;
export type UserSecretsLazyQueryHookResult = ReturnType<typeof useUserSecretsLazyQuery>;
export type UserSecretsSuspenseQueryHookResult = ReturnType<typeof useUserSecretsSuspenseQuery>;
export type UserSecretsQueryResult = ApolloReactCommon.QueryResult<UserSecretsQuery, UserSecretsQueryVariables>;
export const UpsertUserSecretDocument = gql`
    mutation UpsertUserSecret($secretName: String!, $secretValue: String!, $organizationId: ID) {
  upsertUserSecret(
    input: {secretName: $secretName, secretValue: $secretValue, organizationId: $organizationId}
  ) {
    secret {
      uuid
      name
      createdAt
    }
  }
}
    `;
export type UpsertUserSecretMutationFn = ApolloReactCommon.MutationFunction<UpsertUserSecretMutation, UpsertUserSecretMutationVariables>;

/**
 * __useUpsertUserSecretMutation__
 *
 * To run a mutation, you first call `useUpsertUserSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserSecretMutation, { data, loading, error }] = useUpsertUserSecretMutation({
 *   variables: {
 *      secretName: // value for 'secretName'
 *      secretValue: // value for 'secretValue'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useUpsertUserSecretMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertUserSecretMutation, UpsertUserSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertUserSecretMutation, UpsertUserSecretMutationVariables>(UpsertUserSecretDocument, options);
      }
export type UpsertUserSecretMutationHookResult = ReturnType<typeof useUpsertUserSecretMutation>;
export type UpsertUserSecretMutationResult = ApolloReactCommon.MutationResult<UpsertUserSecretMutation>;
export type UpsertUserSecretMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertUserSecretMutation, UpsertUserSecretMutationVariables>;
export const DeleteUserSecretDocument = gql`
    mutation DeleteUserSecret($secretName: String!, $organizationId: ID) {
  deleteUserSecret(
    input: {secretName: $secretName, organizationId: $organizationId}
  ) {
    success
  }
}
    `;
export type DeleteUserSecretMutationFn = ApolloReactCommon.MutationFunction<DeleteUserSecretMutation, DeleteUserSecretMutationVariables>;

/**
 * __useDeleteUserSecretMutation__
 *
 * To run a mutation, you first call `useDeleteUserSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserSecretMutation, { data, loading, error }] = useDeleteUserSecretMutation({
 *   variables: {
 *      secretName: // value for 'secretName'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteUserSecretMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserSecretMutation, DeleteUserSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserSecretMutation, DeleteUserSecretMutationVariables>(DeleteUserSecretDocument, options);
      }
export type DeleteUserSecretMutationHookResult = ReturnType<typeof useDeleteUserSecretMutation>;
export type DeleteUserSecretMutationResult = ApolloReactCommon.MutationResult<DeleteUserSecretMutation>;
export type DeleteUserSecretMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteUserSecretMutation, DeleteUserSecretMutationVariables>;
export const ServerInfoDocument = gql`
    query ServerInfo {
  serverInfo {
    availableCloudRegions {
      id
      provider
      region
    }
    isGoogleIap
    slackClientID
  }
}
    `;

/**
 * __useServerInfoQuery__
 *
 * To run a query within a React component, call `useServerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useServerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServerInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useServerInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ServerInfoQuery, ServerInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ServerInfoQuery, ServerInfoQueryVariables>(ServerInfoDocument, options);
      }
export function useServerInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ServerInfoQuery, ServerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ServerInfoQuery, ServerInfoQueryVariables>(ServerInfoDocument, options);
        }
// @ts-ignore
export function useServerInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ServerInfoQuery, ServerInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ServerInfoQuery, ServerInfoQueryVariables>;
export function useServerInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ServerInfoQuery, ServerInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ServerInfoQuery | undefined, ServerInfoQueryVariables>;
export function useServerInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ServerInfoQuery, ServerInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ServerInfoQuery, ServerInfoQueryVariables>(ServerInfoDocument, options);
        }
export type ServerInfoQueryHookResult = ReturnType<typeof useServerInfoQuery>;
export type ServerInfoLazyQueryHookResult = ReturnType<typeof useServerInfoLazyQuery>;
export type ServerInfoSuspenseQueryHookResult = ReturnType<typeof useServerInfoSuspenseQuery>;
export type ServerInfoQueryResult = ApolloReactCommon.QueryResult<ServerInfoQuery, ServerInfoQueryVariables>;
export const LicenseExpirationUiDocument = gql`
    query LicenseExpirationUI {
  serverInfo {
    licenseExpirationUI {
      bannerTotalDays
      bannerDaysRemaining
      renewUrl
    }
  }
}
    `;

/**
 * __useLicenseExpirationUiQuery__
 *
 * To run a query within a React component, call `useLicenseExpirationUiQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicenseExpirationUiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLicenseExpirationUiQuery({
 *   variables: {
 *   },
 * });
 */
export function useLicenseExpirationUiQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>(LicenseExpirationUiDocument, options);
      }
export function useLicenseExpirationUiLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>(LicenseExpirationUiDocument, options);
        }
// @ts-ignore
export function useLicenseExpirationUiSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>;
export function useLicenseExpirationUiSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LicenseExpirationUiQuery | undefined, LicenseExpirationUiQueryVariables>;
export function useLicenseExpirationUiSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>(LicenseExpirationUiDocument, options);
        }
export type LicenseExpirationUiQueryHookResult = ReturnType<typeof useLicenseExpirationUiQuery>;
export type LicenseExpirationUiLazyQueryHookResult = ReturnType<typeof useLicenseExpirationUiLazyQuery>;
export type LicenseExpirationUiSuspenseQueryHookResult = ReturnType<typeof useLicenseExpirationUiSuspenseQuery>;
export type LicenseExpirationUiQueryResult = ApolloReactCommon.QueryResult<LicenseExpirationUiQuery, LicenseExpirationUiQueryVariables>;
export const UserLimitReachedDocument = gql`
    query UserLimitReached {
  serverInfo {
    userLimitReached
    viewOnlyUserLimitReached
    licenseFlags
  }
}
    `;

/**
 * __useUserLimitReachedQuery__
 *
 * To run a query within a React component, call `useUserLimitReachedQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserLimitReachedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserLimitReachedQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserLimitReachedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserLimitReachedQuery, UserLimitReachedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserLimitReachedQuery, UserLimitReachedQueryVariables>(UserLimitReachedDocument, options);
      }
export function useUserLimitReachedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserLimitReachedQuery, UserLimitReachedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserLimitReachedQuery, UserLimitReachedQueryVariables>(UserLimitReachedDocument, options);
        }
// @ts-ignore
export function useUserLimitReachedSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserLimitReachedQuery, UserLimitReachedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserLimitReachedQuery, UserLimitReachedQueryVariables>;
export function useUserLimitReachedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserLimitReachedQuery, UserLimitReachedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserLimitReachedQuery | undefined, UserLimitReachedQueryVariables>;
export function useUserLimitReachedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserLimitReachedQuery, UserLimitReachedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserLimitReachedQuery, UserLimitReachedQueryVariables>(UserLimitReachedDocument, options);
        }
export type UserLimitReachedQueryHookResult = ReturnType<typeof useUserLimitReachedQuery>;
export type UserLimitReachedLazyQueryHookResult = ReturnType<typeof useUserLimitReachedLazyQuery>;
export type UserLimitReachedSuspenseQueryHookResult = ReturnType<typeof useUserLimitReachedSuspenseQuery>;
export type UserLimitReachedQueryResult = ApolloReactCommon.QueryResult<UserLimitReachedQuery, UserLimitReachedQueryVariables>;
export const ViewOnlyUserLimitReachedDocument = gql`
    query ViewOnlyUserLimitReached {
  serverInfo {
    viewOnlyUserLimitReached
  }
}
    `;

/**
 * __useViewOnlyUserLimitReachedQuery__
 *
 * To run a query within a React component, call `useViewOnlyUserLimitReachedQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewOnlyUserLimitReachedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewOnlyUserLimitReachedQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewOnlyUserLimitReachedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>(ViewOnlyUserLimitReachedDocument, options);
      }
export function useViewOnlyUserLimitReachedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>(ViewOnlyUserLimitReachedDocument, options);
        }
// @ts-ignore
export function useViewOnlyUserLimitReachedSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>;
export function useViewOnlyUserLimitReachedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewOnlyUserLimitReachedQuery | undefined, ViewOnlyUserLimitReachedQueryVariables>;
export function useViewOnlyUserLimitReachedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>(ViewOnlyUserLimitReachedDocument, options);
        }
export type ViewOnlyUserLimitReachedQueryHookResult = ReturnType<typeof useViewOnlyUserLimitReachedQuery>;
export type ViewOnlyUserLimitReachedLazyQueryHookResult = ReturnType<typeof useViewOnlyUserLimitReachedLazyQuery>;
export type ViewOnlyUserLimitReachedSuspenseQueryHookResult = ReturnType<typeof useViewOnlyUserLimitReachedSuspenseQuery>;
export type ViewOnlyUserLimitReachedQueryResult = ApolloReactCommon.QueryResult<ViewOnlyUserLimitReachedQuery, ViewOnlyUserLimitReachedQueryVariables>;
export const RegisteredModelLimitReachedDocument = gql`
    query RegisteredModelLimitReached($entityName: String!) {
  serverInfo {
    registeredModelLimitReached(entityName: $entityName)
  }
}
    `;

/**
 * __useRegisteredModelLimitReachedQuery__
 *
 * To run a query within a React component, call `useRegisteredModelLimitReachedQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisteredModelLimitReachedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisteredModelLimitReachedQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useRegisteredModelLimitReachedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables> & ({ variables: RegisteredModelLimitReachedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables>(RegisteredModelLimitReachedDocument, options);
      }
export function useRegisteredModelLimitReachedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables>(RegisteredModelLimitReachedDocument, options);
        }
// @ts-ignore
export function useRegisteredModelLimitReachedSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables>;
export function useRegisteredModelLimitReachedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RegisteredModelLimitReachedQuery | undefined, RegisteredModelLimitReachedQueryVariables>;
export function useRegisteredModelLimitReachedSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables>(RegisteredModelLimitReachedDocument, options);
        }
export type RegisteredModelLimitReachedQueryHookResult = ReturnType<typeof useRegisteredModelLimitReachedQuery>;
export type RegisteredModelLimitReachedLazyQueryHookResult = ReturnType<typeof useRegisteredModelLimitReachedLazyQuery>;
export type RegisteredModelLimitReachedSuspenseQueryHookResult = ReturnType<typeof useRegisteredModelLimitReachedSuspenseQuery>;
export type RegisteredModelLimitReachedQueryResult = ApolloReactCommon.QueryResult<RegisteredModelLimitReachedQuery, RegisteredModelLimitReachedQueryVariables>;
export const ActionHistoryLimitDocument = gql`
    query ActionHistoryLimit($entityName: String, $artifactCollectionID: ID) {
  serverInfo {
    actionHistoryLimit(
      entityName: $entityName
      artifactCollectionID: $artifactCollectionID
    )
  }
}
    `;

/**
 * __useActionHistoryLimitQuery__
 *
 * To run a query within a React component, call `useActionHistoryLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionHistoryLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionHistoryLimitQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *   },
 * });
 */
export function useActionHistoryLimitQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>(ActionHistoryLimitDocument, options);
      }
export function useActionHistoryLimitLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>(ActionHistoryLimitDocument, options);
        }
// @ts-ignore
export function useActionHistoryLimitSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>;
export function useActionHistoryLimitSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ActionHistoryLimitQuery | undefined, ActionHistoryLimitQueryVariables>;
export function useActionHistoryLimitSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>(ActionHistoryLimitDocument, options);
        }
export type ActionHistoryLimitQueryHookResult = ReturnType<typeof useActionHistoryLimitQuery>;
export type ActionHistoryLimitLazyQueryHookResult = ReturnType<typeof useActionHistoryLimitLazyQuery>;
export type ActionHistoryLimitSuspenseQueryHookResult = ReturnType<typeof useActionHistoryLimitSuspenseQuery>;
export type ActionHistoryLimitQueryResult = ApolloReactCommon.QueryResult<ActionHistoryLimitQuery, ActionHistoryLimitQueryVariables>;
export const FrontendHostDocument = gql`
    query FrontendHost {
  serverInfo {
    frontendHost
  }
}
    `;

/**
 * __useFrontendHostQuery__
 *
 * To run a query within a React component, call `useFrontendHostQuery` and pass it any options that fit your needs.
 * When your component renders, `useFrontendHostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFrontendHostQuery({
 *   variables: {
 *   },
 * });
 */
export function useFrontendHostQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FrontendHostQuery, FrontendHostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FrontendHostQuery, FrontendHostQueryVariables>(FrontendHostDocument, options);
      }
export function useFrontendHostLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FrontendHostQuery, FrontendHostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FrontendHostQuery, FrontendHostQueryVariables>(FrontendHostDocument, options);
        }
// @ts-ignore
export function useFrontendHostSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FrontendHostQuery, FrontendHostQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FrontendHostQuery, FrontendHostQueryVariables>;
export function useFrontendHostSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FrontendHostQuery, FrontendHostQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FrontendHostQuery | undefined, FrontendHostQueryVariables>;
export function useFrontendHostSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FrontendHostQuery, FrontendHostQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FrontendHostQuery, FrontendHostQueryVariables>(FrontendHostDocument, options);
        }
export type FrontendHostQueryHookResult = ReturnType<typeof useFrontendHostQuery>;
export type FrontendHostLazyQueryHookResult = ReturnType<typeof useFrontendHostLazyQuery>;
export type FrontendHostSuspenseQueryHookResult = ReturnType<typeof useFrontendHostSuspenseQuery>;
export type FrontendHostQueryResult = ApolloReactCommon.QueryResult<FrontendHostQuery, FrontendHostQueryVariables>;
export const DeploymentIdDocument = gql`
    query DeploymentID {
  serverInfo {
    deploymentId
  }
}
    `;

/**
 * __useDeploymentIdQuery__
 *
 * To run a query within a React component, call `useDeploymentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeploymentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeploymentIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeploymentIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DeploymentIdQuery, DeploymentIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DeploymentIdQuery, DeploymentIdQueryVariables>(DeploymentIdDocument, options);
      }
export function useDeploymentIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DeploymentIdQuery, DeploymentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DeploymentIdQuery, DeploymentIdQueryVariables>(DeploymentIdDocument, options);
        }
// @ts-ignore
export function useDeploymentIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DeploymentIdQuery, DeploymentIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DeploymentIdQuery, DeploymentIdQueryVariables>;
export function useDeploymentIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DeploymentIdQuery, DeploymentIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DeploymentIdQuery | undefined, DeploymentIdQueryVariables>;
export function useDeploymentIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DeploymentIdQuery, DeploymentIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DeploymentIdQuery, DeploymentIdQueryVariables>(DeploymentIdDocument, options);
        }
export type DeploymentIdQueryHookResult = ReturnType<typeof useDeploymentIdQuery>;
export type DeploymentIdLazyQueryHookResult = ReturnType<typeof useDeploymentIdLazyQuery>;
export type DeploymentIdSuspenseQueryHookResult = ReturnType<typeof useDeploymentIdSuspenseQuery>;
export type DeploymentIdQueryResult = ApolloReactCommon.QueryResult<DeploymentIdQuery, DeploymentIdQueryVariables>;
export const SecureStorageConnectorEnabledDocument = gql`
    query SecureStorageConnectorEnabled {
  serverInfo {
    secureStorageConnectorEnabled
  }
}
    `;

/**
 * __useSecureStorageConnectorEnabledQuery__
 *
 * To run a query within a React component, call `useSecureStorageConnectorEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecureStorageConnectorEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSecureStorageConnectorEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useSecureStorageConnectorEnabledQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>(SecureStorageConnectorEnabledDocument, options);
      }
export function useSecureStorageConnectorEnabledLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>(SecureStorageConnectorEnabledDocument, options);
        }
// @ts-ignore
export function useSecureStorageConnectorEnabledSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>;
export function useSecureStorageConnectorEnabledSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SecureStorageConnectorEnabledQuery | undefined, SecureStorageConnectorEnabledQueryVariables>;
export function useSecureStorageConnectorEnabledSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>(SecureStorageConnectorEnabledDocument, options);
        }
export type SecureStorageConnectorEnabledQueryHookResult = ReturnType<typeof useSecureStorageConnectorEnabledQuery>;
export type SecureStorageConnectorEnabledLazyQueryHookResult = ReturnType<typeof useSecureStorageConnectorEnabledLazyQuery>;
export type SecureStorageConnectorEnabledSuspenseQueryHookResult = ReturnType<typeof useSecureStorageConnectorEnabledSuspenseQuery>;
export type SecureStorageConnectorEnabledQueryResult = ApolloReactCommon.QueryResult<SecureStorageConnectorEnabledQuery, SecureStorageConnectorEnabledQueryVariables>;
export const AvailableBucketProvidersDocument = gql`
    query AvailableBucketProviders {
  serverInfo {
    availableBucketProviders
  }
}
    `;

/**
 * __useAvailableBucketProvidersQuery__
 *
 * To run a query within a React component, call `useAvailableBucketProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableBucketProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableBucketProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableBucketProvidersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>(AvailableBucketProvidersDocument, options);
      }
export function useAvailableBucketProvidersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>(AvailableBucketProvidersDocument, options);
        }
// @ts-ignore
export function useAvailableBucketProvidersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>;
export function useAvailableBucketProvidersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AvailableBucketProvidersQuery | undefined, AvailableBucketProvidersQueryVariables>;
export function useAvailableBucketProvidersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>(AvailableBucketProvidersDocument, options);
        }
export type AvailableBucketProvidersQueryHookResult = ReturnType<typeof useAvailableBucketProvidersQuery>;
export type AvailableBucketProvidersLazyQueryHookResult = ReturnType<typeof useAvailableBucketProvidersLazyQuery>;
export type AvailableBucketProvidersSuspenseQueryHookResult = ReturnType<typeof useAvailableBucketProvidersSuspenseQuery>;
export type AvailableBucketProvidersQueryResult = ApolloReactCommon.QueryResult<AvailableBucketProvidersQuery, AvailableBucketProvidersQueryVariables>;
export const DataRetentionDurationDocument = gql`
    query DataRetentionDuration {
  serverInfo {
    dataRetentionDuration
  }
}
    `;

/**
 * __useDataRetentionDurationQuery__
 *
 * To run a query within a React component, call `useDataRetentionDurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataRetentionDurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataRetentionDurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useDataRetentionDurationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>(DataRetentionDurationDocument, options);
      }
export function useDataRetentionDurationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>(DataRetentionDurationDocument, options);
        }
// @ts-ignore
export function useDataRetentionDurationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>;
export function useDataRetentionDurationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DataRetentionDurationQuery | undefined, DataRetentionDurationQueryVariables>;
export function useDataRetentionDurationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>(DataRetentionDurationDocument, options);
        }
export type DataRetentionDurationQueryHookResult = ReturnType<typeof useDataRetentionDurationQuery>;
export type DataRetentionDurationLazyQueryHookResult = ReturnType<typeof useDataRetentionDurationLazyQuery>;
export type DataRetentionDurationSuspenseQueryHookResult = ReturnType<typeof useDataRetentionDurationSuspenseQuery>;
export type DataRetentionDurationQueryResult = ApolloReactCommon.QueryResult<DataRetentionDurationQuery, DataRetentionDurationQueryVariables>;
export const FailedPaymentBannersDocument = gql`
    query FailedPaymentBanners($id: ID!) {
  failedPaymentBanners(id: $id) {
    userID
    orgsWithFailedPayments {
      id
      orgId
      orgName
      isBillingUser
      billingEmail
      daysUntilCancellation
      isCollectionMethodACH
    }
  }
}
    `;

/**
 * __useFailedPaymentBannersQuery__
 *
 * To run a query within a React component, call `useFailedPaymentBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFailedPaymentBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFailedPaymentBannersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFailedPaymentBannersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables> & ({ variables: FailedPaymentBannersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables>(FailedPaymentBannersDocument, options);
      }
export function useFailedPaymentBannersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables>(FailedPaymentBannersDocument, options);
        }
// @ts-ignore
export function useFailedPaymentBannersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables>;
export function useFailedPaymentBannersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FailedPaymentBannersQuery | undefined, FailedPaymentBannersQueryVariables>;
export function useFailedPaymentBannersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables>(FailedPaymentBannersDocument, options);
        }
export type FailedPaymentBannersQueryHookResult = ReturnType<typeof useFailedPaymentBannersQuery>;
export type FailedPaymentBannersLazyQueryHookResult = ReturnType<typeof useFailedPaymentBannersLazyQuery>;
export type FailedPaymentBannersSuspenseQueryHookResult = ReturnType<typeof useFailedPaymentBannersSuspenseQuery>;
export type FailedPaymentBannersQueryResult = ApolloReactCommon.QueryResult<FailedPaymentBannersQuery, FailedPaymentBannersQueryVariables>;
export const SingleFileDocument = gql`
    query SingleFile($projectName: String!, $entityName: String, $runName: String!, $fileName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      files(first: 1, names: [$fileName]) {
        edges {
          node {
            id
            name
            directUrl
            sizeBytes
            updatedAt
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSingleFileQuery__
 *
 * To run a query within a React component, call `useSingleFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleFileQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useSingleFileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SingleFileQuery, SingleFileQueryVariables> & ({ variables: SingleFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SingleFileQuery, SingleFileQueryVariables>(SingleFileDocument, options);
      }
export function useSingleFileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SingleFileQuery, SingleFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SingleFileQuery, SingleFileQueryVariables>(SingleFileDocument, options);
        }
// @ts-ignore
export function useSingleFileSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SingleFileQuery, SingleFileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SingleFileQuery, SingleFileQueryVariables>;
export function useSingleFileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SingleFileQuery, SingleFileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SingleFileQuery | undefined, SingleFileQueryVariables>;
export function useSingleFileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SingleFileQuery, SingleFileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SingleFileQuery, SingleFileQueryVariables>(SingleFileDocument, options);
        }
export type SingleFileQueryHookResult = ReturnType<typeof useSingleFileQuery>;
export type SingleFileLazyQueryHookResult = ReturnType<typeof useSingleFileLazyQuery>;
export type SingleFileSuspenseQueryHookResult = ReturnType<typeof useSingleFileSuspenseQuery>;
export type SingleFileQueryResult = ApolloReactCommon.QueryResult<SingleFileQuery, SingleFileQueryVariables>;
export const StarredProjectsDocument = gql`
    query StarredProjects($organizationId: ID) {
  viewer {
    id
    starredProjects(first: 30, organizationID: $organizationId) {
      edges {
        node {
          id
          ...AccountProjectFragment
        }
      }
    }
  }
}
    ${AccountProjectFragmentFragmentDoc}`;

/**
 * __useStarredProjectsQuery__
 *
 * To run a query within a React component, call `useStarredProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStarredProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStarredProjectsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useStarredProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StarredProjectsQuery, StarredProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StarredProjectsQuery, StarredProjectsQueryVariables>(StarredProjectsDocument, options);
      }
export function useStarredProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StarredProjectsQuery, StarredProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StarredProjectsQuery, StarredProjectsQueryVariables>(StarredProjectsDocument, options);
        }
// @ts-ignore
export function useStarredProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<StarredProjectsQuery, StarredProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StarredProjectsQuery, StarredProjectsQueryVariables>;
export function useStarredProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StarredProjectsQuery, StarredProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StarredProjectsQuery | undefined, StarredProjectsQueryVariables>;
export function useStarredProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StarredProjectsQuery, StarredProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<StarredProjectsQuery, StarredProjectsQueryVariables>(StarredProjectsDocument, options);
        }
export type StarredProjectsQueryHookResult = ReturnType<typeof useStarredProjectsQuery>;
export type StarredProjectsLazyQueryHookResult = ReturnType<typeof useStarredProjectsLazyQuery>;
export type StarredProjectsSuspenseQueryHookResult = ReturnType<typeof useStarredProjectsSuspenseQuery>;
export type StarredProjectsQueryResult = ApolloReactCommon.QueryResult<StarredProjectsQuery, StarredProjectsQueryVariables>;
export const SubscriptionPlansDocument = gql`
    query SubscriptionPlans {
  plans {
    id
    name
    displayName
    stripePlanId
    maxSeats
    defaultPrivileges
    planType
    planVisibility
    unitPrice
    billingInterval
  }
}
    `;

/**
 * __useSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `useSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionPlansQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>(SubscriptionPlansDocument, options);
      }
export function useSubscriptionPlansLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>(SubscriptionPlansDocument, options);
        }
// @ts-ignore
export function useSubscriptionPlansSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>;
export function useSubscriptionPlansSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SubscriptionPlansQuery | undefined, SubscriptionPlansQueryVariables>;
export function useSubscriptionPlansSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>(SubscriptionPlansDocument, options);
        }
export type SubscriptionPlansQueryHookResult = ReturnType<typeof useSubscriptionPlansQuery>;
export type SubscriptionPlansLazyQueryHookResult = ReturnType<typeof useSubscriptionPlansLazyQuery>;
export type SubscriptionPlansSuspenseQueryHookResult = ReturnType<typeof useSubscriptionPlansSuspenseQuery>;
export type SubscriptionPlansQueryResult = ApolloReactCommon.QueryResult<SubscriptionPlansQuery, SubscriptionPlansQueryVariables>;
export const UpsertSweepDocument = gql`
    mutation upsertSweep($id: ID, $description: String, $state: String, $displayName: String, $config: String, $entityName: String, $projectName: String, $priorRunsFilters: JSONString, $launchScheduler: JSONString) {
  upsertSweep(
    input: {id: $id, description: $description, state: $state, displayName: $displayName, config: $config, entityName: $entityName, projectName: $projectName, priorRunsFilters: $priorRunsFilters, launchScheduler: $launchScheduler}
  ) {
    sweep {
      id
      name
      displayName
      description
      state
    }
    inserted
    insertedPriorRuns
  }
}
    `;
export type UpsertSweepMutationFn = ApolloReactCommon.MutationFunction<UpsertSweepMutation, UpsertSweepMutationVariables>;

/**
 * __useUpsertSweepMutation__
 *
 * To run a mutation, you first call `useUpsertSweepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSweepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSweepMutation, { data, loading, error }] = useUpsertSweepMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      state: // value for 'state'
 *      displayName: // value for 'displayName'
 *      config: // value for 'config'
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      priorRunsFilters: // value for 'priorRunsFilters'
 *      launchScheduler: // value for 'launchScheduler'
 *   },
 * });
 */
export function useUpsertSweepMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertSweepMutation, UpsertSweepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertSweepMutation, UpsertSweepMutationVariables>(UpsertSweepDocument, options);
      }
export type UpsertSweepMutationHookResult = ReturnType<typeof useUpsertSweepMutation>;
export type UpsertSweepMutationResult = ApolloReactCommon.MutationResult<UpsertSweepMutation>;
export type UpsertSweepMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertSweepMutation, UpsertSweepMutationVariables>;
export const DeleteSweepsDocument = gql`
    mutation deleteSweeps($ids: [ID!]!, $deleteRuns: Boolean!) {
  deleteSweeps(input: {ids: $ids, deleteRuns: $deleteRuns}) {
    affectedAgents
    affectedRuns
  }
}
    `;
export type DeleteSweepsMutationFn = ApolloReactCommon.MutationFunction<DeleteSweepsMutation, DeleteSweepsMutationVariables>;

/**
 * __useDeleteSweepsMutation__
 *
 * To run a mutation, you first call `useDeleteSweepsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSweepsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSweepsMutation, { data, loading, error }] = useDeleteSweepsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      deleteRuns: // value for 'deleteRuns'
 *   },
 * });
 */
export function useDeleteSweepsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteSweepsMutation, DeleteSweepsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteSweepsMutation, DeleteSweepsMutationVariables>(DeleteSweepsDocument, options);
      }
export type DeleteSweepsMutationHookResult = ReturnType<typeof useDeleteSweepsMutation>;
export type DeleteSweepsMutationResult = ApolloReactCommon.MutationResult<DeleteSweepsMutation>;
export type DeleteSweepsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteSweepsMutation, DeleteSweepsMutationVariables>;
export const GetTaskDocument = gql`
    query GetTask($id: ID!) {
  task(id: $id) {
    id
    name
    __typename
    state
    progress
    createdAt
    updatedAt
    type
    result
  }
}
    `;

/**
 * __useGetTaskQuery__
 *
 * To run a query within a React component, call `useGetTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaskQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTaskQuery, GetTaskQueryVariables> & ({ variables: GetTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
      }
export function useGetTaskLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
        }
// @ts-ignore
export function useGetTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetTaskQuery, GetTaskQueryVariables>;
export function useGetTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetTaskQuery | undefined, GetTaskQueryVariables>;
export function useGetTaskSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTaskQuery, GetTaskQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, options);
        }
export type GetTaskQueryHookResult = ReturnType<typeof useGetTaskQuery>;
export type GetTaskLazyQueryHookResult = ReturnType<typeof useGetTaskLazyQuery>;
export type GetTaskSuspenseQueryHookResult = ReturnType<typeof useGetTaskSuspenseQuery>;
export type GetTaskQueryResult = ApolloReactCommon.QueryResult<GetTaskQuery, GetTaskQueryVariables>;
export const EntityIsTeamDocument = gql`
    query EntityIsTeam($entityName: String) {
  entity(name: $entityName) {
    id
    isTeam
  }
}
    `;

/**
 * __useEntityIsTeamQuery__
 *
 * To run a query within a React component, call `useEntityIsTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityIsTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityIsTeamQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityIsTeamQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EntityIsTeamQuery, EntityIsTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityIsTeamQuery, EntityIsTeamQueryVariables>(EntityIsTeamDocument, options);
      }
export function useEntityIsTeamLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityIsTeamQuery, EntityIsTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityIsTeamQuery, EntityIsTeamQueryVariables>(EntityIsTeamDocument, options);
        }
// @ts-ignore
export function useEntityIsTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityIsTeamQuery, EntityIsTeamQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityIsTeamQuery, EntityIsTeamQueryVariables>;
export function useEntityIsTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityIsTeamQuery, EntityIsTeamQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityIsTeamQuery | undefined, EntityIsTeamQueryVariables>;
export function useEntityIsTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityIsTeamQuery, EntityIsTeamQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityIsTeamQuery, EntityIsTeamQueryVariables>(EntityIsTeamDocument, options);
        }
export type EntityIsTeamQueryHookResult = ReturnType<typeof useEntityIsTeamQuery>;
export type EntityIsTeamLazyQueryHookResult = ReturnType<typeof useEntityIsTeamLazyQuery>;
export type EntityIsTeamSuspenseQueryHookResult = ReturnType<typeof useEntityIsTeamSuspenseQuery>;
export type EntityIsTeamQueryResult = ApolloReactCommon.QueryResult<EntityIsTeamQuery, EntityIsTeamQueryVariables>;
export const BasicTeamOrganizationDocument = gql`
    query BasicTeamOrganization($entityName: String) {
  entity(name: $entityName) {
    id
    isTeam
    available
    organization {
      id
      name
    }
  }
}
    `;

/**
 * __useBasicTeamOrganizationQuery__
 *
 * To run a query within a React component, call `useBasicTeamOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBasicTeamOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBasicTeamOrganizationQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useBasicTeamOrganizationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>(BasicTeamOrganizationDocument, options);
      }
export function useBasicTeamOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>(BasicTeamOrganizationDocument, options);
        }
// @ts-ignore
export function useBasicTeamOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>;
export function useBasicTeamOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BasicTeamOrganizationQuery | undefined, BasicTeamOrganizationQueryVariables>;
export function useBasicTeamOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>(BasicTeamOrganizationDocument, options);
        }
export type BasicTeamOrganizationQueryHookResult = ReturnType<typeof useBasicTeamOrganizationQuery>;
export type BasicTeamOrganizationLazyQueryHookResult = ReturnType<typeof useBasicTeamOrganizationLazyQuery>;
export type BasicTeamOrganizationSuspenseQueryHookResult = ReturnType<typeof useBasicTeamOrganizationSuspenseQuery>;
export type BasicTeamOrganizationQueryResult = ApolloReactCommon.QueryResult<BasicTeamOrganizationQuery, BasicTeamOrganizationQueryVariables>;
export const TeamOrganizationDocument = gql`
    query TeamOrganization($entityName: String) {
  entity(name: $entityName) {
    id
    isTeam
    computeHours
    settings {
      openToMatchingOrgEmailDomainUsers
      membersCanInvite
      disableMagicLinkSharing
    }
    organization {
      id
      name
      flags
      usedSeats
      memberCount
      orgType
      roles {
        ID
        name
        description
        inheritedFrom {
          name
        }
      }
      members {
        ...OrgMemberFields
      }
      seatAvailability {
        seats
        viewOnlySeats
      }
      subscriptions {
        id
        plan {
          id
          name
          planType
          unitPrice
          billingInterval
          defaultPrivileges
          maxSeats
        }
        privileges
        subscriptionType
        billingPeriodStart
        billingPeriodEnd
        availableSeatsToPurchase
        seats
      }
    }
  }
}
    ${OrgMemberFieldsFragmentDoc}`;

/**
 * __useTeamOrganizationQuery__
 *
 * To run a query within a React component, call `useTeamOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamOrganizationQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useTeamOrganizationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamOrganizationQuery, TeamOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamOrganizationQuery, TeamOrganizationQueryVariables>(TeamOrganizationDocument, options);
      }
export function useTeamOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamOrganizationQuery, TeamOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamOrganizationQuery, TeamOrganizationQueryVariables>(TeamOrganizationDocument, options);
        }
// @ts-ignore
export function useTeamOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamOrganizationQuery, TeamOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamOrganizationQuery, TeamOrganizationQueryVariables>;
export function useTeamOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamOrganizationQuery, TeamOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamOrganizationQuery | undefined, TeamOrganizationQueryVariables>;
export function useTeamOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamOrganizationQuery, TeamOrganizationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamOrganizationQuery, TeamOrganizationQueryVariables>(TeamOrganizationDocument, options);
        }
export type TeamOrganizationQueryHookResult = ReturnType<typeof useTeamOrganizationQuery>;
export type TeamOrganizationLazyQueryHookResult = ReturnType<typeof useTeamOrganizationLazyQuery>;
export type TeamOrganizationSuspenseQueryHookResult = ReturnType<typeof useTeamOrganizationSuspenseQuery>;
export type TeamOrganizationQueryResult = ApolloReactCommon.QueryResult<TeamOrganizationQuery, TeamOrganizationQueryVariables>;
export const TeamMembersOrganizationDocument = gql`
    query TeamMembersOrganization($entityName: String) {
  entity(name: $entityName) {
    id
    organization {
      id
      members {
        ...TeamMembersOrgMemberFields
      }
    }
  }
}
    ${TeamMembersOrgMemberFieldsFragmentDoc}`;

/**
 * __useTeamMembersOrganizationQuery__
 *
 * To run a query within a React component, call `useTeamMembersOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMembersOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMembersOrganizationQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useTeamMembersOrganizationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamMembersOrganizationQuery, TeamMembersOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamMembersOrganizationQuery, TeamMembersOrganizationQueryVariables>(TeamMembersOrganizationDocument, options);
      }
export function useTeamMembersOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamMembersOrganizationQuery, TeamMembersOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamMembersOrganizationQuery, TeamMembersOrganizationQueryVariables>(TeamMembersOrganizationDocument, options);
        }
// @ts-ignore
export function useTeamMembersOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamMembersOrganizationQuery, TeamMembersOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamMembersOrganizationQuery, TeamMembersOrganizationQueryVariables>;
export function useTeamMembersOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamMembersOrganizationQuery, TeamMembersOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamMembersOrganizationQuery | undefined, TeamMembersOrganizationQueryVariables>;
export function useTeamMembersOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamMembersOrganizationQuery, TeamMembersOrganizationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamMembersOrganizationQuery, TeamMembersOrganizationQueryVariables>(TeamMembersOrganizationDocument, options);
        }
export type TeamMembersOrganizationQueryHookResult = ReturnType<typeof useTeamMembersOrganizationQuery>;
export type TeamMembersOrganizationLazyQueryHookResult = ReturnType<typeof useTeamMembersOrganizationLazyQuery>;
export type TeamMembersOrganizationSuspenseQueryHookResult = ReturnType<typeof useTeamMembersOrganizationSuspenseQuery>;
export type TeamMembersOrganizationQueryResult = ApolloReactCommon.QueryResult<TeamMembersOrganizationQuery, TeamMembersOrganizationQueryVariables>;
export const TeamOrganizationRolesDocument = gql`
    query TeamOrganizationRoles($entityName: String) {
  entity(name: $entityName) {
    id
    settings {
      membersCanInvite
    }
    members {
      id
      username
      role
    }
    organization {
      id
      seatAvailability {
        viewOnlySeats
      }
      roles {
        ID
        name
        description
        inheritedFrom {
          name
        }
      }
      members {
        id
        username
        role
      }
    }
  }
}
    `;

/**
 * __useTeamOrganizationRolesQuery__
 *
 * To run a query within a React component, call `useTeamOrganizationRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamOrganizationRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamOrganizationRolesQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useTeamOrganizationRolesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>(TeamOrganizationRolesDocument, options);
      }
export function useTeamOrganizationRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>(TeamOrganizationRolesDocument, options);
        }
// @ts-ignore
export function useTeamOrganizationRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>;
export function useTeamOrganizationRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamOrganizationRolesQuery | undefined, TeamOrganizationRolesQueryVariables>;
export function useTeamOrganizationRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>(TeamOrganizationRolesDocument, options);
        }
export type TeamOrganizationRolesQueryHookResult = ReturnType<typeof useTeamOrganizationRolesQuery>;
export type TeamOrganizationRolesLazyQueryHookResult = ReturnType<typeof useTeamOrganizationRolesLazyQuery>;
export type TeamOrganizationRolesSuspenseQueryHookResult = ReturnType<typeof useTeamOrganizationRolesSuspenseQuery>;
export type TeamOrganizationRolesQueryResult = ApolloReactCommon.QueryResult<TeamOrganizationRolesQuery, TeamOrganizationRolesQueryVariables>;
export const TeamOrganizationMembersDocument = gql`
    query TeamOrganizationMembers($entityName: String) {
  entity(name: $entityName) {
    id
    isTeam
    organizationId
  }
}
    `;

/**
 * __useTeamOrganizationMembersQuery__
 *
 * To run a query within a React component, call `useTeamOrganizationMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamOrganizationMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamOrganizationMembersQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useTeamOrganizationMembersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>(TeamOrganizationMembersDocument, options);
      }
export function useTeamOrganizationMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>(TeamOrganizationMembersDocument, options);
        }
// @ts-ignore
export function useTeamOrganizationMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>;
export function useTeamOrganizationMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamOrganizationMembersQuery | undefined, TeamOrganizationMembersQueryVariables>;
export function useTeamOrganizationMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>(TeamOrganizationMembersDocument, options);
        }
export type TeamOrganizationMembersQueryHookResult = ReturnType<typeof useTeamOrganizationMembersQuery>;
export type TeamOrganizationMembersLazyQueryHookResult = ReturnType<typeof useTeamOrganizationMembersLazyQuery>;
export type TeamOrganizationMembersSuspenseQueryHookResult = ReturnType<typeof useTeamOrganizationMembersSuspenseQuery>;
export type TeamOrganizationMembersQueryResult = ApolloReactCommon.QueryResult<TeamOrganizationMembersQuery, TeamOrganizationMembersQueryVariables>;
export const TeamPageProjectsTwoDocument = gql`
    query TeamPageProjectsTwo($entityName: String!, $first: Int = 10) {
  entity(name: $entityName) {
    id
    organizationId
    projects(order: "-created_at", first: $first) {
      edges {
        node {
          id
          name
          entityName
          description
          totalRuns
          lastActive
        }
      }
    }
  }
}
    `;

/**
 * __useTeamPageProjectsTwoQuery__
 *
 * To run a query within a React component, call `useTeamPageProjectsTwoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamPageProjectsTwoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamPageProjectsTwoQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useTeamPageProjectsTwoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables> & ({ variables: TeamPageProjectsTwoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables>(TeamPageProjectsTwoDocument, options);
      }
export function useTeamPageProjectsTwoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables>(TeamPageProjectsTwoDocument, options);
        }
// @ts-ignore
export function useTeamPageProjectsTwoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables>;
export function useTeamPageProjectsTwoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamPageProjectsTwoQuery | undefined, TeamPageProjectsTwoQueryVariables>;
export function useTeamPageProjectsTwoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables>(TeamPageProjectsTwoDocument, options);
        }
export type TeamPageProjectsTwoQueryHookResult = ReturnType<typeof useTeamPageProjectsTwoQuery>;
export type TeamPageProjectsTwoLazyQueryHookResult = ReturnType<typeof useTeamPageProjectsTwoLazyQuery>;
export type TeamPageProjectsTwoSuspenseQueryHookResult = ReturnType<typeof useTeamPageProjectsTwoSuspenseQuery>;
export type TeamPageProjectsTwoQueryResult = ApolloReactCommon.QueryResult<TeamPageProjectsTwoQuery, TeamPageProjectsTwoQueryVariables>;
export const TeamPageProjectsDocument = gql`
    query TeamPageProjects($entityName: String!) {
  entity(name: $entityName) {
    id
    organizationId
    projects(order: "-created_at", first: 100) {
      edges {
        node {
          id
          name
          entityName
          access
        }
      }
    }
  }
}
    `;

/**
 * __useTeamPageProjectsQuery__
 *
 * To run a query within a React component, call `useTeamPageProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamPageProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamPageProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useTeamPageProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamPageProjectsQuery, TeamPageProjectsQueryVariables> & ({ variables: TeamPageProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamPageProjectsQuery, TeamPageProjectsQueryVariables>(TeamPageProjectsDocument, options);
      }
export function useTeamPageProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamPageProjectsQuery, TeamPageProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamPageProjectsQuery, TeamPageProjectsQueryVariables>(TeamPageProjectsDocument, options);
        }
// @ts-ignore
export function useTeamPageProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamPageProjectsQuery, TeamPageProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamPageProjectsQuery, TeamPageProjectsQueryVariables>;
export function useTeamPageProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamPageProjectsQuery, TeamPageProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamPageProjectsQuery | undefined, TeamPageProjectsQueryVariables>;
export function useTeamPageProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamPageProjectsQuery, TeamPageProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamPageProjectsQuery, TeamPageProjectsQueryVariables>(TeamPageProjectsDocument, options);
        }
export type TeamPageProjectsQueryHookResult = ReturnType<typeof useTeamPageProjectsQuery>;
export type TeamPageProjectsLazyQueryHookResult = ReturnType<typeof useTeamPageProjectsLazyQuery>;
export type TeamPageProjectsSuspenseQueryHookResult = ReturnType<typeof useTeamPageProjectsSuspenseQuery>;
export type TeamPageProjectsQueryResult = ApolloReactCommon.QueryResult<TeamPageProjectsQuery, TeamPageProjectsQueryVariables>;
export const TeamPageReportsDocument = gql`
    query TeamPageReports($entityName: String!, $first: Int = 100, $offset: Int = 0, $displayNameContains: String) {
  entity(name: $entityName) {
    id
    views(first: $first, offset: $offset, displayNameContains: $displayNameContains) {
      totalCount
      edges {
        node {
          id
          ...ReportsTableFragment
        }
      }
    }
  }
}
    ${ReportsTableFragmentFragmentDoc}`;

/**
 * __useTeamPageReportsQuery__
 *
 * To run a query within a React component, call `useTeamPageReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamPageReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamPageReportsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *      displayNameContains: // value for 'displayNameContains'
 *   },
 * });
 */
export function useTeamPageReportsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamPageReportsQuery, TeamPageReportsQueryVariables> & ({ variables: TeamPageReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamPageReportsQuery, TeamPageReportsQueryVariables>(TeamPageReportsDocument, options);
      }
export function useTeamPageReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamPageReportsQuery, TeamPageReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamPageReportsQuery, TeamPageReportsQueryVariables>(TeamPageReportsDocument, options);
        }
// @ts-ignore
export function useTeamPageReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamPageReportsQuery, TeamPageReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamPageReportsQuery, TeamPageReportsQueryVariables>;
export function useTeamPageReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamPageReportsQuery, TeamPageReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamPageReportsQuery | undefined, TeamPageReportsQueryVariables>;
export function useTeamPageReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamPageReportsQuery, TeamPageReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamPageReportsQuery, TeamPageReportsQueryVariables>(TeamPageReportsDocument, options);
        }
export type TeamPageReportsQueryHookResult = ReturnType<typeof useTeamPageReportsQuery>;
export type TeamPageReportsLazyQueryHookResult = ReturnType<typeof useTeamPageReportsLazyQuery>;
export type TeamPageReportsSuspenseQueryHookResult = ReturnType<typeof useTeamPageReportsSuspenseQuery>;
export type TeamPageReportsQueryResult = ApolloReactCommon.QueryResult<TeamPageReportsQuery, TeamPageReportsQueryVariables>;
export const FetchTeamProfilePageProjectsByIDsDocument = gql`
    query FetchTeamProfilePageProjectsByIDs($entityName: String!, $projectIDs: [ID!]!) {
  projects(entityName: $entityName, projectIDs: $projectIDs) {
    edges {
      node {
        id
        name
        entityName
        access
        lastActive
        runCount
        user {
          id
          username
        }
      }
    }
  }
}
    `;

/**
 * __useFetchTeamProfilePageProjectsByIDsQuery__
 *
 * To run a query within a React component, call `useFetchTeamProfilePageProjectsByIDsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTeamProfilePageProjectsByIDsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTeamProfilePageProjectsByIDsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectIDs: // value for 'projectIDs'
 *   },
 * });
 */
export function useFetchTeamProfilePageProjectsByIDsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables> & ({ variables: FetchTeamProfilePageProjectsByIDsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables>(FetchTeamProfilePageProjectsByIDsDocument, options);
      }
export function useFetchTeamProfilePageProjectsByIDsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables>(FetchTeamProfilePageProjectsByIDsDocument, options);
        }
// @ts-ignore
export function useFetchTeamProfilePageProjectsByIDsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables>;
export function useFetchTeamProfilePageProjectsByIDsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchTeamProfilePageProjectsByIDsQuery | undefined, FetchTeamProfilePageProjectsByIDsQueryVariables>;
export function useFetchTeamProfilePageProjectsByIDsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables>(FetchTeamProfilePageProjectsByIDsDocument, options);
        }
export type FetchTeamProfilePageProjectsByIDsQueryHookResult = ReturnType<typeof useFetchTeamProfilePageProjectsByIDsQuery>;
export type FetchTeamProfilePageProjectsByIDsLazyQueryHookResult = ReturnType<typeof useFetchTeamProfilePageProjectsByIDsLazyQuery>;
export type FetchTeamProfilePageProjectsByIDsSuspenseQueryHookResult = ReturnType<typeof useFetchTeamProfilePageProjectsByIDsSuspenseQuery>;
export type FetchTeamProfilePageProjectsByIDsQueryResult = ApolloReactCommon.QueryResult<FetchTeamProfilePageProjectsByIDsQuery, FetchTeamProfilePageProjectsByIDsQueryVariables>;
export const TeamPageDocument = gql`
    query TeamPage($entityName: String!, $workflowsAdminType: WorkflowsAdminType!) {
  entity(name: $entityName) {
    available
    claimingEntity {
      id
      name
    }
    id
    isTeam
    members {
      id
      admin
      pending
      email
      username
      name
      photoUrl
      accountType
      apiKeyCount
      role
      memberRole {
        ID
        name
      }
      serviceAccountAuthMethod
    }
    memberCount
    name
    organizationId
    invites {
      edges {
        node {
          id
          email
          fromUser {
            id
            username
          }
        }
      }
    }
    photoUrl
    projects(first: 1) {
      edges {
        node {
          id
        }
      }
    }
    projectCount
    readOnly
    workflowsAdmins(adminType: $workflowsAdminType) {
      id
      username
      name
      email
    }
    publicQueueLaunchAgents {
      id
      username
      name
      email
    }
    protectedAliases(adminType: $workflowsAdminType)
  }
}
    `;

/**
 * __useTeamPageQuery__
 *
 * To run a query within a React component, call `useTeamPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamPageQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      workflowsAdminType: // value for 'workflowsAdminType'
 *   },
 * });
 */
export function useTeamPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamPageQuery, TeamPageQueryVariables> & ({ variables: TeamPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamPageQuery, TeamPageQueryVariables>(TeamPageDocument, options);
      }
export function useTeamPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamPageQuery, TeamPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamPageQuery, TeamPageQueryVariables>(TeamPageDocument, options);
        }
// @ts-ignore
export function useTeamPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamPageQuery, TeamPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamPageQuery, TeamPageQueryVariables>;
export function useTeamPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamPageQuery, TeamPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamPageQuery | undefined, TeamPageQueryVariables>;
export function useTeamPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamPageQuery, TeamPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamPageQuery, TeamPageQueryVariables>(TeamPageDocument, options);
        }
export type TeamPageQueryHookResult = ReturnType<typeof useTeamPageQuery>;
export type TeamPageLazyQueryHookResult = ReturnType<typeof useTeamPageLazyQuery>;
export type TeamPageSuspenseQueryHookResult = ReturnType<typeof useTeamPageSuspenseQuery>;
export type TeamPageQueryResult = ApolloReactCommon.QueryResult<TeamPageQuery, TeamPageQueryVariables>;
export const AvailableTeamDocument = gql`
    query availableTeam($teamName: String!) {
  entity(name: $teamName) {
    id
    available
  }
}
    `;

/**
 * __useAvailableTeamQuery__
 *
 * To run a query within a React component, call `useAvailableTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableTeamQuery({
 *   variables: {
 *      teamName: // value for 'teamName'
 *   },
 * });
 */
export function useAvailableTeamQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AvailableTeamQuery, AvailableTeamQueryVariables> & ({ variables: AvailableTeamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AvailableTeamQuery, AvailableTeamQueryVariables>(AvailableTeamDocument, options);
      }
export function useAvailableTeamLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AvailableTeamQuery, AvailableTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AvailableTeamQuery, AvailableTeamQueryVariables>(AvailableTeamDocument, options);
        }
// @ts-ignore
export function useAvailableTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AvailableTeamQuery, AvailableTeamQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AvailableTeamQuery, AvailableTeamQueryVariables>;
export function useAvailableTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableTeamQuery, AvailableTeamQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AvailableTeamQuery | undefined, AvailableTeamQueryVariables>;
export function useAvailableTeamSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableTeamQuery, AvailableTeamQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AvailableTeamQuery, AvailableTeamQueryVariables>(AvailableTeamDocument, options);
        }
export type AvailableTeamQueryHookResult = ReturnType<typeof useAvailableTeamQuery>;
export type AvailableTeamLazyQueryHookResult = ReturnType<typeof useAvailableTeamLazyQuery>;
export type AvailableTeamSuspenseQueryHookResult = ReturnType<typeof useAvailableTeamSuspenseQuery>;
export type AvailableTeamQueryResult = ApolloReactCommon.QueryResult<AvailableTeamQuery, AvailableTeamQueryVariables>;
export const AvailableOrgDocument = gql`
    query availableOrg($name: String!) {
  organization(name: $name) {
    id
    available
  }
}
    `;

/**
 * __useAvailableOrgQuery__
 *
 * To run a query within a React component, call `useAvailableOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableOrgQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAvailableOrgQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AvailableOrgQuery, AvailableOrgQueryVariables> & ({ variables: AvailableOrgQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AvailableOrgQuery, AvailableOrgQueryVariables>(AvailableOrgDocument, options);
      }
export function useAvailableOrgLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AvailableOrgQuery, AvailableOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AvailableOrgQuery, AvailableOrgQueryVariables>(AvailableOrgDocument, options);
        }
// @ts-ignore
export function useAvailableOrgSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AvailableOrgQuery, AvailableOrgQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AvailableOrgQuery, AvailableOrgQueryVariables>;
export function useAvailableOrgSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableOrgQuery, AvailableOrgQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AvailableOrgQuery | undefined, AvailableOrgQueryVariables>;
export function useAvailableOrgSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AvailableOrgQuery, AvailableOrgQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AvailableOrgQuery, AvailableOrgQueryVariables>(AvailableOrgDocument, options);
        }
export type AvailableOrgQueryHookResult = ReturnType<typeof useAvailableOrgQuery>;
export type AvailableOrgLazyQueryHookResult = ReturnType<typeof useAvailableOrgLazyQuery>;
export type AvailableOrgSuspenseQueryHookResult = ReturnType<typeof useAvailableOrgSuspenseQuery>;
export type AvailableOrgQueryResult = ApolloReactCommon.QueryResult<AvailableOrgQuery, AvailableOrgQueryVariables>;
export const OrganizationStorageBucketInfosDocument = gql`
    query organizationStorageBucketInfos($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    teams {
      id
      settings {
        storageBucketInfo {
          ID
          provider
          name
          kmsKeyID
          awsExternalID
          path
        }
      }
    }
  }
}
    `;

/**
 * __useOrganizationStorageBucketInfosQuery__
 *
 * To run a query within a React component, call `useOrganizationStorageBucketInfosQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationStorageBucketInfosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationStorageBucketInfosQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationStorageBucketInfosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables> & ({ variables: OrganizationStorageBucketInfosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables>(OrganizationStorageBucketInfosDocument, options);
      }
export function useOrganizationStorageBucketInfosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables>(OrganizationStorageBucketInfosDocument, options);
        }
// @ts-ignore
export function useOrganizationStorageBucketInfosSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables>;
export function useOrganizationStorageBucketInfosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationStorageBucketInfosQuery | undefined, OrganizationStorageBucketInfosQueryVariables>;
export function useOrganizationStorageBucketInfosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables>(OrganizationStorageBucketInfosDocument, options);
        }
export type OrganizationStorageBucketInfosQueryHookResult = ReturnType<typeof useOrganizationStorageBucketInfosQuery>;
export type OrganizationStorageBucketInfosLazyQueryHookResult = ReturnType<typeof useOrganizationStorageBucketInfosLazyQuery>;
export type OrganizationStorageBucketInfosSuspenseQueryHookResult = ReturnType<typeof useOrganizationStorageBucketInfosSuspenseQuery>;
export type OrganizationStorageBucketInfosQueryResult = ApolloReactCommon.QueryResult<OrganizationStorageBucketInfosQuery, OrganizationStorageBucketInfosQueryVariables>;
export const StorageBucketInfosDocument = gql`
    query storageBucketInfos {
  entities {
    edges {
      node {
        id
        settings {
          storageBucketInfo {
            ID
            provider
            name
            kmsKeyID
            awsExternalID
            path
          }
        }
      }
    }
  }
}
    `;

/**
 * __useStorageBucketInfosQuery__
 *
 * To run a query within a React component, call `useStorageBucketInfosQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorageBucketInfosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorageBucketInfosQuery({
 *   variables: {
 *   },
 * });
 */
export function useStorageBucketInfosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>(StorageBucketInfosDocument, options);
      }
export function useStorageBucketInfosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>(StorageBucketInfosDocument, options);
        }
// @ts-ignore
export function useStorageBucketInfosSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>;
export function useStorageBucketInfosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StorageBucketInfosQuery | undefined, StorageBucketInfosQueryVariables>;
export function useStorageBucketInfosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>(StorageBucketInfosDocument, options);
        }
export type StorageBucketInfosQueryHookResult = ReturnType<typeof useStorageBucketInfosQuery>;
export type StorageBucketInfosLazyQueryHookResult = ReturnType<typeof useStorageBucketInfosLazyQuery>;
export type StorageBucketInfosSuspenseQueryHookResult = ReturnType<typeof useStorageBucketInfosSuspenseQuery>;
export type StorageBucketInfosQueryResult = ApolloReactCommon.QueryResult<StorageBucketInfosQuery, StorageBucketInfosQueryVariables>;
export const CreateTeamDocument = gql`
    mutation createTeam($teamName: String!, $organizationId: String, $teamAdminUserName: String, $storageBucketInfo: StorageBucketInfoInput) {
  createTeam(
    input: {teamName: $teamName, organizationId: $organizationId, teamAdminUserName: $teamAdminUserName, storageBucketInfo: $storageBucketInfo}
  ) {
    entity {
      id
      name
      available
      photoUrl
      limits
    }
  }
}
    `;
export type CreateTeamMutationFn = ApolloReactCommon.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      teamName: // value for 'teamName'
 *      organizationId: // value for 'organizationId'
 *      teamAdminUserName: // value for 'teamAdminUserName'
 *      storageBucketInfo: // value for 'storageBucketInfo'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = ApolloReactCommon.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const TestBucketStoreConnectionDocument = gql`
    mutation testBucketStoreConnection($input: StorageBucketInfoInput!) {
  testBucketStoreConnection(input: $input) {
    message
    severity
  }
}
    `;
export type TestBucketStoreConnectionMutationFn = ApolloReactCommon.MutationFunction<TestBucketStoreConnectionMutation, TestBucketStoreConnectionMutationVariables>;

/**
 * __useTestBucketStoreConnectionMutation__
 *
 * To run a mutation, you first call `useTestBucketStoreConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestBucketStoreConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testBucketStoreConnectionMutation, { data, loading, error }] = useTestBucketStoreConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTestBucketStoreConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TestBucketStoreConnectionMutation, TestBucketStoreConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TestBucketStoreConnectionMutation, TestBucketStoreConnectionMutationVariables>(TestBucketStoreConnectionDocument, options);
      }
export type TestBucketStoreConnectionMutationHookResult = ReturnType<typeof useTestBucketStoreConnectionMutation>;
export type TestBucketStoreConnectionMutationResult = ApolloReactCommon.MutationResult<TestBucketStoreConnectionMutation>;
export type TestBucketStoreConnectionMutationOptions = ApolloReactCommon.BaseMutationOptions<TestBucketStoreConnectionMutation, TestBucketStoreConnectionMutationVariables>;
export const TestReferenceBucketConnectionDocument = gql`
    mutation testReferenceBucketConnection($input: TestReferenceBucketConnectionInput!) {
  testReferenceBucketConnection(input: $input) {
    message
    severity
  }
}
    `;
export type TestReferenceBucketConnectionMutationFn = ApolloReactCommon.MutationFunction<TestReferenceBucketConnectionMutation, TestReferenceBucketConnectionMutationVariables>;

/**
 * __useTestReferenceBucketConnectionMutation__
 *
 * To run a mutation, you first call `useTestReferenceBucketConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestReferenceBucketConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testReferenceBucketConnectionMutation, { data, loading, error }] = useTestReferenceBucketConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTestReferenceBucketConnectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TestReferenceBucketConnectionMutation, TestReferenceBucketConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TestReferenceBucketConnectionMutation, TestReferenceBucketConnectionMutationVariables>(TestReferenceBucketConnectionDocument, options);
      }
export type TestReferenceBucketConnectionMutationHookResult = ReturnType<typeof useTestReferenceBucketConnectionMutation>;
export type TestReferenceBucketConnectionMutationResult = ApolloReactCommon.MutationResult<TestReferenceBucketConnectionMutation>;
export type TestReferenceBucketConnectionMutationOptions = ApolloReactCommon.BaseMutationOptions<TestReferenceBucketConnectionMutation, TestReferenceBucketConnectionMutationVariables>;
export const AddReferenceBucketToTeamDocument = gql`
    mutation addReferenceBucketToTeam($input: AddReferenceBucketToTeamInput!) {
  addReferenceBucketToTeam(input: $input) {
    success
    bucketStoreID
    entity {
      id
      name
    }
    clientMutationID
  }
}
    `;
export type AddReferenceBucketToTeamMutationFn = ApolloReactCommon.MutationFunction<AddReferenceBucketToTeamMutation, AddReferenceBucketToTeamMutationVariables>;

/**
 * __useAddReferenceBucketToTeamMutation__
 *
 * To run a mutation, you first call `useAddReferenceBucketToTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReferenceBucketToTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReferenceBucketToTeamMutation, { data, loading, error }] = useAddReferenceBucketToTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddReferenceBucketToTeamMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddReferenceBucketToTeamMutation, AddReferenceBucketToTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddReferenceBucketToTeamMutation, AddReferenceBucketToTeamMutationVariables>(AddReferenceBucketToTeamDocument, options);
      }
export type AddReferenceBucketToTeamMutationHookResult = ReturnType<typeof useAddReferenceBucketToTeamMutation>;
export type AddReferenceBucketToTeamMutationResult = ApolloReactCommon.MutationResult<AddReferenceBucketToTeamMutation>;
export type AddReferenceBucketToTeamMutationOptions = ApolloReactCommon.BaseMutationOptions<AddReferenceBucketToTeamMutation, AddReferenceBucketToTeamMutationVariables>;
export const DeleteTeamDocument = gql`
    mutation deleteTeam($teamName: String!) {
  deleteTeam(input: {teamName: $teamName}) {
    success
  }
}
    `;
export type DeleteTeamMutationFn = ApolloReactCommon.MutationFunction<DeleteTeamMutation, DeleteTeamMutationVariables>;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      teamName: // value for 'teamName'
 *   },
 * });
 */
export function useDeleteTeamMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTeamMutation, DeleteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, options);
      }
export type DeleteTeamMutationHookResult = ReturnType<typeof useDeleteTeamMutation>;
export type DeleteTeamMutationResult = ApolloReactCommon.MutationResult<DeleteTeamMutation>;
export type DeleteTeamMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const EntityFeatureFlagsDocument = gql`
    query entityFeatureFlags($teamName: String, $rampIDType: RampIDType!) {
  entity(name: $teamName) {
    id
    featureFlags(rampIDType: $rampIDType) {
      rampKey
      isEnabled
    }
  }
}
    `;

/**
 * __useEntityFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useEntityFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityFeatureFlagsQuery({
 *   variables: {
 *      teamName: // value for 'teamName'
 *      rampIDType: // value for 'rampIDType'
 *   },
 * });
 */
export function useEntityFeatureFlagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables> & ({ variables: EntityFeatureFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables>(EntityFeatureFlagsDocument, options);
      }
export function useEntityFeatureFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables>(EntityFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useEntityFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables>;
export function useEntityFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityFeatureFlagsQuery | undefined, EntityFeatureFlagsQueryVariables>;
export function useEntityFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables>(EntityFeatureFlagsDocument, options);
        }
export type EntityFeatureFlagsQueryHookResult = ReturnType<typeof useEntityFeatureFlagsQuery>;
export type EntityFeatureFlagsLazyQueryHookResult = ReturnType<typeof useEntityFeatureFlagsLazyQuery>;
export type EntityFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useEntityFeatureFlagsSuspenseQuery>;
export type EntityFeatureFlagsQueryResult = ApolloReactCommon.QueryResult<EntityFeatureFlagsQuery, EntityFeatureFlagsQueryVariables>;
export const OrganizationTeamsDocument = gql`
    query organizationTeams($orgName: String!) {
  organization(name: $orgName) {
    id
    teams {
      id
      name
      memberCount
      computeHours
    }
    subscriptions {
      id
      privileges
    }
    members {
      orgID
      id
      username
      role
      user {
        id
        name
        accountType
        ...UserRoleFragment
        teams {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
}
    ${UserRoleFragmentFragmentDoc}`;

/**
 * __useOrganizationTeamsQuery__
 *
 * To run a query within a React component, call `useOrganizationTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationTeamsQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationTeamsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationTeamsQuery, OrganizationTeamsQueryVariables> & ({ variables: OrganizationTeamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>(OrganizationTeamsDocument, options);
      }
export function useOrganizationTeamsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>(OrganizationTeamsDocument, options);
        }
// @ts-ignore
export function useOrganizationTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>;
export function useOrganizationTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationTeamsQuery | undefined, OrganizationTeamsQueryVariables>;
export function useOrganizationTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>(OrganizationTeamsDocument, options);
        }
export type OrganizationTeamsQueryHookResult = ReturnType<typeof useOrganizationTeamsQuery>;
export type OrganizationTeamsLazyQueryHookResult = ReturnType<typeof useOrganizationTeamsLazyQuery>;
export type OrganizationTeamsSuspenseQueryHookResult = ReturnType<typeof useOrganizationTeamsSuspenseQuery>;
export type OrganizationTeamsQueryResult = ApolloReactCommon.QueryResult<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>;
export const EntityOrganizationDocument = gql`
    query entityOrganization($teamName: String!) {
  entity(name: $teamName) {
    id
    organization {
      id
      name
    }
  }
}
    `;

/**
 * __useEntityOrganizationQuery__
 *
 * To run a query within a React component, call `useEntityOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityOrganizationQuery({
 *   variables: {
 *      teamName: // value for 'teamName'
 *   },
 * });
 */
export function useEntityOrganizationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityOrganizationQuery, EntityOrganizationQueryVariables> & ({ variables: EntityOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityOrganizationQuery, EntityOrganizationQueryVariables>(EntityOrganizationDocument, options);
      }
export function useEntityOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityOrganizationQuery, EntityOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityOrganizationQuery, EntityOrganizationQueryVariables>(EntityOrganizationDocument, options);
        }
// @ts-ignore
export function useEntityOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityOrganizationQuery, EntityOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityOrganizationQuery, EntityOrganizationQueryVariables>;
export function useEntityOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityOrganizationQuery, EntityOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityOrganizationQuery | undefined, EntityOrganizationQueryVariables>;
export function useEntityOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityOrganizationQuery, EntityOrganizationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityOrganizationQuery, EntityOrganizationQueryVariables>(EntityOrganizationDocument, options);
        }
export type EntityOrganizationQueryHookResult = ReturnType<typeof useEntityOrganizationQuery>;
export type EntityOrganizationLazyQueryHookResult = ReturnType<typeof useEntityOrganizationLazyQuery>;
export type EntityOrganizationSuspenseQueryHookResult = ReturnType<typeof useEntityOrganizationSuspenseQuery>;
export type EntityOrganizationQueryResult = ApolloReactCommon.QueryResult<EntityOrganizationQuery, EntityOrganizationQueryVariables>;
export const CreateUserLevelSlackIntegrationDocument = gql`
    mutation CreateUserLevelSlackIntegration($code: String!, $redirectURI: String!) {
  createUserLevelSlackIntegration(input: {code: $code, redirectURI: $redirectURI}) {
    user {
      id
      userLevelAlertPreferences {
        ...UserLevelAlertPreferencesFields
      }
    }
  }
}
    ${UserLevelAlertPreferencesFieldsFragmentDoc}`;
export type CreateUserLevelSlackIntegrationMutationFn = ApolloReactCommon.MutationFunction<CreateUserLevelSlackIntegrationMutation, CreateUserLevelSlackIntegrationMutationVariables>;

/**
 * __useCreateUserLevelSlackIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateUserLevelSlackIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserLevelSlackIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserLevelSlackIntegrationMutation, { data, loading, error }] = useCreateUserLevelSlackIntegrationMutation({
 *   variables: {
 *      code: // value for 'code'
 *      redirectURI: // value for 'redirectURI'
 *   },
 * });
 */
export function useCreateUserLevelSlackIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserLevelSlackIntegrationMutation, CreateUserLevelSlackIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserLevelSlackIntegrationMutation, CreateUserLevelSlackIntegrationMutationVariables>(CreateUserLevelSlackIntegrationDocument, options);
      }
export type CreateUserLevelSlackIntegrationMutationHookResult = ReturnType<typeof useCreateUserLevelSlackIntegrationMutation>;
export type CreateUserLevelSlackIntegrationMutationResult = ApolloReactCommon.MutationResult<CreateUserLevelSlackIntegrationMutation>;
export type CreateUserLevelSlackIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateUserLevelSlackIntegrationMutation, CreateUserLevelSlackIntegrationMutationVariables>;
export const DeleteUserLevelSlackIntegrationDocument = gql`
    mutation DeleteUserLevelSlackIntegration($integrationID: ID!) {
  deleteUserLevelSlackIntegration(input: {integrationID: $integrationID}) {
    user {
      id
      userLevelAlertPreferences {
        ...UserLevelAlertPreferencesFields
      }
    }
  }
}
    ${UserLevelAlertPreferencesFieldsFragmentDoc}`;
export type DeleteUserLevelSlackIntegrationMutationFn = ApolloReactCommon.MutationFunction<DeleteUserLevelSlackIntegrationMutation, DeleteUserLevelSlackIntegrationMutationVariables>;

/**
 * __useDeleteUserLevelSlackIntegrationMutation__
 *
 * To run a mutation, you first call `useDeleteUserLevelSlackIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserLevelSlackIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserLevelSlackIntegrationMutation, { data, loading, error }] = useDeleteUserLevelSlackIntegrationMutation({
 *   variables: {
 *      integrationID: // value for 'integrationID'
 *   },
 * });
 */
export function useDeleteUserLevelSlackIntegrationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserLevelSlackIntegrationMutation, DeleteUserLevelSlackIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserLevelSlackIntegrationMutation, DeleteUserLevelSlackIntegrationMutationVariables>(DeleteUserLevelSlackIntegrationDocument, options);
      }
export type DeleteUserLevelSlackIntegrationMutationHookResult = ReturnType<typeof useDeleteUserLevelSlackIntegrationMutation>;
export type DeleteUserLevelSlackIntegrationMutationResult = ApolloReactCommon.MutationResult<DeleteUserLevelSlackIntegrationMutation>;
export type DeleteUserLevelSlackIntegrationMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteUserLevelSlackIntegrationMutation, DeleteUserLevelSlackIntegrationMutationVariables>;
export const UpdateUserLevelAlertPreferencesDocument = gql`
    mutation UpdateUserLevelAlertPreferences($input: UpdateUserLevelAlertPreferencesInput!) {
  updateUserLevelAlertPreferences(input: $input) {
    user {
      id
      userLevelAlertPreferences {
        ...UserLevelAlertPreferencesFields
      }
    }
  }
}
    ${UserLevelAlertPreferencesFieldsFragmentDoc}`;
export type UpdateUserLevelAlertPreferencesMutationFn = ApolloReactCommon.MutationFunction<UpdateUserLevelAlertPreferencesMutation, UpdateUserLevelAlertPreferencesMutationVariables>;

/**
 * __useUpdateUserLevelAlertPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateUserLevelAlertPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserLevelAlertPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserLevelAlertPreferencesMutation, { data, loading, error }] = useUpdateUserLevelAlertPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserLevelAlertPreferencesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserLevelAlertPreferencesMutation, UpdateUserLevelAlertPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserLevelAlertPreferencesMutation, UpdateUserLevelAlertPreferencesMutationVariables>(UpdateUserLevelAlertPreferencesDocument, options);
      }
export type UpdateUserLevelAlertPreferencesMutationHookResult = ReturnType<typeof useUpdateUserLevelAlertPreferencesMutation>;
export type UpdateUserLevelAlertPreferencesMutationResult = ApolloReactCommon.MutationResult<UpdateUserLevelAlertPreferencesMutation>;
export type UpdateUserLevelAlertPreferencesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserLevelAlertPreferencesMutation, UpdateUserLevelAlertPreferencesMutationVariables>;
export const ViewerUserLevelAlertPreferencesDocument = gql`
    query ViewerUserLevelAlertPreferences {
  viewer {
    id
    userLevelAlertPreferences {
      ...UserLevelAlertPreferencesFields
    }
  }
}
    ${UserLevelAlertPreferencesFieldsFragmentDoc}`;

/**
 * __useViewerUserLevelAlertPreferencesQuery__
 *
 * To run a query within a React component, call `useViewerUserLevelAlertPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerUserLevelAlertPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerUserLevelAlertPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerUserLevelAlertPreferencesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerUserLevelAlertPreferencesQuery, ViewerUserLevelAlertPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerUserLevelAlertPreferencesQuery, ViewerUserLevelAlertPreferencesQueryVariables>(ViewerUserLevelAlertPreferencesDocument, options);
      }
export function useViewerUserLevelAlertPreferencesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerUserLevelAlertPreferencesQuery, ViewerUserLevelAlertPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerUserLevelAlertPreferencesQuery, ViewerUserLevelAlertPreferencesQueryVariables>(ViewerUserLevelAlertPreferencesDocument, options);
        }
// @ts-ignore
export function useViewerUserLevelAlertPreferencesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerUserLevelAlertPreferencesQuery, ViewerUserLevelAlertPreferencesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerUserLevelAlertPreferencesQuery, ViewerUserLevelAlertPreferencesQueryVariables>;
export function useViewerUserLevelAlertPreferencesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerUserLevelAlertPreferencesQuery, ViewerUserLevelAlertPreferencesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerUserLevelAlertPreferencesQuery | undefined, ViewerUserLevelAlertPreferencesQueryVariables>;
export function useViewerUserLevelAlertPreferencesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerUserLevelAlertPreferencesQuery, ViewerUserLevelAlertPreferencesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerUserLevelAlertPreferencesQuery, ViewerUserLevelAlertPreferencesQueryVariables>(ViewerUserLevelAlertPreferencesDocument, options);
        }
export type ViewerUserLevelAlertPreferencesQueryHookResult = ReturnType<typeof useViewerUserLevelAlertPreferencesQuery>;
export type ViewerUserLevelAlertPreferencesLazyQueryHookResult = ReturnType<typeof useViewerUserLevelAlertPreferencesLazyQuery>;
export type ViewerUserLevelAlertPreferencesSuspenseQueryHookResult = ReturnType<typeof useViewerUserLevelAlertPreferencesSuspenseQuery>;
export type ViewerUserLevelAlertPreferencesQueryResult = ApolloReactCommon.QueryResult<ViewerUserLevelAlertPreferencesQuery, ViewerUserLevelAlertPreferencesQueryVariables>;
export const UserContextDocument = gql`
    query UserContext {
  viewer {
    id
    views(viewType: "userContext") {
      edges {
        node {
          id
          spec
        }
      }
    }
  }
}
    `;

/**
 * __useUserContextQuery__
 *
 * To run a query within a React component, call `useUserContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserContextQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserContextQuery, UserContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserContextQuery, UserContextQueryVariables>(UserContextDocument, options);
      }
export function useUserContextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserContextQuery, UserContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserContextQuery, UserContextQueryVariables>(UserContextDocument, options);
        }
// @ts-ignore
export function useUserContextSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserContextQuery, UserContextQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserContextQuery, UserContextQueryVariables>;
export function useUserContextSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserContextQuery, UserContextQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserContextQuery | undefined, UserContextQueryVariables>;
export function useUserContextSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserContextQuery, UserContextQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserContextQuery, UserContextQueryVariables>(UserContextDocument, options);
        }
export type UserContextQueryHookResult = ReturnType<typeof useUserContextQuery>;
export type UserContextLazyQueryHookResult = ReturnType<typeof useUserContextLazyQuery>;
export type UserContextSuspenseQueryHookResult = ReturnType<typeof useUserContextSuspenseQuery>;
export type UserContextQueryResult = ApolloReactCommon.QueryResult<UserContextQuery, UserContextQueryVariables>;
export const ViewerUserInfoDocument = gql`
    query ViewerUserInfo {
  viewer {
    id
    userInfo
  }
}
    `;

/**
 * __useViewerUserInfoQuery__
 *
 * To run a query within a React component, call `useViewerUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerUserInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>(ViewerUserInfoDocument, options);
      }
export function useViewerUserInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>(ViewerUserInfoDocument, options);
        }
// @ts-ignore
export function useViewerUserInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>;
export function useViewerUserInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerUserInfoQuery | undefined, ViewerUserInfoQueryVariables>;
export function useViewerUserInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>(ViewerUserInfoDocument, options);
        }
export type ViewerUserInfoQueryHookResult = ReturnType<typeof useViewerUserInfoQuery>;
export type ViewerUserInfoLazyQueryHookResult = ReturnType<typeof useViewerUserInfoLazyQuery>;
export type ViewerUserInfoSuspenseQueryHookResult = ReturnType<typeof useViewerUserInfoSuspenseQuery>;
export type ViewerUserInfoQueryResult = ApolloReactCommon.QueryResult<ViewerUserInfoQuery, ViewerUserInfoQueryVariables>;
export const UserOrganizationsDocument = gql`
    query UserOrganizations($emailDomain: String, $includeOpenMatchingOrganizations: Boolean = false) {
  viewer {
    id
    organizations: organizations {
      id
      name
      orgType
      members {
        id
        admin
      }
      teams {
        id
        name
      }
      subscriptions {
        id
        subscriptionType
        privileges
        plan {
          id
          name
          planType
          displayName
        }
      }
    }
    openMatchingOrganizations: organizations(emailDomain: $emailDomain) @include(if: $includeOpenMatchingOrganizations) {
      id
      name
      orgType
      flags
      members {
        orgID
        id
        admin
      }
      subscriptions {
        id
        status
      }
      teams {
        id
        name
        memberCount
        settings {
          openToMatchingOrgEmailDomainUsers
        }
      }
    }
  }
}
    `;

/**
 * __useUserOrganizationsQuery__
 *
 * To run a query within a React component, call `useUserOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserOrganizationsQuery({
 *   variables: {
 *      emailDomain: // value for 'emailDomain'
 *      includeOpenMatchingOrganizations: // value for 'includeOpenMatchingOrganizations'
 *   },
 * });
 */
export function useUserOrganizationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserOrganizationsQuery, UserOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserOrganizationsQuery, UserOrganizationsQueryVariables>(UserOrganizationsDocument, options);
      }
export function useUserOrganizationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserOrganizationsQuery, UserOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserOrganizationsQuery, UserOrganizationsQueryVariables>(UserOrganizationsDocument, options);
        }
// @ts-ignore
export function useUserOrganizationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserOrganizationsQuery, UserOrganizationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserOrganizationsQuery, UserOrganizationsQueryVariables>;
export function useUserOrganizationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserOrganizationsQuery, UserOrganizationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserOrganizationsQuery | undefined, UserOrganizationsQueryVariables>;
export function useUserOrganizationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserOrganizationsQuery, UserOrganizationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserOrganizationsQuery, UserOrganizationsQueryVariables>(UserOrganizationsDocument, options);
        }
export type UserOrganizationsQueryHookResult = ReturnType<typeof useUserOrganizationsQuery>;
export type UserOrganizationsLazyQueryHookResult = ReturnType<typeof useUserOrganizationsLazyQuery>;
export type UserOrganizationsSuspenseQueryHookResult = ReturnType<typeof useUserOrganizationsSuspenseQuery>;
export type UserOrganizationsQueryResult = ApolloReactCommon.QueryResult<UserOrganizationsQuery, UserOrganizationsQueryVariables>;
export const EntityStorageBytesDocument = gql`
    query EntityStorageBytes($name: String!) {
  entity(name: $name) {
    id
    storageBytes
  }
}
    `;

/**
 * __useEntityStorageBytesQuery__
 *
 * To run a query within a React component, call `useEntityStorageBytesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityStorageBytesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityStorageBytesQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEntityStorageBytesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityStorageBytesQuery, EntityStorageBytesQueryVariables> & ({ variables: EntityStorageBytesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityStorageBytesQuery, EntityStorageBytesQueryVariables>(EntityStorageBytesDocument, options);
      }
export function useEntityStorageBytesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityStorageBytesQuery, EntityStorageBytesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityStorageBytesQuery, EntityStorageBytesQueryVariables>(EntityStorageBytesDocument, options);
        }
// @ts-ignore
export function useEntityStorageBytesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityStorageBytesQuery, EntityStorageBytesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityStorageBytesQuery, EntityStorageBytesQueryVariables>;
export function useEntityStorageBytesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityStorageBytesQuery, EntityStorageBytesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityStorageBytesQuery | undefined, EntityStorageBytesQueryVariables>;
export function useEntityStorageBytesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityStorageBytesQuery, EntityStorageBytesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityStorageBytesQuery, EntityStorageBytesQueryVariables>(EntityStorageBytesDocument, options);
        }
export type EntityStorageBytesQueryHookResult = ReturnType<typeof useEntityStorageBytesQuery>;
export type EntityStorageBytesLazyQueryHookResult = ReturnType<typeof useEntityStorageBytesLazyQuery>;
export type EntityStorageBytesSuspenseQueryHookResult = ReturnType<typeof useEntityStorageBytesSuspenseQuery>;
export type EntityStorageBytesQueryResult = ApolloReactCommon.QueryResult<EntityStorageBytesQuery, EntityStorageBytesQueryVariables>;
export const EntityDocument = gql`
    query Entity($name: String!) {
  entity(name: $name) {
    id
    name
    available
    photoUrl
    readOnly
    readOnlyAdmin
    isTeam
    privateOnly
    codeSavingEnabled
    artifactTTLDurationSeconds
    settings {
      hidden
      openToMatchingOrgEmailDomainUsers
      membersCanInvite
      disableMagicLinkSharing
      defaultCloudRegion {
        id
        provider
        region
      }
      storageBucketInfo {
        ID
        provider
        name
        kmsKeyID
        awsExternalID
        path
      }
      referenceBucketInfos {
        ID
        provider
        name
        path
      }
      disableMembersEditArtifactTTL
    }
    defaultAccess
    isPaid
    ...EntityRateLimits
    members {
      id
      admin
      role
      pending
      email
      username
      name
      photoUrl
      accountType
      apiKey
    }
    defaultAlerts {
      id
      condition {
        __typename
        ... on FinishedRunCondition {
          success
        }
        ... on StoppedRunCondition {
          minimumRunDuration
        }
      }
      subscriptions {
        __typename
        ... on EmailSubscription {
          id
        }
        ... on SlackChannelSubscription {
          id
        }
      }
    }
    integrations {
      edges {
        node {
          id
          __typename
          ... on SlackIntegration {
            teamName
            channelName
          }
          ... on GenericWebhookIntegration {
            id
            urlEndpoint
            name
            accessTokenRef
            secretRef
            createdAt
          }
        }
      }
    }
    computeHours
    organization {
      id
      name
      orgType
      billingUser {
        id
        username
      }
      subscriptions {
        id
        plan {
          id
          name
          planType
        }
        privileges
        seats
        expiresAt
        subscriptionType
        status
      }
      members {
        orgID
        id
        username
        name
        photoUrl
        admin
        role
      }
      pendingInvites {
        id
        email
      }
    }
    invites {
      edges {
        node {
          id
          createdAt
          name
          toUser {
            id
            email
            username
          }
        }
      }
    }
  }
  user(userName: $name) {
    id
    username
    accountType
  }
}
    ${EntityRateLimitsFragmentDoc}`;

/**
 * __useEntityQuery__
 *
 * To run a query within a React component, call `useEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEntityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityQuery, EntityQueryVariables> & ({ variables: EntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityQuery, EntityQueryVariables>(EntityDocument, options);
      }
export function useEntityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityQuery, EntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityQuery, EntityQueryVariables>(EntityDocument, options);
        }
// @ts-ignore
export function useEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityQuery, EntityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityQuery, EntityQueryVariables>;
export function useEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityQuery, EntityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityQuery | undefined, EntityQueryVariables>;
export function useEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityQuery, EntityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityQuery, EntityQueryVariables>(EntityDocument, options);
        }
export type EntityQueryHookResult = ReturnType<typeof useEntityQuery>;
export type EntityLazyQueryHookResult = ReturnType<typeof useEntityLazyQuery>;
export type EntitySuspenseQueryHookResult = ReturnType<typeof useEntitySuspenseQuery>;
export type EntityQueryResult = ApolloReactCommon.QueryResult<EntityQuery, EntityQueryVariables>;
export const EntityIntegrationsDocument = gql`
    query EntityIntegrations($name: String!) {
  entity(name: $name) {
    id
    name
    integrations {
      edges {
        node {
          id
          __typename
          ... on SlackIntegration {
            teamName
            channelName
          }
          ... on GenericWebhookIntegration {
            id
            urlEndpoint
            name
            accessTokenRef
            secretRef
            createdAt
          }
        }
      }
    }
  }
}
    `;

/**
 * __useEntityIntegrationsQuery__
 *
 * To run a query within a React component, call `useEntityIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityIntegrationsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEntityIntegrationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityIntegrationsQuery, EntityIntegrationsQueryVariables> & ({ variables: EntityIntegrationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityIntegrationsQuery, EntityIntegrationsQueryVariables>(EntityIntegrationsDocument, options);
      }
export function useEntityIntegrationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityIntegrationsQuery, EntityIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityIntegrationsQuery, EntityIntegrationsQueryVariables>(EntityIntegrationsDocument, options);
        }
// @ts-ignore
export function useEntityIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityIntegrationsQuery, EntityIntegrationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityIntegrationsQuery, EntityIntegrationsQueryVariables>;
export function useEntityIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityIntegrationsQuery, EntityIntegrationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityIntegrationsQuery | undefined, EntityIntegrationsQueryVariables>;
export function useEntityIntegrationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityIntegrationsQuery, EntityIntegrationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityIntegrationsQuery, EntityIntegrationsQueryVariables>(EntityIntegrationsDocument, options);
        }
export type EntityIntegrationsQueryHookResult = ReturnType<typeof useEntityIntegrationsQuery>;
export type EntityIntegrationsLazyQueryHookResult = ReturnType<typeof useEntityIntegrationsLazyQuery>;
export type EntityIntegrationsSuspenseQueryHookResult = ReturnType<typeof useEntityIntegrationsSuspenseQuery>;
export type EntityIntegrationsQueryResult = ApolloReactCommon.QueryResult<EntityIntegrationsQuery, EntityIntegrationsQueryVariables>;
export const SearchUsersDocument = gql`
    query SearchUsers($query: String, $queryEmail: String, $ids: [ID!], $usernames: [String!]) {
  users(query: $query, queryEmail: $queryEmail, ids: $ids, usernames: $usernames) {
    edges {
      node {
        emails {
          ...EmailBasic
        }
        id
        name
        loggedInAt
        userInfo
        ...UserRoleFragment
      }
    }
  }
}
    ${EmailBasicFragmentDoc}
${UserRoleFragmentFragmentDoc}`;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      query: // value for 'query'
 *      queryEmail: // value for 'queryEmail'
 *      ids: // value for 'ids'
 *      usernames: // value for 'usernames'
 *   },
 * });
 */
export function useSearchUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
// @ts-ignore
export function useSearchUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export function useSearchUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchUsersQuery | undefined, SearchUsersQueryVariables>;
export function useSearchUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersSuspenseQueryHookResult = ReturnType<typeof useSearchUsersSuspenseQuery>;
export type SearchUsersQueryResult = ApolloReactCommon.QueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export const FindUsersDocument = gql`
    query FindUsers($query: String!, $limit: Int!) {
  users(query: $query, first: $limit) {
    edges {
      node {
        id
        ...UserFragment
      }
    }
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useFindUsersQuery__
 *
 * To run a query within a React component, call `useFindUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUsersQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFindUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FindUsersQuery, FindUsersQueryVariables> & ({ variables: FindUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FindUsersQuery, FindUsersQueryVariables>(FindUsersDocument, options);
      }
export function useFindUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindUsersQuery, FindUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FindUsersQuery, FindUsersQueryVariables>(FindUsersDocument, options);
        }
// @ts-ignore
export function useFindUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FindUsersQuery, FindUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FindUsersQuery, FindUsersQueryVariables>;
export function useFindUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FindUsersQuery, FindUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FindUsersQuery | undefined, FindUsersQueryVariables>;
export function useFindUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FindUsersQuery, FindUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FindUsersQuery, FindUsersQueryVariables>(FindUsersDocument, options);
        }
export type FindUsersQueryHookResult = ReturnType<typeof useFindUsersQuery>;
export type FindUsersLazyQueryHookResult = ReturnType<typeof useFindUsersLazyQuery>;
export type FindUsersSuspenseQueryHookResult = ReturnType<typeof useFindUsersSuspenseQuery>;
export type FindUsersQueryResult = ApolloReactCommon.QueryResult<FindUsersQuery, FindUsersQueryVariables>;
export const FindUsersByUsernameDocument = gql`
    query FindUsersByUsername($usernames: [String!]!, $limit: Int!) {
  users(usernames: $usernames, first: $limit) {
    edges {
      node {
        id
        ...UserFragment
      }
    }
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useFindUsersByUsernameQuery__
 *
 * To run a query within a React component, call `useFindUsersByUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUsersByUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUsersByUsernameQuery({
 *   variables: {
 *      usernames: // value for 'usernames'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFindUsersByUsernameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables> & ({ variables: FindUsersByUsernameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables>(FindUsersByUsernameDocument, options);
      }
export function useFindUsersByUsernameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables>(FindUsersByUsernameDocument, options);
        }
// @ts-ignore
export function useFindUsersByUsernameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables>;
export function useFindUsersByUsernameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FindUsersByUsernameQuery | undefined, FindUsersByUsernameQueryVariables>;
export function useFindUsersByUsernameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables>(FindUsersByUsernameDocument, options);
        }
export type FindUsersByUsernameQueryHookResult = ReturnType<typeof useFindUsersByUsernameQuery>;
export type FindUsersByUsernameLazyQueryHookResult = ReturnType<typeof useFindUsersByUsernameLazyQuery>;
export type FindUsersByUsernameSuspenseQueryHookResult = ReturnType<typeof useFindUsersByUsernameSuspenseQuery>;
export type FindUsersByUsernameQueryResult = ApolloReactCommon.QueryResult<FindUsersByUsernameQuery, FindUsersByUsernameQueryVariables>;
export const UpdateUserRoleDocument = gql`
    mutation UpdateUserRole($id: ID!, $role: String!) {
  updateUserRole(input: {id: $id, accountType: $role}) {
    user {
      id
      name
      username
      email
      admin
      deletedAt
      accountType
    }
  }
}
    `;
export type UpdateUserRoleMutationFn = ApolloReactCommon.MutationFunction<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;

/**
 * __useUpdateUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleMutation, { data, loading, error }] = useUpdateUserRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateUserRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>(UpdateUserRoleDocument, options);
      }
export type UpdateUserRoleMutationHookResult = ReturnType<typeof useUpdateUserRoleMutation>;
export type UpdateUserRoleMutationResult = ApolloReactCommon.MutationResult<UpdateUserRoleMutation>;
export type UpdateUserRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;
export const UpdateUserRoleV2Document = gql`
    mutation UpdateUserRoleV2($id: ID!, $role: String!) {
  updateUserRoleV2(input: {id: $id, accountType: $role}) {
    user {
      id
      name
      username
      email
      admin
      deletedAt
      accountType
    }
  }
}
    `;
export type UpdateUserRoleV2MutationFn = ApolloReactCommon.MutationFunction<UpdateUserRoleV2Mutation, UpdateUserRoleV2MutationVariables>;

/**
 * __useUpdateUserRoleV2Mutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleV2Mutation, { data, loading, error }] = useUpdateUserRoleV2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateUserRoleV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserRoleV2Mutation, UpdateUserRoleV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserRoleV2Mutation, UpdateUserRoleV2MutationVariables>(UpdateUserRoleV2Document, options);
      }
export type UpdateUserRoleV2MutationHookResult = ReturnType<typeof useUpdateUserRoleV2Mutation>;
export type UpdateUserRoleV2MutationResult = ApolloReactCommon.MutationResult<UpdateUserRoleV2Mutation>;
export type UpdateUserRoleV2MutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserRoleV2Mutation, UpdateUserRoleV2MutationVariables>;
export const SetUserAdminDocument = gql`
    mutation SetUserAdmin($id: ID!, $admin: Boolean!) {
  updateUser(input: {id: $id, admin: $admin}) {
    user {
      id
      name
      username
      email
      admin
      deletedAt
    }
  }
}
    `;
export type SetUserAdminMutationFn = ApolloReactCommon.MutationFunction<SetUserAdminMutation, SetUserAdminMutationVariables>;

/**
 * __useSetUserAdminMutation__
 *
 * To run a mutation, you first call `useSetUserAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserAdminMutation, { data, loading, error }] = useSetUserAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      admin: // value for 'admin'
 *   },
 * });
 */
export function useSetUserAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetUserAdminMutation, SetUserAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetUserAdminMutation, SetUserAdminMutationVariables>(SetUserAdminDocument, options);
      }
export type SetUserAdminMutationHookResult = ReturnType<typeof useSetUserAdminMutation>;
export type SetUserAdminMutationResult = ApolloReactCommon.MutationResult<SetUserAdminMutation>;
export type SetUserAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<SetUserAdminMutation, SetUserAdminMutationVariables>;
export const PurgeUserDocument = gql`
    mutation PurgeUser($username: String!, $email: String!) {
  purgeUser(input: {username: $username, email: $email}) {
    user {
      id
      deletedAt
    }
  }
}
    `;
export type PurgeUserMutationFn = ApolloReactCommon.MutationFunction<PurgeUserMutation, PurgeUserMutationVariables>;

/**
 * __usePurgeUserMutation__
 *
 * To run a mutation, you first call `usePurgeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurgeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purgeUserMutation, { data, loading, error }] = usePurgeUserMutation({
 *   variables: {
 *      username: // value for 'username'
 *      email: // value for 'email'
 *   },
 * });
 */
export function usePurgeUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PurgeUserMutation, PurgeUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PurgeUserMutation, PurgeUserMutationVariables>(PurgeUserDocument, options);
      }
export type PurgeUserMutationHookResult = ReturnType<typeof usePurgeUserMutation>;
export type PurgeUserMutationResult = ApolloReactCommon.MutationResult<PurgeUserMutation>;
export type PurgeUserMutationOptions = ApolloReactCommon.BaseMutationOptions<PurgeUserMutation, PurgeUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: ID!) {
  deleteUser(input: {id: $id}) {
    user {
      id
      name
      username
      email
      admin
      deletedAt
    }
  }
}
    `;
export type DeleteUserMutationFn = ApolloReactCommon.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = ApolloReactCommon.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const UndeleteUserDocument = gql`
    mutation UndeleteUser($id: ID!) {
  undeleteUser(input: {id: $id}) {
    user {
      id
      name
      username
      email
      admin
      deletedAt
    }
  }
}
    `;
export type UndeleteUserMutationFn = ApolloReactCommon.MutationFunction<UndeleteUserMutation, UndeleteUserMutationVariables>;

/**
 * __useUndeleteUserMutation__
 *
 * To run a mutation, you first call `useUndeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undeleteUserMutation, { data, loading, error }] = useUndeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUndeleteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UndeleteUserMutation, UndeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UndeleteUserMutation, UndeleteUserMutationVariables>(UndeleteUserDocument, options);
      }
export type UndeleteUserMutationHookResult = ReturnType<typeof useUndeleteUserMutation>;
export type UndeleteUserMutationResult = ApolloReactCommon.MutationResult<UndeleteUserMutation>;
export type UndeleteUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UndeleteUserMutation, UndeleteUserMutationVariables>;
export const CreateInviteDocument = gql`
    mutation CreateInvite($entityName: String!, $email: String, $username: String, $admin: Boolean, $role: String, $modelsSeat: String, $weaveRole: String) {
  createInvite(
    input: {entityName: $entityName, email: $email, username: $username, admin: $admin, role: $role, modelsSeat: $modelsSeat, weaveRole: $weaveRole}
  ) {
    invite {
      id
      name
      email
      createdAt
      toUser {
        id
        name
      }
    }
    success
    remainingSeats
    remainingViewOnlySeats
  }
}
    `;
export type CreateInviteMutationFn = ApolloReactCommon.MutationFunction<CreateInviteMutation, CreateInviteMutationVariables>;

/**
 * __useCreateInviteMutation__
 *
 * To run a mutation, you first call `useCreateInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInviteMutation, { data, loading, error }] = useCreateInviteMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      email: // value for 'email'
 *      username: // value for 'username'
 *      admin: // value for 'admin'
 *      role: // value for 'role'
 *      modelsSeat: // value for 'modelsSeat'
 *      weaveRole: // value for 'weaveRole'
 *   },
 * });
 */
export function useCreateInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateInviteMutation, CreateInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateInviteMutation, CreateInviteMutationVariables>(CreateInviteDocument, options);
      }
export type CreateInviteMutationHookResult = ReturnType<typeof useCreateInviteMutation>;
export type CreateInviteMutationResult = ApolloReactCommon.MutationResult<CreateInviteMutation>;
export type CreateInviteMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateInviteMutation, CreateInviteMutationVariables>;
export const DeleteInviteDocument = gql`
    mutation DeleteInvite($id: String, $entityName: String) {
  deleteInvite(input: {id: $id, entityName: $entityName}) {
    success
  }
}
    `;
export type DeleteInviteMutationFn = ApolloReactCommon.MutationFunction<DeleteInviteMutation, DeleteInviteMutationVariables>;

/**
 * __useDeleteInviteMutation__
 *
 * To run a mutation, you first call `useDeleteInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInviteMutation, { data, loading, error }] = useDeleteInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useDeleteInviteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteInviteMutation, DeleteInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteInviteMutation, DeleteInviteMutationVariables>(DeleteInviteDocument, options);
      }
export type DeleteInviteMutationHookResult = ReturnType<typeof useDeleteInviteMutation>;
export type DeleteInviteMutationResult = ApolloReactCommon.MutationResult<DeleteInviteMutation>;
export type DeleteInviteMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteInviteMutation, DeleteInviteMutationVariables>;
export const UpdateMemberDocument = gql`
    mutation UpdateMember($entityName: String!, $user: ID!, $role: String!) {
  updateMember(input: {entityName: $entityName, user: $user, role: $role}) {
    member {
      id
      role
    }
  }
}
    `;
export type UpdateMemberMutationFn = ApolloReactCommon.MutationFunction<UpdateMemberMutation, UpdateMemberMutationVariables>;

/**
 * __useUpdateMemberMutation__
 *
 * To run a mutation, you first call `useUpdateMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberMutation, { data, loading, error }] = useUpdateMemberMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      user: // value for 'user'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateMemberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMemberMutation, UpdateMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMemberMutation, UpdateMemberMutationVariables>(UpdateMemberDocument, options);
      }
export type UpdateMemberMutationHookResult = ReturnType<typeof useUpdateMemberMutation>;
export type UpdateMemberMutationResult = ApolloReactCommon.MutationResult<UpdateMemberMutation>;
export type UpdateMemberMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMemberMutation, UpdateMemberMutationVariables>;
export const CreateServiceAccountDocument = gql`
    mutation CreateServiceAccount($entityName: String!, $description: String!, $organizationId: ID) {
  createServiceAccount(
    input: {description: $description, entityName: $entityName, organizationId: $organizationId}
  ) {
    user {
      id
      name
      apiKeys {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export type CreateServiceAccountMutationFn = ApolloReactCommon.MutationFunction<CreateServiceAccountMutation, CreateServiceAccountMutationVariables>;

/**
 * __useCreateServiceAccountMutation__
 *
 * To run a mutation, you first call `useCreateServiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceAccountMutation, { data, loading, error }] = useCreateServiceAccountMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      description: // value for 'description'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCreateServiceAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateServiceAccountMutation, CreateServiceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateServiceAccountMutation, CreateServiceAccountMutationVariables>(CreateServiceAccountDocument, options);
      }
export type CreateServiceAccountMutationHookResult = ReturnType<typeof useCreateServiceAccountMutation>;
export type CreateServiceAccountMutationResult = ApolloReactCommon.MutationResult<CreateServiceAccountMutation>;
export type CreateServiceAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateServiceAccountMutation, CreateServiceAccountMutationVariables>;
export const CreateOrgServiceAccountDocument = gql`
    mutation CreateOrgServiceAccount($description: String!, $defaultEntityId: ID!, $organizationId: ID!) {
  createOrgServiceAccount(
    input: {description: $description, defaultEntityId: $defaultEntityId, organizationId: $organizationId}
  ) {
    user {
      id
      name
      apiKeys {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export type CreateOrgServiceAccountMutationFn = ApolloReactCommon.MutationFunction<CreateOrgServiceAccountMutation, CreateOrgServiceAccountMutationVariables>;

/**
 * __useCreateOrgServiceAccountMutation__
 *
 * To run a mutation, you first call `useCreateOrgServiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrgServiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrgServiceAccountMutation, { data, loading, error }] = useCreateOrgServiceAccountMutation({
 *   variables: {
 *      description: // value for 'description'
 *      defaultEntityId: // value for 'defaultEntityId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCreateOrgServiceAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrgServiceAccountMutation, CreateOrgServiceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOrgServiceAccountMutation, CreateOrgServiceAccountMutationVariables>(CreateOrgServiceAccountDocument, options);
      }
export type CreateOrgServiceAccountMutationHookResult = ReturnType<typeof useCreateOrgServiceAccountMutation>;
export type CreateOrgServiceAccountMutationResult = ApolloReactCommon.MutationResult<CreateOrgServiceAccountMutation>;
export type CreateOrgServiceAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrgServiceAccountMutation, CreateOrgServiceAccountMutationVariables>;
export const DeleteServiceAccountDocument = gql`
    mutation DeleteServiceAccount($id: ID!) {
  deleteServiceAccount(input: {id: $id}) {
    user {
      id
    }
  }
}
    `;
export type DeleteServiceAccountMutationFn = ApolloReactCommon.MutationFunction<DeleteServiceAccountMutation, DeleteServiceAccountMutationVariables>;

/**
 * __useDeleteServiceAccountMutation__
 *
 * To run a mutation, you first call `useDeleteServiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceAccountMutation, { data, loading, error }] = useDeleteServiceAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteServiceAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteServiceAccountMutation, DeleteServiceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteServiceAccountMutation, DeleteServiceAccountMutationVariables>(DeleteServiceAccountDocument, options);
      }
export type DeleteServiceAccountMutationHookResult = ReturnType<typeof useDeleteServiceAccountMutation>;
export type DeleteServiceAccountMutationResult = ApolloReactCommon.MutationResult<DeleteServiceAccountMutation>;
export type DeleteServiceAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteServiceAccountMutation, DeleteServiceAccountMutationVariables>;
export const CreateEntityDocument = gql`
    mutation CreateEntity($name: String!, $invited: String, $framework: String) {
  createEntity(
    input: {name: $name, defaultFramework: $framework, invited: $invited}
  ) {
    entity {
      id
      name
      photoUrl
      invitedTeam
      projects(first: 100) {
        edges {
          node {
            id
            name
            entityName
          }
        }
      }
    }
    apiKey {
      id
      name
    }
  }
}
    `;
export type CreateEntityMutationFn = ApolloReactCommon.MutationFunction<CreateEntityMutation, CreateEntityMutationVariables>;

/**
 * __useCreateEntityMutation__
 *
 * To run a mutation, you first call `useCreateEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityMutation, { data, loading, error }] = useCreateEntityMutation({
 *   variables: {
 *      name: // value for 'name'
 *      invited: // value for 'invited'
 *      framework: // value for 'framework'
 *   },
 * });
 */
export function useCreateEntityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEntityMutation, CreateEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateEntityMutation, CreateEntityMutationVariables>(CreateEntityDocument, options);
      }
export type CreateEntityMutationHookResult = ReturnType<typeof useCreateEntityMutation>;
export type CreateEntityMutationResult = ApolloReactCommon.MutationResult<CreateEntityMutation>;
export type CreateEntityMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateEntityMutation, CreateEntityMutationVariables>;
export const CreateUserFromAdminDocument = gql`
    mutation CreateUserFromAdmin($email: String!, $admin: Boolean, $accountType: String, $organizationID: ID, $modelsSeat: String, $weaveRole: String) {
  createUser(
    input: {email: $email, admin: $admin, accountType: $accountType, organizationID: $organizationID, modelsSeat: $modelsSeat, weaveRole: $weaveRole}
  ) {
    user {
      id
      name
      username
      email
      admin
    }
  }
}
    `;
export type CreateUserFromAdminMutationFn = ApolloReactCommon.MutationFunction<CreateUserFromAdminMutation, CreateUserFromAdminMutationVariables>;

/**
 * __useCreateUserFromAdminMutation__
 *
 * To run a mutation, you first call `useCreateUserFromAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserFromAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserFromAdminMutation, { data, loading, error }] = useCreateUserFromAdminMutation({
 *   variables: {
 *      email: // value for 'email'
 *      admin: // value for 'admin'
 *      accountType: // value for 'accountType'
 *      organizationID: // value for 'organizationID'
 *      modelsSeat: // value for 'modelsSeat'
 *      weaveRole: // value for 'weaveRole'
 *   },
 * });
 */
export function useCreateUserFromAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserFromAdminMutation, CreateUserFromAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserFromAdminMutation, CreateUserFromAdminMutationVariables>(CreateUserFromAdminDocument, options);
      }
export type CreateUserFromAdminMutationHookResult = ReturnType<typeof useCreateUserFromAdminMutation>;
export type CreateUserFromAdminMutationResult = ApolloReactCommon.MutationResult<CreateUserFromAdminMutation>;
export type CreateUserFromAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateUserFromAdminMutation, CreateUserFromAdminMutationVariables>;
export const CreateEntityOnboardingFlowDocument = gql`
    mutation CreateEntityOnboardingFlow($name: String!) {
  createEntity(input: {name: $name}) {
    entity {
      id
    }
  }
}
    `;
export type CreateEntityOnboardingFlowMutationFn = ApolloReactCommon.MutationFunction<CreateEntityOnboardingFlowMutation, CreateEntityOnboardingFlowMutationVariables>;

/**
 * __useCreateEntityOnboardingFlowMutation__
 *
 * To run a mutation, you first call `useCreateEntityOnboardingFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityOnboardingFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityOnboardingFlowMutation, { data, loading, error }] = useCreateEntityOnboardingFlowMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateEntityOnboardingFlowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateEntityOnboardingFlowMutation, CreateEntityOnboardingFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateEntityOnboardingFlowMutation, CreateEntityOnboardingFlowMutationVariables>(CreateEntityOnboardingFlowDocument, options);
      }
export type CreateEntityOnboardingFlowMutationHookResult = ReturnType<typeof useCreateEntityOnboardingFlowMutation>;
export type CreateEntityOnboardingFlowMutationResult = ApolloReactCommon.MutationResult<CreateEntityOnboardingFlowMutation>;
export type CreateEntityOnboardingFlowMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateEntityOnboardingFlowMutation, CreateEntityOnboardingFlowMutationVariables>;
export const CheckAvailabilityDocument = gql`
    query CheckAvailability($name: String) {
  entity(name: $name) {
    id
    available
  }
}
    `;

/**
 * __useCheckAvailabilityQuery__
 *
 * To run a query within a React component, call `useCheckAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckAvailabilityQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCheckAvailabilityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>(CheckAvailabilityDocument, options);
      }
export function useCheckAvailabilityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>(CheckAvailabilityDocument, options);
        }
// @ts-ignore
export function useCheckAvailabilitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>;
export function useCheckAvailabilitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CheckAvailabilityQuery | undefined, CheckAvailabilityQueryVariables>;
export function useCheckAvailabilitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>(CheckAvailabilityDocument, options);
        }
export type CheckAvailabilityQueryHookResult = ReturnType<typeof useCheckAvailabilityQuery>;
export type CheckAvailabilityLazyQueryHookResult = ReturnType<typeof useCheckAvailabilityLazyQuery>;
export type CheckAvailabilitySuspenseQueryHookResult = ReturnType<typeof useCheckAvailabilitySuspenseQuery>;
export type CheckAvailabilityQueryResult = ApolloReactCommon.QueryResult<CheckAvailabilityQuery, CheckAvailabilityQueryVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($defaultEntity: String, $defaultFramework: String, $photoUrl: String, $code: String, $settingsVisited: Boolean, $galleryVisited: Boolean, $onboardingHidden: Boolean, $hideTeamsFromPublic: Boolean) {
  updateUser(
    input: {defaultEntity: $defaultEntity, defaultFramework: $defaultFramework, photoUrl: $photoUrl, code: $code, settingsVisited: $settingsVisited, galleryVisited: $galleryVisited, onboardingHidden: $onboardingHidden, hideTeamsFromPublic: $hideTeamsFromPublic}
  ) {
    user {
      id
      flags
      entity
      hideTeamsFromPublic
      teams {
        edges {
          node {
            id
            name
            isTeam
          }
        }
      }
    }
  }
}
    `;
export type UpdateUserMutationFn = ApolloReactCommon.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      defaultEntity: // value for 'defaultEntity'
 *      defaultFramework: // value for 'defaultFramework'
 *      photoUrl: // value for 'photoUrl'
 *      code: // value for 'code'
 *      settingsVisited: // value for 'settingsVisited'
 *      galleryVisited: // value for 'galleryVisited'
 *      onboardingHidden: // value for 'onboardingHidden'
 *      hideTeamsFromPublic: // value for 'hideTeamsFromPublic'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = ApolloReactCommon.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserInfoDocument = gql`
    mutation UpdateUserInfo($id: ID, $name: String, $photoUrl: String, $userInfo: JSONString, $defaultEntity: String, $primaryEmail: String, $password: String) {
  updateUser(
    input: {id: $id, name: $name, userInfo: $userInfo, defaultEntity: $defaultEntity, photoUrl: $photoUrl, primaryEmail: $primaryEmail, password: $password}
  ) {
    user {
      id
      name
      userInfo
      photoUrl
      entity
      teams {
        edges {
          node {
            id
            name
            isTeam
          }
        }
      }
    }
  }
}
    `;
export type UpdateUserInfoMutationFn = ApolloReactCommon.MutationFunction<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>;

/**
 * __useUpdateUserInfoMutation__
 *
 * To run a mutation, you first call `useUpdateUserInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserInfoMutation, { data, loading, error }] = useUpdateUserInfoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      photoUrl: // value for 'photoUrl'
 *      userInfo: // value for 'userInfo'
 *      defaultEntity: // value for 'defaultEntity'
 *      primaryEmail: // value for 'primaryEmail'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useUpdateUserInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>(UpdateUserInfoDocument, options);
      }
export type UpdateUserInfoMutationHookResult = ReturnType<typeof useUpdateUserInfoMutation>;
export type UpdateUserInfoMutationResult = ApolloReactCommon.MutationResult<UpdateUserInfoMutation>;
export type UpdateUserInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserInfoMutation, UpdateUserInfoMutationVariables>;
export const UpdateUserEmailDocument = gql`
    mutation UpdateUserEmail($id: ID!, $type: EmailType) {
  updateUserEmail(input: {id: $id, type: $type}) {
    success
    email {
      id
      emailAddress
    }
  }
}
    `;
export type UpdateUserEmailMutationFn = ApolloReactCommon.MutationFunction<UpdateUserEmailMutation, UpdateUserEmailMutationVariables>;

/**
 * __useUpdateUserEmailMutation__
 *
 * To run a mutation, you first call `useUpdateUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserEmailMutation, { data, loading, error }] = useUpdateUserEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateUserEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserEmailMutation, UpdateUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserEmailMutation, UpdateUserEmailMutationVariables>(UpdateUserEmailDocument, options);
      }
export type UpdateUserEmailMutationHookResult = ReturnType<typeof useUpdateUserEmailMutation>;
export type UpdateUserEmailMutationResult = ApolloReactCommon.MutationResult<UpdateUserEmailMutation>;
export type UpdateUserEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserEmailMutation, UpdateUserEmailMutationVariables>;
export const DeleteUserEmailDocument = gql`
    mutation DeleteUserEmail($id: ID!) {
  deleteUserEmail(input: {id: $id}) {
    success
  }
}
    `;
export type DeleteUserEmailMutationFn = ApolloReactCommon.MutationFunction<DeleteUserEmailMutation, DeleteUserEmailMutationVariables>;

/**
 * __useDeleteUserEmailMutation__
 *
 * To run a mutation, you first call `useDeleteUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserEmailMutation, { data, loading, error }] = useDeleteUserEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserEmailMutation, DeleteUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserEmailMutation, DeleteUserEmailMutationVariables>(DeleteUserEmailDocument, options);
      }
export type DeleteUserEmailMutationHookResult = ReturnType<typeof useDeleteUserEmailMutation>;
export type DeleteUserEmailMutationResult = ApolloReactCommon.MutationResult<DeleteUserEmailMutation>;
export type DeleteUserEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteUserEmailMutation, DeleteUserEmailMutationVariables>;
export const GenerateApiKeyDocument = gql`
    mutation GenerateApiKey($description: String, $organizationID: ID) {
  generateApiKey(
    input: {description: $description, organizationID: $organizationID}
  ) {
    apiKey {
      id
      name
      description
      apiKeyId
      createdAt
      expiresAt
      user {
        id
        name
      }
    }
    secretApiKey
  }
}
    `;
export type GenerateApiKeyMutationFn = ApolloReactCommon.MutationFunction<GenerateApiKeyMutation, GenerateApiKeyMutationVariables>;

/**
 * __useGenerateApiKeyMutation__
 *
 * To run a mutation, you first call `useGenerateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateApiKeyMutation, { data, loading, error }] = useGenerateApiKeyMutation({
 *   variables: {
 *      description: // value for 'description'
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useGenerateApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateApiKeyMutation, GenerateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateApiKeyMutation, GenerateApiKeyMutationVariables>(GenerateApiKeyDocument, options);
      }
export type GenerateApiKeyMutationHookResult = ReturnType<typeof useGenerateApiKeyMutation>;
export type GenerateApiKeyMutationResult = ApolloReactCommon.MutationResult<GenerateApiKeyMutation>;
export type GenerateApiKeyMutationOptions = ApolloReactCommon.BaseMutationOptions<GenerateApiKeyMutation, GenerateApiKeyMutationVariables>;
export const DeleteApiKeyDocument = gql`
    mutation DeleteApiKey($id: String!) {
  deleteApiKey(input: {id: $id}) {
    success
  }
}
    `;
export type DeleteApiKeyMutationFn = ApolloReactCommon.MutationFunction<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;

/**
 * __useDeleteApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiKeyMutation, { data, loading, error }] = useDeleteApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>(DeleteApiKeyDocument, options);
      }
export type DeleteApiKeyMutationHookResult = ReturnType<typeof useDeleteApiKeyMutation>;
export type DeleteApiKeyMutationResult = ApolloReactCommon.MutationResult<DeleteApiKeyMutation>;
export type DeleteApiKeyMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;
export const CreateServiceAccountApiKeyDocument = gql`
    mutation CreateServiceAccountApiKey($serviceAccountId: ID!, $description: String) {
  createServiceAccountApiKey(
    input: {serviceAccountId: $serviceAccountId, description: $description}
  ) {
    apiKey {
      id
      name
      description
      apiKeyId
      createdAt
      expiresAt
      user {
        id
        name
      }
    }
    secretApiKey
    success
  }
}
    `;
export type CreateServiceAccountApiKeyMutationFn = ApolloReactCommon.MutationFunction<CreateServiceAccountApiKeyMutation, CreateServiceAccountApiKeyMutationVariables>;

/**
 * __useCreateServiceAccountApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateServiceAccountApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceAccountApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceAccountApiKeyMutation, { data, loading, error }] = useCreateServiceAccountApiKeyMutation({
 *   variables: {
 *      serviceAccountId: // value for 'serviceAccountId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateServiceAccountApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateServiceAccountApiKeyMutation, CreateServiceAccountApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateServiceAccountApiKeyMutation, CreateServiceAccountApiKeyMutationVariables>(CreateServiceAccountApiKeyDocument, options);
      }
export type CreateServiceAccountApiKeyMutationHookResult = ReturnType<typeof useCreateServiceAccountApiKeyMutation>;
export type CreateServiceAccountApiKeyMutationResult = ApolloReactCommon.MutationResult<CreateServiceAccountApiKeyMutation>;
export type CreateServiceAccountApiKeyMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateServiceAccountApiKeyMutation, CreateServiceAccountApiKeyMutationVariables>;
export const DeleteServiceAccountApiKeyDocument = gql`
    mutation DeleteServiceAccountApiKey($apiKeyId: String!, $serviceAccountId: ID!) {
  deleteServiceAccountApiKey(
    input: {apiKeyId: $apiKeyId, serviceAccountId: $serviceAccountId}
  ) {
    success
  }
}
    `;
export type DeleteServiceAccountApiKeyMutationFn = ApolloReactCommon.MutationFunction<DeleteServiceAccountApiKeyMutation, DeleteServiceAccountApiKeyMutationVariables>;

/**
 * __useDeleteServiceAccountApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteServiceAccountApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceAccountApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceAccountApiKeyMutation, { data, loading, error }] = useDeleteServiceAccountApiKeyMutation({
 *   variables: {
 *      apiKeyId: // value for 'apiKeyId'
 *      serviceAccountId: // value for 'serviceAccountId'
 *   },
 * });
 */
export function useDeleteServiceAccountApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteServiceAccountApiKeyMutation, DeleteServiceAccountApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteServiceAccountApiKeyMutation, DeleteServiceAccountApiKeyMutationVariables>(DeleteServiceAccountApiKeyDocument, options);
      }
export type DeleteServiceAccountApiKeyMutationHookResult = ReturnType<typeof useDeleteServiceAccountApiKeyMutation>;
export type DeleteServiceAccountApiKeyMutationResult = ApolloReactCommon.MutationResult<DeleteServiceAccountApiKeyMutation>;
export type DeleteServiceAccountApiKeyMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteServiceAccountApiKeyMutation, DeleteServiceAccountApiKeyMutationVariables>;
export const DeleteApiKeysDocument = gql`
    mutation DeleteApiKeys($keys: [DeleteApiKeyRefInput!]!) {
  deleteApiKeys(input: {keys: $keys}) {
    deletedCount
  }
}
    `;
export type DeleteApiKeysMutationFn = ApolloReactCommon.MutationFunction<DeleteApiKeysMutation, DeleteApiKeysMutationVariables>;

/**
 * __useDeleteApiKeysMutation__
 *
 * To run a mutation, you first call `useDeleteApiKeysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApiKeysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiKeysMutation, { data, loading, error }] = useDeleteApiKeysMutation({
 *   variables: {
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function useDeleteApiKeysMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteApiKeysMutation, DeleteApiKeysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteApiKeysMutation, DeleteApiKeysMutationVariables>(DeleteApiKeysDocument, options);
      }
export type DeleteApiKeysMutationHookResult = ReturnType<typeof useDeleteApiKeysMutation>;
export type DeleteApiKeysMutationResult = ApolloReactCommon.MutationResult<DeleteApiKeysMutation>;
export type DeleteApiKeysMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteApiKeysMutation, DeleteApiKeysMutationVariables>;
export const UpdateServiceAccountApiKeyDocument = gql`
    mutation UpdateServiceAccountApiKey($apiKeyId: String!, $serviceAccountId: ID!, $description: String!) {
  updateServiceAccountApiKey(
    input: {apiKeyId: $apiKeyId, serviceAccountId: $serviceAccountId, description: $description}
  ) {
    success
    apiKey {
      id
      description
    }
  }
}
    `;
export type UpdateServiceAccountApiKeyMutationFn = ApolloReactCommon.MutationFunction<UpdateServiceAccountApiKeyMutation, UpdateServiceAccountApiKeyMutationVariables>;

/**
 * __useUpdateServiceAccountApiKeyMutation__
 *
 * To run a mutation, you first call `useUpdateServiceAccountApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceAccountApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceAccountApiKeyMutation, { data, loading, error }] = useUpdateServiceAccountApiKeyMutation({
 *   variables: {
 *      apiKeyId: // value for 'apiKeyId'
 *      serviceAccountId: // value for 'serviceAccountId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateServiceAccountApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateServiceAccountApiKeyMutation, UpdateServiceAccountApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateServiceAccountApiKeyMutation, UpdateServiceAccountApiKeyMutationVariables>(UpdateServiceAccountApiKeyDocument, options);
      }
export type UpdateServiceAccountApiKeyMutationHookResult = ReturnType<typeof useUpdateServiceAccountApiKeyMutation>;
export type UpdateServiceAccountApiKeyMutationResult = ApolloReactCommon.MutationResult<UpdateServiceAccountApiKeyMutation>;
export type UpdateServiceAccountApiKeyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateServiceAccountApiKeyMutation, UpdateServiceAccountApiKeyMutationVariables>;
export const UpdateApiKeyDocument = gql`
    mutation UpdateApiKey($apiKeyId: String!, $description: String!) {
  updateApiKey(input: {id: $apiKeyId, description: $description}) {
    success
    apiKey {
      id
      description
    }
  }
}
    `;
export type UpdateApiKeyMutationFn = ApolloReactCommon.MutationFunction<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;

/**
 * __useUpdateApiKeyMutation__
 *
 * To run a mutation, you first call `useUpdateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApiKeyMutation, { data, loading, error }] = useUpdateApiKeyMutation({
 *   variables: {
 *      apiKeyId: // value for 'apiKeyId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>(UpdateApiKeyDocument, options);
      }
export type UpdateApiKeyMutationHookResult = ReturnType<typeof useUpdateApiKeyMutation>;
export type UpdateApiKeyMutationResult = ApolloReactCommon.MutationResult<UpdateApiKeyMutation>;
export type UpdateApiKeyMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;
export const OrganizationTeamsWithViewerRoleDocument = gql`
    query OrganizationTeamsWithViewerRole($orgName: String!) {
  organization(name: $orgName) {
    id
    name
    teams {
      id
      name
      members {
        id
        username
        role
        memberRole {
          ID
          name
          permissions {
            name
            groupName
            displayName
          }
        }
      }
    }
  }
  viewer {
    id
    username
  }
}
    `;

/**
 * __useOrganizationTeamsWithViewerRoleQuery__
 *
 * To run a query within a React component, call `useOrganizationTeamsWithViewerRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationTeamsWithViewerRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationTeamsWithViewerRoleQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationTeamsWithViewerRoleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables> & ({ variables: OrganizationTeamsWithViewerRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables>(OrganizationTeamsWithViewerRoleDocument, options);
      }
export function useOrganizationTeamsWithViewerRoleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables>(OrganizationTeamsWithViewerRoleDocument, options);
        }
// @ts-ignore
export function useOrganizationTeamsWithViewerRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables>;
export function useOrganizationTeamsWithViewerRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationTeamsWithViewerRoleQuery | undefined, OrganizationTeamsWithViewerRoleQueryVariables>;
export function useOrganizationTeamsWithViewerRoleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables>(OrganizationTeamsWithViewerRoleDocument, options);
        }
export type OrganizationTeamsWithViewerRoleQueryHookResult = ReturnType<typeof useOrganizationTeamsWithViewerRoleQuery>;
export type OrganizationTeamsWithViewerRoleLazyQueryHookResult = ReturnType<typeof useOrganizationTeamsWithViewerRoleLazyQuery>;
export type OrganizationTeamsWithViewerRoleSuspenseQueryHookResult = ReturnType<typeof useOrganizationTeamsWithViewerRoleSuspenseQuery>;
export type OrganizationTeamsWithViewerRoleQueryResult = ApolloReactCommon.QueryResult<OrganizationTeamsWithViewerRoleQuery, OrganizationTeamsWithViewerRoleQueryVariables>;
export const UpdateEntityDocument = gql`
    mutation UpdateEntity($entityName: String!, $defaultAccess: String, $privateOnly: Boolean, $codeSavingEnabled: Boolean, $settings: EntitySettingsInput) {
  updateEntity(
    input: {entity: $entityName, defaultAccess: $defaultAccess, privateOnly: $privateOnly, codeSavingEnabled: $codeSavingEnabled, settings: $settings}
  ) {
    entity {
      id
      defaultAccess
      privateOnly
      limits
      settings {
        hidden
        defaultCloudRegion {
          id
          provider
          region
        }
      }
    }
  }
}
    `;
export type UpdateEntityMutationFn = ApolloReactCommon.MutationFunction<UpdateEntityMutation, UpdateEntityMutationVariables>;

/**
 * __useUpdateEntityMutation__
 *
 * To run a mutation, you first call `useUpdateEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityMutation, { data, loading, error }] = useUpdateEntityMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      defaultAccess: // value for 'defaultAccess'
 *      privateOnly: // value for 'privateOnly'
 *      codeSavingEnabled: // value for 'codeSavingEnabled'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateEntityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEntityMutation, UpdateEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateEntityMutation, UpdateEntityMutationVariables>(UpdateEntityDocument, options);
      }
export type UpdateEntityMutationHookResult = ReturnType<typeof useUpdateEntityMutation>;
export type UpdateEntityMutationResult = ApolloReactCommon.MutationResult<UpdateEntityMutation>;
export type UpdateEntityMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateEntityMutation, UpdateEntityMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($email: String!) {
  resetPassword(input: {email: $email}) {
    success
  }
}
    `;
export type ResetPasswordMutationFn = ApolloReactCommon.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = ApolloReactCommon.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = ApolloReactCommon.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const ViewerAllProjectsWithPatternDocument = gql`
    query ViewerAllProjectsWithPattern($pattern: String, $limit: Int = 500) {
  viewer {
    id
    entity
    projects(first: $limit, pattern: $pattern) {
      edges {
        node {
          id
          name
          entityName
        }
      }
    }
  }
}
    `;

/**
 * __useViewerAllProjectsWithPatternQuery__
 *
 * To run a query within a React component, call `useViewerAllProjectsWithPatternQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerAllProjectsWithPatternQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerAllProjectsWithPatternQuery({
 *   variables: {
 *      pattern: // value for 'pattern'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useViewerAllProjectsWithPatternQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>(ViewerAllProjectsWithPatternDocument, options);
      }
export function useViewerAllProjectsWithPatternLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>(ViewerAllProjectsWithPatternDocument, options);
        }
// @ts-ignore
export function useViewerAllProjectsWithPatternSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>;
export function useViewerAllProjectsWithPatternSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerAllProjectsWithPatternQuery | undefined, ViewerAllProjectsWithPatternQueryVariables>;
export function useViewerAllProjectsWithPatternSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>(ViewerAllProjectsWithPatternDocument, options);
        }
export type ViewerAllProjectsWithPatternQueryHookResult = ReturnType<typeof useViewerAllProjectsWithPatternQuery>;
export type ViewerAllProjectsWithPatternLazyQueryHookResult = ReturnType<typeof useViewerAllProjectsWithPatternLazyQuery>;
export type ViewerAllProjectsWithPatternSuspenseQueryHookResult = ReturnType<typeof useViewerAllProjectsWithPatternSuspenseQuery>;
export type ViewerAllProjectsWithPatternQueryResult = ApolloReactCommon.QueryResult<ViewerAllProjectsWithPatternQuery, ViewerAllProjectsWithPatternQueryVariables>;
export const ViewerDocument = gql`
    query Viewer($includeStorage: Boolean = false) {
  viewer {
    id
    analyticsId
    admin
    email
    entity
    defaultFramework
    photoUrl
    flags
    code
    username
    createdAt
    name
    accountType
    userInfo
    hideTeamsFromPublic
    limits
    nvidiaAccountLinkedAt
    signupRequired
    personalEntityDisabled
    isNvidiaAccountLinked
    instanceAdminTeamAccessDisabled
    teams(first: 100) {
      edges {
        node {
          id
          name
          photoUrl
          defaultAccess
          readOnlyAdmin
          privateOnly
          isTeam
          entityType
          organizationId
        }
      }
    }
    organizations {
      id
      name
      orgType
      subscriptions {
        id
        subscriptionType
      }
    }
    defaultEntity {
      id
      name
    }
    userEntity {
      id
      name
      defaultAccess
      codeSavingEnabled
      storageBytes @include(if: $includeStorage)
      settings {
        defaultCloudRegion {
          id
          provider
          region
        }
      }
      isTeam
      defaultAlerts {
        id
        condition {
          __typename
          ... on FinishedRunCondition {
            success
          }
          ... on StoppedRunCondition {
            minimumRunDuration
          }
        }
        subscriptions {
          __typename
          ... on EmailSubscription {
            id
          }
          ... on SlackChannelSubscription {
            id
          }
        }
      }
      integrations {
        edges {
          node {
            id
            __typename
            ... on SlackIntegration {
              teamName
              channelName
            }
          }
        }
      }
      claimedEntities {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useViewerQuery__
 *
 * To run a query within a React component, call `useViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerQuery({
 *   variables: {
 *      includeStorage: // value for 'includeStorage'
 *   },
 * });
 */
export function useViewerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
      }
export function useViewerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
        }
// @ts-ignore
export function useViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerQuery, ViewerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerQuery, ViewerQueryVariables>;
export function useViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerQuery, ViewerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerQuery | undefined, ViewerQueryVariables>;
export function useViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerQuery, ViewerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerQuery, ViewerQueryVariables>(ViewerDocument, options);
        }
export type ViewerQueryHookResult = ReturnType<typeof useViewerQuery>;
export type ViewerLazyQueryHookResult = ReturnType<typeof useViewerLazyQuery>;
export type ViewerSuspenseQueryHookResult = ReturnType<typeof useViewerSuspenseQuery>;
export type ViewerQueryResult = ApolloReactCommon.QueryResult<ViewerQuery, ViewerQueryVariables>;
export const ViewerPhotoUrlDocument = gql`
    query ViewerPhotoURL {
  viewer {
    id
    photoUrl
  }
}
    `;

/**
 * __useViewerPhotoUrlQuery__
 *
 * To run a query within a React component, call `useViewerPhotoUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerPhotoUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerPhotoUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerPhotoUrlQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>(ViewerPhotoUrlDocument, options);
      }
export function useViewerPhotoUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>(ViewerPhotoUrlDocument, options);
        }
// @ts-ignore
export function useViewerPhotoUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>;
export function useViewerPhotoUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerPhotoUrlQuery | undefined, ViewerPhotoUrlQueryVariables>;
export function useViewerPhotoUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>(ViewerPhotoUrlDocument, options);
        }
export type ViewerPhotoUrlQueryHookResult = ReturnType<typeof useViewerPhotoUrlQuery>;
export type ViewerPhotoUrlLazyQueryHookResult = ReturnType<typeof useViewerPhotoUrlLazyQuery>;
export type ViewerPhotoUrlSuspenseQueryHookResult = ReturnType<typeof useViewerPhotoUrlSuspenseQuery>;
export type ViewerPhotoUrlQueryResult = ApolloReactCommon.QueryResult<ViewerPhotoUrlQuery, ViewerPhotoUrlQueryVariables>;
export const ViewerFeatureFlagsDocument = gql`
    query viewerFeatureFlags($rampIDType: RampIDType!) {
  viewer {
    id
    featureFlags(rampIDType: $rampIDType) {
      rampKey
      isEnabled
    }
  }
}
    `;

/**
 * __useViewerFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useViewerFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerFeatureFlagsQuery({
 *   variables: {
 *      rampIDType: // value for 'rampIDType'
 *   },
 * });
 */
export function useViewerFeatureFlagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables> & ({ variables: ViewerFeatureFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>(ViewerFeatureFlagsDocument, options);
      }
export function useViewerFeatureFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>(ViewerFeatureFlagsDocument, options);
        }
// @ts-ignore
export function useViewerFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>;
export function useViewerFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerFeatureFlagsQuery | undefined, ViewerFeatureFlagsQueryVariables>;
export function useViewerFeatureFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>(ViewerFeatureFlagsDocument, options);
        }
export type ViewerFeatureFlagsQueryHookResult = ReturnType<typeof useViewerFeatureFlagsQuery>;
export type ViewerFeatureFlagsLazyQueryHookResult = ReturnType<typeof useViewerFeatureFlagsLazyQuery>;
export type ViewerFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useViewerFeatureFlagsSuspenseQuery>;
export type ViewerFeatureFlagsQueryResult = ApolloReactCommon.QueryResult<ViewerFeatureFlagsQuery, ViewerFeatureFlagsQueryVariables>;
export const UpsertViewDocument = gql`
    mutation upsertView($id: ID, $entityName: String, $projectName: String, $type: String, $name: String, $description: String, $spec: String!, $specIsGzipped: Boolean) {
  upsertView(
    input: {id: $id, entityName: $entityName, projectName: $projectName, name: $name, description: $description, type: $type, spec: $spec, specIsGzipped: $specIsGzipped}
  ) {
    view {
      id
      ...ViewFragment
    }
    inserted
  }
}
    ${ViewFragmentFragmentDoc}`;
export type UpsertViewMutationFn = ApolloReactCommon.MutationFunction<UpsertViewMutation, UpsertViewMutationVariables>;

/**
 * __useUpsertViewMutation__
 *
 * To run a mutation, you first call `useUpsertViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertViewMutation, { data, loading, error }] = useUpsertViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      spec: // value for 'spec'
 *      specIsGzipped: // value for 'specIsGzipped'
 *   },
 * });
 */
export function useUpsertViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertViewMutation, UpsertViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertViewMutation, UpsertViewMutationVariables>(UpsertViewDocument, options);
      }
export type UpsertViewMutationHookResult = ReturnType<typeof useUpsertViewMutation>;
export type UpsertViewMutationResult = ApolloReactCommon.MutationResult<UpsertViewMutation>;
export type UpsertViewMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertViewMutation, UpsertViewMutationVariables>;
export const DeleteViewDocument = gql`
    mutation deleteView($id: ID) {
  deleteView(input: {id: $id}) {
    success
  }
}
    `;
export type DeleteViewMutationFn = ApolloReactCommon.MutationFunction<DeleteViewMutation, DeleteViewMutationVariables>;

/**
 * __useDeleteViewMutation__
 *
 * To run a mutation, you first call `useDeleteViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteViewMutation, { data, loading, error }] = useDeleteViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteViewMutation, DeleteViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteViewMutation, DeleteViewMutationVariables>(DeleteViewDocument, options);
      }
export type DeleteViewMutationHookResult = ReturnType<typeof useDeleteViewMutation>;
export type DeleteViewMutationResult = ApolloReactCommon.MutationResult<DeleteViewMutation>;
export type DeleteViewMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteViewMutation, DeleteViewMutationVariables>;
export const CreateSharedViewDocument = gql`
    mutation createSharedView($entityName: String!, $name: String!, $type: String!, $description: String, $spec: String!) {
  upsertSharedView(
    input: {entityName: $entityName, name: $name, type: $type, description: $description, spec: $spec}
  ) {
    view {
      id
      ...ViewFragment
    }
  }
}
    ${ViewFragmentFragmentDoc}`;
export type CreateSharedViewMutationFn = ApolloReactCommon.MutationFunction<CreateSharedViewMutation, CreateSharedViewMutationVariables>;

/**
 * __useCreateSharedViewMutation__
 *
 * To run a mutation, you first call `useCreateSharedViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSharedViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSharedViewMutation, { data, loading, error }] = useCreateSharedViewMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      description: // value for 'description'
 *      spec: // value for 'spec'
 *   },
 * });
 */
export function useCreateSharedViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSharedViewMutation, CreateSharedViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSharedViewMutation, CreateSharedViewMutationVariables>(CreateSharedViewDocument, options);
      }
export type CreateSharedViewMutationHookResult = ReturnType<typeof useCreateSharedViewMutation>;
export type CreateSharedViewMutationResult = ApolloReactCommon.MutationResult<CreateSharedViewMutation>;
export type CreateSharedViewMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSharedViewMutation, CreateSharedViewMutationVariables>;
export const ViewParentDocument = gql`
    query viewParent($id: ID!) {
  viewParent(id: $id) {
    id
    displayName
  }
}
    `;

/**
 * __useViewParentQuery__
 *
 * To run a query within a React component, call `useViewParentQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewParentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewParentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewParentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewParentQuery, ViewParentQueryVariables> & ({ variables: ViewParentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewParentQuery, ViewParentQueryVariables>(ViewParentDocument, options);
      }
export function useViewParentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewParentQuery, ViewParentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewParentQuery, ViewParentQueryVariables>(ViewParentDocument, options);
        }
// @ts-ignore
export function useViewParentSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewParentQuery, ViewParentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewParentQuery, ViewParentQueryVariables>;
export function useViewParentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewParentQuery, ViewParentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewParentQuery | undefined, ViewParentQueryVariables>;
export function useViewParentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewParentQuery, ViewParentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewParentQuery, ViewParentQueryVariables>(ViewParentDocument, options);
        }
export type ViewParentQueryHookResult = ReturnType<typeof useViewParentQuery>;
export type ViewParentLazyQueryHookResult = ReturnType<typeof useViewParentLazyQuery>;
export type ViewParentSuspenseQueryHookResult = ReturnType<typeof useViewParentSuspenseQuery>;
export type ViewParentQueryResult = ApolloReactCommon.QueryResult<ViewParentQuery, ViewParentQueryVariables>;
export const ViewChildrenDocument = gql`
    query viewChildren($id: ID!) {
  view(id: $id) {
    id
    children {
      edges {
        node {
          id
          displayName
          user {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useViewChildrenQuery__
 *
 * To run a query within a React component, call `useViewChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewChildrenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewChildrenQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewChildrenQuery, ViewChildrenQueryVariables> & ({ variables: ViewChildrenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewChildrenQuery, ViewChildrenQueryVariables>(ViewChildrenDocument, options);
      }
export function useViewChildrenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewChildrenQuery, ViewChildrenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewChildrenQuery, ViewChildrenQueryVariables>(ViewChildrenDocument, options);
        }
// @ts-ignore
export function useViewChildrenSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewChildrenQuery, ViewChildrenQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewChildrenQuery, ViewChildrenQueryVariables>;
export function useViewChildrenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewChildrenQuery, ViewChildrenQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewChildrenQuery | undefined, ViewChildrenQueryVariables>;
export function useViewChildrenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewChildrenQuery, ViewChildrenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewChildrenQuery, ViewChildrenQueryVariables>(ViewChildrenDocument, options);
        }
export type ViewChildrenQueryHookResult = ReturnType<typeof useViewChildrenQuery>;
export type ViewChildrenLazyQueryHookResult = ReturnType<typeof useViewChildrenLazyQuery>;
export type ViewChildrenSuspenseQueryHookResult = ReturnType<typeof useViewChildrenSuspenseQuery>;
export type ViewChildrenQueryResult = ApolloReactCommon.QueryResult<ViewChildrenQuery, ViewChildrenQueryVariables>;
export const AcademicApplicationOrgInfoDocument = gql`
    query AcademicApplicationOrgInfo($organizationID: ID!) {
  organization(id: $organizationID) {
    id
    name
    subscriptions {
      id
      plan {
        id
        name
        planType
      }
    }
  }
}
    `;

/**
 * __useAcademicApplicationOrgInfoQuery__
 *
 * To run a query within a React component, call `useAcademicApplicationOrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAcademicApplicationOrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAcademicApplicationOrgInfoQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useAcademicApplicationOrgInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables> & ({ variables: AcademicApplicationOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables>(AcademicApplicationOrgInfoDocument, options);
      }
export function useAcademicApplicationOrgInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables>(AcademicApplicationOrgInfoDocument, options);
        }
// @ts-ignore
export function useAcademicApplicationOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables>;
export function useAcademicApplicationOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AcademicApplicationOrgInfoQuery | undefined, AcademicApplicationOrgInfoQueryVariables>;
export function useAcademicApplicationOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables>(AcademicApplicationOrgInfoDocument, options);
        }
export type AcademicApplicationOrgInfoQueryHookResult = ReturnType<typeof useAcademicApplicationOrgInfoQuery>;
export type AcademicApplicationOrgInfoLazyQueryHookResult = ReturnType<typeof useAcademicApplicationOrgInfoLazyQuery>;
export type AcademicApplicationOrgInfoSuspenseQueryHookResult = ReturnType<typeof useAcademicApplicationOrgInfoSuspenseQuery>;
export type AcademicApplicationOrgInfoQueryResult = ApolloReactCommon.QueryResult<AcademicApplicationOrgInfoQuery, AcademicApplicationOrgInfoQueryVariables>;
export const MostActiveMembersDocument = gql`
    query MostActiveMembers($organizationId: ID!, $startDate: DateTime!, $endDate: DateTime!) {
  organization(id: $organizationId) {
    id
    members {
      id
      name
      username
      photoUrl
      daysActive(start: $startDate, end: $endDate)
      lastActiveAt
    }
  }
}
    `;

/**
 * __useMostActiveMembersQuery__
 *
 * To run a query within a React component, call `useMostActiveMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMostActiveMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMostActiveMembersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useMostActiveMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MostActiveMembersQuery, MostActiveMembersQueryVariables> & ({ variables: MostActiveMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MostActiveMembersQuery, MostActiveMembersQueryVariables>(MostActiveMembersDocument, options);
      }
export function useMostActiveMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MostActiveMembersQuery, MostActiveMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MostActiveMembersQuery, MostActiveMembersQueryVariables>(MostActiveMembersDocument, options);
        }
// @ts-ignore
export function useMostActiveMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MostActiveMembersQuery, MostActiveMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MostActiveMembersQuery, MostActiveMembersQueryVariables>;
export function useMostActiveMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MostActiveMembersQuery, MostActiveMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MostActiveMembersQuery | undefined, MostActiveMembersQueryVariables>;
export function useMostActiveMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MostActiveMembersQuery, MostActiveMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MostActiveMembersQuery, MostActiveMembersQueryVariables>(MostActiveMembersDocument, options);
        }
export type MostActiveMembersQueryHookResult = ReturnType<typeof useMostActiveMembersQuery>;
export type MostActiveMembersLazyQueryHookResult = ReturnType<typeof useMostActiveMembersLazyQuery>;
export type MostActiveMembersSuspenseQueryHookResult = ReturnType<typeof useMostActiveMembersSuspenseQuery>;
export type MostActiveMembersQueryResult = ApolloReactCommon.QueryResult<MostActiveMembersQuery, MostActiveMembersQueryVariables>;
export const OrganizationMemberActivityDocument = gql`
    query OrganizationMemberActivity($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    members {
      id
      lastActiveAt
    }
    activeUsersForRange {
      last7Days
      last30Days
      last90Days
      last6Months
      last12Months
    }
  }
}
    `;

/**
 * __useOrganizationMemberActivityQuery__
 *
 * To run a query within a React component, call `useOrganizationMemberActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMemberActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMemberActivityQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationMemberActivityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables> & ({ variables: OrganizationMemberActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables>(OrganizationMemberActivityDocument, options);
      }
export function useOrganizationMemberActivityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables>(OrganizationMemberActivityDocument, options);
        }
// @ts-ignore
export function useOrganizationMemberActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables>;
export function useOrganizationMemberActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationMemberActivityQuery | undefined, OrganizationMemberActivityQueryVariables>;
export function useOrganizationMemberActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables>(OrganizationMemberActivityDocument, options);
        }
export type OrganizationMemberActivityQueryHookResult = ReturnType<typeof useOrganizationMemberActivityQuery>;
export type OrganizationMemberActivityLazyQueryHookResult = ReturnType<typeof useOrganizationMemberActivityLazyQuery>;
export type OrganizationMemberActivitySuspenseQueryHookResult = ReturnType<typeof useOrganizationMemberActivitySuspenseQuery>;
export type OrganizationMemberActivityQueryResult = ApolloReactCommon.QueryResult<OrganizationMemberActivityQuery, OrganizationMemberActivityQueryVariables>;
export const TeamUsageChartDataDocument = gql`
    query TeamUsageChartData($orgName: String!, $usageType: UsageType!, $usagePeriod: UsagePeriod!, $viewType: ViewType!) {
  organization(name: $orgName) {
    id
    usageByPeriod(
      usageType: $usageType
      usagePeriod: $usagePeriod
      viewType: $viewType
    ) {
      dailyAverageUsage
      intervals {
        startDate
        endDate
        stackTotal
        entities {
          entityName
          value
        }
      }
    }
  }
}
    `;

/**
 * __useTeamUsageChartDataQuery__
 *
 * To run a query within a React component, call `useTeamUsageChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamUsageChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamUsageChartDataQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      usageType: // value for 'usageType'
 *      usagePeriod: // value for 'usagePeriod'
 *      viewType: // value for 'viewType'
 *   },
 * });
 */
export function useTeamUsageChartDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamUsageChartDataQuery, TeamUsageChartDataQueryVariables> & ({ variables: TeamUsageChartDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamUsageChartDataQuery, TeamUsageChartDataQueryVariables>(TeamUsageChartDataDocument, options);
      }
export function useTeamUsageChartDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamUsageChartDataQuery, TeamUsageChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamUsageChartDataQuery, TeamUsageChartDataQueryVariables>(TeamUsageChartDataDocument, options);
        }
// @ts-ignore
export function useTeamUsageChartDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamUsageChartDataQuery, TeamUsageChartDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamUsageChartDataQuery, TeamUsageChartDataQueryVariables>;
export function useTeamUsageChartDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamUsageChartDataQuery, TeamUsageChartDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamUsageChartDataQuery | undefined, TeamUsageChartDataQueryVariables>;
export function useTeamUsageChartDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamUsageChartDataQuery, TeamUsageChartDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamUsageChartDataQuery, TeamUsageChartDataQueryVariables>(TeamUsageChartDataDocument, options);
        }
export type TeamUsageChartDataQueryHookResult = ReturnType<typeof useTeamUsageChartDataQuery>;
export type TeamUsageChartDataLazyQueryHookResult = ReturnType<typeof useTeamUsageChartDataLazyQuery>;
export type TeamUsageChartDataSuspenseQueryHookResult = ReturnType<typeof useTeamUsageChartDataSuspenseQuery>;
export type TeamUsageChartDataQueryResult = ApolloReactCommon.QueryResult<TeamUsageChartDataQuery, TeamUsageChartDataQueryVariables>;
export const CreateAlertThresholdDocument = gql`
    mutation CreateAlertThreshold($input: CreateAlertThresholdInput!) {
  createAlertThreshold(input: $input) {
    success
    alertThreshold {
      id
      type
      value
      emailSent
      isEnabled
      product
    }
  }
}
    `;
export type CreateAlertThresholdMutationFn = ApolloReactCommon.MutationFunction<CreateAlertThresholdMutation, CreateAlertThresholdMutationVariables>;

/**
 * __useCreateAlertThresholdMutation__
 *
 * To run a mutation, you first call `useCreateAlertThresholdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlertThresholdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlertThresholdMutation, { data, loading, error }] = useCreateAlertThresholdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAlertThresholdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAlertThresholdMutation, CreateAlertThresholdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAlertThresholdMutation, CreateAlertThresholdMutationVariables>(CreateAlertThresholdDocument, options);
      }
export type CreateAlertThresholdMutationHookResult = ReturnType<typeof useCreateAlertThresholdMutation>;
export type CreateAlertThresholdMutationResult = ApolloReactCommon.MutationResult<CreateAlertThresholdMutation>;
export type CreateAlertThresholdMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAlertThresholdMutation, CreateAlertThresholdMutationVariables>;
export const DeleteAlertThresholdDocument = gql`
    mutation DeleteAlertThreshold($input: DeleteAlertThresholdInput!) {
  deleteAlertThreshold(input: $input) {
    success
  }
}
    `;
export type DeleteAlertThresholdMutationFn = ApolloReactCommon.MutationFunction<DeleteAlertThresholdMutation, DeleteAlertThresholdMutationVariables>;

/**
 * __useDeleteAlertThresholdMutation__
 *
 * To run a mutation, you first call `useDeleteAlertThresholdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlertThresholdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlertThresholdMutation, { data, loading, error }] = useDeleteAlertThresholdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAlertThresholdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAlertThresholdMutation, DeleteAlertThresholdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAlertThresholdMutation, DeleteAlertThresholdMutationVariables>(DeleteAlertThresholdDocument, options);
      }
export type DeleteAlertThresholdMutationHookResult = ReturnType<typeof useDeleteAlertThresholdMutation>;
export type DeleteAlertThresholdMutationResult = ApolloReactCommon.MutationResult<DeleteAlertThresholdMutation>;
export type DeleteAlertThresholdMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAlertThresholdMutation, DeleteAlertThresholdMutationVariables>;
export const UpdateAlertThresholdDocument = gql`
    mutation UpdateAlertThreshold($input: UpdateAlertThresholdInput!) {
  updateAlertThreshold(input: $input) {
    success
    alertThreshold {
      id
      isEnabled
    }
  }
}
    `;
export type UpdateAlertThresholdMutationFn = ApolloReactCommon.MutationFunction<UpdateAlertThresholdMutation, UpdateAlertThresholdMutationVariables>;

/**
 * __useUpdateAlertThresholdMutation__
 *
 * To run a mutation, you first call `useUpdateAlertThresholdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlertThresholdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlertThresholdMutation, { data, loading, error }] = useUpdateAlertThresholdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAlertThresholdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAlertThresholdMutation, UpdateAlertThresholdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAlertThresholdMutation, UpdateAlertThresholdMutationVariables>(UpdateAlertThresholdDocument, options);
      }
export type UpdateAlertThresholdMutationHookResult = ReturnType<typeof useUpdateAlertThresholdMutation>;
export type UpdateAlertThresholdMutationResult = ApolloReactCommon.MutationResult<UpdateAlertThresholdMutation>;
export type UpdateAlertThresholdMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAlertThresholdMutation, UpdateAlertThresholdMutationVariables>;
export const AlertsTabOrgInfoDocument = gql`
    query AlertsTabOrgInfo($orgName: String!) {
  organization(name: $orgName) {
    id
    name
    alertThresholds {
      id
      type
      value
      emailSent
      isEnabled
      product
    }
  }
}
    `;

/**
 * __useAlertsTabOrgInfoQuery__
 *
 * To run a query within a React component, call `useAlertsTabOrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertsTabOrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertsTabOrgInfoQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useAlertsTabOrgInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables> & ({ variables: AlertsTabOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables>(AlertsTabOrgInfoDocument, options);
      }
export function useAlertsTabOrgInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables>(AlertsTabOrgInfoDocument, options);
        }
// @ts-ignore
export function useAlertsTabOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables>;
export function useAlertsTabOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AlertsTabOrgInfoQuery | undefined, AlertsTabOrgInfoQueryVariables>;
export function useAlertsTabOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables>(AlertsTabOrgInfoDocument, options);
        }
export type AlertsTabOrgInfoQueryHookResult = ReturnType<typeof useAlertsTabOrgInfoQuery>;
export type AlertsTabOrgInfoLazyQueryHookResult = ReturnType<typeof useAlertsTabOrgInfoLazyQuery>;
export type AlertsTabOrgInfoSuspenseQueryHookResult = ReturnType<typeof useAlertsTabOrgInfoSuspenseQuery>;
export type AlertsTabOrgInfoQueryResult = ApolloReactCommon.QueryResult<AlertsTabOrgInfoQuery, AlertsTabOrgInfoQueryVariables>;
export const CurrentBillingPeriodUsageSectionOrgInfoDocument = gql`
    query CurrentBillingPeriodUsageSectionOrgInfo($orgName: String!) {
  organization(name: $orgName) {
    id
    name
    createdAt
    usedSeats
    stripeBillingInfo {
      cancelAtPeriodEnd
      currentPeriodEnd
    }
    teams {
      id
      name
    }
    subscriptions {
      id
      billingPeriodStart
      billingPeriodEnd
      subscriptionType
      seats
      plan {
        id
        name
        planType
      }
    }
  }
}
    `;

/**
 * __useCurrentBillingPeriodUsageSectionOrgInfoQuery__
 *
 * To run a query within a React component, call `useCurrentBillingPeriodUsageSectionOrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentBillingPeriodUsageSectionOrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentBillingPeriodUsageSectionOrgInfoQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useCurrentBillingPeriodUsageSectionOrgInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables> & ({ variables: CurrentBillingPeriodUsageSectionOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>(CurrentBillingPeriodUsageSectionOrgInfoDocument, options);
      }
export function useCurrentBillingPeriodUsageSectionOrgInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>(CurrentBillingPeriodUsageSectionOrgInfoDocument, options);
        }
// @ts-ignore
export function useCurrentBillingPeriodUsageSectionOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>;
export function useCurrentBillingPeriodUsageSectionOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CurrentBillingPeriodUsageSectionOrgInfoQuery | undefined, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>;
export function useCurrentBillingPeriodUsageSectionOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>(CurrentBillingPeriodUsageSectionOrgInfoDocument, options);
        }
export type CurrentBillingPeriodUsageSectionOrgInfoQueryHookResult = ReturnType<typeof useCurrentBillingPeriodUsageSectionOrgInfoQuery>;
export type CurrentBillingPeriodUsageSectionOrgInfoLazyQueryHookResult = ReturnType<typeof useCurrentBillingPeriodUsageSectionOrgInfoLazyQuery>;
export type CurrentBillingPeriodUsageSectionOrgInfoSuspenseQueryHookResult = ReturnType<typeof useCurrentBillingPeriodUsageSectionOrgInfoSuspenseQuery>;
export type CurrentBillingPeriodUsageSectionOrgInfoQueryResult = ApolloReactCommon.QueryResult<CurrentBillingPeriodUsageSectionOrgInfoQuery, CurrentBillingPeriodUsageSectionOrgInfoQueryVariables>;
export const EnterpriseBillingPeriodOrgInfoDocument = gql`
    query EnterpriseBillingPeriodOrgInfo($orgName: String!) {
  organization(name: $orgName) {
    id
    weaveEnterpriseSubscription {
      billingPeriodStart
      billingPeriodEnd
    }
  }
}
    `;

/**
 * __useEnterpriseBillingPeriodOrgInfoQuery__
 *
 * To run a query within a React component, call `useEnterpriseBillingPeriodOrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnterpriseBillingPeriodOrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnterpriseBillingPeriodOrgInfoQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useEnterpriseBillingPeriodOrgInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables> & ({ variables: EnterpriseBillingPeriodOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables>(EnterpriseBillingPeriodOrgInfoDocument, options);
      }
export function useEnterpriseBillingPeriodOrgInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables>(EnterpriseBillingPeriodOrgInfoDocument, options);
        }
// @ts-ignore
export function useEnterpriseBillingPeriodOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables>;
export function useEnterpriseBillingPeriodOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EnterpriseBillingPeriodOrgInfoQuery | undefined, EnterpriseBillingPeriodOrgInfoQueryVariables>;
export function useEnterpriseBillingPeriodOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables>(EnterpriseBillingPeriodOrgInfoDocument, options);
        }
export type EnterpriseBillingPeriodOrgInfoQueryHookResult = ReturnType<typeof useEnterpriseBillingPeriodOrgInfoQuery>;
export type EnterpriseBillingPeriodOrgInfoLazyQueryHookResult = ReturnType<typeof useEnterpriseBillingPeriodOrgInfoLazyQuery>;
export type EnterpriseBillingPeriodOrgInfoSuspenseQueryHookResult = ReturnType<typeof useEnterpriseBillingPeriodOrgInfoSuspenseQuery>;
export type EnterpriseBillingPeriodOrgInfoQueryResult = ApolloReactCommon.QueryResult<EnterpriseBillingPeriodOrgInfoQuery, EnterpriseBillingPeriodOrgInfoQueryVariables>;
export const UsageTotalInfoDocument = gql`
    query UsageTotalInfo($orgName: String!, $usageType: UsageType!, $intervalMarkers: [DateTime!]!) {
  organization(name: $orgName) {
    id
    createdAt
    usageTotal(usageType: $usageType, intervalMarkers: $intervalMarkers)
  }
}
    `;

/**
 * __useUsageTotalInfoQuery__
 *
 * To run a query within a React component, call `useUsageTotalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsageTotalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsageTotalInfoQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      usageType: // value for 'usageType'
 *      intervalMarkers: // value for 'intervalMarkers'
 *   },
 * });
 */
export function useUsageTotalInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UsageTotalInfoQuery, UsageTotalInfoQueryVariables> & ({ variables: UsageTotalInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsageTotalInfoQuery, UsageTotalInfoQueryVariables>(UsageTotalInfoDocument, options);
      }
export function useUsageTotalInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsageTotalInfoQuery, UsageTotalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsageTotalInfoQuery, UsageTotalInfoQueryVariables>(UsageTotalInfoDocument, options);
        }
// @ts-ignore
export function useUsageTotalInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UsageTotalInfoQuery, UsageTotalInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsageTotalInfoQuery, UsageTotalInfoQueryVariables>;
export function useUsageTotalInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsageTotalInfoQuery, UsageTotalInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsageTotalInfoQuery | undefined, UsageTotalInfoQueryVariables>;
export function useUsageTotalInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsageTotalInfoQuery, UsageTotalInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UsageTotalInfoQuery, UsageTotalInfoQueryVariables>(UsageTotalInfoDocument, options);
        }
export type UsageTotalInfoQueryHookResult = ReturnType<typeof useUsageTotalInfoQuery>;
export type UsageTotalInfoLazyQueryHookResult = ReturnType<typeof useUsageTotalInfoLazyQuery>;
export type UsageTotalInfoSuspenseQueryHookResult = ReturnType<typeof useUsageTotalInfoSuspenseQuery>;
export type UsageTotalInfoQueryResult = ApolloReactCommon.QueryResult<UsageTotalInfoQuery, UsageTotalInfoQueryVariables>;
export const CurrentPlanPageOrgInfoDocument = gql`
    query CurrentPlanPageOrgInfo($organizationID: ID!) {
  organization(id: $organizationID) {
    id
    name
    usedSeats
    createdAt
    subscriptions {
      id
      status
      seats
      plan {
        id
        planType
        name
      }
    }
    teams {
      id
      name
    }
    stripeBillingInfo {
      currentPeriodEnd
    }
  }
}
    `;

/**
 * __useCurrentPlanPageOrgInfoQuery__
 *
 * To run a query within a React component, call `useCurrentPlanPageOrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentPlanPageOrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentPlanPageOrgInfoQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useCurrentPlanPageOrgInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables> & ({ variables: CurrentPlanPageOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables>(CurrentPlanPageOrgInfoDocument, options);
      }
export function useCurrentPlanPageOrgInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables>(CurrentPlanPageOrgInfoDocument, options);
        }
// @ts-ignore
export function useCurrentPlanPageOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables>;
export function useCurrentPlanPageOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CurrentPlanPageOrgInfoQuery | undefined, CurrentPlanPageOrgInfoQueryVariables>;
export function useCurrentPlanPageOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables>(CurrentPlanPageOrgInfoDocument, options);
        }
export type CurrentPlanPageOrgInfoQueryHookResult = ReturnType<typeof useCurrentPlanPageOrgInfoQuery>;
export type CurrentPlanPageOrgInfoLazyQueryHookResult = ReturnType<typeof useCurrentPlanPageOrgInfoLazyQuery>;
export type CurrentPlanPageOrgInfoSuspenseQueryHookResult = ReturnType<typeof useCurrentPlanPageOrgInfoSuspenseQuery>;
export type CurrentPlanPageOrgInfoQueryResult = ApolloReactCommon.QueryResult<CurrentPlanPageOrgInfoQuery, CurrentPlanPageOrgInfoQueryVariables>;
export const PrimaryPlanCardV3OrgInfoDocument = gql`
    query PrimaryPlanCardV3OrgInfo($organizationID: ID!) {
  organization(id: $organizationID) {
    id
    name
    usedSeats
    createdAt
    teams {
      id
      name
      computeHours
    }
    subscriptions {
      id
      expiresAt
      seats
      billingPeriodStart
      billingPeriodEnd
      subscriptionType
      status
      discount {
        start
        end
        coupon {
          id
          amountOff
          percentOff
          duration
          currency
          name
        }
      }
      plan {
        id
        displayName
        planType
        name
        stripePrice {
          amount
        }
        billingInterval
        unitPrice
      }
    }
  }
}
    `;

/**
 * __usePrimaryPlanCardV3OrgInfoQuery__
 *
 * To run a query within a React component, call `usePrimaryPlanCardV3OrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrimaryPlanCardV3OrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimaryPlanCardV3OrgInfoQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function usePrimaryPlanCardV3OrgInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables> & ({ variables: PrimaryPlanCardV3OrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables>(PrimaryPlanCardV3OrgInfoDocument, options);
      }
export function usePrimaryPlanCardV3OrgInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables>(PrimaryPlanCardV3OrgInfoDocument, options);
        }
// @ts-ignore
export function usePrimaryPlanCardV3OrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables>;
export function usePrimaryPlanCardV3OrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PrimaryPlanCardV3OrgInfoQuery | undefined, PrimaryPlanCardV3OrgInfoQueryVariables>;
export function usePrimaryPlanCardV3OrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables>(PrimaryPlanCardV3OrgInfoDocument, options);
        }
export type PrimaryPlanCardV3OrgInfoQueryHookResult = ReturnType<typeof usePrimaryPlanCardV3OrgInfoQuery>;
export type PrimaryPlanCardV3OrgInfoLazyQueryHookResult = ReturnType<typeof usePrimaryPlanCardV3OrgInfoLazyQuery>;
export type PrimaryPlanCardV3OrgInfoSuspenseQueryHookResult = ReturnType<typeof usePrimaryPlanCardV3OrgInfoSuspenseQuery>;
export type PrimaryPlanCardV3OrgInfoQueryResult = ApolloReactCommon.QueryResult<PrimaryPlanCardV3OrgInfoQuery, PrimaryPlanCardV3OrgInfoQueryVariables>;
export const StoragePlanCardV2OrgInfoDocument = gql`
    query StoragePlanCardV2OrgInfo($organizationID: ID!) {
  organization(id: $organizationID) {
    id
    name
    createdAt
    teams {
      id
      storageBytes
      referenceBytes
    }
    subscriptions {
      id
      plan {
        id
        name
        planType
      }
      billingPeriodStart
      billingPeriodEnd
      subscriptionType
    }
  }
}
    `;

/**
 * __useStoragePlanCardV2OrgInfoQuery__
 *
 * To run a query within a React component, call `useStoragePlanCardV2OrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoragePlanCardV2OrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoragePlanCardV2OrgInfoQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useStoragePlanCardV2OrgInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables> & ({ variables: StoragePlanCardV2OrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables>(StoragePlanCardV2OrgInfoDocument, options);
      }
export function useStoragePlanCardV2OrgInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables>(StoragePlanCardV2OrgInfoDocument, options);
        }
// @ts-ignore
export function useStoragePlanCardV2OrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables>;
export function useStoragePlanCardV2OrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StoragePlanCardV2OrgInfoQuery | undefined, StoragePlanCardV2OrgInfoQueryVariables>;
export function useStoragePlanCardV2OrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables>(StoragePlanCardV2OrgInfoDocument, options);
        }
export type StoragePlanCardV2OrgInfoQueryHookResult = ReturnType<typeof useStoragePlanCardV2OrgInfoQuery>;
export type StoragePlanCardV2OrgInfoLazyQueryHookResult = ReturnType<typeof useStoragePlanCardV2OrgInfoLazyQuery>;
export type StoragePlanCardV2OrgInfoSuspenseQueryHookResult = ReturnType<typeof useStoragePlanCardV2OrgInfoSuspenseQuery>;
export type StoragePlanCardV2OrgInfoQueryResult = ApolloReactCommon.QueryResult<StoragePlanCardV2OrgInfoQuery, StoragePlanCardV2OrgInfoQueryVariables>;
export const ServerCurrentBillingPeriodUsageSectionDocument = gql`
    query ServerCurrentBillingPeriodUsageSection {
  serverInfo {
    weaveLimits {
      weaveLimitBytes
      weaveOverageCostCents
      weaveOverageUnit
    }
    contractStartDate
  }
}
    `;

/**
 * __useServerCurrentBillingPeriodUsageSectionQuery__
 *
 * To run a query within a React component, call `useServerCurrentBillingPeriodUsageSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useServerCurrentBillingPeriodUsageSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServerCurrentBillingPeriodUsageSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useServerCurrentBillingPeriodUsageSectionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>(ServerCurrentBillingPeriodUsageSectionDocument, options);
      }
export function useServerCurrentBillingPeriodUsageSectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>(ServerCurrentBillingPeriodUsageSectionDocument, options);
        }
// @ts-ignore
export function useServerCurrentBillingPeriodUsageSectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>;
export function useServerCurrentBillingPeriodUsageSectionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ServerCurrentBillingPeriodUsageSectionQuery | undefined, ServerCurrentBillingPeriodUsageSectionQueryVariables>;
export function useServerCurrentBillingPeriodUsageSectionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>(ServerCurrentBillingPeriodUsageSectionDocument, options);
        }
export type ServerCurrentBillingPeriodUsageSectionQueryHookResult = ReturnType<typeof useServerCurrentBillingPeriodUsageSectionQuery>;
export type ServerCurrentBillingPeriodUsageSectionLazyQueryHookResult = ReturnType<typeof useServerCurrentBillingPeriodUsageSectionLazyQuery>;
export type ServerCurrentBillingPeriodUsageSectionSuspenseQueryHookResult = ReturnType<typeof useServerCurrentBillingPeriodUsageSectionSuspenseQuery>;
export type ServerCurrentBillingPeriodUsageSectionQueryResult = ApolloReactCommon.QueryResult<ServerCurrentBillingPeriodUsageSectionQuery, ServerCurrentBillingPeriodUsageSectionQueryVariables>;
export const TotalUsageSectionOrgInfoDocument = gql`
    query TotalUsageSectionOrgInfo($organizationID: ID!) {
  organization(id: $organizationID) {
    id
    usedSeats
    subscriptions {
      id
      privileges
      seats
      subscriptionType
      billingPeriodEnd
      plan {
        id
        name
        planType
      }
    }
    teams {
      id
      computeHours
      storageBytes
      referenceBytes
    }
  }
}
    `;

/**
 * __useTotalUsageSectionOrgInfoQuery__
 *
 * To run a query within a React component, call `useTotalUsageSectionOrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalUsageSectionOrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalUsageSectionOrgInfoQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useTotalUsageSectionOrgInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables> & ({ variables: TotalUsageSectionOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables>(TotalUsageSectionOrgInfoDocument, options);
      }
export function useTotalUsageSectionOrgInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables>(TotalUsageSectionOrgInfoDocument, options);
        }
// @ts-ignore
export function useTotalUsageSectionOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables>;
export function useTotalUsageSectionOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TotalUsageSectionOrgInfoQuery | undefined, TotalUsageSectionOrgInfoQueryVariables>;
export function useTotalUsageSectionOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables>(TotalUsageSectionOrgInfoDocument, options);
        }
export type TotalUsageSectionOrgInfoQueryHookResult = ReturnType<typeof useTotalUsageSectionOrgInfoQuery>;
export type TotalUsageSectionOrgInfoLazyQueryHookResult = ReturnType<typeof useTotalUsageSectionOrgInfoLazyQuery>;
export type TotalUsageSectionOrgInfoSuspenseQueryHookResult = ReturnType<typeof useTotalUsageSectionOrgInfoSuspenseQuery>;
export type TotalUsageSectionOrgInfoQueryResult = ApolloReactCommon.QueryResult<TotalUsageSectionOrgInfoQuery, TotalUsageSectionOrgInfoQueryVariables>;
export const StorageTableDocument = gql`
    query StorageTable($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    name
    teams {
      id
      name
      storageBytes
      storageTree {
        id
      }
      projects {
        edges {
          node {
            id
            storageBytes
          }
        }
      }
    }
  }
}
    `;

/**
 * __useStorageTableQuery__
 *
 * To run a query within a React component, call `useStorageTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorageTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorageTableQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useStorageTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StorageTableQuery, StorageTableQueryVariables> & ({ variables: StorageTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StorageTableQuery, StorageTableQueryVariables>(StorageTableDocument, options);
      }
export function useStorageTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StorageTableQuery, StorageTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StorageTableQuery, StorageTableQueryVariables>(StorageTableDocument, options);
        }
// @ts-ignore
export function useStorageTableSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<StorageTableQuery, StorageTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StorageTableQuery, StorageTableQueryVariables>;
export function useStorageTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StorageTableQuery, StorageTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StorageTableQuery | undefined, StorageTableQueryVariables>;
export function useStorageTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StorageTableQuery, StorageTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<StorageTableQuery, StorageTableQueryVariables>(StorageTableDocument, options);
        }
export type StorageTableQueryHookResult = ReturnType<typeof useStorageTableQuery>;
export type StorageTableLazyQueryHookResult = ReturnType<typeof useStorageTableLazyQuery>;
export type StorageTableSuspenseQueryHookResult = ReturnType<typeof useStorageTableSuspenseQuery>;
export type StorageTableQueryResult = ApolloReactCommon.QueryResult<StorageTableQuery, StorageTableQueryVariables>;
export const ServiceAccountDrawerOrgTeamsDocument = gql`
    query ServiceAccountDrawerOrgTeams($orgName: String!) {
  organization(name: $orgName) {
    id
    teams {
      id
      name
    }
  }
}
    `;

/**
 * __useServiceAccountDrawerOrgTeamsQuery__
 *
 * To run a query within a React component, call `useServiceAccountDrawerOrgTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceAccountDrawerOrgTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceAccountDrawerOrgTeamsQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useServiceAccountDrawerOrgTeamsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ServiceAccountDrawerOrgTeamsQuery, ServiceAccountDrawerOrgTeamsQueryVariables> & ({ variables: ServiceAccountDrawerOrgTeamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ServiceAccountDrawerOrgTeamsQuery, ServiceAccountDrawerOrgTeamsQueryVariables>(ServiceAccountDrawerOrgTeamsDocument, options);
      }
export function useServiceAccountDrawerOrgTeamsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ServiceAccountDrawerOrgTeamsQuery, ServiceAccountDrawerOrgTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ServiceAccountDrawerOrgTeamsQuery, ServiceAccountDrawerOrgTeamsQueryVariables>(ServiceAccountDrawerOrgTeamsDocument, options);
        }
// @ts-ignore
export function useServiceAccountDrawerOrgTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ServiceAccountDrawerOrgTeamsQuery, ServiceAccountDrawerOrgTeamsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ServiceAccountDrawerOrgTeamsQuery, ServiceAccountDrawerOrgTeamsQueryVariables>;
export function useServiceAccountDrawerOrgTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ServiceAccountDrawerOrgTeamsQuery, ServiceAccountDrawerOrgTeamsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ServiceAccountDrawerOrgTeamsQuery | undefined, ServiceAccountDrawerOrgTeamsQueryVariables>;
export function useServiceAccountDrawerOrgTeamsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ServiceAccountDrawerOrgTeamsQuery, ServiceAccountDrawerOrgTeamsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ServiceAccountDrawerOrgTeamsQuery, ServiceAccountDrawerOrgTeamsQueryVariables>(ServiceAccountDrawerOrgTeamsDocument, options);
        }
export type ServiceAccountDrawerOrgTeamsQueryHookResult = ReturnType<typeof useServiceAccountDrawerOrgTeamsQuery>;
export type ServiceAccountDrawerOrgTeamsLazyQueryHookResult = ReturnType<typeof useServiceAccountDrawerOrgTeamsLazyQuery>;
export type ServiceAccountDrawerOrgTeamsSuspenseQueryHookResult = ReturnType<typeof useServiceAccountDrawerOrgTeamsSuspenseQuery>;
export type ServiceAccountDrawerOrgTeamsQueryResult = ApolloReactCommon.QueryResult<ServiceAccountDrawerOrgTeamsQuery, ServiceAccountDrawerOrgTeamsQueryVariables>;
export const DefaultEntityForDomainCaptureDropdownDocument = gql`
    query DefaultEntityForDomainCaptureDropdown($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    flags
    teams {
      id
      name
      settings {
        openToMatchingOrgEmailDomainUsers
      }
    }
  }
}
    `;

/**
 * __useDefaultEntityForDomainCaptureDropdownQuery__
 *
 * To run a query within a React component, call `useDefaultEntityForDomainCaptureDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultEntityForDomainCaptureDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultEntityForDomainCaptureDropdownQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDefaultEntityForDomainCaptureDropdownQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables> & ({ variables: DefaultEntityForDomainCaptureDropdownQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables>(DefaultEntityForDomainCaptureDropdownDocument, options);
      }
export function useDefaultEntityForDomainCaptureDropdownLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables>(DefaultEntityForDomainCaptureDropdownDocument, options);
        }
// @ts-ignore
export function useDefaultEntityForDomainCaptureDropdownSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables>;
export function useDefaultEntityForDomainCaptureDropdownSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DefaultEntityForDomainCaptureDropdownQuery | undefined, DefaultEntityForDomainCaptureDropdownQueryVariables>;
export function useDefaultEntityForDomainCaptureDropdownSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables>(DefaultEntityForDomainCaptureDropdownDocument, options);
        }
export type DefaultEntityForDomainCaptureDropdownQueryHookResult = ReturnType<typeof useDefaultEntityForDomainCaptureDropdownQuery>;
export type DefaultEntityForDomainCaptureDropdownLazyQueryHookResult = ReturnType<typeof useDefaultEntityForDomainCaptureDropdownLazyQuery>;
export type DefaultEntityForDomainCaptureDropdownSuspenseQueryHookResult = ReturnType<typeof useDefaultEntityForDomainCaptureDropdownSuspenseQuery>;
export type DefaultEntityForDomainCaptureDropdownQueryResult = ApolloReactCommon.QueryResult<DefaultEntityForDomainCaptureDropdownQuery, DefaultEntityForDomainCaptureDropdownQueryVariables>;
export const OrganizationDefaultModelsSeatDocument = gql`
    query OrganizationDefaultModelsSeat($orgName: String!) {
  organization(name: $orgName) {
    id
    flags
    subscriptions {
      id
      privileges
      plan {
        id
        planType
      }
    }
  }
}
    `;

/**
 * __useOrganizationDefaultModelsSeatQuery__
 *
 * To run a query within a React component, call `useOrganizationDefaultModelsSeatQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDefaultModelsSeatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationDefaultModelsSeatQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationDefaultModelsSeatQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables> & ({ variables: OrganizationDefaultModelsSeatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables>(OrganizationDefaultModelsSeatDocument, options);
      }
export function useOrganizationDefaultModelsSeatLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables>(OrganizationDefaultModelsSeatDocument, options);
        }
// @ts-ignore
export function useOrganizationDefaultModelsSeatSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables>;
export function useOrganizationDefaultModelsSeatSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationDefaultModelsSeatQuery | undefined, OrganizationDefaultModelsSeatQueryVariables>;
export function useOrganizationDefaultModelsSeatSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables>(OrganizationDefaultModelsSeatDocument, options);
        }
export type OrganizationDefaultModelsSeatQueryHookResult = ReturnType<typeof useOrganizationDefaultModelsSeatQuery>;
export type OrganizationDefaultModelsSeatLazyQueryHookResult = ReturnType<typeof useOrganizationDefaultModelsSeatLazyQuery>;
export type OrganizationDefaultModelsSeatSuspenseQueryHookResult = ReturnType<typeof useOrganizationDefaultModelsSeatSuspenseQuery>;
export type OrganizationDefaultModelsSeatQueryResult = ApolloReactCommon.QueryResult<OrganizationDefaultModelsSeatQuery, OrganizationDefaultModelsSeatQueryVariables>;
export const OrganizationDomainCaptureSettingDocument = gql`
    query OrganizationDomainCaptureSetting($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    flags
    teams {
      id
      settings {
        openToMatchingOrgEmailDomainUsers
      }
    }
  }
}
    `;

/**
 * __useOrganizationDomainCaptureSettingQuery__
 *
 * To run a query within a React component, call `useOrganizationDomainCaptureSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDomainCaptureSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationDomainCaptureSettingQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationDomainCaptureSettingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables> & ({ variables: OrganizationDomainCaptureSettingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables>(OrganizationDomainCaptureSettingDocument, options);
      }
export function useOrganizationDomainCaptureSettingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables>(OrganizationDomainCaptureSettingDocument, options);
        }
// @ts-ignore
export function useOrganizationDomainCaptureSettingSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables>;
export function useOrganizationDomainCaptureSettingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationDomainCaptureSettingQuery | undefined, OrganizationDomainCaptureSettingQueryVariables>;
export function useOrganizationDomainCaptureSettingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables>(OrganizationDomainCaptureSettingDocument, options);
        }
export type OrganizationDomainCaptureSettingQueryHookResult = ReturnType<typeof useOrganizationDomainCaptureSettingQuery>;
export type OrganizationDomainCaptureSettingLazyQueryHookResult = ReturnType<typeof useOrganizationDomainCaptureSettingLazyQuery>;
export type OrganizationDomainCaptureSettingSuspenseQueryHookResult = ReturnType<typeof useOrganizationDomainCaptureSettingSuspenseQuery>;
export type OrganizationDomainCaptureSettingQueryResult = ApolloReactCommon.QueryResult<OrganizationDomainCaptureSettingQuery, OrganizationDomainCaptureSettingQueryVariables>;
export const ViewerDomainClaimBlockingReasonDocument = gql`
    query ViewerDomainClaimBlockingReason($orgID: ID!) {
  viewer {
    id
    domainClaimBlockingReason(orgId: $orgID)
  }
}
    `;

/**
 * __useViewerDomainClaimBlockingReasonQuery__
 *
 * To run a query within a React component, call `useViewerDomainClaimBlockingReasonQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerDomainClaimBlockingReasonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerDomainClaimBlockingReasonQuery({
 *   variables: {
 *      orgID: // value for 'orgID'
 *   },
 * });
 */
export function useViewerDomainClaimBlockingReasonQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables> & ({ variables: ViewerDomainClaimBlockingReasonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables>(ViewerDomainClaimBlockingReasonDocument, options);
      }
export function useViewerDomainClaimBlockingReasonLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables>(ViewerDomainClaimBlockingReasonDocument, options);
        }
// @ts-ignore
export function useViewerDomainClaimBlockingReasonSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables>;
export function useViewerDomainClaimBlockingReasonSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerDomainClaimBlockingReasonQuery | undefined, ViewerDomainClaimBlockingReasonQueryVariables>;
export function useViewerDomainClaimBlockingReasonSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables>(ViewerDomainClaimBlockingReasonDocument, options);
        }
export type ViewerDomainClaimBlockingReasonQueryHookResult = ReturnType<typeof useViewerDomainClaimBlockingReasonQuery>;
export type ViewerDomainClaimBlockingReasonLazyQueryHookResult = ReturnType<typeof useViewerDomainClaimBlockingReasonLazyQuery>;
export type ViewerDomainClaimBlockingReasonSuspenseQueryHookResult = ReturnType<typeof useViewerDomainClaimBlockingReasonSuspenseQuery>;
export type ViewerDomainClaimBlockingReasonQueryResult = ApolloReactCommon.QueryResult<ViewerDomainClaimBlockingReasonQuery, ViewerDomainClaimBlockingReasonQueryVariables>;
export const OrganizationTeamsWithDomainCaptureEnabledDocument = gql`
    query OrganizationTeamsWithDomainCaptureEnabled($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    flags
    teams {
      id
      name
      settings {
        openToMatchingOrgEmailDomainUsers
      }
      memberCount
    }
  }
}
    `;

/**
 * __useOrganizationTeamsWithDomainCaptureEnabledQuery__
 *
 * To run a query within a React component, call `useOrganizationTeamsWithDomainCaptureEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationTeamsWithDomainCaptureEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationTeamsWithDomainCaptureEnabledQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationTeamsWithDomainCaptureEnabledQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables> & ({ variables: OrganizationTeamsWithDomainCaptureEnabledQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>(OrganizationTeamsWithDomainCaptureEnabledDocument, options);
      }
export function useOrganizationTeamsWithDomainCaptureEnabledLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>(OrganizationTeamsWithDomainCaptureEnabledDocument, options);
        }
// @ts-ignore
export function useOrganizationTeamsWithDomainCaptureEnabledSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>;
export function useOrganizationTeamsWithDomainCaptureEnabledSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationTeamsWithDomainCaptureEnabledQuery | undefined, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>;
export function useOrganizationTeamsWithDomainCaptureEnabledSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>(OrganizationTeamsWithDomainCaptureEnabledDocument, options);
        }
export type OrganizationTeamsWithDomainCaptureEnabledQueryHookResult = ReturnType<typeof useOrganizationTeamsWithDomainCaptureEnabledQuery>;
export type OrganizationTeamsWithDomainCaptureEnabledLazyQueryHookResult = ReturnType<typeof useOrganizationTeamsWithDomainCaptureEnabledLazyQuery>;
export type OrganizationTeamsWithDomainCaptureEnabledSuspenseQueryHookResult = ReturnType<typeof useOrganizationTeamsWithDomainCaptureEnabledSuspenseQuery>;
export type OrganizationTeamsWithDomainCaptureEnabledQueryResult = ApolloReactCommon.QueryResult<OrganizationTeamsWithDomainCaptureEnabledQuery, OrganizationTeamsWithDomainCaptureEnabledQueryVariables>;
export const ViewerOrgTeamAccessDocument = gql`
    query ViewerOrgTeamAccess($orgName: String!, $viewerId: ID!, $username: String) {
  organization(name: $orgName) {
    id
    member(username: $username) {
      id
      role
    }
    teams {
      id
      name
      member(id: $viewerId) {
        id
        role
      }
    }
  }
}
    `;

/**
 * __useViewerOrgTeamAccessQuery__
 *
 * To run a query within a React component, call `useViewerOrgTeamAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerOrgTeamAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerOrgTeamAccessQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      viewerId: // value for 'viewerId'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useViewerOrgTeamAccessQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewerOrgTeamAccessQuery, ViewerOrgTeamAccessQueryVariables> & ({ variables: ViewerOrgTeamAccessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerOrgTeamAccessQuery, ViewerOrgTeamAccessQueryVariables>(ViewerOrgTeamAccessDocument, options);
      }
export function useViewerOrgTeamAccessLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerOrgTeamAccessQuery, ViewerOrgTeamAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerOrgTeamAccessQuery, ViewerOrgTeamAccessQueryVariables>(ViewerOrgTeamAccessDocument, options);
        }
// @ts-ignore
export function useViewerOrgTeamAccessSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerOrgTeamAccessQuery, ViewerOrgTeamAccessQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerOrgTeamAccessQuery, ViewerOrgTeamAccessQueryVariables>;
export function useViewerOrgTeamAccessSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerOrgTeamAccessQuery, ViewerOrgTeamAccessQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerOrgTeamAccessQuery | undefined, ViewerOrgTeamAccessQueryVariables>;
export function useViewerOrgTeamAccessSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerOrgTeamAccessQuery, ViewerOrgTeamAccessQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerOrgTeamAccessQuery, ViewerOrgTeamAccessQueryVariables>(ViewerOrgTeamAccessDocument, options);
        }
export type ViewerOrgTeamAccessQueryHookResult = ReturnType<typeof useViewerOrgTeamAccessQuery>;
export type ViewerOrgTeamAccessLazyQueryHookResult = ReturnType<typeof useViewerOrgTeamAccessLazyQuery>;
export type ViewerOrgTeamAccessSuspenseQueryHookResult = ReturnType<typeof useViewerOrgTeamAccessSuspenseQuery>;
export type ViewerOrgTeamAccessQueryResult = ApolloReactCommon.QueryResult<ViewerOrgTeamAccessQuery, ViewerOrgTeamAccessQueryVariables>;
export const EditOrgMembersModalDocument = gql`
    query EditOrgMembersModal($organizationID: ID!) {
  organization(id: $organizationID) {
    id
    name
    flags
    teams {
      id
      name
      settings {
        openToMatchingOrgEmailDomainUsers
      }
    }
    seatAvailability {
      seats
    }
    pendingInvites {
      id
      email
    }
    billingUser {
      id
      username
    }
    subscriptions {
      id
      seats
      plan {
        id
        unitPrice
        planType
        billingInterval
      }
    }
    members {
      id
      username
      role
      modelsSeat
      name
      user {
        id
        loggedInAt
      }
      teams {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useEditOrgMembersModalQuery__
 *
 * To run a query within a React component, call `useEditOrgMembersModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditOrgMembersModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditOrgMembersModalQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useEditOrgMembersModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables> & ({ variables: EditOrgMembersModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables>(EditOrgMembersModalDocument, options);
      }
export function useEditOrgMembersModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables>(EditOrgMembersModalDocument, options);
        }
// @ts-ignore
export function useEditOrgMembersModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables>;
export function useEditOrgMembersModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditOrgMembersModalQuery | undefined, EditOrgMembersModalQueryVariables>;
export function useEditOrgMembersModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables>(EditOrgMembersModalDocument, options);
        }
export type EditOrgMembersModalQueryHookResult = ReturnType<typeof useEditOrgMembersModalQuery>;
export type EditOrgMembersModalLazyQueryHookResult = ReturnType<typeof useEditOrgMembersModalLazyQuery>;
export type EditOrgMembersModalSuspenseQueryHookResult = ReturnType<typeof useEditOrgMembersModalSuspenseQuery>;
export type EditOrgMembersModalQueryResult = ApolloReactCommon.QueryResult<EditOrgMembersModalQuery, EditOrgMembersModalQueryVariables>;
export const IsEmailDomainClaimedAndShouldRedirectToSsoDocument = gql`
    query IsEmailDomainClaimedAndShouldRedirectToSSO {
  viewer {
    id
    isEmailDomainClaimedAndShouldRedirectToSSO
  }
}
    `;

/**
 * __useIsEmailDomainClaimedAndShouldRedirectToSsoQuery__
 *
 * To run a query within a React component, call `useIsEmailDomainClaimedAndShouldRedirectToSsoQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsEmailDomainClaimedAndShouldRedirectToSsoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsEmailDomainClaimedAndShouldRedirectToSsoQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsEmailDomainClaimedAndShouldRedirectToSsoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>(IsEmailDomainClaimedAndShouldRedirectToSsoDocument, options);
      }
export function useIsEmailDomainClaimedAndShouldRedirectToSsoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>(IsEmailDomainClaimedAndShouldRedirectToSsoDocument, options);
        }
// @ts-ignore
export function useIsEmailDomainClaimedAndShouldRedirectToSsoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>;
export function useIsEmailDomainClaimedAndShouldRedirectToSsoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IsEmailDomainClaimedAndShouldRedirectToSsoQuery | undefined, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>;
export function useIsEmailDomainClaimedAndShouldRedirectToSsoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>(IsEmailDomainClaimedAndShouldRedirectToSsoDocument, options);
        }
export type IsEmailDomainClaimedAndShouldRedirectToSsoQueryHookResult = ReturnType<typeof useIsEmailDomainClaimedAndShouldRedirectToSsoQuery>;
export type IsEmailDomainClaimedAndShouldRedirectToSsoLazyQueryHookResult = ReturnType<typeof useIsEmailDomainClaimedAndShouldRedirectToSsoLazyQuery>;
export type IsEmailDomainClaimedAndShouldRedirectToSsoSuspenseQueryHookResult = ReturnType<typeof useIsEmailDomainClaimedAndShouldRedirectToSsoSuspenseQuery>;
export type IsEmailDomainClaimedAndShouldRedirectToSsoQueryResult = ApolloReactCommon.QueryResult<IsEmailDomainClaimedAndShouldRedirectToSsoQuery, IsEmailDomainClaimedAndShouldRedirectToSsoQueryVariables>;
export const TeamPageShowcasedProjectsDocument = gql`
    query TeamPageShowcasedProjects($entityName: String!, $pattern: String, $first: Int = 20, $order: String = "-created_at") {
  projects(
    first: $first
    entityName: $entityName
    pattern: $pattern
    order: $order
  ) {
    edges {
      node {
        id
        name
        entityName
        description
        lastActive
        runCount
        access
        user {
          id
          username
        }
      }
    }
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useTeamPageShowcasedProjectsQuery__
 *
 * To run a query within a React component, call `useTeamPageShowcasedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamPageShowcasedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamPageShowcasedProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      pattern: // value for 'pattern'
 *      first: // value for 'first'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTeamPageShowcasedProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables> & ({ variables: TeamPageShowcasedProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables>(TeamPageShowcasedProjectsDocument, options);
      }
export function useTeamPageShowcasedProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables>(TeamPageShowcasedProjectsDocument, options);
        }
// @ts-ignore
export function useTeamPageShowcasedProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables>;
export function useTeamPageShowcasedProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamPageShowcasedProjectsQuery | undefined, TeamPageShowcasedProjectsQueryVariables>;
export function useTeamPageShowcasedProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables>(TeamPageShowcasedProjectsDocument, options);
        }
export type TeamPageShowcasedProjectsQueryHookResult = ReturnType<typeof useTeamPageShowcasedProjectsQuery>;
export type TeamPageShowcasedProjectsLazyQueryHookResult = ReturnType<typeof useTeamPageShowcasedProjectsLazyQuery>;
export type TeamPageShowcasedProjectsSuspenseQueryHookResult = ReturnType<typeof useTeamPageShowcasedProjectsSuspenseQuery>;
export type TeamPageShowcasedProjectsQueryResult = ApolloReactCommon.QueryResult<TeamPageShowcasedProjectsQuery, TeamPageShowcasedProjectsQueryVariables>;
export const ProfilePageShowcasedProjectsDocument = gql`
    query ProfilePageShowcasedProjects($username: String!, $pattern: String, $first: Int = 20, $order: String = "-created_at") {
  user(userName: $username) {
    id
    projects(first: $first, pattern: $pattern, order: $order) {
      edges {
        node {
          id
          name
          entityName
          access
          description
          totalRuns
          lastActive
          runCount
          user {
            id
            username
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProfilePageShowcasedProjectsQuery__
 *
 * To run a query within a React component, call `useProfilePageShowcasedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilePageShowcasedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilePageShowcasedProjectsQuery({
 *   variables: {
 *      username: // value for 'username'
 *      pattern: // value for 'pattern'
 *      first: // value for 'first'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useProfilePageShowcasedProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables> & ({ variables: ProfilePageShowcasedProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables>(ProfilePageShowcasedProjectsDocument, options);
      }
export function useProfilePageShowcasedProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables>(ProfilePageShowcasedProjectsDocument, options);
        }
// @ts-ignore
export function useProfilePageShowcasedProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables>;
export function useProfilePageShowcasedProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProfilePageShowcasedProjectsQuery | undefined, ProfilePageShowcasedProjectsQueryVariables>;
export function useProfilePageShowcasedProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables>(ProfilePageShowcasedProjectsDocument, options);
        }
export type ProfilePageShowcasedProjectsQueryHookResult = ReturnType<typeof useProfilePageShowcasedProjectsQuery>;
export type ProfilePageShowcasedProjectsLazyQueryHookResult = ReturnType<typeof useProfilePageShowcasedProjectsLazyQuery>;
export type ProfilePageShowcasedProjectsSuspenseQueryHookResult = ReturnType<typeof useProfilePageShowcasedProjectsSuspenseQuery>;
export type ProfilePageShowcasedProjectsQueryResult = ApolloReactCommon.QueryResult<ProfilePageShowcasedProjectsQuery, ProfilePageShowcasedProjectsQueryVariables>;
export const SimpleTestQueryDocument = gql`
    query SimpleTestQuery {
  serverInfo {
    pollingOK
  }
}
    `;

/**
 * __useSimpleTestQueryQuery__
 *
 * To run a query within a React component, call `useSimpleTestQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimpleTestQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimpleTestQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSimpleTestQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>(SimpleTestQueryDocument, options);
      }
export function useSimpleTestQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>(SimpleTestQueryDocument, options);
        }
// @ts-ignore
export function useSimpleTestQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>;
export function useSimpleTestQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SimpleTestQueryQuery | undefined, SimpleTestQueryQueryVariables>;
export function useSimpleTestQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>(SimpleTestQueryDocument, options);
        }
export type SimpleTestQueryQueryHookResult = ReturnType<typeof useSimpleTestQueryQuery>;
export type SimpleTestQueryLazyQueryHookResult = ReturnType<typeof useSimpleTestQueryLazyQuery>;
export type SimpleTestQuerySuspenseQueryHookResult = ReturnType<typeof useSimpleTestQuerySuspenseQuery>;
export type SimpleTestQueryQueryResult = ApolloReactCommon.QueryResult<SimpleTestQueryQuery, SimpleTestQueryQueryVariables>;
export const HistoricUsageOrganizationInfoDocument = gql`
    query HistoricUsageOrganizationInfo($orgName: String!) {
  organization(name: $orgName) {
    id
    members {
      id
      username
      role
    }
  }
}
    `;

/**
 * __useHistoricUsageOrganizationInfoQuery__
 *
 * To run a query within a React component, call `useHistoricUsageOrganizationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricUsageOrganizationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricUsageOrganizationInfoQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useHistoricUsageOrganizationInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables> & ({ variables: HistoricUsageOrganizationInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables>(HistoricUsageOrganizationInfoDocument, options);
      }
export function useHistoricUsageOrganizationInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables>(HistoricUsageOrganizationInfoDocument, options);
        }
// @ts-ignore
export function useHistoricUsageOrganizationInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables>;
export function useHistoricUsageOrganizationInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HistoricUsageOrganizationInfoQuery | undefined, HistoricUsageOrganizationInfoQueryVariables>;
export function useHistoricUsageOrganizationInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables>(HistoricUsageOrganizationInfoDocument, options);
        }
export type HistoricUsageOrganizationInfoQueryHookResult = ReturnType<typeof useHistoricUsageOrganizationInfoQuery>;
export type HistoricUsageOrganizationInfoLazyQueryHookResult = ReturnType<typeof useHistoricUsageOrganizationInfoLazyQuery>;
export type HistoricUsageOrganizationInfoSuspenseQueryHookResult = ReturnType<typeof useHistoricUsageOrganizationInfoSuspenseQuery>;
export type HistoricUsageOrganizationInfoQueryResult = ApolloReactCommon.QueryResult<HistoricUsageOrganizationInfoQuery, HistoricUsageOrganizationInfoQueryVariables>;
export const UsageTabInfoDocument = gql`
    query UsageTabInfo($orgName: String!, $usageType: UsageType!, $intervalMarkers: [DateTime!]!) {
  organization(name: $orgName) {
    id
    createdAt
    usage(usageType: $usageType, intervalMarkers: $intervalMarkers) {
      start
      end
      value
      projectName
      entityName
      ... on InferenceCostUsageAggregation {
        endpointName
        inputCount
        outputCount
        inputCost
        outputCost
        cachedCost
        uncachedCost
        cachedCount
        uncachedCount
      }
      ... on TrainingCostUsageAggregation {
        gpuModelID
        gpuDurationMs
      }
    }
  }
}
    `;

/**
 * __useUsageTabInfoQuery__
 *
 * To run a query within a React component, call `useUsageTabInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsageTabInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsageTabInfoQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      usageType: // value for 'usageType'
 *      intervalMarkers: // value for 'intervalMarkers'
 *   },
 * });
 */
export function useUsageTabInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UsageTabInfoQuery, UsageTabInfoQueryVariables> & ({ variables: UsageTabInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsageTabInfoQuery, UsageTabInfoQueryVariables>(UsageTabInfoDocument, options);
      }
export function useUsageTabInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsageTabInfoQuery, UsageTabInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsageTabInfoQuery, UsageTabInfoQueryVariables>(UsageTabInfoDocument, options);
        }
// @ts-ignore
export function useUsageTabInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UsageTabInfoQuery, UsageTabInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsageTabInfoQuery, UsageTabInfoQueryVariables>;
export function useUsageTabInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsageTabInfoQuery, UsageTabInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsageTabInfoQuery | undefined, UsageTabInfoQueryVariables>;
export function useUsageTabInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsageTabInfoQuery, UsageTabInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UsageTabInfoQuery, UsageTabInfoQueryVariables>(UsageTabInfoDocument, options);
        }
export type UsageTabInfoQueryHookResult = ReturnType<typeof useUsageTabInfoQuery>;
export type UsageTabInfoLazyQueryHookResult = ReturnType<typeof useUsageTabInfoLazyQuery>;
export type UsageTabInfoSuspenseQueryHookResult = ReturnType<typeof useUsageTabInfoSuspenseQuery>;
export type UsageTabInfoQueryResult = ApolloReactCommon.QueryResult<UsageTabInfoQuery, UsageTabInfoQueryVariables>;
export const GlobalUsageTabInfoDocument = gql`
    query GlobalUsageTabInfo($usageType: UsageType!, $intervalMarkers: [DateTime!]!) {
  usage(usageType: $usageType, intervalMarkers: $intervalMarkers) {
    start
    end
    value
    projectName
    entityName
    ... on InferenceCostUsageAggregation {
      endpointName
      inputCount
      outputCount
      inputCost
      outputCost
      cachedCost
      uncachedCost
      cachedCount
      uncachedCount
    }
    ... on TrainingCostUsageAggregation {
      gpuModelID
      gpuDurationMs
    }
  }
}
    `;

/**
 * __useGlobalUsageTabInfoQuery__
 *
 * To run a query within a React component, call `useGlobalUsageTabInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalUsageTabInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalUsageTabInfoQuery({
 *   variables: {
 *      usageType: // value for 'usageType'
 *      intervalMarkers: // value for 'intervalMarkers'
 *   },
 * });
 */
export function useGlobalUsageTabInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables> & ({ variables: GlobalUsageTabInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables>(GlobalUsageTabInfoDocument, options);
      }
export function useGlobalUsageTabInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables>(GlobalUsageTabInfoDocument, options);
        }
// @ts-ignore
export function useGlobalUsageTabInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables>;
export function useGlobalUsageTabInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GlobalUsageTabInfoQuery | undefined, GlobalUsageTabInfoQueryVariables>;
export function useGlobalUsageTabInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables>(GlobalUsageTabInfoDocument, options);
        }
export type GlobalUsageTabInfoQueryHookResult = ReturnType<typeof useGlobalUsageTabInfoQuery>;
export type GlobalUsageTabInfoLazyQueryHookResult = ReturnType<typeof useGlobalUsageTabInfoLazyQuery>;
export type GlobalUsageTabInfoSuspenseQueryHookResult = ReturnType<typeof useGlobalUsageTabInfoSuspenseQuery>;
export type GlobalUsageTabInfoQueryResult = ApolloReactCommon.QueryResult<GlobalUsageTabInfoQuery, GlobalUsageTabInfoQueryVariables>;
export const WeaveUsageInfoDocument = gql`
    query WeaveUsageInfo($orgName: String!, $usageType: UsageType!, $intervalMarkers: [DateTime!]!) {
  organization(name: $orgName) {
    id
    createdAt
    usageTotal(usageType: $usageType, intervalMarkers: $intervalMarkers)
  }
}
    `;

/**
 * __useWeaveUsageInfoQuery__
 *
 * To run a query within a React component, call `useWeaveUsageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeaveUsageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeaveUsageInfoQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      usageType: // value for 'usageType'
 *      intervalMarkers: // value for 'intervalMarkers'
 *   },
 * });
 */
export function useWeaveUsageInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables> & ({ variables: WeaveUsageInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables>(WeaveUsageInfoDocument, options);
      }
export function useWeaveUsageInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables>(WeaveUsageInfoDocument, options);
        }
// @ts-ignore
export function useWeaveUsageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables>;
export function useWeaveUsageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WeaveUsageInfoQuery | undefined, WeaveUsageInfoQueryVariables>;
export function useWeaveUsageInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables>(WeaveUsageInfoDocument, options);
        }
export type WeaveUsageInfoQueryHookResult = ReturnType<typeof useWeaveUsageInfoQuery>;
export type WeaveUsageInfoLazyQueryHookResult = ReturnType<typeof useWeaveUsageInfoLazyQuery>;
export type WeaveUsageInfoSuspenseQueryHookResult = ReturnType<typeof useWeaveUsageInfoSuspenseQuery>;
export type WeaveUsageInfoQueryResult = ApolloReactCommon.QueryResult<WeaveUsageInfoQuery, WeaveUsageInfoQueryVariables>;
export const HomepageProjectsDocument = gql`
    query HomepageProjects($first: Int = 50) {
  viewer {
    id
    projects(first: $first, order: "-created_at") {
      edges {
        node {
          id
          ...AccountProjectFragment
        }
      }
    }
  }
}
    ${AccountProjectFragmentFragmentDoc}`;

/**
 * __useHomepageProjectsQuery__
 *
 * To run a query within a React component, call `useHomepageProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomepageProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomepageProjectsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useHomepageProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HomepageProjectsQuery, HomepageProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HomepageProjectsQuery, HomepageProjectsQueryVariables>(HomepageProjectsDocument, options);
      }
export function useHomepageProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HomepageProjectsQuery, HomepageProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HomepageProjectsQuery, HomepageProjectsQueryVariables>(HomepageProjectsDocument, options);
        }
// @ts-ignore
export function useHomepageProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HomepageProjectsQuery, HomepageProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HomepageProjectsQuery, HomepageProjectsQueryVariables>;
export function useHomepageProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HomepageProjectsQuery, HomepageProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HomepageProjectsQuery | undefined, HomepageProjectsQueryVariables>;
export function useHomepageProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HomepageProjectsQuery, HomepageProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HomepageProjectsQuery, HomepageProjectsQueryVariables>(HomepageProjectsDocument, options);
        }
export type HomepageProjectsQueryHookResult = ReturnType<typeof useHomepageProjectsQuery>;
export type HomepageProjectsLazyQueryHookResult = ReturnType<typeof useHomepageProjectsLazyQuery>;
export type HomepageProjectsSuspenseQueryHookResult = ReturnType<typeof useHomepageProjectsSuspenseQuery>;
export type HomepageProjectsQueryResult = ApolloReactCommon.QueryResult<HomepageProjectsQuery, HomepageProjectsQueryVariables>;
export const ServerHomepageContentDocument = gql`
    query ServerHomepageContent($first: Int = 100, $orgName: String!, $userID: ID!) {
  organization(name: $orgName) {
    id
    teamRuns: latestRuns(excludeUserID: $userID) {
      edges {
        node {
          id
          ...RunsTableFragment
        }
      }
    }
  }
  viewer {
    id
    teams {
      edges {
        node {
          id
          myRuns: latestRuns(userID: $userID) {
            edges {
              node {
                id
                ...RunsTableFragment
              }
            }
          }
        }
      }
    }
    projects(first: $first, order: "-created_at") {
      edges {
        node {
          id
          ...AccountProjectFragment
        }
      }
    }
    views(viewType: "runs", first: $first) {
      edges {
        node {
          id
          ...ReportsTableFragment
        }
      }
    }
  }
}
    ${RunsTableFragmentFragmentDoc}
${AccountProjectFragmentFragmentDoc}
${ReportsTableFragmentFragmentDoc}`;

/**
 * __useServerHomepageContentQuery__
 *
 * To run a query within a React component, call `useServerHomepageContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useServerHomepageContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServerHomepageContentQuery({
 *   variables: {
 *      first: // value for 'first'
 *      orgName: // value for 'orgName'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useServerHomepageContentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ServerHomepageContentQuery, ServerHomepageContentQueryVariables> & ({ variables: ServerHomepageContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ServerHomepageContentQuery, ServerHomepageContentQueryVariables>(ServerHomepageContentDocument, options);
      }
export function useServerHomepageContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ServerHomepageContentQuery, ServerHomepageContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ServerHomepageContentQuery, ServerHomepageContentQueryVariables>(ServerHomepageContentDocument, options);
        }
// @ts-ignore
export function useServerHomepageContentSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ServerHomepageContentQuery, ServerHomepageContentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ServerHomepageContentQuery, ServerHomepageContentQueryVariables>;
export function useServerHomepageContentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ServerHomepageContentQuery, ServerHomepageContentQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ServerHomepageContentQuery | undefined, ServerHomepageContentQueryVariables>;
export function useServerHomepageContentSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ServerHomepageContentQuery, ServerHomepageContentQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ServerHomepageContentQuery, ServerHomepageContentQueryVariables>(ServerHomepageContentDocument, options);
        }
export type ServerHomepageContentQueryHookResult = ReturnType<typeof useServerHomepageContentQuery>;
export type ServerHomepageContentLazyQueryHookResult = ReturnType<typeof useServerHomepageContentLazyQuery>;
export type ServerHomepageContentSuspenseQueryHookResult = ReturnType<typeof useServerHomepageContentSuspenseQuery>;
export type ServerHomepageContentQueryResult = ApolloReactCommon.QueryResult<ServerHomepageContentQuery, ServerHomepageContentQueryVariables>;
export const DeletedRunsDocument = gql`
    query DeletedRuns($entityName: String!, $projectName: String!, $first: Int, $after: String, $filters: JSONString) {
  project(name: $projectName, entityName: $entityName) {
    id
    deletedRuns(first: $first, after: $after, filters: $filters) {
      edges {
        node {
          displayName
          name
          state
          deletedAt
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
      totalCount
    }
  }
}
    `;

/**
 * __useDeletedRunsQuery__
 *
 * To run a query within a React component, call `useDeletedRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeletedRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedRunsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDeletedRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DeletedRunsQuery, DeletedRunsQueryVariables> & ({ variables: DeletedRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DeletedRunsQuery, DeletedRunsQueryVariables>(DeletedRunsDocument, options);
      }
export function useDeletedRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DeletedRunsQuery, DeletedRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DeletedRunsQuery, DeletedRunsQueryVariables>(DeletedRunsDocument, options);
        }
// @ts-ignore
export function useDeletedRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DeletedRunsQuery, DeletedRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DeletedRunsQuery, DeletedRunsQueryVariables>;
export function useDeletedRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DeletedRunsQuery, DeletedRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DeletedRunsQuery | undefined, DeletedRunsQueryVariables>;
export function useDeletedRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DeletedRunsQuery, DeletedRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DeletedRunsQuery, DeletedRunsQueryVariables>(DeletedRunsDocument, options);
        }
export type DeletedRunsQueryHookResult = ReturnType<typeof useDeletedRunsQuery>;
export type DeletedRunsLazyQueryHookResult = ReturnType<typeof useDeletedRunsLazyQuery>;
export type DeletedRunsSuspenseQueryHookResult = ReturnType<typeof useDeletedRunsSuspenseQuery>;
export type DeletedRunsQueryResult = ApolloReactCommon.QueryResult<DeletedRunsQuery, DeletedRunsQueryVariables>;
export const TrialCardAccountExpirationDocument = gql`
    query TrialCardAccountExpiration($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    subscriptions {
      id
      expiresAt
      status
      plan {
        id
        name
        planType
      }
    }
  }
}
    `;

/**
 * __useTrialCardAccountExpirationQuery__
 *
 * To run a query within a React component, call `useTrialCardAccountExpirationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrialCardAccountExpirationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrialCardAccountExpirationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useTrialCardAccountExpirationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables> & ({ variables: TrialCardAccountExpirationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables>(TrialCardAccountExpirationDocument, options);
      }
export function useTrialCardAccountExpirationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables>(TrialCardAccountExpirationDocument, options);
        }
// @ts-ignore
export function useTrialCardAccountExpirationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables>;
export function useTrialCardAccountExpirationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TrialCardAccountExpirationQuery | undefined, TrialCardAccountExpirationQueryVariables>;
export function useTrialCardAccountExpirationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables>(TrialCardAccountExpirationDocument, options);
        }
export type TrialCardAccountExpirationQueryHookResult = ReturnType<typeof useTrialCardAccountExpirationQuery>;
export type TrialCardAccountExpirationLazyQueryHookResult = ReturnType<typeof useTrialCardAccountExpirationLazyQuery>;
export type TrialCardAccountExpirationSuspenseQueryHookResult = ReturnType<typeof useTrialCardAccountExpirationSuspenseQuery>;
export type TrialCardAccountExpirationQueryResult = ApolloReactCommon.QueryResult<TrialCardAccountExpirationQuery, TrialCardAccountExpirationQueryVariables>;
export const CreateProjectDrawerProjectDocument = gql`
    query CreateProjectDrawerProject($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    name
    entityName
    access
    description
    user {
      id
    }
    entity {
      id
      isTeam
      entityType
    }
  }
}
    `;

/**
 * __useCreateProjectDrawerProjectQuery__
 *
 * To run a query within a React component, call `useCreateProjectDrawerProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectDrawerProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateProjectDrawerProjectQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useCreateProjectDrawerProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CreateProjectDrawerProjectQuery, CreateProjectDrawerProjectQueryVariables> & ({ variables: CreateProjectDrawerProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreateProjectDrawerProjectQuery, CreateProjectDrawerProjectQueryVariables>(CreateProjectDrawerProjectDocument, options);
      }
export function useCreateProjectDrawerProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateProjectDrawerProjectQuery, CreateProjectDrawerProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreateProjectDrawerProjectQuery, CreateProjectDrawerProjectQueryVariables>(CreateProjectDrawerProjectDocument, options);
        }
// @ts-ignore
export function useCreateProjectDrawerProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CreateProjectDrawerProjectQuery, CreateProjectDrawerProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateProjectDrawerProjectQuery, CreateProjectDrawerProjectQueryVariables>;
export function useCreateProjectDrawerProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateProjectDrawerProjectQuery, CreateProjectDrawerProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateProjectDrawerProjectQuery | undefined, CreateProjectDrawerProjectQueryVariables>;
export function useCreateProjectDrawerProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateProjectDrawerProjectQuery, CreateProjectDrawerProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreateProjectDrawerProjectQuery, CreateProjectDrawerProjectQueryVariables>(CreateProjectDrawerProjectDocument, options);
        }
export type CreateProjectDrawerProjectQueryHookResult = ReturnType<typeof useCreateProjectDrawerProjectQuery>;
export type CreateProjectDrawerProjectLazyQueryHookResult = ReturnType<typeof useCreateProjectDrawerProjectLazyQuery>;
export type CreateProjectDrawerProjectSuspenseQueryHookResult = ReturnType<typeof useCreateProjectDrawerProjectSuspenseQuery>;
export type CreateProjectDrawerProjectQueryResult = ApolloReactCommon.QueryResult<CreateProjectDrawerProjectQuery, CreateProjectDrawerProjectQueryVariables>;
export const MarimoNotebookRuntimePageDocument = gql`
    query MarimoNotebookRuntimePage($id: ID!) {
  notebook(id: $id) {
    id
    ...NotebookTable_Notebook
  }
}
    ${NotebookTable_NotebookFragmentDoc}`;

/**
 * __useMarimoNotebookRuntimePageQuery__
 *
 * To run a query within a React component, call `useMarimoNotebookRuntimePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarimoNotebookRuntimePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarimoNotebookRuntimePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarimoNotebookRuntimePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MarimoNotebookRuntimePageQuery, MarimoNotebookRuntimePageQueryVariables> & ({ variables: MarimoNotebookRuntimePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MarimoNotebookRuntimePageQuery, MarimoNotebookRuntimePageQueryVariables>(MarimoNotebookRuntimePageDocument, options);
      }
export function useMarimoNotebookRuntimePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MarimoNotebookRuntimePageQuery, MarimoNotebookRuntimePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MarimoNotebookRuntimePageQuery, MarimoNotebookRuntimePageQueryVariables>(MarimoNotebookRuntimePageDocument, options);
        }
// @ts-ignore
export function useMarimoNotebookRuntimePageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MarimoNotebookRuntimePageQuery, MarimoNotebookRuntimePageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MarimoNotebookRuntimePageQuery, MarimoNotebookRuntimePageQueryVariables>;
export function useMarimoNotebookRuntimePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MarimoNotebookRuntimePageQuery, MarimoNotebookRuntimePageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MarimoNotebookRuntimePageQuery | undefined, MarimoNotebookRuntimePageQueryVariables>;
export function useMarimoNotebookRuntimePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MarimoNotebookRuntimePageQuery, MarimoNotebookRuntimePageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MarimoNotebookRuntimePageQuery, MarimoNotebookRuntimePageQueryVariables>(MarimoNotebookRuntimePageDocument, options);
        }
export type MarimoNotebookRuntimePageQueryHookResult = ReturnType<typeof useMarimoNotebookRuntimePageQuery>;
export type MarimoNotebookRuntimePageLazyQueryHookResult = ReturnType<typeof useMarimoNotebookRuntimePageLazyQuery>;
export type MarimoNotebookRuntimePageSuspenseQueryHookResult = ReturnType<typeof useMarimoNotebookRuntimePageSuspenseQuery>;
export type MarimoNotebookRuntimePageQueryResult = ApolloReactCommon.QueryResult<MarimoNotebookRuntimePageQuery, MarimoNotebookRuntimePageQueryVariables>;
export const MarimoNotebookViewPageDocument = gql`
    query MarimoNotebookViewPage($id: ID!) {
  notebook(id: $id) {
    id
    staticOutputUrl
    ...NotebookTable_Notebook
  }
}
    ${NotebookTable_NotebookFragmentDoc}`;

/**
 * __useMarimoNotebookViewPageQuery__
 *
 * To run a query within a React component, call `useMarimoNotebookViewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarimoNotebookViewPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarimoNotebookViewPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarimoNotebookViewPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MarimoNotebookViewPageQuery, MarimoNotebookViewPageQueryVariables> & ({ variables: MarimoNotebookViewPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MarimoNotebookViewPageQuery, MarimoNotebookViewPageQueryVariables>(MarimoNotebookViewPageDocument, options);
      }
export function useMarimoNotebookViewPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MarimoNotebookViewPageQuery, MarimoNotebookViewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MarimoNotebookViewPageQuery, MarimoNotebookViewPageQueryVariables>(MarimoNotebookViewPageDocument, options);
        }
// @ts-ignore
export function useMarimoNotebookViewPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MarimoNotebookViewPageQuery, MarimoNotebookViewPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MarimoNotebookViewPageQuery, MarimoNotebookViewPageQueryVariables>;
export function useMarimoNotebookViewPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MarimoNotebookViewPageQuery, MarimoNotebookViewPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MarimoNotebookViewPageQuery | undefined, MarimoNotebookViewPageQueryVariables>;
export function useMarimoNotebookViewPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MarimoNotebookViewPageQuery, MarimoNotebookViewPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MarimoNotebookViewPageQuery, MarimoNotebookViewPageQueryVariables>(MarimoNotebookViewPageDocument, options);
        }
export type MarimoNotebookViewPageQueryHookResult = ReturnType<typeof useMarimoNotebookViewPageQuery>;
export type MarimoNotebookViewPageLazyQueryHookResult = ReturnType<typeof useMarimoNotebookViewPageLazyQuery>;
export type MarimoNotebookViewPageSuspenseQueryHookResult = ReturnType<typeof useMarimoNotebookViewPageSuspenseQuery>;
export type MarimoNotebookViewPageQueryResult = ApolloReactCommon.QueryResult<MarimoNotebookViewPageQuery, MarimoNotebookViewPageQueryVariables>;
export const AccountNotebooksDocument = gql`
    query AccountNotebooks($after: String, $before: String, $entityName: String!, $first: Int, $last: Int, $organizationId: ID!, $search: String, $userID: ID, $skipEntity: Boolean!, $skipOrganization: Boolean!) {
  entity(name: $entityName) @skip(if: $skipEntity) {
    id
    notebooks(
      search: $search
      userID: $userID
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      edges {
        node {
          id
          ...NotebookTable_Notebook
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
  organization(id: $organizationId) @skip(if: $skipOrganization) {
    id
    notebooks(
      search: $search
      userID: $userID
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      edges {
        node {
          id
          ...NotebookTable_Notebook
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${NotebookTable_NotebookFragmentDoc}`;

/**
 * __useAccountNotebooksQuery__
 *
 * To run a query within a React component, call `useAccountNotebooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountNotebooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountNotebooksQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      entityName: // value for 'entityName'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      organizationId: // value for 'organizationId'
 *      search: // value for 'search'
 *      userID: // value for 'userID'
 *      skipEntity: // value for 'skipEntity'
 *      skipOrganization: // value for 'skipOrganization'
 *   },
 * });
 */
export function useAccountNotebooksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountNotebooksQuery, AccountNotebooksQueryVariables> & ({ variables: AccountNotebooksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountNotebooksQuery, AccountNotebooksQueryVariables>(AccountNotebooksDocument, options);
      }
export function useAccountNotebooksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountNotebooksQuery, AccountNotebooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountNotebooksQuery, AccountNotebooksQueryVariables>(AccountNotebooksDocument, options);
        }
// @ts-ignore
export function useAccountNotebooksSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AccountNotebooksQuery, AccountNotebooksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountNotebooksQuery, AccountNotebooksQueryVariables>;
export function useAccountNotebooksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountNotebooksQuery, AccountNotebooksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountNotebooksQuery | undefined, AccountNotebooksQueryVariables>;
export function useAccountNotebooksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountNotebooksQuery, AccountNotebooksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccountNotebooksQuery, AccountNotebooksQueryVariables>(AccountNotebooksDocument, options);
        }
export type AccountNotebooksQueryHookResult = ReturnType<typeof useAccountNotebooksQuery>;
export type AccountNotebooksLazyQueryHookResult = ReturnType<typeof useAccountNotebooksLazyQuery>;
export type AccountNotebooksSuspenseQueryHookResult = ReturnType<typeof useAccountNotebooksSuspenseQuery>;
export type AccountNotebooksQueryResult = ApolloReactCommon.QueryResult<AccountNotebooksQuery, AccountNotebooksQueryVariables>;
export const PredefinedRoleOrgInfoDocument = gql`
    query PredefinedRoleOrgInfo($organizationID: ID!) {
  organization(id: $organizationID) {
    id
    subscriptions {
      id
      subscriptionType
      plan {
        id
        name
        planType
      }
    }
  }
}
    `;

/**
 * __usePredefinedRoleOrgInfoQuery__
 *
 * To run a query within a React component, call `usePredefinedRoleOrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePredefinedRoleOrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePredefinedRoleOrgInfoQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function usePredefinedRoleOrgInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables> & ({ variables: PredefinedRoleOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables>(PredefinedRoleOrgInfoDocument, options);
      }
export function usePredefinedRoleOrgInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables>(PredefinedRoleOrgInfoDocument, options);
        }
// @ts-ignore
export function usePredefinedRoleOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables>;
export function usePredefinedRoleOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PredefinedRoleOrgInfoQuery | undefined, PredefinedRoleOrgInfoQueryVariables>;
export function usePredefinedRoleOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables>(PredefinedRoleOrgInfoDocument, options);
        }
export type PredefinedRoleOrgInfoQueryHookResult = ReturnType<typeof usePredefinedRoleOrgInfoQuery>;
export type PredefinedRoleOrgInfoLazyQueryHookResult = ReturnType<typeof usePredefinedRoleOrgInfoLazyQuery>;
export type PredefinedRoleOrgInfoSuspenseQueryHookResult = ReturnType<typeof usePredefinedRoleOrgInfoSuspenseQuery>;
export type PredefinedRoleOrgInfoQueryResult = ApolloReactCommon.QueryResult<PredefinedRoleOrgInfoQuery, PredefinedRoleOrgInfoQueryVariables>;
export const OrganizationFlagsDocument = gql`
    query OrganizationFlags($orgName: String!) {
  organization(name: $orgName) {
    id
    flags
  }
}
    `;

/**
 * __useOrganizationFlagsQuery__
 *
 * To run a query within a React component, call `useOrganizationFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationFlagsQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationFlagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationFlagsQuery, OrganizationFlagsQueryVariables> & ({ variables: OrganizationFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationFlagsQuery, OrganizationFlagsQueryVariables>(OrganizationFlagsDocument, options);
      }
export function useOrganizationFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationFlagsQuery, OrganizationFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationFlagsQuery, OrganizationFlagsQueryVariables>(OrganizationFlagsDocument, options);
        }
// @ts-ignore
export function useOrganizationFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationFlagsQuery, OrganizationFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationFlagsQuery, OrganizationFlagsQueryVariables>;
export function useOrganizationFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationFlagsQuery, OrganizationFlagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationFlagsQuery | undefined, OrganizationFlagsQueryVariables>;
export function useOrganizationFlagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationFlagsQuery, OrganizationFlagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationFlagsQuery, OrganizationFlagsQueryVariables>(OrganizationFlagsDocument, options);
        }
export type OrganizationFlagsQueryHookResult = ReturnType<typeof useOrganizationFlagsQuery>;
export type OrganizationFlagsLazyQueryHookResult = ReturnType<typeof useOrganizationFlagsLazyQuery>;
export type OrganizationFlagsSuspenseQueryHookResult = ReturnType<typeof useOrganizationFlagsSuspenseQuery>;
export type OrganizationFlagsQueryResult = ApolloReactCommon.QueryResult<OrganizationFlagsQuery, OrganizationFlagsQueryVariables>;
export const RemoteScoringOrganizationDocument = gql`
    query RemoteScoringOrganization($orgName: String!) {
  organization(name: $orgName) {
    id
  }
}
    `;

/**
 * __useRemoteScoringOrganizationQuery__
 *
 * To run a query within a React component, call `useRemoteScoringOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemoteScoringOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemoteScoringOrganizationQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useRemoteScoringOrganizationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RemoteScoringOrganizationQuery, RemoteScoringOrganizationQueryVariables> & ({ variables: RemoteScoringOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RemoteScoringOrganizationQuery, RemoteScoringOrganizationQueryVariables>(RemoteScoringOrganizationDocument, options);
      }
export function useRemoteScoringOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RemoteScoringOrganizationQuery, RemoteScoringOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RemoteScoringOrganizationQuery, RemoteScoringOrganizationQueryVariables>(RemoteScoringOrganizationDocument, options);
        }
// @ts-ignore
export function useRemoteScoringOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RemoteScoringOrganizationQuery, RemoteScoringOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RemoteScoringOrganizationQuery, RemoteScoringOrganizationQueryVariables>;
export function useRemoteScoringOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RemoteScoringOrganizationQuery, RemoteScoringOrganizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RemoteScoringOrganizationQuery | undefined, RemoteScoringOrganizationQueryVariables>;
export function useRemoteScoringOrganizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RemoteScoringOrganizationQuery, RemoteScoringOrganizationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RemoteScoringOrganizationQuery, RemoteScoringOrganizationQueryVariables>(RemoteScoringOrganizationDocument, options);
        }
export type RemoteScoringOrganizationQueryHookResult = ReturnType<typeof useRemoteScoringOrganizationQuery>;
export type RemoteScoringOrganizationLazyQueryHookResult = ReturnType<typeof useRemoteScoringOrganizationLazyQuery>;
export type RemoteScoringOrganizationSuspenseQueryHookResult = ReturnType<typeof useRemoteScoringOrganizationSuspenseQuery>;
export type RemoteScoringOrganizationQueryResult = ApolloReactCommon.QueryResult<RemoteScoringOrganizationQuery, RemoteScoringOrganizationQueryVariables>;
export const OrganizationRemoteScoringPolicyDocument = gql`
    query OrganizationRemoteScoringPolicy($organizationId: ID!) {
  organizationRemoteScoringPolicy(organizationId: $organizationId) {
    enabled
    allowedHosts {
      host
      port
    }
  }
}
    `;

/**
 * __useOrganizationRemoteScoringPolicyQuery__
 *
 * To run a query within a React component, call `useOrganizationRemoteScoringPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationRemoteScoringPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationRemoteScoringPolicyQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationRemoteScoringPolicyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationRemoteScoringPolicyQuery, OrganizationRemoteScoringPolicyQueryVariables> & ({ variables: OrganizationRemoteScoringPolicyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationRemoteScoringPolicyQuery, OrganizationRemoteScoringPolicyQueryVariables>(OrganizationRemoteScoringPolicyDocument, options);
      }
export function useOrganizationRemoteScoringPolicyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationRemoteScoringPolicyQuery, OrganizationRemoteScoringPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationRemoteScoringPolicyQuery, OrganizationRemoteScoringPolicyQueryVariables>(OrganizationRemoteScoringPolicyDocument, options);
        }
// @ts-ignore
export function useOrganizationRemoteScoringPolicySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRemoteScoringPolicyQuery, OrganizationRemoteScoringPolicyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationRemoteScoringPolicyQuery, OrganizationRemoteScoringPolicyQueryVariables>;
export function useOrganizationRemoteScoringPolicySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRemoteScoringPolicyQuery, OrganizationRemoteScoringPolicyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationRemoteScoringPolicyQuery | undefined, OrganizationRemoteScoringPolicyQueryVariables>;
export function useOrganizationRemoteScoringPolicySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRemoteScoringPolicyQuery, OrganizationRemoteScoringPolicyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationRemoteScoringPolicyQuery, OrganizationRemoteScoringPolicyQueryVariables>(OrganizationRemoteScoringPolicyDocument, options);
        }
export type OrganizationRemoteScoringPolicyQueryHookResult = ReturnType<typeof useOrganizationRemoteScoringPolicyQuery>;
export type OrganizationRemoteScoringPolicyLazyQueryHookResult = ReturnType<typeof useOrganizationRemoteScoringPolicyLazyQuery>;
export type OrganizationRemoteScoringPolicySuspenseQueryHookResult = ReturnType<typeof useOrganizationRemoteScoringPolicySuspenseQuery>;
export type OrganizationRemoteScoringPolicyQueryResult = ApolloReactCommon.QueryResult<OrganizationRemoteScoringPolicyQuery, OrganizationRemoteScoringPolicyQueryVariables>;
export const OrganizationRemoteScoringGateDocument = gql`
    query OrganizationRemoteScoringGate($organizationId: ID!) {
  organizationRemoteScoringPolicy(organizationId: $organizationId) {
    configured
    enabled
  }
}
    `;

/**
 * __useOrganizationRemoteScoringGateQuery__
 *
 * To run a query within a React component, call `useOrganizationRemoteScoringGateQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationRemoteScoringGateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationRemoteScoringGateQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationRemoteScoringGateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationRemoteScoringGateQuery, OrganizationRemoteScoringGateQueryVariables> & ({ variables: OrganizationRemoteScoringGateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationRemoteScoringGateQuery, OrganizationRemoteScoringGateQueryVariables>(OrganizationRemoteScoringGateDocument, options);
      }
export function useOrganizationRemoteScoringGateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationRemoteScoringGateQuery, OrganizationRemoteScoringGateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationRemoteScoringGateQuery, OrganizationRemoteScoringGateQueryVariables>(OrganizationRemoteScoringGateDocument, options);
        }
// @ts-ignore
export function useOrganizationRemoteScoringGateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRemoteScoringGateQuery, OrganizationRemoteScoringGateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationRemoteScoringGateQuery, OrganizationRemoteScoringGateQueryVariables>;
export function useOrganizationRemoteScoringGateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRemoteScoringGateQuery, OrganizationRemoteScoringGateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationRemoteScoringGateQuery | undefined, OrganizationRemoteScoringGateQueryVariables>;
export function useOrganizationRemoteScoringGateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationRemoteScoringGateQuery, OrganizationRemoteScoringGateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationRemoteScoringGateQuery, OrganizationRemoteScoringGateQueryVariables>(OrganizationRemoteScoringGateDocument, options);
        }
export type OrganizationRemoteScoringGateQueryHookResult = ReturnType<typeof useOrganizationRemoteScoringGateQuery>;
export type OrganizationRemoteScoringGateLazyQueryHookResult = ReturnType<typeof useOrganizationRemoteScoringGateLazyQuery>;
export type OrganizationRemoteScoringGateSuspenseQueryHookResult = ReturnType<typeof useOrganizationRemoteScoringGateSuspenseQuery>;
export type OrganizationRemoteScoringGateQueryResult = ApolloReactCommon.QueryResult<OrganizationRemoteScoringGateQuery, OrganizationRemoteScoringGateQueryVariables>;
export const UpdateOrganizationRemoteScoringSettingsDocument = gql`
    mutation UpdateOrganizationRemoteScoringSettings($organizationId: ID!, $remoteScoringEnabled: Boolean!, $remoteScoringAllowedHosts: [RemoteScoringAllowedHostInput!]!, $clientMutationId: String) {
  updateOrganizationRemoteScoringSettings(
    input: {organizationId: $organizationId, remoteScoringEnabled: $remoteScoringEnabled, remoteScoringAllowedHosts: $remoteScoringAllowedHosts, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateOrganizationRemoteScoringSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateOrganizationRemoteScoringSettingsMutation, UpdateOrganizationRemoteScoringSettingsMutationVariables>;

/**
 * __useUpdateOrganizationRemoteScoringSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationRemoteScoringSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationRemoteScoringSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationRemoteScoringSettingsMutation, { data, loading, error }] = useUpdateOrganizationRemoteScoringSettingsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      remoteScoringEnabled: // value for 'remoteScoringEnabled'
 *      remoteScoringAllowedHosts: // value for 'remoteScoringAllowedHosts'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateOrganizationRemoteScoringSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationRemoteScoringSettingsMutation, UpdateOrganizationRemoteScoringSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationRemoteScoringSettingsMutation, UpdateOrganizationRemoteScoringSettingsMutationVariables>(UpdateOrganizationRemoteScoringSettingsDocument, options);
      }
export type UpdateOrganizationRemoteScoringSettingsMutationHookResult = ReturnType<typeof useUpdateOrganizationRemoteScoringSettingsMutation>;
export type UpdateOrganizationRemoteScoringSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationRemoteScoringSettingsMutation>;
export type UpdateOrganizationRemoteScoringSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationRemoteScoringSettingsMutation, UpdateOrganizationRemoteScoringSettingsMutationVariables>;
export const FetchProfilePageProjectsByIDsDocument = gql`
    query FetchProfilePageProjectsByIDs($entityName: String!, $projectIDs: [ID!]!) {
  projects(entityName: $entityName, projectIDs: $projectIDs) {
    edges {
      node {
        id
        name
        entityName
        access
        lastActive
        runCount
        user {
          id
          username
        }
      }
    }
  }
}
    `;

/**
 * __useFetchProfilePageProjectsByIDsQuery__
 *
 * To run a query within a React component, call `useFetchProfilePageProjectsByIDsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProfilePageProjectsByIDsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProfilePageProjectsByIDsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectIDs: // value for 'projectIDs'
 *   },
 * });
 */
export function useFetchProfilePageProjectsByIDsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables> & ({ variables: FetchProfilePageProjectsByIDsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables>(FetchProfilePageProjectsByIDsDocument, options);
      }
export function useFetchProfilePageProjectsByIDsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables>(FetchProfilePageProjectsByIDsDocument, options);
        }
// @ts-ignore
export function useFetchProfilePageProjectsByIDsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables>;
export function useFetchProfilePageProjectsByIDsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProfilePageProjectsByIDsQuery | undefined, FetchProfilePageProjectsByIDsQueryVariables>;
export function useFetchProfilePageProjectsByIDsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables>(FetchProfilePageProjectsByIDsDocument, options);
        }
export type FetchProfilePageProjectsByIDsQueryHookResult = ReturnType<typeof useFetchProfilePageProjectsByIDsQuery>;
export type FetchProfilePageProjectsByIDsLazyQueryHookResult = ReturnType<typeof useFetchProfilePageProjectsByIDsLazyQuery>;
export type FetchProfilePageProjectsByIDsSuspenseQueryHookResult = ReturnType<typeof useFetchProfilePageProjectsByIDsSuspenseQuery>;
export type FetchProfilePageProjectsByIDsQueryResult = ApolloReactCommon.QueryResult<FetchProfilePageProjectsByIDsQuery, FetchProfilePageProjectsByIDsQueryVariables>;
export const ProjectNotebooksDocument = gql`
    query ProjectNotebooks($entityName: String!, $projectName: String!, $search: String, $userID: ID, $after: String, $before: String, $first: Int, $last: Int) {
  project(entityName: $entityName, name: $projectName) {
    id
    notebooks(
      search: $search
      userID: $userID
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      edges {
        node {
          id
          ...NotebookTable_Notebook
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${NotebookTable_NotebookFragmentDoc}`;

/**
 * __useProjectNotebooksQuery__
 *
 * To run a query within a React component, call `useProjectNotebooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectNotebooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectNotebooksQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      search: // value for 'search'
 *      userID: // value for 'userID'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useProjectNotebooksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectNotebooksQuery, ProjectNotebooksQueryVariables> & ({ variables: ProjectNotebooksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectNotebooksQuery, ProjectNotebooksQueryVariables>(ProjectNotebooksDocument, options);
      }
export function useProjectNotebooksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectNotebooksQuery, ProjectNotebooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectNotebooksQuery, ProjectNotebooksQueryVariables>(ProjectNotebooksDocument, options);
        }
// @ts-ignore
export function useProjectNotebooksSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectNotebooksQuery, ProjectNotebooksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectNotebooksQuery, ProjectNotebooksQueryVariables>;
export function useProjectNotebooksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectNotebooksQuery, ProjectNotebooksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectNotebooksQuery | undefined, ProjectNotebooksQueryVariables>;
export function useProjectNotebooksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectNotebooksQuery, ProjectNotebooksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectNotebooksQuery, ProjectNotebooksQueryVariables>(ProjectNotebooksDocument, options);
        }
export type ProjectNotebooksQueryHookResult = ReturnType<typeof useProjectNotebooksQuery>;
export type ProjectNotebooksLazyQueryHookResult = ReturnType<typeof useProjectNotebooksLazyQuery>;
export type ProjectNotebooksSuspenseQueryHookResult = ReturnType<typeof useProjectNotebooksSuspenseQuery>;
export type ProjectNotebooksQueryResult = ApolloReactCommon.QueryResult<ProjectNotebooksQuery, ProjectNotebooksQueryVariables>;
export const ProjectPageDocument = gql`
    query ProjectPage($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    name
    entityName
    access
    hasRun
    fromV2
    entity {
      id
      claimingEntity {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useProjectPageQuery__
 *
 * To run a query within a React component, call `useProjectPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPageQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useProjectPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectPageQuery, ProjectPageQueryVariables> & ({ variables: ProjectPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectPageQuery, ProjectPageQueryVariables>(ProjectPageDocument, options);
      }
export function useProjectPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectPageQuery, ProjectPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectPageQuery, ProjectPageQueryVariables>(ProjectPageDocument, options);
        }
// @ts-ignore
export function useProjectPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectPageQuery, ProjectPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectPageQuery, ProjectPageQueryVariables>;
export function useProjectPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectPageQuery, ProjectPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectPageQuery | undefined, ProjectPageQueryVariables>;
export function useProjectPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectPageQuery, ProjectPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectPageQuery, ProjectPageQueryVariables>(ProjectPageDocument, options);
        }
export type ProjectPageQueryHookResult = ReturnType<typeof useProjectPageQuery>;
export type ProjectPageLazyQueryHookResult = ReturnType<typeof useProjectPageLazyQuery>;
export type ProjectPageSuspenseQueryHookResult = ReturnType<typeof useProjectPageSuspenseQuery>;
export type ProjectPageQueryResult = ApolloReactCommon.QueryResult<ProjectPageQuery, ProjectPageQueryVariables>;
export const RunOverflowMenuDocument = gql`
    query RunOverflowMenu($projectName: String!, $entityName: String, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    name
    entityName
    readOnly
    run(name: $runName) {
      id
      state
      displayName
      inputArtifacts {
        totalCount
      }
      runInfo {
        git {
          remote
          commit
        }
      }
      commit
      github
    }
  }
}
    `;

/**
 * __useRunOverflowMenuQuery__
 *
 * To run a query within a React component, call `useRunOverflowMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunOverflowMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunOverflowMenuQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunOverflowMenuQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunOverflowMenuQuery, RunOverflowMenuQueryVariables> & ({ variables: RunOverflowMenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunOverflowMenuQuery, RunOverflowMenuQueryVariables>(RunOverflowMenuDocument, options);
      }
export function useRunOverflowMenuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunOverflowMenuQuery, RunOverflowMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunOverflowMenuQuery, RunOverflowMenuQueryVariables>(RunOverflowMenuDocument, options);
        }
// @ts-ignore
export function useRunOverflowMenuSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunOverflowMenuQuery, RunOverflowMenuQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunOverflowMenuQuery, RunOverflowMenuQueryVariables>;
export function useRunOverflowMenuSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunOverflowMenuQuery, RunOverflowMenuQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunOverflowMenuQuery | undefined, RunOverflowMenuQueryVariables>;
export function useRunOverflowMenuSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunOverflowMenuQuery, RunOverflowMenuQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunOverflowMenuQuery, RunOverflowMenuQueryVariables>(RunOverflowMenuDocument, options);
        }
export type RunOverflowMenuQueryHookResult = ReturnType<typeof useRunOverflowMenuQuery>;
export type RunOverflowMenuLazyQueryHookResult = ReturnType<typeof useRunOverflowMenuLazyQuery>;
export type RunOverflowMenuSuspenseQueryHookResult = ReturnType<typeof useRunOverflowMenuSuspenseQuery>;
export type RunOverflowMenuQueryResult = ApolloReactCommon.QueryResult<RunOverflowMenuQuery, RunOverflowMenuQueryVariables>;
export const RunOverviewPatchItemDocument = gql`
    query RunOverviewPatchItem($projectName: String!, $entityName: String, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      ...RunOverviewPatchItem_Run
    }
  }
}
    ${RunOverviewPatchItem_RunFragmentDoc}`;

/**
 * __useRunOverviewPatchItemQuery__
 *
 * To run a query within a React component, call `useRunOverviewPatchItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunOverviewPatchItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunOverviewPatchItemQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunOverviewPatchItemQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunOverviewPatchItemQuery, RunOverviewPatchItemQueryVariables> & ({ variables: RunOverviewPatchItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunOverviewPatchItemQuery, RunOverviewPatchItemQueryVariables>(RunOverviewPatchItemDocument, options);
      }
export function useRunOverviewPatchItemLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunOverviewPatchItemQuery, RunOverviewPatchItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunOverviewPatchItemQuery, RunOverviewPatchItemQueryVariables>(RunOverviewPatchItemDocument, options);
        }
// @ts-ignore
export function useRunOverviewPatchItemSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunOverviewPatchItemQuery, RunOverviewPatchItemQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunOverviewPatchItemQuery, RunOverviewPatchItemQueryVariables>;
export function useRunOverviewPatchItemSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunOverviewPatchItemQuery, RunOverviewPatchItemQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunOverviewPatchItemQuery | undefined, RunOverviewPatchItemQueryVariables>;
export function useRunOverviewPatchItemSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunOverviewPatchItemQuery, RunOverviewPatchItemQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunOverviewPatchItemQuery, RunOverviewPatchItemQueryVariables>(RunOverviewPatchItemDocument, options);
        }
export type RunOverviewPatchItemQueryHookResult = ReturnType<typeof useRunOverviewPatchItemQuery>;
export type RunOverviewPatchItemLazyQueryHookResult = ReturnType<typeof useRunOverviewPatchItemLazyQuery>;
export type RunOverviewPatchItemSuspenseQueryHookResult = ReturnType<typeof useRunOverviewPatchItemSuspenseQuery>;
export type RunOverviewPatchItemQueryResult = ApolloReactCommon.QueryResult<RunOverviewPatchItemQuery, RunOverviewPatchItemQueryVariables>;
export const RunOverviewDocument = gql`
    query RunOverview($projectName: String!, $entityName: String, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    internalId
    name
    readOnly
    entityName
    entity {
      id
      isTeam
    }
    tags {
      id
      name
      colorIndex
    }
    run(name: $runName) {
      id
      state
      stopped
      heartbeatAt
      name
      displayName
      notes
      config
      inputArtifacts {
        totalCount
      }
      createdAt
      jobType
      group
      tags: tagColors {
        id
        name
        colorIndex
      }
      host
      sweep {
        id
        name
        displayName
      }
      runInfo {
        program
        args
        os
        python
        colab
        executable
        cpuCount
        cpuCountLogical
        gpuCount
        gpu
        git {
          remote
          commit
        }
      }
      user {
        id
        username
        name
        photoUrl
        accountType
      }
      branchPoint {
        run {
          id
          name
          project {
            id
            name
            entity {
              id
              name
            }
          }
        }
        step
      }
      internalID
      ...RunOverviewCommandItems_Run
    }
  }
}
    ${RunOverviewCommandItems_RunFragmentDoc}`;

/**
 * __useRunOverviewQuery__
 *
 * To run a query within a React component, call `useRunOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunOverviewQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunOverviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunOverviewQuery, RunOverviewQueryVariables> & ({ variables: RunOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunOverviewQuery, RunOverviewQueryVariables>(RunOverviewDocument, options);
      }
export function useRunOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunOverviewQuery, RunOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunOverviewQuery, RunOverviewQueryVariables>(RunOverviewDocument, options);
        }
// @ts-ignore
export function useRunOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunOverviewQuery, RunOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunOverviewQuery, RunOverviewQueryVariables>;
export function useRunOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunOverviewQuery, RunOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunOverviewQuery | undefined, RunOverviewQueryVariables>;
export function useRunOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunOverviewQuery, RunOverviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunOverviewQuery, RunOverviewQueryVariables>(RunOverviewDocument, options);
        }
export type RunOverviewQueryHookResult = ReturnType<typeof useRunOverviewQuery>;
export type RunOverviewLazyQueryHookResult = ReturnType<typeof useRunOverviewLazyQuery>;
export type RunOverviewSuspenseQueryHookResult = ReturnType<typeof useRunOverviewSuspenseQuery>;
export type RunOverviewQueryResult = ApolloReactCommon.QueryResult<RunOverviewQuery, RunOverviewQueryVariables>;
export const RunPageHeaderDocument = gql`
    query RunPageHeader($projectName: String!, $entityName: String, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    readOnly
    run(name: $runName) {
      id
      name
      state
      stopped
      config
      tags: tagColors {
        id
        name
      }
      notes
      displayName
    }
  }
}
    `;

/**
 * __useRunPageHeaderQuery__
 *
 * To run a query within a React component, call `useRunPageHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunPageHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunPageHeaderQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunPageHeaderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunPageHeaderQuery, RunPageHeaderQueryVariables> & ({ variables: RunPageHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunPageHeaderQuery, RunPageHeaderQueryVariables>(RunPageHeaderDocument, options);
      }
export function useRunPageHeaderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunPageHeaderQuery, RunPageHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunPageHeaderQuery, RunPageHeaderQueryVariables>(RunPageHeaderDocument, options);
        }
// @ts-ignore
export function useRunPageHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunPageHeaderQuery, RunPageHeaderQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunPageHeaderQuery, RunPageHeaderQueryVariables>;
export function useRunPageHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunPageHeaderQuery, RunPageHeaderQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunPageHeaderQuery | undefined, RunPageHeaderQueryVariables>;
export function useRunPageHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunPageHeaderQuery, RunPageHeaderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunPageHeaderQuery, RunPageHeaderQueryVariables>(RunPageHeaderDocument, options);
        }
export type RunPageHeaderQueryHookResult = ReturnType<typeof useRunPageHeaderQuery>;
export type RunPageHeaderLazyQueryHookResult = ReturnType<typeof useRunPageHeaderLazyQuery>;
export type RunPageHeaderSuspenseQueryHookResult = ReturnType<typeof useRunPageHeaderSuspenseQuery>;
export type RunPageHeaderQueryResult = ApolloReactCommon.QueryResult<RunPageHeaderQuery, RunPageHeaderQueryVariables>;
export const RunOverviewViewCodeModalDocument = gql`
    query RunOverviewViewCodeModal($projectName: String!, $entityName: String, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      ...ViewCodeModal_Run
    }
  }
}
    ${ViewCodeModal_RunFragmentDoc}`;

/**
 * __useRunOverviewViewCodeModalQuery__
 *
 * To run a query within a React component, call `useRunOverviewViewCodeModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunOverviewViewCodeModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunOverviewViewCodeModalQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunOverviewViewCodeModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunOverviewViewCodeModalQuery, RunOverviewViewCodeModalQueryVariables> & ({ variables: RunOverviewViewCodeModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunOverviewViewCodeModalQuery, RunOverviewViewCodeModalQueryVariables>(RunOverviewViewCodeModalDocument, options);
      }
export function useRunOverviewViewCodeModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunOverviewViewCodeModalQuery, RunOverviewViewCodeModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunOverviewViewCodeModalQuery, RunOverviewViewCodeModalQueryVariables>(RunOverviewViewCodeModalDocument, options);
        }
// @ts-ignore
export function useRunOverviewViewCodeModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunOverviewViewCodeModalQuery, RunOverviewViewCodeModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunOverviewViewCodeModalQuery, RunOverviewViewCodeModalQueryVariables>;
export function useRunOverviewViewCodeModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunOverviewViewCodeModalQuery, RunOverviewViewCodeModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunOverviewViewCodeModalQuery | undefined, RunOverviewViewCodeModalQueryVariables>;
export function useRunOverviewViewCodeModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunOverviewViewCodeModalQuery, RunOverviewViewCodeModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunOverviewViewCodeModalQuery, RunOverviewViewCodeModalQueryVariables>(RunOverviewViewCodeModalDocument, options);
        }
export type RunOverviewViewCodeModalQueryHookResult = ReturnType<typeof useRunOverviewViewCodeModalQuery>;
export type RunOverviewViewCodeModalLazyQueryHookResult = ReturnType<typeof useRunOverviewViewCodeModalLazyQuery>;
export type RunOverviewViewCodeModalSuspenseQueryHookResult = ReturnType<typeof useRunOverviewViewCodeModalSuspenseQuery>;
export type RunOverviewViewCodeModalQueryResult = ApolloReactCommon.QueryResult<RunOverviewViewCodeModalQuery, RunOverviewViewCodeModalQueryVariables>;
export const StartupProgramDocument = gql`
    query StartupProgram($organizationID: ID!) {
  organization(id: $organizationID) {
    id
    flags
    subscriptions {
      id
      subscriptionType
      plan {
        id
        name
        planType
      }
    }
  }
}
    `;

/**
 * __useStartupProgramQuery__
 *
 * To run a query within a React component, call `useStartupProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartupProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartupProgramQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useStartupProgramQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StartupProgramQuery, StartupProgramQueryVariables> & ({ variables: StartupProgramQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StartupProgramQuery, StartupProgramQueryVariables>(StartupProgramDocument, options);
      }
export function useStartupProgramLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StartupProgramQuery, StartupProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StartupProgramQuery, StartupProgramQueryVariables>(StartupProgramDocument, options);
        }
// @ts-ignore
export function useStartupProgramSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<StartupProgramQuery, StartupProgramQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StartupProgramQuery, StartupProgramQueryVariables>;
export function useStartupProgramSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StartupProgramQuery, StartupProgramQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StartupProgramQuery | undefined, StartupProgramQueryVariables>;
export function useStartupProgramSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StartupProgramQuery, StartupProgramQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<StartupProgramQuery, StartupProgramQueryVariables>(StartupProgramDocument, options);
        }
export type StartupProgramQueryHookResult = ReturnType<typeof useStartupProgramQuery>;
export type StartupProgramLazyQueryHookResult = ReturnType<typeof useStartupProgramLazyQuery>;
export type StartupProgramSuspenseQueryHookResult = ReturnType<typeof useStartupProgramSuspenseQuery>;
export type StartupProgramQueryResult = ApolloReactCommon.QueryResult<StartupProgramQuery, StartupProgramQueryVariables>;
export const StartupProgramCouponInfoDocument = gql`
    query StartupProgramCouponInfo($couponID: String!) {
  coupon(id: $couponID) {
    id
  }
}
    `;

/**
 * __useStartupProgramCouponInfoQuery__
 *
 * To run a query within a React component, call `useStartupProgramCouponInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartupProgramCouponInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartupProgramCouponInfoQuery({
 *   variables: {
 *      couponID: // value for 'couponID'
 *   },
 * });
 */
export function useStartupProgramCouponInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables> & ({ variables: StartupProgramCouponInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables>(StartupProgramCouponInfoDocument, options);
      }
export function useStartupProgramCouponInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables>(StartupProgramCouponInfoDocument, options);
        }
// @ts-ignore
export function useStartupProgramCouponInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables>;
export function useStartupProgramCouponInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StartupProgramCouponInfoQuery | undefined, StartupProgramCouponInfoQueryVariables>;
export function useStartupProgramCouponInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables>(StartupProgramCouponInfoDocument, options);
        }
export type StartupProgramCouponInfoQueryHookResult = ReturnType<typeof useStartupProgramCouponInfoQuery>;
export type StartupProgramCouponInfoLazyQueryHookResult = ReturnType<typeof useStartupProgramCouponInfoLazyQuery>;
export type StartupProgramCouponInfoSuspenseQueryHookResult = ReturnType<typeof useStartupProgramCouponInfoSuspenseQuery>;
export type StartupProgramCouponInfoQueryResult = ApolloReactCommon.QueryResult<StartupProgramCouponInfoQuery, StartupProgramCouponInfoQueryVariables>;
export const TeamPageNotebooksDocument = gql`
    query TeamPageNotebooks($entityName: String!, $search: String, $userID: ID, $after: String, $before: String, $first: Int, $last: Int) {
  entity(name: $entityName) {
    id
    notebooks(
      search: $search
      userID: $userID
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      edges {
        node {
          id
          ...NotebookTable_Notebook
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    ${NotebookTable_NotebookFragmentDoc}`;

/**
 * __useTeamPageNotebooksQuery__
 *
 * To run a query within a React component, call `useTeamPageNotebooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamPageNotebooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamPageNotebooksQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      search: // value for 'search'
 *      userID: // value for 'userID'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useTeamPageNotebooksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamPageNotebooksQuery, TeamPageNotebooksQueryVariables> & ({ variables: TeamPageNotebooksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamPageNotebooksQuery, TeamPageNotebooksQueryVariables>(TeamPageNotebooksDocument, options);
      }
export function useTeamPageNotebooksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamPageNotebooksQuery, TeamPageNotebooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamPageNotebooksQuery, TeamPageNotebooksQueryVariables>(TeamPageNotebooksDocument, options);
        }
// @ts-ignore
export function useTeamPageNotebooksSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamPageNotebooksQuery, TeamPageNotebooksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamPageNotebooksQuery, TeamPageNotebooksQueryVariables>;
export function useTeamPageNotebooksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamPageNotebooksQuery, TeamPageNotebooksQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamPageNotebooksQuery | undefined, TeamPageNotebooksQueryVariables>;
export function useTeamPageNotebooksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamPageNotebooksQuery, TeamPageNotebooksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamPageNotebooksQuery, TeamPageNotebooksQueryVariables>(TeamPageNotebooksDocument, options);
        }
export type TeamPageNotebooksQueryHookResult = ReturnType<typeof useTeamPageNotebooksQuery>;
export type TeamPageNotebooksLazyQueryHookResult = ReturnType<typeof useTeamPageNotebooksLazyQuery>;
export type TeamPageNotebooksSuspenseQueryHookResult = ReturnType<typeof useTeamPageNotebooksSuspenseQuery>;
export type TeamPageNotebooksQueryResult = ApolloReactCommon.QueryResult<TeamPageNotebooksQuery, TeamPageNotebooksQueryVariables>;
export const TrialEndOrgInfoDocument = gql`
    query TrialEndOrgInfo($organizationID: ID!) {
  organization(id: $organizationID) {
    id
    name
    usedSeats
    flags
    teams {
      id
      name
    }
    subscriptions {
      id
      expiresAt
      plan {
        id
        name
        planType
      }
    }
  }
}
    `;

/**
 * __useTrialEndOrgInfoQuery__
 *
 * To run a query within a React component, call `useTrialEndOrgInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrialEndOrgInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrialEndOrgInfoQuery({
 *   variables: {
 *      organizationID: // value for 'organizationID'
 *   },
 * });
 */
export function useTrialEndOrgInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables> & ({ variables: TrialEndOrgInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables>(TrialEndOrgInfoDocument, options);
      }
export function useTrialEndOrgInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables>(TrialEndOrgInfoDocument, options);
        }
// @ts-ignore
export function useTrialEndOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables>;
export function useTrialEndOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TrialEndOrgInfoQuery | undefined, TrialEndOrgInfoQueryVariables>;
export function useTrialEndOrgInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables>(TrialEndOrgInfoDocument, options);
        }
export type TrialEndOrgInfoQueryHookResult = ReturnType<typeof useTrialEndOrgInfoQuery>;
export type TrialEndOrgInfoLazyQueryHookResult = ReturnType<typeof useTrialEndOrgInfoLazyQuery>;
export type TrialEndOrgInfoSuspenseQueryHookResult = ReturnType<typeof useTrialEndOrgInfoSuspenseQuery>;
export type TrialEndOrgInfoQueryResult = ApolloReactCommon.QueryResult<TrialEndOrgInfoQuery, TrialEndOrgInfoQueryVariables>;
export const TrialEndCouponInfoDocument = gql`
    query TrialEndCouponInfo($couponID: String!) {
  coupon(id: $couponID) {
    id
    amountOff
    percentOff
    duration
    currency
    name
    durationInMonths
  }
}
    `;

/**
 * __useTrialEndCouponInfoQuery__
 *
 * To run a query within a React component, call `useTrialEndCouponInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrialEndCouponInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrialEndCouponInfoQuery({
 *   variables: {
 *      couponID: // value for 'couponID'
 *   },
 * });
 */
export function useTrialEndCouponInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables> & ({ variables: TrialEndCouponInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables>(TrialEndCouponInfoDocument, options);
      }
export function useTrialEndCouponInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables>(TrialEndCouponInfoDocument, options);
        }
// @ts-ignore
export function useTrialEndCouponInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables>;
export function useTrialEndCouponInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TrialEndCouponInfoQuery | undefined, TrialEndCouponInfoQueryVariables>;
export function useTrialEndCouponInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables>(TrialEndCouponInfoDocument, options);
        }
export type TrialEndCouponInfoQueryHookResult = ReturnType<typeof useTrialEndCouponInfoQuery>;
export type TrialEndCouponInfoLazyQueryHookResult = ReturnType<typeof useTrialEndCouponInfoLazyQuery>;
export type TrialEndCouponInfoSuspenseQueryHookResult = ReturnType<typeof useTrialEndCouponInfoSuspenseQuery>;
export type TrialEndCouponInfoQueryResult = ApolloReactCommon.QueryResult<TrialEndCouponInfoQuery, TrialEndCouponInfoQueryVariables>;
export const TrackRouteOrgAccountTypeDocument = gql`
    query TrackRouteOrgAccountType($entityName: String) {
  entity(name: $entityName) {
    id
    organization {
      id
      name
      subscriptions {
        id
        subscriptionType
        plan {
          id
          name
          planType
        }
      }
    }
  }
}
    `;

/**
 * __useTrackRouteOrgAccountTypeQuery__
 *
 * To run a query within a React component, call `useTrackRouteOrgAccountTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackRouteOrgAccountTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackRouteOrgAccountTypeQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useTrackRouteOrgAccountTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TrackRouteOrgAccountTypeQuery, TrackRouteOrgAccountTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TrackRouteOrgAccountTypeQuery, TrackRouteOrgAccountTypeQueryVariables>(TrackRouteOrgAccountTypeDocument, options);
      }
export function useTrackRouteOrgAccountTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TrackRouteOrgAccountTypeQuery, TrackRouteOrgAccountTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TrackRouteOrgAccountTypeQuery, TrackRouteOrgAccountTypeQueryVariables>(TrackRouteOrgAccountTypeDocument, options);
        }
// @ts-ignore
export function useTrackRouteOrgAccountTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TrackRouteOrgAccountTypeQuery, TrackRouteOrgAccountTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TrackRouteOrgAccountTypeQuery, TrackRouteOrgAccountTypeQueryVariables>;
export function useTrackRouteOrgAccountTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TrackRouteOrgAccountTypeQuery, TrackRouteOrgAccountTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TrackRouteOrgAccountTypeQuery | undefined, TrackRouteOrgAccountTypeQueryVariables>;
export function useTrackRouteOrgAccountTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TrackRouteOrgAccountTypeQuery, TrackRouteOrgAccountTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TrackRouteOrgAccountTypeQuery, TrackRouteOrgAccountTypeQueryVariables>(TrackRouteOrgAccountTypeDocument, options);
        }
export type TrackRouteOrgAccountTypeQueryHookResult = ReturnType<typeof useTrackRouteOrgAccountTypeQuery>;
export type TrackRouteOrgAccountTypeLazyQueryHookResult = ReturnType<typeof useTrackRouteOrgAccountTypeLazyQuery>;
export type TrackRouteOrgAccountTypeSuspenseQueryHookResult = ReturnType<typeof useTrackRouteOrgAccountTypeSuspenseQuery>;
export type TrackRouteOrgAccountTypeQueryResult = ApolloReactCommon.QueryResult<TrackRouteOrgAccountTypeQuery, TrackRouteOrgAccountTypeQueryVariables>;
export const CreateAccessTokenDocument = gql`
    mutation createAccessToken($projects: [ProjectSpecifier!]!, $viewId: ID!, $email: String, $username: String, $clientMutationId: String, $previewURL: String) {
  createAccessToken(
    input: {projects: $projects, viewId: $viewId, email: $email, username: $username, clientMutationId: $clientMutationId, previewURL: $previewURL}
  ) {
    accessToken {
      id
      token
      view {
        id
      }
      type
      emails
      createdBy {
        id
        username
        email
        name
      }
      createdAt
      lastAccessedAt
      revokedAt
      projects {
        id
        name
        entityName
      }
    }
    toNewUser
    recipientAlreadyOnTeam
    clientMutationId
  }
}
    `;
export type CreateAccessTokenMutationFn = ApolloReactCommon.MutationFunction<CreateAccessTokenMutation, CreateAccessTokenMutationVariables>;

/**
 * __useCreateAccessTokenMutation__
 *
 * To run a mutation, you first call `useCreateAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccessTokenMutation, { data, loading, error }] = useCreateAccessTokenMutation({
 *   variables: {
 *      projects: // value for 'projects'
 *      viewId: // value for 'viewId'
 *      email: // value for 'email'
 *      username: // value for 'username'
 *      clientMutationId: // value for 'clientMutationId'
 *      previewURL: // value for 'previewURL'
 *   },
 * });
 */
export function useCreateAccessTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAccessTokenMutation, CreateAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAccessTokenMutation, CreateAccessTokenMutationVariables>(CreateAccessTokenDocument, options);
      }
export type CreateAccessTokenMutationHookResult = ReturnType<typeof useCreateAccessTokenMutation>;
export type CreateAccessTokenMutationResult = ApolloReactCommon.MutationResult<CreateAccessTokenMutation>;
export type CreateAccessTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAccessTokenMutation, CreateAccessTokenMutationVariables>;
export const RevokeAccessTokenDocument = gql`
    mutation revokeAccessToken($token: String!, $clientMutationId: String) {
  revokeAccessToken(input: {token: $token, clientMutationId: $clientMutationId}) {
    success
    clientMutationId
  }
}
    `;
export type RevokeAccessTokenMutationFn = ApolloReactCommon.MutationFunction<RevokeAccessTokenMutation, RevokeAccessTokenMutationVariables>;

/**
 * __useRevokeAccessTokenMutation__
 *
 * To run a mutation, you first call `useRevokeAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeAccessTokenMutation, { data, loading, error }] = useRevokeAccessTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useRevokeAccessTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RevokeAccessTokenMutation, RevokeAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RevokeAccessTokenMutation, RevokeAccessTokenMutationVariables>(RevokeAccessTokenDocument, options);
      }
export type RevokeAccessTokenMutationHookResult = ReturnType<typeof useRevokeAccessTokenMutation>;
export type RevokeAccessTokenMutationResult = ApolloReactCommon.MutationResult<RevokeAccessTokenMutation>;
export type RevokeAccessTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<RevokeAccessTokenMutation, RevokeAccessTokenMutationVariables>;
export const UpdateAccessTokenProjectsDocument = gql`
    mutation updateAccessTokenProjects($token: String!, $projects: [ProjectSpecifier!]!, $clientMutationId: String) {
  updateAccessTokenProjects(
    input: {token: $token, projects: $projects, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type UpdateAccessTokenProjectsMutationFn = ApolloReactCommon.MutationFunction<UpdateAccessTokenProjectsMutation, UpdateAccessTokenProjectsMutationVariables>;

/**
 * __useUpdateAccessTokenProjectsMutation__
 *
 * To run a mutation, you first call `useUpdateAccessTokenProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccessTokenProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccessTokenProjectsMutation, { data, loading, error }] = useUpdateAccessTokenProjectsMutation({
 *   variables: {
 *      token: // value for 'token'
 *      projects: // value for 'projects'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUpdateAccessTokenProjectsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAccessTokenProjectsMutation, UpdateAccessTokenProjectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAccessTokenProjectsMutation, UpdateAccessTokenProjectsMutationVariables>(UpdateAccessTokenProjectsDocument, options);
      }
export type UpdateAccessTokenProjectsMutationHookResult = ReturnType<typeof useUpdateAccessTokenProjectsMutation>;
export type UpdateAccessTokenProjectsMutationResult = ApolloReactCommon.MutationResult<UpdateAccessTokenProjectsMutation>;
export type UpdateAccessTokenProjectsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAccessTokenProjectsMutation, UpdateAccessTokenProjectsMutationVariables>;
export const UpdateAccessTokenDocument = gql`
    mutation updateAccessToken($token: String!, $email: String, $username: String, $clientMutationId: String, $previewURL: String) {
  updateAccessToken(
    input: {token: $token, email: $email, username: $username, clientMutationId: $clientMutationId, previewURL: $previewURL}
  ) {
    accessToken {
      id
      token
      view {
        id
      }
      type
      emails
      createdBy {
        id
        username
        email
        name
      }
      createdAt
      lastAccessedAt
      revokedAt
      projects {
        id
        name
        entityName
      }
    }
    toNewUser
    recipientAlreadyOnTeam
    clientMutationId
  }
}
    `;
export type UpdateAccessTokenMutationFn = ApolloReactCommon.MutationFunction<UpdateAccessTokenMutation, UpdateAccessTokenMutationVariables>;

/**
 * __useUpdateAccessTokenMutation__
 *
 * To run a mutation, you first call `useUpdateAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccessTokenMutation, { data, loading, error }] = useUpdateAccessTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *      email: // value for 'email'
 *      username: // value for 'username'
 *      clientMutationId: // value for 'clientMutationId'
 *      previewURL: // value for 'previewURL'
 *   },
 * });
 */
export function useUpdateAccessTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAccessTokenMutation, UpdateAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAccessTokenMutation, UpdateAccessTokenMutationVariables>(UpdateAccessTokenDocument, options);
      }
export type UpdateAccessTokenMutationHookResult = ReturnType<typeof useUpdateAccessTokenMutation>;
export type UpdateAccessTokenMutationResult = ApolloReactCommon.MutationResult<UpdateAccessTokenMutation>;
export type UpdateAccessTokenMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAccessTokenMutation, UpdateAccessTokenMutationVariables>;
export const RevokeAccessTokenEmailDocument = gql`
    mutation revokeAccessTokenEmail($token: String!, $email: String!, $clientMutationId: String) {
  revokeAccessTokenEmail(
    input: {token: $token, email: $email, clientMutationId: $clientMutationId}
  ) {
    accessToken {
      id
      token
      view {
        id
      }
      type
      emails
    }
    clientMutationId
  }
}
    `;
export type RevokeAccessTokenEmailMutationFn = ApolloReactCommon.MutationFunction<RevokeAccessTokenEmailMutation, RevokeAccessTokenEmailMutationVariables>;

/**
 * __useRevokeAccessTokenEmailMutation__
 *
 * To run a mutation, you first call `useRevokeAccessTokenEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeAccessTokenEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeAccessTokenEmailMutation, { data, loading, error }] = useRevokeAccessTokenEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *      email: // value for 'email'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useRevokeAccessTokenEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RevokeAccessTokenEmailMutation, RevokeAccessTokenEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RevokeAccessTokenEmailMutation, RevokeAccessTokenEmailMutationVariables>(RevokeAccessTokenEmailDocument, options);
      }
export type RevokeAccessTokenEmailMutationHookResult = ReturnType<typeof useRevokeAccessTokenEmailMutation>;
export type RevokeAccessTokenEmailMutationResult = ApolloReactCommon.MutationResult<RevokeAccessTokenEmailMutation>;
export type RevokeAccessTokenEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<RevokeAccessTokenEmailMutation, RevokeAccessTokenEmailMutationVariables>;
export const ArtifactCollectionAliasActionHistoryDocument = gql`
    query ArtifactCollectionAliasActionHistory($projectName: String, $entityName: String, $artifactTypeName: String!, $artifactCollectionName: String!, $actionCursor: String, $actionFirst: Int, $alias: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactType(name: $artifactTypeName) {
      id
      artifactCollection(name: $artifactCollectionName) {
        id
        aliases {
          edges {
            node {
              id
              alias
            }
          }
        }
        isModelRegistryMigratedArtifactCollection
        aliasActionHistory(after: $actionCursor, first: $actionFirst, alias: $alias) {
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          edges {
            node {
              createdAt
              alias
              actionType
              targetArtifact {
                id
                versionIndex
                artifactSequence {
                  id
                  name
                  project {
                    id
                    name
                  }
                }
              }
              sourceArtifact {
                id
                versionIndex
                artifactSequence {
                  id
                  name
                  project {
                    id
                    name
                  }
                }
              }
              user {
                id
                username
                photoUrl
                name
                accountType
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactCollectionAliasActionHistoryQuery__
 *
 * To run a query within a React component, call `useArtifactCollectionAliasActionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCollectionAliasActionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCollectionAliasActionHistoryQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *      artifactCollectionName: // value for 'artifactCollectionName'
 *      actionCursor: // value for 'actionCursor'
 *      actionFirst: // value for 'actionFirst'
 *      alias: // value for 'alias'
 *   },
 * });
 */
export function useArtifactCollectionAliasActionHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables> & ({ variables: ArtifactCollectionAliasActionHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables>(ArtifactCollectionAliasActionHistoryDocument, options);
      }
export function useArtifactCollectionAliasActionHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables>(ArtifactCollectionAliasActionHistoryDocument, options);
        }
// @ts-ignore
export function useArtifactCollectionAliasActionHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables>;
export function useArtifactCollectionAliasActionHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionAliasActionHistoryQuery | undefined, ArtifactCollectionAliasActionHistoryQueryVariables>;
export function useArtifactCollectionAliasActionHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables>(ArtifactCollectionAliasActionHistoryDocument, options);
        }
export type ArtifactCollectionAliasActionHistoryQueryHookResult = ReturnType<typeof useArtifactCollectionAliasActionHistoryQuery>;
export type ArtifactCollectionAliasActionHistoryLazyQueryHookResult = ReturnType<typeof useArtifactCollectionAliasActionHistoryLazyQuery>;
export type ArtifactCollectionAliasActionHistorySuspenseQueryHookResult = ReturnType<typeof useArtifactCollectionAliasActionHistorySuspenseQuery>;
export type ArtifactCollectionAliasActionHistoryQueryResult = ApolloReactCommon.QueryResult<ArtifactCollectionAliasActionHistoryQuery, ArtifactCollectionAliasActionHistoryQueryVariables>;
export const ArtifactCollectionActionHistoryDocument = gql`
    query ArtifactCollectionActionHistory($projectName: String, $entityName: String, $artifactTypeName: String!, $artifactCollectionName: String!, $actionCursor: String, $actionFirst: Int) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactType(name: $artifactTypeName) {
      id
      artifactCollection(name: $artifactCollectionName) {
        id
        aliases {
          edges {
            node {
              id
              alias
            }
          }
        }
        artifactCollectionActions(after: $actionCursor, first: $actionFirst) {
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          edges {
            node {
              id
              createdAt
              actionType
              user {
                id
                username
                name
                accountType
              }
              artifact {
                id
                versionIndex
                artifactSequence {
                  id
                  name
                  project {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactCollectionActionHistoryQuery__
 *
 * To run a query within a React component, call `useArtifactCollectionActionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCollectionActionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCollectionActionHistoryQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *      artifactCollectionName: // value for 'artifactCollectionName'
 *      actionCursor: // value for 'actionCursor'
 *      actionFirst: // value for 'actionFirst'
 *   },
 * });
 */
export function useArtifactCollectionActionHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables> & ({ variables: ArtifactCollectionActionHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables>(ArtifactCollectionActionHistoryDocument, options);
      }
export function useArtifactCollectionActionHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables>(ArtifactCollectionActionHistoryDocument, options);
        }
// @ts-ignore
export function useArtifactCollectionActionHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables>;
export function useArtifactCollectionActionHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionActionHistoryQuery | undefined, ArtifactCollectionActionHistoryQueryVariables>;
export function useArtifactCollectionActionHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables>(ArtifactCollectionActionHistoryDocument, options);
        }
export type ArtifactCollectionActionHistoryQueryHookResult = ReturnType<typeof useArtifactCollectionActionHistoryQuery>;
export type ArtifactCollectionActionHistoryLazyQueryHookResult = ReturnType<typeof useArtifactCollectionActionHistoryLazyQuery>;
export type ArtifactCollectionActionHistorySuspenseQueryHookResult = ReturnType<typeof useArtifactCollectionActionHistorySuspenseQuery>;
export type ArtifactCollectionActionHistoryQueryResult = ApolloReactCommon.QueryResult<ArtifactCollectionActionHistoryQuery, ArtifactCollectionActionHistoryQueryVariables>;
export const ArtifactCollectionDocument = gql`
    query ArtifactCollection($projectName: String, $entityName: String, $artifactTypeName: String!, $artifactCollectionName: String!, $artifactCursor: String, $artifactFirst: Int) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactType(name: $artifactTypeName) {
      id
      name
      description
      artifactCollection(name: $artifactCollectionName) {
        __typename
        id
        name
        description
        artifactMemberships(after: $artifactCursor, first: $artifactFirst) {
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          edges {
            node {
              id
              createdAt
              commitHash
              versionIndex
              artifact {
                id
                digest
                state
                createdAt
              }
              aliases {
                id
                artifactCollection {
                  id
                  name
                }
                alias
              }
            }
          }
        }
        aliases {
          edges {
            node {
              id
              alias
              artifact {
                id
                versionIndex
              }
            }
          }
        }
        tags {
          edges {
            node {
              id
              name
              tagCategoryName
              attributes
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactCollectionQuery__
 *
 * To run a query within a React component, call `useArtifactCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCollectionQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *      artifactCollectionName: // value for 'artifactCollectionName'
 *      artifactCursor: // value for 'artifactCursor'
 *      artifactFirst: // value for 'artifactFirst'
 *   },
 * });
 */
export function useArtifactCollectionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCollectionQuery, ArtifactCollectionQueryVariables> & ({ variables: ArtifactCollectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCollectionQuery, ArtifactCollectionQueryVariables>(ArtifactCollectionDocument, options);
      }
export function useArtifactCollectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCollectionQuery, ArtifactCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCollectionQuery, ArtifactCollectionQueryVariables>(ArtifactCollectionDocument, options);
        }
// @ts-ignore
export function useArtifactCollectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionQuery, ArtifactCollectionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionQuery, ArtifactCollectionQueryVariables>;
export function useArtifactCollectionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionQuery, ArtifactCollectionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionQuery | undefined, ArtifactCollectionQueryVariables>;
export function useArtifactCollectionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionQuery, ArtifactCollectionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCollectionQuery, ArtifactCollectionQueryVariables>(ArtifactCollectionDocument, options);
        }
export type ArtifactCollectionQueryHookResult = ReturnType<typeof useArtifactCollectionQuery>;
export type ArtifactCollectionLazyQueryHookResult = ReturnType<typeof useArtifactCollectionLazyQuery>;
export type ArtifactCollectionSuspenseQueryHookResult = ReturnType<typeof useArtifactCollectionSuspenseQuery>;
export type ArtifactCollectionQueryResult = ApolloReactCommon.QueryResult<ArtifactCollectionQuery, ArtifactCollectionQueryVariables>;
export const EntityPortfoliosDocument = gql`
    query EntityPortfolios($entityName: String!, $artifactTypeName: String!) {
  entity(name: $entityName) {
    id
    name
    projects {
      edges {
        node {
          id
          name
          artifactType(name: $artifactTypeName) {
            id
            name
            artifactCollections(collectionTypes: [PORTFOLIO]) {
              edges {
                node {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useEntityPortfoliosQuery__
 *
 * To run a query within a React component, call `useEntityPortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityPortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityPortfoliosQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *   },
 * });
 */
export function useEntityPortfoliosQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityPortfoliosQuery, EntityPortfoliosQueryVariables> & ({ variables: EntityPortfoliosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityPortfoliosQuery, EntityPortfoliosQueryVariables>(EntityPortfoliosDocument, options);
      }
export function useEntityPortfoliosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityPortfoliosQuery, EntityPortfoliosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityPortfoliosQuery, EntityPortfoliosQueryVariables>(EntityPortfoliosDocument, options);
        }
// @ts-ignore
export function useEntityPortfoliosSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityPortfoliosQuery, EntityPortfoliosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityPortfoliosQuery, EntityPortfoliosQueryVariables>;
export function useEntityPortfoliosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityPortfoliosQuery, EntityPortfoliosQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityPortfoliosQuery | undefined, EntityPortfoliosQueryVariables>;
export function useEntityPortfoliosSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityPortfoliosQuery, EntityPortfoliosQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityPortfoliosQuery, EntityPortfoliosQueryVariables>(EntityPortfoliosDocument, options);
        }
export type EntityPortfoliosQueryHookResult = ReturnType<typeof useEntityPortfoliosQuery>;
export type EntityPortfoliosLazyQueryHookResult = ReturnType<typeof useEntityPortfoliosLazyQuery>;
export type EntityPortfoliosSuspenseQueryHookResult = ReturnType<typeof useEntityPortfoliosSuspenseQuery>;
export type EntityPortfoliosQueryResult = ApolloReactCommon.QueryResult<EntityPortfoliosQuery, EntityPortfoliosQueryVariables>;
export const ArtifactCollectionNameFromIdDocument = gql`
    query ArtifactCollectionNameFromID($artifactCollectionID: ID!) {
  artifactCollection(id: $artifactCollectionID) {
    __typename
    ... on ArtifactSequence {
      id
      name
      project {
        id
        name
      }
    }
    ... on ArtifactPortfolio {
      id
      name
      project {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useArtifactCollectionNameFromIdQuery__
 *
 * To run a query within a React component, call `useArtifactCollectionNameFromIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCollectionNameFromIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCollectionNameFromIdQuery({
 *   variables: {
 *      artifactCollectionID: // value for 'artifactCollectionID'
 *   },
 * });
 */
export function useArtifactCollectionNameFromIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables> & ({ variables: ArtifactCollectionNameFromIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables>(ArtifactCollectionNameFromIdDocument, options);
      }
export function useArtifactCollectionNameFromIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables>(ArtifactCollectionNameFromIdDocument, options);
        }
// @ts-ignore
export function useArtifactCollectionNameFromIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables>;
export function useArtifactCollectionNameFromIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCollectionNameFromIdQuery | undefined, ArtifactCollectionNameFromIdQueryVariables>;
export function useArtifactCollectionNameFromIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables>(ArtifactCollectionNameFromIdDocument, options);
        }
export type ArtifactCollectionNameFromIdQueryHookResult = ReturnType<typeof useArtifactCollectionNameFromIdQuery>;
export type ArtifactCollectionNameFromIdLazyQueryHookResult = ReturnType<typeof useArtifactCollectionNameFromIdLazyQuery>;
export type ArtifactCollectionNameFromIdSuspenseQueryHookResult = ReturnType<typeof useArtifactCollectionNameFromIdSuspenseQuery>;
export type ArtifactCollectionNameFromIdQueryResult = ApolloReactCommon.QueryResult<ArtifactCollectionNameFromIdQuery, ArtifactCollectionNameFromIdQueryVariables>;
export const ArtifactFilesDocument = gql`
    query ArtifactFiles($artifactID: ID!, $artifactFileNames: [String!]!) {
  artifact(id: $artifactID) {
    id
    createdAt
    files(names: $artifactFileNames) {
      edges {
        node {
          id
          name
          displayName
          digest
          url
          directUrl
          isReference
          sizeBytes
          updatedAt
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactFilesQuery__
 *
 * To run a query within a React component, call `useArtifactFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactFilesQuery({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *      artifactFileNames: // value for 'artifactFileNames'
 *   },
 * });
 */
export function useArtifactFilesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactFilesQuery, ArtifactFilesQueryVariables> & ({ variables: ArtifactFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactFilesQuery, ArtifactFilesQueryVariables>(ArtifactFilesDocument, options);
      }
export function useArtifactFilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactFilesQuery, ArtifactFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactFilesQuery, ArtifactFilesQueryVariables>(ArtifactFilesDocument, options);
        }
// @ts-ignore
export function useArtifactFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactFilesQuery, ArtifactFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactFilesQuery, ArtifactFilesQueryVariables>;
export function useArtifactFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactFilesQuery, ArtifactFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactFilesQuery | undefined, ArtifactFilesQueryVariables>;
export function useArtifactFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactFilesQuery, ArtifactFilesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactFilesQuery, ArtifactFilesQueryVariables>(ArtifactFilesDocument, options);
        }
export type ArtifactFilesQueryHookResult = ReturnType<typeof useArtifactFilesQuery>;
export type ArtifactFilesLazyQueryHookResult = ReturnType<typeof useArtifactFilesLazyQuery>;
export type ArtifactFilesSuspenseQueryHookResult = ReturnType<typeof useArtifactFilesSuspenseQuery>;
export type ArtifactFilesQueryResult = ApolloReactCommon.QueryResult<ArtifactFilesQuery, ArtifactFilesQueryVariables>;
export const ArtifactIdDocument = gql`
    query ArtifactID($projectName: String!, $entityName: String!, $artifactTypeName: String!, $artifactID: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactType(name: $artifactTypeName) {
      id
      artifact(name: $artifactID) {
        id
      }
    }
  }
}
    `;

/**
 * __useArtifactIdQuery__
 *
 * To run a query within a React component, call `useArtifactIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactIdQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *      artifactID: // value for 'artifactID'
 *   },
 * });
 */
export function useArtifactIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactIdQuery, ArtifactIdQueryVariables> & ({ variables: ArtifactIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactIdQuery, ArtifactIdQueryVariables>(ArtifactIdDocument, options);
      }
export function useArtifactIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactIdQuery, ArtifactIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactIdQuery, ArtifactIdQueryVariables>(ArtifactIdDocument, options);
        }
// @ts-ignore
export function useArtifactIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactIdQuery, ArtifactIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactIdQuery, ArtifactIdQueryVariables>;
export function useArtifactIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactIdQuery, ArtifactIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactIdQuery | undefined, ArtifactIdQueryVariables>;
export function useArtifactIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactIdQuery, ArtifactIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactIdQuery, ArtifactIdQueryVariables>(ArtifactIdDocument, options);
        }
export type ArtifactIdQueryHookResult = ReturnType<typeof useArtifactIdQuery>;
export type ArtifactIdLazyQueryHookResult = ReturnType<typeof useArtifactIdLazyQuery>;
export type ArtifactIdSuspenseQueryHookResult = ReturnType<typeof useArtifactIdSuspenseQuery>;
export type ArtifactIdQueryResult = ApolloReactCommon.QueryResult<ArtifactIdQuery, ArtifactIdQueryVariables>;
export const ArtifactPathInfoDocument = gql`
    query ArtifactPathInfo($artifactId: ID!) {
  artifact(id: $artifactId) {
    id
    createdAt
    commitHash
    versionIndex
    artifactSequence {
      id
      name
    }
    artifactType {
      id
      name
      project {
        id
        name
        entityName
      }
    }
  }
}
    `;

/**
 * __useArtifactPathInfoQuery__
 *
 * To run a query within a React component, call `useArtifactPathInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactPathInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactPathInfoQuery({
 *   variables: {
 *      artifactId: // value for 'artifactId'
 *   },
 * });
 */
export function useArtifactPathInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables> & ({ variables: ArtifactPathInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables>(ArtifactPathInfoDocument, options);
      }
export function useArtifactPathInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables>(ArtifactPathInfoDocument, options);
        }
// @ts-ignore
export function useArtifactPathInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables>;
export function useArtifactPathInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactPathInfoQuery | undefined, ArtifactPathInfoQueryVariables>;
export function useArtifactPathInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables>(ArtifactPathInfoDocument, options);
        }
export type ArtifactPathInfoQueryHookResult = ReturnType<typeof useArtifactPathInfoQuery>;
export type ArtifactPathInfoLazyQueryHookResult = ReturnType<typeof useArtifactPathInfoLazyQuery>;
export type ArtifactPathInfoSuspenseQueryHookResult = ReturnType<typeof useArtifactPathInfoSuspenseQuery>;
export type ArtifactPathInfoQueryResult = ApolloReactCommon.QueryResult<ArtifactPathInfoQuery, ArtifactPathInfoQueryVariables>;
export const ArtifactManifestDocument = gql`
    query ArtifactManifest($projectName: String, $entityName: String, $artifactTypeName: String!, $artifactID: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactType(name: $artifactTypeName) {
      id
      artifact(name: $artifactID) {
        id
        createdAt
        currentManifest {
          id
          file {
            id
            directUrl
          }
        }
      }
    }
  }
  serverInfo {
    defaultCloudRegion {
      id
    }
  }
}
    `;

/**
 * __useArtifactManifestQuery__
 *
 * To run a query within a React component, call `useArtifactManifestQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactManifestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactManifestQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *      artifactID: // value for 'artifactID'
 *   },
 * });
 */
export function useArtifactManifestQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactManifestQuery, ArtifactManifestQueryVariables> & ({ variables: ArtifactManifestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactManifestQuery, ArtifactManifestQueryVariables>(ArtifactManifestDocument, options);
      }
export function useArtifactManifestLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactManifestQuery, ArtifactManifestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactManifestQuery, ArtifactManifestQueryVariables>(ArtifactManifestDocument, options);
        }
// @ts-ignore
export function useArtifactManifestSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactManifestQuery, ArtifactManifestQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactManifestQuery, ArtifactManifestQueryVariables>;
export function useArtifactManifestSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactManifestQuery, ArtifactManifestQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactManifestQuery | undefined, ArtifactManifestQueryVariables>;
export function useArtifactManifestSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactManifestQuery, ArtifactManifestQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactManifestQuery, ArtifactManifestQueryVariables>(ArtifactManifestDocument, options);
        }
export type ArtifactManifestQueryHookResult = ReturnType<typeof useArtifactManifestQuery>;
export type ArtifactManifestLazyQueryHookResult = ReturnType<typeof useArtifactManifestLazyQuery>;
export type ArtifactManifestSuspenseQueryHookResult = ReturnType<typeof useArtifactManifestSuspenseQuery>;
export type ArtifactManifestQueryResult = ApolloReactCommon.QueryResult<ArtifactManifestQuery, ArtifactManifestQueryVariables>;
export const ArtifactManifestFromIdDocument = gql`
    query ArtifactManifestFromID($artifactId: ID!) {
  artifact(id: $artifactId) {
    id
    createdAt
    artifactSequence {
      id
      name
      project {
        id
        name
        entityName
      }
    }
    artifactType {
      id
      name
    }
    currentManifest {
      id
      file {
        id
        directUrl
      }
    }
  }
  serverInfo {
    defaultCloudRegion {
      id
    }
  }
}
    `;

/**
 * __useArtifactManifestFromIdQuery__
 *
 * To run a query within a React component, call `useArtifactManifestFromIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactManifestFromIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactManifestFromIdQuery({
 *   variables: {
 *      artifactId: // value for 'artifactId'
 *   },
 * });
 */
export function useArtifactManifestFromIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables> & ({ variables: ArtifactManifestFromIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables>(ArtifactManifestFromIdDocument, options);
      }
export function useArtifactManifestFromIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables>(ArtifactManifestFromIdDocument, options);
        }
// @ts-ignore
export function useArtifactManifestFromIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables>;
export function useArtifactManifestFromIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactManifestFromIdQuery | undefined, ArtifactManifestFromIdQueryVariables>;
export function useArtifactManifestFromIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables>(ArtifactManifestFromIdDocument, options);
        }
export type ArtifactManifestFromIdQueryHookResult = ReturnType<typeof useArtifactManifestFromIdQuery>;
export type ArtifactManifestFromIdLazyQueryHookResult = ReturnType<typeof useArtifactManifestFromIdLazyQuery>;
export type ArtifactManifestFromIdSuspenseQueryHookResult = ReturnType<typeof useArtifactManifestFromIdSuspenseQuery>;
export type ArtifactManifestFromIdQueryResult = ApolloReactCommon.QueryResult<ArtifactManifestFromIdQuery, ArtifactManifestFromIdQueryVariables>;
export const ResolveLatestSequenceAliasToArtifactIdDocument = gql`
    query ResolveLatestSequenceAliasToArtifactId($sequenceId: ID!) {
  artifactSequence(id: $sequenceId) {
    id
    latestArtifact {
      id
    }
  }
}
    `;

/**
 * __useResolveLatestSequenceAliasToArtifactIdQuery__
 *
 * To run a query within a React component, call `useResolveLatestSequenceAliasToArtifactIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveLatestSequenceAliasToArtifactIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveLatestSequenceAliasToArtifactIdQuery({
 *   variables: {
 *      sequenceId: // value for 'sequenceId'
 *   },
 * });
 */
export function useResolveLatestSequenceAliasToArtifactIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables> & ({ variables: ResolveLatestSequenceAliasToArtifactIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables>(ResolveLatestSequenceAliasToArtifactIdDocument, options);
      }
export function useResolveLatestSequenceAliasToArtifactIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables>(ResolveLatestSequenceAliasToArtifactIdDocument, options);
        }
// @ts-ignore
export function useResolveLatestSequenceAliasToArtifactIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables>;
export function useResolveLatestSequenceAliasToArtifactIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ResolveLatestSequenceAliasToArtifactIdQuery | undefined, ResolveLatestSequenceAliasToArtifactIdQueryVariables>;
export function useResolveLatestSequenceAliasToArtifactIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables>(ResolveLatestSequenceAliasToArtifactIdDocument, options);
        }
export type ResolveLatestSequenceAliasToArtifactIdQueryHookResult = ReturnType<typeof useResolveLatestSequenceAliasToArtifactIdQuery>;
export type ResolveLatestSequenceAliasToArtifactIdLazyQueryHookResult = ReturnType<typeof useResolveLatestSequenceAliasToArtifactIdLazyQuery>;
export type ResolveLatestSequenceAliasToArtifactIdSuspenseQueryHookResult = ReturnType<typeof useResolveLatestSequenceAliasToArtifactIdSuspenseQuery>;
export type ResolveLatestSequenceAliasToArtifactIdQueryResult = ApolloReactCommon.QueryResult<ResolveLatestSequenceAliasToArtifactIdQuery, ResolveLatestSequenceAliasToArtifactIdQueryVariables>;
export const ArtifactCommitHashDocument = gql`
    query ArtifactCommitHash($id: ID!, $artifactCollectionName: String!) {
  artifact(id: $id) {
    id
    commitHash(artifactCollectionName: $artifactCollectionName)
  }
}
    `;

/**
 * __useArtifactCommitHashQuery__
 *
 * To run a query within a React component, call `useArtifactCommitHashQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactCommitHashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactCommitHashQuery({
 *   variables: {
 *      id: // value for 'id'
 *      artifactCollectionName: // value for 'artifactCollectionName'
 *   },
 * });
 */
export function useArtifactCommitHashQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables> & ({ variables: ArtifactCommitHashQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables>(ArtifactCommitHashDocument, options);
      }
export function useArtifactCommitHashLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables>(ArtifactCommitHashDocument, options);
        }
// @ts-ignore
export function useArtifactCommitHashSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables>;
export function useArtifactCommitHashSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactCommitHashQuery | undefined, ArtifactCommitHashQueryVariables>;
export function useArtifactCommitHashSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables>(ArtifactCommitHashDocument, options);
        }
export type ArtifactCommitHashQueryHookResult = ReturnType<typeof useArtifactCommitHashQuery>;
export type ArtifactCommitHashLazyQueryHookResult = ReturnType<typeof useArtifactCommitHashLazyQuery>;
export type ArtifactCommitHashSuspenseQueryHookResult = ReturnType<typeof useArtifactCommitHashSuspenseQuery>;
export type ArtifactCommitHashQueryResult = ApolloReactCommon.QueryResult<ArtifactCommitHashQuery, ArtifactCommitHashQueryVariables>;
export const ArtifactManifestFromMembershipDocument = gql`
    query ArtifactManifestFromMembership($projectName: String!, $entityName: String!, $artifactName: String!, $versionIndex: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactCollection(name: $artifactName) {
      id
      artifactMembership(aliasName: $versionIndex) {
        id
        artifact {
          id
          createdAt
          currentManifest {
            id
            file {
              id
              directUrl
            }
          }
        }
      }
    }
  }
  serverInfo {
    defaultCloudRegion {
      id
    }
  }
}
    `;

/**
 * __useArtifactManifestFromMembershipQuery__
 *
 * To run a query within a React component, call `useArtifactManifestFromMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactManifestFromMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactManifestFromMembershipQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      artifactName: // value for 'artifactName'
 *      versionIndex: // value for 'versionIndex'
 *   },
 * });
 */
export function useArtifactManifestFromMembershipQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables> & ({ variables: ArtifactManifestFromMembershipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables>(ArtifactManifestFromMembershipDocument, options);
      }
export function useArtifactManifestFromMembershipLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables>(ArtifactManifestFromMembershipDocument, options);
        }
// @ts-ignore
export function useArtifactManifestFromMembershipSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables>;
export function useArtifactManifestFromMembershipSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactManifestFromMembershipQuery | undefined, ArtifactManifestFromMembershipQueryVariables>;
export function useArtifactManifestFromMembershipSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables>(ArtifactManifestFromMembershipDocument, options);
        }
export type ArtifactManifestFromMembershipQueryHookResult = ReturnType<typeof useArtifactManifestFromMembershipQuery>;
export type ArtifactManifestFromMembershipLazyQueryHookResult = ReturnType<typeof useArtifactManifestFromMembershipLazyQuery>;
export type ArtifactManifestFromMembershipSuspenseQueryHookResult = ReturnType<typeof useArtifactManifestFromMembershipSuspenseQuery>;
export type ArtifactManifestFromMembershipQueryResult = ApolloReactCommon.QueryResult<ArtifactManifestFromMembershipQuery, ArtifactManifestFromMembershipQueryVariables>;
export const CreateArtifactTypesDocument = gql`
    mutation CreateArtifactTypes($entityName: String!, $projectName: String!, $artifactTypes: [ArtifactTypeInput!]!) {
  createArtifactTypes(
    input: {entityName: $entityName, projectName: $projectName, artifactTypes: $artifactTypes}
  ) {
    artifactTypes {
      id
      name
    }
  }
}
    `;
export type CreateArtifactTypesMutationFn = ApolloReactCommon.MutationFunction<CreateArtifactTypesMutation, CreateArtifactTypesMutationVariables>;

/**
 * __useCreateArtifactTypesMutation__
 *
 * To run a mutation, you first call `useCreateArtifactTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArtifactTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArtifactTypesMutation, { data, loading, error }] = useCreateArtifactTypesMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      artifactTypes: // value for 'artifactTypes'
 *   },
 * });
 */
export function useCreateArtifactTypesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateArtifactTypesMutation, CreateArtifactTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateArtifactTypesMutation, CreateArtifactTypesMutationVariables>(CreateArtifactTypesDocument, options);
      }
export type CreateArtifactTypesMutationHookResult = ReturnType<typeof useCreateArtifactTypesMutation>;
export type CreateArtifactTypesMutationResult = ApolloReactCommon.MutationResult<CreateArtifactTypesMutation>;
export type CreateArtifactTypesMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateArtifactTypesMutation, CreateArtifactTypesMutationVariables>;
export const UpdateArtifactDocument = gql`
    mutation UpdateArtifact($artifactID: ID!, $description: String, $aliases: [ArtifactAliasInput!], $labels: JSONString, $metadata: JSONString, $ttlDurationSeconds: Int64) {
  updateArtifact(
    input: {artifactID: $artifactID, description: $description, aliases: $aliases, labels: $labels, metadata: $metadata, ttlDurationSeconds: $ttlDurationSeconds}
  ) {
    artifact {
      id
      digest
      description
      aliases {
        id
        artifactCollectionName
        alias
      }
      labels
      ttlDurationSeconds
    }
  }
}
    `;
export type UpdateArtifactMutationFn = ApolloReactCommon.MutationFunction<UpdateArtifactMutation, UpdateArtifactMutationVariables>;

/**
 * __useUpdateArtifactMutation__
 *
 * To run a mutation, you first call `useUpdateArtifactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArtifactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArtifactMutation, { data, loading, error }] = useUpdateArtifactMutation({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *      description: // value for 'description'
 *      aliases: // value for 'aliases'
 *      labels: // value for 'labels'
 *      metadata: // value for 'metadata'
 *      ttlDurationSeconds: // value for 'ttlDurationSeconds'
 *   },
 * });
 */
export function useUpdateArtifactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateArtifactMutation, UpdateArtifactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateArtifactMutation, UpdateArtifactMutationVariables>(UpdateArtifactDocument, options);
      }
export type UpdateArtifactMutationHookResult = ReturnType<typeof useUpdateArtifactMutation>;
export type UpdateArtifactMutationResult = ApolloReactCommon.MutationResult<UpdateArtifactMutation>;
export type UpdateArtifactMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateArtifactMutation, UpdateArtifactMutationVariables>;
export const DeleteArtifactDocument = gql`
    mutation DeleteArtifact($artifactID: ID!, $deleteAliases: Boolean = false) {
  deleteArtifact(input: {artifactID: $artifactID, deleteAliases: $deleteAliases}) {
    artifact {
      id
      state
    }
  }
}
    `;
export type DeleteArtifactMutationFn = ApolloReactCommon.MutationFunction<DeleteArtifactMutation, DeleteArtifactMutationVariables>;

/**
 * __useDeleteArtifactMutation__
 *
 * To run a mutation, you first call `useDeleteArtifactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArtifactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArtifactMutation, { data, loading, error }] = useDeleteArtifactMutation({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *      deleteAliases: // value for 'deleteAliases'
 *   },
 * });
 */
export function useDeleteArtifactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteArtifactMutation, DeleteArtifactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteArtifactMutation, DeleteArtifactMutationVariables>(DeleteArtifactDocument, options);
      }
export type DeleteArtifactMutationHookResult = ReturnType<typeof useDeleteArtifactMutation>;
export type DeleteArtifactMutationResult = ApolloReactCommon.MutationResult<DeleteArtifactMutation>;
export type DeleteArtifactMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteArtifactMutation, DeleteArtifactMutationVariables>;
export const DeleteArtifactSequenceDocument = gql`
    mutation DeleteArtifactSequence($artifactSequenceID: ID!) {
  deleteArtifactSequence(input: {artifactSequenceID: $artifactSequenceID}) {
    artifactCollection {
      id
      state
    }
  }
}
    `;
export type DeleteArtifactSequenceMutationFn = ApolloReactCommon.MutationFunction<DeleteArtifactSequenceMutation, DeleteArtifactSequenceMutationVariables>;

/**
 * __useDeleteArtifactSequenceMutation__
 *
 * To run a mutation, you first call `useDeleteArtifactSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArtifactSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArtifactSequenceMutation, { data, loading, error }] = useDeleteArtifactSequenceMutation({
 *   variables: {
 *      artifactSequenceID: // value for 'artifactSequenceID'
 *   },
 * });
 */
export function useDeleteArtifactSequenceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteArtifactSequenceMutation, DeleteArtifactSequenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteArtifactSequenceMutation, DeleteArtifactSequenceMutationVariables>(DeleteArtifactSequenceDocument, options);
      }
export type DeleteArtifactSequenceMutationHookResult = ReturnType<typeof useDeleteArtifactSequenceMutation>;
export type DeleteArtifactSequenceMutationResult = ApolloReactCommon.MutationResult<DeleteArtifactSequenceMutation>;
export type DeleteArtifactSequenceMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteArtifactSequenceMutation, DeleteArtifactSequenceMutationVariables>;
export const UpdateArtifactTypeDocument = gql`
    mutation UpdateArtifactType($artifactTypeID: ID!, $description: String) {
  updateArtifactType(
    input: {artifactTypeID: $artifactTypeID, description: $description}
  ) {
    artifactType {
      id
      description
    }
  }
}
    `;
export type UpdateArtifactTypeMutationFn = ApolloReactCommon.MutationFunction<UpdateArtifactTypeMutation, UpdateArtifactTypeMutationVariables>;

/**
 * __useUpdateArtifactTypeMutation__
 *
 * To run a mutation, you first call `useUpdateArtifactTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArtifactTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArtifactTypeMutation, { data, loading, error }] = useUpdateArtifactTypeMutation({
 *   variables: {
 *      artifactTypeID: // value for 'artifactTypeID'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateArtifactTypeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateArtifactTypeMutation, UpdateArtifactTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateArtifactTypeMutation, UpdateArtifactTypeMutationVariables>(UpdateArtifactTypeDocument, options);
      }
export type UpdateArtifactTypeMutationHookResult = ReturnType<typeof useUpdateArtifactTypeMutation>;
export type UpdateArtifactTypeMutationResult = ApolloReactCommon.MutationResult<UpdateArtifactTypeMutation>;
export type UpdateArtifactTypeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateArtifactTypeMutation, UpdateArtifactTypeMutationVariables>;
export const UpdateArtifactPortfolioDocument = gql`
    mutation UpdateArtifactPortfolio($artifactPortfolioID: ID!, $name: String, $description: String) {
  updateArtifactPortfolio(
    input: {artifactPortfolioID: $artifactPortfolioID, name: $name, description: $description}
  ) {
    artifactCollection {
      id
      name
      description
    }
  }
}
    `;
export type UpdateArtifactPortfolioMutationFn = ApolloReactCommon.MutationFunction<UpdateArtifactPortfolioMutation, UpdateArtifactPortfolioMutationVariables>;

/**
 * __useUpdateArtifactPortfolioMutation__
 *
 * To run a mutation, you first call `useUpdateArtifactPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArtifactPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArtifactPortfolioMutation, { data, loading, error }] = useUpdateArtifactPortfolioMutation({
 *   variables: {
 *      artifactPortfolioID: // value for 'artifactPortfolioID'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateArtifactPortfolioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateArtifactPortfolioMutation, UpdateArtifactPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateArtifactPortfolioMutation, UpdateArtifactPortfolioMutationVariables>(UpdateArtifactPortfolioDocument, options);
      }
export type UpdateArtifactPortfolioMutationHookResult = ReturnType<typeof useUpdateArtifactPortfolioMutation>;
export type UpdateArtifactPortfolioMutationResult = ApolloReactCommon.MutationResult<UpdateArtifactPortfolioMutation>;
export type UpdateArtifactPortfolioMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateArtifactPortfolioMutation, UpdateArtifactPortfolioMutationVariables>;
export const UpdateArtifactCollectionDocument = gql`
    mutation UpdateArtifactCollection($artifactSequenceID: ID!, $name: String, $description: String) {
  updateArtifactSequence(
    input: {artifactSequenceID: $artifactSequenceID, name: $name, description: $description}
  ) {
    artifactCollection {
      id
      name
      description
    }
  }
}
    `;
export type UpdateArtifactCollectionMutationFn = ApolloReactCommon.MutationFunction<UpdateArtifactCollectionMutation, UpdateArtifactCollectionMutationVariables>;

/**
 * __useUpdateArtifactCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateArtifactCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArtifactCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArtifactCollectionMutation, { data, loading, error }] = useUpdateArtifactCollectionMutation({
 *   variables: {
 *      artifactSequenceID: // value for 'artifactSequenceID'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateArtifactCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateArtifactCollectionMutation, UpdateArtifactCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateArtifactCollectionMutation, UpdateArtifactCollectionMutationVariables>(UpdateArtifactCollectionDocument, options);
      }
export type UpdateArtifactCollectionMutationHookResult = ReturnType<typeof useUpdateArtifactCollectionMutation>;
export type UpdateArtifactCollectionMutationResult = ApolloReactCommon.MutationResult<UpdateArtifactCollectionMutation>;
export type UpdateArtifactCollectionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateArtifactCollectionMutation, UpdateArtifactCollectionMutationVariables>;
export const MoveArtifactCollectionDocument = gql`
    mutation MoveArtifactCollection($artifactSequenceID: ID!, $destinationArtifactTypeName: String!) {
  moveArtifactSequence(
    input: {artifactSequenceID: $artifactSequenceID, destinationArtifactTypeName: $destinationArtifactTypeName}
  ) {
    artifactCollection {
      id
      name
      description
    }
  }
}
    `;
export type MoveArtifactCollectionMutationFn = ApolloReactCommon.MutationFunction<MoveArtifactCollectionMutation, MoveArtifactCollectionMutationVariables>;

/**
 * __useMoveArtifactCollectionMutation__
 *
 * To run a mutation, you first call `useMoveArtifactCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveArtifactCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveArtifactCollectionMutation, { data, loading, error }] = useMoveArtifactCollectionMutation({
 *   variables: {
 *      artifactSequenceID: // value for 'artifactSequenceID'
 *      destinationArtifactTypeName: // value for 'destinationArtifactTypeName'
 *   },
 * });
 */
export function useMoveArtifactCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveArtifactCollectionMutation, MoveArtifactCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveArtifactCollectionMutation, MoveArtifactCollectionMutationVariables>(MoveArtifactCollectionDocument, options);
      }
export type MoveArtifactCollectionMutationHookResult = ReturnType<typeof useMoveArtifactCollectionMutation>;
export type MoveArtifactCollectionMutationResult = ApolloReactCommon.MutationResult<MoveArtifactCollectionMutation>;
export type MoveArtifactCollectionMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveArtifactCollectionMutation, MoveArtifactCollectionMutationVariables>;
export const DeleteArtifactCollectionDocument = gql`
    mutation DeleteArtifactCollection($artifactSequenceID: ID!) {
  deleteArtifactSequence(input: {artifactSequenceID: $artifactSequenceID}) {
    artifactCollection {
      id
    }
  }
}
    `;
export type DeleteArtifactCollectionMutationFn = ApolloReactCommon.MutationFunction<DeleteArtifactCollectionMutation, DeleteArtifactCollectionMutationVariables>;

/**
 * __useDeleteArtifactCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteArtifactCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArtifactCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArtifactCollectionMutation, { data, loading, error }] = useDeleteArtifactCollectionMutation({
 *   variables: {
 *      artifactSequenceID: // value for 'artifactSequenceID'
 *   },
 * });
 */
export function useDeleteArtifactCollectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteArtifactCollectionMutation, DeleteArtifactCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteArtifactCollectionMutation, DeleteArtifactCollectionMutationVariables>(DeleteArtifactCollectionDocument, options);
      }
export type DeleteArtifactCollectionMutationHookResult = ReturnType<typeof useDeleteArtifactCollectionMutation>;
export type DeleteArtifactCollectionMutationResult = ApolloReactCommon.MutationResult<DeleteArtifactCollectionMutation>;
export type DeleteArtifactCollectionMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteArtifactCollectionMutation, DeleteArtifactCollectionMutationVariables>;
export const DeleteArtifactPortfolioDocument = gql`
    mutation DeleteArtifactPortfolio($artifactPortfolioID: ID!) {
  deleteArtifactPortfolio(input: {artifactPortfolioID: $artifactPortfolioID}) {
    artifactCollection {
      id
    }
  }
}
    `;
export type DeleteArtifactPortfolioMutationFn = ApolloReactCommon.MutationFunction<DeleteArtifactPortfolioMutation, DeleteArtifactPortfolioMutationVariables>;

/**
 * __useDeleteArtifactPortfolioMutation__
 *
 * To run a mutation, you first call `useDeleteArtifactPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArtifactPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArtifactPortfolioMutation, { data, loading, error }] = useDeleteArtifactPortfolioMutation({
 *   variables: {
 *      artifactPortfolioID: // value for 'artifactPortfolioID'
 *   },
 * });
 */
export function useDeleteArtifactPortfolioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteArtifactPortfolioMutation, DeleteArtifactPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteArtifactPortfolioMutation, DeleteArtifactPortfolioMutationVariables>(DeleteArtifactPortfolioDocument, options);
      }
export type DeleteArtifactPortfolioMutationHookResult = ReturnType<typeof useDeleteArtifactPortfolioMutation>;
export type DeleteArtifactPortfolioMutationResult = ApolloReactCommon.MutationResult<DeleteArtifactPortfolioMutation>;
export type DeleteArtifactPortfolioMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteArtifactPortfolioMutation, DeleteArtifactPortfolioMutationVariables>;
export const CreateArtifactFilesDocument = gql`
    mutation CreateArtifactFiles($artifactFiles: [CreateArtifactFileSpecInput!]!, $layout: ArtifactStorageLayout = V1) {
  createArtifactFiles(
    input: {artifactFiles: $artifactFiles, storageLayout: $layout}
  ) {
    files {
      edges {
        node {
          id
          name
          displayName
          uploadUrl: url(upload: true)
          directUrl
          isReference
          sizeBytes
          updatedAt
        }
      }
    }
  }
}
    `;
export type CreateArtifactFilesMutationFn = ApolloReactCommon.MutationFunction<CreateArtifactFilesMutation, CreateArtifactFilesMutationVariables>;

/**
 * __useCreateArtifactFilesMutation__
 *
 * To run a mutation, you first call `useCreateArtifactFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArtifactFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArtifactFilesMutation, { data, loading, error }] = useCreateArtifactFilesMutation({
 *   variables: {
 *      artifactFiles: // value for 'artifactFiles'
 *      layout: // value for 'layout'
 *   },
 * });
 */
export function useCreateArtifactFilesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateArtifactFilesMutation, CreateArtifactFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateArtifactFilesMutation, CreateArtifactFilesMutationVariables>(CreateArtifactFilesDocument, options);
      }
export type CreateArtifactFilesMutationHookResult = ReturnType<typeof useCreateArtifactFilesMutation>;
export type CreateArtifactFilesMutationResult = ApolloReactCommon.MutationResult<CreateArtifactFilesMutation>;
export type CreateArtifactFilesMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateArtifactFilesMutation, CreateArtifactFilesMutationVariables>;
export const CreateArtifactPortfolioDocument = gql`
    mutation CreateArtifactPortfolio($entityName: String!, $projectName: String!, $artifactTypeID: ID!, $name: String!, $description: String, $clientMutationId: String) {
  createArtifactPortfolio(
    input: {entityName: $entityName, projectName: $projectName, artifactTypeID: $artifactTypeID, name: $name, description: $description, clientMutationId: $clientMutationId}
  ) {
    artifactCollection {
      id
      name
    }
  }
}
    `;
export type CreateArtifactPortfolioMutationFn = ApolloReactCommon.MutationFunction<CreateArtifactPortfolioMutation, CreateArtifactPortfolioMutationVariables>;

/**
 * __useCreateArtifactPortfolioMutation__
 *
 * To run a mutation, you first call `useCreateArtifactPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArtifactPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArtifactPortfolioMutation, { data, loading, error }] = useCreateArtifactPortfolioMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      artifactTypeID: // value for 'artifactTypeID'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCreateArtifactPortfolioMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateArtifactPortfolioMutation, CreateArtifactPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateArtifactPortfolioMutation, CreateArtifactPortfolioMutationVariables>(CreateArtifactPortfolioDocument, options);
      }
export type CreateArtifactPortfolioMutationHookResult = ReturnType<typeof useCreateArtifactPortfolioMutation>;
export type CreateArtifactPortfolioMutationResult = ApolloReactCommon.MutationResult<CreateArtifactPortfolioMutation>;
export type CreateArtifactPortfolioMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateArtifactPortfolioMutation, CreateArtifactPortfolioMutationVariables>;
export const CreateArtifactSequenceDocument = gql`
    mutation CreateArtifactSequence($entityName: String!, $projectName: String!, $artifactTypeID: ID!, $name: String!, $description: String, $clientMutationId: String) {
  createArtifactSequence(
    input: {entityName: $entityName, projectName: $projectName, artifactTypeID: $artifactTypeID, name: $name, description: $description, clientMutationId: $clientMutationId}
  ) {
    artifactCollection {
      id
      name
    }
  }
}
    `;
export type CreateArtifactSequenceMutationFn = ApolloReactCommon.MutationFunction<CreateArtifactSequenceMutation, CreateArtifactSequenceMutationVariables>;

/**
 * __useCreateArtifactSequenceMutation__
 *
 * To run a mutation, you first call `useCreateArtifactSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArtifactSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArtifactSequenceMutation, { data, loading, error }] = useCreateArtifactSequenceMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      artifactTypeID: // value for 'artifactTypeID'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useCreateArtifactSequenceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateArtifactSequenceMutation, CreateArtifactSequenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateArtifactSequenceMutation, CreateArtifactSequenceMutationVariables>(CreateArtifactSequenceDocument, options);
      }
export type CreateArtifactSequenceMutationHookResult = ReturnType<typeof useCreateArtifactSequenceMutation>;
export type CreateArtifactSequenceMutationResult = ApolloReactCommon.MutationResult<CreateArtifactSequenceMutation>;
export type CreateArtifactSequenceMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateArtifactSequenceMutation, CreateArtifactSequenceMutationVariables>;
export const UnlinkArtifactDocument = gql`
    mutation UnlinkArtifact($artifactID: ID!, $artifactPortfolioID: ID!) {
  unlinkArtifact(
    input: {artifactID: $artifactID, artifactPortfolioID: $artifactPortfolioID}
  ) {
    artifactID
    success
    clientMutationId
  }
}
    `;
export type UnlinkArtifactMutationFn = ApolloReactCommon.MutationFunction<UnlinkArtifactMutation, UnlinkArtifactMutationVariables>;

/**
 * __useUnlinkArtifactMutation__
 *
 * To run a mutation, you first call `useUnlinkArtifactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkArtifactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkArtifactMutation, { data, loading, error }] = useUnlinkArtifactMutation({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *      artifactPortfolioID: // value for 'artifactPortfolioID'
 *   },
 * });
 */
export function useUnlinkArtifactMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnlinkArtifactMutation, UnlinkArtifactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnlinkArtifactMutation, UnlinkArtifactMutationVariables>(UnlinkArtifactDocument, options);
      }
export type UnlinkArtifactMutationHookResult = ReturnType<typeof useUnlinkArtifactMutation>;
export type UnlinkArtifactMutationResult = ApolloReactCommon.MutationResult<UnlinkArtifactMutation>;
export type UnlinkArtifactMutationOptions = ApolloReactCommon.BaseMutationOptions<UnlinkArtifactMutation, UnlinkArtifactMutationVariables>;
export const AddAliasesDocument = gql`
    mutation AddAliases($artifactID: ID!, $aliases: [ArtifactCollectionAliasInput!]!, $clientMutationId: String) {
  addAliases(
    input: {artifactID: $artifactID, aliases: $aliases, clientMutationId: $clientMutationId}
  ) {
    success
  }
}
    `;
export type AddAliasesMutationFn = ApolloReactCommon.MutationFunction<AddAliasesMutation, AddAliasesMutationVariables>;

/**
 * __useAddAliasesMutation__
 *
 * To run a mutation, you first call `useAddAliasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAliasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAliasesMutation, { data, loading, error }] = useAddAliasesMutation({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *      aliases: // value for 'aliases'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useAddAliasesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddAliasesMutation, AddAliasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddAliasesMutation, AddAliasesMutationVariables>(AddAliasesDocument, options);
      }
export type AddAliasesMutationHookResult = ReturnType<typeof useAddAliasesMutation>;
export type AddAliasesMutationResult = ApolloReactCommon.MutationResult<AddAliasesMutation>;
export type AddAliasesMutationOptions = ApolloReactCommon.BaseMutationOptions<AddAliasesMutation, AddAliasesMutationVariables>;
export const DeleteAliasesDocument = gql`
    mutation DeleteAliases($artifactID: ID!, $aliases: [ArtifactCollectionAliasInput!]!, $clientMutationId: String) {
  deleteAliases(
    input: {artifactID: $artifactID, aliases: $aliases, clientMutationId: $clientMutationId}
  ) {
    success
  }
}
    `;
export type DeleteAliasesMutationFn = ApolloReactCommon.MutationFunction<DeleteAliasesMutation, DeleteAliasesMutationVariables>;

/**
 * __useDeleteAliasesMutation__
 *
 * To run a mutation, you first call `useDeleteAliasesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAliasesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAliasesMutation, { data, loading, error }] = useDeleteAliasesMutation({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *      aliases: // value for 'aliases'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useDeleteAliasesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAliasesMutation, DeleteAliasesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAliasesMutation, DeleteAliasesMutationVariables>(DeleteAliasesDocument, options);
      }
export type DeleteAliasesMutationHookResult = ReturnType<typeof useDeleteAliasesMutation>;
export type DeleteAliasesMutationResult = ApolloReactCommon.MutationResult<DeleteAliasesMutation>;
export type DeleteAliasesMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteAliasesMutation, DeleteAliasesMutationVariables>;
export const UpdateArtifactEntityTtlDocument = gql`
    mutation UpdateArtifactEntityTTL($entityName: String!, $ttlDurationSeconds: Int64!) {
  updateArtifactEntityTTL(
    input: {entityName: $entityName, ttlDurationSeconds: $ttlDurationSeconds}
  ) {
    clientMutationId
  }
}
    `;
export type UpdateArtifactEntityTtlMutationFn = ApolloReactCommon.MutationFunction<UpdateArtifactEntityTtlMutation, UpdateArtifactEntityTtlMutationVariables>;

/**
 * __useUpdateArtifactEntityTtlMutation__
 *
 * To run a mutation, you first call `useUpdateArtifactEntityTtlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArtifactEntityTtlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArtifactEntityTtlMutation, { data, loading, error }] = useUpdateArtifactEntityTtlMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      ttlDurationSeconds: // value for 'ttlDurationSeconds'
 *   },
 * });
 */
export function useUpdateArtifactEntityTtlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateArtifactEntityTtlMutation, UpdateArtifactEntityTtlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateArtifactEntityTtlMutation, UpdateArtifactEntityTtlMutationVariables>(UpdateArtifactEntityTtlDocument, options);
      }
export type UpdateArtifactEntityTtlMutationHookResult = ReturnType<typeof useUpdateArtifactEntityTtlMutation>;
export type UpdateArtifactEntityTtlMutationResult = ApolloReactCommon.MutationResult<UpdateArtifactEntityTtlMutation>;
export type UpdateArtifactEntityTtlMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateArtifactEntityTtlMutation, UpdateArtifactEntityTtlMutationVariables>;
export const DeleteArtifactEntityTtlDocument = gql`
    mutation DeleteArtifactEntityTTL($entityName: String!) {
  deleteArtifactEntityTTL(input: {entityName: $entityName}) {
    clientMutationId
  }
}
    `;
export type DeleteArtifactEntityTtlMutationFn = ApolloReactCommon.MutationFunction<DeleteArtifactEntityTtlMutation, DeleteArtifactEntityTtlMutationVariables>;

/**
 * __useDeleteArtifactEntityTtlMutation__
 *
 * To run a mutation, you first call `useDeleteArtifactEntityTtlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArtifactEntityTtlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArtifactEntityTtlMutation, { data, loading, error }] = useDeleteArtifactEntityTtlMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useDeleteArtifactEntityTtlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteArtifactEntityTtlMutation, DeleteArtifactEntityTtlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteArtifactEntityTtlMutation, DeleteArtifactEntityTtlMutationVariables>(DeleteArtifactEntityTtlDocument, options);
      }
export type DeleteArtifactEntityTtlMutationHookResult = ReturnType<typeof useDeleteArtifactEntityTtlMutation>;
export type DeleteArtifactEntityTtlMutationResult = ApolloReactCommon.MutationResult<DeleteArtifactEntityTtlMutation>;
export type DeleteArtifactEntityTtlMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteArtifactEntityTtlMutation, DeleteArtifactEntityTtlMutationVariables>;
export const ArtifactRedirectDocument = gql`
    query ArtifactRedirect($projectName: String, $entityName: String, $artifactTypeName: String!, $artifactCollectionName: String!, $membershipIdentifier: String!, $includeMembership: Boolean!) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactTypes {
      edges {
        node {
          id
          name
          artifactCollections(first: 1) {
            edges {
              node {
                id
                name
                artifactMemberships(first: 1) {
                  edges {
                    node {
                      id
                      versionIndex
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    artifactType(name: $artifactTypeName) {
      id
      name
      artifactCollections(first: 1) {
        edges {
          node {
            id
            name
            artifactMemberships(first: 1) {
              edges {
                node {
                  id
                  versionIndex
                }
              }
            }
          }
        }
      }
      artifactCollection(name: $artifactCollectionName) {
        id
        name
        artifactMemberships(first: 1) {
          edges {
            node {
              id
              versionIndex
            }
          }
        }
        artifactMembership(aliasName: $membershipIdentifier) @include(if: $includeMembership) {
          id
          versionIndex
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactRedirectQuery__
 *
 * To run a query within a React component, call `useArtifactRedirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactRedirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactRedirectQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *      artifactCollectionName: // value for 'artifactCollectionName'
 *      membershipIdentifier: // value for 'membershipIdentifier'
 *      includeMembership: // value for 'includeMembership'
 *   },
 * });
 */
export function useArtifactRedirectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactRedirectQuery, ArtifactRedirectQueryVariables> & ({ variables: ArtifactRedirectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactRedirectQuery, ArtifactRedirectQueryVariables>(ArtifactRedirectDocument, options);
      }
export function useArtifactRedirectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactRedirectQuery, ArtifactRedirectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactRedirectQuery, ArtifactRedirectQueryVariables>(ArtifactRedirectDocument, options);
        }
// @ts-ignore
export function useArtifactRedirectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactRedirectQuery, ArtifactRedirectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactRedirectQuery, ArtifactRedirectQueryVariables>;
export function useArtifactRedirectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactRedirectQuery, ArtifactRedirectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactRedirectQuery | undefined, ArtifactRedirectQueryVariables>;
export function useArtifactRedirectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactRedirectQuery, ArtifactRedirectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactRedirectQuery, ArtifactRedirectQueryVariables>(ArtifactRedirectDocument, options);
        }
export type ArtifactRedirectQueryHookResult = ReturnType<typeof useArtifactRedirectQuery>;
export type ArtifactRedirectLazyQueryHookResult = ReturnType<typeof useArtifactRedirectLazyQuery>;
export type ArtifactRedirectSuspenseQueryHookResult = ReturnType<typeof useArtifactRedirectSuspenseQuery>;
export type ArtifactRedirectQueryResult = ApolloReactCommon.QueryResult<ArtifactRedirectQuery, ArtifactRedirectQueryVariables>;
export const ArtifactTypeDocument = gql`
    query ArtifactType($projectName: String!, $entityName: String!, $artifactTypeName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactType(name: $artifactTypeName) {
      id
      name
      description
      artifactSequences(order: "-createdAt") {
        edges {
          node {
            id
            name
            description
            createdAt
            artifacts {
              totalCount
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactTypeQuery__
 *
 * To run a query within a React component, call `useArtifactTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactTypeQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      artifactTypeName: // value for 'artifactTypeName'
 *   },
 * });
 */
export function useArtifactTypeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactTypeQuery, ArtifactTypeQueryVariables> & ({ variables: ArtifactTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactTypeQuery, ArtifactTypeQueryVariables>(ArtifactTypeDocument, options);
      }
export function useArtifactTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactTypeQuery, ArtifactTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactTypeQuery, ArtifactTypeQueryVariables>(ArtifactTypeDocument, options);
        }
// @ts-ignore
export function useArtifactTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactTypeQuery, ArtifactTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactTypeQuery, ArtifactTypeQueryVariables>;
export function useArtifactTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactTypeQuery, ArtifactTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactTypeQuery | undefined, ArtifactTypeQueryVariables>;
export function useArtifactTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactTypeQuery, ArtifactTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactTypeQuery, ArtifactTypeQueryVariables>(ArtifactTypeDocument, options);
        }
export type ArtifactTypeQueryHookResult = ReturnType<typeof useArtifactTypeQuery>;
export type ArtifactTypeLazyQueryHookResult = ReturnType<typeof useArtifactTypeLazyQuery>;
export type ArtifactTypeSuspenseQueryHookResult = ReturnType<typeof useArtifactTypeSuspenseQuery>;
export type ArtifactTypeQueryResult = ApolloReactCommon.QueryResult<ArtifactTypeQuery, ArtifactTypeQueryVariables>;
export const ArtifactTypesDocument = gql`
    query ArtifactTypes($entityName: String, $projectName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactTypes {
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactTypesQuery__
 *
 * To run a query within a React component, call `useArtifactTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactTypesQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useArtifactTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ArtifactTypesQuery, ArtifactTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactTypesQuery, ArtifactTypesQueryVariables>(ArtifactTypesDocument, options);
      }
export function useArtifactTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactTypesQuery, ArtifactTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactTypesQuery, ArtifactTypesQueryVariables>(ArtifactTypesDocument, options);
        }
// @ts-ignore
export function useArtifactTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactTypesQuery, ArtifactTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactTypesQuery, ArtifactTypesQueryVariables>;
export function useArtifactTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactTypesQuery, ArtifactTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactTypesQuery | undefined, ArtifactTypesQueryVariables>;
export function useArtifactTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactTypesQuery, ArtifactTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactTypesQuery, ArtifactTypesQueryVariables>(ArtifactTypesDocument, options);
        }
export type ArtifactTypesQueryHookResult = ReturnType<typeof useArtifactTypesQuery>;
export type ArtifactTypesLazyQueryHookResult = ReturnType<typeof useArtifactTypesLazyQuery>;
export type ArtifactTypesSuspenseQueryHookResult = ReturnType<typeof useArtifactTypesSuspenseQuery>;
export type ArtifactTypesQueryResult = ApolloReactCommon.QueryResult<ArtifactTypesQuery, ArtifactTypesQueryVariables>;
export const ViewerDefaultResourceConfigsDocument = gql`
    query ViewerDefaultResourceConfigs {
  viewer {
    id
    teams {
      edges {
        node {
          id
          defaultResourceConfigs {
            edges {
              node {
                id
                createdAt
                updatedAt
                scope {
                  __typename
                  Type
                  ID
                }
                resource
                config
                templateVariables {
                  name
                  description
                  schema
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useViewerDefaultResourceConfigsQuery__
 *
 * To run a query within a React component, call `useViewerDefaultResourceConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerDefaultResourceConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerDefaultResourceConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerDefaultResourceConfigsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>(ViewerDefaultResourceConfigsDocument, options);
      }
export function useViewerDefaultResourceConfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>(ViewerDefaultResourceConfigsDocument, options);
        }
// @ts-ignore
export function useViewerDefaultResourceConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>;
export function useViewerDefaultResourceConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerDefaultResourceConfigsQuery | undefined, ViewerDefaultResourceConfigsQueryVariables>;
export function useViewerDefaultResourceConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>(ViewerDefaultResourceConfigsDocument, options);
        }
export type ViewerDefaultResourceConfigsQueryHookResult = ReturnType<typeof useViewerDefaultResourceConfigsQuery>;
export type ViewerDefaultResourceConfigsLazyQueryHookResult = ReturnType<typeof useViewerDefaultResourceConfigsLazyQuery>;
export type ViewerDefaultResourceConfigsSuspenseQueryHookResult = ReturnType<typeof useViewerDefaultResourceConfigsSuspenseQuery>;
export type ViewerDefaultResourceConfigsQueryResult = ApolloReactCommon.QueryResult<ViewerDefaultResourceConfigsQuery, ViewerDefaultResourceConfigsQueryVariables>;
export const EntityDefaultResourceConfigsDocument = gql`
    query EntityDefaultResourceConfigs($entityName: String!) {
  entity(name: $entityName) {
    id
    defaultResourceConfigs {
      edges {
        node {
          id
          createdAt
          updatedAt
          scope {
            __typename
            Type
            ID
          }
          resource
          config
          templateVariables {
            name
            description
            schema
          }
        }
      }
    }
  }
}
    `;

/**
 * __useEntityDefaultResourceConfigsQuery__
 *
 * To run a query within a React component, call `useEntityDefaultResourceConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityDefaultResourceConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityDefaultResourceConfigsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityDefaultResourceConfigsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables> & ({ variables: EntityDefaultResourceConfigsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables>(EntityDefaultResourceConfigsDocument, options);
      }
export function useEntityDefaultResourceConfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables>(EntityDefaultResourceConfigsDocument, options);
        }
// @ts-ignore
export function useEntityDefaultResourceConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables>;
export function useEntityDefaultResourceConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityDefaultResourceConfigsQuery | undefined, EntityDefaultResourceConfigsQueryVariables>;
export function useEntityDefaultResourceConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables>(EntityDefaultResourceConfigsDocument, options);
        }
export type EntityDefaultResourceConfigsQueryHookResult = ReturnType<typeof useEntityDefaultResourceConfigsQuery>;
export type EntityDefaultResourceConfigsLazyQueryHookResult = ReturnType<typeof useEntityDefaultResourceConfigsLazyQuery>;
export type EntityDefaultResourceConfigsSuspenseQueryHookResult = ReturnType<typeof useEntityDefaultResourceConfigsSuspenseQuery>;
export type EntityDefaultResourceConfigsQueryResult = ApolloReactCommon.QueryResult<EntityDefaultResourceConfigsQuery, EntityDefaultResourceConfigsQueryVariables>;
export const ProjectDefaultResourceConfigsDocument = gql`
    query ProjectDefaultResourceConfigs($projectName: String!) {
  project(name: $projectName) {
    id
    defaultResourceConfigs {
      edges {
        node {
          id
          createdAt
          updatedAt
          scope {
            Type
            ID
          }
          resource
          config
          templateVariables {
            name
            description
            schema
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProjectDefaultResourceConfigsQuery__
 *
 * To run a query within a React component, call `useProjectDefaultResourceConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDefaultResourceConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectDefaultResourceConfigsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useProjectDefaultResourceConfigsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables> & ({ variables: ProjectDefaultResourceConfigsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables>(ProjectDefaultResourceConfigsDocument, options);
      }
export function useProjectDefaultResourceConfigsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables>(ProjectDefaultResourceConfigsDocument, options);
        }
// @ts-ignore
export function useProjectDefaultResourceConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables>;
export function useProjectDefaultResourceConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectDefaultResourceConfigsQuery | undefined, ProjectDefaultResourceConfigsQueryVariables>;
export function useProjectDefaultResourceConfigsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables>(ProjectDefaultResourceConfigsDocument, options);
        }
export type ProjectDefaultResourceConfigsQueryHookResult = ReturnType<typeof useProjectDefaultResourceConfigsQuery>;
export type ProjectDefaultResourceConfigsLazyQueryHookResult = ReturnType<typeof useProjectDefaultResourceConfigsLazyQuery>;
export type ProjectDefaultResourceConfigsSuspenseQueryHookResult = ReturnType<typeof useProjectDefaultResourceConfigsSuspenseQuery>;
export type ProjectDefaultResourceConfigsQueryResult = ApolloReactCommon.QueryResult<ProjectDefaultResourceConfigsQuery, ProjectDefaultResourceConfigsQueryVariables>;
export const CreateDefaultResourceConfigDocument = gql`
    mutation CreateDefaultResourceConfig($entityName: String!, $projectName: String, $resource: String!, $config: JSONString!, $templateVariables: JSONString!) {
  createDefaultResourceConfig(
    input: {entityName: $entityName, projectName: $projectName, resource: $resource, config: $config, templateVariables: $templateVariables}
  ) {
    defaultResourceConfigID
    schemaValidationErrors
    success
  }
}
    `;
export type CreateDefaultResourceConfigMutationFn = ApolloReactCommon.MutationFunction<CreateDefaultResourceConfigMutation, CreateDefaultResourceConfigMutationVariables>;

/**
 * __useCreateDefaultResourceConfigMutation__
 *
 * To run a mutation, you first call `useCreateDefaultResourceConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDefaultResourceConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDefaultResourceConfigMutation, { data, loading, error }] = useCreateDefaultResourceConfigMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      resource: // value for 'resource'
 *      config: // value for 'config'
 *      templateVariables: // value for 'templateVariables'
 *   },
 * });
 */
export function useCreateDefaultResourceConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDefaultResourceConfigMutation, CreateDefaultResourceConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDefaultResourceConfigMutation, CreateDefaultResourceConfigMutationVariables>(CreateDefaultResourceConfigDocument, options);
      }
export type CreateDefaultResourceConfigMutationHookResult = ReturnType<typeof useCreateDefaultResourceConfigMutation>;
export type CreateDefaultResourceConfigMutationResult = ApolloReactCommon.MutationResult<CreateDefaultResourceConfigMutation>;
export type CreateDefaultResourceConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDefaultResourceConfigMutation, CreateDefaultResourceConfigMutationVariables>;
export const DeleteDefaultResourceConfigDocument = gql`
    mutation DeleteDefaultResourceConfig($defaultResourceConfigIDs: [ID!]!) {
  deleteDefaultResourceConfigs(
    input: {defaultResourceConfigIDs: $defaultResourceConfigIDs}
  ) {
    numAffected
    success
  }
}
    `;
export type DeleteDefaultResourceConfigMutationFn = ApolloReactCommon.MutationFunction<DeleteDefaultResourceConfigMutation, DeleteDefaultResourceConfigMutationVariables>;

/**
 * __useDeleteDefaultResourceConfigMutation__
 *
 * To run a mutation, you first call `useDeleteDefaultResourceConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDefaultResourceConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDefaultResourceConfigMutation, { data, loading, error }] = useDeleteDefaultResourceConfigMutation({
 *   variables: {
 *      defaultResourceConfigIDs: // value for 'defaultResourceConfigIDs'
 *   },
 * });
 */
export function useDeleteDefaultResourceConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDefaultResourceConfigMutation, DeleteDefaultResourceConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDefaultResourceConfigMutation, DeleteDefaultResourceConfigMutationVariables>(DeleteDefaultResourceConfigDocument, options);
      }
export type DeleteDefaultResourceConfigMutationHookResult = ReturnType<typeof useDeleteDefaultResourceConfigMutation>;
export type DeleteDefaultResourceConfigMutationResult = ApolloReactCommon.MutationResult<DeleteDefaultResourceConfigMutation>;
export type DeleteDefaultResourceConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteDefaultResourceConfigMutation, DeleteDefaultResourceConfigMutationVariables>;
export const UpdateDefaultResourceConfigDocument = gql`
    mutation UpdateDefaultResourceConfig($defaultResourceConfigID: ID!, $resource: String, $config: JSONString!, $entityName: String, $projectName: String, $templateVariables: JSONString!) {
  updateDefaultResourceConfig(
    input: {defaultResourceConfigID: $defaultResourceConfigID, resource: $resource, config: $config, entityName: $entityName, projectName: $projectName, templateVariables: $templateVariables}
  ) {
    schemaValidationErrors
    success
  }
}
    `;
export type UpdateDefaultResourceConfigMutationFn = ApolloReactCommon.MutationFunction<UpdateDefaultResourceConfigMutation, UpdateDefaultResourceConfigMutationVariables>;

/**
 * __useUpdateDefaultResourceConfigMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultResourceConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultResourceConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultResourceConfigMutation, { data, loading, error }] = useUpdateDefaultResourceConfigMutation({
 *   variables: {
 *      defaultResourceConfigID: // value for 'defaultResourceConfigID'
 *      resource: // value for 'resource'
 *      config: // value for 'config'
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      templateVariables: // value for 'templateVariables'
 *   },
 * });
 */
export function useUpdateDefaultResourceConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDefaultResourceConfigMutation, UpdateDefaultResourceConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDefaultResourceConfigMutation, UpdateDefaultResourceConfigMutationVariables>(UpdateDefaultResourceConfigDocument, options);
      }
export type UpdateDefaultResourceConfigMutationHookResult = ReturnType<typeof useUpdateDefaultResourceConfigMutation>;
export type UpdateDefaultResourceConfigMutationResult = ApolloReactCommon.MutationResult<UpdateDefaultResourceConfigMutation>;
export type UpdateDefaultResourceConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDefaultResourceConfigMutation, UpdateDefaultResourceConfigMutationVariables>;
export const DefaultResourceConfigDocument = gql`
    query DefaultResourceConfig($entityName: String!, $defaultResourceConfigID: ID!) {
  entity(name: $entityName) {
    id
    defaultResourceConfig(id: $defaultResourceConfigID) {
      id
      config
      resource
      templateVariables {
        name
        description
        schema
      }
    }
  }
}
    `;

/**
 * __useDefaultResourceConfigQuery__
 *
 * To run a query within a React component, call `useDefaultResourceConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultResourceConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultResourceConfigQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      defaultResourceConfigID: // value for 'defaultResourceConfigID'
 *   },
 * });
 */
export function useDefaultResourceConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables> & ({ variables: DefaultResourceConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables>(DefaultResourceConfigDocument, options);
      }
export function useDefaultResourceConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables>(DefaultResourceConfigDocument, options);
        }
// @ts-ignore
export function useDefaultResourceConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables>;
export function useDefaultResourceConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DefaultResourceConfigQuery | undefined, DefaultResourceConfigQueryVariables>;
export function useDefaultResourceConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables>(DefaultResourceConfigDocument, options);
        }
export type DefaultResourceConfigQueryHookResult = ReturnType<typeof useDefaultResourceConfigQuery>;
export type DefaultResourceConfigLazyQueryHookResult = ReturnType<typeof useDefaultResourceConfigLazyQuery>;
export type DefaultResourceConfigSuspenseQueryHookResult = ReturnType<typeof useDefaultResourceConfigSuspenseQuery>;
export type DefaultResourceConfigQueryResult = ApolloReactCommon.QueryResult<DefaultResourceConfigQuery, DefaultResourceConfigQueryVariables>;
export const EntityArtifactsDocument = gql`
    query EntityArtifacts($entityName: String!) {
  entity(name: $entityName) {
    id
    projects {
      edges {
        node {
          id
          name
          artifactTypes {
            edges {
              node {
                id
                name
                artifactSequences(order: "-createdAt") {
                  edges {
                    node {
                      id
                      name
                      createdAt
                      artifacts(first: 100) {
                        edges {
                          node {
                            id
                            versionIndex
                            aliases {
                              id
                              alias
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useEntityArtifactsQuery__
 *
 * To run a query within a React component, call `useEntityArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityArtifactsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityArtifactsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityArtifactsQuery, EntityArtifactsQueryVariables> & ({ variables: EntityArtifactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityArtifactsQuery, EntityArtifactsQueryVariables>(EntityArtifactsDocument, options);
      }
export function useEntityArtifactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityArtifactsQuery, EntityArtifactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityArtifactsQuery, EntityArtifactsQueryVariables>(EntityArtifactsDocument, options);
        }
// @ts-ignore
export function useEntityArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityArtifactsQuery, EntityArtifactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityArtifactsQuery, EntityArtifactsQueryVariables>;
export function useEntityArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityArtifactsQuery, EntityArtifactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityArtifactsQuery | undefined, EntityArtifactsQueryVariables>;
export function useEntityArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityArtifactsQuery, EntityArtifactsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityArtifactsQuery, EntityArtifactsQueryVariables>(EntityArtifactsDocument, options);
        }
export type EntityArtifactsQueryHookResult = ReturnType<typeof useEntityArtifactsQuery>;
export type EntityArtifactsLazyQueryHookResult = ReturnType<typeof useEntityArtifactsLazyQuery>;
export type EntityArtifactsSuspenseQueryHookResult = ReturnType<typeof useEntityArtifactsSuspenseQuery>;
export type EntityArtifactsQueryResult = ApolloReactCommon.QueryResult<EntityArtifactsQuery, EntityArtifactsQueryVariables>;
export const PaidEntityDocument = gql`
    query PaidEntity($entityName: String!) {
  entity(name: $entityName) {
    id
    name
    isPaid
  }
}
    `;

/**
 * __usePaidEntityQuery__
 *
 * To run a query within a React component, call `usePaidEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaidEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaidEntityQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function usePaidEntityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaidEntityQuery, PaidEntityQueryVariables> & ({ variables: PaidEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaidEntityQuery, PaidEntityQueryVariables>(PaidEntityDocument, options);
      }
export function usePaidEntityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaidEntityQuery, PaidEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaidEntityQuery, PaidEntityQueryVariables>(PaidEntityDocument, options);
        }
// @ts-ignore
export function usePaidEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PaidEntityQuery, PaidEntityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PaidEntityQuery, PaidEntityQueryVariables>;
export function usePaidEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PaidEntityQuery, PaidEntityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PaidEntityQuery | undefined, PaidEntityQueryVariables>;
export function usePaidEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PaidEntityQuery, PaidEntityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PaidEntityQuery, PaidEntityQueryVariables>(PaidEntityDocument, options);
        }
export type PaidEntityQueryHookResult = ReturnType<typeof usePaidEntityQuery>;
export type PaidEntityLazyQueryHookResult = ReturnType<typeof usePaidEntityLazyQuery>;
export type PaidEntitySuspenseQueryHookResult = ReturnType<typeof usePaidEntitySuspenseQuery>;
export type PaidEntityQueryResult = ApolloReactCommon.QueryResult<PaidEntityQuery, PaidEntityQueryVariables>;
export const EntityProfileDocument = gql`
    query EntityProfile($entityName: String!) {
  entity(name: $entityName) {
    id
    profileView {
      id
      spec
      updatedAt
      updatedBy {
        id
        username
      }
    }
  }
}
    `;

/**
 * __useEntityProfileQuery__
 *
 * To run a query within a React component, call `useEntityProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityProfileQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityProfileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityProfileQuery, EntityProfileQueryVariables> & ({ variables: EntityProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityProfileQuery, EntityProfileQueryVariables>(EntityProfileDocument, options);
      }
export function useEntityProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityProfileQuery, EntityProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityProfileQuery, EntityProfileQueryVariables>(EntityProfileDocument, options);
        }
// @ts-ignore
export function useEntityProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityProfileQuery, EntityProfileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityProfileQuery, EntityProfileQueryVariables>;
export function useEntityProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityProfileQuery, EntityProfileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityProfileQuery | undefined, EntityProfileQueryVariables>;
export function useEntityProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityProfileQuery, EntityProfileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityProfileQuery, EntityProfileQueryVariables>(EntityProfileDocument, options);
        }
export type EntityProfileQueryHookResult = ReturnType<typeof useEntityProfileQuery>;
export type EntityProfileLazyQueryHookResult = ReturnType<typeof useEntityProfileLazyQuery>;
export type EntityProfileSuspenseQueryHookResult = ReturnType<typeof useEntityProfileSuspenseQuery>;
export type EntityProfileQueryResult = ApolloReactCommon.QueryResult<EntityProfileQuery, EntityProfileQueryVariables>;
export const EntityProjectsReportsDocument = gql`
    query EntityProjectsReports($entityName: String!, $pattern: String, $first: Int = 100) {
  entity(name: $entityName) {
    id
    projects(order: "-created_at", first: $first, pattern: $pattern) {
      edges {
        node {
          id
          name
          entityName
          reports: allViews(viewType: "runs") {
            edges {
              node {
                id
                ...ViewFragmentMetadata
              }
            }
          }
        }
      }
    }
  }
}
    ${ViewFragmentMetadataFragmentDoc}`;

/**
 * __useEntityProjectsReportsQuery__
 *
 * To run a query within a React component, call `useEntityProjectsReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityProjectsReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityProjectsReportsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      pattern: // value for 'pattern'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useEntityProjectsReportsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables> & ({ variables: EntityProjectsReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables>(EntityProjectsReportsDocument, options);
      }
export function useEntityProjectsReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables>(EntityProjectsReportsDocument, options);
        }
// @ts-ignore
export function useEntityProjectsReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables>;
export function useEntityProjectsReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityProjectsReportsQuery | undefined, EntityProjectsReportsQueryVariables>;
export function useEntityProjectsReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables>(EntityProjectsReportsDocument, options);
        }
export type EntityProjectsReportsQueryHookResult = ReturnType<typeof useEntityProjectsReportsQuery>;
export type EntityProjectsReportsLazyQueryHookResult = ReturnType<typeof useEntityProjectsReportsLazyQuery>;
export type EntityProjectsReportsSuspenseQueryHookResult = ReturnType<typeof useEntityProjectsReportsSuspenseQuery>;
export type EntityProjectsReportsQueryResult = ApolloReactCommon.QueryResult<EntityProjectsReportsQuery, EntityProjectsReportsQueryVariables>;
export const ProjectReportsDocument = gql`
    query ProjectReports($entityName: String, $projectName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    name
    entityName
    reports: allViews(viewType: "runs") {
      edges {
        node {
          id
          ...ViewFragmentMetadata
        }
      }
    }
  }
}
    ${ViewFragmentMetadataFragmentDoc}`;

/**
 * __useProjectReportsQuery__
 *
 * To run a query within a React component, call `useProjectReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectReportsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useProjectReportsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectReportsQuery, ProjectReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectReportsQuery, ProjectReportsQueryVariables>(ProjectReportsDocument, options);
      }
export function useProjectReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectReportsQuery, ProjectReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectReportsQuery, ProjectReportsQueryVariables>(ProjectReportsDocument, options);
        }
// @ts-ignore
export function useProjectReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectReportsQuery, ProjectReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectReportsQuery, ProjectReportsQueryVariables>;
export function useProjectReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectReportsQuery, ProjectReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectReportsQuery | undefined, ProjectReportsQueryVariables>;
export function useProjectReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectReportsQuery, ProjectReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectReportsQuery, ProjectReportsQueryVariables>(ProjectReportsDocument, options);
        }
export type ProjectReportsQueryHookResult = ReturnType<typeof useProjectReportsQuery>;
export type ProjectReportsLazyQueryHookResult = ReturnType<typeof useProjectReportsLazyQuery>;
export type ProjectReportsSuspenseQueryHookResult = ReturnType<typeof useProjectReportsSuspenseQuery>;
export type ProjectReportsQueryResult = ApolloReactCommon.QueryResult<ProjectReportsQuery, ProjectReportsQueryVariables>;
export const EntityTagsDocument = gql`
    query EntityTags($entityName: String!, $filters: JSONString) {
  entity(name: $entityName) {
    id
    tagCategories {
      id
      name
      tags(filters: $filters, first: 1000) {
        edges {
          node {
            id
            name
            tagCategoryName
            attributes
          }
        }
      }
    }
  }
}
    `;

/**
 * __useEntityTagsQuery__
 *
 * To run a query within a React component, call `useEntityTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityTagsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useEntityTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityTagsQuery, EntityTagsQueryVariables> & ({ variables: EntityTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityTagsQuery, EntityTagsQueryVariables>(EntityTagsDocument, options);
      }
export function useEntityTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityTagsQuery, EntityTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityTagsQuery, EntityTagsQueryVariables>(EntityTagsDocument, options);
        }
// @ts-ignore
export function useEntityTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityTagsQuery, EntityTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityTagsQuery, EntityTagsQueryVariables>;
export function useEntityTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityTagsQuery, EntityTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityTagsQuery | undefined, EntityTagsQueryVariables>;
export function useEntityTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityTagsQuery, EntityTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityTagsQuery, EntityTagsQueryVariables>(EntityTagsDocument, options);
        }
export type EntityTagsQueryHookResult = ReturnType<typeof useEntityTagsQuery>;
export type EntityTagsLazyQueryHookResult = ReturnType<typeof useEntityTagsLazyQuery>;
export type EntityTagsSuspenseQueryHookResult = ReturnType<typeof useEntityTagsSuspenseQuery>;
export type EntityTagsQueryResult = ApolloReactCommon.QueryResult<EntityTagsQuery, EntityTagsQueryVariables>;
export const GalleryDocument = gql`
    query Gallery {
  singletonView(type: "fullyConnected") {
    id
    spec
  }
}
    `;

/**
 * __useGalleryQuery__
 *
 * To run a query within a React component, call `useGalleryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGalleryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGalleryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGalleryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GalleryQuery, GalleryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GalleryQuery, GalleryQueryVariables>(GalleryDocument, options);
      }
export function useGalleryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GalleryQuery, GalleryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GalleryQuery, GalleryQueryVariables>(GalleryDocument, options);
        }
// @ts-ignore
export function useGallerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GalleryQuery, GalleryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GalleryQuery, GalleryQueryVariables>;
export function useGallerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GalleryQuery, GalleryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GalleryQuery | undefined, GalleryQueryVariables>;
export function useGallerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GalleryQuery, GalleryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GalleryQuery, GalleryQueryVariables>(GalleryDocument, options);
        }
export type GalleryQueryHookResult = ReturnType<typeof useGalleryQuery>;
export type GalleryLazyQueryHookResult = ReturnType<typeof useGalleryLazyQuery>;
export type GallerySuspenseQueryHookResult = ReturnType<typeof useGallerySuspenseQuery>;
export type GalleryQueryResult = ApolloReactCommon.QueryResult<GalleryQuery, GalleryQueryVariables>;
export const UpdateGalleryDocument = gql`
    mutation UpdateGallery($id: ID, $spec: String!) {
  upsertView(input: {id: $id, spec: $spec, name: "", type: "fullyConnected"}) {
    view {
      id
      updatedAt
      createdAt
      spec
    }
    inserted
  }
}
    `;
export type UpdateGalleryMutationFn = ApolloReactCommon.MutationFunction<UpdateGalleryMutation, UpdateGalleryMutationVariables>;

/**
 * __useUpdateGalleryMutation__
 *
 * To run a mutation, you first call `useUpdateGalleryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGalleryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGalleryMutation, { data, loading, error }] = useUpdateGalleryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      spec: // value for 'spec'
 *   },
 * });
 */
export function useUpdateGalleryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateGalleryMutation, UpdateGalleryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateGalleryMutation, UpdateGalleryMutationVariables>(UpdateGalleryDocument, options);
      }
export type UpdateGalleryMutationHookResult = ReturnType<typeof useUpdateGalleryMutation>;
export type UpdateGalleryMutationResult = ApolloReactCommon.MutationResult<UpdateGalleryMutation>;
export type UpdateGalleryMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateGalleryMutation, UpdateGalleryMutationVariables>;
export const FeaturedReportsMetadataDocument = gql`
    query FeaturedReportsMetadata($ids: [ID!]!, $recentStarCountFrom: DateTime) {
  views(ids: $ids) {
    edges {
      node {
        id
        createdAt
        updatedAt
        entityName
        project {
          id
          entityName
          name
          access
        }
        displayName
        description
        previewUrl
        viewCount
        starCount
        recentStarCount: starCount(from: $recentStarCountFrom)
        starred
      }
    }
  }
}
    `;

/**
 * __useFeaturedReportsMetadataQuery__
 *
 * To run a query within a React component, call `useFeaturedReportsMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturedReportsMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturedReportsMetadataQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      recentStarCountFrom: // value for 'recentStarCountFrom'
 *   },
 * });
 */
export function useFeaturedReportsMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables> & ({ variables: FeaturedReportsMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables>(FeaturedReportsMetadataDocument, options);
      }
export function useFeaturedReportsMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables>(FeaturedReportsMetadataDocument, options);
        }
// @ts-ignore
export function useFeaturedReportsMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables>;
export function useFeaturedReportsMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FeaturedReportsMetadataQuery | undefined, FeaturedReportsMetadataQueryVariables>;
export function useFeaturedReportsMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables>(FeaturedReportsMetadataDocument, options);
        }
export type FeaturedReportsMetadataQueryHookResult = ReturnType<typeof useFeaturedReportsMetadataQuery>;
export type FeaturedReportsMetadataLazyQueryHookResult = ReturnType<typeof useFeaturedReportsMetadataLazyQuery>;
export type FeaturedReportsMetadataSuspenseQueryHookResult = ReturnType<typeof useFeaturedReportsMetadataSuspenseQuery>;
export type FeaturedReportsMetadataQueryResult = ApolloReactCommon.QueryResult<FeaturedReportsMetadataQuery, FeaturedReportsMetadataQueryVariables>;
export const FeaturedReportsAuthorsDocument = gql`
    query FeaturedReportsAuthors($usernames: [String!]!) {
  users(usernames: $usernames) {
    edges {
      node {
        id
        name
        username
        photoUrl
        userInfo
      }
    }
  }
}
    `;

/**
 * __useFeaturedReportsAuthorsQuery__
 *
 * To run a query within a React component, call `useFeaturedReportsAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturedReportsAuthorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturedReportsAuthorsQuery({
 *   variables: {
 *      usernames: // value for 'usernames'
 *   },
 * });
 */
export function useFeaturedReportsAuthorsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables> & ({ variables: FeaturedReportsAuthorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables>(FeaturedReportsAuthorsDocument, options);
      }
export function useFeaturedReportsAuthorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables>(FeaturedReportsAuthorsDocument, options);
        }
// @ts-ignore
export function useFeaturedReportsAuthorsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables>;
export function useFeaturedReportsAuthorsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FeaturedReportsAuthorsQuery | undefined, FeaturedReportsAuthorsQueryVariables>;
export function useFeaturedReportsAuthorsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables>(FeaturedReportsAuthorsDocument, options);
        }
export type FeaturedReportsAuthorsQueryHookResult = ReturnType<typeof useFeaturedReportsAuthorsQuery>;
export type FeaturedReportsAuthorsLazyQueryHookResult = ReturnType<typeof useFeaturedReportsAuthorsLazyQuery>;
export type FeaturedReportsAuthorsSuspenseQueryHookResult = ReturnType<typeof useFeaturedReportsAuthorsSuspenseQuery>;
export type FeaturedReportsAuthorsQueryResult = ApolloReactCommon.QueryResult<FeaturedReportsAuthorsQuery, FeaturedReportsAuthorsQueryVariables>;
export const InsertGalleryDiscussionDocument = gql`
    mutation InsertGalleryDiscussion($spec: String!, $reportID: ID!, $sendEmail: Boolean) {
  insertGalleryDiscussion(
    input: {spec: $spec, reportID: $reportID, sendEmail: $sendEmail}
  ) {
    success
  }
}
    `;
export type InsertGalleryDiscussionMutationFn = ApolloReactCommon.MutationFunction<InsertGalleryDiscussionMutation, InsertGalleryDiscussionMutationVariables>;

/**
 * __useInsertGalleryDiscussionMutation__
 *
 * To run a mutation, you first call `useInsertGalleryDiscussionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertGalleryDiscussionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertGalleryDiscussionMutation, { data, loading, error }] = useInsertGalleryDiscussionMutation({
 *   variables: {
 *      spec: // value for 'spec'
 *      reportID: // value for 'reportID'
 *      sendEmail: // value for 'sendEmail'
 *   },
 * });
 */
export function useInsertGalleryDiscussionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InsertGalleryDiscussionMutation, InsertGalleryDiscussionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InsertGalleryDiscussionMutation, InsertGalleryDiscussionMutationVariables>(InsertGalleryDiscussionDocument, options);
      }
export type InsertGalleryDiscussionMutationHookResult = ReturnType<typeof useInsertGalleryDiscussionMutation>;
export type InsertGalleryDiscussionMutationResult = ApolloReactCommon.MutationResult<InsertGalleryDiscussionMutation>;
export type InsertGalleryDiscussionMutationOptions = ApolloReactCommon.BaseMutationOptions<InsertGalleryDiscussionMutation, InsertGalleryDiscussionMutationVariables>;
export const SubmitFcNewsDocument = gql`
    mutation SubmitFCNews($name: String!, $email: String!, $url: String!, $details: String) {
  submitFCNews(input: {name: $name, email: $email, url: $url, details: $details}) {
    success
  }
}
    `;
export type SubmitFcNewsMutationFn = ApolloReactCommon.MutationFunction<SubmitFcNewsMutation, SubmitFcNewsMutationVariables>;

/**
 * __useSubmitFcNewsMutation__
 *
 * To run a mutation, you first call `useSubmitFcNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFcNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFcNewsMutation, { data, loading, error }] = useSubmitFcNewsMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      url: // value for 'url'
 *      details: // value for 'details'
 *   },
 * });
 */
export function useSubmitFcNewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitFcNewsMutation, SubmitFcNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubmitFcNewsMutation, SubmitFcNewsMutationVariables>(SubmitFcNewsDocument, options);
      }
export type SubmitFcNewsMutationHookResult = ReturnType<typeof useSubmitFcNewsMutation>;
export type SubmitFcNewsMutationResult = ApolloReactCommon.MutationResult<SubmitFcNewsMutation>;
export type SubmitFcNewsMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitFcNewsMutation, SubmitFcNewsMutationVariables>;
export const GalleryTagSectionsDocument = gql`
    query GalleryTagSections {
  galleryTagSections
}
    `;

/**
 * __useGalleryTagSectionsQuery__
 *
 * To run a query within a React component, call `useGalleryTagSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGalleryTagSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGalleryTagSectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGalleryTagSectionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>(GalleryTagSectionsDocument, options);
      }
export function useGalleryTagSectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>(GalleryTagSectionsDocument, options);
        }
// @ts-ignore
export function useGalleryTagSectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>;
export function useGalleryTagSectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GalleryTagSectionsQuery | undefined, GalleryTagSectionsQueryVariables>;
export function useGalleryTagSectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>(GalleryTagSectionsDocument, options);
        }
export type GalleryTagSectionsQueryHookResult = ReturnType<typeof useGalleryTagSectionsQuery>;
export type GalleryTagSectionsLazyQueryHookResult = ReturnType<typeof useGalleryTagSectionsLazyQuery>;
export type GalleryTagSectionsSuspenseQueryHookResult = ReturnType<typeof useGalleryTagSectionsSuspenseQuery>;
export type GalleryTagSectionsQueryResult = ApolloReactCommon.QueryResult<GalleryTagSectionsQuery, GalleryTagSectionsQueryVariables>;
export const ProjectAccessDocument = gql`
    query ProjectAccess($name: String, $entityName: String) {
  project(name: $name, entityName: $entityName) {
    id
    access
  }
}
    `;

/**
 * __useProjectAccessQuery__
 *
 * To run a query within a React component, call `useProjectAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectAccessQuery({
 *   variables: {
 *      name: // value for 'name'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useProjectAccessQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProjectAccessQuery, ProjectAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectAccessQuery, ProjectAccessQueryVariables>(ProjectAccessDocument, options);
      }
export function useProjectAccessLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectAccessQuery, ProjectAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectAccessQuery, ProjectAccessQueryVariables>(ProjectAccessDocument, options);
        }
// @ts-ignore
export function useProjectAccessSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectAccessQuery, ProjectAccessQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectAccessQuery, ProjectAccessQueryVariables>;
export function useProjectAccessSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectAccessQuery, ProjectAccessQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectAccessQuery | undefined, ProjectAccessQueryVariables>;
export function useProjectAccessSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectAccessQuery, ProjectAccessQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectAccessQuery, ProjectAccessQueryVariables>(ProjectAccessDocument, options);
        }
export type ProjectAccessQueryHookResult = ReturnType<typeof useProjectAccessQuery>;
export type ProjectAccessLazyQueryHookResult = ReturnType<typeof useProjectAccessLazyQuery>;
export type ProjectAccessSuspenseQueryHookResult = ReturnType<typeof useProjectAccessSuspenseQuery>;
export type ProjectAccessQueryResult = ApolloReactCommon.QueryResult<ProjectAccessQuery, ProjectAccessQueryVariables>;
export const NewsletterSubscriptionDocument = gql`
    query NewsletterSubscription($userName: String!) {
  user(userName: $userName) {
    id
    newsletterSubscription {
      id
    }
  }
}
    `;

/**
 * __useNewsletterSubscriptionQuery__
 *
 * To run a query within a React component, call `useNewsletterSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterSubscriptionQuery({
 *   variables: {
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useNewsletterSubscriptionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables> & ({ variables: NewsletterSubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>(NewsletterSubscriptionDocument, options);
      }
export function useNewsletterSubscriptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>(NewsletterSubscriptionDocument, options);
        }
// @ts-ignore
export function useNewsletterSubscriptionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>;
export function useNewsletterSubscriptionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NewsletterSubscriptionQuery | undefined, NewsletterSubscriptionQueryVariables>;
export function useNewsletterSubscriptionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>(NewsletterSubscriptionDocument, options);
        }
export type NewsletterSubscriptionQueryHookResult = ReturnType<typeof useNewsletterSubscriptionQuery>;
export type NewsletterSubscriptionLazyQueryHookResult = ReturnType<typeof useNewsletterSubscriptionLazyQuery>;
export type NewsletterSubscriptionSuspenseQueryHookResult = ReturnType<typeof useNewsletterSubscriptionSuspenseQuery>;
export type NewsletterSubscriptionQueryResult = ApolloReactCommon.QueryResult<NewsletterSubscriptionQuery, NewsletterSubscriptionQueryVariables>;
export const CreateNewsletterSubscriptionDocument = gql`
    mutation CreateNewsletterSubscription($email: String) {
  createNewsletterSubscription(input: {email: $email}) {
    newsletterSubscription {
      id
    }
  }
}
    `;
export type CreateNewsletterSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CreateNewsletterSubscriptionMutation, CreateNewsletterSubscriptionMutationVariables>;

/**
 * __useCreateNewsletterSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateNewsletterSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewsletterSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewsletterSubscriptionMutation, { data, loading, error }] = useCreateNewsletterSubscriptionMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateNewsletterSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateNewsletterSubscriptionMutation, CreateNewsletterSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateNewsletterSubscriptionMutation, CreateNewsletterSubscriptionMutationVariables>(CreateNewsletterSubscriptionDocument, options);
      }
export type CreateNewsletterSubscriptionMutationHookResult = ReturnType<typeof useCreateNewsletterSubscriptionMutation>;
export type CreateNewsletterSubscriptionMutationResult = ApolloReactCommon.MutationResult<CreateNewsletterSubscriptionMutation>;
export type CreateNewsletterSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateNewsletterSubscriptionMutation, CreateNewsletterSubscriptionMutationVariables>;
export const AllNewsletterSubscriptionsDocument = gql`
    query AllNewsletterSubscriptions($first: Int = 10000) {
  newsletterSubscriptions(first: $first) {
    edges {
      node {
        id
        user {
          id
          username
          email
        }
        email
        createdAt
      }
    }
  }
}
    `;

/**
 * __useAllNewsletterSubscriptionsQuery__
 *
 * To run a query within a React component, call `useAllNewsletterSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllNewsletterSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllNewsletterSubscriptionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAllNewsletterSubscriptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>(AllNewsletterSubscriptionsDocument, options);
      }
export function useAllNewsletterSubscriptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>(AllNewsletterSubscriptionsDocument, options);
        }
// @ts-ignore
export function useAllNewsletterSubscriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>;
export function useAllNewsletterSubscriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllNewsletterSubscriptionsQuery | undefined, AllNewsletterSubscriptionsQueryVariables>;
export function useAllNewsletterSubscriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>(AllNewsletterSubscriptionsDocument, options);
        }
export type AllNewsletterSubscriptionsQueryHookResult = ReturnType<typeof useAllNewsletterSubscriptionsQuery>;
export type AllNewsletterSubscriptionsLazyQueryHookResult = ReturnType<typeof useAllNewsletterSubscriptionsLazyQuery>;
export type AllNewsletterSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useAllNewsletterSubscriptionsSuspenseQuery>;
export type AllNewsletterSubscriptionsQueryResult = ApolloReactCommon.QueryResult<AllNewsletterSubscriptionsQuery, AllNewsletterSubscriptionsQueryVariables>;
export const ViewPreviewUrlDocument = gql`
    query ViewPreviewUrl($id: ID!) {
  view(id: $id) {
    id
    previewUrl
  }
}
    `;

/**
 * __useViewPreviewUrlQuery__
 *
 * To run a query within a React component, call `useViewPreviewUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewPreviewUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewPreviewUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewPreviewUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables> & ({ variables: ViewPreviewUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables>(ViewPreviewUrlDocument, options);
      }
export function useViewPreviewUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables>(ViewPreviewUrlDocument, options);
        }
// @ts-ignore
export function useViewPreviewUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables>;
export function useViewPreviewUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewPreviewUrlQuery | undefined, ViewPreviewUrlQueryVariables>;
export function useViewPreviewUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables>(ViewPreviewUrlDocument, options);
        }
export type ViewPreviewUrlQueryHookResult = ReturnType<typeof useViewPreviewUrlQuery>;
export type ViewPreviewUrlLazyQueryHookResult = ReturnType<typeof useViewPreviewUrlLazyQuery>;
export type ViewPreviewUrlSuspenseQueryHookResult = ReturnType<typeof useViewPreviewUrlSuspenseQuery>;
export type ViewPreviewUrlQueryResult = ApolloReactCommon.QueryResult<ViewPreviewUrlQuery, ViewPreviewUrlQueryVariables>;
export const GroupPageDocument = gql`
    query GroupPage($projectName: String!, $entityName: String, $groupName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runGroup(name: $groupName) {
      id
      name
      notes
      tags {
        id
        name
        colorIndex
      }
    }
  }
}
    `;

/**
 * __useGroupPageQuery__
 *
 * To run a query within a React component, call `useGroupPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupPageQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      groupName: // value for 'groupName'
 *   },
 * });
 */
export function useGroupPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GroupPageQuery, GroupPageQueryVariables> & ({ variables: GroupPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GroupPageQuery, GroupPageQueryVariables>(GroupPageDocument, options);
      }
export function useGroupPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GroupPageQuery, GroupPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GroupPageQuery, GroupPageQueryVariables>(GroupPageDocument, options);
        }
// @ts-ignore
export function useGroupPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GroupPageQuery, GroupPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupPageQuery, GroupPageQueryVariables>;
export function useGroupPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupPageQuery, GroupPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GroupPageQuery | undefined, GroupPageQueryVariables>;
export function useGroupPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GroupPageQuery, GroupPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GroupPageQuery, GroupPageQueryVariables>(GroupPageDocument, options);
        }
export type GroupPageQueryHookResult = ReturnType<typeof useGroupPageQuery>;
export type GroupPageLazyQueryHookResult = ReturnType<typeof useGroupPageLazyQuery>;
export type GroupPageSuspenseQueryHookResult = ReturnType<typeof useGroupPageSuspenseQuery>;
export type GroupPageQueryResult = ApolloReactCommon.QueryResult<GroupPageQuery, GroupPageQueryVariables>;
export const HistoryKeysDocument = gql`
    query HistoryKeys($projectName: String!, $entityName: String!, $filters: JSONString, $limit: Int = 100, $order: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(filters: $filters, first: $limit, order: $order) {
      historyKeys(format: PLAINTEXT)
    }
  }
}
    `;

/**
 * __useHistoryKeysQuery__
 *
 * To run a query within a React component, call `useHistoryKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoryKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoryKeysQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useHistoryKeysQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HistoryKeysQuery, HistoryKeysQueryVariables> & ({ variables: HistoryKeysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HistoryKeysQuery, HistoryKeysQueryVariables>(HistoryKeysDocument, options);
      }
export function useHistoryKeysLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HistoryKeysQuery, HistoryKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HistoryKeysQuery, HistoryKeysQueryVariables>(HistoryKeysDocument, options);
        }
// @ts-ignore
export function useHistoryKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HistoryKeysQuery, HistoryKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HistoryKeysQuery, HistoryKeysQueryVariables>;
export function useHistoryKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HistoryKeysQuery, HistoryKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HistoryKeysQuery | undefined, HistoryKeysQueryVariables>;
export function useHistoryKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HistoryKeysQuery, HistoryKeysQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HistoryKeysQuery, HistoryKeysQueryVariables>(HistoryKeysDocument, options);
        }
export type HistoryKeysQueryHookResult = ReturnType<typeof useHistoryKeysQuery>;
export type HistoryKeysLazyQueryHookResult = ReturnType<typeof useHistoryKeysLazyQuery>;
export type HistoryKeysSuspenseQueryHookResult = ReturnType<typeof useHistoryKeysSuspenseQuery>;
export type HistoryKeysQueryResult = ApolloReactCommon.QueryResult<HistoryKeysQuery, HistoryKeysQueryVariables>;
export const HistoryKeysWithHashDocument = gql`
    query HistoryKeysWithHash($projectName: String!, $entityName: String!, $filters: JSONString, $limit: Int = 100, $order: String, $pinnedFilters: JSONString, $includePinnedRuns: Boolean = false) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(filters: $filters, first: $limit, order: $order) {
      ...HistoryKeysRunsFields
    }
    pinnedRuns: runs(filters: $pinnedFilters) @include(if: $includePinnedRuns) {
      ...HistoryKeysRunsFields
    }
  }
}
    ${HistoryKeysRunsFieldsFragmentDoc}`;

/**
 * __useHistoryKeysWithHashQuery__
 *
 * To run a query within a React component, call `useHistoryKeysWithHashQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoryKeysWithHashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoryKeysWithHashQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      pinnedFilters: // value for 'pinnedFilters'
 *      includePinnedRuns: // value for 'includePinnedRuns'
 *   },
 * });
 */
export function useHistoryKeysWithHashQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables> & ({ variables: HistoryKeysWithHashQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables>(HistoryKeysWithHashDocument, options);
      }
export function useHistoryKeysWithHashLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables>(HistoryKeysWithHashDocument, options);
        }
// @ts-ignore
export function useHistoryKeysWithHashSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables>;
export function useHistoryKeysWithHashSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HistoryKeysWithHashQuery | undefined, HistoryKeysWithHashQueryVariables>;
export function useHistoryKeysWithHashSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables>(HistoryKeysWithHashDocument, options);
        }
export type HistoryKeysWithHashQueryHookResult = ReturnType<typeof useHistoryKeysWithHashQuery>;
export type HistoryKeysWithHashLazyQueryHookResult = ReturnType<typeof useHistoryKeysWithHashLazyQuery>;
export type HistoryKeysWithHashSuspenseQueryHookResult = ReturnType<typeof useHistoryKeysWithHashSuspenseQuery>;
export type HistoryKeysWithHashQueryResult = ApolloReactCommon.QueryResult<HistoryKeysWithHashQuery, HistoryKeysWithHashQueryVariables>;
export const HistoryKeysByProjectIdDocument = gql`
    query HistoryKeysByProjectId($internalId: ID!, $filters: JSONString, $limit: Int = 100, $order: String) {
  project(internalId: $internalId) {
    id
    runs(filters: $filters, first: $limit, order: $order) {
      historyKeys(format: BITMAP)
    }
  }
}
    `;

/**
 * __useHistoryKeysByProjectIdQuery__
 *
 * To run a query within a React component, call `useHistoryKeysByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoryKeysByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoryKeysByProjectIdQuery({
 *   variables: {
 *      internalId: // value for 'internalId'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useHistoryKeysByProjectIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables> & ({ variables: HistoryKeysByProjectIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables>(HistoryKeysByProjectIdDocument, options);
      }
export function useHistoryKeysByProjectIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables>(HistoryKeysByProjectIdDocument, options);
        }
// @ts-ignore
export function useHistoryKeysByProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables>;
export function useHistoryKeysByProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HistoryKeysByProjectIdQuery | undefined, HistoryKeysByProjectIdQueryVariables>;
export function useHistoryKeysByProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables>(HistoryKeysByProjectIdDocument, options);
        }
export type HistoryKeysByProjectIdQueryHookResult = ReturnType<typeof useHistoryKeysByProjectIdQuery>;
export type HistoryKeysByProjectIdLazyQueryHookResult = ReturnType<typeof useHistoryKeysByProjectIdLazyQuery>;
export type HistoryKeysByProjectIdSuspenseQueryHookResult = ReturnType<typeof useHistoryKeysByProjectIdSuspenseQuery>;
export type HistoryKeysByProjectIdQueryResult = ApolloReactCommon.QueryResult<HistoryKeysByProjectIdQuery, HistoryKeysByProjectIdQueryVariables>;
export const InviteDocument = gql`
    query Invite($key: String!) {
  invite(key: $key) {
    id
    toUser {
      id
      username
    }
  }
}
    `;

/**
 * __useInviteQuery__
 *
 * To run a query within a React component, call `useInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useInviteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InviteQuery, InviteQueryVariables> & ({ variables: InviteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InviteQuery, InviteQueryVariables>(InviteDocument, options);
      }
export function useInviteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InviteQuery, InviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InviteQuery, InviteQueryVariables>(InviteDocument, options);
        }
// @ts-ignore
export function useInviteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InviteQuery, InviteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InviteQuery, InviteQueryVariables>;
export function useInviteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InviteQuery, InviteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InviteQuery | undefined, InviteQueryVariables>;
export function useInviteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InviteQuery, InviteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InviteQuery, InviteQueryVariables>(InviteDocument, options);
        }
export type InviteQueryHookResult = ReturnType<typeof useInviteQuery>;
export type InviteLazyQueryHookResult = ReturnType<typeof useInviteLazyQuery>;
export type InviteSuspenseQueryHookResult = ReturnType<typeof useInviteSuspenseQuery>;
export type InviteQueryResult = ApolloReactCommon.QueryResult<InviteQuery, InviteQueryVariables>;
export const FetchEntityJobsDocument = gql`
    query FetchEntityJobs($entityName: String!, $pattern: String) {
  entity(name: $entityName) {
    id
    name
    projects(first: 100, pattern: $pattern) {
      edges {
        node {
          id
          name
          artifactType(name: "job") {
            id
            artifactCollections {
              edges {
                node {
                  id
                  name
                  description
                  artifacts {
                    edges {
                      node {
                        id
                        description
                        labels
                        versionIndex
                        aliases {
                          id
                          alias
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchEntityJobsQuery__
 *
 * To run a query within a React component, call `useFetchEntityJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEntityJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEntityJobsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useFetchEntityJobsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchEntityJobsQuery, FetchEntityJobsQueryVariables> & ({ variables: FetchEntityJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchEntityJobsQuery, FetchEntityJobsQueryVariables>(FetchEntityJobsDocument, options);
      }
export function useFetchEntityJobsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchEntityJobsQuery, FetchEntityJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchEntityJobsQuery, FetchEntityJobsQueryVariables>(FetchEntityJobsDocument, options);
        }
// @ts-ignore
export function useFetchEntityJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchEntityJobsQuery, FetchEntityJobsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchEntityJobsQuery, FetchEntityJobsQueryVariables>;
export function useFetchEntityJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchEntityJobsQuery, FetchEntityJobsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchEntityJobsQuery | undefined, FetchEntityJobsQueryVariables>;
export function useFetchEntityJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchEntityJobsQuery, FetchEntityJobsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchEntityJobsQuery, FetchEntityJobsQueryVariables>(FetchEntityJobsDocument, options);
        }
export type FetchEntityJobsQueryHookResult = ReturnType<typeof useFetchEntityJobsQuery>;
export type FetchEntityJobsLazyQueryHookResult = ReturnType<typeof useFetchEntityJobsLazyQuery>;
export type FetchEntityJobsSuspenseQueryHookResult = ReturnType<typeof useFetchEntityJobsSuspenseQuery>;
export type FetchEntityJobsQueryResult = ApolloReactCommon.QueryResult<FetchEntityJobsQuery, FetchEntityJobsQueryVariables>;
export const FetchProjectJobsPartialDocument = gql`
    query FetchProjectJobsPartial($entityName: String!, $projectName: String!, $limit: Int!, $after: String, $filters: JSONString) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    internalId
    artifactType(name: "job") {
      id
      artifactCollections(first: $limit, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...JobInfo
          }
        }
      }
    }
  }
}
    ${JobInfoFragmentDoc}`;

/**
 * __useFetchProjectJobsPartialQuery__
 *
 * To run a query within a React component, call `useFetchProjectJobsPartialQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectJobsPartialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectJobsPartialQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchProjectJobsPartialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables> & ({ variables: FetchProjectJobsPartialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables>(FetchProjectJobsPartialDocument, options);
      }
export function useFetchProjectJobsPartialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables>(FetchProjectJobsPartialDocument, options);
        }
// @ts-ignore
export function useFetchProjectJobsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables>;
export function useFetchProjectJobsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectJobsPartialQuery | undefined, FetchProjectJobsPartialQueryVariables>;
export function useFetchProjectJobsPartialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables>(FetchProjectJobsPartialDocument, options);
        }
export type FetchProjectJobsPartialQueryHookResult = ReturnType<typeof useFetchProjectJobsPartialQuery>;
export type FetchProjectJobsPartialLazyQueryHookResult = ReturnType<typeof useFetchProjectJobsPartialLazyQuery>;
export type FetchProjectJobsPartialSuspenseQueryHookResult = ReturnType<typeof useFetchProjectJobsPartialSuspenseQuery>;
export type FetchProjectJobsPartialQueryResult = ApolloReactCommon.QueryResult<FetchProjectJobsPartialQuery, FetchProjectJobsPartialQueryVariables>;
export const FetchProjectInternalIdDocument = gql`
    query FetchProjectInternalId($entityName: String!, $projectName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    internalId
  }
}
    `;

/**
 * __useFetchProjectInternalIdQuery__
 *
 * To run a query within a React component, call `useFetchProjectInternalIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectInternalIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectInternalIdQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useFetchProjectInternalIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables> & ({ variables: FetchProjectInternalIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables>(FetchProjectInternalIdDocument, options);
      }
export function useFetchProjectInternalIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables>(FetchProjectInternalIdDocument, options);
        }
// @ts-ignore
export function useFetchProjectInternalIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables>;
export function useFetchProjectInternalIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectInternalIdQuery | undefined, FetchProjectInternalIdQueryVariables>;
export function useFetchProjectInternalIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables>(FetchProjectInternalIdDocument, options);
        }
export type FetchProjectInternalIdQueryHookResult = ReturnType<typeof useFetchProjectInternalIdQuery>;
export type FetchProjectInternalIdLazyQueryHookResult = ReturnType<typeof useFetchProjectInternalIdLazyQuery>;
export type FetchProjectInternalIdSuspenseQueryHookResult = ReturnType<typeof useFetchProjectInternalIdSuspenseQuery>;
export type FetchProjectInternalIdQueryResult = ApolloReactCommon.QueryResult<FetchProjectInternalIdQuery, FetchProjectInternalIdQueryVariables>;
export const FetchProjectJobsDocument = gql`
    query FetchProjectJobs($entityName: String!, $projectName: String!, $filters: JSONString) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    artifactType(name: "job") {
      id
      artifactCollections {
        edges {
          node {
            ...JobInfo
          }
        }
      }
    }
  }
}
    ${JobInfoFragmentDoc}`;

/**
 * __useFetchProjectJobsQuery__
 *
 * To run a query within a React component, call `useFetchProjectJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectJobsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useFetchProjectJobsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchProjectJobsQuery, FetchProjectJobsQueryVariables> & ({ variables: FetchProjectJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchProjectJobsQuery, FetchProjectJobsQueryVariables>(FetchProjectJobsDocument, options);
      }
export function useFetchProjectJobsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchProjectJobsQuery, FetchProjectJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchProjectJobsQuery, FetchProjectJobsQueryVariables>(FetchProjectJobsDocument, options);
        }
// @ts-ignore
export function useFetchProjectJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectJobsQuery, FetchProjectJobsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectJobsQuery, FetchProjectJobsQueryVariables>;
export function useFetchProjectJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectJobsQuery, FetchProjectJobsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectJobsQuery | undefined, FetchProjectJobsQueryVariables>;
export function useFetchProjectJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectJobsQuery, FetchProjectJobsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchProjectJobsQuery, FetchProjectJobsQueryVariables>(FetchProjectJobsDocument, options);
        }
export type FetchProjectJobsQueryHookResult = ReturnType<typeof useFetchProjectJobsQuery>;
export type FetchProjectJobsLazyQueryHookResult = ReturnType<typeof useFetchProjectJobsLazyQuery>;
export type FetchProjectJobsSuspenseQueryHookResult = ReturnType<typeof useFetchProjectJobsSuspenseQuery>;
export type FetchProjectJobsQueryResult = ApolloReactCommon.QueryResult<FetchProjectJobsQuery, FetchProjectJobsQueryVariables>;
export const FetchRecentlyUsedJobsDocument = gql`
    query FetchRecentlyUsedJobs($entityName: String!, $projectName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    runs(first: 100) {
      edges {
        node {
          id
          createdAt
          job {
            id
            artifactSequence {
              id
              name
              state
              project {
                id
                name
                entityName
              }
              description
              createdAt
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchRecentlyUsedJobsQuery__
 *
 * To run a query within a React component, call `useFetchRecentlyUsedJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRecentlyUsedJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRecentlyUsedJobsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useFetchRecentlyUsedJobsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables> & ({ variables: FetchRecentlyUsedJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables>(FetchRecentlyUsedJobsDocument, options);
      }
export function useFetchRecentlyUsedJobsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables>(FetchRecentlyUsedJobsDocument, options);
        }
// @ts-ignore
export function useFetchRecentlyUsedJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables>;
export function useFetchRecentlyUsedJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRecentlyUsedJobsQuery | undefined, FetchRecentlyUsedJobsQueryVariables>;
export function useFetchRecentlyUsedJobsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables>(FetchRecentlyUsedJobsDocument, options);
        }
export type FetchRecentlyUsedJobsQueryHookResult = ReturnType<typeof useFetchRecentlyUsedJobsQuery>;
export type FetchRecentlyUsedJobsLazyQueryHookResult = ReturnType<typeof useFetchRecentlyUsedJobsLazyQuery>;
export type FetchRecentlyUsedJobsSuspenseQueryHookResult = ReturnType<typeof useFetchRecentlyUsedJobsSuspenseQuery>;
export type FetchRecentlyUsedJobsQueryResult = ApolloReactCommon.QueryResult<FetchRecentlyUsedJobsQuery, FetchRecentlyUsedJobsQueryVariables>;
export const FetchJobVersionsDocument = gql`
    query FetchJobVersions($entityName: String!, $projectName: String!, $jobName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    artifactCollection(name: $jobName) {
      id
      description
      artifacts {
        edges {
          node {
            id
            createdAt
            createdBy {
              __typename
              ... on User {
                id
                name
                username
                photoUrl
              }
              ... on Run {
                id
                name
                displayName
                defaultColorIndex
              }
            }
            aliases {
              id
              alias
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchJobVersionsQuery__
 *
 * To run a query within a React component, call `useFetchJobVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchJobVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchJobVersionsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      jobName: // value for 'jobName'
 *   },
 * });
 */
export function useFetchJobVersionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchJobVersionsQuery, FetchJobVersionsQueryVariables> & ({ variables: FetchJobVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchJobVersionsQuery, FetchJobVersionsQueryVariables>(FetchJobVersionsDocument, options);
      }
export function useFetchJobVersionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchJobVersionsQuery, FetchJobVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchJobVersionsQuery, FetchJobVersionsQueryVariables>(FetchJobVersionsDocument, options);
        }
// @ts-ignore
export function useFetchJobVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchJobVersionsQuery, FetchJobVersionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchJobVersionsQuery, FetchJobVersionsQueryVariables>;
export function useFetchJobVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchJobVersionsQuery, FetchJobVersionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchJobVersionsQuery | undefined, FetchJobVersionsQueryVariables>;
export function useFetchJobVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchJobVersionsQuery, FetchJobVersionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchJobVersionsQuery, FetchJobVersionsQueryVariables>(FetchJobVersionsDocument, options);
        }
export type FetchJobVersionsQueryHookResult = ReturnType<typeof useFetchJobVersionsQuery>;
export type FetchJobVersionsLazyQueryHookResult = ReturnType<typeof useFetchJobVersionsLazyQuery>;
export type FetchJobVersionsSuspenseQueryHookResult = ReturnType<typeof useFetchJobVersionsSuspenseQuery>;
export type FetchJobVersionsQueryResult = ApolloReactCommon.QueryResult<FetchJobVersionsQuery, FetchJobVersionsQueryVariables>;
export const FetchRecentlyUsedJobDetailDocument = gql`
    query FetchRecentlyUsedJobDetail($entityName: String!, $projectName: String!, $limit: Int!, $after: String, $filters: JSONString, $artifactCollectionFilters: JSONString) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    internalId
    entityName
    artifactType(name: "job") {
      id
      artifactCollections(
        first: $limit
        after: $after
        filters: $artifactCollectionFilters
      ) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            project {
              id
              name
              entityName
            }
            ...JobInfo
          }
        }
      }
    }
  }
}
    ${JobInfoFragmentDoc}`;

/**
 * __useFetchRecentlyUsedJobDetailQuery__
 *
 * To run a query within a React component, call `useFetchRecentlyUsedJobDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRecentlyUsedJobDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRecentlyUsedJobDetailQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *      artifactCollectionFilters: // value for 'artifactCollectionFilters'
 *   },
 * });
 */
export function useFetchRecentlyUsedJobDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables> & ({ variables: FetchRecentlyUsedJobDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables>(FetchRecentlyUsedJobDetailDocument, options);
      }
export function useFetchRecentlyUsedJobDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables>(FetchRecentlyUsedJobDetailDocument, options);
        }
// @ts-ignore
export function useFetchRecentlyUsedJobDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables>;
export function useFetchRecentlyUsedJobDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRecentlyUsedJobDetailQuery | undefined, FetchRecentlyUsedJobDetailQueryVariables>;
export function useFetchRecentlyUsedJobDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables>(FetchRecentlyUsedJobDetailDocument, options);
        }
export type FetchRecentlyUsedJobDetailQueryHookResult = ReturnType<typeof useFetchRecentlyUsedJobDetailQuery>;
export type FetchRecentlyUsedJobDetailLazyQueryHookResult = ReturnType<typeof useFetchRecentlyUsedJobDetailLazyQuery>;
export type FetchRecentlyUsedJobDetailSuspenseQueryHookResult = ReturnType<typeof useFetchRecentlyUsedJobDetailSuspenseQuery>;
export type FetchRecentlyUsedJobDetailQueryResult = ApolloReactCommon.QueryResult<FetchRecentlyUsedJobDetailQuery, FetchRecentlyUsedJobDetailQueryVariables>;
export const FetchJobDocument = gql`
    query FetchJob($jobId: ID!) {
  artifactCollection(id: $jobId) {
    id
    name
  }
}
    `;

/**
 * __useFetchJobQuery__
 *
 * To run a query within a React component, call `useFetchJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchJobQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useFetchJobQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchJobQuery, FetchJobQueryVariables> & ({ variables: FetchJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchJobQuery, FetchJobQueryVariables>(FetchJobDocument, options);
      }
export function useFetchJobLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchJobQuery, FetchJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchJobQuery, FetchJobQueryVariables>(FetchJobDocument, options);
        }
// @ts-ignore
export function useFetchJobSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchJobQuery, FetchJobQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchJobQuery, FetchJobQueryVariables>;
export function useFetchJobSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchJobQuery, FetchJobQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchJobQuery | undefined, FetchJobQueryVariables>;
export function useFetchJobSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchJobQuery, FetchJobQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchJobQuery, FetchJobQueryVariables>(FetchJobDocument, options);
        }
export type FetchJobQueryHookResult = ReturnType<typeof useFetchJobQuery>;
export type FetchJobLazyQueryHookResult = ReturnType<typeof useFetchJobLazyQuery>;
export type FetchJobSuspenseQueryHookResult = ReturnType<typeof useFetchJobSuspenseQuery>;
export type FetchJobQueryResult = ApolloReactCommon.QueryResult<FetchJobQuery, FetchJobQueryVariables>;
export const FetchJobDetailsDocument = gql`
    query FetchJobDetails($jobId: ID!) {
  artifactCollection(id: $jobId) {
    ...JobCollectionFields
    artifacts {
      edges {
        node {
          ...JobVersionFields
          labels
          versionIndex
          usedBy {
            totalCount
            edges {
              node {
                ...JobRunFields
              }
            }
          }
        }
      }
    }
  }
}
    ${JobCollectionFieldsFragmentDoc}
${JobVersionFieldsFragmentDoc}
${JobRunFieldsFragmentDoc}`;

/**
 * __useFetchJobDetailsQuery__
 *
 * To run a query within a React component, call `useFetchJobDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchJobDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchJobDetailsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useFetchJobDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchJobDetailsQuery, FetchJobDetailsQueryVariables> & ({ variables: FetchJobDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchJobDetailsQuery, FetchJobDetailsQueryVariables>(FetchJobDetailsDocument, options);
      }
export function useFetchJobDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchJobDetailsQuery, FetchJobDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchJobDetailsQuery, FetchJobDetailsQueryVariables>(FetchJobDetailsDocument, options);
        }
// @ts-ignore
export function useFetchJobDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchJobDetailsQuery, FetchJobDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchJobDetailsQuery, FetchJobDetailsQueryVariables>;
export function useFetchJobDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchJobDetailsQuery, FetchJobDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchJobDetailsQuery | undefined, FetchJobDetailsQueryVariables>;
export function useFetchJobDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchJobDetailsQuery, FetchJobDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchJobDetailsQuery, FetchJobDetailsQueryVariables>(FetchJobDetailsDocument, options);
        }
export type FetchJobDetailsQueryHookResult = ReturnType<typeof useFetchJobDetailsQuery>;
export type FetchJobDetailsLazyQueryHookResult = ReturnType<typeof useFetchJobDetailsLazyQuery>;
export type FetchJobDetailsSuspenseQueryHookResult = ReturnType<typeof useFetchJobDetailsSuspenseQuery>;
export type FetchJobDetailsQueryResult = ApolloReactCommon.QueryResult<FetchJobDetailsQuery, FetchJobDetailsQueryVariables>;
export const FetchJobVersionsByIdDocument = gql`
    query FetchJobVersionsById($jobId: ID!) {
  artifactCollection(id: $jobId) {
    ...JobCollectionFields
    artifacts {
      edges {
        node {
          ...JobVersionFields
        }
      }
    }
  }
}
    ${JobCollectionFieldsFragmentDoc}
${JobVersionFieldsFragmentDoc}`;

/**
 * __useFetchJobVersionsByIdQuery__
 *
 * To run a query within a React component, call `useFetchJobVersionsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchJobVersionsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchJobVersionsByIdQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useFetchJobVersionsByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchJobVersionsByIdQuery, FetchJobVersionsByIdQueryVariables> & ({ variables: FetchJobVersionsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchJobVersionsByIdQuery, FetchJobVersionsByIdQueryVariables>(FetchJobVersionsByIdDocument, options);
      }
export function useFetchJobVersionsByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchJobVersionsByIdQuery, FetchJobVersionsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchJobVersionsByIdQuery, FetchJobVersionsByIdQueryVariables>(FetchJobVersionsByIdDocument, options);
        }
// @ts-ignore
export function useFetchJobVersionsByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchJobVersionsByIdQuery, FetchJobVersionsByIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchJobVersionsByIdQuery, FetchJobVersionsByIdQueryVariables>;
export function useFetchJobVersionsByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchJobVersionsByIdQuery, FetchJobVersionsByIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchJobVersionsByIdQuery | undefined, FetchJobVersionsByIdQueryVariables>;
export function useFetchJobVersionsByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchJobVersionsByIdQuery, FetchJobVersionsByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchJobVersionsByIdQuery, FetchJobVersionsByIdQueryVariables>(FetchJobVersionsByIdDocument, options);
        }
export type FetchJobVersionsByIdQueryHookResult = ReturnType<typeof useFetchJobVersionsByIdQuery>;
export type FetchJobVersionsByIdLazyQueryHookResult = ReturnType<typeof useFetchJobVersionsByIdLazyQuery>;
export type FetchJobVersionsByIdSuspenseQueryHookResult = ReturnType<typeof useFetchJobVersionsByIdSuspenseQuery>;
export type FetchJobVersionsByIdQueryResult = ApolloReactCommon.QueryResult<FetchJobVersionsByIdQuery, FetchJobVersionsByIdQueryVariables>;
export const FetchJobVersionRunsDocument = gql`
    query FetchJobVersionRuns($artifactId: ID!, $usedByFilters: JSONString, $usedByFirst: Int) {
  artifact(id: $artifactId) {
    id
    aliases {
      id
      alias
    }
    usedBy(filters: $usedByFilters, first: $usedByFirst) {
      totalCount
      edges {
        node {
          ...JobRunFields
          runInfo {
            args
          }
        }
      }
    }
  }
}
    ${JobRunFieldsFragmentDoc}`;

/**
 * __useFetchJobVersionRunsQuery__
 *
 * To run a query within a React component, call `useFetchJobVersionRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchJobVersionRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchJobVersionRunsQuery({
 *   variables: {
 *      artifactId: // value for 'artifactId'
 *      usedByFilters: // value for 'usedByFilters'
 *      usedByFirst: // value for 'usedByFirst'
 *   },
 * });
 */
export function useFetchJobVersionRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchJobVersionRunsQuery, FetchJobVersionRunsQueryVariables> & ({ variables: FetchJobVersionRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchJobVersionRunsQuery, FetchJobVersionRunsQueryVariables>(FetchJobVersionRunsDocument, options);
      }
export function useFetchJobVersionRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchJobVersionRunsQuery, FetchJobVersionRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchJobVersionRunsQuery, FetchJobVersionRunsQueryVariables>(FetchJobVersionRunsDocument, options);
        }
// @ts-ignore
export function useFetchJobVersionRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchJobVersionRunsQuery, FetchJobVersionRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchJobVersionRunsQuery, FetchJobVersionRunsQueryVariables>;
export function useFetchJobVersionRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchJobVersionRunsQuery, FetchJobVersionRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchJobVersionRunsQuery | undefined, FetchJobVersionRunsQueryVariables>;
export function useFetchJobVersionRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchJobVersionRunsQuery, FetchJobVersionRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchJobVersionRunsQuery, FetchJobVersionRunsQueryVariables>(FetchJobVersionRunsDocument, options);
        }
export type FetchJobVersionRunsQueryHookResult = ReturnType<typeof useFetchJobVersionRunsQuery>;
export type FetchJobVersionRunsLazyQueryHookResult = ReturnType<typeof useFetchJobVersionRunsLazyQuery>;
export type FetchJobVersionRunsSuspenseQueryHookResult = ReturnType<typeof useFetchJobVersionRunsSuspenseQuery>;
export type FetchJobVersionRunsQueryResult = ApolloReactCommon.QueryResult<FetchJobVersionRunsQuery, FetchJobVersionRunsQueryVariables>;
export const FetchProjectRunsDocument = gql`
    query FetchProjectRuns($entityName: String!, $projectName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    runs {
      edges {
        node {
          id
          name
          displayName
          runInfo {
            git {
              remote
              commit
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchProjectRunsQuery__
 *
 * To run a query within a React component, call `useFetchProjectRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectRunsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useFetchProjectRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchProjectRunsQuery, FetchProjectRunsQueryVariables> & ({ variables: FetchProjectRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchProjectRunsQuery, FetchProjectRunsQueryVariables>(FetchProjectRunsDocument, options);
      }
export function useFetchProjectRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchProjectRunsQuery, FetchProjectRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchProjectRunsQuery, FetchProjectRunsQueryVariables>(FetchProjectRunsDocument, options);
        }
// @ts-ignore
export function useFetchProjectRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectRunsQuery, FetchProjectRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectRunsQuery, FetchProjectRunsQueryVariables>;
export function useFetchProjectRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectRunsQuery, FetchProjectRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectRunsQuery | undefined, FetchProjectRunsQueryVariables>;
export function useFetchProjectRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectRunsQuery, FetchProjectRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchProjectRunsQuery, FetchProjectRunsQueryVariables>(FetchProjectRunsDocument, options);
        }
export type FetchProjectRunsQueryHookResult = ReturnType<typeof useFetchProjectRunsQuery>;
export type FetchProjectRunsLazyQueryHookResult = ReturnType<typeof useFetchProjectRunsLazyQuery>;
export type FetchProjectRunsSuspenseQueryHookResult = ReturnType<typeof useFetchProjectRunsSuspenseQuery>;
export type FetchProjectRunsQueryResult = ApolloReactCommon.QueryResult<FetchProjectRunsQuery, FetchProjectRunsQueryVariables>;
export const FetchProjectLaunchQueuesDocument = gql`
    query FetchProjectLaunchQueues($entityName: String!, $projectName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    entity {
      id
      isTeam
      name
    }
    runQueues {
      id
      name
      access
      defaultResourceConfigID
      prioritizationMode
    }
  }
}
    `;

/**
 * __useFetchProjectLaunchQueuesQuery__
 *
 * To run a query within a React component, call `useFetchProjectLaunchQueuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectLaunchQueuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectLaunchQueuesQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useFetchProjectLaunchQueuesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables> & ({ variables: FetchProjectLaunchQueuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables>(FetchProjectLaunchQueuesDocument, options);
      }
export function useFetchProjectLaunchQueuesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables>(FetchProjectLaunchQueuesDocument, options);
        }
// @ts-ignore
export function useFetchProjectLaunchQueuesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables>;
export function useFetchProjectLaunchQueuesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectLaunchQueuesQuery | undefined, FetchProjectLaunchQueuesQueryVariables>;
export function useFetchProjectLaunchQueuesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables>(FetchProjectLaunchQueuesDocument, options);
        }
export type FetchProjectLaunchQueuesQueryHookResult = ReturnType<typeof useFetchProjectLaunchQueuesQuery>;
export type FetchProjectLaunchQueuesLazyQueryHookResult = ReturnType<typeof useFetchProjectLaunchQueuesLazyQuery>;
export type FetchProjectLaunchQueuesSuspenseQueryHookResult = ReturnType<typeof useFetchProjectLaunchQueuesSuspenseQuery>;
export type FetchProjectLaunchQueuesQueryResult = ApolloReactCommon.QueryResult<FetchProjectLaunchQueuesQuery, FetchProjectLaunchQueuesQueryVariables>;
export const FetchEntityProjectsDocument = gql`
    query FetchEntityProjects($entityName: String!) {
  entity(name: $entityName) {
    id
    projects(first: 100, order: "-createdAt") {
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFetchEntityProjectsQuery__
 *
 * To run a query within a React component, call `useFetchEntityProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEntityProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEntityProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useFetchEntityProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables> & ({ variables: FetchEntityProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables>(FetchEntityProjectsDocument, options);
      }
export function useFetchEntityProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables>(FetchEntityProjectsDocument, options);
        }
// @ts-ignore
export function useFetchEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables>;
export function useFetchEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchEntityProjectsQuery | undefined, FetchEntityProjectsQueryVariables>;
export function useFetchEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables>(FetchEntityProjectsDocument, options);
        }
export type FetchEntityProjectsQueryHookResult = ReturnType<typeof useFetchEntityProjectsQuery>;
export type FetchEntityProjectsLazyQueryHookResult = ReturnType<typeof useFetchEntityProjectsLazyQuery>;
export type FetchEntityProjectsSuspenseQueryHookResult = ReturnType<typeof useFetchEntityProjectsSuspenseQuery>;
export type FetchEntityProjectsQueryResult = ApolloReactCommon.QueryResult<FetchEntityProjectsQuery, FetchEntityProjectsQueryVariables>;
export const EntityPhotoDocument = gql`
    query EntityPhoto($entityName: String!) {
  entity(name: $entityName) {
    id
    photoUrl
  }
}
    `;

/**
 * __useEntityPhotoQuery__
 *
 * To run a query within a React component, call `useEntityPhotoQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityPhotoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityPhotoQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityPhotoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityPhotoQuery, EntityPhotoQueryVariables> & ({ variables: EntityPhotoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityPhotoQuery, EntityPhotoQueryVariables>(EntityPhotoDocument, options);
      }
export function useEntityPhotoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityPhotoQuery, EntityPhotoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityPhotoQuery, EntityPhotoQueryVariables>(EntityPhotoDocument, options);
        }
// @ts-ignore
export function useEntityPhotoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityPhotoQuery, EntityPhotoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityPhotoQuery, EntityPhotoQueryVariables>;
export function useEntityPhotoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityPhotoQuery, EntityPhotoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityPhotoQuery | undefined, EntityPhotoQueryVariables>;
export function useEntityPhotoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityPhotoQuery, EntityPhotoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityPhotoQuery, EntityPhotoQueryVariables>(EntityPhotoDocument, options);
        }
export type EntityPhotoQueryHookResult = ReturnType<typeof useEntityPhotoQuery>;
export type EntityPhotoLazyQueryHookResult = ReturnType<typeof useEntityPhotoLazyQuery>;
export type EntityPhotoSuspenseQueryHookResult = ReturnType<typeof useEntityPhotoSuspenseQuery>;
export type EntityPhotoQueryResult = ApolloReactCommon.QueryResult<EntityPhotoQuery, EntityPhotoQueryVariables>;
export const UserEntitiesDocument = gql`
    query UserEntities {
  viewer {
    id
    teams {
      edges {
        node {
          id
          name
          photoUrl
          entityType
          members {
            id
            username
            role
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUserEntitiesQuery__
 *
 * To run a query within a React component, call `useUserEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEntitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserEntitiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserEntitiesQuery, UserEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserEntitiesQuery, UserEntitiesQueryVariables>(UserEntitiesDocument, options);
      }
export function useUserEntitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserEntitiesQuery, UserEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserEntitiesQuery, UserEntitiesQueryVariables>(UserEntitiesDocument, options);
        }
// @ts-ignore
export function useUserEntitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserEntitiesQuery, UserEntitiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserEntitiesQuery, UserEntitiesQueryVariables>;
export function useUserEntitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserEntitiesQuery, UserEntitiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserEntitiesQuery | undefined, UserEntitiesQueryVariables>;
export function useUserEntitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserEntitiesQuery, UserEntitiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserEntitiesQuery, UserEntitiesQueryVariables>(UserEntitiesDocument, options);
        }
export type UserEntitiesQueryHookResult = ReturnType<typeof useUserEntitiesQuery>;
export type UserEntitiesLazyQueryHookResult = ReturnType<typeof useUserEntitiesLazyQuery>;
export type UserEntitiesSuspenseQueryHookResult = ReturnType<typeof useUserEntitiesSuspenseQuery>;
export type UserEntitiesQueryResult = ApolloReactCommon.QueryResult<UserEntitiesQuery, UserEntitiesQueryVariables>;
export const ViewerDestinationProjectsDocument = gql`
    query ViewerDestinationProjects {
  viewer {
    id
    teams {
      edges {
        node {
          id
          name
          projects {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useViewerDestinationProjectsQuery__
 *
 * To run a query within a React component, call `useViewerDestinationProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerDestinationProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerDestinationProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerDestinationProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>(ViewerDestinationProjectsDocument, options);
      }
export function useViewerDestinationProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>(ViewerDestinationProjectsDocument, options);
        }
// @ts-ignore
export function useViewerDestinationProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>;
export function useViewerDestinationProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerDestinationProjectsQuery | undefined, ViewerDestinationProjectsQueryVariables>;
export function useViewerDestinationProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>(ViewerDestinationProjectsDocument, options);
        }
export type ViewerDestinationProjectsQueryHookResult = ReturnType<typeof useViewerDestinationProjectsQuery>;
export type ViewerDestinationProjectsLazyQueryHookResult = ReturnType<typeof useViewerDestinationProjectsLazyQuery>;
export type ViewerDestinationProjectsSuspenseQueryHookResult = ReturnType<typeof useViewerDestinationProjectsSuspenseQuery>;
export type ViewerDestinationProjectsQueryResult = ApolloReactCommon.QueryResult<ViewerDestinationProjectsQuery, ViewerDestinationProjectsQueryVariables>;
export const QueueNamesDocument = gql`
    query QueueNames($entityName: String) {
  project(name: "model-registry", entityName: $entityName) {
    id
    runQueues {
      id
      name
    }
  }
}
    `;

/**
 * __useQueueNamesQuery__
 *
 * To run a query within a React component, call `useQueueNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueueNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueueNamesQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useQueueNamesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<QueueNamesQuery, QueueNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QueueNamesQuery, QueueNamesQueryVariables>(QueueNamesDocument, options);
      }
export function useQueueNamesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QueueNamesQuery, QueueNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QueueNamesQuery, QueueNamesQueryVariables>(QueueNamesDocument, options);
        }
// @ts-ignore
export function useQueueNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<QueueNamesQuery, QueueNamesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<QueueNamesQuery, QueueNamesQueryVariables>;
export function useQueueNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QueueNamesQuery, QueueNamesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<QueueNamesQuery | undefined, QueueNamesQueryVariables>;
export function useQueueNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QueueNamesQuery, QueueNamesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<QueueNamesQuery, QueueNamesQueryVariables>(QueueNamesDocument, options);
        }
export type QueueNamesQueryHookResult = ReturnType<typeof useQueueNamesQuery>;
export type QueueNamesLazyQueryHookResult = ReturnType<typeof useQueueNamesLazyQuery>;
export type QueueNamesSuspenseQueryHookResult = ReturnType<typeof useQueueNamesSuspenseQuery>;
export type QueueNamesQueryResult = ApolloReactCommon.QueryResult<QueueNamesQuery, QueueNamesQueryVariables>;
export const AllQueuesDocument = gql`
    query AllQueues {
  viewer {
    id
    entity
    teams {
      edges {
        node {
          id
          name
          organizationId
          launchProject {
            id
            name
            launchAgents {
              id
              name
              createdAt
              heartbeatAt
              agentStatus
              stopPolling
              runQueues
              hostname
            }
            runQueues {
              id
              createdAt
              createdBy
              updatedAt
              name
              access
              prioritizationMode
              executorInfo
              externalLinks
              defaultResourceConfig {
                id
                ...DefaultResourceConfigFragment
              }
              runQueueItems(first: 500) {
                edges {
                  node {
                    id
                    ...RunQueueItemFragment
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${DefaultResourceConfigFragmentFragmentDoc}
${RunQueueItemFragmentFragmentDoc}`;

/**
 * __useAllQueuesQuery__
 *
 * To run a query within a React component, call `useAllQueuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllQueuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllQueuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllQueuesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllQueuesQuery, AllQueuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllQueuesQuery, AllQueuesQueryVariables>(AllQueuesDocument, options);
      }
export function useAllQueuesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllQueuesQuery, AllQueuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllQueuesQuery, AllQueuesQueryVariables>(AllQueuesDocument, options);
        }
// @ts-ignore
export function useAllQueuesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllQueuesQuery, AllQueuesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllQueuesQuery, AllQueuesQueryVariables>;
export function useAllQueuesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllQueuesQuery, AllQueuesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllQueuesQuery | undefined, AllQueuesQueryVariables>;
export function useAllQueuesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllQueuesQuery, AllQueuesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllQueuesQuery, AllQueuesQueryVariables>(AllQueuesDocument, options);
        }
export type AllQueuesQueryHookResult = ReturnType<typeof useAllQueuesQuery>;
export type AllQueuesLazyQueryHookResult = ReturnType<typeof useAllQueuesLazyQuery>;
export type AllQueuesSuspenseQueryHookResult = ReturnType<typeof useAllQueuesSuspenseQuery>;
export type AllQueuesQueryResult = ApolloReactCommon.QueryResult<AllQueuesQuery, AllQueuesQueryVariables>;
export const PublicQueueDocument = gql`
    query PublicQueue($entityName: String, $publicQueueName: String) {
  entity(name: $entityName) {
    id
    name
    launchProject {
      id
      name
      launchAgents {
        id
        name
        createdAt
        heartbeatAt
        agentStatus
        stopPolling
        runQueues
        hostname
      }
      runQueue(name: $publicQueueName) {
        id
        createdAt
        createdBy
        updatedAt
        name
        access
        prioritizationMode
        executorInfo
        externalLinks
        defaultResourceConfig {
          id
          ...DefaultResourceConfigFragment
        }
        runQueueItems(first: 500) {
          edges {
            node {
              id
              ...RunQueueItemFragment
              error {
                message
                stage
                filePaths
              }
              warnings {
                message
                stage
                filePaths
              }
            }
          }
        }
      }
    }
  }
}
    ${DefaultResourceConfigFragmentFragmentDoc}
${RunQueueItemFragmentFragmentDoc}`;

/**
 * __usePublicQueueQuery__
 *
 * To run a query within a React component, call `usePublicQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicQueueQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      publicQueueName: // value for 'publicQueueName'
 *   },
 * });
 */
export function usePublicQueueQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PublicQueueQuery, PublicQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublicQueueQuery, PublicQueueQueryVariables>(PublicQueueDocument, options);
      }
export function usePublicQueueLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublicQueueQuery, PublicQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublicQueueQuery, PublicQueueQueryVariables>(PublicQueueDocument, options);
        }
// @ts-ignore
export function usePublicQueueSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PublicQueueQuery, PublicQueueQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublicQueueQuery, PublicQueueQueryVariables>;
export function usePublicQueueSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublicQueueQuery, PublicQueueQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublicQueueQuery | undefined, PublicQueueQueryVariables>;
export function usePublicQueueSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublicQueueQuery, PublicQueueQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublicQueueQuery, PublicQueueQueryVariables>(PublicQueueDocument, options);
        }
export type PublicQueueQueryHookResult = ReturnType<typeof usePublicQueueQuery>;
export type PublicQueueLazyQueryHookResult = ReturnType<typeof usePublicQueueLazyQuery>;
export type PublicQueueSuspenseQueryHookResult = ReturnType<typeof usePublicQueueSuspenseQuery>;
export type PublicQueueQueryResult = ApolloReactCommon.QueryResult<PublicQueueQuery, PublicQueueQueryVariables>;
export const QueueByIdLiteDocument = gql`
    query QueueByIDLite($entityName: String!, $queueId: ID!) {
  project(name: "model-registry", entityName: $entityName) {
    id
    name
    launchAgents {
      id
      name
      createdAt
      heartbeatAt
      agentStatus
      stopPolling
      runQueues
      hostname
    }
    runQueue(id: $queueId) {
      id
      createdAt
      name
      defaultResourceConfig {
        id
        createdAt
        resource
        config
        templateVariables {
          name
          description
          schema
        }
      }
      prioritizationMode
      executorInfo
      externalLinks
      runQueueItems(first: 500) {
        edges {
          node {
            id
            ...RunQueueItemFragment
          }
        }
      }
    }
  }
}
    ${RunQueueItemFragmentFragmentDoc}`;

/**
 * __useQueueByIdLiteQuery__
 *
 * To run a query within a React component, call `useQueueByIdLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueueByIdLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueueByIdLiteQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      queueId: // value for 'queueId'
 *   },
 * });
 */
export function useQueueByIdLiteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<QueueByIdLiteQuery, QueueByIdLiteQueryVariables> & ({ variables: QueueByIdLiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QueueByIdLiteQuery, QueueByIdLiteQueryVariables>(QueueByIdLiteDocument, options);
      }
export function useQueueByIdLiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QueueByIdLiteQuery, QueueByIdLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QueueByIdLiteQuery, QueueByIdLiteQueryVariables>(QueueByIdLiteDocument, options);
        }
// @ts-ignore
export function useQueueByIdLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<QueueByIdLiteQuery, QueueByIdLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<QueueByIdLiteQuery, QueueByIdLiteQueryVariables>;
export function useQueueByIdLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QueueByIdLiteQuery, QueueByIdLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<QueueByIdLiteQuery | undefined, QueueByIdLiteQueryVariables>;
export function useQueueByIdLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QueueByIdLiteQuery, QueueByIdLiteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<QueueByIdLiteQuery, QueueByIdLiteQueryVariables>(QueueByIdLiteDocument, options);
        }
export type QueueByIdLiteQueryHookResult = ReturnType<typeof useQueueByIdLiteQuery>;
export type QueueByIdLiteLazyQueryHookResult = ReturnType<typeof useQueueByIdLiteLazyQuery>;
export type QueueByIdLiteSuspenseQueryHookResult = ReturnType<typeof useQueueByIdLiteSuspenseQuery>;
export type QueueByIdLiteQueryResult = ApolloReactCommon.QueryResult<QueueByIdLiteQuery, QueueByIdLiteQueryVariables>;
export const PublicQueueLiteDocument = gql`
    query PublicQueueLite($entityName: String, $publicQueueName: String) {
  entity(name: $entityName) {
    id
    name
    launchProject {
      id
      name
      launchAgents {
        id
        name
        createdAt
        heartbeatAt
        agentStatus
        stopPolling
        runQueues
        hostname
      }
      runQueue(name: $publicQueueName) {
        id
        createdAt
        createdBy
        updatedAt
        name
        access
        prioritizationMode
        executorInfo
        externalLinks
        defaultResourceConfig {
          id
          ...DefaultResourceConfigFragment
        }
        runQueueItems(first: 500) {
          edges {
            node {
              id
              ...RunQueueItemFragment
            }
          }
        }
      }
    }
  }
}
    ${DefaultResourceConfigFragmentFragmentDoc}
${RunQueueItemFragmentFragmentDoc}`;

/**
 * __usePublicQueueLiteQuery__
 *
 * To run a query within a React component, call `usePublicQueueLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicQueueLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicQueueLiteQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      publicQueueName: // value for 'publicQueueName'
 *   },
 * });
 */
export function usePublicQueueLiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>(PublicQueueLiteDocument, options);
      }
export function usePublicQueueLiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>(PublicQueueLiteDocument, options);
        }
// @ts-ignore
export function usePublicQueueLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>;
export function usePublicQueueLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublicQueueLiteQuery | undefined, PublicQueueLiteQueryVariables>;
export function usePublicQueueLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>(PublicQueueLiteDocument, options);
        }
export type PublicQueueLiteQueryHookResult = ReturnType<typeof usePublicQueueLiteQuery>;
export type PublicQueueLiteLazyQueryHookResult = ReturnType<typeof usePublicQueueLiteLazyQuery>;
export type PublicQueueLiteSuspenseQueryHookResult = ReturnType<typeof usePublicQueueLiteSuspenseQuery>;
export type PublicQueueLiteQueryResult = ApolloReactCommon.QueryResult<PublicQueueLiteQuery, PublicQueueLiteQueryVariables>;
export const EntityQueuesLiteDocument = gql`
    query EntityQueuesLite($entityName: String) {
  entity(name: $entityName) {
    id
    name
    launchProject {
      id
      name
      launchAgents {
        id
        name
        createdAt
        heartbeatAt
        agentStatus
        stopPolling
        runQueues
        hostname
      }
      runQueues {
        id
        createdAt
        createdBy
        updatedAt
        name
        access
        defaultResourceConfig {
          id
          createdAt
          updatedAt
          scope {
            __typename
            Type
            ID
          }
          resource
          config
          templateVariables {
            name
            description
            schema
          }
        }
        prioritizationMode
        executorInfo
        externalLinks
      }
    }
  }
}
    `;

/**
 * __useEntityQueuesLiteQuery__
 *
 * To run a query within a React component, call `useEntityQueuesLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityQueuesLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityQueuesLiteQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityQueuesLiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>(EntityQueuesLiteDocument, options);
      }
export function useEntityQueuesLiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>(EntityQueuesLiteDocument, options);
        }
// @ts-ignore
export function useEntityQueuesLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>;
export function useEntityQueuesLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityQueuesLiteQuery | undefined, EntityQueuesLiteQueryVariables>;
export function useEntityQueuesLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>(EntityQueuesLiteDocument, options);
        }
export type EntityQueuesLiteQueryHookResult = ReturnType<typeof useEntityQueuesLiteQuery>;
export type EntityQueuesLiteLazyQueryHookResult = ReturnType<typeof useEntityQueuesLiteLazyQuery>;
export type EntityQueuesLiteSuspenseQueryHookResult = ReturnType<typeof useEntityQueuesLiteSuspenseQuery>;
export type EntityQueuesLiteQueryResult = ApolloReactCommon.QueryResult<EntityQueuesLiteQuery, EntityQueuesLiteQueryVariables>;
export const EntityQueueByQueueNameLiteDocument = gql`
    query EntityQueueByQueueNameLite($entityName: String, $queueName: String) {
  entity(name: $entityName) {
    id
    name
    launchProject {
      id
      name
      launchAgents {
        id
        name
        createdAt
        heartbeatAt
        agentStatus
        stopPolling
        runQueues
        hostname
      }
      runQueue(name: $queueName) {
        id
        createdAt
        createdBy
        updatedAt
        name
        access
        defaultResourceConfig {
          id
          createdAt
          updatedAt
          scope {
            __typename
            Type
            ID
          }
          resource
          config
          templateVariables {
            name
            description
            schema
          }
        }
        prioritizationMode
        executorInfo
        externalLinks
      }
    }
  }
}
    `;

/**
 * __useEntityQueueByQueueNameLiteQuery__
 *
 * To run a query within a React component, call `useEntityQueueByQueueNameLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityQueueByQueueNameLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityQueueByQueueNameLiteQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      queueName: // value for 'queueName'
 *   },
 * });
 */
export function useEntityQueueByQueueNameLiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>(EntityQueueByQueueNameLiteDocument, options);
      }
export function useEntityQueueByQueueNameLiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>(EntityQueueByQueueNameLiteDocument, options);
        }
// @ts-ignore
export function useEntityQueueByQueueNameLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>;
export function useEntityQueueByQueueNameLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityQueueByQueueNameLiteQuery | undefined, EntityQueueByQueueNameLiteQueryVariables>;
export function useEntityQueueByQueueNameLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>(EntityQueueByQueueNameLiteDocument, options);
        }
export type EntityQueueByQueueNameLiteQueryHookResult = ReturnType<typeof useEntityQueueByQueueNameLiteQuery>;
export type EntityQueueByQueueNameLiteLazyQueryHookResult = ReturnType<typeof useEntityQueueByQueueNameLiteLazyQuery>;
export type EntityQueueByQueueNameLiteSuspenseQueryHookResult = ReturnType<typeof useEntityQueueByQueueNameLiteSuspenseQuery>;
export type EntityQueueByQueueNameLiteQueryResult = ApolloReactCommon.QueryResult<EntityQueueByQueueNameLiteQuery, EntityQueueByQueueNameLiteQueryVariables>;
export const AllQueuesLiteDocument = gql`
    query AllQueuesLite {
  viewer {
    id
    entity
    teams {
      edges {
        node {
          id
          name
          organizationId
          launchProject {
            id
            name
            launchAgents {
              id
              name
              createdAt
              heartbeatAt
              agentStatus
              stopPolling
              runQueues
              hostname
            }
            runQueues {
              id
              createdAt
              createdBy
              updatedAt
              name
              access
              prioritizationMode
              executorInfo
              externalLinks
              defaultResourceConfig {
                id
                createdAt
                updatedAt
                scope {
                  __typename
                  Type
                  ID
                }
                resource
                config
                templateVariables {
                  name
                  description
                  schema
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAllQueuesLiteQuery__
 *
 * To run a query within a React component, call `useAllQueuesLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllQueuesLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllQueuesLiteQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllQueuesLiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>(AllQueuesLiteDocument, options);
      }
export function useAllQueuesLiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>(AllQueuesLiteDocument, options);
        }
// @ts-ignore
export function useAllQueuesLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>;
export function useAllQueuesLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllQueuesLiteQuery | undefined, AllQueuesLiteQueryVariables>;
export function useAllQueuesLiteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>(AllQueuesLiteDocument, options);
        }
export type AllQueuesLiteQueryHookResult = ReturnType<typeof useAllQueuesLiteQuery>;
export type AllQueuesLiteLazyQueryHookResult = ReturnType<typeof useAllQueuesLiteLazyQuery>;
export type AllQueuesLiteSuspenseQueryHookResult = ReturnType<typeof useAllQueuesLiteSuspenseQuery>;
export type AllQueuesLiteQueryResult = ApolloReactCommon.QueryResult<AllQueuesLiteQuery, AllQueuesLiteQueryVariables>;
export const RunsInformationDocument = gql`
    query RunsInformation($projectName: String!, $entityName: String, $filters: JSONString) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(filters: $filters) {
      edges {
        node {
          id
          name
          displayName
          state
          createdAt
          heartbeatAt
        }
      }
    }
  }
}
    `;

/**
 * __useRunsInformationQuery__
 *
 * To run a query within a React component, call `useRunsInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsInformationQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRunsInformationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsInformationQuery, RunsInformationQueryVariables> & ({ variables: RunsInformationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsInformationQuery, RunsInformationQueryVariables>(RunsInformationDocument, options);
      }
export function useRunsInformationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsInformationQuery, RunsInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsInformationQuery, RunsInformationQueryVariables>(RunsInformationDocument, options);
        }
// @ts-ignore
export function useRunsInformationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsInformationQuery, RunsInformationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsInformationQuery, RunsInformationQueryVariables>;
export function useRunsInformationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsInformationQuery, RunsInformationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsInformationQuery | undefined, RunsInformationQueryVariables>;
export function useRunsInformationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsInformationQuery, RunsInformationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsInformationQuery, RunsInformationQueryVariables>(RunsInformationDocument, options);
        }
export type RunsInformationQueryHookResult = ReturnType<typeof useRunsInformationQuery>;
export type RunsInformationLazyQueryHookResult = ReturnType<typeof useRunsInformationLazyQuery>;
export type RunsInformationSuspenseQueryHookResult = ReturnType<typeof useRunsInformationSuspenseQuery>;
export type RunsInformationQueryResult = ApolloReactCommon.QueryResult<RunsInformationQuery, RunsInformationQueryVariables>;
export const FetchCodeArtifactFilesDocument = gql`
    query FetchCodeArtifactFiles($artifactID: ID!) {
  artifact(id: $artifactID) {
    id
    files {
      edges {
        node {
          id
          name
          displayName
          mimetype
          sizeBytes
          url
        }
      }
    }
  }
}
    `;

/**
 * __useFetchCodeArtifactFilesQuery__
 *
 * To run a query within a React component, call `useFetchCodeArtifactFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCodeArtifactFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCodeArtifactFilesQuery({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *   },
 * });
 */
export function useFetchCodeArtifactFilesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables> & ({ variables: FetchCodeArtifactFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables>(FetchCodeArtifactFilesDocument, options);
      }
export function useFetchCodeArtifactFilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables>(FetchCodeArtifactFilesDocument, options);
        }
// @ts-ignore
export function useFetchCodeArtifactFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables>;
export function useFetchCodeArtifactFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchCodeArtifactFilesQuery | undefined, FetchCodeArtifactFilesQueryVariables>;
export function useFetchCodeArtifactFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables>(FetchCodeArtifactFilesDocument, options);
        }
export type FetchCodeArtifactFilesQueryHookResult = ReturnType<typeof useFetchCodeArtifactFilesQuery>;
export type FetchCodeArtifactFilesLazyQueryHookResult = ReturnType<typeof useFetchCodeArtifactFilesLazyQuery>;
export type FetchCodeArtifactFilesSuspenseQueryHookResult = ReturnType<typeof useFetchCodeArtifactFilesSuspenseQuery>;
export type FetchCodeArtifactFilesQueryResult = ApolloReactCommon.QueryResult<FetchCodeArtifactFilesQuery, FetchCodeArtifactFilesQueryVariables>;
export const FetchAgentDetailsDocument = gql`
    query FetchAgentDetails($agentId: ID!) {
  launchAgent(id: $agentId) {
    id
    name
    createdAt
    updatedAt
    heartbeatAt
    runQueues
    hostname
    agentStatus
    stopPolling
    agentConfig
    version
  }
}
    `;

/**
 * __useFetchAgentDetailsQuery__
 *
 * To run a query within a React component, call `useFetchAgentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAgentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAgentDetailsQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useFetchAgentDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables> & ({ variables: FetchAgentDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables>(FetchAgentDetailsDocument, options);
      }
export function useFetchAgentDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables>(FetchAgentDetailsDocument, options);
        }
// @ts-ignore
export function useFetchAgentDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables>;
export function useFetchAgentDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchAgentDetailsQuery | undefined, FetchAgentDetailsQueryVariables>;
export function useFetchAgentDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables>(FetchAgentDetailsDocument, options);
        }
export type FetchAgentDetailsQueryHookResult = ReturnType<typeof useFetchAgentDetailsQuery>;
export type FetchAgentDetailsLazyQueryHookResult = ReturnType<typeof useFetchAgentDetailsLazyQuery>;
export type FetchAgentDetailsSuspenseQueryHookResult = ReturnType<typeof useFetchAgentDetailsSuspenseQuery>;
export type FetchAgentDetailsQueryResult = ApolloReactCommon.QueryResult<FetchAgentDetailsQuery, FetchAgentDetailsQueryVariables>;
export const EntityAgentsDocument = gql`
    query EntityAgents($entityName: String!) {
  entity(name: $entityName) {
    id
    name
    launchProject {
      id
      name
      launchAgents {
        id
        name
        createdAt
        heartbeatAt
        agentStatus
        stopPolling
        runQueues
        hostname
      }
    }
  }
}
    `;

/**
 * __useEntityAgentsQuery__
 *
 * To run a query within a React component, call `useEntityAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityAgentsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityAgentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityAgentsQuery, EntityAgentsQueryVariables> & ({ variables: EntityAgentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityAgentsQuery, EntityAgentsQueryVariables>(EntityAgentsDocument, options);
      }
export function useEntityAgentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityAgentsQuery, EntityAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityAgentsQuery, EntityAgentsQueryVariables>(EntityAgentsDocument, options);
        }
// @ts-ignore
export function useEntityAgentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityAgentsQuery, EntityAgentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityAgentsQuery, EntityAgentsQueryVariables>;
export function useEntityAgentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityAgentsQuery, EntityAgentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityAgentsQuery | undefined, EntityAgentsQueryVariables>;
export function useEntityAgentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityAgentsQuery, EntityAgentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityAgentsQuery, EntityAgentsQueryVariables>(EntityAgentsDocument, options);
        }
export type EntityAgentsQueryHookResult = ReturnType<typeof useEntityAgentsQuery>;
export type EntityAgentsLazyQueryHookResult = ReturnType<typeof useEntityAgentsLazyQuery>;
export type EntityAgentsSuspenseQueryHookResult = ReturnType<typeof useEntityAgentsSuspenseQuery>;
export type EntityAgentsQueryResult = ApolloReactCommon.QueryResult<EntityAgentsQuery, EntityAgentsQueryVariables>;
export const FetchRunOutputLogDocument = gql`
    query FetchRunOutputLog($entityName: String!, $projectName: String!, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      logLineCount
      outputLogFile: files(first: 1, names: ["output.log"]) {
        edges {
          node {
            id
            name
            md5
            sizeBytes
            directUrl
            url(upload: false)
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchRunOutputLogQuery__
 *
 * To run a query within a React component, call `useFetchRunOutputLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRunOutputLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRunOutputLogQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useFetchRunOutputLogQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables> & ({ variables: FetchRunOutputLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables>(FetchRunOutputLogDocument, options);
      }
export function useFetchRunOutputLogLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables>(FetchRunOutputLogDocument, options);
        }
// @ts-ignore
export function useFetchRunOutputLogSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables>;
export function useFetchRunOutputLogSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchRunOutputLogQuery | undefined, FetchRunOutputLogQueryVariables>;
export function useFetchRunOutputLogSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables>(FetchRunOutputLogDocument, options);
        }
export type FetchRunOutputLogQueryHookResult = ReturnType<typeof useFetchRunOutputLogQuery>;
export type FetchRunOutputLogLazyQueryHookResult = ReturnType<typeof useFetchRunOutputLogLazyQuery>;
export type FetchRunOutputLogSuspenseQueryHookResult = ReturnType<typeof useFetchRunOutputLogSuspenseQuery>;
export type FetchRunOutputLogQueryResult = ApolloReactCommon.QueryResult<FetchRunOutputLogQuery, FetchRunOutputLogQueryVariables>;
export const QueueByIdDocument = gql`
    query QueueByID($entityName: String!, $queueId: ID!, $first: Int, $after: String) {
  project(name: "model-registry", entityName: $entityName) {
    id
    name
    launchAgents {
      id
      name
      createdAt
      heartbeatAt
      agentStatus
      stopPolling
      runQueues
      hostname
    }
    runQueue(id: $queueId) {
      id
      createdAt
      name
      defaultResourceConfig {
        id
        createdAt
        resource
        config
        templateVariables {
          name
          description
          schema
        }
      }
      prioritizationMode
      executorInfo
      externalLinks
      runQueueItems(first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            ...RunQueueItemFragment
            error {
              message
              stage
              filePaths
            }
            warnings {
              message
              stage
              filePaths
            }
          }
        }
      }
    }
  }
}
    ${RunQueueItemFragmentFragmentDoc}`;

/**
 * __useQueueByIdQuery__
 *
 * To run a query within a React component, call `useQueueByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueueByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueueByIdQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      queueId: // value for 'queueId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useQueueByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<QueueByIdQuery, QueueByIdQueryVariables> & ({ variables: QueueByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QueueByIdQuery, QueueByIdQueryVariables>(QueueByIdDocument, options);
      }
export function useQueueByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QueueByIdQuery, QueueByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QueueByIdQuery, QueueByIdQueryVariables>(QueueByIdDocument, options);
        }
// @ts-ignore
export function useQueueByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<QueueByIdQuery, QueueByIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<QueueByIdQuery, QueueByIdQueryVariables>;
export function useQueueByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QueueByIdQuery, QueueByIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<QueueByIdQuery | undefined, QueueByIdQueryVariables>;
export function useQueueByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QueueByIdQuery, QueueByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<QueueByIdQuery, QueueByIdQueryVariables>(QueueByIdDocument, options);
        }
export type QueueByIdQueryHookResult = ReturnType<typeof useQueueByIdQuery>;
export type QueueByIdLazyQueryHookResult = ReturnType<typeof useQueueByIdLazyQuery>;
export type QueueByIdSuspenseQueryHookResult = ReturnType<typeof useQueueByIdSuspenseQuery>;
export type QueueByIdQueryResult = ApolloReactCommon.QueryResult<QueueByIdQuery, QueueByIdQueryVariables>;
export const RunJobDocument = gql`
    query RunJob($entityName: String!, $projectName: String!, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      job {
        id
        artifactSequence {
          id
          name
        }
        versionIndex
      }
    }
  }
}
    `;

/**
 * __useRunJobQuery__
 *
 * To run a query within a React component, call `useRunJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunJobQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunJobQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunJobQuery, RunJobQueryVariables> & ({ variables: RunJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunJobQuery, RunJobQueryVariables>(RunJobDocument, options);
      }
export function useRunJobLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunJobQuery, RunJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunJobQuery, RunJobQueryVariables>(RunJobDocument, options);
        }
// @ts-ignore
export function useRunJobSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunJobQuery, RunJobQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunJobQuery, RunJobQueryVariables>;
export function useRunJobSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunJobQuery, RunJobQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunJobQuery | undefined, RunJobQueryVariables>;
export function useRunJobSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunJobQuery, RunJobQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunJobQuery, RunJobQueryVariables>(RunJobDocument, options);
        }
export type RunJobQueryHookResult = ReturnType<typeof useRunJobQuery>;
export type RunJobLazyQueryHookResult = ReturnType<typeof useRunJobLazyQuery>;
export type RunJobSuspenseQueryHookResult = ReturnType<typeof useRunJobSuspenseQuery>;
export type RunJobQueryResult = ApolloReactCommon.QueryResult<RunJobQuery, RunJobQueryVariables>;
export const RunFilesAndFolderWithDirectUrLsDocument = gql`
    query RunFilesAndFolderWithDirectURLs($projectName: String!, $entityName: String, $runName: String!, $maxNumFiles: Int!, $pattern: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    name
    run(name: $runName) {
      id
      name
      projectId
      files(first: $maxNumFiles, pattern: $pattern) {
        edges {
          node {
            id
            name
            directUrl
            sizeBytes
            updatedAt
            artifact {
              id
              digest
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRunFilesAndFolderWithDirectUrLsQuery__
 *
 * To run a query within a React component, call `useRunFilesAndFolderWithDirectUrLsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunFilesAndFolderWithDirectUrLsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunFilesAndFolderWithDirectUrLsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      maxNumFiles: // value for 'maxNumFiles'
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useRunFilesAndFolderWithDirectUrLsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables> & ({ variables: RunFilesAndFolderWithDirectUrLsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables>(RunFilesAndFolderWithDirectUrLsDocument, options);
      }
export function useRunFilesAndFolderWithDirectUrLsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables>(RunFilesAndFolderWithDirectUrLsDocument, options);
        }
// @ts-ignore
export function useRunFilesAndFolderWithDirectUrLsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables>;
export function useRunFilesAndFolderWithDirectUrLsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunFilesAndFolderWithDirectUrLsQuery | undefined, RunFilesAndFolderWithDirectUrLsQueryVariables>;
export function useRunFilesAndFolderWithDirectUrLsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables>(RunFilesAndFolderWithDirectUrLsDocument, options);
        }
export type RunFilesAndFolderWithDirectUrLsQueryHookResult = ReturnType<typeof useRunFilesAndFolderWithDirectUrLsQuery>;
export type RunFilesAndFolderWithDirectUrLsLazyQueryHookResult = ReturnType<typeof useRunFilesAndFolderWithDirectUrLsLazyQuery>;
export type RunFilesAndFolderWithDirectUrLsSuspenseQueryHookResult = ReturnType<typeof useRunFilesAndFolderWithDirectUrLsSuspenseQuery>;
export type RunFilesAndFolderWithDirectUrLsQueryResult = ApolloReactCommon.QueryResult<RunFilesAndFolderWithDirectUrLsQuery, RunFilesAndFolderWithDirectUrLsQueryVariables>;
export const AccountUsingLaunchDocument = gql`
    query AccountUsingLaunch($name: String!) {
  organization(name: $name) {
    id
    isLaunchActive
  }
}
    `;

/**
 * __useAccountUsingLaunchQuery__
 *
 * To run a query within a React component, call `useAccountUsingLaunchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountUsingLaunchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountUsingLaunchQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAccountUsingLaunchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables> & ({ variables: AccountUsingLaunchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables>(AccountUsingLaunchDocument, options);
      }
export function useAccountUsingLaunchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables>(AccountUsingLaunchDocument, options);
        }
// @ts-ignore
export function useAccountUsingLaunchSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables>;
export function useAccountUsingLaunchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountUsingLaunchQuery | undefined, AccountUsingLaunchQueryVariables>;
export function useAccountUsingLaunchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables>(AccountUsingLaunchDocument, options);
        }
export type AccountUsingLaunchQueryHookResult = ReturnType<typeof useAccountUsingLaunchQuery>;
export type AccountUsingLaunchLazyQueryHookResult = ReturnType<typeof useAccountUsingLaunchLazyQuery>;
export type AccountUsingLaunchSuspenseQueryHookResult = ReturnType<typeof useAccountUsingLaunchSuspenseQuery>;
export type AccountUsingLaunchQueryResult = ApolloReactCommon.QueryResult<AccountUsingLaunchQuery, AccountUsingLaunchQueryVariables>;
export const ArtifactPathEntityProjectsDocument = gql`
    query ArtifactPathEntityProjects($entityName: String!, $pattern: String) {
  entity(name: $entityName) {
    id
    name
    projects(first: 500, pattern: $pattern) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactPathEntityProjectsQuery__
 *
 * To run a query within a React component, call `useArtifactPathEntityProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactPathEntityProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactPathEntityProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useArtifactPathEntityProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables> & ({ variables: ArtifactPathEntityProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables>(ArtifactPathEntityProjectsDocument, options);
      }
export function useArtifactPathEntityProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables>(ArtifactPathEntityProjectsDocument, options);
        }
// @ts-ignore
export function useArtifactPathEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables>;
export function useArtifactPathEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactPathEntityProjectsQuery | undefined, ArtifactPathEntityProjectsQueryVariables>;
export function useArtifactPathEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables>(ArtifactPathEntityProjectsDocument, options);
        }
export type ArtifactPathEntityProjectsQueryHookResult = ReturnType<typeof useArtifactPathEntityProjectsQuery>;
export type ArtifactPathEntityProjectsLazyQueryHookResult = ReturnType<typeof useArtifactPathEntityProjectsLazyQuery>;
export type ArtifactPathEntityProjectsSuspenseQueryHookResult = ReturnType<typeof useArtifactPathEntityProjectsSuspenseQuery>;
export type ArtifactPathEntityProjectsQueryResult = ApolloReactCommon.QueryResult<ArtifactPathEntityProjectsQuery, ArtifactPathEntityProjectsQueryVariables>;
export const ArtifactPathSearchArtifactsDocument = gql`
    query ArtifactPathSearchArtifacts($entityName: String!, $projectName: String!, $limit: Int!, $searchTerm: String, $artifactsLimit: Int) {
  entity(name: $entityName) {
    id
    project(name: $projectName) {
      id
      artifactCollectionsSearch(
        limit: $limit
        searchTerm: $searchTerm
        artifactsLimit: $artifactsLimit
      ) {
        edges {
          node {
            id
            name
            artifacts {
              edges {
                node {
                  id
                  versionIndex
                  aliases {
                    id
                    alias
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useArtifactPathSearchArtifactsQuery__
 *
 * To run a query within a React component, call `useArtifactPathSearchArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArtifactPathSearchArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArtifactPathSearchArtifactsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      limit: // value for 'limit'
 *      searchTerm: // value for 'searchTerm'
 *      artifactsLimit: // value for 'artifactsLimit'
 *   },
 * });
 */
export function useArtifactPathSearchArtifactsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables> & ({ variables: ArtifactPathSearchArtifactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables>(ArtifactPathSearchArtifactsDocument, options);
      }
export function useArtifactPathSearchArtifactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables>(ArtifactPathSearchArtifactsDocument, options);
        }
// @ts-ignore
export function useArtifactPathSearchArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables>;
export function useArtifactPathSearchArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ArtifactPathSearchArtifactsQuery | undefined, ArtifactPathSearchArtifactsQueryVariables>;
export function useArtifactPathSearchArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables>(ArtifactPathSearchArtifactsDocument, options);
        }
export type ArtifactPathSearchArtifactsQueryHookResult = ReturnType<typeof useArtifactPathSearchArtifactsQuery>;
export type ArtifactPathSearchArtifactsLazyQueryHookResult = ReturnType<typeof useArtifactPathSearchArtifactsLazyQuery>;
export type ArtifactPathSearchArtifactsSuspenseQueryHookResult = ReturnType<typeof useArtifactPathSearchArtifactsSuspenseQuery>;
export type ArtifactPathSearchArtifactsQueryResult = ApolloReactCommon.QueryResult<ArtifactPathSearchArtifactsQuery, ArtifactPathSearchArtifactsQueryVariables>;
export const AddPublicQueueLaunchAgentTeamConfigDocument = gql`
    mutation AddPublicQueueLaunchAgentTeamConfig($input: AddPublicQueueLaunchAgentTeamConfigInput!) {
  addPublicQueueLaunchAgentTeamConfig(input: $input) {
    success
    clientMutationID
  }
}
    `;
export type AddPublicQueueLaunchAgentTeamConfigMutationFn = ApolloReactCommon.MutationFunction<AddPublicQueueLaunchAgentTeamConfigMutation, AddPublicQueueLaunchAgentTeamConfigMutationVariables>;

/**
 * __useAddPublicQueueLaunchAgentTeamConfigMutation__
 *
 * To run a mutation, you first call `useAddPublicQueueLaunchAgentTeamConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPublicQueueLaunchAgentTeamConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPublicQueueLaunchAgentTeamConfigMutation, { data, loading, error }] = useAddPublicQueueLaunchAgentTeamConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPublicQueueLaunchAgentTeamConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddPublicQueueLaunchAgentTeamConfigMutation, AddPublicQueueLaunchAgentTeamConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddPublicQueueLaunchAgentTeamConfigMutation, AddPublicQueueLaunchAgentTeamConfigMutationVariables>(AddPublicQueueLaunchAgentTeamConfigDocument, options);
      }
export type AddPublicQueueLaunchAgentTeamConfigMutationHookResult = ReturnType<typeof useAddPublicQueueLaunchAgentTeamConfigMutation>;
export type AddPublicQueueLaunchAgentTeamConfigMutationResult = ApolloReactCommon.MutationResult<AddPublicQueueLaunchAgentTeamConfigMutation>;
export type AddPublicQueueLaunchAgentTeamConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<AddPublicQueueLaunchAgentTeamConfigMutation, AddPublicQueueLaunchAgentTeamConfigMutationVariables>;
export const DeletePublicQueueLaunchAgentTeamConfigDocument = gql`
    mutation DeletePublicQueueLaunchAgentTeamConfig($input: DeletePublicQueueLaunchAgentTeamConfigInput!) {
  deletePublicQueueLaunchAgentTeamConfig(input: $input) {
    success
    clientMutationID
  }
}
    `;
export type DeletePublicQueueLaunchAgentTeamConfigMutationFn = ApolloReactCommon.MutationFunction<DeletePublicQueueLaunchAgentTeamConfigMutation, DeletePublicQueueLaunchAgentTeamConfigMutationVariables>;

/**
 * __useDeletePublicQueueLaunchAgentTeamConfigMutation__
 *
 * To run a mutation, you first call `useDeletePublicQueueLaunchAgentTeamConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePublicQueueLaunchAgentTeamConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePublicQueueLaunchAgentTeamConfigMutation, { data, loading, error }] = useDeletePublicQueueLaunchAgentTeamConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePublicQueueLaunchAgentTeamConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePublicQueueLaunchAgentTeamConfigMutation, DeletePublicQueueLaunchAgentTeamConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeletePublicQueueLaunchAgentTeamConfigMutation, DeletePublicQueueLaunchAgentTeamConfigMutationVariables>(DeletePublicQueueLaunchAgentTeamConfigDocument, options);
      }
export type DeletePublicQueueLaunchAgentTeamConfigMutationHookResult = ReturnType<typeof useDeletePublicQueueLaunchAgentTeamConfigMutation>;
export type DeletePublicQueueLaunchAgentTeamConfigMutationResult = ApolloReactCommon.MutationResult<DeletePublicQueueLaunchAgentTeamConfigMutation>;
export type DeletePublicQueueLaunchAgentTeamConfigMutationOptions = ApolloReactCommon.BaseMutationOptions<DeletePublicQueueLaunchAgentTeamConfigMutation, DeletePublicQueueLaunchAgentTeamConfigMutationVariables>;
export const ViewerTeamsProjectsDocument = gql`
    query ViewerTeamsProjects($pattern: String) {
  viewer {
    id
    teams {
      edges {
        node {
          id
          name
          projects(first: 100, pattern: $pattern) {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useViewerTeamsProjectsQuery__
 *
 * To run a query within a React component, call `useViewerTeamsProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerTeamsProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerTeamsProjectsQuery({
 *   variables: {
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useViewerTeamsProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>(ViewerTeamsProjectsDocument, options);
      }
export function useViewerTeamsProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>(ViewerTeamsProjectsDocument, options);
        }
// @ts-ignore
export function useViewerTeamsProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>;
export function useViewerTeamsProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerTeamsProjectsQuery | undefined, ViewerTeamsProjectsQueryVariables>;
export function useViewerTeamsProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>(ViewerTeamsProjectsDocument, options);
        }
export type ViewerTeamsProjectsQueryHookResult = ReturnType<typeof useViewerTeamsProjectsQuery>;
export type ViewerTeamsProjectsLazyQueryHookResult = ReturnType<typeof useViewerTeamsProjectsLazyQuery>;
export type ViewerTeamsProjectsSuspenseQueryHookResult = ReturnType<typeof useViewerTeamsProjectsSuspenseQuery>;
export type ViewerTeamsProjectsQueryResult = ApolloReactCommon.QueryResult<ViewerTeamsProjectsQuery, ViewerTeamsProjectsQueryVariables>;
export const FetchProjectRunsForConfigDocument = gql`
    query FetchProjectRunsForConfig($entityName: String!, $projectName: String!, $first: Int) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    runs(first: $first, order: "-createdAt") {
      edges {
        node {
          id
          name
          displayName
          createdAt
          state
          defaultColorIndex
          config
          runInfo {
            args
          }
          user {
            id
            name
            username
            photoUrl
          }
          job {
            id
            description
            labels
            versionIndex
            aliases {
              id
              alias
            }
            artifactSequence {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchProjectRunsForConfigQuery__
 *
 * To run a query within a React component, call `useFetchProjectRunsForConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProjectRunsForConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchProjectRunsForConfigQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFetchProjectRunsForConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables> & ({ variables: FetchProjectRunsForConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables>(FetchProjectRunsForConfigDocument, options);
      }
export function useFetchProjectRunsForConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables>(FetchProjectRunsForConfigDocument, options);
        }
// @ts-ignore
export function useFetchProjectRunsForConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables>;
export function useFetchProjectRunsForConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchProjectRunsForConfigQuery | undefined, FetchProjectRunsForConfigQueryVariables>;
export function useFetchProjectRunsForConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables>(FetchProjectRunsForConfigDocument, options);
        }
export type FetchProjectRunsForConfigQueryHookResult = ReturnType<typeof useFetchProjectRunsForConfigQuery>;
export type FetchProjectRunsForConfigLazyQueryHookResult = ReturnType<typeof useFetchProjectRunsForConfigLazyQuery>;
export type FetchProjectRunsForConfigSuspenseQueryHookResult = ReturnType<typeof useFetchProjectRunsForConfigSuspenseQuery>;
export type FetchProjectRunsForConfigQueryResult = ApolloReactCommon.QueryResult<FetchProjectRunsForConfigQuery, FetchProjectRunsForConfigQueryVariables>;
export const MessageOfTheDayDocument = gql`
    query MessageOfTheDay {
  serverInfo {
    messageOfTheDay
  }
}
    `;

/**
 * __useMessageOfTheDayQuery__
 *
 * To run a query within a React component, call `useMessageOfTheDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageOfTheDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageOfTheDayQuery({
 *   variables: {
 *   },
 * });
 */
export function useMessageOfTheDayQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>(MessageOfTheDayDocument, options);
      }
export function useMessageOfTheDayLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>(MessageOfTheDayDocument, options);
        }
// @ts-ignore
export function useMessageOfTheDaySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>;
export function useMessageOfTheDaySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MessageOfTheDayQuery | undefined, MessageOfTheDayQueryVariables>;
export function useMessageOfTheDaySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>(MessageOfTheDayDocument, options);
        }
export type MessageOfTheDayQueryHookResult = ReturnType<typeof useMessageOfTheDayQuery>;
export type MessageOfTheDayLazyQueryHookResult = ReturnType<typeof useMessageOfTheDayLazyQuery>;
export type MessageOfTheDaySuspenseQueryHookResult = ReturnType<typeof useMessageOfTheDaySuspenseQuery>;
export type MessageOfTheDayQueryResult = ApolloReactCommon.QueryResult<MessageOfTheDayQuery, MessageOfTheDayQueryVariables>;
export const MoveViewDocument = gql`
    mutation moveView($id: ID!, $entityName: String!, $projectName: String!, $clientMutationId: String) {
  moveView(
    input: {id: $id, entityName: $entityName, projectName: $projectName, clientMutationId: $clientMutationId}
  ) {
    success
    clientMutationId
  }
}
    `;
export type MoveViewMutationFn = ApolloReactCommon.MutationFunction<MoveViewMutation, MoveViewMutationVariables>;

/**
 * __useMoveViewMutation__
 *
 * To run a mutation, you first call `useMoveViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveViewMutation, { data, loading, error }] = useMoveViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useMoveViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoveViewMutation, MoveViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MoveViewMutation, MoveViewMutationVariables>(MoveViewDocument, options);
      }
export type MoveViewMutationHookResult = ReturnType<typeof useMoveViewMutation>;
export type MoveViewMutationResult = ApolloReactCommon.MutationResult<MoveViewMutation>;
export type MoveViewMutationOptions = ApolloReactCommon.BaseMutationOptions<MoveViewMutation, MoveViewMutationVariables>;
export const MultiRunWorkspaceDocument = gql`
    query MultiRunWorkspace($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    readOnly
  }
}
    `;

/**
 * __useMultiRunWorkspaceQuery__
 *
 * To run a query within a React component, call `useMultiRunWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMultiRunWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMultiRunWorkspaceQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useMultiRunWorkspaceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables> & ({ variables: MultiRunWorkspaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables>(MultiRunWorkspaceDocument, options);
      }
export function useMultiRunWorkspaceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables>(MultiRunWorkspaceDocument, options);
        }
// @ts-ignore
export function useMultiRunWorkspaceSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables>;
export function useMultiRunWorkspaceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MultiRunWorkspaceQuery | undefined, MultiRunWorkspaceQueryVariables>;
export function useMultiRunWorkspaceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables>(MultiRunWorkspaceDocument, options);
        }
export type MultiRunWorkspaceQueryHookResult = ReturnType<typeof useMultiRunWorkspaceQuery>;
export type MultiRunWorkspaceLazyQueryHookResult = ReturnType<typeof useMultiRunWorkspaceLazyQuery>;
export type MultiRunWorkspaceSuspenseQueryHookResult = ReturnType<typeof useMultiRunWorkspaceSuspenseQuery>;
export type MultiRunWorkspaceQueryResult = ApolloReactCommon.QueryResult<MultiRunWorkspaceQuery, MultiRunWorkspaceQueryVariables>;
export const NwEntityPermissionDocument = gql`
    query NwEntityPermission($entityName: String) {
  entity(name: $entityName) {
    id
    isTeam
    settings {
      hidden
    }
  }
}
    `;

/**
 * __useNwEntityPermissionQuery__
 *
 * To run a query within a React component, call `useNwEntityPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useNwEntityPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNwEntityPermissionQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useNwEntityPermissionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>(NwEntityPermissionDocument, options);
      }
export function useNwEntityPermissionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>(NwEntityPermissionDocument, options);
        }
// @ts-ignore
export function useNwEntityPermissionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>;
export function useNwEntityPermissionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NwEntityPermissionQuery | undefined, NwEntityPermissionQueryVariables>;
export function useNwEntityPermissionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>(NwEntityPermissionDocument, options);
        }
export type NwEntityPermissionQueryHookResult = ReturnType<typeof useNwEntityPermissionQuery>;
export type NwEntityPermissionLazyQueryHookResult = ReturnType<typeof useNwEntityPermissionLazyQuery>;
export type NwEntityPermissionSuspenseQueryHookResult = ReturnType<typeof useNwEntityPermissionSuspenseQuery>;
export type NwEntityPermissionQueryResult = ApolloReactCommon.QueryResult<NwEntityPermissionQuery, NwEntityPermissionQueryVariables>;
export const NwProjectPermissionDocument = gql`
    query NwProjectPermission($projectName: String!, $entityName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    access
    user {
      id
      username
    }
    members {
      id
      username
    }
  }
}
    `;

/**
 * __useNwProjectPermissionQuery__
 *
 * To run a query within a React component, call `useNwProjectPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useNwProjectPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNwProjectPermissionQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useNwProjectPermissionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NwProjectPermissionQuery, NwProjectPermissionQueryVariables> & ({ variables: NwProjectPermissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NwProjectPermissionQuery, NwProjectPermissionQueryVariables>(NwProjectPermissionDocument, options);
      }
export function useNwProjectPermissionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NwProjectPermissionQuery, NwProjectPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NwProjectPermissionQuery, NwProjectPermissionQueryVariables>(NwProjectPermissionDocument, options);
        }
// @ts-ignore
export function useNwProjectPermissionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NwProjectPermissionQuery, NwProjectPermissionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NwProjectPermissionQuery, NwProjectPermissionQueryVariables>;
export function useNwProjectPermissionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NwProjectPermissionQuery, NwProjectPermissionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NwProjectPermissionQuery | undefined, NwProjectPermissionQueryVariables>;
export function useNwProjectPermissionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NwProjectPermissionQuery, NwProjectPermissionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NwProjectPermissionQuery, NwProjectPermissionQueryVariables>(NwProjectPermissionDocument, options);
        }
export type NwProjectPermissionQueryHookResult = ReturnType<typeof useNwProjectPermissionQuery>;
export type NwProjectPermissionLazyQueryHookResult = ReturnType<typeof useNwProjectPermissionLazyQuery>;
export type NwProjectPermissionSuspenseQueryHookResult = ReturnType<typeof useNwProjectPermissionSuspenseQuery>;
export type NwProjectPermissionQueryResult = ApolloReactCommon.QueryResult<NwProjectPermissionQuery, NwProjectPermissionQueryVariables>;
export const OrgAdminsDocument = gql`
    query OrgAdmins($orgName: String) {
  organization(name: $orgName) {
    id
    billingUser {
      id
      username
    }
    members {
      id
      user {
        id
        username
      }
      admin
    }
  }
}
    `;

/**
 * __useOrgAdminsQuery__
 *
 * To run a query within a React component, call `useOrgAdminsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgAdminsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgAdminsQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrgAdminsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrgAdminsQuery, OrgAdminsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrgAdminsQuery, OrgAdminsQueryVariables>(OrgAdminsDocument, options);
      }
export function useOrgAdminsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrgAdminsQuery, OrgAdminsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrgAdminsQuery, OrgAdminsQueryVariables>(OrgAdminsDocument, options);
        }
// @ts-ignore
export function useOrgAdminsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrgAdminsQuery, OrgAdminsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgAdminsQuery, OrgAdminsQueryVariables>;
export function useOrgAdminsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgAdminsQuery, OrgAdminsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrgAdminsQuery | undefined, OrgAdminsQueryVariables>;
export function useOrgAdminsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrgAdminsQuery, OrgAdminsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrgAdminsQuery, OrgAdminsQueryVariables>(OrgAdminsDocument, options);
        }
export type OrgAdminsQueryHookResult = ReturnType<typeof useOrgAdminsQuery>;
export type OrgAdminsLazyQueryHookResult = ReturnType<typeof useOrgAdminsLazyQuery>;
export type OrgAdminsSuspenseQueryHookResult = ReturnType<typeof useOrgAdminsSuspenseQuery>;
export type OrgAdminsQueryResult = ApolloReactCommon.QueryResult<OrgAdminsQuery, OrgAdminsQueryVariables>;
export const OrganizationTagNamesDocument = gql`
    query OrganizationTagNames($orgName: String!, $filters: JSONString) {
  organization(name: $orgName) {
    id
    tagNames(filters: $filters) {
      edges {
        node
      }
    }
  }
}
    `;

/**
 * __useOrganizationTagNamesQuery__
 *
 * To run a query within a React component, call `useOrganizationTagNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationTagNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationTagNamesQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useOrganizationTagNamesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationTagNamesQuery, OrganizationTagNamesQueryVariables> & ({ variables: OrganizationTagNamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationTagNamesQuery, OrganizationTagNamesQueryVariables>(OrganizationTagNamesDocument, options);
      }
export function useOrganizationTagNamesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationTagNamesQuery, OrganizationTagNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationTagNamesQuery, OrganizationTagNamesQueryVariables>(OrganizationTagNamesDocument, options);
        }
// @ts-ignore
export function useOrganizationTagNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTagNamesQuery, OrganizationTagNamesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationTagNamesQuery, OrganizationTagNamesQueryVariables>;
export function useOrganizationTagNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTagNamesQuery, OrganizationTagNamesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationTagNamesQuery | undefined, OrganizationTagNamesQueryVariables>;
export function useOrganizationTagNamesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationTagNamesQuery, OrganizationTagNamesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationTagNamesQuery, OrganizationTagNamesQueryVariables>(OrganizationTagNamesDocument, options);
        }
export type OrganizationTagNamesQueryHookResult = ReturnType<typeof useOrganizationTagNamesQuery>;
export type OrganizationTagNamesLazyQueryHookResult = ReturnType<typeof useOrganizationTagNamesLazyQuery>;
export type OrganizationTagNamesSuspenseQueryHookResult = ReturnType<typeof useOrganizationTagNamesSuspenseQuery>;
export type OrganizationTagNamesQueryResult = ApolloReactCommon.QueryResult<OrganizationTagNamesQuery, OrganizationTagNamesQueryVariables>;
export const ParameterImportanceDocument = gql`
    query ParameterImportance($projectName: String!, $entityName: String, $limit: Int!, $targetName: String!, $filters: JSONString, $parameters: [String!], $runParameters: [String!], $sweepName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    parameterImportance(
      limit: $limit
      filters: $filters
      target: $targetName
      parameters: $parameters
      runParameters: $runParameters
      sweepName: $sweepName
    )
  }
}
    `;

/**
 * __useParameterImportanceQuery__
 *
 * To run a query within a React component, call `useParameterImportanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useParameterImportanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParameterImportanceQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      limit: // value for 'limit'
 *      targetName: // value for 'targetName'
 *      filters: // value for 'filters'
 *      parameters: // value for 'parameters'
 *      runParameters: // value for 'runParameters'
 *      sweepName: // value for 'sweepName'
 *   },
 * });
 */
export function useParameterImportanceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ParameterImportanceQuery, ParameterImportanceQueryVariables> & ({ variables: ParameterImportanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ParameterImportanceQuery, ParameterImportanceQueryVariables>(ParameterImportanceDocument, options);
      }
export function useParameterImportanceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ParameterImportanceQuery, ParameterImportanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ParameterImportanceQuery, ParameterImportanceQueryVariables>(ParameterImportanceDocument, options);
        }
// @ts-ignore
export function useParameterImportanceSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ParameterImportanceQuery, ParameterImportanceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ParameterImportanceQuery, ParameterImportanceQueryVariables>;
export function useParameterImportanceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ParameterImportanceQuery, ParameterImportanceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ParameterImportanceQuery | undefined, ParameterImportanceQueryVariables>;
export function useParameterImportanceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ParameterImportanceQuery, ParameterImportanceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ParameterImportanceQuery, ParameterImportanceQueryVariables>(ParameterImportanceDocument, options);
        }
export type ParameterImportanceQueryHookResult = ReturnType<typeof useParameterImportanceQuery>;
export type ParameterImportanceLazyQueryHookResult = ReturnType<typeof useParameterImportanceLazyQuery>;
export type ParameterImportanceSuspenseQueryHookResult = ReturnType<typeof useParameterImportanceSuspenseQuery>;
export type ParameterImportanceQueryResult = ApolloReactCommon.QueryResult<ParameterImportanceQuery, ParameterImportanceQueryVariables>;
export const ProjectArtifactCollectionsDocument = gql`
    query ProjectArtifactCollections($projectName: String!, $entityName: String!, $collectionTypes: [ArtifactCollectionType!]) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactTypes {
      edges {
        node {
          id
          name
          artifactCollections(order: "-createdAt", collectionTypes: $collectionTypes) {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProjectArtifactCollectionsQuery__
 *
 * To run a query within a React component, call `useProjectArtifactCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectArtifactCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectArtifactCollectionsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      collectionTypes: // value for 'collectionTypes'
 *   },
 * });
 */
export function useProjectArtifactCollectionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables> & ({ variables: ProjectArtifactCollectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables>(ProjectArtifactCollectionsDocument, options);
      }
export function useProjectArtifactCollectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables>(ProjectArtifactCollectionsDocument, options);
        }
// @ts-ignore
export function useProjectArtifactCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables>;
export function useProjectArtifactCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectArtifactCollectionsQuery | undefined, ProjectArtifactCollectionsQueryVariables>;
export function useProjectArtifactCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables>(ProjectArtifactCollectionsDocument, options);
        }
export type ProjectArtifactCollectionsQueryHookResult = ReturnType<typeof useProjectArtifactCollectionsQuery>;
export type ProjectArtifactCollectionsLazyQueryHookResult = ReturnType<typeof useProjectArtifactCollectionsLazyQuery>;
export type ProjectArtifactCollectionsSuspenseQueryHookResult = ReturnType<typeof useProjectArtifactCollectionsSuspenseQuery>;
export type ProjectArtifactCollectionsQueryResult = ApolloReactCommon.QueryResult<ProjectArtifactCollectionsQuery, ProjectArtifactCollectionsQueryVariables>;
export const ProjectFieldsDocument = gql`
    query ProjectFields($projectName: String!, $entityName: String!, $types: [String!]!, $columns: [String!]!, $pattern: String, $count: Int!, $cursor: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    fields(
      types: $types
      columns: $columns
      pattern: $pattern
      first: $count
      after: $cursor
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          path
          type
        }
      }
    }
  }
}
    `;

/**
 * __useProjectFieldsQuery__
 *
 * To run a query within a React component, call `useProjectFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFieldsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      types: // value for 'types'
 *      columns: // value for 'columns'
 *      pattern: // value for 'pattern'
 *      count: // value for 'count'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useProjectFieldsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectFieldsQuery, ProjectFieldsQueryVariables> & ({ variables: ProjectFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectFieldsQuery, ProjectFieldsQueryVariables>(ProjectFieldsDocument, options);
      }
export function useProjectFieldsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectFieldsQuery, ProjectFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectFieldsQuery, ProjectFieldsQueryVariables>(ProjectFieldsDocument, options);
        }
// @ts-ignore
export function useProjectFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectFieldsQuery, ProjectFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectFieldsQuery, ProjectFieldsQueryVariables>;
export function useProjectFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectFieldsQuery, ProjectFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectFieldsQuery | undefined, ProjectFieldsQueryVariables>;
export function useProjectFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectFieldsQuery, ProjectFieldsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectFieldsQuery, ProjectFieldsQueryVariables>(ProjectFieldsDocument, options);
        }
export type ProjectFieldsQueryHookResult = ReturnType<typeof useProjectFieldsQuery>;
export type ProjectFieldsLazyQueryHookResult = ReturnType<typeof useProjectFieldsLazyQuery>;
export type ProjectFieldsSuspenseQueryHookResult = ReturnType<typeof useProjectFieldsSuspenseQuery>;
export type ProjectFieldsQueryResult = ApolloReactCommon.QueryResult<ProjectFieldsQuery, ProjectFieldsQueryVariables>;
export const ProjectTags2Document = gql`
    query ProjectTags2($projectName: String!, $entityName: String!, $pattern: String, $before: String, $after: String, $first: Int = 100, $last: Int) {
  project(name: $projectName, entityName: $entityName) {
    id
    runTags(
      pattern: $pattern
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          name
          id
        }
      }
    }
  }
}
    `;

/**
 * __useProjectTags2Query__
 *
 * To run a query within a React component, call `useProjectTags2Query` and pass it any options that fit your needs.
 * When your component renders, `useProjectTags2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTags2Query({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      pattern: // value for 'pattern'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useProjectTags2Query(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectTags2Query, ProjectTags2QueryVariables> & ({ variables: ProjectTags2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectTags2Query, ProjectTags2QueryVariables>(ProjectTags2Document, options);
      }
export function useProjectTags2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectTags2Query, ProjectTags2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectTags2Query, ProjectTags2QueryVariables>(ProjectTags2Document, options);
        }
// @ts-ignore
export function useProjectTags2SuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectTags2Query, ProjectTags2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectTags2Query, ProjectTags2QueryVariables>;
export function useProjectTags2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectTags2Query, ProjectTags2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectTags2Query | undefined, ProjectTags2QueryVariables>;
export function useProjectTags2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectTags2Query, ProjectTags2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectTags2Query, ProjectTags2QueryVariables>(ProjectTags2Document, options);
        }
export type ProjectTags2QueryHookResult = ReturnType<typeof useProjectTags2Query>;
export type ProjectTags2LazyQueryHookResult = ReturnType<typeof useProjectTags2LazyQuery>;
export type ProjectTags2SuspenseQueryHookResult = ReturnType<typeof useProjectTags2SuspenseQuery>;
export type ProjectTags2QueryResult = ApolloReactCommon.QueryResult<ProjectTags2Query, ProjectTags2QueryVariables>;
export const ProjectTagsDocument = gql`
    query ProjectTags($projectName: String!, $entityName: String, $filters: JSONString) {
  project(name: $projectName, entityName: $entityName) {
    id
    tagCounts(filters: $filters) {
      name
      count
    }
  }
}
    `;

/**
 * __useProjectTagsQuery__
 *
 * To run a query within a React component, call `useProjectTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTagsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useProjectTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectTagsQuery, ProjectTagsQueryVariables> & ({ variables: ProjectTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectTagsQuery, ProjectTagsQueryVariables>(ProjectTagsDocument, options);
      }
export function useProjectTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectTagsQuery, ProjectTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectTagsQuery, ProjectTagsQueryVariables>(ProjectTagsDocument, options);
        }
// @ts-ignore
export function useProjectTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectTagsQuery, ProjectTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectTagsQuery, ProjectTagsQueryVariables>;
export function useProjectTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectTagsQuery, ProjectTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectTagsQuery | undefined, ProjectTagsQueryVariables>;
export function useProjectTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectTagsQuery, ProjectTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectTagsQuery, ProjectTagsQueryVariables>(ProjectTagsDocument, options);
        }
export type ProjectTagsQueryHookResult = ReturnType<typeof useProjectTagsQuery>;
export type ProjectTagsLazyQueryHookResult = ReturnType<typeof useProjectTagsLazyQuery>;
export type ProjectTagsSuspenseQueryHookResult = ReturnType<typeof useProjectTagsSuspenseQuery>;
export type ProjectTagsQueryResult = ApolloReactCommon.QueryResult<ProjectTagsQuery, ProjectTagsQueryVariables>;
export const ReportPageDocument = gql`
    query ReportPage($projectName: String!, $entityName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    access
    readOnly
    entity {
      id
      name
      defaultAccess
      readOnlyAdmin
      privateOnly
      isTeam
    }
  }
}
    `;

/**
 * __useReportPageQuery__
 *
 * To run a query within a React component, call `useReportPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportPageQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useReportPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReportPageQuery, ReportPageQueryVariables> & ({ variables: ReportPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReportPageQuery, ReportPageQueryVariables>(ReportPageDocument, options);
      }
export function useReportPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReportPageQuery, ReportPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReportPageQuery, ReportPageQueryVariables>(ReportPageDocument, options);
        }
// @ts-ignore
export function useReportPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReportPageQuery, ReportPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReportPageQuery, ReportPageQueryVariables>;
export function useReportPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReportPageQuery, ReportPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReportPageQuery | undefined, ReportPageQueryVariables>;
export function useReportPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReportPageQuery, ReportPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReportPageQuery, ReportPageQueryVariables>(ReportPageDocument, options);
        }
export type ReportPageQueryHookResult = ReturnType<typeof useReportPageQuery>;
export type ReportPageLazyQueryHookResult = ReturnType<typeof useReportPageLazyQuery>;
export type ReportPageSuspenseQueryHookResult = ReturnType<typeof useReportPageSuspenseQuery>;
export type ReportPageQueryResult = ApolloReactCommon.QueryResult<ReportPageQuery, ReportPageQueryVariables>;
export const ReportTableDocument = gql`
    query ReportTable($projectName: String!, $entityName: String, $draftsOffset: Int = 0, $draftsPageSize: Int = 100, $publishedOffset: Int = 0, $publishedPageSize: Int = 100, $displayNameContains: String, $userName: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    access
    readOnly
    reportAuthors
    reportDrafts: allViews(
      viewType: "runs/draft"
      first: $draftsPageSize
      offset: $draftsOffset
      displayNameContains: $displayNameContains
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
      edges {
        node {
          id
          ...ViewFragmentMetadata
        }
      }
    }
    reports: allViews(
      viewType: "runs"
      first: $publishedPageSize
      offset: $publishedOffset
      displayNameContains: $displayNameContains
      userName: $userName
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
      edges {
        node {
          id
          ...ViewFragmentMetadata
          children {
            edges {
              node {
                id
                type
                user {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${ViewFragmentMetadataFragmentDoc}`;

/**
 * __useReportTableQuery__
 *
 * To run a query within a React component, call `useReportTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportTableQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      draftsOffset: // value for 'draftsOffset'
 *      draftsPageSize: // value for 'draftsPageSize'
 *      publishedOffset: // value for 'publishedOffset'
 *      publishedPageSize: // value for 'publishedPageSize'
 *      displayNameContains: // value for 'displayNameContains'
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useReportTableQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReportTableQuery, ReportTableQueryVariables> & ({ variables: ReportTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReportTableQuery, ReportTableQueryVariables>(ReportTableDocument, options);
      }
export function useReportTableLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReportTableQuery, ReportTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReportTableQuery, ReportTableQueryVariables>(ReportTableDocument, options);
        }
// @ts-ignore
export function useReportTableSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReportTableQuery, ReportTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReportTableQuery, ReportTableQueryVariables>;
export function useReportTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReportTableQuery, ReportTableQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReportTableQuery | undefined, ReportTableQueryVariables>;
export function useReportTableSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReportTableQuery, ReportTableQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReportTableQuery, ReportTableQueryVariables>(ReportTableDocument, options);
        }
export type ReportTableQueryHookResult = ReturnType<typeof useReportTableQuery>;
export type ReportTableLazyQueryHookResult = ReturnType<typeof useReportTableLazyQuery>;
export type ReportTableSuspenseQueryHookResult = ReturnType<typeof useReportTableSuspenseQuery>;
export type ReportTableQueryResult = ApolloReactCommon.QueryResult<ReportTableQuery, ReportTableQueryVariables>;
export const RunArtifactVersionsDocument = gql`
    query RunArtifactVersions($projectName: String!, $entityName: String!, $runName: String!, $pageSize: Int = 1000, $includeOutput: Boolean = false, $includeInput: Boolean = false, $after: String = "") {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      state
      outputArtifacts(first: $pageSize, after: $after) @include(if: $includeOutput) {
        pageInfo {
          hasNextPage
          endCursor
        }
        totalCount
        edges {
          node {
            artifactType {
              id
              name
              project {
                id
                name
                entity {
                  id
                  name
                }
              }
            }
            id
            versionIndex
            artifactSequence {
              id
              name
            }
            usedBy {
              totalCount
            }
            isLinkedToGlobalRegistry
          }
        }
      }
      inputArtifacts(first: $pageSize, after: $after) @include(if: $includeInput) {
        pageInfo {
          hasNextPage
          endCursor
        }
        totalCount
        edges {
          node {
            artifactType {
              id
              name
              project {
                id
                name
                entity {
                  id
                  name
                }
              }
            }
            id
            versionIndex
            artifactSequence {
              id
              name
              project {
                id
                name
                entity {
                  id
                  name
                }
              }
            }
            usedBy(first: 0) {
              totalCount
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRunArtifactVersionsQuery__
 *
 * To run a query within a React component, call `useRunArtifactVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunArtifactVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunArtifactVersionsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *      pageSize: // value for 'pageSize'
 *      includeOutput: // value for 'includeOutput'
 *      includeInput: // value for 'includeInput'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRunArtifactVersionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables> & ({ variables: RunArtifactVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables>(RunArtifactVersionsDocument, options);
      }
export function useRunArtifactVersionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables>(RunArtifactVersionsDocument, options);
        }
// @ts-ignore
export function useRunArtifactVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables>;
export function useRunArtifactVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunArtifactVersionsQuery | undefined, RunArtifactVersionsQueryVariables>;
export function useRunArtifactVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables>(RunArtifactVersionsDocument, options);
        }
export type RunArtifactVersionsQueryHookResult = ReturnType<typeof useRunArtifactVersionsQuery>;
export type RunArtifactVersionsLazyQueryHookResult = ReturnType<typeof useRunArtifactVersionsLazyQuery>;
export type RunArtifactVersionsSuspenseQueryHookResult = ReturnType<typeof useRunArtifactVersionsSuspenseQuery>;
export type RunArtifactVersionsQueryResult = ApolloReactCommon.QueryResult<RunArtifactVersionsQuery, RunArtifactVersionsQueryVariables>;
export const CodeFilesDocument = gql`
    query CodeFiles($projectName: String!, $entityName: String!, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      codeArtifact {
        id
        commitHash
        artifactSequence {
          id
          name
        }
      }
      config
      group
      sweep {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCodeFilesQuery__
 *
 * To run a query within a React component, call `useCodeFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCodeFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCodeFilesQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useCodeFilesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CodeFilesQuery, CodeFilesQueryVariables> & ({ variables: CodeFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CodeFilesQuery, CodeFilesQueryVariables>(CodeFilesDocument, options);
      }
export function useCodeFilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CodeFilesQuery, CodeFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CodeFilesQuery, CodeFilesQueryVariables>(CodeFilesDocument, options);
        }
// @ts-ignore
export function useCodeFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CodeFilesQuery, CodeFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CodeFilesQuery, CodeFilesQueryVariables>;
export function useCodeFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CodeFilesQuery, CodeFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CodeFilesQuery | undefined, CodeFilesQueryVariables>;
export function useCodeFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CodeFilesQuery, CodeFilesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CodeFilesQuery, CodeFilesQueryVariables>(CodeFilesDocument, options);
        }
export type CodeFilesQueryHookResult = ReturnType<typeof useCodeFilesQuery>;
export type CodeFilesLazyQueryHookResult = ReturnType<typeof useCodeFilesLazyQuery>;
export type CodeFilesSuspenseQueryHookResult = ReturnType<typeof useCodeFilesSuspenseQuery>;
export type CodeFilesQueryResult = ApolloReactCommon.QueryResult<CodeFilesQuery, CodeFilesQueryVariables>;
export const RunCodePollingDocument = gql`
    query RunCodePolling($projectName: String!, $entityName: String!, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      state
      historyKeys(format: PLAINTEXT)
    }
  }
}
    `;

/**
 * __useRunCodePollingQuery__
 *
 * To run a query within a React component, call `useRunCodePollingQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunCodePollingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunCodePollingQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunCodePollingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunCodePollingQuery, RunCodePollingQueryVariables> & ({ variables: RunCodePollingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunCodePollingQuery, RunCodePollingQueryVariables>(RunCodePollingDocument, options);
      }
export function useRunCodePollingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunCodePollingQuery, RunCodePollingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunCodePollingQuery, RunCodePollingQueryVariables>(RunCodePollingDocument, options);
        }
// @ts-ignore
export function useRunCodePollingSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunCodePollingQuery, RunCodePollingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunCodePollingQuery, RunCodePollingQueryVariables>;
export function useRunCodePollingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunCodePollingQuery, RunCodePollingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunCodePollingQuery | undefined, RunCodePollingQueryVariables>;
export function useRunCodePollingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunCodePollingQuery, RunCodePollingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunCodePollingQuery, RunCodePollingQueryVariables>(RunCodePollingDocument, options);
        }
export type RunCodePollingQueryHookResult = ReturnType<typeof useRunCodePollingQuery>;
export type RunCodePollingLazyQueryHookResult = ReturnType<typeof useRunCodePollingLazyQuery>;
export type RunCodePollingSuspenseQueryHookResult = ReturnType<typeof useRunCodePollingSuspenseQuery>;
export type RunCodePollingQueryResult = ApolloReactCommon.QueryResult<RunCodePollingQuery, RunCodePollingQueryVariables>;
export const RunsOutputArtifactsDocument = gql`
    query RunsOutputArtifacts($projectName: String!, $entityName: String!, $runNames: [String!]!, $filters: JSONString, $filenames: [String!]!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(names: $runNames) {
      edges {
        node {
          id
          name
          outputArtifacts(filters: $filters) {
            edges {
              node {
                id
                artifactType {
                  id
                  name
                }
                artifactSequenceMembership {
                  id
                  files(names: $filenames) {
                    edges {
                      node {
                        id
                        name
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRunsOutputArtifactsQuery__
 *
 * To run a query within a React component, call `useRunsOutputArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsOutputArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsOutputArtifactsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runNames: // value for 'runNames'
 *      filters: // value for 'filters'
 *      filenames: // value for 'filenames'
 *   },
 * });
 */
export function useRunsOutputArtifactsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables> & ({ variables: RunsOutputArtifactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables>(RunsOutputArtifactsDocument, options);
      }
export function useRunsOutputArtifactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables>(RunsOutputArtifactsDocument, options);
        }
// @ts-ignore
export function useRunsOutputArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables>;
export function useRunsOutputArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsOutputArtifactsQuery | undefined, RunsOutputArtifactsQueryVariables>;
export function useRunsOutputArtifactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables>(RunsOutputArtifactsDocument, options);
        }
export type RunsOutputArtifactsQueryHookResult = ReturnType<typeof useRunsOutputArtifactsQuery>;
export type RunsOutputArtifactsLazyQueryHookResult = ReturnType<typeof useRunsOutputArtifactsLazyQuery>;
export type RunsOutputArtifactsSuspenseQueryHookResult = ReturnType<typeof useRunsOutputArtifactsSuspenseQuery>;
export type RunsOutputArtifactsQueryResult = ApolloReactCommon.QueryResult<RunsOutputArtifactsQuery, RunsOutputArtifactsQueryVariables>;
export const RunByDisplayNameDocument = gql`
    query RunByDisplayName($entityName: String!, $projectName: String!, $filters: JSONString!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(first: 1, order: "-createdAt", filters: $filters) {
      edges {
        node {
          id
          name
          displayName
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useRunByDisplayNameQuery__
 *
 * To run a query within a React component, call `useRunByDisplayNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunByDisplayNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunByDisplayNameQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRunByDisplayNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunByDisplayNameQuery, RunByDisplayNameQueryVariables> & ({ variables: RunByDisplayNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunByDisplayNameQuery, RunByDisplayNameQueryVariables>(RunByDisplayNameDocument, options);
      }
export function useRunByDisplayNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunByDisplayNameQuery, RunByDisplayNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunByDisplayNameQuery, RunByDisplayNameQueryVariables>(RunByDisplayNameDocument, options);
        }
// @ts-ignore
export function useRunByDisplayNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunByDisplayNameQuery, RunByDisplayNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunByDisplayNameQuery, RunByDisplayNameQueryVariables>;
export function useRunByDisplayNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunByDisplayNameQuery, RunByDisplayNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunByDisplayNameQuery | undefined, RunByDisplayNameQueryVariables>;
export function useRunByDisplayNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunByDisplayNameQuery, RunByDisplayNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunByDisplayNameQuery, RunByDisplayNameQueryVariables>(RunByDisplayNameDocument, options);
        }
export type RunByDisplayNameQueryHookResult = ReturnType<typeof useRunByDisplayNameQuery>;
export type RunByDisplayNameLazyQueryHookResult = ReturnType<typeof useRunByDisplayNameLazyQuery>;
export type RunByDisplayNameSuspenseQueryHookResult = ReturnType<typeof useRunByDisplayNameSuspenseQuery>;
export type RunByDisplayNameQueryResult = ApolloReactCommon.QueryResult<RunByDisplayNameQuery, RunByDisplayNameQueryVariables>;
export const RunHistoryQueryDocument = gql`
    query RunHistoryQuery($entityName: String!, $projectName: String!, $runName: String!, $sampledHistorySpecs: [JSONString!]!) {
  project(entityName: $entityName, name: $projectName) {
    id
    run(name: $runName) {
      id
      sampledHistory(specs: $sampledHistorySpecs, packVersion: 1)
    }
  }
}
    `;

/**
 * __useRunHistoryQueryQuery__
 *
 * To run a query within a React component, call `useRunHistoryQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunHistoryQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunHistoryQueryQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runName: // value for 'runName'
 *      sampledHistorySpecs: // value for 'sampledHistorySpecs'
 *   },
 * });
 */
export function useRunHistoryQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunHistoryQueryQuery, RunHistoryQueryQueryVariables> & ({ variables: RunHistoryQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunHistoryQueryQuery, RunHistoryQueryQueryVariables>(RunHistoryQueryDocument, options);
      }
export function useRunHistoryQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunHistoryQueryQuery, RunHistoryQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunHistoryQueryQuery, RunHistoryQueryQueryVariables>(RunHistoryQueryDocument, options);
        }
// @ts-ignore
export function useRunHistoryQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunHistoryQueryQuery, RunHistoryQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunHistoryQueryQuery, RunHistoryQueryQueryVariables>;
export function useRunHistoryQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunHistoryQueryQuery, RunHistoryQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunHistoryQueryQuery | undefined, RunHistoryQueryQueryVariables>;
export function useRunHistoryQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunHistoryQueryQuery, RunHistoryQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunHistoryQueryQuery, RunHistoryQueryQueryVariables>(RunHistoryQueryDocument, options);
        }
export type RunHistoryQueryQueryHookResult = ReturnType<typeof useRunHistoryQueryQuery>;
export type RunHistoryQueryLazyQueryHookResult = ReturnType<typeof useRunHistoryQueryLazyQuery>;
export type RunHistoryQuerySuspenseQueryHookResult = ReturnType<typeof useRunHistoryQuerySuspenseQuery>;
export type RunHistoryQueryQueryResult = ApolloReactCommon.QueryResult<RunHistoryQueryQuery, RunHistoryQueryQueryVariables>;
export const RunInfoAndConfigDocument = gql`
    query RunInfoAndConfig($projectName: String!, $entityName: String, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      runInfo {
        program
        args
        os
        python
        colab
        executable
        codeSaved
        cpuCount
        cpuCountLogical
        gpuCount
        gpu
        git {
          remote
          commit
        }
      }
      config
    }
  }
}
    `;

/**
 * __useRunInfoAndConfigQuery__
 *
 * To run a query within a React component, call `useRunInfoAndConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunInfoAndConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunInfoAndConfigQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunInfoAndConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables> & ({ variables: RunInfoAndConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables>(RunInfoAndConfigDocument, options);
      }
export function useRunInfoAndConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables>(RunInfoAndConfigDocument, options);
        }
// @ts-ignore
export function useRunInfoAndConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables>;
export function useRunInfoAndConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunInfoAndConfigQuery | undefined, RunInfoAndConfigQueryVariables>;
export function useRunInfoAndConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables>(RunInfoAndConfigDocument, options);
        }
export type RunInfoAndConfigQueryHookResult = ReturnType<typeof useRunInfoAndConfigQuery>;
export type RunInfoAndConfigLazyQueryHookResult = ReturnType<typeof useRunInfoAndConfigLazyQuery>;
export type RunInfoAndConfigSuspenseQueryHookResult = ReturnType<typeof useRunInfoAndConfigSuspenseQuery>;
export type RunInfoAndConfigQueryResult = ApolloReactCommon.QueryResult<RunInfoAndConfigQuery, RunInfoAndConfigQueryVariables>;
export const RunInfoDocument = gql`
    query RunInfo($projectName: String!, $entityName: String, $runName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      runInfo {
        program
        args
        os
        python
        colab
        executable
        codeSaved
        cpuCount
        cpuCountLogical
        gpuCount
        gpu
        git {
          remote
          commit
        }
      }
    }
  }
}
    `;

/**
 * __useRunInfoQuery__
 *
 * To run a query within a React component, call `useRunInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunInfoQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunInfoQuery, RunInfoQueryVariables> & ({ variables: RunInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunInfoQuery, RunInfoQueryVariables>(RunInfoDocument, options);
      }
export function useRunInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunInfoQuery, RunInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunInfoQuery, RunInfoQueryVariables>(RunInfoDocument, options);
        }
// @ts-ignore
export function useRunInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunInfoQuery, RunInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunInfoQuery, RunInfoQueryVariables>;
export function useRunInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunInfoQuery, RunInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunInfoQuery | undefined, RunInfoQueryVariables>;
export function useRunInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunInfoQuery, RunInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunInfoQuery, RunInfoQueryVariables>(RunInfoDocument, options);
        }
export type RunInfoQueryHookResult = ReturnType<typeof useRunInfoQuery>;
export type RunInfoLazyQueryHookResult = ReturnType<typeof useRunInfoLazyQuery>;
export type RunInfoSuspenseQueryHookResult = ReturnType<typeof useRunInfoSuspenseQuery>;
export type RunInfoQueryResult = ApolloReactCommon.QueryResult<RunInfoQuery, RunInfoQueryVariables>;
export const RunKeysDocument = gql`
    query RunKeys($entityName: String!, $projectName: String!, $types: [String!] = ["number", "string", "boolean", "other"], $limit: Int = 1000) {
  project(name: $projectName, entityName: $entityName) {
    id
    name
    fields(
      types: $types
      columns: ["config", "summary_metrics", "system_metrics"]
      first: $limit
    ) {
      edges {
        node {
          path
        }
      }
    }
  }
}
    `;

/**
 * __useRunKeysQuery__
 *
 * To run a query within a React component, call `useRunKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunKeysQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      types: // value for 'types'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRunKeysQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunKeysQuery, RunKeysQueryVariables> & ({ variables: RunKeysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunKeysQuery, RunKeysQueryVariables>(RunKeysDocument, options);
      }
export function useRunKeysLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunKeysQuery, RunKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunKeysQuery, RunKeysQueryVariables>(RunKeysDocument, options);
        }
// @ts-ignore
export function useRunKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunKeysQuery, RunKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunKeysQuery, RunKeysQueryVariables>;
export function useRunKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunKeysQuery, RunKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunKeysQuery | undefined, RunKeysQueryVariables>;
export function useRunKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunKeysQuery, RunKeysQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunKeysQuery, RunKeysQueryVariables>(RunKeysDocument, options);
        }
export type RunKeysQueryHookResult = ReturnType<typeof useRunKeysQuery>;
export type RunKeysLazyQueryHookResult = ReturnType<typeof useRunKeysLazyQuery>;
export type RunKeysSuspenseQueryHookResult = ReturnType<typeof useRunKeysSuspenseQuery>;
export type RunKeysQueryResult = ApolloReactCommon.QueryResult<RunKeysQuery, RunKeysQueryVariables>;
export const RunSearchDocument = gql`
    query RunSearch($entityName: String!, $projectName: String!, $filters: JSONString!, $first: Int) {
  project(entityName: $entityName, name: $projectName) {
    id
    runs(first: $first, order: "-createdAt", filters: $filters) {
      edges {
        node {
          id
          name
          displayName
        }
      }
    }
  }
}
    `;

/**
 * __useRunSearchQuery__
 *
 * To run a query within a React component, call `useRunSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunSearchQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useRunSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunSearchQuery, RunSearchQueryVariables> & ({ variables: RunSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunSearchQuery, RunSearchQueryVariables>(RunSearchDocument, options);
      }
export function useRunSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunSearchQuery, RunSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunSearchQuery, RunSearchQueryVariables>(RunSearchDocument, options);
        }
// @ts-ignore
export function useRunSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunSearchQuery, RunSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSearchQuery, RunSearchQueryVariables>;
export function useRunSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSearchQuery, RunSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSearchQuery | undefined, RunSearchQueryVariables>;
export function useRunSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSearchQuery, RunSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunSearchQuery, RunSearchQueryVariables>(RunSearchDocument, options);
        }
export type RunSearchQueryHookResult = ReturnType<typeof useRunSearchQuery>;
export type RunSearchLazyQueryHookResult = ReturnType<typeof useRunSearchLazyQuery>;
export type RunSearchSuspenseQueryHookResult = ReturnType<typeof useRunSearchSuspenseQuery>;
export type RunSearchQueryResult = ApolloReactCommon.QueryResult<RunSearchQuery, RunSearchQueryVariables>;
export const RunSelectorDocument = gql`
    query RunSelector($projectInternalId: ID!) {
  project(internalId: $projectInternalId) {
    id
    fields(
      types: ["number", "string", "boolean", "other"]
      columns: ["config", "summary_metrics", "system_metrics", "aggregations_min", "aggregations_max"]
      first: 2000
    ) {
      edges {
        node {
          path
        }
      }
    }
    entity {
      id
      settings {
        storageBucketInfo {
          ID
        }
      }
    }
  }
}
    `;

/**
 * __useRunSelectorQuery__
 *
 * To run a query within a React component, call `useRunSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunSelectorQuery({
 *   variables: {
 *      projectInternalId: // value for 'projectInternalId'
 *   },
 * });
 */
export function useRunSelectorQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunSelectorQuery, RunSelectorQueryVariables> & ({ variables: RunSelectorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunSelectorQuery, RunSelectorQueryVariables>(RunSelectorDocument, options);
      }
export function useRunSelectorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunSelectorQuery, RunSelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunSelectorQuery, RunSelectorQueryVariables>(RunSelectorDocument, options);
        }
// @ts-ignore
export function useRunSelectorSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorQuery, RunSelectorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorQuery, RunSelectorQueryVariables>;
export function useRunSelectorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorQuery, RunSelectorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorQuery | undefined, RunSelectorQueryVariables>;
export function useRunSelectorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorQuery, RunSelectorQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunSelectorQuery, RunSelectorQueryVariables>(RunSelectorDocument, options);
        }
export type RunSelectorQueryHookResult = ReturnType<typeof useRunSelectorQuery>;
export type RunSelectorLazyQueryHookResult = ReturnType<typeof useRunSelectorLazyQuery>;
export type RunSelectorSuspenseQueryHookResult = ReturnType<typeof useRunSelectorSuspenseQuery>;
export type RunSelectorQueryResult = ApolloReactCommon.QueryResult<RunSelectorQuery, RunSelectorQueryVariables>;
export const RunSelectorGroupsLeanDocument = gql`
    query RunSelectorGroupsLean($filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $limit: Int!, $order: String!, $projectInternalId: ID!) {
  project(internalId: $projectInternalId) {
    id
    runSelectorGroups(
      first: $limit
      order: $order
      filters: $filters
      groupKeys: $groupKeys
      groupLevel: $groupLevel
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          value
          label
          count
          subgroupCount
          hasActiveRuns
        }
      }
    }
  }
}
    `;

/**
 * __useRunSelectorGroupsLeanQuery__
 *
 * To run a query within a React component, call `useRunSelectorGroupsLeanQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunSelectorGroupsLeanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunSelectorGroupsLeanQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      projectInternalId: // value for 'projectInternalId'
 *   },
 * });
 */
export function useRunSelectorGroupsLeanQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunSelectorGroupsLeanQuery, RunSelectorGroupsLeanQueryVariables> & ({ variables: RunSelectorGroupsLeanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunSelectorGroupsLeanQuery, RunSelectorGroupsLeanQueryVariables>(RunSelectorGroupsLeanDocument, options);
      }
export function useRunSelectorGroupsLeanLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunSelectorGroupsLeanQuery, RunSelectorGroupsLeanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunSelectorGroupsLeanQuery, RunSelectorGroupsLeanQueryVariables>(RunSelectorGroupsLeanDocument, options);
        }
// @ts-ignore
export function useRunSelectorGroupsLeanSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorGroupsLeanQuery, RunSelectorGroupsLeanQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorGroupsLeanQuery, RunSelectorGroupsLeanQueryVariables>;
export function useRunSelectorGroupsLeanSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorGroupsLeanQuery, RunSelectorGroupsLeanQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorGroupsLeanQuery | undefined, RunSelectorGroupsLeanQueryVariables>;
export function useRunSelectorGroupsLeanSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorGroupsLeanQuery, RunSelectorGroupsLeanQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunSelectorGroupsLeanQuery, RunSelectorGroupsLeanQueryVariables>(RunSelectorGroupsLeanDocument, options);
        }
export type RunSelectorGroupsLeanQueryHookResult = ReturnType<typeof useRunSelectorGroupsLeanQuery>;
export type RunSelectorGroupsLeanLazyQueryHookResult = ReturnType<typeof useRunSelectorGroupsLeanLazyQuery>;
export type RunSelectorGroupsLeanSuspenseQueryHookResult = ReturnType<typeof useRunSelectorGroupsLeanSuspenseQuery>;
export type RunSelectorGroupsLeanQueryResult = ApolloReactCommon.QueryResult<RunSelectorGroupsLeanQuery, RunSelectorGroupsLeanQueryVariables>;
export const RunSelectorRunsDocument = gql`
    query RunSelectorRuns($aggregationKeys: [String!], $configKeys: [String!], $currentRuns: [String!]!, $enableAggregations: Boolean = false, $enableArtifactCounts: Boolean = false, $enableConfig: Boolean = false, $enableGroupedMetadataColumns: Boolean = false, $enableSummary: Boolean = false, $enableTags: Boolean = false, $filters: JSONString!, $groupAggregation: GroupAggregation, $groupedMetadataColumnKeys: [String!]!, $groupedMetadataColumnLimit: Int, $groupKeys: [String!]!, $groupLevel: Int!, $lastUpdated: DateTime!, $limit: Int!, $order: String!, $pinnedRunIds: [ID!]!, $projectInternalId: ID!, $summaryKeys: [String!], $wandbKeys: [String!]) {
  pinnedRuns: runs(ids: $pinnedRunIds, order: $order) {
    runs {
      project {
        id
        name
        entityName
      }
      ...RunFields
    }
  }
  project(internalId: $projectInternalId) {
    ...RunsSelectorRunsProjectFragment
  }
}
    ${RunFieldsFragmentDoc}
${RunsSelectorRunsProjectFragmentFragmentDoc}`;

/**
 * __useRunSelectorRunsQuery__
 *
 * To run a query within a React component, call `useRunSelectorRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunSelectorRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunSelectorRunsQuery({
 *   variables: {
 *      aggregationKeys: // value for 'aggregationKeys'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableAggregations: // value for 'enableAggregations'
 *      enableArtifactCounts: // value for 'enableArtifactCounts'
 *      enableConfig: // value for 'enableConfig'
 *      enableGroupedMetadataColumns: // value for 'enableGroupedMetadataColumns'
 *      enableSummary: // value for 'enableSummary'
 *      enableTags: // value for 'enableTags'
 *      filters: // value for 'filters'
 *      groupAggregation: // value for 'groupAggregation'
 *      groupedMetadataColumnKeys: // value for 'groupedMetadataColumnKeys'
 *      groupedMetadataColumnLimit: // value for 'groupedMetadataColumnLimit'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      pinnedRunIds: // value for 'pinnedRunIds'
 *      projectInternalId: // value for 'projectInternalId'
 *      summaryKeys: // value for 'summaryKeys'
 *      wandbKeys: // value for 'wandbKeys'
 *   },
 * });
 */
export function useRunSelectorRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunSelectorRunsQuery, RunSelectorRunsQueryVariables> & ({ variables: RunSelectorRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunSelectorRunsQuery, RunSelectorRunsQueryVariables>(RunSelectorRunsDocument, options);
      }
export function useRunSelectorRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunSelectorRunsQuery, RunSelectorRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunSelectorRunsQuery, RunSelectorRunsQueryVariables>(RunSelectorRunsDocument, options);
        }
// @ts-ignore
export function useRunSelectorRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorRunsQuery, RunSelectorRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorRunsQuery, RunSelectorRunsQueryVariables>;
export function useRunSelectorRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorRunsQuery, RunSelectorRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorRunsQuery | undefined, RunSelectorRunsQueryVariables>;
export function useRunSelectorRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorRunsQuery, RunSelectorRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunSelectorRunsQuery, RunSelectorRunsQueryVariables>(RunSelectorRunsDocument, options);
        }
export type RunSelectorRunsQueryHookResult = ReturnType<typeof useRunSelectorRunsQuery>;
export type RunSelectorRunsLazyQueryHookResult = ReturnType<typeof useRunSelectorRunsLazyQuery>;
export type RunSelectorRunsSuspenseQueryHookResult = ReturnType<typeof useRunSelectorRunsSuspenseQuery>;
export type RunSelectorRunsQueryResult = ApolloReactCommon.QueryResult<RunSelectorRunsQuery, RunSelectorRunsQueryVariables>;
export const RunSelectorFilteredRunExistsDocument = gql`
    query RunSelectorFilteredRunExists($projectInternalId: ID!, $filters: JSONString!) {
  project(internalId: $projectInternalId) {
    id
    runs(first: 1, filters: $filters) {
      edges {
        node {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useRunSelectorFilteredRunExistsQuery__
 *
 * To run a query within a React component, call `useRunSelectorFilteredRunExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunSelectorFilteredRunExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunSelectorFilteredRunExistsQuery({
 *   variables: {
 *      projectInternalId: // value for 'projectInternalId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRunSelectorFilteredRunExistsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunSelectorFilteredRunExistsQuery, RunSelectorFilteredRunExistsQueryVariables> & ({ variables: RunSelectorFilteredRunExistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunSelectorFilteredRunExistsQuery, RunSelectorFilteredRunExistsQueryVariables>(RunSelectorFilteredRunExistsDocument, options);
      }
export function useRunSelectorFilteredRunExistsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunSelectorFilteredRunExistsQuery, RunSelectorFilteredRunExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunSelectorFilteredRunExistsQuery, RunSelectorFilteredRunExistsQueryVariables>(RunSelectorFilteredRunExistsDocument, options);
        }
// @ts-ignore
export function useRunSelectorFilteredRunExistsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorFilteredRunExistsQuery, RunSelectorFilteredRunExistsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorFilteredRunExistsQuery, RunSelectorFilteredRunExistsQueryVariables>;
export function useRunSelectorFilteredRunExistsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorFilteredRunExistsQuery, RunSelectorFilteredRunExistsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorFilteredRunExistsQuery | undefined, RunSelectorFilteredRunExistsQueryVariables>;
export function useRunSelectorFilteredRunExistsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorFilteredRunExistsQuery, RunSelectorFilteredRunExistsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunSelectorFilteredRunExistsQuery, RunSelectorFilteredRunExistsQueryVariables>(RunSelectorFilteredRunExistsDocument, options);
        }
export type RunSelectorFilteredRunExistsQueryHookResult = ReturnType<typeof useRunSelectorFilteredRunExistsQuery>;
export type RunSelectorFilteredRunExistsLazyQueryHookResult = ReturnType<typeof useRunSelectorFilteredRunExistsLazyQuery>;
export type RunSelectorFilteredRunExistsSuspenseQueryHookResult = ReturnType<typeof useRunSelectorFilteredRunExistsSuspenseQuery>;
export type RunSelectorFilteredRunExistsQueryResult = ApolloReactCommon.QueryResult<RunSelectorFilteredRunExistsQuery, RunSelectorFilteredRunExistsQueryVariables>;
export const RunSelectorCsvExportRunsDocument = gql`
    query RunSelectorCsvExportRuns($aggregationKeys: [String!], $configKeys: [String!], $enableAggregations: Boolean = false, $enableArtifactCounts: Boolean = false, $enableConfig: Boolean = false, $enableGroupedMetadataColumns: Boolean = false, $enableSummary: Boolean = false, $enableTags: Boolean = false, $entityName: String!, $filters: JSONString!, $groupAggregation: GroupAggregation, $groupedMetadataColumnKeys: [String!]!, $groupedMetadataColumnLimit: Int, $groupKeys: [String!]!, $groupLevel: Int!, $limit: Int!, $order: String!, $pinnedRunIds: [ID!]!, $projectName: String!, $summaryKeys: [String!], $wandbKeys: [String!]) {
  pinnedRuns: runs(ids: $pinnedRunIds, order: $order) {
    runs {
      project {
        id
        name
        entityName
      }
      ...RunSelectorCsvExportRunFields
    }
  }
  project(name: $projectName, entityName: $entityName) {
    id
    runs(
      first: $limit
      order: $order
      filters: $filters
      groupKeys: $groupKeys
      groupAggregation: $groupAggregation
      groupLevel: $groupLevel
    ) {
      edges {
        node {
          ...RunSelectorCsvExportRunFields
        }
      }
    }
  }
}
    ${RunSelectorCsvExportRunFieldsFragmentDoc}`;

/**
 * __useRunSelectorCsvExportRunsQuery__
 *
 * To run a query within a React component, call `useRunSelectorCsvExportRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunSelectorCsvExportRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunSelectorCsvExportRunsQuery({
 *   variables: {
 *      aggregationKeys: // value for 'aggregationKeys'
 *      configKeys: // value for 'configKeys'
 *      enableAggregations: // value for 'enableAggregations'
 *      enableArtifactCounts: // value for 'enableArtifactCounts'
 *      enableConfig: // value for 'enableConfig'
 *      enableGroupedMetadataColumns: // value for 'enableGroupedMetadataColumns'
 *      enableSummary: // value for 'enableSummary'
 *      enableTags: // value for 'enableTags'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      groupAggregation: // value for 'groupAggregation'
 *      groupedMetadataColumnKeys: // value for 'groupedMetadataColumnKeys'
 *      groupedMetadataColumnLimit: // value for 'groupedMetadataColumnLimit'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      pinnedRunIds: // value for 'pinnedRunIds'
 *      projectName: // value for 'projectName'
 *      summaryKeys: // value for 'summaryKeys'
 *      wandbKeys: // value for 'wandbKeys'
 *   },
 * });
 */
export function useRunSelectorCsvExportRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables> & ({ variables: RunSelectorCsvExportRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables>(RunSelectorCsvExportRunsDocument, options);
      }
export function useRunSelectorCsvExportRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables>(RunSelectorCsvExportRunsDocument, options);
        }
// @ts-ignore
export function useRunSelectorCsvExportRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables>;
export function useRunSelectorCsvExportRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorCsvExportRunsQuery | undefined, RunSelectorCsvExportRunsQueryVariables>;
export function useRunSelectorCsvExportRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables>(RunSelectorCsvExportRunsDocument, options);
        }
export type RunSelectorCsvExportRunsQueryHookResult = ReturnType<typeof useRunSelectorCsvExportRunsQuery>;
export type RunSelectorCsvExportRunsLazyQueryHookResult = ReturnType<typeof useRunSelectorCsvExportRunsLazyQuery>;
export type RunSelectorCsvExportRunsSuspenseQueryHookResult = ReturnType<typeof useRunSelectorCsvExportRunsSuspenseQuery>;
export type RunSelectorCsvExportRunsQueryResult = ApolloReactCommon.QueryResult<RunSelectorCsvExportRunsQuery, RunSelectorCsvExportRunsQueryVariables>;
export const RunSelectorAutoColsRunsDocument = gql`
    query RunSelectorAutoColsRuns($enableArtifactCounts: Boolean = false, $entityName: String!, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $limit: Int!, $order: String!, $projectName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(
      first: $limit
      order: $order
      filters: $filters
      groupKeys: $groupKeys
      groupLevel: $groupLevel
    ) {
      edges {
        node {
          id
          aggregations
          commit
          config
          createdAt
          displayName
          framework
          github
          group
          groupCounts
          heartbeatAt
          host
          jobType
          logLineCount
          name
          notes
          projectId
          readOnly
          runInfo {
            gpu
            gpuCount
          }
          shouldStop
          state
          stopped
          summaryMetrics
          sweep {
            id
            name
            displayName
          }
          updatedAt
          user {
            id
            username
          }
          ...ArtifactCountsFragment @include(if: $enableArtifactCounts)
        }
      }
    }
  }
}
    ${ArtifactCountsFragmentFragmentDoc}`;

/**
 * __useRunSelectorAutoColsRunsQuery__
 *
 * To run a query within a React component, call `useRunSelectorAutoColsRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunSelectorAutoColsRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunSelectorAutoColsRunsQuery({
 *   variables: {
 *      enableArtifactCounts: // value for 'enableArtifactCounts'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useRunSelectorAutoColsRunsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables> & ({ variables: RunSelectorAutoColsRunsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables>(RunSelectorAutoColsRunsDocument, options);
      }
export function useRunSelectorAutoColsRunsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables>(RunSelectorAutoColsRunsDocument, options);
        }
// @ts-ignore
export function useRunSelectorAutoColsRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables>;
export function useRunSelectorAutoColsRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSelectorAutoColsRunsQuery | undefined, RunSelectorAutoColsRunsQueryVariables>;
export function useRunSelectorAutoColsRunsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables>(RunSelectorAutoColsRunsDocument, options);
        }
export type RunSelectorAutoColsRunsQueryHookResult = ReturnType<typeof useRunSelectorAutoColsRunsQuery>;
export type RunSelectorAutoColsRunsLazyQueryHookResult = ReturnType<typeof useRunSelectorAutoColsRunsLazyQuery>;
export type RunSelectorAutoColsRunsSuspenseQueryHookResult = ReturnType<typeof useRunSelectorAutoColsRunsSuspenseQuery>;
export type RunSelectorAutoColsRunsQueryResult = ApolloReactCommon.QueryResult<RunSelectorAutoColsRunsQuery, RunSelectorAutoColsRunsQueryVariables>;
export const BulkEditorProjectTagsDocument = gql`
    query BulkEditorProjectTags($name: String!, $entityName: String, $tempFilters: JSONString) {
  project(name: $name, entityName: $entityName) {
    id
    tags {
      id
      name
      colorIndex
    }
    tagCounts(filters: $tempFilters) {
      name
      count
    }
  }
}
    `;

/**
 * __useBulkEditorProjectTagsQuery__
 *
 * To run a query within a React component, call `useBulkEditorProjectTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkEditorProjectTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkEditorProjectTagsQuery({
 *   variables: {
 *      name: // value for 'name'
 *      entityName: // value for 'entityName'
 *      tempFilters: // value for 'tempFilters'
 *   },
 * });
 */
export function useBulkEditorProjectTagsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables> & ({ variables: BulkEditorProjectTagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables>(BulkEditorProjectTagsDocument, options);
      }
export function useBulkEditorProjectTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables>(BulkEditorProjectTagsDocument, options);
        }
// @ts-ignore
export function useBulkEditorProjectTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables>;
export function useBulkEditorProjectTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BulkEditorProjectTagsQuery | undefined, BulkEditorProjectTagsQueryVariables>;
export function useBulkEditorProjectTagsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables>(BulkEditorProjectTagsDocument, options);
        }
export type BulkEditorProjectTagsQueryHookResult = ReturnType<typeof useBulkEditorProjectTagsQuery>;
export type BulkEditorProjectTagsLazyQueryHookResult = ReturnType<typeof useBulkEditorProjectTagsLazyQuery>;
export type BulkEditorProjectTagsSuspenseQueryHookResult = ReturnType<typeof useBulkEditorProjectTagsSuspenseQuery>;
export type BulkEditorProjectTagsQueryResult = ApolloReactCommon.QueryResult<BulkEditorProjectTagsQuery, BulkEditorProjectTagsQueryVariables>;
export const RunSetSummaryDocument = gql`
    query RunSetSummary($projectInternalId: ID!, $selections: JSONString!) {
  project(internalId: $projectInternalId) {
    id
    selectedCount: runCount(filters: $selections)
  }
}
    `;

/**
 * __useRunSetSummaryQuery__
 *
 * To run a query within a React component, call `useRunSetSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunSetSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunSetSummaryQuery({
 *   variables: {
 *      projectInternalId: // value for 'projectInternalId'
 *      selections: // value for 'selections'
 *   },
 * });
 */
export function useRunSetSummaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunSetSummaryQuery, RunSetSummaryQueryVariables> & ({ variables: RunSetSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunSetSummaryQuery, RunSetSummaryQueryVariables>(RunSetSummaryDocument, options);
      }
export function useRunSetSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunSetSummaryQuery, RunSetSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunSetSummaryQuery, RunSetSummaryQueryVariables>(RunSetSummaryDocument, options);
        }
// @ts-ignore
export function useRunSetSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunSetSummaryQuery, RunSetSummaryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSetSummaryQuery, RunSetSummaryQueryVariables>;
export function useRunSetSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSetSummaryQuery, RunSetSummaryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunSetSummaryQuery | undefined, RunSetSummaryQueryVariables>;
export function useRunSetSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunSetSummaryQuery, RunSetSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunSetSummaryQuery, RunSetSummaryQueryVariables>(RunSetSummaryDocument, options);
        }
export type RunSetSummaryQueryHookResult = ReturnType<typeof useRunSetSummaryQuery>;
export type RunSetSummaryLazyQueryHookResult = ReturnType<typeof useRunSetSummaryLazyQuery>;
export type RunSetSummarySuspenseQueryHookResult = ReturnType<typeof useRunSetSummarySuspenseQuery>;
export type RunSetSummaryQueryResult = ApolloReactCommon.QueryResult<RunSetSummaryQuery, RunSetSummaryQueryVariables>;
export const ViewSpecDocument = gql`
    query ViewSpec($id: ID!) {
  view(id: $id) {
    id
    type
    spec
  }
}
    `;

/**
 * __useViewSpecQuery__
 *
 * To run a query within a React component, call `useViewSpecQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewSpecQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewSpecQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewSpecQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewSpecQuery, ViewSpecQueryVariables> & ({ variables: ViewSpecQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewSpecQuery, ViewSpecQueryVariables>(ViewSpecDocument, options);
      }
export function useViewSpecLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewSpecQuery, ViewSpecQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewSpecQuery, ViewSpecQueryVariables>(ViewSpecDocument, options);
        }
// @ts-ignore
export function useViewSpecSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewSpecQuery, ViewSpecQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewSpecQuery, ViewSpecQueryVariables>;
export function useViewSpecSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewSpecQuery, ViewSpecQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewSpecQuery | undefined, ViewSpecQueryVariables>;
export function useViewSpecSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewSpecQuery, ViewSpecQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewSpecQuery, ViewSpecQueryVariables>(ViewSpecDocument, options);
        }
export type ViewSpecQueryHookResult = ReturnType<typeof useViewSpecQuery>;
export type ViewSpecLazyQueryHookResult = ReturnType<typeof useViewSpecLazyQuery>;
export type ViewSpecSuspenseQueryHookResult = ReturnType<typeof useViewSpecSuspenseQuery>;
export type ViewSpecQueryResult = ApolloReactCommon.QueryResult<ViewSpecQuery, ViewSpecQueryVariables>;
export const SearchEntityProjectsDocument = gql`
    query SearchEntityProjects($entityName: String, $entityProjectsLimit: Int = 10000) {
  projects(entityName: $entityName, first: $entityProjectsLimit) {
    edges {
      node {
        id
        name
        entityName
        allViews(viewType: "runs", first: 1000) {
          edges {
            node {
              id
              displayName
              project {
                id
                name
                entityName
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchEntityProjectsQuery__
 *
 * To run a query within a React component, call `useSearchEntityProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEntityProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEntityProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      entityProjectsLimit: // value for 'entityProjectsLimit'
 *   },
 * });
 */
export function useSearchEntityProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>(SearchEntityProjectsDocument, options);
      }
export function useSearchEntityProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>(SearchEntityProjectsDocument, options);
        }
// @ts-ignore
export function useSearchEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>;
export function useSearchEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchEntityProjectsQuery | undefined, SearchEntityProjectsQueryVariables>;
export function useSearchEntityProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>(SearchEntityProjectsDocument, options);
        }
export type SearchEntityProjectsQueryHookResult = ReturnType<typeof useSearchEntityProjectsQuery>;
export type SearchEntityProjectsLazyQueryHookResult = ReturnType<typeof useSearchEntityProjectsLazyQuery>;
export type SearchEntityProjectsSuspenseQueryHookResult = ReturnType<typeof useSearchEntityProjectsSuspenseQuery>;
export type SearchEntityProjectsQueryResult = ApolloReactCommon.QueryResult<SearchEntityProjectsQuery, SearchEntityProjectsQueryVariables>;
export const SearchViewerDocument = gql`
    query SearchViewer {
  viewer {
    id
    admin
    photoUrl
    username
    organizations {
      id
      name
      orgType
    }
    projects(first: 500) {
      edges {
        node {
          id
          name
          entityName
        }
      }
    }
    views(viewType: "runs", first: 10000) {
      edges {
        node {
          id
          displayName
          project {
            id
            name
            entityName
          }
        }
      }
    }
    teams(first: 500) {
      edges {
        node {
          id
          name
          photoUrl
          projects(first: 500) {
            edges {
              node {
                id
                name
                entityName
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchViewerQuery__
 *
 * To run a query within a React component, call `useSearchViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useSearchViewerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchViewerQuery, SearchViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchViewerQuery, SearchViewerQueryVariables>(SearchViewerDocument, options);
      }
export function useSearchViewerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchViewerQuery, SearchViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchViewerQuery, SearchViewerQueryVariables>(SearchViewerDocument, options);
        }
// @ts-ignore
export function useSearchViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchViewerQuery, SearchViewerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchViewerQuery, SearchViewerQueryVariables>;
export function useSearchViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchViewerQuery, SearchViewerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchViewerQuery | undefined, SearchViewerQueryVariables>;
export function useSearchViewerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchViewerQuery, SearchViewerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchViewerQuery, SearchViewerQueryVariables>(SearchViewerDocument, options);
        }
export type SearchViewerQueryHookResult = ReturnType<typeof useSearchViewerQuery>;
export type SearchViewerLazyQueryHookResult = ReturnType<typeof useSearchViewerLazyQuery>;
export type SearchViewerSuspenseQueryHookResult = ReturnType<typeof useSearchViewerSuspenseQuery>;
export type SearchViewerQueryResult = ApolloReactCommon.QueryResult<SearchViewerQuery, SearchViewerQueryVariables>;
export const SearchNavQueryDocument = gql`
    query SearchNavQuery($entityName: String, $projectName: String, $runName: String!, $sweepName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    name
    access
    readOnly
    entity {
      id
      name
      readOnlyAdmin
      defaultAccess
      privateOnly
      isTeam
    }
    user {
      id
    }
    run(name: $runName) {
      id
      displayName
      state
    }
    sweep(sweepName: $sweepName) {
      id
      name
      displayName
      config
    }
  }
}
    `;

/**
 * __useSearchNavQueryQuery__
 *
 * To run a query within a React component, call `useSearchNavQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchNavQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchNavQueryQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runName: // value for 'runName'
 *      sweepName: // value for 'sweepName'
 *   },
 * });
 */
export function useSearchNavQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchNavQueryQuery, SearchNavQueryQueryVariables> & ({ variables: SearchNavQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchNavQueryQuery, SearchNavQueryQueryVariables>(SearchNavQueryDocument, options);
      }
export function useSearchNavQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchNavQueryQuery, SearchNavQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchNavQueryQuery, SearchNavQueryQueryVariables>(SearchNavQueryDocument, options);
        }
// @ts-ignore
export function useSearchNavQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchNavQueryQuery, SearchNavQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchNavQueryQuery, SearchNavQueryQueryVariables>;
export function useSearchNavQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchNavQueryQuery, SearchNavQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchNavQueryQuery | undefined, SearchNavQueryQueryVariables>;
export function useSearchNavQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchNavQueryQuery, SearchNavQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchNavQueryQuery, SearchNavQueryQueryVariables>(SearchNavQueryDocument, options);
        }
export type SearchNavQueryQueryHookResult = ReturnType<typeof useSearchNavQueryQuery>;
export type SearchNavQueryLazyQueryHookResult = ReturnType<typeof useSearchNavQueryLazyQuery>;
export type SearchNavQuerySuspenseQueryHookResult = ReturnType<typeof useSearchNavQuerySuspenseQuery>;
export type SearchNavQueryQueryResult = ApolloReactCommon.QueryResult<SearchNavQueryQuery, SearchNavQueryQueryVariables>;
export const SelectedCountDocument = gql`
    query SelectedCount($projectInternalId: ID!, $filters: JSONString, $tempFilters: JSONString) {
  project(internalId: $projectInternalId) {
    id
    selectedCount: runCount(filters: $filters)
    tempSelectedCount: runCount(filters: $tempFilters)
    tempSelectedActiveCount: runActiveCount(filters: $tempFilters)
    tempOutputArtifactsCount: runOutputArtifactsCount(filters: $tempFilters)
  }
}
    `;

/**
 * __useSelectedCountQuery__
 *
 * To run a query within a React component, call `useSelectedCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedCountQuery({
 *   variables: {
 *      projectInternalId: // value for 'projectInternalId'
 *      filters: // value for 'filters'
 *      tempFilters: // value for 'tempFilters'
 *   },
 * });
 */
export function useSelectedCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SelectedCountQuery, SelectedCountQueryVariables> & ({ variables: SelectedCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectedCountQuery, SelectedCountQueryVariables>(SelectedCountDocument, options);
      }
export function useSelectedCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectedCountQuery, SelectedCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectedCountQuery, SelectedCountQueryVariables>(SelectedCountDocument, options);
        }
// @ts-ignore
export function useSelectedCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SelectedCountQuery, SelectedCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectedCountQuery, SelectedCountQueryVariables>;
export function useSelectedCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectedCountQuery, SelectedCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectedCountQuery | undefined, SelectedCountQueryVariables>;
export function useSelectedCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectedCountQuery, SelectedCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SelectedCountQuery, SelectedCountQueryVariables>(SelectedCountDocument, options);
        }
export type SelectedCountQueryHookResult = ReturnType<typeof useSelectedCountQuery>;
export type SelectedCountLazyQueryHookResult = ReturnType<typeof useSelectedCountLazyQuery>;
export type SelectedCountSuspenseQueryHookResult = ReturnType<typeof useSelectedCountSuspenseQuery>;
export type SelectedCountQueryResult = ApolloReactCommon.QueryResult<SelectedCountQuery, SelectedCountQueryVariables>;
export const SweepPageDocument = gql`
    query SweepPage($projectName: String!, $entityName: String!, $sweepName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    access
    readOnly
    sweep(sweepName: $sweepName) {
      id
      name
      displayName
      runCount
      runCountExpected
      runTime
      method
      state
      description
      user {
        id
        username
        photoUrl
      }
      config
      createdAt
      heartbeatAt
      updatedAt
      controllerRunName
      priorRuns {
        edges {
          node {
            id
            name
          }
        }
      }
      scheduler
    }
    entity {
      id
      name
      defaultAccess
      readOnlyAdmin
      privateOnly
      isTeam
    }
  }
}
    `;

/**
 * __useSweepPageQuery__
 *
 * To run a query within a React component, call `useSweepPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSweepPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSweepPageQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      sweepName: // value for 'sweepName'
 *   },
 * });
 */
export function useSweepPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SweepPageQuery, SweepPageQueryVariables> & ({ variables: SweepPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SweepPageQuery, SweepPageQueryVariables>(SweepPageDocument, options);
      }
export function useSweepPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SweepPageQuery, SweepPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SweepPageQuery, SweepPageQueryVariables>(SweepPageDocument, options);
        }
// @ts-ignore
export function useSweepPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SweepPageQuery, SweepPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SweepPageQuery, SweepPageQueryVariables>;
export function useSweepPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SweepPageQuery, SweepPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SweepPageQuery | undefined, SweepPageQueryVariables>;
export function useSweepPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SweepPageQuery, SweepPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SweepPageQuery, SweepPageQueryVariables>(SweepPageDocument, options);
        }
export type SweepPageQueryHookResult = ReturnType<typeof useSweepPageQuery>;
export type SweepPageLazyQueryHookResult = ReturnType<typeof useSweepPageLazyQuery>;
export type SweepPageSuspenseQueryHookResult = ReturnType<typeof useSweepPageSuspenseQuery>;
export type SweepPageQueryResult = ApolloReactCommon.QueryResult<SweepPageQuery, SweepPageQueryVariables>;
export const SweepPageAgentsDocument = gql`
    query SweepPageAgents($projectName: String!, $entityName: String!, $sweepName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    sweep(sweepName: $sweepName) {
      id
      agents {
        edges {
          node {
            id
            name
            state
            host
            persistent
            user {
              id
            }
            metrics
            createdAt
            heartbeatAt
            totalRuns
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSweepPageAgentsQuery__
 *
 * To run a query within a React component, call `useSweepPageAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSweepPageAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSweepPageAgentsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      sweepName: // value for 'sweepName'
 *   },
 * });
 */
export function useSweepPageAgentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SweepPageAgentsQuery, SweepPageAgentsQueryVariables> & ({ variables: SweepPageAgentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SweepPageAgentsQuery, SweepPageAgentsQueryVariables>(SweepPageAgentsDocument, options);
      }
export function useSweepPageAgentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SweepPageAgentsQuery, SweepPageAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SweepPageAgentsQuery, SweepPageAgentsQueryVariables>(SweepPageAgentsDocument, options);
        }
// @ts-ignore
export function useSweepPageAgentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SweepPageAgentsQuery, SweepPageAgentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SweepPageAgentsQuery, SweepPageAgentsQueryVariables>;
export function useSweepPageAgentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SweepPageAgentsQuery, SweepPageAgentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SweepPageAgentsQuery | undefined, SweepPageAgentsQueryVariables>;
export function useSweepPageAgentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SweepPageAgentsQuery, SweepPageAgentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SweepPageAgentsQuery, SweepPageAgentsQueryVariables>(SweepPageAgentsDocument, options);
        }
export type SweepPageAgentsQueryHookResult = ReturnType<typeof useSweepPageAgentsQuery>;
export type SweepPageAgentsLazyQueryHookResult = ReturnType<typeof useSweepPageAgentsLazyQuery>;
export type SweepPageAgentsSuspenseQueryHookResult = ReturnType<typeof useSweepPageAgentsSuspenseQuery>;
export type SweepPageAgentsQueryResult = ApolloReactCommon.QueryResult<SweepPageAgentsQuery, SweepPageAgentsQueryVariables>;
export const SweepValueDropdownDocument = gql`
    query SweepValueDropdown($projectName: String!, $entityName: String, $filters: JSONString, $after: String, $first: Int, $order: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    sweeps(filters: $filters, after: $after, first: $first, order: $order) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useSweepValueDropdownQuery__
 *
 * To run a query within a React component, call `useSweepValueDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useSweepValueDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSweepValueDropdownQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSweepValueDropdownQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SweepValueDropdownQuery, SweepValueDropdownQueryVariables> & ({ variables: SweepValueDropdownQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SweepValueDropdownQuery, SweepValueDropdownQueryVariables>(SweepValueDropdownDocument, options);
      }
export function useSweepValueDropdownLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SweepValueDropdownQuery, SweepValueDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SweepValueDropdownQuery, SweepValueDropdownQueryVariables>(SweepValueDropdownDocument, options);
        }
// @ts-ignore
export function useSweepValueDropdownSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SweepValueDropdownQuery, SweepValueDropdownQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SweepValueDropdownQuery, SweepValueDropdownQueryVariables>;
export function useSweepValueDropdownSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SweepValueDropdownQuery, SweepValueDropdownQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SweepValueDropdownQuery | undefined, SweepValueDropdownQueryVariables>;
export function useSweepValueDropdownSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SweepValueDropdownQuery, SweepValueDropdownQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SweepValueDropdownQuery, SweepValueDropdownQueryVariables>(SweepValueDropdownDocument, options);
        }
export type SweepValueDropdownQueryHookResult = ReturnType<typeof useSweepValueDropdownQuery>;
export type SweepValueDropdownLazyQueryHookResult = ReturnType<typeof useSweepValueDropdownLazyQuery>;
export type SweepValueDropdownSuspenseQueryHookResult = ReturnType<typeof useSweepValueDropdownSuspenseQuery>;
export type SweepValueDropdownQueryResult = ApolloReactCommon.QueryResult<SweepValueDropdownQuery, SweepValueDropdownQueryVariables>;
export const SweepsDocument = gql`
    query Sweeps($projectName: String!, $entityName: String, $after: String, $before: String, $first: Int, $last: Int, $order: String, $filters: JSONString) {
  project(name: $projectName, entityName: $entityName) {
    id
    readOnly
    sweeps(
      before: $before
      after: $after
      first: $first
      last: $last
      order: $order
      filters: $filters
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          displayName
          state
          runCount
          runCountExpected
          runTime
          createdAt
          user {
            id
            username
            photoUrl
          }
          config
          scheduler
        }
      }
    }
  }
}
    `;

/**
 * __useSweepsQuery__
 *
 * To run a query within a React component, call `useSweepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSweepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSweepsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      order: // value for 'order'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSweepsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SweepsQuery, SweepsQueryVariables> & ({ variables: SweepsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SweepsQuery, SweepsQueryVariables>(SweepsDocument, options);
      }
export function useSweepsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SweepsQuery, SweepsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SweepsQuery, SweepsQueryVariables>(SweepsDocument, options);
        }
// @ts-ignore
export function useSweepsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SweepsQuery, SweepsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SweepsQuery, SweepsQueryVariables>;
export function useSweepsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SweepsQuery, SweepsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SweepsQuery | undefined, SweepsQueryVariables>;
export function useSweepsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SweepsQuery, SweepsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SweepsQuery, SweepsQueryVariables>(SweepsDocument, options);
        }
export type SweepsQueryHookResult = ReturnType<typeof useSweepsQuery>;
export type SweepsLazyQueryHookResult = ReturnType<typeof useSweepsLazyQuery>;
export type SweepsSuspenseQueryHookResult = ReturnType<typeof useSweepsSuspenseQuery>;
export type SweepsQueryResult = ApolloReactCommon.QueryResult<SweepsQuery, SweepsQueryVariables>;
export const CreateArtifactCollectionTagAssignmentsDocument = gql`
    mutation CreateArtifactCollectionTagAssignments($entityName: String!, $projectName: String!, $artifactCollectionName: String!, $tags: [TagInput!]!) {
  createArtifactCollectionTagAssignments(
    input: {entityName: $entityName, projectName: $projectName, artifactCollectionName: $artifactCollectionName, tags: $tags}
  ) {
    tags {
      id
      name
      tagCategoryName
    }
  }
}
    `;
export type CreateArtifactCollectionTagAssignmentsMutationFn = ApolloReactCommon.MutationFunction<CreateArtifactCollectionTagAssignmentsMutation, CreateArtifactCollectionTagAssignmentsMutationVariables>;

/**
 * __useCreateArtifactCollectionTagAssignmentsMutation__
 *
 * To run a mutation, you first call `useCreateArtifactCollectionTagAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArtifactCollectionTagAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArtifactCollectionTagAssignmentsMutation, { data, loading, error }] = useCreateArtifactCollectionTagAssignmentsMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      artifactCollectionName: // value for 'artifactCollectionName'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateArtifactCollectionTagAssignmentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateArtifactCollectionTagAssignmentsMutation, CreateArtifactCollectionTagAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateArtifactCollectionTagAssignmentsMutation, CreateArtifactCollectionTagAssignmentsMutationVariables>(CreateArtifactCollectionTagAssignmentsDocument, options);
      }
export type CreateArtifactCollectionTagAssignmentsMutationHookResult = ReturnType<typeof useCreateArtifactCollectionTagAssignmentsMutation>;
export type CreateArtifactCollectionTagAssignmentsMutationResult = ApolloReactCommon.MutationResult<CreateArtifactCollectionTagAssignmentsMutation>;
export type CreateArtifactCollectionTagAssignmentsMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateArtifactCollectionTagAssignmentsMutation, CreateArtifactCollectionTagAssignmentsMutationVariables>;
export const DeleteArtifactCollectionTagAssignmentsDocument = gql`
    mutation DeleteArtifactCollectionTagAssignments($entityName: String!, $projectName: String!, $artifactCollectionName: String!, $tags: [TagInput!]!) {
  deleteArtifactCollectionTagAssignments(
    input: {entityName: $entityName, projectName: $projectName, artifactCollectionName: $artifactCollectionName, tags: $tags}
  ) {
    success
  }
}
    `;
export type DeleteArtifactCollectionTagAssignmentsMutationFn = ApolloReactCommon.MutationFunction<DeleteArtifactCollectionTagAssignmentsMutation, DeleteArtifactCollectionTagAssignmentsMutationVariables>;

/**
 * __useDeleteArtifactCollectionTagAssignmentsMutation__
 *
 * To run a mutation, you first call `useDeleteArtifactCollectionTagAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArtifactCollectionTagAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArtifactCollectionTagAssignmentsMutation, { data, loading, error }] = useDeleteArtifactCollectionTagAssignmentsMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      artifactCollectionName: // value for 'artifactCollectionName'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useDeleteArtifactCollectionTagAssignmentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteArtifactCollectionTagAssignmentsMutation, DeleteArtifactCollectionTagAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteArtifactCollectionTagAssignmentsMutation, DeleteArtifactCollectionTagAssignmentsMutationVariables>(DeleteArtifactCollectionTagAssignmentsDocument, options);
      }
export type DeleteArtifactCollectionTagAssignmentsMutationHookResult = ReturnType<typeof useDeleteArtifactCollectionTagAssignmentsMutation>;
export type DeleteArtifactCollectionTagAssignmentsMutationResult = ApolloReactCommon.MutationResult<DeleteArtifactCollectionTagAssignmentsMutation>;
export type DeleteArtifactCollectionTagAssignmentsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteArtifactCollectionTagAssignmentsMutation, DeleteArtifactCollectionTagAssignmentsMutationVariables>;
export const CreateArtifactTagAssignmentsDocument = gql`
    mutation CreateArtifactTagAssignments($artifactID: ID!, $tags: [TagInput!]!) {
  createArtifactTagAssignments(input: {artifactID: $artifactID, tags: $tags}) {
    tags {
      id
      name
      tagCategoryName
    }
  }
}
    `;
export type CreateArtifactTagAssignmentsMutationFn = ApolloReactCommon.MutationFunction<CreateArtifactTagAssignmentsMutation, CreateArtifactTagAssignmentsMutationVariables>;

/**
 * __useCreateArtifactTagAssignmentsMutation__
 *
 * To run a mutation, you first call `useCreateArtifactTagAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArtifactTagAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArtifactTagAssignmentsMutation, { data, loading, error }] = useCreateArtifactTagAssignmentsMutation({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateArtifactTagAssignmentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateArtifactTagAssignmentsMutation, CreateArtifactTagAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateArtifactTagAssignmentsMutation, CreateArtifactTagAssignmentsMutationVariables>(CreateArtifactTagAssignmentsDocument, options);
      }
export type CreateArtifactTagAssignmentsMutationHookResult = ReturnType<typeof useCreateArtifactTagAssignmentsMutation>;
export type CreateArtifactTagAssignmentsMutationResult = ApolloReactCommon.MutationResult<CreateArtifactTagAssignmentsMutation>;
export type CreateArtifactTagAssignmentsMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateArtifactTagAssignmentsMutation, CreateArtifactTagAssignmentsMutationVariables>;
export const DeleteArtifactTagAssignmentsDocument = gql`
    mutation DeleteArtifactTagAssignments($artifactID: ID!, $tags: [TagInput!]!) {
  deleteArtifactTagAssignments(input: {artifactID: $artifactID, tags: $tags}) {
    success
  }
}
    `;
export type DeleteArtifactTagAssignmentsMutationFn = ApolloReactCommon.MutationFunction<DeleteArtifactTagAssignmentsMutation, DeleteArtifactTagAssignmentsMutationVariables>;

/**
 * __useDeleteArtifactTagAssignmentsMutation__
 *
 * To run a mutation, you first call `useDeleteArtifactTagAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArtifactTagAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArtifactTagAssignmentsMutation, { data, loading, error }] = useDeleteArtifactTagAssignmentsMutation({
 *   variables: {
 *      artifactID: // value for 'artifactID'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useDeleteArtifactTagAssignmentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteArtifactTagAssignmentsMutation, DeleteArtifactTagAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteArtifactTagAssignmentsMutation, DeleteArtifactTagAssignmentsMutationVariables>(DeleteArtifactTagAssignmentsDocument, options);
      }
export type DeleteArtifactTagAssignmentsMutationHookResult = ReturnType<typeof useDeleteArtifactTagAssignmentsMutation>;
export type DeleteArtifactTagAssignmentsMutationResult = ApolloReactCommon.MutationResult<DeleteArtifactTagAssignmentsMutation>;
export type DeleteArtifactTagAssignmentsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteArtifactTagAssignmentsMutation, DeleteArtifactTagAssignmentsMutationVariables>;
export const TeamMembersDocument = gql`
    query TeamMembers($entityName: String!) {
  entity(name: $entityName) {
    id
    members {
      ...TeamMemberFields
    }
  }
}
    ${TeamMemberFieldsFragmentDoc}`;

/**
 * __useTeamMembersQuery__
 *
 * To run a query within a React component, call `useTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMembersQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useTeamMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables> & ({ variables: TeamMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
      }
export function useTeamMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
        }
// @ts-ignore
export function useTeamMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamMembersQuery, TeamMembersQueryVariables>;
export function useTeamMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamMembersQuery | undefined, TeamMembersQueryVariables>;
export function useTeamMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
        }
export type TeamMembersQueryHookResult = ReturnType<typeof useTeamMembersQuery>;
export type TeamMembersLazyQueryHookResult = ReturnType<typeof useTeamMembersLazyQuery>;
export type TeamMembersSuspenseQueryHookResult = ReturnType<typeof useTeamMembersSuspenseQuery>;
export type TeamMembersQueryResult = ApolloReactCommon.QueryResult<TeamMembersQuery, TeamMembersQueryVariables>;
export const TeamMemberDocument = gql`
    query TeamMember($entityName: String!, $memberId: ID!) {
  entity(name: $entityName) {
    id
    member(id: $memberId) {
      ...TeamMemberFields
      ...TeamMemberDetailedRole
    }
  }
}
    ${TeamMemberFieldsFragmentDoc}
${TeamMemberDetailedRoleFragmentDoc}`;

/**
 * __useTeamMemberQuery__
 *
 * To run a query within a React component, call `useTeamMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMemberQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useTeamMemberQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamMemberQuery, TeamMemberQueryVariables> & ({ variables: TeamMemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamMemberQuery, TeamMemberQueryVariables>(TeamMemberDocument, options);
      }
export function useTeamMemberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamMemberQuery, TeamMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamMemberQuery, TeamMemberQueryVariables>(TeamMemberDocument, options);
        }
// @ts-ignore
export function useTeamMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamMemberQuery, TeamMemberQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamMemberQuery, TeamMemberQueryVariables>;
export function useTeamMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamMemberQuery, TeamMemberQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamMemberQuery | undefined, TeamMemberQueryVariables>;
export function useTeamMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamMemberQuery, TeamMemberQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamMemberQuery, TeamMemberQueryVariables>(TeamMemberDocument, options);
        }
export type TeamMemberQueryHookResult = ReturnType<typeof useTeamMemberQuery>;
export type TeamMemberLazyQueryHookResult = ReturnType<typeof useTeamMemberLazyQuery>;
export type TeamMemberSuspenseQueryHookResult = ReturnType<typeof useTeamMemberSuspenseQuery>;
export type TeamMemberQueryResult = ApolloReactCommon.QueryResult<TeamMemberQuery, TeamMemberQueryVariables>;
export const ContactUsForUserLedTrialDocument = gql`
    mutation contactUsForUserLedTrial($clientMutationId: String) {
  contactUsForUserLedTrial(input: {clientMutationId: $clientMutationId}) {
    clientMutationId
  }
}
    `;
export type ContactUsForUserLedTrialMutationFn = ApolloReactCommon.MutationFunction<ContactUsForUserLedTrialMutation, ContactUsForUserLedTrialMutationVariables>;

/**
 * __useContactUsForUserLedTrialMutation__
 *
 * To run a mutation, you first call `useContactUsForUserLedTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactUsForUserLedTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactUsForUserLedTrialMutation, { data, loading, error }] = useContactUsForUserLedTrialMutation({
 *   variables: {
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useContactUsForUserLedTrialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ContactUsForUserLedTrialMutation, ContactUsForUserLedTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ContactUsForUserLedTrialMutation, ContactUsForUserLedTrialMutationVariables>(ContactUsForUserLedTrialDocument, options);
      }
export type ContactUsForUserLedTrialMutationHookResult = ReturnType<typeof useContactUsForUserLedTrialMutation>;
export type ContactUsForUserLedTrialMutationResult = ApolloReactCommon.MutationResult<ContactUsForUserLedTrialMutation>;
export type ContactUsForUserLedTrialMutationOptions = ApolloReactCommon.BaseMutationOptions<ContactUsForUserLedTrialMutation, ContactUsForUserLedTrialMutationVariables>;
export const ContactUsForComputeHoursDocument = gql`
    mutation contactUsForComputeHours($clientMutationId: String) {
  contactUsForComputeHours(input: {clientMutationId: $clientMutationId}) {
    clientMutationId
  }
}
    `;
export type ContactUsForComputeHoursMutationFn = ApolloReactCommon.MutationFunction<ContactUsForComputeHoursMutation, ContactUsForComputeHoursMutationVariables>;

/**
 * __useContactUsForComputeHoursMutation__
 *
 * To run a mutation, you first call `useContactUsForComputeHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactUsForComputeHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactUsForComputeHoursMutation, { data, loading, error }] = useContactUsForComputeHoursMutation({
 *   variables: {
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useContactUsForComputeHoursMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ContactUsForComputeHoursMutation, ContactUsForComputeHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ContactUsForComputeHoursMutation, ContactUsForComputeHoursMutationVariables>(ContactUsForComputeHoursDocument, options);
      }
export type ContactUsForComputeHoursMutationHookResult = ReturnType<typeof useContactUsForComputeHoursMutation>;
export type ContactUsForComputeHoursMutationResult = ApolloReactCommon.MutationResult<ContactUsForComputeHoursMutation>;
export type ContactUsForComputeHoursMutationOptions = ApolloReactCommon.BaseMutationOptions<ContactUsForComputeHoursMutation, ContactUsForComputeHoursMutationVariables>;
export const UserProfileDocument = gql`
    query UserProfile($userName: String!) {
  user(userName: $userName) {
    id
    profileView {
      id
      spec
      updatedAt
      updatedBy {
        id
        username
      }
    }
  }
}
    `;

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useUserProfileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserProfileQuery, UserProfileQueryVariables> & ({ variables: UserProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
      }
export function useUserProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
// @ts-ignore
export function useUserProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserProfileQuery, UserProfileQueryVariables>;
export function useUserProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserProfileQuery | undefined, UserProfileQueryVariables>;
export function useUserProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>;
export type UserProfileLazyQueryHookResult = ReturnType<typeof useUserProfileLazyQuery>;
export type UserProfileSuspenseQueryHookResult = ReturnType<typeof useUserProfileSuspenseQuery>;
export type UserProfileQueryResult = ApolloReactCommon.QueryResult<UserProfileQuery, UserProfileQueryVariables>;
export const UserProjectsDocument = gql`
    query UserProjects($userName: String!, $first: Int = 10000, $pattern: String) {
  user(userName: $userName) {
    id
    teams {
      edges {
        node {
          id
          name
          projects(order: "-created_at", first: $first, pattern: $pattern) {
            edges {
              node {
                id
                name
                entityName
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUserProjectsQuery__
 *
 * To run a query within a React component, call `useUserProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProjectsQuery({
 *   variables: {
 *      userName: // value for 'userName'
 *      first: // value for 'first'
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useUserProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserProjectsQuery, UserProjectsQueryVariables> & ({ variables: UserProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserProjectsQuery, UserProjectsQueryVariables>(UserProjectsDocument, options);
      }
export function useUserProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserProjectsQuery, UserProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserProjectsQuery, UserProjectsQueryVariables>(UserProjectsDocument, options);
        }
// @ts-ignore
export function useUserProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserProjectsQuery, UserProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserProjectsQuery, UserProjectsQueryVariables>;
export function useUserProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserProjectsQuery, UserProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserProjectsQuery | undefined, UserProjectsQueryVariables>;
export function useUserProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserProjectsQuery, UserProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserProjectsQuery, UserProjectsQueryVariables>(UserProjectsDocument, options);
        }
export type UserProjectsQueryHookResult = ReturnType<typeof useUserProjectsQuery>;
export type UserProjectsLazyQueryHookResult = ReturnType<typeof useUserProjectsLazyQuery>;
export type UserProjectsSuspenseQueryHookResult = ReturnType<typeof useUserProjectsSuspenseQuery>;
export type UserProjectsQueryResult = ApolloReactCommon.QueryResult<UserProjectsQuery, UserProjectsQueryVariables>;
export const AllTeamProjectsDocument = gql`
    query AllTeamProjects($entityName: String!, $first: Int = 10000) {
  projects(first: $first, entityName: $entityName) {
    edges {
      node {
        id
        name
        entityName
        totalRuns
        lastActive
        computeHours
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useAllTeamProjectsQuery__
 *
 * To run a query within a React component, call `useAllTeamProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTeamProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTeamProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useAllTeamProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllTeamProjectsQuery, AllTeamProjectsQueryVariables> & ({ variables: AllTeamProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllTeamProjectsQuery, AllTeamProjectsQueryVariables>(AllTeamProjectsDocument, options);
      }
export function useAllTeamProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllTeamProjectsQuery, AllTeamProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllTeamProjectsQuery, AllTeamProjectsQueryVariables>(AllTeamProjectsDocument, options);
        }
// @ts-ignore
export function useAllTeamProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AllTeamProjectsQuery, AllTeamProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllTeamProjectsQuery, AllTeamProjectsQueryVariables>;
export function useAllTeamProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllTeamProjectsQuery, AllTeamProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AllTeamProjectsQuery | undefined, AllTeamProjectsQueryVariables>;
export function useAllTeamProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllTeamProjectsQuery, AllTeamProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllTeamProjectsQuery, AllTeamProjectsQueryVariables>(AllTeamProjectsDocument, options);
        }
export type AllTeamProjectsQueryHookResult = ReturnType<typeof useAllTeamProjectsQuery>;
export type AllTeamProjectsLazyQueryHookResult = ReturnType<typeof useAllTeamProjectsLazyQuery>;
export type AllTeamProjectsSuspenseQueryHookResult = ReturnType<typeof useAllTeamProjectsSuspenseQuery>;
export type AllTeamProjectsQueryResult = ApolloReactCommon.QueryResult<AllTeamProjectsQuery, AllTeamProjectsQueryVariables>;
export const UserReportsDocument = gql`
    query UserReports {
  viewer {
    id
    username
    views(viewType: "runs") {
      edges {
        node {
          id
          createdAt
          updatedAt
          name
          displayName
          description
          previewUrl
          spec
          viewCount
          project {
            id
            name
            entityName
            access
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUserReportsQuery__
 *
 * To run a query within a React component, call `useUserReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserReportsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserReportsQuery, UserReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserReportsQuery, UserReportsQueryVariables>(UserReportsDocument, options);
      }
export function useUserReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserReportsQuery, UserReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserReportsQuery, UserReportsQueryVariables>(UserReportsDocument, options);
        }
// @ts-ignore
export function useUserReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserReportsQuery, UserReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserReportsQuery, UserReportsQueryVariables>;
export function useUserReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserReportsQuery, UserReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserReportsQuery | undefined, UserReportsQueryVariables>;
export function useUserReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserReportsQuery, UserReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserReportsQuery, UserReportsQueryVariables>(UserReportsDocument, options);
        }
export type UserReportsQueryHookResult = ReturnType<typeof useUserReportsQuery>;
export type UserReportsLazyQueryHookResult = ReturnType<typeof useUserReportsLazyQuery>;
export type UserReportsSuspenseQueryHookResult = ReturnType<typeof useUserReportsSuspenseQuery>;
export type UserReportsQueryResult = ApolloReactCommon.QueryResult<UserReportsQuery, UserReportsQueryVariables>;
export const Vega2PanelDocument = gql`
    query Vega2Panel($projectName: String!, $entityName: String, $id: ID!, $fetchSingle: Boolean!) {
  project(name: $projectName, entityName: $entityName) {
    id
    allViews(viewType: "vega2-panel") {
      edges {
        node {
          id
          ...ViewFragment
        }
      }
    }
  }
  view(id: $id, type: "vega2-panel") @include(if: $fetchSingle) {
    id
    ...ViewFragment
  }
}
    ${ViewFragmentFragmentDoc}`;

/**
 * __useVega2PanelQuery__
 *
 * To run a query within a React component, call `useVega2PanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useVega2PanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVega2PanelQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      id: // value for 'id'
 *      fetchSingle: // value for 'fetchSingle'
 *   },
 * });
 */
export function useVega2PanelQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Vega2PanelQuery, Vega2PanelQueryVariables> & ({ variables: Vega2PanelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Vega2PanelQuery, Vega2PanelQueryVariables>(Vega2PanelDocument, options);
      }
export function useVega2PanelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Vega2PanelQuery, Vega2PanelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Vega2PanelQuery, Vega2PanelQueryVariables>(Vega2PanelDocument, options);
        }
// @ts-ignore
export function useVega2PanelSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<Vega2PanelQuery, Vega2PanelQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<Vega2PanelQuery, Vega2PanelQueryVariables>;
export function useVega2PanelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Vega2PanelQuery, Vega2PanelQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<Vega2PanelQuery | undefined, Vega2PanelQueryVariables>;
export function useVega2PanelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Vega2PanelQuery, Vega2PanelQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Vega2PanelQuery, Vega2PanelQueryVariables>(Vega2PanelDocument, options);
        }
export type Vega2PanelQueryHookResult = ReturnType<typeof useVega2PanelQuery>;
export type Vega2PanelLazyQueryHookResult = ReturnType<typeof useVega2PanelLazyQuery>;
export type Vega2PanelSuspenseQueryHookResult = ReturnType<typeof useVega2PanelSuspenseQuery>;
export type Vega2PanelQueryResult = ApolloReactCommon.QueryResult<Vega2PanelQuery, Vega2PanelQueryVariables>;
export const VegaPanelDocument = gql`
    query VegaPanel($projectName: String!, $entityName: String, $id: ID!, $fetchSingle: Boolean!) {
  project(name: $projectName, entityName: $entityName) {
    id
    allViews(viewType: "vega-panel") {
      edges {
        node {
          id
          ...ViewFragment
        }
      }
    }
  }
  view(id: $id, type: "vega-panel") @include(if: $fetchSingle) {
    id
    ...ViewFragment
  }
}
    ${ViewFragmentFragmentDoc}`;

/**
 * __useVegaPanelQuery__
 *
 * To run a query within a React component, call `useVegaPanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useVegaPanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVegaPanelQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      id: // value for 'id'
 *      fetchSingle: // value for 'fetchSingle'
 *   },
 * });
 */
export function useVegaPanelQuery(baseOptions: ApolloReactHooks.QueryHookOptions<VegaPanelQuery, VegaPanelQueryVariables> & ({ variables: VegaPanelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VegaPanelQuery, VegaPanelQueryVariables>(VegaPanelDocument, options);
      }
export function useVegaPanelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VegaPanelQuery, VegaPanelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VegaPanelQuery, VegaPanelQueryVariables>(VegaPanelDocument, options);
        }
// @ts-ignore
export function useVegaPanelSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<VegaPanelQuery, VegaPanelQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<VegaPanelQuery, VegaPanelQueryVariables>;
export function useVegaPanelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<VegaPanelQuery, VegaPanelQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<VegaPanelQuery | undefined, VegaPanelQueryVariables>;
export function useVegaPanelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<VegaPanelQuery, VegaPanelQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<VegaPanelQuery, VegaPanelQueryVariables>(VegaPanelDocument, options);
        }
export type VegaPanelQueryHookResult = ReturnType<typeof useVegaPanelQuery>;
export type VegaPanelLazyQueryHookResult = ReturnType<typeof useVegaPanelLazyQuery>;
export type VegaPanelSuspenseQueryHookResult = ReturnType<typeof useVegaPanelSuspenseQuery>;
export type VegaPanelQueryResult = ApolloReactCommon.QueryResult<VegaPanelQuery, VegaPanelQueryVariables>;
export const ViewerApiKeyDocument = gql`
    query ViewerApiKey {
  viewer {
    id
    apiKey
  }
}
    `;

/**
 * __useViewerApiKeyQuery__
 *
 * To run a query within a React component, call `useViewerApiKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerApiKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerApiKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerApiKeyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>(ViewerApiKeyDocument, options);
      }
export function useViewerApiKeyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>(ViewerApiKeyDocument, options);
        }
// @ts-ignore
export function useViewerApiKeySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>;
export function useViewerApiKeySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerApiKeyQuery | undefined, ViewerApiKeyQueryVariables>;
export function useViewerApiKeySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>(ViewerApiKeyDocument, options);
        }
export type ViewerApiKeyQueryHookResult = ReturnType<typeof useViewerApiKeyQuery>;
export type ViewerApiKeyLazyQueryHookResult = ReturnType<typeof useViewerApiKeyLazyQuery>;
export type ViewerApiKeySuspenseQueryHookResult = ReturnType<typeof useViewerApiKeySuspenseQuery>;
export type ViewerApiKeyQueryResult = ApolloReactCommon.QueryResult<ViewerApiKeyQuery, ViewerApiKeyQueryVariables>;
export const ViewerApiKeysDocument = gql`
    query ViewerApiKeys {
  viewer {
    id
    apiKeys {
      edges {
        node {
          id
          name
          createdAt
          expiresAt
          description
          apiKeyId
          organizationID
          lastUsedAt
        }
      }
    }
  }
}
    `;

/**
 * __useViewerApiKeysQuery__
 *
 * To run a query within a React component, call `useViewerApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerApiKeysQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>(ViewerApiKeysDocument, options);
      }
export function useViewerApiKeysLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>(ViewerApiKeysDocument, options);
        }
// @ts-ignore
export function useViewerApiKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>;
export function useViewerApiKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerApiKeysQuery | undefined, ViewerApiKeysQueryVariables>;
export function useViewerApiKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>(ViewerApiKeysDocument, options);
        }
export type ViewerApiKeysQueryHookResult = ReturnType<typeof useViewerApiKeysQuery>;
export type ViewerApiKeysLazyQueryHookResult = ReturnType<typeof useViewerApiKeysLazyQuery>;
export type ViewerApiKeysSuspenseQueryHookResult = ReturnType<typeof useViewerApiKeysSuspenseQuery>;
export type ViewerApiKeysQueryResult = ApolloReactCommon.QueryResult<ViewerApiKeysQuery, ViewerApiKeysQueryVariables>;
export const WandbConfigDocument = gql`
    query WandbConfig($projectName: String!, $entityName: String!, $filters: JSONString, $limit: Int = 100, $order: String) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(filters: $filters, first: $limit, order: $order) {
      edges {
        node {
          id
          wandbConfig
        }
      }
    }
  }
}
    `;

/**
 * __useWandbConfigQuery__
 *
 * To run a query within a React component, call `useWandbConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useWandbConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWandbConfigQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useWandbConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WandbConfigQuery, WandbConfigQueryVariables> & ({ variables: WandbConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WandbConfigQuery, WandbConfigQueryVariables>(WandbConfigDocument, options);
      }
export function useWandbConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WandbConfigQuery, WandbConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WandbConfigQuery, WandbConfigQueryVariables>(WandbConfigDocument, options);
        }
// @ts-ignore
export function useWandbConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WandbConfigQuery, WandbConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WandbConfigQuery, WandbConfigQueryVariables>;
export function useWandbConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WandbConfigQuery, WandbConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WandbConfigQuery | undefined, WandbConfigQueryVariables>;
export function useWandbConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WandbConfigQuery, WandbConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WandbConfigQuery, WandbConfigQueryVariables>(WandbConfigDocument, options);
        }
export type WandbConfigQueryHookResult = ReturnType<typeof useWandbConfigQuery>;
export type WandbConfigLazyQueryHookResult = ReturnType<typeof useWandbConfigLazyQuery>;
export type WandbConfigSuspenseQueryHookResult = ReturnType<typeof useWandbConfigSuspenseQuery>;
export type WandbConfigQueryResult = ApolloReactCommon.QueryResult<WandbConfigQuery, WandbConfigQueryVariables>;
export const CoreweaveIdDocument = gql`
    query CoreweaveId($entity: String) {
  entity(name: $entity) {
    id
    organization {
      id
      coreWeaveOrganizationId
    }
  }
}
    `;

/**
 * __useCoreweaveIdQuery__
 *
 * To run a query within a React component, call `useCoreweaveIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoreweaveIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoreweaveIdQuery({
 *   variables: {
 *      entity: // value for 'entity'
 *   },
 * });
 */
export function useCoreweaveIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CoreweaveIdQuery, CoreweaveIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CoreweaveIdQuery, CoreweaveIdQueryVariables>(CoreweaveIdDocument, options);
      }
export function useCoreweaveIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CoreweaveIdQuery, CoreweaveIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CoreweaveIdQuery, CoreweaveIdQueryVariables>(CoreweaveIdDocument, options);
        }
// @ts-ignore
export function useCoreweaveIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CoreweaveIdQuery, CoreweaveIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CoreweaveIdQuery, CoreweaveIdQueryVariables>;
export function useCoreweaveIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CoreweaveIdQuery, CoreweaveIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CoreweaveIdQuery | undefined, CoreweaveIdQueryVariables>;
export function useCoreweaveIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CoreweaveIdQuery, CoreweaveIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CoreweaveIdQuery, CoreweaveIdQueryVariables>(CoreweaveIdDocument, options);
        }
export type CoreweaveIdQueryHookResult = ReturnType<typeof useCoreweaveIdQuery>;
export type CoreweaveIdLazyQueryHookResult = ReturnType<typeof useCoreweaveIdLazyQuery>;
export type CoreweaveIdSuspenseQueryHookResult = ReturnType<typeof useCoreweaveIdSuspenseQuery>;
export type CoreweaveIdQueryResult = ApolloReactCommon.QueryResult<CoreweaveIdQuery, CoreweaveIdQueryVariables>;
export const CoreweaveIdByRunNameDocument = gql`
    query CoreweaveIdByRunName($projectName: String!, $entityName: String!, $runName: String!) {
  entity(name: $entityName) {
    id
    organizationId
  }
  project(name: $projectName, entityName: $entityName) {
    id
    readOnly
    run(name: $runName) {
      id
      runInfo {
        slurm {
          jobId
          metadata
        }
        coreweave {
          orgId
          clusterName
          region
        }
      }
    }
  }
}
    `;

/**
 * __useCoreweaveIdByRunNameQuery__
 *
 * To run a query within a React component, call `useCoreweaveIdByRunNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoreweaveIdByRunNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoreweaveIdByRunNameQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useCoreweaveIdByRunNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables> & ({ variables: CoreweaveIdByRunNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables>(CoreweaveIdByRunNameDocument, options);
      }
export function useCoreweaveIdByRunNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables>(CoreweaveIdByRunNameDocument, options);
        }
// @ts-ignore
export function useCoreweaveIdByRunNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables>;
export function useCoreweaveIdByRunNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CoreweaveIdByRunNameQuery | undefined, CoreweaveIdByRunNameQueryVariables>;
export function useCoreweaveIdByRunNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables>(CoreweaveIdByRunNameDocument, options);
        }
export type CoreweaveIdByRunNameQueryHookResult = ReturnType<typeof useCoreweaveIdByRunNameQuery>;
export type CoreweaveIdByRunNameLazyQueryHookResult = ReturnType<typeof useCoreweaveIdByRunNameLazyQuery>;
export type CoreweaveIdByRunNameSuspenseQueryHookResult = ReturnType<typeof useCoreweaveIdByRunNameSuspenseQuery>;
export type CoreweaveIdByRunNameQueryResult = ApolloReactCommon.QueryResult<CoreweaveIdByRunNameQuery, CoreweaveIdByRunNameQueryVariables>;
export const RunIssueQueryDocument = gql`
    query RunIssueQuery($entityName: String!, $projectName: String!, $runName: String!, $start: DateTime!) {
  project(entityName: $entityName, name: $projectName) {
    id
    run(name: $runName) {
      id
      nodeAlertsHistory(start: $start) {
        ...NodeAlertFragment
      }
    }
  }
}
    ${NodeAlertFragmentFragmentDoc}`;

/**
 * __useRunIssueQueryQuery__
 *
 * To run a query within a React component, call `useRunIssueQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunIssueQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunIssueQueryQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runName: // value for 'runName'
 *      start: // value for 'start'
 *   },
 * });
 */
export function useRunIssueQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunIssueQueryQuery, RunIssueQueryQueryVariables> & ({ variables: RunIssueQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunIssueQueryQuery, RunIssueQueryQueryVariables>(RunIssueQueryDocument, options);
      }
export function useRunIssueQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunIssueQueryQuery, RunIssueQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunIssueQueryQuery, RunIssueQueryQueryVariables>(RunIssueQueryDocument, options);
        }
// @ts-ignore
export function useRunIssueQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunIssueQueryQuery, RunIssueQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunIssueQueryQuery, RunIssueQueryQueryVariables>;
export function useRunIssueQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunIssueQueryQuery, RunIssueQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunIssueQueryQuery | undefined, RunIssueQueryQueryVariables>;
export function useRunIssueQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunIssueQueryQuery, RunIssueQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunIssueQueryQuery, RunIssueQueryQueryVariables>(RunIssueQueryDocument, options);
        }
export type RunIssueQueryQueryHookResult = ReturnType<typeof useRunIssueQueryQuery>;
export type RunIssueQueryLazyQueryHookResult = ReturnType<typeof useRunIssueQueryLazyQuery>;
export type RunIssueQuerySuspenseQueryHookResult = ReturnType<typeof useRunIssueQuerySuspenseQuery>;
export type RunIssueQueryQueryResult = ApolloReactCommon.QueryResult<RunIssueQueryQuery, RunIssueQueryQueryVariables>;
export const IssuesTimestampsByMetricQueryDocument = gql`
    query IssuesTimestampsByMetricQuery($entityName: String!, $projectName: String!, $runName: String!, $bucketedHistorySpecs: [JSONString!]!) {
  project(name: $projectName, entityName: $entityName) {
    id
    run(name: $runName) {
      id
      bucketedHistory(specs: $bucketedHistorySpecs, packVersion: 1)
    }
  }
}
    `;

/**
 * __useIssuesTimestampsByMetricQueryQuery__
 *
 * To run a query within a React component, call `useIssuesTimestampsByMetricQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssuesTimestampsByMetricQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssuesTimestampsByMetricQueryQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runName: // value for 'runName'
 *      bucketedHistorySpecs: // value for 'bucketedHistorySpecs'
 *   },
 * });
 */
export function useIssuesTimestampsByMetricQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables> & ({ variables: IssuesTimestampsByMetricQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables>(IssuesTimestampsByMetricQueryDocument, options);
      }
export function useIssuesTimestampsByMetricQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables>(IssuesTimestampsByMetricQueryDocument, options);
        }
// @ts-ignore
export function useIssuesTimestampsByMetricQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables>;
export function useIssuesTimestampsByMetricQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IssuesTimestampsByMetricQueryQuery | undefined, IssuesTimestampsByMetricQueryQueryVariables>;
export function useIssuesTimestampsByMetricQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables>(IssuesTimestampsByMetricQueryDocument, options);
        }
export type IssuesTimestampsByMetricQueryQueryHookResult = ReturnType<typeof useIssuesTimestampsByMetricQueryQuery>;
export type IssuesTimestampsByMetricQueryLazyQueryHookResult = ReturnType<typeof useIssuesTimestampsByMetricQueryLazyQuery>;
export type IssuesTimestampsByMetricQuerySuspenseQueryHookResult = ReturnType<typeof useIssuesTimestampsByMetricQuerySuspenseQuery>;
export type IssuesTimestampsByMetricQueryQueryResult = ApolloReactCommon.QueryResult<IssuesTimestampsByMetricQueryQuery, IssuesTimestampsByMetricQueryQueryVariables>;
export const RunGrafanaDashboardQueryDocument = gql`
    query RunGrafanaDashboardQuery($entityName: String!, $projectName: String!, $runName: String!) {
  project(entityName: $entityName, name: $projectName) {
    id
    run(name: $runName) {
      id
      coreweaveGrafanaDashboard
    }
  }
}
    `;

/**
 * __useRunGrafanaDashboardQueryQuery__
 *
 * To run a query within a React component, call `useRunGrafanaDashboardQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunGrafanaDashboardQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunGrafanaDashboardQueryQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      runName: // value for 'runName'
 *   },
 * });
 */
export function useRunGrafanaDashboardQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables> & ({ variables: RunGrafanaDashboardQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables>(RunGrafanaDashboardQueryDocument, options);
      }
export function useRunGrafanaDashboardQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables>(RunGrafanaDashboardQueryDocument, options);
        }
// @ts-ignore
export function useRunGrafanaDashboardQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables>;
export function useRunGrafanaDashboardQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunGrafanaDashboardQueryQuery | undefined, RunGrafanaDashboardQueryQueryVariables>;
export function useRunGrafanaDashboardQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables>(RunGrafanaDashboardQueryDocument, options);
        }
export type RunGrafanaDashboardQueryQueryHookResult = ReturnType<typeof useRunGrafanaDashboardQueryQuery>;
export type RunGrafanaDashboardQueryLazyQueryHookResult = ReturnType<typeof useRunGrafanaDashboardQueryLazyQuery>;
export type RunGrafanaDashboardQuerySuspenseQueryHookResult = ReturnType<typeof useRunGrafanaDashboardQuerySuspenseQuery>;
export type RunGrafanaDashboardQueryQueryResult = ApolloReactCommon.QueryResult<RunGrafanaDashboardQueryQuery, RunGrafanaDashboardQueryQueryVariables>;
export const PanelGenHistoryKeysDocument = gql`
    query PanelGenHistoryKeys($projectName: String!, $entityName: String!, $filters: JSONString, $runLimit: Int, $runOrder: String, $maxPrefixGroups: Int, $maxMetricsPerGroup: Int, $metricNamePattern: String, $requiredPrefixes: [String!], $requiredRunKeys: [String!], $requiredMetrics: [String!], $lastPrefix: Boolean) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(
      filters: $filters
      first: $runLimit
      order: $runOrder
      requiredRunKeys: $requiredRunKeys
    ) {
      sectionAwareHistoryKeys(
        maxPrefixGroups: $maxPrefixGroups
        maxMetricsPerGroup: $maxMetricsPerGroup
        metricNamePattern: $metricNamePattern
        requiredPrefixes: $requiredPrefixes
        requiredMetrics: $requiredMetrics
        lastPrefix: $lastPrefix
      ) {
        lastStep
        groups {
          prefix
          matchedCount
          totalCount
          metrics {
            key
            types
            latestType
            column
          }
        }
        typeCategorySections {
          category
          matchedCount
          totalCount
          hasMore
          metrics {
            key
            types
            latestType
            column
          }
        }
        systemMetrics {
          key
          types
          latestType
          column
        }
        matchedPrefixCount
      }
    }
  }
}
    `;

/**
 * __usePanelGenHistoryKeysQuery__
 *
 * To run a query within a React component, call `usePanelGenHistoryKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `usePanelGenHistoryKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePanelGenHistoryKeysQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      runLimit: // value for 'runLimit'
 *      runOrder: // value for 'runOrder'
 *      maxPrefixGroups: // value for 'maxPrefixGroups'
 *      maxMetricsPerGroup: // value for 'maxMetricsPerGroup'
 *      metricNamePattern: // value for 'metricNamePattern'
 *      requiredPrefixes: // value for 'requiredPrefixes'
 *      requiredRunKeys: // value for 'requiredRunKeys'
 *      requiredMetrics: // value for 'requiredMetrics'
 *      lastPrefix: // value for 'lastPrefix'
 *   },
 * });
 */
export function usePanelGenHistoryKeysQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PanelGenHistoryKeysQuery, PanelGenHistoryKeysQueryVariables> & ({ variables: PanelGenHistoryKeysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PanelGenHistoryKeysQuery, PanelGenHistoryKeysQueryVariables>(PanelGenHistoryKeysDocument, options);
      }
export function usePanelGenHistoryKeysLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PanelGenHistoryKeysQuery, PanelGenHistoryKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PanelGenHistoryKeysQuery, PanelGenHistoryKeysQueryVariables>(PanelGenHistoryKeysDocument, options);
        }
// @ts-ignore
export function usePanelGenHistoryKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PanelGenHistoryKeysQuery, PanelGenHistoryKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PanelGenHistoryKeysQuery, PanelGenHistoryKeysQueryVariables>;
export function usePanelGenHistoryKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PanelGenHistoryKeysQuery, PanelGenHistoryKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PanelGenHistoryKeysQuery | undefined, PanelGenHistoryKeysQueryVariables>;
export function usePanelGenHistoryKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PanelGenHistoryKeysQuery, PanelGenHistoryKeysQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PanelGenHistoryKeysQuery, PanelGenHistoryKeysQueryVariables>(PanelGenHistoryKeysDocument, options);
        }
export type PanelGenHistoryKeysQueryHookResult = ReturnType<typeof usePanelGenHistoryKeysQuery>;
export type PanelGenHistoryKeysLazyQueryHookResult = ReturnType<typeof usePanelGenHistoryKeysLazyQuery>;
export type PanelGenHistoryKeysSuspenseQueryHookResult = ReturnType<typeof usePanelGenHistoryKeysSuspenseQuery>;
export type PanelGenHistoryKeysQueryResult = ApolloReactCommon.QueryResult<PanelGenHistoryKeysQuery, PanelGenHistoryKeysQueryVariables>;
export const ServerPollingOkDocument = gql`
    query ServerPollingOk {
  serverInfo {
    pollingOK
  }
}
    `;

/**
 * __useServerPollingOkQuery__
 *
 * To run a query within a React component, call `useServerPollingOkQuery` and pass it any options that fit your needs.
 * When your component renders, `useServerPollingOkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServerPollingOkQuery({
 *   variables: {
 *   },
 * });
 */
export function useServerPollingOkQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ServerPollingOkQuery, ServerPollingOkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ServerPollingOkQuery, ServerPollingOkQueryVariables>(ServerPollingOkDocument, options);
      }
export function useServerPollingOkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ServerPollingOkQuery, ServerPollingOkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ServerPollingOkQuery, ServerPollingOkQueryVariables>(ServerPollingOkDocument, options);
        }
// @ts-ignore
export function useServerPollingOkSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ServerPollingOkQuery, ServerPollingOkQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ServerPollingOkQuery, ServerPollingOkQueryVariables>;
export function useServerPollingOkSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ServerPollingOkQuery, ServerPollingOkQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ServerPollingOkQuery | undefined, ServerPollingOkQueryVariables>;
export function useServerPollingOkSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ServerPollingOkQuery, ServerPollingOkQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ServerPollingOkQuery, ServerPollingOkQueryVariables>(ServerPollingOkDocument, options);
        }
export type ServerPollingOkQueryHookResult = ReturnType<typeof useServerPollingOkQuery>;
export type ServerPollingOkLazyQueryHookResult = ReturnType<typeof useServerPollingOkLazyQuery>;
export type ServerPollingOkSuspenseQueryHookResult = ReturnType<typeof useServerPollingOkSuspenseQuery>;
export type ServerPollingOkQueryResult = ApolloReactCommon.QueryResult<ServerPollingOkQuery, ServerPollingOkQueryVariables>;
export const RunsStateQueryDocument = gql`
    query RunsStateQuery($aggregationKeys: [String!], $configKeys: [String!], $enableAggregations: Boolean = false, $enableArtifactCounts: Boolean = false, $enableBasic: Boolean = true, $enableConfig: Boolean = false, $enableHistoryKeyInfo: Boolean = false, $enableSampledHistory: Boolean = false, $enableSummary: Boolean = false, $enableSystemMetrics: Boolean = true, $enableTags: Boolean = true, $enableWandb: Boolean = false, $entityName: String!, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $limit: Int!, $order: String!, $projectName: String!, $sampledHistorySpecs: [JSONString!]!, $summaryKeys: [String!], $wandbKeys: [String!]) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(
      first: $limit
      order: $order
      filters: $filters
      groupKeys: $groupKeys
      groupLevel: $groupLevel
    ) {
      totalCount
      edges {
        node {
          id
          name
          projectId
          displayName
          updatedAt
          ...ArtifactCountsFragment @include(if: $enableArtifactCounts)
          ...RunStateBasicFragment @include(if: $enableBasic)
          aggregations(keys: $aggregationKeys) @include(if: $enableAggregations)
          config(keys: $configKeys) @include(if: $enableConfig)
          historyKeys(format: PLAINTEXT) @include(if: $enableHistoryKeyInfo)
          sampledHistory(specs: $sampledHistorySpecs, packVersion: 1) @include(if: $enableSampledHistory)
          summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
          systemMetrics @include(if: $enableSystemMetrics)
          tags: tagColors @include(if: $enableTags) {
            id
            name
            colorIndex
          }
          wandbConfig(keys: $wandbKeys) @include(if: $enableWandb)
        }
      }
    }
  }
}
    ${ArtifactCountsFragmentFragmentDoc}
${RunStateBasicFragmentFragmentDoc}`;

/**
 * __useRunsStateQueryQuery__
 *
 * To run a query within a React component, call `useRunsStateQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsStateQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsStateQueryQuery({
 *   variables: {
 *      aggregationKeys: // value for 'aggregationKeys'
 *      configKeys: // value for 'configKeys'
 *      enableAggregations: // value for 'enableAggregations'
 *      enableArtifactCounts: // value for 'enableArtifactCounts'
 *      enableBasic: // value for 'enableBasic'
 *      enableConfig: // value for 'enableConfig'
 *      enableHistoryKeyInfo: // value for 'enableHistoryKeyInfo'
 *      enableSampledHistory: // value for 'enableSampledHistory'
 *      enableSummary: // value for 'enableSummary'
 *      enableSystemMetrics: // value for 'enableSystemMetrics'
 *      enableTags: // value for 'enableTags'
 *      enableWandb: // value for 'enableWandb'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      projectName: // value for 'projectName'
 *      sampledHistorySpecs: // value for 'sampledHistorySpecs'
 *      summaryKeys: // value for 'summaryKeys'
 *      wandbKeys: // value for 'wandbKeys'
 *   },
 * });
 */
export function useRunsStateQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsStateQueryQuery, RunsStateQueryQueryVariables> & ({ variables: RunsStateQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsStateQueryQuery, RunsStateQueryQueryVariables>(RunsStateQueryDocument, options);
      }
export function useRunsStateQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsStateQueryQuery, RunsStateQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsStateQueryQuery, RunsStateQueryQueryVariables>(RunsStateQueryDocument, options);
        }
// @ts-ignore
export function useRunsStateQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsStateQueryQuery, RunsStateQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsStateQueryQuery, RunsStateQueryQueryVariables>;
export function useRunsStateQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsStateQueryQuery, RunsStateQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsStateQueryQuery | undefined, RunsStateQueryQueryVariables>;
export function useRunsStateQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsStateQueryQuery, RunsStateQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsStateQueryQuery, RunsStateQueryQueryVariables>(RunsStateQueryDocument, options);
        }
export type RunsStateQueryQueryHookResult = ReturnType<typeof useRunsStateQueryQuery>;
export type RunsStateQueryLazyQueryHookResult = ReturnType<typeof useRunsStateQueryLazyQuery>;
export type RunsStateQuerySuspenseQueryHookResult = ReturnType<typeof useRunsStateQuerySuspenseQuery>;
export type RunsStateQueryQueryResult = ApolloReactCommon.QueryResult<RunsStateQueryQuery, RunsStateQueryQueryVariables>;
export const RunsStateQueryWithProjectIdDocument = gql`
    query RunsStateQueryWithProjectId($aggregationKeys: [String!], $configKeys: [String!], $enableAggregations: Boolean = false, $enableArtifactCounts: Boolean = false, $enableBasic: Boolean = true, $enableConfig: Boolean = false, $enableHistoryKeyInfo: Boolean = false, $enableSampledHistory: Boolean = false, $enableSummary: Boolean = false, $enableSystemMetrics: Boolean = true, $enableTags: Boolean = true, $enableWandb: Boolean = false, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $limit: Int!, $order: String!, $sampledHistorySpecs: [JSONString!]!, $summaryKeys: [String!], $wandbKeys: [String!], $internalId: ID!) {
  project(internalId: $internalId) {
    id
    runs(
      first: $limit
      order: $order
      filters: $filters
      groupKeys: $groupKeys
      groupLevel: $groupLevel
    ) {
      totalCount
      edges {
        node {
          id
          name
          projectId
          displayName
          updatedAt
          ...ArtifactCountsFragment @include(if: $enableArtifactCounts)
          ...RunStateBasicFragment @include(if: $enableBasic)
          aggregations(keys: $aggregationKeys) @include(if: $enableAggregations)
          config(keys: $configKeys) @include(if: $enableConfig)
          historyKeys(format: BITMAP) @include(if: $enableHistoryKeyInfo)
          sampledHistory(specs: $sampledHistorySpecs, packVersion: 1) @include(if: $enableSampledHistory)
          summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
          systemMetrics @include(if: $enableSystemMetrics)
          tags: tagColors @include(if: $enableTags) {
            id
            name
            colorIndex
          }
          wandbConfig(keys: $wandbKeys) @include(if: $enableWandb)
        }
      }
    }
  }
}
    ${ArtifactCountsFragmentFragmentDoc}
${RunStateBasicFragmentFragmentDoc}`;

/**
 * __useRunsStateQueryWithProjectIdQuery__
 *
 * To run a query within a React component, call `useRunsStateQueryWithProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsStateQueryWithProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsStateQueryWithProjectIdQuery({
 *   variables: {
 *      aggregationKeys: // value for 'aggregationKeys'
 *      configKeys: // value for 'configKeys'
 *      enableAggregations: // value for 'enableAggregations'
 *      enableArtifactCounts: // value for 'enableArtifactCounts'
 *      enableBasic: // value for 'enableBasic'
 *      enableConfig: // value for 'enableConfig'
 *      enableHistoryKeyInfo: // value for 'enableHistoryKeyInfo'
 *      enableSampledHistory: // value for 'enableSampledHistory'
 *      enableSummary: // value for 'enableSummary'
 *      enableSystemMetrics: // value for 'enableSystemMetrics'
 *      enableTags: // value for 'enableTags'
 *      enableWandb: // value for 'enableWandb'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sampledHistorySpecs: // value for 'sampledHistorySpecs'
 *      summaryKeys: // value for 'summaryKeys'
 *      wandbKeys: // value for 'wandbKeys'
 *      internalId: // value for 'internalId'
 *   },
 * });
 */
export function useRunsStateQueryWithProjectIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables> & ({ variables: RunsStateQueryWithProjectIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables>(RunsStateQueryWithProjectIdDocument, options);
      }
export function useRunsStateQueryWithProjectIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables>(RunsStateQueryWithProjectIdDocument, options);
        }
// @ts-ignore
export function useRunsStateQueryWithProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables>;
export function useRunsStateQueryWithProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsStateQueryWithProjectIdQuery | undefined, RunsStateQueryWithProjectIdQueryVariables>;
export function useRunsStateQueryWithProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables>(RunsStateQueryWithProjectIdDocument, options);
        }
export type RunsStateQueryWithProjectIdQueryHookResult = ReturnType<typeof useRunsStateQueryWithProjectIdQuery>;
export type RunsStateQueryWithProjectIdLazyQueryHookResult = ReturnType<typeof useRunsStateQueryWithProjectIdLazyQuery>;
export type RunsStateQueryWithProjectIdSuspenseQueryHookResult = ReturnType<typeof useRunsStateQueryWithProjectIdSuspenseQuery>;
export type RunsStateQueryWithProjectIdQueryResult = ApolloReactCommon.QueryResult<RunsStateQueryWithProjectIdQuery, RunsStateQueryWithProjectIdQueryVariables>;
export const RunsStateDeltaQuery_Dd_Dq_U_RsdqDocument = gql`
    query RunsStateDeltaQuery_DD_DQ_U_RSDQ($aggregationKeys: [String!], $configKeys: [String!], $currentRuns: [String!]!, $enableAggregations: Boolean = false, $enableArtifactCounts: Boolean = false, $enableBasic: Boolean = true, $enableConfig: Boolean = false, $enableHistoryKeyInfo: Boolean = false, $enableSampledHistory: Boolean = false, $enableSummary: Boolean = false, $enableSystemMetrics: Boolean = true, $enableTags: Boolean = true, $enableWandb: Boolean = false, $entityName: String!, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $lastUpdated: DateTime!, $limit: Int!, $order: String!, $projectName: String!, $sampledHistorySpecs: [JSONString!]!, $summaryKeys: [String!], $wandbKeys: [String!]) {
  project(name: $projectName, entityName: $entityName) {
    id
    runs(
      first: $limit
      order: $order
      filters: $filters
      groupKeys: $groupKeys
      groupLevel: $groupLevel
    ) {
      totalCount
      delta(currentRuns: $currentRuns, lastUpdated: $lastUpdated) {
        index
        op
        run {
          id
          name
          projectId
          displayName
          updatedAt
          ...ArtifactCountsFragment @include(if: $enableArtifactCounts)
          ...RunStateBasicFragment @include(if: $enableBasic)
          aggregations(keys: $aggregationKeys) @include(if: $enableAggregations)
          config(keys: $configKeys) @include(if: $enableConfig)
          historyKeys(format: PLAINTEXT) @include(if: $enableHistoryKeyInfo)
          sampledHistory(specs: $sampledHistorySpecs, packVersion: 1) @include(if: $enableSampledHistory)
          summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
          systemMetrics @include(if: $enableSystemMetrics)
          tags: tagColors @include(if: $enableTags) {
            id
            name
            colorIndex
          }
          wandbConfig(keys: $wandbKeys) @include(if: $enableWandb)
        }
      }
    }
  }
}
    ${ArtifactCountsFragmentFragmentDoc}
${RunStateBasicFragmentFragmentDoc}`;

/**
 * __useRunsStateDeltaQuery_Dd_Dq_U_RsdqQuery__
 *
 * To run a query within a React component, call `useRunsStateDeltaQuery_Dd_Dq_U_RsdqQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsStateDeltaQuery_Dd_Dq_U_RsdqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsStateDeltaQuery_Dd_Dq_U_RsdqQuery({
 *   variables: {
 *      aggregationKeys: // value for 'aggregationKeys'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableAggregations: // value for 'enableAggregations'
 *      enableArtifactCounts: // value for 'enableArtifactCounts'
 *      enableBasic: // value for 'enableBasic'
 *      enableConfig: // value for 'enableConfig'
 *      enableHistoryKeyInfo: // value for 'enableHistoryKeyInfo'
 *      enableSampledHistory: // value for 'enableSampledHistory'
 *      enableSummary: // value for 'enableSummary'
 *      enableSystemMetrics: // value for 'enableSystemMetrics'
 *      enableTags: // value for 'enableTags'
 *      enableWandb: // value for 'enableWandb'
 *      entityName: // value for 'entityName'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      projectName: // value for 'projectName'
 *      sampledHistorySpecs: // value for 'sampledHistorySpecs'
 *      summaryKeys: // value for 'summaryKeys'
 *      wandbKeys: // value for 'wandbKeys'
 *   },
 * });
 */
export function useRunsStateDeltaQuery_Dd_Dq_U_RsdqQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsStateDeltaQuery_Dd_Dq_U_RsdqQuery, RunsStateDeltaQuery_Dd_Dq_U_RsdqQueryVariables> & ({ variables: RunsStateDeltaQuery_Dd_Dq_U_RsdqQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsStateDeltaQuery_Dd_Dq_U_RsdqQuery, RunsStateDeltaQuery_Dd_Dq_U_RsdqQueryVariables>(RunsStateDeltaQuery_Dd_Dq_U_RsdqDocument, options);
      }
export function useRunsStateDeltaQuery_Dd_Dq_U_RsdqLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsStateDeltaQuery_Dd_Dq_U_RsdqQuery, RunsStateDeltaQuery_Dd_Dq_U_RsdqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsStateDeltaQuery_Dd_Dq_U_RsdqQuery, RunsStateDeltaQuery_Dd_Dq_U_RsdqQueryVariables>(RunsStateDeltaQuery_Dd_Dq_U_RsdqDocument, options);
        }
// @ts-ignore
export function useRunsStateDeltaQuery_Dd_Dq_U_RsdqSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsStateDeltaQuery_Dd_Dq_U_RsdqQuery, RunsStateDeltaQuery_Dd_Dq_U_RsdqQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsStateDeltaQuery_Dd_Dq_U_RsdqQuery, RunsStateDeltaQuery_Dd_Dq_U_RsdqQueryVariables>;
export function useRunsStateDeltaQuery_Dd_Dq_U_RsdqSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsStateDeltaQuery_Dd_Dq_U_RsdqQuery, RunsStateDeltaQuery_Dd_Dq_U_RsdqQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsStateDeltaQuery_Dd_Dq_U_RsdqQuery | undefined, RunsStateDeltaQuery_Dd_Dq_U_RsdqQueryVariables>;
export function useRunsStateDeltaQuery_Dd_Dq_U_RsdqSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsStateDeltaQuery_Dd_Dq_U_RsdqQuery, RunsStateDeltaQuery_Dd_Dq_U_RsdqQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsStateDeltaQuery_Dd_Dq_U_RsdqQuery, RunsStateDeltaQuery_Dd_Dq_U_RsdqQueryVariables>(RunsStateDeltaQuery_Dd_Dq_U_RsdqDocument, options);
        }
export type RunsStateDeltaQuery_Dd_Dq_U_RsdqQueryHookResult = ReturnType<typeof useRunsStateDeltaQuery_Dd_Dq_U_RsdqQuery>;
export type RunsStateDeltaQuery_Dd_Dq_U_RsdqLazyQueryHookResult = ReturnType<typeof useRunsStateDeltaQuery_Dd_Dq_U_RsdqLazyQuery>;
export type RunsStateDeltaQuery_Dd_Dq_U_RsdqSuspenseQueryHookResult = ReturnType<typeof useRunsStateDeltaQuery_Dd_Dq_U_RsdqSuspenseQuery>;
export type RunsStateDeltaQuery_Dd_Dq_U_RsdqQueryResult = ApolloReactCommon.QueryResult<RunsStateDeltaQuery_Dd_Dq_U_RsdqQuery, RunsStateDeltaQuery_Dd_Dq_U_RsdqQueryVariables>;
export const RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqDocument = gql`
    query RunsStateProjectIdDeltaQuery_DD_DQ_U_RSDQ($aggregationKeys: [String!], $configKeys: [String!], $currentRuns: [String!]!, $enableAggregations: Boolean = false, $enableArtifactCounts: Boolean = false, $enableBasic: Boolean = true, $enableConfig: Boolean = false, $enableHistoryKeyInfo: Boolean = false, $enableSampledHistory: Boolean = false, $enableSummary: Boolean = false, $enableSystemMetrics: Boolean = true, $enableTags: Boolean = true, $enableWandb: Boolean = false, $filters: JSONString!, $groupKeys: [String!]!, $groupLevel: Int!, $lastUpdated: DateTime!, $limit: Int!, $order: String!, $sampledHistorySpecs: [JSONString!]!, $summaryKeys: [String!], $wandbKeys: [String!], $internalId: ID!) {
  project(internalId: $internalId) {
    id
    runs(
      first: $limit
      order: $order
      filters: $filters
      groupKeys: $groupKeys
      groupLevel: $groupLevel
    ) {
      totalCount
      delta(currentRuns: $currentRuns, lastUpdated: $lastUpdated) {
        index
        op
        run {
          id
          name
          projectId
          displayName
          updatedAt
          ...ArtifactCountsFragment @include(if: $enableArtifactCounts)
          ...RunStateBasicFragment @include(if: $enableBasic)
          aggregations(keys: $aggregationKeys) @include(if: $enableAggregations)
          config(keys: $configKeys) @include(if: $enableConfig)
          historyKeys(format: BITMAP) @include(if: $enableHistoryKeyInfo)
          sampledHistory(specs: $sampledHistorySpecs, packVersion: 1) @include(if: $enableSampledHistory)
          summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
          systemMetrics @include(if: $enableSystemMetrics)
          tags: tagColors @include(if: $enableTags) {
            id
            name
            colorIndex
          }
          wandbConfig(keys: $wandbKeys) @include(if: $enableWandb)
        }
      }
    }
  }
}
    ${ArtifactCountsFragmentFragmentDoc}
${RunStateBasicFragmentFragmentDoc}`;

/**
 * __useRunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQuery__
 *
 * To run a query within a React component, call `useRunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQuery({
 *   variables: {
 *      aggregationKeys: // value for 'aggregationKeys'
 *      configKeys: // value for 'configKeys'
 *      currentRuns: // value for 'currentRuns'
 *      enableAggregations: // value for 'enableAggregations'
 *      enableArtifactCounts: // value for 'enableArtifactCounts'
 *      enableBasic: // value for 'enableBasic'
 *      enableConfig: // value for 'enableConfig'
 *      enableHistoryKeyInfo: // value for 'enableHistoryKeyInfo'
 *      enableSampledHistory: // value for 'enableSampledHistory'
 *      enableSummary: // value for 'enableSummary'
 *      enableSystemMetrics: // value for 'enableSystemMetrics'
 *      enableTags: // value for 'enableTags'
 *      enableWandb: // value for 'enableWandb'
 *      filters: // value for 'filters'
 *      groupKeys: // value for 'groupKeys'
 *      groupLevel: // value for 'groupLevel'
 *      lastUpdated: // value for 'lastUpdated'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *      sampledHistorySpecs: // value for 'sampledHistorySpecs'
 *      summaryKeys: // value for 'summaryKeys'
 *      wandbKeys: // value for 'wandbKeys'
 *      internalId: // value for 'internalId'
 *   },
 * });
 */
export function useRunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQuery, RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQueryVariables> & ({ variables: RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQuery, RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQueryVariables>(RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqDocument, options);
      }
export function useRunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQuery, RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQuery, RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQueryVariables>(RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqDocument, options);
        }
// @ts-ignore
export function useRunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQuery, RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQuery, RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQueryVariables>;
export function useRunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQuery, RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQuery | undefined, RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQueryVariables>;
export function useRunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQuery, RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQuery, RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQueryVariables>(RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqDocument, options);
        }
export type RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQueryHookResult = ReturnType<typeof useRunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQuery>;
export type RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqLazyQueryHookResult = ReturnType<typeof useRunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqLazyQuery>;
export type RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqSuspenseQueryHookResult = ReturnType<typeof useRunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqSuspenseQuery>;
export type RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQueryResult = ApolloReactCommon.QueryResult<RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQuery, RunsStateProjectIdDeltaQuery_Dd_Dq_U_RsdqQueryVariables>;
export const Views2MetadataDocument = gql`
    query Views2Metadata($entityName: String, $name: String, $viewType: String = "runs", $userName: String, $viewName: String) {
  project(name: $name, entityName: $entityName) {
    id
    allViews(viewType: $viewType, viewName: $viewName, userName: $userName) {
      edges {
        node {
          id
          ...ViewFragmentMetadata2
        }
      }
    }
  }
}
    ${ViewFragmentMetadata2FragmentDoc}`;

/**
 * __useViews2MetadataQuery__
 *
 * To run a query within a React component, call `useViews2MetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useViews2MetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViews2MetadataQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      name: // value for 'name'
 *      viewType: // value for 'viewType'
 *      userName: // value for 'userName'
 *      viewName: // value for 'viewName'
 *   },
 * });
 */
export function useViews2MetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Views2MetadataQuery, Views2MetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Views2MetadataQuery, Views2MetadataQueryVariables>(Views2MetadataDocument, options);
      }
export function useViews2MetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Views2MetadataQuery, Views2MetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Views2MetadataQuery, Views2MetadataQueryVariables>(Views2MetadataDocument, options);
        }
// @ts-ignore
export function useViews2MetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<Views2MetadataQuery, Views2MetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<Views2MetadataQuery, Views2MetadataQueryVariables>;
export function useViews2MetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Views2MetadataQuery, Views2MetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<Views2MetadataQuery | undefined, Views2MetadataQueryVariables>;
export function useViews2MetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Views2MetadataQuery, Views2MetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Views2MetadataQuery, Views2MetadataQueryVariables>(Views2MetadataDocument, options);
        }
export type Views2MetadataQueryHookResult = ReturnType<typeof useViews2MetadataQuery>;
export type Views2MetadataLazyQueryHookResult = ReturnType<typeof useViews2MetadataLazyQuery>;
export type Views2MetadataSuspenseQueryHookResult = ReturnType<typeof useViews2MetadataSuspenseQuery>;
export type Views2MetadataQueryResult = ApolloReactCommon.QueryResult<Views2MetadataQuery, Views2MetadataQueryVariables>;
export const Views2ViewDocument = gql`
    query Views2View($id: ID!) {
  view(id: $id) {
    id
    ...ViewFragmentMetadata2
    spec
  }
}
    ${ViewFragmentMetadata2FragmentDoc}`;

/**
 * __useViews2ViewQuery__
 *
 * To run a query within a React component, call `useViews2ViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useViews2ViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViews2ViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViews2ViewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Views2ViewQuery, Views2ViewQueryVariables> & ({ variables: Views2ViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Views2ViewQuery, Views2ViewQueryVariables>(Views2ViewDocument, options);
      }
export function useViews2ViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Views2ViewQuery, Views2ViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Views2ViewQuery, Views2ViewQueryVariables>(Views2ViewDocument, options);
        }
// @ts-ignore
export function useViews2ViewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<Views2ViewQuery, Views2ViewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<Views2ViewQuery, Views2ViewQueryVariables>;
export function useViews2ViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Views2ViewQuery, Views2ViewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<Views2ViewQuery | undefined, Views2ViewQueryVariables>;
export function useViews2ViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Views2ViewQuery, Views2ViewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Views2ViewQuery, Views2ViewQueryVariables>(Views2ViewDocument, options);
        }
export type Views2ViewQueryHookResult = ReturnType<typeof useViews2ViewQuery>;
export type Views2ViewLazyQueryHookResult = ReturnType<typeof useViews2ViewLazyQuery>;
export type Views2ViewSuspenseQueryHookResult = ReturnType<typeof useViews2ViewSuspenseQuery>;
export type Views2ViewQueryResult = ApolloReactCommon.QueryResult<Views2ViewQuery, Views2ViewQueryVariables>;
export const Views2RawViewDocument = gql`
    query Views2RawView($id: ID!) {
  view(id: $id) {
    id
    ...ViewFragmentMetadata2
    specObject
  }
}
    ${ViewFragmentMetadata2FragmentDoc}`;

/**
 * __useViews2RawViewQuery__
 *
 * To run a query within a React component, call `useViews2RawViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useViews2RawViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViews2RawViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViews2RawViewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Views2RawViewQuery, Views2RawViewQueryVariables> & ({ variables: Views2RawViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Views2RawViewQuery, Views2RawViewQueryVariables>(Views2RawViewDocument, options);
      }
export function useViews2RawViewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Views2RawViewQuery, Views2RawViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Views2RawViewQuery, Views2RawViewQueryVariables>(Views2RawViewDocument, options);
        }
// @ts-ignore
export function useViews2RawViewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<Views2RawViewQuery, Views2RawViewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<Views2RawViewQuery, Views2RawViewQueryVariables>;
export function useViews2RawViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Views2RawViewQuery, Views2RawViewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<Views2RawViewQuery | undefined, Views2RawViewQueryVariables>;
export function useViews2RawViewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<Views2RawViewQuery, Views2RawViewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<Views2RawViewQuery, Views2RawViewQueryVariables>(Views2RawViewDocument, options);
        }
export type Views2RawViewQueryHookResult = ReturnType<typeof useViews2RawViewQuery>;
export type Views2RawViewLazyQueryHookResult = ReturnType<typeof useViews2RawViewLazyQuery>;
export type Views2RawViewSuspenseQueryHookResult = ReturnType<typeof useViews2RawViewSuspenseQuery>;
export type Views2RawViewQueryResult = ApolloReactCommon.QueryResult<Views2RawViewQuery, Views2RawViewQueryVariables>;
export const ViewUpdatedAtDocument = gql`
    query ViewUpdatedAt($id: ID!) {
  view(id: $id) {
    id
    updatedAt
  }
}
    `;

/**
 * __useViewUpdatedAtQuery__
 *
 * To run a query within a React component, call `useViewUpdatedAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewUpdatedAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewUpdatedAtQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewUpdatedAtQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables> & ({ variables: ViewUpdatedAtQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables>(ViewUpdatedAtDocument, options);
      }
export function useViewUpdatedAtLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables>(ViewUpdatedAtDocument, options);
        }
// @ts-ignore
export function useViewUpdatedAtSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables>;
export function useViewUpdatedAtSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewUpdatedAtQuery | undefined, ViewUpdatedAtQueryVariables>;
export function useViewUpdatedAtSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables>(ViewUpdatedAtDocument, options);
        }
export type ViewUpdatedAtQueryHookResult = ReturnType<typeof useViewUpdatedAtQuery>;
export type ViewUpdatedAtLazyQueryHookResult = ReturnType<typeof useViewUpdatedAtLazyQuery>;
export type ViewUpdatedAtSuspenseQueryHookResult = ReturnType<typeof useViewUpdatedAtSuspenseQuery>;
export type ViewUpdatedAtQueryResult = ApolloReactCommon.QueryResult<ViewUpdatedAtQuery, ViewUpdatedAtQueryVariables>;
export const NamedWorkspaceUpdateViewFieldsDocument = gql`
    query NamedWorkspaceUpdateViewFields($id: ID!) {
  view(id: $id) {
    id
    createdAt
    user {
      id
      name
      username
    }
    updatedAt
    updatedBy {
      id
      name
      username
    }
  }
}
    `;

/**
 * __useNamedWorkspaceUpdateViewFieldsQuery__
 *
 * To run a query within a React component, call `useNamedWorkspaceUpdateViewFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNamedWorkspaceUpdateViewFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNamedWorkspaceUpdateViewFieldsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNamedWorkspaceUpdateViewFieldsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables> & ({ variables: NamedWorkspaceUpdateViewFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables>(NamedWorkspaceUpdateViewFieldsDocument, options);
      }
export function useNamedWorkspaceUpdateViewFieldsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables>(NamedWorkspaceUpdateViewFieldsDocument, options);
        }
// @ts-ignore
export function useNamedWorkspaceUpdateViewFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables>;
export function useNamedWorkspaceUpdateViewFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NamedWorkspaceUpdateViewFieldsQuery | undefined, NamedWorkspaceUpdateViewFieldsQueryVariables>;
export function useNamedWorkspaceUpdateViewFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables>(NamedWorkspaceUpdateViewFieldsDocument, options);
        }
export type NamedWorkspaceUpdateViewFieldsQueryHookResult = ReturnType<typeof useNamedWorkspaceUpdateViewFieldsQuery>;
export type NamedWorkspaceUpdateViewFieldsLazyQueryHookResult = ReturnType<typeof useNamedWorkspaceUpdateViewFieldsLazyQuery>;
export type NamedWorkspaceUpdateViewFieldsSuspenseQueryHookResult = ReturnType<typeof useNamedWorkspaceUpdateViewFieldsSuspenseQuery>;
export type NamedWorkspaceUpdateViewFieldsQueryResult = ApolloReactCommon.QueryResult<NamedWorkspaceUpdateViewFieldsQuery, NamedWorkspaceUpdateViewFieldsQueryVariables>;
export const UpsertView2Document = gql`
    mutation UpsertView2($id: ID, $entityName: String, $projectName: String, $type: String, $name: String, $displayName: String, $description: String, $spec: String, $specIsGzipped: Boolean, $parentId: ID, $locked: Boolean, $overridePublished: Boolean, $previewUrl: String, $coverUrl: String, $showcasedAt: DateTime, $createdUsing: ViewSource) {
  upsertView(
    input: {id: $id, entityName: $entityName, projectName: $projectName, name: $name, displayName: $displayName, description: $description, type: $type, spec: $spec, specIsGzipped: $specIsGzipped, parentId: $parentId, locked: $locked, overridePublished: $overridePublished, previewUrl: $previewUrl, coverUrl: $coverUrl, showcasedAt: $showcasedAt, createdUsing: $createdUsing}
  ) {
    view {
      id
      ...ViewFragmentMetadata2
    }
    inserted
  }
}
    ${ViewFragmentMetadata2FragmentDoc}`;
export type UpsertView2MutationFn = ApolloReactCommon.MutationFunction<UpsertView2Mutation, UpsertView2MutationVariables>;

/**
 * __useUpsertView2Mutation__
 *
 * To run a mutation, you first call `useUpsertView2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertView2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertView2Mutation, { data, loading, error }] = useUpsertView2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      displayName: // value for 'displayName'
 *      description: // value for 'description'
 *      spec: // value for 'spec'
 *      specIsGzipped: // value for 'specIsGzipped'
 *      parentId: // value for 'parentId'
 *      locked: // value for 'locked'
 *      overridePublished: // value for 'overridePublished'
 *      previewUrl: // value for 'previewUrl'
 *      coverUrl: // value for 'coverUrl'
 *      showcasedAt: // value for 'showcasedAt'
 *      createdUsing: // value for 'createdUsing'
 *   },
 * });
 */
export function useUpsertView2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertView2Mutation, UpsertView2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertView2Mutation, UpsertView2MutationVariables>(UpsertView2Document, options);
      }
export type UpsertView2MutationHookResult = ReturnType<typeof useUpsertView2Mutation>;
export type UpsertView2MutationResult = ApolloReactCommon.MutationResult<UpsertView2Mutation>;
export type UpsertView2MutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertView2Mutation, UpsertView2MutationVariables>;
export const UpsertUserProfileViewDocument = gql`
    mutation UpsertUserProfileView($id: ID, $spec: String, $specIsGzipped: Boolean) {
  upsertUserProfileView(
    input: {id: $id, spec: $spec, specIsGzipped: $specIsGzipped}
  ) {
    view {
      id
      ...ViewFragmentMetadata2
      spec
    }
    inserted
  }
}
    ${ViewFragmentMetadata2FragmentDoc}`;
export type UpsertUserProfileViewMutationFn = ApolloReactCommon.MutationFunction<UpsertUserProfileViewMutation, UpsertUserProfileViewMutationVariables>;

/**
 * __useUpsertUserProfileViewMutation__
 *
 * To run a mutation, you first call `useUpsertUserProfileViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserProfileViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserProfileViewMutation, { data, loading, error }] = useUpsertUserProfileViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      spec: // value for 'spec'
 *      specIsGzipped: // value for 'specIsGzipped'
 *   },
 * });
 */
export function useUpsertUserProfileViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpsertUserProfileViewMutation, UpsertUserProfileViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpsertUserProfileViewMutation, UpsertUserProfileViewMutationVariables>(UpsertUserProfileViewDocument, options);
      }
export type UpsertUserProfileViewMutationHookResult = ReturnType<typeof useUpsertUserProfileViewMutation>;
export type UpsertUserProfileViewMutationResult = ApolloReactCommon.MutationResult<UpsertUserProfileViewMutation>;
export type UpsertUserProfileViewMutationOptions = ApolloReactCommon.BaseMutationOptions<UpsertUserProfileViewMutation, UpsertUserProfileViewMutationVariables>;
export const DeleteView2Document = gql`
    mutation deleteView2($id: ID, $deleteDrafts: Boolean) {
  deleteView(input: {id: $id, deleteDrafts: $deleteDrafts}) {
    success
    pendingDrafts
  }
}
    `;
export type DeleteView2MutationFn = ApolloReactCommon.MutationFunction<DeleteView2Mutation, DeleteView2MutationVariables>;

/**
 * __useDeleteView2Mutation__
 *
 * To run a mutation, you first call `useDeleteView2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteView2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteView2Mutation, { data, loading, error }] = useDeleteView2Mutation({
 *   variables: {
 *      id: // value for 'id'
 *      deleteDrafts: // value for 'deleteDrafts'
 *   },
 * });
 */
export function useDeleteView2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteView2Mutation, DeleteView2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteView2Mutation, DeleteView2MutationVariables>(DeleteView2Document, options);
      }
export type DeleteView2MutationHookResult = ReturnType<typeof useDeleteView2Mutation>;
export type DeleteView2MutationResult = ApolloReactCommon.MutationResult<DeleteView2Mutation>;
export type DeleteView2MutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteView2Mutation, DeleteView2MutationVariables>;
export const DeleteViewsDocument = gql`
    mutation deleteViews($ids: [ID!]!, $deleteDrafts: Boolean) {
  deleteViews(input: {ids: $ids, deleteDrafts: $deleteDrafts}) {
    success
    pendingDrafts
  }
}
    `;
export type DeleteViewsMutationFn = ApolloReactCommon.MutationFunction<DeleteViewsMutation, DeleteViewsMutationVariables>;

/**
 * __useDeleteViewsMutation__
 *
 * To run a mutation, you first call `useDeleteViewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteViewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteViewsMutation, { data, loading, error }] = useDeleteViewsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      deleteDrafts: // value for 'deleteDrafts'
 *   },
 * });
 */
export function useDeleteViewsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteViewsMutation, DeleteViewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteViewsMutation, DeleteViewsMutationVariables>(DeleteViewsDocument, options);
      }
export type DeleteViewsMutationHookResult = ReturnType<typeof useDeleteViewsMutation>;
export type DeleteViewsMutationResult = ApolloReactCommon.MutationResult<DeleteViewsMutation>;
export type DeleteViewsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteViewsMutation, DeleteViewsMutationVariables>;
export const StarViewDocument = gql`
    mutation starView($id: ID!) {
  starView(input: {id: $id}) {
    view {
      id
      starCount
      starred
    }
  }
}
    `;
export type StarViewMutationFn = ApolloReactCommon.MutationFunction<StarViewMutation, StarViewMutationVariables>;

/**
 * __useStarViewMutation__
 *
 * To run a mutation, you first call `useStarViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStarViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [starViewMutation, { data, loading, error }] = useStarViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStarViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StarViewMutation, StarViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StarViewMutation, StarViewMutationVariables>(StarViewDocument, options);
      }
export type StarViewMutationHookResult = ReturnType<typeof useStarViewMutation>;
export type StarViewMutationResult = ApolloReactCommon.MutationResult<StarViewMutation>;
export type StarViewMutationOptions = ApolloReactCommon.BaseMutationOptions<StarViewMutation, StarViewMutationVariables>;
export const UnstarViewDocument = gql`
    mutation unstarView($id: ID!) {
  unstarView(input: {id: $id}) {
    view {
      id
      starCount
      starred
    }
  }
}
    `;
export type UnstarViewMutationFn = ApolloReactCommon.MutationFunction<UnstarViewMutation, UnstarViewMutationVariables>;

/**
 * __useUnstarViewMutation__
 *
 * To run a mutation, you first call `useUnstarViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnstarViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unstarViewMutation, { data, loading, error }] = useUnstarViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnstarViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnstarViewMutation, UnstarViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnstarViewMutation, UnstarViewMutationVariables>(UnstarViewDocument, options);
      }
export type UnstarViewMutationHookResult = ReturnType<typeof useUnstarViewMutation>;
export type UnstarViewMutationResult = ApolloReactCommon.MutationResult<UnstarViewMutation>;
export type UnstarViewMutationOptions = ApolloReactCommon.BaseMutationOptions<UnstarViewMutation, UnstarViewMutationVariables>;
export const StargazersQueryDocument = gql`
    query StargazersQuery($viewID: ID!, $limit: Int, $cursor: String) {
  view(id: $viewID) {
    id
    stargazers(after: $cursor, first: $limit) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
          username
          userInfo
          photoUrl
        }
      }
    }
  }
}
    `;

/**
 * __useStargazersQueryQuery__
 *
 * To run a query within a React component, call `useStargazersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStargazersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStargazersQueryQuery({
 *   variables: {
 *      viewID: // value for 'viewID'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useStargazersQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StargazersQueryQuery, StargazersQueryQueryVariables> & ({ variables: StargazersQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StargazersQueryQuery, StargazersQueryQueryVariables>(StargazersQueryDocument, options);
      }
export function useStargazersQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StargazersQueryQuery, StargazersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StargazersQueryQuery, StargazersQueryQueryVariables>(StargazersQueryDocument, options);
        }
// @ts-ignore
export function useStargazersQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<StargazersQueryQuery, StargazersQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StargazersQueryQuery, StargazersQueryQueryVariables>;
export function useStargazersQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StargazersQueryQuery, StargazersQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<StargazersQueryQuery | undefined, StargazersQueryQueryVariables>;
export function useStargazersQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<StargazersQueryQuery, StargazersQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<StargazersQueryQuery, StargazersQueryQueryVariables>(StargazersQueryDocument, options);
        }
export type StargazersQueryQueryHookResult = ReturnType<typeof useStargazersQueryQuery>;
export type StargazersQueryLazyQueryHookResult = ReturnType<typeof useStargazersQueryLazyQuery>;
export type StargazersQuerySuspenseQueryHookResult = ReturnType<typeof useStargazersQuerySuspenseQuery>;
export type StargazersQueryQueryResult = ApolloReactCommon.QueryResult<StargazersQueryQuery, StargazersQueryQueryVariables>;
export const PublicViewsDocument = gql`
    query PublicViews($limit: Int, $cursor: String) {
  publicViews(type: "runs", after: $cursor, first: $limit) {
    edges {
      node {
        id
        name
        description
        user {
          id
          username
          name
        }
      }
    }
  }
}
    `;

/**
 * __usePublicViewsQuery__
 *
 * To run a query within a React component, call `usePublicViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicViewsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function usePublicViewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PublicViewsQuery, PublicViewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublicViewsQuery, PublicViewsQueryVariables>(PublicViewsDocument, options);
      }
export function usePublicViewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublicViewsQuery, PublicViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublicViewsQuery, PublicViewsQueryVariables>(PublicViewsDocument, options);
        }
// @ts-ignore
export function usePublicViewsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PublicViewsQuery, PublicViewsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublicViewsQuery, PublicViewsQueryVariables>;
export function usePublicViewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublicViewsQuery, PublicViewsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublicViewsQuery | undefined, PublicViewsQueryVariables>;
export function usePublicViewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublicViewsQuery, PublicViewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublicViewsQuery, PublicViewsQueryVariables>(PublicViewsDocument, options);
        }
export type PublicViewsQueryHookResult = ReturnType<typeof usePublicViewsQuery>;
export type PublicViewsLazyQueryHookResult = ReturnType<typeof usePublicViewsLazyQuery>;
export type PublicViewsSuspenseQueryHookResult = ReturnType<typeof usePublicViewsSuspenseQuery>;
export type PublicViewsQueryResult = ApolloReactCommon.QueryResult<PublicViewsQuery, PublicViewsQueryVariables>;
export const ViewDraftsDocument = gql`
    query viewDrafts($viewID: ID!) {
  view(id: $viewID) {
    id
    children {
      edges {
        node {
          id
          displayName
          updatedAt
          user {
            id
          }
          entityName
          project {
            id
            name
            entityName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useViewDraftsQuery__
 *
 * To run a query within a React component, call `useViewDraftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewDraftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewDraftsQuery({
 *   variables: {
 *      viewID: // value for 'viewID'
 *   },
 * });
 */
export function useViewDraftsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewDraftsQuery, ViewDraftsQueryVariables> & ({ variables: ViewDraftsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewDraftsQuery, ViewDraftsQueryVariables>(ViewDraftsDocument, options);
      }
export function useViewDraftsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewDraftsQuery, ViewDraftsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewDraftsQuery, ViewDraftsQueryVariables>(ViewDraftsDocument, options);
        }
// @ts-ignore
export function useViewDraftsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewDraftsQuery, ViewDraftsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewDraftsQuery, ViewDraftsQueryVariables>;
export function useViewDraftsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewDraftsQuery, ViewDraftsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewDraftsQuery | undefined, ViewDraftsQueryVariables>;
export function useViewDraftsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewDraftsQuery, ViewDraftsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewDraftsQuery, ViewDraftsQueryVariables>(ViewDraftsDocument, options);
        }
export type ViewDraftsQueryHookResult = ReturnType<typeof useViewDraftsQuery>;
export type ViewDraftsLazyQueryHookResult = ReturnType<typeof useViewDraftsLazyQuery>;
export type ViewDraftsSuspenseQueryHookResult = ReturnType<typeof useViewDraftsSuspenseQuery>;
export type ViewDraftsQueryResult = ApolloReactCommon.QueryResult<ViewDraftsQuery, ViewDraftsQueryVariables>;
export const ViewPermissionsDocument = gql`
    query viewPermissions($projectName: String!, $entityName: String!) {
  entity(name: $entityName) {
    id
    isTeam
    settings {
      disableMagicLinkSharing
      hidden
    }
  }
  project(name: $projectName, entityName: $entityName) {
    id
    access
  }
}
    `;

/**
 * __useViewPermissionsQuery__
 *
 * To run a query within a React component, call `useViewPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewPermissionsQuery({
 *   variables: {
 *      projectName: // value for 'projectName'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useViewPermissionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewPermissionsQuery, ViewPermissionsQueryVariables> & ({ variables: ViewPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewPermissionsQuery, ViewPermissionsQueryVariables>(ViewPermissionsDocument, options);
      }
export function useViewPermissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewPermissionsQuery, ViewPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewPermissionsQuery, ViewPermissionsQueryVariables>(ViewPermissionsDocument, options);
        }
// @ts-ignore
export function useViewPermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewPermissionsQuery, ViewPermissionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewPermissionsQuery, ViewPermissionsQueryVariables>;
export function useViewPermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewPermissionsQuery, ViewPermissionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewPermissionsQuery | undefined, ViewPermissionsQueryVariables>;
export function useViewPermissionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewPermissionsQuery, ViewPermissionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewPermissionsQuery, ViewPermissionsQueryVariables>(ViewPermissionsDocument, options);
        }
export type ViewPermissionsQueryHookResult = ReturnType<typeof useViewPermissionsQuery>;
export type ViewPermissionsLazyQueryHookResult = ReturnType<typeof useViewPermissionsLazyQuery>;
export type ViewPermissionsSuspenseQueryHookResult = ReturnType<typeof useViewPermissionsSuspenseQuery>;
export type ViewPermissionsQueryResult = ApolloReactCommon.QueryResult<ViewPermissionsQuery, ViewPermissionsQueryVariables>;
export const ViewViewDocument = gql`
    mutation viewView($id: ID!) {
  viewView(input: {id: $id}) {
    success
  }
}
    `;
export type ViewViewMutationFn = ApolloReactCommon.MutationFunction<ViewViewMutation, ViewViewMutationVariables>;

/**
 * __useViewViewMutation__
 *
 * To run a mutation, you first call `useViewViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useViewViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [viewViewMutation, { data, loading, error }] = useViewViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useViewViewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ViewViewMutation, ViewViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ViewViewMutation, ViewViewMutationVariables>(ViewViewDocument, options);
      }
export type ViewViewMutationHookResult = ReturnType<typeof useViewViewMutation>;
export type ViewViewMutationResult = ApolloReactCommon.MutationResult<ViewViewMutation>;
export type ViewViewMutationOptions = ApolloReactCommon.BaseMutationOptions<ViewViewMutation, ViewViewMutationVariables>;
export const AccountPrivilegesDocument = gql`
    query AccountPrivileges($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    subscriptions {
      id
      privileges
      plan {
        id
        planType
      }
    }
  }
}
    `;

/**
 * __useAccountPrivilegesQuery__
 *
 * To run a query within a React component, call `useAccountPrivilegesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountPrivilegesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountPrivilegesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAccountPrivilegesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountPrivilegesQuery, AccountPrivilegesQueryVariables> & ({ variables: AccountPrivilegesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountPrivilegesQuery, AccountPrivilegesQueryVariables>(AccountPrivilegesDocument, options);
      }
export function useAccountPrivilegesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountPrivilegesQuery, AccountPrivilegesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountPrivilegesQuery, AccountPrivilegesQueryVariables>(AccountPrivilegesDocument, options);
        }
// @ts-ignore
export function useAccountPrivilegesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AccountPrivilegesQuery, AccountPrivilegesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountPrivilegesQuery, AccountPrivilegesQueryVariables>;
export function useAccountPrivilegesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountPrivilegesQuery, AccountPrivilegesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountPrivilegesQuery | undefined, AccountPrivilegesQueryVariables>;
export function useAccountPrivilegesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountPrivilegesQuery, AccountPrivilegesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccountPrivilegesQuery, AccountPrivilegesQueryVariables>(AccountPrivilegesDocument, options);
        }
export type AccountPrivilegesQueryHookResult = ReturnType<typeof useAccountPrivilegesQuery>;
export type AccountPrivilegesLazyQueryHookResult = ReturnType<typeof useAccountPrivilegesLazyQuery>;
export type AccountPrivilegesSuspenseQueryHookResult = ReturnType<typeof useAccountPrivilegesSuspenseQuery>;
export type AccountPrivilegesQueryResult = ApolloReactCommon.QueryResult<AccountPrivilegesQuery, AccountPrivilegesQueryVariables>;
export const AccountEnterpriseWeaveLimitsDocument = gql`
    query AccountEnterpriseWeaveLimits($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    weaveEnterpriseSubscription {
      billingPeriodStart
      billingPeriodEnd
      weaveLimit {
        weaveLimitBytes
        weaveOverageCostCents
        weaveOverageUnit
      }
    }
  }
}
    `;

/**
 * __useAccountEnterpriseWeaveLimitsQuery__
 *
 * To run a query within a React component, call `useAccountEnterpriseWeaveLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountEnterpriseWeaveLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountEnterpriseWeaveLimitsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAccountEnterpriseWeaveLimitsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables> & ({ variables: AccountEnterpriseWeaveLimitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables>(AccountEnterpriseWeaveLimitsDocument, options);
      }
export function useAccountEnterpriseWeaveLimitsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables>(AccountEnterpriseWeaveLimitsDocument, options);
        }
// @ts-ignore
export function useAccountEnterpriseWeaveLimitsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables>;
export function useAccountEnterpriseWeaveLimitsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountEnterpriseWeaveLimitsQuery | undefined, AccountEnterpriseWeaveLimitsQueryVariables>;
export function useAccountEnterpriseWeaveLimitsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables>(AccountEnterpriseWeaveLimitsDocument, options);
        }
export type AccountEnterpriseWeaveLimitsQueryHookResult = ReturnType<typeof useAccountEnterpriseWeaveLimitsQuery>;
export type AccountEnterpriseWeaveLimitsLazyQueryHookResult = ReturnType<typeof useAccountEnterpriseWeaveLimitsLazyQuery>;
export type AccountEnterpriseWeaveLimitsSuspenseQueryHookResult = ReturnType<typeof useAccountEnterpriseWeaveLimitsSuspenseQuery>;
export type AccountEnterpriseWeaveLimitsQueryResult = ApolloReactCommon.QueryResult<AccountEnterpriseWeaveLimitsQuery, AccountEnterpriseWeaveLimitsQueryVariables>;
export const AccountSubscriptionPlansDocument = gql`
    query AccountSubscriptionPlans($organizationId: ID!) {
  organization(id: $organizationId) {
    id
    subscriptions {
      id
      plan {
        id
        planType
        name
      }
    }
  }
}
    `;

/**
 * __useAccountSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `useAccountSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSubscriptionPlansQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAccountSubscriptionPlansQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables> & ({ variables: AccountSubscriptionPlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables>(AccountSubscriptionPlansDocument, options);
      }
export function useAccountSubscriptionPlansLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables>(AccountSubscriptionPlansDocument, options);
        }
// @ts-ignore
export function useAccountSubscriptionPlansSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables>;
export function useAccountSubscriptionPlansSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AccountSubscriptionPlansQuery | undefined, AccountSubscriptionPlansQueryVariables>;
export function useAccountSubscriptionPlansSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables>(AccountSubscriptionPlansDocument, options);
        }
export type AccountSubscriptionPlansQueryHookResult = ReturnType<typeof useAccountSubscriptionPlansQuery>;
export type AccountSubscriptionPlansLazyQueryHookResult = ReturnType<typeof useAccountSubscriptionPlansLazyQuery>;
export type AccountSubscriptionPlansSuspenseQueryHookResult = ReturnType<typeof useAccountSubscriptionPlansSuspenseQuery>;
export type AccountSubscriptionPlansQueryResult = ApolloReactCommon.QueryResult<AccountSubscriptionPlansQuery, AccountSubscriptionPlansQueryVariables>;
export const UserDynamicConfigDocument = gql`
    query userDynamicConfig($configId: String!) {
  viewer {
    id
    dynamicConfig(configId: $configId) {
      value
    }
  }
}
    `;

/**
 * __useUserDynamicConfigQuery__
 *
 * To run a query within a React component, call `useUserDynamicConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDynamicConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDynamicConfigQuery({
 *   variables: {
 *      configId: // value for 'configId'
 *   },
 * });
 */
export function useUserDynamicConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserDynamicConfigQuery, UserDynamicConfigQueryVariables> & ({ variables: UserDynamicConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserDynamicConfigQuery, UserDynamicConfigQueryVariables>(UserDynamicConfigDocument, options);
      }
export function useUserDynamicConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserDynamicConfigQuery, UserDynamicConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserDynamicConfigQuery, UserDynamicConfigQueryVariables>(UserDynamicConfigDocument, options);
        }
// @ts-ignore
export function useUserDynamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserDynamicConfigQuery, UserDynamicConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserDynamicConfigQuery, UserDynamicConfigQueryVariables>;
export function useUserDynamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserDynamicConfigQuery, UserDynamicConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserDynamicConfigQuery | undefined, UserDynamicConfigQueryVariables>;
export function useUserDynamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserDynamicConfigQuery, UserDynamicConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserDynamicConfigQuery, UserDynamicConfigQueryVariables>(UserDynamicConfigDocument, options);
        }
export type UserDynamicConfigQueryHookResult = ReturnType<typeof useUserDynamicConfigQuery>;
export type UserDynamicConfigLazyQueryHookResult = ReturnType<typeof useUserDynamicConfigLazyQuery>;
export type UserDynamicConfigSuspenseQueryHookResult = ReturnType<typeof useUserDynamicConfigSuspenseQuery>;
export type UserDynamicConfigQueryResult = ApolloReactCommon.QueryResult<UserDynamicConfigQuery, UserDynamicConfigQueryVariables>;
export const EntityDynamicConfigDocument = gql`
    query entityDynamicConfig($configId: String!, $entityName: String!) {
  entity(name: $entityName) {
    id
    dynamicConfig(configId: $configId) {
      value
    }
  }
}
    `;

/**
 * __useEntityDynamicConfigQuery__
 *
 * To run a query within a React component, call `useEntityDynamicConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityDynamicConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityDynamicConfigQuery({
 *   variables: {
 *      configId: // value for 'configId'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useEntityDynamicConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables> & ({ variables: EntityDynamicConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables>(EntityDynamicConfigDocument, options);
      }
export function useEntityDynamicConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables>(EntityDynamicConfigDocument, options);
        }
// @ts-ignore
export function useEntityDynamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables>;
export function useEntityDynamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityDynamicConfigQuery | undefined, EntityDynamicConfigQueryVariables>;
export function useEntityDynamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables>(EntityDynamicConfigDocument, options);
        }
export type EntityDynamicConfigQueryHookResult = ReturnType<typeof useEntityDynamicConfigQuery>;
export type EntityDynamicConfigLazyQueryHookResult = ReturnType<typeof useEntityDynamicConfigLazyQuery>;
export type EntityDynamicConfigSuspenseQueryHookResult = ReturnType<typeof useEntityDynamicConfigSuspenseQuery>;
export type EntityDynamicConfigQueryResult = ApolloReactCommon.QueryResult<EntityDynamicConfigQuery, EntityDynamicConfigQueryVariables>;
export const OrganizationDyamicConfigDocument = gql`
    query organizationDyamicConfig($configId: String!, $orgName: String!) {
  organization(name: $orgName) {
    id
    orgType
    dynamicConfig(configId: $configId) {
      value
    }
  }
}
    `;

/**
 * __useOrganizationDyamicConfigQuery__
 *
 * To run a query within a React component, call `useOrganizationDyamicConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDyamicConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationDyamicConfigQuery({
 *   variables: {
 *      configId: // value for 'configId'
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationDyamicConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables> & ({ variables: OrganizationDyamicConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables>(OrganizationDyamicConfigDocument, options);
      }
export function useOrganizationDyamicConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables>(OrganizationDyamicConfigDocument, options);
        }
// @ts-ignore
export function useOrganizationDyamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables>;
export function useOrganizationDyamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationDyamicConfigQuery | undefined, OrganizationDyamicConfigQueryVariables>;
export function useOrganizationDyamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables>(OrganizationDyamicConfigDocument, options);
        }
export type OrganizationDyamicConfigQueryHookResult = ReturnType<typeof useOrganizationDyamicConfigQuery>;
export type OrganizationDyamicConfigLazyQueryHookResult = ReturnType<typeof useOrganizationDyamicConfigLazyQuery>;
export type OrganizationDyamicConfigSuspenseQueryHookResult = ReturnType<typeof useOrganizationDyamicConfigSuspenseQuery>;
export type OrganizationDyamicConfigQueryResult = ApolloReactCommon.QueryResult<OrganizationDyamicConfigQuery, OrganizationDyamicConfigQueryVariables>;
export const ViewerOrganizationsDynamicConfigDocument = gql`
    query viewerOrganizationsDynamicConfig($configId: String!) {
  viewer {
    id
    organizations {
      id
      name
      dynamicConfig(configId: $configId) {
        value
      }
    }
  }
}
    `;

/**
 * __useViewerOrganizationsDynamicConfigQuery__
 *
 * To run a query within a React component, call `useViewerOrganizationsDynamicConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerOrganizationsDynamicConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerOrganizationsDynamicConfigQuery({
 *   variables: {
 *      configId: // value for 'configId'
 *   },
 * });
 */
export function useViewerOrganizationsDynamicConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ViewerOrganizationsDynamicConfigQuery, ViewerOrganizationsDynamicConfigQueryVariables> & ({ variables: ViewerOrganizationsDynamicConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ViewerOrganizationsDynamicConfigQuery, ViewerOrganizationsDynamicConfigQueryVariables>(ViewerOrganizationsDynamicConfigDocument, options);
      }
export function useViewerOrganizationsDynamicConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ViewerOrganizationsDynamicConfigQuery, ViewerOrganizationsDynamicConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ViewerOrganizationsDynamicConfigQuery, ViewerOrganizationsDynamicConfigQueryVariables>(ViewerOrganizationsDynamicConfigDocument, options);
        }
// @ts-ignore
export function useViewerOrganizationsDynamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ViewerOrganizationsDynamicConfigQuery, ViewerOrganizationsDynamicConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerOrganizationsDynamicConfigQuery, ViewerOrganizationsDynamicConfigQueryVariables>;
export function useViewerOrganizationsDynamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerOrganizationsDynamicConfigQuery, ViewerOrganizationsDynamicConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ViewerOrganizationsDynamicConfigQuery | undefined, ViewerOrganizationsDynamicConfigQueryVariables>;
export function useViewerOrganizationsDynamicConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ViewerOrganizationsDynamicConfigQuery, ViewerOrganizationsDynamicConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ViewerOrganizationsDynamicConfigQuery, ViewerOrganizationsDynamicConfigQueryVariables>(ViewerOrganizationsDynamicConfigDocument, options);
        }
export type ViewerOrganizationsDynamicConfigQueryHookResult = ReturnType<typeof useViewerOrganizationsDynamicConfigQuery>;
export type ViewerOrganizationsDynamicConfigLazyQueryHookResult = ReturnType<typeof useViewerOrganizationsDynamicConfigLazyQuery>;
export type ViewerOrganizationsDynamicConfigSuspenseQueryHookResult = ReturnType<typeof useViewerOrganizationsDynamicConfigSuspenseQuery>;
export type ViewerOrganizationsDynamicConfigQueryResult = ApolloReactCommon.QueryResult<ViewerOrganizationsDynamicConfigQuery, ViewerOrganizationsDynamicConfigQueryVariables>;
export const TeamOrgDocument = gql`
    query TeamOrg($entityName: String!) {
  entity(name: $entityName) {
    id
    name
    organization {
      id
      name
    }
  }
}
    `;

/**
 * __useTeamOrgQuery__
 *
 * To run a query within a React component, call `useTeamOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamOrgQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useTeamOrgQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamOrgQuery, TeamOrgQueryVariables> & ({ variables: TeamOrgQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamOrgQuery, TeamOrgQueryVariables>(TeamOrgDocument, options);
      }
export function useTeamOrgLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamOrgQuery, TeamOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamOrgQuery, TeamOrgQueryVariables>(TeamOrgDocument, options);
        }
// @ts-ignore
export function useTeamOrgSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TeamOrgQuery, TeamOrgQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamOrgQuery, TeamOrgQueryVariables>;
export function useTeamOrgSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamOrgQuery, TeamOrgQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TeamOrgQuery | undefined, TeamOrgQueryVariables>;
export function useTeamOrgSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamOrgQuery, TeamOrgQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamOrgQuery, TeamOrgQueryVariables>(TeamOrgDocument, options);
        }
export type TeamOrgQueryHookResult = ReturnType<typeof useTeamOrgQuery>;
export type TeamOrgLazyQueryHookResult = ReturnType<typeof useTeamOrgLazyQuery>;
export type TeamOrgSuspenseQueryHookResult = ReturnType<typeof useTeamOrgSuspenseQuery>;
export type TeamOrgQueryResult = ApolloReactCommon.QueryResult<TeamOrgQuery, TeamOrgQueryVariables>;
export const ProjectRunStoreAcceleratorReadEnabledDocument = gql`
    query ProjectRunStoreAcceleratorReadEnabled($entityName: String!, $projectName: String!) {
  project(name: $projectName, entityName: $entityName) {
    ...ProjectRsaReadGate
  }
}
    ${ProjectRsaReadGateFragmentDoc}`;

/**
 * __useProjectRunStoreAcceleratorReadEnabledQuery__
 *
 * To run a query within a React component, call `useProjectRunStoreAcceleratorReadEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRunStoreAcceleratorReadEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectRunStoreAcceleratorReadEnabledQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useProjectRunStoreAcceleratorReadEnabledQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectRunStoreAcceleratorReadEnabledQuery, ProjectRunStoreAcceleratorReadEnabledQueryVariables> & ({ variables: ProjectRunStoreAcceleratorReadEnabledQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectRunStoreAcceleratorReadEnabledQuery, ProjectRunStoreAcceleratorReadEnabledQueryVariables>(ProjectRunStoreAcceleratorReadEnabledDocument, options);
      }
export function useProjectRunStoreAcceleratorReadEnabledLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectRunStoreAcceleratorReadEnabledQuery, ProjectRunStoreAcceleratorReadEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectRunStoreAcceleratorReadEnabledQuery, ProjectRunStoreAcceleratorReadEnabledQueryVariables>(ProjectRunStoreAcceleratorReadEnabledDocument, options);
        }
// @ts-ignore
export function useProjectRunStoreAcceleratorReadEnabledSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectRunStoreAcceleratorReadEnabledQuery, ProjectRunStoreAcceleratorReadEnabledQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectRunStoreAcceleratorReadEnabledQuery, ProjectRunStoreAcceleratorReadEnabledQueryVariables>;
export function useProjectRunStoreAcceleratorReadEnabledSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectRunStoreAcceleratorReadEnabledQuery, ProjectRunStoreAcceleratorReadEnabledQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectRunStoreAcceleratorReadEnabledQuery | undefined, ProjectRunStoreAcceleratorReadEnabledQueryVariables>;
export function useProjectRunStoreAcceleratorReadEnabledSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectRunStoreAcceleratorReadEnabledQuery, ProjectRunStoreAcceleratorReadEnabledQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectRunStoreAcceleratorReadEnabledQuery, ProjectRunStoreAcceleratorReadEnabledQueryVariables>(ProjectRunStoreAcceleratorReadEnabledDocument, options);
        }
export type ProjectRunStoreAcceleratorReadEnabledQueryHookResult = ReturnType<typeof useProjectRunStoreAcceleratorReadEnabledQuery>;
export type ProjectRunStoreAcceleratorReadEnabledLazyQueryHookResult = ReturnType<typeof useProjectRunStoreAcceleratorReadEnabledLazyQuery>;
export type ProjectRunStoreAcceleratorReadEnabledSuspenseQueryHookResult = ReturnType<typeof useProjectRunStoreAcceleratorReadEnabledSuspenseQuery>;
export type ProjectRunStoreAcceleratorReadEnabledQueryResult = ApolloReactCommon.QueryResult<ProjectRunStoreAcceleratorReadEnabledQuery, ProjectRunStoreAcceleratorReadEnabledQueryVariables>;
export const PinnedRunsProjectLookupDocument = gql`
    query PinnedRunsProjectLookup($pinnedRunIds: [ID!]!, $order: String!) {
  pinnedRuns: runs(ids: $pinnedRunIds, order: $order) {
    runs {
      id
      name
      project {
        id
        internalId
        name
        entityName
      }
    }
  }
}
    `;

/**
 * __usePinnedRunsProjectLookupQuery__
 *
 * To run a query within a React component, call `usePinnedRunsProjectLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `usePinnedRunsProjectLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePinnedRunsProjectLookupQuery({
 *   variables: {
 *      pinnedRunIds: // value for 'pinnedRunIds'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePinnedRunsProjectLookupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PinnedRunsProjectLookupQuery, PinnedRunsProjectLookupQueryVariables> & ({ variables: PinnedRunsProjectLookupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PinnedRunsProjectLookupQuery, PinnedRunsProjectLookupQueryVariables>(PinnedRunsProjectLookupDocument, options);
      }
export function usePinnedRunsProjectLookupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PinnedRunsProjectLookupQuery, PinnedRunsProjectLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PinnedRunsProjectLookupQuery, PinnedRunsProjectLookupQueryVariables>(PinnedRunsProjectLookupDocument, options);
        }
// @ts-ignore
export function usePinnedRunsProjectLookupSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PinnedRunsProjectLookupQuery, PinnedRunsProjectLookupQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PinnedRunsProjectLookupQuery, PinnedRunsProjectLookupQueryVariables>;
export function usePinnedRunsProjectLookupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PinnedRunsProjectLookupQuery, PinnedRunsProjectLookupQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PinnedRunsProjectLookupQuery | undefined, PinnedRunsProjectLookupQueryVariables>;
export function usePinnedRunsProjectLookupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PinnedRunsProjectLookupQuery, PinnedRunsProjectLookupQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PinnedRunsProjectLookupQuery, PinnedRunsProjectLookupQueryVariables>(PinnedRunsProjectLookupDocument, options);
        }
export type PinnedRunsProjectLookupQueryHookResult = ReturnType<typeof usePinnedRunsProjectLookupQuery>;
export type PinnedRunsProjectLookupLazyQueryHookResult = ReturnType<typeof usePinnedRunsProjectLookupLazyQuery>;
export type PinnedRunsProjectLookupSuspenseQueryHookResult = ReturnType<typeof usePinnedRunsProjectLookupSuspenseQuery>;
export type PinnedRunsProjectLookupQueryResult = ApolloReactCommon.QueryResult<PinnedRunsProjectLookupQuery, PinnedRunsProjectLookupQueryVariables>;
export const BillingPeriodSubscriptionsDocument = gql`
    query BillingPeriodSubscriptions($orgName: String!) {
  organization(name: $orgName) {
    id
    createdAt
    subscriptions {
      id
      billingPeriodStart
      billingPeriodEnd
      subscriptionType
      plan {
        id
        name
        planType
      }
    }
    inferenceEnterpriseSubscription {
      billingPeriodStart
      billingPeriodEnd
      inferenceLimit
    }
    sandboxesEnterpriseSubscription {
      billingPeriodStart
      billingPeriodEnd
      sandboxesLimit
    }
  }
}
    `;

/**
 * __useBillingPeriodSubscriptionsQuery__
 *
 * To run a query within a React component, call `useBillingPeriodSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingPeriodSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingPeriodSubscriptionsQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useBillingPeriodSubscriptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables> & ({ variables: BillingPeriodSubscriptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables>(BillingPeriodSubscriptionsDocument, options);
      }
export function useBillingPeriodSubscriptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables>(BillingPeriodSubscriptionsDocument, options);
        }
// @ts-ignore
export function useBillingPeriodSubscriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables>;
export function useBillingPeriodSubscriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BillingPeriodSubscriptionsQuery | undefined, BillingPeriodSubscriptionsQueryVariables>;
export function useBillingPeriodSubscriptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables>(BillingPeriodSubscriptionsDocument, options);
        }
export type BillingPeriodSubscriptionsQueryHookResult = ReturnType<typeof useBillingPeriodSubscriptionsQuery>;
export type BillingPeriodSubscriptionsLazyQueryHookResult = ReturnType<typeof useBillingPeriodSubscriptionsLazyQuery>;
export type BillingPeriodSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useBillingPeriodSubscriptionsSuspenseQuery>;
export type BillingPeriodSubscriptionsQueryResult = ApolloReactCommon.QueryResult<BillingPeriodSubscriptionsQuery, BillingPeriodSubscriptionsQueryVariables>;
export const EntityDeletedProjectsDocument = gql`
    query EntityDeletedProjects($entityName: String!, $limit: Int = 50) {
  entityDeletedProjects(entityName: $entityName, limit: $limit) {
    id
    name
    storageKey
    entityName
    createdAt
    deletedAt
  }
}
    `;

/**
 * __useEntityDeletedProjectsQuery__
 *
 * To run a query within a React component, call `useEntityDeletedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityDeletedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityDeletedProjectsQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useEntityDeletedProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EntityDeletedProjectsQuery, EntityDeletedProjectsQueryVariables> & ({ variables: EntityDeletedProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EntityDeletedProjectsQuery, EntityDeletedProjectsQueryVariables>(EntityDeletedProjectsDocument, options);
      }
export function useEntityDeletedProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EntityDeletedProjectsQuery, EntityDeletedProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EntityDeletedProjectsQuery, EntityDeletedProjectsQueryVariables>(EntityDeletedProjectsDocument, options);
        }
// @ts-ignore
export function useEntityDeletedProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EntityDeletedProjectsQuery, EntityDeletedProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityDeletedProjectsQuery, EntityDeletedProjectsQueryVariables>;
export function useEntityDeletedProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityDeletedProjectsQuery, EntityDeletedProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EntityDeletedProjectsQuery | undefined, EntityDeletedProjectsQueryVariables>;
export function useEntityDeletedProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EntityDeletedProjectsQuery, EntityDeletedProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EntityDeletedProjectsQuery, EntityDeletedProjectsQueryVariables>(EntityDeletedProjectsDocument, options);
        }
export type EntityDeletedProjectsQueryHookResult = ReturnType<typeof useEntityDeletedProjectsQuery>;
export type EntityDeletedProjectsLazyQueryHookResult = ReturnType<typeof useEntityDeletedProjectsLazyQuery>;
export type EntityDeletedProjectsSuspenseQueryHookResult = ReturnType<typeof useEntityDeletedProjectsSuspenseQuery>;
export type EntityDeletedProjectsQueryResult = ApolloReactCommon.QueryResult<EntityDeletedProjectsQuery, EntityDeletedProjectsQueryVariables>;
export const UndeleteProjectDocument = gql`
    mutation undeleteProject($entityName: String!, $projectName: String!, $clientMutationId: String) {
  undeleteProject(
    input: {entityName: $entityName, projectName: $projectName, clientMutationId: $clientMutationId}
  ) {
    success
    nameRestored
    runsRestored
    artifactCollectionsRestored
    project {
      id
      name
      entityName
    }
  }
}
    `;
export type UndeleteProjectMutationFn = ApolloReactCommon.MutationFunction<UndeleteProjectMutation, UndeleteProjectMutationVariables>;

/**
 * __useUndeleteProjectMutation__
 *
 * To run a mutation, you first call `useUndeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undeleteProjectMutation, { data, loading, error }] = useUndeleteProjectMutation({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUndeleteProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UndeleteProjectMutation, UndeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UndeleteProjectMutation, UndeleteProjectMutationVariables>(UndeleteProjectDocument, options);
      }
export type UndeleteProjectMutationHookResult = ReturnType<typeof useUndeleteProjectMutation>;
export type UndeleteProjectMutationResult = ApolloReactCommon.MutationResult<UndeleteProjectMutation>;
export type UndeleteProjectMutationOptions = ApolloReactCommon.BaseMutationOptions<UndeleteProjectMutation, UndeleteProjectMutationVariables>;
export const UndeleteProjectByIdDocument = gql`
    mutation UndeleteProjectById($projectID: ID!, $clientMutationId: String) {
  undeleteProjectByID(
    input: {projectID: $projectID, clientMutationId: $clientMutationId}
  ) {
    success
    nameRestored
    runsRestored
    artifactCollectionsRestored
    project {
      id
      name
      entityName
    }
  }
}
    `;
export type UndeleteProjectByIdMutationFn = ApolloReactCommon.MutationFunction<UndeleteProjectByIdMutation, UndeleteProjectByIdMutationVariables>;

/**
 * __useUndeleteProjectByIdMutation__
 *
 * To run a mutation, you first call `useUndeleteProjectByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndeleteProjectByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undeleteProjectByIdMutation, { data, loading, error }] = useUndeleteProjectByIdMutation({
 *   variables: {
 *      projectID: // value for 'projectID'
 *      clientMutationId: // value for 'clientMutationId'
 *   },
 * });
 */
export function useUndeleteProjectByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UndeleteProjectByIdMutation, UndeleteProjectByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UndeleteProjectByIdMutation, UndeleteProjectByIdMutationVariables>(UndeleteProjectByIdDocument, options);
      }
export type UndeleteProjectByIdMutationHookResult = ReturnType<typeof useUndeleteProjectByIdMutation>;
export type UndeleteProjectByIdMutationResult = ApolloReactCommon.MutationResult<UndeleteProjectByIdMutation>;
export type UndeleteProjectByIdMutationOptions = ApolloReactCommon.BaseMutationOptions<UndeleteProjectByIdMutation, UndeleteProjectByIdMutationVariables>;
export const OrganizationSubscriptionUpdateAdditionalInfoDocument = gql`
    query OrganizationSubscriptionUpdateAdditionalInfo($orgName: String!) {
  organization(name: $orgName) {
    id
    weaveEnterpriseSubscription {
      billingPeriodStart
      billingPeriodEnd
    }
    inferenceEnterpriseSubscription {
      billingPeriodStart
      billingPeriodEnd
      inferenceLimit
    }
    sandboxesEnterpriseSubscription {
      billingPeriodStart
      billingPeriodEnd
      sandboxesLimit
    }
  }
}
    `;

/**
 * __useOrganizationSubscriptionUpdateAdditionalInfoQuery__
 *
 * To run a query within a React component, call `useOrganizationSubscriptionUpdateAdditionalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSubscriptionUpdateAdditionalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSubscriptionUpdateAdditionalInfoQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useOrganizationSubscriptionUpdateAdditionalInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables> & ({ variables: OrganizationSubscriptionUpdateAdditionalInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>(OrganizationSubscriptionUpdateAdditionalInfoDocument, options);
      }
export function useOrganizationSubscriptionUpdateAdditionalInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>(OrganizationSubscriptionUpdateAdditionalInfoDocument, options);
        }
// @ts-ignore
export function useOrganizationSubscriptionUpdateAdditionalInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>;
export function useOrganizationSubscriptionUpdateAdditionalInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganizationSubscriptionUpdateAdditionalInfoQuery | undefined, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>;
export function useOrganizationSubscriptionUpdateAdditionalInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>(OrganizationSubscriptionUpdateAdditionalInfoDocument, options);
        }
export type OrganizationSubscriptionUpdateAdditionalInfoQueryHookResult = ReturnType<typeof useOrganizationSubscriptionUpdateAdditionalInfoQuery>;
export type OrganizationSubscriptionUpdateAdditionalInfoLazyQueryHookResult = ReturnType<typeof useOrganizationSubscriptionUpdateAdditionalInfoLazyQuery>;
export type OrganizationSubscriptionUpdateAdditionalInfoSuspenseQueryHookResult = ReturnType<typeof useOrganizationSubscriptionUpdateAdditionalInfoSuspenseQuery>;
export type OrganizationSubscriptionUpdateAdditionalInfoQueryResult = ApolloReactCommon.QueryResult<OrganizationSubscriptionUpdateAdditionalInfoQuery, OrganizationSubscriptionUpdateAdditionalInfoQueryVariables>;
export const FetchLorasDocument = gql`
    query FetchLoras($entityName: String!, $projectName: String!) {
  project(name: $projectName, entityName: $entityName) {
    id
    artifactType(name: "lora") {
      id
      artifactCollections {
        edges {
          node {
            id
            name
            artifacts {
              edges {
                node {
                  id
                  versionIndex
                  metadata
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchLorasQuery__
 *
 * To run a query within a React component, call `useFetchLorasQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchLorasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchLorasQuery({
 *   variables: {
 *      entityName: // value for 'entityName'
 *      projectName: // value for 'projectName'
 *   },
 * });
 */
export function useFetchLorasQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchLorasQuery, FetchLorasQueryVariables> & ({ variables: FetchLorasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchLorasQuery, FetchLorasQueryVariables>(FetchLorasDocument, options);
      }
export function useFetchLorasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchLorasQuery, FetchLorasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchLorasQuery, FetchLorasQueryVariables>(FetchLorasDocument, options);
        }
// @ts-ignore
export function useFetchLorasSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FetchLorasQuery, FetchLorasQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchLorasQuery, FetchLorasQueryVariables>;
export function useFetchLorasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchLorasQuery, FetchLorasQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FetchLorasQuery | undefined, FetchLorasQueryVariables>;
export function useFetchLorasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchLorasQuery, FetchLorasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchLorasQuery, FetchLorasQueryVariables>(FetchLorasDocument, options);
        }
export type FetchLorasQueryHookResult = ReturnType<typeof useFetchLorasQuery>;
export type FetchLorasLazyQueryHookResult = ReturnType<typeof useFetchLorasLazyQuery>;
export type FetchLorasSuspenseQueryHookResult = ReturnType<typeof useFetchLorasSuspenseQuery>;
export type FetchLorasQueryResult = ApolloReactCommon.QueryResult<FetchLorasQuery, FetchLorasQueryVariables>;